const APP_VERSION = '2026.09.09.04-workshop-live-shape-authority';
const WORKSHOP_PLANNER_SCRIPT_VERSION = '2026.09.09.03-fitting-duration-coherence';
// Production Supabase project ref. Used only to LABEL which environment
// the backup status panel is showing (staging vs production) -- this
// constant intentionally names only the production ref, never the
// staging ref, so this file can ship to production without the
// production-artifact secret/staging-reference scan failing.
const PRODUCTION_SUPABASE_PROJECT_REF = 'vjdtsswhroyguxyfjdkt';
window.VEHICLE_TRACKING_DATA = window.VEHICLE_TRACKING_DATA || { report: {}, vehicles: [], toyotaMatches: {} };
const EDITS_KEY = 'vehicleTrackingCoreNavisionOnlyEdits:v1';
const ADDED_KEY = 'vehicleTrackingCoreNavisionOnlyVehicles:v1';
const AMY_EMAIL = 'amy.elkington@broometoyota.com.au';
const PMG_UPDATE_EMAIL = 'Newvehiclebuild@pmgwa.com.au';
const TINT_EMAIL = 'jono@performancetinting.com.au';
const RFT_SALESPERSON_EMAIL = 'bryce.guthrie@broometoyota.com.au';
const AUDIT_LOG_KEY = 'vehicleTrackingCoreNavisionOnlyAuditLog:v1';
const OPERATOR_NAME_KEY = 'vehicleTrackingCoreCurrentOperator:v1';
const OPERATOR_ROLE_KEY = 'vehicleTrackingCoreCurrentOperatorRole:v1';
// Stage 2A (independent-review remediation, localStorage-to-Supabase
// migration): mechanics/salespeople/sublet providers are now
// authoritative in Supabase (public.workshop_technicians/
// public.salespeople/public.sublet_providers via
// workshop-reference-data-service.js). These six key constants are
// DELIBERATELY KEPT (not deleted) purely so the Stage 2A browser-data
// importer (scripts/import_stage2a_reference_data.py) can still read
// whatever a given staff computer's old local roster contained during
// the one-time import/reconciliation step. No other code path reads
// from or writes to these keys anymore -- loadMechanics()/
// loadSalespersons()/loadSubletProviders() read exclusively from
// workshop-reference-data-service.js's Supabase-backed cache.
const MECHANICS_KEY = 'vehicleTrackingCorePdcMechanics:v1';
const MECHANICS_ROSTER_SEED_KEY = 'vehicleTrackingCorePdcMechanicsRosterSeed:v1';
const MECHANICS_ROSTER_SEED_VERSION = '2026-07-15-departments-138-139-v1';
const SUBLET_PROVIDERS_KEY = 'vehicleTrackingCorePdcSubletProviders:v1';
const SUBLET_PROVIDERS_SEED_KEY = 'vehicleTrackingCorePdcSubletProvidersSeed:v2';
const SUBLET_PROVIDERS_SEED_VERSION = '2026-07-13-v2';
const SALESPERSONS_KEY = 'vehicleTrackingCoreSalespersons:v1';
const SALESPERSONS_SEED_KEY = 'vehicleTrackingCoreSalespersonsSeed:v1';
const SALESPERSONS_SEED_VERSION = '2026-07-13-v1';
const OPERATIONAL_HEALTH_KEY = 'vehicleTrackingCoreOperationalHealth:v1';
const EMAIL_REVIEW_DECISIONS_KEY = 'vehicleTrackingCoreEmailReviewDecisions:v1';
const AI_FILE_ASSISTANT_REVIEWS_KEY = 'vehicleTrackingCoreAiFileAssistantReviews:v1';
const STORAGE_TRANSACTION_JOURNAL_KEY = 'vehicleTrackingCoreStorageTransaction:v1';
const VEHICLE_TABLE_COLUMN_ORDER_KEY = 'vehicleTrackingCoreColumnOrder:v5';
const WORKFLOW_WIDTH_MODE_KEY = 'vehicleTrackingCoreWorkflowWidthMode:v1';
const ROW_WIDTH_MODE_KEY = 'vehicleTrackingCoreRowWidthMode:v1';
const VEHICLE_TABLE_DEFAULT_COLUMN_IDS = ['sp', 'stock', 'prodMth', 'client', 'vehicle', 'bus4x4', 'tint', 'hoist', 'fitting', 'fabrication', 'electrical', 'tyre', 'status', 'eta', 'navisionNotes', 'jita', 'action'];
const PO_TASKS_KEY = 'vehicleTrackingCoreNavisionOnlyPoTasks:v1';
const PO_FILES_KEY = 'vehicleTrackingCoreNavisionOnlyPoFiles:v1';
const ARB_LABOUR_CATALOG = window.ARB_LABOUR_CATALOG || { entries: {}, ambiguous: {}, labourRate: 160, sourceCode: 'DRT20260201.1' };
const DELETED_KEY = 'vehicleTrackingCoreNavisionOnlyDeleted:v1';
const TOYOTA_MATCHES = window.VEHICLE_TRACKING_DATA?.toyotaMatches || {};
const AUTOCARE_DESPATCH_STATUS = 'AUTOCARE DESPATCHED';
const AUTOCARE_RESULTS_KEY = 'vehicleTrackingCoreNavisionOnlyAutocareDispatch:v1';
const NAVISION_IMPORT_RESULTS_KEY = 'vehicleTrackingCoreNavisionOnlyImport:v1';
const NAVISION_LOCAL_STORAGE_SAFE_BUDGET_BYTES = 4 * 1024 * 1024;
const NAVISION_IMPORT_SUMMARY_VERSION = 2;
const NAVISION_IMPORT_SUMMARY_MAX_CHARS = 16 * 1024;
const NAVISION_IMPORT_TOO_LARGE_MESSAGE = 'Import too large—nothing saved';
const CRM_BACKUP_TYPE = 'vehicle-tracking-core-backup';
const CRM_BACKUP_VERSION = 1;
const CRM_BACKUP_STORAGE_KEYS = [
  EDITS_KEY,
  ADDED_KEY,
  PO_TASKS_KEY,
  PO_FILES_KEY,
  DELETED_KEY,
  AUTOCARE_RESULTS_KEY,
  NAVISION_IMPORT_RESULTS_KEY,
  AUDIT_LOG_KEY,
  // MECHANICS_KEY/MECHANICS_ROSTER_SEED_KEY, SUBLET_PROVIDERS_KEY/
  // SUBLET_PROVIDERS_SEED_KEY, and SALESPERSONS_KEY/SALESPERSONS_SEED_KEY
  // are intentionally NOT included here as of Stage 2A: mechanics,
  // sublet providers, and salespeople are now authoritative in Supabase
  // (public.workshop_technicians/public.sublet_providers/
  // public.salespeople via workshop-reference-data-service.js), covered
  // by the real Supabase encrypted backup/restore system, not this
  // browser-local export mechanism. The key constants and any existing
  // browser-local data under them are deliberately left untouched on
  // disk (not deleted, not read from, not written to) so the Stage 2A
  // browser-data importer can still read a given staff computer's old
  // local roster during the one-time import/reconciliation step -- see
  // scripts/import_stage2a_reference_data.py. They are never treated as
  // an authoritative source by any other code path.
  OPERATIONAL_HEALTH_KEY,
  EMAIL_REVIEW_DECISIONS_KEY,
  AI_FILE_ASSISTANT_REVIEWS_KEY,
  VEHICLE_TABLE_COLUMN_ORDER_KEY
];

const PDC_LOCATION_OPTIONS = [
  { value: '', label: 'Follow Navision until Yard Hold' },
  { value: 'YH', label: 'YH - Yard Hold' },
  { value: 'PMB', label: 'Released to PMB' },
  { value: 'PIT', label: 'PIT - Department of Transport inspection' },
  { value: 'QC', label: 'QC - Ready for QC / QC Gate', systemOnly: true },
  { value: 'RFT', label: 'RFT - set by QC sign-off', systemOnly: true },
];

const PDC_LOCATION_LABELS = new Map(PDC_LOCATION_OPTIONS.map(option => [option.value, option.label]));


// r407 (F20): non-blocking, accessible error message for the drag, schedule
// and QC action paths (replaces window.alert there). r409 (F25): every other
// app.js alert() is now this toast too, except the PO-attachment notice in
// draftNewVehicleBuildEmail (must be read before the mail app opens). Same toast region and
// styling as the Workshop Planner's workshopNotify(). Errors use role="alert"
// and stay until dismissed; info uses role="status" and clears after 8 s.
function pdcNotify(message, tone = 'error') {
  const text = String(message ?? '').trim();
  if (!text) return;
  const kind = tone === 'info' ? 'info' : 'error';
  if (typeof document === 'undefined' || !document.body || typeof document.createElement !== 'function') {
    if (typeof console !== 'undefined' && typeof console.warn === 'function') console.warn(text);
    return;
  }
  let region = document.getElementById('workshop-toast-region');
  if (!region) {
    region = document.createElement('div');
    region.id = 'workshop-toast-region';
    region.className = 'workshop-toast-region';
    document.body.appendChild(region);
  }
  const toast = document.createElement('div');
  toast.className = `workshop-toast is-${kind}`;
  toast.setAttribute('role', kind === 'info' ? 'status' : 'alert');
  toast.setAttribute('aria-live', kind === 'info' ? 'polite' : 'assertive');
  toast.setAttribute('aria-atomic', 'true');
  const body = document.createElement('span');
  body.className = 'workshop-toast-message';
  body.textContent = text;
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'workshop-toast-close';
  close.setAttribute('aria-label', 'Dismiss message');
  close.textContent = '×';
  close.addEventListener('click', () => toast.remove());
  toast.append(body, close);
  region.appendChild(toast);
  // r409 (F25): with every app.js message now a toast, keep errors in view:
  // past four on screen the oldest info toast goes first, then the oldest error.
  while (region.children.length > 4) {
    const oldestInfo = [...region.children].find(el => el !== toast && String(el.className || '').includes('is-info'));
    (oldestInfo || region.firstElementChild).remove();
  }
  if (kind === 'info') setTimeout(() => toast.remove(), 8000);
}

// r408 (F24): the admin list add/remove handlers chained .then() with no
// .catch(). The reference-data service resolves { ok:false } for server
// errors but rejects when fetch itself fails (offline, DNS, CORS), so a
// network blip became an unhandled rejection: no message on the action, and
// the global handler painted a "Website error" banner instead. This gives
// each of those chains a visible, specific failure message.
function pdcAdminListRequestFailed(action) {
  return error => {
    if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(`PDC admin list: could not ${action}`, error);
    const detail = String(error?.message || '').trim();
    pdcNotify(`Could not ${action}${detail ? ` (${detail})` : ''}. Check your connection and try again.`);
  };
}

function normalizePdcLocation(value = '') {
  const clean = String(value || '').trim().toUpperCase();
  if (!clean) return '';
  if (clean === 'YH' || clean.includes('YARD HOLD')) return 'YH';
  if (clean === 'PMB' || clean.includes('PERTH MOTOR BODIES')) return 'PMB';
  if (clean === 'PIT' || clean.includes('PIT INSPECTION') || clean.includes('DEPARTMENT OF TRANSPORT')) return 'PIT';
  if (clean === 'QC' || clean.includes('QUALITY CONTROL')) return 'QC';
  if (clean === 'RFT' || clean.includes('READY FOR TRANSPORT') || clean.includes('READY FOR TRANSFER')) return 'RFT';
  return '';
}

function pdcLocationLabel(value = '') {
  const normalized = normalizePdcLocation(value);
  return PDC_LOCATION_LABELS.get(normalized) || normalized || '';
}

function pdcLocationManualTransitionAllowed(current = '', target = '', vehicle = {}) {
  const from = normalizePdcLocation(current);
  const to = normalizePdcLocation(target);
  if (from === 'YH') return to === 'YH' || to === 'PMB';
  if (from === 'PMB') {
    return to === 'PMB' || (to === 'PIT'
      && !vehicle.pdcQcComplete
      && !normalizePmbStage(inferredPmbStage(vehicle)));
  }
  if (from === 'PIT') return to === 'PIT' || to === 'PMB';
  return false;
}

function pdcLocationSelectOptions(current = '', serverAuthoritative = false, vehicle = {}) {
  const normalizedCurrent = normalizePdcLocation(current);
  return PDC_LOCATION_OPTIONS.map(option => {
    const selected = option.value === normalizedCurrent ? ' selected' : '';
    const disabled = option.value !== normalizedCurrent && (
      option.systemOnly || (serverAuthoritative && !pdcLocationManualTransitionAllowed(normalizedCurrent, option.value, vehicle))
    ) ? ' disabled' : '';
    return `<option value="${escapeHtml(option.value)}"${selected}${disabled}>${escapeHtml(option.label)}</option>`;
  }).join('');
}

// r753 (F358, Craig 30 Oct 10:51): the tile row is the car's journey. PIT is a sublet step, not a stop on the journey,
// so its tile is gone (its list and calendar are the Pit bookings page in the menu). QC reads "Final check". WPC (work
// completed) sits between Final check and RFT: the car has passed final check and waits for Sales to say where it goes;
// the RFT'd tick moves it to RFT. Codes (qc, rft, PIT location) are unchanged underneath, so nothing else moves.
const VEHICLE_LOCATION_BUCKET_DEFS = Object.freeze([
  { key: 'rft', label: 'RFT', hint: 'RFT’d · Sales has given the destination · ready for transport' },
  { key: 'wpc', label: 'WPC', hint: 'Work completed · passed final check · waiting on Sales for the destination' },
  { key: 'qc', label: 'Final check', hint: 'All required station jobs complete · awaiting final check sign-off' },
  { key: 'newpmb', label: 'New to PMB', hint: 'Key number under 24 hours · also listed in PMB' },
  { key: 'pmb', label: 'PMB', hint: 'Vehicles at Perth Motor Bodies with work still active' },
  { key: 'yardhold', label: 'YARD HOLD', hint: 'Navision Yard Hold vehicles — release to PMB from here' },
  { key: 'nonnavision', label: 'NON-NAVISION VEHICLES', hint: 'No Navision location or ETA updates · move to PMB when the vehicle arrives' },
  { key: 'transit', label: 'IT', hint: 'In transit to WA / Kewdale' },
  { key: 'overseas', label: 'OTHER', hint: 'All other active vehicles' },
]);

function workshopEligibilityHarnessFallback() {
  // Whole-app VM tests execute app.js without loading index.html dependencies.
  // Never use this compatibility shape in a real browser: production must load
  // workshop-eligibility.js and fails closed if that canonical module is absent.
  if (window === globalThis) return null;
  const tuples = [
    ['BUS_4X4', 'Bus 4x4', 'bus4x4', 'planner-bus-4x4', 'workshop/bus-4x4', true],
    ['TINT', 'Tint', 'tint', 'planner-tint', 'workshop/tint', true],
    ['HOIST', 'Hoist', 'hoist', 'planner-hoist', 'workshop/hoist', true],
    ['FITTING', 'Fitting', 'fitting', 'planner-fitting', 'workshop/fitting', true],
    ['FABRICATION', 'Fab', 'fabrication', 'planner-fab', 'workshop/fab', true],
    ['ELECTRICAL', 'Elec', 'electrical', 'planner-elec', 'workshop/elec', true],
    ['TYRE', 'Tyre', 'tyre', 'planner-tyre', 'workshop/tyre', true],
    ['PIT_INSPECTION', 'Pit', 'pitInspection', '', '', false],
    ['SUBLET', 'Sublet', 'sublet', '', '', false],
  ];
  const stationDefinitions = tuples.map(([code, label, jobKey, route, path, plannerEnabled]) => ({ code, label, jobKey, route, path, plannerEnabled }));
  return {
    stationDefinitions,
    canonicalWorkshopStage: value => stationDefinitions.find(def => def.code === String(value || '').trim().toUpperCase())?.code || '',
    workshopPlannerStageCodes: () => stationDefinitions.filter(def => def.plannerEnabled).map(def => def.code),
    workshopPlannerStationDefinitions: () => stationDefinitions.filter(def => def.plannerEnabled),
  };
}

const WORKSHOP_ELIGIBILITY = window.PDC_WORKSHOP_ELIGIBILITY || workshopEligibilityHarnessFallback();
if (!WORKSHOP_ELIGIBILITY) throw new Error('Canonical workshop eligibility module failed to load');
if (!globalThis.PDC_WORKSHOP_ELIGIBILITY && window !== globalThis) globalThis.PDC_WORKSHOP_ELIGIBILITY = WORKSHOP_ELIGIBILITY;
const WORKSHOP_CANONICAL_STATION_DEFS = WORKSHOP_ELIGIBILITY.stationDefinitions;
const PMB_STAGE_OPTIONS = [
  { value: '', label: 'UNALLOCATED' },
  ...WORKSHOP_CANONICAL_STATION_DEFS
    .map(def => ({ value: def.code, label: def.label })),
];

const PMB_STAGE_DEFS = PMB_STAGE_OPTIONS.filter(option => option.value);
const PDC_JOB_LINE_STAGE_OPTIONS = PMB_STAGE_OPTIONS.filter(option => option.value && option.value !== 'SUBLET');
const PMB_STAGE_UNASSIGNED_FILTER = '__UNASSIGNED__';
const PMB_STAGE_LABELS = new Map([
  ...PMB_STAGE_OPTIONS.map(option => [option.value, option.label]),
  ['PIT_INSPECTION', 'Pit Inspection'],
]);

const PMB_WIP_LIMITS = {
  '': 12,
  BUS_4X4: 10,
  TINT: 2,
  HOIST: 3,
  FITTING: 5,
  FABRICATION: 16, // r509 (F122) / r941 (F521): 16 fabrication bays; 01-02 stay Internal / External Fabrication
  ELECTRICAL: 7, // r566 (F180): PMB Bays 13-19; 20-22 hidden (not deleted)
  TYRE: 2,
  PIT_INSPECTION: 1,
  SUBLET: 12,
};

const PMB_STAGE_BAY_COUNTS = {
  BUS_4X4: 10,
  TINT: 2,
  HOIST: 3,
  FITTING: 5,
  FABRICATION: 16, // r509 (F122) / r941 (F521): planner and PMB bay board draw Fab Bays 01-16
  ELECTRICAL: 7, // r566 (F180): Elec bays 08-10 (PMB 20-22) hidden via is_active
  TYRE: 2,
  PIT_INSPECTION: 1,
};

const PMB_STAGE_CAPACITY_LABELS = {
  BUS_4X4: '10 bays · Mechanical, Progression, QA, Electrical and Accessory Fitting',
  FABRICATION: '16 bays · Internal and External Fabrication, Fab 03-16',
  TYRE: '2 bays · 1 wheel alignment bay',
  SUBLET: 'Provider queue',
};

const PMB_STAGE_AGE_LIMITS = {
  '': 1,
  BUS_4X4: 2,
  TINT: 2,
  HOIST: 2,
  FITTING: 3,
  FABRICATION: 4,
  ELECTRICAL: 2,
  TYRE: 2,
  PIT_INSPECTION: 1,
};

const PMB_BAY_MAX_COUNT = 13;
const PMB_BAY_STATION_SEQUENCE = Object.freeze(WORKSHOP_ELIGIBILITY.workshopPlannerStageCodes());
const PRODUCTION_FLOW_DEFS = [
  { key: 'BUS_4X4', label: 'Bus 4x4', short: 'B4', jobKey: 'bus4x4', stage: 'BUS_4X4', department: '138', search: /\b(bus\s*4x4|4x4 bus|department\s*138)\b/i },
  { key: 'TINT', label: 'Tint', short: 'T', jobKey: 'tint', stage: 'TINT', search: /\b(tint|tinting|window tint)\b/i },
  { key: 'HOIST', label: 'Hoist', short: 'H', jobKey: 'hoist', stage: 'HOIST', search: /\b(hoist|suspension|gvm|lift kit|lift|underbody|towbar|tow bar)\b/i },
  { key: 'FITTING', label: 'Fitting', short: 'F', jobKey: 'fitting', stage: 'FITTING', search: /\b(fit|fitting|build|pdi|pre delivery|pre-delivery|accessor(?:y|ies)|job card|workshop)\b/i },
  { key: 'FABRICATION', label: 'Fab', short: 'Fa', jobKey: 'fabrication', stage: 'FABRICATION', search: /\b(fab|fabricat|tray|canopy|body builder|bodybuilder|steel tray|aluminium tray|tub body|bullbar|bar work)\b/i },
  { key: 'ELECTRICAL', label: 'Elec', short: 'E', jobKey: 'electrical', stage: 'ELECTRICAL', search: /\b(electrical|auto electrical|auto-elec|12v|dual battery|battery system|uhf|spotlight|light bar|beacon|compressor|anderson|redarc|brake controller|dc dc|dcdc|dash cam|camera|reverse camera|power outlet|usb)\b/i },
  { key: 'TYRE', label: 'Tyre', short: 'Ty', jobKey: 'tyre', stage: 'TYRE', search: /\b(tyre|tire|wheel|wheels|alloy|rotation|balance|alignment)\b/i },
  { key: 'PIT_INSPECTION', label: 'Pit', short: 'PI', jobKey: 'pitInspection', stage: 'PIT_INSPECTION', search: /\b(pit inspection|pit and weigh|inspection)\b/i },
];
const PRODUCTION_DEPARTMENT_VIEWS = {
  'dept-bus-4x4': 'BUS_4X4',
  'dept-tint': 'TINT',
  'dept-hoist': 'HOIST',
  'dept-fitting': 'FITTING',
  'dept-fabrication': 'FABRICATION',
  'dept-electrical': 'ELECTRICAL',
  'dept-tyre': 'TYRE',
  'dept-pit-inspection': 'PIT_INSPECTION',
};
const WORKSHOP_STATION_ROUTE_DEFS = Object.freeze(WORKSHOP_ELIGIBILITY.workshopPlannerStationDefinitions().map(def => ({
  view: def.route,
  path: def.path,
  stage: def.code,
  label: def.label,
})));
const WORKSHOP_PLANNER_VIEWS = Object.freeze(Object.fromEntries([
  ...WORKSHOP_STATION_ROUTE_DEFS.map(def => [def.view, def.stage]),
  ...(window.PDC_WORKSHOP_DEPARTMENTS?.BUS_WORK || []).filter(item => !item.external).map(item => [item.view, 'BUS_4X4']),
]));
const WORKSHOP_PLANNER_ROUTE_BY_STAGE = Object.freeze(Object.fromEntries(WORKSHOP_STATION_ROUTE_DEFS.map(def => [def.stage, def.view])));
const WORKSHOP_PLANNER_ROUTE_BY_PATH = Object.freeze(Object.fromEntries([
  ...WORKSHOP_STATION_ROUTE_DEFS.map(def => [def.path, def.view]),
  ...(window.PDC_WORKSHOP_DEPARTMENTS?.BUS_WORK || []).map(item => [item.path, item.view]),
]));
const WORKSHOP_CONTROL_BOARD_STATIONS = PMB_BAY_STATION_SEQUENCE;

const PDC_JOB_DEFS = [
  { key: 'bus4x4', label: 'BUS 4X4', short: 'B4', requireKey: 'pdcRequiresBus4x4', completeKey: 'pdcCompleteBus4x4', completeAtKey: 'pdcCompleteBus4x4At', completeByKey: 'pdcCompleteBus4x4By' },
  { key: 'tint', label: 'TINT', short: 'T', requireKey: 'pdcRequiresTint', completeKey: 'pdcCompleteTint', completeAtKey: 'pdcCompleteTintAt', completeByKey: 'pdcCompleteTintBy' },
  { key: 'hoist', label: 'HOIST', short: 'H', requireKey: 'pdcRequiresHoist', completeKey: 'pdcCompleteHoist', completeAtKey: 'pdcCompleteHoistAt', completeByKey: 'pdcCompleteHoistBy' },
  { key: 'fitting', label: 'FITTING', short: 'F', requireKey: 'pdcRequiresFitting', completeKey: 'pdcCompleteFitting', completeAtKey: 'pdcCompleteFittingAt', completeByKey: 'pdcCompleteFittingBy' },
  { key: 'fabrication', label: 'FAB', short: 'Fa', requireKey: 'pdcRequiresFabrication', completeKey: 'pdcCompleteFabrication', completeAtKey: 'pdcCompleteFabricationAt', completeByKey: 'pdcCompleteFabricationBy' },
  { key: 'electrical', label: 'ELEC', short: 'E', requireKey: 'pdcRequiresElectrical', completeKey: 'pdcCompleteElectrical', completeAtKey: 'pdcCompleteElectricalAt', completeByKey: 'pdcCompleteElectricalBy' },
  { key: 'tyre', label: 'TYRE', short: 'Ty', requireKey: 'pdcRequiresTyre', completeKey: 'pdcCompleteTyre', completeAtKey: 'pdcCompleteTyreAt', completeByKey: 'pdcCompleteTyreBy' },
  { key: 'pitInspection', label: 'PIT', short: 'PI', requireKey: 'pdcRequiresPitInspection', completeKey: 'pdcCompletePitInspection', completeAtKey: 'pdcCompletePitInspectionAt', completeByKey: 'pdcCompletePitInspectionBy' },
  { key: 'sublet', label: 'SUBLET', short: 'S', requireKey: 'pdcRequiresSublet', completeKey: 'pdcCompleteSublet', completeAtKey: 'pdcCompleteSubletAt', completeByKey: 'pdcCompleteSubletBy' },
  { key: 'parts', label: 'PARTS', short: 'P', requireKey: 'pdcRequiresParts', completeKey: 'pdcCompleteParts', completeAtKey: 'pdcCompletePartsAt', completeByKey: 'pdcCompletePartsBy' },
];
function currentPdcJobLabelList() {
  return PDC_JOB_DEFS.map(def => def.label).join(', ');
}

function currentPdcJobColumnList() {
  return PDC_JOB_DEFS.map(def => def.label).join('/');
}

function pdcJobTriState(vehicle = {}, def = {}) {
  if (pdcJobComplete(vehicle, def)) return 'complete';
  if (pdcJobRequired(vehicle, def)) return 'required';
  return 'none';
}

function canonicalVehicleWorkState(vehicle = {}, def = {}, options = {}) {
  const workStateGuard = typeof window !== 'undefined' ? window.VehicleRequirementsGuard : globalThis.VehicleRequirementsGuard;
  if (typeof workStateGuard?.projectWorkState !== 'function' || !def?.key) {
    return Object.freeze({ state: pdcJobTriState(vehicle, def), marker: '–', label: 'Unknown' });
  }
  const stage = pmbStageForPdcJob(def);
  const cachedDetail = typeof vehicleWorkshopDetailCanonicalId === 'function'
    ? app?.vehicleWorkshopDetailCache?.get(vehicleWorkshopDetailCanonicalId(vehicle))
    : null;
  const bookings = Array.isArray(options.bookings)
    ? options.bookings
    : [
      ...(Array.isArray(vehicle.salesWorkshopBookings) ? vehicle.salesWorkshopBookings : []),
      ...(cachedDetail?.status === 'ready' && Array.isArray(cachedDetail.detail?.bookings) ? cachedDetail.detail.bookings : []),
    ];
  const currentStageKey = PMB_STAGE_TO_JOB_KEY[normalizePmbStage(inferredPmbStage(vehicle))] || '';
  const vehicleStageStoppage = isPdcBlocked(vehicle) && currentStageKey === def.key;
  return workStateGuard.projectWorkState({
    workKey: def.key,
    required: pdcJobRequired(vehicle, def),
    completed: options.completed === true || options.completed === false ? options.completed : pdcJobComplete(vehicle, def),
    bookings,
    partsOrdered: def.key === 'parts' && partsOrdered(vehicle),
    partsStoppage: def.key === 'parts' && isActivePartsStoppage(vehicle),
    stoppage: Boolean(options.stoppage || vehicleStageStoppage),
    stoppageReason: options.stoppageReason || (vehicleStageStoppage ? pdcBlockReason(vehicle) : ''),
    subletBookings: Array.isArray(vehicle.pdcSubletBookings) ? vehicle.pdcSubletBookings : [],
  });
}

function pdcWorkDestinationDateLabel(value = '') {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-AU', { timeZone: 'Australia/Perth', day: '2-digit', month: '2-digit', year: '2-digit' });
}

function canonicalActiveSubletBooking(vehicle = {}) {
  const active = (Array.isArray(vehicle.pdcSubletBookings) ? vehicle.pdcSubletBookings : [])
    .filter(booking => String(booking?.status || '').trim().toLowerCase() === 'active' && booking?.bookingId)
    .sort((a, b) => String(a.outDate || '').localeCompare(String(b.outDate || '')) || String(a.bookingId).localeCompare(String(b.bookingId)));
  return active.length === 1 ? active[0] : null;
}

function pdcWorkDestination(vehicle = {}, def = {}) {
  if (!def?.key) return null;
  if (def.key === 'parts') {
    const eta = partsWorstEtaValue(vehicle);
    return pdcJobRequired(vehicle, def) ? { kind: 'view', view: 'parts', label: eta ? `ETA ${pdcWorkDestinationDateLabel(eta)}` : 'Open Parts', booked: partsOrdered(vehicle) } : null;
  }
  if (def.key === 'sublet') {
    const activeBooking = canonicalActiveSubletBooking(vehicle);
    const returnDate = cleanNavisionText(activeBooking?.expectedReturnDate || '');
    return pdcJobRequired(vehicle, def) ? { kind: 'view', view: 'sublet', label: returnDate ? `Return ${pdcWorkDestinationDateLabel(returnDate)}` : 'Open Sublet', booked: Boolean(activeBooking) } : null;
  }
  const stage = pmbStageForPdcJob(def);
  if (!stage || !WORKSHOP_PLANNER_ROUTE_BY_STAGE[stage]) return null;
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const state = canonicalId ? app?.vehicleWorkshopDetailCache?.get(canonicalId) : null;
  // r661 (F271): a queued job has no bay, so the pill says Not booked.
  const bookings = vehicleWorkshopBookingsForStage(state?.status === 'ready' ? state.detail?.bookings : [], stage)
    .filter(booking => !['completed', 'deleted', 'cancelled', 'queued'].includes(cleanNavisionText(booking.status).toLowerCase()));
  const booking = bookings[0];
  if (!booking) return null;
  const dateKey = vehicleWorkshopBookingDateKey(booking);
  const dateLabel = pdcWorkDestinationDateLabel(booking.scheduled_start_at);
  const bayLabel = Number(booking.bay_number) > 0 ? ` · ${pdcBayText(stage, Number(booking.bay_number))}` : '';
  return {
    kind: 'workshop', booked: true, label: `${dateLabel || 'Booked'}${bayLabel}`,
    bookingId: cleanNavisionText(booking.booking_id || ''), stage, dateKey,
  };
}

function pdcJobTriStateControl(vehicle = {}, def = {}, locked = false) {
  const state = pdcJobTriState(vehicle, def);
  const destination = pdcWorkDestination(vehicle, def);
  const projected = canonicalVehicleWorkState(vehicle, def);
  const ordered = def.key === 'parts' && projected.state === 'booked';
  const booked = projected.state === 'booked';
  const displayState = projected.state === 'completed' ? 'complete' : projected.state;
  const stateLabel = projected.state === 'required' ? 'To be completed' : projected.label;
  const disabled = locked ? ' disabled' : '';
  const destinationPill = destination?.kind === 'workshop' && destination.bookingId && destination.dateKey
    ? `<button type="button" class="pdc-work-destination-pill" data-vehicle-workshop-booking-id="${escapeHtml(destination.bookingId)}" data-vehicle-workshop-booking-stage="${escapeHtml(destination.stage)}" data-vehicle-workshop-booking-date="${escapeHtml(destination.dateKey)}" title="Open exact ${escapeHtml(def.label)} booking">${escapeHtml(destination.label)}</button>`
    : destination?.kind === 'view'
      ? `<button type="button" class="pdc-work-destination-pill" data-pdc-work-destination-view="${escapeHtml(destination.view)}" title="Open ${escapeHtml(def.label)}">${escapeHtml(destination.label)}</button>`
      : '<span class="pdc-work-destination-empty">Not booked</span>';
  return `<div class="pdc-work-state-cell"><button class="pdc-work-state pdc-work-state-${escapeHtml(displayState)}${booked ? ' pdc-work-state-ordered' : ''} pdc-toggle-${escapeHtml(def.key)}" type="button" data-pdc-work-state="${escapeHtml(def.key)}" data-state="${escapeHtml(state)}" aria-label="${escapeHtml(def.label)} - ${stateLabel}" title="${escapeHtml(def.label)} - ${stateLabel}. Grey not required, red to complete, orange booked/ordered, green completed, red STOPPAGE."${disabled}>
    <span class="pdc-work-state-code">${escapeHtml(def.short)}</span>
    <span class="pdc-work-state-label">${escapeHtml(def.label)}</span>
    <span class="pdc-work-state-status">${escapeHtml(stateLabel)}</span>
  </button>
  <input type="hidden" data-pdc-work-require="${escapeHtml(def.key)}" name="${escapeHtml(def.requireKey)}" value="${state === 'none' ? '0' : '1'}" />
  <input type="hidden" data-pdc-work-complete="${escapeHtml(def.key)}" name="${escapeHtml(def.completeKey)}" value="${state === 'complete' ? '1' : '0'}" />
  <div class="pdc-work-destination-box">${destinationPill}</div></div>`;
}

const PDC_JOB_BY_REQUIRE_KEY = new Map(PDC_JOB_DEFS.map(def => [def.requireKey, def]));
const PDC_JOB_BY_COMPLETE_KEY = new Map(PDC_JOB_DEFS.map(def => [def.completeKey, def]));
const PDC_JOB_BY_KEY = new Map(PDC_JOB_DEFS.map(def => [def.key, def]));
const PDC_IMPORT_CONTROL_COLUMNS_TEXT = 'BUS 4X4, TINT, HOIST, FITTING, FABRICATION, ELECTRICAL, TYRE, PIT, SUBLET, PARTS';

function currentPdcJobLabelsText() {
  return PDC_JOB_DEFS.map(def => def.label).join(', ');
}

const PMB_STAGE_TO_JOB_KEY = Object.freeze(Object.fromEntries(WORKSHOP_CANONICAL_STATION_DEFS.map(def => [def.code, def.jobKey])));

function pmbStageJobDef(stage = '') {
  const key = PMB_STAGE_TO_JOB_KEY[normalizePmbStage(stage)];
  return key ? PDC_JOB_BY_KEY.get(key) : null;
}

function pmbStageForPdcJob(def = {}) {
  const match = PRODUCTION_FLOW_DEFS.find(item => item.jobKey === def?.key);
  return match ? normalizePmbStage(match.stage) : '';
}

function pdcJobFieldSuffix(def = {}) {
  const clean = String(def.key || '').trim();
  return clean ? clean.charAt(0).toUpperCase() + clean.slice(1) : '';
}

function pdcJobMechanicKey(def = {}) { return `pdcComplete${pdcJobFieldSuffix(def)}Mechanic`; }
function pdcJobBayKey(def = {}) { return `pdcComplete${pdcJobFieldSuffix(def)}Bay`; }
function pdcJobHoursKey(def = {}) { return `pdcComplete${pdcJobFieldSuffix(def)}Hours`; }

function pdcJobMechanic(vehicle = {}, def = {}) {
  return cleanNavisionText(vehicle[pdcJobMechanicKey(def)] || '');
}

function pdcJobBay(vehicle = {}, def = {}) {
  return cleanNavisionText(vehicle[pdcJobBayKey(def)] || '');
}

function pdcJobHours(vehicle = {}, def = {}) {
  return cleanNavisionText(vehicle[pdcJobHoursKey(def)] || '');
}


function normalizePmbStage(value = '') {
  const canonical = WORKSHOP_ELIGIBILITY.canonicalWorkshopStage(value);
  if (canonical) return canonical;
  const clean = String(value || '').trim().toUpperCase();
  if (!clean) return '';
  if (/\bBUS[ _-]*4X4\b|\b4X4[ _-]*BUS\b|\b(?:DEPT|DEPARTMENT)[ _-]*138\b/.test(clean)) return 'BUS_4X4';
  if (clean.includes('TINT')) return 'TINT';
  if ((clean.includes('EXPRESS') && clean.includes('HOIST')) || clean.includes('PITS HOIST') || clean.includes('PIT HOIST')) return 'HOIST';
  if (clean.includes('EXPRESS') && (clean.includes('FITOUT') || clean.includes('FIT OUT') || clean.includes('FITTING') || clean.includes('FITMENT'))) return 'FITTING';
  if (clean.includes('HOIST') || clean.includes('SUSPENSION') || clean.includes('LIFT')) return 'HOIST';
  if (clean.includes('FITTING') || clean.includes('FITMENT') || clean.includes('FITOUT') || clean.includes('FIT OUT') || clean.includes('BUILD') || clean.includes('PDI') || clean.includes('PRE DELIVERY') || clean.includes('PRE-DELIVERY')) return 'FITTING';
  if (clean.includes('FAB') || clean.includes('TRAY') || clean.includes('BODY')) return 'FABRICATION';
  if (clean.includes('ELECTRICAL') || clean.includes('AUTO ELEC') || clean.includes('AUTO-ELEC') || clean.includes('12V') || clean.includes('UHF')) return 'ELECTRICAL';
  if (clean.includes('TYRE') || clean.includes('TIRE') || clean.includes('WHEEL')) return 'TYRE';
  if (clean.includes('PIT') || clean.includes('INSPECTION')) return 'PIT_INSPECTION';
  if (clean.includes('SUBLET') || clean.includes('SUB-LET') || clean.includes('SUB LET') || clean.includes('OUTSOURCE') || clean.includes('EXTERNAL')) return 'SUBLET';
  return '';
}

function pmbStageLabel(value = '') {
  const normalized = normalizePmbStage(value);
  return PMB_STAGE_LABELS.get(normalized) || normalized || '';
}

function normalizePmbSubFilter(value = '') {
  if (String(value || '') === PMB_STAGE_UNASSIGNED_FILTER) return PMB_STAGE_UNASSIGNED_FILTER;
  return normalizePmbStage(value);
}

function pmbSubFilterLabel(value = '') {
  if (value === PMB_STAGE_UNASSIGNED_FILTER) return 'Unallocated';
  return pmbStageLabel(value);
}

function pmbStageSelectOptions(current = '') {
  const normalizedCurrent = normalizePmbStage(current);
  return PMB_STAGE_OPTIONS.map(option => {
    const selected = option.value === normalizedCurrent ? ' selected' : '';
    return `<option value="${escapeHtml(option.value)}"${selected}>${escapeHtml(option.label)}</option>`;
  }).join('');
}

function pmbStageSourceText(vehicle = {}) {
  return [
    vehicle.pmbStage,
    vehicle.pdcWorkStage,
    vehicle.workStage,
    vehicle.internalStatus,
    vehicle.navisionDealerComments,
    vehicle.navisionVehicleNote,
    vehicle.financeNote,
    ...(vehicle.poTasks || []),
    ...(vehicle.poFiles || []),
    ...getNotes(vehicleKey(vehicle)),
  ].join(' ').toLowerCase();
}

function inferredPmbStage(vehicle = {}) {
  // Only a manually assigned PMB work stream should place a vehicle into
  // Required work ticks do not allocate vehicles into productive workshop stations.
  // Required work ticks do not allocate the vehicle into a production bucket.
  return normalizePmbStage(vehicle.pmbStage || '');
}

function pmbStageBadge(vehicle = {}) {
  const stage = inferredPmbStage(vehicle);
  return stage ? `<span class="badge pmb-stage-badge pmb-stage-${escapeHtml(stage.toLowerCase())}">${escapeHtml(pmbStageLabel(stage))}</span>` : '';
}

function nowIsoString() {
  return new Date().toISOString();
}

function parseIsoTimestamp(value = '') {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function pmbEnteredTimestamp(vehicle = {}) {
  const history = vehicle.lifecycleHistory && typeof vehicle.lifecycleHistory === 'object' ? vehicle.lifecycleHistory : {};
  return history.firstEnteredPmbAt || history.first_entered_pmb_at
    || vehicle.firstEnteredPmbAt || vehicle.first_entered_pmb_at
    || vehicle.pmbEnteredAt || vehicle.pmbTransferredAt || '';
}

// r407 (F19): day counts are Perth calendar days whatever the device's timezone.
// Perth is always UTC+8 (no daylight saving), so the Perth day number of an
// instant is floor((ms + 8 h) / 24 h). Dates parsed by parseDateAU are a
// calendar date (built from d/m/y), so their day number is taken from those fields.
function daysSinceTimestamp(value = '') {
  const parsed = parseIsoTimestamp(value);
  if (!parsed) return null;
  const start = Math.floor((parsed.getTime() + 8 * 3600000) / 86400000);
  const today = Math.floor((new Date().getTime() + 8 * 3600000) / 86400000);
  return Math.max(0, today - start);
}

function daysSinceDateValue(value = '') {
  const parsed = parseDateAU(value);
  if (!parsed || Number.isNaN(parsed.getTime())) return null;
  const start = Date.UTC(parsed.getFullYear(), parsed.getMonth(), parsed.getDate()) / 86400000;
  const today = Math.floor((new Date().getTime() + 8 * 3600000) / 86400000);
  return today - start;
}

function kewdaleEtaValue(vehicle = {}) {
  return scotEtaOnly(vehicle.navisionKewdaleEta || vehicle.etaAtKewdale || vehicle.etaAtDealer || '');
}

const PDC_DEPARTMENT_LABELS = { '138': 'Bus 4x4', '137': 'Fab', '139': 'PD' };

function vehicleDepartmentCode(vehicle = {}) {
  const raw = cleanNavisionText(vehicle.pdcDepartmentCode || vehicle.departmentCode || vehicle.navisionDepartmentCode || vehicle.department || vehicle.dept || '');
  const match = raw.match(/\b(137|138|139)\b/);
  if (match) return match[1];
  const text = raw.toLowerCase();
  if (/bus\s*4x4|4x4\s*bus/.test(text)) return '138';
  if (/\bfab(?:rication)?\b/.test(text)) return '137';
  if (/\bpd\b|pre.?delivery/.test(text)) return '139';
  return '';
}

function vehicleDepartmentLabel(vehicle = {}) {
  const code = vehicleDepartmentCode(vehicle);
  return code ? `${code} ${PDC_DEPARTMENT_LABELS[code]}` : '';
}

function vehicleDepartmentBadge(vehicle = {}) {
  const label = vehicleDepartmentLabel(vehicle);
  return label ? `<span class="badge pdc-department-badge pdc-department-${escapeHtml(vehicleDepartmentCode(vehicle))}">${escapeHtml(label)}</span>` : '';
}

function onSiteDays(vehicle = {}) {
  return daysSinceDateValue(kewdaleEtaValue(vehicle));
}

function onSiteDaysLabel(vehicle = {}) {
  const days = onSiteDays(vehicle);
  if (days === null) return 'Days on site unknown';
  if (days < 0) return `Due in ${Math.abs(days)}d`;
  if (days === 0) return 'On site today';
  return `${days}d on site`;
}

function onSiteDaysClass(vehicle = {}) {
  return vehicleAgeColourBand(onSiteDays(vehicle));
}

function vehicleAgeColourBand(days) {
  if (days === null) return 'unknown';
  if (days < 0) return 'future';
  if (days > 21) return 'critical';
  if (days > 10) return 'warning';
  if (days > 5) return 'watch';
  return 'fresh';
}

function locationAgeLabel(vehicle = {}) {
  const status = statusCategory(vehicle);
  const location = typeof vehiclePdcLocation === 'function' ? vehiclePdcLocation(vehicle) : '';
  if (status === 'pmb' || status === 'qc' || location === 'PMB') return pmbLifecycleAgeLabel(vehicle);
  if (status === 'yardhold' || location === 'YH') return yardHoldLifecycleAgeLabel(vehicle);
  return navisionEtaForVehicle(vehicle) || 'No ETA';
}

function pmbEnteredDateValue(vehicle = {}) {
  const timestamp = pmbEnteredTimestamp(vehicle);
  if (!timestamp) return '';
  const parsed = parseIsoTimestamp(timestamp);
  if (!parsed) return scotEtaOnly(timestamp);
  return parsed.toISOString().slice(0, 10);
}

// r830 (F391, Craig 30 Oct): WPC means the car has left the PMB key tags (into QC) and its number is free for reuse.
// Its age runs from the moment it became WPC until Autocare collects it; the PMB days before that are kept.
function vehicleKeyIsWpc(vehicle = {}) {
  return String(vehicle.keyNumber || vehicle.keyNo || vehicle.key_number || vehicle.keyTag || vehicle.pdcKeyNumber || '')
    .replace(/\s+/g, '').toUpperCase() === 'WPC';
}

function wpcTimerRow(vehicle = {}) {
  const map = typeof app === 'undefined' ? null : app.wpcTimers;
  if (!map || typeof map.get !== 'function') return null;
  for (const id of [vehicle.id, vehicle.__emailVehicleId, vehicle.sharedVehicleId, vehicle.permanent_vehicle_id]) {
    const row = id ? map.get(String(id)) : null;
    if (row) return row;
  }
  return null;
}

function ensureWpcTimers() {
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.wpcTimersLoading) return;
  const revision = app.emailVehicleLocationRevision;
  const revisionChanged = String(revision ?? '') !== String(app.wpcTimersRevision ?? '');
  if (!revisionChanged && app.wpcTimersLoadedAt && Date.now() - app.wpcTimersLoadedAt < 15000) return;
  app.wpcTimersLoading = true;
  const started = Date.now();
  client.rpc('list_wpc_timers_830').then(result => {
    app.wpcTimersLoading = false;
    app.wpcTimersLoadedAt = started;
    app.wpcTimersRevision = revision;
    if (result?.error) return;
    const next = new Map();
    (Array.isArray(result?.data) ? result.data : []).forEach(row => {
      if (row?.vehicle_id) next.set(String(row.vehicle_id), row);
    });
    const signature = [...next.entries()].map(([id, row]) => `${id}|${row.wpc_at || ''}|${row.collected_at || ''}`).sort().join('\n');
    const changed = signature !== app.wpcTimersSignature;
    app.wpcTimers = next;
    app.wpcTimersSignature = signature;
    if (changed && app.currentView === 'dashboard' && typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
    if (changed && app.currentView === 'qc' && typeof renderQualityControlPage === 'function') renderQualityControlPage();
  }).catch(() => {
    app.wpcTimersLoading = false;
    app.wpcTimersLoadedAt = started;
  });
}

function wholeDaysBetween(from, to) {
  const a = parseIsoTimestamp(from)?.getTime();
  const b = to ? parseIsoTimestamp(to)?.getTime() : Date.now();
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  const perth = ms => Math.floor((ms + 8 * 3600000) / 86400000);
  return Math.max(0, perth(b) - perth(a));
}

// r827 (F465): days since the RFT'd tick (the transport timer). Navision delivery or leaving Navision closes it.
function rftTransitAgeLabel(vehicle = {}) {
  const started = vehicle.dealerTransitStartedAt || vehicle.dealer_transit_started_at || '';
  if (!started) return '—';
  const days = wholeDaysBetween(started, vehicle.dealerTransitClosedAt || vehicle.dealer_transit_closed_at || null);
  return days === null ? '—' : `RFT ${days} day${days === 1 ? '' : 's'}`;
}

function wpcAgeInfo(vehicle = {}) {
  if (!vehicleKeyIsWpc(vehicle)) return null;
  ensureWpcTimers();
  const row = wpcTimerRow(vehicle);
  const days = row ? wholeDaysBetween(row.wpc_at, row.collected_at) : null;
  const pmbDays = row && row.pmb_key_at ? wholeDaysBetween(row.pmb_key_at, row.wpc_at) : null;
  const dayText = n => `${n} day${n === 1 ? '' : 's'}`;
  const label = days === null ? 'WPC' : `WPC ${dayText(days)}`;
  const parts = [days === null ? 'WPC start not recorded yet' : `${dayText(days)} since WPC${row.collected_at ? ' until Autocare collected it' : ', waiting for Autocare'}`];
  if (row && row.freed_key) parts.push(`key ${row.freed_key} freed`);
  if (pmbDays !== null) parts.push(`${dayText(pmbDays)} at PMB before WPC`);
  return { days, pmbDays, label, title: parts.join('. ') + '.' };
}

// r562 (F176) recorded the key instant. r563 (F177) starts the PMB age at the
// earlier of that instant and the first Tune import. When neither exists, the
// board arrival is kept and flagged.
function pmbVehicleHasKey(vehicle = {}) {
  const direct = String(vehicle.keyNumber || vehicle.keyNo || vehicle.key_number || vehicle.keyTag || vehicle.pdcKeyNumber || '').trim();
  if (direct && vehicleKeyIsWpc(vehicle)) return false;
  if (direct) return true;
  const row = pmbKeyAssignedRow(vehicle);
  return row ? row.has_key === true : false;
}

function pmbKeyAssignedRow(vehicle = {}) {
  const map = typeof app === 'undefined' ? null : app.pmbKeyAssigned;
  if (!map || typeof map.get !== 'function') return null;
  for (const id of [vehicle.id, vehicle.__emailVehicleId, vehicle.sharedVehicleId, vehicle.permanent_vehicle_id]) {
    const row = id ? map.get(String(id)) : null;
    if (row) return row;
  }
  return null;
}

function pmbKeyAssignedTimestamp(vehicle = {}) {
  const direct = vehicle.keyAssignedAt || vehicle.key_assigned_at || '';
  if (direct) return direct;
  const row = pmbKeyAssignedRow(vehicle);
  return row && row.assigned_at ? row.assigned_at : '';
}

// r593 (F207): the New to PMB view uses the stored key-assignment instant only.
// There is no fallback to the board arrival or the Tune import. No row means not new.
// r679 (F289, Craig 29 Oct): New to PMB lists a key number for its first 24 hours only.
// The old stored window (list_new_to_pmb_window_586) no longer exists, so the board always used 4 days.
function newToPmbWindowDays() {
  return 1;
}
function newToPmbWindowLabel() {
  return '24 hours';
}

function pmbKeyIsNew(vehicle = {}) {
  if (vehicleKeyIsWpc(vehicle)) return false;
  const raw = pmbKeyAssignedTimestamp(vehicle);
  if (!raw) return false;
  const when = new Date(raw).getTime();
  if (Number.isNaN(when)) return false;
  const age = Date.now() - when;
  return age >= 0 && age < newToPmbWindowDays() * 86400000;
}

function pmbBodybuilderHoldOpen(vehicle = {}) {
  const row = pmbArrivalRecord(vehicle);
  return Boolean(row && row.source === 'bodybuilder' && row.closed !== true);
}

function pmbNewTagHtml(vehicle = {}) {
  if (!pmbKeyIsNew(vehicle)) return '';
  return `<span class="badge pmb-new-tag" title="This key number is under ${newToPmbWindowLabel()} old. Display only. It does not change booking, eligibility, stations or QC.">New to PMB</span>`;
}

function pmbArrivalAgeRow(vehicle = {}) {
  const map = typeof app === 'undefined' ? null : app.pmbArrivalAge;
  if (!map || typeof map.get !== 'function') return null;
  for (const id of [vehicle.id, vehicle.__emailVehicleId, vehicle.sharedVehicleId, vehicle.permanent_vehicle_id]) {
    const row = id ? map.get(String(id)) : null;
    if (row) return row;
  }
  return null;
}

function pmbTuneImportedTimestamp(vehicle = {}) {
  const direct = vehicle.tuneImportedAt || vehicle.tune_imported_at || '';
  if (direct) return direct;
  const row = pmbArrivalAgeRow(vehicle);
  return row && row.tune_at ? row.tune_at : '';
}

function pmbArrivalAgeBasis(vehicle = {}) {
  // r707 (F317, Craig 29 Oct, standing rule): at PMB the age is days since the key number was given. A key always wins
  // over the Tune import date; the Tune date and board arrival are only used when there is no key.
  const keyFirst = vehicle.keyAssignedAt || vehicle.key_assigned_at || (pmbVehicleHasKey(vehicle) ? pmbKeyAssignedTimestamp(vehicle) : '');
  if (keyFirst && Number.isFinite(parseIsoTimestamp(keyFirst)?.getTime())) return 'key';
  const directKey = vehicle.keyAssignedAt || vehicle.key_assigned_at || '';
  const directTune = vehicle.tuneImportedAt || vehicle.tune_imported_at || '';
  const row = pmbArrivalAgeRow(vehicle);
  if (!directKey && !directTune && row && row.basis) return row.basis;
  const keyAt = directKey || (pmbVehicleHasKey(vehicle) ? pmbKeyAssignedTimestamp(vehicle) : '');
  const tuneAt = directTune || (row && row.tune_at) || '';
  const keyMs = keyAt ? parseIsoTimestamp(keyAt)?.getTime() : NaN;
  const tuneMs = tuneAt ? parseIsoTimestamp(tuneAt)?.getTime() : NaN;
  if (Number.isFinite(keyMs) && Number.isFinite(tuneMs)) return keyMs <= tuneMs ? 'key' : 'tune';
  if (Number.isFinite(keyMs)) return 'key';
  if (Number.isFinite(tuneMs)) return 'tune';
  return 'fallback';
}

function pmbArrivalAgeTimestamp(vehicle = {}) {
  const basis = pmbArrivalAgeBasis(vehicle);
  const row = pmbArrivalAgeRow(vehicle);
  if (basis === 'key') return pmbKeyAssignedTimestamp(vehicle) || row?.key_at || row?.arrived_at || '';
  if (basis === 'tune') return pmbTuneImportedTimestamp(vehicle) || row?.arrived_at || '';
  return pmbEnteredTimestamp(vehicle) || vehicle.dateToPmb || vehicle.date_to_pmb || row?.date_to_pmb || '';
}

function pmbAgeDays(vehicle = {}) {
  return daysSinceTimestamp(pmbArrivalAgeTimestamp(vehicle));
}

function pmbAgeLabel(vehicle = {}) {
  const wpc = wpcAgeInfo(vehicle);
  if (wpc) return wpc.label;
  if (typeof ensurePmbKeyAssigned === 'function') ensurePmbKeyAssigned();
  if (typeof ensurePmbArrivalAge === 'function') ensurePmbArrivalAge();
  const days = pmbAgeDays(vehicle);
  if (days === null) return pmbVehicleHasKey(vehicle) ? '—' : 'No key';
  return `${days} day${days === 1 ? '' : 's'}`;
}

function lifecycleAgeDays(vehicle = {}, key = '') {
  const timestamp = lifecycleHistoryForVehicle(vehicle)[key] || '';
  return daysSinceTimestamp(timestamp);
}

function lifecycleAgeDaysLabel(days) {
  return days === null ? 'Unknown' : String(days);
}

function pmbLifecycleAgeLabel(vehicle = {}) {
  return pmbAgeLabel(vehicle);
}

function yardHoldLifecycleAgeLabel(vehicle = {}) {
  return '—';
}

function partsEtaCounterLabel(vehicle = {}) {
  if (pmbAgeDays(vehicle) !== null) return pmbAgeLabel(vehicle);
  const eta = kewdaleEtaValue(vehicle);
  return dateHelper(eta) || 'No ETA counter';
}

function partsEtaCounterClass(vehicle = {}) {
  if (pmbAgeDays(vehicle) !== null) return pmbAgeClass(vehicle);
  const eta = etaDeltaText(kewdaleEtaValue(vehicle));
  if (eta.cls === 'negative') return 'overdue';
  if (eta.cls === 'positive') return 'future';
  if (eta.cls === 'neutral' && eta.label) return 'fresh';
  return 'unknown';
}

function pmbAgeDetailText(vehicle = {}) {
  const wpc = wpcAgeInfo(vehicle);
  if (wpc) return wpc.title;
  const basis = pmbArrivalAgeBasis(vehicle);
  const days = pmbAgeDays(vehicle);
  if (basis === 'tune') {
    if (days === null) return 'Tune import date not recorded';
    if (days === 0) return 'First Tune import was today';
    return `${days} day${days === 1 ? '' : 's'} since this vehicle first appeared in a Tune import`;
  }
  if (basis === 'fallback') {
    if (days === null) return 'No key history and no Tune import, so there is no PMB age';
    return `${days} day${days === 1 ? '' : 's'} since the board arrival. No key history and no Tune import.`;
  }
  if (days === null) return pmbVehicleHasKey(vehicle) ? 'Key number date not recorded' : 'No key number, so there is no PMB age';
  if (days === 0) return 'Key number assigned today';
  return `${days} day${days === 1 ? '' : 's'} since the key number was assigned`;
}

function pmbAgeClass(vehicle = {}) {
  const days = pmbAgeDays(vehicle);
  if (days === null) return 'unknown';
  if (days > 30) return 'critical';
  if (days > 15) return 'warning';
  if (days > 7) return 'watch';
  if (days < 0) return 'future';
  return 'fresh';
}

function lifecycleHistoryForVehicle(vehicle = {}) {
  const history = vehicle.lifecycleHistory && typeof vehicle.lifecycleHistory === 'object' ? vehicle.lifecycleHistory : {};
  return {
    ...history,
    firstReachedYardHoldAt: history.firstReachedYardHoldAt || history.first_reached_yard_hold_at || vehicle.firstReachedYardHoldAt || '',
    firstEnteredPmbAt: history.firstEnteredPmbAt || history.first_entered_pmb_at || vehicle.firstEnteredPmbAt || '',
    firstBecameRftAt: history.firstBecameRftAt || history.first_became_rft_at || vehicle.firstBecameRftAt || '',
    elapsedYardHoldToPmbSeconds: history.elapsedYardHoldToPmbSeconds ?? history.elapsed_yard_hold_to_pmb_seconds ?? null,
    elapsedPmbToRftSeconds: history.elapsedPmbToRftSeconds ?? history.elapsed_pmb_to_rft_seconds ?? null,
    elapsedYardHoldToRftSeconds: history.elapsedYardHoldToRftSeconds ?? history.elapsed_yard_hold_to_rft_seconds ?? null,
    elapsedYardHoldToPmbDays: history.elapsedYardHoldToPmbDays ?? history.elapsed_yard_hold_to_pmb_days ?? null,
    elapsedPmbToRftDays: history.elapsedPmbToRftDays ?? history.elapsed_pmb_to_rft_days ?? null,
    elapsedYardHoldToRftDays: history.elapsedYardHoldToRftDays ?? history.elapsed_yard_hold_to_rft_days ?? null,
    evidenceState: history.evidenceState || history.evidence_state || 'partial_or_unknown',
    missingEvidence: Array.isArray(history.missingEvidence) ? history.missingEvidence : (Array.isArray(history.missing_evidence) ? history.missing_evidence : []),
  };
}

function lifecycleTimestamp(vehicle = {}, key = '') {
  const history = lifecycleHistoryForVehicle(vehicle);
  return parseIsoTimestamp(history[key] || '');
}

function completedPmbStartDate(vehicle = {}) {
  return lifecycleTimestamp(vehicle, 'firstEnteredPmbAt');
}

function completedRftDate(vehicle = {}) {
  return lifecycleTimestamp(vehicle, 'firstBecameRftAt');
}

function dateOnly(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
}

function completedPmbDays(vehicle = {}) {
  const history = lifecycleHistoryForVehicle(vehicle);
  const recorded = history.elapsedPmbToRftDays;
  if ((typeof recorded === 'number' || (typeof recorded === 'string' && recorded.trim())) && Number.isFinite(Number(recorded)) && Number(recorded) >= 0) return Number(recorded);
  const start = completedPmbStartDate(vehicle);
  const end = completedRftDate(vehicle);
  if (!start || !end || end < start) return null;
  return (end - start) / 86400000;
}

function lifecycleDurationDays(vehicle = {}, key = '') {
  const history = lifecycleHistoryForVehicle(vehicle);
  const daysKey = `${key}Days`;
  const recorded = history[daysKey];
  if ((typeof recorded === 'number' || (typeof recorded === 'string' && recorded.trim())) && Number.isFinite(Number(recorded)) && Number(recorded) >= 0) return Number(recorded);
  const pairs = {
    elapsedYardHoldToPmb: ['firstReachedYardHoldAt', 'firstEnteredPmbAt'],
    elapsedPmbToRft: ['firstEnteredPmbAt', 'firstBecameRftAt'],
    elapsedYardHoldToRft: ['firstReachedYardHoldAt', 'firstBecameRftAt'],
  };
  const [from, to] = pairs[key] || [];
  const start = from ? lifecycleTimestamp(vehicle, from) : null;
  const end = to ? lifecycleTimestamp(vehicle, to) : null;
  return start && end && end >= start ? (end - start) / 86400000 : null;
}

function lifecycleDurationLabel(vehicle = {}, key = '') {
  const days = lifecycleDurationDays(vehicle, key);
  if (!Number.isFinite(days)) return 'Unknown';
  const history = lifecycleHistoryForVehicle(vehicle);
  const secondsKey = `${key}Seconds`;
  const recorded = history[secondsKey];
  const seconds = (typeof recorded === 'number' || (typeof recorded === 'string' && recorded.trim())) && Number.isFinite(Number(recorded)) && Number(recorded) >= 0 ? String(recorded) : String(days * 86400);
  const dayText = Number(days).toFixed(6).replace(/0+$/, '').replace(/\.$/, '');
  return `${dayText} day${dayText === '1' ? '' : 's'} (${seconds} seconds)`;
}

function completedPmbDaysLabel(vehicle = {}) {
  const days = completedPmbDays(vehicle);
  if (days === null) return 'Unknown';
  if (days === 0) return 'Same day';
  return `${days} day${days === 1 ? '' : 's'}`;
}

function completedPmbStatisticsFromDays(values = []) {
  const durations = (Array.isArray(values) ? values : [])
    .filter(value => Number.isFinite(value) && value >= 0)
    .sort((a, b) => a - b);
  const midpoint = Math.floor(durations.length / 2);
  const median = !durations.length
    ? null
    : (durations.length % 2 ? durations[midpoint] : (durations[midpoint - 1] + durations[midpoint]) / 2);
  return {
    known: durations.length,
    average: durations.length ? durations.reduce((total, value) => total + value, 0) / durations.length : null,
    median,
    fastest: durations.length ? durations[0] : null,
    longest: durations.length ? durations[durations.length - 1] : null,
  };
}

function completedPmbStatistics(vehicles = []) {
  const rows = Array.isArray(vehicles) ? vehicles : [];
  const stats = completedPmbStatisticsFromDays(rows.map(completedPmbDays));
  return { ...stats, total: rows.length, unknown: Math.max(0, rows.length - stats.known) };
}

function completedPmbStatisticDaysLabel(value) {
  if (!Number.isFinite(value)) return '—';
  const rounded = Math.round(value * 10) / 10;
  return `${rounded} day${rounded === 1 ? '' : 's'}`;
}

function renderCompletedPmbStatistics(rows = completedVehicleRows()) {
  const host = $('#completed-pmb-statistics');
  if (!host) return;
  const historyRows = rows.map(vehicle => ({ vehicle, milestones: completedHistoryMilestones(vehicle) }));
  const measures = [
    ['pmbToRft', 'PMB → RFT', 'Work turnaround'],
    ['rftToOd', 'RFT → OD recorded', 'Ready for transport to delivery confirmation'],
    ['pmbToOd', 'PMB → OD recorded', 'Total recorded time'],
  ].map(([key, label, note]) => {
    const intervals = historyRows.map(row => completedHistoryInterval(row.vehicle, key, row.milestones));
    return { key, label, note, dateOnly: intervals.some(interval => interval?.dateOnly), ...completedPmbStatisticsFromDays(intervals.map(interval => interval?.days ?? null)) };
  });
  host.innerHTML = `<div class="completed-statistics-heading">
      <div><span>Completed vehicle turnaround</span><strong>${rows.length} delivered vehicle${rows.length === 1 ? '' : 's'}${($('#completed-search')?.value || '').trim() ? ' matching search' : ''}</strong></div>
      <small>Averages use known dates only. Missing or reversed dates are excluded.</small>
    </div>
    <div class="completed-statistics-grid completed-history-statistics">
      ${measures.map((stats, index) => `<article class="completed-stat-card ${index === 0 ? 'is-primary' : ''}" data-completed-stat="${escapeHtml(stats.key)}"><span>Average ${escapeHtml(stats.label)}</span><strong>${escapeHtml(stats.dateOnly && stats.average !== null ? `${Math.round(stats.average * 10) / 10} days` : completedHistoryDurationLabel(stats.average === null ? null : { seconds: stats.average * 86400, days: stats.average, dateOnly: false }))}</strong><small>${escapeHtml(stats.note)} · ${stats.known} of ${rows.length} vehicle${rows.length === 1 ? '' : 's'} with known dates${stats.dateOnly ? ' · includes date-only records' : ''}</small></article>`).join('')}
    </div>${typeof completedHistoryTurnaroundHtml === 'function' && (app.pmbTurnaround895 || app.pmbTurnaroundLoading895 || app.pmbTurnaroundError895) ? completedHistoryTurnaroundHtml() : ''}`;
  if (typeof completedHistoryBindTurnaround === 'function') completedHistoryBindTurnaround(host);
}

function shortDateAu(date) {
  if (!date) return '';
  const parsed = date instanceof Date ? date : new Date(date);
  if (!Number.isFinite(parsed.getTime())) return '';
  return parsed.toLocaleDateString('en-AU', { timeZone: 'Australia/Perth', day: '2-digit', month: '2-digit', year: 'numeric' });
}

function pmbStageEnteredTimestamp(vehicle = {}) {
  return vehicle.pmbStageEnteredAt || vehicle.pmbStageUpdatedAt || pmbEnteredTimestamp(vehicle);
}

function pmbStageAgeDays(vehicle = {}) {
  return daysSinceTimestamp(pmbStageEnteredTimestamp(vehicle));
}

function pmbStageAgeLabel(vehicle = {}) {
  const days = pmbStageAgeDays(vehicle);
  const stage = pmbStageLabel(inferredPmbStage(vehicle)) || 'Unallocated';
  if (days === null) return `${stage} age unknown`;
  return `${stage} ${days} day${days === 1 ? '' : 's'}`;
}

function pmbStageAgeClass(vehicle = {}) {
  const days = pmbStageAgeDays(vehicle);
  if (days === null) return 'unknown';
  const stage = inferredPmbStage(vehicle);
  const limit = PMB_STAGE_AGE_LIMITS[stage] ?? 3;
  if (days > limit) return 'overdue';
  if (days >= Math.max(1, limit - 1)) return 'watch';
  return 'fresh';
}

function pmbLaneLimit(stage = '') {
  const normalized = normalizePmbStage(stage);
  return PMB_WIP_LIMITS[normalized] ?? PMB_WIP_LIMITS[''];
}

function pmbStageBayCount(stage = '') {
  const normalized = normalizePmbStage(stage);
  return PMB_STAGE_BAY_COUNTS[normalized] ?? PMB_BAY_MAX_COUNT;
}

// r483 (F96): Dept 139 bays read with Craig's names and numbers ('Fitting · Bay 06', from
// pdc-workshop-departments.js); Bus 4x4 and the shared Tint / Tyre bays keep their plain 'Bay N'.
function pdcBayText(stage = '', bay = '', pad = false) {
  // r548 (F162): a missing bay reads Unallocated, never Bay 00.
  const number = Number(bay);
  if (!Number.isInteger(number) || number < 1) return 'Unallocated';
  // r549 (F163): prefer the cached bay display_name when present.
  let normalized = '';
  try { if (typeof normalizePmbStage === 'function') normalized = normalizePmbStage(stage); } catch (_error) { normalized = ''; }
  if (!normalized && typeof globalThis.normalizePmbStage === 'function') normalized = globalThis.normalizePmbStage(stage);
  if (!normalized) normalized = String(stage || '').trim().toUpperCase();
  const rows = (typeof window === 'object' && window.__workshopReferenceDataService?.getCachedWorkshopBays?.()?.rows) || [];
  const code = `${normalized}-BAY-${String(number).padStart(2, '0')}`;
  const stored = String(rows.find(row => row && row.code === code)?.display_name || '').trim();
  if (stored) return stored;
  const layout = typeof window === 'object' ? window.PDC_WORKSHOP_DEPARTMENTS : null;
  const named = layout?.pmbBayLabel?.(normalized, number);
  return named || `Bay ${pad ? String(number).padStart(2, '0') : number}`;
}

function pmbStageCapacityLabel(stage = '') {
  const normalized = normalizePmbStage(stage);
  const explicit = PMB_STAGE_CAPACITY_LABELS[normalized];
  if (explicit) return explicit;
  const count = pmbStageBayCount(normalized);
  if (!count) return 'Refer Dan';
  return `${count} bay${count === 1 ? '' : 's'}`;
}

function pmbBayVehiclesForStage(stage = '') {
  const normalized = normalizePmbStage(stage);
  if (!normalized) return [];
  return app.data.filter(vehicle => statusCategory(vehicle) === 'pmb'
    && normalizePmbStage(inferredPmbStage(vehicle)) === normalized
    && pmbBayNumber(vehicle, normalized));
}

function pmbBayOccupants(stage = '', bay = '', excludeKey = '') {
  const normalized = normalizePmbStage(stage);
  const bayNumber = normalizePmbBayNumber(bay, normalized);
  const cleanExclude = String(excludeKey || '').trim();
  if (!normalized || !bayNumber) return [];
  return app.data.filter(vehicle => {
    if (cleanExclude && vehicleKey(vehicle) === cleanExclude) return false;
    if (statusCategory(vehicle) !== 'pmb') return false;
    if (normalizePmbStage(inferredPmbStage(vehicle)) !== normalized) return false;
    return pmbBayNumber(vehicle, normalized) === bayNumber;
  });
}

function pmbStageHasBayCapacity(stage = '', excludeKey = '') {
  const normalized = normalizePmbStage(stage);
  const bayCount = pmbStageBayCount(normalized);
  if (!normalized || !bayCount) return true;
  const cleanExclude = String(excludeKey || '').trim();
  const occupied = pmbBayVehiclesForStage(normalized).filter(vehicle => vehicleKey(vehicle) !== cleanExclude).length;
  return occupied < bayCount;
}

function pmbLaneAgeLimit(stage = '') {
  const normalized = normalizePmbStage(stage);
  return PMB_STAGE_AGE_LIMITS[normalized] ?? PMB_STAGE_AGE_LIMITS[''];
}

function pmbLaneMetrics(stage = '', vehicles = []) {
  const limit = pmbLaneLimit(stage);
  const oldestStageDays = vehicles.reduce((max, vehicle) => {
    const days = pmbStageAgeDays(vehicle);
    return days === null ? max : Math.max(max, days);
  }, 0);
  const blockedCount = vehicles.filter(isPdcBlocked).length;
  return {
    limit,
    limitLabel: Number.isFinite(limit) ? String(limit) : 'Refer Dan',
    overLimit: Number.isFinite(limit) && vehicles.length > limit,
    atLimit: Number.isFinite(limit) && vehicles.length === limit,
    blockedCount,
    oldestStageDays,
  };
}

function isPdcBlocked(vehicle = {}) {
  return vehicle.pdcBlocked === true
    || Boolean(cleanNavisionText(vehicle.pdcBlockReason || ''))
    || vehicle.pdcWorkshopBlocked === true
    || Boolean(cleanNavisionText(vehicle.pdcWorkshopBlockReason || ''));
}

function pdcBlockReason(vehicle = {}) {
  return cleanNavisionText(vehicle.pdcBlockReason || '')
    || cleanNavisionText(vehicle.pdcWorkshopBlockReason || '')
    || 'Blocked';
}

function pdcBooleanFromText(value) {
  const clean = cleanNavisionText(value).toLowerCase();
  if (!clean) return undefined;
  if (/^(yes|y|true|1|tick|ticked|x|required|req|done|complete|completed|signed off)$/i.test(clean)) return true;
  if (/^(no|n|false|0|not required|none|blank|na|n\/a|not needed|open)$/i.test(clean)) return false;
  return undefined;
}

function pdcQualityControlRequirementDefinitions(vehicle = {}) {
  return pdcRequirementDefinitions(vehicle).filter(job => !['parts', 'pitInspection'].includes(job.key));
}

function vehicleRftGateIssues(vehicle = {}) {
  const issues = [];
  if (isPdcBlocked(vehicle)) issues.push(`Blocked: ${pdcBlockReason(vehicle)}`);
  if (vehicle.pdcPartsStoppage === true || cleanNavisionText(vehicle.pdcPartsStoppageReason || '')) {
    issues.push(`Parts STOPPAGE: ${partsStoppageReason(vehicle)}`);
  }
  if (partsEtaRisk(vehicle)) issues.push(`PARTS RISK: Parts ETA ${partsWorstEtaLabel(vehicle)} is later than the scheduled Workshop booking date`);
  const outstanding = pdcQualityControlRequirementDefinitions(vehicle).filter(job => !pdcJobComplete(vehicle, job)).map(job => job.label);
  if (outstanding.length) issues.push(`Outstanding jobs: ${outstanding.join(', ')}`);
  const alreadyTransferredToRft = vehiclePdcLocation(vehicle) === 'RFT' || statusCategory(vehicle) === 'rft' || vehicleCollectedFromRft(vehicle);
  const locationCategory = statusCategory(vehicle);
  if (!alreadyTransferredToRft && ['pmb', 'qc'].includes(locationCategory)) {
    const currentStage = normalizePmbStage(inferredPmbStage(vehicle));
    const currentBay = currentStage ? pmbBayNumber(vehicle, currentStage) : '';
    if (currentBay) issues.push(`Currently in ${pmbStageLabel(currentStage)} Bay ${currentBay}`);
    if (!outstanding.length && vehicle.pdcQcComplete !== true) issues.push('QC sign-off required');
  }
  return issues;
}

function vehiclesWithRftGateIssues(vehicles = []) {
  return vehicles.map(vehicle => ({ vehicle, issues: vehicleRftGateIssues(vehicle) })).filter(row => row.issues.length);
}


function pdcJobDefinitionForKey(key = '') {
  const clean = String(key || '').trim();
  return PDC_JOB_BY_REQUIRE_KEY.get(clean) || PDC_JOB_BY_COMPLETE_KEY.get(clean) || PDC_JOB_BY_KEY.get(clean.toLowerCase()) || null;
}

function pdcJobSourceText(vehicle = {}) {
  return pmbStageSourceText(vehicle);
}

function navisionVehicleRequiresExplicitPdcWork(vehicle = {}) {
  const lifecycle = cleanNavisionText(vehicle.recordLifecycle || '').toLowerCase();
  const source = cleanNavisionText(vehicle.source || '').toLowerCase();
  return lifecycle === 'navision' || source === 'navision' || source === 'navision import';
}

function pdcStageMatchesJob(stage = '', def = {}) {
  const normalized = normalizePmbStage(stage);
  if (!normalized || !def?.key) return false;
  return ({
    bus4x4: 'BUS_4X4',
    tint: 'TINT',
    hoist: 'HOIST',
    fitting: 'FITTING',
    fabrication: 'FABRICATION',
    electrical: 'ELECTRICAL',
    tyre: 'TYRE',
    sublet: 'SUBLET',
  })[def.key] === normalized;
}

function pdcJobFallbackRequired(vehicle = {}, def = {}) {
  const source = pdcJobSourceText(vehicle);
  const stage = normalizePmbStage(vehicle.pmbStage || vehicle.pdcWorkStage || vehicle.workStage || '');
  // Daily Navision and Back End Data rows must not create work ticks from free-text
  // comments, vehicle notes or location descriptions. Explicit spreadsheet booleans,
  // PO-derived flags and operator choices are handled before this fallback. A deliberate
  // PMB bay/stage assignment may still show its matching work item as required.
  if (navisionVehicleRequiresExplicitPdcWork(vehicle)) return pdcStageMatchesJob(stage, def);
  switch (def.key) {
    case 'bus4x4':
      return /\b(bus\s*4x4|4x4\s*bus|department\s*138)\b/.test(source) || stage === 'BUS_4X4' || vehicleDepartmentCode(vehicle) === '138';
    case 'tint':
      return legacyVehicleFlag(vehicle, 'tintRaised') || /\b(tint|tinting|window tint)\b/.test(source) || stage === 'TINT';
    case 'hoist':
      return legacyVehicleFlag(vehicle, 'buildPoRaised') || /\b(hoist|suspension|gvm|lift kit|lift|underbody|towbar|tow bar)\b/.test(source) || stage === 'HOIST';
    case 'fitting':
      return legacyVehicleFlag(vehicle, 'buildPoRaised') || legacyVehicleFlag(vehicle, 'buildComplete') || /\b(fit|fitting|fitment|fitout|fit out|build|pdi|pre delivery|pre-delivery|job card|workshop|accessor(?:y|ies))\b/.test(source) || stage === 'FITTING';
    case 'electrical':
      return /\b(electrical|auto electrical|auto-elec|12v|dual battery|battery system|uhf|spotlight|light bar|beacon|compressor|anderson|redarc|brake controller|dc dc|dcdc|dash cam|camera|reverse camera|power outlet|usb)\b/.test(source) || stage === 'ELECTRICAL';
    case 'tyre':
      return /\b(tyre|tire|wheel|wheels|alloy|rotation|balance|alignment)\b/.test(source) || stage === 'TYRE';
    case 'sublet':
      return /\b(sublet|sub-let|sub let|outsourced|external contractor|external work|outside contractor)\b/.test(source) || stage === 'SUBLET';
    case 'fabrication':
      return legacyVehicleFlag(vehicle, 'trayOrdered') || legacyVehicleFlag(vehicle, 'trayFitmentComplete') || /\b(fab|fabricat|tray|canopy|body builder|bodybuilder|steel tray|aluminium tray|tub body|bullbar|bar work)\b/.test(source) || stage === 'FABRICATION';
    default:
      return false;
  }
}

function pdcJobRequired(vehicle = {}, def = {}) {
  if (def?.busCategory) return busCategoryState(vehicle, def).required; // r799
  if (!def?.requireKey) return false;
  // Parts is not an optional work bucket in this PDC flow.
  // Every imported vehicle with a real batch / stock number requires Parts to order and sign off before RFT.
  if (def.key === 'parts') {
    const projection = vehicle.parts_update || vehicle.partsUpdate || vehicle.__emailPartsUpdate || null;
    if (projection && typeof projection.parts_required === 'boolean') return projection.parts_required;
    return vehicleHasBatchNumber(vehicle);
  }
  // r401: Pit and weigh never counts as required work. It never blocks QC,
  // RFT, completion, progress, scheduling or dispatch, and any department can tick it.
  if (def.key === 'pitInspection') return false;
  if (def.key === 'fitting' && vehicle.pdcRequiresBuild === true) return true;
  if (vehicle[def.requireKey] === true) return true;
  if (vehicle[def.requireKey] === false) return false;
  return pdcJobFallbackRequired(vehicle, def);
}

function pdcJobComplete(vehicle = {}, def = {}) {
  if (def?.busCategory) return busCategoryState(vehicle, def).complete; // r799
  if (!def?.completeKey) return false;
  if (vehicle[def.completeKey] === true) return true;
  if (vehicle[def.completeKey] === false) return false;
  return false;
}

// r578 (F192): a station icon is green when every line of that station is done,
// or a controller overrode the station. The work-item flag above is unchanged.
function pdcStationLinesMakeComplete(vehicle = {}, def = {}) {
  if (!def?.key || def.key === 'pitInspection') return false;
  if (vehicle?.pdcStationLinesComplete?.[def.key] === true) return true;
  const id = typeof pmbArrivalVehicleId === 'function' ? pmbArrivalVehicleId(vehicle) : String(vehicle?.id || '');
  if (!id || typeof app === 'undefined' || !(app?.stationIconCompletion instanceof Map)) return false;
  return app.stationIconCompletion.get(String(id))?.[def.key]?.complete === true;
}

function pdcStationLinesOverrideBy(vehicle = {}, def = {}) {
  if (!def?.key) return '';
  const listed = vehicle?.pdcStationLineOverride?.[def.key];
  if (listed) return String(listed);
  const id = typeof pmbArrivalVehicleId === 'function' ? pmbArrivalVehicleId(vehicle) : String(vehicle?.id || '');
  if (!id || typeof app === 'undefined' || !(app?.stationIconCompletion instanceof Map)) return '';
  const row = app.stationIconCompletion.get(String(id))?.[def.key];
  if (row?.override !== true) return '';
  return String(row.by || 'controller');
}

function pdcRequiredJobs(vehicle = {}) {
  return PDC_JOB_DEFS.filter(def => pdcJobRequired(vehicle, def));
}

function pdcCompletedJobs(vehicle = {}) {
  return PDC_JOB_DEFS.filter(def => pdcJobRequired(vehicle, def) && pdcJobComplete(vehicle, def));
}

function pdcRequirementDefinitions(vehicle = {}) {
  return pdcRequiredJobs(vehicle).map(def => ({ ...def, required: true, complete: pdcJobComplete(vehicle, def) }));
}

function pmbRequirementDefinitions(vehicle = {}) {
  return pdcRequirementDefinitions(vehicle);
}

function pdcJobCompletionTitle(vehicle = {}, def = {}) {
  const complete = pdcJobComplete(vehicle, def);
  const bits = [`${def.label} required`];
  if (complete) {
    bits.push('signed off');
    if (vehicle[def.completeByKey]) bits.push(`by ${vehicle[def.completeByKey]}`);
    const doneAt = parseIsoTimestamp(vehicle[def.completeAtKey]);
    if (doneAt) bits.push(doneAt.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }));
  } else {
    bits.push('not signed off yet');
  }
  return bits.join(' - ');
}

function pdcJobMarkerTitle(vehicle = {}, def = {}) {
  const required = pdcJobRequired(vehicle, def);
  const complete = pdcJobComplete(vehicle, def);
  if (!required && !complete) return `${def.label} not required`;
  return pdcJobCompletionTitle(vehicle, def);
}

function pdcJobDefsPartsFirst() {
  const rowOrder = ['parts', 'tint', 'bus4x4', 'hoist', 'fitting', 'fabrication', 'electrical', 'tyre', 'sublet'];
  return rowOrder.map(key => PDC_JOB_BY_KEY.get(key)).filter(Boolean);
}

// r799 (F409, Craig 1 Nov 2026 08:16): Vehicle Locations station columns follow the Department filter.
//   All departments: today's columns (pdcJobDefsPartsFirst). Department 139: the same without Bus 4x4.
//   Department 138: one column per Bus 4x4 category (Mechanical, Accessories, Electrical, QA, Pit) instead of Bus 4x4.
// A category column is red while any of its lines is open, orange when a Bus 4x4 booking for that category is open,
// green when every line is ticked (or the Bus 4x4 override with no line part-way, the r578 rule), grey when the car
// has no line in that category. The numbers come from list_station_icon_completion_578 (category rows, r799).
const PDC_BUS_CATEGORY_DEFS = Object.freeze([
  { key: 'busMechanical', label: 'BUS MECHANICAL', short: 'Me', busCategory: 'BUS_MECHANICAL', gridLabel: 'Mechanical' },
  { key: 'busAccessories', label: 'BUS ACCESSORIES', short: 'Ac', busCategory: 'BUS_ACCESSORIES', gridLabel: 'Accessories' },
  { key: 'busElectrical', label: 'BUS ELECTRICAL', short: 'El', busCategory: 'BUS_ELECTRICAL', gridLabel: 'Electrical' },
  { key: 'busQa', label: 'BUS QA', short: 'QA', busCategory: 'BUS_QA', gridLabel: 'QA' },
  { key: 'busPit', label: 'BUS PIT', short: 'Pi', busCategory: 'BUS_PIT', gridLabel: 'Pit' },
].map(def => Object.freeze(def)));
const PDC_BUS_CATEGORY_BY_KEY = new Map(PDC_BUS_CATEGORY_DEFS.map(def => [def.key, def]));

function pdcJobDefsForDepartment(department = '') {
  const dept = String(department ?? '').trim();
  const base = pdcJobDefsPartsFirst();
  if (dept === '139') return base.filter(def => def.key !== 'bus4x4');
  if (dept === '138') return ['parts', ...PDC_BUS_CATEGORY_DEFS.map(def => def.key), 'tint', 'tyre', 'sublet']
    .map(key => PDC_JOB_BY_KEY.get(key) || PDC_BUS_CATEGORY_BY_KEY.get(key)).filter(Boolean);
  return base;
}

// The Vehicle Locations table asks for its columns here (it follows the Department filter); every other screen keeps
// pdcJobDefsPartsFirst.
function pdcVehicleLocationsStationDefs() {
  return pdcJobDefsForDepartment(typeof incomingDepartmentFilterValue === 'function' ? incomingDepartmentFilterValue() : '');
}

// r799: per-category state for one car. Lines come from the car's own operation lines (instant) and the server tally
// (ticks, overrides, bookings) once list_station_icon_completion_578 has answered.
function busCategoryState(vehicle = {}, def = {}) {
  const category = String(def?.busCategory || '').toUpperCase();
  const empty = { required: false, complete: false, booked: false, stoppage: false, stoppageReason: '', total: 0, done: 0, override: false, by: '', at: '' };
  if (!category) return empty;
  const id = typeof pmbArrivalVehicleId === 'function' ? pmbArrivalVehicleId(vehicle) : String(vehicle?.id || '');
  const row = id && typeof app !== 'undefined' && app?.busCategoryCompletion instanceof Map ? app.busCategoryCompletion.get(String(id))?.[category] : null;
  const lines = Array.isArray(vehicle?.pdcQcOperationLines) ? vehicle.pdcQcOperationLines : [];
  const own = lines.filter(line => line && line.active !== false && line.rejected !== true
    && String(line.workCategory || line.work_category || '').toUpperCase() === category).length;
  if (!row) return { ...empty, required: own > 0, total: own };
  return {
    required: Number(row.total) > 0 || own > 0,
    complete: row.complete === true,
    booked: row.booked === true && row.complete !== true,
    stoppage: row.stoppage === true && row.complete !== true,
    stoppageReason: String(row.stoppageReason || ''),
    total: Number(row.total) || own,
    done: Number(row.done) || 0,
    override: row.override === true,
    by: String(row.by || ''),
    at: String(row.at || ''),
  };
}

function busCategoryCheckHtml(vehicle = {}, def = {}) {
  const state = busCategoryState(vehicle, def);
  const label = pdcGridJobLabel(def);
  const classes = ['incoming-work-check', `pdc-station-${def.key}`];
  let marker = '–'; let word = 'not required';
  if (state.complete) { classes.push('is-required', 'is-complete'); marker = '✓'; word = 'complete'; }
  else if (state.required && state.stoppage) { classes.push('is-required', 'is-blocked'); marker = '!'; word = 'STOPPAGE'; }
  else if (state.required && state.booked) { classes.push('is-required', 'is-booked'); marker = '!'; word = 'booked'; }
  else if (state.required) { classes.push('is-required'); marker = '•'; word = 'required'; }
  else classes.push('is-not-required');
  const count = state.total ? ` · ${state.done} of ${state.total} lines ticked` : '';
  const title = state.complete
    ? (state.override ? `${label} complete (override by ${state.by || 'controller'})${count}` : `${label} complete${count}`)
    : state.stoppage ? `${label} STOPPAGE${state.stoppageReason ? `: ${state.stoppageReason}` : ''}${count}`
    : state.booked ? `${label} booked${count}` : state.required ? `${label} required${count}` : `${label} not required`;
  return `<span class="${classes.join(' ')}" title="${escapeHtml(title)}" aria-label="${escapeHtml(`${label} ${word}`)}">
      <span class="incoming-work-box" aria-hidden="true">${marker}</span>
      <span class="incoming-work-label">${escapeHtml(label)}</span>
    </span>`;
}


const PDC_GRID_JOB_LABELS = {
  parts: 'Parts',
  bus4x4: 'Bus 4x4',
  tint: 'Tint',
  hoist: 'Hoist',
  fitting: 'Fitting',
  fabrication: 'Fab',
  electrical: 'Elec',
  tyre: 'Tyre',
  sublet: 'Sublet',
};

function pdcGridJobLabel(def = {}) {
  return PDC_GRID_JOB_LABELS[def.key] || def.gridLabel || def.label || def.key || 'Station';
}

function pdcGridCompletedJobsText(vehicle = {}) {
  const jobs = pdcJobDefsPartsFirst().filter(def => pdcJobComplete(vehicle, def));
  return jobs.length ? jobs.map(pdcGridJobLabel).join(', ') : 'No station sign-offs';
}

function workflowHeaderOptionsHtml(options = [], current = '') {
  return options.map(option => `<option value="${escapeHtml(option.value)}"${option.value === current ? ' selected' : ''}>${escapeHtml(option.label)}</option>`).join('');
}

function workflowHeaderFilterHtml(label = '', filterType = '', options = [], current = '', className = '', dataAttributes = '') {
  const selected = options.find(option => option.value === current);
  const activeText = current ? (selected?.short || selected?.label || current) : '';
  const classes = ['workflow-column-filter', className, current ? 'is-active' : ''].filter(Boolean).join(' ');
  return `<label class="${escapeHtml(classes)}" title="${escapeHtml(`Filter or sort ${label}`)}">
    <span>${escapeHtml(label)}</span>
    ${activeText ? `<small>${escapeHtml(activeText)}</small>` : ''}
    <select data-workflow-header-filter="${escapeHtml(filterType)}" ${dataAttributes} aria-label="${escapeHtml(`Filter or sort ${label}`)}">${workflowHeaderOptionsHtml(options, current)}</select>
  </label>`;
}

function productionGridHeaderHtml(className = '', options = {}) {
  const heading = (label, key) => options.incomingSort
    ? incomingSortHeadingHtml(label, key, options.incomingSort)
    : `<span>${escapeHtml(label)}</span>`;
  const meta1Label = options.meta1Label || 'Age / ETA';
  const meta2Label = options.meta2Label || 'Status';
  const actionLabel = options.actionLabel || 'Actions';
  const classes = ['pdc-production-grid-header', className || ''].filter(Boolean).join(' ');
  const workflowFilters = options.workflowFilters || null;
  if (workflowFilters) {
    const sortOptions = {
      key: [{ value: '', label: 'No key sort' }, { value: 'key-asc', label: 'Key low to high', short: '↑' }, { value: 'key-desc', label: 'Key high to low', short: '↓' }],
      stock: [{ value: '', label: 'No stock sort' }, { value: 'stock-asc', label: 'Stock A to Z', short: 'A–Z' }, { value: 'stock-desc', label: 'Stock Z to A', short: 'Z–A' }],
      jobcard: [{ value: '', label: 'No job card sort' }, { value: 'jobcard-asc', label: 'Job card A to Z', short: 'A–Z' }, { value: 'jobcard-desc', label: 'Job card Z to A', short: 'Z–A' }],
      customer: [{ value: '', label: 'No customer sort' }, { value: 'customer-asc', label: 'Customer A to Z', short: 'A–Z' }, { value: 'customer-desc', label: 'Customer Z to A', short: 'Z–A' }],
      vehicle: [{ value: '', label: 'No vehicle sort' }, { value: 'vehicle-asc', label: 'Vehicle A to Z', short: 'A–Z' }, { value: 'vehicle-desc', label: 'Vehicle Z to A', short: 'Z–A' }],
    };
    const sortValueFor = key => sortOptions[key].some(option => option.value === workflowFilters.sort) ? workflowFilters.sort : '';
    const workOptions = [
      { value: '', label: 'All vehicles' },
      { value: 'yes', label: 'Yes — required', short: 'Yes' },
      { value: 'no', label: 'No — not required', short: 'No' },
      { value: 'outstanding', label: 'Outstanding work', short: 'Open' },
      { value: 'complete', label: 'Completed work', short: 'Done' },
    ];
    const stationHeaders = pdcJobDefsPartsFirst().map(def => {
      let current = '';
      if (workflowFilters.work === def.key) {
        if (workflowFilters.required === 'yes') current = 'yes';
        else if (workflowFilters.required === 'no') current = 'no';
        else if (workflowFilters.completion === 'outstanding') current = 'outstanding';
        else if (workflowFilters.completion === 'complete') current = 'complete';
      }
      const stationOptions = def.key === 'parts' ? workOptions.filter(option => option.value !== 'no') : workOptions;
      return workflowHeaderFilterHtml(pdcGridJobLabel(def), 'work', stationOptions, current, `pdc-grid-station-heading pdc-grid-station-${def.key}`, `data-workflow-work-key="${escapeHtml(def.key)}"`);
    }).join('');
    const statusOptions = [
      { value: '', label: 'All PMB statuses' },
      { value: 'bucket:UNALLOCATED', label: 'Unallocated', short: 'Unalloc.' },
      ...PMB_STAGE_DEFS.map(def => ({ value: `bucket:${def.value}`, label: def.label, short: def.label })),
      { value: 'stoppage:yes', label: 'STOPPAGE only', short: 'STOPPAGE' },
      { value: 'stoppage:no', label: 'No STOPPAGE', short: 'Clear' },
    ];
    const statusValue = workflowFilters.bucket ? `bucket:${workflowFilters.bucket}` : workflowFilters.stoppage ? `stoppage:${workflowFilters.stoppage}` : '';
    const ageOptions = [
      { value: 'oldest', label: 'Oldest at PMB first', short: 'Oldest' },
      { value: 'newest', label: 'Newest at PMB first', short: 'Newest' },
    ];
    const hasColumnFilters = Boolean(workflowFilters.bucket || workflowFilters.work || workflowFilters.required || workflowFilters.completion || workflowFilters.stoppage || !['oldest', 'newest'].includes(workflowFilters.sort));
    return `<div class="${escapeHtml(classes)}">
      <span class="pdc-grid-control-heading" aria-hidden="true"></span>
      <span class="pdc-grid-select-heading" aria-hidden="true"></span>
      <span class="pdc-grid-identity-heading">
        ${workflowHeaderFilterHtml('Key', 'sort', sortOptions.key, sortValueFor('key'), 'workflow-identity-filter')}
        ${workflowHeaderFilterHtml('Stock', 'sort', sortOptions.stock, sortValueFor('stock'), 'workflow-identity-filter')}
        ${workflowHeaderFilterHtml('Job Card', 'sort', sortOptions.jobcard, sortValueFor('jobcard'), 'workflow-identity-filter')}
        ${workflowHeaderFilterHtml('Customer', 'sort', sortOptions.customer, sortValueFor('customer'), 'workflow-identity-filter')}
      </span>
      ${workflowHeaderFilterHtml('Vehicle', 'sort', sortOptions.vehicle, sortValueFor('vehicle'), 'pdc-grid-vehicle-heading')}
      <span class="pdc-grid-stations-heading">${stationHeaders}</span>
      ${workflowHeaderFilterHtml(meta1Label, 'sort', ageOptions, ['newest'].includes(workflowFilters.sort) ? 'newest' : 'oldest', 'pdc-grid-meta-heading workflow-age-filter')}
      ${workflowHeaderFilterHtml(meta2Label, 'status', statusOptions, statusValue, 'pdc-grid-status-heading')}
      <span class="pdc-grid-action-heading workflow-header-actions"><span>${escapeHtml(actionLabel)}</span>${hasColumnFilters ? '<button type="button" data-workflow-clear-column-filters>Clear</button>' : ''}</span>
    </div>`;
  }
  const stationHeaders = (Array.isArray(options.stationDefs) ? options.stationDefs : pdcJobDefsPartsFirst()).map(def => { // r799: Vehicle Locations passes dept columns
    const label = pdcGridJobLabel(def);
    return `<span class="pdc-grid-station-heading pdc-grid-station-${escapeHtml(def.key)}" title="${escapeHtml(label)}"><span>${escapeHtml(label)}</span></span>`;
  }).join('');
  return `<div class="${escapeHtml(classes)}">
    <span class="pdc-grid-control-heading" aria-hidden="true"></span>
    <span class="pdc-grid-select-heading" aria-hidden="true"></span>
    <span class="pdc-grid-identity-heading">
      ${heading('Key', 'key')}${heading('Stock', 'stock')}${heading('Job Card', 'jobcard')}${heading('Customer', 'customer')}
    </span>
    <span class="pdc-grid-vehicle-heading">${heading('Vehicle', 'vehicle')}</span>
    <span class="pdc-grid-stations-heading">${stationHeaders}</span>
    <span class="pdc-grid-meta-heading">${options.incomingSort ? heading(meta1Label, 'age') : escapeHtml(meta1Label)}</span>
    <span class="pdc-grid-status-heading">${escapeHtml(meta2Label)}</span>
    <span class="pdc-grid-action-heading">${escapeHtml(actionLabel)}</span>
  </div>`;
}

function vehicleLocationsRftHeaderHtml(sort = null) {
  const heading = (label, key) => sort ? incomingSortHeadingHtml(label, key, sort) : `<span>${escapeHtml(label)}</span>`;
  return `<div class="pdc-production-grid-header rft-vehicle-locations-header">
    <span class="pdc-grid-control-heading" aria-hidden="true"></span>
    <span class="pdc-grid-select-heading" aria-hidden="true"></span>
    <span class="pdc-grid-identity-heading">${heading('Key', 'key')}${heading('Stock', 'stock')}${heading('Job Card', 'jobcard')}${heading('Customer', 'customer')}</span>
    <span class="pdc-grid-vehicle-heading">${heading('Vehicle', 'vehicle')}</span>
    <span class="rft-controls-heading"><span>RFT’d</span><span>Email Sales Person</span><span>Collected</span></span>
  </div>`;
}

function vehicleWorkshopActivityLabel(vehicle = {}, options = {}) {
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  let bookings = null;
  if (vehicle.__emailVehicleServerAuthoritative === true && canonicalId && vehicle.__emailVehicleWorkshopBookingsAvailable === true) {
    bookings = vehicle.salesWorkshopBookings;
  } else {
    const detail = canonicalId ? app.vehicleWorkshopDetailCache?.get(canonicalId) : null;
    if (detail?.status === 'ready' && String(detail.detail?.vehicle_id || '') === canonicalId && Array.isArray(detail.detail?.bookings)) bookings = detail.detail.bookings;
    else if (options.bookingProjection?.available === true) bookings = options.bookingProjection.activeBookings;
  }
  const rows = (Array.isArray(bookings) ? bookings : []).filter(booking => {
    const id = String(booking?.vehicle_id || booking?.sharedVehicleId || '').trim();
    return (!id || id === canonicalId) && !booking?.deleted_at
      && ['queued', 'planned', 'started', 'stoppage', 'in_progress'].includes(String(booking?.status || '').toLowerCase());
  });
  const place = booking => {
    const stage = pmbStageLabel(normalizePmbStage(booking.stageCode || booking.stage_code || booking.stage)) || booking.stageName || booking.stage_name || 'Workshop';
    const number = booking.bayNumber || booking.bay_number || booking.bay;
    const stageCode = normalizePmbStage(booking.stageCode || booking.stage_code || booking.stage);
    const code = `${stageCode}-BAY-${String(number).padStart(2, '0')}`;
    const rows = (typeof window === 'object' && window.__workshopReferenceDataService?.getCachedWorkshopBays?.()?.rows) || [];
    const cached = String(rows.find(row => row && row.code === code)?.display_name || '').trim();
    const stored = String(booking.bay_display_name || booking.bayName || booking.bay_name || booking.bay?.display_name || '').trim();
    const bayFallback = (() => {
      try { if (typeof pdcBayText === 'function') return pdcBayText(stageCode, number); } catch (_error) {}
      if (typeof globalThis.pdcBayText === 'function') return globalThis.pdcBayText(stageCode, number);
      return number ? `Bay ${number}` : 'Bay not assigned';
    })();
    const bay = cached || stored || (number ? bayFallback : 'Bay not assigned');
    return `${stage} · ${bay}`;
  };
  const live = rows.filter(booking => ['started', 'stoppage', 'in_progress'].includes(String(booking.status).toLowerCase()));
  if (live.length > 1) return 'Multiple active bookings — check planners';
  if (live.length) return `${String(live[0].status).toLowerCase() === 'stoppage' ? 'STOPPAGE' : 'In progress'} · ${place(live[0])}`;
  const planned = rows.sort((a, b) => (Date.parse(a.scheduledStartAt || a.scheduled_start_at || a.startAt) || Infinity) - (Date.parse(b.scheduledStartAt || b.scheduled_start_at || b.startAt) || Infinity))[0];
  if (planned) return `${Date.parse(planned.scheduledStartAt || planned.scheduled_start_at || planned.startAt) > Number(options.now ?? Date.now()) ? 'Booked next' : 'Planned — not started'} · ${place(planned)}`;
  const stream = pmbStageLabel(inferredPmbStage(vehicle));
  if (stream) return `PMB stream: ${stream}`;
  return Array.isArray(bookings) ? 'No active workshop booking' : 'Workshop activity not loaded';
}

function incomingGridStatusLabel(vehicle = {}, bucketKey = '', options = {}) {
  if (bucketKey === 'pmb') return vehicleWorkshopActivityLabel(vehicle, options);
  if (bucketKey === 'rft') return rftHomeStatusLabel(rftHomeStatus(vehicle));
  if (bucketKey === 'qc') return vehicle.pdcQcComplete === true ? 'Final check signed off · awaiting sync' : 'Awaiting final check';
  if (bucketKey === 'wpc') return 'Work completed · waiting on Sales for the destination';
  if (bucketKey === 'pit') return 'Department of Transport inspection';
  if (bucketKey === 'yardhold') return 'Yard Hold';
  if (bucketKey === 'nonnavision') return 'Location unconfirmed';
  if (bucketKey === 'transit') return 'In Transit';
  if (bucketKey === 'overseas') return navisionStatusText(vehicle) || 'Overseas / Other';
  return statusCategoryLabel(vehicle) || incomingBucketLabel(bucketKey) || navisionStatusText(vehicle) || 'Current';
}

function pdcJobMarkersHtml(vehicle = {}, interactive = false) {
  return `<div class="pmb-card-requirements" aria-label="PMB requirements">${pdcJobDefsPartsFirst().map(def => {
    const required = pdcJobRequired(vehicle, def);
    const complete = pdcJobComplete(vehicle, def);
    const stateClass = complete ? 'is-complete' : required ? 'is-pending' : 'is-not-required';
    const attrs = interactive ? ` role="button" tabindex="0" data-toggle-pdc-job-complete="${escapeHtml(def.key)}" data-job-stock="${escapeHtml(vehicleKey(vehicle))}"` : '';
    const markerText = complete ? `${def.short}✓` : def.short;
    return `<span class="pmb-req-marker pmb-req-${escapeHtml(def.key)} ${stateClass}" title="${escapeHtml(pdcJobMarkerTitle(vehicle, def))}"${attrs}>${escapeHtml(markerText)}</span>`;
  }).join('')}</div>`;
}

function pmbRequirementMarkersHtml(vehicle = {}) {
  return pdcJobMarkersHtml(vehicle, true);
}

function pmbOutstandingStationChipsHtml(vehicle = {}) {
  const outstanding = pdcRequirementDefinitions(vehicle)
    .filter(job => !pdcJobComplete(vehicle, job))
    .sort((a, b) => (a.key === 'parts' ? -1 : b.key === 'parts' ? 1 : 0));
  const chips = outstanding.length
    ? outstanding.map(job => `<span class="pmb-outstanding-station" title="${escapeHtml(`${pdcGridJobLabel(job)} outstanding`)}">${escapeHtml(pdcGridJobLabel(job))}</span>`)
    : ['<span class="pmb-outstanding-station is-clear">All clear</span>'];
  return `<div class="pmb-outstanding-stations" aria-label="Outstanding PMB stations">${chips.join('')}</div>`;
}

function pmbBayPillIdentityHtml(vehicle = {}) {
  const stock = displayStockNumber(vehicle) || '—';
  const cells = [
    { label: 'Key', value: vehicleKeyNumber(vehicle) || '—' },
    { label: 'Stock', value: stock },
    { label: 'JC', value: vehicleJobcardNumber(vehicle) || '—' },
  ].map(cell => `<span class="pmb-bay-id-cell pmb-bay-id-${escapeHtml(cell.label.toLowerCase())}" aria-label="${escapeHtml(`${cell.label} ${cell.value}`)}" title="${escapeHtml(cell.value)}">${escapeHtml(truncate(cell.value, 14))}</span>`).join('');
  return `<div class="pmb-bay-pill-ids">${cells}</div>`;
}

function pmbPillCustomerHtml(vehicle = {}) {
  const customer = vehicleCustomerName(vehicle) || 'Unknown customer';
  return `<span class="pmb-pill-customer" title="${escapeHtml(customer)}">${escapeHtml(customer)}</span>`;
}

function pmbRequirementText(vehicle = {}) {
  const required = pdcRequirementDefinitions(vehicle).map(item => `${item.label}${pdcJobComplete(vehicle, item) ? ' done' : ' required'}`);
  return required.length ? required.join(', ') : 'No PDC requirements set';
}

function pdcCompletedJobsText(vehicle = {}) {
  const done = pdcCompletedJobs(vehicle).map(item => item.label);
  return done.length ? done.join(', ') : 'No PMB jobs signed off yet';
}

function pdcOutstandingJobsText(vehicle = {}) {
  const outstanding = pdcRequirementDefinitions(vehicle).filter(item => !pdcJobComplete(vehicle, item)).map(item => item.label);
  return outstanding.length ? outstanding.join(', ') : 'No outstanding PMB jobs';
}


const TOYOTA_STATUS_ORDER = [
  'Delivered - At Dealer',
  'Planned For Despatch - From TWA',
  'Despatched - From Body Builder',
  'Vehicle Out on Consignment',
  'Delivered - At Body Builder',
  'Waiting PD2',
  'Waiting PD1',
  'Vehicle Yard Hold',
  'Vehicle Delayed',
  'Vehicle Waiting For Wholesale',
  'Vehicle At Wharf',
  'In Transit to WA',
  'Ready For Shipment',
  'Planned for Production'
];

function normalizeToyotaStatus(status = '') {
  return String(status || '')
    .toLowerCase()
    .replace(/[\u2010-\u2015]/g, '-')
    .replace(/\s+/g, ' ')
    .replace(/\s*-\s*/g, ' - ')
    .trim();
}

const TOYOTA_STATUS_RANKS = new Map(
  TOYOTA_STATUS_ORDER.map((status, index) => [normalizeToyotaStatus(status), index])
);

function canonicalToyotaStatus(status = '') {
  const normalized = normalizeToyotaStatus(status);
  if (!normalized || normalized === 'not matched') return '';
  if (normalized === normalizeToyotaStatus(AUTOCARE_DESPATCH_STATUS) || (normalized.includes('autocare') && (normalized.includes('despatch') || normalized.includes('dispatch')))) return AUTOCARE_DESPATCH_STATUS;
  const exact = TOYOTA_STATUS_ORDER.find(item => normalizeToyotaStatus(item) === normalized);
  if (exact) return exact;

  const checks = [
    ['Delivered - At Dealer', s => s.includes('delivered') && s.includes('dealer')],
    ['Planned For Despatch - From TWA', s => s.includes('from twa') && (s.includes('planned for despatch') || s.includes('for despatch') || s.includes('despatched') || s.includes('for transport'))],
    ['Despatched - From Body Builder', s => (s.includes('despatched') || s.includes('for despatch')) && s.includes('body builder')],
    ['Vehicle Out on Consignment', s => s.includes('out on consignment')],
    ['Delivered - At Body Builder', s => s.includes('body builder') && (s.includes('delivered') || s.startsWith('at ') || s === 'body builder')],
    ['Waiting PD2', s => s.includes('waiting pd2')],
    ['Waiting PD1', s => s.includes('waiting pd1')],
    ['Vehicle Yard Hold', s => s.includes('vehicle yard hold') || s.includes('vehicle in yard hold') || s.includes('yard hold')],
    ['Vehicle Delayed', s => s.includes('delayed')],
    ['Vehicle Waiting For Wholesale', s => s.includes('waiting for wholesale')],
    ['Vehicle At Wharf', s => s.includes('at wharf') || s.includes('o/s wharf')],
    ['In Transit to WA', s => s.includes('in transit to wa')],
    ['Ready For Shipment', s => s.includes('ready for shipment')],
    ['Planned for Production', s => s.includes('planned for production') || s === 'for production' || s.endsWith(' for production')],
  ];
  const found = checks.find(([, test]) => test(normalized));
  return found ? found[0] : String(status || '').trim();
}

function toyotaStatusRank(status = '') {
  const canonical = canonicalToyotaStatus(status);
  const normalized = normalizeToyotaStatus(canonical || status);
  if (TOYOTA_STATUS_RANKS.has(normalized)) return TOYOTA_STATUS_RANKS.get(normalized);
  if (normalized === normalizeToyotaStatus(AUTOCARE_DESPATCH_STATUS)) return 1.5;
  return TOYOTA_STATUS_ORDER.length + 100;
}

function sortToyotaStatuses(statuses) {
  const collator = new Intl.Collator('en-AU', { numeric: true, sensitivity: 'base' });
  return statuses.slice().sort((a, b) => {
    const rankDiff = toyotaStatusRank(a) - toyotaStatusRank(b);
    return rankDiff || collator.compare(String(a), String(b));
  });
}

function isAutocareDespatched(vehicleOrStatus) {
  if (vehicleOrStatus && typeof vehicleOrStatus === 'object' && vehicleOrStatus.autocareDespatched) return true;
  const status = typeof vehicleOrStatus === 'string' ? vehicleOrStatus : vehicleOrStatus?.toyotaStatus;
  return canonicalToyotaStatus(status || '') === AUTOCARE_DESPATCH_STATUS;
}

const TASK_OPTIONS = [
  'Allocate vehicle, generate orders',
  'Customer update required',
  'Confirm customer contact details',
  'Order accessories / JITA parts',
  'Confirm JITA parts ordered',
  'Book workshop job card',
  'Book tint / accessories',
  'Book tray / body builder',
  'Released from Perth - book workshop',
  'Vehicle arrived - prepare delivery',
  'Delivery booked',
  'No task required'
];

let activeRenderJsonCache = null;

function loadJson(key, fallback) {
  if (activeRenderJsonCache?.has(key)) return activeRenderJsonCache.get(key);
  let value = fallback;
  try {
    const stored = localStorage.getItem(key);
    value = stored === null ? JSON.parse(JSON.stringify(fallback)) : JSON.parse(stored);
  } catch {
    value = fallback;
  }
  activeRenderJsonCache?.set(key, value);
  return value;
}

function saveJson(key, value) {
  activeRenderJsonCache?.delete(key);
  localStorage.setItem(key, JSON.stringify(value));
}

function sha256Hex(value = '') {
  const bytes = [];
  for (const character of String(value)) {
    const code = character.codePointAt(0);
    if (code <= 0x7f) bytes.push(code);
    else if (code <= 0x7ff) bytes.push(0xc0 | (code >>> 6), 0x80 | (code & 63));
    else if (code <= 0xffff) bytes.push(0xe0 | (code >>> 12), 0x80 | ((code >>> 6) & 63), 0x80 | (code & 63));
    else bytes.push(0xf0 | (code >>> 18), 0x80 | ((code >>> 12) & 63), 0x80 | ((code >>> 6) & 63), 0x80 | (code & 63));
  }
  const bitLength = bytes.length * 8;
  bytes.push(0x80);
  while ((bytes.length % 64) !== 56) bytes.push(0);
  const high = Math.floor(bitLength / 0x100000000);
  const low = bitLength >>> 0;
  for (let shift = 24; shift >= 0; shift -= 8) bytes.push((high >>> shift) & 255);
  for (let shift = 24; shift >= 0; shift -= 8) bytes.push((low >>> shift) & 255);
  const k = [
    0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,
    0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,
    0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,
    0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,
    0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,
    0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,0xd192e819,0xd6990624,0xf40e3585,0x106aa070,
    0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,
    0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2,
  ];
  const h = [0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19];
  const rotate = (word, bits) => (word >>> bits) | (word << (32 - bits));
  for (let offset = 0; offset < bytes.length; offset += 64) {
    const w = new Array(64);
    for (let i = 0; i < 16; i += 1) {
      const p = offset + i * 4;
      w[i] = ((bytes[p] << 24) | (bytes[p + 1] << 16) | (bytes[p + 2] << 8) | bytes[p + 3]) >>> 0;
    }
    for (let i = 16; i < 64; i += 1) {
      const s0 = rotate(w[i - 15], 7) ^ rotate(w[i - 15], 18) ^ (w[i - 15] >>> 3);
      const s1 = rotate(w[i - 2], 17) ^ rotate(w[i - 2], 19) ^ (w[i - 2] >>> 10);
      w[i] = (w[i - 16] + s0 + w[i - 7] + s1) >>> 0;
    }
    let [a,b,c,d,e,f,g,hh] = h;
    for (let i = 0; i < 64; i += 1) {
      const s1 = rotate(e, 6) ^ rotate(e, 11) ^ rotate(e, 25);
      const ch = (e & f) ^ ((~e) & g);
      const t1 = (hh + s1 + ch + k[i] + w[i]) >>> 0;
      const s0 = rotate(a, 2) ^ rotate(a, 13) ^ rotate(a, 22);
      const maj = (a & b) ^ (a & c) ^ (b & c);
      const t2 = (s0 + maj) >>> 0;
      hh = g; g = f; f = e; e = (d + t1) >>> 0; d = c; c = b; b = a; a = (t1 + t2) >>> 0;
    }
    h[0]=(h[0]+a)>>>0; h[1]=(h[1]+b)>>>0; h[2]=(h[2]+c)>>>0; h[3]=(h[3]+d)>>>0;
    h[4]=(h[4]+e)>>>0; h[5]=(h[5]+f)>>>0; h[6]=(h[6]+g)>>>0; h[7]=(h[7]+hh)>>>0;
  }
  return h.map(word => word.toString(16).padStart(8, '0')).join('');
}

function navisionPayloadFingerprint(text = '') {
  return sha256Hex(String(text || ''));
}

function localStorageQuotaBytes(key, value) {
  return 2 * (String(key || '').length + String(value ?? '').length);
}

function currentLocalStorageValues() {
  const values = new Map();
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (key !== null) values.set(key, localStorage.getItem(key));
  }
  return values;
}

function boundedNavisionImportSummary(result = {}) {
  const parsedVehicles = result?.parsed?.vehicles || [];
  const allWarnings = (result?.skipped || result?.parsed?.warnings || [])
    .filter(Boolean).map(value => String(value));
  const warnings = allWarnings.slice(0, 50).map(value => value.slice(0, 200));
  const counts = {
    rows: parsedVehicles.length,
    added: result?.added?.length || 0,
    updated: result?.updated?.length || 0,
    unchanged: result?.unchanged?.length || 0,
    stockNumberUpdates: result?.stockNumberUpdates?.length || 0,
    restored: result?.restored?.length || 0,
    missingFromUpload: result?.missingFromUpload?.length || 0,
    removedMissing: result?.removedMissing?.length || 0,
    warnings: allWarnings.length,
  };
  const summary = {
    summaryVersion: NAVISION_IMPORT_SUMMARY_VERSION,
    fileName: String(result.fileName || app.navisionFileName || 'Pasted text').slice(0, 255),
    importedAt: String(result.importedAt || '').slice(0, 64),
    appliedAt: String(result.appliedAt || '').slice(0, 64),
    fullRefresh: result.fullRefresh !== false,
    confirmed: result.confirmed === true,
    counts,
    sourceFingerprint: /^[a-f0-9]{64}$/i.test(String(result.sourceFingerprint || ''))
      ? String(result.sourceFingerprint).toLowerCase()
      : sha256Hex(String(result.sourceFingerprint || '')),
    vehiclePayloadSha256: sha256Hex(JSON.stringify(parsedVehicles)),
    warningSha256: sha256Hex(JSON.stringify(allWarnings)),
    parsed: { vehicleCount: counts.rows, warnings },
    warningPreviewTruncated: allWarnings.length > warnings.length,
  };
  while (JSON.stringify(summary).length > NAVISION_IMPORT_SUMMARY_MAX_CHARS && summary.parsed.warnings.length) {
    summary.parsed.warnings.pop();
    summary.warningPreviewTruncated = true;
  }
  if (JSON.stringify(summary).length > NAVISION_IMPORT_SUMMARY_MAX_CHARS) {
    summary.parsed.warnings = [];
    summary.warningPreviewTruncated = true;
  }
  if (JSON.stringify(summary).length > NAVISION_IMPORT_SUMMARY_MAX_CHARS) {
    const minimal = {
      summaryVersion: NAVISION_IMPORT_SUMMARY_VERSION,
      counts,
      sourceFingerprint: summary.sourceFingerprint,
      vehiclePayloadSha256: summary.vehiclePayloadSha256,
      warningSha256: summary.warningSha256,
      warningPreviewTruncated: true,
    };
    if (JSON.stringify(minimal).length > NAVISION_IMPORT_SUMMARY_MAX_CHARS) {
      throw new Error('Navision import summary exceeds hard serialized ceiling');
    }
    return minimal;
  }
  return summary;
}

let storageTransactionDepth = 0;

function storageTransactionJournalStores() {
  const stores = [localStorage];
  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage && sessionStorage !== localStorage) stores.push(sessionStorage);
  } catch {}
  return stores;
}

function clearStorageTransactionJournals() {
  storageTransactionJournalStores().forEach(store => {
    try { store.removeItem(STORAGE_TRANSACTION_JOURNAL_KEY); } catch {}
  });
}

function recoverInterruptedStorageTransaction() {
  let journal = null;
  for (const store of storageTransactionJournalStores()) {
    let candidate = null;
    try { candidate = JSON.parse(store.getItem(STORAGE_TRANSACTION_JOURNAL_KEY) || 'null'); } catch {}
    if (candidate?.snapshot && typeof candidate.snapshot === 'object') {
      journal = candidate;
      break;
    }
    try { store.removeItem(STORAGE_TRANSACTION_JOURNAL_KEY); } catch {}
  }
  if (!journal) return false;
  Object.keys(journal.snapshot).forEach(key => localStorage.removeItem(key));
  Object.entries(journal.snapshot).forEach(([key, entry]) => {
    if (entry?.exists) localStorage.setItem(key, String(entry.value ?? ''));
    else localStorage.removeItem(key);
  });
  clearStorageTransactionJournals();
  return true;
}

function prepareStorageTransaction(label = 'Tracker update', keys = [], startedAt = nowIsoString()) {
  const touchedKeys = [...new Set((Array.isArray(keys) ? keys : []).map(key => String(key || '').trim()).filter(Boolean))]
    .filter(key => key !== STORAGE_TRANSACTION_JOURNAL_KEY);
  const snapshot = Object.fromEntries(touchedKeys.map(key => {
    const value = localStorage.getItem(key);
    return [key, { exists: value !== null, value }];
  }));
  const journal = { version: 1, label, startedAt, snapshot };
  return { label, touchedKeys, snapshot, journal, serializedJournal: JSON.stringify(journal) };
}

function runStorageTransaction(label = 'Tracker update', keys = [], operation = () => undefined, prepared = null) {
  if (storageTransactionDepth > 0) return operation();
  const transaction = prepared || prepareStorageTransaction(label, keys);
  const { touchedKeys, snapshot, serializedJournal } = transaction;
  const snapshotStillCurrent = touchedKeys.every(key => {
    const value = localStorage.getItem(key);
    const entry = snapshot[key];
    return entry?.exists ? value === entry.value : value === null;
  });
  if (!snapshotStillCurrent) throw new Error(`${label} was cancelled because browser storage changed after the safety check.`);
  let journalStore = null;
  for (const store of storageTransactionJournalStores()) {
    try {
      store.setItem(STORAGE_TRANSACTION_JOURNAL_KEY, serializedJournal);
      journalStore = store;
      break;
    } catch {}
  }
  if (!journalStore) {
    throw new Error(`${label} could not start safely because the browser storage recovery snapshot could not be saved. Export a backup and free browser storage before trying again.`);
  }
  storageTransactionDepth += 1;
  try {
    const result = operation();
    journalStore.removeItem(STORAGE_TRANSACTION_JOURNAL_KEY);
    return result;
  } catch (error) {
    touchedKeys.forEach(key => localStorage.removeItem(key));
    Object.entries(snapshot).forEach(([key, entry]) => {
      if (entry.exists) localStorage.setItem(key, entry.value);
      else localStorage.removeItem(key);
    });
    journalStore.removeItem(STORAGE_TRANSACTION_JOURNAL_KEY);
    throw new Error(`${label} was not saved. The previous tracker data was restored. ${error?.message || error}`);
  } finally {
    storageTransactionDepth = Math.max(0, storageTransactionDepth - 1);
  }
}

function trackerTransactionKeys(extraKeys = []) {
  return [...new Set(CRM_BACKUP_STORAGE_KEYS.concat(extraKeys || []).filter(Boolean))];
}

function clearLocalDataFromUrl() {
  const search = String(window.location?.search || '');
  const ParamsCtor = window.URLSearchParams || (typeof URLSearchParams !== 'undefined' ? URLSearchParams : null);
  const resetRequested = ParamsCtor
    ? new ParamsCtor(search).has('clearLocalData') || new ParamsCtor(search).has('resetLocalData') || new ParamsCtor(search).has('freshData')
    : /[?&](clearLocalData|resetLocalData|freshData)(=|&|$)/.test(search);
  if (!resetRequested) return;
  const path = String(window.location?.pathname || '');
  const resetAllowed = window.PDC_ALLOW_LOCAL_RESET === true;
  if (!resetAllowed) {
    console.warn('Local data reset was ignored on the live board. Use the Back End Data reset controls instead.');
    return;
  }
  try {
    CRM_BACKUP_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
    localStorage.removeItem('vehicleTrackingCoreColumnOrder:v1');
    localStorage.removeItem('vehicleTrackingCoreColumnOrder:v2');
    localStorage.removeItem('vehicleTrackingCoreColumnOrder:v3');
    localStorage.removeItem('vehicleTrackingCoreColumnOrder:v4');
    localStorage.removeItem('vehicleTrackingCoreColumnWidths:v1:vehicle-table');
    localStorage.removeItem('vehicleTrackingCoreColumnWidths:v3:vehicle-table');
    localStorage.removeItem('vehicleTrackingCoreColumnWidths:v4:vehicle-table');
    window.PDC_LOCAL_DATA_CLEARED = true;
  } catch (error) {
    console.warn('Unable to clear local PDC data', error);
  }
}

recoverInterruptedStorageTransaction();
clearLocalDataFromUrl();

function loadVehicleEdits() { return loadJson(EDITS_KEY, {}); }
function loadAddedVehicles() { return loadJson(ADDED_KEY, []); }
function saveAddedVehicles(vehicles) { saveJson(ADDED_KEY, vehicles); }
function loadPoTasks() { return loadJson(PO_TASKS_KEY, {}); }
function savePoTasks(tasks) { saveJson(PO_TASKS_KEY, tasks); }
function loadPoFiles() { return loadJson(PO_FILES_KEY, {}); }
function savePoFiles(files) { saveJson(PO_FILES_KEY, files); }
function loadDeletedVehicles() { return loadJson(DELETED_KEY, []); }
function saveDeletedVehicles(stockList) { saveJson(DELETED_KEY, stockList); }
function deletedVehicleKeyFromRecord(record) {
  return typeof record === 'string' ? record : String(record?.key || record?.vehicleKey || record?.stock || record?.id || '').trim();
}
function deletedVehicleKeys(records = loadDeletedVehicles()) {
  const keys = new Set();
  (Array.isArray(records) ? records : []).forEach(record => {
    const primary = deletedVehicleKeyFromRecord(record);
    if (primary) keys.add(primary);
    if (record && typeof record === 'object' && Array.isArray(record.keys)) {
      record.keys.map(value => String(value || '').trim()).filter(Boolean).forEach(value => keys.add(value));
    }
  });
  return keys;
}
function deletedVehicleRecords() {
  return (Array.isArray(loadDeletedVehicles()) ? loadDeletedVehicles() : []).map(record => {
    if (typeof record === 'string') return { key: record, deletedAt: '', deletedBy: '', vehicle: { stock: record } };
    return {
      key: deletedVehicleKeyFromRecord(record),
      deletedAt: record.deletedAt || '',
      deletedBy: record.deletedBy || '',
      deletedRole: record.deletedRole || '',
      reason: record.reason || '',
      deletionType: record.deletionType || '',
      vehicle: record.vehicle || { stock: record.stock || record.key || '' },
      keys: Array.isArray(record.keys) ? record.keys : [],
    };
  }).filter(record => record.key);
}
function saveDeletedVehicleRecords(records = []) { saveDeletedVehicles(records); }
const DEFAULT_MECHANICS = [
  'Ajafari Abdelkrim',
  'Andrew McCormick',
  'Ben Palmer',
  'Chelsea Rees # 2',
  'Daniel Evelyn',
  'Gurmohan Singh',
  'James Ierino',
  'Jamie Bello',
  'Joe Izzi',
  'John Castagna',
  'Jundullah Sharif Ramli',
  'Kade Bailey',
  'Luke Walton',
  'Nick Darker',
  'Ratchapool Jaumorn',
  'Ravindra Singh',
  'Richard Tatov',
  'Robert Celenza',
  'Samuel Sherratt',
  'Simon Duncan',
  'Simon Fraser',
  'Thanh Truong',
  'Wilfredo Aquionos',
  'Winn Chiu Pang',
  'Zachary King',
];

function normalizedMechanicList(names = []) {
  return [...new Set((Array.isArray(names) ? names : []).map(name => cleanNavisionText(name)).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b));
}

// Stage 2A: mechanics/technicians are now authoritative in Supabase
// (public.workshop_technicians via workshop-reference-data-service.js),
// not localStorage. loadMechanics() keeps its existing synchronous,
// plain-name-array return shape so every one of its ~10 existing call
// sites (bay-assignment dropdowns, Setup screen admin list, KPI counts)
// keeps working unmodified -- but the data itself now comes from the
// service's disposable in-memory cache, refreshed by realtime, never from
// MECHANICS_KEY. If the shared service has not loaded yet (e.g. before
// the first authenticated fetch completes) this returns an empty list
// rather than falling back to localStorage or the old hard-coded
// DEFAULT_MECHANICS seed -- a real name list only ever comes from
// Supabase now.
function loadMechanics() {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return [];
  const cached = service.getCachedTechnicians();
  return normalizedMechanicList((cached.rows || []).filter(row => row.active).map(row => row.name));
}
// Returns the full technician records (id/name/active/version), not just
// names -- needed by the Setup screen admin UI to call
// addTechnician/editTechnician/setTechnicianActive with a real id and
// expected_version rather than only a display name.
function loadMechanicRecords(includeInactive = false) {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return [];
  const cached = service.getCachedTechnicians();
  const rows = cached.rows || [];
  return includeInactive ? rows : rows.filter(row => row.active);
}
// Triggers an authoritative (re)load from Supabase -- call this once at
// boot and whenever the admin Setup screen is opened, since loadMechanics()
// itself only reads the disposable in-memory cache synchronously and never
// triggers a network fetch on its own (matching the existing synchronous
// call-site contract every caller of loadMechanics() already relies on).
function workshopReferenceDataRoleCanRead(role = window.PDC_AUTH_CONTEXT?.role) {
  return ['operator', 'administrator'].includes(String(role || '').trim().toLowerCase());
}

function refreshWorkshopReferenceData() {
  if (!workshopReferenceDataRoleCanRead()) {
    stopWorkshopReferenceDataReconciliationTimer();
    window.__workshopReferenceDataService?.unsubscribeAll?.();
    window.__workshopReferenceDataService = null;
    return;
  }
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return Promise.resolve({ ok: true, skipped: true });
  const refreshes = [
    service.listTechnicians(true),
    service.listSalespeople(true),
    service.listSubletProviders(true),
    service.listWorkshopBays(true),
  ];
  if (typeof service.getWorkshopConfiguration === 'function') refreshes.push(service.getWorkshopConfiguration());
  service.subscribeTechnicians();
  service.subscribeSalespeople();
  service.subscribeSubletProviders();
  service.subscribeWorkshopBays();
  if (typeof service.subscribeWorkshopSettings === 'function') service.subscribeWorkshopSettings();
  startWorkshopReferenceDataReconciliationTimer();
  return Promise.allSettled(refreshes).then(results => ({
    ok: results.every(result => result.status === 'fulfilled'),
    results,
  }));
}

// Periodic lightweight reconciliation while the page is open, as a
// backstop against any missed/undelivered realtime event (network
// blips, dropped messages, etc.) -- the realtime subscriptions above
// are the primary update path and this timer is deliberately low
// frequency (2 minutes) since it is a safety net, not the main path.
// Guarded against duplicate timers if this is called more than once
// per page load (e.g. across the two refreshWorkshopReferenceData()
// call sites), and stopped on logout/account-lockout so it never
// polls with a signed-out session.
function startWorkshopReferenceDataReconciliationTimer() {
  if (!workshopReferenceDataRoleCanRead()) {
    stopWorkshopReferenceDataReconciliationTimer();
    return;
  }
  if (window.__workshopReferenceDataReconcileTimer) return;
  // r490: while the tab is hidden the 2-minute safety-net read is skipped and
  // remembered; it runs once as soon as the tab is visible again.
  if (!window.__workshopReferenceDataReconcileVisibilityHook && typeof document !== 'undefined' && document.addEventListener) {
    window.__workshopReferenceDataReconcileVisibilityHook = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden' || !window.__workshopReferenceDataReconcileMissed) return;
      window.__workshopReferenceDataReconcileMissed = false;
      if (window.__workshopReferenceDataReconcileTimer) reconcileWorkshopReferenceDataNow();
    });
  }
  window.__workshopReferenceDataReconcileTimer = window.setInterval(() => {
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
      window.__workshopReferenceDataReconcileMissed = true;
      return;
    }
    reconcileWorkshopReferenceDataNow();
  }, 120000);
}

function reconcileWorkshopReferenceDataNow() {
  if (!workshopReferenceDataRoleCanRead()) {
    stopWorkshopReferenceDataReconciliationTimer();
    return;
  }
  const service = window.__workshopReferenceDataService;
  if (!service || !window.PDC_AUTH_CONTEXT) return;
  service.listTechnicians(true).catch(() => {});
  service.listSalespeople(true).catch(() => {});
  service.listSubletProviders(true).catch(() => {});
  service.listWorkshopBays(true).catch(() => {});
  if (typeof service.getWorkshopConfiguration === 'function') service.getWorkshopConfiguration().catch(() => {});
}

function stopWorkshopReferenceDataReconciliationTimer() {
  if (window.__workshopReferenceDataReconcileTimer) {
    window.clearInterval(window.__workshopReferenceDataReconcileTimer);
    window.__workshopReferenceDataReconcileTimer = null;
  }
  if (window.__workshopReferenceDataService && typeof window.__workshopReferenceDataService.unsubscribeAll === 'function') {
    window.__workshopReferenceDataService.unsubscribeAll();
  }
}

const DEFAULT_SUBLET_PROVIDERS = [
  '4X4 Mechanic - Ascot',
  'ARB',
  'ARB - Welshpool',
  'Ashley Group',
  'Autonomo',
  'AV Auto Elec',
  'Beam',
  'Beam Rustproofing',
  'Bull Motor Bodies',
  'Customer Sublet',
  'Electrical - 53 Fortron Blvd High Wycombe',
  'Great Racks',
  'Great Racks - Bibra Lake',
  'Harness Master',
  'Hidrive',
  'Hidrive - Canning Vale',
  'Hunter Mech',
  'Ironman Canning Vale',
  'Jaram',
  'Jason Signs',
  'Lovells',
  'Malaga Springs',
  'Malaga Springs and Suspensions',
  'MMT',
  'MRT Perth',
  'MRT - Bibra Lake',
  'Norweld',
  'Pedders - Cockburn',
  'Pedders - Malaga',
  'Pedders Cannington',
  'Perth Ceramic Coating',
  'PK Technology',
  'PTE',
  'Roscoes',
  'SWAT',
  'Swank',
  'TC Boxes Bayswater',
  'Techfire',
  'TL Engineering',
  'TWD 4X4',
  'Tyrepower - Osborne Park',
  'Tyrepower - West Perth',
  'Ultimate 4X4',
  'Unicorn Transport Equipment',
  'Westrac',
];

const SUBLET_PROVIDER_ALIASES = new Map([
  ['arb welshpool', 'ARB - Welshpool'],
  ['arb - welshpool', 'ARB - Welshpool'],
  ['customersublet', 'Customer Sublet'],
  ['customer sublet', 'Customer Sublet'],
  ['harnessmaster', 'Harness Master'],
  ['harness master', 'Harness Master'],
  ['hidrive canning vale', 'Hidrive - Canning Vale'],
  ['hidrive - canning vale', 'Hidrive - Canning Vale'],
  ['malaga springs and suspensions', 'Malaga Springs and Suspensions'],
  ['pedders malaga', 'Pedders - Malaga'],
  ['pedders - malaga', 'Pedders - Malaga'],
  ['roscos', 'Roscoes'],
  ['roscoes', 'Roscoes'],
  ['techfire', 'Techfire'],
  ['tyrepower west perth', 'Tyrepower - West Perth'],
  ['tyrepower - west perth', 'Tyrepower - West Perth'],
  ['ultimate4x4', 'Ultimate 4X4'],
  ['ultimate 4x4', 'Ultimate 4X4'],
]);

const SUBLET_PROVIDER_ACRONYMS = new Set(['4X4', 'ARB', 'AV', 'MMT', 'MRT', 'PK', 'PTE', 'SWAT', 'TC', 'TL', 'TWD']);

function normalizeSubletProviderName(value = '') {
  const clean = cleanNavisionText(value).replace(/\s*-\s*/g, ' - ');
  if (!clean) return '';
  const alias = SUBLET_PROVIDER_ALIASES.get(clean.toLowerCase());
  if (alias) return alias;
  return clean.toLowerCase().replace(/\b[0-9a-z]+\b/gi, (word, offset) => {
    const upper = word.toUpperCase();
    if (SUBLET_PROVIDER_ACRONYMS.has(upper)) return upper;
    if (offset > 0 && ['and', 'of', 'the'].includes(word.toLowerCase())) return word.toLowerCase();
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

function normalizedSubletProviderList(names = []) {
  const unique = new Map();
  (Array.isArray(names) ? names : []).forEach(name => {
    const normalized = normalizeSubletProviderName(name);
    if (normalized) unique.set(normalized.toLowerCase(), normalized);
  });
  return [...unique.values()].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

// Stage 2A: sublet providers are now authoritative in Supabase
// (public.sublet_providers via workshop-reference-data-service.js), not
// localStorage. loadSubletProviders() keeps its existing synchronous
// plain-name-array shape for every existing call site.
function loadSubletProviders() {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return [];
  const cached = service.getCachedSubletProviders();
  return normalizedSubletProviderList((cached.rows || []).filter(row => row.active).map(row => row.name));
}
function loadSubletProviderRecords(includeInactive = false) {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return [];
  const cached = service.getCachedSubletProviders();
  const rows = cached.rows || [];
  return includeInactive ? rows : rows.filter(row => row.active);
}

const DEFAULT_SALESPERSONS = [
  { initials: 'JB', name: 'Jason Battle', email: 'jason.battle@pmgwa.com.au' },
  { initials: 'KB', name: 'Kevin Bonser', email: 'kevin.bonser@pmgwa.com.au' },
  { initials: 'CF', name: 'Clint Franklin', email: 'clint.franklin@pmgwa.com.au' },
  { initials: 'BH', name: 'Brooke Hornby', email: 'brooke.hornby@pmgwa.com.au' },
  { initials: 'SL', name: 'Scott Lovett', email: 'scott.lovett@pmgwa.com.au' },
  { initials: 'SP', name: 'Stephen Peck', email: 'stephen.peck@pmgwa.com.au' },
  { initials: 'PS', name: 'Paul Symmons', email: 'paul.symmons@broometoyota.com.au' },
  { initials: 'DW', name: 'David Watson', email: 'dave@pmgwa.com.au' },
  { initials: 'AW', name: 'Andy Weir', email: 'andy.weir@broometoyota.com.au' },
  { initials: 'BG', name: 'Bryce Guthrie', email: 'bryce.guthrie@broometoyota.com.au' },
  { initials: 'PM', name: 'Peter Morris', email: 'peter.morris@broometoyota.com.au' },
  { initials: 'CW', name: 'Craig Watson', email: 'craig.watson@broometoyota.com.au' },
];
const SALESPERSON_CODE_ALIASES = new Map([
  // The supplied FO (FLEET ORDER UP) row shares Stephen Peck's SP address.
  ['FO', 'SP'],
]);

function normalizeSalespersonRecord(record = {}) {
  const initials = cleanNavisionText(record.initials || record.code || record.consultant || '').replace(/[^a-z0-9]/gi, '').toUpperCase().slice(0, 6);
  const name = cleanNavisionText(record.name || record.fullName || '');
  const email = cleanNavisionText(record.email || '').toLowerCase();
  if (!initials || !email || !email.includes('@')) return null;
  return { initials, name: name || initials, email };
}

function normalizedSalespersonList(records = []) {
  const unique = new Map();
  (Array.isArray(records) ? records : []).forEach(record => {
    const normalized = normalizeSalespersonRecord(record);
    if (normalized) unique.set(normalized.initials, normalized);
  });
  return [...unique.values()].sort((a, b) => a.initials.localeCompare(b.initials));
}

// Stage 2A: salespeople are now authoritative in Supabase
// (public.salespeople via workshop-reference-data-service.js), not
// localStorage. loadSalespersons() keeps its existing synchronous
// {initials, name, email} record shape for every existing call site --
// 'initials' maps to the database's 'code' column.
function loadSalespersons() {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return [];
  const cached = service.getCachedSalespeople();
  return normalizedSalespersonList((cached.rows || []).filter(row => row.active).map(row => ({ initials: row.code, name: row.name, email: row.email })));
}
function loadSalespersonRecords(includeInactive = false) {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) return [];
  const cached = service.getCachedSalespeople();
  const rows = cached.rows || [];
  return includeInactive ? rows : rows.filter(row => row.active);
}

function salespersonDirectoryRecords() {
  const records = loadSalespersons();
  return records.length ? records : DEFAULT_SALESPERSONS;
}

function salespersonRecord(value = '') {
  const clean = cleanNavisionText(value);
  const lower = clean.toLowerCase();
  const isInitialsCode = /^[a-z0-9]{1,6}$/i.test(clean);
  const lookupCode = isInitialsCode ? (SALESPERSON_CODE_ALIASES.get(clean.toUpperCase()) || clean.toUpperCase()) : '';
  return salespersonDirectoryRecords().find(record =>
    (isInitialsCode && record.initials === lookupCode) ||
    record.name.toLowerCase() === lower || record.email.toLowerCase() === lower
  ) || null;
}

function salespersonForVehicle(vehicle = {}) {
  const directEmail = cleanNavisionText(vehicle.salespersonEmail || vehicle.salesPersonEmail || vehicle.consultantEmail || vehicle.ownerEmail || vehicle.salesEmail || '');
  const consultant = consultantName(vehicle);
  const record = salespersonRecord(consultant);
  if (record) return record;
  if (directEmail) {
    const directRecord = salespersonDirectoryRecords().find(item => item.email.toLowerCase() === directEmail.toLowerCase());
    return { initials: directRecord?.initials || salesPersonInitials(consultant), name: directRecord?.name || (consultant === 'Unassigned' ? 'Sales' : consultant), email: directEmail };
  }
  return null;
}

function salespersonOptionsHtml(current = '') {
  const selectedValue = cleanNavisionText(current);
  const isInitialsCode = /^[a-z0-9]{1,6}$/i.test(selectedValue);
  const records = loadSalespersons();
  const known = records.some(record => (isInitialsCode && record.initials === selectedValue.toUpperCase()) || record.name.toLowerCase() === selectedValue.toLowerCase());
  const unknownOption = selectedValue && selectedValue !== 'Unassigned' && !known
    ? `<option value="${escapeHtml(selectedValue)}" selected>${escapeHtml(selectedValue)} — imported value</option>`
    : '';
  return `<option value="">Unassigned</option>${unknownOption}${records.map(record => {
    const selected = (isInitialsCode && record.initials === selectedValue.toUpperCase()) || record.name.toLowerCase() === selectedValue.toLowerCase();
    return `<option value="${escapeHtml(record.initials)}"${selected ? ' selected' : ''}>${escapeHtml(record.initials)} — ${escapeHtml(record.name)}</option>`;
  }).join('')}`;
}

function isBlankStock(value) {
  const stock = String(value || '').trim();
  return !stock || stock === '0' || /^TBA$/i.test(stock) || stock.startsWith('PENDING-');
}

function vehicleKey(vehicleOrKey) {
  if (typeof vehicleOrKey === 'string') return vehicleOrKey.trim();
  const v = vehicleOrKey || {};
  const stock = String(v.stock || '').trim();
  if (stock && !isBlankStock(stock)) return stock;
  return String(v.id || stock || '').trim();
}

function vehicleDeleteKey(vehicleOrStock) {
  return vehicleKey(vehicleOrStock);
}
function isDeletedVehicle(vehicle) {
  const key = vehicleDeleteKey(vehicle);
  return Boolean(key && deletedVehicleKeys().has(key));
}

function getToyotaMatch(vehicle) {
  const stock = String(vehicle?.stock || '').trim();
  if (stock && TOYOTA_MATCHES[stock]) return TOYOTA_MATCHES[stock];
  return null;
}

function navisionEtaForVehicle(vehicle) {
  // Dashboard ETA must be Kewdale-only.
  // Do not fall back to ETA Date, Port/Plant ETA Date, or ETA At Dealer/BB.
  return scotEtaOnly(vehicle?.navisionKewdaleEta || vehicle?.etaAtKewdale || '');
}

function buildVehicleData() {
  const edits = loadVehicleEdits();
  const poTasks = loadPoTasks();
  const poFiles = loadPoFiles();
  const deleted = deletedVehicleKeys();
  const base = JSON.parse(JSON.stringify(window.VEHICLE_TRACKING_DATA.vehicles || []));
  const added = loadAddedVehicles();
  return base.concat(added).filter(vehicle => !deleted.has(vehicleDeleteKey(vehicle))).map(vehicle => {
    const key = vehicleKey(vehicle);
    const updated = {
      ...vehicle,
      ...(edits[key] || edits[vehicle.stock] || {}),
    };
    return {
      ...updated,
      toyotaStatus: cleanNavisionText(updated.navisionSubLocationDescription || updated.toyotaStatus || ''),
      etaAtDealer: navisionEtaForVehicle(updated),
      poTasks: poTasks[key] || poTasks[vehicle.stock] || updated.poTasks || [],
      poFiles: poFiles[key] || poFiles[vehicle.stock] || updated.poFiles || [],
    };
  });
}

function clearLegacyLocalSalespersonAssignments() {
  const edits = loadVehicleEdits();
  let changed = false;
  Object.values(edits || {}).forEach(update => {
    if (!update || typeof update !== 'object' || Array.isArray(update)) return;
    ['consultant', 'owner', 'salesperson', 'salesPerson', 'salespersonCode', 'salespersonEmail', 'salespersonReference'].forEach(field => {
      if (!Object.prototype.hasOwnProperty.call(update, field)) return;
      delete update[field];
      changed = true;
    });
  });
  if (changed) saveJson(EDITS_KEY, edits);
  return changed;
}

// Salesperson assignment is operational data. Legacy browser-only values are
// deliberately discarded; the canonical Supabase snapshot is the only source.
clearLegacyLocalSalespersonAssignments();

const app = {
  data: buildVehicleData(),
  matches: TOYOTA_MATCHES,
  report: window.VEHICLE_TRACKING_DATA?.report || {},
  currentView: 'dashboard',
  selectedStock: null,
  activeVehicleDetail: null,
  // A modal is bound to the exact canonical vehicle and the Stock value shown
  // when it opened. Refresh/realtime must never retarget it by index or first
  // visible row.
  vehicleModalIdentity: null,
  vehicleModalIdentityReady: false,
  vehicleModalIdentityRecoveryInFlight: null,
  vehicleModalIdentityRecoveryAttempted: false,
  vehicleModalIdentityLastError: '',
  vehicleModalSaveInFlight: null,
  vehicleDetailPage: 'details',
  vehicleWorkshopDetailCache: new Map(),
  vehicleWorkshopDetailRequestGeneration: 0,
  vehicleWorkshopHoursBatchDrafts: new Map(),
  vehicleWorkshopHoursBatchSaving: false,
  vehicleWorkshopHoursBatchMessage: '',
  vehicleHistoryCache: new Map(),
  vehicleHistoryRequestGeneration: 0,
  pendingWorkshopBookingLink: null,
  reviewed: false,
  quickFilter: 'incoming',
  dashboardView: 'operations',
  pmbSubFilter: '',
  activePmbBayStage: '',
  pmbDraggingKey: '',
  pmbScheduleClockTimer: null,
  workflowBucketsCollapsed: false,
  workflowSearch: '',
  workflowKeySearch: '', // r912 (F494): Control Board Key # box (exact key match)
  workshopEligibilitySnapshot: null,
  workshopEligibilityState: 'idle',
  workshopEligibilityError: '',
  workshopEligibilityRequestGeneration: 0,
  workshopEligibilityRevisionPending: false,
  workshopEligibilitySnapshotRequest: null,
  workshopEligibilityRevisionRequest: null,
  workshopEligibilityClockMinute: null,
  workshopEligibilityRealtime: null,
  workshopEligibilityReconnectTimer: null,
  singleSearchFocus: {},
  workflowFilters: {
    sort: 'oldest',
    bucket: '',
    work: '',
    required: '',
    completion: '',
    stoppage: '',
  },
  workflowWidthMode: 'standard',
  sort: { key: '', dir: 'asc' },
  selectedRows: new Set(),
  columnFilters: { sales: '', production: '', status: '', jita: '' },
  filterOptions: { statuses: [], consultants: [], productionMonths: [], sources: [] },
  autocareFiles: [],
  autocareScan: loadJson(AUTOCARE_RESULTS_KEY, null),
  aiIntakeFiles: [],
  aiIntakeStatus: [],
  aiIntakeAnalysisGeneration: 0,
  serverAiIntakeService: null,
  serverAiIntakeState: 'idle',
  serverAiIntakeError: '',
  serverAiIntakeRevision: null,
  serverAiIntakeNavisionRevision: null,
  serverAiIntakeItems: [],
  serverAiIntakeHistory: [],
  serverAiIntakeGeneration: 0,
  serverAiIntakeLifecycleGeneration: 0,
  serverAiIntakeRealtime: null,
  serverAiIntakeDecisionInFlight: false,
  serverAiIntakeDecisionAttempts: new Map(),
  pdcAuditorService: null,
  pdcAuditorSnapshot: null,
  pdcAuditorResult: null,
  pdcAuditorState: 'idle',
  pdcAuditorError: '',
  pdcAuditorReport: 'morning',
  pdcAuditorSeverityFilter: 'all',
  pdcAuditorCategoryFilter: 'all',
  pdcAuditorSearch: '',
  pdcAuditorGeneration: 0,
  pdcAuditorRealtime: null,
  pdcAuditorPage: 0,
  pdcAuditorDecisionInFlight: false,
  pdcAuditorDecisionMessage: '',
  pdcAuditorDocumentProposals: [],
  emailVehicleLocationService: null,
  emailVehicleLocationRows: [],
  emailVehicleLocationRevision: null,
  emailVehicleLocationError: '',
  emailVehicleLocationGeneration: 0,
  emailVehicleLocationRealtime: null,
  emailVehicleReceiptOverlays: new Map(),
  rftTransportActionGeneration: 0,
  rftTransportActionInFlight: new Set(),
  deletedVehicleSnapshotRows: [],
  deletedVehicleSnapshotState: 'idle',
  deletedVehicleSnapshotError: '',
  deletedVehicleSnapshotGeneration: 0,
  subletMutationQueues: new Map(),
  // Calendar → Month is the canonical clean-session Sublet default. These
  // values remain in memory only; an explicit control selection during this
  // session is allowed to replace them without becoming browser authority.
  subletViewMode: 'calendar',
  subletCalendarMode: 'month',
  subletCalendarAnchor: '',
  navisionImport: loadJson(NAVISION_IMPORT_RESULTS_KEY, null),
  pendingNavisionImport: null,
  navisionFileName: '',
  rejectedNavisionFingerprint: '',
  sharedNavisionVisibleRows: [],
  sharedNavisionVisibleState: 'idle',
  sharedNavisionVisibleError: '',
  sharedNavisionVisibleRevision: null,
  sharedNavisionVisibleGeneration: 0,
  sharedNavisionVisibleRealtime: null,
  sharedNavisionVisibleRealtimeGeneration: 0,
  sharedNavisionVisibleRealtimeState: 'idle',
  sharedNavisionVisibleReconnectAttempt: 0,
  sharedNavisionVisibleReconnectTimer: null,
  sharedNavisionVisibleStableTimer: null,
  sharedNavisionVisibleRealtimeReconciled: false,
  sharedNavisionLocationReadOnlyKeys: new Set(),
  vehicleLocationsRefreshGeneration: 0,
  vehicleLocationsRefreshState: 'idle',
  vehicleLocationsRefreshError: '',
  vehicleLocationsRefreshResult: null,
  vehicleLocationsRefreshDisclosure: null,
  vehicleLocationsRefreshCoordinator: null,
  vehicleLocationsRefreshClickDelegation: null,
  operationalRefreshClickDelegation: null,
  operationalRefreshState: 'idle',
  operationalRefreshRoute: '',
  operationalRefreshError: '',
  operationalRefreshResult: null,
  operationalRefreshDraftConflicts: [],
  operationalRefreshRestoreState: null,
};


window.PDC_APP = app;
window.app = app;

function ensureAppDataAvailable() {
  if (!window.VEHICLE_TRACKING_DATA) window.VEHICLE_TRACKING_DATA = { report: {}, vehicles: [], toyotaMatches: {} };
  if (!Array.isArray(window.VEHICLE_TRACKING_DATA.vehicles)) window.VEHICLE_TRACKING_DATA.vehicles = [];
  if (!app.data.length && window.VEHICLE_TRACKING_DATA.vehicles.length) {
    app.data = buildVehicleData();
    app.selectedStock = vehicleKey(app.data.find(v => v.toyotaStatus) || app.data[0]);
  }
  return app.data;
}

// r408 (F23): window 'error' and 'unhandledrejection' used to call
// showStartupError() for every failure for the life of the page. After start-up
// that painted a permanent, non-dismissable "Website error" banner on top of
// the board for one failed background request, and each further failure
// stacked another. Start-up failures keep the banner (the page may not work);
// failures after init() has run become one dismissable error toast per message
// per 30 s, and aborted requests (the app cancels superseded fetches) are not
// errors at all.
const pdcStartupBannerMessages = new Set();
const pdcRuntimeErrorLastShown = new Map();
let pdcStartupComplete = false;
const PDC_RUNTIME_ERROR_REPEAT_MS = 30000;
function pdcIsAbortError(error) {
  return !!error && (error.name === 'AbortError' || error.code === 20);
}
function reportPdcRuntimeError(error, now = Date.now()) {
  if (!pdcStartupComplete) { showStartupError(error); return; }
  if (pdcIsAbortError(error)) return;
  console.error('PDC Control Board error', error);
  const message = String(error?.message || error || 'Unknown error').trim() || 'Unknown error';
  const last = pdcRuntimeErrorLastShown.get(message);
  if (last !== undefined && now - last < PDC_RUNTIME_ERROR_REPEAT_MS) return;
  pdcRuntimeErrorLastShown.set(message, now);
  pdcNotify(`Something went wrong: ${message}. If this keeps happening, refresh the page.`);
}

function showStartupError(error) {
  console.error('PDC Control Board startup error', error);
  const message = error?.message || String(error || 'Unknown startup error');
  const target = document.querySelector('#fix-first-grid') || document.querySelector('#kpi-grid') || document.querySelector('main') || document.body;
  // r408 (F23): one banner per distinct message, never a growing stack.
  if (pdcStartupBannerMessages.has(message)) return;
  pdcStartupBannerMessages.add(message);
  if (target && typeof target.insertAdjacentHTML === 'function') {
    target.insertAdjacentHTML('afterbegin', `<div class="startup-error-banner"><strong>Website error</strong><span>${escapeHtml(message)}</span><small>Open the browser console and send the error to the builder.</small></div>`);
  }
}

const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
const on = (target, eventName, handler, options) => {
  if (target && typeof target.addEventListener === 'function') target.addEventListener(eventName, handler, options);
};

function setVehicleLocationsRefreshButtonBusy(button, busy) {
  if (!button) return;
  button.disabled = busy === true;
  const status = button.closest?.('.vehicle-locations-refresh');
  if (status) status.setAttribute('aria-busy', busy === true ? 'true' : 'false');
  if (busy === true) {
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Refreshing…';
  } else {
    button.removeAttribute('aria-busy');
    button.textContent = 'Refresh';
  }
}

function handleVehicleLocationsRefreshClickStart(button) {
  setVehicleLocationsRefreshButtonBusy(button, true);
  const status = button?.closest?.('.vehicle-locations-refresh');
  const heading = status?.querySelector?.('strong');
  const detail = status?.querySelector?.('span');
  if (heading) heading.textContent = 'Refreshing Vehicle Locations…';
  if (detail) detail.textContent = 'Reloading the authoritative Navision, operational, work, booking and receipt snapshots.';
}

function handleVehicleLocationsRefreshClickResult(result) {
  if (result?.stale || result?.ok !== false) return;
  const error = String(result.error || result.code || 'refresh_failed');
  if (app.vehicleLocationsRefreshState === 'error' && app.vehicleLocationsRefreshError === error) return;
  app.vehicleLocationsRefreshState = 'error';
  app.vehicleLocationsRefreshError = error;
  renderIncomingDashboardBoard();
}

function bindVehicleLocationsRefreshClickDelegation() {
  if (window.PDC_OPERATIONAL_REFRESH_UI?.createOperationalRefreshClickDelegation) {
    if (app.operationalRefreshClickDelegation) return app.operationalRefreshClickDelegation;
    const delegation = window.PDC_OPERATIONAL_REFRESH_UI.createOperationalRefreshClickDelegation({
      root: document,
      refresh: route => refreshOperationalPage(route),
      onStart: button => handleOperationalRefreshClickStart(button),
      onResult: result => handleOperationalRefreshClickResult(result),
    });
    delegation.bind();
    app.operationalRefreshClickDelegation = delegation;
    app.vehicleLocationsRefreshClickDelegation = delegation;
    return delegation;
  }
  if (app.vehicleLocationsRefreshClickDelegation) return app.vehicleLocationsRefreshClickDelegation;
  const root = $('#incoming-main-board') || document;
  const uiFactory = window.PDC_VEHICLE_LOCATIONS_REFRESH_UI?.createRefreshClickDelegation;
  if (typeof uiFactory === 'function') {
    app.vehicleLocationsRefreshClickDelegation = uiFactory({
      root,
      refresh: () => refreshVehicleLocations(),
      onStart: handleVehicleLocationsRefreshClickStart,
      onResult: handleVehicleLocationsRefreshClickResult,
    });
    app.vehicleLocationsRefreshClickDelegation.bind();
    return app.vehicleLocationsRefreshClickDelegation;
  }
  let inFlight = null;
  const fallbackHandler = event => {
    const button = event.target?.closest?.('[data-vehicle-locations-refresh]');
    if (!button || button.disabled || inFlight) return;
    event.preventDefault();
    event.stopPropagation();
    handleVehicleLocationsRefreshClickStart(button);
    const promise = Promise.resolve().then(() => refreshVehicleLocations()).then(result => {
      handleVehicleLocationsRefreshClickResult(result);
      return result;
    }).catch(() => {
      const result = { ok: false, error: 'refresh_failed' };
      handleVehicleLocationsRefreshClickResult(result);
      return result;
    }).finally(() => {
      if (inFlight === promise) inFlight = null;
      setVehicleLocationsRefreshButtonBusy(button, false);
    });
    inFlight = promise;
  };
  on(root, 'click', fallbackHandler);
  app.vehicleLocationsRefreshClickDelegation = { bind: () => true, isBound: () => true, isRefreshing: () => Boolean(inFlight) };
  return app.vehicleLocationsRefreshClickDelegation;
}

function cleanName(value = '') {
  return String(value)
    .toUpperCase()
    .replace(/\s+-\s+R\b/g, '')
    .replace(/\bPTY\b|\bLTD\b|\bTHE\b|\bTRUSTEE\b|\bFOR\b/g, '')
    .replace(/[^A-Z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function similarity(a, b) {
  const sa = new Set(a.split(' ').filter(Boolean));
  const sb = new Set(b.split(' ').filter(Boolean));
  const intersection = [...sa].filter(x => sb.has(x)).length;
  const union = new Set([...sa, ...sb]).size || 1;
  return intersection / union;
}

function isCustomerMatch(vehicle) {
  if (/navision/i.test(String(vehicle?.source || ''))) return true;
  if (!vehicle.toyotaCustomer) return true;
  const excel = cleanName(vehicle.client);
  const toyota = cleanName(vehicle.toyotaCustomer);
  if (!excel || !toyota) return true;
  return excel.includes(toyota) || toyota.includes(excel) || similarity(excel, toyota) > 0.62;
}

function consultantName(vehicle) {
  return vehicle.consultant || vehicle.owner || 'Unassigned';
}

function salesPersonInitials(value) {
  const name = String(value || '').trim();
  if (!name || name === 'Unassigned') return '--';
  if (/^[A-Z]{1,4}$/i.test(name) && !name.includes(' ')) return name.toUpperCase();
  const words = name.replace(/[^A-Za-z0-9 ]+/g, ' ').split(/\s+/).filter(Boolean);
  if (!words.length) return '--';
  return words.slice(0, 3).map(w => w[0]).join('').toUpperCase();
}

function taskOptionsHtml(current = '') {
  let currentValue = String(current || '').trim();
  let normalizedCurrent = currentValue.toLowerCase();
  const disallowedTask = normalizedCurrent === 'do builds' || normalizedCurrent.includes('purchase order') || normalizedCurrent.includes('po task');
  if (disallowedTask) {
    currentValue = '';
    normalizedCurrent = '';
  }
  const options = TASK_OPTIONS.filter(task => task.toLowerCase() !== 'do builds');
  const extra = currentValue && !options.some(task => task.toLowerCase() === normalizedCurrent)
    ? [`${currentValue}`]
    : [];
  return ['<option value="">Select a task...</option>']
    .concat(options, extra)
    .map((task, index) => {
      if (index === 0) return task;
      const selected = task.toLowerCase() === normalizedCurrent ? ' selected' : '';
      return `<option value="${escapeHtml(task)}"${selected}>${escapeHtml(task)}</option>`;
    })
    .join('');
}

const NAVISION_JITA_NUMBER_AUTHORITY = 'validated-navision-import-v1';

function vehicleNavisionJitaNumber(vehicle = {}) {
  if (vehicle.navisionJitaNumberAuthority !== NAVISION_JITA_NUMBER_AUTHORITY) return '';
  if (vehicle.navisionJitaIdentityVerified !== true || vehicle.navisionJitaNumberColumnPresent !== true) return '';
  const value = String(vehicle.jitQty || vehicle.navisionJitaNumber || '').trim();
  return /\d/.test(value) && !/^0+(?:\.0+)?$/.test(value) ? value : '';
}
function jitaDisplay(vehicle) {
  return vehicleNavisionJitaNumber(vehicle);
}

function jitaIndicator(vehicle) {
  const number = vehicleNavisionJitaNumber(vehicle);
  if (number) {
    const accessible = `Navision JITA number ${number}`;
    return `<span class="jita-icon jita-yes" role="img" aria-label="${escapeHtml(accessible)}" title="${escapeHtml(accessible)}">✓</span>`;
  }
  return '<span class="jita-icon jita-unknown" role="img" aria-label="No Navision JITA number" title="No Navision JITA number">—</span>';
}

function legacyVehicleFlag(vehicle, key) {
  if (!vehicle) return false;
  const tasks = (vehicle.poTasks || []).join(' ').toLowerCase();
  const files = (vehicle.poFiles || []).join(' ').toLowerCase();
  const hasPoUpload = Boolean((vehicle.poFiles || []).length || tasks);
  if (key === 'buildPoRaised' && hasPoUpload) return true;
  if (vehicle[key] === true) return true;
  if (vehicle[key] === false) return false;
  if (key === 'tintRaised') return tasks.includes('window tint') || files.includes('tint');
  if (key === 'trayOrdered') return tasks.includes('tray');
  if (key === 'trayFitmentComplete') return false;
  return false;
}

function vehicleFlag(vehicle, key) {
  const def = pdcJobDefinitionForKey(key);
  if (def && key === def.requireKey) return pdcJobRequired(vehicle, def);
  if (def && key === def.completeKey) return pdcJobComplete(vehicle, def);
  return legacyVehicleFlag(vehicle, key);
}

function checkboxCell(vehicle, key, label, shortLabel = '') {
  const checked = vehicleFlag(vehicle, key) ? ' checked' : '';
  const def = pdcJobDefinitionForKey(key);
  const jobClass = def ? ` pdc-mini-${def.key}` : '';
  return `<label class="mini-check${jobClass}" title="${escapeHtml(label)}"><input type="checkbox" data-flag-stock="${escapeHtml(vehicleKey(vehicle))}" data-flag-key="${escapeHtml(key)}"${checked} /><span>${escapeHtml(shortLabel || label)}</span></label>`;
}

function pdcJobPartsVisualStatus(vehicle = {}, def = {}) {
  if (def?.key !== 'parts') return '';
  if (!pdcJobRequired(vehicle, def)) return '';
  if (pdcJobComplete(vehicle, def) || vehicle.pdcPartsReceived === true) return 'issued';
  if (partsOrdered(vehicle)) return 'onorder';
  return 'notordered';
}

function pdcPartsStatusGlyphHtml(status = '') {
  const glyphs = {
    notordered: '<path d="M4 4h10v12H4z"/><path d="M6.5 7h5M6.5 10h5M6.5 13h3"/>',
    ordered: '<path d="M4 4h10v12H4z"/><path d="M6.5 7h5M6.5 10h5"/><path d="m9 13 1.5 1.5L14 11"/>',
    issued: '<path d="m4 9 4 4 8-8"/>',
  };
  const labels = { notordered: 'Parts not ordered', ordered: 'Parts ordered', issued: 'Parts received' };
  const key = status === 'onorder' ? 'ordered' : (Object.prototype.hasOwnProperty.call(glyphs, status) ? status : 'notordered');
  return `<span class="parts-status-glyph parts-status-glyph-${key}" role="img" aria-label="${escapeHtml(labels[key])}" title="${escapeHtml(labels[key])}"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">${glyphs[key]}</svg></span>`;
}

function pdcJobTableCell(vehicle, def) {
  if (!def) return '';
  if (statusCategory(vehicle) === 'rft') {
    const checked = pdcJobComplete(vehicle, def);
    const mechanic = pdcJobMechanic(vehicle, def);
    const meta = [mechanic ? `Mechanic: ${mechanic}` : '', pdcJobBay(vehicle, def) ? `Bay ${pdcJobBay(vehicle, def)}` : '', pdcJobHours(vehicle, def) ? `${pdcJobHours(vehicle, def)}h` : ''].filter(Boolean).join(' · ');
    const title = checked
      ? `${def.label} was completed before RFT${meta ? ` · ${meta}` : ''}`
      : `${def.label} has not been signed off before RFT`;
    return `<label class="mini-check pdc-mini-${escapeHtml(def.key)} rft-completion-check ${checked ? 'is-complete' : 'is-missing'}" title="${escapeHtml(title)}"><input type="checkbox" data-flag-stock="${escapeHtml(vehicleKey(vehicle))}" data-flag-key="${escapeHtml(def.completeKey)}"${checked ? ' checked' : ''} /><span>${escapeHtml(def.short)}</span></label>`;
  }
  const partsVisualStatus = pdcJobPartsVisualStatus(vehicle, def);
  if (partsVisualStatus) {
    const checked = vehicleFlag(vehicle, def.requireKey) ? ' checked' : '';
    const statusLabel = partsVisualStatus === 'issued' ? 'Parts received/there' : partsVisualStatus === 'onorder' ? 'Parts confirmed/ordered' : 'Parts required - not ordered';
    return `<label class="mini-check pdc-mini-${escapeHtml(def.key)} parts-visual-${escapeHtml(partsVisualStatus)}" title="${escapeHtml(`${def.label} required · ${statusLabel}`)}"><input class="parts-visual-input" type="checkbox" data-flag-stock="${escapeHtml(vehicleKey(vehicle))}" data-flag-key="${escapeHtml(def.requireKey)}"${checked} aria-label="${escapeHtml(`${def.label} required`)}" />${pdcPartsStatusGlyphHtml(partsVisualStatus)}<span class="parts-visual-copy">${escapeHtml(def.short)}</span></label>`;
  }
  return checkboxCell(vehicle, def.requireKey, `${def.label} required`, def.short);
}

function flagGroupCell(vehicle) {
  return `<div class="flag-group" aria-label="PDC required jobs">${PDC_JOB_DEFS.map(def => checkboxCell(vehicle, def.requireKey, `${def.label} required`, def.short)).join('')}</div>`;
}

function getStage(vehicle) {
  const manualPdcLocation = vehiclePdcLocation(vehicle || {});
  if (manualPdcLocation === 'YH') return 'Yard Hold';
  if (manualPdcLocation === 'PMB' && statusCategory(vehicle) === 'qc') return 'QC';
  if (manualPdcLocation === 'PMB') return 'PMB';
  if (manualPdcLocation === 'PIT') return 'PIT';
  if (manualPdcLocation === 'QC') return 'QC';
  if (manualPdcLocation === 'RFT') return 'RFT';
  if (manualPdcLocation === 'COLLECTED') return 'Collected';

  const category = statusCategory(vehicle);
  if (category === 'yardhold') return 'Yard Hold';
  if (category === 'prodtransit') return 'Production / In Transit';
  if (category === 'batchmatched') return 'Batch Matched';

  const status = normalizeToyotaStatus(vehicle.toyotaStatus || '');
  if (isAutocareDespatched(vehicle)) return 'Production / In Transit';
  if (!status || status === 'not matched') return 'Needs Matching';
  return 'Needs Matching';
}

const STATUS_TAB_DEFS = [];
const STATUS_TABS = STATUS_TAB_DEFS;

function vehicleHasBatchNumber(vehicle = {}) {
  return !isBlankStock(vehicle.batch || vehicle.stock || vehicle.toyotaBatch || vehicle.autocareBatch || '');
}

function navisionStatusText(vehicleOrStatus = '') {
  if (vehicleOrStatus && typeof vehicleOrStatus === 'object') {
    return cleanNavisionText(vehicleOrStatus.toyotaStatus || vehicleOrStatus.navisionSubLocationDescription || '');
  }
  return cleanNavisionText(vehicleOrStatus || '');
}

function vehiclePdcLocation(vehicle = {}) {
  const explicit = normalizePdcLocation(vehicle.pdcLocation || vehicle.pdcStatus || vehicle.manualLocation || '');
  return explicit;
}

function vehicleRftTransportBooked(vehicle = {}) {
  return Boolean(vehicle.rftTransportBookedAt);
}

function durableRftLifecycleEnabled() {
  const config = window.PDC_SUPABASE_CONFIG || {};
  return config.environment === 'staging'
    && config.projectRef === 'cdsmnqxtyyoeoznmbidd'
    && config.vehicleLifecycle?.durableRftLifecycle === true;
}

function vehicleRftEmailEvidenceReady(vehicle = {}) {
  const outbox = vehicle.rftTransportOutbox && typeof vehicle.rftTransportOutbox === 'object' ? vehicle.rftTransportOutbox : {};
  const evidence = vehicle.rftTransportEmailEvidence && typeof vehicle.rftTransportEmailEvidence === 'object'
    ? vehicle.rftTransportEmailEvidence
    : outbox.evidence && typeof outbox.evidence === 'object' ? outbox.evidence : {};
  return vehicleRftTransportBooked(vehicle)
    && outbox.intercepted === true
    && outbox.delivery_enabled === false
    && outbox.sent_at == null
    && outbox.delivered_at == null
    && Boolean(evidence.photo_receipt_id || evidence.photoReceiptId)
    && Boolean(evidence.mime_sha256 || evidence.mimeSha256);
}

function vehicleRftCollectionEnabled(vehicle = {}) {
  return durableRftLifecycleEnabled() && vehicleRftEmailEvidenceReady(vehicle);
}

function vehicleRftLifecycleRoleAllowed(role = window.PDC_AUTH_CONTEXT?.role) {
  return ['operator', 'administrator'].includes(String(role || '').trim().toLowerCase());
}

function rftTransportActionAuthorityReady(vehicle = {}) {
  return durableRftLifecycleEnabled()
    && vehicle.__emailVehicleServerAuthoritative === true
    && Boolean(vehicle.__emailVehicleId)
    && Number(vehicle.__emailVehicleVersion || 0) >= 1
    && typeof app.emailVehicleLocationService?.setRftConfirmation736 === 'function'
    && typeof app.emailVehicleLocationService?.bookRftTransport739 === 'function'
    && typeof app.emailVehicleLocationService?.collectRftTransport734 === 'function';
}

function vehicleRftConfirmationActive(vehicle = {}) {
  return vehicle.rftConfirmed === true
    || Boolean(vehicle.rftConfirmedAt)
    || vehicle.pdcLifecycle?.rft_confirmed === true;
}

function rftConfirmationVehicleCollectedOrCompleted(vehicle = {}) {
  const state = String(vehicle.pdcLifecycleState || vehicle.vehicleLifecycleState || vehicle.lifecycleState || '').trim().toLowerCase();
  const location = String(vehicle.pdcLocation || vehicle.current_location || '').trim().toLowerCase();
  return ['collected', 'completed'].includes(state) || ['collected', 'completed'].includes(location) || vehicle.completedVehicle === true;
}

function rftConfirmationIrreversibleReason(vehicle = {}) {
  if (vehicleRftTransportBooked(vehicle) || vehicle.rftTransportOutbox?.notification_id || vehicle.rftTransportEmailEvidence?.photo_receipt_id) return 'Email Sales Person evidence exists; RFT’d cannot be unticked';
  if (rftConfirmationVehicleCollectedOrCompleted(vehicle)) return 'Collected or Completed is recorded; RFT’d cannot be unticked';
  return '';
}

function rftTransportCollectionDisabledReason(vehicle = {}) {
  if (!vehicleRftTransportBooked(vehicle)) return 'Book RFT transport first';
  if (!vehicleRftEmailEvidenceReady(vehicle)) return 'Mandatory email and QC photo evidence required';
  if (!rftTransportActionAuthorityReady(vehicle)) return 'Shared staging authority unavailable';
  return '';
}

function vehicleRftTransitionAuthoritative(vehicle = {}) {
  return vehicleRftConfirmationActive(vehicle);
}

function rftTransportControlsHtml(vehicle = {}) {
  const key = vehicleKey(vehicle);
  const roleAllowed = vehicleRftLifecycleRoleAllowed();
  const rftConfirmed = vehicleRftConfirmationActive(vehicle);
  const booked = vehicleRftTransportBooked(vehicle);
  const draft = vehicle.rftTransportDraft && typeof vehicle.rftTransportDraft === 'object' ? vehicle.rftTransportDraft : {};
  const authorityReady = rftTransportActionAuthorityReady(vehicle);
  const actionKey = `rft:${key}`;
  const inFlight = app.rftTransportActionInFlight?.has(actionKey);
  const irreversibleReason = rftConfirmationIrreversibleReason(vehicle);
  const confirmationReason = !roleAllowed
    ? 'Operator or Administrator access required'
    : !authorityReady
      ? 'Shared staging authority unavailable'
      : rftConfirmed && irreversibleReason
        ? irreversibleReason
        : inFlight ? 'Another RFT action is in progress' : '';
  const confirmationDisabled = Boolean(confirmationReason);
  const bookedDisabled = booked || !roleAllowed || !authorityReady || !rftConfirmed || inFlight;
  const collectionEnabled = roleAllowed && vehicleRftCollectionEnabled(vehicle) && authorityReady;
  const collectionReason = !roleAllowed
    ? 'Operator or Administrator access required'
    : rftTransportCollectionDisabledReason(vehicle) || (inFlight ? 'Another RFT action is in progress' : '');
  const confirmationTitle = confirmationDisabled
    ? `Disabled: ${confirmationReason}`
    : rftConfirmed
      ? 'Untick to reverse an accidental manual RFT confirmation and clear its open dealer-transit timer'
      : 'Tick to record manual RFT confirmation and start the dealer-transit timer';
  const bookedTitle = booked
    ? 'Checked: RFT transport is booked and the mandatory salesperson email is sent or queued in staging'
    : !roleAllowed
      ? 'Disabled: Operator or Administrator access is required'
      : !rftConfirmed
        ? 'Disabled: tick RFT’d first'
      : authorityReady
        ? 'Record RFT transport booking through the shared staging successor'
        : 'Unavailable: this row is not bound to shared staging authority';
  const collectedTitle = collectionEnabled
    ? 'Record physical RFT collection through the shared staging successor'
    : collectionReason;
  const collectionAria = collectionEnabled
    ? 'Collected — ready to record physical collection'
    : `Collected — disabled: ${collectionReason || 'Collection is not yet enabled'}`;
  return `<span class="rft-transport-controls" role="group" aria-label="RFT transport controls">
    <label class="rft-transport-control rft-confirmation-control ${rftConfirmed ? 'is-checked' : 'is-unchecked'}" title="${escapeHtml(confirmationTitle)}"><input type="checkbox" data-rft-confirmation-key="${escapeHtml(key)}" aria-label="RFT’d" ${rftConfirmed ? 'checked' : ''} ${confirmationDisabled ? 'disabled' : ''} /><span class="rft-transport-icon" aria-hidden="true">${rftConfirmed ? '✓' : '○'}</span><span>RFT’d</span></label>
    <button class="small-button rft-transport-control rft-email-salesperson-button" type="button" data-rft-transport-booked-key="${escapeHtml(key)}" aria-pressed="${booked ? 'true' : 'false'}" ${bookedDisabled ? 'disabled' : ''} title="${escapeHtml(bookedTitle)}"><span class="rft-transport-icon" aria-hidden="true">${booked ? '✓' : '↗'}</span><span>Email Sales Person</span></button>
    <button class="small-button rft-transport-control rft-collected-button" type="button" data-rft-collected-key="${escapeHtml(key)}" aria-label="${escapeHtml(collectionAria)}" ${collectionEnabled && !inFlight ? '' : 'disabled'} title="${escapeHtml(collectedTitle || 'Collection is not yet enabled')}"><span class="rft-transport-icon" aria-hidden="true">✓</span><span>Collected</span></button>
    ${draft.draft_id ? `<a class="rft-draft-download-link" href="#" data-rft-draft-key="${escapeHtml(key)}" aria-label="Download intercepted salesperson email draft (.eml)" title="Download the intercepted salesperson email draft (.eml)"><span aria-hidden="true">⇩</span></a>` : ''}
  </span>`;
}

function rftTransportEmailStatusLabel(vehicle = {}) {
  const outbox = vehicle.rftTransportOutbox && typeof vehicle.rftTransportOutbox === 'object' ? vehicle.rftTransportOutbox : {};
  if (outbox.intercepted === true || outbox.intercept_receipt_id || outbox.interceptReceiptId) return 'Mandatory salesperson email captured in staging';
  if (outbox.delivered_at || outbox.sent_at || ['sent', 'delivered'].includes(String(outbox.delivery_status || '').toLowerCase())) return 'Mandatory salesperson email sent';
  if (vehicleRftTransportBooked(vehicle)) return 'Mandatory salesperson email queued';
  return '';
}

function vehicleCollectedFromRft(vehicle = {}) {
  const state = String(vehicle.pdcLifecycleState || vehicle.vehicleLifecycleState || vehicle.lifecycleState || '').trim().toLowerCase();
  const location = String(vehicle.pdcLocation || vehicle.current_location || '').trim().toLowerCase();
  return state === 'completed' || location === 'completed' || vehicle.completedVehicle === true;
}

function vehicleInCollectedState(vehicle = {}) {
  const state = String(vehicle.pdcLifecycleState || vehicle.vehicleLifecycleState || '').trim().toLowerCase();
  const location = String(vehicle.pdcLocation || vehicle.current_location || '').trim().toLowerCase();
  return state === 'collected' || location === 'collected' || (Boolean(vehicle.rftCollectedAt) && !vehicleCollectedFromRft(vehicle));
}

function isHermesSyntheticVehicle(vehicle = {}) {
  return /^HERMES-TEST-/.test(displayStockNumber(vehicle));
}

function navisionImportedToyotaTransitCategory(vehicle = {}) {
  if (!vehicle || typeof vehicle !== 'object' || !vehicleLooksToyota(vehicle)) return '';
  const source = [
    vehicle.source,
    vehicle.sourceSystem,
    vehicle.source_system,
    vehicle.recordLifecycle,
    vehicle.__sharedNavisionReadOnly ? 'shared navision' : '',
    vehicle.__sharedNavisionRecordId ? 'shared navision' : '',
  ].map(value => cleanNavisionText(value || '').toLowerCase()).filter(Boolean).join(' ');
  if (!source.includes('navision')) return '';
  const canonicalLocation = cleanNavisionText(
    vehicle.__sharedNavisionCanonicalLocation || vehicle.current_location || vehicle.currentLocation || vehicle.pdcLocation || ''
  ).toUpperCase();
  const status = normalizeToyotaStatus(navisionLocationSourceText(vehicle));
  const fromTwaDespatch = status.includes('from twa') &&
    (status.includes('despatch') || status.includes('dispatch'));
  const preArrival = canonicalLocation === 'IT' || canonicalLocation === 'IN TRANSIT' ||
    fromTwaDespatch ||
    status.includes('planned for production') || status.includes('line off complete') ||
    status.includes('final inspection') || status.includes('ready for shipment') ||
    status.includes('in transit') || status.includes('shipment') || status.includes('wharf') ||
    status.includes('production transit') || /\bit\b/.test(status);
  if (!preArrival) return '';
  return parseDateAU(kewdaleEtaValue(vehicle)) ? 'prodtransit' : 'other';
}

function statusCategory(vehicleOrStatus = '') {
  const isVehicle = vehicleOrStatus && typeof vehicleOrStatus === 'object';
  if (isVehicle && vehicleInCollectedState(vehicleOrStatus)) return 'collected';
  if (isVehicle && vehicleCollectedFromRft(vehicleOrStatus)) return 'completed';
  if (isVehicle && !vehicleHasBatchNumber(vehicleOrStatus)) return 'other';

  if (isVehicle) {
    const manualPdcLocation = vehiclePdcLocation(vehicleOrStatus);
    if (manualPdcLocation === 'YH') return 'yardhold';
    if (manualPdcLocation === 'PIT') return 'pit';
    if (manualPdcLocation === 'QC') return 'qc';
    if (manualPdcLocation === 'RFT') return 'rft';
    if (manualPdcLocation === 'PMB' && vehicleOrStatus.pdcQcComplete === true) return 'qc';
    if (manualPdcLocation === 'PMB') return 'pmb';
    const navisionTransitCategory = navisionImportedToyotaTransitCategory(vehicleOrStatus);
    if (navisionTransitCategory) return navisionTransitCategory;
  }

  const rawStatus = normalizeToyotaStatus(navisionStatusText(vehicleOrStatus));
  const canonicalStatus = normalizeToyotaStatus(canonicalToyotaStatus(rawStatus) || rawStatus);
  const locationStatus = isVehicle
    ? normalizeToyotaStatus(vehicleOrStatus.navisionLocationStatus || vehicleOrStatus.locationStatus || '')
    : '';
  const status = `${rawStatus} ${canonicalStatus} ${locationStatus}`.trim();

  // Source status may group an already-visible vehicle through Yard Hold. PMB and
  // RFT are independent PDC locations and are protected from normal Navision imports.
  if (
    locationStatus === 'yh' ||
    status.includes('vehicle yard hold') ||
    status.includes('vehicle in yard hold') ||
    status.includes('yard hold') ||
    /\byh\b/.test(status)
  ) return 'yardhold';

  if (
    status.includes('planned for production') ||
    status.includes('line off complete') ||
    status.includes('final inspection') ||
    status.includes('in transit to o/s wharf') ||
    status.includes('in transit to os wharf') ||
    status.includes('in transit to eastern states') ||
    status.includes('ready for shipment') ||
    status.includes('in transit to wa') ||
    status.includes('vehicle at wharf') ||
    (status.includes('at wharf') && !status.includes('enroute')) ||
    status.includes('vehicle enroute from wharf') ||
    status.includes('production') ||
    status.includes('transit') ||
    status.includes('shipment') ||
    status.includes('wharf')
  ) return 'prodtransit';

  if (isVehicle && vehicleHasBatchNumber(vehicleOrStatus)) return 'batchmatched';

  return 'other';
}

function statusCategoryLabel(vehicleOrStatus = '') {
  const category = statusCategory(vehicleOrStatus);
  const tab = STATUS_TAB_DEFS.find(item => item.key === category);
  if (tab) return tab.label;
  return category === 'other' ? 'Other' : category;
}

function statusClass(vehicleOrStatus = '') {
  return `status-${statusCategory(vehicleOrStatus)}`;
}

function needsContact(vehicle) {
  const s = String(vehicle.toyotaStatus || '').toLowerCase();
  const internal = String(vehicle.internalStatus || '').toLowerCase();
  return s.includes('delayed') || s.includes('ready') || s.includes('dealer') || s.includes('transit') || internal.includes('tray') || !isCustomerMatch(vehicle);
}

function scotEtaOnly(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  const dates = [...text.matchAll(/\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/g)].map(match => match[0]);
  // Some imported rows can accidentally include more than one date.
  // Keep the last date-like value for compact display.
  return dates.length ? dates[dates.length - 1] : text;
}

function parseDateAU(value) {
  const cleanValue = scotEtaOnly(value);
  if (!cleanValue || String(cleanValue).toUpperCase().includes('TBA')) return null;
  const m = String(cleanValue).match(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
  if (!m) return null;
  const year = Number(m[3].length === 2 ? '20' + m[3] : m[3]);
  return new Date(year, Number(m[2]) - 1, Number(m[1]));
}

function daysTo(value) {
  const dt = parseDateAU(value);
  if (!dt || Number.isNaN(dt.getTime())) return null;
  // r407 (F19): Perth calendar days, as daysSinceDateValue.
  return Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()) / 86400000 - Math.floor((new Date().getTime() + 8 * 3600000) / 86400000);
}

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
}

async function copyTextToClipboard(value = '') {
  const text = String(value);
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (_) {
      // Clipboard permission can be rejected even when the API is exposed.
      // Continue to the selectable-text fallback below.
    }
  }
  let fallback = null;
  try {
    fallback = document.createElement('textarea');
    fallback.value = text;
    fallback.setAttribute('readonly', '');
    fallback.style.position = 'fixed';
    fallback.style.opacity = '0';
    document.body.appendChild(fallback);
    fallback.select();
    if (!document.execCommand('copy')) {
      throw new Error('copy command failed');
    }
  } catch (_) {
    throw new Error('Clipboard copy is unavailable. Select and copy the Stock Number manually.');
  } finally {
    fallback?.remove();
  }
}

async function copyVehicleStockNumber(value, button, status) {
  const text = String(value ?? '');
  try {
    if (!text.trim()) throw new Error('No Stock Number is available.');
    await copyTextToClipboard(text);
    if (button) button.textContent = 'Copied';
    if (status) status.textContent = `Copied ${text}`;
    window.setTimeout(() => {
      if (button?.isConnected) button.textContent = 'Copy';
    }, 1500);
    return true;
  } catch (error) {
    const message = error?.message || 'Could not copy the Stock Number.';
    if (button) button.textContent = 'Copy failed';
    if (status) status.textContent = message;
    return false;
  }
}

function navisionDealerNoteText(vehicle = {}) {
  return cleanNavisionText(vehicle.navisionDealerComments || vehicle.dealerComments || vehicle.financeNote || '');
}

function navisionNotesCell(vehicle = {}) {
  const note = navisionDealerNoteText(vehicle);
  if (!note) return '<span class="navision-note-empty" aria-label="No Navision Notes"></span>';
  return `<span class="navision-note-icon" tabindex="0" title="Navision Notes: ${escapeHtml(note)}" aria-label="Navision Notes: ${escapeHtml(note)}">!</span>`;
}

function formatStatus(vehicle) {
  const manualPdcLocation = vehiclePdcLocation(vehicle || {});
  const navisionStatus = String(vehicle?.toyotaStatus || '').trim() || 'No Sub Location';
  const primaryStatus = manualPdcLocation ? pdcLocationLabel(manualPdcLocation) : navisionStatus;
  const navisionLine = manualPdcLocation && navisionStatus && navisionStatus !== 'No Sub Location'
    ? `<div class="subtle pdc-status-note">Navision: ${escapeHtml(navisionStatus)}</div>`
    : '';
  const autocare = isAutocareDespatched(vehicle) && navisionStatus !== AUTOCARE_DESPATCH_STATUS
    ? `<div class="subtle autocare-status-note">${escapeHtml(AUTOCARE_DESPATCH_STATUS)}</div>`
    : '';
  return `<span class="badge ${statusClass(vehicle)}">${escapeHtml(primaryStatus)}</span>${navisionLine}${autocare}`;
}

function dateHelper(value) {
  const d = daysTo(value);
  if (d === null) return '';
  if (d < 0) return `${Math.abs(d)} days past ETA`;
  if (d === 0) return 'Due today';
  return `${d} days to ETA`;
}

function etaDeltaText(value) {
  const d = daysTo(value);
  if (d === null) return { label: '', cls: 'neutral' };
  if (d < 0) {
    const daysPast = Math.abs(d);
    return { label: `+${daysPast} days`, cls: 'negative', title: `${daysPast} days past ETA / on ground` };
  }
  if (d === 0) return { label: 'Today', cls: 'neutral', title: 'ETA is today' };
  return { label: `${d} days`, cls: 'positive', title: `${d} days to ETA` };
}

function formatEta(value) {
  const eta = scotEtaOnly(value);
  if (!eta) return '';
  const delta = etaDeltaText(eta);
  const badge = delta.label ? `<span class="eta-badge ${delta.cls}" title="${escapeHtml(delta.title || delta.label)}">${escapeHtml(delta.label)}</span>` : '';
  return `<div class="eta-inline"><strong>${escapeHtml(eta)}</strong>${badge}</div>`;
}

function displayStockNumber(vehicle) {
  const stock = String(vehicle?.stock || '').trim();
  if (isBlankStock(stock)) return stock.replace(/^PENDING-/, '') || '';
  return stock;
}

function vehicleKeyNumber(vehicle = {}) {
  return cleanNavisionText(
    vehicle.keyNumber ||
    vehicle.keyNo ||
    vehicle.keyTag ||
    vehicle.pdcKeyNumber ||
    vehicle.vehicleKeyNumber ||
    ''
  );
}

function vehicleJobcardNumber(vehicle = {}) {
  return cleanNavisionText(
    vehicle.pdcJobcard ||
    vehicle.jobcard ||
    vehicle.jobCard ||
    vehicle.jobcardNumber ||
    vehicle.jobCardNumber ||
    vehicle.jcJobcard ||
    vehicle.jc ||
    ''
  );
}

function vehicleCustomerName(vehicle = {}) {
  return cleanNavisionText(vehicle.client || vehicle.toyotaCustomer || vehicle.dealerCustomer || '');
}

function vehicleIdentityParts(vehicle = {}) {
  const stock = displayStockNumber(vehicle);
  return [
    { label: 'Key', value: vehicleKeyNumber(vehicle) },
    { label: 'Stock', value: stock },
    { label: 'JC', value: vehicleJobcardNumber(vehicle) },
    { label: 'Customer', value: vehicleCustomerName(vehicle) },
  ].filter(part => cleanNavisionText(part.value));
}

function vehicleIdentityLabelText(part = {}) {
  return `${part.label} ${part.value}`.trim();
}

function vehicleIdentityPrimary(vehicle = {}) {
  return vehicleIdentityParts(vehicle)[0] || { label: 'Vehicle', value: displayVehicle(vehicle) || 'Vehicle' };
}

function vehicleIdentityTitle(vehicle = {}) {
  const parts = vehicleIdentityParts(vehicle).map(vehicleIdentityLabelText);
  const unit = displayVehicle(vehicle);
  if (unit) parts.push(unit);
  return parts.join(' · ');
}

function vehicleIdentitySecondaryText(vehicle = {}) {
  return vehicleIdentityParts(vehicle).slice(1).map(vehicleIdentityLabelText).join(' · ');
}

const VEHICLE_IDENTITY_COLUMNS = [
  { label: 'Key', className: 'identity-key' },
  { label: 'SN', className: 'identity-stock' },
  { label: 'JC', className: 'identity-jc' },
  { label: 'Name', className: 'identity-name' },
];

function vehicleIdentityCells(vehicle = {}) {
  const stock = displayStockNumber(vehicle);
  return [
    { ...VEHICLE_IDENTITY_COLUMNS[0], value: vehicleKeyNumber(vehicle) },
    { ...VEHICLE_IDENTITY_COLUMNS[1], value: stock },
    { ...VEHICLE_IDENTITY_COLUMNS[2], value: vehicleJobcardNumber(vehicle) },
    { ...VEHICLE_IDENTITY_COLUMNS[3], value: vehicleCustomerName(vehicle) },
  ];
}

function vehicleIdentityHeaderHtml(className = '') {
  return '';
}

function vehicleIdentityStackHtml(vehicle = {}, options = {}) {
  const includeName = options.includeName !== false;
  const cells = vehicleIdentityCells(vehicle).filter(cell => includeName || cell.label !== 'Name');
  const key = vehicleKey(vehicle);
  const title = vehicleIdentityTitle(vehicle);
  const classes = ['vehicle-identity-stack', 'vehicle-identity-columns', includeName ? '' : 'vehicle-identity-no-name', options.className || ''].filter(Boolean).join(' ');
  const html = cells.map((cell, index) => {
    const rawValue = cleanNavisionText(cell.value) || '—';
    // Customer names are deliberately left intact. CSS gives the name cell room to wrap
    // so long company names remain readable instead of being cut down to a few characters.
    const value = cell.label === 'Name' ? rawValue : truncate(rawValue, 18);
    const buttonCell = options.button === true
      && cleanNavisionText(cell.value)
      && (options.buttonLabel ? cell.label === options.buttonLabel : index === 0);
    const valueHtml = buttonCell
      ? `<button class="stock-link stock-button vehicle-identity-value vehicle-identity-primary" type="button" data-open-stock="${escapeHtml(key)}" title="${escapeHtml(title)}" aria-label="${escapeHtml(`${cell.label} ${rawValue}`)}">${escapeHtml(value)}</button>`
      : `<span class="vehicle-identity-value ${index === 0 ? 'vehicle-identity-primary' : ''}" title="${escapeHtml(rawValue)}" aria-label="${escapeHtml(`${cell.label} ${rawValue}`)}">${escapeHtml(value)}</span>`;
    // r952 (F524): the key flashes while the car is off site on a Sublet booking.
    const offsite = cell.label === 'Key' && typeof pdcSubletOffsite952 === 'function' ? pdcSubletOffsite952(vehicle) : null;
    if (offsite) return `<span class="vehicle-identity-cell ${escapeHtml(cell.className)} pdc-offsite-key is-${offsite.state === 'away' ? 'away' : 'overdue'}" data-label="${escapeHtml(cell.label)}" title="${escapeHtml(pdcSubletOffsiteTitle952(offsite))}">${valueHtml}${pdcSubletOffsiteTagHtml952(offsite)}</span>`;
    return `<span class="vehicle-identity-cell ${escapeHtml(cell.className)}" data-label="${escapeHtml(cell.label)}">${valueHtml}</span>`;
  }).join('');
  return `<div class="${escapeHtml(classes)}" title="${escapeHtml(title)}">${html}</div>`;
}

function vehiclePmbKeyNumber(vehicle = {}) {
  return statusCategory(vehicle) === 'pmb' ? vehicleKeyNumber(vehicle) : '';
}

function activePmbVehicleWithKeyNumber(keyNumber = '', currentKey = '') {
  const cleanKeyNumber = cleanNavisionText(keyNumber).toLowerCase();
  const cleanCurrentKey = String(currentKey || '').trim();
  if (!cleanKeyNumber) return null;
  return (app.data || []).find(vehicle => {
    const key = vehicleKey(vehicle);
    return key !== cleanCurrentKey && statusCategory(vehicle) === 'pmb' && vehicleKeyNumber(vehicle).toLowerCase() === cleanKeyNumber;
  }) || null;
}

function boardKeyToken(value = '') {
  return String(value || '').replace(/\s+/g, '').toUpperCase();
}

function boardVehicleWithSameKey(keyNumber = '', currentKey = '') {
  const token = boardKeyToken(keyNumber);
  // r830 (F391): any number of cars can be WPC.
  if (!token || /^0+$/.test(token) || token === 'WPC') return null;
  return (app.data || []).find(vehicle => {
    const key = vehicleKey(vehicle);
    return key !== String(currentKey || '').trim() && boardKeyToken(vehicleKeyNumber(vehicle)) === token;
  }) || null;
}

function keyAlreadyOnStockSentence(keyNumber = '', vehicle = {}) {
  const stock = displayStockNumber(vehicle) || '(no stock)';
  return `Key ${boardKeyToken(keyNumber)} is already on stock ${stock}`;
}

function pmbKeyNumberPillHtml(vehicle = {}) {
  const keyNumber = vehiclePmbKeyNumber(vehicle);
  return keyNumber ? `<span class="pmb-keytag-pill" title="PMB key tag number">Key ${escapeHtml(keyNumber)}</span>` : '';
}

function stockOrderSubline(vehicle) {
  return '';
}

function stockLabel(vehicle) {
  const stock = String(vehicle?.stock || '').trim();
  if (isBlankStock(stock)) return 'Stock';
  return 'Stock';
}


function actionSelectHtml(stock) {
  return `<select class="action-select" data-action-stock="${escapeHtml(stock)}" aria-label="Select vehicle action">
    <option value="">Select action...</option>
    <option value="released">Vehicle Released</option>
    <option value="update">Request Update</option>
    <option value="build">New PMB Work Order</option>
    <option value="tint">Tint PO Email</option>
  </select>`;
}

function truncate(value, max) {
  value = String(value || '');
  return value.length > max ? value.slice(0, max - 1) + '…' : value;
}

function titleCaseVehicle(value) {
  const keepUpper = new Set(['LC300', 'LC70', 'RAV4', 'AWD', '2WD', 'PHEV', 'GR', 'SR', 'SR5', 'GX', 'GXL', 'VX', 'ECC', 'DCC', 'SCC', 'DC', 'WM', 'AT', 'ZX', 'XSE']);
  return String(value || '')
    .trim()
    .split(/\s+/)
    .map(token => {
      const clean = token.replace(/[^A-Za-z0-9+-]/g, '');
      const upper = clean.toUpperCase();
      if (keepUpper.has(upper)) return upper;
      if (upper === 'HILUX') return 'Hilux';
      if (upper === 'HIACE') return 'HiAce';
      if (upper === 'RAV') return 'RAV';
      return clean.charAt(0).toUpperCase() + clean.slice(1).toLowerCase();
    })
    .join(' ')
    .replace(/Yaris-\s*Cross/i, 'Yaris Cross');
}

function displayVehicle(vehicle) {
  const preferred = String(vehicle.vehicle || '').trim();
  const toyota = [vehicle.toyotaVehicle, vehicle.suffix].filter(Boolean).join(' ').trim();
  const raw = (!preferred || /\d\.\dL|\bDSL\b|\bHYB\b|\bCVT\b|\b6AT\b|\b10AT\b|\bWGN\b|\bFABRIC\b|\bGLACIER\b|\bFROSTED\b|\bGRAPHITE\b/i.test(preferred))
    ? (toyota || preferred)
    : preferred;
  return compactVehicleDescription(raw);
}

function compactVehicleDescription(rawValue) {
  let raw = String(rawValue || '').replace(/\s+/g, ' ').trim();
  if (!raw) return '';
  const upper = raw.toUpperCase();
  let model = '';
  if (/\bHI\s?LUX\b/.test(upper)) model = 'Hilux';
  else if (/\bLC300\b/.test(upper)) model = 'LC300';
  else if (/\bLC70\b/.test(upper)) model = 'LC70';
  else if (/\bPRADO\b/.test(upper)) model = 'Prado';
  else if (/\bRAV4\b/.test(upper)) model = 'RAV4';
  else if (/\bFORTUNER\b/.test(upper)) model = 'Fortuner';
  else if (/\bYARIS[- ]?CROSS\b/.test(upper)) model = 'Yaris Cross';
  else if (/\bYARIS\b/.test(upper)) model = 'Yaris';
  else if (/\bCOROLLA CROSS\b/.test(upper)) model = 'Corolla Cross';
  else if (/\bCOROLLA\b/.test(upper)) model = 'Corolla';
  else if (/\bCAMRY\b/.test(upper)) model = 'Camry';
  else if (/\bHIACE\b/.test(upper)) model = 'HiAce';
  else if (/\bCOASTER\b/.test(upper)) model = 'Coaster';
  else if (/\bTUNDRA\b/.test(upper)) model = 'Tundra';
  else if (/\bBZ4X\b/.test(upper)) model = 'bZ4X';

  const parts = model ? [model] : [];
  const bodyMatch = upper.match(/\b(E\/C\/C|D\/C\/C|S\/C\/C|E\/C|D\/C|S\/C|ECC|DCC|SCC|DUAL CAB|SINGLE CAB)\b/);
  if (bodyMatch) {
    const body = bodyMatch[1]
      .replace('E/C/C', 'ECC')
      .replace('D/C/C', 'DCC')
      .replace('S/C/C', 'SCC')
      .replace('E/C', 'EC')
      .replace('D/C', 'DC')
      .replace('S/C', 'SC')
      .replace('DUAL CAB', 'DCC')
      .replace('SINGLE CAB', 'SCC');
    if (!parts.includes(body)) parts.push(body);
  }

  const gradePatterns = [
    ['SAHARA ZX', 'Sahara ZX'], ['GR SPORT', 'GR Sport'], ['GR-SPORT', 'GR Sport'], ['GR-S', 'GR-S'],
    ['RUGGED X', 'Rugged X'], ['WORKMATE', 'WM'], ['ROGUE', 'Rogue'], ['CRUISER', 'Cruiser'],
    ['ALTITUDE', 'Altitude'], ['KAKADU', 'Kakadu'], ['ATMOS', 'Atmos'], ['ASCENT SPORT', 'Ascent Sport'],
    ['SAHARA', 'Sahara'], ['VX', 'VX'], ['GXL', 'GXL'], ['GX', 'GX'], ['SR5', 'SR5'], ['SR', 'SR'],
    ['XSE', 'XSE'], ['BASE', 'Base'], ['DELUXE', 'Deluxe'], ['LIMITED', 'Limited']
  ];
  const found = gradePatterns.find(([pattern]) => upper.includes(pattern));
  if (found && !parts.includes(found[1])) parts.push(found[1]);

  if (upper.includes('AWD') && ['RAV4', 'Yaris Cross', 'Corolla Cross'].includes(model) && !parts.includes('AWD')) parts.splice(1, 0, 'AWD');
  if (upper.includes('2WD') && ['RAV4', 'Yaris Cross', 'Corolla Cross'].includes(model) && !parts.includes('2WD')) parts.splice(1, 0, '2WD');
  if (upper.includes('PHEV') && !parts.includes('PHEV')) parts.splice(Math.min(parts.length, 2), 0, 'PHEV');

  return parts.length ? parts.join(' ') : titleCaseVehicle(raw);
}

function sortValue(vehicle, key) {
  switch (key) {
    case 'consultant': return salesPersonInitials(consultantName(vehicle));
    case 'stock': return vehicle.stock || '';
    case 'prodMth': return `${String(productionMonthRank(vehicle.prodMth || vehicle.productionMonth || '')).padStart(8, '0')} ${productionMonthLabel(vehicle.prodMth || vehicle.productionMonth || '')}`;
    case 'client': return vehicle.client || vehicle.toyotaCustomer || '';
    case 'vehicle': return displayVehicle(vehicle);
    case 'navisionNotes': return navisionDealerNoteText(vehicle);
    case 'internalStatus': return vehicle.internalStatus || '';
    case 'toyotaStatus': return `${String(toyotaStatusRank(vehicle.toyotaStatus)).padStart(4, '0')} ${vehicle.toyotaStatus || ''}`;
    case 'eta': return parseDateAU(vehicle.etaAtDealer)?.getTime() || 9999999999999;
    case 'jita': return vehicleNavisionJitaNumber(vehicle) ? 'Yes' : 'Unknown';
    case 'pdcRequiresTint': return vehicleFlag(vehicle, 'pdcRequiresTint') ? 'Yes' : 'No';
    case 'pdcRequiresHoist': return vehicleFlag(vehicle, 'pdcRequiresHoist') ? 'Yes' : 'No';
    case 'pdcRequiresFitting': return vehicleFlag(vehicle, 'pdcRequiresFitting') ? 'Yes' : 'No';
    case 'pdcRequiresFabrication': return vehicleFlag(vehicle, 'pdcRequiresFabrication') ? 'Yes' : 'No';
    case 'pdcRequiresElectrical': return vehicleFlag(vehicle, 'pdcRequiresElectrical') ? 'Yes' : 'No';
    case 'pdcRequiresTyre': return vehicleFlag(vehicle, 'pdcRequiresTyre') ? 'Yes' : 'No';

    case 'tintRaised': return legacyVehicleFlag(vehicle, 'tintRaised') ? 'Yes' : 'No';
    case 'buildPoRaised': return legacyVehicleFlag(vehicle, 'buildPoRaised') ? 'Yes' : 'No';
    case 'buildComplete': return legacyVehicleFlag(vehicle, 'buildComplete') ? 'Yes' : 'No';
    case 'trayOrdered': return legacyVehicleFlag(vehicle, 'trayOrdered') ? 'Yes' : 'No';
    case 'trayFitmentComplete': return legacyVehicleFlag(vehicle, 'trayFitmentComplete') ? 'Yes' : 'No';
    default: return '';
  }
}

function sortRows(rows) {
  const { key, dir } = app.sort || {};
  if (!key) return rows;
  const collator = new Intl.Collator('en-AU', { numeric: true, sensitivity: 'base' });
  const direction = dir === 'desc' ? -1 : 1;
  return rows.slice().sort((a, b) => {
    const av = sortValue(a, key);
    const bv = sortValue(b, key);
    const cmp = typeof av === 'number' && typeof bv === 'number'
      ? av - bv
      : collator.compare(String(av), String(bv));
    return cmp * direction;
  });
}

function setSort(key) {
  const current = app.sort || {};
  const defaultDir = key === 'prodMth' ? 'desc' : 'asc';
  app.sort = {
    key,
    dir: current.key === key ? (current.dir === 'asc' ? 'desc' : 'asc') : defaultDir,
  };
  renderVehicleTable();
}

function sortableTh(label, key) {
  const active = app.sort?.key === key;
  const arrow = active ? (app.sort.dir === 'asc' ? '▲' : '▼') : '';
  return `<button class="sort-header" type="button" data-sort-key="${escapeHtml(key)}">${escapeHtml(label)}<span class="sort-indicator">${arrow}</span></button>`;
}

function columnFilterSlot(key, options = [], selected = '', placeholder = 'All') {
  const opts = (options || []).map(option => typeof option === 'object'
    ? { value: String(option.value || ''), label: String(option.label || option.value || '') }
    : { value: String(option || ''), label: String(option || '') });
  const html = [`<option value="">${escapeHtml(placeholder)}</option>`]
    .concat(opts.map(option => `<option value="${escapeHtml(option.value)}"${option.value === selected ? ' selected' : ''}>${escapeHtml(option.label)}</option>`))
    .join('');
  return `<div class="column-filter-slot"><select class="column-filter-select" data-column-filter="${escapeHtml(key)}" aria-label="Filter ${escapeHtml(key)}">${html}</select></div>`;
}

function emptyColumnFilterSlot() {
  return '<div class="column-filter-slot column-filter-empty" aria-hidden="true"><span></span></div>';
}

function bindColumnFilterControls(root = document) {
  $$('[data-column-filter]', root).forEach(select => {
    select.addEventListener('click', event => event.stopPropagation());
    select.addEventListener('change', () => {
      const key = select.dataset.columnFilter;
      if (!key) return;
      app.columnFilters = app.columnFilters || { sales: '', production: '', status: '', jita: '' };
      app.columnFilters[key] = select.value;
      renderKpis();
      renderVehicleTable();
    });
  });
}

function toggleSidebar() {
  const shell = $('#app-shell');
  if (!shell) return;
  shell.classList.toggle('sidebar-collapsed');
  const collapsed = shell.classList.contains('sidebar-collapsed');
  const button = $('#sidebar-toggle');
  if (button) {
    button.setAttribute('aria-label', collapsed ? 'Expand sidebar' : 'Collapse sidebar');
    button.title = collapsed ? 'Expand sidebar' : 'Collapse sidebar';
  }
}

function updateNavisionSidebarMeta() {
  const importTimestamp = app.navisionImport?.appliedAt || app.navisionImport?.importedAt || '';
  const importedAt = importTimestamp ? new Date(importTimestamp) : null;
  const masterImport = window.VEHICLE_TRACKING_DATA?.report?.masterImport || null;
  const masterDate = masterImport?.importedAt ? parseDateAU(String(masterImport.importedAt).split('-').reverse().join('/')) : null;
  const dateLabel = importedAt && !Number.isNaN(importedAt.getTime())
    ? importedAt.toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : masterImport
      ? `Master EOS · ${masterDate && !Number.isNaN(masterDate.getTime()) ? masterDate.toLocaleDateString('en-AU') : masterImport.importedAt}`
      : 'No Navision import yet';
  const reportDate = $('#report-date');
  const reportMeta = $('#report-meta');
  const pdcCount = pdcSheetVehicles(app.data).length;
  const backEndOnlyCount = app.data.length - pdcCount;
  if (reportDate) reportDate.textContent = dateLabel;
  if (reportMeta) reportMeta.textContent = `${pdcCount} PDC sheet · ${backEndOnlyCount} back end only`;
}

function loadOperationalHealth() {
  return loadJson(OPERATIONAL_HEALTH_KEY, {});
}

function updateOperationalHealth(updates = {}) {
  const health = { ...loadOperationalHealth(), ...updates };
  try { saveJson(OPERATIONAL_HEALTH_KEY, health); }
  catch (error) { console.warn('Operational health metadata could not be saved.', error); }
  renderOperationalHealthSummary();
  return health;
}

function operationalHealthDateLabel(value = '') {
  const date = parseIsoTimestamp(value);
  return date ? date.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : 'Not recorded';
}

function operationalHealthAgeHours(value = '') {
  const date = parseIsoTimestamp(value);
  return date ? Math.max(0, (Date.now() - date.getTime()) / 3600000) : null;
}

function renderOperationalHealthSummary() {
  const host = $('#operational-health-summary');
  if (!host) return;
  const health = loadOperationalHealth();
  const navisionAt = health.lastNavisionImportAt || app.navisionImport?.appliedAt || app.navisionImport?.importedAt || '';
  const navisionAge = operationalHealthAgeHours(navisionAt);
  const navisionTone = navisionAge === null || navisionAge > 36 ? 'warn' : Number(health.lastNavisionWarnings || 0) > 0 ? 'watch' : 'ok';
  const backupAge = operationalHealthAgeHours(health.lastBackupAt);
  const backupTone = backupAge === null || backupAge > 168 ? 'warn' : 'ok';
  const navisionDetail = navisionAt
    ? `${operationalHealthDateLabel(navisionAt)}${health.lastNavisionRows ? ` · ${health.lastNavisionRows} rows` : ''}${health.lastNavisionWarnings ? ` · ${health.lastNavisionWarnings} warning${Number(health.lastNavisionWarnings) === 1 ? '' : 's'}` : ''}`
    : 'Not imported yet';
  const workLabel = cleanNavisionText(health.lastWorkImportType || '') || 'PD Document';
  const workDetail = health.lastWorkImportAt
    ? `${operationalHealthDateLabel(health.lastWorkImportAt)}${health.lastWorkImportRows ? ` · ${health.lastWorkImportRows} vehicle${Number(health.lastWorkImportRows) === 1 ? '' : 's'}` : ''}`
    : 'Not imported yet';
  host.innerHTML = `
    <span class="health-line ${navisionTone}" title="${escapeHtml(navisionDetail)}"><b>Navision</b><small>${escapeHtml(navisionDetail)}</small></span>
    <span class="health-line ${health.lastWorkImportAt ? 'ok' : 'neutral'}" title="${escapeHtml(workDetail)}"><b>${escapeHtml(workLabel)}</b><small>${escapeHtml(workDetail)}</small></span>
    <span class="health-line ${backupTone}"><b>Backup</b><small>${escapeHtml(health.lastBackupAt ? operationalHealthDateLabel(health.lastBackupAt) : 'Not exported yet')}</small></span>`;
}

function vehicleSourceText(vehicle = {}) {
  return cleanNavisionText(vehicle.source || vehicle.group || '').toLowerCase();
}

function vehicleHasManualOrPdcOrigin(vehicle = {}) {
  const source = vehicleSourceText(vehicle);
  const lifecycle = cleanNavisionText(vehicle.recordLifecycle || '').toLowerCase();
  return Boolean(
    /\bmanual\b|pd check-form|purchase order|po only|master2021|master sheet/.test(source) ||
    ['manual', 'purchase-order', 'pd-check-form', 'pdc'].includes(lifecycle)
  );
}

function vehicleHasPdcTrackingSignal(vehicle = {}) {
  if (vehicle.pdcSheetVisible === true) return true;
  if (vehiclePdcLocation(vehicle)) return true;
  if (normalizePmbStage(vehicle.pmbStage || vehicle.pdcWorkStage || vehicle.workStage || '')) return true;
  if (isPdcBlocked(vehicle) || vehicle.pdcPartsStoppage === true) return true;
  if ((vehicle.poTasks || []).length || (vehicle.poFiles || []).length || vehicle.buildPoRaised === true) return true;
  return PDC_JOB_DEFS.some(def => vehicle[def.requireKey] === true || vehicle[def.completeKey] === true);
}

function isVehicleVisibleOnPdcSheet(vehicle = {}) {
  if (vehicleHasManualOrPdcOrigin(vehicle) || vehicleHasPdcTrackingSignal(vehicle)) return true;
  if (vehicle.pdcSheetVisible === false) return false;
  const source = vehicleSourceText(vehicle);
  // Legacy tracker/master rows pre-date the visibility flag and must remain visible.
  return !/navision/.test(source);
}

function pdcSheetVehicles(rows = app.data) {
  return (Array.isArray(rows) ? rows : []).filter(isVehicleVisibleOnPdcSheet);
}

function isNavisionOnlyBackEndVehicle(vehicle = {}) {
  const source = vehicleSourceText(vehicle);
  return /navision/.test(source) && !vehicleHasManualOrPdcOrigin(vehicle) && !isVehicleVisibleOnPdcSheet(vehicle);
}

function promoteVehicleToPdcSheet(vehicle = {}, visibilitySource = 'Independent vehicle load') {
  const key = vehicleKey(vehicle);
  if (!key) return vehicle;
  const updates = {
    pdcSheetVisible: true,
    pdcVisibilitySource: cleanNavisionText(visibilitySource) || 'Independent vehicle load',
    pdcPromotedAt: vehicle.pdcPromotedAt || nowIsoString(),
  };
  Object.assign(vehicle, updates);
  const edits = loadVehicleEdits();
  edits[key] = { ...(edits[key] || {}), ...updates };
  saveJson(EDITS_KEY, edits);
  return vehicle;
}

function pdcVisibilityPromotionUpdates(vehicle = {}, visibilitySource = 'Independent PDC work') {
  return {
    pdcSheetVisible: true,
    pdcVisibilitySource: cleanNavisionText(visibilitySource) || 'Independent PDC work',
    pdcPromotedAt: vehicle.pdcPromotedAt || nowIsoString(),
  };
}

function vehicleWasIndependentlyPromoted(vehicle = {}) {
  if (vehicleHasManualOrPdcOrigin(vehicle)) return true;
  const source = cleanNavisionText(vehicle.pdcVisibilitySource || '').toLowerCase();
  return /manual|purchase order|pd check-form|work \/ job file|independent|operator|job card/.test(source);
}

function workshopCombinedPlannerRollbackEnabled() {
  const configured = window.PDC_SUPABASE_CONFIG?.workshop?.stationRoutes?.combinedPlannerRollback;
  return configured === true;
}

function workshopViewFromLocation() {
  let path = '';
  try {
    path = decodeURIComponent(String(window.location?.hash || '').replace(/^#\/?/, '').replace(/\/$/, ''));
  } catch (_error) {
    return 'dashboard';
  }
  if (!path) return 'dashboard';
  if (path === 'pipeline') return 'workflow';
  if (WORKSHOP_PLANNER_ROUTE_BY_PATH[path]) return WORKSHOP_PLANNER_ROUTE_BY_PATH[path];
  if (path === 'workshop') return workshopCombinedPlannerRollbackEnabled() ? 'workshop' : 'workflow';
  if (path.startsWith('workshop/')) return 'workflow';
  const candidate = path.replaceAll('/', '-');
  return document.getElementById(candidate) || document.querySelector(`[data-view="${candidate}"]`) ? candidate : 'dashboard';
}

function workshopLocationPathForView(view = '') {
  const category = window.PDC_WORKSHOP_DEPARTMENTS?.categoryForView?.(view);
  if (category) return category.path;
  const station = WORKSHOP_STATION_ROUTE_DEFS.find(def => def.view === view);
  return station ? station.path : (view === 'workshop' ? 'workshop' : String(view || 'dashboard'));
}

function updateWorkshopBrowserRoute(view = '', historyMode = 'push') {
  if (!window.history || historyMode === 'none') return;
  const hash = `#/${workshopLocationPathForView(view)}`;
  if (window.location.hash === hash && historyMode !== 'replace') return;
  const method = historyMode === 'replace' ? 'replaceState' : 'pushState';
  window.history[method]({ pdcView: view }, '', hash);
}

function init() {
  ensureAppDataAvailable();
  installFitterWorkshopRefreshBridge();
  migrateLegacyAutocareArrivalsToPmb();
  renderAppVersionMarker();
  renderHostingSecurityWarning();
  applyWorkflowWidthMode(loadWorkflowWidthMode());
  updateNavisionSidebarMeta();
  const visibleRows = pdcSheetVehicles();
  app.selectedStock = vehicleKey(visibleRows.find(v => v.toyotaStatus) || visibleRows[0] || app.data[0]);
  bindNav();
  populateFilters();
  showView(workshopViewFromLocation(), { historyMode: 'replace' });
  updateNavisionImportButton();
  loadVehicleLifecycleSharedActionsIfConfigured();
  loadWorkshopReferenceDataServiceIfConfigured();
  if (window.PDC_AUTH_CONTEXT) loadSharedNavisionVisibleRows();
  initServerAiIntakeIfAvailable();
}

// Loads workshop-reference-data-service.js (Stage 2A) lazily, mirroring
// the existing lazy-load pattern used for the other shared-data bridges.
// Unlike those, this one is NOT behind a feature flag -- it loads
// whenever window.PDC_SUPABASE_CONFIG exists at all, since mechanics/
// salespeople/sublet-providers/bays/workshop-configuration must be
// Supabase-authoritative immediately per the Stage 2A instruction. It
// still requires a real authenticated session before it reports anything
// other than a clear not-authenticated/offline state (see
// initWorkshopReferenceDataServiceIfAvailable() and
// getPdcSupabaseAccessToken()).
function loadWorkshopReferenceDataServiceIfConfigured() {
  if (!window.PDC_SUPABASE_CONFIG || typeof loadExternalScript !== 'function') return;
  loadExternalScript(`workshop-reference-data-service.js?bay-assignment=2026.09.17.01&r527=2026.10.25.r527&r549=2026.10.26.r549&v=${encodeURIComponent(APP_VERSION)}`, 'workshop-reference-data-service-script')
    .then(() => {
      initWorkshopReferenceDataServiceIfAvailable();
      if (typeof refreshWorkshopReferenceData === 'function') refreshWorkshopReferenceData();
    })
    .catch(() => { /* non-fatal: renderAdminLists()/loadMechanics() etc. report an explicit offline/error state instead of throwing */ });
}

// Loads vehicle-lifecycle-actions.js lazily (mirrors the workshop shared
// data service's own lazy-load pattern) and only initializes the bridge
// once loaded. No-op unless window.PDC_SUPABASE_CONFIG.vehicleLifecycle.
// sharedData is explicitly true, so pages without that config never fetch
// the extra script and legacy QC/RFT/Collected behaviour is unaffected.
function loadVehicleLifecycleSharedActionsIfConfigured() {
  if (typeof workshopSharedModeEnabled === 'function' && workshopSharedModeEnabled(window.PDC_SUPABASE_CONFIG)) {
    // Already being loaded by the workshop planner path; createWorkshopSupabaseClient
    // will already be available once that finishes, so just wait for it below.
  }
  if (!window.PDC_SUPABASE_CONFIG || !window.PDC_SUPABASE_CONFIG.vehicleLifecycle || window.PDC_SUPABASE_CONFIG.vehicleLifecycle.sharedData !== true) return;
  if (typeof loadExternalScript !== 'function') return;
  const lifecycleAssetVersion = window.PDC_SUPABASE_CONFIG.vehicleLifecycle.resolverAssetVersion || APP_VERSION;
  loadExternalScript(`vehicle-lifecycle-actions.js?v=${encodeURIComponent(lifecycleAssetVersion)}`, 'vehicle-lifecycle-actions-script')
    .then(() => {
      // createWorkshopSupabaseClient lives in workshop-data-service.js; load
      // it too if it is not already present (it may already be loaded by
      // the workshop planner path, in which case this is a fast no-op).
      if (typeof createWorkshopSupabaseClient === 'function') {
        initVehicleLifecycleSharedActionsIfEnabled();
        return;
      }
      loadExternalScript(`workshop-data-service.js?r424=2026.10.21.01&r417=2026.10.21.01&scope-reuse=2026.10.18.01&lock-recovery=2026.10.18.02&station-switch=2026.10.17.03&connection-speed=2026.10.17.01&planner-speed=2026.09.17.02&speed=2026.09.17.01&planner-reliability=2026.09.16.01&review-fixes=2026.09.13.01&v=${encodeURIComponent(APP_VERSION)}&bhavesh-followup=2026.09.23.01&search-drag=2026.10.19.04&hoist-corrections=2026.10.19.02&planner-followup=2026.10.19.01&r592=2026.10.28.r592`, 'workshop-data-service-script')
        .then(() => initVehicleLifecycleSharedActionsIfEnabled())
        .catch(() => { /* fail closed: configured shared lifecycle actions report service_unavailable */ });
    })
    .catch(() => { /* fail closed: configured shared lifecycle actions report service_unavailable */ });
}

function renderAppVersionMarker() {
  const host = $('#app-version');
  if (host) host.textContent = `Version ${APP_VERSION}`;
}

let incomingSearchRenderTimer = null;

function queueIncomingDashboardRender() {
  if (incomingSearchRenderTimer) clearTimeout(incomingSearchRenderTimer);
  incomingSearchRenderTimer = setTimeout(() => {
    incomingSearchRenderTimer = null;
    renderIncomingDashboardBoard();
  }, 160);
}

function setAdminNavigationExpanded(expanded) {
  const toggle = $('#nav-admin-toggle');
  const menu = $('#nav-admin-menu');
  if (!toggle || !menu) return;
  const next = Boolean(expanded);
  toggle.setAttribute('aria-expanded', String(next));
  menu.hidden = !next;
}

function syncAdminNavigationVisibility() {
  syncUserManagementAccess();
  window.PdcUpdateHistory?.syncAccess();
  window.PdcFittingStats?.syncAccess();
  window.PdcBayManager?.syncAccess();
  const group = $('#nav-admin-group');
  // The group also contains destinations historically available to approved
  // non-administrator staff. Every destination and write remains role/RLS
  // gated; hiding this disclosure is not an authority boundary.
  const allowed = Boolean(window.PDC_AUTH_CONTEXT?.userId || window.PDC_AUTH_CONTEXT?.email);
  if (group) group.hidden = !allowed;
  const deletedNav = document.querySelector('.nav-item[data-view="deleted"]');
  if (deletedNav) deletedNav.hidden = !vehicleLifecycleAdministratorActive();
  if (!allowed) setAdminNavigationExpanded(false);
  return allowed;
}

function resetDeletedVehicleAuthorityState() {
  app.deletedVehicleSnapshotGeneration += 1;
  app.deletedVehicleSnapshotRows = [];
  app.deletedVehicleSnapshotState = 'idle';
  app.deletedVehicleSnapshotError = '';
}

function bindNav() {
  $$('.nav-item[data-view]').forEach(btn => btn.addEventListener('click', () => {
    if (btn.dataset.view === 'planner-bus-4x4' || window.PDC_WORKSHOP_DEPARTMENTS?.categoryForView?.(btn.dataset.view)) {
      if (typeof workshopResetFocusedBooking === 'function') workshopResetFocusedBooking();
    }
    showView(btn.dataset.view);
  }));
  on($('#nav-admin-toggle'), 'click', () => {
    if (!syncAdminNavigationVisibility()) return;
    setAdminNavigationExpanded($('#nav-admin-toggle')?.getAttribute('aria-expanded') !== 'true');
  });
  syncAdminNavigationVisibility();
  pdcSyncWorkshopDepartmentNavigation();
  if (!window.__pdcWorkshopRouteListenersInstalled && typeof window.addEventListener === 'function') {
    const restoreRoute = () => showView(workshopViewFromLocation(), { historyMode: 'none' });
    window.addEventListener('popstate', restoreRoute);
    window.addEventListener('hashchange', restoreRoute);
    window.__pdcWorkshopRouteListenersInstalled = true;
  }
  on($('#operator-profile'), 'click', setOperatorProfile);
  on($('#tv-set-operator-top'), 'click', setOperatorProfile);
  $$('[data-view-target]').forEach(btn => btn.addEventListener('click', () => showView(btn.dataset.viewTarget)));
  on($('#search'), 'input', () => { renderKpis(); renderVehicleTable(); });

  on($('#status-filter'), 'change', () => { renderKpis(); renderVehicleTable(); });
  on($('#sales-filter'), 'change', () => { renderKpis(); renderVehicleTable(); });
  on($('#production-filter'), 'change', () => { renderKpis(); renderVehicleTable(); });
  on($('#source-filter'), 'change', () => { renderKpis(); renderVehicleTable(); });
  on($('#jita-filter'), 'change', () => { renderKpis(); renderVehicleTable(); });
  on($('#parts-search'), 'input', renderPartsHome);
  on($('#parts-status-filter'), 'change', renderPartsHome);
  on($('#parts-eta-filter'), 'change', renderPartsHome);
  on($('#parts-eta-sort'), 'change', renderPartsHome);
  on($('#parts-department-filter'), 'change', renderPartsHome);
  on($('#email-review-status-filter'), 'change', renderEmailIntakeReview);
  // Do not pass the click event as the explicit analysis clock.
  on($('#ai-board-refresh'), 'click', () => renderAiBoardAdvisor());
  on($('#ai-auditor-refresh'), 'click', () => loadPdcAuditorSnapshot({ force: true }));
  on($('#ai-auditor-severity-filter'), 'change', event => { app.pdcAuditorSeverityFilter = event.target.value || 'all'; renderPdcAuditor(); });
  on($('#ai-auditor-category-filter'), 'change', event => { app.pdcAuditorCategoryFilter = event.target.value || 'all'; renderPdcAuditor(); });
  on($('#ai-auditor-search'), 'input', event => { app.pdcAuditorSearch = String(event.target.value || ''); renderPdcAuditor(); });
  $$('[data-ai-auditor-report]').forEach(button => {
    button.addEventListener('click', () => selectPdcAuditorReport(button.dataset.aiAuditorReport));
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = $$('[data-ai-auditor-report]');
      const current = tabs.indexOf(button);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
        : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      selectPdcAuditorReport(tabs[next].dataset.aiAuditorReport);
    });
  });
  on($('#ai-intake-upload'), 'change', handleAiFileAssistantSelect);
  on($('#ai-auditor-document-drop-zone'), 'dragover', handleAiFileAssistantDragOver);
  on($('#ai-auditor-document-drop-zone'), 'dragleave', handleAiFileAssistantDragLeave);
  on($('#ai-auditor-document-drop-zone'), 'drop', handleAiFileAssistantDrop);
  on($('#ai-auditor-document-drop-zone'), 'keydown', handleAiFileAssistantDropZoneKeydown);
  on($('#ai-intake-analyze'), 'click', analyzeAiFileAssistantUploads);
  on($('#ai-intake-clear'), 'click', () => clearAiFileAssistantUploads());
  on($('#ai-intake-server-refresh'), 'click', () => refreshServerAiIntake());
  on($('#ai-intake-server-filter'), 'change', () => refreshServerAiIntake());
  on($('#sublet-search'), 'input', renderSubletHome);
  on($('#sublet-provider-filter'), 'change', renderSubletHome);
  on($('#sublet-sort-filter'), 'change', renderSubletHome);
  on($('#sublet-list-view'), 'click', () => selectSubletView('list'));
  on($('#sublet-calendar-view'), 'click', () => selectSubletView('calendar'));
  on($('#sublet-calendar-week'), 'click', () => selectSubletCalendarMode('week'));
  on($('#sublet-calendar-month'), 'click', () => selectSubletCalendarMode('month'));
  on($('#sublet-calendar-previous'), 'click', () => moveSubletCalendar(-1));
  on($('#sublet-calendar-today'), 'click', () => moveSubletCalendar(0));
  on($('#sublet-calendar-next'), 'click', () => moveSubletCalendar(1));
  bindSubletCreateDialog();
  on($('#schedule-search'), 'input', renderScheduleBoard);
  on($('#schedule-department-filter'), 'change', renderScheduleBoard);
  on($('#department-search'), 'input', renderProductionDepartmentBoard);
  on($('#department-status-filter'), 'change', renderProductionDepartmentBoard);
  on($('#parts-export-csv'), 'click', exportPartsCsv);
  on($('#rft-export-csv'), 'click', exportRftCsv);
  on($('#rft-search'), 'input', renderRftHome);
  on($('#rft-status-filter'), 'change', renderRftHome);
  on($('#completed-export-csv'), 'click', exportCompletedVehiclesCsv);
  on($('#completed-search'), 'input', renderCompletedVehicles);
  $$('[data-completed-scope-pick]').forEach(button => on(button, 'click', () => { app.completedScope756 = button.dataset.completedScopePick; if (app.completedScope756 !== 'completed') void loadArchivedVehicles756(true).then(renderCompletedVehicles); renderCompletedVehicles(); })); // r756a
  on($('#collected-search'), 'input', renderCollectedVehicles);
  on($('#deleted-export-csv'), 'click', exportDeletedVehiclesCsv);
  on($('#deleted-search'), 'input', renderDeletedVehicles);
  on($('#customer-search'), 'input', renderCustomers);
  on($('#clear-table-filters'), 'click', () => clearAllFilters());
  on($('#reset-table-columns'), 'click', resetVehicleTableColumnOrder);
  on($('#show-all-priority'), 'click', () => clearAllFilters());
  on($('#export-csv'), 'click', exportCsv);
  on($('#export-backup'), 'click', exportCrmBackup);
  on($('#export-backup-top'), 'click', exportCrmBackup);
  on($('#backup-upload'), 'change', handleCrmBackupFileSelect);
  configureCrmBackupAuthorityUi();
  on($('#email-selected-amy'), 'click', draftSelectedArrivingVehicleEmail);
  on($('#email-selected-amy-bar'), 'click', draftSelectedArrivingVehicleEmail);
  on($('#email-selected-update-bar'), 'click', () => draftSelectedVehicleStatusEmail());
  $$('[data-print-selected-zpl]').forEach(button => button.addEventListener('click', printZplFromSelectedRows));
  on($('#override-selected-to-yh-bar'), 'click', overrideSelectedVehiclesToYh);
  on($('#override-selected-to-yh-top'), 'click', overrideSelectedVehiclesToYh);
  on($('#transfer-selected-to-pmb-bar'), 'click', transferSelectedYhVehiclesToPmb);
  on($('#transfer-selected-to-pmb-top'), 'click', transferSelectedYhVehiclesToPmb);
  on($('#transfer-selected-to-rft-bar'), 'click', transferSelectedPmbVehiclesToRft);
  on($('#delete-selected-vehicles'), 'click', deleteSelectedVehicles);
  on($('#delete-selected-vehicles-bar'), 'click', deleteSelectedVehicles);
  on($('#clear-selected-rows'), 'click', clearSelectedRows);
  on($('#clear-selected-rows-bar'), 'click', clearSelectedRows);
  on($('#zpl-generate'), 'click', generateZplFromInput);
  on($('#zpl-copy'), 'click', copyZplOutput);
  on($('#zpl-print'), 'click', printCurrentZplOutput);
  on($('#zpl-clear'), 'click', clearZplGenerator);
  on($('#autocare-upload'), 'change', handleAutocareSelect);
  on($('#navision-upload'), 'change', handleNavisionFileSelect);
  on($('#navision-paste'), 'input', updateNavisionImportButton);
  on($('#navision-dealer-code'), 'change', updateNavisionImportButton);
  document.querySelectorAll('[data-navision-profile]').forEach(button=>on(button,'click',()=>{
    if(app.navisionPreviewInFlight||app.navisionSharedApplyInFlight)return;
    const profile=button.dataset.navisionProfile;
    if(!['broome','pilbara'].includes(profile))return;
    setNavisionUploadProfile(profile);
    updateNavisionImportButton();
  }));

  on($('#dashboard-navision-paste'), 'input', updateDashboardNavisionPasteButtons);
  on($('#dashboard-import-navision'), 'click', importDashboardNavisionPaste);
  on($('#dashboard-clear-navision'), 'click', clearDashboardNavisionPaste);
  on($('#dashboard-pd-paste'), 'input', updateDashboardPdImportButtons);
  on($('#dashboard-pd-upload'), 'change', handleDashboardPdFileSelect);
  on($('#dashboard-import-pd'), 'click', importDashboardPdWork);
  on($('#dashboard-clear-pd'), 'click', clearDashboardPdImport);
  on($('#incoming-search'), 'input', queueIncomingDashboardRender);
  bindVehicleLocationsRefreshClickDelegation();
  on($('#incoming-department-filter'), 'change', event => window.PDC_DEPARTMENT_FILTER?.setSelection(event.target.value));
  window.addEventListener('pdc-department-filter-changed', syncIncomingDepartmentFilter);
  const departmentSelect = $('#incoming-department-filter');
  if (departmentSelect) departmentSelect.value = incomingDepartmentFilterValue();
  on($('#incoming-status-filter'), 'change', renderIncomingDashboardBoard);
  on($('#incoming-bucket-filter'), 'change', renderIncomingDashboardBoard);
  on($('#incoming-rep-filter'), 'change', renderIncomingDashboardBoard);
  $$('input[name="incoming-work-filter"]').forEach(input => input.addEventListener('change', renderIncomingDashboardBoard));
  on($('#incoming-find'), 'click', renderIncomingDashboardBoard);
  on($('#incoming-clear-filters'), 'click', clearIncomingDashboardFilters);
  on($('#incoming-collapse-all'), 'click', toggleMainScreenRows);
  // r924 (F506): the Control Board has one Refresh (the shared operational refresh control in its toolbar row).
  on($('#rft-collapse-all'), 'click', toggleRftRows);
  on($('#completed-collapse-all'), 'click', toggleCompletedRows);
  on($('#deleted-collapse-all'), 'click', toggleDeletedRows);
  on($('#workflow-width-mode'), 'change', event => setWorkflowWidthMode(event.target.value));
  on($('#workflow-search'), 'input', event => { app.workflowSearch = String(event.target.value || '').trim().toLowerCase(); renderWorkflowBoard(); });
  on($('#workflow-find'), 'click', findControlBoardOverviewMatch);
  on($('#workflow-search'), 'keydown', event => { if (event.key === 'Enter') { event.preventDefault(); findControlBoardOverviewMatch(); } });
  on($('#workflow-clear-search'), 'click', clearWorkflowSearch);
  // r912 (F494): Key # box next to the Control Board search (exact key number; Enter or Find jumps to the job).
  on($('#workflow-key-search'), 'input', event => { app.workflowKeySearch = String(event.target.value || '').trim(); renderWorkflowBoard(); });
  on($('#workflow-key-search'), 'keydown', event => { if (event.key === 'Enter') { event.preventDefault(); findControlBoardOverviewMatch(); } });
  document.addEventListener('change', event => {
    const select = event.target?.closest?.('[data-workflow-header-filter]');
    if (!select) return;
    applyWorkflowHeaderFilter(select.dataset.workflowHeaderFilter, select.value, select.dataset.workflowWorkKey || '');
  });
  document.addEventListener('click', event => {
    const clear = event.target?.closest?.('[data-workflow-clear-column-filters]');
    if (!clear) return;
    event.preventDefault();
    event.stopPropagation();
    clearWorkflowFilters();
  });
  if (window.addEventListener) {
    window.addEventListener('scroll', scheduleWorkflowFloatingHeaderUpdate, { passive: true });
    window.addEventListener('resize', scheduleWorkflowFloatingHeaderUpdate, { passive: true });
  }
  document.addEventListener('scroll', scheduleWorkflowFloatingHeaderUpdate, true);
  on($('#incoming-transfer-selected-pmb'), 'click', transferSelectedMainYhVehiclesToPmb);
  on($('#incoming-email-selected-update'), 'click', () => draftSelectedVehicleStatusEmail());
  on($('#incoming-delete-selected'), 'click', deleteSelectedVehicles);
  on($('#incoming-clear-selected'), 'click', clearSelectedRows);
  on($('#workflow-transfer-selected-rft'), 'click', transferSelectedPmbVehiclesToRft);
  on($('#workflow-email-selected-update'), 'click', () => draftSelectedVehicleStatusEmail());
  on($('#workflow-delete-selected'), 'click', deleteSelectedVehicles);
  on($('#workflow-clear-selected'), 'click', clearSelectedRows);
  bindDashboardPdDropZone();

  on($('#import-navision'), 'click', importNavisionVehicles);
  on($('#apply-navision-shared'), 'click', applySharedNavisionImport);
  on($('#navision-clear'), 'click', clearNavisionImport);
  on($('#backend-data-search'), 'input', renderBackEndData);
  on($('#backend-data-state-filter'), 'change', renderBackEndData);
  on($('#backend-data-clear-search'), 'click', clearBackEndDataSearch);
  on($('#backend-data-refresh-shared'), 'click', () => loadSharedNavisionVisibleRows({ force: true }));
  on($('#add-mechanic-list-button'), 'click', addMechanicFromAdminInput);
  on($('#mechanic-name-input'), 'keydown', event => { if (event.key === 'Enter') { event.preventDefault(); addMechanicFromAdminInput(); } });
  on($('#add-sublet-provider-button'), 'click', addSubletProviderFromAdminInput);
  on($('#sublet-provider-name-input'), 'keydown', event => { if (event.key === 'Enter') { event.preventDefault(); addSubletProviderFromAdminInput(); } });
  on($('#add-salesperson-button'), 'click', addSalespersonFromAdminInput);
  on($('#backup-status-refresh'), 'click', renderBackupStatusPanel);
  on($('#user-management-refresh'), 'click', renderUserManagementScreen);
  $$('#user-management-tabs [data-um-tab]').forEach(button => on(button, 'click', () => {
    USER_MANAGEMENT_STATE.tab = button.dataset.umTab;
    $$('#user-management-tabs [data-um-tab]').forEach(other => other.classList.toggle('active', other === button));
    renderUserManagementScreen();
  }));
  on($('#user-management-role-filter'), 'change', event => {
    USER_MANAGEMENT_STATE.roleFilter = String(event.target?.value || 'all');
    const host = $('#user-management-content');
    if (host) renderUserManagementList(host); // display only: no reload, no server call
  });
  ['#salesperson-initials-input', '#salesperson-name-input', '#salesperson-email-input'].forEach(selector => {
    on($(selector), 'keydown', event => { if (event.key === 'Enter') { event.preventDefault(); addSalespersonFromAdminInput(); } });
  });
  on($('#scan-autocare'), 'click', scanAutocareNotice);
  on($('#autocare-clear'), 'click', clearAutocareResults);
  on($('#autocare-zpl-all'), 'click', () => printZplFromAutocareResults('all'));
  on($('#autocare-zpl-unmatched'), 'click', () => printZplFromAutocareResults('unmatched'));
  on($('#autocare-paste'), 'input', updateAutocareScanButton);
  on($('#pdf-upload'), 'change', handlePdfSelect);

  on($('#scan-report'), 'click', scanReport);
  on($('#approve-all'), 'click', approveCleanMatches);
  on($('#modal-close'), 'click', closeVehicleModal);
  on($('#vehicle-modal'), 'click', (e) => { if (e.target.id === 'vehicle-modal') closeVehicleModal(); });
  on($('#add-customer-open'), 'click', openCustomerModal);
  on($('#add-customer-top'), 'click', openCustomerModal);
  on($('#add-customer-customers'), 'click', openCustomerModal);
  on($('#customer-modal-close'), 'click', closeCustomerModal);
  on($('#customer-modal-cancel'), 'click', closeCustomerModal);
  on($('#customer-modal'), 'click', (e) => { if (e.target.id === 'customer-modal') closeCustomerModal(); });
  on($('#new-customer-form'), 'submit', addCustomerFromForm);
  document.addEventListener('keydown', (e) => {
    // Native dialogs own their focus and Escape key while above these popups.
    if (document.querySelector('dialog[open]')) return;
    const customerModal = $('#customer-modal');
    const vehicleModal = $('#vehicle-modal');
    const activeModal = customerModal?.hidden === false ? customerModal : vehicleModal?.hidden === false ? vehicleModal : null;
    if (e.key === 'Tab' && activeModal) {
      trapModalFocus(activeModal, e);
      return;
    }
    if (e.key !== 'Escape') return;
    if (customerModal?.hidden === false) closeCustomerModal();
    else if (vehicleModal?.hidden === false) closeVehicleModal();
  });
}


function workshopTechnicianAdminCanMutate(role = window.PDC_AUTH_CONTEXT?.role) {
  return String(role || '').trim().toLowerCase() === 'administrator';
}

function workshopReferenceMutationMessage(result, fallback) {
  const code = String(result?.error || '').trim();
  const detail = String(result?.detail?.message || result?.detail?.details || '').trim();
  if (code === 'duplicate_name') return 'That name is already on the list.';
  if (code === 'duplicate_code') return 'That mechanic code is already in use.';
  if (code === 'name_required') return 'Enter a mechanic name.';
  if (code === 'permission_denied') return 'Administrator access is required. No change was made.';
  if (code === 'technician_already_assigned_to_bay') return 'That mechanic is already the default for another bay.';
  if (code === 'version_conflict') return 'This shared record changed while you were editing it. It has been refreshed; retry your change.';
  if (detail) return `${fallback} (${detail})`;
  if (code && code !== 'request_failed') return `${fallback} (${code})`;
  return fallback;
}

async function addMechanicFromAdminInput() {
  const input = $('#mechanic-name-input');
  const entered = cleanNavisionText(input?.value || '');
  if (!entered) return false;
  // add_technician remains administrator-only at the RPC/RLS boundary. The UI
  // mirrors that existing authority instead of inviting an operator to submit
  // a request that the server must reject.
  if (!workshopTechnicianAdminCanMutate()) {
    pdcNotify('Administrator access is required to add mechanics. No request was sent.');
    return false;
  }
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) {
    pdcNotify('Cannot reach the shared mechanic list right now. Check your connection and try again.');
    return false;
  }
  try {
    const result = await service.addTechnician(entered);
    if (!result || result.ok !== true) {
      const fallback = 'Could not add mechanic. Check your connection and try again.';
      pdcNotify(result?.error === 'duplicate_name'
        ? `"${entered}" is already on the mechanic list.`
        : workshopReferenceMutationMessage(result, fallback));
      return false;
    }
    if (input) input.value = '';
    // mutate() already performs an authoritative reload; explicitly await a
    // final list refresh so this outer handler renders only confirmed rows.
    await service.listTechnicians(true);
    renderAdminLists();
    renderKpis();
    return true;
  } catch (_error) {
    pdcNotify('Could not add mechanic. Check your connection and try again.');
    return false;
  }
}

function removeMechanicFromAdminList(name = '') {
  const clean = cleanNavisionText(name);
  if (!clean) return;
  if (!workshopTechnicianAdminCanMutate()) {
    pdcNotify('Administrator access is required to remove mechanics. No request was sent.');
    return;
  }
  if (!window.confirm(`Remove mechanic "${clean}" from the dropdown list? Existing vehicle history will stay on the vehicle.`)) return;
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared mechanic list right now. Check your connection and try again.'); return; }
  const record = loadMechanicRecords(true).find(row => row.name === clean);
  if (!record) { pdcNotify(`"${clean}" was not found.`); return; }
  // Deactivate rather than delete -- preserves every historical
  // workshop_booking_assignments row that already points at this
  // technician_id, exactly as the Stage 2A requirement specifies.
  service.setTechnicianActive(record.id, record.version, false).then(result => {
    if (!result.ok) { pdcNotify(result.error || 'Could not remove mechanic.'); return; }
    renderAdminLists();
    renderKpis();
  }).catch(pdcAdminListRequestFailed('remove mechanic'));
}


function subletProviderEmailValid(email = '') {
  return !email || /^[^\s@<>;,]+@[^\s@<>;,]+\.[^\s@<>;,]+$/.test(email);
}

function subletProviderContact(vehicle = {}) {
  const records = loadSubletProviderRecords(true);
  const id = cleanNavisionText(vehicle.__subletProviderId || '');
  const name = pmbBaySubletProvider(vehicle);
  const matches = id ? records.filter(row => row.id === id) : records.filter(row => row.active && cleanNavisionText(row.name).toLowerCase() === name.toLowerCase());
  const record = matches.length === 1 ? matches[0] : null;
  return { name: cleanNavisionText(record?.name || name), email: cleanNavisionText(vehicle.pmbSubletProviderEmail || record?.email || '') };
}

function renderSubletProviderAdminList() {
  const host = $('#sublet-provider-list-admin');
  if (!host) return;
  const rows = loadSubletProviderRecords();
  const disabled = workshopTechnicianAdminCanMutate() ? '' : 'disabled';
  host.innerHTML = rows.length ? `<div class="admin-reference-table-wrap"><table class="admin-reference-table sublet-provider-admin-table"><thead><tr><th scope="col">Name</th><th scope="col">Email</th><th scope="col">Status</th><th scope="col">Actions</th></tr></thead><tbody>${rows.map(row => `<tr><td><strong>${escapeHtml(row.name)}</strong></td><td><input type="email" data-provider-email-input aria-label="Email for ${escapeHtml(row.name)}" value="${escapeHtml(row.email || '')}" placeholder="Email address" ${disabled}></td><td><span class="admin-status-badge is-active">Active</span></td><td class="admin-table-actions"><button type="button" class="text-button" data-save-provider-email="${escapeHtml(row.id)}" data-provider-version="${escapeHtml(String(row.version))}" ${disabled}>Save email</button><button type="button" class="text-button admin-action-danger" data-remove-provider="${escapeHtml(row.name)}" ${disabled}>Remove</button></td></tr>`).join('')}</tbody></table></div>` : '<div class="empty-state compact-empty"><strong>No providers yet</strong><span>Add a provider name and email above.</span></div>';
  $$('[data-save-provider-email]', host).forEach(button => on(button, 'click', () => saveSubletProviderEmail(button)));
}

async function saveSubletProviderEmail(button) {
  if (!workshopTechnicianAdminCanMutate()) return false;
  const input = button.closest('tr')?.querySelector('[data-provider-email-input]');
  const email = String(input?.value || '').trim();
  if (!subletProviderEmailValid(email) || (input && !input.reportValidity())) { pdcNotify('Enter a valid provider email address.'); return false; }
  const service = initWorkshopReferenceDataServiceIfAvailable();
  if (!service?.editSubletProvider) { pdcNotify('Cannot reach the shared provider list. No change was saved.'); return false; }
  button.disabled = true;
  try {
    const result = await service.editSubletProvider(button.dataset.saveProviderEmail, Number(button.dataset.providerVersion), { email });
    if (!result?.ok) { pdcNotify(result?.error === 'version_conflict' ? 'This provider changed in another session. Refresh the list and retry.' : 'Could not save the provider email.'); return false; }
    renderAdminLists();
    return true;
  } catch (_) { pdcNotify('Could not save the provider email. Check your connection and retry.'); return false; }
  finally { button.disabled = false; }
}

function fillSubletCreateProviderEmail() {
  const id = $('#sublet-create-provider')?.value || '';
  const matches = loadSubletProviderRecords().filter(row => row.id === id);
  const input = $('#sublet-create-provider-email');
  if (input) input.value = matches.length === 1 ? (matches[0].email || '') : '';
}

function addSubletProviderFromAdminInput() {
  const input = $('#sublet-provider-name-input');
  const entered = cleanNavisionText(input?.value || '');
  if (!entered) return;
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared provider list right now. Check your connection and try again.'); return; }
  const emailInput = $('#sublet-provider-email-input');
  const email = String(emailInput?.value || '').trim();
  if (!subletProviderEmailValid(email) || (emailInput && !emailInput.reportValidity())) { pdcNotify('Enter a valid provider email address.'); return; }
  service.addSubletProvider(entered, email).then(result => {
    if (!result.ok) {
      pdcNotify(result.error === 'duplicate_name' ? `"${entered}" is already on the provider list.` : (result.error || 'Could not add provider.'));
      return;
    }
    if (input) input.value = '';
    if (emailInput) emailInput.value = '';
    renderAdminLists();
    renderKpis();
  }).catch(pdcAdminListRequestFailed('add provider'));
}

function removeSubletProviderFromAdminList(name = '') {
  const clean = cleanNavisionText(name);
  if (!clean) return;
  if (!window.confirm(`Remove provider "${clean}" from the dropdown list? Existing vehicle history will stay on the vehicle.`)) return;
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared provider list right now. Check your connection and try again.'); return; }
  const record = loadSubletProviderRecords(true).find(row => row.name === clean);
  if (!record) { pdcNotify(`"${clean}" was not found.`); return; }
  service.setSubletProviderActive(record.id, record.version, false).then(result => {
    if (!result.ok) { pdcNotify(result.error || 'Could not remove provider.'); return; }
    renderAdminLists();
    renderKpis();
  }).catch(pdcAdminListRequestFailed('remove provider'));
}

function renderHostingSecurityWarning() {
  const host = $('#hosting-security-warning');
  if (!host) return;
  const publicStaticHost = /(^|\.)github\.io$/i.test(String(window.location?.hostname || ''));
  const bundledVehicleCount = Array.isArray(window.VEHICLE_TRACKING_DATA?.vehicles) ? window.VEHICLE_TRACKING_DATA.vehicles.length : 0;
  host.hidden = !(publicStaticHost && bundledVehicleCount > 0);
}

function addSalespersonFromAdminInput() {
  const initialsInput = $('#salesperson-initials-input');
  const nameInput = $('#salesperson-name-input');
  const emailInput = $('#salesperson-email-input');
  const record = normalizeSalespersonRecord({ initials: initialsInput?.value, name: nameInput?.value, email: emailInput?.value });
  if (!record) {
    pdcNotify('Enter salesperson initials, name and a valid email address.');
    return;
  }
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared salesperson list right now. Check your connection and try again.'); return; }
  const finish = () => {
    if (initialsInput) initialsInput.value = '';
    if (nameInput) nameInput.value = '';
    if (emailInput) emailInput.value = '';
    renderAdminLists();
    renderDetail();
  };
  const existing = loadSalespersonRecords(true).find(row => (row.code || '').toUpperCase() === record.initials);
  const request = existing
    ? service.editSalesperson(existing.id, existing.version, { name: record.name, email: record.email, code: record.initials })
    : service.addSalesperson(record.name, record.email, record.initials);
  request.then(result => {
    if (!result.ok) {
      pdcNotify(result.error === 'duplicate_code' ? `Salesperson code "${record.initials}" is already in use.` : (result.error || 'Could not save salesperson.'));
      return;
    }
    finish();
  }).catch(pdcAdminListRequestFailed('save salesperson'));
}

function removeSalespersonFromAdminList(initials = '') {
  const clean = cleanNavisionText(initials).toUpperCase();
  const record = loadSalespersonRecords(true).find(row => (row.code || '').toUpperCase() === clean);
  if (!record) return;
  if (!window.confirm(`Remove ${record.code} - ${record.name} from the salesperson dropdown? Existing vehicles keep their saved initials.`)) return;
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared salesperson list right now. Check your connection and try again.'); return; }
  service.setSalespersonActive(record.id, record.version, false).then(result => {
    if (!result.ok) { pdcNotify(result.error || 'Could not remove salesperson.'); return; }
    renderAdminLists();
  }).catch(pdcAdminListRequestFailed('remove salesperson'));
}

function renderAdminList(host, items, removeAttr, emptyText, options = {}) {
  if (!host) return;
  if (!items.length) {
    host.innerHTML = `<div class="empty-state compact-empty"><strong>No entries yet</strong><span>${escapeHtml(emptyText)}</span></div>`;
    return;
  }
  const disabled = options.canMutate === false ? 'disabled title="Administrator access is required"' : '';
  host.innerHTML = `<div class="admin-reference-table-wrap"><table class="admin-reference-table">
    <thead><tr><th>Name</th><th>Status</th><th>Actions</th></tr></thead>
    <tbody>${items.map(item => `<tr><td><strong>${escapeHtml(item)}</strong></td><td><span class="admin-status-badge is-active">Active</span></td><td class="admin-table-actions"><button type="button" class="text-button admin-action-danger" ${removeAttr}="${escapeHtml(item)}" ${disabled}>Remove</button></td></tr>`).join('')}</tbody>
  </table></div>`;
}

function renderAdminLists(options = {}) {
  const canManageTechnicians = workshopTechnicianAdminCanMutate();
  const mechanicInput = $('#mechanic-name-input');
  const mechanicButton = $('#add-mechanic-list-button');
  [mechanicInput, mechanicButton].filter(Boolean).forEach(control => {
    control.disabled = !canManageTechnicians;
    control.title = canManageTechnicians ? '' : 'Administrator access is required to manage mechanics.';
  });
  renderAdminList($('#mechanic-list-admin'), loadMechanics(), 'data-remove-mechanic', canManageTechnicians
    ? 'Add mechanics so they appear in the bay assignment dropdowns.'
    : 'The shared mechanic roster is read-only for this account. An administrator can add or remove mechanics.', { canMutate: canManageTechnicians });
  renderSubletProviderAdminList();
  const salesHost = $('#salesperson-list-admin');
  if (salesHost) {
    const salespersons = loadSalespersons();
    salesHost.innerHTML = salespersons.length
      ? `<div class="admin-reference-table-wrap"><table class="admin-reference-table salesperson-admin-table" aria-label="Salespersons"><thead><tr><th scope="col">Initials</th><th scope="col">Name</th><th scope="col">Email</th><th scope="col">Actions</th></tr></thead><tbody>${salespersons.map(record => `<tr><td>${escapeHtml(record.initials)}</td><td><strong>${escapeHtml(record.name)}</strong></td><td>${escapeHtml(record.email)}</td><td class="admin-table-actions"><button type="button" class="text-button admin-action-danger" data-remove-salesperson="${escapeHtml(record.initials)}">Remove</button></td></tr>`).join('')}</tbody></table></div>`
      : '<div class="empty-state compact-empty"><strong>No salespersons yet</strong><span>Add initials, name and email to populate vehicle dropdowns.</span></div>';
  }
  $$('[data-remove-mechanic]').forEach(button => button.addEventListener('click', () => removeMechanicFromAdminList(button.dataset.removeMechanic)));
  $$('[data-remove-provider]').forEach(button => button.addEventListener('click', () => removeSubletProviderFromAdminList(button.dataset.removeProvider)));
  $$('[data-remove-salesperson]').forEach(button => button.addEventListener('click', () => removeSalespersonFromAdminList(button.dataset.removeSalesperson)));
  // Reference-only updates still hide history immediately when authority changes.
  // A normal re-render does not ask again while a fresh result is on screen.
  if (options.refreshBackup === false) {
    if (!backupStatusSharedModeReady()) renderBackupStatusPanel();
  } else {
    requestBackupStatus();
  }
}

// Admin-visible backup status widget (Setup screen). Reads only from
// backup_runs / restore_test_runs, both RLS-gated to administrator role
// at the database layer -- a viewer/controller loading this same page
// simply gets zero rows back (see migration 017), so this frontend
// visibility check is a convenience, not the security boundary.
function backupStatusSharedModeReady() {
  return typeof window !== 'undefined'
    && typeof workshopSharedModeEnabled === 'function'
    && workshopSharedModeEnabled(window.PDC_SUPABASE_CONFIG)
    && !!window.PDC_SUPABASE
    && typeof window.PDC_SUPABASE.from === 'function'
    && window.PDC_AUTH_CONTEXT
    && window.PDC_AUTH_CONTEXT.role === 'administrator';
}

function formatBackupBytes(bytes) {
  if (bytes == null) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = Number(bytes);
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}

function formatBackupStatusDate(value) {
  const date = new Date(value || '');
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('en-AU', {
    day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

const BACKUP_SUCCESS_WARNING_MS = 6 * 60 * 60 * 1000;
const BACKUP_RUNNING_WARNING_MS = 3 * 60 * 60 * 1000;
const BACKUP_STATUS_POLL_MS = 15 * 60 * 1000;

function backupHistoryHealth(runs, lastSuccess, now = Date.now()) {
  const warnings = [];
  const lastTime = Date.parse(lastSuccess && (lastSuccess.finished_at || lastSuccess.started_at));
  if (!Number.isFinite(lastTime)) warnings.push('No successful backup is recorded.');
  else if (now - lastTime > BACKUP_SUCCESS_WARNING_MS) warnings.push('No successful backup has been recorded in the past six hours.');
  const unfinished = (runs || []).filter(run => run.status === 'running' && now - Date.parse(run.started_at) > BACKUP_RUNNING_WARNING_MS);
  if (unfinished.length) warnings.push(`${unfinished.length} older backup attempt(s) have no recorded completion.`);
  if (lastSuccess && !lastSuccess.file_path) warnings.push('The latest successful record has no backup file location.');
  return warnings;
}

async function renderBackupStatusPanel() {
  const panel = $('#backup-status-panel');
  const host = $('#backup-status-content');
  if (!panel || !host) return;

  if (!backupStatusSharedModeReady()) {
    panel.hidden = true;
    return;
  }
  if (typeof app !== 'undefined' && app) app.backupStatusLoadedAt = Date.now();
  panel.hidden = false;
  host.innerHTML = '<div class="empty-state compact-empty"><strong>Loading backup status…</strong></div>';

  try {
    const client = window.PDC_SUPABASE;
    if (!client || typeof client.from !== 'function') {
      throw new Error('Supabase client is not ready yet');
    }
    const environment = (window.PDC_SUPABASE_CONFIG && window.PDC_SUPABASE_CONFIG.projectRef === PRODUCTION_SUPABASE_PROJECT_REF) ? 'production' : 'staging';

    const { data: runs, error: runsError } = await client
      .from('backup_runs')
      .select('id,status,started_at,finished_at,file_size_bytes,file_path,error_message,kind,triggered_by')
      .eq('environment', environment)
      .order('started_at', { ascending: false })
      .limit(20);
    if (runsError) throw runsError;

    const { data: restoreTests, error: restoreError } = await client
      .from('restore_test_runs')
      .select('id,status,started_at,finished_at,row_count_matches,target_schema')
      .eq('environment', environment)
      .order('started_at', { ascending: false })
      .limit(1);
    if (restoreError) throw restoreError;

    // A long series of failures must not hide the last successful export.
    const { data: successes, error: successError } = await client
      .from('backup_runs')
      .select('id,status,started_at,finished_at,file_size_bytes,file_path,encrypted,kind')
      .eq('environment', environment)
      .eq('status', 'success')
      .order('started_at', { ascending: false })
      .limit(1);
    if (successError) throw successError;
    const lastSuccess = (successes || [])[0];
    let consecutiveFailures = 0;
    for (const run of (runs || [])) {
      if (run.status === 'failed') consecutiveFailures += 1;
      else if (run.status === 'success') break;
    }
    const recentFailures = (runs || []).filter(run => run.status === 'failed').slice(0, 5);
    const lastRestoreTest = (restoreTests || [])[0];

    const warnings = backupHistoryHealth(runs, lastSuccess);
    if (consecutiveFailures >= 3) warnings.push(`${consecutiveFailures} consecutive backup failures need investigation.`);
    const restoreLabel = !lastRestoreTest ? 'Never run'
      : lastRestoreTest.status === 'running' ? 'No completed result yet'
      : lastRestoreTest.status === 'success' && lastRestoreTest.row_count_matches === true ? 'Passed' : 'FAILED';
    const alertBanner = warnings.length
      ? `<div class="hosting-security-warning" role="alert"><strong>Backup attention needed</strong><span>${escapeHtml(warnings.join(' '))}</span></div>`
      : '';

    host.innerHTML = `
      ${alertBanner}
      <div class="visibility-grid backup-status-grid">
        <div class="visibility-card"><span class="muted-label">Environment</span><strong>${escapeHtml(environment)}</strong></div>
        <div class="visibility-card"><span class="muted-label">Last recorded success</span><strong>${lastSuccess ? formatBackupStatusDate(lastSuccess.finished_at || lastSuccess.started_at) : 'Never'}</strong></div>
        <div class="visibility-card"><span class="muted-label">Automatic schedule</span><strong>Not verified</strong></div>
        <div class="visibility-card"><span class="muted-label">Last size</span><strong>${lastSuccess ? formatBackupBytes(lastSuccess.file_size_bytes) : '—'}</strong></div>
        <div class="visibility-card"><span class="muted-label">Last backup type</span><strong>${lastSuccess ? escapeHtml(lastSuccess.kind || 'Not recorded') : '—'}</strong></div>
        <div class="visibility-card"><span class="muted-label">Restore test</span><strong>${lastRestoreTest ? `${formatBackupStatusDate(lastRestoreTest.started_at)} · ${restoreLabel}` : restoreLabel}</strong></div>
        <div class="visibility-card"><span class="muted-label">Failures</span><strong>${consecutiveFailures} consecutive</strong></div>
        <div class="visibility-card"><span class="muted-label">Retention</span><strong>Not verified</strong></div>
      </div>
      <div class="parts-help-strip"><strong>Backup coverage:</strong><span>This panel shows recorded exports. The schedule, stored files and full-database coverage need independent verification. Refresh reloads the history; it does not start a backup. Supabase-managed backups are checked separately in Supabase.</span></div>
      ${recentFailures.length ? `<div class="parts-help-strip"><strong>Recent failure detail:</strong><span>${recentFailures.map(run => `${escapeHtml(new Date(run.started_at).toLocaleString())} — ${escapeHtml(run.error_message || 'unknown error')}`).join(' · ')}</span></div>` : ''}
    `;
  } catch (error) {
    if (typeof app !== 'undefined' && app) app.backupStatusLoadedAt = 0;
    host.innerHTML = `<div class="empty-state compact-empty"><strong>Could not load backup status</strong><span>${escapeHtml(error && error.message ? error.message : String(error))}</span></div>`;
  }
}

function backupStatusPageVisible() {
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return false;
  return typeof app !== 'undefined' && app.currentView === 'lists';
}

function requestBackupStatus() {
  ensureBackupStatusPoll();
  if (!backupStatusSharedModeReady()) {
    renderBackupStatusPanel();
    return;
  }
  if (!backupStatusPageVisible()) return;
  const loadedAt = app.backupStatusLoadedAt || 0;
  if (loadedAt && Date.now() - loadedAt < BACKUP_STATUS_POLL_MS) return;
  return renderBackupStatusPanel();
}

function ensureBackupStatusPoll() {
  if (typeof app === 'undefined' || !app || app.backupStatusPollBound) return;
  const timer = typeof window !== 'undefined' ? window.setInterval : undefined;
  const listen = typeof document !== 'undefined' && typeof document.addEventListener === 'function';
  if (typeof timer !== 'function' && !listen) return;
  app.backupStatusPollBound = true;
  if (typeof timer === 'function') timer(() => requestBackupStatus(), BACKUP_STATUS_POLL_MS);
  if (listen) document.addEventListener('visibilitychange', () => requestBackupStatus());
}

// ---------------------------------------------------------------------
// Administrator-only User Management screen. Reads directly from
// pdc_user_roles (RLS lets an administrator see every row; anyone else
// sees only their own row at the database layer -- see migration 018),
// and every action button below calls the corresponding protected RPC
// (admin_approve_user / admin_reject_registration / admin_change_role /
// admin_disable_user / admin_restore_user), each of which independently
// re-verifies the caller is an active administrator server-side. This
// frontend code is a convenience UI, not the security boundary.
// ---------------------------------------------------------------------
const USER_MANAGEMENT_STATE = { tab: 'all', rows: [], realtimeChannel: null, generation: 0, showDisabled: false, roleFilter: 'all', stationAssignments: new Map() };

// r557 (F171): workshop stations a person can acknowledge on New to PMB. An administrator
// assigns these in User Management, the same way a salesperson record is linked. A user
// may have several. Parts and Pit are not stations. Department 135 is not one of these.
const PMB_ACK_STATIONS = Object.freeze([
  ['BUS_4X4', 'Bus 4x4'],
  ['TINT', 'Tint'],
  ['HOIST', 'Hoist'],
  ['FITTING', 'Fitting'],
  ['FABRICATION', 'Fabrication'],
  ['ELECTRICAL', 'Electrical'],
  ['TYRE', 'Tyre'],
  ['SUBLET', 'Sublet'],
]);

// r430: the All list hides Disabled accounts unless "Show disabled (N)" is on (display only; no account row is changed).
// The Disabled tab still lists them; Pending, Approved and Rejected are unchanged.
function userManagementRowStatus(row) {
  return String(row?.account_status || (row?.active ? 'approved' : 'disabled')).toLowerCase();
}

function userManagementVisibleRows(rows, tab, showDisabled) {
  const list = Array.isArray(rows) ? rows : [];
  if (tab !== 'all') return { rows: list.filter(row => row.account_status === tab), disabledCount: 0, hiddenDisabled: 0 };
  const disabledCount = list.filter(row => userManagementRowStatus(row) === 'disabled').length;
  const visible = showDisabled ? list : list.filter(row => userManagementRowStatus(row) !== 'disabled');
  return { rows: visible, disabledCount, hiddenDisabled: showDisabled ? 0 : disabledCount };
}

function userManagementDisabledToggleHtml(view, showDisabled) {
  if (!view.disabledCount) return '';
  const label = showDisabled ? `Hide disabled (${view.disabledCount})` : `Show disabled (${view.disabledCount})`;
  return `<div class="um-disabled-toggle-row" style="margin:0 0 8px"><button type="button" class="small-button text-button" data-um-toggle-disabled aria-pressed="${showDisabled ? 'true' : 'false'}">${label}</button></div>`;
}

function userManagementAdministratorActive() {
  return window.PDC_AUTH_CONTEXT?.role === 'administrator';
}

function resetUserManagementAuthorityState() {
  USER_MANAGEMENT_STATE.generation += 1;
  USER_MANAGEMENT_STATE.rows = [];
  USER_MANAGEMENT_STATE.roleFilter = 'all';
  const channel = USER_MANAGEMENT_STATE.realtimeChannel;
  USER_MANAGEMENT_STATE.realtimeChannel = null;
  if (channel) {
    try { window.PDC_SUPABASE?.removeChannel?.(channel); } catch (_error) { /* best-effort teardown */ }
  }
  const roleFilter = document.getElementById('user-management-role-filter');
  if (roleFilter) roleFilter.innerHTML = '<option value="all" selected>All roles</option>';
  document.getElementById('user-management-content')?.replaceChildren();
}

function syncUserManagementAccess() {
  const allowed = userManagementAdministratorActive();
  const navItem = document.getElementById('nav-user-management');
  const view = document.getElementById('user-management');
  if (navItem) navItem.hidden = !allowed;
  if (view) view.hidden = !allowed;
  if (!allowed) resetUserManagementAuthorityState();
  return allowed;
}

function userManagementSharedModeReady() {
  return backupStatusSharedModeReady(); // same gating: shared mode + signed-in administrator
}

async function loadUserManagementRows() {
  if (!userManagementSharedModeReady()) return [];
  const client = window.PDC_SUPABASE;
  const { data, error } = await client
    .from('pdc_user_roles')
    .select('id,email,full_name,display_name,role,active,account_status,registered_at,approved_by,approved_at,rejected_at,rejection_reason,disabled_at,disabled_reason,restored_at,last_sign_in_at,created_at')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

// r419 (F34): every role the server accepts is offered, the current role is always the selected option (an unknown role is
// shown as itself, never silently replaced by the first option), and every role change asks for confirmation first.
const USER_MANAGEMENT_ROLE_OPTIONS = [
  ['viewer', 'viewer'],
  ['operator', 'controller'],
  ['importer', 'importer'],
  ['administrator', 'administrator'],
  ['fitter', 'fitter'],
  ['salesperson', 'salesperson'],
];

function userManagementRoleLabel(role) {
  const match = USER_MANAGEMENT_ROLE_OPTIONS.find(([value]) => value === role);
  return match ? match[1] : (role || '—');
}

function userManagementRoleOptionsHtml(selectedRole) {
  const known = USER_MANAGEMENT_ROLE_OPTIONS.some(([value]) => value === selectedRole);
  const options = USER_MANAGEMENT_ROLE_OPTIONS.map(([value, label]) =>
    `<option value="${value}"${value === selectedRole ? ' selected' : ''}>${label}</option>`);
  if (selectedRole && !known) {
    options.unshift(`<option value="${escapeHtml(selectedRole)}" selected>${escapeHtml(selectedRole)}</option>`);
  }
  return options.join('');
}

// r510 (F123): Role dropdown on User Administration. Options are the distinct roles in the
// loaded list (known-role order, then any other role). Filtering stays on the rows already
// shown: the status tab, and on All the Show disabled toggle. Display only; no server call.
function userManagementRoleFilterLabel(role) {
  const label = userManagementRoleLabel(role);
  if (!label || label === '—') return '—';
  return label.charAt(0).toUpperCase() + label.slice(1);
}

function userManagementDistinctRoles(rows) {
  const seen = new Set();
  const roles = [];
  for (const row of Array.isArray(rows) ? rows : []) {
    const role = String(row?.role || '').trim();
    if (!role || seen.has(role)) continue;
    seen.add(role);
    roles.push(role);
  }
  const order = new Map(USER_MANAGEMENT_ROLE_OPTIONS.map(([value], index) => [value, index]));
  roles.sort((left, right) => {
    const leftOrder = order.has(left) ? order.get(left) : 1000;
    const rightOrder = order.has(right) ? order.get(right) : 1000;
    if (leftOrder !== rightOrder) return leftOrder - rightOrder;
    return userManagementRoleFilterLabel(left).localeCompare(userManagementRoleFilterLabel(right));
  });
  return roles;
}

function userManagementApplyRoleFilter(rows, roleFilter) {
  const list = Array.isArray(rows) ? rows : [];
  const role = String(roleFilter || 'all');
  if (role === 'all') return list;
  return list.filter(row => String(row?.role || '').trim() === role);
}

function userManagementRoleFilterOptionsHtml(rows, selected) {
  const current = String(selected || 'all');
  const roles = userManagementDistinctRoles(rows);
  const option = (value, label, isSelected) =>
    `<option value="${escapeHtml(value)}"${isSelected ? ' selected' : ''}>${escapeHtml(label)}</option>`;
  const html = [option('all', 'All roles', current === 'all')];
  for (const role of roles) html.push(option(role, userManagementRoleFilterLabel(role), role === current));
  if (current !== 'all' && !roles.includes(current)) html.push(option(current, userManagementRoleFilterLabel(current), true));
  return html.join('');
}

function syncUserManagementRoleFilter(rows, selected) {
  const select = document.getElementById('user-management-role-filter');
  if (!select) return;
  select.innerHTML = userManagementRoleFilterOptionsHtml(rows, selected);
}

function userManagementRoleFilterHiddenHint(role) {
  if (!role || role === 'all') return '';
  if (USER_MANAGEMENT_STATE.tab !== 'all' || USER_MANAGEMENT_STATE.showDisabled) return '';
  const hidden = (Array.isArray(USER_MANAGEMENT_STATE.rows) ? USER_MANAGEMENT_STATE.rows : []).filter(row =>
    userManagementRowStatus(row) === 'disabled' && String(row?.role || '').trim() === role).length;
  if (!hidden) return '';
  const label = userManagementRoleFilterLabel(role);
  const noun = hidden === 1 ? 'account stays' : 'accounts stay';
  return `<span>${hidden} disabled ${escapeHtml(label)} ${noun} hidden until Show disabled is on.</span>`;
}

function userManagementRowActionsHtml(row) {
  const email = escapeHtml(row.email);
  if (row.account_status === 'pending') {
    return `
      <select class="um-role-select" data-um-role-for="${email}">
        ${userManagementRoleOptionsHtml('viewer')}
      </select>
      <button class="small-button primary" data-um-approve="${email}">Approve</button>
      <button class="small-button text-button" data-um-reject="${email}">Reject</button>
    `;
  }
  if (row.account_status === 'approved') {
    return `
      <select class="um-role-select" data-um-role-for="${email}" data-um-current-role="${escapeHtml(row.role || '')}">
        ${userManagementRoleOptionsHtml(row.role || '')}
      </select>
      <button class="small-button" data-um-change-role="${email}">Change role</button>
      ${row.role === 'operator' ? `<button class="small-button text-button" data-um-link-sales="${email}" title="Let this controller also use the Sales site as their salesperson record (matched by email)">Link salesperson record</button>` : ''}
      <button class="small-button text-button" data-um-disable="${email}">Disable</button>
    `;
  }
  if (row.account_status === 'disabled') {
    return `<button class="small-button primary" data-um-restore="${email}">Restore</button>`;
  }
  return '<span class="muted-label">No actions</span>';
}

// Returns true only when the administrator confirms a real change of role.
function userManagementConfirmRoleChange(email, currentRole, newRole) {
  if (!newRole) return false;
  if (newRole === currentRole) {
    pdcNotify(`${email} is already ${userManagementRoleLabel(newRole)}. Nothing changed.`, 'info');
    return false;
  }
  let message = `Change ${email} from ${userManagementRoleLabel(currentRole)} to ${userManagementRoleLabel(newRole)}?`;
  if (currentRole === 'administrator') message += '\n\nThey will lose administrator access (User Admin, vehicle delete/restore, all Sales).';
  if (newRole === 'administrator') message += '\n\nThey will get full administrator access, including User Admin.';
  // r429 (F41): the server links the Sales site record (salespeople row with the same email) in the same change.
  if (newRole === 'salesperson') message += '\n\nTheir Sales site access is linked to the salesperson record with the same email. If there is no such record the change is refused; add them to the salespeople list first.';
  return window.confirm(message) === true;
}

// r432 (F43): a controller can also use the Sales site as their own salesperson record. The server matches the active
// salespeople row with the same email (refuses none or more than one), keeps the controller role and writes an audit row.
function userManagementConfirmSalesLink(email) {
  return window.confirm(`Link ${email} to the salesperson record with the same email?\n\nThey stay a controller (no extra admin access) and can also use the Sales site as that salesperson, seeing their own vehicles. If there is no matching record, or more than one, nothing changes.`) === true;
}

async function userManagementLinkSalesRecord(email) {
  if (!userManagementSharedModeReady() || !userManagementConfirmSalesLink(email)) return false;
  const { data, error } = await window.PDC_SUPABASE.rpc('admin_link_controller_salesperson_432', { p_target_email: email });
  if (error) {
    pdcNotify(`Action failed: ${error.message || error}`);
    return false;
  }
  const who = [data?.salesperson_name, data?.salesperson_code ? `(${data.salesperson_code})` : ''].filter(Boolean).join(' ');
  const linkMessage = data?.already_linked
    ? `${email} is already linked to ${who || 'a salesperson record'}. Nothing changed.`
    : `${email} is linked to ${who || 'their salesperson record'} and can now use the Sales site.`;
  pdcNotify(linkMessage, 'info');
  await renderUserManagementScreen();
  return true;
}

async function loadUserStationDepartments() {
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function') return new Map();
  const { data, error } = await client.rpc('list_user_station_departments_557');
  if (error || !Array.isArray(data)) return new Map();
  const map = new Map();
  data.forEach(row => {
    const email = String(row?.email || '').trim().toLowerCase();
    const station = String(row?.station_code || '').trim();
    if (!email || !station) return;
    if (!map.has(email)) map.set(email, []);
    map.get(email).push(station);
  });
  return map;
}

async function userManagementSaveStations(email) {
  if (!userManagementSharedModeReady()) return false;
  const boxes = [...document.querySelectorAll(`[data-um-station-for="${email}"]`)];
  const stations = boxes.filter(box => box.checked).map(box => box.dataset.umStation).filter(Boolean);
  const labels = stations.map(code => (PMB_ACK_STATIONS.find(([value]) => value === code) || [])[1] || code);
  const summary = labels.length ? labels.join(', ') : 'no stations';
  if (window.confirm(`Assign ${summary} to ${email}?\n\nThey can acknowledge New to PMB for those stations. A station left unticked is removed.`) !== true) return false;
  const { data, error } = await window.PDC_SUPABASE.rpc('admin_set_user_station_departments_557', { p_email: email, p_stations: stations });
  if (error || !data || data.ok !== true) {
    pdcNotify(`Action failed: ${data?.message || error?.message || error || 'The stations were not saved.'}`);
    return false;
  }
  pdcNotify(`${email} now looks after ${summary}.`, 'info');
  await renderUserManagementScreen();
  return true;
}

function userManagementAssignedStations(email = '') {
  const map = USER_MANAGEMENT_STATE.stationAssignments;
  const selected = map && typeof map.get === 'function' ? map.get(String(email || '').trim().toLowerCase()) : null;
  return Array.isArray(selected) ? selected : [];
}

function userManagementStationsHtml(row) {
  if (row.account_status !== 'approved') return '<span class="muted-label">—</span>';
  const email = escapeHtml(row.email);
  const selected = new Set(userManagementAssignedStations(row.email));
  const boxes = PMB_ACK_STATIONS.map(([code, label]) =>
    `<label class="um-station"><input type="checkbox" data-um-station="${code}" data-um-station-for="${email}"${selected.has(code) ? ' checked' : ''}> ${escapeHtml(label)}</label>`).join('');
  return `<div class="um-stations">${boxes}<button type="button" class="small-button" data-um-save-stations="${email}">Save stations</button></div>`;
}

function userManagementRowHtml(row) {
  const roleLabel = userManagementRoleLabel(row.role);
  const status = cleanNavisionText(row.account_status || (row.active ? 'approved' : 'disabled')).toLowerCase();
  const statusLabel = status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown';
  return `<tr>
    <td><strong>${escapeHtml(row.full_name || row.display_name || '—')}</strong></td>
    <td>${escapeHtml(row.email)}</td>
    <td class="admin-role-cell">${escapeHtml(roleLabel)}</td>
    <td class="um-stations-cell">${userManagementStationsHtml(row)}</td>
    <td><span class="admin-status-badge is-${escapeHtml(status)}">${escapeHtml(statusLabel)}</span></td>
    <td class="um-actions-cell">${userManagementRowActionsHtml(row)}</td>
  </tr>`;
}

async function renderUserManagementScreen() {
  if (!syncUserManagementAccess()) return;
  const host = $('#user-management-content');
  if (!host) return;

  if (!userManagementSharedModeReady()) {
    host.innerHTML = '<div class="empty-state compact-empty"><strong>Administrator access required</strong></div>';
    return;
  }
  const generation = ++USER_MANAGEMENT_STATE.generation;
  host.innerHTML = '<div class="empty-state compact-empty"><strong>Loading…</strong></div>';

  subscribeUserManagementRealtime();

  try {
    const rows = await loadUserManagementRows();
    if (generation !== USER_MANAGEMENT_STATE.generation || !userManagementSharedModeReady()) return;
    USER_MANAGEMENT_STATE.rows = rows;
    USER_MANAGEMENT_STATE.stationAssignments = await loadUserStationDepartments();
  } catch (error) {
    if (generation !== USER_MANAGEMENT_STATE.generation || !userManagementSharedModeReady()) return;
    host.innerHTML = `<div class="empty-state compact-empty"><strong>Could not load users</strong><span>${escapeHtml(error && error.message ? error.message : String(error))}</span></div>`;
    return;
  }

  renderUserManagementList(host);
}

function renderUserManagementList(host) {
  const role = String(USER_MANAGEMENT_STATE.roleFilter || 'all');
  syncUserManagementRoleFilter(USER_MANAGEMENT_STATE.rows, role);
  const view = userManagementVisibleRows(USER_MANAGEMENT_STATE.rows, USER_MANAGEMENT_STATE.tab, USER_MANAGEMENT_STATE.showDisabled);
  const toggle = userManagementDisabledToggleHtml(view, USER_MANAGEMENT_STATE.showDisabled);
  const filtered = userManagementApplyRoleFilter(view.rows, role);
  if (!filtered.length) {
    const what = role !== 'all'
      ? userManagementRoleFilterLabel(role).toLowerCase()
      : (USER_MANAGEMENT_STATE.tab === 'all' && view.hiddenDisabled ? 'other' : USER_MANAGEMENT_STATE.tab);
    const hint = role !== 'all' ? userManagementRoleFilterHiddenHint(role) : '';
    host.innerHTML = `${toggle}<div class="empty-state compact-empty"><strong>No ${escapeHtml(what)} accounts</strong>${hint}</div>`;
    wireUserManagementDisabledToggle(host);
    return;
  }

  host.innerHTML = `${toggle}<div class="admin-reference-table-wrap"><table class="admin-reference-table user-admin-table">
    <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Stations</th><th>Status</th><th>Actions</th></tr></thead>
    <tbody>${filtered.map(userManagementRowHtml).join('')}</tbody>
  </table></div>`;

  wireUserManagementActions();
  wireUserManagementDisabledToggle(host);
}

function wireUserManagementDisabledToggle(host) {
  const button = host?.querySelector?.('[data-um-toggle-disabled]');
  if (!button) return;
  button.addEventListener('click', () => {
    USER_MANAGEMENT_STATE.showDisabled = !USER_MANAGEMENT_STATE.showDisabled;
    renderUserManagementList(host); // display only: no reload, no server call
  });
}

function subscribeUserManagementRealtime() {
  if (!userManagementSharedModeReady()) return;
  const client = window.PDC_SUPABASE;
  if (!client || typeof client.channel !== 'function') return;
  if (USER_MANAGEMENT_STATE.realtimeChannel) return; // already subscribed for this session
  const channel = client
    .channel('pdc_user_roles_admin_view')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'pdc_user_roles' }, () => {
      // Any account-status/role change (approve/reject/change-role/
      // disable/restore) re-renders the currently active tab live,
      // without requiring a manual "Refresh" click -- proven via a real
      // two-browser test: one browser makes the change, a second,
      // already-open browser on this screen picks it up automatically.
      if (document.getElementById('user-management')?.classList.contains('active')) {
        renderUserManagementScreen();
      }
    })
    .subscribe();
  USER_MANAGEMENT_STATE.realtimeChannel = channel;
}

async function userManagementCallRpc(rpcName, params, successMessage) {
  if (!userManagementSharedModeReady()) return false;
  const client = window.PDC_SUPABASE;
  const { error } = await client.rpc(rpcName, params);
  if (error) {
    pdcNotify(`Action failed: ${error.message || error}`);
    return false;
  }
  if (successMessage) {
    // Non-blocking confirmation; the row list below refreshes immediately
    // afterward regardless, so this is just an audible/visible cue.
  }
  await renderUserManagementScreen();
  return true;
}

function wireUserManagementActions() {
  $$('[data-um-approve]').forEach(button => button.addEventListener('click', async () => {
    const email = button.dataset.umApprove;
    const select = $(`[data-um-role-for="${email}"]`);
    const role = select ? select.value : 'viewer';
    if (!window.confirm(`Approve ${email} as ${userManagementRoleLabel(role)}?`)) return;
    await userManagementCallRpc('admin_approve_user', { p_target_email: email, p_role: role }, 'Approved');
  }));
  $$('[data-um-reject]').forEach(button => button.addEventListener('click', async () => {
    const email = button.dataset.umReject;
    const reason = window.prompt(`Reason for rejecting ${email} (optional):`, '') || null;
    await userManagementCallRpc('admin_reject_registration', { p_target_email: email, p_reason: reason }, 'Rejected');
  }));
  $$('[data-um-change-role]').forEach(button => button.addEventListener('click', async () => {
    const email = button.dataset.umChangeRole;
    const select = $(`[data-um-role-for="${email}"]`);
    const role = select ? select.value : null;
    const currentRole = select ? (select.dataset.umCurrentRole || '') : '';
    if (!userManagementConfirmRoleChange(email, currentRole, role)) return;
    await userManagementCallRpc('admin_change_role', { p_target_email: email, p_role: role }, 'Role changed');
  }));
  $$('[data-um-link-sales]').forEach(button => button.addEventListener('click', async () => {
    await userManagementLinkSalesRecord(button.dataset.umLinkSales);
  }));
  $$('[data-um-save-stations]').forEach(button => button.addEventListener('click', async () => {
    await userManagementSaveStations(button.dataset.umSaveStations);
  }));
  $$('[data-um-disable]').forEach(button => button.addEventListener('click', async () => {
    const email = button.dataset.umDisable;
    const reason = window.prompt(`Reason for disabling ${email} (optional):`, '') || null;
    if (!window.confirm(`Disable access for ${email}? They will immediately lose all operational access.`)) return;
    await userManagementCallRpc('admin_disable_user', { p_target_email: email, p_reason: reason }, 'Disabled');
  }));
  $$('[data-um-restore]').forEach(button => button.addEventListener('click', async () => {
    const email = button.dataset.umRestore;
    await userManagementCallRpc('admin_restore_user', { p_target_email: email, p_reason: 'Restored via User Management screen' }, 'Restored');
  }));
}

function cancelWorkshopPlannerRender() {
  const pending = window.__workshopPlannerRenderFrame;
  if (!pending) return;
  if (window.__workshopPlannerRenderUsesRaf && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(pending);
  else window.clearTimeout?.(pending);
  window.__workshopPlannerRenderFrame = 0;
  window.__workshopPlannerRenderUsesRaf = false;
}

function scheduleWorkshopPlannerRender() {
  if (app.currentView !== 'workshop' || window.__workshopPlannerRenderFrame) return;
  const render = () => {
    window.__workshopPlannerRenderFrame = 0;
    window.__workshopPlannerRenderUsesRaf = false;
    if (app.currentView === 'workshop' && typeof renderWorkshopPlanner === 'function') renderWorkshopPlanner();
  };
  if (typeof window.requestAnimationFrame === 'function') {
    window.__workshopPlannerRenderUsesRaf = true;
    window.__workshopPlannerRenderFrame = window.requestAnimationFrame(render);
  } else {
    window.__workshopPlannerRenderFrame = window.setTimeout(render, 16);
  }
}

function installWorkshopRecoveryListeners() {
  if (window.__workshopRecoveryListenerCleanup) return;
  const reconcileVisiblePlanner = () => {
    if (app.currentView === 'workshop' && document.visibilityState === 'visible') {
      window.__workshopDataService?.reconcileRevision?.('visible_planner_revision');
    } else if (app.currentView === 'workflow' && document.visibilityState === 'visible') {
      reconcileWorkshopEligibilityRevision('visible_overview_revision');
      refreshWorkshopEligibilityClock();
    }
  };
  const onOnline = () => window.__workshopRealtimeManager?.forceReconnect?.();
  const onVisibility = () => {
    if (document.visibilityState === 'visible') {
      window.__workshopDataService?.onVisibilityReturn?.();
      if (app.currentView === 'workflow') reconcileVisiblePlanner();
    }
  };
  window.addEventListener('online', onOnline);
  window.addEventListener('focus', reconcileVisiblePlanner);
  document.addEventListener('visibilitychange', onVisibility);
  // Realtime is the immediate path. A tiny revision read also repairs a
  // missed event while the controller leaves this planner open all day.
  // Unchanged revisions do not fetch bookings or redraw the board.
  const revisionTimer = window.setInterval(reconcileVisiblePlanner, 10000);
  window.__workshopRecoveryListenerCleanup = () => {
    window.removeEventListener('online', onOnline);
    window.removeEventListener('focus', reconcileVisiblePlanner);
    document.removeEventListener('visibilitychange', onVisibility);
    window.clearInterval(revisionTimer);
    window.__workshopRecoveryListenerCleanup = null;
  };
}

function installFitterWorkshopRefreshBridge() {
  if (window.__fitterWorkshopRefreshBridgeCleanup) return;
  let channel = null;
  let refreshTimer = null;
  const refreshVisibleBoard = () => {
    refreshTimer = null;
    if (document.visibilityState !== 'visible' || !getPdcSupabaseAccessToken()) return;
    if (app.currentView === 'workshop') {
      // A confirmed command may cascade into other departments. Never filter
      // by the caller's stage or use event data as authoritative booking data.
      window.__workshopDataService?.onRevisionSignal?.();
    } else if (app.currentView === 'workflow') {
      if (app.workshopEligibilityState === 'loading') app.workshopEligibilityRevisionPending = true;
      else loadWorkshopEligibilitySnapshot('confirmed_fitter_write');
    }
  };
  const queueRefresh = () => {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshVisibleBoard, 200);
  };
  const onSaved = () => {
    if (!getPdcSupabaseAccessToken()) return;
    queueRefresh();
    // Only an invalidation signal crosses tabs: no names, tokens, booking
    // contents or inferred success state. Each recipient reads under its own
    // current authentication and scoped snapshot rules.
    try { channel?.postMessage({ type: 'fitter-workshop-saved' }); } catch (_error) { /* polling / Realtime remain available */ }
  };
  const closeChannel = () => {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = null;
    channel?.close();
    channel = null;
  };
  const openChannel = () => {
    if (channel || typeof window.BroadcastChannel !== 'function' || !window.PDC_SUPABASE_CONFIG?.url) return;
    try {
      channel = new window.BroadcastChannel(`pdc-workshop-saved:${window.PDC_SUPABASE_CONFIG.url}`);
      channel.onmessage = event => { if (event.data?.type === 'fitter-workshop-saved') queueRefresh(); };
    } catch (_error) { channel = null; }
  };
  window.addEventListener('pdc-fitter-workshop-saved', onSaved);
  window.addEventListener('pagehide', closeChannel);
  window.addEventListener('pageshow', openChannel);
  openChannel();
  window.__fitterWorkshopRefreshBridgeCleanup = () => {
    closeChannel();
    window.removeEventListener('pdc-fitter-workshop-saved', onSaved);
    window.removeEventListener('pagehide', closeChannel);
    window.removeEventListener('pageshow', openChannel);
    window.__fitterWorkshopRefreshBridgeCleanup = null;
  };
}

function removeWorkshopRecoveryListeners() {
  try { window.__workshopRecoveryListenerCleanup?.(); } catch (_error) { window.__workshopRecoveryListenerCleanup = null; }
}

function teardownWorkshopPlannerScope(options) {
  options = options || {};
  if (typeof cancelWorkshopPlannerRender === 'function') cancelWorkshopPlannerRender();
  // Keep the revision-only socket while changing station. setScope clears
  // the old station's rows and authority before the destination is rendered.
  if (!options.preserveConnection) {
    if (typeof removeWorkshopRecoveryListeners === 'function') removeWorkshopRecoveryListeners();
    try { window.__workshopRealtimeManager?.stop?.(); } catch (_error) { /* best-effort route teardown */ }
    try { window.__workshopDataService?.destroy?.(); } catch (_error) { /* best-effort route teardown */ }
    window.__workshopRealtimeManager = null;
    window.__workshopDataService = null;
    window.__workshopSharedActions = null;
  }
  window.__activeWorkshopPlannerStage = '';
  const root = document.getElementById('workshop-planner-root');
  const stationContent = options.preserveShell ? root?.querySelector?.('[data-workshop-station-content]') : null;
  if (stationContent) {
    stationContent.innerHTML = '<div class="empty-state workshop-station-loading" role="status"><strong>Loading selected station</strong><span>Fetching the latest bookings for this station…</span></div>';
  } else if (root) root.replaceChildren();
}

function showView(view, options) {
  options = options || {};
  let requestedView = view || 'dashboard';
  if (window.PDC_AUTH_CONTEXT?.role === 'fitter') requestedView = 'fitters';
  // Hidden navigation is not an authority boundary. Reject direct/hash/history
  // routing before changing state, history, active classes or menu expansion.
  if (requestedView === 'user-management' && !userManagementAdministratorActive()) {
    resetUserManagementAuthorityState();
    requestedView = 'dashboard';
  }
  if (requestedView === 'update-history' && !userManagementAdministratorActive()) {
    window.PdcUpdateHistory?.reset();
    requestedView = 'dashboard';
  }
  // r489 (F102): Admin > Fitting statistics is administrators only, like Update history.
  if (requestedView === 'fitting-stats' && !userManagementAdministratorActive()) {
    window.PdcFittingStats?.reset();
    requestedView = 'dashboard';
  }
  // r591 (F205): Admin > Revolution uploads is administrators only. Apply stays off in this preview.
  if (requestedView === 'revolution-upload' && !userManagementAdministratorActive()) {
    window.PdcRevolutionUpload?.reset();
    requestedView = 'dashboard';
  }
  // r958 (F531): Admin > Key Manager is administrators and planners (operator) only, like its Release key button.
  if (requestedView === 'key-manager' && !['administrator', 'operator'].includes(String(window.PDC_AUTH_CONTEXT?.role || '').trim().toLowerCase())) {
    requestedView = 'dashboard';
  }
  if (requestedView === 'deleted' && !vehicleLifecycleAdministratorActive()) {
    resetDeletedVehicleAuthorityState();
    requestedView = 'dashboard';
  }
  if (requestedView === 'pipeline') requestedView = 'workflow';
  const categoryDestination = window.PDC_WORKSHOP_DEPARTMENTS?.categoryForView?.(requestedView);
  if (requestedView.startsWith('planner-') && !WORKSHOP_PLANNER_VIEWS[requestedView] && !categoryDestination) requestedView = 'workflow';
  if (requestedView === 'workshop' && !workshopCombinedPlannerRollbackEnabled()) requestedView = 'workflow';
  const departmentStage = PRODUCTION_DEPARTMENT_VIEWS[requestedView] || '';
  const plannerStage = WORKSHOP_PLANNER_VIEWS[requestedView] || '';
  const nextView = categoryDestination?.external ? 'bus-pit' : (departmentStage ? 'department' : (plannerStage ? 'workshop' : requestedView));
  const previousRequestedView = app.currentRequestedView || app.currentView || 'dashboard';
  if (app.currentView && app.currentView !== nextView && app.vehicleLocationsRefreshCoordinator?.isRefreshing?.()) {
    // A refresh started on another route must become inert before its late
    // callbacks can repaint the newly selected route or its selected vehicle.
    invalidateVehicleLocationsRefresh();
  }
  const previousWasPlanner = previousRequestedView === 'workshop' || Boolean(WORKSHOP_PLANNER_VIEWS[previousRequestedView]);
  const enteringWorkflowBoard = requestedView === 'workflow' && previousRequestedView !== 'workflow';
  const switchingPlannerStation = previousWasPlanner && Boolean(plannerStage) && WORKSHOP_PLANNER_VIEWS[previousRequestedView] !== plannerStage;
  const enteringWorkshopPlanner = nextView === 'workshop'
    && (!previousWasPlanner || switchingPlannerStation);
  const focusedWorkshopIntent = app.pendingWorkshopBookingLink?.focused === true || app.pendingWorkshopBookingLink?.search === true;
  if (focusedWorkshopIntent) app.pendingWorkshopOpenToday = false;
  if ((nextView !== 'workshop' || (previousRequestedView !== requestedView && !focusedWorkshopIntent))
      && typeof workshopResetFocusedBooking === 'function') workshopResetFocusedBooking();
  if (plannerStage === 'BUS_4X4' && !focusedWorkshopIntent) {
    app.pendingBusBayGroup = categoryDestination?.id
      || window.PDC_WORKSHOP_DEPARTMENTS?.category(app.workshopPlanner?.busBayGroup)?.id || 'mechanical';
    app.pendingBusShowAllBays = !categoryDestination;
  }
  if (enteringWorkshopPlanner && !focusedWorkshopIntent) app.pendingWorkshopOpenToday = true;
  // Dashboard completion projection deliberately uses an unscoped Workshop
  // service. Never reuse it for a station planner with different authority.
  if (enteringWorkshopPlanner && !previousWasPlanner && window.__workshopDataService) {
    teardownWorkshopPlannerScope();
  }
  if (previousWasPlanner && (nextView !== 'workshop' || switchingPlannerStation)) teardownWorkshopPlannerScope({ preserveShell: switchingPlannerStation, preserveConnection: switchingPlannerStation });
  if (previousRequestedView === 'workflow' && requestedView !== 'workflow') teardownWorkshopEligibilityOverview({ clearSnapshot: true });
  releaseHeavyViewDom(app.currentView, nextView);
  if (requestedView !== 'workflow') {
    app.activePmbBayStage = '';
    app.pmbSubFilter = '';
    document.body.classList.remove('pmb-station-mode');
    const pmbWorkflowHost = $('#pmb-workflow-board');
    if (pmbWorkflowHost) pmbWorkflowHost.classList.remove('station-only');
  }
  if (departmentStage) app.activeProductionDepartment = departmentStage;
  app.activeWorkshopPlannerStage = plannerStage;
  window.__activeWorkshopPlannerStage = plannerStage;
  if (app.currentView === 'fitters' && nextView !== 'fitters') window.PdcFitters?.close();
  if (app.currentView === 'update-history' && nextView !== 'update-history') window.PdcUpdateHistory?.close();
  if (app.currentView === 'fitting-stats' && nextView !== 'fitting-stats') window.PdcFittingStats?.close();
  if (app.currentView === 'bay-manager' && nextView !== 'bay-manager') window.PdcBayManager?.close();
  if (app.currentView === 'mmt-sublet' && nextView !== 'mmt-sublet') window.PdcMmtSublet?.close(); // r642 (F257)
  if (app.currentView === 'psc-sublet' && nextView !== 'psc-sublet') window.PdcPscSublet?.close(); // r711 (F321)
  if (app.currentView === 'stock-take' && nextView !== 'stock-take') window.PdcStockTake?.close?.(); // r720 (F330)
  if (app.currentView === 'revolution-upload' && nextView !== 'revolution-upload') window.PdcRevolutionUpload?.reset();
  if (app.currentView === 'lists' && nextView !== 'lists') window.PdcWorkshopHours?.reset();
  app.currentRequestedView = requestedView;
  app.currentView = nextView;
  updateWorkshopBrowserRoute(requestedView, options.historyMode || 'push');
  if (document.body?.dataset) document.body.dataset.currentView = requestedView;
  $$('.view').forEach(el => el.classList.toggle('active', el.id === nextView));
  $$('.nav-item[data-view]').forEach(el => el.classList.toggle('active', el.dataset.view === requestedView || (plannerStage && el.dataset.view === 'workshop')));
  const adminViews = new Set(['user-management', 'update-history', 'fitting-stats', 'bay-manager', 'key-manager', 'revolution-upload', 'lists', 'import', 'backup', 'deleted', 'completed', 'backend']);
  const adminActive = adminViews.has(requestedView);
  $('#nav-admin-toggle')?.classList.toggle('active', adminActive);
  if (adminActive && syncAdminNavigationVisibility()) setAdminNavigationExpanded(true);
  const departmentDef = departmentStage ? PRODUCTION_FLOW_DEFS.find(def => def.key === departmentStage) : null;
  const titleMap = {
    dashboard: 'Vehicle Locations',
    qc: 'Final check',
    'pit-bookings': 'Pit bookings', // r753 (F358)
    fitters: 'Fitters bay',
    workflow: 'Control Board',
    workshop: 'Workshop Planner',
    visibility: 'Operational Visibility',
    tv: 'PDC TV Board',
    schedule: 'Production',
    parts: 'Parts',
    emailreview: 'AI Intake',
    'ai-auditor': 'BETA – AI Auditor',
    sublet: 'Sublet',
    'mmt-sublet': 'Sublet · Malaga Motor Trimmers',
    'psc-sublet': 'Sublet · Perth Sign Craft',
    'stock-take': 'Stock take',
    rft: 'RFT',
    completed: 'Completed vehicles',
    collected: 'Collected Vehicles',
    deleted: 'Deleted vehicles',
    backend: 'Back End Data',
    lists: 'Setup',
    import: 'Navision Uploads',
    backup: 'Backup / Restore',
    'user-management': 'User Management',
    'update-history': 'Update history',
    'fitting-stats': 'Fitting statistics',
    'bay-manager': 'Bay Manager',
    'key-manager': 'Key Manager', // r958 (F531)
    'revolution-upload': 'Revolution uploads',
    zpl: 'Label Tools'
  };
  const pageTitle = $('#page-title');
  if (pageTitle) pageTitle.textContent = departmentDef
    ? departmentDef.label
    : categoryDestination ? `Bus 4×4 — ${categoryDestination.label}${categoryDestination.external ? ' · External inspection' : ''}`
    : (plannerStage ? (window.PDC_WORKSHOP_DEPARTMENTS?.plannerTitle(plannerStage) || `${pmbStageLabel(plannerStage)} Planner`) : (titleMap[requestedView] || 'Control Board'));
  if (requestedView !== 'dashboard' && app.frozenHeaderCleanup) {
    app.frozenHeaderCleanup();
    app.frozenHeaderCleanup = null;
  }
  renderActiveView();
  ensureOperationalRefreshControls();
  if (requestedView === 'backup') configureCrmBackupAuthorityUi();
  if (enteringWorkflowBoard && workshopEligibilitySharedAuthorityEnabled()
      && !['idle', 'loading'].includes(app.workshopEligibilityState)) {
    loadWorkshopEligibilitySnapshot('route_entry_refresh');
  }
  scheduleWorkflowFloatingHeaderUpdate();
}

const HEAVY_VIEW_HOSTS = Object.freeze({
  dashboard: ['incoming-main-board', 'kpi-grid', 'vehicle-table'],
  qc: ['qc-page-host'],
  workflow: ['workflow-board'],
  workshop: ['workshop-planner-root'],
  parts: ['parts-home-content', 'parts-summary-grid'],
  emailreview: ['email-intake-review-content'],
  'ai-auditor': ['ai-auditor-report'],
  sublet: ['sublet-home-content'],
  'bus-pit': ['bus-pit-content'],
  rft: ['rft-home-content', 'rft-summary-grid'],
  completed: ['completed-vehicles-content'],
  deleted: ['deleted-vehicles-content'],
  backend: ['backend-data-content'],
  department: ['department-content'],
  schedule: ['schedule-content'],
  visibility: ['visibility-content'],
  tv: ['tv-content'],
});

function releaseHeavyViewDom(previousView = '', nextView = '') {
  if (!previousView || previousView === nextView) return;
  (HEAVY_VIEW_HOSTS[previousView] || []).forEach(id => {
    const host = document.getElementById(id);
    if (host) host.replaceChildren();
  });
}


function populateFilters() {
  const visibleRows = pdcSheetVehicles();
  const statuses = sortToyotaStatuses([...new Set(visibleRows.map(v => v.toyotaStatus).filter(Boolean))]);
  const consultants = [...new Set(visibleRows.map(v => salesPersonInitials(consultantName(v))).filter(Boolean))].sort();
  const productionMonths = sortProductionMonths([...new Set(visibleRows.map(v => productionMonthLabel(v.prodMth || v.productionMonth || '')).filter(Boolean))]);
  const sources = [...new Set(visibleRows.map(v => v.source).filter(Boolean))].sort();
  app.filterOptions = { statuses, consultants, productionMonths, sources };
  app.columnFilters = app.columnFilters || { sales: '', production: '', status: '', jita: '' };
  [['status', statuses], ['sales', consultants], ['production', productionMonths], ['jita', ['Yes', 'No', 'Unknown']]].forEach(([key, options]) => {
    if (app.columnFilters[key] && !options.includes(app.columnFilters[key])) app.columnFilters[key] = '';
  });
  const sourceFilter = $('#source-filter');
  if (sourceFilter) {
    const selected = sourceFilter.value || '';
    sourceFilter.innerHTML = '<option value="">All sources</option>' + sources.map(s => `<option value="${escapeHtml(s)}"${s === selected ? ' selected' : ''}>${escapeHtml(s)}</option>`).join('');
  }
  populateTaskSelects();
}

function populateTaskSelects() {
  const select = $('#new-customer-task');
  if (select) select.innerHTML = taskOptionsHtml('');
}


function updateSidebarStats() {
  updateNavisionSidebarMeta();
  renderOperationalHealthSummary();
}

function renderAll() {
  ensureAppDataAvailable();
  updateSidebarStats();
  populateFilters();
  renderActiveView();
  ensureOperationalRefreshControls();
  restoreOperationalRefreshViewState();
  updateNavisionImportButton();
}

// Bridges to the real Supabase client that pdc-auth.js already creates
// (window.PDC_SUPABASE) as part of the standard login flow. Kept as thin,
// dedicated functions (rather than reaching into window.PDC_SUPABASE
// directly from workshop-data-service.js) so the shared data service
// module has no hard dependency on pdc-auth.js's internal implementation
// details, and so a future auth provider swap only touches these two
// functions.
function getPdcSupabaseAccessToken() {
  // supabase-js v2 exposes the session via getSession() (async) but every
  // caller of getAccessToken() here is synchronous by contract (see
  // workshop-data-service.js). pdc-auth.js caches the current access
  // token on window.__pdcCachedAccessToken every time it unlocks the app
  // or reacts to an auth state change (including silent token refresh),
  // and clears it immediately on sign-out/session loss -- so this is
  // always either the live token or null, never stale beyond one tick.
  return window.PDC_AUTH_CONTEXT ? (window.__pdcCachedAccessToken || null) : null;
}

// r619 (F234): during an import, a burst of realtime events refetches the board at most every 20 s.
// Quiet time: one refetch 250 ms after an event, as before. Burst = more than 3 events in 60 s.
const PDC_BURST_QUIET_MS = 250;
const PDC_BURST_GAP_MS = 20000;
const PDC_BURST_WINDOW_MS = 60000;
const PDC_BURST_EVENTS = 3;
function pdcBurstDelay(state, now) {
  state.events = (state.events || []).filter(at => now - at < PDC_BURST_WINDOW_MS);
  state.events.push(now);
  const burst = state.events.length > PDC_BURST_EVENTS;
  const sinceLast = now - (state.lastRun || 0);
  return burst ? Math.max(PDC_BURST_QUIET_MS, PDC_BURST_GAP_MS - sinceLast) : PDC_BURST_QUIET_MS;
}
function pdcBurstGate(fn, clock = () => Date.now(), schedule = (cb, ms) => setTimeout(cb, ms)) {
  const state = { events: [], lastRun: 0, timer: null, args: null };
  return function gated(...args) {
    state.args = args;
    const delay = pdcBurstDelay(state, clock());
    if (state.timer !== null) return;
    state.timer = schedule(() => {
      state.timer = null;
      state.lastRun = clock();
      fn(...state.args);
    }, delay);
  };
}

function createPdcSupabaseRealtimeSubscription(config, handlers, scope = null) {
  const client = window.PDC_SUPABASE;
  if (!client || typeof client.channel !== 'function') {
    const status = 'CLIENT_UNAVAILABLE';
    if (typeof handlers?.onStatus === 'function') handlers.onStatus(status);
    if (typeof handlers?.onError === 'function') handlers.onError(status);
    return { requiresSubscribedStatus: true, unsubscribe: () => {} };
  }
  const stageCode = String(scope?.stageCode || '').trim().toUpperCase();
  const allStations = scope?.allStations === true;
  const table = stageCode || allStations ? 'workshop_station_revision' : 'workshop_revision';
  const filter = stageCode ? `stage_code=eq.${stageCode}` : undefined;
  const changeSpec = { event: '*', schema: 'public', table, ...(filter ? { filter } : {}) };
  const channel = client
    .channel(stageCode ? `workshop-station-revision-${stageCode.toLowerCase()}` : allStations ? (scope?.overview ? 'workshop-overview-station-revisions' : 'workshop-all-station-revisions') : 'workshop-revision')
    .on('postgres_changes', changeSpec, (typeof pdcBurstGate === 'function' ? pdcBurstGate : f => f)(payload => { // r619 (F234)
      if (typeof handlers?.onChange === 'function') handlers.onChange(payload);
    }))
    .subscribe(status => {
      if (typeof handlers?.onStatus === 'function') handlers.onStatus(status);
      if (status === 'SUBSCRIBED') {
        if (typeof handlers?.onSubscribed === 'function') handlers.onSubscribed(status);
      } else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
        if (typeof handlers?.onError === 'function') handlers.onError(status);
      } else if (status === 'CLOSED') {
        if (typeof handlers?.onClosed === 'function') handlers.onClosed(status);
      }
    });
  return {
    requiresSubscribedStatus: true,
    unsubscribe: () => client.removeChannel(channel)
  };
}

// Generic per-table realtime subscription, used by
// workshop-reference-data-service.js (Stage 2A) for mechanics/salespeople/
// sublet-providers/bays/workshop-settings, none of which share the single
// fixed 'workshop-revision' channel the booking-data path above uses.
// Each table gets its own named channel so unrelated resources never
// interfere with each other's subscribe/reconnect lifecycle.
function createPdcSupabaseTableRealtimeSubscription(tableName, handlers) {
  const client = window.PDC_SUPABASE;
  if (!client || typeof client.channel !== 'function') return { unsubscribe: () => {} };
  const channel = client
    .channel(`pdc-reference-${tableName}`)
    .on('postgres_changes', { event: '*', schema: 'public', table: tableName }, payload => {
      if (typeof handlers?.onChange === 'function') handlers.onChange(payload);
    })
    .subscribe(status => {
      if (typeof handlers?.onStatus === 'function') handlers.onStatus(status);
    });
  return { unsubscribe: () => client.removeChannel(channel) };
}

// Constructs the Stage 2A shared workshop reference/configuration data
// service exactly once per page load. Unlike
// initWorkshopSharedServicesIfEnabled() above (which stays behind an
// explicit opt-in flag while the legacy local-plan booking fallback is
// retired in a later stage), this service is NOT gated by a feature flag
// -- per the Stage 2A instruction, Supabase must be authoritative for
// mechanics/salespeople/sublet-providers/bays/workshop-configuration
// immediately. It still requires a real, authenticated session
// (getPdcSupabaseAccessToken()) before it will report anything other than
// a clear "not authenticated"/offline state -- there is no synchronous
// path back to localStorage.
function initWorkshopReferenceDataServiceIfAvailable() {
  if (!workshopReferenceDataRoleCanRead()) return null;
  if (window.__workshopReferenceDataService) return window.__workshopReferenceDataService;
  if (!window.PDC_SUPABASE_CONFIG || typeof createWorkshopReferenceDataService !== 'function' || typeof createWorkshopReferenceSupabaseClient !== 'function') return null;

  const client = createWorkshopReferenceSupabaseClient(window.PDC_SUPABASE_CONFIG);
  const service = createWorkshopReferenceDataService({
    config: window.PDC_SUPABASE_CONFIG,
    client,
    getAccessToken: () => (typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null),
    subscribeRealtime: (tableName, handlers) => createPdcSupabaseTableRealtimeSubscription(tableName, handlers),
    onStateChange: () => {
      // Independent-review remediation (finding 1): pull the latest
      // validated workshop configuration into the planner's live
      // scheduling constants BEFORE re-rendering, so a settings change
      // made in another browser (or the periodic reconciliation
      // backstop) actually changes planner behaviour here, not only
      // the raw cached JSON.
      if (typeof workshopSyncConfigFromSharedSettings === 'function') {
        try { workshopSyncConfigFromSharedSettings(); } catch (_err) { /* keep last-known-good config */ }
      }
      // Reference changes keep visible controls current. Backup history is
      // independent and is loaded when Setup opens or its refresh is used.
      if (app.currentView === 'lists') renderAdminLists({ refreshBackup: false });
      if (app.currentView === 'dashboard') renderKpis();
      if (app.currentView === 'workshop') scheduleWorkshopPlannerRender();
    }
  });
  window.__workshopReferenceDataService = service;
  return service;
}

// Lazily constructs the shared workshop data service + realtime manager
// exactly once per page load. No-op (and leaves window.__workshopDataService
// undefined) unless window.PDC_SUPABASE_CONFIG.workshop.sharedData is
// explicitly true -- see workshop-data-service.js for the fail-closed
// opt-in contract. Kept in app.js (not workshop-planner.js) because it owns
// the actual Supabase client / auth token / realtime subscription
// wiring, which are already app.js concerns for the rest of the site.
function initWorkshopSharedServicesIfEnabled() {
  if (typeof workshopSharedModeEnabled !== 'function' || !workshopSharedModeEnabled(window.PDC_SUPABASE_CONFIG)) return;
  if (!OPERATIONAL_REFRESH_ROUTES.includes(app.currentView) && app.currentView !== 'dashboard') return;
  // The auth-ready event can fire while the lazy module chain is between
  // workshop-data-service.js and workshop-realtime.js on a slower network.
  // Do not create the data service in that gap: doing so activates the
  // no-Realtime fallback snapshot, then the channel subscription performs a
  // second initial snapshot when the remaining module arrives.
  if (window.__workshopPlannerModulesLoading) return;

  if (typeof workshopApplyOpenDateDefault === 'function') workshopApplyOpenDateDefault();

  const pendingBookingDate = app.pendingWorkshopBookingLink
    && normalizePmbStage(app.pendingWorkshopBookingLink.stage || '') === normalizePmbStage(app.activeWorkshopPlannerStage || '')
    ? cleanNavisionText(app.pendingWorkshopBookingLink.date || '')
    : '';
  if (pendingBookingDate && typeof workshopState === 'function') workshopState().date = pendingBookingDate;
  const plannerDate = pendingBookingDate || (typeof workshopState === 'function'
    ? workshopState().date
    : new Date().toISOString().slice(0, 10));

  if (!window.__workshopDataService) {
    if (typeof createWorkshopDataService !== 'function' || typeof createWorkshopSupabaseClient !== 'function') return;

    const client = createWorkshopSupabaseClient(window.PDC_SUPABASE_CONFIG);
    const dataService = createWorkshopDataService({
      config: window.PDC_SUPABASE_CONFIG,
      client,
      scope: app.activeWorkshopPlannerStage ? {
        stageCode: app.activeWorkshopPlannerStage,
        dateFrom: plannerDate,
        dateTo: plannerDate,
      } : null,
      getAccessToken: () => (typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null),
      getRole: () => (typeof window.PDC_AUTH_CONTEXT !== 'undefined' ? window.PDC_AUTH_CONTEXT?.role : null),
      onStateChange: () => {
        if (app.currentView === 'workshop') scheduleWorkshopPlannerRender();
        if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
        if (app.currentView === 'emailreview' && typeof renderAiBoardAdvisor === 'function') renderAiBoardAdvisor();
      },
      onSnapshot: () => {
        if (app.currentView === 'workshop') scheduleWorkshopPlannerRender();
        if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
        if (app.currentView === 'emailreview' && typeof renderAiBoardAdvisor === 'function') renderAiBoardAdvisor();
      }
    });
    window.__workshopDataService = dataService;

    // Read the selected station while the socket connects; the data service
    // keeps editing locked until its post-subscription revision check succeeds.
    if (typeof createWorkshopRealtimeManager === 'function' && typeof createPdcSupabaseRealtimeSubscription === 'function') {
      dataService.startConnecting();
    } else {
      dataService.loadSnapshot('initial_without_realtime');
    }
  } else if (app.activeWorkshopPlannerStage) {
    // Same-stage category clicks do nothing. New scopes cancel old reads
    // and clear their rows before fetching only the destination snapshot.
    window.__workshopDataService.setScope({
      stageCode: app.activeWorkshopPlannerStage, dateFrom: plannerDate, dateTo: plannerDate
    });
  }

  // Deliberately re-checked every call, same reasoning as the shared-
  // actions block below: workshop-realtime.js is also lazy-loaded
  // on-demand when the user first opens the Workshop Planner, which can
  // happen after the data service already exists (e.g. pdc-auth-ready
  // firing on login before the planner has ever been opened).
  if (!window.__workshopRealtimeManager && typeof createWorkshopRealtimeManager === 'function' && typeof createPdcSupabaseRealtimeSubscription === 'function') {
    const dataService = window.__workshopDataService;
    window.__workshopRealtimeManager = createWorkshopRealtimeManager({
      dataService,
      subscribe: (handlers) => createPdcSupabaseRealtimeSubscription(
        window.PDC_SUPABASE_CONFIG,
        { ...handlers, onChange: payload => {
          const row = payload?.new || payload;
          const stage = dataService.getScope?.()?.stageCode;
          // Revision events contain no booking rows. Ignore other stations;
          // unknown events still invalidate rather than assuming freshness.
          if (stage && row?.stage_code && row.stage_code !== stage) return;
          handlers.onChange(payload);
        } },
        app.activeWorkshopPlannerStage ? { allStations: true } : null,
      ),
      onStatusChange: () => {
        if (app.currentView === 'workshop') scheduleWorkshopPlannerRender();
        if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
      }
    });
    window.__workshopRealtimeManager.start();
    installWorkshopRecoveryListeners();
  }

  // Deliberately re-checked every call (not just inside the "first init"
  // branch above): workshop-shared-actions.js is lazy-loaded on-demand
  // when the user first opens the Workshop Planner view, which can easily
  // happen *after* the data service was already constructed here (e.g.
  // from the pdc-auth-ready listener firing on login before the user has
  // ever visited the planner). Without this re-check, window.
  // __workshopSharedActions would stay null forever once the data service
  // already existed.
  if (!window.__workshopSharedActions && typeof buildWorkshopSharedActions === 'function') {
    window.__workshopSharedActions = buildWorkshopSharedActions(window.__workshopDataService);
  }
}

// Lazily constructs the vehicle-lifecycle shared actions bridge (QC
// complete -> RFT -> Collected) exactly once per page load. Independent of
// initWorkshopSharedServicesIfEnabled(): a site can enable shared workshop
// scheduling without enabling shared QC/RFT/Collected, or vice versa.
// Fails closed -- if not enabled/loaded, window.__vehicleLifecycleActions
// stays undefined and configured shared lifecycle actions fail closed.
function initVehicleLifecycleSharedActionsIfEnabled() {
  if (typeof vehicleLifecycleSharedModeEnabled !== 'function' || !vehicleLifecycleSharedModeEnabled(window.PDC_SUPABASE_CONFIG)) return;
  if (typeof createWorkshopSupabaseClient !== 'function' || typeof buildVehicleLifecycleSharedActions !== 'function') return;
  const client = createWorkshopSupabaseClient(window.PDC_SUPABASE_CONFIG);
  if (!window.__vehicleLifecycleActions) {
    window.__vehicleLifecycleActions = buildVehicleLifecycleSharedActions(
      client,
      () => (typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null),
    );
  }
  window.__vehicleLifecycleResolverDiagnostics = window.__vehicleLifecycleResolverDiagnostics || [];
  const rollback = typeof vehicleLifecycleResolverRollbackEnabled === 'function'
    && vehicleLifecycleResolverRollbackEnabled(window.PDC_SUPABASE_CONFIG);
  if (rollback) {
    window.__vehicleLifecycleResolverDiagnostics.push({
      type: 'rollback_mode',
      at: new Date().toISOString(),
      mode: 'staging_direct_read',
    });
    console.warn('PDC C1 lifecycle resolver: explicit staging rollback direct-read mode is active.');
    return;
  }
  if (!window.__vehicleLifecycleIdentityResolver && typeof createVehicleLifecycleIdentityResolver === 'function') {
    window.__vehicleLifecycleIdentityResolver = createVehicleLifecycleIdentityResolver({
      client,
      getAccessToken: () => (typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null),
      subscribe: handlers => createPdcSupabaseTableRealtimeSubscription('vehicle_lifecycle_resolver_revision', handlers),
      onDiagnostic: item => {
        window.__vehicleLifecycleResolverDiagnostics.push(item);
        if (window.__vehicleLifecycleResolverDiagnostics.length > 100) window.__vehicleLifecycleResolverDiagnostics.shift();
      },
      onRefresh: item => {
        window.dispatchEvent?.(new CustomEvent('pdc-vehicle-lifecycle-resolver-refresh', { detail: item }));
      },
    });
    window.__vehicleLifecycleIdentityResolver.start();
  }
  if (!window.__vehicleLifecycleResolverReconcileListenersInstalled) {
    window.addEventListener('online', () => {
      window.__vehicleLifecycleIdentityResolver?.reconcile?.('online_return');
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        window.__vehicleLifecycleIdentityResolver?.reconcile?.('visibility_return');
      }
    });
    window.__vehicleLifecycleResolverReconcileListenersInstalled = true;
  }
  window.__vehicleLifecycleIdentityResolver?.reconcile?.('auth_ready');
}

function vehicleLifecycleSharedModeActive() {
  return typeof window !== 'undefined'
    && typeof vehicleLifecycleSharedModeEnabled === 'function'
    && vehicleLifecycleSharedModeEnabled(window.PDC_SUPABASE_CONFIG);
}

function sharedVehicleLocationMutationUnavailable(operation = 'change vehicle location', vehicle = null, options = {}) {
  if (!vehicleLifecycleSharedModeActive()) return false;
  if (vehicle?.__emailVehicleServerAuthoritative === true && operation === 'transfer to PMB') return false;
  if (!options.silent) {
    pdcNotify(`Cannot ${operation} from this control. Shared vehicle locations must be changed through an audited server action; no browser-local change was saved.`);
  }
  return true;
}

function vehicleLifecycleAdministratorActive() {
  return window.PDC_AUTH_CONTEXT?.role === 'administrator';
}

function vehicleLifecycleStagingResetAllowed() {
  const config = window.PDC_SUPABASE_CONFIG || {};
  const location = window.location || {};
  const origin = String(location.origin || '').replace(/\/$/, '');
  const pathname = String(location.pathname || '');
  const approvedPath = pathname === '/pdc-control-board-staging/';
  return vehicleLifecycleSharedModeActive()
    && config.projectRef === 'cdsmnqxtyyoeoznmbidd'
    && String(config.url || '').replace(/\/$/, '') === 'https://cdsmnqxtyyoeoznmbidd.supabase.co'
    && origin === 'https://btnew.github.io'
    && approvedPath;
}

function vehicleLifecycleActionErrorMessage(result = {}) {
  return typeof describeVehicleLifecycleActionError === 'function'
    ? describeVehicleLifecycleActionError(result)
    : (result?.message || result?.body?.message || result?.error || 'The vehicle lifecycle action failed.');
}

async function refreshVehicleLifecycleLocationsAndRender() {
  await refreshEmailVehicleLocations();
  renderAll();
}

function authoritativeSalespersonCode(vehicle = {}) { return String(vehicle.salespersonCode || '').trim().toUpperCase(); }
function salespersonAssignmentIdempotencyKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID();
  return '00000000-0000-4000-8000-' + Array.from({ length: 12 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
}
function pdcLocationRequestKey(vehicleId = '', expectedVersion = 0, location = '') {
  return `pdc-location:${String(vehicleId).trim().toLowerCase()}:${Number(expectedVersion) || 0}:${normalizePdcLocation(location)}`;
}
function authoritativeReceiptData(result = {}) {
  const data = result?.data && typeof result.data === 'object' ? result.data : null;
  const vehicleId = String(data?.vehicle_id || '').trim();
  const receiptId = String(data?.receipt_id || '').trim();
  const vehicleVersionAfter = Number(data?.vehicle_version_after ?? data?.vehicle_version ?? 0);
  if (result?.ok !== true || !vehicleId || !receiptId || !Number.isInteger(vehicleVersionAfter) || vehicleVersionAfter < 1) return null;
  const effective = data?.effective_salesperson && typeof data.effective_salesperson === 'object' ? data.effective_salesperson : {};
  return {
    receiptId, vehicleId, vehicleVersionAfter,
    salespersonCode: String(effective.salesperson_code || '').trim().toUpperCase(),
    salespersonName: String(effective.salesperson_name || '').trim(),
    salespersonEmail: String(effective.salesperson_email || '').trim().toLowerCase(),
    salespersonManualOverride: effective.salesperson_manual_override === true,
    hasSalespersonProjection: Object.prototype.hasOwnProperty.call(data || {}, 'effective_salesperson'),
  };
}
function applyAuthoritativeVehicleReceipt(vehicle = {}, result = {}, requestedCode = '', detailChanges = {}) {
  const receipt = authoritativeReceiptData(result);
  if (!receipt || String(vehicle.__emailVehicleId || '').trim() !== receipt.vehicleId) return null;
  const requestedSalesperson = String(requestedCode || '').trim().toUpperCase();
  const salespersonCode = receipt.salespersonCode || requestedSalesperson || authoritativeSalespersonCode(vehicle);
  const next = { ...vehicle, __emailVehicleId: receipt.vehicleId, __emailVehicleVersion: receipt.vehicleVersionAfter };
  if (receipt.salespersonCode || requestedSalesperson || Object.prototype.hasOwnProperty.call(result?.data || {}, 'effective_salesperson')) {
    next.salespersonCode = salespersonCode;
    next.salespersonName = receipt.salespersonName || (salespersonCode ? String(vehicle.salespersonName || salespersonCode) : '');
    next.salespersonEmail = receipt.salespersonEmail || (salespersonCode ? String(vehicle.salespersonEmail || '').trim().toLowerCase() : '');
    next.salespersonManualOverride = receipt.salespersonManualOverride;
    next.consultant = salespersonCode || next.salespersonName || 'Unassigned';
  }
  if (Object.prototype.hasOwnProperty.call(detailChanges || {}, 'client_name')) next.client = String(detailChanges.client_name ?? '').trim();
  if (Object.prototype.hasOwnProperty.call(detailChanges || {}, 'key_number')) next.keyNumber = String(detailChanges.key_number ?? '').trim();
  if (Object.prototype.hasOwnProperty.call(detailChanges || {}, 'job_card_number')) {
    const jobcard = String(detailChanges.job_card_number ?? '').trim();
    next.pdcJobcard = jobcard; next.jobcard = jobcard; next.jobCardNumber = jobcard;
  }
  return next;
}
function authoritativeVehicleReadbackStatus(row = {}, expected = {}) {
  const rowId = String(row.id || row.permanent_vehicle_id || row.__emailVehicleId || '').trim();
  if (!rowId || rowId !== String(expected.vehicleId || '').trim()) return 'pending';
  const rowVersion = Number(row.version || row.__emailVehicleVersion || 0);
  const expectedVersion = Number(expected.vehicleVersionAfter || 0);
  if (rowVersion < expectedVersion) return 'pending';
  const rowSalespersonCode = String(row.salesperson_code || row.salesperson_reference || row.__salespersonCode || '').trim().toUpperCase();
  if (expected.hasSalespersonProjection && rowSalespersonCode !== String(expected.salespersonCode || '').trim().toUpperCase()) return 'contradictory';
  const changes = expected.detailChanges && typeof expected.detailChanges === 'object' ? expected.detailChanges : {};
  if (Object.prototype.hasOwnProperty.call(changes, 'client_name') && String(row.customer_name ?? row.client ?? '').trim() !== String(changes.client_name ?? '').trim()) return 'contradictory';
  if (Object.prototype.hasOwnProperty.call(changes, 'key_number') && String(row.key_number ?? row.keyNumber ?? '').trim() !== String(changes.key_number ?? '').trim()) return 'contradictory';
  if (Object.prototype.hasOwnProperty.call(changes, 'job_card_number') && String(row.job_card_number ?? row.jobcard ?? '').trim() !== String(changes.job_card_number ?? '').trim()) return 'contradictory';
  return 'matching';
}
function authoritativeVehicleReceiptExpectation(result = {}, requestedCode = '', detailChanges = {}) {
  const receipt = authoritativeReceiptData(result);
  if (!receipt) return null;
  return { ...receipt, salespersonCode: receipt.salespersonCode || String(requestedCode || '').trim().toUpperCase(), hasSalespersonProjection: receipt.hasSalespersonProjection || Boolean(String(requestedCode || '').trim()), detailChanges: { ...(detailChanges || {}) } };
}
function authoritativeVehicleRawOverlay(vehicle = {}, expected = {}) {
  const overlay = { id: expected.vehicleId, version: expected.vehicleVersionAfter };
  if (expected.hasSalespersonProjection) {
    overlay.salesperson_code = expected.salespersonCode;
    overlay.salesperson_name = String(vehicle.salespersonName || expected.salespersonCode || '');
    overlay.salesperson_email = String(vehicle.salespersonEmail || '').trim().toLowerCase();
    overlay.salesperson_manual_override = vehicle.salespersonManualOverride === true;
  }
  const changes = expected.detailChanges || {};
  if (Object.prototype.hasOwnProperty.call(changes, 'client_name')) overlay.customer_name = String(changes.client_name ?? '').trim();
  if (Object.prototype.hasOwnProperty.call(changes, 'key_number')) overlay.key_number = String(changes.key_number ?? '').trim();
  if (Object.prototype.hasOwnProperty.call(changes, 'job_card_number')) overlay.job_card_number = String(changes.job_card_number ?? '').trim();
  return overlay;
}
function applyAuthoritativeVehicleReceiptToState(vehicle = {}, result = {}, requestedCode = '', detailChanges = {}) {
  const expected = authoritativeVehicleReceiptExpectation(result, requestedCode, detailChanges);
  const patched = applyAuthoritativeVehicleReceipt(vehicle, result, requestedCode, detailChanges);
  if (!expected || !patched) return null;
  const canonicalId = expected.vehicleId;
  const merge = row => String(row?.__emailVehicleId || row?.id || '').trim() === canonicalId ? { ...row, ...patched } : row;
  app.data = (Array.isArray(app.data) ? app.data : []).map(merge);
  app.emailVehicleLocationRows = (Array.isArray(app.emailVehicleLocationRows) ? app.emailVehicleLocationRows : []).map(merge);
  if (!(app.emailVehicleReceiptOverlays instanceof Map)) app.emailVehicleReceiptOverlays = new Map();
  app.emailVehicleReceiptOverlays.set(canonicalId, { expected, patchedVehicle: patched, rawOverlay: authoritativeVehicleRawOverlay(patched, expected) });
  return { expected, patched };
}
function applyPendingAuthoritativeVehicleReceiptOverlays(serverRows = []) {
  const overlays = app.emailVehicleReceiptOverlays instanceof Map ? app.emailVehicleReceiptOverlays : new Map();
  const rows = Array.isArray(serverRows) ? serverRows : [];
  overlays.forEach((overlay, canonicalId) => {
    const row = rows.find(item => String(item?.id || item?.permanent_vehicle_id || '').trim() === canonicalId);
    const status = row ? authoritativeVehicleReadbackStatus(row, overlay.expected) : 'pending';
    if (status === 'matching' || status === 'contradictory') overlays.delete(canonicalId);
  });
  return rows.map(row => {
    const canonicalId = String(row?.id || row?.permanent_vehicle_id || '').trim();
    const overlay = overlays.get(canonicalId);
    return overlay ? { ...row, ...overlay.rawOverlay } : row;
  });
}
function applyAuthoritativeVehicleReadbackRow(row = {}) {
  const module = typeof window !== 'undefined'
    ? window.PDC_EMAIL_VEHICLE_LOCATION_SERVICE
    : globalThis.PDC_EMAIL_VEHICLE_LOCATION_SERVICE;
  if (!row || typeof module?.mapServerVehicle !== 'function') return null;
  const mapped = module.mapServerVehicle(row);
  const canonicalId = String(mapped.__emailVehicleId || row.id || '').trim();
  const merge = item => String(item?.__emailVehicleId || item?.id || '').trim() === canonicalId ? { ...item, ...mapped } : item;
  app.data = (Array.isArray(app.data) ? app.data : []).map(merge);
  app.emailVehicleLocationRows = (Array.isArray(app.emailVehicleLocationRows) ? app.emailVehicleLocationRows : []).map(merge);
  return mapped;
}
async function reconcileAuthoritativeVehicleReceipt(result = {}, vehicle = {}, requestedCode = '', detailChanges = {}, attempts = 3) {
  const expected = authoritativeVehicleReceiptExpectation(result, requestedCode, detailChanges);
  const service = app.emailVehicleLocationService;
  if (!expected || !service?.snapshot) return { status: 'pending', vehicle };
  for (let attempt = 0; attempt < Math.max(1, Number(attempts) || 1); attempt += 1) {
    let response = null;
    try { response = await service.snapshot(); } catch (_error) { response = null; }
    const rows = Array.isArray(response?.data?.vehicles) ? response.data.vehicles : [];
    const row = response?.ok === true ? rows.find(item => String(item?.id || '').trim() === expected.vehicleId) : null;
    if (row) {
      const status = authoritativeVehicleReadbackStatus(row, expected);
      if (status === 'matching' || status === 'contradictory') {
        app.emailVehicleReceiptOverlays?.delete?.(expected.vehicleId);
        const mapped = applyAuthoritativeVehicleReadbackRow(row) || vehicle;
        return { status, vehicle: mapped };
      }
    }
    if (attempt + 1 < Math.max(1, Number(attempts) || 1)) await new Promise(resolve => window.setTimeout(resolve, 80 * (attempt + 1)));
  }
  return { status: 'pending', vehicle };
}
function discardLegacyAuthoritativeSalespersonEdits(rows = []) {
  const edits = loadVehicleEdits(); let changed = false;
  const fields = ['consultant', 'salesperson', 'salesPerson', 'salespersonCode', 'salespersonName', 'salespersonEmail'];
  (Array.isArray(rows) ? rows : []).forEach(row => {
    [row.stock_number, row.stock, row.permanent_vehicle_id, row.id].map(value => String(value || '').trim()).filter(Boolean).forEach(key => {
      const entry = edits[key]; if (!entry || typeof entry !== 'object') return;
      fields.forEach(field => { if (Object.prototype.hasOwnProperty.call(entry, field)) { delete entry[field]; changed = true; } });
      if (!Object.keys(entry).length) delete edits[key];
    });
  });
  if (changed) saveJson(EDITS_KEY, edits);
  return changed;
}
async function saveAuthoritativeVehicleSalesperson(vehicle = {}, requestedCode = '') {
  const service = app.emailVehicleLocationService; const canonicalId = String(vehicle.__emailVehicleId || '').trim();
  const result = service?.updateSalespersonAssignment
    ? await service.updateSalespersonAssignment(canonicalId, Number(vehicle.__emailVehicleVersion || 0), String(requestedCode || '').trim().toUpperCase(), salespersonAssignmentIdempotencyKey())
    : { ok: false, code: 'salesperson_assignment_unavailable', data: null };
  if (!result || result.ok !== true) return result || { ok: false, code: 'salesperson_assignment_unavailable', data: null };
  const applied = applyAuthoritativeVehicleReceiptToState(vehicle, result, requestedCode);
  if (!applied) return { ok: false, code: 'salesperson_assignment_receipt_invalid', data: result.data || null };
  void refreshEmailVehicleLocations();
  const readback = await reconcileAuthoritativeVehicleReceipt(result, applied.patched, requestedCode);
  if (readback.status === 'contradictory') return { ok: false, code: 'salesperson_assignment_readback_contradictory', data: result.data || null };
  return { ...result, data: { ...(result.data || {}), authoritativeVehicle: readback.vehicle || applied.patched }, readbackPending: readback.status === 'pending' };
}
async function saveAuthoritativeVehicleChanges(vehicle = {}, requestedCode = '', detailChanges = {}) {
  let current = vehicle; let last = { ok: true, data: {} };
  if (authoritativeSalespersonCode(vehicle) !== String(requestedCode || '').trim().toUpperCase()) {
    const result = await saveAuthoritativeVehicleSalesperson(current, requestedCode);
    if (!result || result.ok !== true) return result || { ok: false, code: 'salesperson_assignment_failed', data: null };
    last = result; current = result.data?.authoritativeVehicle || current;
  }
  if (!Object.keys(detailChanges || {}).length) return { ...last, data: { ...(last.data || {}), authoritativeVehicle: current } };
  const result = app.emailVehicleLocationService?.updateVehicleDetailFields
    ? await app.emailVehicleLocationService.updateVehicleDetailFields(current.__emailVehicleId, Number(current.__emailVehicleVersion || 0), detailChanges, salespersonAssignmentIdempotencyKey())
    : { ok: false, code: 'vehicle_detail_update_unavailable', data: null };
  if (!result || result.ok !== true) return result || { ok: false, code: 'vehicle_detail_update_unavailable', data: null };
  const applied = applyAuthoritativeVehicleReceiptToState(current, result, '', detailChanges);
  if (!applied) return { ok: false, code: 'vehicle_detail_receipt_invalid', data: result.data || null };
  void refreshEmailVehicleLocations();
  const readback = await reconcileAuthoritativeVehicleReceipt(result, applied.patched, '', detailChanges);
  if (readback.status === 'contradictory') return { ok: false, code: 'vehicle_detail_readback_contradictory', data: result.data || null };
  return { ...result, data: { ...(result.data || {}), authoritativeVehicle: readback.vehicle || applied.patched }, readbackPending: readback.status === 'pending' };
}

function resetEmailVehicleLocations() {
  app.emailVehicleLocationGeneration += 1;
  app.subletMutationQueues?.clear?.();
  try { app.emailVehicleLocationRealtime?.unsubscribe?.(); } catch (_error) { /* best-effort teardown */ }
  app.emailVehicleLocationRealtime = null;
  app.emailVehicleLocationService = null;
  app.emailVehicleLocationRows = [];
  app.emailVehicleLocationRevision = null;
  app.emailVehicleLocationError = '';
  app.emailVehicleReceiptOverlays = new Map();
  app.vehicleHistoryCache = new Map();
  app.vehicleHistoryRequestGeneration += 1;
  if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
  if (app.currentView === 'bus-pit') renderBusPitInspections();
}

async function refreshEmailVehicleLocations(options = {}) {
  const service = app.emailVehicleLocationService;
  const authority = String(window.PDC_AUTH_CONTEXT?.userId || '');
  if (!service || !authority || !getPdcSupabaseAccessToken()) {
    app.emailVehicleLocationError = !authority || !getPdcSupabaseAccessToken() ? 'not_authenticated' : 'service_unavailable';
    return false;
  }
  const refreshGeneration = options.refreshGeneration;
  const generation = ++app.emailVehicleLocationGeneration;
  const response = await service.snapshot(options.checkRevision === true
    ? { reconcile: true, knownRevision: app.emailVehicleLocationRevision } : {});
  if (generation !== app.emailVehicleLocationGeneration || service !== app.emailVehicleLocationService || authority !== String(window.PDC_AUTH_CONTEXT?.userId || '')) return false;
  if (refreshGeneration != null && refreshGeneration !== app.vehicleLocationsRefreshGeneration) return false;
  if (!response.ok) {
    app.emailVehicleLocationError = response.code || response.error || 'snapshot_unavailable';
    if (app.currentView === 'bus-pit' && refreshGeneration == null) renderBusPitInspections();
    return false;
  }
  if (response.unchanged === true) {
    const recovered = Boolean(app.emailVehicleLocationError);
    app.emailVehicleLocationError = '';
    // A reconnect may validate the retained snapshot without replacing rows.
    // Clear a visible error then; coordinated refresh owns its final paint.
    if (recovered && app.currentView === 'bus-pit' && refreshGeneration == null) renderBusPitInspections();
    return true;
  }
  const serverRows = applyPendingAuthoritativeVehicleReceiptOverlays(Array.isArray(response.data?.vehicles) ? response.data.vehicles : []);
  app.emailVehicleLocationRows = applyPendingSharedWorkStateOverlays(serverRows);
  const module = typeof window !== 'undefined'
    ? window.PDC_EMAIL_VEHICLE_LOCATION_SERVICE
    : globalThis.PDC_EMAIL_VEHICLE_LOCATION_SERVICE;
  if (typeof module?.reconcileVehicleRows === 'function') {
    const reconciled = module.reconcileVehicleRows(app.data, serverRows, { authoritative: true });
    runStorageTransaction('Reconcile authoritative email vehicles', [EDITS_KEY, ADDED_KEY, DELETED_KEY], () => {
      discardLegacyAuthoritativeSalespersonEdits(serverRows);
      saveAddedVehicles([]);
      saveJson(DELETED_KEY, []);
    });
    app.data = applyPendingSharedWorkStateOverlays(reconciled.rows);
    app.selectedRows.clear();
    const visibleRows = pdcSheetVehicles();
    if (!app.vehicleModalIdentity) {
      app.selectedStock = vehicleKey(visibleRows.find(vehicle => vehicle.toyotaStatus) || visibleRows[0] || app.data[0]);
    }
    app.emailVehicleIdentityConflictCount = reconciled.conflictCount;
    if (typeof qcPageNoteVehicleVersionsFromRows === 'function') qcPageNoteVehicleVersionsFromRows(app.data);
  }
  app.emailVehicleLocationRevision = response.data?.revision ?? null;
  app.emailVehicleLocationError = '';
  if (typeof window.refreshPdcFcAutoSendSentBadges === 'function') await window.refreshPdcFcAutoSendSentBadges();
  void refreshPdcPitLineTicks();
  // A coordinated refresh renders once after all of its readers settle.
  // Rendering here as well rebuilds the board with a partial refresh.
  if (refreshGeneration == null) renderAll();
  return true;
}

// r748 (F348): "Import running, part N of M" while a Revolution import applies. The board reader carries
// import_progress on every answer and every applied part bumps the board, so this needs no timer: the banner
// shows on the first answer that says running and hides on the first answer after the import finishes.
function renderImportProgressBanner(progress) {
  const host = document.getElementById('pdc-import-banner');
  if (!host) return;
  if (!progress || progress.running !== true) { host.hidden = true; host.innerHTML = ''; return; }
  const n = Number(progress.n_parts) || 0; const part = Math.min(Math.max(Number(progress.part) || 0, 0), n);
  const mode = progress.mode === 'preview' ? 'Import preview' : 'Import';
  const where = progress.status === 'queued' ? 'waiting to start' : n ? `part ${Math.max(part, 1)} of ${n}` : 'running';
  host.innerHTML = `<strong>${escapeHtml(mode)} running · ${escapeHtml(where)}</strong><span>Saves and moves may take a few seconds longer until it finishes. The board updates as each part lands.</span>`;
  host.hidden = false;
}

function initEmailVehicleLocationsIfAvailable(options = {}) {
  if (!window.PDC_AUTH_CONTEXT || !getPdcSupabaseAccessToken()) return null;
  const module = typeof window !== 'undefined'
    ? window.PDC_EMAIL_VEHICLE_LOCATION_SERVICE
    : globalThis.PDC_EMAIL_VEHICLE_LOCATION_SERVICE;
  if (typeof module?.createPdcEmailVehicleLocationService !== 'function') return null;
  if (!app.emailVehicleLocationService) {
    try {
      app.emailVehicleLocationService = module.createPdcEmailVehicleLocationService({
        config: window.PDC_SUPABASE_CONFIG || {},
        getAccessToken: () => getPdcSupabaseAccessToken(),
        onImportProgress: renderImportProgressBanner,
        subscribeRealtime: (tableName, onChange) => createPdcSupabaseTableRealtimeSubscription(tableName, {
          onChange,
          // Reconcile authoritatively after every initial subscription/reconnect
          // so events missed while disconnected cannot leave active/deleted views stale.
          onStatus: status => { if (status === 'SUBSCRIBED') onChange({ reconnect: true }); },
        }),
      });
    } catch (_error) { return null; }
  }
  if (!app.emailVehicleLocationRealtime) app.emailVehicleLocationRealtime = app.emailVehicleLocationService.subscribe((revision, event) => {
    // r910 (F492): no background board reload while a QC vehicle is open for ticking; it runs once the hold ends.
    if (typeof qcTickHoldBackgroundRefresh === 'function' && qcTickHoldBackgroundRefresh(revision, event)) return;
    if (event?.reconnect) void refreshEmailVehicleLocations({ checkRevision: true });
    else if (revision != null && Number(revision) === Number(app.emailVehicleLocationRevision)) return;
    else if (app.vehicleLocationsRefreshCoordinator) void refreshVehicleLocations({ supersede: true, deferSupersede: true, source: 'email_revision' });
    else refreshEmailVehicleLocations();
    if (vehicleLifecycleAdministratorActive() && app.deletedVehicleSnapshotState !== 'idle') loadDeletedVehicleSnapshot({ force: true });
  });
  if (options.skipInitialRefresh !== true) refreshEmailVehicleLocations();
  return app.emailVehicleLocationService;
}

// pdc-auth.js dispatches 'pdc-auth-ready' every time a session unlocks the
// app (initial load, token refresh redirect, re-login after sign-out).
// Re-run the shared-services init so a user who logs in while already on
// the Workshop Planner view (or returns after a session refresh) gets the
// data service without needing to navigate away and back.
window.addEventListener?.('pdc-auth-ready', () => {
  const userManagementAllowed = syncUserManagementAccess();
  if (!userManagementAllowed && (app.currentView === 'user-management' || app.currentRequestedView === 'user-management')) {
    showView('dashboard', { historyMode: 'replace' });
  }
  if (!userManagementAllowed && (app.currentView === 'update-history' || app.currentRequestedView === 'update-history')) {
    window.PdcUpdateHistory?.reset();
    showView('dashboard', { historyMode: 'replace' });
  }
  if (!userManagementAllowed && (app.currentView === 'fitting-stats' || app.currentRequestedView === 'fitting-stats')) {
    window.PdcFittingStats?.reset();
    showView('dashboard', { historyMode: 'replace' });
  }
  const fitterOnly = window.PDC_AUTH_CONTEXT?.role === 'fitter';
  document.body.classList.toggle('fitter-only', fitterOnly);
  if (fitterOnly) {
    teardownWorkshopPlannerScope();
    teardownWorkshopEligibilityOverview({ clearSnapshot: true });
    closeVehicleModal();
    showView('fitters', { historyMode: 'replace' });
    return;
  }
  // r643 (F258): the MMT login opens Sublet · MMT only.
  const mmtOnly = typeof window.pdcIsMmtSession === 'function' && window.pdcIsMmtSession();
  document.body.classList.toggle('mmt-only', mmtOnly);
  if (mmtOnly) {
    teardownWorkshopPlannerScope();
    teardownWorkshopEligibilityOverview({ clearSnapshot: true });
    closeVehicleModal();
    showView('mmt-sublet', { historyMode: 'replace' });
    return;
  }
  // r711 (F321): the PSC login opens Sublet · PSC only.
  const pscOnly = typeof window.pdcIsPscSession === 'function' && window.pdcIsPscSession();
  document.body.classList.toggle('psc-only', pscOnly);
  if (pscOnly) {
    teardownWorkshopPlannerScope();
    teardownWorkshopEligibilityOverview({ clearSnapshot: true });
    closeVehicleModal();
    showView('psc-sublet', { historyMode: 'replace' });
    return;
  }
  // Auth-ready also represents live token/role changes. Existing planner
  // services must discard their prior authority generation before reuse;
  // init alone intentionally reuses the instance and is not sufficient.
  window.__workshopDataService?.onTokenRefresh?.();
  if (app.currentView === 'workshop' && typeof initWorkshopSharedServicesIfEnabled === 'function') initWorkshopSharedServicesIfEnabled();
  if (app.currentView === 'workflow') {
    teardownWorkshopEligibilityOverview({ clearSnapshot: true });
    loadWorkshopEligibilitySnapshot('auth_ready');
  }
  if (typeof initVehicleLifecycleSharedActionsIfEnabled === 'function') initVehicleLifecycleSharedActionsIfEnabled();
  if (typeof refreshWorkshopReferenceData === 'function') refreshWorkshopReferenceData();
  resetDeletedVehicleAuthorityState();
  syncAdminNavigationVisibility();
  if (!vehicleLifecycleAdministratorActive() && (app.currentView === 'deleted' || app.currentRequestedView === 'deleted')) {
    showView('dashboard', { historyMode: 'replace' });
  }
  if (app.currentView === 'emailreview' && typeof renderAiBoardAdvisor === 'function') renderAiBoardAdvisor();
  resetPdcAuditorAuthorityState();
  if (app.currentView === 'ai-auditor') loadPdcAuditorSnapshot({ force: true });
  resetServerAiIntakeAuthorityState({ clearData: true });
  initServerAiIntakeIfAvailable();
  refreshServerAiIntake({ silent: true });
  loadSharedNavisionVisibleRows({ force: true });
  initEmailVehicleLocationsIfAvailable();
});

// Independent-review remediation, finding #5 / critical blocker #5:
// pdc-auth.js now subscribes every signed-in browser to its own
// pdc_user_roles row and fires 'pdc-auth-locked' the instant that row
// shows the account is no longer approved (disabled, rejected, or
// reverted to pending) -- without waiting for a reload or sign-out.
// This handler is the operational-data side of that fix: it tears down
// every shared realtime subscription and drops in-memory shared-mode
// state so a disabled user's already-open tab cannot continue showing
// (or silently re-deriving UI from) previously-loaded operational data.
window.addEventListener?.('pdc-auth-locked', () => {
  resetUserManagementAuthorityState();
  window.PdcUpdateHistory?.reset();
  if (app.currentView === 'update-history' || app.currentRequestedView === 'update-history') showView('dashboard', { historyMode: 'replace' });
  window.PdcFittingStats?.reset();
  if (app.currentView === 'fitting-stats' || app.currentRequestedView === 'fitting-stats') showView('dashboard', { historyMode: 'replace' });
  window.PdcBayManager?.reset();
  if (app.currentView === 'bay-manager' || app.currentRequestedView === 'bay-manager') showView('dashboard', { historyMode: 'replace' });
  if (app.currentView === 'key-manager' || app.currentRequestedView === 'key-manager') showView('dashboard', { historyMode: 'replace' }); // r958 (F531)
  window.PdcRevolutionUpload?.reset();
  if (app.currentView === 'revolution-upload' || app.currentRequestedView === 'revolution-upload') showView('dashboard', { historyMode: 'replace' });
  const userManagementView = document.getElementById('user-management');
  if (userManagementView) userManagementView.hidden = true;
  if (app.currentView === 'user-management' || app.currentRequestedView === 'user-management') showView('dashboard', { historyMode: 'replace' });
  invalidateVehicleLocationsRefresh();
  resetEmailVehicleLocations();
  resetDeletedVehicleAuthorityState();
  resetPdcAuditorAuthorityState();
  const advisorHost = document.getElementById('ai-board-advisor-content');
  if (advisorHost) advisorHost.replaceChildren();
  cancelWorkshopPlannerRender();
  teardownWorkshopEligibilityOverview({ clearSnapshot: true });
  removeWorkshopRecoveryListeners();
  try {
    if (window.__workshopRealtimeManager && typeof window.__workshopRealtimeManager.stop === 'function') {
      window.__workshopRealtimeManager.stop();
    }
  } catch (_err) { /* best-effort teardown */ }
  try {
    if (window.__workshopDataService && typeof window.__workshopDataService.destroy === 'function') {
      window.__workshopDataService.destroy();
    }
  } catch (_err) { /* best-effort teardown */ }
  try {
    if (window.__vehicleLifecycleIdentityResolver && typeof window.__vehicleLifecycleIdentityResolver.stop === 'function') {
      window.__vehicleLifecycleIdentityResolver.stop();
    }
    if (window.__vehicleLifecycleRealtimeManager && typeof window.__vehicleLifecycleRealtimeManager.stop === 'function') {
      window.__vehicleLifecycleRealtimeManager.stop();
    }
  } catch (_err) { /* best-effort teardown */ }
  try {
    if (USER_MANAGEMENT_STATE && USER_MANAGEMENT_STATE.realtimeChannel && window.PDC_SUPABASE && typeof window.PDC_SUPABASE.removeChannel === 'function') {
      window.PDC_SUPABASE.removeChannel(USER_MANAGEMENT_STATE.realtimeChannel);
      USER_MANAGEMENT_STATE.realtimeChannel = null;
      USER_MANAGEMENT_STATE.rows = [];
    }
  } catch (_err) { /* best-effort teardown */ }
  try {
    // Stage 2A: tear down every workshop reference/configuration data
    // realtime subscription (technicians/salespeople/sublet-providers/
    // bays) on lockout too, exactly like every other shared-data service
    // above -- otherwise a disabled user's already-open tab could keep
    // receiving mechanic/salesperson/provider/bay change events after
    // being locked out of everything else.
    if (window.__workshopReferenceDataService && typeof window.__workshopReferenceDataService.unsubscribeAll === 'function') {
      window.__workshopReferenceDataService.unsubscribeAll();
    }
  } catch (_err) { /* best-effort teardown */ }
  window.__workshopRealtimeManager = null;
  window.__workshopDataService = null;
  window.__workshopSharedActions = null;
  window.__vehicleLifecycleIdentityResolver = null;
  window.__vehicleLifecycleResolverDiagnostics = [];
  window.__vehicleLifecycleActions = null;
  window.__workshopReferenceDataService = null;
  resetServerAiIntakeAuthorityState({ clearData: true });
  clearSharedNavisionVisibilityReconnectTimer();
  app.sharedNavisionVisibleGeneration += 1;
  app.sharedNavisionVisibleLoadPromise = null;
  releaseSharedNavisionVisibilityChannel();
  app.sharedNavisionVisibleRealtimeState = 'idle';
  app.sharedNavisionVisibleReconnectAttempt = 0;
  app.sharedNavisionLocationReadOnlyKeys = new Set();
  app.vehicleWorkshopDetailRequestGeneration += 1;
  app.vehicleWorkshopDetailCache = new Map();
  app.pendingWorkshopBookingLink = null;
  closeVehicleModal();
  if (app.currentView === 'deleted' || app.currentRequestedView === 'deleted') showView('dashboard', { historyMode: 'replace' });
  app.selectedRows.clear();
  app.sharedNavisionVisibleRows = [];
  app.sharedNavisionVisibleRevision = null;
  app.sharedNavisionVisibleError = '';
  app.sharedNavisionVisibleState = 'idle';
  if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
  const adminGroup = document.getElementById('nav-admin-group');
  if (adminGroup) adminGroup.hidden = true;
  setAdminNavigationExpanded(false);
  const navItem = document.getElementById('nav-user-management');
  if (navItem) navItem.hidden = true;
});

function renderWorkshopPlannerWhenReady() {
  const requestedStage = app.activeWorkshopPlannerStage || '';
  if (typeof renderWorkshopPlanner === 'function' && !window.__workshopPlannerModulesLoading) {
    initWorkshopSharedServicesIfEnabled();
    if (app.activeWorkshopPlannerStage === requestedStage) renderWorkshopPlanner();
    return;
  }
  // Rapid station clicks share the pending module load and its single render.
  // The completion callback below reads the latest destination.
  if (window.__workshopPlannerModulesLoading) return;
  const root = $('#workshop-planner-root');
  if (root) root.innerHTML = '<div class="empty-state"><strong>Loading Workshop Planner</strong><span>Preparing scheduling controls…</span></div>';
  window.__workshopPlannerModulesLoading = true;
  // Load the shared-data service + realtime manager modules first. Both
  // stay completely inert (no snapshot fetch, no subscription, no writes)
  // unless window.PDC_SUPABASE_CONFIG.workshop.sharedData is explicitly set
  // to true; the planner UI/runtime is not modified by this load and
  // continues to operate exactly as before.
  Promise.all([
    loadExternalScript(`workshop-data-service.js?r424=2026.10.21.01&r417=2026.10.21.01&scope-reuse=2026.10.18.01&lock-recovery=2026.10.18.02&station-switch=2026.10.17.03&connection-speed=2026.10.17.01&planner-speed=2026.09.17.02&speed=2026.09.17.01&planner-reliability=2026.09.16.01&review-fixes=2026.09.13.01&v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}&bhavesh-followup=2026.09.23.01&search-drag=2026.10.19.04&hoist-corrections=2026.10.19.02&planner-followup=2026.10.19.01&r592=2026.10.28.r592`, 'workshop-data-service-script'),
    loadExternalScript(`workshop-realtime.js?v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}`, 'workshop-realtime-script'),
    loadExternalScript(`workshop-shared-actions.js?v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}&bhavesh-followup=2026.09.23.01&r417=2026.10.21.01&r424=2026.10.21.01&r569=2026.10.27.r569&r592=2026.10.28.r592&r597=2026.10.28.r597`, 'workshop-shared-actions-script'),
    loadExternalScript(`workshop-planner.js?station-scope=2026.10.19.03&r403=2026.10.21.01&r406=2026.10.21.01&r493=2026.10.22.r493&r948=2026.11.04.r948&r498=2026.10.22.r498&r407=2026.10.21.01&r415=2026.10.21.01&r417=2026.10.21.01&r424=2026.10.21.01&bay8-category=2026.10.20.01&returned-selection=2026.10.19.02&lock-recovery=2026.10.18.02&weekly-scope=2026.10.18.01&retired-readiness=2026.10.17.01&planner-navigation=2026.10.17.01&jobcard-categories=2026.10.15.01&site-speed=2026.10.16.02&department-bays=2026.10.15.02&closed-hours=2026.10.02.13&bus-clock=2026.09.21.02&bus-workflow=2026.09.21.01&bay-assignment=2026.09.17.01&planner-speed=2026.09.17.02&speed=2026.09.17.01&planner-reliability=2026.09.16.01&move-conflict-scope=2026.09.16.01&review-fixes=2026.09.13.01&performance=2026.09.13.01&v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}&search-identity=2026.09.11.01&vehicle-handover=2026.09.11.01&continuation=2026.09.11.01&weekday-hours=2026.09.11.01&hide-weekly-toolbar=2026.09.12.01&deep-review=2026.09.13.01&focused-fit=2026.09.14.01&ai-hours=2026.09.14.01&capacity=2026.09.14.01&one-hour-gap=2026.09.14.01&board-context=2026.09.15.01&best-slot=2026.09.16.01&fitters=2026.09.16.03&carry-over=2026.09.16.06&start-priority=2026.09.16.05&controller-moves=2026.09.16.01&bhavesh-followup=2026.09.23.01&search-drag=2026.10.19.04&hoist-corrections=2026.10.19.02&planner-followup=2026.10.19.01&r483=2026.10.22.r483&r527=2026.10.25.r527&r531=2026.10.26.r531&r535=2026.10.26.r535&r540=2026.10.26.r540&r548=2026.10.26.r548&r550=2026.10.26.r550&r549=2026.10.26.r549&r561=2026.10.27.r561&r570=2026.10.27.r570&search-jobcards=2026.10.26.01&r569=2026.10.27.r569&r573=2026.10.27.r573&r592=2026.10.28.r592&r594=2026.10.28.r594&r597=2026.10.28.r597&r601=2026.10.28.r601&r750=2026.10.30.r750&r860=2026.10.30.r860&r861=2026.10.30.r861&r862=2026.10.30.r862&r863=2026.10.30.r863`, 'workshop-planner-script')
  ])
    .then(() => {
      window.__workshopPlannerModulesLoading = false;
      // Navigation can change while these shared modules download. Initialize
      // the current destination, never the station captured by the first click.
      if (app.currentView !== 'workshop') return;
      initWorkshopSharedServicesIfEnabled();
      if (typeof renderWorkshopPlanner === 'function') renderWorkshopPlanner();
    })
    .catch(error => {
      window.__workshopPlannerModulesLoading = false;
      if (!root) return;
      root.innerHTML = '<div class="empty-state"><strong>Workshop Planner could not load</strong><span></span></div>';
      const message = root.querySelector('span');
      if (message) message.textContent = error.message || String(error);
    });
}

function ensureDashboardWorkshopProjectionReady() {
  const sharedMode = window.PDC_SUPABASE_CONFIG?.workshop?.sharedData === true;
  // The shared backend deliberately denies the legacy broad snapshot. Dashboard work chips are
  // sourced from canonical requirements/operation lines; planners load only their selected station.
  if (sharedMode) return false;
  if (typeof workshopLoadPlans === 'function') {
    initWorkshopSharedServicesIfEnabled();
    const service = window.__workshopDataService;
    if (sharedMode && service?.getScope?.()) {
      if (!window.__dashboardWorkshopScopeResetting) {
        window.__dashboardWorkshopScopeResetting = true;
        window.__workshopRealtimeManager?.stop?.();
        window.__workshopRealtimeManager = null;
        Promise.resolve(service.setScope(null)).then(() => {
          window.__dashboardWorkshopScopeResetting = false;
          if (app.currentView !== 'dashboard') return;
          initWorkshopSharedServicesIfEnabled();
          renderIncomingDashboardBoard();
        }).catch(error => {
          window.__dashboardWorkshopScopeResetting = false;
          console.warn('Workshop completion projection scope could not reset.', error);
        });
      }
      return false;
    }
    return !sharedMode || Boolean(service?.getTrustedSnapshot?.());
  }
  if (window.__dashboardWorkshopProjectionLoading) return false;
  window.__dashboardWorkshopProjectionLoading = true;
  loadExternalScript(`workshop-data-service.js?r424=2026.10.21.01&r417=2026.10.21.01&scope-reuse=2026.10.18.01&lock-recovery=2026.10.18.02&station-switch=2026.10.17.03&connection-speed=2026.10.17.01&planner-speed=2026.09.17.02&speed=2026.09.17.01&planner-reliability=2026.09.16.01&review-fixes=2026.09.13.01&v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}&bhavesh-followup=2026.09.23.01&search-drag=2026.10.19.04&hoist-corrections=2026.10.19.02&planner-followup=2026.10.19.01&r592=2026.10.28.r592`, 'workshop-data-service-script')
    .then(() => loadExternalScript(`workshop-realtime.js?v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}`, 'workshop-realtime-script'))
    .then(() => loadExternalScript(`workshop-shared-actions.js?v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}&bhavesh-followup=2026.09.23.01&r417=2026.10.21.01&r424=2026.10.21.01&r569=2026.10.27.r569&r592=2026.10.28.r592&r597=2026.10.28.r597`, 'workshop-shared-actions-script'))
    .catch(() => { /* read-only projection remains unavailable */ })
    .then(() => loadExternalScript(`workshop-planner.js?station-scope=2026.10.19.03&r403=2026.10.21.01&r406=2026.10.21.01&r493=2026.10.22.r493&r948=2026.11.04.r948&r498=2026.10.22.r498&r407=2026.10.21.01&r415=2026.10.21.01&r417=2026.10.21.01&r424=2026.10.21.01&bay8-category=2026.10.20.01&returned-selection=2026.10.19.02&lock-recovery=2026.10.18.02&weekly-scope=2026.10.18.01&retired-readiness=2026.10.17.01&planner-navigation=2026.10.17.01&jobcard-categories=2026.10.15.01&site-speed=2026.10.16.02&department-bays=2026.10.15.02&closed-hours=2026.10.02.13&bus-clock=2026.09.21.02&bus-workflow=2026.09.21.01&bay-assignment=2026.09.17.01&planner-speed=2026.09.17.02&speed=2026.09.17.01&review-fixes=2026.09.13.01&performance=2026.09.13.01&v=${encodeURIComponent(WORKSHOP_PLANNER_SCRIPT_VERSION)}&search-identity=2026.09.11.01&vehicle-handover=2026.09.11.01&continuation=2026.09.11.01&weekday-hours=2026.09.11.01&hide-weekly-toolbar=2026.09.12.01&deep-review=2026.09.13.01&focused-fit=2026.09.14.01&ai-hours=2026.09.14.01&capacity=2026.09.14.01&one-hour-gap=2026.09.14.01&board-context=2026.09.15.01&best-slot=2026.09.16.01&fitters=2026.09.16.03&carry-over=2026.09.16.06&start-priority=2026.09.16.05&controller-moves=2026.09.16.01&bhavesh-followup=2026.09.23.01&search-drag=2026.10.19.04&hoist-corrections=2026.10.19.02&planner-followup=2026.10.19.01&r483=2026.10.22.r483&r527=2026.10.25.r527&r531=2026.10.26.r531&r535=2026.10.26.r535&r540=2026.10.26.r540&r548=2026.10.26.r548&r550=2026.10.26.r550&r549=2026.10.26.r549&r561=2026.10.27.r561&r570=2026.10.27.r570&search-jobcards=2026.10.26.01&r569=2026.10.27.r569&r573=2026.10.27.r573&r592=2026.10.28.r592&r594=2026.10.28.r594&r597=2026.10.28.r597&r601=2026.10.28.r601&r750=2026.10.30.r750&r860=2026.10.30.r860&r861=2026.10.30.r861&r862=2026.10.30.r862&r863=2026.10.30.r863`, 'workshop-planner-script'))
    .then(() => {
      window.__dashboardWorkshopProjectionLoading = false;
      if (app.currentView !== 'dashboard') return;
      initWorkshopSharedServicesIfEnabled();
      renderIncomingDashboardBoard();
    })
    .catch(error => {
      window.__dashboardWorkshopProjectionLoading = false;
      console.warn('Workshop completion projection could not load.', error);
    });
  return false;
}

const qcPhotoEvidence = new Map();
const qcPageSignoffInFlight = new Set();
const qcPagePhotoUploadInFlight = new Set();
// r414 (F30): stored receipts are read back from the server, so a refresh never forgets a stored photo.
const qcPagePhotoReceiptReads = new Map();
const qcPageOperationPending = new Map();
// r838 (F480): saved ticks, kept for 60 s so a board reload fetched before the save cannot untick them.
const qcPageLineReceipts = new Map();
// r908 (F490): highest vehicle version seen per id; stale snapshots must not roll it back.
const qcVehicleVersionHigh = new Map();
const qcPageFeedback = new Map();
const qcPageSignoffBlockers = new Map();
const qcPageRejectInFlight = new Set();
// r947: a QC reject sends only the lines the inspector picked (no whole-car reject). key -> { picked: Set, reason }.
const qcPageRejectPicks = new Map();
let qcPageOperationMutationChain = Promise.resolve();
let qcPageNotice = '';
let qcSelectedVehicleKey = '';
let pdcWriteAuthorityGeneration = 0;
let qcPageAuthorityActor = window.PDC_AUTH_CONTEXT?.userId || '';

function capturePdcWriteAuthority() {
  return { generation: pdcWriteAuthorityGeneration, actor: window.PDC_AUTH_CONTEXT?.userId || '' };
}

function pdcWriteAuthorityCurrent(authority) {
  return Boolean(authority?.actor && authority.generation === pdcWriteAuthorityGeneration
    && authority.actor === window.PDC_AUTH_CONTEXT?.userId
    && ['operator', 'administrator'].includes(window.PDC_AUTH_CONTEXT?.role));
}

function qcPageResetAuthority(event = {}) {
  const interrupted = qcPageOperationPending.size || qcPagePhotoUploadInFlight.size
    || qcPageSignoffInFlight.size || qcPageRejectInFlight.size;
  pdcWriteAuthorityGeneration += 1;
  qcPageOperationMutationChain = Promise.resolve();
  qcPageOperationPending.clear(); qcPagePhotoUploadInFlight.clear(); qcPageLineReceipts.clear();
  if (typeof qcVehicleVersionHigh !== 'undefined') qcVehicleVersionHigh.clear();
  qcPageSignoffInFlight.clear(); qcPageRejectInFlight.clear(); qcPageFeedback.clear();
  if (typeof qcPageSignoffBlockers !== 'undefined') qcPageSignoffBlockers.clear();
  if (typeof qcTickResetAuthority === 'function') qcTickResetAuthority(); // r910 (F492): stored drafts stay per user in this tab
  app.partsCompletionInFlight?.clear(); app.partsStoppageInFlight?.clear();
  app.rftTransportActionInFlight?.clear(); app.rftTransportActionOwners?.clear();
  qcSelectedVehicleKey = '';
  qcPageNotice = interrupted ? 'Your session changed. Queued QC actions were cancelled. Refresh and check the saved state before continuing.' : '';
  if (event.detail?.reason !== 'session-revalidate') qcPhotoEvidence.clear();
}

window.addEventListener?.('pdc-auth-locked', qcPageResetAuthority);
window.addEventListener?.('pdc-auth-ready', () => {
  const actor = window.PDC_AUTH_CONTEXT?.userId || '';
  if (actor !== qcPageAuthorityActor) {
    qcPageResetAuthority();
    qcPhotoEvidence.clear();
    qcPageAuthorityActor = actor;
  }
});

function qcPageIsMobile() {
  return Boolean(window.matchMedia?.('(max-width: 900px)').matches);
}

function qcPagePendingKey(key = '', lineIdentity = '') {
  return `${String(key || '').trim()}::${String(lineIdentity || '').trim()}`;
}

function qcPageVehicleIsEligible(vehicle = {}) {
  if (vehicle.__emailVehicleServerAuthoritative !== true || typeof vehicleInQualityControlGate !== 'function' || !vehicleInQualityControlGate(vehicle) || vehicle.pdcQcComplete === true) return false;
  if (vehicle.pdcQcOperationLinesProjectionPresent !== true) return false;
  return qcPageOperationLines(vehicle).length > 0;
}

function qcPageVehicles() {
  const rows = typeof pdcSheetVehicles === 'function' ? pdcSheetVehicles() : [];
  const eligible = rows.filter(qcPageVehicleIsEligible);
  return typeof qcPageSortByKeyNumber === 'function' ? qcPageSortByKeyNumber(eligible) : eligible; // r615 (F230)
}

const QC_KEY_BADGE_STYLE = 'display:inline-block;background:#0f172a;color:#fff;border-radius:6px;padding:1px 7px;margin-right:4px;font-weight:800;';
// r615 (F230): QC lists lowest key number first; vehicles with no key go last.
function qcPageKeySortValue(vehicle = {}) {
  const n = Number.parseInt(String(vehicleKeyNumber(vehicle) || '').replace(/\D+/g, ''), 10);
  return Number.isFinite(n) && n > 0 ? n : Number.POSITIVE_INFINITY;
}
function qcPageSortByKeyNumber(rows = []) {
  return rows.map((row, index) => ({ row, index, key: qcPageKeySortValue(row) }))
    .sort((a, b) => (a.key === b.key ? a.index - b.index : a.key < b.key ? -1 : 1))
    .map(item => item.row);
}

// r615 (F230): the QC tablet/phone cards (pdc-qc-mobile.js is frozen) get a key badge after each render.
function qcPageDecorateKeyNumbers(host = document.querySelector('#qc-page-host')) {
  if (!host) return;
  const cards = host.querySelectorAll('.qc-phone-vehicle[data-qc-open-vehicle]');
  if (!cards.length) return;
  const byKey = new Map(qcPageVehicles().map(row => [qcPageVehicleKey(row), row]));
  cards.forEach(card => {
    if (card.querySelector('.qc-key-badge')) return;
    const keyNo = vehicleKeyNumber(byKey.get(card.dataset.qcOpenVehicle) || {});
    const top = card.querySelector('.qc-phone-card-top strong');
    if (!keyNo || !top) return;
    const badge = document.createElement('b');
    badge.className = 'qc-key-badge';
    badge.style.cssText = QC_KEY_BADGE_STYLE;
    badge.textContent = `K${keyNo}`;
    top.prepend(badge, ' ');
  });
}
if (typeof window !== 'undefined' && typeof MutationObserver === 'function' && typeof document !== 'undefined') {
  const qcKeyObserverStart = () => {
    const host = document.querySelector('#qc-page-host');
    if (!host || host.dataset.qcKeyObserver) return;
    host.dataset.qcKeyObserver = '1';
    new MutationObserver(() => qcPageDecorateKeyNumbers(host)).observe(host, { childList: true });
    qcPageDecorateKeyNumbers(host);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', qcKeyObserverStart); else setTimeout(qcKeyObserverStart, 0);
}

function qcPageVehicleKey(vehicle = {}) {
  return String(vehicleKey(vehicle) || vehicle.id || '').trim();
}

function qcPageOperationLineIsDeferredPit(vehicle = {}, line = {}) {
  // r400: QC cannot tick the external Department of Transport Pit inspection
  // (it happens after QC) or job-card notes (information only). The server
  // helper public.pdc_qc_line_not_checkable_400 uses the same two stages.
  if (['PIT_INSPECTION', 'JOB_CARD_NOTES'].includes(String(line?.stageCode || '').trim().toUpperCase())) return true;
  // r405 (F14): a Pit and weigh / Pit inspection line is Pit by its wording, whatever
  // it was filed under (Dept 139 job cards file "PIT AND WEIGH" as Fitting). Same rule
  // as the server helper public.pdc_line_is_pit_401.
  if (/(^|[^A-Z])PITS? ?(AND|&|\+|\/|N|'N')? ?WEIGH|(^|[^A-Z])PIT ?INSPECT/.test(String(line?.description || '').toUpperCase().replace(/\s+/g, ' '))) return true;
  if (String(line.sourceKind || '') !== 'authenticated') return false;
  const sourceLineId = String(line.sourceLineId || '').trim().toLowerCase();
  if (!sourceLineId) return false;
  return (Array.isArray(vehicle.pdcEmailOperationLines) ? vehicle.pdcEmailOperationLines : []).some(sourceLine => (
    String(sourceLine?.operation_line_id || '').trim().toLowerCase() === sourceLineId
    && String(sourceLine?.work_key || '').trim().toLowerCase() === 'pitinspection'
  ));
}

// r401: Pit and weigh ticks. Optional, tickable by any department, never blocking.
// Ticks live in their own server table (pdc_pit_line_ticks_401), so a tick never
// changes the QC projection, work items, progress or any gate.
const pdcPitTickState = new Map();
const pdcPitTickPending = new Set();
const pdcPitTickErrors = new Map();
let pdcPitTickHandlerInstalled = false;

function pdcPitTickKey(vehicleId = '', lineIdentity = '') {
  return `${String(vehicleId || '').trim().toLowerCase()}::${String(lineIdentity || '').trim()}`;
}

function pdcPitTickFor(vehicle = {}, line = {}) {
  return pdcPitTickState.get(pdcPitTickKey(vehicle.__emailVehicleId, line.lineIdentity)) || null;
}

function pdcPitTickCaption(vehicle = {}, line = {}) {
  const tick = pdcPitTickFor(vehicle, line);
  const error = pdcPitTickErrors.get(pdcPitTickKey(vehicle.__emailVehicleId, line.lineIdentity));
  const done = tick?.ticked === true
    ? ` · ticked by ${tick.ticked_by_email || 'staff'}${tick.ticked_role ? ` (${tick.ticked_role})` : ''}${tick.ticked_at ? ` ${formatPdcPitTickTime(tick.ticked_at)}` : ''}`
    : '';
  return `Pit and weigh · optional, any department can tick · never blocks QC or RFT${done}${error ? ` · ${error}` : ''}`;
}

function formatPdcPitTickTime(value = '') {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  try { return date.toLocaleString('en-AU', { timeZone: 'Australia/Perth', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) + ' AWST'; }
  catch (_error) { return date.toISOString(); }
}

function pdcPitTickCheckboxHtml(vehicle = {}, line = {}) {
  installPdcPitTickHandler();
  const vehicleId = String(vehicle.__emailVehicleId || '');
  if (!vehicleId || !line?.lineIdentity) return '<span class="qc-work-marker" aria-hidden="true">–</span>';
  const key = pdcPitTickKey(vehicleId, line.lineIdentity);
  const tick = pdcPitTickState.get(key);
  const pending = pdcPitTickPending.has(key);
  return `<input type="checkbox" class="pdc-pit-tick" data-pit-tick-vehicle="${escapeHtml(vehicleId)}" data-pit-tick-line="${escapeHtml(line.lineIdentity)}" data-pit-tick-version="${Number(tick?.version || 0)}" ${tick?.ticked === true ? 'checked' : ''} ${pending ? 'disabled aria-busy="true"' : ''} title="Optional: any department can tick Pit and weigh. It never blocks anything." aria-label="${escapeHtml(`Pit and weigh ${line.description || ''} (optional, never blocks)`)}" />`;
}

async function refreshPdcPitLineTicks() {
  const service = app.emailVehicleLocationService;
  if (!service || typeof service.readPitLineTicks !== 'function') return false;
  const result = await service.readPitLineTicks(null);
  if (!result?.ok) return false;
  pdcPitTickState.clear();
  for (const tick of result.data.ticks) pdcPitTickState.set(pdcPitTickKey(tick.vehicle_id, tick.line_identity), tick);
  if (['qc', 'bus-pit'].includes(app.currentView)) renderActiveView();
  return true;
}

async function setPdcPitLineTick(vehicleId = '', lineIdentity = '', expectedVersion = 0, ticked = false) {
  const service = app.emailVehicleLocationService;
  const key = pdcPitTickKey(vehicleId, lineIdentity);
  if (!service || typeof service.setPitLineTick !== 'function' || pdcPitTickPending.has(key)) return false;
  pdcPitTickPending.add(key); pdcPitTickErrors.delete(key);
  try {
    const result = await service.setPitLineTick(vehicleId, lineIdentity, expectedVersion, ticked, crypto.randomUUID());
    if (result?.ok && result.data?.tick) {
      pdcPitTickState.set(key, { ...result.data.tick, vehicle_id: vehicleId });
      return true;
    }
    const code = String(result?.code || '');
    pdcPitTickErrors.set(key, /UNAUTHORIZED/i.test(code) ? 'your role cannot tick' : /VERSION/i.test(code) ? 'changed elsewhere, reloaded' : 'not saved, try again');
    await refreshPdcPitLineTicks();
    return false;
  } finally {
    pdcPitTickPending.delete(key);
    if (['qc', 'bus-pit'].includes(app.currentView)) renderActiveView();
  }
}

function installPdcPitTickHandler() {
  if (pdcPitTickHandlerInstalled || typeof document === 'undefined' || typeof document.addEventListener !== 'function') return;
  pdcPitTickHandlerInstalled = true;
  document.addEventListener('change', event => {
    const input = event.target?.closest?.('input[data-pit-tick-line]');
    if (!input) return;
    void setPdcPitLineTick(input.dataset.pitTickVehicle, input.dataset.pitTickLine, Number(input.dataset.pitTickVersion || 0), input.checked === true);
  });
}

// r838 (F480): Craig 3 Nov 07:54 "when I tick an item and then another one, sometimes the one I ticked before undoes and it
// refreshes". A board reload that started before a tick was saved landed after it, putting the old tick and the old vehicle
// version back; the next tick then hit a version conflict and reloaded. A saved tick now wins over an older reload.
// r908 (F490): receipts stay until the snapshot vehicle version catches up; version high-water stops stale snapshots rolling back.
function qcPageNoteVehicleVersionHigh(vehicleId = '', version = 0) {
  const id = String(vehicleId || '').trim();
  const next = Number(version) || 0;
  if (!id || next < 1) return Number(qcVehicleVersionHigh.get(id) || 0);
  const high = Math.max(Number(qcVehicleVersionHigh.get(id) || 0), next);
  qcVehicleVersionHigh.set(id, high);
  return high;
}

function qcPageApplyVehicleVersionHigh(vehicle = {}) {
  const id = String(vehicle.__emailVehicleId || '').trim();
  if (!id) return;
  const snapshotVersion = Number(vehicle.__emailVehicleVersion || 0);
  if (snapshotVersion > 0) qcPageNoteVehicleVersionHigh(id, snapshotVersion);
  const high = Number(qcVehicleVersionHigh.get(id) || 0);
  if (high > snapshotVersion) {
    // r910 (F492): remember what the snapshot itself said, so saved-tick receipts are not dropped by the high-water bump.
    if (!(Number(vehicle.__qcSnapshotVehicleVersion) > 0) && snapshotVersion > 0) vehicle.__qcSnapshotVehicleVersion = snapshotVersion;
    vehicle.__emailVehicleVersion = high;
  }
}

function qcPageNoteVehicleVersionsFromRows(rows = []) {
  (Array.isArray(rows) ? rows : []).filter(Boolean).forEach(qcPageApplyVehicleVersionHigh);
}

function qcPageTickExpectedVehicleVersion(vehicle = {}) {
  qcPageApplyVehicleVersionHigh(vehicle);
  return Number(vehicle.__emailVehicleVersion || 0);
}

function qcPageSignoffBlockersKey(vehicle = {}) {
  return String(vehicle.__emailVehicleId || '').trim();
}

function qcPageLineHoursMissing(line = {}) {
  if (String(line.stageCode || '') === 'SUBLET') return false;
  const hours = line.estimatedHours;
  return hours === null || hours === undefined || hours === '' || !Number.isFinite(Number(hours));
}

function qcPageLocalSignoffBlockers(vehicle = {}) {
  return qcPageOperationLines(vehicle).flatMap(line => {
    const label = qcPageStageLabel(line.stageCode);
    const title = line.description || line.operationNo || 'a line';
    if (line.completed !== true) return [`${label}: ${title} is not ticked.`];
    if (qcPageLineHoursMissing(line)) return [`${label}: ${title} has no hours, so it cannot be signed off.`];
    return [];
  });
}

function qcPageOperationVersionConflict(code = '') {
  return /PDC_379_VEHICLE_VERSION_CONFLICT|PT409|40001|LINE_VERSION|version|conflict/i.test(String(code || ''));
}

async function qcPageResolveVehicleVersionForRetry(vehicle = {}) {
  const id = String(vehicle.__emailVehicleId || '').trim();
  if (!id) return 0;
  const service = app.emailVehicleLocationService;
  if (service && typeof service.readQcVehicleVersion === 'function') {
    try {
      const read = await service.readQcVehicleVersion(id);
      if (read?.ok === true && Number(read.version) > 0) {
        qcPageNoteVehicleVersionHigh(id, read.version);
        vehicle.__emailVehicleVersion = Math.max(Number(vehicle.__emailVehicleVersion || 0), Number(read.version));
        return Number(vehicle.__emailVehicleVersion);
      }
    } catch (_error) { /* optional RPC; fall back to the high-water mark */ }
  }
  const high = Number(qcVehicleVersionHigh.get(id) || 0);
  if (high > 0) vehicle.__emailVehicleVersion = Math.max(Number(vehicle.__emailVehicleVersion || 0), high);
  return Number(vehicle.__emailVehicleVersion || 0);
}

function qcPageRefreshSignoffBlockersAfterTicks() {
  if (typeof qcPageSignoffBlockers === 'undefined') return;
  qcPageSignoffBlockers.clear();
  const selected = qcPageVehicles().find(row => qcPageVehicleKey(row) === qcSelectedVehicleKey);
  if (selected) void qcPageLoadSignoffOutstanding(selected);
}

// r913 (F495): Craig 3 Nov 13:53, key 617: "clicked save, but it unticked all of the items". The 27 ticks were saved, but the
// save bumped the open vehicle's own version to the receipt version, so the very next render threw every receipt away; the
// board reload 0.02 s later got the previous board (the 3 s prewarm was mid-rebuild for 9.3 s) and showed all 27 unticked.
// The version the snapshot itself carried is now pinned before a save bumps it, so receipts last until a board that already
// has the save arrives.
function qcPagePinSnapshotVehicleVersion(vehicle = {}) {
  if (!vehicle || Number(vehicle.__qcSnapshotVehicleVersion) > 0) return;
  const own = Number(vehicle.__emailVehicleVersion || 0);
  if (own > 0) vehicle.__qcSnapshotVehicleVersion = own;
}

function qcPageApplyLineReceipts(vehicle = {}) {
  // r910 (F492): compare with the version the snapshot carried, not the high-water mark (that bump made a 6-10 s old
  // board reload drop a saved tick's receipt, so the tick flipped off and the next tick hit LINE_VERSION_CONFLICT).
  const snapshotVersion = Number(vehicle.__qcSnapshotVehicleVersion || vehicle.__emailVehicleVersion || 0);
  qcPageApplyVehicleVersionHigh(vehicle);
  const id = String(vehicle.__emailVehicleId || '');
  if (!id || typeof qcPageLineReceipts === 'undefined' || !qcPageLineReceipts.size || !Array.isArray(vehicle.pdcQcOperationLines)) return;
  const now = Date.now();
  for (const [receiptKey, receipt] of qcPageLineReceipts) {
    if (now - receipt.at > 120000) { qcPageLineReceipts.delete(receiptKey); continue; }
    if (receipt.vehicleId !== id) continue;
    const line = vehicle.pdcQcOperationLines.find(item => item?.lineIdentity === receipt.lineIdentity);
    if (!line) continue;
    if (snapshotVersion >= receipt.vehicleVersion) { qcPageLineReceipts.delete(receiptKey); continue; }
    line.completed = receipt.completed; line.completedBy = receipt.completedBy; line.completedAt = receipt.completedAt;
    line.lineVersion = receipt.lineVersion;
  }
}

function qcPageOperationLines(vehicle = {}) {
  if (typeof qcPageApplyLineReceipts === 'function') qcPageApplyLineReceipts(vehicle);
  const stageRank = stage => stage === 'UNALLOCATED_MAPPING_REVIEW' ? 2 : stage === 'SUBLET' ? 1 : 0;
  const source = Array.isArray(vehicle.pdcQcOperationLines) ? vehicle.pdcQcOperationLines : [];
  // r910 (F492): unsaved ticks from this phone's draft are shown on copies of the lines; the saved state is untouched.
  return (typeof qcTickDraftOverlay === 'function' ? qcTickDraftOverlay(vehicle, source) : source)
    .filter(line => line?.active === true
      && /^(?:source|manual):[0-9a-f-]{36}$/.test(String(line.lineIdentity || ''))
      && !qcPageOperationLineIsDeferredPit(vehicle, line))
    .sort((a, b) => stageRank(String(a.stageCode)) - stageRank(String(b.stageCode)) || String(a.stageCode).localeCompare(String(b.stageCode)) || String(a.operationNo).localeCompare(String(b.operationNo), undefined, { numeric: true }) || String(a.lineIdentity).localeCompare(String(b.lineIdentity)));
}

function qcPageAllOperationLinesComplete(vehicle = {}) {
  const lines = qcPageOperationLines(vehicle);
  return lines.length > 0 && lines.every(line => line.completed === true);
}

function qcPageSignoffStatus(vehicle = {}, options = {}) {
  const photoValid = options.photoValid === true;
  const local = qcPageLocalSignoffBlockers(vehicle);
  // r910 (F492): with unsaved ticks the server list is out of date; sign-off saves them first, then the server checks again.
  const unsaved = typeof qcTickDraftUnsavedCount === 'function' && !Array.isArray(options.outstanding) ? qcTickDraftUnsavedCount(vehicle) : 0;
  if (unsaved > 0) {
    const ready = local.length === 0 && photoValid && qcPageAllOperationLinesComplete(vehicle);
    const first = `${unsaved} unsaved tick${unsaved === 1 ? '' : 's'} will be saved first.`;
    return { ready, shown: local, checked: true, note: local.length ? `${local.join(' ')} ${first}` : !photoValid ? `Store a completion photo before final sign-off. ${first}` : `${first} Then final sign-off records QC evidence and moves the vehicle to RFT.` };
  }
  const forced = Array.isArray(options.outstanding);
  const cache = qcPageSignoffBlockers.get(qcPageSignoffBlockersKey(vehicle));
  const checked = forced || Boolean(cache && cache.loading !== true && Array.isArray(cache.outstanding));
  const server = (forced ? options.outstanding : (checked ? cache.outstanding : []))
    .map(item => String(item || '').trim())
    .filter(Boolean);
  const shown = checked ? [...new Set([...server, ...local])] : local;
  const ready = checked && shown.length === 0 && photoValid && qcPageAllOperationLinesComplete(vehicle);
  const note = shown.length
    ? shown.join(' ')
    : !checked
      ? 'Checking what is still outstanding…'
      : !photoValid
        ? 'Store a completion photo before final sign-off.'
        : 'Photo stored. Final sign-off records QC evidence and moves the vehicle to RFT. No salesperson email or dealer-transit timer starts until explicit RFT Booked.';
  return { ready, note, shown, checked };
}

async function qcPageLoadSignoffOutstanding(vehicle = {}) {
  const id = String(vehicle.__emailVehicleId || '');
  if (!id) return;
  const cacheKey = qcPageSignoffBlockersKey(vehicle);
  if (qcPageSignoffBlockers.has(cacheKey)) return;
  qcPageSignoffBlockers.set(cacheKey, { loading: true, outstanding: null });
  const service = app.emailVehicleLocationService;
  let outstanding = [];
  let failed = typeof service?.readQcSignoffOutstanding !== 'function';
  if (!failed) {
    try {
      const result = await service.readQcSignoffOutstanding(id);
      if (result?.ok === true && result.ready === true) outstanding = [];
      else if (Array.isArray(result?.outstanding) && result.outstanding.length) outstanding = result.outstanding.map(item => String(item || '')).filter(Boolean);
      else if (result?.message) outstanding = [String(result.message)];
      else failed = true;
    } catch (_error) {
      failed = true;
    }
  }
  qcPageSignoffBlockers.set(cacheKey, {
    loading: false,
    outstanding: failed ? ['QC sign-off status could not be read. Refresh QC before signing off.'] : outstanding,
  });
  if (typeof renderQualityControlPage === 'function') renderQualityControlPage();
}

function qcPageOperationHoursLabel(line = {}) {
  if (line.stageCode === 'SUBLET') return 'Hours not required';
  if (line.estimatedHours === null || line.estimatedHours === undefined || line.estimatedHours === '') return 'Unknown hours';
  const numeric = Number(line.estimatedHours);
  return Number.isFinite(numeric) ? `${line.hoursProvenance==='ai_estimated'?'AI estimate · ':''}${numeric.toFixed(2).replace(/\.00$/, '')} h` : 'Unknown hours';
}

function qcPageStageLabel(stage = '') {
  if (String(stage) === 'UNALLOCATED_MAPPING_REVIEW') return 'Unallocated – mapping review';
  if (String(stage) === 'SUBLET') return 'Sublet';
  return pmbStageLabel(stage) || String(stage || '');
}

function qcPageWorkItemsHtml(vehicle = {}) {
  const key = qcPageVehicleKey(vehicle);
  const groups = groupBy(qcPageOperationLines(vehicle), line => String(line.stageCode || 'UNKNOWN'));
  const html = Object.entries(groups).map(([stage, lines]) => `<section class="qc-operation-group" aria-labelledby="qc-operation-${escapeHtml(stage)}">
    <h4 id="qc-operation-${escapeHtml(stage)}">${escapeHtml(qcPageStageLabel(stage))}</h4>
    ${lines.map(line => {
    const hoursUnknown = stage !== 'SUBLET' && (line.estimatedHours === null || line.estimatedHours === undefined || line.estimatedHours === '' || !Number.isFinite(Number(line.estimatedHours)));
    const mappingReview = stage === 'UNALLOCATED_MAPPING_REVIEW';
    const pending = qcPageOperationPending.get(qcPagePendingKey(key, line.lineIdentity));
    // r805 (F420): a queued tick shows its new state straight away.
    const shownDone = pending ? pending.checked === true : line.completed;
    return `<label class="qc-work-item qc-operation-line ${shownDone ? 'is-complete' : 'is-required'} ${pending ? 'is-saving' : ''}" data-qc-line-identity="${escapeHtml(line.lineIdentity)}" ${pending ? 'aria-busy="true"' : ''}>
      <input type="checkbox" data-qc-operation-check="${escapeHtml(key)}" data-qc-line-identity="${escapeHtml(line.lineIdentity)}" data-qc-line-version="${Number(line.lineVersion || 0)}" ${shownDone ? 'checked' : ''} ${(mappingReview || hoursUnknown || pending) ? `disabled title="${pending ? 'Saving this operation' : mappingReview ? 'Station mapping review is required before QC completion' : 'Unknown operation hours require review before QC completion'}"` : ''} aria-label="${escapeHtml(`${line.operationNo || 'Manual'} ${line.description} ${pending ? 'saving' : mappingReview ? 'requires station mapping review' : hoursUnknown ? 'requires hours review' : line.completed ? 'completed' : 'not completed'}`)}" />
      <span class="qc-work-marker" aria-hidden="true">${pending ? '…' : line.completed ? '✓' : '○'}</span>
      <span class="qc-work-copy"><strong>${escapeHtml(`${line.operationNo || 'Manual'} · ${line.description}`)}</strong><small class="${line.hoursProvenance==='ai_estimated' && stage!=='SUBLET'?'pdc-ai-estimate':''}">${escapeHtml(`${qcPageStageLabel(stage)} · ${qcPageOperationHoursLabel(line)} · ${line.jobCardNumber ? `JC ${line.jobCardNumber}` : line.sourceKind === 'manual' ? 'Audited manual line' : 'Source JC unavailable'}`)}</small></span>
    </label>`;
  }).join('')}
  </section>`).join('');
  if (vehicle.pdcQcOperationLinesProjectionPresent !== true) {
    return '<div class="qc-operation-unavailable" role="alert"><strong>QC operation lines are still loading</strong><span>The authenticated server snapshot is missing its QC projection. Refresh to retry; the source operation evidence has not been treated as absent.</span></div>';
  }
  // r400: job-card notes are listed for information, with no checkbox.
  // r401: Pit and weigh lines get an optional checkbox (own tick store); ticking is never required.
  // r405: every line kept off the checklist as Pit (stage, wording or email rule) is listed here.
  const afterQcLines = (Array.isArray(vehicle.pdcQcOperationLines) ? vehicle.pdcQcOperationLines : [])
    .filter(line => line?.active === true && qcPageOperationLineIsDeferredPit(vehicle, line));
  const afterQcHtml = afterQcLines.length ? `<section class="qc-operation-group qc-after-qc-lines" aria-label="Not required for QC">
    <h4>Not required for QC</h4>
    ${afterQcLines.map(line => {
    const notes = String(line.stageCode || '').trim().toUpperCase() === 'JOB_CARD_NOTES';
    return `<div class="qc-work-item qc-operation-line is-info">${notes ? '<span class="qc-work-marker" aria-hidden="true">–</span>' : pdcPitTickCheckboxHtml(vehicle, line)}<span class="qc-work-copy"><strong>${escapeHtml(`${line.operationNo || 'Manual'} · ${line.description}`)}</strong><small>${escapeHtml(notes ? 'Job card notes · information only' : pdcPitTickCaption(vehicle, line))}</small></span></div>`;
  }).join('')}
  </section>` : '';
  return (html || '<div class="qc-operation-unavailable" role="alert"><strong>No active operation lines are available</strong><span>QC completion remains blocked until an authenticated or audited manual operation line is available.</span></div>') + afterQcHtml;
}

function qcPageVehicleCardHtml(vehicle = {}, selected = false) {
  const key = qcPageVehicleKey(vehicle);
  const stock = displayStockNumber(vehicle) || key || 'No stock';
  const unit = displayVehicle(vehicle) || 'Vehicle not listed';
  const consultant = consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || 'No salesperson';
  const allComplete = qcPageAllOperationLinesComplete(vehicle);
  const status = vehicle.pdcQcFixStatus === 'Pending QC fixes' ? 'Pending QC fixes' : allComplete ? 'Ready to sign off' : 'Work incomplete';
  return `<button class="qc-vehicle-card ${selected ? 'is-selected' : ''} ${allComplete ? 'is-ready' : 'needs-work'}" type="button" data-qc-open-vehicle="${escapeHtml(key)}" data-qc-vehicle-key="${escapeHtml(key)}" aria-pressed="${selected ? 'true' : 'false'}">
    <span class="qc-vehicle-card-top"><strong>${vehicleKeyNumber(vehicle) ? `<b class="qc-key-badge" style="${QC_KEY_BADGE_STYLE}">K${escapeHtml(vehicleKeyNumber(vehicle))}</b> ` : ''}${escapeHtml(stock)}</strong><span class="qc-status-pill ${allComplete ? 'is-green' : 'is-warning'}">${escapeHtml(status)}</span></span>
    <span class="qc-vehicle-card-unit">${escapeHtml(unit)}</span>
    <span class="qc-vehicle-card-meta"><span>${escapeHtml(vehicleCustomerName(vehicle) || vehicle.customerName || 'Customer unavailable')}</span><span>${escapeHtml(vehicleKeyNumber(vehicle) || 'No key')}</span><span>${escapeHtml(consultant)}</span></span>
  </button>`;
}

function qcPagePhotoDisabledReason(vehicle = {}, key = '') {
  if (vehicle.__emailVehicleServerAuthoritative !== true) return '';
  if (!vehicle.__emailVehicleId || Number(vehicle.__emailVehicleVersion || 0) < 1) return 'QC identity/version is unavailable; refresh the authenticated snapshot.';
  if (vehicle.pdcQcRetestCycleId) {
    if (vehicle.pdcQcRetestFreshCycleOpen !== true) return 'This fresh QC cycle is closed; no new photo can be accepted.';
    const rawActiveLineCount = (Array.isArray(vehicle.pdcQcOperationLines) ? vehicle.pdcQcOperationLines : [])
      .filter(line => line?.active === true && /^(?:source|manual):[0-9a-f-]{36}$/.test(String(line.lineIdentity || ''))).length;
    if (rawActiveLineCount !== 17 || !qcPageAllOperationLinesComplete(vehicle)) return 'Complete all 17 operation lines before uploading a QC photo.';
  }
  if (qcPagePhotoUploadInFlight.has(key)) return 'Uploading QC photo…';
  // r414 (F30): one stored photo per QC inspection; a second upload was refused and looked like a stuck receipt.
  if (typeof qcPhotoEvidence !== 'undefined' && typeof qcPhotoEvidenceIsValid === 'function' && qcPhotoEvidenceIsValid(qcPhotoEvidence.get(key))) return 'A completion photo is already stored for this QC.';
  return '';
}

// r414 (F30): read the stored completion photo receipt back from the server (once per vehicle version), so the
// Sign off button shows after a refresh, on another device, or when a re-upload is refused as already recorded.
async function qcPageLoadStoredPhoto(key = '', { force = false } = {}) {
  const cleanKey = String(key || '').trim();
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === cleanKey);
  const service = app.emailVehicleLocationService;
  if (!vehicle || vehicle.pdcQcRetestCycleId || vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId
    || !service || typeof service.readQcPhotoReceipt !== 'function' || qcPagePhotoUploadInFlight.has(cleanKey)) return false;
  if (qcPhotoEvidenceIsValid(qcPhotoEvidence.get(cleanKey))) return true;
  const readKey = `${vehicle.__emailVehicleId}:${Number(vehicle.__emailVehicleVersion || 0)}`;
  if (!force && qcPagePhotoReceiptReads.get(cleanKey) === readKey) return false;
  qcPagePhotoReceiptReads.set(cleanKey, readKey);
  const authority = capturePdcWriteAuthority();
  const result = await service.readQcPhotoReceipt(vehicle.__emailVehicleId);
  if (!pdcWriteAuthorityCurrent(authority) || qcPagePhotoUploadInFlight.has(cleanKey)) return false;
  if (!result?.ok || !result.data) {
    if (result?.code && result.code !== 'qc_photo_none' && force) qcPageFeedback.set(cleanKey, { kind: 'error', message: qcPagePhotoErrorMessage(result.code) });
    if (force) renderQualityControlPage();
    return false;
  }
  const data = result.data;
  const stored = { ...data, status: 'accepted', photoReceiptId: data.photo_receipt_id, originalFilename: data.original_filename || 'Stored image',
    byteLength: Number(data.byte_length || 0), originalByteLength: Number(data.original_byte_length || 0), imageWidth: Number(data.image_width || 0),
    imageHeight: Number(data.image_height || 0), sha256: data.sha256, url: '', storedAt: data.stored_at || '' };
  if (!qcPhotoEvidenceIsValid(stored)) return false;
  qcPhotoEvidence.set(cleanKey, stored);
  qcPageFeedback.set(cleanKey, { kind: 'saved', message: 'The completion photo stored earlier for this QC was found. It is used for sign-off.' });
  renderQualityControlPage();
  return true;
}

function qcPagePhotoErrorMessage(code = '') {
  const messages = {
    qc_photo_invalid_input: 'Choose an image between 1 byte and 10 MB.',
    qc_photo_compression_unavailable: 'This browser could not prepare the image. Try another photo or browser.',
    qc_photo_compression_limit: 'The image could not be reduced below the staging size limit.',
    qc_retest_cycle_invalid: 'The fresh QC cycle identity is invalid; refresh the authenticated snapshot.',
    qc_retest_cycle_not_found: 'The fresh QC cycle is no longer available; refresh the authenticated snapshot.',
    qc_retest_vehicle_version_or_location_conflict: 'This vehicle changed in another session; the latest QC state must be reloaded.',
    qc_retest_photo_storage_object_not_owned: 'The staging photo upload is not owned by the authenticated QC user.',
    qc_retest_photo_replay_mismatch: 'This photo request conflicts with an existing immutable QC receipt.',
    qc_photo_upload_failed: 'The staging photo upload failed. Retry without leaving this QC screen.',
    qc_photo_receipt_invalid: 'Staging accepted no verifiable QC photo receipt.',
    qc_photo_already_recorded: 'A completion photo is already stored for this QC. It is used for sign-off; no new photo is needed.',
    qc_photo_vehicle_not_in_qc: 'This vehicle is no longer in QC. Refresh the QC page.',
    vehicle_version_conflict: 'This vehicle changed in another session. Refresh the QC page and try again.',
    not_authorized: 'Your account cannot store QC photos. Ask an administrator.',
    qc_photo_storage_missing: 'The stored photo file could not be found. Clear it and choose the photo again.',
  };
  return messages[String(code || '')] || 'The QC photo was not stored. No sign-off was recorded.';
}

function qcPhotoEvidenceIsValid(photo = {}) {
  return photo?.status === 'accepted'
    && /^[0-9a-f-]{36}$/i.test(String(photo.photoReceiptId || ''))
    && String(photo.bucket_id || '').trim() === 'pdc-qc-evidence-staging'
    && String(photo.storage_path || '').trim().length > 0
    && String(photo.content_type || '').toLowerCase().startsWith('image/')
    && Number(photo.byteLength || photo.byte_length || 0) >= 1
    && Number(photo.byteLength || photo.byte_length || 0) <= 1048576
    && Number(photo.originalByteLength || photo.original_byte_length || 0) >= 1
    && Number(photo.originalByteLength || photo.original_byte_length || 0) <= 10485760
    && Number(photo.imageWidth || photo.image_width || 0) >= 1
    && Number(photo.imageWidth || photo.image_width || 0) <= 1600
    && Number(photo.imageHeight || photo.image_height || 0) >= 1
    && Number(photo.imageHeight || photo.image_height || 0) <= 1600
    && /^[a-f0-9]{64}$/i.test(String(photo.sha256 || ''));
}

function qcPageDetailHtml(vehicle = {}) {
  const key = qcPageVehicleKey(vehicle);
  const stock = displayStockNumber(vehicle) || key || 'No stock';
  const photo = qcPhotoEvidence.get(key);
  const allComplete = qcPageAllOperationLinesComplete(vehicle);
  const hasSalesperson = Boolean(cleanNavisionText(vehicle.salespersonCode || '') && cleanNavisionText(vehicle.salespersonEmail || ''));
  const photoValid = qcPhotoEvidenceIsValid(photo);
  const signoff = qcPageSignoffStatus(vehicle, { photoValid });
  const signoffBusy = qcPageSignoffInFlight.has(key);
  const inputId = `qc-photo-input-${key}`;
  const photoDisabledReason = qcPagePhotoDisabledReason(vehicle, key);
  const feedback = qcPageFeedback.get(key);
  const photoBusy = qcPagePhotoUploadInFlight.has(key);
  const rejectBusy = qcPageRejectInFlight.has(key);
  return `<section class="qc-detail-card" aria-labelledby="qc-detail-title">
    <header class="qc-detail-header">
      <div><button class="small-button qc-mobile-back" type="button" data-qc-back-to-list>← QC vehicles</button><span class="eyebrow">Selected vehicle</span><h3 id="qc-detail-title">${escapeHtml(stock)}</h3><p>${escapeHtml(displayVehicle(vehicle) || 'Vehicle not listed')} · ${escapeHtml(consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || 'No salesperson')}</p></div>
      <span class="qc-detail-state ${allComplete ? 'is-green' : 'is-warning'}">${allComplete ? 'All work green' : 'Complete outstanding work'}</span>
    </header>
    <div class="qc-save-feedback ${feedback?.kind === 'error' ? 'is-error' : feedback?.kind === 'saved' ? 'is-saved' : ''}" role="status" aria-live="polite">${photoBusy ? '<progress class="qc-photo-progress" aria-label="Uploading QC photo"></progress><span>Uploading QC photo…</span>' : escapeHtml(feedback?.message || '')}</div>
    <div class="qc-detail-identifiers">${vehicleIdentityStackHtml(vehicle, { className: 'qc-identity', button: false })}</div>
    <fieldset class="qc-work-checklist" aria-label="Work to inspect for selected vehicle"><legend>Work to inspect</legend><div class="qc-work-list">${qcPageWorkItemsHtml(vehicle)}</div></fieldset>
    <div class="qc-photo-panel">
      <div><strong>Completion photo</strong><p>Add a completion photo before signing off. The saved photo stays with the vehicle’s QC record.</p></div>
      <label class="qc-photo-picker" for="${escapeHtml(inputId)}" aria-disabled="${photoDisabledReason ? 'true' : 'false'}"><span>${photoValid ? 'Photo stored · choose another only after this receipt is cleared' : photo?.status === 'uploading' ? 'Uploading QC photo…' : 'Take or choose QC photo'}</span><input id="${escapeHtml(inputId)}" type="file" accept="image/*" data-qc-photo="${escapeHtml(key)}" aria-describedby="${escapeHtml(inputId)}-status"${photoDisabledReason ? ' disabled' : ''} /></label>
      <div id="${escapeHtml(inputId)}-status" class="qc-photo-status" aria-live="polite">${photoDisabledReason ? escapeHtml(photoDisabledReason) : ''}</div>
      ${photo?.url || photoValid ? `<div class="qc-photo-preview">${photo?.url ? `<img src="${escapeHtml(photo.url)}" alt="QC completion photo for ${escapeHtml(stock)}" />` : ''}<span>${photoValid ? `${photo?.url ? '' : 'Stored photo · '}${escapeHtml(photo.originalFilename || 'Stored image')} · ${escapeHtml(String(photo.originalByteLength || photo.original_byte_length || 0))} → ${escapeHtml(String(photo.byteLength || photo.byte_length || 0))} bytes · ${escapeHtml(String(photo.imageWidth || photo.image_width || 0))}×${escapeHtml(String(photo.imageHeight || photo.image_height || 0))} · SHA-256 ${escapeHtml(photo.sha256 || '')}` : photo?.status === 'error' ? `${escapeHtml(photo.originalFilename || 'Selected image')} · Not stored. Clear it and choose the photo again.` : `${escapeHtml(photo.originalFilename || 'Selected image')} · Storing the photo…`}</span></div>` : '<div class="qc-photo-empty">No stored completion photo</div>'}
      ${photo && !photoValid && photo.status !== 'uploading' ? `<button class="small-button qc-photo-clear" type="button" data-qc-photo-clear="${escapeHtml(key)}">Clear / choose another</button>` : ''}
      </div>
      <div class="qc-detail-actions"><button class="small-button qc-reject-action" type="button" data-qc-reject="${escapeHtml(key)}" ${rejectBusy ? 'disabled' : ''}>${rejectBusy ? 'Rejecting…' : 'Reject / QC Fix Required'}</button></div>
      ${qcPageRejectPicks.has(key) ? qcPageRejectPickHtml(vehicle, key) : ''}
      <div class="qc-signoff-bar"><span class="qc-signoff-note" role="status">${escapeHtml(signoff.note)}</span><button class="primary qc-signoff-button" type="button" data-qc-signoff="${escapeHtml(key)}" ${(signoff.ready && !signoffBusy) ? '' : 'disabled'}>${signoffBusy ? 'Signing off…' : 'Sign off QC → RFT'}</button></div>
  </section>`;
}

function qcPageReceiptLineApply(vehicle = {}, lineIdentity = '', result = {}) {
  const line = qcPageOperationLines(vehicle).find(item => item.lineIdentity === String(lineIdentity || ''));
  const receiptLine = result?.data?.line;
  if (!line || !receiptLine || String(receiptLine.line_identity || '') !== String(lineIdentity || '')) return false;
  if (typeof qcPageSignoffBlockers !== 'undefined') qcPageSignoffBlockers.delete(qcPageSignoffBlockersKey(vehicle));
  line.completed = receiptLine.completed === true;
  line.completedBy = receiptLine.completed_by || null;
  line.completedAt = receiptLine.completed_at || null;
  line.lineVersion = Number(receiptLine.version || line.lineVersion || 0);
  const afterVersion = Number(result.data?.vehicle_version_after || 0);
  qcPagePinSnapshotVehicleVersion(vehicle);
  if (afterVersion > 0) qcPageNoteVehicleVersionHigh(vehicle.__emailVehicleId, afterVersion);
  vehicle.__emailVehicleVersion = Math.max(Number(vehicle.__emailVehicleVersion || 0), afterVersion, Number(qcVehicleVersionHigh.get(String(vehicle.__emailVehicleId || '')) || 0));
  if (vehicle.__emailVehicleId && typeof qcPageLineReceipts !== 'undefined') {
    qcPageLineReceipts.set(`${vehicle.__emailVehicleId}::${line.lineIdentity}`, { at: Date.now(), vehicleId: String(vehicle.__emailVehicleId),
      lineIdentity: line.lineIdentity, completed: line.completed, completedBy: line.completedBy, completedAt: line.completedAt,
      lineVersion: line.lineVersion, vehicleVersion: Number(vehicle.__emailVehicleVersion || 0) });
  }
  return true;
}

async function qcPageAwaitOperationSnapshot(key = '', lineIdentity = '', completed = false, attempts = 3, authority = capturePdcWriteAuthority()) {
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    await refreshEmailVehicleLocations();
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    const current = qcPageVehicles().find(row => qcPageVehicleKey(row) === String(key || '').trim());
    const currentLine = qcPageOperationLines(current || {}).find(item => item.lineIdentity === String(lineIdentity || ''));
    if (currentLine && currentLine.completed === completed) return true;
    await new Promise(resolve => window.setTimeout(resolve, 120 * (attempt + 1)));
  }
  return false;
}

async function qcPageSetOperationState(key = '', lineIdentity = '', checked = false, authority = capturePdcWriteAuthority()) {
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  let vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === String(key || '').trim());
  let line = qcPageOperationLines(vehicle || {}).find(item => item.lineIdentity === String(lineIdentity || ''));
  const service = app.emailVehicleLocationService;
  if (!vehicle || !line || !service || typeof service.setQcOperationCompletion !== 'function'
      || vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId || Number(vehicle.__emailVehicleVersion || 0) < 1) {
    qcPageFeedback.set(key, { kind: 'error', message: 'This operation is not bound to stable QC authority. Nothing was changed.' });
    renderQualityControlPage();
    return false;
  }
  let result = await service.setQcOperationCompletion(vehicle.__emailVehicleId, qcPageTickExpectedVehicleVersion(vehicle),
    line.lineIdentity, Number(line.lineVersion || 0), checked, crypto.randomUUID());
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  // r908 (F490): on version conflict, re-read this vehicle's version (or use the high-water mark) and retry once — no full board reload.
  if (!result?.ok && qcPageOperationVersionConflict(result?.code)) {
    await qcPageResolveVehicleVersionForRetry(vehicle);
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    line = qcPageOperationLines(vehicle).find(item => item.lineIdentity === String(lineIdentity || '')) || line;
    if (line?.completed === checked) {
      qcPageFeedback.set(key, { kind: 'saved', message: `${line.operationNo || 'Operation'} saved. You can continue ticking other jobs.` });
      renderQualityControlPage();
      return true;
    }
    result = await service.setQcOperationCompletion(vehicle.__emailVehicleId, qcPageTickExpectedVehicleVersion(vehicle),
      line.lineIdentity, Number(line.lineVersion || 0), checked, crypto.randomUUID());
    if (!pdcWriteAuthorityCurrent(authority)) return false;
  }
  if (!result?.ok || result.data?.line?.completed !== checked || !qcPageReceiptLineApply(vehicle, line.lineIdentity, result)) {
    await qcPageAwaitOperationSnapshot(key, lineIdentity, checked, 1, authority);
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    qcPageFeedback.set(key, { kind: 'error', message: /PT409|40001|version|conflict/i.test(String(result?.code || ''))
      ? 'This operation changed in another session. The latest QC state has been reloaded.'
      : 'This operation was not saved. Tap it again after the latest state loads.' });
    renderQualityControlPage();
    return false;
  }
  qcPageFeedback.set(key, { kind: 'saved', message: `${line.operationNo || 'Operation'} saved. You can continue ticking other jobs.` });
  renderQualityControlPage();
  if (typeof qcPageScheduleSync === 'function') qcPageScheduleSync(authority);
  return true;
}

// r805 (F420): Craig 1 Nov 19:20 "when i click an item to say its done, its saving each click and taking a while".
// The server receipt is the saved state. The whole board snapshot (2 to 9 s) is reloaded once, 2.5 s after the last tick,
// not three times after every tick (each reload cancelled the one before, so the page waited on the last of them).
let qcPageSyncTimer = 0;
function qcPageScheduleSync(authority = capturePdcWriteAuthority()) {
  if (qcPageSyncTimer) window.clearTimeout(qcPageSyncTimer);
  qcPageSyncTimer = window.setTimeout(() => {
    qcPageSyncTimer = 0;
    if (qcPageOperationPending.size) { qcPageScheduleSync(authority); return; }
    if (!pdcWriteAuthorityCurrent(authority)) return;
    void refreshEmailVehicleLocations().then(() => { if (pdcWriteAuthorityCurrent(authority)) renderQualityControlPage(); });
  }, 2500);
}

// r838 (F480): the phone QC page (pdc-qc-mobile.js, a frozen shared file) draws a queued tick from the saved state, so each
// tick flicked back to empty until its turn to save. After every QC redraw, queued ticks are painted with the state being saved.
function qcPagePaintQueuedTicks() {
  if (typeof qcTickDraftPaint === 'function') qcTickDraftPaint(); // r910 (F492): Save ticks bar and unsaved marks
  if (!qcPageOperationPending.size || typeof document === 'undefined') return;
  for (const [pendingKey, queued] of qcPageOperationPending) {
    if (typeof queued?.checked !== 'boolean') continue;
    const cut = pendingKey.indexOf('::');
    const key = pendingKey.slice(0, cut), lineIdentity = pendingKey.slice(cut + 2);
    document.querySelectorAll('input[data-qc-operation-check][data-qc-line-identity]').forEach(node => {
      if (node.dataset.qcOperationCheck !== key || node.dataset.qcLineIdentity !== lineIdentity) return;
      node.checked = queued.checked;
      node.closest('.qc-phone-item')?.classList.toggle('is-checked', queued.checked);
    });
  }
}

function qcPageWrapRenderForQueuedTicks() {
  if (typeof renderQualityControlPage !== 'function' || renderQualityControlPage.__r838) return;
  const inner = renderQualityControlPage;
  const wrapped = function (...args) { const out = inner.apply(this, args); qcPagePaintQueuedTicks(); return out; };
  wrapped.__r838 = true;
  renderQualityControlPage = wrapped;
}

function qcPageQueueOperationState(key = '', lineIdentity = '', checked = false, input = null) {
  qcPageWrapRenderForQueuedTicks();
  // r910 (F492): batch mode keeps the tick on this phone until Save ticks. ?qcBatch=0 keeps the per-tick save below.
  if (typeof qcTickBatchEnabled === 'function' && qcTickBatchEnabled()) { qcTickDraftToggle(key, lineIdentity, checked, input); return; }
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return;
  const pendingKey = qcPagePendingKey(key, lineIdentity);
  if (qcPageOperationPending.has(pendingKey)) return;
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === String(key || '').trim());
  const line = qcPageOperationLines(vehicle || {}).find(item => item.lineIdentity === String(lineIdentity || ''));
  // r805 (F420): the tick shows straight away; a failed save reloads the real state.
  if (input) input.checked = checked === true;
  const queued = { checked, authority };
  qcPageOperationPending.set(pendingKey, queued);
  qcPageFeedback.set(key, { kind: 'saving', message: `${line?.operationNo || 'Operation'} queued for saving…` });
  renderQualityControlPage();
  qcPageOperationMutationChain = qcPageOperationMutationChain
    .then(() => qcPageSetOperationState(key, lineIdentity, checked, authority))
    .catch(() => {
      if (!pdcWriteAuthorityCurrent(authority)) return false;
      qcPageFeedback.set(key, { kind: 'error', message: 'The operation could not be saved. The authoritative state was retained.' });
      return false;
    })
    .finally(() => {
      if (qcPageOperationPending.get(pendingKey) !== queued) return;
      qcPageOperationPending.delete(pendingKey);
      renderQualityControlPage();
      if (!qcPageOperationPending.size && typeof qcPageRefreshSignoffBlockersAfterTicks === 'function') qcPageRefreshSignoffBlockersAfterTicks();
    });
}

// r910 (F492): Craig 3 Nov 12:32 "when we open it, it doesn't refresh until we click save at the bottom so we can tick
// everything at the time and then when we hit save, acknowledges it all". With batch mode on (the default; ?qcBatch=0 turns it
// off for this tab), a tick only changes a local draft. Nothing is sent and the board does not reload while the vehicle is open.
// Save ticks sends the whole draft in one call (set_pdc_qc_operation_completion_batch_910) and confirms it from the server answer.
// The draft is kept in this tab's sessionStorage (line ids and true/false only) so an iOS reload or the camera does not lose it.
const QC_TICK_DRAFT_STORAGE_PREFIX = 'pdc.qc.tickdraft.v1:';
const QC_TICK_DRAFT_MAX_AGE_MS = 12 * 60 * 60 * 1000;
const QC_TICK_HOLD_MAX_MS = 20 * 60 * 1000;
const qcTickDrafts = new Map();
const qcTickSaveInFlight = new Map();
let qcTickHoldSince = 0;
let qcTickDeferredRefresh = '';

let qcTickBatchFlag = null;
function qcTickBatchEnabled() {
  if (qcTickBatchFlag === null) {
    qcTickBatchFlag = true;
    try {
      const query = `${window.location?.search || ''}&${String(window.location?.hash || '').split('?')[1] || ''}`;
      const flag = /(?:^|[?&])qcBatch=([01])(?:&|$)/.exec(query);
      if (flag && window.sessionStorage) {
        if (flag[1] === '0') window.sessionStorage.setItem('pdc.qc.batch', '0');
        else window.sessionStorage.removeItem('pdc.qc.batch');
      }
      if (window.sessionStorage?.getItem('pdc.qc.batch') === '0') qcTickBatchFlag = false;
    } catch (_error) { /* storage blocked: default on */ }
  }
  const service = app.emailVehicleLocationService;
  // Needs the r910 service (batch call); if the database function is missing the save falls back to one 379 call per tick.
  return qcTickBatchFlag && Boolean(service && typeof service.setQcOperationCompletionBatch === 'function' && typeof service.setQcOperationCompletion === 'function');
}

function qcTickDraftStorageKey(vehicleId = '') {
  return `${QC_TICK_DRAFT_STORAGE_PREFIX}${window.PDC_AUTH_CONTEXT?.userId || 'anon'}:${String(vehicleId || '')}`;
}

function qcTickDraftNewBatchKey() {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : '';
}

function qcTickDraftGet(vehicleId = '', create = false) {
  const id = String(vehicleId || '').trim();
  if (!id) return null;
  const memoryKey = qcTickDraftStorageKey(id);
  let draft = qcTickDrafts.get(memoryKey) || null;
  if (!draft) {
    try {
      const stored = JSON.parse(window.sessionStorage?.getItem(memoryKey) || 'null');
      if (stored && typeof stored === 'object' && Date.now() - Number(stored.at || 0) < QC_TICK_DRAFT_MAX_AGE_MS && stored.lines && typeof stored.lines === 'object') {
        const lines = new Map(Object.entries(stored.lines)
          .filter(([lineIdentity, value]) => /^(?:source|manual):[0-9a-f-]{36}$/.test(lineIdentity) && typeof value === 'boolean'));
        if (lines.size) draft = { lines, batchKey: String(stored.batchKey || '') || qcTickDraftNewBatchKey(), at: Number(stored.at) };
      } else if (stored) window.sessionStorage?.removeItem(memoryKey);
    } catch (_error) { draft = null; }
    if (draft) qcTickDrafts.set(memoryKey, draft);
  }
  if (!draft && create) {
    draft = { lines: new Map(), batchKey: qcTickDraftNewBatchKey(), at: Date.now() };
    qcTickDrafts.set(memoryKey, draft);
  }
  return draft;
}

function qcTickDraftPersist(vehicleId = '') {
  const memoryKey = qcTickDraftStorageKey(vehicleId);
  const draft = qcTickDrafts.get(memoryKey);
  try {
    if (!draft || !draft.lines.size) {
      qcTickDrafts.delete(memoryKey);
      window.sessionStorage?.removeItem(memoryKey);
      return;
    }
    window.sessionStorage?.setItem(memoryKey, JSON.stringify({ lines: Object.fromEntries(draft.lines), batchKey: draft.batchKey, at: draft.at }));
  } catch (_error) { /* in-memory draft still works */ }
}

function qcTickDraftDiscard(vehicleId = '') {
  qcTickDrafts.delete(qcTickDraftStorageKey(vehicleId));
  try { window.sessionStorage?.removeItem(qcTickDraftStorageKey(vehicleId)); } catch (_error) { /* nothing stored */ }
}

// Server state of the line (after saved-tick receipts), never the draft.
function qcTickServerLine(vehicle = {}, lineIdentity = '') {
  return (Array.isArray(vehicle.pdcQcOperationLines) ? vehicle.pdcQcOperationLines : []).find(line => line?.lineIdentity === String(lineIdentity || '')) || null;
}

// Changes still to send: draft entries that differ from the server state. Entries that now match are dropped.
function qcTickDraftChanges(vehicle = {}) {
  const id = String(vehicle?.__emailVehicleId || '').trim();
  if (!id || !qcTickBatchEnabled()) return [];
  const draft = qcTickDraftGet(id);
  if (!draft || !draft.lines.size) return [];
  if (typeof qcPageApplyLineReceipts === 'function') qcPageApplyLineReceipts(vehicle);
  const changes = [];
  let pruned = false;
  for (const [lineIdentity, completed] of draft.lines) {
    const line = qcTickServerLine(vehicle, lineIdentity);
    if (!line || line.active !== true || (line.completed === true) === completed) { draft.lines.delete(lineIdentity); pruned = true; continue; }
    changes.push({ line_identity: lineIdentity, completed });
  }
  if (pruned && !qcTickSaveInFlight.has(id)) qcTickDraftPersist(id);
  return changes;
}

function qcTickDraftUnsavedCount(vehicle = {}) {
  return qcTickDraftChanges(vehicle).length;
}

function qcTickDraftOverlay(vehicle = {}, lines = []) {
  const id = String(vehicle?.__emailVehicleId || '').trim();
  let stored = false;
  try { stored = window.sessionStorage?.length > 0; } catch (_error) { stored = false; }
  if (!id || (!qcTickDrafts.size && !stored)) return lines;
  if (!qcTickBatchEnabled()) return lines;
  const draft = qcTickDraftGet(id);
  if (!draft || !draft.lines.size) return lines;
  if (typeof renderQualityControlPage === 'function' && !renderQualityControlPage.__r838) {
    qcPageWrapRenderForQueuedTicks();
    Promise.resolve().then(() => qcPagePaintQueuedTicks());
  }
  return lines.map(line => {
    if (!draft.lines.has(line.lineIdentity)) return line;
    const wanted = draft.lines.get(line.lineIdentity);
    return (line.completed === true) === wanted ? line : { ...line, completed: wanted, __qcUnsaved: true };
  });
}

function qcTickDraftToggle(key = '', lineIdentity = '', checked = false, input = null) {
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  qcPageWrapRenderForQueuedTicks();
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === String(key || '').trim());
  const id = String(vehicle?.__emailVehicleId || '').trim();
  const line = vehicle ? qcTickServerLine(vehicle, lineIdentity) : null;
  if (!vehicle || !id || !line || vehicle.__emailVehicleServerAuthoritative !== true) {
    if (input) input.checked = !checked;
    qcPageFeedback.set(key, { kind: 'error', message: 'This operation is not bound to stable QC authority. Nothing was changed.' });
    renderQualityControlPage();
    return false;
  }
  if (qcTickSaveInFlight.has(id)) { if (input) input.checked = !checked; return false; }
  const draft = qcTickDraftGet(id, true);
  if ((line.completed === true) === (checked === true)) draft.lines.delete(line.lineIdentity);
  else draft.lines.set(line.lineIdentity, checked === true);
  draft.batchKey = qcTickDraftNewBatchKey();
  draft.at = Date.now();
  qcTickDraftPersist(id);
  if (input) input.checked = checked === true;
  const count = qcTickDraftUnsavedCount(vehicle);
  qcPageFeedback.set(key, count
    ? { kind: 'saving', message: `${count} unsaved tick${count === 1 ? '' : 's'}. Tap Save ticks at the bottom when you are done.` }
    : { kind: '', message: '' });
  renderQualityControlPage();
  return true;
}

function qcTickApplyBatchLines(vehicle = {}, data = {}) {
  const afterVersion = Number(data.vehicle_version_after || 0);
  const id = String(vehicle.__emailVehicleId || '');
  qcPagePinSnapshotVehicleVersion(vehicle);
  if (afterVersion > 0) qcPageNoteVehicleVersionHigh(id, afterVersion);
  vehicle.__emailVehicleVersion = Math.max(Number(vehicle.__emailVehicleVersion || 0), afterVersion, Number(qcVehicleVersionHigh.get(id) || 0));
  for (const item of Array.isArray(data.lines) ? data.lines : []) {
    const line = qcTickServerLine(vehicle, item?.line_identity);
    if (!line) continue;
    line.completed = item.completed === true;
    line.completedBy = item.completed_by || null;
    line.completedAt = item.completed_at || null;
    line.lineVersion = Number(item.line_version || line.lineVersion || 0);
    if (typeof qcPageLineReceipts !== 'undefined') {
      qcPageLineReceipts.set(`${id}::${line.lineIdentity}`, { at: Date.now(), vehicleId: id, lineIdentity: line.lineIdentity, completed: line.completed,
        completedBy: line.completedBy, completedAt: line.completedAt, lineVersion: line.lineVersion, vehicleVersion: Number(vehicle.__emailVehicleVersion || 0) });
    }
  }
}

// Used only when the 910 function is not on the database yet: the same draft is sent line by line through 379.
async function qcTickSaveSerially(vehicle = {}, changes = [], authority = capturePdcWriteAuthority()) {
  const service = app.emailVehicleLocationService;
  const failed = [];
  let saved = 0;
  for (const change of changes) {
    if (!pdcWriteAuthorityCurrent(authority)) return { ok: false, saved, failed: changes.slice(saved) };
    let line = qcTickServerLine(vehicle, change.line_identity);
    if (!line) { failed.push(change); continue; }
    let result = await service.setQcOperationCompletion(vehicle.__emailVehicleId, qcPageTickExpectedVehicleVersion(vehicle), line.lineIdentity, Number(line.lineVersion || 0), change.completed, crypto.randomUUID());
    if (!result?.ok && qcPageOperationVersionConflict(result?.code)) {
      await qcPageResolveVehicleVersionForRetry(vehicle);
      result = await service.setQcOperationCompletion(vehicle.__emailVehicleId, qcPageTickExpectedVehicleVersion(vehicle), line.lineIdentity, Number(line.lineVersion || 0), change.completed, crypto.randomUUID());
    }
    if (!result?.ok || result.data?.line?.completed !== change.completed) { failed.push({ ...change, code: result?.code || '' }); continue; }
    qcTickApplyBatchLines(vehicle, { vehicle_version_after: result.data.vehicle_version_after, lines: [{ line_identity: line.lineIdentity, completed: result.data.line.completed,
      completed_by: result.data.line.completed_by, completed_at: result.data.line.completed_at, line_version: result.data.line.version }] });
    saved += 1;
  }
  return { ok: failed.length === 0, saved, failed };
}

async function qcTickDraftSave(key = '', authority = capturePdcWriteAuthority()) {
  const cleanKey = String(key || '').trim();
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === cleanKey);
  const id = String(vehicle?.__emailVehicleId || '').trim();
  if (!vehicle || !id) return { ok: false, saved: 0, failed: [] };
  if (qcTickSaveInFlight.has(id)) return qcTickSaveInFlight.get(id);
  const changes = qcTickDraftChanges(vehicle);
  if (!changes.length) return { ok: true, saved: 0, failed: [] };
  const draft = qcTickDraftGet(id, true);
  let settle = null;
  qcTickSaveInFlight.set(id, new Promise(resolve => { settle = resolve; }));
  const queued = new Map(changes.map(change => [qcPagePendingKey(cleanKey, change.line_identity), { checked: change.completed, authority, batch: true }]));
  for (const [pendingKey, value] of queued) qcPageOperationPending.set(pendingKey, value);
  qcPageFeedback.set(cleanKey, { kind: 'saving', message: `Saving ${changes.length} tick${changes.length === 1 ? '' : 's'}…` });
  renderQualityControlPage();
  const run = async () => {
    const service = app.emailVehicleLocationService;
    let outcome;
    let result = typeof service?.setQcOperationCompletionBatch === 'function'
      ? await service.setQcOperationCompletionBatch(id, changes, draft.batchKey)
      : { ok: false, code: 'qc_operation_batch_unavailable' };
    if (!pdcWriteAuthorityCurrent(authority)) return { ok: false, saved: 0, failed: changes };
    if (result?.ok) {
      qcTickApplyBatchLines(vehicle, result.data);
      const failed = result.data.failed || [];
      outcome = { ok: failed.length === 0, saved: (result.data.applied || []).length + (result.data.unchanged || []).length, failed };
    } else if (result?.code === 'qc_operation_batch_unavailable' && typeof service?.setQcOperationCompletion === 'function') {
      outcome = await qcTickSaveSerially(vehicle, changes, authority);
    } else {
      outcome = { ok: false, saved: 0, failed: changes, code: String(result?.code || '') };
    }
    if (outcome.ok || outcome.saved) draft.batchKey = qcTickDraftNewBatchKey();
    return outcome;
  };
  const saving = qcPageOperationMutationChain.catch(() => false).then(run).catch(() => ({ ok: false, saved: 0, failed: changes }));
  qcPageOperationMutationChain = saving.then(() => true);
  const promise = saving
    .then(async outcome => {
      for (const [pendingKey, value] of queued) if (qcPageOperationPending.get(pendingKey) === value) qcPageOperationPending.delete(pendingKey);
      qcTickSaveInFlight.delete(id);
      if (!pdcWriteAuthorityCurrent(authority)) return outcome;
      qcTickDraftChanges(vehicle);
      qcTickDraftPersist(id);
      const left = qcTickDraftUnsavedCount(vehicle);
      if (/NOT_ACTIVE_QC/i.test(String(outcome.code || ''))) {
        qcTickDraftDiscard(id);
        qcPageFeedback.set(cleanKey, { kind: 'error', message: 'This vehicle is no longer in QC, so the ticks were not saved. The board will reload.' });
      } else if (outcome.ok) {
        qcPageFeedback.set(cleanKey, { kind: 'saved', message: `Saved ${outcome.saved} tick${outcome.saved === 1 ? '' : 's'} ✓` });
      } else if (outcome.saved) {
        qcPageFeedback.set(cleanKey, { kind: 'error', message: `Saved ${outcome.saved}. ${left} tick${left === 1 ? '' : 's'} could not be saved (changed in another session). Check them and tap Save ticks again.` });
      } else {
        qcPageFeedback.set(cleanKey, { kind: 'error', message: `The ticks were not saved (${outcome.code || 'no answer'}). They are still on this phone. Tap Save ticks to try again.` });
      }
      if (typeof qcPageSignoffBlockers !== 'undefined') qcPageSignoffBlockers.delete(qcPageSignoffBlockersKey(vehicle));
      renderQualityControlPage();
      if (outcome.saved || !outcome.ok) {
        try { await qcPageLoadSignoffOutstanding(vehicle); } catch (_error) { /* the sign-off note says to refresh */ }
        qcTickDeferredRefresh = '';
        void Promise.resolve(refreshEmailVehicleLocations()).then(() => { if (pdcWriteAuthorityCurrent(authority)) renderQualityControlPage(); }).catch(() => false);
      }
      return outcome;
    });
  void promise.then(settle);
  return promise;
}

// Sign-off and Save to RFT send unsaved ticks first; sign-off stops if any tick did not save.
async function qcTickDraftFlushBeforeSignoff(key = '', authority = capturePdcWriteAuthority()) {
  if (!qcTickBatchEnabled()) return true;
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === String(key || '').trim());
  if (!vehicle) return true;
  const id = String(vehicle.__emailVehicleId || '');
  if (!qcTickDraftUnsavedCount(vehicle) && !qcTickSaveInFlight.has(id)) return true;
  const outcome = await (qcTickSaveInFlight.get(id) || qcTickDraftSave(key, authority));
  if (qcTickSaveInFlight.has(id)) await qcTickSaveInFlight.get(id);
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  const current = qcPageVehicles().find(row => qcPageVehicleKey(row) === String(key || '').trim());
  if (outcome?.ok !== true || (current && qcTickDraftUnsavedCount(current))) return false;
  if (current && typeof qcPageSignoffBlockers !== 'undefined' && !qcPageSignoffBlockers.has(qcPageSignoffBlockersKey(current))) await qcPageLoadSignoffOutstanding(current);
  return true;
}

function qcTickSelectedVehicle() {
  if (!qcSelectedVehicleKey) return null;
  return qcPageVehicles().find(row => qcPageVehicleKey(row) === qcSelectedVehicleKey) || null;
}

function qcTickAnyUnsaved() {
  if (!qcTickBatchEnabled()) return false;
  return qcPageVehicles().some(vehicle => qcTickDraftUnsavedCount(vehicle) > 0);
}

// While a vehicle is open on the phone (or has unsaved ticks on a desktop) background board reloads wait. One reload runs
// when the hold ends: after Save ticks, going back to the list, or leaving QC. Explicit Refresh, photo and sign-off reloads still run.
function qcTickHoldActive() {
  if (!qcTickBatchEnabled() || app.currentView !== 'qc' || !qcSelectedVehicleKey) { qcTickHoldSince = 0; return false; }
  const selected = qcTickSelectedVehicle();
  const holding = Boolean(selected) && (qcPageIsMobile() || qcTickDraftUnsavedCount(selected) > 0);
  if (!holding) { qcTickHoldSince = 0; return false; }
  if (!qcTickHoldSince) qcTickHoldSince = Date.now();
  return Date.now() - qcTickHoldSince < QC_TICK_HOLD_MAX_MS;
}

function qcTickHoldBackgroundRefresh(revision = null, event = null) {
  if (!qcTickHoldActive()) return false;
  if (!event?.reconnect && revision != null && Number(revision) === Number(app.emailVehicleLocationRevision)) return true;
  qcTickDeferredRefresh = event?.reconnect ? 'reconnect' : 'revision';
  qcPageWrapRenderForQueuedTicks();
  return true;
}

function qcTickReleaseDeferredRefresh() {
  if (!qcTickDeferredRefresh || qcTickHoldActive()) return;
  qcTickDeferredRefresh = '';
  void Promise.resolve(refreshEmailVehicleLocations({ checkRevision: true })).catch(() => false);
}

function qcTickEnsureStyles() {
  if (typeof document === 'undefined' || document.getElementById('qc-tick-draft-style')) return;
  const style = document.createElement('style');
  style.id = 'qc-tick-draft-style';
  style.textContent = '.qc-tick-draft-bar{position:fixed;left:0;right:0;bottom:0;z-index:1200;display:flex;align-items:center;gap:10px;padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));background:#0f172a;color:#fff;box-shadow:0 -4px 16px rgba(15,23,42,.25);font-weight:700}'
    + '.qc-tick-draft-bar span{flex:1;min-width:0}.qc-tick-draft-bar button{min-height:44px;border-radius:10px;padding:0 16px;font-weight:800;border:0}'
    + '.qc-tick-draft-bar [data-qc-tick-save]{background:#16a34a;color:#fff}.qc-tick-draft-bar [data-qc-tick-discard]{background:transparent;color:#cbd5e1;border:1px solid #475569}'
    + '.qc-tick-draft-bar button[disabled]{opacity:.6}.has-qc-tick-draft{padding-bottom:84px}.is-qc-unsaved{outline:2px dashed #f59e0b;outline-offset:2px}'
    + '.qc-tick-draft-badge{display:inline-block;margin-left:6px;padding:1px 7px;border-radius:999px;background:#f59e0b;color:#111827;font-size:12px;font-weight:800}';
  document.head?.appendChild(style);
}

function qcTickDraftPaint() {
  if (typeof document === 'undefined') return;
  const host = document.getElementById('qc-page-host');
  document.querySelectorAll('.qc-tick-draft-bar').forEach(node => node.remove());
  host?.classList?.remove('has-qc-tick-draft');
  qcTickReleaseDeferredRefresh();
  if (!host || app.currentView !== 'qc' || !qcTickBatchEnabled()) return;
  const vehicles = qcPageVehicles();
  host.querySelectorAll('[data-qc-open-vehicle]').forEach(button => {
    const vehicle = vehicles.find(row => qcPageVehicleKey(row) === button.dataset.qcOpenVehicle);
    const count = vehicle ? qcTickDraftUnsavedCount(vehicle) : 0;
    if (count && !button.querySelector('.qc-tick-draft-badge')) button.insertAdjacentHTML('beforeend', `<span class="qc-tick-draft-badge">${count} unsaved</span>`);
  });
  const selected = qcTickSelectedVehicle();
  if (!selected) return;
  const key = qcPageVehicleKey(selected);
  const id = String(selected.__emailVehicleId || '');
  const changes = qcTickDraftChanges(selected);
  const saving = qcTickSaveInFlight.has(id);
  if (!changes.length && !saving) return;
  const unsaved = new Set(changes.map(change => change.line_identity));
  host.querySelectorAll('input[data-qc-operation-check][data-qc-line-identity]').forEach(node => {
    if (node.dataset.qcOperationCheck !== key || !unsaved.has(node.dataset.qcLineIdentity)) return;
    (node.closest('.qc-phone-item, label, li') || node).classList.add('is-qc-unsaved');
  });
  qcTickEnsureStyles();
  host.classList.add('has-qc-tick-draft');
  const count = changes.length;
  host.insertAdjacentHTML('beforeend', `<div class="qc-tick-draft-bar" role="region" aria-label="Unsaved QC ticks"><span role="status" aria-live="polite">${saving ? `Saving ${count} tick${count === 1 ? '' : 's'}…` : `${count} unsaved tick${count === 1 ? '' : 's'}`}</span>`
    + `<button type="button" data-qc-tick-discard="${escapeHtml(key)}"${saving ? ' disabled' : ''}>Undo</button>`
    + `<button type="button" data-qc-tick-save="${escapeHtml(key)}"${saving ? ' disabled' : ''}>${saving ? 'Saving…' : 'Save ticks'}</button></div>`);
  host.querySelector('[data-qc-tick-save]')?.addEventListener('click', () => { void qcTickDraftSave(key); });
  host.querySelector('[data-qc-tick-discard]')?.addEventListener('click', () => {
    if (!window.confirm(`Undo ${count} unsaved tick${count === 1 ? '' : 's'}? Nothing has been saved for them.`)) return;
    qcTickDraftDiscard(id);
    qcPageFeedback.delete(key);
    renderQualityControlPage();
  });
}

// Leaving a vehicle with unsaved ticks asks first. OK saves them, then carries on. Cancel leaves them unsaved on this phone.
function qcTickInstallLeaveGuards() {
  if (typeof window === 'undefined' || window.__qcTickLeaveGuards) return;
  window.__qcTickLeaveGuards = true;
  window.addEventListener?.('beforeunload', event => {
    if (!qcTickAnyUnsaved()) return;
    event.preventDefault();
    event.returnValue = 'QC ticks are not saved yet.';
  });
  document.addEventListener?.('click', event => {
    const target = event.target?.closest?.('[data-qc-back-to-list], [data-qc-open-vehicle], [data-qc-phone-signout]');
    if (!target || target.__qcTickContinue) return;
    const selected = qcTickBatchEnabled() ? qcTickSelectedVehicle() : null;
    if (!selected || target.dataset.qcOpenVehicle === qcPageVehicleKey(selected)) return;
    const count = qcTickDraftUnsavedCount(selected);
    if (!count) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const key = qcPageVehicleKey(selected);
    const proceed = () => { target.__qcTickContinue = true; try { target.click(); } finally { target.__qcTickContinue = false; } };
    if (!window.confirm(`You have ${count} unsaved tick${count === 1 ? '' : 's'} on this vehicle.\n\nOK = save them now.\nCancel = leave them unsaved (they stay on this phone until you save).`)) { proceed(); return; }
    void qcTickDraftSave(key).then(outcome => { if (outcome?.ok) proceed(); });
  }, true);
}

function qcTickResetAuthority() {
  qcTickDrafts.clear();
  qcTickSaveInFlight.clear();
  qcTickHoldSince = 0;
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') qcTickInstallLeaveGuards();

async function qcPageAttachPhoto(key = '', input) {
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  const cleanKey = String(key || '').trim();
  if (!cleanKey || qcPagePhotoUploadInFlight.has(cleanKey)) return false;
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === cleanKey);
  const file = input?.files?.[0];
  const service = app.emailVehicleLocationService;
  const disabledReason = qcPagePhotoDisabledReason(vehicle || {}, cleanKey);
  if (disabledReason && !qcPagePhotoUploadInFlight.has(cleanKey)) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: disabledReason });
    renderQualityControlPage();
    return false;
  }
  if (!vehicle || !file || !service || typeof service.uploadQcPhotoEvidence !== 'function' || vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId || Number(vehicle.__emailVehicleVersion || 0) < 1) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'This photo is not bound to stable QC authority. Nothing was stored.' });
    renderQualityControlPage();
    return false;
  }
  if (!String(file.type || '').toLowerCase().startsWith('image/') || Number(file.size || 0) < 1 || Number(file.size || 0) > 10 * 1024 * 1024) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'Choose an image no larger than 10 MB. Nothing was stored.' });
    renderQualityControlPage();
    return false;
  }
  qcPagePhotoUploadInFlight.add(cleanKey);
  qcPageFeedback.set(cleanKey, { kind: 'saving', message: 'Preparing and uploading the private completion photo…' });
  renderQualityControlPage();
  try {
    const previewReader = new FileReader();
    const preview = await new Promise((resolve, reject) => {
      const timer = setTimeout(() => { previewReader.abort(); reject(new Error('photo_read_failed')); }, 15000);
      previewReader.addEventListener('load', () => { clearTimeout(timer); resolve(String(previewReader.result || '')); }, { once: true });
      const failed = () => { clearTimeout(timer); reject(new Error('photo_read_failed')); };
      previewReader.addEventListener('error', failed, { once: true });
      previewReader.addEventListener('abort', failed, { once: true });
      previewReader.readAsDataURL(file);
    });
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    qcPhotoEvidence.set(cleanKey, { originalFilename: file.name, url: preview, originalByteLength: file.size, byteLength: 0, imageWidth: 0, imageHeight: 0, sha256: '' });
    const result = vehicle.pdcQcRetestCycleId
      ? await service.uploadQcPhotoEvidence(vehicle.__emailVehicleId, vehicle.__emailVehicleVersion, vehicle.pdcQcRetestCycleId, file)
      : await service.uploadQcPhotoEvidence(vehicle.__emailVehicleId, vehicle.__emailVehicleVersion, file);
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    if (!result?.ok || !result.data?.photo_receipt_id) {
      // r414 (F30): a receipt already exists for this QC: load it and use it instead of showing a stuck preview.
      if (result?.code === 'qc_photo_already_recorded' && await qcPageLoadStoredPhoto(cleanKey, { force: true })) {
        qcPageFeedback.set(cleanKey, { kind: 'saved', message: qcPagePhotoErrorMessage('qc_photo_already_recorded') });
        renderQualityControlPage();
        return true;
      }
      if (!pdcWriteAuthorityCurrent(authority)) return false;
      const failed = qcPhotoEvidence.get(cleanKey);
      if (failed && !qcPhotoEvidenceIsValid(failed)) qcPhotoEvidence.set(cleanKey, { ...failed, status: 'error', photoReceiptId: '' });
      qcPageFeedback.set(cleanKey, { kind: 'error', message: qcPagePhotoErrorMessage(result?.code) });
      renderQualityControlPage();
      return false;
    }
    const acceptedEvidence = { ...qcPhotoEvidence.get(cleanKey), ...result.data, status: 'accepted', photoReceiptId: result.data.photo_receipt_id, originalFilename: result.data.original_filename || file.name, byteLength: Number(result.data.byte_length || 0), originalByteLength: Number(result.data.original_byte_length || file.size), imageWidth: Number(result.data.image_width || 0), imageHeight: Number(result.data.image_height || 0), sha256: result.data.sha256, url: preview };
    if (!qcPhotoEvidenceIsValid(acceptedEvidence)) {
      qcPhotoEvidence.set(cleanKey, { ...acceptedEvidence, status: 'error', photoReceiptId: '' });
      qcPageFeedback.set(cleanKey, { kind: 'error', message: qcPagePhotoErrorMessage('qc_photo_receipt_invalid') });
      renderQualityControlPage();
      return false;
    }
    qcPhotoEvidence.set(cleanKey, acceptedEvidence);
    qcPageFeedback.set(cleanKey, { kind: 'saved', message: `Photo compressed and stored (${Math.round(Number(result.data.original_byte_length || file.size) / 1024)} KB → ${Math.round(Number(result.data.byte_length || 0) / 1024)} KB). All active operation lines must be complete before sign-off.` });
    renderQualityControlPage();
    return true;
  } catch (error) {
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    const failed = qcPhotoEvidence.get(cleanKey);
    if (failed && !qcPhotoEvidenceIsValid(failed)) qcPhotoEvidence.set(cleanKey, { ...failed, status: 'error', photoReceiptId: '' });
    qcPageFeedback.set(cleanKey, { kind: 'error', message: error.message === 'photo_read_failed'
      ? 'The photo could not be read. Choose the photo again before signing off.'
      : 'The photo was not confirmed. Refresh QC and check the saved state before retrying.' });
    return false;
  } finally {
    if (pdcWriteAuthorityCurrent(authority)) {
      qcPagePhotoUploadInFlight.delete(cleanKey);
      renderQualityControlPage();
    }
  }
}

async function qcPageSignoff(key = '') {
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  const cleanKey = String(key || '').trim();
  if (!cleanKey || qcPageSignoffInFlight.has(cleanKey)) return false;
  // r910 (F492): unsaved ticks are saved first; sign-off stops if any did not save.
  if (typeof qcTickDraftFlushBeforeSignoff === 'function' && !(await qcTickDraftFlushBeforeSignoff(cleanKey, authority))) {
    if (pdcWriteAuthorityCurrent(authority)) renderQualityControlPage();
    return false;
  }
  if (!pdcWriteAuthorityCurrent(authority) || qcPageSignoffInFlight.has(cleanKey)) return false;
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === cleanKey);
  const photo = qcPhotoEvidence.get(cleanKey);
  if (!vehicle || !qcPhotoEvidenceIsValid(photo)) return false;
  const signoff = qcPageSignoffStatus(vehicle, { photoValid: true });
  if (!signoff.ready) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: signoff.note });
    pdcNotify(signoff.note);
    renderQualityControlPage();
    return false;
  }
  qcPageSignoffInFlight.add(cleanKey);
  try {
    const result = vehicle.pdcQcRetestCycleId && typeof app.emailVehicleLocationService?.finalizeQcRetest === 'function'
      ? await app.emailVehicleLocationService.finalizeQcRetest(vehicle.__emailVehicleId, vehicle.__emailVehicleVersion, vehicle.pdcQcRetestCycleId, photo.photoReceiptId, crypto.randomUUID())
      : await completeVehicleQualityControl(cleanKey, photo, authority);
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    const succeeded = vehicle.pdcQcRetestCycleId ? result?.ok === true : result;
    if (succeeded) {
      qcPhotoEvidence.delete(cleanKey);
      qcSelectedVehicleKey = '';
      qcPageNotice = 'Final check passed. The car is in WPC and keeps its key number. The salesperson email is opening now. Tick RFT\u2019d when Sales gives the destination: that frees the key and starts the transport timer.'; // r827 (F465), was r755 (F360)
      renderQualityControlPage();
      // r827 (F465, Craig 2 Nov 15:23): "Email sales person when we do the FC": open the salesperson email straight after sign-off.
      void (async () => {
        try {
          if (typeof refreshEmailVehicleLocations === 'function') await refreshEmailVehicleLocations();
          if (typeof markRftTransportBooked === 'function') await markRftTransportBooked(cleanKey, true);
        } catch (_error) { /* the Email salesperson button in WPC still works */ }
      })();
    }
    return result;
  } finally {
    if (pdcWriteAuthorityCurrent(authority)) qcPageSignoffInFlight.delete(cleanKey);
  }
}

function qcPageClearInvalidPhoto(key = '') {
  const cleanKey = String(key || '').trim();
  if (!cleanKey || qcPagePhotoUploadInFlight.has(cleanKey)) return false;
  const photo = qcPhotoEvidence.get(cleanKey);
  if (!photo || qcPhotoEvidenceIsValid(photo)) return false;
  qcPhotoEvidence.delete(cleanKey);
  qcPageFeedback.delete(cleanKey);
  renderQualityControlPage();
  return true;
}

// r947: Reject opens a pick list. Nothing is sent until at least one line is picked.
function qcPageRejectPickHtml(vehicle = {}, key = '') {
  const pick = qcPageRejectPicks.get(key);
  if (!pick) return '';
  const lines = qcPageOperationLines(vehicle);
  const busy = qcPageRejectInFlight.has(key);
  const count = lines.filter(line => pick.picked.has(line.lineIdentity)).length;
  return `<section class="qc-phone-reject-panel qc-reject-pick-panel" role="region" aria-label="Pick the lines that need repair">
    <h3>Pick the lines that need repair</h3>
    <p>Only the picked lines go back to <strong>PMB Stoppage / Fix First</strong>. A QC reject needs at least one line.</p>
    <div class="qc-reject-selection">${lines.length ? lines.map(line => `<label><input type="checkbox" data-qc-reject-pick="${escapeHtml(key)}" data-qc-line-identity="${escapeHtml(line.lineIdentity)}" ${pick.picked.has(line.lineIdentity) ? 'checked' : ''} ${busy ? 'disabled' : ''}><span>${escapeHtml(line.description || line.operationNo || 'Line')}<small>${escapeHtml(qcPageStageLabel(line.stageCode))} · ${escapeHtml(qcPageOperationHoursLabel(line))}</small></span></label>`).join('') : '<p class="qc-reject-pick-empty">No QC lines are listed for this vehicle, so it cannot be rejected here. Refresh, or add the missing work first.</p>'}</div>
    <label for="qc-reject-pick-reason-${escapeHtml(key)}">Additional reason (optional)</label>
    <textarea id="qc-reject-pick-reason-${escapeHtml(key)}" data-qc-reject-reason="${escapeHtml(key)}" maxlength="240" rows="2" ${busy ? 'disabled' : ''}>${escapeHtml(pick.reason || '')}</textarea>
    <div class="qc-reject-pick-hint" role="status" aria-live="polite">${count ? `${count} line${count === 1 ? '' : 's'} picked.` : 'Pick at least one line that needs repair.'}</div>
    <div class="qc-phone-reject-buttons qc-reject-pick-buttons"><button class="small-button" type="button" data-qc-reject-cancel="${escapeHtml(key)}" ${busy ? 'disabled' : ''}>Cancel</button><button class="small-button danger-button qc-reject-action" type="button" data-qc-reject-confirm="${escapeHtml(key)}" ${busy || !count ? 'disabled' : ''}>${busy ? 'Rejecting…' : `Reject picked (${count}) → Stoppage`}</button></div>
  </section>`;
}

function qcPageRejectTogglePick(key = '', lineIdentity = '', picked = false) {
  const pick = qcPageRejectPicks.get(String(key || ''));
  if (!pick || qcPageRejectInFlight.has(key)) return;
  if (picked) pick.picked.add(String(lineIdentity || '')); else pick.picked.delete(String(lineIdentity || ''));
  qcPageFeedback.delete(key);
  renderQualityControlPage();
}

async function qcPageRejectVehicle(key = '') {
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  const cleanKey = String(key || '').trim();
  if (!cleanKey || qcPageRejectInFlight.has(cleanKey)) return false;
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === cleanKey);
  const service = app.emailVehicleLocationService;
  if (!vehicle || vehicle.__emailVehicleServerAuthoritative !== true || typeof service?.rejectQcVehicleToPmb !== 'function') {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'QC rejection requires the authenticated staging service. Nothing was changed.' });
    renderQualityControlPage();
    return false;
  }
  // r947: the Reject button only opens the pick list; the confirm button sends.
  for (const other of [...qcPageRejectPicks.keys()]) if (other !== cleanKey) qcPageRejectPicks.delete(other);
  if (!qcPageRejectPicks.has(cleanKey)) qcPageRejectPicks.set(cleanKey, { picked: new Set(), reason: '' });
  qcPageFeedback.set(cleanKey, { kind: 'info', message: 'Pick the lines that need repair, then press Reject picked.' });
  renderQualityControlPage();
  return false;
}

async function qcPageConfirmRejectVehicle(key = '') {
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return false;
  const cleanKey = String(key || '').trim();
  if (!cleanKey || qcPageRejectInFlight.has(cleanKey)) return false;
  const vehicle = qcPageVehicles().find(row => qcPageVehicleKey(row) === cleanKey);
  const service = app.emailVehicleLocationService;
  const pick = qcPageRejectPicks.get(cleanKey);
  if (!vehicle || vehicle.__emailVehicleServerAuthoritative !== true || typeof service?.rejectQcVehicleToPmb !== 'function') {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'QC rejection requires the authenticated staging service. Nothing was changed.' });
    renderQualityControlPage();
    return false;
  }
  const lines = pick ? qcPageOperationLines(vehicle).filter(line => pick.picked.has(line.lineIdentity)) : [];
  if (!lines.length) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'Pick at least one line that needs repair before rejecting. Nothing was changed.' });
    renderQualityControlPage();
    return false;
  }
  if (lines.length !== pick.picked.size) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'The line list changed since you picked. Check the picked lines and try again. Nothing was changed.' });
    pick.picked = new Set(lines.map(line => line.lineIdentity));
    renderQualityControlPage();
    return false;
  }
  const reason = String(pick.reason || `Not fitted / QC repair: ${lines.map(line => line.description || line.operationNo || 'line').join('; ')}`).trim().replace(/\s+/g, ' ').slice(0, 240);
  if (reason.length < 3) {
    qcPageFeedback.set(cleanKey, { kind: 'error', message: 'Enter a reason of at least 3 characters.' });
    renderQualityControlPage();
    return false;
  }
  const stock = displayStockNumber(vehicle) || cleanKey;
  const customer = vehicleCustomerName(vehicle) || vehicle.customerName || 'Customer unavailable';
  if (!window.confirm(`Reject Stock ${stock} for QC fixes?\n\nCustomer: ${customer}\nLines picked (${lines.length}):\n${lines.map(line => `• ${line.description || line.operationNo || line.lineIdentity}`).join('\n')}\nReason: ${reason}\n\nOnly these lines go back to PMB Stoppage / Fix First as Pending QC fixes.`)) return false;
  qcPageRejectInFlight.add(cleanKey);
  qcPageFeedback.set(cleanKey, { kind: 'saving', message: `Rejecting ${lines.length} picked line${lines.length === 1 ? '' : 's'}…` });
  renderQualityControlPage();
  try {
    const rejectedLines = lines.map(line => ({ line_identity: line.lineIdentity, line_version: Number(line.lineVersion || 0) }));
    const result = await service.rejectQcVehicleToPmb(vehicle.__emailVehicleId, stock, vehicle.__emailVehicleVersion, reason, crypto.randomUUID(), rejectedLines);
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    if (!result?.ok) {
      qcPageFeedback.set(cleanKey, { kind: 'error', message: result?.code === 'PDC_766_VEHICLE_VERSION_CONFLICT' || /VERSION_CONFLICT/i.test(String(result?.code || '')) ? 'This vehicle or a line changed in another session. Refresh and pick again.'
        : result?.code === 'qc_reject_lines_required' ? 'Pick at least one line that needs repair before rejecting. Nothing was changed.'
        : `QC rejection was not recorded (${result?.code || 'unknown_error'}).` });
      renderQualityControlPage();
      return false;
    }
    qcPageRejectPicks.delete(cleanKey);
    qcSelectedVehicleKey = '';
    qcPageNotice = `Stock ${stock} — ${lines.length} QC line${lines.length === 1 ? '' : 's'} rejected. Moved to PMB Stoppage / Fix First as Pending QC fixes.`;
    await refreshEmailVehicleLocations();
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    renderQualityControlPage();
    return true;
  } finally {
    if (pdcWriteAuthorityCurrent(authority)) qcPageRejectInFlight.delete(cleanKey);
  }
}

function renderQualityControlPage() {
  const host = $('#qc-page-host');
  if (!host) return;
  const vehicles = qcPageVehicles();
  const mobile = qcPageIsMobile();
  if (!vehicles.some(vehicle => qcPageVehicleKey(vehicle) === qcSelectedVehicleKey)) qcSelectedVehicleKey = mobile ? '' : qcPageVehicleKey(vehicles[0] || {});
  const selected = vehicles.find(vehicle => qcPageVehicleKey(vehicle) === qcSelectedVehicleKey) || null;
  if (selected) void qcPageLoadStoredPhoto(qcPageVehicleKey(selected));
  if (selected) void qcPageLoadSignoffOutstanding(selected);
  host.innerHTML = `<div class="qc-page-layout ${mobile ? selected ? 'is-mobile-detail' : 'is-mobile-list' : ''}">${qcPageNotice ? `<div class="qc-finalization-notice" role="status" aria-live="polite">${escapeHtml(qcPageNotice)}</div>` : ''}
    <section class="qc-queue" aria-labelledby="qc-queue-title"><div class="qc-queue-header"><div><h3 id="qc-queue-title">Vehicles requiring final check</h3><p>${vehicles.length} awaiting QC sign-off</p></div><span class="qc-queue-count">${vehicles.length}</span></div><div class="qc-vehicle-list">${vehicles.length ? vehicles.map(vehicle => qcPageVehicleCardHtml(vehicle, qcPageVehicleKey(vehicle) === qcSelectedVehicleKey)).join('') : '<div class="qc-empty-state"><strong>No vehicles require QC</strong><span>Vehicles appear here after all required workshop work is complete.</span></div>'}</div></section>
    <section class="qc-detail-host">${selected ? qcPageDetailHtml(selected) : '<div class="qc-empty-state qc-detail-empty"><strong>Select a vehicle</strong><span>Choose a QC vehicle to review its completed work and store the completion photo.</span></div>'}</section>
  </div>`;
  $$('[data-qc-open-vehicle]', host).forEach(button => button.addEventListener('click', () => {
    qcSelectedVehicleKey = button.dataset.qcOpenVehicle || '';
    qcPageNotice = '';
    renderQualityControlPage();
  }));
  $$('[data-qc-back-to-list]', host).forEach(button => button.addEventListener('click', () => {
    qcSelectedVehicleKey = '';
    renderQualityControlPage();
  }));
  $$('[data-qc-operation-check]', host).forEach(input => input.addEventListener('change', () => {
    qcPageQueueOperationState(input.dataset.qcOperationCheck, input.dataset.qcLineIdentity, input.checked, input);
  }));
  $$('[data-qc-photo]', host).forEach(input => input.addEventListener('change', () => { void qcPageAttachPhoto(input.dataset.qcPhoto, input); }));
  $$('[data-qc-photo-clear]', host).forEach(button => button.addEventListener('click', () => { qcPageClearInvalidPhoto(button.dataset.qcPhotoClear); }));
  $$('[data-qc-reject]', host).forEach(button => button.addEventListener('click', () => { void qcPageRejectVehicle(button.dataset.qcReject); }));
  $$('[data-qc-reject-pick]', host).forEach(input => input.addEventListener('change', () => { qcPageRejectTogglePick(input.dataset.qcRejectPick, input.dataset.qcLineIdentity, input.checked); }));
  $$('[data-qc-reject-reason]', host).forEach(input => input.addEventListener('input', () => { const pick = qcPageRejectPicks.get(input.dataset.qcRejectReason); if (pick) pick.reason = input.value; }));
  $$('[data-qc-reject-cancel]', host).forEach(button => button.addEventListener('click', () => { qcPageRejectPicks.delete(button.dataset.qcRejectCancel); qcPageFeedback.delete(button.dataset.qcRejectCancel); renderQualityControlPage(); }));
  $$('[data-qc-reject-confirm]', host).forEach(button => button.addEventListener('click', () => { void qcPageConfirmRejectVehicle(button.dataset.qcRejectConfirm); }));
  if (selected && qcPageRejectPicks.has(qcPageVehicleKey(selected))) $$('[data-qc-signoff]', host).forEach(button => { button.disabled = true; });
  $$('[data-qc-signoff]', host).forEach(button => button.addEventListener('click', () => { void qcPageSignoff(button.dataset.qcSignoff); }));
}

function renderActiveView() {
  ensureAppDataAvailable();
  const view = app.currentView || 'dashboard';
  const previousRenderJsonCache = activeRenderJsonCache;
  activeRenderJsonCache = new Map();
  try {
    switch (view) {
    case 'dashboard':
      renderKpis();
      renderIncomingDashboardBoard();
      break;
    case 'fitters':
      window.PdcFitters?.open();
      break;
    case 'qc':
      renderQualityControlPage();
      break;
    case 'workflow':
      renderWorkflowBoard();
      break;
    case 'workshop':
      renderWorkshopPlannerWhenReady();
      break;
    case 'parts':
      renderPartsHome();
      break;
    case 'emailreview':
      renderEmailIntakeReview();
      break;
    case 'ai-auditor':
      renderPdcAuditor();
      if (app.pdcAuditorState === 'idle') loadPdcAuditorSnapshot();
      break;
    case 'sublet':
      renderSubletHome();
      break;
    case 'bus-pit':
      renderBusPitInspections();
      break;
    case 'rft':
      renderRftHome();
      break;
    case 'completed':
      renderCompletedVehicles();
      break;
    case 'collected':
      renderCollectedVehicles();
      break;
    case 'deleted':
      renderDeletedVehicles();
      break;
    case 'backend':
      renderBackEndData();
      break;
    case 'lists':
      renderAdminLists();
      window.PdcWorkshopHours?.open();
      break;
    case 'user-management':
      renderUserManagementScreen();
      break;
    case 'update-history':
      window.PdcUpdateHistory?.open();
      break;
    case 'fitting-stats':
      window.PdcFittingStats?.open();
      break;
    case 'bay-manager':
      window.PdcBayManager?.open();
      break;
    case 'mmt-sublet': // r642 (F257)
      window.PdcMmtSublet?.open();
      break;
    case 'psc-sublet': // r711 (F321)
      window.PdcPscSublet?.open();
      break;
    case 'stock-take': // r720 (F330)
      window.PdcStockTake?.open?.();
      break;
    case 'pit-bookings': // r753 (F358)
      window.PDC_PIT_BOOKINGS?.open?.();
      break;
    case 'revolution-upload':
      window.PdcRevolutionUpload?.open();
      break;
    case 'import':
      renderReviewTable(false);
      renderScotSummary(false);
      renderAutocareResults(app.autocareScan);
      if (app.navisionImport) renderNavisionSummary(app.navisionImport);
      break;
    case 'schedule':
      renderScheduleBoard();
      break;
    case 'department':
      renderProductionDepartmentBoard();
      break;
    case 'visibility':
      renderOperationalVisibility();
      break;
    case 'tv':
      renderTvBoard();
      break;
      default:
        break;
    }
  } finally {
    activeRenderJsonCache = previousRenderJsonCache;
  }
}


function navisionOrderType(vehicle) {
  return String(vehicle.navisionTransportPriority || vehicle.transportPriority || vehicle.salesType || vehicle.dealerCustomerCategory || '').toLowerCase();
}

function filteredVehiclesIgnoringQuickFilter() {
  const savedQuickFilter = app.quickFilter;
  const savedSubFilter = app.pmbSubFilter;
  app.quickFilter = '';
  app.pmbSubFilter = '';
  const rows = filteredVehicles();
  app.quickFilter = savedQuickFilter;
  app.pmbSubFilter = savedSubFilter;
  return rows;
}

function renderKpis() {
  const dashboardRows = filteredVehiclesIgnoringQuickFilter();
  const grid = $('#kpi-grid');
  if (!grid) return;
  const cards = STATUS_TAB_DEFS.map(def => {
    const value = dashboardRows.filter(matchesQuickFilter(def.key)).length;
    return { ...def, value };
  });
  grid.innerHTML = cards.map(card => {
    const active = app.quickFilter === card.key || (!app.quickFilter && card.key === 'batchmatched');
    return `
    <button class="kpi-card status-tab ${card.className} ${active ? 'active' : ''}" data-kpi-filter="${escapeHtml(card.key)}" type="button" aria-pressed="${active}">
      <span>${escapeHtml(card.label)}</span>
      <strong>${card.value}</strong>
      <small>${escapeHtml(card.sub)}</small>
    </button>
  `;
  }).join('');
  $$('[data-kpi-filter]').forEach(card => card.addEventListener('click', () => {
    applyQuickFilter(card.dataset.kpiFilter);
  }));
}

function isOpenThirdPartyVehicle(vehicle = {}) {
  const thirdPartyJobKeys = new Set(['tint', 'fabrication', 'electrical']);
  const hasOpenExternalJob = PDC_JOB_DEFS.some(def => thirdPartyJobKeys.has(def.key) && pdcJobRequired(vehicle, def) && !pdcJobComplete(vehicle, def));
  const hasOpenLegacySublet = vehicle.pdcRequiresSublet === true && vehicle.pdcCompleteSublet !== true;
  const stage = inferredPmbStage(vehicle);
  return hasOpenExternalJob || hasOpenLegacySublet || ['TINT', 'FABRICATION', 'ELECTRICAL', 'PIT_INSPECTION'].includes(stage);
}

function isWorkflowStagnant(vehicle = {}) {
  if (isActivePartsStoppage(vehicle) || isPdcBlocked(vehicle)) return true;
  if (statusCategory(vehicle) !== 'pmb') return false;
  const days = pmbStageAgeDays(vehicle);
  if (days === null) return false;
  return days > pmbLaneAgeLimit(inferredPmbStage(vehicle));
}

function operationalVisibilityMetrics(rows = []) {
  const pmbRows = rows.filter(vehicle => statusCategory(vehicle) === 'pmb');
  const rftGateIssues = vehiclesWithRftGateIssues(pmbRows);
  const stages = ['', ...PMB_STAGE_DEFS.map(def => def.value)];
  const capacityAlerts = stages.map(stage => {
    const vehicles = pmbRows.filter(vehicle => stage ? inferredPmbStage(vehicle) === stage : !inferredPmbStage(vehicle));
    return { stage, vehicles, metrics: pmbLaneMetrics(stage, vehicles) };
  }).filter(row => row.metrics.overLimit || row.metrics.atLimit || row.metrics.blockedCount || row.metrics.oldestStageDays > pmbLaneAgeLimit(row.stage));
  const openThirdPartyRows = rows.filter(isOpenThirdPartyVehicle);
  return {
    openThirdParty: openThirdPartyRows.length,
    assignedThirdParty: openThirdPartyRows.filter(vehicle => pmbBaySubletProvider(vehicle) || pmbBayMechanic(vehicle)).length,
    stagnant: rows.filter(isWorkflowStagnant).length,
    activeBlockers: rows.filter(vehicle => isPdcBlocked(vehicle) || isActivePartsStoppage(vehicle)).length,
    capacityAlerts: capacityAlerts.length,
    rftGateIssues: rftGateIssues.length,
    historyEvents: loadAuditLog().length,
    pmbRows: pmbRows.length,
  };
}

function renderOperationalVisibility() {
  const host = $('#operational-visibility-grid');
  if (!host) return;
  const rows = filteredVehiclesIgnoringQuickFilter();
  const metrics = operationalVisibilityMetrics(rows);
  const cards = [
    { label: 'External/specialist work', value: metrics.openThirdParty, detail: `${metrics.assignedThirdParty} assigned · tint / fabrication / electrical / pit inspection` },
    { label: 'Stagnation & blockers', value: metrics.stagnant, detail: `${metrics.activeBlockers} active blockers or Parts STOPPAGES` },
    { label: 'Capacity alerts', value: metrics.capacityAlerts, detail: `${metrics.pmbRows} PMB vehicles checked against WIP and ageing limits` },
    { label: 'RFT gate issues', value: metrics.rftGateIssues, detail: 'Manual QC remains required before Ready for Transport' },
    { label: 'History events', value: metrics.historyEvents, detail: 'Local timestamped audit records for reporting review' },
  ];
  host.innerHTML = cards.map(card => `
    <article class="visibility-card">
      <span>${escapeHtml(card.label)}</span>
      <strong>${escapeHtml(card.value)}</strong>
      <small>${escapeHtml(card.detail)}</small>
    </article>
  `).join('');
}


function workflowVehiclesForStep(step = '') {
  const rows = pdcSheetVehicles().filter(vehicleHasBatchNumber);
  switch (step) {
    case 'import': return rows.filter(vehicle => statusCategory(vehicle) === 'batchmatched');
    case 'arrival': return rows.filter(vehicle => statusCategory(vehicle) === 'prodtransit');
    case 'yardhold': return rows.filter(vehicle => statusCategory(vehicle) === 'yardhold');
    case 'parts': return rows.filter(vehicle => ['notordered', 'onorder', 'stoppage', 'miscacc'].includes(partsDepartmentStatus(vehicle)));
    case 'pmb': return rows.filter(vehicle => statusCategory(vehicle) === 'pmb');
    case 'rft': return rows.filter(vehicle => statusCategory(vehicle) === 'rft');
    default: return rows;
  }
}

function vehicleWorkshopStoppageBookings(vehicle = {}) {
  return (Array.isArray(vehicle.salesWorkshopBookings) ? vehicle.salesWorkshopBookings : [])
    .filter(booking => String(booking?.status || '').trim().toLowerCase() === 'stoppage')
    .filter(booking => booking?.bookingId || booking?.id)
    .sort((a, b) => String(a.scheduledStartAt || '').localeCompare(String(b.scheduledStartAt || ''))
      || String(a.bookingId || a.id).localeCompare(String(b.bookingId || b.id)));
}

function workflowPriorityRows() {
  const pmbRows = workflowVehiclesForStep('pmb');
  const issueRows = [];
  pdcSheetVehicles().filter(vehicleHasBatchNumber).forEach(vehicle => {
    vehicleWorkshopStoppageBookings(vehicle).forEach(booking => {
      const station = cleanNavisionText(booking.stageName || booking.stageCode || 'Workshop');
      const bay = cleanNavisionText(booking.bayName || '');
      const reason = cleanNavisionText(booking.stoppageReason || 'Workshop job stopped');
      issueRows.push({
        vehicle,
        label: `${station} STOPPAGE`,
        severity: 'danger',
        detail: `${reason}${bay ? ` · ${bay}` : ''}`,
        stoppageKind: 'booking',
        bookingId: String(booking.bookingId || booking.id),
        bookingVersion: Number(booking.version || 0),
      });
    });
  });
  workflowVehiclesForStep('parts')
    .filter(vehicle => partsDepartmentStatus(vehicle) === 'stoppage')
    .forEach(vehicle => {
      const eta = partsWorstEtaLabel(vehicle);
      issueRows.push({
        vehicle,
        label: 'Parts STOPPAGE',
        severity: 'danger',
        stoppageKind: 'parts',
        detail: `${partsStoppageReason(vehicle)} · ${eta ? `Parts ETA ${eta}` : 'Parts ETA pending'}`,
      });
    });
  pmbRows
    .filter(isPdcBlocked)
    .forEach(vehicle => issueRows.push({ vehicle, label: vehicle.pdcQcFixStatus === 'Pending QC fixes' ? 'Pending QC fixes' : 'PMB STOPPAGE', severity: 'danger', stoppageKind: 'pmb', detail: pdcBlockReason(vehicle) }));
  const seen = new Set();
  return issueRows.filter(row => {
    const key = `${vehicleKey(row.vehicle)}:${row.label}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).sort((a, b) => {
    if (a.label === 'Parts STOPPAGE' && b.label === 'Parts STOPPAGE') {
      const etaDiff = partsWorstEtaSortValue(a.vehicle) - partsWorstEtaSortValue(b.vehicle);
      if (etaDiff) return etaDiff;
    }
    return 0;
  });
}

function fixFirstRowsHtml(rows = [], emptyText = 'No urgent production exceptions right now.') {
  if (!rows.length) return `<div class="empty-state compact-empty fix-first-empty"><strong>Clear</strong><span>${escapeHtml(emptyText)}</span></div>`;
  const rowHtml = rows.map(row => {
    const vehicle = row.vehicle || {};
    const key = vehicleKey(vehicle);
    const identityHtml = vehicleIdentityStackHtml(vehicle);
    const client = vehicleCustomerName(vehicle) || 'Dealer Order';
    const unit = displayVehicle(vehicle) || 'Vehicle not listed';
    const stage = pmbStageLabel(inferredPmbStage(vehicle)) || pdcLocationLabel(vehiclePdcLocation(vehicle)) || incomingBucketLabel(incomingBucketForVehicle(vehicle));
    const severity = row.severity || 'warning';
    const clearAction = row.stoppageKind
      ? `<button class="small-button fix-first-clear" type="button" data-clear-priority-stoppage="${escapeHtml(key)}" data-stoppage-kind="${escapeHtml(row.stoppageKind)}" data-booking-id="${escapeHtml(row.bookingId || '')}" data-booking-version="${Number(row.bookingVersion || 0)}">Clear stoppage</button>` : '';
    return `<div class="fix-first-row-wrap">
      <button class="fix-first-row fix-first-${escapeHtml(severity)}" type="button" data-open-stock="${escapeHtml(key)}">
        <span class="fix-first-label">${escapeHtml(row.label || 'Action needed')}</span>
        ${identityHtml}
        <small>${escapeHtml(unit)}</small>
        <em>${escapeHtml(row.detail || stage || 'Open vehicle for details')}</em>
      </button>${clearAction}
    </div>`;
  }).join('');
  return `${vehicleIdentityHeaderHtml('fix-first-identity-header')}${rowHtml}`;
}

async function clearPriorityStoppage(key = '', stoppageKind = '', bookingId = '', bookingVersion = 0) {
  const vehicle = selectedVehicle(key);
  const service = app.emailVehicleLocationService;
  if (!vehicle || vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId || Number(vehicle.__emailVehicleVersion || 0) < 1 || typeof service?.clearVehicleStoppage !== 'function') {
    pdcNotify('This stoppage is not bound to current server authority. Nothing was changed.'); return;
  }
  const note = cleanNavisionText(window.prompt('Why is this stoppage being cleared? This note is kept in the vehicle history.', 'Issue resolved') || '');
  if (!note) return;
  const result = await service.clearVehicleStoppage(vehicle.__emailVehicleId, Number(vehicle.__emailVehicleVersion), stoppageKind, bookingId, Number(bookingVersion || 0), note, salespersonAssignmentIdempotencyKey());
  if (!result?.ok) {
    const messages = { no_active_stoppage: 'This vehicle no longer has an active stoppage.', no_active_parts_stoppage: 'This Parts stoppage is no longer active.', no_active_pmb_stoppage: 'This PMB stoppage is no longer active.', booking_not_in_stoppage: 'This Workshop booking is no longer stopped.', booking_version_conflict: 'This Workshop booking changed in another session. The latest state has been reloaded.', vehicle_version_conflict: 'This vehicle changed in another session. The latest state has been reloaded.', vehicle_not_active: 'This vehicle is no longer active.' };
    await Promise.allSettled([refreshEmailVehicleLocations(), window.__workshopDataService?.loadSnapshot?.('clear_stoppage_rejected')]);
    pdcNotify(messages[result?.code] || 'The stoppage was not cleared. No history was removed.'); renderAll(); return;
  }
  await Promise.allSettled([refreshEmailVehicleLocations(), window.__workshopDataService?.loadSnapshot?.('clear_stoppage_412')]);
  renderAll();
}

function bindFixFirstRows(root = document) {
  $$('.fix-first-row[data-open-stock]', root).forEach(button => {
    if (button.dataset.fixFirstBound === 'true') return;
    button.dataset.fixFirstBound = 'true';
    button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); });
  });
  $$('[data-clear-priority-stoppage]', root).forEach(button => {
    if (button.dataset.clearStoppageBound === 'true') return;
    button.dataset.clearStoppageBound = 'true';
    button.addEventListener('click', event => { event.stopPropagation(); void clearPriorityStoppage(button.dataset.clearPriorityStoppage, button.dataset.stoppageKind, button.dataset.bookingId, Number(button.dataset.bookingVersion || 0)); });
  });
}

function renderFixFirstGrid() {
  const host = $('#fix-first-grid');
  if (!host) return;
  const rows = workflowPriorityRows();
  host.innerHTML = `<details class="fix-first-list"><summary>Show STOPPAGES</summary><div class="fix-first-list-body">${fixFirstRowsHtml(rows)}</div></details>`;
  bindFixFirstRows(host);
}

function workflowBoardStats() {
  const pmbRows = workflowVehiclesForStep('pmb');
  const pmbBlocked = pmbRows.filter(isPdcBlocked).length;
  const gateIssues = vehiclesWithRftGateIssues(pmbRows).length;
  const unallocated = pmbRows.filter(vehicle => !inferredPmbStage(vehicle)).length;
  const stageSteps = [
    { value: '', filter: PMB_STAGE_UNASSIGNED_FILTER, number: '0', title: 'Unallocated', action: 'Open list' },
    ...PMB_STAGE_DEFS.map((def, index) => ({ value: def.value, filter: def.value, number: String(index + 1), title: def.label, action: def.value === 'SUBLET' ? 'Provider queue' : 'Open bays' }))
  ];
  return {
    total: pmbRows.length,
    pmbBlocked,
    gateIssues,
    unallocated,
    steps: stageSteps.map(step => {
      const vehicles = step.value ? pmbRows.filter(vehicle => inferredPmbStage(vehicle) === step.value) : pmbRows.filter(vehicle => !inferredPmbStage(vehicle));
      const metrics = pmbLaneMetrics(step.value, vehicles);
      return {
        ...step,
        count: vehicles.length,
        detail: step.value ? `${vehicles.length} in queue · oldest ${metrics.oldestStageDays}d${metrics.blockedCount ? ` · blocked ${metrics.blockedCount}` : ''}` : 'Vehicles need a PMB category',
        rule: step.value === 'SUBLET' ? 'Assign provider and track outsourced work in the SUBLET row.' : step.value ? 'Click to open the bay board for this PMB category.' : 'Assign these vehicles to the correct PMB category first.',
        target: step.filter,
        state: metrics.overLimit || metrics.blockedCount ? 'warning' : 'ready',
      };
    }),
  };
}

function workflowAction(target = '') {
  app.quickFilter = 'pmb';
  app.pmbSubFilter = normalizePmbSubFilter(target);
  app.activePmbBayStage = normalizePmbStage(target);
  showView('workflow');
  renderWorkflowBoard();
}

function workshopEligibilitySharedAuthorityEnabled() {
  return window.PDC_SUPABASE_CONFIG?.workshop?.sharedData === true;
}

function teardownWorkshopEligibilityOverview({ clearSnapshot = false } = {}) {
  app.workshopEligibilityRequestGeneration += 1;
  app.workshopEligibilityRevisionPending = false;
  app.workshopEligibilitySnapshotRequest?.controller?.abort();
  app.workshopEligibilityRevisionRequest?.controller?.abort();
  app.workshopEligibilitySnapshotRequest = null;
  app.workshopEligibilityRevisionRequest = null;
  app.workshopEligibilityClockMinute = null;
  const realtime = app.workshopEligibilityRealtime;
  app.workshopEligibilityRealtime = null;
  if (app.workshopEligibilityReconnectTimer) clearTimeout(app.workshopEligibilityReconnectTimer);
  app.workshopEligibilityReconnectTimer = null;
  try { realtime?.unsubscribe?.(); } catch (_error) { /* best effort */ }
  if (clearSnapshot) {
    app.workshopEligibilitySnapshot = null;
    app.workshopEligibilityState = 'idle';
    app.workshopEligibilityError = '';
  }
}

function failWorkshopEligibilityOverviewSubscription(owner, status = 'Realtime unavailable') {
  if (app.workshopEligibilityRealtime !== owner) return;
  // Invalidate every snapshot request issued under the failed authority
  // session before releasing the channel. A late response is therefore inert.
  app.workshopEligibilityRequestGeneration += 1;
  app.workshopEligibilitySnapshotRequest?.controller?.abort();
  app.workshopEligibilityRevisionRequest?.controller?.abort();
  app.workshopEligibilitySnapshotRequest = null;
  app.workshopEligibilityRevisionRequest = null;
  app.workshopEligibilityRealtime = null;
  app.workshopEligibilitySnapshot = null;
  app.workshopEligibilityRevisionPending = false;
  app.workshopEligibilityState = 'reconnecting';
  app.workshopEligibilityError = String(status || 'Realtime unavailable');
  try { owner?.unsubscribe?.(); } catch (_error) { /* best effort */ }
  if (app.workshopEligibilityReconnectTimer) clearTimeout(app.workshopEligibilityReconnectTimer);
  app.workshopEligibilityReconnectTimer = setTimeout(() => {
    app.workshopEligibilityReconnectTimer = null;
    workshopEligibilityOverviewSubscribe();
  }, 1000);
  if (app.currentView === 'workflow') renderWorkflowBoard();
}

function workshopEligibilityOverviewSubscribe() {
  if (app.workshopEligibilityRealtime || typeof createPdcSupabaseRealtimeSubscription !== 'function') return;
  installWorkshopRecoveryListeners();
  app.workshopEligibilitySnapshot = null;
  app.workshopEligibilityState = 'reconnecting';
  // Install an owner token before opening the transport. Supabase adapters may
  // emit a failure synchronously from subscribe(); the token still makes that
  // callback authoritative and ensures the returned failed handle is disposed.
  const owner = {
    handle: null,
    subscribed: false,
    unsubscribe() {
      const handle = owner.handle;
      owner.handle = null;
      handle?.unsubscribe?.();
    },
  };
  app.workshopEligibilityRealtime = owner;
  let handle;
  try {
    handle = createPdcSupabaseRealtimeSubscription(window.PDC_SUPABASE_CONFIG, {
      onChange: () => {
        if (app.workshopEligibilityRealtime !== owner) return;
        app.workshopEligibilityRevisionPending = true;
        if (owner.subscribed) reconcileWorkshopEligibilityRevision('realtime');
      },
      onSubscribed: () => {
        if (app.workshopEligibilityRealtime !== owner) return null;
        owner.subscribed = true;
        if (app.workshopEligibilityReconnectTimer) clearTimeout(app.workshopEligibilityReconnectTimer);
        app.workshopEligibilityReconnectTimer = null;
        return loadWorkshopEligibilitySnapshot('subscribed');
      },
      onError: status => failWorkshopEligibilityOverviewSubscription(owner, status),
      onClosed: status => failWorkshopEligibilityOverviewSubscription(owner, status || 'Realtime closed'),
    }, { allStations: true, overview: true });
  } catch (error) {
    failWorkshopEligibilityOverviewSubscription(owner, error?.message || 'Realtime subscribe failed');
    return;
  }
  owner.handle = handle;
  if (app.workshopEligibilityRealtime !== owner) owner.unsubscribe();
}

function workshopEligibilityRequestIsCurrent(request) {
  if (request.generation !== app.workshopEligibilityRequestGeneration || app.workshopEligibilityRealtime !== request.owner) return false;
  if (getPdcSupabaseAccessToken() === request.token && (window.PDC_AUTH_CONTEXT?.role || null) === request.role) return true;
  teardownWorkshopEligibilityOverview({ clearSnapshot: true });
  app.workshopEligibilityState = 'permission_denied';
  app.workshopEligibilityError = 'Sign in again to load current workshop information.';
  if (app.currentView === 'workflow') renderWorkflowBoard();
  return false;
}

function workshopEligibilityReadError(error) {
  app.workshopEligibilitySnapshot = null;
  app.workshopEligibilityState = error?.status === 401 || error?.status === 403 ? 'permission_denied' : 'offline_error';
  app.workshopEligibilityError = error?.message || String(error);
  if (app.currentView === 'workflow') renderWorkflowBoard();
}

function refreshWorkshopEligibilityClock() {
  if (app.currentView !== 'workflow' || document.visibilityState !== 'visible'
      || app.workshopEligibilityState !== 'connected' || !app.workshopEligibilitySnapshot
      || !getPdcSupabaseAccessToken()) return;
  const minute = Math.floor(Date.now() / 60000);
  if (app.workshopEligibilityClockMinute === minute) return;
  // A clock redraw must not interrupt panning, typing or a booking dialog.
  if (document.querySelector?.('.modal-overlay:not([hidden]), dialog[open], .control-board-pan-rail.is-dragging')
      || document.activeElement?.matches?.('input, textarea, select')) return;
  app.workshopEligibilityClockMinute = minute;
  renderWorkflowBoard();
}

function reconcileWorkshopEligibilityRevision(reason = 'revision_check') {
  if (!workshopEligibilitySharedAuthorityEnabled() || app.currentView !== 'workflow' || document.visibilityState !== 'visible') return Promise.resolve(null);
  const token = getPdcSupabaseAccessToken();
  if (!token) return Promise.resolve(null);
  const owner = app.workshopEligibilityRealtime;
  if (!owner) { workshopEligibilityOverviewSubscribe(); return Promise.resolve(null); }
  if (!owner.subscribed || app.workshopEligibilitySnapshotRequest) return Promise.resolve(null);
  if (app.workshopEligibilityRevisionRequest) return app.workshopEligibilityRevisionRequest.promise;
  const request = { owner, token, role: window.PDC_AUTH_CONTEXT?.role || null,
    generation: app.workshopEligibilityRequestGeneration, controller: new AbortController(), promise: null };
  app.workshopEligibilityRevisionRequest = request;
  const timeout = window.setTimeout(() => request.controller.abort(), 8000);
  request.promise = (async () => {
    let reload = false;
    try {
      const response = await fetch(`${window.PDC_SUPABASE_CONFIG.url}/rest/v1/rpc/get_workshop_overview_revisions`, {
        method: 'POST', body: '{}',
        headers: { apikey: window.PDC_SUPABASE_CONFIG.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        cache: 'no-store', signal: request.controller.signal,
      });
      if (!response.ok) throw Object.assign(new Error('Workshop freshness could not be checked.'), { status: response.status });
      const rows = await response.json();
      if (!workshopEligibilityRequestIsCurrent(request)) return null;
      if (!Array.isArray(rows) || rows.length === 0 || rows.some(row => !row.stage_code || !/^\d+$/.test(String(row.revision ?? '')))
          || new Set(rows.map(row => row.stage_code)).size !== rows.length) throw new Error('Workshop freshness returned an invalid revision.');
      const revisions = new Map(rows.map(row => [row.stage_code, String(row.revision)]));
      const stages = app.workshopEligibilitySnapshot?.stages;
      reload = app.workshopEligibilityState !== 'connected' || !Array.isArray(stages) || stages.length === 0 || stages.length !== rows.length
        || stages.some(stage => revisions.get(stage.code) !== String(stage.revision));
      app.workshopEligibilityRevisionPending = false;
    } catch (error) {
      if (workshopEligibilityRequestIsCurrent(request)) workshopEligibilityReadError(error);
    } finally {
      window.clearTimeout(timeout);
      if (app.workshopEligibilityRevisionRequest === request) app.workshopEligibilityRevisionRequest = null;
    }
    return reload && workshopEligibilityRequestIsCurrent(request) ? loadWorkshopEligibilitySnapshot(reason) : null;
  })();
  return request.promise;
}

function loadWorkshopEligibilitySnapshot(reason = 'manual') {
  if (!workshopEligibilitySharedAuthorityEnabled()) return null;
  const token = getPdcSupabaseAccessToken();
  if (!token) {
    app.workshopEligibilitySnapshot = null;
    app.workshopEligibilityState = 'permission_denied';
    app.workshopEligibilityError = 'Sign in to load authoritative workshop eligibility.';
    if (app.currentView === 'workflow') renderWorkflowBoard();
    return null;
  }
  // Trust is established only after the Realtime channel reports SUBSCRIBED.
  // The subscription callback then performs the authoritative resync, closing
  // the fetch-before-subscribe missed-event window.
  if (!app.workshopEligibilityRealtime && reason !== 'subscribed') {
    workshopEligibilityOverviewSubscribe();
    return null;
  }
  const authorityOwner = app.workshopEligibilityRealtime;
  if (!authorityOwner?.subscribed) return null;
  // Route entry, manual refresh and Realtime can coincide. One in-flight
  // snapshot wins; a later revision check detects any change made during it.
  if (app.workshopEligibilitySnapshotRequest) {
    if (reason === 'confirmed_fitter_write') app.workshopEligibilityRevisionPending = true;
    return app.workshopEligibilitySnapshotRequest.promise;
  }
  const request = { owner: authorityOwner, token, role: window.PDC_AUTH_CONTEXT?.role || null,
    generation: ++app.workshopEligibilityRequestGeneration, controller: new AbortController(), promise: null };
  app.workshopEligibilityRevisionRequest?.controller?.abort();
  app.workshopEligibilityRevisionRequest = null;
  app.workshopEligibilitySnapshotRequest = request;
  const retainVisibleSnapshot = app.workshopEligibilityState === 'connected' && app.workshopEligibilitySnapshot;
  if (!retainVisibleSnapshot) app.workshopEligibilityState = 'loading';
  app.workshopEligibilityError = '';
  if (!retainVisibleSnapshot && app.currentView === 'workflow') renderWorkflowBoard();
  const timeout = window.setTimeout(() => request.controller.abort(), 20000);
  request.promise = (async () => {
   try {
    const response = await fetch(`${window.PDC_SUPABASE_CONFIG.url}/rest/v1/rpc/get_workshop_eligibility_snapshot`, {
      method: 'POST',
      headers: {
        apikey: window.PDC_SUPABASE_CONFIG.publishableKey,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: '{}',
      cache: 'no-store', signal: request.controller.signal,
    });
    if (!response.ok) throw Object.assign(new Error(response.status === 401 || response.status === 403 ? 'Not authorized to read workshop eligibility.' : `Eligibility RPC failed (${response.status}).`), { status: response.status });
    const snapshot = await response.json();
    if (!workshopEligibilityRequestIsCurrent(request)) return null;
    if (!snapshot || !Array.isArray(snapshot.stages) || !Array.isArray(snapshot.candidates)) throw new Error('Eligibility RPC returned an invalid snapshot.');
    app.workshopEligibilitySnapshot = snapshot;
    app.workshopEligibilityState = 'connected';
    app.workshopEligibilityError = '';
    app.workshopEligibilityClockMinute = Math.floor(Date.now() / 60000);
    if (app.currentView === 'workflow') renderWorkflowBoard();
    return snapshot;
  } catch (error) {
    if (!workshopEligibilityRequestIsCurrent(request)) return null;
    workshopEligibilityReadError(error);
    return null;
  } finally {
    window.clearTimeout(timeout);
    if (app.workshopEligibilitySnapshotRequest === request) {
      app.workshopEligibilitySnapshotRequest = null;
      if (app.workshopEligibilityRevisionPending && app.workshopEligibilityState === 'connected') {
        void reconcileWorkshopEligibilityRevision('realtime_pending');
      }
    }
  }
  })();
  return request.promise;
}

function workshopEligibilityCandidateVehicle(candidate = {}) {
  const raw = candidate.vehicle || {};
  const local = app.data.find(vehicle => String(vehicle.id || vehicle.sharedVehicleId || '') === String(raw.id || ''))
    || app.data.find(vehicle => String(displayStockNumber(vehicle) || '') === String(raw.stock_number || ''));
  const workItems = Array.isArray(candidate.work_items) ? candidate.work_items : [];
  let shared = {
    id: raw.id,
    sharedVehicleId: raw.id,
    stock: raw.stock_number || '', stockNumber: raw.stock_number || '',
    vin: raw.vin || '', jobCardNumber: raw.job_card_number || '',
    client: raw.customer_name || '', vehicle: [raw.make, raw.model].filter(Boolean).join(' '),
    rego: raw.registration || '', registration: raw.registration || '',
    pdcLocation: raw.current_location || '', manualLocation: raw.current_location || '',
    pmbStage: raw.pmb_stage || '', pmbBayStage: raw.pmb_bay_stage || '', pmbBay: raw.pmb_bay_number || '',
    etaToKewdale: raw.eta_to_kewdale || '', eta: raw.eta_to_kewdale || '',
    pmbJobs: {},
  };
  workItems.forEach(item => {
    const def = pmbStageJobDef(WORKSHOP_ELIGIBILITY.canonicalWorkshopStage(item.work_key));
    if (def) shared.pmbJobs[def.key] = { required: item.required === true, complete: item.completed === true, completedAt: item.completed_at || '' };
  });
  shared = { ...shared, pmbJobs: { ...shared.pmbJobs } };
  shared.__workshopEligibility = {
    stage: candidate.stage_code,
    location: raw.current_location || '',
    scheduleEnabled: candidate.schedule_enabled === true,
    disabledReason: candidate.disabled_reason || '',
    localVehicleKey: local ? vehicleKey(local) : '',
  };
  return shared;
}

function authoritativeWorkshopVehiclesForStage(stage = '') {
  if (app.workshopEligibilityState !== 'connected') return [];
  const canonical = WORKSHOP_ELIGIBILITY.canonicalWorkshopStage(stage);
  const candidates = app.workshopEligibilitySnapshot?.candidates;
  if (!Array.isArray(candidates)) return [];
  return candidates.filter(candidate => WORKSHOP_ELIGIBILITY.canonicalWorkshopStage(candidate.stage_code) === canonical)
    .map(workshopEligibilityCandidateVehicle)
    .sort((a, b) => String(displayStockNumber(a) || vehicleKey(a) || '').localeCompare(String(displayStockNumber(b) || vehicleKey(b) || '')));
}

function pmbVehicleNeedsStationWork(vehicle = {}, stage = '') {
  const normalizedStage = normalizePmbStage(stage);
  const def = pmbStageJobDef(normalizedStage);
  if (statusCategory(vehicle) !== 'pmb' || !def || !WORKSHOP_CONTROL_BOARD_STATIONS.includes(normalizedStage)) return false;
  const incomplete = !pdcJobComplete(vehicle, def);
  if (!incomplete) return false;
  return pdcJobRequired(vehicle, def);
}

function pmbVehiclesNeedingStationWork(stage = '') {
  const normalizedStage = normalizePmbStage(stage);
  if (workshopEligibilitySharedAuthorityEnabled()) return authoritativeWorkshopVehiclesForStage(normalizedStage);
  return app.data
    .filter(vehicle => pmbVehicleNeedsStationWork(vehicle, normalizedStage))
    .sort((a, b) => String(displayStockNumber(a) || vehicleKey(a) || '').localeCompare(String(displayStockNumber(b) || vehicleKey(b) || '')));
}

// C1 resolves a legacy lifecycle consumer through the narrow deterministic RPC.
// The old direct table query remains available only through the explicit,
// staging-project-only rollback flag. Neither path selects a first row when
// multiple candidates exist.
function recordVehicleLifecycleResolverDiagnostic(item = {}) {
  window.__vehicleLifecycleResolverDiagnostics = window.__vehicleLifecycleResolverDiagnostics || [];
  window.__vehicleLifecycleResolverDiagnostics.push({ at: new Date().toISOString(), ...item });
  if (window.__vehicleLifecycleResolverDiagnostics.length > 100) window.__vehicleLifecycleResolverDiagnostics.shift();
}

async function vehicleLifecycleLegacyDirectRef(vehicle = {}) {
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  const identity = String(displayStockNumber(vehicle) || '').trim();
  if (!identity) return { outcome: 'invalid_input' };
  const url = `${window.PDC_SUPABASE_CONFIG.url}/rest/v1/vehicles?select=id,version,qc_completed_at,lifecycle_state,deleted_at&or=(stock_number.eq.${encodeURIComponent(identity)},permanent_vehicle_id.eq.${encodeURIComponent(identity)})&limit=2`;
  recordVehicleLifecycleResolverDiagnostic({ type: 'rollback_direct_read', identityFields: ['legacy_identity'] });
  try {
    const res = await fetch(url, {
      headers: {
        apikey: window.PDC_SUPABASE_CONFIG.publishableKey,
        Authorization: `Bearer ${token || window.PDC_SUPABASE_CONFIG.publishableKey}`,
      },
    });
    if (res.status === 401 || res.status === 403) return { outcome: 'unauthorized' };
    if (!res.ok) return { outcome: 'service_unavailable' };
    const rows = await res.json();
    if (!Array.isArray(rows)) return { outcome: 'service_unavailable' };
    if (rows.length === 0) return { outcome: 'not_found' };
    if (rows.length > 1) return { outcome: 'ambiguous' };
    const row = rows[0];
    return {
      outcome: 'resolved',
      vehicleId: row.id,
      version: row.version,
      qcCompletedAt: row.qc_completed_at,
      lifecycleState: row.lifecycle_state,
      isArchived: row.deleted_at != null,
      resolverRevision: null,
      matchedBy: ['legacy_direct_read'],
    };
  } catch (_err) {
    return { outcome: 'service_unavailable' };
  }
}

async function vehicleLifecycleSharedRef(vehicle = {}) {
  if (!vehicleLifecycleSharedModeActive()) return { outcome: 'service_unavailable' };
  const rollback = typeof vehicleLifecycleResolverRollbackEnabled === 'function'
    && vehicleLifecycleResolverRollbackEnabled(window.PDC_SUPABASE_CONFIG);
  if (rollback) return vehicleLifecycleLegacyDirectRef(vehicle);
  if (!window.__vehicleLifecycleIdentityResolver || typeof buildVehicleLifecycleIdentityInput !== 'function') {
    return { outcome: 'service_unavailable' };
  }
  const input = buildVehicleLifecycleIdentityInput(vehicle);
  const result = await window.__vehicleLifecycleIdentityResolver.resolve(input, { reason: 'lifecycle_consumer' });
  recordVehicleLifecycleResolverDiagnostic({
    type: 'consumer_resolution',
    outcome: result && result.outcome,
    inputFields: Object.keys(input).sort(),
  });
  return result || { outcome: 'service_unavailable' };
}

function describeVehicleLifecycleResolutionOutcome(result = {}) {
  const messages = {
    not_found: 'This vehicle was not found in the shared database.',
    ambiguous: 'More than one shared vehicle matches this identity. No change was made; an administrator must resolve the duplicate.',
    conflict: 'The supplied vehicle identifiers point to different shared vehicles. No change was made.',
    invalid_input: 'This vehicle does not have a valid shared identity. No change was made.',
    unauthorized: 'Your account is not authorized to resolve shared vehicle identity.',
    service_unavailable: 'Shared vehicle identity is temporarily unavailable. No change was made.',
  };
  return messages[result && result.outcome] || 'This vehicle could not be resolved safely. No change was made.';
}

function describeSharedVehicleWorkStateError(result = {}) {
  const messages = {
    vehicle_version_conflict: 'This vehicle changed after you opened it. Reload the vehicle and try again.',
    active_booking_exists: `This work already has an active Workshop booking. Change or complete it from the ${pmbStageLabel(result.stage_code || '') || 'Workshop'} Planner.`,
    vehicle_not_found: 'The shared vehicle is no longer available.',
    invalid_work_states: 'The required-work selection was invalid.',
    invalid_work_state_keys: 'The required-work selection was incomplete.',
    invalid_work_state: 'One required-work selection was invalid.',
    permission_denied: 'Your account is not permitted to change required work.',
  };
  const backendBody = Array.isArray(result.body) ? result.body[0] : result.body;
  const backendMessage = backendBody?.message || backendBody?.error || backendBody?.details || backendBody?.hint || result.message || '';
  const base = messages[result.error] || 'Required work could not be saved to the shared database. No required-work change was made.';
  const status = result.status ? ` HTTP ${result.status}` : '';
  return backendMessage ? `${base}${status} — ${String(backendMessage).slice(0, 240)}` : `${base}${status}`;
}

function reconcileSharedWorkStatesInMemory(vehicle = {}, vehicleId = '', workStates = {}, vehicleVersion = null) {
  const requestedId = String(vehicleId || '').trim();
  const requestedKeys = new Set([
    vehicleKey(vehicle), vehicle?.stock, vehicle?.batch, vehicle?.id, vehicle?.__emailVehicleId,
  ].map(value => String(value || '').trim()).filter(Boolean));
  const rows = [
    vehicle,
    ...(Array.isArray(app.data) ? app.data : []),
    ...(Array.isArray(app.emailVehicleLocationRows) ? app.emailVehicleLocationRows : []),
  ].filter(Boolean);
  const seen = new Set();
  rows.forEach(row => {
    const rowId = String(row.__emailVehicleId || row.sharedVehicleId || '').trim();
    const rowKeys = [vehicleKey(row), row.stock, row.batch, row.id].map(value => String(value || '').trim());
    if (row !== vehicle && rowId !== requestedId && !rowKeys.some(value => value && requestedKeys.has(value))) return;
    if (seen.has(row)) return;
    seen.add(row);
    PDC_JOB_DEFS.forEach(def => {
      const state = String(workStates[def.key] || 'none').toLowerCase();
      row[def.requireKey] = state !== 'none';
      row[def.completeKey] = state === 'complete';
    });
    if (requestedId) {
      row.__emailVehicleServerAuthoritative = true;
      row.__emailVehicleId = requestedId;
      row.sharedVehicleId = requestedId;
    }
    if (Number.isInteger(Number(vehicleVersion)) && Number(vehicleVersion) > 0) row.__emailVehicleVersion = Number(vehicleVersion);
  });
}

function pdcWorkStateFromForm(form, vehicle = {}, def = {}, locked = false) {
  if (locked) return pdcJobTriState(vehicle, def);
  const button = form?.querySelector?.(`[data-pdc-work-state="${def.key}"]`);
  const buttonState = String(button?.dataset?.state || '').toLowerCase();
  if (['none', 'required', 'complete'].includes(buttonState)) return buttonState;
  const named = form?.elements?.namedItem?.(def.requireKey) || form?.[def.requireKey];
  const completed = form?.elements?.namedItem?.(def.completeKey) || form?.[def.completeKey];
  if (completed?.value === '1') return 'complete';
  if (named?.value === '1') return 'required';
  return 'none';
}

function pdcWorkStateMapFromForm(form, vehicle = {}, locked = false) {
  return Object.fromEntries(PDC_JOB_DEFS.map(def => [def.key, pdcWorkStateFromForm(form, vehicle, def, locked)]));
}

function pdcWorkStateUpdatesFromMap(workStates = {}) {
  const requirementUpdates = {};
  const completionUpdates = {};
  PDC_JOB_DEFS.forEach(def => {
    const state = String(workStates[def.key] || 'none').toLowerCase();
    requirementUpdates[def.requireKey] = state !== 'none';
    completionUpdates[def.completeKey] = state === 'complete';
  });
  return { requirementUpdates, completionUpdates };
}

async function refreshSharedVehicleWorkState(vehicle = {}) {
  if (!vehicle || !vehicleLifecycleSharedModeActive()) return false;
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !window.PDC_SUPABASE_CONFIG?.url) return false;
  const ref = await vehicleLifecycleSharedRef(vehicle);
  if (!ref || ref.outcome !== 'resolved') return false;
  const headers = {
    apikey: window.PDC_SUPABASE_CONFIG.publishableKey,
    Authorization: `Bearer ${token}`,
  };
  const workUrl = `${window.PDC_SUPABASE_CONFIG.url}/rest/v1/vehicle_work_items?select=work_key,required,completed,completed_at,completed_by&vehicle_id=eq.${encodeURIComponent(ref.vehicleId)}&order=work_key`;
  const partsUrl = `${window.PDC_SUPABASE_CONFIG.url}/rest/v1/vehicle_parts_updates?select=parts_required,parts_ordered,parts_received,worst_eta,updated_at&vehicle_id=eq.${encodeURIComponent(ref.vehicleId)}&order=updated_at.desc,id.desc&limit=1`;
  try {
    const [workResponse, partsResponse] = await Promise.all([
      fetch(workUrl, { headers }),
      fetch(partsUrl, { headers }),
    ]);
    if (!workResponse.ok || !partsResponse.ok) return false;
    const workRows = await workResponse.json();
    const partsRows = await partsResponse.json();
    const workStates = Object.fromEntries(PDC_JOB_DEFS.map(def => [def.key, 'none']));
    (Array.isArray(workRows) ? workRows : []).forEach(row => {
      const def = pdcJobDefinitionForKey(row.work_key);
      if (!def) return;
      workStates[def.key] = row.completed === true ? 'complete' : row.required === true ? 'required' : 'none';
    });
    const parts = Array.isArray(partsRows) ? partsRows[0] : null;
    if (parts) {
      workStates.parts = parts.parts_received === true ? 'complete' : parts.parts_required === true ? 'required' : 'none';
      vehicle.pdcPartsOrdered = parts.parts_ordered === true;
      vehicle.pdcPartsWorstEta = parts.worst_eta || '';
      vehicle.pdcPartsPreviousWorstEta = parts.previous_worst_eta || '';
      vehicle.pdcPartsWorstEtaUpdatedAt = parts.updated_at || '';
    }
    reconcileSharedWorkStatesInMemory(vehicle, ref.vehicleId, workStates, ref.version);
    cacheSharedWorkState(vehicle, ref.vehicleId, workStates, ref.version);
    pendingSharedWorkStateMap().set(ref.vehicleId, {
      stock: String(displayStockNumber(vehicle) || vehicle.stock || '').trim(),
      workStates: { ...workStates },
      vehicleVersion: Number(ref.version) || 0,
      savedAt: Date.now(),
    });
    return true;
  } catch (_error) {
    return false;
  }
}

function sharedWorkStateCache() {
  if (!(app.sharedVehicleWorkStateCache instanceof Map)) app.sharedVehicleWorkStateCache = new Map();
  return app.sharedVehicleWorkStateCache;
}

function cacheSharedWorkState(vehicle, vehicleId, workStates, vehicleVersion) {
  sharedWorkStateCache().set(String(vehicleId || '').trim(), {
    stock: String(displayStockNumber(vehicle) || vehicle.stock || '').trim(),
    workStates: { ...workStates },
    vehicleVersion: Number(vehicleVersion) || 0,
  });
}

function applySharedWorkStateCache(rows = []) {
  const cache = sharedWorkStateCache();
  rows.filter(Boolean).forEach(row => {
    for (const [vehicleId, item] of cache) {
      const rowId = String(row.__emailVehicleId || row.sharedVehicleId || row.id || '').trim();
      const rowStock = String(row.stock || row.stockNumber || '').trim();
      if (rowId !== vehicleId && rowStock !== item.stock) continue;
      PDC_JOB_DEFS.forEach(def => {
        const state = String(item.workStates[def.key] || 'none').toLowerCase();
        row[def.requireKey] = state !== 'none';
        row[def.completeKey] = state === 'complete';
      });
      row.__emailVehicleServerAuthoritative = true;
      row.__emailVehicleId = vehicleId;
      row.sharedVehicleId = vehicleId;
      row.__emailVehicleVersion = Math.max(Number(row.__emailVehicleVersion || 0), item.vehicleVersion);
    }
  });
  return rows;
}

function pendingSharedWorkStateMap() {
  if (!(app.pendingSharedWorkStates instanceof Map)) app.pendingSharedWorkStates = new Map();
  return app.pendingSharedWorkStates;
}

function sharedWorkStatesMatchVehicle(vehicle = {}, workStates = {}) {
  return PDC_JOB_DEFS.every(def => {
    const state = String(workStates[def.key] || 'none').toLowerCase();
    return Boolean(vehicle[def.requireKey]) === (state !== 'none')
      && Boolean(vehicle[def.completeKey]) === (state === 'complete');
  });
}

function applyPendingSharedWorkStateOverlays(rows = []) {
  const pending = pendingSharedWorkStateMap();
  const now = Date.now();
  rows.filter(Boolean).forEach(row => {
    for (const [vehicleId, item] of pending) {
      if (now - item.savedAt > 30000) {
        pending.delete(vehicleId);
        continue;
      }
      const rowId = String(row.__emailVehicleId || row.sharedVehicleId || row.id || '').trim();
      const rowStock = String(row.stock || row.stockNumber || '').trim();
      if (rowId !== vehicleId && rowStock !== item.stock) continue;
      const incomingVersion = Number(row.__emailVehicleVersion || row.sharedVehicleLinkVehicleVersion || row.version || 0);
      if (incomingVersion >= item.vehicleVersion && sharedWorkStatesMatchVehicle(row, item.workStates)) {
        pending.delete(vehicleId);
        continue;
      }
      PDC_JOB_DEFS.forEach(def => {
        const state = String(item.workStates[def.key] || 'none').toLowerCase();
        row[def.requireKey] = state !== 'none';
        row[def.completeKey] = state === 'complete';
      });
      row.__emailVehicleServerAuthoritative = true;
      row.__emailVehicleId = vehicleId;
      row.sharedVehicleId = vehicleId;
      row.__emailVehicleVersion = Math.max(incomingVersion, item.vehicleVersion);
    }
  });
  return rows;
}

async function saveSharedVehicleWorkStates(vehicle = {}, workStates = {}) {
  const ref = await vehicleLifecycleSharedRef(vehicle);
  if (!ref || ref.outcome !== 'resolved') {
    return { ok: false, error: 'identity_resolution_failed', message: describeVehicleLifecycleResolutionOutcome(ref) };
  }
  if (ref.isArchived) return { ok: false, error: 'vehicle_archived', message: 'Archived or completed vehicles cannot have required work changed.' };
  const guardedPatch = window.VehicleRequirementsGuard?.mergeRequirementPatch?.({}, workStates);
  if (guardedPatch && guardedPatch.ok !== true) return guardedPatch;
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token) return { ok: false, error: 'permission_denied' };
  try {
    const response = await fetch(`${window.PDC_SUPABASE_CONFIG.url}/rest/v1/rpc/set_pdc_vehicle_work_states`, {
      method: 'POST',
      headers: {
        apikey: window.PDC_SUPABASE_CONFIG.publishableKey,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        p_vehicle_id: ref.vehicleId,
        p_expected_version: ref.version,
        p_work_states: workStates,
      }),
    });
    let body = null;
    try { body = await response.json(); } catch (_error) { body = null; }
    if (!response.ok) {
      return { ok: false, error: response.status === 401 || response.status === 403 ? 'permission_denied' : 'request_failed', status: response.status, body };
    }
    if (!body || body.ok !== true) return { ok: false, ...(body || {}) };
    vehicle.sharedVehicleId = ref.vehicleId;
    vehicle.sharedVehicleLinkVehicleVersion = body.vehicle_version;
    reconcileSharedWorkStatesInMemory(vehicle, ref.vehicleId, workStates, body.vehicle_version);
    cacheSharedWorkState(vehicle, ref.vehicleId, workStates, body.vehicle_version);
    pendingSharedWorkStateMap().set(ref.vehicleId, {
      stock: String(displayStockNumber(vehicle) || vehicle.stock || '').trim(),
      workStates: { ...workStates },
      vehicleVersion: Number(body.vehicle_version) || 0,
      savedAt: Date.now(),
    });
    // Do not block the Save button on unrelated Workshop snapshot services.
    // Their refresh is best-effort; the email vehicle snapshot is reconciled
    // through the bounded pending overlay above until it confirms this version.
    void Promise.resolve().then(() => loadWorkshopEligibilitySnapshot('vehicle_work_states_saved')).catch(() => {});
    void Promise.resolve().then(() => window.__workshopDataService?.loadSnapshot?.('vehicle_work_states_saved')).catch(() => {});
    void refreshEmailVehicleLocations();
    void refreshSharedVehicleWorkState(vehicle).then(ok => {
      if (ok && app.selectedStock === vehicleKey(vehicle)) renderDetail();
    });
    return body;
  } catch (_error) {
    return { ok: false, error: 'service_unavailable' };
  }
}

function reconcileVehicleLifecycleServerResult(vehicle = {}, result = {}) {
  const authoritative = result && typeof result.vehicle === 'object'
    ? result.vehicle
    : result?.data && typeof result.data.vehicle === 'object'
      ? result.data.vehicle
      : null;
  if (!authoritative) return false;
  const location = normalizePdcLocation(authoritative.current_location || '');
  if (location) {
    vehicle.pdcLocation = location;
    vehicle.manualLocation = location;
  }
  vehicle.pdcQcComplete = Boolean(authoritative.qc_completed_at);
  vehicle.pdcQcCompleteAt = authoritative.qc_completed_at || '';
  vehicle.pdcQcCompleteBy = authoritative.qc_completed_by || '';
  vehicle.rftTransferredAt = authoritative.rft_transferred_at || '';
  vehicle.dateToPmb = authoritative.date_to_pmb || vehicle.dateToPmb || '';
  vehicle.dateToRft = authoritative.date_to_rft || vehicle.dateToRft || '';
  vehicle.deliveredToDealerDate = authoritative.delivered_to_dealer_date || vehicle.deliveredToDealerDate || '';
  return true;
}

function vehicleReadyForQualityControl(vehicle = {}) {
  if (vehicle.pdcHasUnclassifiedOperationWork === true) return false;
  if (vehiclePdcLocation(vehicle) !== 'PMB' || vehicle.pdcQcComplete === true || isPdcBlocked(vehicle) || isActivePartsStoppage(vehicle)) return false;
  if (pdcQualityControlRequirementDefinitions(vehicle).some(job => !pdcJobComplete(vehicle, job))) return false;
  const currentStage = normalizePmbStage(inferredPmbStage(vehicle));
  return !currentStage || currentStage === 'PIT_INSPECTION';
}

function vehicleInQualityControlGate(vehicle = {}) {
  return vehiclePdcLocation(vehicle) === 'QC';
}

function isAcceptanceClosureVehicle(vehicle = {}) {
  return /^HERMES-TEST-AC-[ABC]$/.test(displayStockNumber(vehicle))
    && String(vehicle.sourceRecordId || vehicle.source_record_id || '').trim() === displayStockNumber(vehicle);
}

async function markVehicleReadyForQualityControl(key = '') {
  const vehicle = selectedVehicle(key);
  if (!vehicle || !vehicleReadyForQualityControl(vehicle)) {
    pdcNotify('Ready for QC is available only after every required physical workshop item is green and the vehicle is back in PMB Unallocated.');
    return false;
  }
  const label = vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'this vehicle';
  if (!window.confirm(`All required work is complete for ${label}.\n\nMark this vehicle Ready for QC and move it to the QC Gate in Vehicle Locations?`)) return false;

  if (vehicleLifecycleSharedModeActive()) {
    const ref = await vehicleLifecycleSharedRef(vehicle);
    if (!ref || ref.outcome !== 'resolved') {
      pdcNotify(describeVehicleLifecycleResolutionOutcome(ref));
      return false;
    }
    if (ref.isArchived) {
      pdcNotify('This vehicle has been archived and cannot be moved to the QC Gate.');
      return false;
    }
    const result = await window.__vehicleLifecycleActions.markReadyForQc({ vehicleId: ref.vehicleId, expectedVersion: ref.version });
    if (!result || result.ok !== true) {
      pdcNotify(typeof describeVehicleLifecycleActionError === 'function'
        ? describeVehicleLifecycleActionError(result && result.error)
        : 'The vehicle could not be moved to the QC Gate.');
      return false;
    }
    reconcileVehicleLifecycleServerResult(vehicle, result);
    const [locationsRefreshed] = await Promise.all([
      refreshEmailVehicleLocations(),
      window.__workshopDataService && typeof window.__workshopDataService.loadSnapshot === 'function'
        ? window.__workshopDataService.loadSnapshot('ready_for_qc').then(() => true).catch(() => false)
        : Promise.resolve(false),
    ]);
    // The direct lifecycle response has already been reconciled in memory. If
    // the broader authoritative snapshot is temporarily unavailable, render
    // that committed QC state immediately rather than requiring Ctrl+F5.
    if (!locationsRefreshed) renderAll();
    return true;
  }

  const now = nowIsoString();
  recordVehicleAudit(vehicle, 'Vehicle marked Ready for QC', { by: getCurrentOperatorName(), from: 'PMB', to: 'QC Gate' });
  saveVehicleEdits(vehicleKey(vehicle), {
    pdcLocation: 'QC', manualLocation: 'QC', pdcLocationLocked: true, pdcLocationUpdatedAt: now,
  });
  renderAll();
  return true;
}

function qualityControlVehicleHtml(vehicle = {}) {
  const key = vehicleKey(vehicle);
  const stock = displayStockNumber(vehicle) || key || 'No stock';
  const action = `<button class="small-button" type="button" data-open-qc-vehicle="${escapeHtml(key)}">Open QC finalization</button>`;
  return `<article class="control-board-work-vehicle control-board-qc-vehicle" aria-label="${escapeHtml(stock)} in QC">
    <span class="control-board-work-identity">${vehicleIdentityStackHtml(vehicle)}</span>
    <span class="control-board-work-main"><strong>${escapeHtml(displayVehicle(vehicle) || 'Vehicle not listed')}</strong></span>
    <span class="control-board-work-location"><b>Now</b><span>QC</span></span>
    <span class="control-board-work-age"><b>${vehicleKeyIsWpc(vehicle) ? 'Since' : 'PMB'}</b><span title="${escapeHtml(pmbAgeDetailText(vehicle))}">${escapeHtml(pmbAgeLabel(vehicle))}</span></span>
    <span class="badge warning">Awaiting receipt-backed sign-off</span>
    ${action}
  </article>`;
}

async function completeVehicleQualityControl(key = '', photoEvidence = null, authority = capturePdcWriteAuthority()) {
  if (vehicleLifecycleSharedModeActive() && !pdcWriteAuthorityCurrent(authority)) return false;
  const vehicle = selectedVehicle(key);
  if (!vehicle) return false;
  if (!vehicleInQualityControlGate(vehicle)) {
    pdcNotify('QC finalization is available only for vehicles currently in the QC Gate.');
    return false;
  }
  if (vehicleLifecycleSharedModeActive() && (!photoEvidence?.photoReceiptId || typeof app.emailVehicleLocationService?.finalizeQcToRft700 !== 'function')) {
    pdcNotify('Store the private completion photo first. No QC or RFT state was changed.');
    return false;
  }
  const operator = cleanNavisionText(window.PDC_AUTH_CONTEXT?.displayName || window.PDC_AUTH_CONTEXT?.email || localStorage.getItem(OPERATOR_NAME_KEY) || '');
  const role = cleanNavisionText(window.PDC_AUTH_CONTEXT?.role || localStorage.getItem(OPERATOR_ROLE_KEY) || '');
  if (!operator || !role) {
    pdcNotify('Set your operator name and role before completing QC. No vehicle was changed.');
    return false;
  }
  const label = vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'this vehicle';
  if (!window.confirm(`Pass final check for ${label}?\n\nThe car goes to WPC and keeps its key number until it is ticked RFT\u2019d (r827). The salesperson email opens next.\n\nThis stores the named QC sign-off, exact completed-item snapshot and private photo evidence. The transport timer starts at the RFT\u2019d tick, not at QC.`)) return false;

  if (vehicleLifecycleSharedModeActive()) {
    const service = app.emailVehicleLocationService;
    const ref = await vehicleLifecycleSharedRef(vehicle);
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    if (!ref || ref.outcome !== 'resolved') {
      pdcNotify(describeVehicleLifecycleResolutionOutcome(ref));
      return false;
    }
    if (ref.isArchived) {
      pdcNotify('This vehicle is archived in shared data, so QC finalization was not applied. No change was made.');
      return false;
    }
    const result = await service.finalizeQcToRft700(ref.vehicleId, ref.version, photoEvidence.photoReceiptId, crypto.randomUUID());
    if (!pdcWriteAuthorityCurrent(authority)) return false;
    if (!result || result.ok !== true) {
      const qcFinalizationMessages = {
        salesperson_email_required: 'Assign an active salesperson with an email address before final sign-off. The stored photo receipt is retained and no vehicle state changed.',
        qc_operation_lines_incomplete: 'Every active QC operation must be completed before final sign-off. The stored photo receipt is retained.',
        vehicle_version_conflict: 'This vehicle changed after the photo was stored. Reload the QC page; the stored photo receipt is retained.',
        qc_photo_receipt_required: 'The server could not verify the stored completion photo receipt. No vehicle state changed.',
      };
      const resultCode = cleanNavisionText(result?.code || result?.error || '');
      const named = cleanNavisionText(result?.message || '');
      const listed = (Array.isArray(result?.outstanding) ? result.outstanding : []).map(item => cleanNavisionText(item || '')).filter(Boolean).join(' ');
      const message = named || listed || qcFinalizationMessages[resultCode] || (typeof describeVehicleLifecycleActionError === 'function'
        ? describeVehicleLifecycleActionError(result && (result.code || result.error))
        : 'The QC finalization could not be saved.');
      pdcNotify(message);
      qcPageFeedback.set(String(key || ''), { kind: 'error', message });
      if (window.__workshopDataService && typeof window.__workshopDataService.loadSnapshot === 'function') await window.__workshopDataService.loadSnapshot('qc_finalization_rejected');
      renderAll();
      return false;
    }
    if (window.__workshopDataService && typeof window.__workshopDataService.loadSnapshot === 'function') await window.__workshopDataService.loadSnapshot('qc_finalization');
    if (typeof refreshEmailVehicleLocations === 'function') await refreshEmailVehicleLocations();
    renderAll();
    return true;
  }

  const now = nowIsoString();
  try {
    runStorageTransaction('Complete vehicle QC', [EDITS_KEY, AUDIT_LOG_KEY], () => {
      recordVehicleAudit(vehicle, 'Vehicle QC signed off', { by: operator, role, location: 'QC' });
      if (!saveVehicleEdits(vehicleKey(vehicle), {
        pdcQcComplete: true,
        pdcQcCompleteAt: now,
        pdcQcCompleteBy: operator,
        pdcLocation: 'QC',
        manualLocation: 'QC',
        pdcLocationLocked: true,
        pdcLocationUpdatedAt: now,
      })) {
        throw new Error('The QC sign-off could not be saved.');
      }
    });
  } catch (error) {
    pdcNotify(error.message || String(error));
    return false;
  }
  renderAll();
  return true;
}

function vehicleCanEnterPit(vehicle = {}) {
  return vehiclePdcLocation(vehicle) === 'PMB'
    && !vehicle.pdcQcComplete
    && !normalizePmbStage(inferredPmbStage(vehicle));
}

async function moveVehiclePitLocation(key = '', direction = 'to_pit') {
  const vehicle = selectedVehicle(key);
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, direction === 'to_pit' ? 'transfer to PIT' : 'return PIT vehicle to PMB')) return false;
  const toPit = direction === 'to_pit';
  if (toPit && !vehicleCanEnterPit(vehicle)) {
    pdcNotify('PIT transport is available only from PMB Unallocated. Complete or exit any active workshop station first.');
    return false;
  }
  if (!toPit && vehiclePdcLocation(vehicle) !== 'PIT') {
    pdcNotify('Only a vehicle currently in PIT can be returned to PMB.');
    return false;
  }
  const label = vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'this vehicle';
  const target = toPit ? 'PIT for Department of Transport inspection' : 'PMB Unallocated';
  if (!window.confirm(`Move ${label} to ${target}?`)) return false;

  if (vehicleLifecycleSharedModeActive()) {
    const ref = await vehicleLifecycleSharedRef(vehicle);
    if (!ref || ref.outcome !== 'resolved') {
      pdcNotify(describeVehicleLifecycleResolutionOutcome(ref));
      return false;
    }
    if (ref.isArchived) {
      pdcNotify('This vehicle is archived in shared data, so its PIT location was not changed. No change was made.');
      return false;
    }
    const result = await window.__vehicleLifecycleActions.pitTransferVehicle({
      vehicleId: ref.vehicleId,
      expectedVersion: ref.version,
      direction,
    });
    if (!result || result.ok !== true) {
      const message = typeof describeVehicleLifecycleActionError === 'function'
        ? describeVehicleLifecycleActionError(result && result.error)
        : 'The PIT location movement could not be saved.';
      pdcNotify(message);
      return false;
    }
    reconcileVehicleLifecycleServerResult(vehicle, result);
    if (window.__workshopDataService && typeof window.__workshopDataService.loadSnapshot === 'function') {
      await window.__workshopDataService.loadSnapshot(`pit_${direction}`);
    }
    renderAll();
    return true;
  }

  const now = nowIsoString();
  const location = toPit ? 'PIT' : 'PMB';
  const updates = {
    pdcLocation: location,
    manualLocation: location,
    pdcLocationLocked: true,
    pdcLocationUpdatedAt: now,
    pmbStage: '',
    pdcWorkStage: '',
    workStage: '',
    pmbBayStage: '',
    pmbBayNumber: '',
  };
  recordVehicleAudit(vehicle, toPit ? 'Transferred to PIT' : 'Returned from PIT', { from: toPit ? 'PMB Unallocated' : 'PIT', to: target });
  if (!saveVehicleEdits(vehicleKey(vehicle), updates)) return false;
  renderAll();
  return true;
}

function controlBoardStationVehicleHtml(vehicle = {}, stage = '') {
  const key = vehicleKey(vehicle);
  const stock = displayStockNumber(vehicle) || key || 'No stock';
  const unit = displayVehicle(vehicle) || 'Vehicle not listed';
  const currentStage = normalizePmbStage(inferredPmbStage(vehicle));
  const currentBay = currentStage ? pmbBayNumber(vehicle, currentStage) : '';
  const inBay = Boolean(currentStage && currentBay);
  const eligibility = vehicle.__workshopEligibility || {};
  const planningLocation = cleanNavisionText(eligibility.location || vehiclePdcLocation(vehicle) || '').toUpperCase() || 'Unknown';
  const currentLabel = inBay ? `${pmbStageLabel(currentStage)} · ${pdcBayText(currentStage, currentBay)}` : currentStage ? `${pmbStageLabel(currentStage)} queue` : `${planningLocation} · Unallocated`;
  const blocked = isPdcBlocked(vehicle) || isActivePartsStoppage(vehicle);
  const etaDisabled = planningLocation === 'IT' && eligibility.scheduleEnabled === false;
  const targetVehicleKey = eligibility.localVehicleKey || (vehicle.__workshopEligibility ? '' : key);
  const navigationIntent = window.WorkshopNavigation?.buildWorkBookingsNavigationIntent({
    station: stage, bay: inBay && currentStage === normalizePmbStage(stage) ? currentBay : null,
    vehicleId: eligibility.vehicleId || eligibility.vehicle_id || '', stockNumber: stock,
  });
  const targetAttribute = targetVehicleKey
    ? `data-open-work-bookings="${escapeHtml(targetVehicleKey)}" data-open-stock="${escapeHtml(targetVehicleKey)}" data-work-station="${escapeHtml(navigationIntent?.filters?.station || stage)}" data-work-bay="${escapeHtml(navigationIntent?.filters?.bay || '')}"`
    : `data-open-workshop-stage="${escapeHtml(stage)}"`;
  return `<button class="control-board-work-vehicle${blocked ? ' is-blocked' : ''}${inBay ? ' is-in-bay' : ''}${etaDisabled ? ' is-scheduling-disabled' : ''}" type="button" ${targetAttribute} aria-label="Open Work and bookings for ${escapeHtml(stock)} in ${escapeHtml(pmbStageLabel(stage))}${navigationIntent?.filters?.bay ? ` Bay ${escapeHtml(navigationIntent.filters.bay)}` : ''}">
    <span class="control-board-work-identity">${vehicleIdentityStackHtml(vehicle, { includeName: false })}</span>
    <span class="control-board-work-main"><span>${escapeHtml(vehicle.vehicle || 'Vehicle not listed')}</span></span>
    <span class="control-board-work-customer"><b>Customer</b><span>${escapeHtml(vehicleCustomerName(vehicle) || 'Dealer Order')}</span></span>
    <span class="control-board-work-location"><b>Now</b><span>${escapeHtml(currentLabel)}</span></span>
    <span class="control-board-work-age"><b>Location</b><span>${escapeHtml(planningLocation)}</span></span>
    ${etaDisabled ? `<span class="badge danger">${escapeHtml(eligibility.disabledReason === 'missing_eta' ? 'ETA missing · disabled' : 'ETA invalid · disabled')}</span>` : blocked ? '<span class="badge danger">Stopped</span>' : inBay ? `<span class="badge info">IN ${escapeHtml(pmbStageLabel(currentStage).toUpperCase())} BAY ${escapeHtml(currentBay)}</span>` : '<span class="badge warning">Work required</span>'}
  </button>`;
}

function openWorkshopPlannerForStage(stage = '') {
  const normalizedStage = normalizePmbStage(stage);
  const category = normalizedStage === 'BUS_4X4' ? window.PDC_WORKSHOP_DEPARTMENTS?.category(app.pendingBusBayGroup) : null;
  const route = category?.view || WORKSHOP_PLANNER_ROUTE_BY_STAGE[normalizedStage];
  if (!route) return;
  showView(route);
}

function controlBoardStationPipelineMetrics(stage = '', snapshot = app.workshopEligibilitySnapshot) {
  const normalizedStage = normalizePmbStage(stage);
  const rows = Array.isArray(snapshot?.pipeline) ? snapshot.pipeline : [];
  const source = rows.find(row => normalizePmbStage(row?.stage_code || row?.stageCode || '') === normalizedStage);
  if (!source) return null;
  const count = value => Math.max(0, Math.floor(Number(value) || 0));
  return {
    stage: normalizedStage,
    it: count(source.it),
    pmbWaiting: count(source.pmb_waiting ?? source.pmbWaiting),
    yardHoldWaiting: count(source.yard_hold_waiting ?? source.yardHoldWaiting),
    inBays: count(source.in_bays ?? source.inBays),
    averageBayHours: Math.max(0, Number(source.average_bay_hours ?? source.averageBayHours) || 0),
    stoppage: count(source.stoppage),
    completedMtd: count(source.completed_mtd ?? source.completedMtd),
  };
}

function controlBoardAverageBayTimeLabel(hours = 0) {
  const value = Math.max(0, Number(hours) || 0);
  if (!value) return '—';
  if (value < 1) return `${Math.max(1, Math.round(value * 60))}m`;
  if (value < 24) return `${value.toFixed(value < 10 ? 1 : 0)}h`;
  const days = Math.floor(value / 24);
  const remainder = Math.round(value % 24);
  return remainder ? `${days}d ${remainder}h` : `${days}d`;
}

function controlBoardStationPipelineHtml(stage = '') {
  const metrics = controlBoardStationPipelineMetrics(stage);
  if (!metrics) {
    const unavailable = app.workshopEligibilityState === 'offline_error' || app.workshopEligibilityState === 'permission_denied';
    return `<span class="control-board-pipeline is-pending" role="status">${escapeHtml(unavailable ? 'Pipeline unavailable' : 'Loading pipeline…')}</span>`;
  }
  const average = controlBoardAverageBayTimeLabel(metrics.averageBayHours);
  const segments = [
    { key: 'it', label: 'IT', count: metrics.it },
    { key: 'waiting', label: 'PMB waiting', count: metrics.pmbWaiting },
    { key: 'yard-hold', label: 'Yard Hold waiting', count: metrics.yardHoldWaiting },
    { key: 'bays', label: 'In bays', count: metrics.inBays },
    { key: 'stoppage', label: 'Stoppage', count: metrics.stoppage },
    { key: 'complete', label: 'Completed MTD', count: metrics.completedMtd },
  ];
  const total = segments.reduce((sum, item) => sum + item.count, 0);
  const aria = `${pmbStageLabel(metrics.stage)} pipeline: ${metrics.it} IT, ${metrics.pmbWaiting} at PMB waiting, ${metrics.yardHoldWaiting} at Yard Hold waiting, ${metrics.inBays} in bays, average bay time ${average}, ${metrics.stoppage} stoppage, ${metrics.completedMtd} completed month to date.`;
  const bar = total
    ? segments.filter(item => item.count > 0).map(item => `<span class="control-board-pipeline-segment is-${escapeHtml(item.key)}" style="--pipeline-weight:${item.count}" title="${escapeHtml(`${item.label}: ${item.count}`)}"><b>${item.count}</b></span>`).join('')
    : '<span class="control-board-pipeline-empty">No current or month-to-date activity</span>';
  return `<span class="control-board-pipeline" role="img" aria-label="${escapeHtml(aria)}">
    <span class="control-board-pipeline-bar">${bar}</span>
    <span class="control-board-pipeline-legend">
      <span class="is-it"><i></i>IT <b>${metrics.it}</b></span>
      <span class="is-waiting"><i></i>PMB wait <b>${metrics.pmbWaiting}</b></span>
      ${metrics.yardHoldWaiting ? `<span class="is-yard-hold"><i></i>YH wait <b>${metrics.yardHoldWaiting}</b></span>` : ''}
      <span class="is-bays"><i></i>Bays <b>${metrics.inBays}</b><small>avg ${escapeHtml(average)}</small></span>
      <span class="is-stoppage"><i></i>Stop <b>${metrics.stoppage}</b></span>
      <span class="is-complete"><i></i>Done MTD <b>${metrics.completedMtd}</b></span>
    </span>
  </span>`;
}


function pdcWorkshopDepartmentControls() {
  const department = window.PDC_DEPARTMENT_FILTER?.getSelection() || '';
  return `<label class="pdc-workshop-department-choice">Department <select data-workshop-department aria-label="Workshop department"><option value=""${!department?' selected':''}>All departments</option><option value="138"${department==='138'?' selected':''}>138 — Bus 4×4</option><option value="139"${department==='139'?' selected':''}>139 — PMB</option></select></label>`;
}
function pdcWorkshopDepartmentChanged(event) {
  window.PDC_DEPARTMENT_FILTER?.setSelection(event.target.value);
}
// r924 (F506): the Control Board Department choice sits in the toolbar row (#workflow-department-slot) next to
// Search / Key # / Find / Refresh. Returns false when there is no slot, so the board keeps its own copy.
function renderWorkflowDepartmentSlot() {
  const slot = typeof $ === 'function' ? $('#workflow-department-slot') : null;
  if (!slot) return false;
  const department = window.PDC_DEPARTMENT_FILTER?.getSelection() || '';
  const select = slot.querySelector?.('[data-workshop-department]');
  if (select) {
    if (select.value !== department) select.value = department;
  } else slot.innerHTML = pdcWorkshopDepartmentControls();
  if (!slot.dataset.pdcDepartmentBound) {
    slot.dataset.pdcDepartmentBound = '1';
    slot.addEventListener('change', event => {
      if (event.target.matches?.('[data-workshop-department]')) pdcWorkshopDepartmentChanged(event);
    });
  }
  return true;
}
function pdcSyncWorkshopDepartmentNavigation() {
  const layout = window.PDC_WORKSHOP_DEPARTMENTS;
  if (!layout) return;
  const department = window.PDC_DEPARTMENT_FILTER?.getSelection() || '';
  document.querySelectorAll('[data-workshop-nav-department]').forEach(heading => {
    const owner = heading.dataset.workshopNavDepartment;
    heading.classList.toggle('pdc-department-hidden', Boolean(department && owner !== 'shared' && owner !== department));
  });
  for (const def of WORKSHOP_CANONICAL_STATION_DEFS) {
    document.querySelectorAll(`.nav-workshop-item[data-view="${def.route}"]`).forEach(button => {
      button.classList.toggle('pdc-department-hidden', !layout.stageVisible(def.code,department));
    });
  }
}
window.addEventListener('pdc-department-filter-changed', () => {
  pdcSyncWorkshopDepartmentNavigation();
  if (app.currentView === 'bus-pit') {
    if (window.PDC_DEPARTMENT_FILTER?.getSelection() === '139') showView('planner-fitting');
    else renderBusPitInspections();
    return;
  }
  if (app.currentView === 'workflow') renderWorkflowBoard();
  if (app.currentView !== 'workshop') return;
  const stage = app.activeWorkshopPlannerStage || app.workshopPlanner?.stage;
  const department = window.PDC_DEPARTMENT_FILTER?.getSelection() || '';
  if (stage && window.PDC_WORKSHOP_DEPARTMENTS && !window.PDC_WORKSHOP_DEPARTMENTS.stageVisible(stage,department)) {
    openWorkshopPlannerForStage(department === '138' ? 'BUS_4X4' : 'FITTING');
  } else if (typeof renderWorkshopPlanner === 'function') renderWorkshopPlanner();
});
window.addEventListener('pdc-auth-ready',pdcSyncWorkshopDepartmentNavigation);

function renderWorkflowBoard() {
  const host = $('#workflow-board');
  if (!host) return;
  host.controlBoardTimelineCleanup?.();
  host.controlBoardTimelineCleanup = null;
  document.body.classList.remove('pmb-station-mode');
  app.activePmbBayStage = '';
  const oldScroll = host.querySelector?.('.control-board-bays-scroll');
  if (oldScroll) app.controlBoardScroll = { left: oldScroll.scrollLeft, top: oldScroll.scrollTop };
  const search = String($('#workflow-search')?.value || app.workflowSearch || '').trim().toLowerCase();
  app.workflowSearch = search;
  const keyInput = $('#workflow-key-search');
  const keySearch = String(keyInput ? keyInput.value || '' : app.workflowKeySearch || '').trim();
  app.workflowKeySearch = keySearch;
  const departmentInToolbar = typeof renderWorkflowDepartmentSlot === 'function' && renderWorkflowDepartmentSlot();
  const sharedEligibility = workshopEligibilitySharedAuthorityEnabled();
  if (sharedEligibility && app.workshopEligibilityState === 'idle') loadWorkshopEligibilitySnapshot('route_entry');
  if (sharedEligibility && app.workshopEligibilityState !== 'connected') {
    const unavailable = ['offline_error', 'permission_denied'].includes(app.workshopEligibilityState);
    host.innerHTML = `<div class="workshop-connection-banner ${escapeHtml(app.workshopEligibilityState)}" role="status" aria-live="polite" aria-busy="${!unavailable}"><strong>${unavailable ? 'Workshop overview unavailable' : 'Loading workshop overview…'}</strong><span>${unavailable ? 'The latest workshop information could not be loaded. Use Refresh to try again.' : 'Checking required work and bookings. Counts will appear when the latest information is ready.'}</span></div>`;
    return;
  }
  const overview = window.ControlBoardOverview;
  const displayIdentities = window.WorkshopDisplayIdentity?.build(
    typeof pdcSheetVehicles === 'function' ? pdcSheetVehicles() : [], normalizePmbStage,
  );
  const model = overview?.buildModel(app.workshopEligibilitySnapshot, { search, keySearch, stageOrder: WORKSHOP_CONTROL_BOARD_STATIONS, displayIdentities, department: window.PDC_DEPARTMENT_FILTER?.getSelection() || '' });
  if (!model) {
    host.innerHTML = '<div class="workshop-connection-banner offline_error" role="status"><strong>Workshop overview unavailable</strong><span>The full bay list could not be loaded. Use Refresh to try again.</span></div>';
    return;
  }
  // r912 (F494): a key search fits the dates like a text search ('key:3' keeps it apart from a text search for '3').
  const appliedSearch = [search, keySearch && model?.keySearch ? `key:${model.keySearch}` : ''].filter(Boolean).join(' ');
  if (appliedSearch !== (app.controlBoardAppliedSearch || '')) {
    if (appliedSearch) {
      if (!app.controlBoardAppliedSearch) app.controlBoardBeforeSearch = { start: app.controlBoardTimelineStart, days: app.controlBoardTimelineDays, scroll: app.controlBoardScroll };
      const range = overview.searchDateRange(model);
      if (range) {
        app.controlBoardTimelineStart = range.startDate;
        app.controlBoardTimelineDays = range.dayCount;
      }
      app.controlBoardScroll = { left: 0, top: 0 };
    } else if (app.controlBoardBeforeSearch) {
      app.controlBoardTimelineStart = app.controlBoardBeforeSearch.start;
      app.controlBoardTimelineDays = app.controlBoardBeforeSearch.days;
      app.controlBoardScroll = app.controlBoardBeforeSearch.scroll;
      app.controlBoardBeforeSearch = null;
    }
    app.controlBoardAppliedSearch = appliedSearch;
  }
  const timelineOptions = { startDate: app.controlBoardTimelineStart, dayCount: app.controlBoardTimelineDays || 14, now: new Date() };
  // r924 (F506): no green "Workshop information connected" bar; Department lives in the toolbar row when present.
  host.innerHTML = `${departmentInToolbar ? '' : pdcWorkshopDepartmentControls()}${overview.render(model, timelineOptions)}`;
  const scroll = host.querySelector('.control-board-bays-scroll');
  if (scroll && app.controlBoardScroll) {
    scroll.scrollLeft = app.controlBoardScroll.left;
    scroll.scrollTop = app.controlBoardScroll.top;
  }
  host.controlBoardTimelineCleanup = overview.mountTimeline?.(host);
  controlBoardKeyStatus912(host, model);
  const items = new Map([...model.waiting, ...model.columns.flatMap(column => column.items)].map(item => [`${item.kind}:${item.id}`, item]));
  const changeDates = (date, dayCount = app.controlBoardTimelineDays || 14, keepHorizontal = false) => {
    app.controlBoardTimelineStart = date;
    app.controlBoardTimelineDays = dayCount;
    if (scroll && !keepHorizontal) scroll.scrollLeft = 0;
    renderWorkflowBoard();
  };
  const currentStart = () => host.querySelector('[data-control-board-start]')?.value || overview.dateKey(model.generatedAt) || overview.dateKey(new Date());
  host.onchange = event => {
    if (event.target.matches?.('[data-workshop-department]')) { pdcWorkshopDepartmentChanged(event); return; }
    if (event.target.matches?.('[data-control-board-start]') && event.target.value) changeDates(event.target.value);
  };
  host.onclick = event => {
    const target = event.target.closest('button');
    if (!target || !host.contains(target)) return;
    if (target.dataset.controlBoardItem) {
      const item = items.get(`${target.dataset.controlBoardItem}:${target.dataset.controlBoardId}`);
      if (item) openControlBoardOverviewItem(item, target.dataset.controlBoardDate);
    } else if (target.dataset.controlBoardPlanner) {
      if (typeof workshopState === 'function') workshopState().busBayGroup = target.dataset.controlBoardGroup || '';
      app.pendingBusBayGroup = target.dataset.controlBoardGroup || '';
      openWorkshopPlannerForStage(target.dataset.controlBoardPlanner);
    } else if (target.dataset.controlBoardJump) {
      const department = [...host.querySelectorAll('[data-control-board-stage]')].find(node => node.dataset.controlBoardStage === target.dataset.controlBoardJump);
      if (department) department.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });
    } else if (target.hasAttribute('data-control-board-today')) {
      changeDates(overview.dateKey(new Date()));
    } else if (target.dataset.controlBoardShift) {
      changeDates(overview.shiftDate(currentStart(), Number(target.dataset.controlBoardShift)));
    } else if (target.hasAttribute('data-control-board-more')) {
      changeDates(currentStart(), Math.min(56, (app.controlBoardTimelineDays || 14) + 14), true);
    } else if (target.dataset.controlBoardReveal) {
      changeDates(target.dataset.controlBoardReveal);
    } else if (target.dataset.controlBoardScroll) {
      scroll?.scrollBy({ left: Number(target.dataset.controlBoardScroll) * Math.max(246, scroll.clientWidth - 80), behavior: 'auto' });
    }
  };
  // Old floating table headers must not follow the new bay overview.
  const floating = $('#workflow-floating-column-header');
  if (floating) floating.hidden = true;
}

function openControlBoardOverviewItem(item, clickedDate = '') {
  const source = item.source || {};
  const vehicle = item.vehicle || {};
  if (item.kind === 'booking' && source.scheduled_start_at && source.bay_id && !item.unassignedBay) {
    const date = /^\d{4}-\d{2}-\d{2}$/.test(clickedDate) ? clickedDate : vehicleWorkshopBookingDateKey(source);
    return openVehicleWorkshopBooking(source.booking_id, item.stage, date, source.vehicle_id || vehicle.id, vehicle.stock_number || '', source.bay_number || '', { showSurrounding: true });
  }
  const local = app.data.find(row => String(row.id || row.sharedVehicleId || '') === String(vehicle.id || ''));
  if (local) return openVehicleWorkBookingsFromTile({ dataset: { openWorkBookings: vehicleKey(local), workStation: item.stage, workBay: '' } });
  return openWorkshopPlannerForStage(item.stage);
}

function findControlBoardOverviewMatch() {
  app.workflowSearch = String($('#workflow-search')?.value || '').trim().toLowerCase();
  app.workflowKeySearch = String($('#workflow-key-search')?.value || '').trim();
  renderWorkflowBoard();
  let match = $('#workflow-board')?.querySelector('[data-control-board-match]');
  if (!match && app.workshopEligibilityState === 'connected') {
    const overview = window.ControlBoardOverview;
    const model = overview?.buildModel(app.workshopEligibilitySnapshot, { search: app.workflowSearch, keySearch: app.workflowKeySearch || '', stageOrder: WORKSHOP_CONTROL_BOARD_STATIONS });
    const timeline = model && overview.buildTimeline(model, { startDate: app.controlBoardTimelineStart, dayCount: app.controlBoardTimelineDays || 14 });
    const date = timeline?.outside[0]?.date;
    if (date) {
      app.controlBoardTimelineStart = date;
      const scroll = $('#workflow-board')?.querySelector('.control-board-bays-scroll');
      if (scroll) scroll.scrollLeft = 0;
      renderWorkflowBoard();
      match = $('#workflow-board')?.querySelector('[data-control-board-match]');
    }
  }
  match?.scrollIntoView({ inline: 'center', block: 'nearest' });
  if (match?.tagName === 'BUTTON') match.focus({ preventScroll: true });
}

// r912 (F494, Craig 3 Nov 13:18): "on the control board, add an option to search key number as well as stock number".
// The Key # box (or 'k3' / 'key 3' in the main box) is an exact key match in ControlBoardOverview.buildModel. When no
// workshop job has that key, the board says where the key is instead: on a board car with no workshop job, held on the
// key list (r909 get_pdc_key_reserved_lookup_909, read only, same wording as Vehicle Locations), or on nothing.
// Read only: no booking, planner, cascade or key-list writes here (Release / Hold stay on Vehicle Locations).
const controlBoardKeyLookup912 = { token: '', rows: null, loading: false, at: 0 };
function controlBoardKeySearchValue912() {
  const input = $('#workflow-key-search');
  const value = String(input ? input.value || '' : app.workflowKeySearch || '').trim();
  app.workflowKeySearch = value;
  return value;
}
function controlBoardKeyStatus912(host, model) {
  const token = String(model?.keySearch || '');
  if (!token || model.matchingItems) return;
  const node = host?.querySelector?.('[data-control-board-key-status]');
  if (!node) return;
  const overview = window.ControlBoardOverview;
  const same = vehicle => !!overview?.keyToken && overview.keyToken(typeof vehicleKeyNumber === 'function' ? vehicleKeyNumber(vehicle) : vehicle?.keyNumber) === token;
  const cars = (typeof pdcSheetVehicles === 'function' ? pdcSheetVehicles() : (app.data || []))
    .filter(vehicle => same(vehicle) && (typeof statusCategory !== 'function' || statusCategory(vehicle) !== 'completed'));
  if (cars.length) {
    const label = vehicle => [typeof displayStockNumber === 'function' ? displayStockNumber(vehicle) : vehicle.stock,
      typeof displayVehicle === 'function' ? displayVehicle(vehicle) : ''].map(value => String(value || '').trim()).filter(Boolean).join(' · ');
    node.innerHTML = `Key ${escapeHtml(token)} is on <strong>${cars.map(vehicle => escapeHtml(label(vehicle))).join('</strong>, <strong>')}</strong>, which has no workshop job on the Control Board. Search the key on Vehicle Locations to open it.`;
    return;
  }
  const paint = rows => {
    const live = host.querySelector?.(`[data-control-board-key-status="${token}"]`);
    if (!live) return;
    const vlt = window.PDC_VEHICLE_LOCATIONS_TABLE;
    const line = Array.isArray(rows) && rows.length && typeof vlt?.reservedKeyLineHtml === 'function' ? vlt.reservedKeyLineHtml(rows, { admin: false }) : '';
    live.innerHTML = line ? `${line} Release or hold keys on Vehicle Locations.`
      : rows ? `Key ${escapeHtml(token)} is not on any board car or on the key list.` : '';
  };
  const cache = controlBoardKeyLookup912;
  if (cache.token === token && (cache.loading || Date.now() - cache.at < 60000)) { if (!cache.loading) paint(cache.rows); return; }
  const client = window.PDC_SUPABASE;
  if (!client || typeof client.rpc !== 'function') return;
  Object.assign(cache, { token, rows: null, loading: true, at: Date.now() });
  Promise.resolve(client.rpc('get_pdc_key_reserved_lookup_909', { p_key: token }))
    .then(result => (result?.error ? null : (Array.isArray(result?.data) ? result.data : [])))
    .catch(() => null)
    .then(rows => {
      if (cache.token !== token) return;
      Object.assign(cache, { rows, loading: false, at: rows ? Date.now() : 0 });
      paint(rows);
    });
}

function vehicleHasNavisionSource(vehicle = {}) {
  if (vehicle.__locationIdentityReadOnly === true || vehicle.__navisionDetailsIdentityConflict === true) return false;
  if (String(vehicle.__sharedNavisionRecordId || '').trim()) return true;
  // The snapshot only labels details as Navision after a unique, verified match.
  if (vehicle.__navisionDetailsSource === 'microsoft_navision'
    && String(vehicle.__navisionDetailsBackendRecordId || '').trim()) return true;
  return [vehicle.source, vehicle.sourceSystem, vehicle.source_system]
    .some(value => ['microsoft_navision', 'navision', 'shared navision'].includes(String(value || '').trim().toLowerCase()));
}

function incomingBucketForVehicle(vehicle = {}) {
  const category = statusCategory(vehicle);
  if (category === 'completed') return 'completed';
  if (category === 'collected') return 'collected';
  const operationalLocation = vehiclePdcLocation(vehicle);
  // r557 (F171): a vehicle waiting to be acknowledged is still at PMB. This
  // function stays 'pmb'. Only vehicleLocationsDisplayBucket splits the tile.
  if (operationalLocation === 'PMB') return vehicle.pdcQcComplete === true ? 'qc' : 'pmb';
  if (['PIT', 'QC', 'RFT'].includes(operationalLocation)) return operationalLocation.toLowerCase();
  if (category === 'rft') return 'rft';
  if (category === 'qc') return 'qc';
  if (category === 'pit') return 'pit';
  if (category === 'pmb') return 'pmb';
  // This is an incoming display group, not a rewrite of location or history.
  if (!vehicleHasNavisionSource(vehicle)) return 'nonnavision';
  if (category === 'yardhold') return 'yardhold';
  if (category === 'prodtransit') return 'transit';
  return 'overseas';
}

// r557 (F171): tile split only. Missing or failed acknowledgement data leaves the
// vehicle on the PMB tile, which is where every other consumer already counts it.
function pmbArrivalRecord(vehicle = {}) {
  const map = app.pmbArrivalAck;
  if (!map || typeof map.get !== 'function') return null;
  for (const id of [vehicle.id, vehicle.__emailVehicleId, vehicle.sharedVehicleId, vehicle.permanent_vehicle_id]) {
    const row = id ? map.get(String(id)) : null;
    if (row) return row;
  }
  return null;
}

function vehicleLocationsDisplayBucket(vehicle = {}) {
  const operational = incomingBucketForVehicle(vehicle);
  // r753 (F358): PIT is a sublet step while the car is at PMB; it has no tile of its own (Pit bookings page instead).
  if (operational === 'pit') return 'pmb';
  // r753 (F358): after final check the car is at WPC (work completed) until the RFT'd tick.
  if (operational === 'rft') return vehicleRftConfirmationActive(vehicle) ? 'rft' : 'wpc';
  if (operational !== 'pmb') return operational;
  // r582 (F195): a body-builder delivery stays off the PMB bucket until To PMB.
  if (pmbBodybuilderHoldOpen(vehicle)) return 'newpmb';
  // r593 (F207): an acknowledgement no longer takes the vehicle off the PMB bucket.
  return 'pmb';
}

// r593 (F207): a recent key is listed in New to PMB and stays in the PMB bucket.
// A body-builder hold is only in New to PMB until someone presses To PMB.
function vehicleLocationsDisplayBuckets(vehicle = {}) {
  const primary = vehicleLocationsDisplayBucket(vehicle);
  // r707 (F317, Craig 29 Oct, standing rule): a vehicle at PMB with a key number is in the PMB bucket. New to PMB is
  // only a second list of the keys under 24 hours (200 in PMB + 10 new = PMB 210, New to PMB 10).
  // A body-builder car still waiting for To PMB stays listed in New to PMB as well, so its To PMB button is there.
  if (primary === 'newpmb' && pmbVehicleHasKey(vehicle)) return ['pmb', 'newpmb'];
  if (primary === 'newpmb') return ['newpmb'];
  if (primary === 'pmb' && pmbKeyIsNew(vehicle)) return ['pmb', 'newpmb'];
  return [primary];
}

function pmbArrivalDepartments(vehicle = {}) {
  const row = pmbArrivalRecord(vehicle);
  return row && Array.isArray(row.departments) ? row.departments : [];
}

function pmbArrivalWhenLabel(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-AU', { timeZone: 'Australia/Perth', dateStyle: 'medium', timeStyle: 'short' });
}

function pmbArrivalPersonLabel(department = {}) {
  const name = String(department.acknowledged_by_name || '').trim();
  if (!name) return '';
  const role = String(department.acknowledged_by_role || '').trim().toLowerCase();
  return role === 'operator' ? `${name} (controller)` : name;
}

function pmbArrivalNoteHtml() {
  // r593 (F207): the acknowledgement notes are no longer shown. Who ticked, and
  // when, stay in the arrival table. The card does not ask anyone to tick.
  return '';
}

function pmbKeyNeededBadgeHtml(vehicle = {}) {
  if (!pmbBodybuilderHoldOpen(vehicle) || pmbVehicleHasKey(vehicle)) return '';
  return `<span class="badge pmb-key-needed" title="A key number is needed before this vehicle can move from New to PMB into PMB.">Key number needed</span>`;
}

function pmbBodybuilderHoldHtml(vehicle = {}) {
  const row = pmbArrivalRecord(vehicle);
  if (!row || row.source !== 'bodybuilder' || row.closed === true) return '';
  return `<span class="badge pmb-bodybuilder-hold" title="Delivered to the body builder. Check the key number, then press To PMB.">Delivered to body builder</span>`;
}

function pmbArrivalAgeFlagHtml(vehicle = {}) {
  if (pmbArrivalAgeBasis(vehicle) !== 'fallback') return '';
  const missing = pmbAgeDays(vehicle) === null;
  const title = missing
    ? 'No key history and no Tune import, so there is no PMB age.'
    : 'This age is the board arrival. There is no key history and no Tune import.';
  const label = missing ? 'Arrival date not on file' : 'Board arrival';
  return `<span class="badge pmb-age-fallback" title="${escapeHtml(title)}">${label}</span>`;
}

function pmbArrivalAgeReportHtml(rows = []) {
  const flagged = (Array.isArray(rows) ? rows : []).filter(vehicle => {
    const bucket = typeof vehicleLocationsDisplayBucket === 'function' ? vehicleLocationsDisplayBucket(vehicle) : '';
    if (bucket && bucket !== 'pmb' && bucket !== 'newpmb' && bucket !== 'qc') return false;
    return pmbArrivalAgeBasis(vehicle) === 'fallback';
  });
  if (!flagged.length) return '';
  const items = flagged.map(vehicle => `<li>${escapeHtml(displayStockNumber(vehicle) || vehicleKey(vehicle))}</li>`).join('');
  return `<section class="pmb-age-fallback-report" aria-label="Arrival date not on file"><h2>Arrival date not on file</h2><p>${flagged.length} vehicle${flagged.length === 1 ? '' : 's'} use the board arrival. No key history and no Tune import.</p><ul>${items}</ul></section>`;
}

const PMB_KEY_NEEDED_TITLE = 'A key number is needed before this vehicle can move from New to PMB into PMB.';

function pmbArrivalAckButtonLabel(label = '') {
  const name = String(label || 'station').trim() || 'station';
  return `Acknowledge for ${name}`;
}

// r593 (F207): no department tick. A body-builder delivery still shows To PMB.
// Booking from the PMB bucket uses the existing planner controls on that card.
function pmbArrivalActionHtml(vehicle = {}, key = '') {
  if (!pmbBodybuilderHoldOpen(vehicle)) return '';
  if (!pmbVehicleHasKey(vehicle)) {
    return `<button class="primary pmb-push-disabled" type="button" disabled title="${escapeHtml(PMB_KEY_NEEDED_TITLE)}">To PMB</button>`;
  }
  return `<button class="primary" type="button" data-pmb-push="${escapeHtml(key)}" title="Move this body-builder delivery into the PMB bucket. No acknowledgement.">To PMB</button>`;
}

function pmbArrivalVehicleId(vehicle = {}) {
  const id = String(vehicle.__emailVehicleId || vehicle.sharedVehicleId || vehicle.id || vehicle.permanent_vehicle_id || '').trim();
  return /^[0-9a-f-]{36}$/i.test(id) ? id : '';
}

function ensurePmbArrivalAck() {
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.pmbArrivalAckLoading) return;
  // r557 (F171): the r554 location copy lasts 15 seconds, but a new email
  // revision means a vehicle just arrived or a station was acknowledged.
  // Refetch then, even inside that window, so the tile is not the stale list.
  const revision = app.emailVehicleLocationRevision;
  const revisionChanged = String(revision ?? '') !== String(app.pmbArrivalAckRevision ?? '');
  if (!revisionChanged && app.pmbArrivalAckLoadedAt && Date.now() - app.pmbArrivalAckLoadedAt < 15000) return;
  app.pmbArrivalAckLoading = true;
  const started = Date.now();
  const revisionAtStart = revision;
  client.rpc('list_pmb_arrival_ack_557').then(result => {
    app.pmbArrivalAckLoading = false;
    app.pmbArrivalAckLoadedAt = started;
    app.pmbArrivalAckRevision = revisionAtStart;
    if (result?.error) return;
    const next = new Map();
    (Array.isArray(result?.data) ? result.data : []).forEach(row => {
      if (row?.vehicle_id) next.set(String(row.vehicle_id), row);
    });
    const signature = [...next.entries()].map(([id, row]) => {
      const departments = Array.isArray(row.departments) ? row.departments : [];
      return `${id}|${row.viewer_pending}|${row.closed}|${row.source}|${departments.map(department => `${department.station}:${department.pending}:${department.acknowledged_by_name || ''}:${department.acknowledged_at || ''}`).join(',')}`;
    }).sort().join('\n');
    const changed = signature !== app.pmbArrivalAckSignature;
    app.pmbArrivalAck = next;
    app.pmbArrivalAckSignature = signature;
    if (changed && app.currentView === 'dashboard' && typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
  }).catch(() => {
    app.pmbArrivalAckLoading = false;
    app.pmbArrivalAckLoadedAt = started;
    app.pmbArrivalAckRevision = revisionAtStart;
  });
}

async function acknowledgePmbArrival(key = '', station = '') {
  const vehicle = vehicleLocationsScreenRows().find(row => vehicleKey(row) === key);
  const id = vehicle ? pmbArrivalVehicleId(vehicle) : '';
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!vehicle || !id || !station || !client || typeof client.rpc !== 'function') {
    if (typeof pdcNotify === 'function') pdcNotify('This arrival could not be acknowledged. Refresh and try again.');
    return;
  }
  const result = await client.rpc('acknowledge_pmb_arrival_557', { p_vehicle_id: id, p_station: station });
  const body = result?.data;
  if (result?.error || !body || body.ok !== true) {
    const message = body?.message || result?.error?.message || 'This arrival could not be acknowledged.';
    if (typeof pdcNotify === 'function') pdcNotify(message);
    return;
  }
  const data = body.data || {};
  if (!(app.pmbArrivalAck instanceof Map)) app.pmbArrivalAck = new Map();
  app.pmbArrivalAck.set(id, {
    vehicle_id: id,
    source: data.source || 'location',
    viewer_pending: data.viewer_pending === true,
    closed: data.closed === true,
    departments: Array.isArray(data.departments) ? data.departments : [],
  });
  app.pmbArrivalAckSignature = '';
  app.pmbArrivalAckLoadedAt = 0;
  if (typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
  const stationLabel = (PMB_ACK_STATIONS.find(([code]) => code === String(station || '').trim()) || [])[1] || station;
  // r574 (F188): the tick is what takes this department off the list. A key
  // number, the r562 gate, is also required before that department can book.
  if (pmbVehicleHasKey(vehicle)) openPmbArrivalBayBooking(vehicle, station, stationLabel);
  else if (typeof pdcNotify === 'function') pdcNotify(`Acknowledged for ${stationLabel}. A key number is needed before this vehicle can be booked into a bay.`);
}

// r574 (F188): bays for this station. Prefer the planner's active bays. Fall
// back to the station's own bay count so the picker can still be drawn.
function pmbArrivalStationBays(station = '') {
  const normalized = typeof normalizePmbStage === 'function' ? normalizePmbStage(station) : String(station || '').trim().toUpperCase();
  if (!normalized) return [];
  let numbers = [];
  try {
    if (typeof workshopSchedulableBayNumbers === 'function') numbers = workshopSchedulableBayNumbers(normalized) || [];
  } catch (_error) {
    numbers = [];
  }
  if (!numbers.length && typeof pmbStageBayCount === 'function') {
    const count = Number(pmbStageBayCount(normalized)) || 0;
    numbers = Array.from({ length: count }, (_, index) => index + 1);
  }
  return numbers.map(number => {
    let label = '';
    try {
      if (typeof workshopBayChoiceLabel === 'function') label = String(workshopBayChoiceLabel(normalized, number) || '');
    } catch (_error) {
      label = '';
    }
    if (!label && typeof pdcBayText === 'function') label = pdcBayText(normalized, number, true);
    return { number, label: label || `Bay ${number}` };
  });
}

function pmbArrivalBayOptionsHtml(station = '') {
  const bays = pmbArrivalStationBays(station);
  if (!bays.length) return '<option value="">No bay is listed for this station</option>';
  return bays.map(bay => `<option value="${escapeHtml(String(bay.number))}">${escapeHtml(bay.label)}</option>`).join('');
}

function pmbArrivalBayBookingHtml(vehicle = {}, station = '', label = '') {
  if (!pmbVehicleHasKey(vehicle)) return '';
  const stationCode = String(station || '').trim();
  const stationLabel = String(label || (PMB_ACK_STATIONS.find(([code]) => code === stationCode) || [])[1] || stationCode || 'station');
  const key = vehicleKey(vehicle);
  const stock = typeof displayStockNumber === 'function' ? (displayStockNumber(vehicle) || key) : key;
  const keyNo = typeof vehicleKeyNumber === 'function' ? (vehicleKeyNumber(vehicle) || '') : '';
  const who = [stock, keyNo ? `Key ${keyNo}` : ''].filter(Boolean).join(' · ');
  return `<section class="modal-card pmb-book-card" data-pmb-book-panel="${escapeHtml(stationCode)}">
    <button class="modal-close" type="button" data-pmb-book-dismiss aria-label="Close">×</button>
    <header><h2>Book into a ${escapeHtml(stationLabel)} bay</h2><p>${escapeHtml(who)}. Same booking as the Workshop Planner. No new booking rule.</p></header>
    <label class="pmb-book-bay"><span>Bay</span><select data-pmb-book-bay-select aria-label="${escapeHtml(stationLabel)} bay">${pmbArrivalBayOptionsHtml(stationCode)}</select></label>
    <div class="edit-actions pmb-book-actions">
      <button class="secondary" type="button" data-pmb-book-dismiss>Not now</button>
      <button class="primary" type="button" data-pmb-book-best="${escapeHtml(key)}" data-pmb-book-station="${escapeHtml(stationCode)}">Best slot</button>
      <button class="primary" type="button" data-pmb-book-bay="${escapeHtml(key)}" data-pmb-book-station="${escapeHtml(stationCode)}">Book this bay</button>
    </div>
  </section>`;
}

async function pmbArrivalPrepareStationSnapshot(station = '') {
  const service = typeof window === 'object' ? window.__workshopDataService : null;
  if (typeof workshopSharedModeActive !== 'function' || !workshopSharedModeActive() || !service || typeof service.setScope !== 'function') return;
  const dateKey = typeof workshopState === 'function'
    ? (workshopState().date || (typeof workshopDefaultOpenDateKey === 'function' ? workshopDefaultOpenDateKey() : ''))
    : '';
  if (!dateKey) return;
  await service.setScope({ stageCode: station, dateFrom: dateKey, dateTo: dateKey });
  if (typeof service.loadSnapshot === 'function') await service.loadSnapshot('new_to_pmb_bay_566');
}

// r574 (F188): Best slot is workshopScheduleVehicleNextAvailable. A chosen bay
// uses workshopFirstAvailableStartSlot and scheduleWorkshopVehicle, the same
// pair the planner's Schedule window uses. Neither path adds a booking rule.
async function pmbArrivalBookBestSlot(key = '', station = '') {
  if (typeof workshopScheduleVehicleNextAvailable !== 'function') {
    if (typeof pdcNotify === 'function') pdcNotify('The Workshop Planner booking is not loaded. Refresh and try again. No booking was saved.');
    return false;
  }
  return workshopScheduleVehicleNextAvailable({ vehicleKeyValue: key, stage: station });
}

async function pmbArrivalBookIntoBay(key = '', station = '', bayNumber = 0) {
  const bay = Number(bayNumber);
  await pmbArrivalPrepareStationSnapshot(station);
  const canSlot = bay > 0
    && typeof workshopFirstAvailableStartSlot === 'function'
    && typeof scheduleWorkshopVehicle === 'function'
    && typeof workshopNormalizeStartDate === 'function'
    && typeof workshopDateKey === 'function';
  if (!canSlot) {
    if (typeof openWorkshopScheduleModal === 'function') {
      openWorkshopScheduleModal(key, station);
      return false;
    }
    if (typeof pdcNotify === 'function') pdcNotify('The Workshop Planner booking is not loaded. Refresh and try again. No booking was saved.');
    return false;
  }
  const vehicle = typeof workshopVehicle === 'function' ? workshopVehicle(key, station) : null;
  const now = workshopNormalizeStartDate(new Date());
  const today = workshopDateKey(now);
  const eta = vehicle && typeof workshopVehicleEtaConstraint === 'function' ? workshopVehicleEtaConstraint(vehicle) : {};
  const earliest = typeof workshopDateKeyNotBefore === 'function' ? workshopDateKeyNotBefore(today, eta.earliestDateKey || '') : today;
  const notBefore = earliest === workshopDateKey(now) ? Math.max(0, typeof workshopMinuteOffset === 'function' ? workshopMinuteOffset(now) : 0) : 0;
  const duration = vehicle && typeof workshopSchedulingDuration === 'function' ? workshopSchedulingDuration(vehicle, station) : null;
  const hours = duration?.hours || (typeof workshopDefaultBookingHours === 'function' ? workshopDefaultBookingHours() : 0);
  const plans = typeof workshopLoadPlans === 'function' ? workshopLoadPlans() : [];
  const slot = workshopFirstAvailableStartSlot(station, bay, earliest, hours, plans, notBefore, 260, new Date(), [], null, '', vehicle);
  if (!slot) {
    if (typeof pdcNotify === 'function') pdcNotify('No free slot in this bay. No booking was saved.');
    return false;
  }
  return scheduleWorkshopVehicle({
    vehicleKeyValue: key,
    stage: station,
    bay,
    dateKey: slot.dateKey,
    startMinutes: slot.startMinutes,
    hoursValue: hours,
    preferRequestedTime: true,
    cascadeNewBooking: true,
  });
}

function closePmbArrivalBayBooking() {
  const overlay = typeof document === 'object' ? document.querySelector?.('[data-pmb-book-dialog]') : null;
  overlay?.remove?.();
  if (typeof document === 'object' && !document.querySelector?.('.modal-overlay')) document.body?.classList?.remove?.('modal-open');
  if (typeof app === 'object' && app) app.pmbArrivalBookOffer = null;
}

function bindPmbArrivalBayBooking(overlay, station = '') {
  if (!overlay || typeof overlay.querySelector !== 'function') return;
  const dismiss = () => closePmbArrivalBayBooking();
  overlay.querySelectorAll?.('[data-pmb-book-dismiss]')?.forEach(button => button.addEventListener?.('click', event => {
    event.preventDefault?.();
    dismiss();
  }));
  overlay.addEventListener?.('click', event => {
    if (event.target === overlay) dismiss();
  });
  const run = async (button, book) => {
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute?.('aria-busy', 'true');
    try {
      const saved = await book();
      if (saved) dismiss();
    } finally {
      if (button.isConnected !== false) {
        button.disabled = false;
        button.removeAttribute?.('aria-busy');
      }
    }
  };
  overlay.querySelector('[data-pmb-book-best]')?.addEventListener?.('click', event => {
    event.preventDefault?.();
    const button = event.currentTarget;
    void run(button, () => pmbArrivalBookBestSlot(button.dataset?.pmbBookBest || '', button.dataset?.pmbBookStation || station));
  });
  overlay.querySelector('[data-pmb-book-bay]')?.addEventListener?.('click', event => {
    event.preventDefault?.();
    const button = event.currentTarget;
    const selected = overlay.querySelector('[data-pmb-book-bay-select]')?.value;
    void run(button, () => pmbArrivalBookIntoBay(button.dataset?.pmbBookBay || '', button.dataset?.pmbBookStation || station, selected));
  });
}

function openPmbArrivalBayBooking(vehicle = {}, station = '', label = '') {
  const html = pmbArrivalBayBookingHtml(vehicle, station, label);
  if (!html || !pmbVehicleHasKey(vehicle)) return false;
  const stationCode = String(station || '').trim();
  if (typeof app === 'object' && app) app.pmbArrivalBookOffer = { key: vehicleKey(vehicle), station: stationCode, label: String(label || stationCode) };
  const doc = typeof document === 'object' ? document : null;
  if (!doc || typeof doc.createElement !== 'function' || !doc.body) return true;
  doc.querySelector?.('[data-pmb-book-dialog]')?.remove?.();
  const overlay = doc.createElement('div');
  overlay.className = 'modal-overlay pmb-book-overlay';
  overlay.dataset.pmbBookDialog = stationCode;
  overlay.setAttribute?.('role', 'dialog');
  overlay.setAttribute?.('aria-modal', 'true');
  overlay.setAttribute?.('aria-label', `Book into a ${label || stationCode} bay`);
  overlay.innerHTML = html;
  doc.body.appendChild?.(overlay);
  doc.body.classList?.add?.('modal-open');
  bindPmbArrivalBayBooking(overlay, stationCode);
  return true;
}

function ensureNewToPmbWindow() {
  return; // r679 (F289): fixed 24-hour window; the stored-window RPC no longer exists (it was a 404 every minute).
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.newToPmbWindowLoading) return;
  if (app.newToPmbWindowLoadedAt && Date.now() - app.newToPmbWindowLoadedAt < 60000) return;
  app.newToPmbWindowLoading = true;
  client.rpc('list_new_to_pmb_window_586').then(result => {
    app.newToPmbWindowLoading = false;
    app.newToPmbWindowLoadedAt = Date.now();
    if (result?.error) return;
    const days = Number(result?.data);
    if (!Number.isInteger(days) || days < 1 || days > 30 || days === app.newToPmbWindowDays) return;
    app.newToPmbWindowDays = days;
    if (app.currentView === 'dashboard' && typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
  }).catch(() => {
    app.newToPmbWindowLoading = false;
    app.newToPmbWindowLoadedAt = Date.now();
  });
}

function ensurePmbKeyAssigned() {
  if (typeof ensurePmbReservedKeys === 'function') ensurePmbReservedKeys();
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.pmbKeyAssignedLoading) return;
  const revision = app.emailVehicleLocationRevision;
  const revisionChanged = String(revision ?? '') !== String(app.pmbKeyAssignedRevision ?? '');
  if (!revisionChanged && app.pmbKeyAssignedLoadedAt && Date.now() - app.pmbKeyAssignedLoadedAt < 15000) return;
  app.pmbKeyAssignedLoading = true;
  const started = Date.now();
  const revisionAtStart = revision;
  client.rpc('list_pmb_key_assigned_562').then(result => {
    app.pmbKeyAssignedLoading = false;
    app.pmbKeyAssignedLoadedAt = started;
    app.pmbKeyAssignedRevision = revisionAtStart;
    if (result?.error) return;
    const next = new Map();
    (Array.isArray(result?.data) ? result.data : []).forEach(row => {
      if (row?.vehicle_id) next.set(String(row.vehicle_id), row);
    });
    const signature = [...next.entries()].map(([id, row]) => `${id}|${row.assigned_at || ''}|${row.has_key}`).sort().join('\n');
    const changed = signature !== app.pmbKeyAssignedSignature;
    app.pmbKeyAssigned = next;
    app.pmbKeyAssignedSignature = signature;
    if (changed && app.currentView === 'dashboard' && typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
    if (changed && app.currentView === 'qc' && typeof renderQualityControlPage === 'function') renderQualityControlPage();
    // r860 (F410): key dates order the planner's At PMB box.
    if (changed && app.currentView === 'workshop' && typeof scheduleWorkshopPlannerRender === 'function') scheduleWorkshopPlannerRender();
  }).catch(() => {
    app.pmbKeyAssignedLoading = false;
    app.pmbKeyAssignedLoadedAt = started;
    app.pmbKeyAssignedRevision = revisionAtStart;
  });
}

function stationIconCompletionSignature() {
  const map = app.stationIconCompletion instanceof Map ? app.stationIconCompletion : new Map();
  const cats = app.busCategoryCompletion instanceof Map ? app.busCategoryCompletion : new Map(); // r799: category rows redraw too
  const catBits = [...cats.entries()].map(([id, row]) => `${id}#${Object.keys(row || {}).sort().map(key => `${key}:${row[key].done}/${row[key].total}${row[key].complete ? 'c' : ''}${row[key].booked ? 'b' : ''}${row[key].stoppage ? 's' : ''}`).join(',')}`);
  return [...map.entries()].map(([id, row]) => {
    const bits = Object.keys(row || {}).sort().map(key => `${key}:${row[key]?.override ? 'o' : 'l'}:${row[key]?.by || ''}`);
    return `${id}|${bits.join(',')}`;
  }).concat(catBits).sort().join('\n');
}

function storeStationIconCompletion(ids, stations, startedAt = 0) {
  if (!(app.stationIconCompletion instanceof Map)) app.stationIconCompletion = new Map();
  if (!(app.stationIconCompletionStamp instanceof Map)) app.stationIconCompletionStamp = new Map();
  const requested = new Set((Array.isArray(ids) ? ids : []).map(id => String(id || '')).filter(Boolean));
  requested.forEach(id => {
    const stamp = app.stationIconCompletionStamp.get(id) || 0;
    if (startedAt && stamp > startedAt) requested.delete(id);
  });
  requested.forEach(id => app.stationIconCompletion.delete(id));
  const grouped = new Map();
  // r799 (F409): category rows (work_key 'bus4x4:<category>') feed the Department 138 columns and never the station map.
  if (!(app.busCategoryCompletion instanceof Map)) app.busCategoryCompletion = new Map();
  requested.forEach(id => app.busCategoryCompletion.delete(id));
  (Array.isArray(stations) ? stations : []).forEach(row => {
    const id = String(row?.vehicle_id || '');
    if (!requested.has(id) || !row?.work_key || !String(row.work_key).startsWith('bus4x4:')) return;
    const category = String(row.category || String(row.work_key).slice('bus4x4:'.length)).toUpperCase();
    if (!app.busCategoryCompletion.has(id)) app.busCategoryCompletion.set(id, {});
    app.busCategoryCompletion.get(id)[category] = {
      total: Number(row.total) || 0, done: Number(row.done) || 0, complete: row.complete === true,
      booked: row.booked === true, stoppage: row.stoppage === true, stoppageReason: row.stoppage_reason || '',
      override: row.override === true, by: row.override === true ? String(row.override_email || 'controller') : '', at: row.acted_at || '',
    };
  });
  (Array.isArray(stations) ? stations : []).forEach(row => {
    const id = String(row?.vehicle_id || '');
    if (!requested.has(id) || row?.complete !== true || !row.work_key || row.work_key === 'pitInspection' || String(row.work_key).startsWith('bus4x4:')) return;
    if (!grouped.has(id)) grouped.set(id, {});
    grouped.get(id)[row.work_key] = {
      complete: true,
      override: row.override === true,
      by: row.override === true ? String(row.override_email || 'controller') : '',
      at: row.acted_at || '',
    };
  });
  grouped.forEach((value, id) => app.stationIconCompletion.set(id, value));
  app.stationIconCompletionSignature = stationIconCompletionSignature();
}

function redrawStationIconsIfChanged(previous) {
  if (previous === app.stationIconCompletionSignature) return;
  if (app.currentView === 'dashboard' && typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
  if (app.currentView === 'qc' && typeof renderQualityControlPage === 'function') renderQualityControlPage();
}

function ensureStationIconCompletion() {
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.stationIconCompletionLoading) return;
  const revision = app.emailVehicleLocationRevision;
  const revisionChanged = String(revision ?? '') !== String(app.stationIconCompletionRevision ?? '');
  if (!revisionChanged && app.stationIconCompletionLoadedAt && Date.now() - app.stationIconCompletionLoadedAt < 15000) return;
  const ids = [...new Set((typeof vehicleLocationsScreenRows === 'function' ? vehicleLocationsScreenRows() : [])
    .map(vehicle => (typeof pmbArrivalVehicleId === 'function' ? pmbArrivalVehicleId(vehicle) : ''))
    .filter(Boolean))].slice(0, 1000);
  if (!ids.length) return;
  app.stationIconCompletionLoading = true;
  const started = Date.now();
  const revisionAtStart = revision;
  const previous = app.stationIconCompletionSignature || '';
  client.rpc('list_station_icon_completion_578', { p_vehicle_ids: ids }).then(result => {
    app.stationIconCompletionLoading = false;
    app.stationIconCompletionLoadedAt = started;
    app.stationIconCompletionRevision = revisionAtStart;
    if (result?.error || result?.data?.ok !== true) return;
    storeStationIconCompletion(ids, result.data.stations, started);
    redrawStationIconsIfChanged(previous);
  }).catch(() => {
    app.stationIconCompletionLoading = false;
    app.stationIconCompletionLoadedAt = started;
    app.stationIconCompletionRevision = revisionAtStart;
  });
}

function ensurePmbArrivalAge() {
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.pmbArrivalAgeLoading) return;
  const revision = app.emailVehicleLocationRevision;
  const revisionChanged = String(revision ?? '') !== String(app.pmbArrivalAgeRevision ?? '');
  if (!revisionChanged && app.pmbArrivalAgeLoadedAt && Date.now() - app.pmbArrivalAgeLoadedAt < 15000) return;
  app.pmbArrivalAgeLoading = true;
  const started = Date.now();
  const revisionAtStart = revision;
  client.rpc('list_pmb_arrival_age_563').then(result => {
    app.pmbArrivalAgeLoading = false;
    app.pmbArrivalAgeLoadedAt = started;
    app.pmbArrivalAgeRevision = revisionAtStart;
    if (result?.error) return;
    const next = new Map();
    (Array.isArray(result?.data) ? result.data : []).forEach(row => {
      if (row?.vehicle_id) next.set(String(row.vehicle_id), row);
    });
    const signature = [...next.entries()].map(([id, row]) => `${id}|${row.basis}|${row.arrived_at || ''}|${row.key_at || ''}|${row.tune_at || ''}`).sort().join('\n');
    const changed = signature !== app.pmbArrivalAgeSignature;
    app.pmbArrivalAge = next;
    app.pmbArrivalAgeSignature = signature;
    if (changed && app.currentView === 'dashboard' && typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
    if (changed && app.currentView === 'qc' && typeof renderQualityControlPage === 'function') renderQualityControlPage();
  }).catch(() => {
    app.pmbArrivalAgeLoading = false;
    app.pmbArrivalAgeLoadedAt = started;
    app.pmbArrivalAgeRevision = revisionAtStart;
  });
}

async function pushNewToPmb(key = '') {
  const vehicle = vehicleLocationsScreenRows().find(row => vehicleKey(row) === key);
  const id = vehicle ? pmbArrivalVehicleId(vehicle) : '';
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!vehicle || !id || !client || typeof client.rpc !== 'function') {
    if (typeof pdcNotify === 'function') pdcNotify('This vehicle could not be moved to PMB. Refresh and try again.');
    return;
  }
  const result = await client.rpc('push_new_to_pmb_562', { p_vehicle_id: id });
  const body = result?.data;
  if (result?.error || !body || body.ok !== true) {
    const message = body?.message || result?.error?.message || 'This vehicle could not be moved to PMB.';
    if (typeof pdcNotify === 'function') pdcNotify(message);
    return;
  }
  const data = body.data || {};
  if (!(app.pmbArrivalAck instanceof Map)) app.pmbArrivalAck = new Map();
  app.pmbArrivalAck.set(id, {
    vehicle_id: id,
    source: data.source || 'location',
    viewer_pending: false,
    closed: data.closed !== false,
    departments: Array.isArray(data.departments) ? data.departments : [],
  });
  app.pmbArrivalAckSignature = '';
  app.pmbArrivalAckLoadedAt = 0;
  app.pmbKeyAssignedSignature = '';
  app.pmbKeyAssignedLoadedAt = 0;
  if (typeof renderIncomingDashboardBoard === 'function') renderIncomingDashboardBoard();
}

// Keep every consumer of Vehicle Locations on the same authoritative row set.
// Parts must not grow its own universe from the legacy PDC sheet/back-end data.
function vehicleLocationsScreenRows(rows = vehicleLocationBoardRows()) {
  return (Array.isArray(rows) ? rows : [])
    .filter(vehicle => incomingBucketForVehicle(vehicle) && !vehicleCollectedFromRft(vehicle) && !vehicleInCollectedState(vehicle));
}

function incomingBucketLabel(bucketKey = '') {
  if (bucketKey === 'completed') return 'Completed vehicles';
  return VEHICLE_LOCATION_BUCKET_DEFS.find(def => def.key === bucketKey)?.label || bucketKey || 'OTHER';
}

function vehicleJobcardSearchNumbers(vehicle = {}) {
  const lines = [...(vehicle.pdcEmailOperationLines || []), ...(vehicle.pdcQcOperationLines || [])];
  return [...new Set([vehicleJobcardNumber(vehicle), vehicle.job_card_number,
    ...(vehicle.pdcJobCardNumbers || []), ...lines.map(line => line.job_card_number || line.jobCardNumber)]
    .filter(Boolean).map(value => String(value).trim().toLowerCase()))];
}

function vehicleMatchesJobcardSearch(vehicle = {}, query = '') {
  const needle = String(query || '').toLowerCase().replace(/[\s-]/g, '');
  return Boolean(needle && /\d/.test(needle) && vehicleJobcardSearchNumbers(vehicle)
    .some(number => number.replace(/[\s-]/g, '').includes(needle)));
}

function incomingSearchText(vehicle = {}, bucketKey = '') {
  return [
    displayStockNumber(vehicle), vehicle.stock, vehicle.batch, ...vehicleJobcardSearchNumbers(vehicle),
    vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle), vehicle.rego, vehicle.registration, vehicle.client, vehicle.toyotaCustomer,
    vehicle.vehicle, vehicle.toyotaVehicle, displayVehicle(vehicle), navisionStatusText(vehicle), incomingBucketLabel(bucketKey),
    vehicle.consultant, vehicle.salesperson, vehicle.salesPerson, vehicle.owner, vehicle.navisionNotes, vehicle.dealerComments,
    vehicle.notes, vehicle.keyNumber, vehicle.keyNo, vehicle.pmbKeyNumber, vehicle.vehicleKeyNumber, vehicle.pdcJobcard, vehicle.jobcard, vehicle.jobCardNumber,
    vehicle.purchaseOrderNumber, vehicle.purchaseOrderReference, vehicle.purchaseOrderDeliverTo, vehicle.purchaseOrderIssuedBy,
  ].filter(Boolean).join(' ').toLowerCase();
}

function incomingWorkFilterValues() {
  return $$('input[name="incoming-work-filter"]')
    .filter(input => input.checked)
    .map(input => String(input.value || '').trim().toLowerCase())
    .filter(Boolean);
}

function incomingDepartmentFilterValue() {
  return typeof window === 'object' ? window.PDC_DEPARTMENT_FILTER?.getSelection() || '' : '';
}

function syncIncomingDepartmentFilter() {
  const control = $('#incoming-department-filter');
  if (control) control.value = incomingDepartmentFilterValue();
  if (app.currentView !== 'dashboard') return;
  app.selectedRows.clear();
  if (app.singleSearchFocus) app.singleSearchFocus.incoming = '';
  renderIncomingDashboardBoard();
}

function pruneIncomingDepartmentSelection(rows = []) {
  if (app.currentView !== 'dashboard') return;
  const visible = new Set(rows.map(vehicleKey));
  [...app.selectedRows].forEach(key => { if (!visible.has(key)) app.selectedRows.delete(key); });
}

function incomingDepartmentPriorityRows(filters = incomingDashboardFilterValues()) {
  return workflowPriorityRows().filter(row => incomingVehicleMatchesFilters(row.vehicle, filters));
}

function incomingDashboardFilterValues() {
  return {
    search: String($('#incoming-search')?.value || '').trim().toLowerCase(),
    department: incomingDepartmentFilterValue(),
    status: String($('#incoming-status-filter')?.value || '').trim(),
    bucket: String($('#incoming-bucket-filter')?.value || '').trim(),
    rep: String($('#incoming-rep-filter')?.value || '').trim(),
    work: incomingWorkFilterValues(),
  };
}

function incomingWorkFilterMatches(vehicle = {}, workKey = '') {
  const key = String(workKey || '').trim().toLowerCase();
  if (!key) return true;
  const def = PDC_JOB_BY_KEY.get(key);
  if (!def) return true;
  return pdcJobRequired(vehicle, def) || pdcJobComplete(vehicle, def);
}

function incomingVehicleMatchesFilters(vehicle = {}, filters = incomingDashboardFilterValues()) {
  if (filters.department && (typeof window !== 'object' || window.PDC_DEPARTMENT_FILTER?.matches(vehicle, filters.department) !== true)) return false;
  const bucket = incomingBucketForVehicle(vehicle);
  if (!bucket) return false;
  const status = navisionStatusText(vehicle) || pdcLocationLabel(vehiclePdcLocation(vehicle)) || '';
  const rep = consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || '';
  if (filters.bucket && bucket !== filters.bucket) return false;
  if (filters.status && status !== filters.status) return false;
  if (filters.rep && rep !== filters.rep) return false;
  const workFilters = Array.isArray(filters.work) ? filters.work : (filters.work ? [filters.work] : []);
  if (workFilters.length && !workFilters.some(work => incomingWorkFilterMatches(vehicle, work))) return false;
  if (filters.search && !incomingSearchText(vehicle, bucket).includes(filters.search) && !vehicleMatchesJobcardSearch(vehicle, filters.search)) return false;
  return true;
}

function setSelectOptions(select, options = [], placeholder = 'All') {
  if (!select) return;
  const current = select.value;
  select.innerHTML = `<option value="">${escapeHtml(placeholder)}</option>` + options
    .filter(Boolean)
    .sort((a, b) => String(a).localeCompare(String(b), undefined, { sensitivity: 'base' }))
    .map(value => `<option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`)
    .join('');
  if (options.includes(current)) select.value = current;
}

function updateIncomingDashboardFilterOptions(rows = []) {
  const statuses = [...new Set(rows.map(vehicle => navisionStatusText(vehicle) || pdcLocationLabel(vehiclePdcLocation(vehicle)) || '').filter(Boolean))];
  const reps = [...new Set(rows.map(vehicle => consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || '').filter(Boolean))];
  setSelectOptions($('#incoming-status-filter'), statuses, 'All statuses');
  setSelectOptions($('#incoming-rep-filter'), reps, 'All reps');
}

function setCollapseToggleLabel(button, expanded) {
  if (button) button.textContent = expanded ? 'Collapse all rows' : 'Expand all rows';
}

function detailsWithin(host) {
  if (!host) return [];
  const directSelectors = [
    ':scope > details',
    ':scope > .incoming-vertical-list > details',
    ':scope > .rft-compact-list > details',
    ':scope > .deleted-compact-list > details',
    ':scope > .workflow-collapsible-board > details',
  ];
  const rows = directSelectors.flatMap(selector => {
    try { return $$(selector, host); } catch (error) { return []; }
  });
  const unique = [...new Set(rows)];
  return unique.length ? unique : $$('details', host).filter(row => row.parentElement === host);
}

function setDetailsWithin(host, open) {
  detailsWithin(host).forEach(row => { row.open = open; });
}

function toggleDetailsWithin(host, button) {
  const rows = detailsWithin(host);
  if (!rows.length) return;
  const shouldExpand = !rows.some(row => row.open);
  rows.forEach(row => { row.open = shouldExpand; });
  setCollapseToggleLabel(button, shouldExpand);
}

function updateCollapseToggleButtons() {
  [
    ['#incoming-main-board', '#incoming-collapse-all'],
    ['#rft-home-content', '#rft-collapse-all'],
    ['#completed-vehicles-content', '#completed-collapse-all'],
    ['#deleted-vehicles-content', '#deleted-collapse-all'],
  ].forEach(([hostSelector, buttonSelector]) => {
    const rows = detailsWithin($(hostSelector));
    if (rows.length) setCollapseToggleLabel($(buttonSelector), rows.some(row => row.open));
  });
  const workflowRows = detailsWithin($('#workflow-board'));
  if (workflowRows.length) setCollapseToggleLabel($('#workflow-collapse-all'), workflowRows.some(row => row.open));
}

function toggleMainScreenRows() {
  toggleDetailsWithin($('#incoming-main-board'), $('#incoming-collapse-all'));
}

function toggleRftRows() {
  toggleDetailsWithin($('#rft-home-content'), $('#rft-collapse-all'));
}

function toggleCompletedRows() {
  toggleDetailsWithin($('#completed-vehicles-content'), $('#completed-collapse-all'));
}

function toggleDeletedRows() {
  toggleDetailsWithin($('#deleted-vehicles-content'), $('#deleted-collapse-all'));
}

function toggleWorkflowRows() {
  const host = $('#workflow-board');
  const rows = detailsWithin(host);
  const shouldExpand = !rows.some(row => row.open);
  app.workflowBucketsCollapsed = !shouldExpand;
  if (normalizePmbStage(app.activePmbBayStage) || app.pmbSubFilter) {
    app.activePmbBayStage = '';
    app.pmbSubFilter = '';
    document.body.classList.remove('pmb-station-mode');
    showView('workflow');
  }
  renderWorkflowBoard();
  setDetailsWithin($('#workflow-board'), shouldExpand);
  setCollapseToggleLabel($('#workflow-collapse-all'), shouldExpand);
}

function clearIncomingDashboardFilters() {
  ['#incoming-search', '#incoming-status-filter', '#incoming-bucket-filter', '#incoming-rep-filter'].forEach(selector => {
    const input = $(selector);
    if (input) input.value = '';
  });
  $$('input[name="incoming-work-filter"]').forEach(input => { input.checked = false; });
  if (incomingDepartmentFilterValue()) window.PDC_DEPARTMENT_FILTER.setSelection('');
  else renderIncomingDashboardBoard();
}

function workflowSearchText(vehicle = {}) {
  return incomingSearchText(vehicle, 'pmb');
}

function workflowVehicleMatchesSearch(vehicle = {}, search = '') {
  const needle = String(search || '').trim().toLowerCase();
  if (!needle) return true;
  return workflowSearchText(vehicle).includes(needle) || vehicleMatchesJobcardSearch(vehicle, needle);
}

function workflowSearchValue() {
  return String($('#workflow-search')?.value || app.workflowSearch || '').trim().toLowerCase();
}

function revealSingleVehicleSearchResult(host, vehicles = [], query = '', scope = 'vehicle-search') {
  const needle = String(query || '').trim().toLowerCase();
  if (!host || !needle || vehicles.length !== 1) {
    if (app.singleSearchFocus) app.singleSearchFocus[scope] = '';
    return;
  }
  const key = vehicleKey(vehicles[0]);
  const matchingRows = $$('[data-incoming-row]', host).filter(row => row.dataset.incomingRow === key);
  if (!matchingRows.length) return;
  matchingRows.forEach(row => {
    row.open = true;
    row.classList.add('vehicle-search-highlight');
    const bucket = row.closest?.('details.incoming-bucket');
    if (bucket) bucket.open = true;
  });
  const primary = matchingRows.find(row => !row.closest?.('.workflow-fix-first-bucket, .incoming-priority-stoppages')) || matchingRows[0];
  const token = `${needle}|${key}`;
  if (app.singleSearchFocus?.[scope] === token) return;
  app.singleSearchFocus[scope] = token;
  window.requestAnimationFrame?.(() => primary.scrollIntoView?.({ block: 'center', behavior: 'smooth' }));
}

function focusVehiclesAfterWorkImport(keys = []) {
  const focusKeys = [...new Set((Array.isArray(keys) ? keys : [keys]).map(value => String(value || '').trim()).filter(Boolean))];
  if (!focusKeys.length) return;

  ['#incoming-search', '#incoming-status-filter', '#incoming-bucket-filter', '#incoming-rep-filter'].forEach(selector => {
    const input = $(selector);
    if (input) input.value = '';
  });
  $$('input[name="incoming-work-filter"]').forEach(input => { input.checked = false; });
  app.quickFilter = 'incoming';
  app.singleSearchFocus.incoming = '';
  showView('dashboard');

  window.requestAnimationFrame?.(() => {
    const host = $('#incoming-main-board');
    if (!host) return;
    $$('details', host).forEach(details => { details.open = false; });
    const focusedRows = [];
    focusKeys.forEach(key => {
      const rows = $$('[data-incoming-row]', host).filter(row => row.dataset.incomingRow === key);
      const primary = rows.find(row => !row.closest?.('.incoming-priority-stoppages')) || rows[0];
      if (!primary) return;
      primary.open = true;
      primary.classList.add('vehicle-search-highlight', 'vehicle-import-highlight');
      const bucket = primary.closest?.('details.incoming-bucket');
      if (bucket) bucket.open = true;
      focusedRows.push(primary);
    });
    updateCollapseToggleButtons();
    focusedRows[0]?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
  });
}

function clearWorkflowSearch() {
  app.workflowSearch = '';
  app.workflowKeySearch = ''; // r912 (F494)
  const input = $('#workflow-search');
  if (input) input.value = '';
  const keyInput = $('#workflow-key-search');
  if (keyInput) keyInput.value = '';
  renderWorkflowBoard();
}

function workflowFilterValues() {
  const previous = app.workflowFilters || {};
  const filters = {
    search: workflowSearchValue(),
    sort: String(previous.sort || 'oldest').trim() || 'oldest',
    bucket: String(previous.bucket || '').trim(),
    work: String(previous.work || '').trim(),
    required: String(previous.required || '').trim(),
    completion: String(previous.completion || '').trim(),
    stoppage: String(previous.stoppage || '').trim(),
  };
  if (!filters.work) {
    filters.required = '';
    filters.completion = '';
  }
  if (filters.required === 'no') {
    filters.completion = '';
  }
  app.workflowFilters = {
    sort: filters.sort,
    bucket: filters.bucket,
    work: filters.work,
    required: filters.required,
    completion: filters.completion,
    stoppage: filters.stoppage,
  };
  return filters;
}

function workflowFiltersNarrowRows(filters = {}) {
  return Boolean(filters.search || filters.bucket || filters.work || filters.required || filters.completion || filters.stoppage);
}

function workflowColumnFiltersActive(filters = {}) {
  return Boolean(filters.bucket || filters.work || filters.required || filters.completion || filters.stoppage);
}

function workflowVehicleHasStoppage(vehicle = {}) {
  return Boolean(isPdcBlocked(vehicle) || partsDepartmentStatus(vehicle) === 'stoppage');
}

function workflowVehicleMatchesFilters(vehicle = {}, filters = {}) {
  if (filters.search && !workflowVehicleMatchesSearch(vehicle, filters.search)) return false;
  const stage = inferredPmbStage(vehicle);
  if (filters.bucket === 'UNALLOCATED' && stage) return false;
  if (filters.bucket && filters.bucket !== 'UNALLOCATED' && stage !== filters.bucket) return false;

  const workDef = filters.work ? PDC_JOB_BY_KEY.get(filters.work) : null;
  if (workDef) {
    const required = pdcJobRequired(vehicle, workDef) || pdcJobComplete(vehicle, workDef);
    const complete = pdcJobComplete(vehicle, workDef);
    if (filters.required === 'yes' && !required) return false;
    if (filters.required === 'no' && required) return false;
    if (filters.completion === 'outstanding' && !(required && !complete)) return false;
    if (filters.completion === 'complete' && !complete) return false;
  }

  const stopped = workflowVehicleHasStoppage(vehicle);
  if (filters.stoppage === 'yes' && !stopped) return false;
  if (filters.stoppage === 'no' && stopped) return false;
  return true;
}

function workflowVehicleSortTimestamp(vehicle = {}) {
  const entered = parseIsoTimestamp(pmbEnteredTimestamp(vehicle));
  if (entered) return entered.getTime();
  const kewdaleDate = parseDateAU(kewdaleEtaValue(vehicle));
  return kewdaleDate ? kewdaleDate.getTime() : null;
}

function workflowCompareVehicles(a = {}, b = {}, sort = 'oldest') {
  const textCompare = (left, right) => String(left || '').localeCompare(String(right || ''), undefined, { numeric: true, sensitivity: 'base' });
  if (sort === 'key-asc' || sort === 'key-desc') {
    const direction = sort === 'key-desc' ? -1 : 1;
    return direction * textCompare(vehicleKeyNumber(a), vehicleKeyNumber(b));
  }
  if (sort === 'stock-asc' || sort === 'stock-desc') {
    const direction = sort === 'stock-desc' ? -1 : 1;
    return direction * textCompare(displayStockNumber(a) || vehicleKey(a), displayStockNumber(b) || vehicleKey(b));
  }
  if (sort === 'customer-asc') {
    const customerDiff = textCompare(vehicleCustomerName(a), vehicleCustomerName(b));
    return customerDiff || textCompare(displayStockNumber(a) || vehicleKey(a), displayStockNumber(b) || vehicleKey(b));
  }
  if (sort === 'customer-desc') {
    const customerDiff = textCompare(vehicleCustomerName(b), vehicleCustomerName(a));
    return customerDiff || textCompare(displayStockNumber(a) || vehicleKey(a), displayStockNumber(b) || vehicleKey(b));
  }
  if (sort === 'jobcard-asc' || sort === 'jobcard-desc') {
    const direction = sort === 'jobcard-desc' ? -1 : 1;
    return direction * textCompare(vehicleJobcardNumber(a), vehicleJobcardNumber(b));
  }
  if (sort === 'vehicle-asc' || sort === 'vehicle-desc') {
    const direction = sort === 'vehicle-desc' ? -1 : 1;
    return direction * textCompare(displayVehicle(a), displayVehicle(b));
  }
  const aDate = workflowVehicleSortTimestamp(a);
  const bDate = workflowVehicleSortTimestamp(b);
  if (aDate === null && bDate !== null) return 1;
  if (aDate !== null && bDate === null) return -1;
  if (aDate !== null && bDate !== null && aDate !== bDate) return sort === 'newest' ? bDate - aDate : aDate - bDate;
  return textCompare(displayStockNumber(a) || vehicleKey(a), displayStockNumber(b) || vehicleKey(b));
}

function workflowFilterAndSortRows(rows = [], filters = {}) {
  return rows
    .filter(vehicle => workflowVehicleMatchesFilters(vehicle, filters))
    .map((vehicle, index) => ({ vehicle, index }))
    .sort((a, b) => workflowCompareVehicles(a.vehicle, b.vehicle, filters.sort || 'oldest') || a.index - b.index)
    .map(item => item.vehicle);
}

function workflowFilterSummary(filters = {}, matched = 0, total = 0) {
  const parts = [`Showing ${matched} of ${total}`];
  const sortLabels = { oldest: 'oldest first', newest: 'newest first', 'key-asc': 'key low–high', 'key-desc': 'key high–low', 'stock-asc': 'stock A–Z', 'stock-desc': 'stock Z–A', 'jobcard-asc': 'job card A–Z', 'jobcard-desc': 'job card Z–A', 'customer-asc': 'customer A–Z', 'customer-desc': 'customer Z–A', 'vehicle-asc': 'vehicle A–Z', 'vehicle-desc': 'vehicle Z–A' };
  const bucketLabels = { UNALLOCATED: 'Unallocated', TINT: 'Tint', HOIST: 'Hoist', FITTING: 'Fitting', FABRICATION: 'Fab', ELECTRICAL: 'Elec', TYRE: 'Tyre', PIT_INSPECTION: 'Pit', SUBLET: 'Sublet' };
  if (filters.search) parts.push(`search “${filters.search}”`);
  if (filters.bucket) parts.push(`bucket ${bucketLabels[filters.bucket] || filters.bucket}`);
  if (filters.work) parts.push(`work ${PDC_JOB_BY_KEY.get(filters.work)?.label || filters.work}`);
  if (filters.required) parts.push(`required ${filters.required}`);
  if (filters.completion) parts.push(filters.completion);
  if (filters.stoppage) parts.push(filters.stoppage === 'yes' ? 'STOPPAGE only' : 'no STOPPAGE');
  parts.push(sortLabels[filters.sort] || 'oldest first');
  return parts.join(' · ');
}

function applyWorkflowHeaderFilter(type = '', value = '', workKey = '') {
  const filters = { ...(app.workflowFilters || {}) };
  if (type === 'sort') {
    filters.sort = value || 'oldest';
  } else if (type === 'status') {
    filters.bucket = '';
    filters.stoppage = '';
    const [kind, selected] = String(value || '').split(':');
    if (kind === 'bucket') filters.bucket = selected || '';
    if (kind === 'stoppage') filters.stoppage = selected || '';
  } else if (type === 'work') {
    filters.work = value ? workKey : '';
    filters.required = value === 'yes' ? 'yes' : value === 'no' ? 'no' : '';
    filters.completion = value === 'outstanding' ? 'outstanding' : value === 'complete' ? 'complete' : '';
  }
  app.workflowFilters = filters;
  renderWorkflowBoard();
}

function clearWorkflowFilters() {
  app.workflowFilters = { sort: 'oldest', bucket: '', work: '', required: '', completion: '', stoppage: '' };
  renderWorkflowBoard();
}

let workflowFloatingHeaderFrame = 0;

function scheduleWorkflowFloatingHeaderUpdate() {
  if (workflowFloatingHeaderFrame || !window.requestAnimationFrame) return;
  workflowFloatingHeaderFrame = window.requestAnimationFrame(() => {
    workflowFloatingHeaderFrame = 0;
    updateWorkflowFloatingHeader();
  });
}

function workflowFloatingHeaderHost() {
  let floating = $('#workflow-floating-column-header');
  if (floating) return floating;
  floating = document.createElement('div');
  floating.id = 'workflow-floating-column-header';
  floating.className = 'workflow-floating-column-header';
  floating.hidden = true;
  floating.addEventListener('scroll', () => {
    const sourceList = floating.__sourceList;
    if (sourceList && Math.abs(sourceList.scrollLeft - floating.scrollLeft) > 1) sourceList.scrollLeft = floating.scrollLeft;
  }, { passive: true });
  document.body.appendChild(floating);
  return floating;
}

function updateWorkflowFloatingHeader() {
  const floating = $('#workflow-floating-column-header');
  if (document.body?.dataset?.currentView !== 'workflow' || document.body.classList.contains('pmb-station-mode')) {
    if (floating) floating.hidden = true;
    return;
  }
  const headers = $$('.workflow-production-grid-header', $('#workflow-board'));
  const top = 8;
  let source = null;
  headers.forEach(header => {
    const lane = header.closest('.workflow-stage-bucket');
    if (!lane?.open) return;
    const headerRect = header.getBoundingClientRect();
    const laneRect = lane.getBoundingClientRect();
    if (headerRect.top < top && laneRect.bottom > top + headerRect.height) source = header;
  });
  if (!source) {
    if (floating) floating.hidden = true;
    return;
  }
  const sourceList = source.closest('.workflow-vertical-list');
  if (!sourceList) return;
  const listRect = sourceList.getBoundingClientRect();
  const visibleLeft = Math.max(0, listRect.left);
  const visibleRight = Math.min(window.innerWidth, listRect.right);
  const host = workflowFloatingHeaderHost();
  if (host.__sourceHeader !== source) {
    host.innerHTML = '';
    const clone = source.cloneNode(true);
    clone.classList.add('is-floating-copy');
    clone.removeAttribute('id');
    host.appendChild(clone);
    host.__sourceHeader = source;
  }
  host.__sourceList = sourceList;
  host.style.left = `${Math.round(visibleLeft)}px`;
  host.style.width = `${Math.max(0, Math.round(visibleRight - visibleLeft))}px`;
  host.hidden = false;
  if (Math.abs(host.scrollLeft - sourceList.scrollLeft) > 1) host.scrollLeft = sourceList.scrollLeft;
}


function loadWorkflowWidthMode() {
  try {
    const value = localStorage.getItem(ROW_WIDTH_MODE_KEY) || localStorage.getItem(WORKFLOW_WIDTH_MODE_KEY) || 'standard';
    return ['compact', 'standard', 'wide', 'xl'].includes(value) ? value : 'standard';
  } catch (error) {
    return 'standard';
  }
}

function applyWorkflowWidthMode(mode = 'standard') {
  const normalized = ['compact', 'standard', 'wide', 'xl'].includes(mode) ? mode : 'standard';
  app.workflowWidthMode = normalized;
  if (document.documentElement?.dataset) {
    document.documentElement.dataset.workflowWidth = normalized;
    document.documentElement.dataset.rowWidth = normalized;
  }
  const select = $('#workflow-width-mode');
  if (select) select.value = normalized;
}

function setWorkflowWidthMode(mode = 'standard') {
  const normalized = ['compact', 'standard', 'wide', 'xl'].includes(mode) ? mode : 'standard';
  try {
    localStorage.setItem(WORKFLOW_WIDTH_MODE_KEY, normalized);
    localStorage.setItem(ROW_WIDTH_MODE_KEY, normalized);
  } catch (error) {}
  applyWorkflowWidthMode(normalized);
}

function authenticatedOperationLineValid(value = '') {
  return /^(?:OP(?:[1-9]|[1-9][0-9]{1,2})|PD[0-9]{3}-[A-F0-9]{8})$/.test(String(value || '').trim().toUpperCase());
}

function authenticatedOperationLineSortValue(value = '') {
  const key = String(value || '').trim().toUpperCase();
  const op = key.match(/^OP([0-9]+)$/);
  if (op) return [0, Number(op[1]), key];
  const pd = key.match(/^PD([0-9]{3})-/);
  return [1, pd ? Number(pd[1]) : 9999, key];
}

function authenticatedOperationLineLabel(value = '') {
  const key = String(value || '').trim().toUpperCase();
  const pd = key.match(/^PD([0-9]{3})-/);
  return pd ? `PD line ${Number(pd[1])}` : key;
}

const AUTHENTICATED_OPERATION_STATION_ORDER = Object.freeze([
  { key: 'bus_mechanical', stage: 'BUS_4X4', label: 'Bus 4×4 · Mechanical', colour: '#3e6690', tint: '#edf2f8' },
  { key: 'bus_accessories', stage: 'BUS_4X4', label: 'Bus 4×4 · Accessories', colour: '#79528f', tint: '#f4eef8' },
  { key: 'bus_electrical', stage: 'BUS_4X4', label: 'Bus 4×4 · Electrical', colour: '#557649', tint: '#eef4eb' },
  { key: 'bus_qa', stage: 'BUS_4X4', label: 'Bus 4×4 · QA', colour: '#227889', tint: '#eaf7f9' },
  { key: 'bus_pit', stage: 'PIT_INSPECTION', label: 'Bus 4×4 · Pit (external)', colour: '#475569', tint: '#f8fafc' },
  { key: 'bus4x4', stage: 'BUS_4X4', label: 'Bus 4x4', colour: '#3e6690', tint: '#edf2f8' },
  { key: 'tint', stage: 'TINT', label: 'Tint', colour: '#227889', tint: '#eaf7f9' },
  { key: 'hoist', stage: 'HOIST', label: 'Hoist / GVM', colour: '#805b43', tint: '#f5eee8' },
  { key: 'fitting', stage: 'FITTING', label: 'Fitting', colour: '#79528f', tint: '#f4eef8' },
  { key: 'fabrication', stage: 'FABRICATION', label: 'Fabrication', colour: '#8c671d', tint: '#fbf5e5' },
  { key: 'electrical', stage: 'ELECTRICAL', label: 'Electrical', colour: '#557649', tint: '#eef4eb' },
  { key: 'tyre', stage: 'TYRE', label: 'Tyres', colour: '#a05270', tint: '#faedf2' },
  { key: 'pitinspection', stage: 'PIT_INSPECTION', label: 'Pit inspection', colour: '#475569', tint: '#f8fafc' },
  { key: 'parts', stage: 'PARTS', label: 'Parts', colour: '#dc2626', tint: '#fef2f2' },
  { key: 'sublet', stage: 'SUBLET', label: 'Sublet', colour: '#8c671d', tint: '#fbf5e5' },
  { key: 'review', stage: 'REVIEW', label: 'Review', colour: '#b45309', tint: '#fffbeb' },
]);

function authenticatedOperationSummaryLines(vehicle = {}) {
  const raw = (Array.isArray(vehicle.pdcEmailOperationLines) ? vehicle.pdcEmailOperationLines : []).slice(0, 50);
  const canonicalId = typeof vehicleWorkshopDetailCanonicalId === 'function' ? vehicleWorkshopDetailCanonicalId(vehicle) : '';
  const detailState = canonicalId ? app.vehicleWorkshopDetailCache?.get(canonicalId) : null;
  // The scoped job-card projection owns categories, edits and effective hours.
  // Never merge legacy import rows back into an authoritative (even empty) list.
  if (['ready', 'loading'].includes(detailState?.status) && Array.isArray(detailState.detail?.job_card_lines)) {
    return detailState.detail.job_card_lines.filter(line => line.active !== false && line.rejected !== true).map(line => {
      const stage = String(line.stage_code || '').toUpperCase();
      const workKey = { BUS_4X4: 'bus4x4', PIT_INSPECTION: 'pitinspection', UNALLOCATED_MAPPING_REVIEW: 'review' }[stage] || stage.toLowerCase();
      const categoryKey = String(line.work_category || '').toLowerCase();
      const summaryStationKey = categoryKey === 'unallocated_mapping_review' ? 'review'
        : AUTHENTICATED_OPERATION_STATION_ORDER.some(station => station.key === categoryKey) ? categoryKey : workKey;
      return { ...line, work_key: workKey, summaryStationKey, authoritativeJobCardLine: true,
        operation_line_id: line.source_line_id, workshopLineKey: line.line_identity,
        estimatedHours: line.estimated_hours == null || line.estimated_hours === '' ? null : Number(line.estimated_hours),
        estimatedHoursSource: line.hours_provenance, sourceEstimatedHours: line.source_estimated_hours,
        hoursProvenance: line.hours_provenance, description: cleanNavisionText(line.description || '') };
    });
  }
  const adjustments = detailState?.status === 'ready' && Array.isArray(detailState.detail?.line_adjustments) ? detailState.detail.line_adjustments : [];
  const adjustmentByKey = new Map(adjustments.filter(item => item?.source_kind !== 'manual' && item?.line_key).map(item => [String(item.line_key), item]));
  return raw.flatMap(operation => {
    const sourceStation = AUTHENTICATED_OPERATION_STATION_ORDER.find(station => station.key === String(operation?.work_key || '').trim().toLowerCase());
    const lineKey = typeof vehicleWorkshopLineIdentity === 'function' ? vehicleWorkshopLineIdentity(sourceStation?.stage || '', operation || {}) : '';
    const adjustment = adjustmentByKey.get(lineKey);
    if (adjustment?.active === false) return [];
    const targetStation = adjustment ? AUTHENTICATED_OPERATION_STATION_ORDER.find(station => !station.key.startsWith('bus_') && station.stage === vehicleWorkshopStageCode(adjustment.stage_code)) : sourceStation;
    const adjustedHours = adjustment && adjustment.estimated_hours !== null && adjustment.estimated_hours !== undefined && String(adjustment.estimated_hours).trim() !== ''
      ? Number(adjustment.estimated_hours)
      : operation?.estimatedHours;
    return [{
      ...operation,
      work_key: targetStation?.key || operation?.work_key,
      description: cleanNavisionText(adjustment?.description || operation?.description || ''),
      estimatedHours: Number.isFinite(Number(adjustedHours)) && adjustedHours !== '' && adjustedHours !== null ? Number(adjustedHours) : null,
      estimatedHoursSource: adjustment
        ? (adjustment.correction_origin === 'manual_operator'
          ? 'manual_override'
          : adjustment.correction_origin === 'job_card_source_correction'
            ? 'job_card'
            : adjustment.correction_origin === 'craig_standard_pd_1_5'
              ? 'craig_standard_pd_1_5'
              : adjustment.correction_origin === 'zero_hour_estimate_683'
                ? 'zero_hour_estimate'
                : 'protected_adjustment')
        : operation?.estimatedHoursSource,
      workshopLineKey: lineKey,
    }];
  });
}

function authenticatedEmailOperationLinesHtml(vehicle = {}) {
  const operations = authenticatedOperationSummaryLines(vehicle)
    .filter(operation => operation
      && (operation.authoritativeJobCardLine || authenticatedOperationLineValid(operation.operation_no))
      && operation.description
      && AUTHENTICATED_OPERATION_STATION_ORDER.some(station => station.key === String(operation.summaryStationKey || operation.work_key || '').trim().toLowerCase()))
    .sort((a, b) => {
      const left = authenticatedOperationLineSortValue(a.operation_no);
      const right = authenticatedOperationLineSortValue(b.operation_no);
      return left[0] - right[0] || left[1] - right[1] || left[2].localeCompare(right[2]);
    });
  if (!operations.length) return '';
  const stationColumns = AUTHENTICATED_OPERATION_STATION_ORDER.map(station => ({
    ...station,
    operations: operations.filter(operation => String(operation.summaryStationKey || operation.work_key || '').trim().toLowerCase() === station.key),
  })).filter(station => station.operations.length);
  const vehicleIdentity = typeof vehicleKey === 'function'
    ? vehicleKey(vehicle)
    : String(vehicle?.stock || vehicle?.stockNumber || vehicle?.stock_number || '').trim();
  let canMoveJobs = false;
  try { canMoveJobs = typeof vehicleWorkshopCanEditLines === 'function' && vehicleWorkshopCanEditLines(); } catch (_) { canMoveJobs = false; }
  return `<div class="wide authenticated-email-operations" data-auth-operation-summary="${escapeHtml(vehicleIdentity)}">
    <div class="authenticated-email-operations-heading"><b>Operations from authenticated PD documents and job cards</b>${canMoveJobs && vehicleIdentity ? `<button type="button" class="small-button" data-auth-operation-work="${escapeHtml(vehicleIdentity)}">Edit jobs &amp; hours</button>` : ''}</div>
    <div class="authenticated-operation-station-grid">${stationColumns.map(station => {
      const statedHours = station.operations.map(operation => {
        if (operation?.estimatedHours === null || operation?.estimatedHours === undefined || operation?.estimatedHours === '') return null;
        const value = Number(operation.estimatedHours);
        return Number.isFinite(value) && value >= 0 ? value : null;
      }).filter(value => value !== null);
      const totalHours = statedHours.length ? statedHours.reduce((sum, value) => sum + value, 0) : null;
      const totalHoursLabel = totalHours === null ? 'Unknown hours' : `${totalHours.toFixed(2)} h`;
      return `<section class="authenticated-operation-station" data-operation-station="${escapeHtml(station.stage)}" data-operation-category="${escapeHtml(station.key)}" style="--station-colour:${escapeHtml(station.colour)};--station-tint:${escapeHtml(station.tint)}">
      <header><strong>${escapeHtml(station.label)}</strong><small>${station.operations.length} job${station.operations.length === 1 ? '' : 's'} · ${escapeHtml(totalHoursLabel)}</small></header>
      <ol aria-label="${escapeHtml(`${station.label} jobs`)}">${station.operations.map(operation => {
        const aiEstimate = operation.estimatedHours != null && operation.estimatedHoursSource === 'ai_estimate';
        const hoursText = operation.estimatedHours == null ? 'Hours not stated' : `${Number(operation.estimatedHours).toFixed(2)} h`;
        const hoursClass = aiEstimate ? ' class="is-ai-estimate" title="AI-generated estimate; verify before scheduling"' : '';
        const estimateLabel = aiEstimate ? '<span class="ai-estimate-label">AI estimate</span>' : '';
        const sourceHoursText = operation.classification === 'Review'
          ? `Source hours: ${operation.sourceEstimatedHours == null ? 'blank' : Number(operation.sourceEstimatedHours).toFixed(2)}`
          : '';
        const provenanceText = operation.hoursProvenance === 'pre_delivery_default_1_5' ? 'Business-rule default' : '';
        const reviewEvidence = [sourceHoursText, provenanceText].filter(Boolean).join(' · ');
        return `<li data-operation-source-id="${escapeHtml(operation.operation_line_id || '')}"><strong>${escapeHtml(authenticatedOperationLineLabel(operation.operation_no))}</strong><span>${escapeHtml(operation.description)}</span><em${hoursClass}>${escapeHtml(hoursText)}${estimateLabel}</em>${reviewEvidence ? `<small>${escapeHtml(reviewEvidence)}</small>` : ''}</li>`;
      }).join('')}</ol>
    </section>`;
    }).join('')}</div>
  </div>`;
}

function refreshAuthenticatedOperationSummaryRow(row, vehicle = null) {
  if (!row?.isConnected) return false;
  const targetVehicle = vehicle || selectedVehicle(row.dataset.incomingRow);
  if (!targetVehicle) return false;
  const current = row.querySelector('[data-auth-operation-summary]');
  const html = authenticatedEmailOperationLinesHtml(targetVehicle);
  if (!current) return false;
  if (!html) { current.remove(); return false; }
  const template = document.createElement('template');
  template.innerHTML = html.trim();
  const replacement = template.content.firstElementChild;
  if (!replacement) return false;
  current.replaceWith(replacement);
  replacement.querySelector('[data-auth-operation-work]')?.addEventListener('click', event => {
    event.stopPropagation();
    openAuthenticatedOperationWorkshop(event.currentTarget.dataset.authOperationWork);
  });
  return true;
}

async function loadAuthenticatedOperationSummary(row) {
  const vehicle = selectedVehicle(row?.dataset?.incomingRow);
  const canonicalId = vehicle ? vehicleWorkshopDetailCanonicalId(vehicle) : '';
  if (!row || !vehicle) return false;
  // Paint the retained source lines only when the row is opened, then apply
  // the existing authoritative detail refresh and protected adjustments.
  if (row.querySelector('[data-auth-operation-deferred]')) refreshAuthenticatedOperationSummaryRow(row, vehicle);
  if (!canonicalId) return false;
  const ready = app.vehicleWorkshopDetailCache?.get(canonicalId);
  const vehicleVersion = Number(vehicle.__emailVehicleVersion || vehicle.version || 0);
  if (ready?.status === 'ready' && Number(ready.detail?.vehicle_version || 0) >= vehicleVersion) return refreshAuthenticatedOperationSummaryRow(row, vehicle);
  if (!app.authenticatedOperationSummaryRequests) app.authenticatedOperationSummaryRequests = new Map();
  let request = app.authenticatedOperationSummaryRequests.get(canonicalId);
  if (!request) {
    request = (async () => {
      const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
      const config = window.PDC_SUPABASE_CONFIG || {};
      if (!token || !config.url || !config.publishableKey) return null;
      const dealerCode = vehicleWorkshopDetailRequestDealerCode(vehicle, config);
      if (!dealerCode) return null;
      const response = await fetch(`${config.url}/rest/v1/rpc/get_vehicle_workshop_detail_scoped`, { method: 'POST', headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ p_vehicle_id: canonicalId, p_dealer_code: dealerCode }) });
      if (!response.ok) return null;
      const contract = vehicleWorkshopDetailResponse(await response.json().catch(() => null), canonicalId);
      if (!contract.ok) return null;
      const detail = contract.detail;
      app.vehicleWorkshopDetailCache.set(canonicalId, { status: 'ready', detail });
      return detail;
    })().finally(() => app.authenticatedOperationSummaryRequests.delete(canonicalId));
    app.authenticatedOperationSummaryRequests.set(canonicalId, request);
  }
  const detail = await request;
  return detail ? refreshAuthenticatedOperationSummaryRow(row, vehicle) : false;
}

function bindAuthenticatedOperationSummaries(host = document) {
  installVehicleEmailWarningInteractions();
  $$('[data-incoming-row]', host).forEach(row => {
    row.addEventListener('toggle', () => { if (row.open) void loadAuthenticatedOperationSummary(row); });
    if (row.open) {
      void loadAuthenticatedOperationSummary(row);
      if (vehicleEmailNotesVisible()) void loadVehicleEmailWarnings(selectedVehicle(row.dataset.incomingRow), row);
    }
  });
}

function refreshOpenAuthenticatedOperationSummaries(host = document) {
  $$('[data-incoming-row][open]', host).forEach(row => { void loadAuthenticatedOperationSummary(row); });
}

function vehicleWorkshopBookingProjection(vehicle = {}, options = {}) {
  const unavailable = { activeBookings: [], available: false, bookingRequired: false, label: '', latestEnd: null, missingStages: [], requiredStages: [] };
  const plansAvailable = Array.isArray(options.plans) || typeof workshopLoadPlans === 'function';
  if (options.available === false || !plansAvailable) return unavailable;
  const requiredStages = [...new Set(pdcJobDefsPartsFirst()
    .filter(def => pdcJobRequired(vehicle, def) && !pdcJobComplete(vehicle, def))
    .map(def => pmbStageForPdcJob(def))
    .filter(stage => stage && WORKSHOP_PLANNER_ROUTE_BY_STAGE[stage]))];
  const plans = Array.isArray(options.plans) ? options.plans : workshopLoadPlans();
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const key = String(vehicleKey(vehicle) || '').trim();
  const activeBookings = (Array.isArray(plans) ? plans : []).filter(entry => {
    if (['completed', 'deleted', 'cancelled'].includes(String(entry?.status || '').toLowerCase())) return false;
    const identityMatches = canonicalId
      ? String(entry?.sharedVehicleId || '').trim() === canonicalId
      : String(entry?.vehicleKey || '').trim() === key;
    return identityMatches && normalizePmbStage(entry?.stage);
  });
  const bookedStages = new Set(activeBookings.map(entry => normalizePmbStage(entry.stage)).filter(Boolean));
  const missingStages = requiredStages.filter(stage => !bookedStages.has(stage));
  const endTimes = activeBookings.map(entry => {
    if (typeof workshopEntryEnd === 'function') return workshopEntryEnd(entry);
    const start = parseIsoTimestamp(entry?.startAt || '');
    return start ? new Date(start.getTime() + Math.max(0, Number(entry?.hours) || 0) * 3600000) : null;
  }).filter(date => date instanceof Date && !Number.isNaN(date.getTime()));
  const latestEnd = endTimes.length ? new Date(Math.max(...endTimes.map(date => date.getTime()))) : null;
  const bookingRequired = statusCategory(vehicle) === 'pmb' && missingStages.length > 0;
  const label = latestEnd
    ? `${missingStages.length ? 'Latest booking' : 'Est. complete'} ${latestEnd.toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit' })} ${latestEnd.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' })}`
    : bookingRequired ? 'Booking required' : '';
  return { activeBookings, available: true, bookingRequired, label, latestEnd, missingStages, requiredStages };
}

const PARTS_SINGLE_ICON_FLAG_KEY = 'pdc.control-board.parts-single-icon.v1';
let partsSingleIconEnabledCached = true;

function syncPartsSingleIconPreference() {
  try {
    const search = String(window.location?.search || '');
    const ParamsCtor = window.URLSearchParams || (typeof URLSearchParams !== 'undefined' ? URLSearchParams : null);
    if (ParamsCtor) {
      const value = new ParamsCtor(search).get('partsSingleIcon');
      if (value === '0') localStorage.setItem(PARTS_SINGLE_ICON_FLAG_KEY, '0');
      else if (value === '1') localStorage.removeItem(PARTS_SINGLE_ICON_FLAG_KEY);
    }
    partsSingleIconEnabledCached = localStorage.getItem(PARTS_SINGLE_ICON_FLAG_KEY) !== '0';
  } catch (error) {
    partsSingleIconEnabledCached = true;
  }
}

function partsSingleIconEnabled() {
  return partsSingleIconEnabledCached;
}

syncPartsSingleIconPreference();

function incomingWorkChecklistHtml(vehicle = {}, options = {}) {
  if (typeof ensureStationIconCompletion === 'function') ensureStationIconCompletion();
  const key = vehicleKey(vehicle);
  const currentStage = normalizePmbStage(inferredPmbStage(vehicle));
  const bookingProjection = options.bookingProjection || vehicleWorkshopBookingProjection(vehicle);
  const bookingWarning = bookingProjection.bookingRequired;
  const stoppedBookings = new Map((bookingProjection.activeBookings || [])
    .filter(entry => String(entry?.status || '').toLowerCase() === 'stoppage')
    .map(entry => [normalizePmbStage(entry.stage), entry]));

  return `<div class="incoming-work-checks pdc-station-strip" data-workshop-booking-required="${bookingWarning ? 'true' : 'false'}" aria-label="Required work stations${bookingWarning ? '; workshop booking incomplete' : ''}"${bookingWarning ? ' title="One or more required PMB workshop departments are not booked"' : ''}>${(Array.isArray(options.stationDefs) ? options.stationDefs : pdcJobDefsPartsFirst()).map(def => {
    if (def.busCategory) return busCategoryCheckHtml(vehicle, def); // r799: Department 138 category columns
    const required = pdcJobRequired(vehicle, def);
    const signedOff = pdcJobComplete(vehicle, def);
    const linesComplete = signedOff ? false : (typeof pdcStationLinesMakeComplete === 'function' && pdcStationLinesMakeComplete(vehicle, def));
    const complete = signedOff || linesComplete;
    const stage = pmbStageForPdcJob(def);
    const stoppedBooking = stage ? stoppedBookings.get(stage) : null;
    const stageJobKey = PMB_STAGE_TO_JOB_KEY[currentStage] || '';
    const blocked = def.key === 'parts'
      ? isActivePartsStoppage(vehicle)
      : Boolean(stoppedBooking || (isPdcBlocked(vehicle) && stageJobKey === def.key));
    const ordered = def.key === 'parts' && required && !complete && !blocked && partsOrdered(vehicle);
    const subletBooked = def.key === 'sublet' && Boolean(canonicalActiveSubletBooking(vehicle)) && !complete && !blocked;
    const projected = canonicalVehicleWorkState(vehicle, def, {
      bookings: bookingProjection.activeBookings || vehicle.salesWorkshopBookings || [],
      stoppage: blocked,
      stoppageReason: stoppedBooking?.stoppageReason || (blocked ? pdcBlockReason(vehicle) : ''),
      completed: complete,
    });
    const booked = projected.state === 'booked';
    const classes = ['incoming-work-check', `pdc-station-${def.key}`];
    if (!required && !complete) classes.push('is-not-required');
    if (required) classes.push('is-required');
    if (ordered || subletBooked) classes.push('is-ordered');
    if (booked) classes.push('is-booked');
    if (complete) classes.push('is-complete');
    if (projected.state === 'stoppage') classes.push('is-blocked');
    if (stage && currentStage === stage) classes.push('is-current-stage');
    const state = projected.state === 'completed' ? 'complete' : projected.state === 'stoppage' ? 'STOPPAGE' : ordered ? 'ordered' : projected.state;
    const marker = projected.marker;
    const lineWho = linesComplete && typeof pdcStationLinesOverrideBy === 'function' ? pdcStationLinesOverrideBy(vehicle, def) : '';
    const title = linesComplete
      ? (lineWho ? `${pdcGridJobLabel(def)} complete (override by ${lineWho})` : `${pdcGridJobLabel(def)} complete (every line ticked)`)
      : stoppedBooking
      ? `${pdcGridJobLabel(def)} STOPPAGE${stoppedBooking.stoppageReason ? `: ${stoppedBooking.stoppageReason}` : ''}`
      : ordered ? `${pdcGridJobLabel(def)} ordered` : booked ? `${pdcGridJobLabel(def)} booked` : required || complete ? pdcJobCompletionTitle(vehicle, def) : `${pdcGridJobLabel(def)} not required`;
    if (def.key === 'parts') {
      const jitaNumber = vehicleNavisionJitaNumber(vehicle);
      const jitaStatus = jitaNumber ? `Pre-order ${jitaNumber}` : 'No verified Navision pre-order number';
      const imported = typeof importedPartsStatus === 'function' ? importedPartsStatus(vehicle) : null;
      if (typeof partsSingleIconEnabled === 'function' && partsSingleIconEnabled()) {
        const jitaSuffix = jitaNumber ? ` · ${jitaNumber}` : '';
        const partsHoverTitle = (label) => {
          const text = String(label || '').trim();
          return text.startsWith('Parts:') ? `${text}${jitaSuffix}` : `Parts: ${text}${jitaSuffix}`;
        };
        const partsAriaRef = jitaNumber ? `; ${jitaNumber}` : '';
        if (blocked || projected.state === 'stoppage') {
          return `<span class="${classes.join(' ')} parts-single-icon" role="img" title="${escapeHtml(partsHoverTitle(title))}" aria-label="${escapeHtml(`${pdcGridJobLabel(def)} ${state}${partsAriaRef}`)}"><span class="incoming-work-box" aria-hidden="true">${marker}</span><span class="incoming-work-label">Parts</span></span>`;
        }
        if (imported) {
          const glyph = { green: '✓', orange: '!', red: '●', grey: '—', review: '?' }[imported.colour];
          return `<span class="incoming-work-check pdc-station-parts parts-single-icon imported-parts-${escapeHtml(imported.colour)}" role="img" title="${escapeHtml(partsHoverTitle(imported.label))}" aria-label="${escapeHtml(`${imported.label}${partsAriaRef}`)}"><span class="incoming-work-box" aria-hidden="true">${glyph}</span><span class="incoming-work-label">Parts</span></span>`;
        }
        const singleClasses = [...classes, 'parts-single-icon'];
        if (ordered) singleClasses.push('imported-parts-orange');
        let glyph = marker;
        if (complete) glyph = '✓';
        else if (ordered) glyph = '!';
        else if (!required && !complete) glyph = '—';
        else if (required && !ordered) glyph = '●';
        return `<span class="${singleClasses.join(' ')}" role="img" title="${escapeHtml(partsHoverTitle(title))}" aria-label="${escapeHtml(`${pdcGridJobLabel(def)} ${state}${partsAriaRef}`)}"><span class="incoming-work-box" aria-hidden="true">${glyph}</span><span class="incoming-work-label">Parts</span></span>`;
      }
      // r524 (F138): a verified Navision JITA number paints this whole station green only when
      // there is no imported parts status, or that status is green. Orange, red, review and grey
      // keep their colour, and the JITA tick stays in the bottom-right corner. A parts stoppage
      // stays a stoppage. The JITA ETA chip is a different date and is not read here.
      if (jitaNumber && !isActivePartsStoppage(vehicle) && (!imported || imported.colour === 'green')) {
        return `<span class="incoming-work-check pdc-station-parts parts-jita-split is-complete has-jita" role="img" title="${escapeHtml(`Parts complete. Navision number ${jitaNumber}.`)}" aria-label="${escapeHtml(`Parts complete; ${jitaStatus}`)}"><span class="incoming-work-box parts-jita-parts-marker" aria-hidden="true">✓</span><span class="parts-jita-marker" aria-hidden="true">✓</span><span class="incoming-work-label">Parts</span></span>`;
      }
      if (imported) {
        const glyph = {green: '✓', orange: '!', red: '●', grey: '—', review: '?'}[imported.colour];
        return `<span class="incoming-work-check parts-jita-split imported-parts-${escapeHtml(imported.colour)} ${jitaNumber ? 'has-jita' : 'no-jita'}" role="img" title="${escapeHtml(importedPartsTitle(vehicle) + ' ' + jitaStatus)}" aria-label="${escapeHtml(imported.label + '; ' + jitaStatus)}"><span class="incoming-work-box parts-jita-parts-marker" aria-hidden="true">${glyph}</span><span class="parts-jita-marker" aria-hidden="true">${jitaNumber ? '✓' : '●'}</span><span class="incoming-work-label">Parts</span></span>`;
      }
      return `<span class="${classes.join(' ')} parts-jita-split ${jitaNumber ? 'has-jita' : 'no-jita'}" role="img" title="${escapeHtml(`Top left: ${title}. Bottom right: ${jitaStatus}`)}" aria-label="${escapeHtml(`Parts ${state}; ${jitaStatus}`)}">
        <span class="incoming-work-box parts-jita-parts-marker" aria-hidden="true">${marker}</span>
        <span class="parts-jita-marker" aria-hidden="true">${jitaNumber ? '✓' : '●'}</span>
        <span class="incoming-work-label">Parts</span>
      </span>`;
    }
    if (def.key === 'sublet' && options.subletNavigation === true) {
      const stock = cleanNavisionText(displayStockNumber(vehicle));
      if (stock) return `<button type="button" class="${classes.join(' ')}" data-open-sublet-stock="${escapeHtml(stock)}" title="${escapeHtml(`${title} · Open Sublet for stock ${stock}`)}" aria-label="${escapeHtml(`Open Sublet for stock ${stock}; ${pdcGridJobLabel(def)} ${state}`)}"><span class="incoming-work-box" aria-hidden="true">${marker}</span><span class="incoming-work-label">${escapeHtml(pdcGridJobLabel(def))}</span></button>`;
    }
    return `<span class="${classes.join(' ')}" title="${escapeHtml(title)}" aria-label="${escapeHtml(`${pdcGridJobLabel(def)} ${state}`)}">
      <span class="incoming-work-box" aria-hidden="true">${marker}</span>
      <span class="incoming-work-label">${escapeHtml(pdcGridJobLabel(def))}</span>
    </span>`;
  }).join('')}</div>`;
}

function workStatusLegendHtml() {
  return `<div class="work-status-legend" aria-label="Work status legend">
    <strong>Work status</strong>
    <span class="work-status-key status-none"><b>—</b> Not required</span>
    <span class="work-status-key status-required"><b>●</b> Required</span>
    <span class="work-status-key status-booked"><b>!</b> Booked / Parts ordered</span>
    <span class="work-status-key status-complete"><b>✓</b> Complete</span>
    <span class="work-status-key status-blocked"><b>!</b> STOPPAGE</span>
  </div>`;
}

function incomingKewdaleAgeValue(vehicle = {}) {
  const value = kewdaleEtaValue(vehicle);
  // Shared imports can provide ISO dates; the age calculator uses AU dates.
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec(value);
  return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : value;
}

function incomingVehicleAge(vehicle = {}, bucketKey = '') {
  const atPmb = bucketKey === 'pmb' || bucketKey === 'qc' || bucketKey === 'newpmb';
  const atYardHold = bucketKey === 'yardhold';
  if (!atPmb && !atYardHold) {
    return { label: bucketKey === 'nonnavision' ? 'Unconfirmed' : locationAgeLabel(vehicle), colourClass: '', title: '' };
  }
  // r563 (F177): PMB, New to PMB and QC count from the earlier of the key
  // number and the first Tune import. When neither exists, the board arrival
  // is kept and flagged.
  // r830 (F391): a WPC car counts from WPC until Autocare collects it.
  const wpc = atPmb ? wpcAgeInfo(vehicle) : null;
  if (wpc) return { label: wpc.label, colourClass: `pmb-age-${vehicleAgeColourBand(wpc.days)}`, title: wpc.title };
  if (atPmb && typeof ensurePmbKeyAssigned === 'function') ensurePmbKeyAssigned();
  if (atPmb && typeof ensurePmbArrivalAge === 'function') ensurePmbArrivalAge();
  const days = atPmb ? pmbAgeDays(vehicle) : daysSinceDateValue(incomingKewdaleAgeValue(vehicle));
  const count = days === null ? null : Math.abs(days);
  const duration = count === null ? (atPmb && !pmbVehicleHasKey(vehicle) ? 'No key' : '—') : `${count} day${count === 1 ? '' : 's'}`;
  const basis = atPmb ? pmbArrivalAgeBasis(vehicle) : '';
  const title = !atPmb ? 'Days since Kewdale ETA'
    : basis === 'tune' ? (days === null ? 'Tune import date not recorded' : 'Days since this vehicle first appeared in a Tune import')
    : basis === 'fallback' ? (days === null ? 'No key history and no Tune import, so there is no PMB age' : 'Days since the board arrival. No key history and no Tune import.')
    : (days === null ? 'Key number date not recorded' : 'Days since the key number was assigned');
  return {
    label: days !== null && days < 0 ? `Due in ${duration}` : duration,
    colourClass: `pmb-age-${vehicleAgeColourBand(days)}`,
    title,
  };
}

function incomingVehicleDetailRow(vehicle = {}, bucketKey = '', options = {}) {
  const key = vehicleKey(vehicle);
  const sharedReadOnly = vehicle.__sharedNavisionReadOnly === true;
  const identityReadOnly = vehicle.__locationIdentityReadOnly === true || vehicle.__navisionDetailsIdentityConflict === true;
  const emailReadOnly = vehicle.__emailVehicleReadOnly === true;
  const authorityPending = !sharedNavisionLocationAuthorityReady();
  const locationReadOnly = sharedReadOnly || identityReadOnly || emailReadOnly || authorityPending;
  const protectedLifecycleAllowed = emailReadOnly && !identityReadOnly && !authorityPending && vehicleLifecycleSharedModeActive()
    && (bucketKey === 'yardhold' || bucketKey === 'nonnavision'
      || (bucketKey === 'pmb' && vehicleReadyForQualityControl(vehicle))
      || bucketKey === 'qc');
  const locationAge = incomingVehicleAge(vehicle, bucketKey === 'newpmb' ? 'pmb' : bucketKey);
  const stock = displayStockNumber(vehicle) || vehicleKey(vehicle) || 'No stock';
  const unit = displayVehicle(vehicle) || 'Vehicle not listed';
  const consultant = consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || '—';
  // r827 (F465): once RFT'd the key number is freed; the key spot reads RFT.
  const keyNo = typeof vehicleKeyIsWpc === 'function' && typeof vehicleRftConfirmationActive === 'function' && vehicleKeyIsWpc(vehicle) && vehicleRftConfirmationActive(vehicle) ? 'RFT' : (vehicleKeyNumber(vehicle) || '—');
  const vin = vehicle.vin || vehicle.VIN || vehicle.chassis || vehicle.chassisNo || '—';
  const age = ['pmb', 'newpmb', 'qc', 'yardhold'].includes(bucketKey) ? locationAge.label : bucketKey === 'rft' && typeof rftTransitAgeLabel === 'function' ? rftTransitAgeLabel(vehicle) : '—';
  const bookingProjection = vehicleWorkshopBookingProjection(vehicle, {
    available: options.workshopProjectionAvailable,
    plans: options.workshopPlans,
  });
  const workChecks = incomingWorkChecklistHtml(vehicle, { stationDefs: options.stationDefs, stationTransfer: (bucketKey === 'pmb' || bucketKey === 'newpmb') && options.stationTransfer !== false, bookingProjection, subletNavigation: options.subletNavigation === true });
  const stage = inferredPmbStage(vehicle);
  const rowStatus = incomingGridStatusLabel(vehicle, bucketKey, { bookingProjection });
  const subletProvider = pmbBaySubletProvider(vehicle);
  const canonicalSubletBooking = (Array.isArray(vehicle.pdcSubletBookings) ? vehicle.pdcSubletBookings : [])
    .filter(booking => ['active', 'returned'].includes(String(booking?.status || '')))
    .sort((a, b) => String(a?.outDate || '').localeCompare(String(b?.outDate || '')))[0] || null;
  const canonicalSubletStatus = canonicalSubletBooking?.status === 'returned' ? 'Returned' : 'Booked';
  const canonicalSubletDetail = canonicalSubletBooking
    ? `<div class="wide incoming-sublet-booking-detail"><b>Sublet booking</b><span><strong>${escapeHtml(canonicalSubletBooking.provider || 'Provider not assigned')}</strong> · ${escapeHtml(canonicalSubletBooking.outDate || 'Date not set')} → ${escapeHtml(canonicalSubletBooking.expectedReturnDate || 'Return date not set')} · <span class="sublet-status-pill is-${canonicalSubletBooking.status === 'returned' ? 'returned' : 'booked'}">${escapeHtml(canonicalSubletStatus)}</span></span></div>`
    : '';
  const subletProviderField = !locationReadOnly && bucketKey === 'pmb' && stage === 'SUBLET'
    ? `<div class="wide incoming-sublet-provider"><b>Sublet provider</b><span><select data-pmb-bay-provider-key="${escapeHtml(key)}" data-pmb-bay-provider-stage="SUBLET" aria-label="Sublet provider for ${escapeHtml(stock)}">${subletProviderOptionsHtml(subletProvider)}</select></span></div>`
    : '';
  // r521 (F135): a job-card flag does not pick the Booking column text and does not block booking.
  const readOnlyBadge = identityReadOnly ? 'Identity conflict · Read only' : emailReadOnly ? 'Imported by email · Read only' : sharedReadOnly ? 'Navision source · Read only' : 'Shared sync pending · Read only';
  const rftLike = bucketKey === 'rft' || bucketKey === 'wpc'; // r753 (F358): WPC rows carry the RFT'd tick, not station cells
  const rftAction = rftLike
    ? `${rftTransportControlsHtml(vehicle)}${locationReadOnly ? `<span class="badge neutral rft-source-badge">${readOnlyBadge}</span>` : ''}<button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`
    : '';
  const bodybuilderWaiting = typeof pmbBodybuilderHoldOpen === 'function' && pmbBodybuilderHoldOpen(vehicle);
  const pmbBucketActions = `${typeof pmbArrivalActionHtml === 'function' ? pmbArrivalActionHtml(vehicle, key) : ''}${vehicleReadyForQualityControl(vehicle)
        ? `<button class="primary" type="button" data-ready-for-qc="${escapeHtml(key)}" title="Move this all-green vehicle to the QC Gate">Ready for QC</button>`
        : `<button class="primary" type="button" data-pit-transfer="${escapeHtml(key)}" ${vehicleCanEnterPit(vehicle) ? '' : 'disabled'} title="${escapeHtml(vehicleCanEnterPit(vehicle) ? 'Move PMB Unallocated vehicle to PIT' : 'PIT movement requires PMB Unallocated with no active station')}">To PIT</button>`}<button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`;
  const primaryAction = rftLike
    ? (rftAction || (locationReadOnly ? `<span class="badge neutral">${readOnlyBadge}</span>` : `<button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`))
    : locationReadOnly && !protectedLifecycleAllowed
    ? `<span class="badge neutral">${readOnlyBadge}</span>`
    : bucketKey === 'yardhold' || bucketKey === 'nonnavision' || (bucketKey === 'transit' && canTransferVehicleToPmb(vehicle)) // r692: In transit vehicles that arrive can go To PMB too
    ? `${sharedVehicleLocationMutationUnavailable('transfer to PMB', vehicle, { silent: true }) || !canTransferVehicleToPmb(vehicle) ? '<span class="badge neutral">Shared move unavailable</span>' : `<button class="primary incoming-transfer-pmb" type="button" data-yh-transfer-pmb="${escapeHtml(key)}" title="${bucketKey === 'nonnavision' ? 'Confirm this non-division vehicle at PMB' : 'Transfer this Yard Hold vehicle to PMB'}">To PMB</button>`}<button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`
    : bucketKey === 'newpmb' && bodybuilderWaiting
      ? `<button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`
    : bucketKey === 'newpmb' || bucketKey === 'pmb'
      ? pmbBucketActions
      : bucketKey === 'qc'
        ? `<button class="primary" type="button" data-open-qc-vehicle="${escapeHtml(key)}">Open QC finalization</button><button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`
        : bucketKey === 'pit'
          ? `<button class="primary" type="button" data-pit-return-pmb="${escapeHtml(key)}">Return to PMB</button><button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`
          : rftLike
            ? rftAction
            : `<button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button>`;
  const pmbAckBar = bucketKey === 'newpmb' && bodybuilderWaiting && typeof pmbArrivalActionHtml === 'function'
    ? `<div class="pmb-ack-bar">${pmbArrivalActionHtml(vehicle, key)}</div>`
    : '';
  const labelAction = locationReadOnly || bucketKey === 'qc' ? '' : `<button class="small-button vehicle-label-button" type="button" data-label-vehicle="${escapeHtml(key)}" title="Print one Zebra label for ${escapeHtml(stock)}">Label</button>`;
  const deleteAction = locationReadOnly ? '' : (options.showDelete ? `<button class="small-button incoming-delete-button" type="button" data-incoming-delete="${escapeHtml(key)}" title="Move this vehicle to Deleted vehicles">Delete</button>` : '');
  const identitySummary = vehicleIdentityStackHtml(vehicle, {
    className: 'incoming-identity',
    button: !identityReadOnly && !authorityPending,
    buttonLabel: 'SN',
  });
  const selectBox = locationReadOnly
    ? '<span class="incoming-card-select" aria-hidden="true"></span>'
    : `<label class="incoming-card-select" title="Select ${escapeHtml(stock)}"><input type="checkbox" data-select-stock="${escapeHtml(key)}" aria-label="Select ${escapeHtml(stock)}" ${app.selectedRows.has(key) ? 'checked' : ''} /><span aria-hidden="true"></span></label>`;
  const draggable = options.draggable && !locationReadOnly;
  const dragAttrs = draggable ? ` draggable="true" data-pmb-drag-key="${escapeHtml(key)}"` : '';
  const dragClass = draggable ? ' workflow-draggable-row' : '';
  const risk = partsEtaRisk(vehicle);
  const isRftRow = rftLike;
  const rftControls = isRftRow ? rftTransportControlsHtml(vehicle) : '';
  return `
    <details class="incoming-vehicle-card pdc-production-grid-card incoming-${escapeHtml(bucketKey)}-row${dragClass} ${app.selectedRows.has(key) ? 'is-selected' : ''}${risk ? ' has-parts-risk' : ''}${locationReadOnly ? ' shared-navision-read-only' : ''}" data-incoming-row="${escapeHtml(key)}"${dragAttrs}>
      <summary class="incoming-vehicle-summary pdc-production-grid-row">
        ${selectBox}
        <span class="incoming-card-stock">${identitySummary}</span>
        <span class="incoming-card-main"><strong title="${escapeHtml(unit)}">${escapeHtml(unit)}</strong></span>
        ${isRftRow
          ? `<span class="rft-row-controls-slot">${rftControls}</span>`
          : `<span class="incoming-card-work-wrap">${workChecks}</span>
        <span class="incoming-card-meta incoming-card-age ${escapeHtml(locationAge.colourClass)}" title="${escapeHtml(locationAge.title)}"><b>${bucketKey === 'pmb' || bucketKey === 'newpmb' ? 'PMB' : bucketKey === 'qc' ? 'QC' : bucketKey === 'pit' ? 'PIT' : bucketKey === 'yardhold' ? 'YH' : bucketKey === 'nonnavision' ? 'Location' : 'ETA'}</b><span>${escapeHtml(locationAge.label)}</span></span>
        <span class="incoming-card-meta incoming-card-status"><b>Status</b><span>${partsRiskBadge(vehicle)}${vehicleDepartmentBadge(vehicle)}${escapeHtml(rowStatus)}${(bucketKey === 'pmb' || bucketKey === 'newpmb') && typeof pmbNewTagHtml === 'function' ? pmbNewTagHtml(vehicle) : ''}${typeof pmbBodybuilderHoldHtml === 'function' ? pmbBodybuilderHoldHtml(vehicle) : ''}${typeof pmbKeyNeededBadgeHtml === 'function' ? pmbKeyNeededBadgeHtml(vehicle) : ''}${typeof pmbArrivalAgeFlagHtml === 'function' ? pmbArrivalAgeFlagHtml(vehicle) : ''}</span></span>
        <span class="incoming-card-action">${window.PDC_BOOK_ALL_STATIONS?.actionHtml(vehicle, primaryAction) ?? primaryAction}${labelAction}${deleteAction}</span>`}
        ${pmbAckBar}
      </summary>
      <div class="incoming-vehicle-detail-grid">
        ${vehicleEmailPartsEtaHost(vehicle)}
        <div><b>Stock No.</b><span>${escapeHtml(stock)}</span></div>
        <div><b>VIN / Chassis</b><span>${escapeHtml(vin)}</span></div>
        <div><b>Sales rep</b><span>${escapeHtml(consultant)}</span></div>
        ${isRftRow ? '' : `<div><b>Age</b><span>${escapeHtml(age)}</span></div>`}
        <div><b>Bucket</b><span>${escapeHtml(incomingBucketLabel(bucketKey))}</span></div>
        ${risk && !isRftRow ? `<div class="wide parts-risk-detail"><b>PARTS RISK</b><span>Parts ETA ${escapeHtml(partsWorstEtaLabel(vehicle))} is later than the scheduled Workshop booking date</span></div>` : ''}
        ${canonicalSubletDetail}
        ${subletProviderField}
        ${isRftRow ? '' : `<div class="wide" data-auth-operation-summary="${escapeHtml(key)}" data-auth-operation-deferred></div>`}
      </div>
    </details>`;
}

const SALES_PREPARATION_FIELDS = Object.freeze([
  { field: 'tint_raised', key: 'tintRaised', label: 'Tint raised' },
  { field: 'build_po_raised', key: 'buildPoRaised', label: 'Build PO raised' },
  { field: 'build_complete', key: 'buildComplete', label: 'Build complete' },
  { field: 'tray_ordered', key: 'trayOrdered', label: 'Tray ordered' },
  { field: 'tray_complete', key: 'trayComplete', label: 'Tray complete' },
]);

function dashboardSalespersonCode(vehicle = {}) {
  return cleanNavisionText(vehicle.salespersonCode || salesPersonInitials(consultantName(vehicle)) || vehicle.salesperson || '').toUpperCase();
}

function dashboardViewSalesCode() {
  const value = String(app.dashboardView || 'operations');
  return value.startsWith('sales:') ? value.slice(6).toUpperCase() : '';
}

function populateDashboardViewSelect() {
  const select = $('#dashboard-view-select');
  if (!select) return;
  const current = String(app.dashboardView || 'operations');
  const records = loadSalespersonRecords().filter(record => record.active !== false && record.code);
  const options = [
    { value: 'operations', label: 'PMB Operations' },
    { value: 'sales-all', label: 'All Sales Vehicles' },
    ...records.map(record => ({ value: `sales:${String(record.code).toUpperCase()}`, label: `${String(record.code).toUpperCase()} — ${record.name}` })),
  ];
  select.innerHTML = options.map(option => `<option value="${escapeHtml(option.value)}"${option.value === current ? ' selected' : ''}>${escapeHtml(option.label)}</option>`).join('');
  if (!options.some(option => option.value === current)) {
    app.dashboardView = 'operations';
    select.value = 'operations';
  }
}

function salesBookingStatus(vehicle = {}) {
  const bookings = Array.isArray(vehicle.salesWorkshopBookings) ? vehicle.salesWorkshopBookings : [];
  const active = bookings.filter(booking => !['completed', 'cancelled'].includes(String(booking.status || '').toLowerCase()));
  const stopped = active.find(booking => String(booking.status || '').toLowerCase() === 'stoppage');
  if (stopped) return { tone: 'stoppage', label: 'STOPPAGE', detail: `${stopped.stageName || stopped.stageCode}${stopped.stoppageReason ? ` · ${stopped.stoppageReason}` : ''}` };
  const started = active.find(booking => String(booking.status || '').toLowerCase() === 'started');
  if (started) return { tone: 'started', label: 'Started', detail: `${started.stageName || started.stageCode}${started.bayName ? ` · ${started.bayName}` : ''}` };
  const scheduled = active.filter(booking => booking.scheduledStartAt).sort((a, b) => String(a.scheduledStartAt).localeCompare(String(b.scheduledStartAt)))[0];
  if (scheduled) {
    const date = new Date(scheduled.scheduledStartAt);
    const when = Number.isNaN(date.getTime()) ? '' : date.toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' });
    return { tone: 'scheduled', label: 'Scheduled', detail: `${scheduled.stageName || scheduled.stageCode}${when ? ` · ${when}` : ''}` };
  }
  if (bookings.length && bookings.every(booking => String(booking.status || '').toLowerCase() === 'completed')) return { tone: 'complete', label: 'Workshop complete', detail: 'All scheduled work is complete' };
  return { tone: 'unscheduled', label: 'Not scheduled', detail: 'No active workshop booking' };
}

function salesPreparationEditRoleAllowed(role = window.PDC_AUTH_CONTEXT?.role) {
  // r426 (F39): the Tint / Build PO / Tray ticks are a controller action; importers and viewers see them read-only.
  return ['operator', 'administrator'].includes(String(role || '').trim().toLowerCase());
}

function salesPreparationControlsHtml(vehicle = {}) {
  const preparation = vehicle.salesPreparation || {};
  const readOnly = !salesPreparationEditRoleAllowed();
  const lock = readOnly ? ' disabled aria-disabled="true" title="Read-only for your role"' : '';
  return SALES_PREPARATION_FIELDS.map(def => `<label class="sales-prep-check${readOnly ? ' is-read-only' : ''}"><input type="checkbox" data-sales-prep-vehicle="${escapeHtml(String(vehicle.__emailVehicleId || ''))}" data-sales-prep-field="${escapeHtml(def.field)}" ${preparation[def.key] === true ? 'checked' : ''}${lock} /><span>${escapeHtml(def.label)}</span></label>`).join('');
}

function salesDashboardVehicleHtml(vehicle = {}) {
  const status = salesBookingStatus(vehicle);
  const stock = displayStockNumber(vehicle) || 'No stock';
  const rep = dashboardSalespersonCode(vehicle) || 'Unassigned';
  const eta = scotEtaOnly(vehicle.etaAtDealer) || 'No ETA';
  return `<article class="sales-dashboard-card" data-sales-vehicle="${escapeHtml(String(vehicle.__emailVehicleId || ''))}">
    <div class="sales-dashboard-identity">
      <span class="sales-dashboard-code">${escapeHtml(rep)}</span>
      <div><strong>${escapeHtml(stock)}</strong><span>${escapeHtml(vehicle.client || 'Dealer order')} · ${escapeHtml(displayVehicle(vehicle) || 'Vehicle')}</span></div>
      <div class="sales-dashboard-eta"><b>ETA</b><span>${escapeHtml(eta)}</span></div>
    </div>
    <div class="sales-dashboard-work">${incomingWorkChecklistHtml(vehicle, { stationTransfer: false })}</div>
    <div class="sales-booking-status is-${escapeHtml(status.tone)}"><strong>${escapeHtml(status.label)}</strong><span>${escapeHtml(status.detail)}</span></div>
    <fieldset class="sales-preparation-controls"><legend>Sales preparation</legend>${salesPreparationControlsHtml(vehicle)}</fieldset>
  </article>`;
}

async function updateSalesPreparationControl(input) {
  const vehicleId = String(input.dataset.salesPrepVehicle || '');
  const field = String(input.dataset.salesPrepField || '');
  const vehicle = vehicleLocationsScreenRows().find(row => String(row.__emailVehicleId || '') === vehicleId);
  if (!salesPreparationEditRoleAllowed()) {
    input.checked = !input.checked;
    input.disabled = true; // r426: read-only role; the server refuses too, so nothing is sent.
    return;
  }
  const service = app.emailVehicleLocationService || initEmailVehicleLocationsIfAvailable();
  if (!vehicle || !service?.updateSalesPreparation) {
    input.checked = !input.checked;
    pdcNotify('The shared salesperson preparation record is unavailable. Refresh and try again.');
    return;
  }
  input.disabled = true;
  const result = await service.updateSalesPreparation(vehicleId, Number(vehicle.__emailVehicleVersion || 0), field, input.checked);
  if (!result?.ok) {
    input.checked = !input.checked;
    await refreshEmailVehicleLocations();
    renderIncomingDashboardBoard();
    pdcNotify(result?.code === 'version_conflict' ? 'This vehicle changed elsewhere. The latest shared record has been loaded; please try again.' : 'The preparation update was not saved.');
    return;
  }
  await refreshEmailVehicleLocations();
  renderIncomingDashboardBoard();
}

function renderSalesDashboardBoard() {
  const host = $('#incoming-main-board');
  if (!host) return;
  const allRows = vehicleLocationsScreenRows().filter(vehicle => vehicle.__emailVehicleServerAuthoritative === true);
  const filters = incomingDashboardFilterValues();
  const selectedCode = dashboardViewSalesCode();
  const rows = allRows.filter(vehicle => (!selectedCode || dashboardSalespersonCode(vehicle) === selectedCode) && incomingVehicleMatchesFilters(vehicle, filters));
  const summary = $('#incoming-filter-summary');
  if (summary) summary.textContent = `${rows.length} of ${allRows.length} shared sales vehicles shown${selectedCode ? ` · ${selectedCode}` : ''}`;
  const selectionBar = $('#incoming-selection-bar');
  if (selectionBar) selectionBar.classList.remove('active');
  host.innerHTML = `<section class="sales-dashboard-intro"><div><strong>${selectedCode ? `${escapeHtml(selectedCode)} sales vehicles` : 'All Sales Vehicles'}</strong><span>PMB scheduling and work progress are live and read-only. Sales preparation checks save to the same shared vehicle record.</span></div><span class="badge neutral">${rows.length} vehicle${rows.length === 1 ? '' : 's'}</span></section><div class="sales-dashboard-list">${rows.map(salesDashboardVehicleHtml).join('') || '<div class="empty-state"><strong>No vehicles match this view</strong><span>Choose another salesperson or clear the search filters.</span></div>'}</div>`;
  if (salesPreparationEditRoleAllowed()) $$('[data-sales-prep-field]', host).forEach(input => input.addEventListener('change', () => { void updateSalesPreparationControl(input); }));
}

function incomingSortHeadingHtml(label, key, sort = {}) {
  const active = sort.key === key;
  const direction = active && sort.direction === 'asc' ? 'desc' : 'asc';
  const next = key === 'age'
    ? direction === 'asc' ? 'oldest age / earliest ETA first' : 'newest age / latest ETA first'
    : direction === 'asc' ? 'ascending' : 'descending';
  return `<button type="button" class="incoming-sort-heading${active ? ' is-active' : ''}" data-incoming-sort="${escapeHtml(key)}" aria-label="${escapeHtml(`Sort ${label}: ${next}`)}" title="${escapeHtml(`Sort ${label}: ${next}. Missing values stay last.`)}">${escapeHtml(label)} <span aria-hidden="true">${active ? sort.direction === 'asc' ? '↑' : '↓' : '↕'}</span></button>`;
}

function incomingCompareVehicles(a, b, sort = {}, bucket = '') {
  const text = value => {
    const result = String(value ?? '').trim();
    return !result || /^[—–-]$/.test(result) ? null : result;
  };
  const value = vehicle => {
    switch (sort.key) {
      case 'key': return text(vehicleKeyNumber(vehicle));
      case 'stock': return text(displayStockNumber(vehicle));
      case 'jobcard': return text(vehicleJobcardNumber(vehicle));
      case 'customer': return text(vehicleCustomerName(vehicle));
      case 'vehicle': return text(displayVehicle(vehicle));
      case 'age': return (bucket === 'pmb' || bucket === 'newpmb' || bucket === 'qc'
        ? parseIsoTimestamp(pmbArrivalAgeTimestamp(vehicle))
        : parseDateAU(bucket === 'yardhold' ? incomingKewdaleAgeValue(vehicle) : navisionEtaForVehicle(vehicle)))?.getTime() ?? null;
      default: return parseDateAU(navisionEtaForVehicle(vehicle))?.getTime() ?? null;
    }
  };
  const left = value(a), right = value(b);
  if (left === null && right !== null) return 1;
  if (right === null && left !== null) return -1;
  const compare = (l, r) => String(l ?? '').localeCompare(String(r ?? ''), undefined, { numeric: true, sensitivity: 'base' });
  const difference = left === null ? 0 : typeof left === 'number' ? left - right : compare(left, right);
  return difference ? difference * (sort.direction === 'desc' ? -1 : 1)
    : compare(displayStockNumber(a), displayStockNumber(b));
}

function renderIncomingDashboardBoard() {
  // Direct search, filter and live-refresh callbacks bypass renderActiveView.
  // Keep their parsed local values within this synchronous render only.
  const previousRenderJsonCache = activeRenderJsonCache;
  activeRenderJsonCache = previousRenderJsonCache || new Map();
  try {
    return renderIncomingDashboardBoardContent();
  } finally {
    activeRenderJsonCache = previousRenderJsonCache;
  }
}

function renderIncomingDashboardBoardContent() {
  const host = $('#incoming-main-board');
  if (!host) return;
  if (typeof ensurePmbArrivalAck === 'function') ensurePmbArrivalAck();
  if (typeof ensureNewToPmbWindow === 'function') ensureNewToPmbWindow();
  if (typeof ensurePmbKeyAssigned === 'function') ensurePmbKeyAssigned();
  if (typeof ensurePmbArrivalAge === 'function') ensurePmbArrivalAge();
  const disclosureState = app.vehicleLocationsRefreshDisclosure || captureIncomingBoardDisclosureState(host);
  const workshopProjectionAvailable = ensureDashboardWorkshopProjectionReady();
  const workshopPlans = workshopProjectionAvailable && typeof workshopLoadPlans === 'function' ? workshopLoadPlans() : null;
  const rows = vehicleLocationsScreenRows();
  if (!sharedNavisionLocationAuthorityReady() && app.vehicleLocationsRefreshState !== 'refreshing') app.selectedRows.clear();
  else [...app.selectedRows].forEach(key => {
    if (app.sharedNavisionLocationReadOnlyKeys?.has(key)) app.selectedRows.delete(key);
  });
  updateIncomingDashboardFilterOptions(rows);
  const filters = incomingDashboardFilterValues();
  updateIncomingMoreFiltersState(filters);
  const sort = app.incomingDashboardSort || {};
  const filteredRows = rows.filter(vehicle => incomingVehicleMatchesFilters(vehicle, filters));
  pruneIncomingDepartmentSelection(filteredRows);
  const rowsByBucket = new Map();
  filteredRows.forEach(vehicle => {
    const keys = typeof vehicleLocationsDisplayBuckets === 'function'
      ? vehicleLocationsDisplayBuckets(vehicle)
      : [typeof vehicleLocationsDisplayBucket === 'function' ? vehicleLocationsDisplayBucket(vehicle) : incomingBucketForVehicle(vehicle)];
    keys.forEach(key => {
      const bucket = rowsByBucket.get(key) || [];
      bucket.push(vehicle);
      rowsByBucket.set(key, bucket);
    });
  });
  const summary = $('#incoming-filter-summary');
  // An authenticated board with no rows yet is still loading. Do not present
  // that wait as an empty fleet. A successful or failed refresh may still say 0.
  const locationsStillLoading = rows.length === 0
    && app.vehicleLocationsRefreshState !== 'success'
    && app.vehicleLocationsRefreshState !== 'error'
    && (app.vehicleLocationsRefreshState === 'refreshing'
      || app.sharedNavisionVisibleState === 'loading'
      || (Boolean(window.PDC_AUTH_CONTEXT) && (app.sharedNavisionVisibleState === 'idle' || app.sharedNavisionVisibleState == null)));
  if (summary) {
    const workCount = Array.isArray(filters.work) ? filters.work.length : (filters.work ? 1 : 0);
    const active = [filters.department && `Department ${filters.department}`, filters.search && `search “${filters.search}”`, filters.status, filters.bucket && incomingBucketLabel(filters.bucket), filters.rep, workCount && `${workCount} work type${workCount === 1 ? '' : 's'}`].filter(Boolean);
    summary.textContent = locationsStillLoading
      ? 'Loading vehicles…'
      : `${filteredRows.length} of ${rows.length} vehicles shown${active.length ? ` · ${active.join(' · ')}` : ''}`;
  }
  const defs = VEHICLE_LOCATION_BUCKET_DEFS;
  const priorityRows = incomingDepartmentPriorityRows(filters);
  const priorityHtml = filters.bucket ? '' : `<section class="incoming-priority-stoppages" aria-label="Parts and PMB STOPPAGES">
    <div class="incoming-priority-stoppages-head"><strong>STOPPAGES / Fix First</strong><span>${priorityRows.length} active</span></div>
    <details class="fix-first-list incoming-priority-list"><summary>Show STOPPAGES</summary><div class="fix-first-list-body">${fixFirstRowsHtml(priorityRows)}</div></details>
  </section>`;
  const ageReport = typeof pmbArrivalAgeReportHtml === 'function' ? pmbArrivalAgeReportHtml(rows) : '';
  host.innerHTML = sharedNavisionLocationsStatusHtml() + workStatusLegendHtml() + ageReport + priorityHtml + defs.map(def => {
    if (filters.bucket && filters.bucket !== def.key) return '';
    const vehicles = (rowsByBucket.get(def.key) || [])
      .sort((a, b) => incomingCompareVehicles(a, b, sort, def.key));
    const newCount = def.key === 'newpmb' ? vehicles.filter(vehicle => pmbKeyIsNew(vehicle)).length : vehicles.length;
    const holdCount = def.key === 'newpmb' ? vehicles.filter(vehicle => pmbBodybuilderHoldOpen(vehicle)).length : 0;
    const shown = vehicles.map(vehicle => incomingVehicleDetailRow(vehicle, def.key, { workshopPlans, workshopProjectionAvailable, subletNavigation: true })).join('') || `<div class="pmb-empty-drop">${locationsStillLoading ? 'Loading vehicles…' : 'No vehicles match the current filters'}</div>`;
    const identityHeader = vehicles.length
      ? def.key === 'rft' || def.key === 'wpc'
        ? vehicleLocationsRftHeaderHtml(sort)
        : productionGridHeaderHtml('incoming-production-grid-header', { actionLabel: 'Booking', incomingSort: sort })
      : '';
    const alerting = def.key === 'newpmb' && holdCount > 0;
    const hint = def.key === 'newpmb'
      ? `Key number under ${newToPmbWindowLabel()} · also in PMB${holdCount ? ` · ${holdCount} waiting for To PMB` : ''}`
      : def.hint;
    const countLabel = def.key === 'newpmb' ? newCount : vehicles.length;
    return `<details class="incoming-bucket incoming-${escapeHtml(def.key)}${alerting ? ' is-alerting' : ''}" ${def.open ? 'open' : ''}>
      <summary class="incoming-bucket-title">
        <span>${escapeHtml(def.label)}</span><strong>${locationsStillLoading ? '…' : countLabel}</strong><small>${escapeHtml(hint)}</small>
      </summary>
      <div class="incoming-bucket-list incoming-vertical-list">${identityHeader}${shown}</div>
    </details>`;
  }).join('');
  $$('[data-incoming-sort]', host).forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    const key = button.dataset.incomingSort;
    app.incomingDashboardSort = { key, direction: sort.key === key && sort.direction === 'asc' ? 'desc' : 'asc' };
    const bucketClass = [...(button.closest('.incoming-bucket')?.classList || [])].find(name => name.startsWith('incoming-') && name !== 'incoming-bucket');
    renderIncomingDashboardBoard();
    const bucket = bucketClass ? [...host.querySelectorAll('.incoming-bucket')].find(row => row.classList.contains(bucketClass)) : host;
    [...(bucket?.querySelectorAll('[data-incoming-sort]') || [])].find(control => control.dataset.incomingSort === key)?.focus({ preventScroll: true });
  }));
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    void openVehicleFromStockClick(button.dataset.openStock, button);
  }));
  bindIncomingSubletLinks(host);
  bindVehicleLabelButtons(host);
  $$('[data-incoming-delete]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    deleteIncomingVehicleFromMain(button.dataset.incomingDelete);
  }));
  $$('[data-yh-transfer-pmb]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    transferYhVehicleToPmb(button.dataset.yhTransferPmb);
  }));
  $$('[data-pmb-ack]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    acknowledgePmbArrival(button.dataset.pmbAck, button.dataset.pmbAckStation);
  }));
  $$('[data-pmb-push]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    pushNewToPmb(button.dataset.pmbPush);
  }));
  $$('[data-pit-transfer]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    moveVehiclePitLocation(button.dataset.pitTransfer, 'to_pit');
  }));
  $$('[data-pit-return-pmb]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    moveVehiclePitLocation(button.dataset.pitReturnPmb, 'to_pmb');
  }));
  $$('[data-ready-for-qc]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    markVehicleReadyForQualityControl(button.dataset.readyForQc);
  }));
  $$('[data-open-qc-vehicle]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    qcSelectedVehicleKey = button.dataset.openQcVehicle || '';
    showView('qc');
    renderQualityControlPage();
  }));
  $$('[data-pmb-bay-provider-key]', host).forEach(select => {
    select.addEventListener('click', event => event.stopPropagation());
    select.addEventListener('change', () => updatePmbBaySubletProvider(select.dataset.pmbBayProviderKey, select.dataset.pmbBayProviderStage, select.value));
  });
  $$('[data-auth-operation-work]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    openAuthenticatedOperationWorkshop(button.dataset.authOperationWork);
  }));
  bindAuthenticatedOperationSummaries(host);
  bindFixFirstRows(host);
  bindRftCollectedInputs(host);
  bindIncomingCardSelection(host);
  revealSingleVehicleSearchResult(host, filteredRows, filters.search, 'incoming');
  updateInlineSelectionBars(filteredRows);
  restoreIncomingBoardDisclosureState(host, disclosureState);
  updateCollapseToggleButtons();
  if (app.vehicleLocationsRefreshState !== 'refreshing') app.vehicleLocationsRefreshDisclosure = null;
  ensureOperationalRefreshControls();
}

function openSubletForStock(stock = '') {
  const query = cleanNavisionText(stock);
  const search = $('#sublet-search');
  if (!query || !search) return false;
  const matchingRows = subletRows().filter(vehicle => cleanNavisionText(displayStockNumber(vehicle)) === query);
  app.subletViewMode = 'list';
  app.subletOperationalFilter = ['to-book', 'booked', 'returned'].find(filter => matchingRows.some(vehicle => subletMatchesOperationalFilter(vehicle, filter))) || 'to-book';
  const provider = $('#sublet-provider-filter');
  if (provider) provider.value = 'all';
  search.value = query;
  showView('sublet');
  search.focus();
  search.select();
  return true;
}

function bindIncomingSubletLinks(host = document) {
  $$('[data-open-sublet-stock]', host).forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    openSubletForStock(button.dataset.openSubletStock);
  }));
}

function bindIncomingCardSelection(host = document) {
  $$('[data-select-stock]', host).forEach(input => input.addEventListener('click', event => event.stopPropagation()));
  $$('[data-select-stock]', host).forEach(input => input.addEventListener('change', event => {
    const key = input.dataset.selectStock;
    if (!key) return;
    if (input.checked) app.selectedRows.add(key);
    else app.selectedRows.delete(key);
    const card = input.closest('.incoming-vehicle-card');
    if (card) card.classList.toggle('is-selected', input.checked);
    updateInlineSelectionBars();
    updateBulkSelectionPanel();
  }));
}

function updateInlineSelectionBars(visibleRows = []) {
  const validKeys = new Set(app.data.map(vehicleKey));
  [...app.selectedRows].forEach(key => { if (!validKeys.has(key)) app.selectedRows.delete(key); });
  const selected = selectedVehiclesForBulkEmail();
  const count = selected.length;
  const incomingPmbReadyCount = selected.filter(canTransferVehicleToPmb).length;
  const pmbCount = selected.filter(vehicle => statusCategory(vehicle) === 'pmb').length;
  const gateIssueRows = vehiclesWithRftGateIssues(selected);
  ['incoming-selection-bar', 'workflow-selection-bar'].forEach(id => {
    const bar = $(`#${id}`);
    if (bar) bar.classList.toggle('active', count > 0);
  });
  const incomingCount = $('#incoming-selection-count');
  if (incomingCount) incomingCount.textContent = `${count} selected`;
  const workflowCount = $('#workflow-selection-count');
  if (workflowCount) workflowCount.textContent = `${count} selected`;
  ['incoming-email-selected-update', 'workflow-email-selected-update'].forEach(id => {
    const button = $(`#${id}`);
    if (!button) return;
    button.disabled = count !== 1;
    button.title = count === 1 ? 'Email the selected vehicle update to its salesperson' : 'Select exactly one vehicle to email an update';
  });
  const incomingTransfer = $('#incoming-transfer-selected-pmb');
  if (incomingTransfer) {
    const sharedUnavailable = sharedVehicleLocationMutationUnavailable('bulk transfer to PMB', null, { silent: true });
    incomingTransfer.disabled = sharedUnavailable || !(count > 0 && incomingPmbReadyCount === count);
    incomingTransfer.title = sharedUnavailable ? 'Unavailable: shared vehicle locations require an audited server action' : !count ? 'Select one or more Yard Hold or In Transit vehicles first' : incomingPmbReadyCount === count ? `Transfer ${count} selected Yard Hold/In Transit vehicle${count === 1 ? '' : 's'} to PMB` : 'Only Yard Hold or In Transit vehicles can be transferred to PMB';
  }
  const workflowTransfer = $('#workflow-transfer-selected-rft');
  if (workflowTransfer) {
    workflowTransfer.disabled = !(count > 0 && pmbCount === count && gateIssueRows.length === 0);
    workflowTransfer.title = !count ? 'Select one or more PMB vehicles first' : pmbCount !== count ? 'Only PMB vehicles can transfer to RFT' : gateIssueRows.length ? 'RFT locked: all required boxes must be signed off first' : `Transfer ${count} selected PMB vehicle${count === 1 ? '' : 's'} to RFT`;
  }
  ['incoming-delete-selected', 'workflow-delete-selected', 'incoming-clear-selected', 'workflow-clear-selected'].forEach(id => {
    const button = $(`#${id}`);
    if (button) button.disabled = count === 0;
  });
}

async function transferSelectedMainYhVehiclesToPmb() {
  if (sharedVehicleLocationMutationUnavailable('bulk transfer to PMB')) return false;
  const selected = selectedVehiclesForBulkEmail();
  if (!selected.length) return;
  const notYh = selected.filter(vehicle => !canTransferVehicleToPmb(vehicle));
  if (notYh.length) {
    pdcNotify('Only Yard Hold or In Transit vehicles can be transferred to PMB from the main screen. Untick any PMB, RFT, completed or overseas rows first.');
    return;
  }
  await transferSelectedYhVehiclesToPmb();
  updateInlineSelectionBars();
}

function deleteIncomingVehicleFromMain(key = '') {
  const vehicle = app.data.find(row => vehicleKey(row) === key || row.stock === key || row.id === key);
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'delete')) return;
  const label = `${vehicleIdentityTitle(vehicle) || 'No stock'} - ${vehicleCustomerName(vehicle) || 'Unknown customer'}`;
  if (!window.confirm(`Delete this vehicle from the main screen?\n\n${label}\n\nThis hides it from this browser's tracker and keeps the delete in local storage.`)) return;
  removeVehiclesFromTracker([vehicle]);
  refreshAfterVehicleRemoval();
}

function updateDashboardNavisionPasteButtons() {
  const hasText = Boolean(($('#dashboard-navision-paste')?.value || '').trim());
  const importButton = $('#dashboard-import-navision');
  const clearButton = $('#dashboard-clear-navision');
  if (importButton) importButton.disabled = !hasText;
  if (clearButton) clearButton.disabled = !hasText;
}

function clearDashboardNavisionPaste() {
  const input = $('#dashboard-navision-paste');
  if (input) input.value = '';
  updateDashboardNavisionPasteButtons();
}

function importDashboardNavisionPaste() {
  const source = $('#dashboard-navision-paste');
  const text = source?.value || '';
  if (!text.trim()) return;
  const target = $('#navision-paste');
  if (target) target.value = text;

  showView('import');
  updateNavisionImportButton();
  importNavisionVehicles();
}

function updateDashboardPdImportButtons() {
  const hasText = Boolean(($('#dashboard-pd-paste')?.value || '').trim());
  const hasFiles = Boolean(app.dashboardPdFiles && app.dashboardPdFiles.length);
  const importButton = $('#dashboard-import-pd');
  const clearButton = $('#dashboard-clear-pd');
  if (importButton) importButton.disabled = !(hasText || hasFiles);
  if (clearButton) clearButton.disabled = !(hasText || hasFiles);
}

function setDashboardPdStatus(results = []) {
  const host = $('#dashboard-pd-status');
  if (!host) return;
  host.innerHTML = results.map(result => `<div class="po-status-row ${result.ok ? 'ok' : 'warn'}"><strong>${escapeHtml(result.title || 'PD import')}</strong><span>${escapeHtml(result.message || '')}</span></div>`).join('');
}

function clearDashboardPdImport() {
  app.dashboardPdFiles = [];
  const upload = $('#dashboard-pd-upload');
  const paste = $('#dashboard-pd-paste');
  if (upload) upload.value = '';
  if (paste) paste.value = '';
  setDashboardPdStatus([]);
  updateDashboardPdImportButtons();
}

function handleDashboardPdFileSelect(event) {
  app.dashboardPdFiles = [...(event.target.files || [])];
  setDashboardPdStatus(app.dashboardPdFiles.length ? [{ ok: true, title: `${app.dashboardPdFiles.length} PD file${app.dashboardPdFiles.length === 1 ? '' : 's'} ready`, message: 'Click Review PD Document to check the vehicle and detected work before importing.' }] : []);
  updateDashboardPdImportButtons();
}

function bindDashboardPdDropZone() {
  const zone = $('#dashboard-pd-drop');
  if (!zone) return;
  ['dragenter', 'dragover'].forEach(type => zone.addEventListener(type, event => {
    event.preventDefault();
    zone.classList.add('is-dragover');
  }));
  ['dragleave', 'drop'].forEach(type => zone.addEventListener(type, event => {
    event.preventDefault();
    zone.classList.remove('is-dragover');
  }));
  zone.addEventListener('drop', event => {
    app.dashboardPdFiles = [...(event.dataTransfer?.files || [])];
    setDashboardPdStatus(app.dashboardPdFiles.length ? [{ ok: true, title: `${app.dashboardPdFiles.length} PD file${app.dashboardPdFiles.length === 1 ? '' : 's'} ready`, message: 'Click Review PD Document to check the vehicle and detected work before importing.' }] : []);
    updateDashboardPdImportButtons();
  });
}

function parsePdCheckFormText(text = '', filenames = []) {
  const source = `${String(text || '')}\n${(filenames || []).join('\n')}`;
  const squashed = source.replace(/\s+/g, ' ').trim();
  const lines = source.replaceAll(String.fromCharCode(13), '').split(String.fromCharCode(10)).map(line => line.replace(/\s+/g, ' ').trim()).filter(Boolean);
  const stock = (
    squashed.match(/\bstock\s*(?:no\.?|number|#)?\s*[:#-]?\s*(\d{6,10})\b/i) ||
    []
  )[1] || '';
  const vin = (squashed.match(/\b[A-HJ-NPR-Z0-9]{17}\b/i) || [''])[0].toUpperCase();
  const customerHeading = lines.findIndex(line => /\bCUSTOMER\b/i.test(line) && /\bSALES DETAILS\b/i.test(line));
  const customerAfterHeading = customerHeading >= 0
    ? cleanNavisionText((lines[customerHeading + 1] || '').split(/\b(?:Fleet|Govt|GST Exempt|Diplomatic|Employee|Sale Date|Customer Promise Date)\b/i)[0])
    : '';
  const customer = (source.match(/^\s*(?:customer|client)\s*[:#-]\s*(.+)$/im) || [])[1] || customerAfterHeading;
  const vehicle = (
    source.match(/^\s*(?:vehicle|model|model description)\s*[:#-]\s*(.+)$/im) ||
    source.match(/\bMake\s*&?\s*Model\s*[:#-]?\s*(.+?)(?=\s+Unit\s+Colou?r\b|\s+Trim\s+Colou?r\b|$)/i) ||
    []
  )[1] || '';
  const salesperson = (
    source.match(/^\s*(?:salesperson|sales person|sales rep|consultant)\s*[:#-]\s*\(([A-Z]{2,6})\).*$/im) ||
    source.match(/^\s*(?:salesperson|sales person|sales rep|consultant)\s*[:#-]\s*([A-Z0-9 -]{1,40})$/im) ||
    source.match(/\(([A-Z]{2,6})\)\s+[A-Z][A-Za-z' -]{2,60}(?=\s+(?:Deal\s*:|$))/i) ||
    []
  )[1] || '';
  const colour = (
    source.match(/^\s*Unit\s+Colou?r\s*[:#-]\s*(.+)$/im) ||
    source.match(/^\s*colou?r\s*[:#-]\s*(.+)$/im) ||
    source.match(/\bUnit\s+Colou?r\s*[:#-]?\s*(.+?)(?=\s+Trim\s+Colou?r\b|\s+Body\s+Type\b|$)/i) ||
    []
  )[1] || '';
  const trim = (source.match(/^\s*trim\s*[:#-]\s*(.+)$/im) || [])[1] || '';
  const explicitProvider = (source.match(/^\s*(?:sublet\s+provider|external\s+provider|supplier)\s*[:#-]\s*(.+)$/im) || [])[1] || '';
  const providerNames = normalizedSubletProviderList([
    ...DEFAULT_SUBLET_PROVIDERS,
    ...(typeof loadSubletProviders === 'function' ? loadSubletProviders() : []),
  ]);
  const compactSource = cleanNavisionText(source).toLowerCase().replace(/[^a-z0-9]+/g, '');
  const knownProvider = [...providerNames]
    .sort((a, b) => cleanNavisionText(b).length - cleanNavisionText(a).length)
    .find(name => {
      const escaped = String(name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
      if (new RegExp(`(^|[^A-Z0-9])${escaped}([^A-Z0-9]|$)`, 'i').test(source)) return true;
      const compactName = String(name).toLowerCase().replace(/[^a-z0-9]+/g, '');
      return compactName.length > 3 && compactSource.includes(compactName);
    }) || '';
  const subletProvider = cleanNavisionText(explicitProvider || knownProvider);
  const itemPatterns = [
    ['Bull bar', /bull\s*bar|bullbar/i],
    ['Light bar', /light\s*bar|lightbar|spot\s*light|spotlight/i],
    ['Tray body', /tray\s*body|steel\s*tray|alloy\s*tray|\btray\b/i],
    ['Seat covers', /seat\s*covers?/i],
    ['Tow bar', /tow\s*bar|towbar/i],
    ['Rear rack', /rear\s*rack/i],
    ['Long range tank', /long\s*range\s*(?:fuel\s*)?tank/i],
    ['Ladder rack', /ladder\s*rack/i],
    ['Roof rack', /roof\s*rack/i],
    ['Window tint', /window\s*tint|\btint\b/i],
    ['UHF / radio', /\buhf\b|radio|antenna/i],
    ['Dual battery / 12V', /dual\s*battery|\b12v\b|dcdc|dc\s*dc|redarc|anderson/i],
    ['Canopy', /canopy/i],
    ['Tyre / wheel upgrade', /tyre|tire|wheel\s*upgrade|sunraysia|ko2|ko3/i],
    ['GVM upgrade', /\bgvm\b/i],
    ['Winch', /winch/i],
  ];
  const tasks = itemPatterns.filter(([, pattern]) => pattern.test(squashed)).map(([label]) => label);
  if (subletProvider) tasks.push(`Sublet: ${subletProvider}`);
  return {
    stock,
    vin,
    customer: cleanNavisionText(customer),
    vehicle: cleanNavisionText(vehicle),
    salesperson: cleanNavisionText(salesperson),
    colour: cleanNavisionText(colour),
    trim: cleanNavisionText(trim),
    subletProvider,
    tasks: [...new Set(tasks)],
    filenames,
  };
}

function bindVehicleLabelButtons(host = document) {
  $$('[data-label-vehicle]', host).forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    void printZplForVehicleKey(button.dataset.labelVehicle || '');
  }));
}

function findVehicleForPd(parsed = {}) {
  const stock = String(parsed.stock || '').trim();
  const vin = String(parsed.vin || '').trim().toLowerCase();
  return app.data.find(vehicle =>
    (stock && String(vehicle.stock || '') === stock) ||
    (vin && [vehicle.vin, vehicle.autocareVin].some(value => String(value || '').toLowerCase() === vin))
  ) || null;
}

function ensureVehicleForPd(parsed = {}) {
  const found = findVehicleForPd(parsed);
  if (found) return promoteVehicleToPdcSheet(found, 'PD check-form upload');
  const stock = parsed.stock || `PD-${Date.now().toString().slice(-6)}`;
  const vehicle = {
    id: `pd-${stock}`,
    sourceRow: '',
    stock,
    client: 'Customer from PD check-form',
    internalStatus: '',
    deliveryDate: '',
    vehicle: '',
    financeNote: '',
    group: 'PD check-form upload',
    source: 'PD check-form',
    recordLifecycle: 'pd-check-form',
    pdcSheetVisible: true,
    pdcVisibilitySource: 'PD check-form upload',
    pdcPromotedAt: nowIsoString(),
    toyotaCustomer: '',
    contact: '',
    toyotaVehicle: '',
    suffix: '',
    colour: '',
    trim: '',
    origMth: '',
    prodMth: '',
    compPlate: '',
    arrivalPort: '',
    toyotaStatus: '',
    etaAtDealer: '',
    epodReceipt: '',
    jitQty: '',
    consultant: '',
    poTasks: [],
    poFiles: [],
  };
  const added = loadAddedVehicles();
  added.unshift(vehicle);
  saveAddedVehicles(added);
  app.data.unshift(vehicle);
  return vehicle;
}

function pdFlagsFromTasks(tasks = []) {
  const text = tasks.join(' ').toLowerCase();
  return {
    buildPoRaised: Boolean(tasks.length),
    pdcRequiresBus4x4: /\bbus\s*4x4\b|\b4x4\s*bus\b|\bdepartment\s*138\b/.test(text),
    pdcRequiresTint: /tint/.test(text),
    pdcRequiresHoist: /hoist|suspension|gvm|lift|tow/.test(text),
    pdcRequiresFitting: /\bfit\b|fitment|fitting|pdi|pre.?delivery|accessor|bull ?bar|tow ?bar|canopy|tray/.test(text),
    pdcRequiresFabrication: /tray|bull ?bar|bar work|rack|tank|canopy|winch|gvm|fabricat/.test(text),
    pdcRequiresElectrical: /light|uhf|radio|12v|battery|redarc|anderson|electrical|auto.?elec|camera|power outlet|usb/.test(text),
    pdcRequiresTyre: /tyre|tire|wheel/.test(text),
    pdcRequiresSublet: /\bsublet\b|external provider|outside contractor/.test(text),
  };
}

const WORK_IMPORT_DETECTION_DEFS = [
  { label: 'Tint', pattern: /\btint(?:ing)?\b|window tint/i },
  { label: 'Tray', pattern: /\btray\b|tray body|steel tray|alloy tray|aluminium tray/i },
  { label: 'Bull bar', pattern: /bull\s*bar|bullbar/i },
  { label: 'Tow bar', pattern: /tow\s*bar|towbar/i },
  { label: 'Canopy', pattern: /\bcanopy\b/i },
  { label: 'Rack', pattern: /\b(?:roof|rear|ladder)\s*rack\b/i },
  { label: 'Suspension / GVM', pattern: /\bgvm\b|suspension|lift kit|spring/i },
  { label: 'Electrical / 12V', pattern: /electrical|auto.?elec|\b12v\b|dual battery|dcdc|dc\s*dc|redarc|anderson|light bar|spotlight|\buhf\b|radio|camera|usb/i },
  { label: 'Tyres / wheels', pattern: /tyre|tire|wheel|alignment/i },
  { label: 'Winch', pattern: /\bwinch\b/i },
  { label: 'Fuel tank', pattern: /long range.*tank|fuel tank/i },
  { label: 'Sublet', pattern: /\bsublet\b|external provider|outside contractor/i },
  { label: 'Pit inspection', pattern: /pit inspection|quality control|final inspection/i },
];

function detectedWorkLabelsFromTasks(tasks = []) {
  const text = (Array.isArray(tasks) ? tasks : []).map(cleanNavisionText).filter(Boolean).join(' ');
  return WORK_IMPORT_DETECTION_DEFS.filter(def => def.pattern.test(text)).map(def => def.label);
}

function workImportRequirementUpdates(parsed = {}, vehicle = {}, tasks = []) {
  const explicit = parsed.reviewRequirementUpdates;
  if (!explicit || typeof explicit !== 'object') return pdFlagsFromTasks(tasks);
  const preview = { ...vehicle };
  if (parsed.stock) preview.stock = parsed.stock;
  if (parsed.reference && !preview.batch) preview.batch = parsed.reference;
  const updates = {};
  PDC_JOB_DEFS.forEach(def => {
    const completed = pdcJobComplete(vehicle, def);
    const standardPartsGate = def.key === 'parts' && vehicleHasBatchNumber(preview);
    updates[def.requireKey] = completed || standardPartsGate || explicit[def.requireKey] === true;
  });
  return updates;
}

function workImportVehicleUpdates(parsed = {}) {
  const reviewed = parsed.reviewVehicleUpdates;
  if (!reviewed || typeof reviewed !== 'object') return {};
  const updates = {
    client: cleanNavisionText(reviewed.client),
    vehicle: cleanNavisionText(reviewed.vehicle),
    consultant: cleanNavisionText(reviewed.consultant),
    vin: normalizeVin(reviewed.vin),
    colour: cleanNavisionText(reviewed.colour),
    trim: cleanNavisionText(reviewed.trim),
    pmbSubletProvider: cleanNavisionText(reviewed.pmbSubletProvider),
  };
  updates.toyotaVehicle = updates.vehicle;
  return updates;
}

function workImportReviewPreviewVehicle(kind = 'jobcard', parsed = {}, existing = null) {
  if (existing) return existing;
  return {
    stock: parsed.stock || parsed.reference || '',
    batch: parsed.stock || parsed.reference || '',
    vin: parsed.vin || '',
    client: parsed.client || parsed.customer || 'Customer from PD Document',
    vehicle: parsed.vehicle || '',
    consultant: parsed.salesperson || '',
    colour: parsed.colour || '',
    trim: parsed.trim || '',
    pmbSubletProvider: parsed.subletProvider || '',
    source: 'PD Document',
  };
}

function showWorkImportReviewModal({ kind = 'pd', parsed = {}, filename = '', existing = null } = {}) {
  if (typeof document?.createElement !== 'function') return Promise.resolve(null);
  const sourceLabel = 'PD Document';
  const preview = workImportReviewPreviewVehicle(kind, parsed, existing);
  const detectedLabels = detectedWorkLabelsFromTasks(parsed.tasks || []);
  const detectedFlags = pdFlagsFromTasks(parsed.tasks || []);
  const existingRequired = new Set(PDC_JOB_DEFS.filter(def => pdcJobRequired(preview, def)).map(def => def.requireKey));
  const completedKeys = new Set(PDC_JOB_DEFS.filter(def => pdcJobComplete(preview, def)).map(def => def.requireKey));
  const standardPartsGate = vehicleHasBatchNumber(preview);
  const identity = displayStockNumber(preview) || preview.vin || 'Identity needs review';
  const workChecks = PDC_JOB_DEFS.map(def => {
    const detected = detectedFlags[def.requireKey] === true;
    const completed = completedKeys.has(def.requireKey);
    const required = existingRequired.has(def.requireKey) || completed || (def.key === 'parts' && standardPartsGate);
    const locked = completed || (def.key === 'parts' && standardPartsGate);
    const stateNote = completed ? 'Completed' : def.key === 'parts' && standardPartsGate ? 'Standard stock gate' : detected ? 'Detected in file' : 'Select if required';
    return `<label class="work-import-check ${detected ? 'is-detected' : ''} ${required ? 'is-selected' : ''} ${locked ? 'is-locked' : ''}">
      <input type="checkbox" data-import-work-key="${escapeHtml(def.key)}" data-import-require-key="${escapeHtml(def.requireKey)}" ${required ? 'checked' : ''} ${locked ? 'disabled' : ''} />
      <span><b>${escapeHtml(def.short)}</b><strong>${escapeHtml(def.label)}</strong><small>${escapeHtml(stateNote)}</small></span>
    </label>`;
  }).join('');
  const taskDetails = (parsed.tasks || []).map(task => `<li>${escapeHtml(task)}</li>`).join('');
  return new Promise(resolve => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay work-import-review-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'work-import-review-title');
    overlay.innerHTML = `
      <section class="modal-card work-import-review-card">
        <button class="modal-close" type="button" data-work-import-cancel aria-label="Cancel import">×</button>
        <div class="panel-header work-import-review-heading">
          <div>
            <span class="eyebrow">Review before importing</span>
            <h2 id="work-import-review-title">PD Document vehicle card</h2>
            <p>No changes have been saved yet. Check the vehicle and choose exactly what work is required.</p>
          </div>
          <span class="badge ${existing ? 'neutral' : 'warning'}">${existing ? 'Matched vehicle' : 'New vehicle'}</span>
        </div>
        <form class="work-import-review-form">
          <div class="work-import-vehicle-card">
            <div class="work-import-vehicle-identity"><span>PD Document</span><strong>${escapeHtml(identity)}</strong><small>${escapeHtml(filename || (parsed.filenames || []).join(', ') || sourceLabel)}</small></div>
            <div class="form-row three-col work-import-fields">
              <label><span>Stock number</span><input name="stock" value="${escapeHtml(parsed.stock || preview.stock || '')}" ${existing ? 'readonly' : ''} placeholder="Stock #" /></label>
              <label><span>Salesperson</span><select name="consultant">${salespersonOptionsHtml(parsed.salesperson || consultantName(preview))}</select></label>
              <label><span>Sublet provider</span><select name="pmbSubletProvider">${subletProviderOptionsHtml(parsed.subletProvider || pmbBaySubletProvider(preview))}</select></label>
            </div>
            <div class="form-row two-col work-import-fields">
              <label><span>Customer</span><input name="client" value="${escapeHtml(parsed.customer || parsed.client || preview.client || preview.toyotaCustomer || '')}" required placeholder="Customer name" /></label>
              <label><span>Vehicle</span><input name="vehicle" value="${escapeHtml(parsed.vehicle || preview.vehicle || preview.toyotaVehicle || '')}" required placeholder="Vehicle model / grade" /></label>
            </div>
            <div class="form-row three-col work-import-fields">
              <label><span>VIN</span><input name="vin" value="${escapeHtml(parsed.vin || preview.vin || '')}" maxlength="17" placeholder="VIN if supplied" /></label>
              <label><span>Colour</span><input name="colour" value="${escapeHtml(parsed.colour || preview.colour || '')}" /></label>
              <label><span>Trim</span><input name="trim" value="${escapeHtml(parsed.trim || preview.trim || '')}" /></label>
            </div>
          </div>
          <div class="work-import-detection-card ${detectedLabels.length ? 'has-detections' : 'no-detections'}">
            <div>
              <span class="eyebrow">Detected work</span>
              <strong>${detectedLabels.length ? `We detected: ${escapeHtml(detectedLabels.join(', '))}` : 'No work areas were confidently detected'}</strong>
              <p>${detectedLabels.length ? 'Would you like us to tick the matching work areas automatically? You can still amend every selection below.' : 'Please select the required work areas manually below.'}</p>
            </div>
            ${detectedLabels.length ? `<div class="work-import-detection-actions"><button class="primary" type="button" data-work-import-use-detected>Yes — tick detected work</button><button class="secondary" type="button" data-work-import-manual>No — select manually</button></div>` : ''}
          </div>
          <fieldset class="work-import-requirements">
            <legend>Required work for this vehicle</legend>
            <div class="work-import-check-grid">${workChecks}</div>
          </fieldset>
          ${taskDetails ? `<details class="work-import-task-details"><summary>View ${parsed.tasks.length} detected line item${parsed.tasks.length === 1 ? '' : 's'}</summary><ul>${taskDetails}</ul></details>` : ''}
          <div class="edit-actions work-import-review-actions">
            <button class="primary" type="submit">Confirm and import vehicle</button>
            <button class="secondary" type="button" data-work-import-cancel>Cancel — save nothing</button>
          </div>
        </form>
      </section>`;
    const form = overlay.querySelector('form');
    const syncCheckStyles = () => overlay.querySelectorAll('[data-import-work-key]').forEach(input => input.closest('.work-import-check')?.classList.toggle('is-selected', input.checked));
    const finish = result => {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
      const anotherOpenModal = [...document.querySelectorAll('.modal-overlay')].some(modal => modal.hidden === false);
      if (!anotherOpenModal) document.body.classList.remove('modal-open');
      resolve(result);
    };
    const onKeydown = event => { if (event.key === 'Escape') finish(null); };
    overlay.querySelectorAll('[data-work-import-cancel]').forEach(button => button.addEventListener('click', () => finish(null)));
    overlay.addEventListener('click', event => { if (event.target === overlay) finish(null); });
    overlay.querySelectorAll('[data-import-work-key]').forEach(input => input.addEventListener('change', syncCheckStyles));
    overlay.querySelector('[data-work-import-use-detected]')?.addEventListener('click', () => {
      PDC_JOB_DEFS.forEach(def => {
        if (detectedFlags[def.requireKey] !== true) return;
        const input = overlay.querySelector(`[data-import-work-key="${def.key}"]`);
        if (input && !input.disabled) input.checked = true;
      });
      overlay.querySelector('[data-work-import-use-detected]')?.classList.add('is-active');
      overlay.querySelector('[data-work-import-manual]')?.classList.remove('is-active');
      syncCheckStyles();
    });
    overlay.querySelector('[data-work-import-manual]')?.addEventListener('click', () => {
      PDC_JOB_DEFS.forEach(def => {
        const input = overlay.querySelector(`[data-import-work-key="${def.key}"]`);
        if (input && !input.disabled && detectedFlags[def.requireKey] === true && !existingRequired.has(def.requireKey)) input.checked = false;
      });
      overlay.querySelector('[data-work-import-manual]')?.classList.add('is-active');
      overlay.querySelector('[data-work-import-use-detected]')?.classList.remove('is-active');
      syncCheckStyles();
    });
    form?.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const values = new FormData(form);
      const stock = cleanNavisionText(values.get('stock'));
      const vin = normalizeVin(values.get('vin'));
      if (!stock && !vin) {
        pdcNotify('Enter a stock number or VIN before importing this vehicle.');
        return;
      }
      const requirementUpdates = {};
      PDC_JOB_DEFS.forEach(def => {
        const input = overlay.querySelector(`[data-import-work-key="${def.key}"]`);
        requirementUpdates[def.requireKey] = Boolean(input?.checked || completedKeys.has(def.requireKey) || (def.key === 'parts' && standardPartsGate));
      });
      const reviewVehicleUpdates = {
        client: values.get('client'),
        vehicle: values.get('vehicle'),
        consultant: values.get('consultant'),
        vin,
        colour: values.get('colour'),
        trim: values.get('trim'),
        pmbSubletProvider: values.get('pmbSubletProvider'),
      };
      finish({
        ...parsed,
        stock,
        vin,
        customer: cleanNavisionText(values.get('client')),
        client: cleanNavisionText(values.get('client')),
        vehicle: cleanNavisionText(values.get('vehicle')),
        salesperson: cleanNavisionText(values.get('consultant')),
        colour: cleanNavisionText(values.get('colour')),
        trim: cleanNavisionText(values.get('trim')),
        subletProvider: cleanNavisionText(values.get('pmbSubletProvider')),
        reviewRequirementUpdates: requirementUpdates,
        reviewVehicleUpdates,
      });
    });
    document.addEventListener('keydown', onKeydown);
    document.body.appendChild(overlay);
    document.body.classList.add('modal-open');
    syncCheckStyles();
    const firstControl = overlay.querySelector('[data-work-import-use-detected]') || overlay.querySelector('input');
    firstControl?.focus();
  });
}

function updateIncomingMoreFiltersState(filters = incomingDashboardFilterValues()) {
  const workCount = Array.isArray(filters.work) ? filters.work.length : (filters.work ? 1 : 0);
  const activeCount = (filters.rep ? 1 : 0) + (filters.department ? 1 : 0) + workCount;
  const details = $('#incoming-more-filters');
  const label = details ? $('[data-incoming-more-filter-label]', details) : null;
  if (label) label.textContent = activeCount ? `More filters (${activeCount} active)` : 'More filters';
  details?.classList.toggle('has-active-filters', activeCount > 0);
}

function applyPdCheckFormImport(parsed = {}) {
  return runStorageTransaction('PD Document import', trackerTransactionKeys(), () => applyPdCheckFormImportUnsafe(parsed));
}

function applyPdCheckFormImportUnsafe(parsed = {}) {
  const vehicle = ensureVehicleForPd(parsed);
  const key = vehicleKey(vehicle);
  const taskStore = loadPoTasks();
  const fileStore = loadPoFiles();
  const currentTasks = taskStore[key] || taskStore[vehicle.stock] || vehicle.poTasks || [];
  const importedTasks = (parsed.tasks || []).map(task => `PD check-form: ${task}`);
  const combinedTasks = [...new Set(currentTasks.concat(importedTasks))];
  taskStore[key] = combinedTasks;
  const currentFiles = fileStore[key] || fileStore[vehicle.stock] || vehicle.poFiles || [];
  const combinedFiles = [...new Set(currentFiles.concat(parsed.filenames || []))];
  fileStore[key] = combinedFiles;
  savePoTasks(taskStore);
  savePoFiles(fileStore);
  const updates = {
    ...workImportRequirementUpdates(parsed, vehicle, combinedTasks),
    ...workImportVehicleUpdates(parsed),
  };
  updates.buildPoRaised = Boolean(combinedTasks.length);
  saveVehicleEdits(key, updates);
  return { vehicle, taskCount: importedTasks.length, totalTasks: combinedTasks.length };
}

async function importDashboardPdWork() {
  const files = app.dashboardPdFiles || [];
  const pastedText = ($('#dashboard-pd-paste')?.value || '').trim();
  const results = [];
  const texts = [];
  for (const file of files) {
    try {
      const isPdf = /\.pdf$/i.test(file.name) || file.type === 'application/pdf';
      const text = isPdf ? await extractTextFromPdfFile(file) : await file.text();
      texts.push({ text, filenames: [file.name] });
    } catch (error) {
      results.push({ ok: false, title: file.name, message: error.message || String(error) });
    }
  }
  if (pastedText) texts.push({ text: pastedText, filenames: ['pasted PD text'] });
  for (const item of texts) {
    const parsed = parsePdCheckFormText(item.text, item.filenames);
    try {
      const reviewed = await showWorkImportReviewModal({
        kind: 'pd',
        parsed,
        filename: item.filenames.join(', '),
        existing: findVehicleForPd(parsed),
      });
      if (!reviewed) {
        results.push({ ok: false, cancelled: true, title: parsed.stock || parsed.vin || item.filenames.join(', '), message: 'Import cancelled. No vehicle data was changed.' });
        continue;
      }
      const sharedActivation = await activateSharedNavisionForApprovedDocumentReview(reviewed, 'approved_pd_document');
      if (!sharedActivation?.ok) {
        results.push({ ok: false, title: reviewed.stock || reviewed.vin || item.filenames.join(', '), message: `Matching shared vehicle was not activated: ${sharedActivation?.code || 'unknown error'}. Nothing was imported.` });
        continue;
      }
      const applied = applyPdCheckFormImport(reviewed);
      const selectedWork = PDC_JOB_DEFS.filter(def => reviewed.reviewRequirementUpdates?.[def.requireKey]).map(def => def.label);
      results.push({
        ok: true,
        title: displayStockNumber(applied.vehicle) || reviewed.vin,
        vehicleKey: vehicleKey(applied.vehicle),
        message: `${applied.taskCount} detected line item${applied.taskCount === 1 ? '' : 's'} attached · Required work: ${selectedWork.join(', ') || 'none selected'}.`,
      });
    } catch (error) {
      app.data = buildVehicleData();
      results.push({ ok: false, title: parsed.stock || parsed.vin, message: error.message || String(error) });
    }
  }
  app.data = buildVehicleData();
  const successfulImports = results.filter(result => result.ok);
  if (successfulImports.length) {
    updateOperationalHealth({
      lastWorkImportAt: nowIsoString(),
      lastWorkImportType: 'PD Document',
      lastWorkImportRows: successfulImports.length,
    });
  }
  renderAll();
  setDashboardPdStatus(results.length ? results : [{ ok: false, title: 'PD import', message: 'Add a PD PDF or paste PD text first.' }]);
  focusVehiclesAfterWorkImport(successfulImports.map(result => result.vehicleKey));
  updateDashboardPdImportButtons();
}

function renderPmbBranchTiles() {
  const host = $('#pmb-branch-grid');
  if (!host) return;
  const vehicleTable = $('#vehicle-table');
  const trackerPanel = typeof vehicleTable?.closest === 'function' ? vehicleTable.closest('.panel') : null;
  const showPmbBuckets = app.quickFilter === 'pmb';
  if (trackerPanel) trackerPanel.hidden = showPmbBuckets || trackerPanel.classList.contains('legacy-incoming-table-panel');
  if (!showPmbBuckets) {
    host.hidden = true;
    host.innerHTML = '';
    app.activePmbBayStage = '';
    document.body.classList.remove('pmb-station-mode');
    setupPmbScheduleClock();
    return;
  }
  host.hidden = false;
  const activeStationStage = normalizePmbStage(app.activePmbBayStage);
  document.body.classList.toggle('pmb-station-mode', Boolean(activeStationStage));
  host.classList.toggle('station-only', Boolean(activeStationStage));
  if (activeStationStage) {
    host.innerHTML = renderPmbBayBoardHtml(activeStationStage);
    bindPmbDragBoard(host);
    setupPmbScheduleClock();
    updateInlineSelectionBars();
    return;
  }
  const pmbRows = filteredPmbVehiclesIgnoringSubFilter();
  const unassignedRows = pmbRows.filter(vehicle => !inferredPmbStage(vehicle));
  const lanes = [
    { value: '', filter: PMB_STAGE_UNASSIGNED_FILTER, label: 'UNALLOCATED', className: 'pmb-branch-unassigned', hint: 'Needs bucket' },
    ...PMB_STAGE_DEFS.map(def => ({ ...def, filter: def.value, className: `pmb-branch-${def.value.toLowerCase()}`, hint: 'Open bays' }))
  ];

  const laneHtml = lanes.map(lane => {
    const vehicles = lane.value
      ? pmbRows.filter(vehicle => inferredPmbStage(vehicle) === lane.value)
      : unassignedRows;
    const active = app.pmbSubFilter === lane.filter || (lane.value && normalizePmbStage(app.activePmbBayStage) === lane.value);
    const metrics = pmbLaneMetrics(lane.value, vehicles);
    const laneClasses = [
      active ? 'active' : '',
      lane.className,
      metrics.overLimit ? 'is-over-limit' : '',
      metrics.atLimit ? 'is-at-limit' : '',
      metrics.blockedCount ? 'has-blocked' : '',
    ].filter(Boolean).join(' ');
    const cards = vehicles.map(pmbVehicleCardHtml).join('') || `<div class="pmb-empty-drop">${lane.value ? 'Drop vehicles here' : 'No unallocated PMB vehicles'}</div>`;
    const capacityLabel = lane.value ? pmbStageCapacityLabel(lane.value) : `${metrics.limitLabel} vehicle limit`;
    const hint = metrics.overLimit
      ? `OVER LIMIT ${vehicles.length}/${metrics.limitLabel}`
      : `${capacityLabel} · ${vehicles.length} in queue · oldest ${metrics.oldestStageDays}d${metrics.blockedCount ? ` · blocked ${metrics.blockedCount}` : ''}`;
    const titleAttrs = lane.value
      ? `data-open-pmb-bays="${escapeHtml(lane.value)}" title="Open ${escapeHtml(lane.label)} bays"`
      : `data-pmb-sub-filter="${escapeHtml(lane.filter)}" title="Show unallocated PMB vehicles"`;
    return `
      <section class="pmb-drop-lane ${escapeHtml(laneClasses)}" data-pmb-drop-stage="${escapeHtml(lane.value)}" aria-label="${escapeHtml(lane.label)} PMB bucket">
        <button class="pmb-lane-title" type="button" ${titleAttrs} aria-pressed="${active}">
          <span>${escapeHtml(lane.label)}</span>
          <strong>${vehicles.length}</strong>
          <small>${escapeHtml(lane.value ? `${hint} · click for bay line` : hint)}</small>
        </button>
        <div class="pmb-lane-dropzone" data-pmb-drop-stage="${escapeHtml(lane.value)}">
          ${cards}
        </div>
      </section>`;
  }).join('');

  const allActive = !app.pmbSubFilter;
  host.innerHTML = `
    <div class="branch-header">
      <div><strong>PMB control board</strong><span>All PMB vehicles land in UNALLOCATED first. Drag into TINT, HOIST, FITTING, FAB, ELEC, TYRE or PIT when that department is ready.</span></div>
      <div class="branch-header-actions">
        <button class="small-button ${allActive ? 'active-lite' : ''}" type="button" data-pmb-sub-filter="">Show all PMB (${pmbRows.length})</button>
        <button class="small-button ${app.pmbSubFilter === PMB_STAGE_UNASSIGNED_FILTER ? 'active-lite' : ''}" type="button" data-pmb-sub-filter="${PMB_STAGE_UNASSIGNED_FILTER}">UNALLOCATED (${unassignedRows.length})</button>
      </div>
    </div>
    <div class="pmb-drop-board" data-pmb-board>${laneHtml}</div>
    ${renderPmbBayBoardHtml(app.activePmbBayStage)}
  `;
  bindPmbDragBoard(host);
  setupPmbScheduleClock();
}


function normalizePmbBayNumber(value = '', stage = '') {
  const parsed = Number.parseInt(String(value || '').trim(), 10);
  const max = stage ? pmbStageBayCount(stage) : PMB_BAY_MAX_COUNT;
  return Number.isInteger(parsed) && parsed >= 1 && parsed <= max ? parsed : '';
}

function pmbBayNumber(vehicle = {}, stage = '') {
  const currentStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  const bayStage = normalizePmbStage(vehicle.pmbBayStage || '');
  const bay = normalizePmbBayNumber(vehicle.pmbBayNumber, currentStage);
  if (!bay) return '';
  if (currentStage && bayStage && bayStage !== currentStage) return '';
  return bay;
}

function pmbBayHours(vehicle = {}) {
  const raw = String(vehicle.pmbBayEstimatedHours ?? '').trim();
  if (!raw) return '';
  const parsed = Number.parseFloat(raw);
  if (!Number.isFinite(parsed) || parsed < 0) return '';
  return parsed;
}

function pmbBayHoursLabel(vehicle = {}) {
  const hours = pmbBayHours(vehicle);
  if (hours === '') return 'Hours not set';
  return `${hours}${String(hours).includes('.') ? '' : '.0'}h planned`;
}

function pmbBayScheduledStart(vehicle = {}) {
  return parseIsoTimestamp(vehicle.pmbBayScheduledStartAt || '') || parseIsoTimestamp(vehicle.pmbBayEnteredAt || '') || null;
}

function pmbBayScheduledStartLabel(vehicle = {}) {
  const start = pmbBayScheduledStart(vehicle);
  return start ? start.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : 'Start not set';
}

function datetimeLocalValueFromIso(value = '') {
  const date = parseIsoTimestamp(value);
  if (!date) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function isoFromDatetimeLocalValue(value = '') {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
}

function pmbBayMechanic(vehicle = {}) {
  return cleanNavisionText(vehicle.pmbBayMechanic || '');
}

function mechanicOptionsHtml(current = '') {
  const selected = cleanNavisionText(current);
  const names = loadMechanics();
  const combined = selected && !names.includes(selected) ? [selected, ...names] : names;
  return `<option value="">Unassigned</option>${combined.map(name => `<option value="${escapeHtml(name)}"${name === selected ? ' selected' : ''}>${escapeHtml(name)}</option>`).join('')}`;
}

function pmbBaySubletProvider(vehicle = {}) {
  return cleanNavisionText(vehicle.pmbSubletProvider || '');
}

function subletProviderOptionsHtml(current = '') {
  const selected = cleanNavisionText(current);
  const names = loadSubletProviders();
  const combined = selected && !names.includes(selected) ? [selected, ...names] : names;
  return `<option value="">Unassigned</option>${combined.map(name => `<option value="${escapeHtml(name)}"${name === selected ? ' selected' : ''}>${escapeHtml(name)}</option>`).join('')}`;
}

async function addMechanicFromPrompt() {
  if (!workshopTechnicianAdminCanMutate()) {
    pdcNotify('Administrator access is required to add mechanics. No request was sent.');
    return false;
  }
  const entered = cleanNavisionText(window.prompt('Enter mechanic / technician name:', '') || '');
  if (!entered) return false;
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared mechanic list right now. Check your connection and try again.'); return false; }
  try {
    const result = await service.addTechnician(entered);
    if (!result || result.ok !== true) {
      pdcNotify(result?.error === 'duplicate_name' ? `"${entered}" is already on the mechanic list.` : 'Could not add mechanic.');
      return false;
    }
    await service.listTechnicians(true);
    renderKpis();
    renderAdminLists();
    return true;
  } catch (_error) {
    pdcNotify('Could not add mechanic. Check your connection and try again.');
    return false;
  }
}

function addSubletProviderFromPrompt() {
  const entered = cleanNavisionText(window.prompt('Enter external provider name:', '') || '');
  if (!entered) return;
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  if (!service) { pdcNotify('Cannot reach the shared provider list right now. Check your connection and try again.'); return; }
  service.addSubletProvider(entered).then(result => {
    if (!result.ok && result.error !== 'duplicate_name') { pdcNotify(result.error || 'Could not add provider.'); return; }
    renderKpis();
    renderAdminLists();
  }).catch(pdcAdminListRequestFailed('add provider'));
}

function pmbBaySummary(vehicle = {}) {
  const stage = inferredPmbStage(vehicle);
  const bay = pmbBayNumber(vehicle, stage);
  if (!stage || !bay) return '';
  const hours = pmbBayHours(vehicle);
  return `Bay ${bay}${hours !== '' ? ` · ${hours}h` : ''}`;
}

function pmbBayStageVehicles(stage = '') {
  const normalizedStage = normalizePmbStage(stage);
  if (!normalizedStage) return [];
  return filteredPmbVehiclesIgnoringSubFilter()
    .filter(vehicle => statusCategory(vehicle) === 'pmb' && inferredPmbStage(vehicle) === normalizedStage)
    .sort((a, b) => {
      const bayA = pmbBayNumber(a, normalizedStage) || 999;
      const bayB = pmbBayNumber(b, normalizedStage) || 999;
      if (bayA !== bayB) return bayA - bayB;
      return String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''));
    });
}

function nextOutstandingPmbStage(vehicle = {}, currentStage = '') {
  const current = normalizePmbStage(currentStage || inferredPmbStage(vehicle));
  const currentIndex = PMB_BAY_STATION_SEQUENCE.indexOf(current);
  const after = currentIndex >= 0 ? PMB_BAY_STATION_SEQUENCE.slice(currentIndex + 1) : PMB_BAY_STATION_SEQUENCE.slice();
  const before = currentIndex >= 0 ? PMB_BAY_STATION_SEQUENCE.slice(0, currentIndex) : [];
  return after.concat(before).find(stage => {
    const def = pmbStageJobDef(stage);
    return def && pdcJobRequired(vehicle, def) && !pdcJobComplete(vehicle, def);
  }) || '';
}



const PMB_SCHEDULE_DAYS = 5;
const PMB_SCHEDULE_WORK_START_HOUR = 7;
const PMB_SCHEDULE_WORK_END_HOUR = 16;
const PMB_SCHEDULE_WORK_HOURS_PER_DAY = PMB_SCHEDULE_WORK_END_HOUR - PMB_SCHEDULE_WORK_START_HOUR;
const PMB_SCHEDULE_HOUR_SCALE = 72;
const PMB_SCHEDULE_LEFT_COL = 150;
const PMB_SCHEDULE_SNAP_MINUTES = 15;
const PMB_SCHEDULE_SNAP_HOURS = PMB_SCHEDULE_SNAP_MINUTES / 60;

function isPmbProductionDay(date = new Date()) {
  const day = date.getDay();
  return day >= 1 && day <= 5;
}

function pmbMoveToNextProductionDay(date = new Date()) {
  const d = new Date(date);
  d.setHours(PMB_SCHEDULE_WORK_START_HOUR, 0, 0, 0);
  while (!isPmbProductionDay(d)) d.setDate(d.getDate() + 1);
  return d;
}

function pmbMoveToPreviousProductionDay(date = new Date()) {
  const d = new Date(date);
  d.setHours(PMB_SCHEDULE_WORK_END_HOUR, 0, 0, 0);
  while (!isPmbProductionDay(d)) d.setDate(d.getDate() - 1);
  return d;
}

function pmbAddProductionDays(date = new Date(), days = 0) {
  const d = new Date(date);
  d.setHours(PMB_SCHEDULE_WORK_START_HOUR, 0, 0, 0);
  while (!isPmbProductionDay(d)) d.setDate(d.getDate() + 1);
  let remaining = Math.max(0, Number(days) || 0);
  while (remaining > 0) {
    d.setDate(d.getDate() + 1);
    if (isPmbProductionDay(d)) remaining -= 1;
  }
  return d;
}

function pmbBusinessDayIndexFromScheduleStart(date = new Date(), config = pmbScheduleConfig()) {
  const target = startOfLocalDay(date);
  const start = startOfLocalDay(config.startDate);
  if (target < start) return -1;
  if (!isPmbProductionDay(target)) return -1;
  let idx = 0;
  const cursor = new Date(start);
  while (cursor < target) {
    cursor.setDate(cursor.getDate() + 1);
    if (isPmbProductionDay(cursor)) idx += 1;
  }
  return idx;
}

function pmbScheduleStartDate() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), PMB_SCHEDULE_WORK_START_HOUR, 0, 0, 0);
  return isPmbProductionDay(start) ? start : pmbMoveToNextProductionDay(start);
}

function pmbScheduleConfig() {
  const startDate = pmbScheduleStartDate();
  const hours = PMB_SCHEDULE_DAYS * PMB_SCHEDULE_WORK_HOURS_PER_DAY;
  return {
    startDate,
    startIso: startDate.toISOString(),
    days: PMB_SCHEDULE_DAYS,
    workStartHour: PMB_SCHEDULE_WORK_START_HOUR,
    workEndHour: PMB_SCHEDULE_WORK_END_HOUR,
    workHoursPerDay: PMB_SCHEDULE_WORK_HOURS_PER_DAY,
    hours,
    hourScale: PMB_SCHEDULE_HOUR_SCALE,
    leftCol: PMB_SCHEDULE_LEFT_COL,
    dayWidth: PMB_SCHEDULE_WORK_HOURS_PER_DAY * PMB_SCHEDULE_HOUR_SCALE,
    width: hours * PMB_SCHEDULE_HOUR_SCALE,
  };
}

function startOfLocalDay(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

function dayIndexFromScheduleStart(date = new Date(), config = pmbScheduleConfig()) {
  return pmbBusinessDayIndexFromScheduleStart(date, config);
}

function decimalHour(date = new Date()) {
  return date.getHours() + (date.getMinutes() / 60) + (date.getSeconds() / 3600) + (date.getMilliseconds() / 3600000);
}

function pmbProductionOffsetHoursFromDate(date = new Date(), config = pmbScheduleConfig(), clamp = true) {
  const parsed = date instanceof Date ? date : parseIsoTimestamp(date || '');
  if (!parsed) return 0;
  let dayIndex = pmbBusinessDayIndexFromScheduleStart(parsed, config);
  let inDay = decimalHour(parsed) - config.workStartHour;
  if (clamp) {
    if (dayIndex < 0) {
      const next = pmbMoveToNextProductionDay(parsed);
      dayIndex = pmbBusinessDayIndexFromScheduleStart(next, config);
      if (dayIndex < 0) return 0;
      inDay = 0;
    }
    if (dayIndex >= config.days) return config.hours;
    inDay = Math.max(0, Math.min(config.workHoursPerDay, inDay));
  }
  return dayIndex * config.workHoursPerDay + inDay;
}

function pmbDateAtProductionOffsetHours(config = pmbScheduleConfig(), offsetHours = 0) {
  const safeOffset = Math.max(0, Math.min(config.hours, Number(offsetHours) || 0));
  const dayIndex = Math.min(config.days - 1, Math.floor(safeOffset / config.workHoursPerDay));
  const inDay = Math.min(config.workHoursPerDay, safeOffset - dayIndex * config.workHoursPerDay);
  const date = pmbAddProductionDays(config.startDate, dayIndex);
  date.setHours(config.workStartHour, 0, 0, 0);
  date.setMinutes(date.getMinutes() + Math.round(inDay * 60));
  return date;
}

function pmbClampDateToProductionSlot(date = new Date(), direction = 'forward') {
  const d = new Date(date);
  if (!isPmbProductionDay(d)) {
    return direction === 'back' ? pmbMoveToPreviousProductionDay(d) : pmbMoveToNextProductionDay(d);
  }
  const hour = decimalHour(d);
  if (hour < PMB_SCHEDULE_WORK_START_HOUR) {
    d.setHours(PMB_SCHEDULE_WORK_START_HOUR, 0, 0, 0);
    return d;
  }
  if (hour >= PMB_SCHEDULE_WORK_END_HOUR) {
    if (direction === 'back') {
      d.setHours(PMB_SCHEDULE_WORK_END_HOUR, 0, 0, 0);
      return d;
    }
    d.setDate(d.getDate() + 1);
    return pmbMoveToNextProductionDay(d);
  }
  return d;
}

function pmbNextProductionSlotDate(date = new Date()) {
  return snapDateToScheduleIncrement(pmbClampDateToProductionSlot(date, 'forward'));
}

function pmbAddProductionHours(startDate = new Date(), hours = 0) {
  let current = pmbClampDateToProductionSlot(startDate, 'forward');
  let remaining = Math.max(0, Number(hours) || 0);
  if (!remaining) return current;
  while (remaining > 0.0001) {
    const currentHour = decimalHour(current);
    const availableToday = Math.max(0, PMB_SCHEDULE_WORK_END_HOUR - currentHour);
    if (remaining <= availableToday + 0.0001) {
      current = new Date(current.getTime() + remaining * 3600000);
      return snapDateToScheduleIncrement(current);
    }
    remaining -= availableToday;
    current.setDate(current.getDate() + 1);
    current = pmbMoveToNextProductionDay(current);
  }
  return snapDateToScheduleIncrement(current);
}

function pmbScheduleChipWidthPx(vehicle = {}) {
  const hours = pmbBayHours(vehicle);
  const planned = hours === '' ? 1 : Math.max(PMB_SCHEDULE_SNAP_HOURS, Number(hours));
  return Math.round(Math.min(760, Math.max(96, planned * PMB_SCHEDULE_HOUR_SCALE)));
}

function pmbScheduleChipLeftPx(vehicle = {}, config = pmbScheduleConfig()) {
  const start = pmbBayScheduledStart(vehicle) || pmbNextProductionSlotDate();
  const offsetHours = pmbProductionOffsetHoursFromDate(start, config, true);
  return Math.round(Math.min(config.width - 40, Math.max(0, offsetHours * config.hourScale)));
}

function pmbSchedulePlannedHours(vehicles = []) {
  return vehicles.reduce((sum, vehicle) => {
    const hours = pmbBayHours(vehicle);
    return sum + (hours === '' ? 1 : Math.max(PMB_SCHEDULE_SNAP_HOURS, Number(hours)));
  }, 0);
}

function pmbScheduleMaxHours(rowGroups = []) {
  return PMB_SCHEDULE_DAYS * PMB_SCHEDULE_WORK_HOURS_PER_DAY;
}

function pmbScheduleTickDate(index = 0, config = pmbScheduleConfig()) {
  return pmbDateAtProductionOffsetHours(config, index);
}

function pmbScheduleHourLabel(date = new Date(), index = 0, config = pmbScheduleConfig()) {
  const inDay = index % config.workHoursPerDay;
  const dayLabel = date.toLocaleDateString('en-AU', { weekday: 'short', day: '2-digit', month: '2-digit' });
  const timeLabel = date.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' });
  if (inDay === 0) return `<strong>${escapeHtml(dayLabel)}</strong><small>${escapeHtml(timeLabel)}</small>`;
  return `<span${inDay % 2 ? ' class="minor-hour"' : ''}>${escapeHtml(timeLabel)}</span>`;
}

function pmbScheduleTicksHtml(config = pmbScheduleConfig()) {
  const ticks = Array.from({ length: config.hours }, (_, index) => {
    const date = pmbScheduleTickDate(index, config);
    const inDay = index % config.workHoursPerDay;
    const cls = [
      inDay === 0 ? 'day-start' : '',
      inDay === config.workHoursPerDay - 1 ? 'day-last-hour' : '',
      inDay % 2 === 0 ? 'major-hour' : 'minor-hour'
    ].filter(Boolean).join(' ');
    return `<span class="${cls}">${pmbScheduleHourLabel(date, index, config)}</span>`;
  }).join('');
  return `<div class="pmb-schedule-scale" aria-hidden="true">${ticks}</div>`;
}

function renderPmbScheduleRowHtml({ label = '', sub = '', vehicles = [], stage = '', bay = '', type = '', acceptsDrop = true, config = pmbScheduleConfig() } = {}) {
  const normalizedStage = normalizePmbStage(stage);
  const dropAttrs = acceptsDrop && normalizedStage
    ? `data-pmb-bay-drop-stage="${escapeHtml(normalizedStage)}" data-pmb-bay-drop-number="${escapeHtml(bay)}"`
    : '';
  const plannedHours = pmbSchedulePlannedHours(vehicles);
  const countText = vehicles.length ? `${vehicles.length} vehicle${vehicles.length === 1 ? '' : 's'}` : 'Available';
  const emptyText = type === 'work-started'
    ? 'Completed work returns here after sign-off.'
    : type === 'unassigned'
      ? 'Drop waiting vehicles here or into a bay.'
      : 'Drop vehicle here';
  const rowClasses = [
    'pmb-schedule-row',
    type ? `pmb-schedule-row-${type}` : '',
    type === 'bay' ? 'timeline-row' : 'holding-row',
    vehicles.length ? 'has-vehicles' : 'is-empty',
    acceptsDrop ? 'accepts-drop' : '',
  ].filter(Boolean).join(' ');
  return `
    <section class="${escapeHtml(rowClasses)}" aria-label="${escapeHtml(label)}">
      <div class="pmb-schedule-row-label">
        <strong>${escapeHtml(label)}</strong>
        <span>${escapeHtml(sub || countText)}</span>
        <small>${escapeHtml(`${vehicles.length} vehicle${vehicles.length === 1 ? '' : 's'} · ${plannedHours.toFixed(plannedHours % 1 ? 1 : 0)}h planned`)}</small>
      </div>
      <div class="pmb-schedule-lane" ${dropAttrs}>
        ${vehicles.length ? vehicleIdentityHeaderHtml('pmb-schedule-identity-header') : ''}
        <div class="pmb-schedule-lane-inner">
          ${vehicles.map((vehicle, index) => pmbBayTimelineVehicleCardHtml(vehicle, normalizedStage, type, config, index)).join('') || `<div class="pmb-schedule-empty">${escapeHtml(emptyText)}</div>`}
        </div>
      </div>
    </section>`;
}

function renderPmbBayBoardHtml(stage = '') {
  const normalizedStage = normalizePmbStage(stage);
  if (!normalizedStage) return '';
  const label = pmbStageLabel(normalizedStage);
  const vehicles = pmbBayStageVehicles(normalizedStage);
  const jobDef = pmbStageJobDef(normalizedStage);
  const completedCount = jobDef ? vehicles.filter(vehicle => pdcJobComplete(vehicle, jobDef)).length : 0;
  const totalHours = vehicles.reduce((sum, vehicle) => sum + (pmbBayHours(vehicle) || 0), 0);
  const baylessVehicles = vehicles.filter(vehicle => !pmbBayNumber(vehicle, normalizedStage));
  const workStarted = baylessVehicles.filter(vehicle => jobDef && pdcJobComplete(vehicle, jobDef));
  const unassigned = baylessVehicles.filter(vehicle => !(jobDef && pdcJobComplete(vehicle, jobDef)));
  const bayCount = pmbStageBayCount(normalizedStage);
  const bayTiles = Array.from({ length: bayCount }, (_, index) => {
    const bay = index + 1;
    const bayVehicles = vehicles.filter(vehicle => pmbBayNumber(vehicle, normalizedStage) === bay);
    const completeClass = bayVehicles.length && jobDef && bayVehicles.every(vehicle => pdcJobComplete(vehicle, jobDef)) ? ' is-complete' : '';
    return `
      <section class="pmb-bay ${bayVehicles.length ? 'is-occupied' : 'is-empty'}${completeClass}" data-pmb-bay-drop-stage="${escapeHtml(normalizedStage)}" data-pmb-bay-drop-number="${escapeHtml(String(bay))}">
        <div class="pmb-bay-title">
          <strong>${escapeHtml(pdcBayText(normalizedStage, bay, true))}</strong>
          <span>${bayVehicles.length ? `${bayVehicles.length} vehicle${bayVehicles.length === 1 ? '' : 's'}` : 'Available'}</span>
        </div>
        <div class="pmb-bay-slot">
          ${bayVehicles.map(vehicle => pmbBayVehicleCardHtml(vehicle, normalizedStage)).join('') || '<div class="pmb-bay-empty">Drop vehicle here</div>'}
        </div>
      </section>`;
  }).join('');

  const stageTabs = PMB_STAGE_DEFS.map(def => {
    const tabStage = normalizePmbStage(def.value);
    const tabVehicles = pmbBayStageVehicles(tabStage);
    const activeClass = tabStage === normalizedStage ? ' active' : '';
    const capacityText = pmbStageCapacityLabel(tabStage);
    const vehicleText = `${tabVehicles.length} veh`;
    return `<button class="pmb-bay-stage-tab${activeClass}" type="button" data-open-pmb-bays="${escapeHtml(tabStage)}" aria-pressed="${tabStage === normalizedStage ? 'true' : 'false'}"><span>${escapeHtml(def.label)}</span><strong>${escapeHtml(capacityText)}</strong><em>${escapeHtml(vehicleText)}</em></button>`;
  }).join('');

  return `
    <section class="pmb-bay-board pmb-bay-board-${escapeHtml(normalizedStage.toLowerCase())}" data-pmb-bay-board-stage="${escapeHtml(normalizedStage)}">
      <div class="pmb-bay-board-header">
        <div>
          <strong>${escapeHtml(label)} bays</strong>
          <span>${escapeHtml(pmbStageCapacityLabel(normalizedStage))} · ${vehicles.length} vehicle${vehicles.length === 1 ? '' : 's'} · ${completedCount} complete · ${totalHours.toFixed(totalHours % 1 ? 1 : 0)} planned hour${totalHours === 1 ? '' : 's'}</span>
        </div>
        <div class="pmb-bay-board-actions">
          <button class="small-button" type="button" data-close-pmb-bays>Back to PMB buckets</button>
        </div>
      </div>
      <div class="pmb-bay-stage-tabs" aria-label="PMB buckets">${stageTabs}</div>
      <div class="pmb-bay-help"><strong>${escapeHtml(label)} station focus:</strong> ${escapeHtml(pmbStageOperatorGuidance(normalizedStage))}</div>
      <div class="pmb-bay-holding-grid">
        <section class="pmb-bay-unassigned" data-pmb-bay-drop-stage="${escapeHtml(normalizedStage)}" data-pmb-bay-drop-number="">
          <div class="pmb-bay-unassigned-title"><strong>Not in a bay</strong><span>${unassigned.length} waiting</span></div>
          <div class="pmb-bay-unassigned-list">
            ${unassigned.map(vehicle => pmbBayVehicleCardHtml(vehicle, normalizedStage)).join('') || '<div class="pmb-bay-empty compact">All vehicles are assigned to bays.</div>'}
          </div>
        </section>
        <section class="pmb-bay-work-started" data-pmb-complete-drop-stage="${escapeHtml(normalizedStage)}">
          <div class="pmb-bay-unassigned-title"><strong>Completed / return to unallocated</strong><span>${workStarted.length} complete</span></div>
          <div class="pmb-bay-unassigned-list">
            ${workStarted.map(vehicle => pmbBayVehicleCardHtml(vehicle, normalizedStage)).join('') || '<div class="pmb-bay-empty compact">Drop a vehicle here to choose Complete, STOPPAGE, or Move only.</div>'}
          </div>
        </section>
      </div>
      <div class="pmb-bay-grid">${bayTiles}</div>
    </section>`;
}

function pmbBayTimelineVehicleCardHtml(vehicle = {}, stage = '', rowType = '', config = pmbScheduleConfig(), index = 0) {
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  const key = vehicleKey(vehicle);
  const jobDef = pmbStageJobDef(normalizedStage);
  const bay = pmbBayNumber(vehicle, normalizedStage);
  const complete = jobDef ? pdcJobComplete(vehicle, jobDef) : false;
  const widthPx = rowType === 'bay' ? Math.max(pmbScheduleChipWidthPx(vehicle), 340) : 360;
  const leftPx = rowType === 'bay' ? pmbScheduleChipLeftPx(vehicle, config) : 0;
  const title = `${vehicleIdentityTitle(vehicle) || 'Vehicle'} · ${pmbStageLabel(normalizedStage)}${bay ? ` · Bay ${bay}` : rowType === 'work-started' ? ' · Work Started' : ' · no bay'} · click for details`;
  const draggableAttr = complete || rowType === 'bay' ? '' : `draggable="true" data-pmb-drag-key="${escapeHtml(key)}"`;
  const identityHtml = vehicleIdentityStackHtml(vehicle, { className: 'pmb-bay-identity pmb-schedule-identity' });
  const timeLabel = rowType === 'bay' ? pmbScheduleVehicleTimeLabel(vehicle) : '';
  const adjustAttrs = rowType === 'bay'
    ? `data-pmb-schedule-chip="1" data-pmb-schedule-chip-key="${escapeHtml(key)}" data-pmb-schedule-chip-stage="${escapeHtml(normalizedStage)}" data-pmb-schedule-chip-bay="${escapeHtml(bay)}"`
    : '';
  return `
    <article class="pmb-bay-vehicle-card pmb-schedule-chip pmb-schedule-chip-slim ${complete ? 'is-complete' : ''} ${isPdcBlocked(vehicle) ? 'is-blocked' : ''}" ${draggableAttr} ${adjustAttrs} data-open-stock="${escapeHtml(key)}" style="--chip-width:${widthPx}px; --chip-left:${leftPx}px; --chip-stack:${index};" title="${escapeHtml(title)}">
      ${identityHtml}
      ${rowType === 'bay' ? `<span class="pmb-schedule-chip-time" data-pmb-chip-time-label>${escapeHtml(timeLabel)}</span><span class="pmb-schedule-chip-resize-handle" data-pmb-chip-resize-handle title="Drag to change planned hours"></span>` : ''}
    </article>`;
}

function setupPmbScheduleClock() {
  if (app.pmbScheduleClockTimer) {
    window.clearInterval(app.pmbScheduleClockTimer);
    app.pmbScheduleClockTimer = null;
  }
  if (!$('[data-pmb-schedule-start]')) return;
  updatePmbScheduleClock();
  window.setTimeout(scrollPmbSchedulesToNow, 80);
  app.pmbScheduleClockTimer = window.setInterval(updatePmbScheduleClock, 15000);
}

function updatePmbScheduleClock() {
  $$('[data-pmb-schedule-start]').forEach(board => {
    const config = pmbScheduleConfigFromBoard(board);
    const line = $('[data-pmb-schedule-now-line]', board);
    const label = $('[data-pmb-schedule-now-label]', board);
    if (!line || !config.hours) return;
    const now = new Date();
    const dayIndex = dayIndexFromScheduleStart(now, config);
    const nowHour = decimalHour(now);
    const isVisibleDay = isPmbProductionDay(now) && dayIndex >= 0 && dayIndex < config.days;
    line.hidden = !isVisibleDay;
    line.style.display = isVisibleDay ? 'block' : 'none';
    if (!isVisibleDay) return;
    const direction = nowHour > config.workEndHour ? 'back' : 'forward';
    const clampedNow = pmbClampDateToProductionSlot(now, direction);
    const offsetHours = pmbProductionOffsetHoursFromDate(clampedNow, config, true);
    const left = Math.round(config.leftCol + offsetHours * config.hourScale);
    line.style.left = `${left}px`;
    line.style.height = `${Math.max(board.scrollHeight || 0, board.getBoundingClientRect().height || 0)}px`;
    line.style.setProperty('--now-left', `${left}px`);
    if (label) {
      const suffix = nowHour < config.workStartHour
        ? '7:00 am start'
        : nowHour > config.workEndHour
          ? '5:00 pm finish'
          : now.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' });
      label.textContent = `Now ${suffix}`;
    }
  });
}

function pmbScheduleConfigFromBoard(board) {
  const startDate = parseIsoTimestamp(board?.dataset?.pmbScheduleStart || '') || pmbScheduleStartDate();
  const days = Number(board?.dataset?.pmbScheduleDays || PMB_SCHEDULE_DAYS);
  const workHoursPerDay = Number(board?.dataset?.pmbScheduleWorkHours || PMB_SCHEDULE_WORK_HOURS_PER_DAY);
  const hourScale = Number(board?.dataset?.pmbScheduleScale || PMB_SCHEDULE_HOUR_SCALE);
  const leftCol = Number(board?.dataset?.pmbScheduleLeftCol || PMB_SCHEDULE_LEFT_COL);
  const hours = Number(board?.dataset?.pmbScheduleHours || days * workHoursPerDay);
  return {
    startDate,
    startIso: startDate.toISOString(),
    days,
    workStartHour: PMB_SCHEDULE_WORK_START_HOUR,
    workEndHour: PMB_SCHEDULE_WORK_END_HOUR,
    workHoursPerDay,
    hours,
    hourScale,
    leftCol,
    dayWidth: workHoursPerDay * hourScale,
    width: hours * hourScale,
  };
}

function scrollPmbSchedulesToNow() {
  $$('[data-pmb-schedule-start]').forEach(board => {
    const scroll = $('.pmb-schedule-scroll', board);
    if (!scroll || board.dataset.nowScrollDone === '1') return;
    const config = pmbScheduleConfigFromBoard(board);
    const now = new Date();
    const dayIndex = dayIndexFromScheduleStart(now, config);
    if (!isPmbProductionDay(now) || dayIndex < 0 || dayIndex >= config.days) return;
    const clampedNow = pmbClampDateToProductionSlot(now, decimalHour(now) < config.workStartHour ? 'forward' : 'back');
    const offsetHours = pmbProductionOffsetHoursFromDate(clampedNow, config, true);
    const nowLeft = config.leftCol + offsetHours * config.hourScale;
    scroll.scrollLeft = Math.max(0, nowLeft - 240);
    board.dataset.nowScrollDone = '1';
  });
}

function snapScheduleHours(value = 0) {
  const snap = PMB_SCHEDULE_SNAP_HOURS || 0.25;
  return Math.round(Number(value || 0) / snap) * snap;
}

function snapDateToScheduleIncrement(date = new Date()) {
  const snapMs = (PMB_SCHEDULE_SNAP_MINUTES || 15) * 60000;
  return new Date(Math.round(date.getTime() / snapMs) * snapMs);
}

function formatScheduleTime(date = new Date()) {
  return date.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' });
}

function pmbScheduleVehicleTimeLabel(vehicle = {}, startOverride = null, hoursOverride = null) {
  const start = startOverride || pmbBayScheduledStart(vehicle) || pmbNextProductionSlotDate();
  const rawHours = hoursOverride === null ? pmbBayHours(vehicle) : hoursOverride;
  const hours = rawHours === '' ? 1 : Math.max(PMB_SCHEDULE_SNAP_HOURS, Number(rawHours));
  const end = pmbAddProductionHours(start, hours);
  return `${formatScheduleTime(start)}-${formatScheduleTime(end)} · ${Number(hours.toFixed(2))}h`;
}

function isoFromScheduleOffsetHours(config = pmbScheduleConfig(), offsetHours = 0) {
  return pmbDateAtProductionOffsetHours(config, offsetHours).toISOString();
}

function hoursFromIsoAgainstSchedule(iso = '', config = pmbScheduleConfig()) {
  const date = parseIsoTimestamp(iso || '');
  if (!date) return 0;
  return pmbProductionOffsetHoursFromDate(date, config, true);
}

function bindPmbScheduleChips(host) {
  $$('[data-pmb-schedule-chip="1"]', host).forEach(chip => bindPmbScheduleChip(chip));
}

function bindPmbScheduleChip(chip) {
  if (!chip || chip.dataset.pmbScheduleBound === '1') return;
  chip.dataset.pmbScheduleBound = '1';
  const resizeHandle = $('[data-pmb-chip-resize-handle]', chip);
  if (resizeHandle) {
    resizeHandle.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
    });
    resizeHandle.addEventListener('pointerdown', event => startPmbScheduleChipInteraction(chip, event, 'resize'));
  }
  chip.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    if (event.target.closest('[data-pmb-chip-resize-handle]')) return;
    startPmbScheduleChipInteraction(chip, event, 'move');
  });
}

function startPmbScheduleChipInteraction(chip, event, mode = 'move') {
  if (!chip || chip.dataset.pmbScheduleChip !== '1') return;
  const key = chip.dataset.pmbScheduleChipKey || '';
  const stage = chip.dataset.pmbScheduleChipStage || '';
  const vehicle = app.data.find(v => vehicleKey(v) === key || v.stock === key || v.id === key);
  if (!vehicle || !stage) return;
  const board = chip.closest('[data-pmb-schedule-start]');
  if (!board) return;
  const config = pmbScheduleConfigFromBoard(board);
  const originX = event.clientX;
  const startHours = hoursFromIsoAgainstSchedule(vehicle.pmbBayScheduledStartAt || vehicle.pmbBayEnteredAt || '', config);
  const currentHours = pmbBayHours(vehicle);
  const startPlanned = currentHours === '' ? 1 : Math.max(PMB_SCHEDULE_SNAP_HOURS, Number(currentHours));
  const state = {
    chip, key, stage, mode, config, vehicle,
    originX,
    startHours,
    startPlanned,
    startLeftPx: pmbScheduleChipLeftPx(vehicle, config),
    startWidthPx: pmbScheduleChipWidthPx(vehicle),
    moved: false,
  };
  const onMove = moveEvent => continuePmbScheduleChipInteraction(state, moveEvent);
  const onUp = upEvent => endPmbScheduleChipInteraction(state, upEvent, onMove, onUp);
  document.addEventListener('pointermove', onMove);
  document.addEventListener('pointerup', onUp);
  document.body.classList.add('pmb-schedule-adjusting');
  chip.classList.add(mode === 'resize' ? 'is-resizing' : 'is-moving');
  chip.setPointerCapture?.(event.pointerId);
  event.preventDefault();
  event.stopPropagation();
}

function continuePmbScheduleChipInteraction(state, event) {
  const dx = event.clientX - state.originX;
  const deltaHours = snapScheduleHours(dx / state.config.hourScale);
  if (Math.abs(dx) > 3) state.moved = true;
  if (state.mode === 'move') {
    const newOffset = Math.max(0, Math.min(state.config.hours - 0.25, state.startHours + deltaHours));
    const leftPx = Math.round(Math.max(0, Math.min(state.config.width - 40, newOffset * state.config.hourScale)));
    state.previewOffsetHours = newOffset;
    state.chip.style.setProperty('--chip-left', `${leftPx}px`);
    const label = $('[data-pmb-chip-time-label]', state.chip);
    if (label) label.textContent = pmbScheduleVehicleTimeLabel(state.vehicle, pmbDateAtProductionOffsetHours(state.config, newOffset), state.startPlanned);
  } else {
    const newHours = Math.max(PMB_SCHEDULE_SNAP_HOURS, Math.min(24, snapScheduleHours(state.startPlanned + deltaHours)));
    const widthPx = Math.round(Math.min(760, Math.max(96, newHours * state.config.hourScale)));
    state.previewPlannedHours = newHours;
    state.chip.style.setProperty('--chip-width', `${widthPx}px`);
    const label = $('[data-pmb-chip-time-label]', state.chip);
    if (label) label.textContent = pmbScheduleVehicleTimeLabel(state.vehicle, pmbBayScheduledStart(state.vehicle) || pmbNextProductionSlotDate(), newHours);
  }
}

function endPmbScheduleChipInteraction(state, event, onMove, onUp) {
  document.removeEventListener('pointermove', onMove);
  document.removeEventListener('pointerup', onUp);
  document.body.classList.remove('pmb-schedule-adjusting');
  state.chip.classList.remove('is-moving', 'is-resizing');
  state.chip.releasePointerCapture?.(event.pointerId);
  if (!state.moved) return;
  state.chip.dataset.preventOpenUntil = String(Date.now() + 300);
  if (state.mode === 'move' && Number.isFinite(state.previewOffsetHours)) {
    const nextIso = isoFromScheduleOffsetHours(state.config, state.previewOffsetHours);
    updatePmbBayScheduleStart(state.key, state.stage, datetimeLocalValueFromIso(nextIso));
  }
  if (state.mode === 'resize' && Number.isFinite(state.previewPlannedHours)) {
    const nextHours = String(Number(snapScheduleHours(state.previewPlannedHours).toFixed(2)));
    updatePmbBayHours(state.key, state.stage, nextHours);
  }
}

function renderPmbBayControlSection(v = {}) {
  // The legacy PMB bay detail controls persist operational changes in browser
  // storage. Shared staging/online operation must use the authoritative
  // Workshop Planner RPCs instead, so never expose this mutation surface when
  // shared lifecycle authority is enabled.
  if (vehicleLifecycleSharedModeActive()) return '';
  const stage = normalizePmbStage(v.pmbBayStage || inferredPmbStage(v));
  const bay = pmbBayNumber(v, stage);
  if (statusCategory(v) !== 'pmb' || !stage) return '';
  const jobDef = pmbStageJobDef(stage);
  const complete = jobDef ? pdcJobComplete(v, jobDef) : false;
  const isSubletStage = stage === 'SUBLET';
  const assigneeLabel = isSubletStage ? 'Provider' : 'Mechanic';
  const assigneeValue = isSubletStage ? pmbBaySubletProvider(v) : pmbBayMechanic(v);
  const assigneeOptions = isSubletStage ? subletProviderOptionsHtml(assigneeValue) : mechanicOptionsHtml(assigneeValue);
  const startValue = datetimeLocalValueFromIso(v.pmbBayScheduledStartAt || v.pmbBayEnteredAt || pmbNextProductionSlotDate().toISOString());
  return `
    <section class="pmb-bay-detail-box">
      <div class="muted-label section-label">Production bay details</div>
      <form class="pmb-bay-detail-form" data-pmb-bay-detail-form>
        <div class="form-row three-col">
          <label>
            <span class="muted-label">Station</span>
            <input value="${escapeHtml(pmbStageLabel(stage))}${bay ? ` · Bay ${escapeHtml(bay)}` : ' · Not in a bay'}" readonly />
          </label>
          <label>
            <span class="muted-label">Scheduled start</span>
            <input name="pmbBayScheduledStartAt" type="datetime-local" value="${escapeHtml(startValue)}" />
          </label>
          <label>
            <span class="muted-label">Planned hours</span>
            <input name="pmbBayEstimatedHours" type="number" min="0" step="0.25" inputmode="decimal" value="${pmbBayHours(v) === '' ? '' : escapeHtml(pmbBayHours(v))}" placeholder="1" />
          </label>
        </div>
        <div class="form-row two-col">
          <label>
            <span class="muted-label">${escapeHtml(assigneeLabel)}</span>
            <select name="pmbBayAssignee">${assigneeOptions}</select>
          </label>
          <label>
            <span class="muted-label">Status</span>
            <input value="${escapeHtml(complete ? `${jobDef?.label || 'Job'} complete` : `${jobDef?.label || 'Job'} open`)}" readonly />
          </label>
        </div>
        <div class="edit-actions">
          <button class="primary" type="submit">Save bay details</button>
          <button class="small-button ${complete ? 'active-lite' : ''}" type="button" data-modal-complete-pmb-bay-work="${escapeHtml(vehicleKey(v))}" data-modal-complete-pmb-bay-stage="${escapeHtml(stage)}" ${complete ? 'disabled aria-disabled="true"' : ''}>${complete ? 'Complete ✓' : `Complete ${escapeHtml(jobDef?.label || 'work')}`}</button>
          <span class="save-message" data-bay-save-message></span>
        </div>
      </form>
    </section>`;
}

function pmbStageOperatorGuidance(stage = '') {
  const label = pmbStageLabel(stage);
  return {
    TINT: 'Tint (internal) view: confirm tint work, planned hours, bay and technician only. Use Parts or other station pages for their own blockers and sign-offs.',
    HOIST: 'Hoist view: confirm hoist work, planned hours, bay and technician only.',
    FITTING: 'Fitting view: confirm accessory fitment work, planned hours, bay and technician only. Do not use this page for Parts or external specialist updates.',
    FABRICATION: 'Fabrication view: confirm fabrication work, planned hours, bay and technician only. Leave Tint / Electrical / Parts sign-off to their own pages.',
    ELECTRICAL: 'Electrical view: confirm electrical work, planned hours, bay and technician only. Escalate non-electrical blockers instead of clearing other departments here.',
    TYRE: 'Tyre bay view: confirm tyre/wheel work, planned hours, bay and technician only. One of the two bays is the wheel-alignment bay.'
  }[normalizePmbStage(stage)] || `${label} view: complete this station's work only.`;
}

function pmbCurrentStageStatusHtml(vehicle = {}, stage = '') {
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  const jobDef = pmbStageJobDef(normalizedStage);
  if (!jobDef) return '';
  const required = pdcJobRequired(vehicle, jobDef);
  const complete = pdcJobComplete(vehicle, jobDef);
  const className = complete ? 'done' : required ? 'open' : 'not-required';
  const label = complete ? `${jobDef.label} complete` : required ? `${jobDef.label} required` : `${jobDef.label} not required`;
  return `<span class="pmb-bay-chip ${escapeHtml(className)}">${escapeHtml(label)}</span>`;
}

function pmbCardDetailHtml(vehicle = {}) {
  const unit = displayVehicle(vehicle) || 'Vehicle not listed';
  const consultant = consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || 'No sales rep';
  const blocked = isPdcBlocked(vehicle) || partsDepartmentStatus(vehicle) === 'stoppage';
  const blocker = blocked ? (partsStoppageReason(vehicle) || vehicle.pdcBlockedReason || 'Parts/PMB STOPPAGE') : 'No Parts STOPPAGE';
  return `<span class="pmb-pill-vehicle" title="${escapeHtml(unit)}">${escapeHtml(unit)}</span>
    <span class="pmb-pill-meta">
      <span class="pmb-card-age pmb-age-${escapeHtml(pmbAgeClass(vehicle))}">${escapeHtml(pmbLifecycleAgeLabel(vehicle))}</span>${typeof pmbArrivalAgeFlagHtml === 'function' ? pmbArrivalAgeFlagHtml(vehicle) : ''}
      <span class="pmb-pill-blocker ${blocked ? 'is-blocked' : ''}" title="${escapeHtml(blocker)}">${escapeHtml(blocked ? 'Parts STOPPAGE' : 'No STOPPAGE')}</span>
    </span>
    <span class="pmb-pill-sales" title="${escapeHtml(consultant)}">${escapeHtml(consultant)}</span>`;
}

function pmbBayVehicleCardHtml(vehicle = {}, stage = '') {
  const normalizedStage = normalizePmbStage(stage || vehicle.pmbBayStage || inferredPmbStage(vehicle));
  const key = vehicleKey(vehicle);
  const jobDef = pmbStageJobDef(normalizedStage);
  const bay = pmbBayNumber(vehicle, normalizedStage);
  const complete = jobDef ? pdcJobComplete(vehicle, jobDef) : false;
  const bayLabel = bay ? `Bay ${bay}` : 'No bay';
  const identityHtml = pmbBayPillIdentityHtml(vehicle);
  const title = `${vehicleIdentityTitle(vehicle)} · ${pmbStageLabel(normalizedStage)} ${bayLabel}`;
  const finishButton = normalizedStage
    ? `<button class="small-button pmb-finish-button" type="button" data-move-pmb-stage-key="${escapeHtml(key)}" data-move-pmb-stage-value="" title="Choose Complete, STOPPAGE, or Move only, then return this vehicle to PMB unallocated">Finish / unallocate</button>`
    : '';

  return `
    <article class="pmb-bay-vehicle-card pmb-bay-vehicle-pill ${complete ? 'is-complete' : ''} ${isPdcBlocked(vehicle) ? 'is-blocked' : ''}" draggable="true" data-pmb-drag-key="${escapeHtml(key)}" data-open-stock="${escapeHtml(key)}" title="${escapeHtml(title)}">
      <div class="pmb-bay-pill-main">
        ${identityHtml}
        ${pmbPillCustomerHtml(vehicle)}
      </div>
      <div class="pmb-bay-pill-bottom">
        ${pmbOutstandingStationChipsHtml(vehicle)}
        ${isPdcBlocked(vehicle) ? `<span class="pmb-bay-chip blocked">Blocked</span>` : ''}
        ${finishButton}
      </div>
    </article>`;
}

function pmbVehicleCardHtml(vehicle = {}) {
  const key = vehicleKey(vehicle);
  const stage = normalizePmbStage(vehicle.pmbBayStage || inferredPmbStage(vehicle));
  const title = `Drag ${vehicleIdentityTitle(vehicle) || 'vehicle'} to another PMB bucket`;
  const finishButton = stage
    ? `<button class="small-button pmb-finish-button" type="button" data-move-pmb-stage-key="${escapeHtml(key)}" data-move-pmb-stage-value="" title="Choose Complete, STOPPAGE, or Move only, then return this vehicle to PMB unallocated">Finish / unallocate</button>`
    : '';
  return `
    <article class="pmb-vehicle-card pmb-vehicle-pill ${isPdcBlocked(vehicle) ? 'is-blocked' : ''}" draggable="true" data-pmb-drag-key="${escapeHtml(key)}" data-open-stock="${escapeHtml(key)}" title="${escapeHtml(title)}">
      <div class="pmb-pill-main">
        ${pmbBayPillIdentityHtml(vehicle)}
        ${pmbPillCustomerHtml(vehicle)}
      </div>
      <div class="pmb-pill-bottom">
        ${pmbOutstandingStationChipsHtml(vehicle)}
        ${finishButton}
      </div>
    </article>`;
}

function pdcJsonbCanonicalText(value) {
  if (Array.isArray(value)) return `[${value.map(pdcJsonbCanonicalText).join(', ')}]`;
  if (value && typeof value === 'object') {
    const keys = Object.keys(value).sort((left, right) => left.length - right.length || (left < right ? -1 : left > right ? 1 : 0));
    return `{${keys.map(key => `${JSON.stringify(key)}: ${pdcJsonbCanonicalText(value[key])}`).join(', ')}}`;
  }
  return JSON.stringify(value);
}

async function togglePdcJobCompletionFromCard(stockKey, jobKey) {
  const cleanKey = String(stockKey || '').trim();
  const def = PDC_JOB_BY_KEY.get(String(jobKey || '').toLowerCase());
  if (!cleanKey || !def) return;
  const vehicle = app.data.find(v => vehicleKey(v) === cleanKey || v.stock === cleanKey || v.id === cleanKey);
  if (!vehicle) return;
  const currentlyComplete = pdcJobComplete(vehicle, def);
  if (currentlyComplete && vehicleCollectedFromRft(vehicle)) {
    pdcNotify('Completed / collected vehicles are locked. This sign-off cannot be removed from a completed vehicle.');
    return;
  }
  const actionText = currentlyComplete ? 'remove the sign-off from' : 'sign off';
  if (!window.confirm(`${actionText.charAt(0).toUpperCase()}${actionText.slice(1)} ${def.label} for ${displayStockNumber(vehicle) || 'this vehicle'}?`)) return;
  if (vehicleLifecycleSharedModeActive() && !currentlyComplete && String(window.PDC_AUTH_CONTEXT?.role || '').toLowerCase() === 'administrator') {
    const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
    const detail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
    if (!detail && canonicalId) await loadVehicleWorkshopDetail(vehicle, { force: true });
    const refreshedDetail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
    const stage = vehicleWorkshopStageCode(pmbStageForPdcJob(def));
    const booking = (refreshedDetail?.bookings || []).find(row => vehicleWorkshopStageCode(row.stage_code || '') === stage && ['queued', 'planned', 'started', 'stoppage'].includes(String(row.status || '').toLowerCase()) && row.deleted_at == null);
    if (booking && window.__workshopSharedActions?.completeVehicleDepartment) {
      const idempotencyKey = globalThis.crypto?.randomUUID?.() || `ui772-complete-${canonicalId}-${Date.now()}`;
      const payload = { contract: 'department-complete-772', vehicle_id: canonicalId, work_key: String(def.key || '').toLowerCase(), expected_vehicle_version: Math.max(Number(refreshedDetail?.vehicle_version || 0), Number(vehicle.__emailVehicleVersion || 0), Number(vehicle.version || 0)), booking_id: booking.booking_id || booking.id, expected_booking_version: Number(booking.booking_version || booking.version || 0), idempotency_key: idempotencyKey, reason: `Completed ${def.label} from the vehicle card` };
      const bytes = await globalThis.crypto?.subtle?.digest('SHA-256', new TextEncoder().encode(pdcJsonbCanonicalText(payload)));
      const requestHash = bytes ? Array.from(new Uint8Array(bytes), value => value.toString(16).padStart(2, '0')).join('') : '';
      const result = await window.__workshopSharedActions.completeVehicleDepartment({
        ...payload,
        vehicleId: payload.vehicle_id,
        workKey: payload.work_key,
        expectedVehicleVersion: payload.expected_vehicle_version,
        bookingId: payload.booking_id,
        expectedBookingVersion: payload.expected_booking_version,
        idempotencyKey: payload.idempotency_key,
        requestHash,
      });
      if (!result || result.ok !== true) { pdcNotify('The department completion was not saved. The authoritative vehicle and booking state was preserved.'); return false; }
      await refreshSharedVehicleWorkState(vehicle);
      await loadVehicleWorkshopDetail(vehicle, { force: true });
      renderAll();
      return true;
    }
  }
  const now = nowIsoString();
  const operator = getCurrentOperatorName();
  const updates = { [def.completeKey]: !currentlyComplete, pdcQcComplete: false, pdcQcCompleteAt: '', pdcQcCompleteBy: '' };
  if (!currentlyComplete) {
    updates[def.requireKey] = true;
    updates[def.completeAtKey] = now;
    updates[def.completeByKey] = operator;
  } else {
    updates[def.completeAtKey] = '';
    updates[def.completeByKey] = '';
  }
  recordVehicleAudit(vehicle, currentlyComplete ? 'Job sign-off removed' : 'Job signed off', { job: def.label, by: operator });
  saveVehicleEdits(vehicleKey(vehicle), updates);
  if (!currentlyComplete) {
    offerSalespersonChangeEmail(vehicle, {
      title: `${def.label} completed`,
      subject: 'PDC work completed',
      details: [`${def.label} was signed off by ${operator}.`],
    });
  }
}

function bindPmbDragBoard(host) {
  bindIncomingCardSelection(host);
  bindVehicleLabelButtons(host);
  $$('.workflow-stage-bucket', host).forEach(bucket => {
    bucket.addEventListener('toggle', () => {
      if (bucket.open) app.workflowBucketsCollapsed = false;
      scheduleWorkflowFloatingHeaderUpdate();
    });
  });
  $$('[data-pmb-sub-filter]', host).forEach(button => button.addEventListener('click', () => applyPmbSubFilter(button.dataset.pmbSubFilter || '')));
  $$('[data-open-pmb-bays]', host).forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    openPmbStageBayBoard(button.dataset.openPmbBays || '');
  }));
  $$('[data-close-pmb-bays]', host).forEach(button => button.addEventListener('click', closePmbStageBayBoard));
  $$('[data-add-pmb-mechanic]', host).forEach(button => button.addEventListener('click', addMechanicFromPrompt));
  $$('[data-add-sublet-provider]', host).forEach(button => button.addEventListener('click', addSubletProviderFromPrompt));
  $$('[data-open-stock]', host).forEach(button => {
    button.addEventListener('click', event => {
      event.stopPropagation();
      const preventUntil = Number(button.dataset.preventOpenUntil || 0);
      if (preventUntil && Date.now() < preventUntil) return;
      void openVehicleFromStockClick(button.dataset.openStock, button);
    });
  });
  $$('[data-toggle-pdc-job-complete]', host).forEach(marker => {
    marker.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      void togglePdcJobCompletionFromCard(marker.dataset.jobStock, marker.dataset.togglePdcJobComplete);
    });
    marker.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopPropagation();
      void togglePdcJobCompletionFromCard(marker.dataset.jobStock, marker.dataset.togglePdcJobComplete);
    });
  });
  $$('[data-transfer-rft-stock]', host).forEach(button => {
    button.addEventListener('click', event => {
      event.stopPropagation();
      transferVehicleToRftFromCard(button.dataset.transferRftStock);
    });
  });
  $$('[data-assign-pmb-bay-key]', host).forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      void assignPmbVehicleToBay(
        button.dataset.assignPmbBayKey,
        button.dataset.assignPmbBayStage,
        button.dataset.assignPmbBayNumber || '',
      );
    });
  });
  $$('[data-move-pmb-stage-key]', host).forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      void movePmbVehicleToStage(button.dataset.movePmbStageKey, button.dataset.movePmbStageValue || '');
    });
  });
  $$('[data-pmb-bay-hours-key]', host).forEach(input => {
    input.addEventListener('click', event => event.stopPropagation());
    input.addEventListener('change', () => updatePmbBayHours(input.dataset.pmbBayHoursKey, input.dataset.pmbBayHoursStage, input.value));
  });
  $$('[data-pmb-bay-mechanic-key]', host).forEach(select => {
    select.addEventListener('click', event => event.stopPropagation());
    select.addEventListener('change', () => updatePmbBayMechanic(select.dataset.pmbBayMechanicKey, select.dataset.pmbBayMechanicStage, select.value));
  });
  $$('[data-pmb-bay-provider-key]', host).forEach(select => {
    select.addEventListener('click', event => event.stopPropagation());
    select.addEventListener('change', () => updatePmbBaySubletProvider(select.dataset.pmbBayProviderKey, select.dataset.pmbBayProviderStage, select.value));
  });
  $$('[data-complete-pmb-bay-work]', host).forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      completePmbBayWork(button.dataset.completePmbBayWork, button.dataset.completePmbBayStage);
    });
  });
  $$('[data-move-next-pmb-stage]', host).forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      moveVehicleToNextPmbStageFromBay(button.dataset.moveNextPmbStage, button.dataset.moveNextFromStage);
    });
  });
  $$('[data-pmb-drag-key]', host).forEach(card => bindPmbDraggable(card, card.dataset.pmbDragKey));
  $$('[data-pmb-drop-stage]', host).forEach(dropZone => bindPmbDropTarget(dropZone));
  $$('[data-pmb-bay-drop-stage]', host).forEach(dropZone => bindPmbBayDropTarget(dropZone));
  $$('[data-pmb-complete-drop-stage]', host).forEach(dropZone => bindPmbCompletionDropTarget(dropZone));
  bindPmbScheduleChips(host);
}

function bindPmbTableRowDragging(table) {
  if (!table || app.quickFilter !== 'pmb') return;
  $$('[data-pmb-table-drag-key]', table).forEach(row => bindPmbDraggable(row, row.dataset.pmbTableDragKey));
}

function bindPmbDraggable(element, key) {
  if (!element || !key) return;
  element.addEventListener('dragstart', event => {
    app.pmbDraggingKey = key;
    element.classList.add('pmb-dragging-source');
    document.body.classList.add('pmb-dragging');
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', key);
      event.dataTransfer.setData('application/x-vehicle-key', key);
    }
  });
  element.addEventListener('dragend', () => {
    element.classList.remove('pmb-dragging-source');
    document.body.classList.remove('pmb-dragging');
    $$('.pmb-drop-lane.drag-over').forEach(lane => lane.classList.remove('drag-over'));
    $$('.pmb-bay.drag-over, .pmb-bay-unassigned.drag-over, .pmb-schedule-lane.drag-over').forEach(target => target.classList.remove('drag-over'));
    app.pmbDraggingKey = '';
  });
}

function bindPmbDropTarget(dropTarget) {
  if (!dropTarget) return;
  dropTarget.addEventListener('dragover', event => {
    if (!app.pmbDraggingKey && !event.dataTransfer) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    dropTarget.closest('.pmb-drop-lane')?.classList.add('drag-over');
  });
  dropTarget.addEventListener('dragleave', event => {
    const lane = dropTarget.closest('.pmb-drop-lane');
    if (lane && !lane.contains(event.relatedTarget)) lane.classList.remove('drag-over');
  });
  dropTarget.addEventListener('drop', event => {
    event.preventDefault();
    event.stopPropagation();
    const key = event.dataTransfer?.getData('application/x-vehicle-key') || event.dataTransfer?.getData('text/plain') || app.pmbDraggingKey;
    const stage = dropTarget.dataset.pmbDropStage || '';
    dropTarget.closest('.pmb-drop-lane')?.classList.remove('drag-over');
    void movePmbVehicleToStage(key, stage);
  });
}

function pmbMovementResolutionChoiceModal(vehicle = {}, currentStage = '', nextStage = '') {
  const stock = displayStockNumber(vehicle) || 'this vehicle';
  const area = pmbStageLabel(currentStage) || 'the current area';
  const nextArea = pmbStageLabel(nextStage) || 'Unallocated';
  return new Promise(resolve => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay pmb-resolution-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'pmb-resolution-modal-title');
    overlay.innerHTML = `
      <section class="modal-card pmb-resolution-modal-card">
        <button class="modal-close" type="button" data-pmb-resolution-cancel aria-label="Cancel movement">×</button>
        <div class="panel-header">
          <div>
            <h2 id="pmb-resolution-modal-title">Confirm movement</h2>
            <p>${escapeHtml(stock)} is leaving ${escapeHtml(area)} for ${escapeHtml(nextArea)}. Tick what applies.</p>
          </div>
        </div>
        <div class="pmb-resolution-options" role="group" aria-label="Movement outcome">
          <label class="pmb-resolution-option is-complete">
            <input type="checkbox" value="complete" data-pmb-resolution-choice checked>
            <span>
              <strong>${escapeHtml(area)} complete</strong>
              <small>Sign off this PMB job and move the vehicle.</small>
            </span>
          </label>
          <label class="pmb-resolution-option is-stoppage">
            <input type="checkbox" value="stoppage" data-pmb-resolution-choice>
            <span>
              <strong>Parts / job STOPPAGE</strong>
              <small>Move the vehicle and record why this PMB job is stopped.</small>
            </span>
          </label>
          <label class="pmb-resolution-option is-move">
            <input type="checkbox" value="move" data-pmb-resolution-choice>
            <span>
              <strong>Move only - keep job open</strong>
              <small>Move or unallocate the vehicle without ticking off the PMB job.</small>
            </span>
          </label>
        </div>
        <label class="pmb-resolution-reason" data-pmb-resolution-reason-wrap hidden>
          <span>STOPPAGE reason</span>
          <input type="text" value="${escapeHtml(area)} STOPPAGE" data-pmb-resolution-reason>
        </label>
        <div class="edit-actions pmb-resolution-actions">
          <button class="secondary" type="button" data-pmb-resolution-cancel>Cancel</button>
          <button class="primary" type="button" data-pmb-resolution-save>Apply</button>
        </div>
      </section>
    `;
    const finish = value => {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
      resolve(value);
    };
    const selectedChoice = () => overlay.querySelector('[data-pmb-resolution-choice]:checked')?.value || '';
    const syncReason = () => {
      const showReason = selectedChoice() === 'stoppage';
      overlay.querySelector('[data-pmb-resolution-reason-wrap]').hidden = !showReason;
    };
    const onKeydown = event => {
      if (event.key === 'Escape') finish(null);
    };
    overlay.querySelectorAll('[data-pmb-resolution-choice]').forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          overlay.querySelectorAll('[data-pmb-resolution-choice]').forEach(other => {
            if (other !== input) other.checked = false;
          });
        } else if (!selectedChoice()) {
          input.checked = true;
        }
        syncReason();
      });
    });
    overlay.querySelectorAll('[data-pmb-resolution-cancel]').forEach(btn => btn.addEventListener('click', () => finish(null)));
    overlay.addEventListener('click', event => {
      if (event.target === overlay) finish(null);
    });
    overlay.querySelector('[data-pmb-resolution-save]').addEventListener('click', () => {
      const choice = selectedChoice();
      const reason = cleanNavisionText(overlay.querySelector('[data-pmb-resolution-reason]')?.value || `${area} STOPPAGE`);
      finish({ choice, reason: reason || `${area} STOPPAGE` });
    });
    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKeydown);
    syncReason();
    overlay.querySelector('[data-pmb-resolution-save]')?.focus();
  });
}

async function pmbMovementResolutionUpdates(vehicle = {}, fromStage = '', toStage = '') {
  const currentStage = normalizePmbStage(fromStage);
  const nextStage = normalizePmbStage(toStage);
  if (!currentStage || currentStage === nextStage) return {};
  const jobDef = pmbStageJobDef(currentStage);
  if (!jobDef || pdcJobComplete(vehicle, jobDef)) return {};
  const result = await pmbMovementResolutionChoiceModal(vehicle, currentStage, nextStage);
  if (!result) return null;
  const choice = String(result.choice || '').trim().toLowerCase();
  const now = nowIsoString();
  const operator = getCurrentOperatorName();
  const area = pmbStageLabel(currentStage) || 'the current area';
  if (choice === 'stoppage') {
    const reason = cleanNavisionText(result.reason || `${area} STOPPAGE`);
    return { pdcBlocked: true, pdcBlockReason: reason, pdcBlockedAt: now, pdcBlockedBy: operator };
  }
  if (choice === 'complete') {
    return {
      [jobDef.requireKey]: true,
      [jobDef.completeKey]: true,
      [jobDef.completeAtKey]: now,
      [jobDef.completeByKey]: operator,
      pdcQcComplete: false,
      pdcQcCompleteAt: '',
      pdcQcCompleteBy: '',
      pdcBlocked: false,
      pdcBlockReason: '',
    };
  }
  return {};
}

function recordPmbMovementResolutionAudit(vehicle = {}, fromStage = '', toStage = '', updates = {}) {
  const currentStage = normalizePmbStage(fromStage);
  const nextStage = normalizePmbStage(toStage);
  const operator = getCurrentOperatorName();
  if (updates.pdcBlocked === true) {
    recordVehicleAudit(vehicle, 'PMB movement STOPPAGE recorded', { stage: pmbStageLabel(currentStage), reason: updates.pdcBlockReason || 'STOPPAGE', by: operator });
    return;
  }
  const jobDef = pmbStageJobDef(currentStage);
  if (jobDef && updates[jobDef.completeKey] === true) {
    recordVehicleAudit(vehicle, 'Job signed off by PMB movement', { job: jobDef.label, from: pmbStageLabel(currentStage), to: pmbStageLabel(nextStage) || 'Unallocated', by: operator });
  }
}

function partsIncompleteMovementStage(stage = '') {
  return ['BUS_4X4', 'TINT', 'HOIST', 'FITTING', 'FABRICATION', 'ELECTRICAL', 'TYRE', 'PIT_INSPECTION'].includes(normalizePmbStage(stage));
}

function partsMovementOverrideRoleAllowed(role = '') {
  return /(^|[^a-z])(manager|admin|administrator)([^a-z]|$)/i.test(cleanNavisionText(role));
}

function pmbPhysicalBayEntry(currentStage = '', currentBay = '', nextStage = '', nextBay = '') {
  const normalizedCurrent = normalizePmbStage(currentStage);
  const normalizedNext = normalizePmbStage(nextStage);
  const normalizedNextBay = normalizePmbBayNumber(nextBay, normalizedNext);
  if (!normalizedNext || !normalizedNextBay) return false;
  return normalizedCurrent !== normalizedNext || !normalizePmbBayNumber(currentBay, normalizedCurrent);
}

function confirmPartsIncompleteMovement() {
  return { updates: {}, audit: null };
}

async function movePmbVehicleToStage(key, stage) {
  const cleanKey = String(key || '').trim();
  if (!cleanKey) return;
  const vehicle = selectedVehicle(cleanKey);
  if (!vehicle) return;
  if (statusCategory(vehicle) !== 'pmb') {
    pdcNotify('That vehicle is not currently in PMB. Transfer it from Yard Hold to PMB first.');
    return;
  }
  const nextStage = normalizePmbStage(stage);
  const currentStage = normalizePmbStage(vehicle.pmbBayStage || vehicle.pmbStage || inferredPmbStage(vehicle) || vehicle.pdcWorkStage || vehicle.workStage || '');
  if (currentStage === nextStage) return;
  const now = nowIsoString();
  const resolutionUpdates = await pmbMovementResolutionUpdates(vehicle, currentStage, nextStage);
  if (resolutionUpdates === null) return;
  const updates = {
    ...resolutionUpdates,
    pdcLocation: 'PMB',
    manualLocation: 'PMB',
    pdcLocationLocked: true,
    pmbEnteredAt: pmbEnteredTimestamp(vehicle) || now,
    pmbTransferredAt: vehicle.pmbTransferredAt || now,
    pdcLocationUpdatedAt: vehicle.pdcLocationUpdatedAt || now,
    pmbStage: nextStage,
    pmbStageUpdatedAt: now,
    pmbStageEnteredAt: now,
    pmbBayStage: '',
    pmbBayNumber: '',
    pmbBayEstimatedHours: '',
    pmbBayEnteredAt: '',
    pmbBayScheduledStartAt: '',
    pmbBayCompletedAt: '',
    pmbBayCompletedBy: '',
    pmbBayCompletedStage: '',
    pmbBayMechanic: '',
  };
  const snapshot = { ...vehicle };
  try {
    runStorageTransaction('Move PMB vehicle to stage', [EDITS_KEY, AUDIT_LOG_KEY], () => {
      recordPmbMovementResolutionAudit(vehicle, currentStage, nextStage, resolutionUpdates);
      recordVehicleAudit(vehicle, 'PMB bucket moved', { from: pmbStageLabel(currentStage) || 'Unallocated', to: pmbStageLabel(nextStage) || 'Unallocated' });
      if (!saveVehicleEdits(vehicleKey(vehicle), updates)) throw new Error('The PMB stage update failed.');
    });
  } catch (error) {
    Object.keys(vehicle).forEach(field => { if (!Object.prototype.hasOwnProperty.call(snapshot, field)) delete vehicle[field]; });
    Object.assign(vehicle, snapshot);
    pdcNotify(error.message || String(error));
    return;
  }
  const completedDef = pmbStageJobDef(currentStage);
  if (resolutionUpdates.pdcBlocked === true) {
    offerSalespersonChangeEmail(vehicle, {
      title: `${pmbStageLabel(currentStage) || 'PMB'} STOPPAGE recorded`,
      subject: 'PDC STOPPAGE update',
      details: [resolutionUpdates.pdcBlockReason || 'A production STOPPAGE was recorded.', `Moved to ${pmbStageLabel(nextStage) || 'Unallocated'}.`],
    });
  } else if (completedDef && resolutionUpdates[completedDef.completeKey] === true) {
    offerSalespersonChangeEmail(vehicle, {
      title: `${completedDef.label} completed`,
      subject: 'PDC work completed',
      details: [`${completedDef.label} was signed off by ${getCurrentOperatorName()}.`, `Moved to ${pmbStageLabel(nextStage) || 'Unallocated'}.`],
    });
  }
}


function openPmbStageBayBoard(stage = '') {
  const normalizedStage = normalizePmbStage(stage);
  if (!normalizedStage) return;
  app.quickFilter = 'pmb';
  app.pmbSubFilter = normalizedStage;
  app.activePmbBayStage = normalizedStage;
  showView('workflow');
  renderWorkflowBoard();
}

function closePmbStageBayBoard() {
  app.activePmbBayStage = '';
  app.pmbSubFilter = '';
  document.body.classList.remove('pmb-station-mode');
  showView('workflow');
  renderWorkflowBoard();
}

function bindPmbBayDropTarget(dropTarget) {
  if (!dropTarget) return;
  dropTarget.addEventListener('dragover', event => {
    if (!app.pmbDraggingKey && !event.dataTransfer) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    dropTarget.classList.add('drag-over');
  });
  dropTarget.addEventListener('dragleave', event => {
    if (!dropTarget.contains(event.relatedTarget)) dropTarget.classList.remove('drag-over');
  });
  dropTarget.addEventListener('drop', event => {
    event.preventDefault();
    event.stopPropagation();
    const key = event.dataTransfer?.getData('application/x-vehicle-key') || event.dataTransfer?.getData('text/plain') || app.pmbDraggingKey;
    const stage = dropTarget.dataset.pmbBayDropStage || '';
    const bay = dropTarget.dataset.pmbBayDropNumber || '';
    let scheduledStartIso = '';
    if (bay) {
      const board = dropTarget.closest('[data-pmb-schedule-start]');
      if (board) {
        const config = pmbScheduleConfigFromBoard(board);
        const rect = dropTarget.getBoundingClientRect();
        const offsetPx = Math.max(0, event.clientX - rect.left);
        const offsetHours = Math.max(0, Math.min(config.hours, snapScheduleHours(offsetPx / config.hourScale)));
        scheduledStartIso = isoFromScheduleOffsetHours(config, offsetHours);
      }
    }
    dropTarget.classList.remove('drag-over');
    void assignPmbVehicleToBay(key, stage, bay, scheduledStartIso);
  });
}

function bindPmbCompletionDropTarget(dropTarget) {
  if (!dropTarget) return;
  dropTarget.addEventListener('dragover', event => {
    if (!app.pmbDraggingKey && !event.dataTransfer) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    dropTarget.classList.add('drag-over');
  });
  dropTarget.addEventListener('dragleave', event => {
    if (!dropTarget.contains(event.relatedTarget)) dropTarget.classList.remove('drag-over');
  });
  dropTarget.addEventListener('drop', event => {
    event.preventDefault();
    event.stopPropagation();
    const key = event.dataTransfer?.getData('application/x-vehicle-key') || event.dataTransfer?.getData('text/plain') || app.pmbDraggingKey;
    dropTarget.classList.remove('drag-over');
    void movePmbVehicleToStage(key, '');
  });
}

function pmbSuggestedBayStartIso(stage = '', bay = '', vehicle = null, requestedStartIso = '') {
  const normalizedStage = normalizePmbStage(stage);
  const bayNumber = normalizePmbBayNumber(bay, normalizedStage);
  if (!normalizedStage || !bayNumber) return '';
  const existingStart = vehicle && pmbBayNumber(vehicle, normalizedStage) === bayNumber ? parseIsoTimestamp(vehicle.pmbBayScheduledStartAt || '') : null;
  if (existingStart && !requestedStartIso) return existingStart.toISOString();
  let latestEnd = null;
  app.data.forEach(row => {
    if (row === vehicle) return;
    if (statusCategory(row) !== 'pmb') return;
    if (normalizePmbStage(inferredPmbStage(row)) !== normalizedStage) return;
    if (pmbBayNumber(row, normalizedStage) !== bayNumber) return;
    const start = pmbBayScheduledStart(row) || parseIsoTimestamp(row.pmbBayEnteredAt || '');
    if (!start) return;
    const rawHours = pmbBayHours(row);
    const hours = rawHours === '' ? 1 : Math.max(PMB_SCHEDULE_SNAP_HOURS, Number(rawHours));
    const end = pmbAddProductionHours(start, hours);
    if (!latestEnd || end > latestEnd) latestEnd = end;
  });
  if (requestedStartIso) {
    const requested = pmbNextProductionSlotDate(parseIsoTimestamp(requestedStartIso) || new Date());
    if (latestEnd && requested < latestEnd) return latestEnd.toISOString();
    return requested.toISOString();
  }
  return (latestEnd || pmbNextProductionSlotDate()).toISOString();
}

async function assignPmbVehicleToBay(key, stage, bay, requestedStartIso = '', transactionOptions = {}) {
  const cleanKey = String(key || '').trim();
  const nextStage = normalizePmbStage(stage);
  if (!cleanKey || !nextStage) return;
  const vehicle = selectedVehicle(cleanKey);
  if (!vehicle) return;
  if (statusCategory(vehicle) !== 'pmb') {
    pdcNotify('That vehicle is not currently in PMB. Transfer it from Yard Hold to PMB first.');
    return;
  }
  const bayNumber = normalizePmbBayNumber(bay, nextStage);
  const currentStage = normalizePmbStage(vehicle.pmbBayStage || inferredPmbStage(vehicle));
  const currentBay = pmbBayNumber(vehicle, currentStage);
  const entersNumberedBay = pmbPhysicalBayEntry(currentStage, currentBay, nextStage, bayNumber);
  let swap = null;
  if (bayNumber) {
    const occupied = pmbBayOccupants(nextStage, bayNumber, cleanKey);
    if (occupied.length) {
      const currentStageForSwap = normalizePmbStage(vehicle.pmbBayStage || inferredPmbStage(vehicle));
      if (occupied.length !== 1 || currentStageForSwap !== nextStage || !currentBay) {
        pdcNotify(`${pmbStageLabel(nextStage)} Bay ${bayNumber} already has a vehicle. Move that vehicle out first, or use bay-to-bay swap from another numbered bay.`);
        return;
      }
      const other = occupied[0];
      swap = { other, otherKey: vehicleKey(other) };
    }
    // Bay assignment is already limited by the specific bay number above. Do not also block
    // moves because the PMB bucket is over its row/queue limit; that made valid bay-to-bay
    // and unallocated-to-empty-bay moves fail on busy days.
  }
  const partsDecision = entersNumberedBay ? await confirmPartsIncompleteMovement(vehicle, nextStage) : { updates: {}, audit: null };
  if (partsDecision === null) return;
  const resolutionUpdates = await pmbMovementResolutionUpdates(vehicle, currentStage, nextStage);
  if (resolutionUpdates === null) return;
  const now = nowIsoString();
  const bayLabel = bayNumber ? `Bay ${bayNumber}` : 'No bay';
  const updates = {
    ...partsDecision.updates,
    ...resolutionUpdates,
    pdcLocation: 'PMB',
    manualLocation: 'PMB',
    pdcLocationLocked: true,
    pmbEnteredAt: pmbEnteredTimestamp(vehicle) || now,
    pmbTransferredAt: vehicle.pmbTransferredAt || now,
    pdcLocationUpdatedAt: vehicle.pdcLocationUpdatedAt || now,
    pmbStage: nextStage,
    pmbBayStage: bayNumber ? nextStage : '',
    pmbBayNumber: bayNumber || '',
    pmbBayEnteredAt: bayNumber ? now : '',
    pmbBayScheduledStartAt: bayNumber ? pmbSuggestedBayStartIso(nextStage, bayNumber, vehicle, requestedStartIso) : '',
    pmbBayMechanic: bayNumber && currentStage === nextStage ? pmbBayMechanic(vehicle) : '',
    pmbBayCompletedAt: '',
    pmbBayCompletedBy: '',
    pmbBayCompletedStage: '',
    ...(entersNumberedBay ? { pdcQcComplete: false, pdcQcCompleteAt: '', pdcQcCompleteBy: '' } : {}),
  };
  if (currentStage !== nextStage) {
    updates.pmbStageUpdatedAt = now;
    updates.pmbStageEnteredAt = now;
  }
  const vehicleSnapshot = { ...vehicle };
  const swapSnapshot = swap ? { ...swap.other } : null;
  const extraTransactionKeys = Array.isArray(transactionOptions.keys) ? transactionOptions.keys : [];
  try {
    runStorageTransaction('Assign vehicle to PMB bay', [EDITS_KEY, AUDIT_LOG_KEY, ...extraTransactionKeys], () => {
      if (swap) {
        saveVehicleEdits(swap.otherKey, {
          pdcLocation: 'PMB', manualLocation: 'PMB', pdcLocationLocked: true,
          pmbStage: nextStage, pmbBayStage: nextStage, pmbBayNumber: currentBay,
          pmbBayEnteredAt: now, pmbBayCompletedAt: '', pmbBayCompletedBy: '', pmbBayCompletedStage: '',
        }, { render: false });
        recordVehicleAudit(swap.other, 'Swapped PMB bay', { stage: pmbStageLabel(nextStage), bay: `Bay ${currentBay}` });
      }
      recordPmbMovementResolutionAudit(vehicle, currentStage, nextStage, resolutionUpdates);
      if (currentStage !== nextStage) recordVehicleAudit(vehicle, 'PMB bucket moved', { from: pmbStageLabel(currentStage) || 'Unallocated', to: pmbStageLabel(nextStage) || 'Unallocated' });
      if (partsDecision.audit) recordVehicleAudit(vehicle, 'Parts-incomplete movement override', partsDecision.audit);
      recordVehicleAudit(vehicle, bayNumber ? 'Assigned to PMB bay' : 'Removed from PMB bay', { stage: pmbStageLabel(nextStage), bay: bayLabel });
      if (!saveVehicleEdits(vehicleKey(vehicle), updates)) throw new Error('The vehicle bay update failed.');
      if (typeof transactionOptions.afterAssign === 'function') transactionOptions.afterAssign(vehicle, updates);
    });
  } catch (error) {
    Object.keys(vehicle).forEach(field => { if (!Object.prototype.hasOwnProperty.call(vehicleSnapshot, field)) delete vehicle[field]; });
    Object.assign(vehicle, vehicleSnapshot);
    if (swap && swapSnapshot) {
      Object.keys(swap.other).forEach(field => { if (!Object.prototype.hasOwnProperty.call(swapSnapshot, field)) delete swap.other[field]; });
      Object.assign(swap.other, swapSnapshot);
    }
    pdcNotify(error.message || String(error));
    return false;
  }
  app.activePmbBayStage = nextStage;
  return true;
}

function updatePmbBayHours(key, stage, value) {
  const cleanKey = String(key || '').trim();
  const vehicle = app.data.find(v => vehicleKey(v) === cleanKey || v.stock === cleanKey || v.id === cleanKey);
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  if (!vehicle || !normalizedStage) return;
  const raw = String(value ?? '').trim();
  const parsed = raw === '' ? '' : Number.parseFloat(raw);
  if (parsed !== '' && (!Number.isFinite(parsed) || parsed < 0)) {
    pdcNotify('Enter a valid planned-hours number, for example 2, 3.5 or 0.25.');
    renderKpis();
    return;
  }
  const nextValue = parsed === '' ? '' : String(Number(snapScheduleHours(parsed).toFixed(2)));
  recordVehicleAudit(vehicle, 'Bay planned hours updated', { stage: pmbStageLabel(normalizedStage), hours: nextValue || 'blank' });
  saveVehicleEdits(vehicleKey(vehicle), { pdcLocation: 'PMB', manualLocation: 'PMB', pdcLocationLocked: true, pmbBayEstimatedHours: nextValue });
}

function updatePmbBayScheduleStart(key, stage, value) {
  const cleanKey = String(key || '').trim();
  const vehicle = app.data.find(v => vehicleKey(v) === cleanKey || v.stock === cleanKey || v.id === cleanKey);
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  if (!vehicle || !normalizedStage) return;
  let nextIso = isoFromDatetimeLocalValue(value || '');
  if (!nextIso) {
    pdcNotify('Enter a valid scheduled start date and time.');
    renderKpis();
    return;
  }
  nextIso = pmbNextProductionSlotDate(parseIsoTimestamp(nextIso)).toISOString();
  recordVehicleAudit(vehicle, 'Bay scheduled start updated', { stage: pmbStageLabel(normalizedStage), start: new Date(nextIso).toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) });
  saveVehicleEdits(vehicleKey(vehicle), { pdcLocation: 'PMB', manualLocation: 'PMB', pdcLocationLocked: true, pmbBayScheduledStartAt: nextIso });
}

function savePmbBayDetailForm(vehicle, form) {
  // Defence in depth for direct/stale-DOM invocation: reject before parsing,
  // auditing or touching browser-local operational state.
  if (vehicleLifecycleSharedModeActive()) return false;
  if (!vehicle || !form) return false;
  const stage = normalizePmbStage(vehicle.pmbBayStage || inferredPmbStage(vehicle));
  if (!stage) return false;
  const hoursInput = form.elements?.namedItem('pmbBayEstimatedHours') || form.querySelector('[name="pmbBayEstimatedHours"]');
  const startInput = form.elements?.namedItem('pmbBayScheduledStartAt') || form.querySelector('[name="pmbBayScheduledStartAt"]');
  const assigneeInput = form.elements?.namedItem('pmbBayAssignee') || form.querySelector('[name="pmbBayAssignee"]');
  const rawHours = String(hoursInput?.value ?? '').trim();
  const parsedHours = rawHours === '' ? '' : Number.parseFloat(rawHours);
  if (parsedHours !== '' && (!Number.isFinite(parsedHours) || parsedHours < 0)) {
    pdcNotify('Enter a valid planned-hours number, for example 2, 3.5 or 0.25.');
    return false;
  }
  let startIso = isoFromDatetimeLocalValue(startInput?.value || '');
  if (!startIso) {
    pdcNotify('Enter a valid scheduled start date and time.');
    return false;
  }
  startIso = pmbNextProductionSlotDate(parseIsoTimestamp(startIso)).toISOString();
  const assignee = cleanNavisionText(assigneeInput?.value || '');
  const snappedHours = parsedHours === '' ? '' : String(Number(snapScheduleHours(parsedHours).toFixed(2)));
  const updates = {
    pdcLocation: 'PMB',
    manualLocation: 'PMB',
    pdcLocationLocked: true,
    pmbBayScheduledStartAt: startIso,
    pmbBayEstimatedHours: snappedHours,
  };
  if (stage === 'SUBLET') {
    updates.pmbSubletProvider = assignee;
    // No roster-add call here: pmbBayAssignee is a <select> populated
    // exclusively from loadSubletProviders() (Supabase-backed as of
    // Stage 2A), so `assignee` can only ever be a name that already
    // exists -- there is nothing new to add.
  } else {
    updates.pmbBayMechanic = assignee;
  }
  recordVehicleAudit(vehicle, 'Bay detail updated', {
    stage: pmbStageLabel(stage),
    start: new Date(startIso).toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }),
    hours: updates.pmbBayEstimatedHours || 'blank',
    assignee: assignee || 'Unassigned',
  });
  saveVehicleEdits(vehicleKey(vehicle), updates);
  return true;
}


function updatePmbBayMechanic(key, stage, value) {
  const cleanKey = String(key || '').trim();
  const vehicle = app.data.find(v => vehicleKey(v) === cleanKey || v.stock === cleanKey || v.id === cleanKey);
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  if (!vehicle || !normalizedStage) return;
  const mechanic = cleanNavisionText(value || '');
  // No roster-add call here: `value` comes from a <select> populated
  // exclusively from loadMechanics() (Supabase-backed as of Stage 2A), so
  // it can only ever be a name that already exists.
  recordVehicleAudit(vehicle, 'Bay mechanic assigned', { stage: pmbStageLabel(normalizedStage), mechanic: mechanic || 'Unassigned' });
  saveVehicleEdits(vehicleKey(vehicle), { pmbBayMechanic: mechanic });
}

async function updatePmbBaySubletProvider(key, stage, value) {
  const cleanKey = String(key || '').trim();
  const vehicle = app.data.find(v => vehicleKey(v) === cleanKey || v.stock === cleanKey || v.id === cleanKey);
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  if (!vehicle || !normalizedStage) return;
  const provider = cleanNavisionText(value || '');
  if (vehicle.__emailVehicleServerAuthoritative === true) {
    const bookings = subletRows().filter(row => vehicleKey(row) === cleanKey && row.__subletBookingId && row.__subletBookingStatus === 'active');
    if (bookings.length !== 1) {
      pdcNotify(bookings.length === 0 ? 'No active canonical Sublet booking exists. Use Create booking first; no legacy placeholder update was sent.' : 'Multiple active Sublet bookings exist. Open Sublet and select the exact booking before changing provider. No change was made.');
      return false;
    }
    return updateSubletField(bookings[0].__subletBookingId, 'pmbSubletProvider', provider);
  }
  // Local fixtures retain their existing presentation-only behavior.
  recordVehicleAudit(vehicle, 'External provider assigned', { stage: pmbStageLabel(normalizedStage), provider: provider || 'Unassigned' });
  saveVehicleEdits(vehicleKey(vehicle), { pmbSubletProvider: provider });
  return true;
}

function completePmbBayWork(key, stage, transactionOptions = {}) {
  // Shared lifecycle mode is server-authoritative. The canonical completion
  // flow lives in Workshop Planner; this legacy browser-storage handler must
  // remain unreachable even when called directly from stale markup.
  if (vehicleLifecycleSharedModeActive()) return false;
  const cleanKey = String(key || '').trim();
  const vehicle = selectedVehicle(cleanKey);
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  const def = pmbStageJobDef(normalizedStage);
  if (!vehicle || !def) return;
  const alreadyComplete = pdcJobComplete(vehicle, def);
  const label = `${vehicleIdentityTitle(vehicle) || 'this vehicle'} - ${vehicleCustomerName(vehicle) || 'Unknown customer'}`;
  if (alreadyComplete) {
    pdcNotify(`${def.label} is already signed off for ${label}. Use the job marker or vehicle popup if you need to remove the sign-off.`);
    return;
  }
  const bay = pmbBayNumber(vehicle, normalizedStage);
  const hours = pmbBayHours(vehicle);
  const mechanic = pmbBayMechanic(vehicle);
  const subletProvider = pmbBaySubletProvider(vehicle);
  if (!window.confirm(`Mark ${def.label} complete for ${label}?\n\n${bay ? `Bay ${bay}` : 'No bay assigned'}${hours !== '' ? ` · ${hours} planned hours` : ''}\n\nThis will tick the ${def.label} marker on the main PMB vehicle card.`)) return;
  const now = nowIsoString();
  const operator = getCurrentOperatorName();
  const updates = {
    [def.requireKey]: true,
    [def.completeKey]: true,
    [def.completeAtKey]: now,
    [def.completeByKey]: operator,
    pdcQcComplete: false,
    pdcQcCompleteAt: '',
    pdcQcCompleteBy: '',
    pmbBayCompletedAt: now,
    pmbBayCompletedBy: operator,
    pmbBayCompletedStage: normalizedStage,
    pmbStage: '',
    pmbStageUpdatedAt: now,
    pmbStageEnteredAt: now,
    [pdcJobMechanicKey(def)]: mechanic,
    [pdcJobBayKey(def)]: bay || '',
    [pdcJobHoursKey(def)]: hours === '' ? '' : String(hours),
    ...(normalizedStage === 'SUBLET' ? { pdcCompleteSubletProvider: subletProvider } : {}),
    pmbBayStage: '',
    pmbBayNumber: '',
    pmbBayEstimatedHours: '',
    pmbBayEnteredAt: '',
    pmbBayScheduledStartAt: '',
    pmbBayMechanic: '',
    pmbSubletProvider: '',
  };
  const snapshot = { ...vehicle };
  const extraTransactionKeys = Array.isArray(transactionOptions.keys) ? transactionOptions.keys : [];
  try {
    runStorageTransaction('Complete PMB bay work', [EDITS_KEY, AUDIT_LOG_KEY, ...extraTransactionKeys], () => {
      recordVehicleAudit(vehicle, 'Bay work completed', { stage: pmbStageLabel(normalizedStage), job: def.label, bay: bay || 'No bay', hours: hours === '' ? '' : hours, mechanic: mechanic || 'Unassigned', provider: normalizedStage === 'SUBLET' ? (subletProvider || 'Unassigned') : '', by: operator, returnedTo: 'PMB unallocated' });
      if (!saveVehicleEdits(vehicleKey(vehicle), updates)) throw new Error('The completed bay work could not be saved.');
      if (typeof transactionOptions.afterComplete === 'function') transactionOptions.afterComplete(vehicle, def, updates);
    });
  } catch (error) {
    Object.keys(vehicle).forEach(field => { if (!Object.prototype.hasOwnProperty.call(snapshot, field)) delete vehicle[field]; });
    Object.assign(vehicle, snapshot);
    pdcNotify(error.message || String(error));
    return false;
  }
  offerSalespersonChangeEmail(vehicle, {
    title: `${def.label} completed`,
    subject: 'PDC work completed',
    details: [
      `${def.label} was signed off by ${operator}.`,
      bay ? `Completed in bay ${bay}.` : 'Completed without a numbered bay.',
      mechanic ? `Mechanic: ${mechanic}.` : '',
    ],
  });
  return true;
}

function moveVehicleToNextPmbStageFromBay(key, fromStage) {
  const cleanKey = String(key || '').trim();
  const vehicle = app.data.find(v => vehicleKey(v) === cleanKey || v.stock === cleanKey || v.id === cleanKey);
  const currentStage = normalizePmbStage(fromStage || inferredPmbStage(vehicle));
  if (!vehicle || !currentStage) return;
  const currentDef = pmbStageJobDef(currentStage);
  if (currentDef && !pdcJobComplete(vehicle, currentDef)) {
    pdcNotify(`Complete ${currentDef.label} first. Once it is signed off, this vehicle can be moved to the next required station.`);
    return;
  }
  const nextStage = nextOutstandingPmbStage(vehicle, currentStage);
  if (!nextStage) {
    pdcNotify('No next PMB station is outstanding for this vehicle. If all required jobs are complete, move it to RFT. If Parts is still outstanding, clear the parts issue before RFT.');
    return;
  }
  const now = nowIsoString();
  const bay = pmbBayNumber(vehicle, currentStage);
  app.activePmbBayStage = nextStage;
  recordVehicleAudit(vehicle, 'Moved to next PMB station', { from: pmbStageLabel(currentStage), to: pmbStageLabel(nextStage), fromBay: bay || 'No bay' });
  saveVehicleEdits(vehicleKey(vehicle), {
    pmbStage: nextStage,
    pmbStageUpdatedAt: now,
    pmbStageEnteredAt: now,
    pmbBayStage: '',
    pmbBayNumber: '',
    pmbBayEstimatedHours: '',
    pmbBayEnteredAt: '',
    pmbBayCompletedAt: '',
    pmbBayCompletedBy: '',
    pmbBayCompletedStage: '',
    pmbBayMechanic: '',
  });
}

function filteredPmbVehiclesIgnoringSubFilter() {
  const savedQuickFilter = app.quickFilter;
  const savedSubFilter = app.pmbSubFilter;
  app.quickFilter = 'pmb';
  app.pmbSubFilter = '';
  const rows = filteredVehicles();
  app.quickFilter = savedQuickFilter;
  app.pmbSubFilter = savedSubFilter;
  return rows;
}

function matchesQuickFilter(filter) {
  return (vehicle) => {
    if (!filter) return true;
    if (filter === 'incoming') return !['pmb', 'rft'].includes(statusCategory(vehicle));
    if (filter === 'batchmatched') return statusCategory(vehicle) === 'batchmatched';
    if (filter === 'partsstoppage') return isActivePartsStoppage(vehicle);
    if (filter === 'partsrequired') {
      const parts = PDC_JOB_BY_KEY.get('parts');
      return Boolean(parts && pdcJobRequired(vehicle, parts) && !pdcJobComplete(vehicle, parts));
    }
    return statusCategory(vehicle) === filter;
  };
}

function quickFilterLabel() {
  const base = {
    incoming: 'Incoming / non-PMB vehicles',
    batchmatched: 'Batch Matched vehicles',
    partsstoppage: 'Parts STOPPAGE vehicles',
    prodtransit: 'Production / In Transit vehicles',
    yardhold: 'Vehicles at YH',
    pmb: 'Vehicles at PMB',
    rft: 'Vehicles RFT',
    partsrequired: 'Parts Required',
  }[app.quickFilter || 'incoming'] || '';
  if (app.quickFilter === 'pmb' && app.pmbSubFilter) {
    return `${base} · ${pmbSubFilterLabel(app.pmbSubFilter)}`;
  }
  return base;
}

function applyQuickFilter(filter) {
  if (filter === 'partsrequired') {
    // Parts is still available from the sidebar, but the top Parts Required pill is temporarily removed.
    app.quickFilter = '';
    app.pmbSubFilter = '';
    app.activePmbBayStage = '';
    showView('parts');
    renderKpis();
    renderPartsHome();
    return;
  }
  const requestedFilter = filter || 'incoming';
  const nextFilter = app.quickFilter === requestedFilter ? 'incoming' : requestedFilter;
  app.quickFilter = nextFilter;
  if (nextFilter !== 'pmb') {
    app.pmbSubFilter = '';
    app.activePmbBayStage = '';
  }
  showView(nextFilter === 'pmb' ? 'workflow' : 'dashboard');
  renderKpis();
  renderVehicleTable();
}

function applyPmbSubFilter(filter = '') {
  const normalizedFilter = normalizePmbSubFilter(filter);
  app.quickFilter = 'pmb';
  app.pmbSubFilter = app.pmbSubFilter === normalizedFilter ? '' : normalizedFilter;
  app.activePmbBayStage = normalizePmbStage(normalizedFilter) || app.activePmbBayStage;
  showView('workflow');
  renderKpis();
  renderVehicleTable();
}

function clearQuickFilter(render = true) {
  app.quickFilter = 'incoming';
  app.pmbSubFilter = '';
  app.activePmbBayStage = '';
  if (render) renderKpis();
}

function clearAllFilters() {
  app.quickFilter = 'incoming';
  app.pmbSubFilter = '';
  app.activePmbBayStage = '';
  app.columnFilters = { sales: '', production: '', status: '', jita: '' };
  ['search', 'source-filter'].forEach(id => { const el = $('#' + id); if (el) el.value = ''; });
  renderKpis();
  renderVehicleTable();
}

function nextActionForVehicle(vehicle = {}) {
  const category = statusCategory(vehicle);
  if (isActivePartsStoppage(vehicle)) return `Fix Parts STOPPAGE: ${partsStoppageReason(vehicle)}`;
  if (isPdcBlocked(vehicle)) return `Clear blocker: ${pdcBlockReason(vehicle)}`;
  if (category === 'yardhold') return 'Transfer Yard Hold → PMB';
  if (category === 'pmb') {
    const stage = inferredPmbStage(vehicle);
    if (!stage) return 'Assign PMB stage and bay';
    const stageDef = pmbStageJobDef(stage);
    if (stageDef && pdcJobRequired(vehicle, stageDef) && !pdcJobComplete(vehicle, stageDef)) return `Complete ${stageDef.label}`;
    const nextStage = nextOutstandingPmbStage(vehicle, stage);
    if (nextStage) return `Move to ${pmbStageLabel(nextStage)}`;
    const issues = vehicleRftGateIssues(vehicle);
    if (issues.length) return `Fix before RFT: ${issues.join(' · ')}`;
    return 'Transfer to RFT';
  }
  if (category === 'rft') {
    const issues = vehicleRftGateIssues(vehicle);
    return issues.length ? `Fix RFT gate: ${issues.join(' · ')}` : 'Notify salesperson / final handover';
  }
  return 'Watch ETA / update from Navision';
}

function controlBoardIssueCounts() {
  const rows = pdcSheetVehicles();
  const pmbRows = rows.filter(vehicle => statusCategory(vehicle) === 'pmb');
  const rftRows = rows.filter(vehicle => statusCategory(vehicle) === 'rft');
  return {
    partsStoppage: rows.filter(isActivePartsStoppage).length,
    pmbBlocked: pmbRows.filter(isPdcBlocked).length,
    rftBlocked: rftRows.filter(vehicle => vehicleRftGateIssues(vehicle).length).length,
    pmbUnallocated: pmbRows.filter(vehicle => !inferredPmbStage(vehicle)).length,
    yardHoldReady: rows.filter(canTransferVehicleToPmb).length,
  };
}

function issueStripButtonHtml(action, label, value, detail, tone = '') {
  return `<button class="exception-card ${escapeHtml(tone)}" type="button" data-control-issue="${escapeHtml(action)}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong><small>${escapeHtml(detail)}</small></button>`;
}

function renderControlBoardIssueStripHtml(counts = controlBoardIssueCounts()) {
  return `
    <div class="exception-strip" aria-label="Fix first queues">
      ${issueStripButtonHtml('parts-stoppage', 'Parts STOPPAGES', counts.partsStoppage, 'Blocking production now', counts.partsStoppage ? 'danger' : '')}
      ${issueStripButtonHtml('pmb-blocked', 'PMB blockers', counts.pmbBlocked, 'Blocked PMB vehicles', counts.pmbBlocked ? 'danger' : '')}
      ${issueStripButtonHtml('rft-blocked', 'RFT blocked', counts.rftBlocked, 'Missing gate sign-offs', counts.rftBlocked ? 'warning' : '')}
      ${issueStripButtonHtml('pmb-unallocated', 'PMB unallocated', counts.pmbUnallocated, 'Needs stage / bay decision', counts.pmbUnallocated ? 'warning' : '')}
      ${issueStripButtonHtml('yardhold-ready', 'Yard Hold ready', counts.yardHoldReady, 'Can move to PMB', counts.yardHoldReady ? 'ready' : '')}
    </div>`;
}

function renderControlBoardFixFirst() {
  const host = $('#control-board-fix-first');
  if (!host) return;
  host.innerHTML = `
    <div class="panel-header compact exception-header">
      <div>
        <h2>Fix first</h2>
        <p>Start with blockers and queues that need action now.</p>
      </div>
      <span class="badge neutral">Exception-led</span>
    </div>
    ${renderControlBoardIssueStripHtml()}`;
  bindControlBoardIssueActions(host);
}

function bindControlBoardIssueActions(root = document) {
  $$('[data-control-issue]', root).forEach(button => button.addEventListener('click', () => handleControlBoardIssueAction(button.dataset.controlIssue)));
}

function handleControlBoardIssueAction(action = '') {
  if (action === 'parts-stoppage') {
    showView('parts');
    app.partsOperationalFilter = 'stoppage';
    renderPartsHome();
    return;
  }
  if (action === 'rft-blocked') {
    showView('rft');
    const select = $('#rft-status-filter');
    if (select) select.value = 'blocked';
    renderRftHome();
    return;
  }
  if (action === 'pmb-unallocated') {
    app.quickFilter = 'pmb';
    app.pmbSubFilter = PMB_STAGE_UNASSIGNED_FILTER;
    app.activePmbBayStage = '';
    showView('workflow');
    return;
  }
  if (action === 'pmb-blocked') {
    app.quickFilter = 'pmb';
    app.pmbSubFilter = '';
    app.activePmbBayStage = '';
    showView('workflow');
    return;
  }
  if (action === 'yardhold-ready') {
    showView('dashboard');
    const bucket = $('#incoming-bucket-filter');
    if (bucket) bucket.value = 'yardhold';
    renderIncomingDashboardBoard();
  }
}

function filteredVehicles() {
  const q = ($('#search')?.value || '').trim().toLowerCase();
  const columnFilters = app.columnFilters || {};
  const status = columnFilters.status || '';
  const sales = columnFilters.sales || '';
  const production = columnFilters.production || '';
  const source = $('#source-filter')?.value || '';
  const jita = columnFilters.jita || '';
  return pdcSheetVehicles().filter(v => {
    const productionLabel = productionMonthLabel(v.prodMth || v.productionMonth || '');
    const hay = [v.stock, v.client, v.toyotaCustomer, displayVehicle(v), v.vehicle, v.toyotaVehicle, v.toyotaStatus, pdcLocationLabel(v.pdcLocation), pmbStageLabel(inferredPmbStage(v)), pmbRequirementText(v), pdcCompletedJobsText(v), pdcOutstandingJobsText(v), isPdcBlocked(v) ? 'blocked' : '', pdcBlockReason(v), pmbStageAgeLabel(v), v.deliveryDate, v.etaAtDealer, productionLabel, v.prodMth, v.autocareVin, v.autocareBatch, v.autocareLoadNumber, v.navisionDealerComments, v.financeNote, v.navisionVehicleNote, consultantName(v), salesPersonInitials(consultantName(v)), v.source, v.internalStatus, ...(v.poTasks || [])].join(' ').toLowerCase();
    const matchesQuery = !q || hay.includes(q) || vehicleMatchesJobcardSearch(v, q);
    const matchesStatus = !status || v.toyotaStatus === status;
    const matchesSales = !sales || salesPersonInitials(consultantName(v)) === sales;
    const matchesProduction = !production || productionLabel === production;
    const matchesSource = !source || v.source === source;
    const matchesJita = !jita || (vehicleNavisionJitaNumber(v) ? 'Yes' : 'Unknown') === jita;
    const matchesQuick = !app.quickFilter || matchesQuickFilter(app.quickFilter)(v);
    const currentPmbStage = inferredPmbStage(v);
    const matchesPmbSub = !app.pmbSubFilter || (app.quickFilter === 'pmb' && (app.pmbSubFilter === PMB_STAGE_UNASSIGNED_FILTER ? !currentPmbStage : currentPmbStage === app.pmbSubFilter));
    return matchesQuery && matchesStatus && matchesSales && matchesProduction && matchesSource && matchesJita && matchesQuick && matchesPmbSub;
  });
}


function normalizedVehicleTableColumnOrder(order = []) {
  const defaultIds = VEHICLE_TABLE_DEFAULT_COLUMN_IDS.slice();
  const validIds = new Set(defaultIds);
  const normalized = [];
  (Array.isArray(order) ? order : []).forEach(id => {
    const clean = String(id || '').trim();
    if (validIds.has(clean) && !normalized.includes(clean)) normalized.push(clean);
  });
  defaultIds.forEach(id => {
    if (!normalized.includes(id)) normalized.push(id);
  });
  return normalized;
}

function loadVehicleTableColumnOrder() {
  try {
    return normalizedVehicleTableColumnOrder(JSON.parse(localStorage.getItem(VEHICLE_TABLE_COLUMN_ORDER_KEY) || '[]'));
  } catch {
    return normalizedVehicleTableColumnOrder([]);
  }
}

function saveVehicleTableColumnOrder(order = []) {
  localStorage.setItem(VEHICLE_TABLE_COLUMN_ORDER_KEY, JSON.stringify(normalizedVehicleTableColumnOrder(order)));
}

function moveVehicleTableColumn(draggedId, targetId) {
  if (!draggedId || !targetId || draggedId === targetId) return;
  const order = loadVehicleTableColumnOrder();
  const fromIndex = order.indexOf(draggedId);
  const toIndex = order.indexOf(targetId);
  if (fromIndex === -1 || toIndex === -1) return;
  order.splice(fromIndex, 1);
  const adjustedToIndex = order.indexOf(targetId);
  order.splice(adjustedToIndex, 0, draggedId);
  saveVehicleTableColumnOrder(order);
  renderVehicleTable();
}

function applyVehicleTableColumnOrder(table) {
  if (!table) return;
  const order = loadVehicleTableColumnOrder();
  const orderSet = new Set(order);
  table.querySelectorAll('thead tr, tbody tr').forEach(row => {
    const cells = Array.from(row.children);
    if (!cells.some(cell => cell.dataset?.colId)) return;
    const byId = new Map();
    cells.forEach(cell => {
      const id = cell.dataset?.colId;
      if (id && !byId.has(id)) byId.set(id, cell);
    });
    order.forEach(id => {
      const cell = byId.get(id);
      if (cell) row.appendChild(cell);
    });
    cells.forEach(cell => {
      const id = cell.dataset?.colId;
      if (!id || !orderSet.has(id)) row.appendChild(cell);
    });
  });
}

function makeVehicleColumnsReorderable(table) {
  if (!table) return;
  const headers = Array.from(table.querySelectorAll('thead th[data-col-id]'));
  headers.forEach(th => {
    const colId = th.dataset.colId;
    if (!colId) return;
    th.classList.add('reorderable-column');
    th.addEventListener('dragover', event => {
      event.preventDefault();
      th.classList.add('column-drop-target');
      event.dataTransfer.dropEffect = 'move';
    });
    th.addEventListener('dragleave', () => th.classList.remove('column-drop-target'));
    th.addEventListener('drop', event => {
      event.preventDefault();
      event.stopPropagation();
      th.classList.remove('column-drop-target');
      const draggedId = event.dataTransfer.getData('application/x-vehicle-column') || event.dataTransfer.getData('text/plain');
      moveVehicleTableColumn(draggedId, colId);
    });
    let handle = th.querySelector(':scope > .col-drag-handle');
    if (!handle) {
      handle = document.createElement('span');
      handle.className = 'col-drag-handle';
      handle.textContent = '↔';
      handle.title = 'Drag this column left or right';
      handle.setAttribute('aria-label', 'Drag column left or right');
      th.appendChild(handle);
    }
    handle.draggable = true;
    handle.dataset.dragColumnId = colId;
    handle.addEventListener('click', event => event.stopPropagation());
    handle.addEventListener('mousedown', event => event.stopPropagation());
    handle.addEventListener('dragstart', event => {
      event.stopPropagation();
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('application/x-vehicle-column', colId);
      event.dataTransfer.setData('text/plain', colId);
      table.classList.add('column-reorder-active');
      th.classList.add('column-dragging');
    });
    handle.addEventListener('dragend', () => {
      table.classList.remove('column-reorder-active');
      document.querySelectorAll('.column-drop-target, .column-dragging').forEach(el => el.classList.remove('column-drop-target', 'column-dragging'));
    });
  });
}

function resetVehicleTableColumnOrder() {
  localStorage.removeItem('vehicleTrackingCoreColumnOrder:v1');
  localStorage.removeItem('vehicleTrackingCoreColumnOrder:v2');
  localStorage.removeItem('vehicleTrackingCoreColumnOrder:v3');
  localStorage.removeItem('vehicleTrackingCoreColumnWidths:v1:vehicle-table');
  localStorage.removeItem('vehicleTrackingCoreColumnWidths:v4:vehicle-table');
    localStorage.removeItem('vehicleTrackingCoreColumnWidths:v4:vehicle-table');
  renderVehicleTable();
}

function buildInlineSharedVehicleWorkStates(vehicle = {}, def = {}, checked = false, isCompletionFlag = false) {
  const workStates = Object.fromEntries(PDC_JOB_DEFS.map(job => {
    let required = pdcJobRequired(vehicle, job);
    let complete = pdcJobComplete(vehicle, job);
    if (job.key === def.key) {
      if (isCompletionFlag) { required = true; complete = checked; }
      else { required = checked; complete = false; }
    }
    return [job.key, complete ? 'complete' : required ? 'required' : 'none'];
  }));
  return workStates;
}

async function saveInlineSharedVehicleWorkState(input, vehicle, def, checked, isCompletionFlag) {
  if (!input || !vehicle || !def || !vehicleLifecycleSharedModeActive()) return null;
  input.disabled = true;
  const workStates = buildInlineSharedVehicleWorkStates(vehicle, def, checked, isCompletionFlag);
  const result = await saveSharedVehicleWorkStates(vehicle, workStates);
  if (!result || result.ok !== true) {
    input.checked = !checked;
    input.disabled = false;
    pdcNotify(result?.message || describeSharedVehicleWorkStateError(result || {}));
    renderVehicleTable();
    return false;
  }
  vehicle[def.requireKey] = workStates[def.key] !== 'none';
  vehicle[def.completeKey] = workStates[def.key] === 'complete';
  input.disabled = false;
  renderVehicleTable();
  return true;
}

function renderVehicleTable() {
  const rows = sortRows(filteredVehicles());
  renderQuickFilterBanner(rows.length);
  const table = $('#vehicle-table');
  if (!table) return;
  table.classList.add('compact-table');
  if (!rows.length) {
    const emptyHtml = app.data.length
      ? $('#empty-state').innerHTML
      : '<div class="empty-state"><strong>No Navision vehicles loaded yet</strong><span>Upload or paste your first Navision export to populate the tracker.</span><button class="primary" type="button" data-empty-navision-upload>Upload Navision text</button></div>';
    table.innerHTML = `<tbody><tr><td colspan="17">${emptyHtml}</td></tr></tbody>`;
    on($('[data-empty-navision-upload]', table), 'click', () => showView('import'));
    updateBulkSelectionPanel([]);
    return;
  }
  table.innerHTML = `
    <thead><tr>
      <th class="sp-col" data-col-id="sp">${columnFilterSlot('sales', app.filterOptions.consultants, app.columnFilters.sales, 'All SP')}<div class="sp-select-head"><input type="checkbox" data-select-visible aria-label="Select all visible vehicles" />${sortableTh('SP', 'consultant')}</div></th>
      <th data-col-id="stock">${emptyColumnFilterSlot()}${sortableTh('SN', 'stock')}</th>
      <th class="production-month-col" data-col-id="prodMth">${columnFilterSlot('production', app.filterOptions.productionMonths, app.columnFilters.production, 'All P/Month')} ${sortableTh('P/Month', 'prodMth')}</th>
      <th data-col-id="client">${emptyColumnFilterSlot()}${sortableTh('Client', 'client')}</th>
      <th data-col-id="vehicle">${emptyColumnFilterSlot()}${sortableTh('Vehicle', 'vehicle')}</th>
      <th class="flag-col pdc-job-col pdc-col-tint" data-col-id="tint" title="Tint required">${emptyColumnFilterSlot()}${sortableTh('T', 'pdcRequiresTint')}</th>
      <th class="flag-col pdc-job-col pdc-col-hoist" data-col-id="hoist" title="Hoist required">${emptyColumnFilterSlot()}${sortableTh('H', 'pdcRequiresHoist')}</th>
      <th class="flag-col pdc-job-col pdc-col-fitting" data-col-id="fitting" title="Fitting required">${emptyColumnFilterSlot()}${sortableTh('F', 'pdcRequiresFitting')}</th>
      <th class="flag-col pdc-job-col pdc-col-fabrication" data-col-id="fabrication" title="Fabrication required">${emptyColumnFilterSlot()}${sortableTh('Fa', 'pdcRequiresFabrication')}</th>
      <th class="flag-col pdc-job-col pdc-col-electrical" data-col-id="electrical" title="Electrical required">${emptyColumnFilterSlot()}${sortableTh('E', 'pdcRequiresElectrical')}</th>
      <th class="flag-col pdc-job-col pdc-col-tyre" data-col-id="tyre" title="Tyre required">${emptyColumnFilterSlot()}${sortableTh('Ty', 'pdcRequiresTyre')}</th>

      <th data-col-id="status">${columnFilterSlot('status', app.filterOptions.statuses, app.columnFilters.status, 'All statuses')}${sortableTh('Toyota Status', 'toyotaStatus')}</th>
      <th data-col-id="eta">${emptyColumnFilterSlot()}${sortableTh('ETA', 'eta')}</th>
      <th class="navision-notes-full-col" data-col-id="navisionNotes" title="Full Navision Notes from Dealer Comments">${emptyColumnFilterSlot()}${sortableTh('Navision Notes', 'navisionNotes')}</th>
      <th data-col-id="jita">${columnFilterSlot('jita', [{ value: 'Yes', label: '✓ JITA Number' }, { value: 'Unknown', label: 'Blank' }], app.columnFilters.jita, 'All')}${sortableTh('JITA', 'jita')}</th>
      <th data-col-id="action">${emptyColumnFilterSlot()}<span class="plain-header-label">Action</span></th>
    </tr></thead>
    <tbody>
      ${rows.map(v => {
        const key = vehicleKey(v);
        const rowClasses = [
          app.selectedRows.has(key) ? 'row-selected' : '',
          isAutocareDespatched(v) ? 'autocare-row' : '',
          isNavisionCutButVehicle(v) ? 'cut-but-vehicle-row' : '',
          isPdcBlocked(v) ? 'pdc-blocked-row' : '',
        ].filter(Boolean).join(' ');
        const pmbDragAttrs = statusCategory(v) === 'pmb' ? ` draggable="true" data-pmb-table-drag-key="${escapeHtml(key)}" title="Drag this PMB vehicle to a PMB bucket"` : '';
        return `
        <tr class="${rowClasses}" data-stock="${escapeHtml(key)}"${pmbDragAttrs}>
          <td class="sp-cell" data-col-id="sp"><label class="row-selector" title="Select ${escapeHtml(displayStockNumber(v) || 'vehicle')}"><input type="checkbox" data-select-stock="${escapeHtml(key)}" ${app.selectedRows.has(key) ? 'checked' : ''} /><span><strong title="${escapeHtml(consultantName(v))}">${escapeHtml(salesPersonInitials(consultantName(v)))}</strong></span></label></td>
          <td class="stock-cell" data-col-id="stock">${vehicleIdentityStackHtml(v, { button: true })}${stockOrderSubline(v)}${v.toyotaCustomer && !isCustomerMatch(v) ? `<div class="subtle review-warning">Check customer</div>` : ''}</td>
          <td class="production-month-cell" data-col-id="prodMth"><span>${escapeHtml(productionMonthLabel(v.prodMth || v.productionMonth || ''))}</span></td>
          <td class="client-cell" data-col-id="client"><span title="${escapeHtml(vehicleCustomerName(v) || '')}">${escapeHtml(vehicleCustomerName(v) || '')}</span></td>
          <td data-col-id="vehicle"><span class="vehicle-cell">${escapeHtml(displayVehicle(v))}</span></td>
          <td class="flag-cell pdc-job-cell" data-col-id="tint">${pdcJobTableCell(v, PDC_JOB_BY_KEY.get('tint'))}</td>
          <td class="flag-cell pdc-job-cell" data-col-id="hoist">${pdcJobTableCell(v, PDC_JOB_BY_KEY.get('hoist'))}</td>
          <td class="flag-cell pdc-job-cell" data-col-id="fitting">${pdcJobTableCell(v, PDC_JOB_BY_KEY.get('fitting'))}</td>
          <td class="flag-cell pdc-job-cell" data-col-id="fabrication">${pdcJobTableCell(v, PDC_JOB_BY_KEY.get('fabrication'))}</td>
          <td class="flag-cell pdc-job-cell" data-col-id="electrical">${pdcJobTableCell(v, PDC_JOB_BY_KEY.get('electrical'))}</td>
          <td class="flag-cell pdc-job-cell" data-col-id="tyre">${pdcJobTableCell(v, PDC_JOB_BY_KEY.get('tyre'))}</td>

          <td data-col-id="status">${formatStatus(v)}${isPdcBlocked(v) ? `<div class="pdc-blocked-inline">Blocked: ${escapeHtml(truncate(pdcBlockReason(v), 42))}</div>` : ''}${statusCategory(v) === 'pmb' ? `<div class="pmb-stage-cell">${pmbStageBadge(v) || '<span class="subtle">PMB stage not allocated</span>'}</div>` : ''}${!isCustomerMatch(v) ? '<div class="subtle review-warning">Check customer match</div>' : ''}</td>
          <td data-col-id="eta">${formatEta(v.etaAtDealer)}</td>
          <td class="navision-notes-full-cell" data-col-id="navisionNotes"><span title="${escapeHtml(navisionDealerNoteText(v))}">${escapeHtml(truncate(navisionDealerNoteText(v), 90))}</span></td>
          <td data-col-id="jita">${jitaIndicator(v)}</td>
          <td data-col-id="action">${actionSelectHtml(key)}</td>
        </tr>
      `; }).join('')}
    </tbody>
  `;
  applyVehicleTableColumnOrder(table);
  bindColumnFilterControls(table);
  makeVehicleColumnsReorderable(table);
  $$('[data-sort-key]', table).forEach(btn => btn.addEventListener('click', () => setSort(btn.dataset.sortKey)));
  const visibleKeys = rows.map(vehicleKey).filter(Boolean);
  if (app.quickFilter) {
    const visibleKeySet = new Set(visibleKeys);
    [...app.selectedRows].forEach(key => { if (!visibleKeySet.has(key)) app.selectedRows.delete(key); });
  }
  const selectAllVisible = $('[data-select-visible]', table);
  if (selectAllVisible) {
    const selectedVisible = visibleKeys.filter(key => app.selectedRows.has(key)).length;
    selectAllVisible.checked = visibleKeys.length > 0 && selectedVisible === visibleKeys.length;
    selectAllVisible.indeterminate = selectedVisible > 0 && selectedVisible < visibleKeys.length;
    selectAllVisible.addEventListener('click', e => e.stopPropagation());
    selectAllVisible.addEventListener('change', () => {
      visibleKeys.forEach(key => {
        if (selectAllVisible.checked) app.selectedRows.add(key);
        else app.selectedRows.delete(key);
      });
      renderVehicleTable();
    });
  }
  $$('[data-select-stock]', table).forEach(input => {
    input.addEventListener('click', e => e.stopPropagation());
    input.addEventListener('change', () => {
      const key = input.dataset.selectStock;
      if (!key) return;
      if (input.checked) app.selectedRows.add(key);
      else app.selectedRows.delete(key);
      renderVehicleTable();
    });
  });
  $$('[data-open-stock]', table).forEach(btn => btn.addEventListener('click', (e) => {
    e.stopPropagation();
    void openVehicleFromStockClick(btn.dataset.openStock, btn);
  }));
  $$('[data-task-stock]', table).forEach(select => {
    select.addEventListener('click', (e) => e.stopPropagation());
    select.addEventListener('change', () => {
      saveVehicleEdits(select.dataset.taskStock, { internalStatus: select.value });
    });
  });
  $$('[data-flag-stock]', table).forEach(input => {
    input.addEventListener('click', (e) => e.stopPropagation());
    input.addEventListener('change', async () => {
      const vehicle = selectedVehicle(input.dataset.flagStock);
      const def = pdcJobDefinitionForKey(input.dataset.flagKey);
      const isCompletionFlag = PDC_JOB_BY_COMPLETE_KEY.has(input.dataset.flagKey);
      if (vehicle?.__emailVehicleServerAuthoritative === true && def && vehicleLifecycleSharedModeActive()) {
        const saved = await saveInlineSharedVehicleWorkState(input, vehicle, def, input.checked, isCompletionFlag);
        if (saved !== true) return;
        recordVehicleAudit(vehicle, isCompletionFlag ? (input.checked ? 'Job signed off from shared vehicle table' : 'Job sign-off removed from shared vehicle table') : (input.checked ? 'Requirement added from shared vehicle table' : 'Requirement removed from shared vehicle table'), { job: def.label });
        if (isCompletionFlag && input.checked) {
          offerSalespersonChangeEmail(vehicle, {
            title: `${def.label} completed`,
            subject: 'PDC work completed',
            details: [`${def.label} was signed off by ${getCurrentOperatorName()}.`],
          });
        }
        return;
      }
      const updates = { [input.dataset.flagKey]: input.checked };
      if (isCompletionFlag && def) {
        updates[def.requireKey] = true;
        updates[def.completeAtKey] = input.checked ? nowIsoString() : '';
        updates[def.completeByKey] = input.checked ? getCurrentOperatorName() : '';
        Object.assign(updates, { pdcQcComplete: false, pdcQcCompleteAt: '', pdcQcCompleteBy: '' });
      }
      if (vehicle && def) {
        recordVehicleAudit(vehicle, isCompletionFlag ? (input.checked ? 'Job signed off from RFT table' : 'Job sign-off removed from RFT table') : (input.checked ? 'Requirement added' : 'Requirement removed'), { job: def.label });
      }
      saveVehicleEdits(input.dataset.flagStock, updates);
      if (vehicle && def && isCompletionFlag && input.checked) {
        offerSalespersonChangeEmail(vehicle, {
          title: `${def.label} completed`,
          subject: 'PDC work completed',
          details: [`${def.label} was signed off by ${getCurrentOperatorName()}.`],
        });
      }
    });
  });
  $$('[data-action-stock]', table).forEach(select => {
    select.addEventListener('click', (e) => e.stopPropagation());
    select.addEventListener('change', () => {
      if (!select.value) return;
      handleVehicleAction(select.dataset.actionStock, select.value);
      select.value = '';
    });
  });
  bindPmbTableRowDragging(table);
  updateBulkSelectionPanel(rows);
  makeTableResizable(table);
  setupFrozenVehicleHeader(table);
}


function removeVehiclesFromTracker(vehicles = [], options = {}) {
  const list = vehicles.filter(Boolean);
  if (!list.length || list.some(vehicle => !vehicleLocationActionAllowed(vehicle, 'delete'))) return [];
  try {
    return runStorageTransaction('Vehicle removal', trackerTransactionKeys(), () => removeVehiclesFromTrackerUnsafe(list, options));
  } catch (error) {
    app.data = buildVehicleData();
    pdcNotify(error.message || String(error));
    return [];
  }
}

function removeVehiclesFromTrackerUnsafe(vehicles = [], options = {}) {
  const list = vehicles.filter(Boolean);
  if (!list.length) return [];
  const deletedRecords = deletedVehicleRecords();
  const existingRecordsByKey = new Map();
  deletedRecords.forEach(record => {
    [record.key].concat(record.keys || []).filter(Boolean).forEach(key => existingRecordsByKey.set(String(key), record));
  });
  let added = loadAddedVehicles();
  const edits = loadVehicleEdits();
  const poTasks = loadPoTasks();
  const poFiles = loadPoFiles();
  const exactRemovalKeys = new Set();
  const operator = getCurrentOperatorName();
  const role = getCurrentOperatorRole();
  const deletedAt = nowIsoString();
  const deletionType = cleanNavisionText(options.deletionType || 'manual') || 'manual';
  const deletionReason = cleanNavisionText(options.reason || (deletionType === 'navision-missing' ? 'No longer present in the latest full Navision upload' : 'Deleted by an operator'));

  list.forEach(vehicle => {
    const exactKeys = [
      vehicleDeleteKey(vehicle),
      vehicleKey(vehicle),
      vehicle.stock,
      vehicle.batch,
      vehicle.id,
    ].map(value => String(value || '').trim()).filter(Boolean);

    const vin = normalizeVin(vehicle.vin || vehicle.fullVin || vehicle.frameVin || vehicle.autocareVin || '');
    const allDeleteKeys = [...new Set(exactKeys.concat(vin ? [vin] : []))];
    const key = exactKeys[0] || vin;

    exactKeys.forEach(value => exactRemovalKeys.add(value));
    allDeleteKeys.forEach(value => {
      delete edits[value];
      delete poTasks[value];
      delete poFiles[value];
    });

    if (key && !allDeleteKeys.some(value => existingRecordsByKey.has(value))) {
      const record = {
        key,
        keys: allDeleteKeys,
        deletedAt,
        deletedBy: operator || 'Unknown operator',
        deletedRole: role || 'Unassigned role',
        reason: deletionReason,
        deletionType,
        vehicle: JSON.parse(JSON.stringify(vehicle)),
      };
      deletedRecords.unshift(record);
      allDeleteKeys.forEach(value => existingRecordsByKey.set(value, record));
      const auditAction = deletionType === 'navision-missing' ? 'Retired from Navision back end' : 'Deleted from board';
      recordVehicleAudit(vehicle, auditAction, { by: operator || 'Unknown operator', role: role || 'Unassigned role', reason: deletionReason });
    }
  });

  // Do not use broad Navision comparable keys here. Frame fragments can overlap
  // across multiple imported rows, which previously caused one manual delete to remove
  // a group of unrelated vehicles from the saved Navision list.
  added = added.filter(vehicle => {
    const keys = [
      vehicleDeleteKey(vehicle),
      vehicleKey(vehicle),
      vehicle.stock,
      vehicle.batch,
      vehicle.id,
    ].map(value => String(value || '').trim()).filter(Boolean);
    return !keys.some(key => exactRemovalKeys.has(key));
  });

  saveDeletedVehicleRecords(deletedRecords);
  saveAddedVehicles(added);
  saveJson(EDITS_KEY, edits);
  savePoTasks(poTasks);
  savePoFiles(poFiles);
  return list;
}

function refreshAfterVehicleRemoval() {
  app.selectedRows.clear();
  app.data = buildVehicleData();
  const visibleRows = pdcSheetVehicles();
  app.selectedStock = visibleRows[0] ? vehicleKey(visibleRows[0]) : (app.data[0] ? vehicleKey(app.data[0]) : null);
  populateFilters();
  renderAll();
  updateNavisionSidebarMeta();
}


function selectedVehiclesForBulkEmail() {
  if (!app.selectedRows || !app.selectedRows.size) return [];
  if (!sharedNavisionLocationAuthorityReady()) {
    app.selectedRows.clear();
    return [];
  }
  vehicleLocationBoardRows();
  [...app.selectedRows].forEach(key => {
    if (app.sharedNavisionLocationReadOnlyKeys?.has(key)) app.selectedRows.delete(key);
  });
  return [...app.selectedRows]
    .map(key => app.data.find(vehicle => vehicleKey(vehicle) === key || vehicle.stock === key || vehicle.id === key))
    .filter(Boolean);
}

function updateBulkSelectionPanel(visibleRows = []) {
  const validKeys = new Set(app.data.map(vehicleKey));
  [...app.selectedRows].forEach(key => { if (!validKeys.has(key)) app.selectedRows.delete(key); });
  const selected = selectedVehiclesForBulkEmail();
  const count = selected.length;
  const countEl = $('#selection-count');
  const emailButtons = ['#email-selected-amy', '#email-selected-amy-bar'].map(selector => $(selector)).filter(Boolean);
  const statusEmailButton = $('#email-selected-update-bar');
  const clearButtons = ['#clear-selected-rows', '#clear-selected-rows-bar'].map(selector => $(selector)).filter(Boolean);
  const deleteButtons = ['#delete-selected-vehicles', '#delete-selected-vehicles-bar'].map(selector => $(selector)).filter(Boolean);
  const overrideYhButtons = ['#override-selected-to-yh-bar', '#override-selected-to-yh-top'].map(selector => $(selector)).filter(Boolean);
  const transferButtons = ['#transfer-selected-to-pmb-bar', '#transfer-selected-to-pmb-top'].map(selector => $(selector)).filter(Boolean);
  const transferRftButtons = ['#transfer-selected-to-rft-bar'].map(selector => $(selector)).filter(Boolean);
  const printButtons = $$('[data-print-selected-zpl]');
  const bar = $('#bulk-selection-bar');
  if (countEl) {
    countEl.hidden = count === 0;
    countEl.textContent = `${count} selected`;
  }
  if (bar) bar.classList.toggle('active', count > 0);
  emailButtons.forEach(button => { button.disabled = count === 0; });
  if (statusEmailButton) {
    statusEmailButton.disabled = count !== 1;
    statusEmailButton.title = count === 1 ? 'Email the selected vehicle update to its salesperson' : 'Select exactly one vehicle to email an update';
  }
  clearButtons.forEach(button => { button.disabled = count === 0; });
  deleteButtons.forEach(button => {
    button.disabled = count === 0;
    button.title = count ? `Delete ${count} selected vehicle${count === 1 ? '' : 's'} from this tracker` : 'Select one or more vehicles first';
  });
  printButtons.forEach(button => {
    button.hidden = count === 0;
    button.disabled = count === 0;
    button.title = count ? `Print ${count} selected vehicle label${count === 1 ? '' : 's'} to the Zebra printer` : 'Select one or more vehicles first';
  });
  const sharedYhOverrideUnavailable = sharedVehicleLocationMutationUnavailable('override to Yard Hold', null, { silent: true });
  overrideYhButtons.forEach(button => {
    const canOverride = count > 0 && !sharedYhOverrideUnavailable;
    button.disabled = !canOverride;
    button.title = sharedYhOverrideUnavailable
      ? 'Unavailable: shared vehicle locations require an audited server action'
      : canOverride
        ? `Manually set ${count} selected vehicle${count === 1 ? '' : 's'} to Yard Hold so they can be transferred to PMB`
        : 'Select one or more vehicles first';
  });
  const pmbSelectedCount = selected.filter(vehicle => statusCategory(vehicle) === 'pmb').length;
  const rftSelectedCount = selected.filter(vehicle => statusCategory(vehicle) === 'rft').length;
  const incomingPmbReadyCount = selected.filter(canTransferVehicleToPmb).length;
  const sharedBulkPmbUnavailable = sharedVehicleLocationMutationUnavailable('bulk transfer to PMB', null, { silent: true });
  const canTransferSelectedToPmb = !sharedBulkPmbUnavailable && count > 0 && pmbSelectedCount === 0 && rftSelectedCount === 0 && incomingPmbReadyCount === count;
  transferButtons.forEach(button => {
    button.disabled = !canTransferSelectedToPmb;
    button.title = sharedBulkPmbUnavailable
      ? 'Unavailable: shared vehicle locations require an audited server action'
      : !count
        ? 'Select one or more Yard Hold or In Transit vehicles first'
        : canTransferSelectedToPmb
          ? `Transfer ${count} selected vehicle${count === 1 ? '' : 's'} to PMB`
          : 'Only vehicles currently at Yard Hold or In Transit can be bulk-transferred to PMB';
  });
  transferRftButtons.forEach(button => {
    const gateIssueRows = vehiclesWithRftGateIssues(selected);
    const canTransfer = count > 0 && pmbSelectedCount === count && gateIssueRows.length === 0;
    button.disabled = !canTransfer;
    button.title = !count
      ? 'Select one or more PMB vehicles first'
      : pmbSelectedCount !== count
        ? 'Only vehicles currently at PMB can be bulk-transferred to RFT'
        : gateIssueRows.length
          ? 'RFT locked: all required boxes must be signed off first'
          : `Transfer ${count} selected PMB vehicle${count === 1 ? '' : 's'} to RFT`;
  });

  const table = $('#vehicle-table');
  const selectAllVisible = table ? $('[data-select-visible]', table) : null;
  if (selectAllVisible && visibleRows.length) {
    const visibleKeys = visibleRows.map(vehicleKey).filter(Boolean);
    const selectedVisible = visibleKeys.filter(key => app.selectedRows.has(key)).length;
    selectAllVisible.checked = selectedVisible === visibleKeys.length;
    selectAllVisible.indeterminate = selectedVisible > 0 && selectedVisible < visibleKeys.length;
  }
}

function clearSelectedRows() {
  app.selectedRows.clear();
  renderAll();
  updateInlineSelectionBars();
}

function deleteSelectedVehicles() {
  const vehicles = selectedVehiclesForBulkEmail();
  if (!vehicles.length) return;
  const label = `${vehicles.length} selected vehicle${vehicles.length === 1 ? '' : 's'}`;
  const preview = vehicles.slice(0, 8).map(vehicle => `• ${vehicleIdentityTitle(vehicle) || 'No stock'} - ${vehicleCustomerName(vehicle) || 'Unknown customer'}`).join('\n');
  const more = vehicles.length > 8 ? `\n• plus ${vehicles.length - 8} more` : '';
  if (!window.confirm(`Delete ${label} from the tracker?\n\n${preview}${more}\n\nThis hides them from the prototype and keeps the delete list in this browser.`)) return;

  removeVehiclesFromTracker(vehicles);
  app.selectedRows.clear();
  refreshAfterVehicleRemoval();
}


function overrideSelectedVehiclesToYh() {
  if (sharedVehicleLocationMutationUnavailable('override to Yard Hold')) return false;
  const selected = selectedVehiclesForBulkEmail();
  if (!selected.length) return;
  const preview = selected.slice(0, 10).map(vehicle => `• ${vehicleIdentityTitle(vehicle) || 'No stock'} - ${vehicleCustomerName(vehicle) || 'Unknown customer'} - ${pdcLocationLabel(vehiclePdcLocation(vehicle)) || statusCategory(vehicle)}`).join('\n');
  const more = selected.length > 10 ? `\n• plus ${selected.length - 10} more` : '';
  if (!window.confirm(`Manually override ${selected.length} selected vehicle${selected.length === 1 ? '' : 's'} to Vehicles at YH?\n\n${preview}${more}\n\nThis lets you move them to PMB and protects the manual Yard Hold location from future Navision location changes until you change it again.`)) return;

  const now = nowIsoString();
  const edits = loadVehicleEdits();

  selected.forEach(vehicle => {
    const key = vehicleKey(vehicle);
    if (!key) return;
    const updates = {
      ...pdcVisibilityPromotionUpdates(vehicle, 'Operator manual Yard Hold override'),
      pdcLocation: 'YH',
      manualLocation: 'YH',
      pdcLocationLocked: true,
      navisionLocationLocked: true,
      pdcLocationUpdatedAt: now,
      pmbStage: '',
      pmbStageEnteredAt: '',
      pmbStageUpdatedAt: '',
      pmbBayStage: '',
      pmbBayNumber: '',
      pmbBayEstimatedHours: '',
      pmbBayEnteredAt: '',
      pmbBayScheduledStartAt: '',
      pmbBayCompletedAt: '',
      pmbBayCompletedBy: '',
      pmbBayCompletedStage: '',
      pmbBayMechanic: '',
      pmbSubletProvider: '',
    };
    Object.assign(vehicle, updates);
    edits[key] = { ...(edits[key] || {}), ...updates };
    if (vehicle.stock && vehicle.stock !== key) edits[vehicle.stock] = { ...(edits[vehicle.stock] || {}), ...updates };
    recordVehicleAudit(vehicle, 'Manual override to YH', { to: 'Yard Hold', protectedFromNavision: 'Yes' });
  });

  saveJson(EDITS_KEY, edits);
  app.selectedRows.clear();
  app.quickFilter = 'yardhold';
  app.pmbSubFilter = '';
  app.activePmbBayStage = '';
  app.data = buildVehicleData();
  populateFilters();
  renderAll();
}


function canTransferVehicleToPmb(vehicle) {
  if (!vehicle) return false;
  if (vehicle.__locationIdentityReadOnly === true || vehicle.__navisionDetailsIdentityConflict === true
    || vehicle.pdcSheetVisible === false || vehicle.deleted_at || vehicle.deletedAt || vehicle.is_active === false) return false;
  if (vehicleLifecycleSharedModeActive() && (vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId)) return false;
  const current = statusCategory(vehicle);
  if (['pmb', 'pit', 'qc', 'rft', 'collected', 'completed'].includes(current)) return false;
  if (['PMB', 'PIT', 'QC', 'RFT'].includes(vehiclePdcLocation(vehicle))) return false;
  // r722 (F332, Craig 29 Oct 13:37, 13097784): every vehicle not already at PMB, PIT, QC or RFT can be sent To PMB,
  // including the Other tile (a Navision status the board does not map). The server applies the same rule.
  return true;
  if (!vehicleHasNavisionSource(vehicle)) return true;
  if (current === 'yardhold' || current === 'prodtransit') return true;
  const text = [
    navisionStatusText(vehicle),
    vehicle.status,
    vehicle.toyotaStatus,
  ].map(value => String(value || '').toLowerCase()).join(' ');
  if (text.includes('yard hold') || text.includes('vehicle in yard hold') || text.includes('vehicle yard hold') || /\byh\b/.test(text)) return true;
  if (text.includes('in transit') || text.includes('production transit') || /\bit\b/.test(text)) return true;
  return false;
}


function pmbPartsReleaseWarning(vehicles = []) {
  const parts = partsJobDef();
  const incomplete = vehicles.filter(vehicle => vehicle && pdcJobRequired(vehicle, parts) && !pdcJobComplete(vehicle, parts));
  if (!incomplete.length) return '';
  const stocks = incomplete.slice(0, 10).map(vehicle => `• ${displayStockNumber(vehicle) || 'No stock'}`).join('\n');
  const more = incomplete.length > 10 ? `\n• plus ${incomplete.length - 10} more` : '';
  return `WARNING — CAUTION\n${incomplete.length === 1 ? 'This vehicle will be released' : 'These vehicles will be released'} to PMB without Parts complete.\n\n${stocks}${more}\n\nContinue only if you intend to release with Parts incomplete.`;
}

async function transferSelectedYhVehiclesToPmb() {
  if (sharedVehicleLocationMutationUnavailable('bulk transfer to PMB')) return false;
  const selected = selectedVehiclesForBulkEmail();
  if (!selected.length) return;

  const transferable = selected.filter(canTransferVehicleToPmb);
  const nonYh = selected.filter(vehicle => !canTransferVehicleToPmb(vehicle));
  if (!transferable.length) {
    pdcNotify('No selected Yard Hold or In Transit vehicles could be transferred. Clear selection, open Yard Hold/In Transit, then select the rows again.');
    return;
  }
  if (nonYh.length && !window.confirm(`${nonYh.length} selected vehicle${nonYh.length === 1 ? ' is' : 's are'} not at Yard Hold/In Transit and will be skipped.\n\nTransfer the ${transferable.length} Yard Hold/In Transit vehicle${transferable.length === 1 ? '' : 's'} to PMB?`)) return;

  const preview = transferable.slice(0, 10).map(vehicle => `• ${vehicleIdentityTitle(vehicle) || 'No stock'} - ${vehicleCustomerName(vehicle) || 'Unknown customer'}`).join('\n');
  const more = transferable.length > 10 ? `\n• plus ${transferable.length - 10} more` : '';
  const partsWarning = pmbPartsReleaseWarning(transferable);
  if (!window.confirm(`${partsWarning ? partsWarning + '\n\n' : ''}Transfer ${transferable.length} Yard Hold/In Transit vehicle${transferable.length === 1 ? '' : 's'} to Vehicles at PMB?\n\n${preview}${more}\n\nThis is a manual PDC location change. Future Navision uploads will not move these vehicles back.`)) return;

  const withKey = transferable.filter(vehicle => String(vehicle.keyNumber || vehicle.keyNo || vehicle.key_number || vehicle.keyTag || vehicle.pdcKeyNumber || '').trim());
  const missingKey = transferable.length - withKey.length;
  if (missingKey && typeof pdcNotify === 'function') pdcNotify(`${missingKey} selected vehicle${missingKey === 1 ? ' has' : 's have'} no key number and ${missingKey === 1 ? 'was' : 'were'} not moved. Enter a key on To PMB for each one.`);
  if (!withKey.length) return;

  if (withKey.some(vehicle => !vehicleLocationActionAllowed(vehicle, 'transfer to PMB'))) return;

  const transferTime = nowIsoString();
  const edits = loadVehicleEdits();

  withKey.forEach(vehicle => {
    const key = vehicleKey(vehicle);
    if (!key) return;
    const updates = {
      ...pdcVisibilityPromotionUpdates(vehicle, 'Operator PMB transfer'),
      pdcLocation: 'PMB',
      manualLocation: 'PMB',
      pdcLocationLocked: true,
      navisionLocationLocked: true,
      dateToPmb: vehicle.dateToPmb || window.PDC_VEHICLE_LOCATION_LIFECYCLE?.businessDateInTimeZone?.(new Date()) || transferTime.slice(0, 10),
      pmbEnteredAt: pmbEnteredTimestamp(vehicle) || transferTime,
      pmbTransferredAt: vehicle.pmbTransferredAt || transferTime,
      pdcLocationUpdatedAt: transferTime,
      pmbStage: '',
      pdcWorkStage: '',
      workStage: '',
      pmbStageEnteredAt: '',
      pmbStageUpdatedAt: '',
      pmbBayStage: '',
      pmbBayNumber: '',
      pmbBayEstimatedHours: '',
      pmbBayEnteredAt: '',
      pmbBayScheduledStartAt: '',
      pmbBayCompletedAt: '',
      pmbBayCompletedBy: '',
      pmbBayCompletedStage: '',
      pmbBayMechanic: '',
      pmbSubletProvider: '',
    };

    Object.assign(vehicle, updates);
    edits[key] = { ...(edits[key] || {}), ...updates };
    if (vehicle.stock && vehicle.stock !== key) edits[vehicle.stock] = { ...(edits[vehicle.stock] || {}), ...updates };
    recordVehicleAudit(vehicle, 'Transferred to PMB', { from: pdcLocationLabel(vehiclePdcLocation(vehicle)) || 'Incoming', to: 'PMB - Unallocated', protectedFromNavision: 'Yes' });
  });

  saveJson(EDITS_KEY, edits);
  app.selectedRows.clear();
  app.quickFilter = 'pmb';
  app.pmbSubFilter = '';
  app.activePmbBayStage = '';
  app.data = buildVehicleData();
  populateFilters();
  renderAll();
}

// r693 (F303): PMB key tags follow the yard bays (Ron, 29 Oct). Spare keys = keys in these ranges not on any vehicle
// on the board, lowest first. Out-of-service tags are never offered. WPC (overflow outside PD) is not a key tag.
const PMB_KEY_RANGES = Object.freeze([[1, 40], [101, 152], [201, 282], [301, 370], [401, 462], [501, 520], [601, 650]]);
const PMB_KEY_OUT_OF_SERVICE = Object.freeze([335, 336, 337, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443]);
if (typeof window !== 'undefined' && window) window.PMB_KEY_RANGES = PMB_KEY_RANGES;
// r710 (F320, Craig 29 Oct): a key on Craig's key list is in use even when that vehicle is not on the board,
// so it is never offered as a spare key at To PMB.
function ensurePmbReservedKeys() {
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.from !== 'function' || !window.PDC_AUTH_CONTEXT) return;
  if (app.pmbReservedKeysLoading) return;
  if (app.pmbReservedKeysLoadedAt && Date.now() - app.pmbReservedKeysLoadedAt < 60000) return;
  app.pmbReservedKeysLoading = true;
  const started = Date.now();
  Promise.resolve(client.from('pdc_key_list_reserved_708').select('key_token').limit(2000)).then(result => {
    app.pmbReservedKeysLoading = false;
    app.pmbReservedKeysLoadedAt = started;
    if (result?.error) return;
    app.pmbReservedKeys = new Set((Array.isArray(result?.data) ? result.data : []).map(row => boardKeyToken(row?.key_token)).filter(Boolean));
  }).catch(() => {
    app.pmbReservedKeysLoading = false;
    app.pmbReservedKeysLoadedAt = started;
  });
}
function pmbFreeKeyNumbers(rows = (typeof app !== 'undefined' && Array.isArray(app.data)) ? app.data : [], reserved = (typeof app !== 'undefined' && app.pmbReservedKeys) ? app.pmbReservedKeys : null) {
  if (typeof ensurePmbReservedKeys === 'function' && typeof app !== 'undefined') ensurePmbReservedKeys();
  const used = new Set();
  for (const vehicle of rows || []) {
    const token = boardKeyToken(vehicleKeyNumber(vehicle));
    if (/^\d+$/.test(token)) used.add(Number(token));
  }
  for (const key of reserved || []) {
    const token = boardKeyToken(key);
    if (/^\d+$/.test(token)) used.add(Number(token));
  }
  const out = new Set(PMB_KEY_OUT_OF_SERVICE);
  const free = [];
  for (const [from, to] of PMB_KEY_RANGES) {
    for (let n = from; n <= to; n += 1) if (!used.has(n) && !out.has(n)) free.push(String(n));
  }
  return free;
}

// r692 (F302): Send to PMB box. Step 1 confirm, step 2 key number. Resolves { key } or null (cancelled).
function pmbSendToPmbDialog({ stock = '', customer = '', warning = '', existingKey = '', freeKeys = [], arrivalFlags = null } = {}) {
  return new Promise(resolve => {
    const doc = document;
    if (!doc.getElementById('pmb-send-dialog-style')) {
      const style = doc.createElement('style');
      style.id = 'pmb-send-dialog-style';
      style.textContent = '.pmb-send-overlay{position:fixed;inset:0;z-index:4000;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;padding:16px}'
        + '.pmb-send-box{background:#fff;border-radius:12px;box-shadow:0 20px 50px rgba(15,23,42,.35);width:min(420px,100%);padding:18px 20px;font:14px/1.4 Arial,Helvetica,sans-serif;color:#142334}'
        + '.pmb-send-box h2{margin:0 0 6px;font-size:18px}.pmb-send-box p{margin:0 0 10px}.pmb-send-warn{background:#fef2f2;color:#991b1b;border-radius:8px;padding:8px 10px;white-space:pre-line}'
        + '.pmb-send-box label{display:block;font-weight:700;margin:4px 0}.pmb-send-box input,.pmb-send-box select{box-sizing:border-box;width:100%;margin-top:4px;background:#fff;font:700 22px/1 Arial,Helvetica,sans-serif;padding:10px 12px;border:2px solid #1d4ed8;border-radius:8px;text-transform:uppercase}'
        + '.pmb-send-box small{display:block;color:#475569;margin-top:6px}.pmb-send-err{color:#b91c1c;font-weight:700;min-height:1.2em;margin-top:6px}'
        + '.pmb-send-actions{display:flex;gap:8px;justify-content:flex-end;margin-top:14px}.pmb-send-actions button{font:700 14px/1 Arial,Helvetica,sans-serif;height:40px;padding:0 18px;border-radius:8px;cursor:pointer;border:1px solid #cbd5e1;background:#fff;color:#142334}'
        + '.pmb-send-actions .pmb-send-yes{background:#16a34a;border-color:#15803d;color:#fff}';
      doc.head.appendChild(style);
    }
    const esc = value => escapeHtml(String(value || ''));
    const overlay = doc.createElement('div');
    overlay.className = 'pmb-send-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Send to PMB');
    const done = value => { doc.removeEventListener('keydown', onKey, true); overlay.remove(); resolve(value ? { ...value, checks: arrivalChecks } : value); };
    // r957 (F530): job card flags (GVM, long range tank, pit and weigh, fuel) and Kevin's fuel / GVM photo ticks on step 1.
    const arrival = typeof window !== 'undefined' ? window.PdcPmbArrivalFlags : null;
    let arrivalChecks = {};
    const arrivalHtml = arrival && typeof arrival.flagsHtml === 'function' ? (arrival.ensureCss?.(doc), arrival.flagsHtml(arrivalFlags)) : '';
    const confirmStep = () => {
      overlay.innerHTML = `<div class="pmb-send-box"><h2>Send to PMB?</h2><p>Confirm send <strong>${esc(stock)}</strong>${customer ? ` - ${esc(customer)}` : ''} to PMB.</p>${arrivalHtml}${warning ? `<p class="pmb-send-warn">${esc(warning)}</p>` : ''}<div class="pmb-send-actions"><button type="button" data-pmb-send="no">Cancel</button><button type="button" class="pmb-send-yes" data-pmb-send="yes">Yes, send to PMB</button></div></div>`;
      overlay.querySelector('[data-pmb-send="yes"]').addEventListener('click', keyStep);
      overlay.querySelector('[data-pmb-send="no"]').addEventListener('click', () => done(null));
      overlay.querySelector('[data-pmb-send="yes"]').focus();
      step = 'confirm';
    };
    const keyStep = () => {
      if (step === 'confirm' && arrival && typeof arrival.readChecks === 'function') arrivalChecks = arrival.readChecks(overlay, arrivalFlags);
      // r693 (F303): pick a spare key (lowest first); typing another key is still possible.
      const options = [...new Set([existingKey, ...freeKeys].filter(Boolean))];
      overlay.innerHTML = `<div class="pmb-send-box"><h2>Key number</h2><label for="pmb-send-key-pick">Spare key for ${esc(stock)}</label><select id="pmb-send-key-pick">${options.map(k => `<option value="${esc(k)}">${esc(k)}${k === existingKey ? ' (current key)' : ''}</option>`).join('')}<option value="">Other key…</option></select><input id="pmb-send-key" type="text" inputmode="numeric" autocomplete="off" maxlength="32" placeholder="Type a key number" hidden><small>Lowest spare key tag is picked (yard bay ranges). The key starts the PMB timer; the vehicle shows in New to PMB for 24 hours.</small><div class="pmb-send-err" role="alert"></div><div class="pmb-send-actions"><button type="button" data-pmb-send="no">Cancel</button><button type="button" class="pmb-send-yes" data-pmb-send="go">Send to PMB</button></div></div>`;
      const pick = overlay.querySelector('#pmb-send-key-pick');
      const input = overlay.querySelector('#pmb-send-key');
      const err = overlay.querySelector('.pmb-send-err');
      if (!options.length) { pick.value = ''; input.hidden = false; }
      pick.addEventListener('change', () => { input.hidden = pick.value !== ''; if (!input.hidden) input.focus(); });
      pick.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); go(); } });
      const go = () => {
        const key = String(pick.value || input.value || '').replace(/\s+/g, '').toUpperCase();
        if (!key) { err.textContent = 'Enter the key number.'; input.focus(); return; }
        if (!/^[A-Z0-9][A-Z0-9_-]{0,31}$/.test(key) || /^0+$/.test(key)) { err.textContent = 'Use letters and numbers only (up to 32). 0 is not a key.'; input.focus(); return; }
        done({ key });
      };
      overlay.querySelector('[data-pmb-send="go"]').addEventListener('click', go);
      overlay.querySelector('[data-pmb-send="no"]').addEventListener('click', () => done(null));
      input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); go(); } });
      if (input.hidden) pick.focus(); else input.focus();
      step = 'key';
    };
    let step = 'confirm';
    const onKey = event => {
      if (event.key === 'Escape') { event.preventDefault(); done(null); }
      else if (event.key === 'Enter' && step === 'confirm') { event.preventDefault(); keyStep(); }
    };
    doc.addEventListener('keydown', onKey, true);
    overlay.addEventListener('click', event => { if (event.target === overlay) done(null); });
    doc.body.appendChild(overlay);
    confirmStep();
  });
}

async function transferYhVehicleToPmb(key = '') {
  const vehicle = selectedVehicle(key);
  if (sharedVehicleLocationMutationUnavailable('transfer to PMB', vehicle)) return false;
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'transfer to PMB')) return false;
  if (!canTransferVehicleToPmb(vehicle)) {
    pdcNotify('Only incoming Yard Hold, Non-Navision or In Transit vehicles can be transferred to PMB from this button.');
    return;
  }
  const stock = displayStockNumber(vehicle) || 'No stock';
  const customer = vehicleCustomerName(vehicle) || 'Unknown customer';
  const partsWarning = pmbPartsReleaseWarning([vehicle]);
  const existingKey = String(vehicle.keyNumber || vehicle.keyNo || vehicle.key_number || vehicle.keyTag || vehicle.pdcKeyNumber || '').trim();
  // r692 (F302): one in-page box: "Confirm send to PMB?" then "Key number"; Enter sends. The key starts the PMB timer
  // and keeps the vehicle in New to PMB for 24 hours. Browsers without the box keep the old confirm / prompt.
  let enteredKey = '';
  const dialogReady = typeof pmbSendToPmbDialog === 'function' && typeof document !== 'undefined' && document && document.body && typeof document.createElement === 'function';
  if (dialogReady) {
    const arrivalApi = window.PdcPmbArrivalFlags;
    const arrivalFlags = arrivalApi && typeof arrivalApi.load === 'function' ? await arrivalApi.load(vehicle) : null;
    const answer = await pmbSendToPmbDialog({ stock, customer, warning: partsWarning, existingKey, freeKeys: typeof pmbFreeKeyNumbers === 'function' ? pmbFreeKeyNumbers() : [], arrivalFlags });
    if (!answer || !answer.key) return false;
    enteredKey = answer.key;
    // r957 (F530): save Kevin's ticks (fuel / GVM photos for Ron) as soon as he confirms; never blocks the move.
    if (arrivalApi && answer.checks && Object.keys(answer.checks).length) {
      arrivalApi.save(vehicle, answer.checks).then(res => {
        if (res && res.ok === false && typeof pdcNotify === 'function') pdcNotify(`${stock}: the fuel / GVM photo tick was not saved.`);
      });
    }
  } else {
    if (!window.confirm(`${partsWarning ? partsWarning + '\n\n' : ''}Transfer ${stock} - ${customer} to PMB?\n\nThis is a manual PDC location change. Future Navision uploads will not move it back.`)) return;
    if (!existingKey) {
      const ask = typeof window.prompt === 'function' ? window.prompt.bind(window) : null;
      if (!ask) {
        if (typeof pdcNotify === 'function') pdcNotify('Enter a key number, then press To PMB. The vehicle stayed where it is.');
        return false;
      }
      const typed = ask(`Key number for ${stock}. It goes straight to the PMB bucket. No acknowledgement.`);
      if (typed == null || !String(typed).trim()) {
        if (typeof pdcNotify === 'function') pdcNotify('No key number was entered. The vehicle stayed where it is.');
        return false;
      }
      enteredKey = String(typed).replace(/\s+/g, '').toUpperCase();
    }
  }
  if (enteredKey && enteredKey.toUpperCase() !== existingKey.toUpperCase()) {
    if (!/^[A-Z0-9][A-Z0-9_-]{0,31}$/.test(enteredKey) || /^0+$/.test(enteredKey)) {
      if (typeof pdcNotify === 'function') pdcNotify('Use letters and numbers only (up to 32). The vehicle stayed where it is.');
      return false;
    }
    const client = window.PDC_SUPABASE;
    const keyId = String(vehicle.__emailVehicleId || vehicle.id || '').trim();
    const keyUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (client && typeof client.rpc === 'function' && keyUuid.test(keyId)) {
      const keyVersion = Number(vehicle.__emailVehicleVersion);
      let idem = String(Date.now());
      try { if (typeof crypto !== 'undefined' && crypto.randomUUID) idem = crypto.randomUUID(); } catch (_error) { idem = String(Date.now()); }
      const saved = await client.rpc('set_pdc_vehicle_key_number_460', {
        p_vehicle_id: keyId,
        p_expected_vehicle_version: Number.isInteger(keyVersion) && keyVersion >= 0 ? keyVersion : 0,
        p_key_number: enteredKey,
        p_idempotency_key: idem,
      });
      const savedBody = saved?.data;
      if (saved?.error || !savedBody || savedBody.ok !== true) {
        if (typeof pdcNotify === 'function') pdcNotify(savedBody?.message || saved?.error?.message || 'The key number was not saved. The vehicle stayed where it is.');
        return false;
      }
      // r698 (F308): the new version is inside data. Reading the top level kept the old version, so To PMB then hit
      // "This vehicle changed since you loaded it" and a second try said the key was not saved.
      const keyVersionAfter = Number(savedBody.data?.vehicle_version_after ?? savedBody.vehicle_version_after);
      if (Number.isInteger(keyVersionAfter) && keyVersionAfter > 0) vehicle.__emailVehicleVersion = keyVersionAfter;
    }
    vehicle.keyNumber = enteredKey;
    vehicle.key_number = enteredKey;
  }

  if (!vehicleLocationActionAllowed(vehicle, 'transfer to PMB')) return false;

  if (vehicle.__emailVehicleServerAuthoritative === true && vehicleLifecycleSharedModeActive()) {
    const emailVehicleId = String(vehicle.__emailVehicleId || '').trim();
    const emailVersion = Number(vehicle.__emailVehicleVersion);
    const hasExactEmailRef = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(emailVehicleId)
      && Number.isInteger(emailVersion) && emailVersion >= 0;
    const ref = hasExactEmailRef
      ? { outcome: 'resolved', vehicleId: emailVehicleId, version: emailVersion, isArchived: false }
      : await vehicleLifecycleSharedRef(vehicle);
    if (!ref || ref.outcome !== 'resolved') {
      pdcNotify(describeVehicleLifecycleResolutionOutcome(ref));
      return false;
    }
    if (ref.isArchived) {
      pdcNotify('This vehicle is archived and cannot be moved into PMB. No change was made.');
      return false;
    }
    const result = await window.__vehicleLifecycleActions.pmbTransferVehicle({
      vehicleId: ref.vehicleId,
      expectedVersion: ref.version,
    });
    if (!result || result.ok !== true) {
      pdcNotify(result?.error === 'pmb_transfer_requires_incoming_location'
        ? 'This vehicle is no longer in an incoming location. Refresh Vehicle Locations and check its current location before moving it to PMB.'
        : typeof describeVehicleLifecycleActionError === 'function'
        ? describeVehicleLifecycleActionError(result && result.error)
        : 'The vehicle could not be moved into PMB.');
      await refreshEmailVehicleLocations();
      return false;
    }
    reconcileVehicleLifecycleServerResult(vehicle, result);
    app.quickFilter = 'pmb';
    app.pmbSubFilter = '';
    app.activePmbBayStage = '';
    await refreshEmailVehicleLocations();
    if (app.currentView === 'workflow') await loadWorkshopEligibilitySnapshot('pmb_transfer');
    renderAll();
    return true;
  }

  const transferTime = nowIsoString();
  const edits = loadVehicleEdits();
  const rowKey = vehicleKey(vehicle);
  const updates = {
    ...pdcVisibilityPromotionUpdates(vehicle, 'Operator PMB transfer'),
    pdcLocation: 'PMB',
    manualLocation: 'PMB',
    pdcLocationLocked: true,
    navisionLocationLocked: true,
    dateToPmb: vehicle.dateToPmb || window.PDC_VEHICLE_LOCATION_LIFECYCLE?.businessDateInTimeZone?.(new Date()) || transferTime.slice(0, 10),
    pmbEnteredAt: pmbEnteredTimestamp(vehicle) || transferTime,
    pmbTransferredAt: vehicle.pmbTransferredAt || transferTime,
    pdcLocationUpdatedAt: transferTime,
    pmbStage: '',
    pdcWorkStage: '',
    workStage: '',
    pmbStageEnteredAt: '',
    pmbStageUpdatedAt: '',
    pmbBayStage: '',
    pmbBayNumber: '',
    pmbBayEstimatedHours: '',
    pmbBayEnteredAt: '',
    pmbBayScheduledStartAt: '',
    pmbBayCompletedAt: '',
    pmbBayCompletedBy: '',
    pmbBayCompletedStage: '',
    pmbBayMechanic: '',
    pmbSubletProvider: '',
  };

  Object.assign(vehicle, updates);
  edits[rowKey] = { ...(edits[rowKey] || {}), ...updates };
  if (vehicle.stock && vehicle.stock !== rowKey) edits[vehicle.stock] = { ...(edits[vehicle.stock] || {}), ...updates };

  recordVehicleAudit(vehicle, 'Transferred to PMB', { from: pdcLocationLabel(vehiclePdcLocation(vehicle)) || 'Incoming', to: 'PMB - Unallocated', protectedFromNavision: 'Yes' });

  saveJson(EDITS_KEY, edits);
  app.quickFilter = 'pmb';
  app.pmbSubFilter = '';
  app.activePmbBayStage = '';
  app.data = buildVehicleData();
  populateFilters();
  renderAll();
}

function transferSelectedPmbVehiclesToRft() {
  const selected = selectedVehiclesForBulkEmail();
  transferVehiclesToRft(selected, { clearSelection: true });
}

function transferVehicleToRftFromCard(key) {
  const vehicle = app.data.find(v => vehicleKey(v) === key || v.stock === key || v.id === key);
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'transfer to RFT')) return;
  transferVehiclesToRft([vehicle], { clearSelection: false });
}

function confirmRftGateOverride(vehicles = []) {
  const rows = vehiclesWithRftGateIssues(vehicles);
  if (!rows.length) return { allowed: true, overridden: false, reason: '' };
  const issuePreview = rows.slice(0, 12).map(row => {
    const vehicle = row.vehicle;
    return `• ${displayStockNumber(vehicle) || 'No stock'} - ${row.issues.join('; ')}`;
  }).join('\n');
  const more = rows.length > 12 ? `\n• plus ${rows.length - 12} more with RFT gate issues` : '';
  pdcNotify(`Cannot transfer to RFT yet.\n\nEvery required PDC box must be signed off before a vehicle can move to RFT.\n\n${issuePreview}${more}`);
  return { allowed: false, overridden: false, reason: '', issueCount: rows.length, issues: rows };
}

async function transferVehiclesToRft(vehicles = [], options = {}) {
  const selected = vehicles.filter(Boolean);
  if (!selected.length || selected.some(vehicle => !vehicleLocationActionAllowed(vehicle, 'transfer to RFT'))) return;
  const nonPmb = selected.filter(vehicle => {
    const category = statusCategory(vehicle);
    return !(category === 'qc' && vehicle.pdcQcComplete === true);
  });
  if (nonPmb.length) {
    pdcNotify('Only a vehicle with a named QC sign-off that still remains in QC can be transferred to RFT.');
    return;
  }
  const gate = confirmRftGateOverride(selected);
  if (!gate.allowed) return;
  const preview = selected.slice(0, 10).map(vehicle => `• ${vehicleIdentityTitle(vehicle) || 'No stock'} - ${vehicleCustomerName(vehicle) || 'Unknown customer'} - ${pmbStageLabel(inferredPmbStage(vehicle)) || 'Unallocated'}`).join('\n');
  const more = selected.length > 10 ? `\n• plus ${selected.length - 10} more` : '';
  if (!window.confirm(`Transfer ${selected.length} signed-off QC vehicle${selected.length === 1 ? '' : 's'} to Vehicles RFT?\n\n${preview}${more}\n\nThis is separate from QC sign-off, marks the vehicle Ready for Transport, and keeps it protected from Navision location changes.`)) return;

  if (vehicleLifecycleSharedModeActive()) {
    const failures = [];
    for (const vehicle of selected) {
      if (!vehicleLocationActionAllowed(vehicle, 'transfer to RFT')) {
        failures.push(`${vehicleIdentityTitle(vehicle) || 'No stock'} - shared Navision identity is not ready or requires review`);
        continue;
      }
      const ref = await vehicleLifecycleSharedRef(vehicle);
      if (!ref || ref.outcome !== 'resolved') {
        failures.push(`${vehicleIdentityTitle(vehicle) || 'No stock'} - ${describeVehicleLifecycleResolutionOutcome(ref)}`);
        continue;
      }
      if (ref.isArchived) {
        failures.push(`${vehicleIdentityTitle(vehicle) || 'No stock'} - archived in shared data`);
        continue;
      }
      if (!ref.qcCompletedAt) {
        failures.push(`${vehicleIdentityTitle(vehicle) || 'No stock'} - QC sign-off required first`);
        continue;
      }
      if (!vehicleLocationActionAllowed(vehicle, 'transfer to RFT')) {
        failures.push(`${vehicleIdentityTitle(vehicle) || 'No stock'} - shared Navision identity changed before transfer`);
        continue;
      }
      const result = isAcceptanceClosureVehicle(vehicle)
        ? await window.__vehicleLifecycleActions.acceptanceRftTransfer({ vehicleId: ref.vehicleId, expectedVersion: ref.version, idempotencyKey: crypto.randomUUID() })
        : await window.__vehicleLifecycleActions.rftTransferVehicle({ vehicleId: ref.vehicleId, expectedVersion: ref.version });
      if (!result || result.ok !== true) {
        const message = typeof describeVehicleLifecycleActionError === 'function' ? describeVehicleLifecycleActionError(result && result.error) : 'The transfer could not be saved.';
        failures.push(`${vehicleIdentityTitle(vehicle) || 'No stock'} - ${message}`);
        continue;
      }
    }
    if (failures.length) {
      pdcNotify(`Some vehicles were not transferred:\n\n${failures.join('\n')}`);
    }
    if (options.clearSelection) app.selectedRows.clear();
    app.quickFilter = 'rft';
    app.pmbSubFilter = '';
    if (typeof window.__workshopDataService !== 'undefined' && window.__workshopDataService) window.__workshopDataService.loadSnapshot('rft_transfer');
    renderAll();
    if (selected.length === 1 && !failures.length && !isAcceptanceClosureVehicle(selected[0])) {
      offerSalespersonChangeEmail(selected[0], {
        title: 'Vehicle ready for transport (RFT)',
        subject: 'Vehicle ready for transport',
        shared: true,
        details: ['The vehicle has moved to RFT and is ready for transport. A notification has been queued for the assigned salesperson.'],
      });
    }
    return;
  }

  const transferTime = nowIsoString();
  selected.forEach(vehicle => {
    recordVehicleAudit(vehicle, 'Transferred to RFT', { from: pmbStageLabel(inferredPmbStage(vehicle)) || 'PMB - Unallocated', to: 'RFT', completedJobs: pdcCompletedJobsText(vehicle), outstandingJobs: pdcOutstandingJobsText(vehicle), blocked: isPdcBlocked(vehicle) ? pdcBlockReason(vehicle) : '' });
    saveVehicleEdits(vehicleKey(vehicle), {
      ...pdcVisibilityPromotionUpdates(vehicle, 'Operator RFT transfer'),
      pdcLocation: 'RFT',
      manualLocation: 'RFT',
      pdcLocationLocked: true,
      rftTransferredAt: transferTime,
      dateToRft: vehicle.dateToRft || window.PDC_VEHICLE_LOCATION_LIFECYCLE?.businessDateInTimeZone?.(new Date()) || transferTime.slice(0, 10),
      pdcLocationUpdatedAt: transferTime,
      pmbEnteredAt: pmbEnteredTimestamp(vehicle) || transferTime,
    });
  });
  if (options.clearSelection) app.selectedRows.clear();
  app.quickFilter = 'rft';
  app.pmbSubFilter = '';
  app.data = buildVehicleData();
  populateFilters();
  renderAll();
  if (selected.length === 1) {
    offerSalespersonChangeEmail(selected[0], {
      title: 'Vehicle ready for transport (RFT)',
      subject: 'Vehicle ready for transport',
      details: ['The vehicle has moved to RFT and is ready for transport.'],
    });
  }
}


function salespersonEmail(vehicle = {}) {
  return cleanNavisionText(salespersonForVehicle(vehicle)?.email || RFT_SALESPERSON_EMAIL);
}

function salespersonDisplayName(vehicle = {}) {
  return salespersonForVehicle(vehicle)?.name || consultantName(vehicle) || 'Sales';
}

function salespersonChangeFlag(vehicle = {}, change = {}) {
  const title = cleanNavisionText(change.title || '');
  if (title && title.toLowerCase() !== 'vehicle status update') return title;
  if (statusCategory(vehicle) === 'rft') return 'Ready for transport (RFT)';
  if (vehicleCollectedFromRft(vehicle)) return 'Vehicle completed / collected';
  if (isActivePartsStoppage(vehicle)) return 'Parts delay / STOPPAGE';
  const partsStatus = partsDepartmentStatus(vehicle);
  if (partsWorstEtaLabel(vehicle) && !['issued', 'notrequired'].includes(partsStatus)) return 'Parts ETA / delay update';
  if (isPdcBlocked(vehicle)) return 'PDC STOPPAGE / blocker';
  return title || 'Vehicle status update';
}

function salespersonChangeBannerLines(vehicle = {}, change = {}) {
  return [
    '========================================',
    `IMPORTANT UPDATE: ${salespersonChangeFlag(vehicle, change).toUpperCase()}`,
    '========================================',
  ];
}

function salespersonChangeEmailBody(vehicle = {}, change = {}) {
  const salesperson = salespersonDisplayName(vehicle);
  const details = (Array.isArray(change.details) ? change.details : [change.details]).map(cleanNavisionText).filter(Boolean);
  const outstanding = vehicleOutstandingWorkEmailLines(vehicle);
  return [
    `Hi ${salesperson},`,
    '',
    ...salespersonChangeBannerLines(vehicle, change),
    '',
    'The PDC Control Board has been updated for the following vehicle:',
    '',
    ...vehicleEmailLines(vehicle),
    `Job Card: ${vehicleJobcardNumber(vehicle) || 'TBA'}`,
    `Update: ${cleanNavisionText(change.title || 'Vehicle status updated')}`,
    ...details.map(detail => `- ${detail}`),
    `Current status: ${statusCategoryLabel(vehicle)}${inferredPmbStage(vehicle) ? ` / ${pmbStageLabel(inferredPmbStage(vehicle))}` : ''}`,
    '',
    'Current outstanding work and booking times:',
    ...(outstanding.length ? outstanding : ['- None']),
    '',
    'Please update the customer or delivery expectation if required.',
    '',
    'Kind Regards,',
  ].join('\n');
}

function draftSalespersonChangeEmail(vehicle = {}, change = {}, recipient = '') {
  const stockIdentity = displayStockNumber(vehicle);
  if (!stockIdentity || vehicle.__emailVehicleServerAuthoritative !== true || vehicle.__emailVehicleIdentityConflict === true || !vehicleWorkshopDetailCanonicalId(vehicle)) {
    pdcNotify('The authoritative vehicle card is still loading. No blank or TBA email draft was opened. Close and reopen the Stock after the refresh completes.');
    return false;
  }
  const email = cleanNavisionText(recipient || salespersonEmail(vehicle));
  if (!email) {
    pdcNotify('Enter a salesperson email address before opening the email draft.');
    return false;
  }
  const stock = stockIdentity;
  const subject = `${cleanNavisionText(change.subject || change.title || 'PDC vehicle update')} - ${stock}`;
  const body = String(change.body || '').trim() || salespersonChangeEmailBody(vehicle, change);
  if (change.shared !== true) {
    recordVehicleAudit(vehicle, 'Salesperson update email drafted', { change: change.title || 'Vehicle status updated', recipient: email });
  }
  window.location.href = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return true;
}

function offerSalespersonChangeEmail(vehicle = {}, change = {}) {
  if (!vehicle || !change?.title || typeof document?.createElement !== 'function') return;
  const existingOverlay = document.querySelector('[data-sales-change-email-overlay]');
  if (typeof existingOverlay?.remove === 'function') existingOverlay.remove();
  const salesperson = salespersonDisplayName(vehicle) || 'Unassigned';
  const defaultEmail = salespersonEmail(vehicle);
  const details = (Array.isArray(change.details) ? change.details : [change.details]).map(cleanNavisionText).filter(Boolean);
  const overlay = document.createElement('div');
  const returnFocus = document.activeElement;
  if (typeof overlay?.querySelectorAll !== 'function' || typeof overlay?.querySelector !== 'function') return;
  overlay.className = 'modal-overlay sales-change-email-overlay';
  overlay.dataset.salesChangeEmailOverlay = 'true';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'sales-change-email-title');
  overlay.innerHTML = `
    <section class="modal-card sales-change-email-card">
      <button class="modal-close" type="button" data-sales-email-cancel aria-label="Close email notification">×</button>
      <div class="sales-change-email-heading">
        <span class="sales-change-email-icon">@</span>
        <div><h2 id="sales-change-email-title">Notify salesperson?</h2><p>The vehicle update has been saved. Open a prepared email to let sales know what changed.</p></div>
      </div>
      <div class="sales-change-email-summary">
        <strong>${escapeHtml(salespersonChangeFlag(vehicle, change))}</strong>
        <span>${escapeHtml(vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'Vehicle')} · ${escapeHtml(vehicleCustomerName(vehicle) || 'Unknown customer')}</span>
        ${details.map(detail => `<small>${escapeHtml(detail)}</small>`).join('')}
      </div>
      <div class="sales-change-email-fields">
        <label><span>Salesperson</span><input value="${escapeHtml(salesperson)}" readonly /></label>
        <label><span>Email address</span><input type="email" value="${escapeHtml(defaultEmail)}" data-sales-email-recipient autocomplete="email" readonly /></label>
      </div>
      <div class="subtle">The email address is linked to the selected salesperson directory record. The website opens the draft for review before sending.</div>
      <div class="edit-actions sales-change-email-actions">
        <button class="secondary" type="button" data-sales-email-cancel>Not now</button>
        <button class="primary" type="button" data-sales-email-open>Open email draft</button>
      </div>
    </section>`;
  const close = () => {
    overlay.remove();
    if (!document.querySelector('.modal-overlay')) document.body.classList.remove('modal-open');
    if (returnFocus instanceof HTMLElement && returnFocus.isConnected) returnFocus.focus();
  };
  overlay.querySelectorAll('[data-sales-email-cancel]').forEach(button => button.addEventListener('click', close));
  overlay.addEventListener('click', event => { if (event.target === overlay) close(); });
  overlay.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      trapModalFocus(overlay, event);
      event.stopPropagation();
      return;
    }
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    close();
  });
  overlay.querySelector('[data-sales-email-open]')?.addEventListener('click', () => {
    const recipient = overlay.querySelector('[data-sales-email-recipient]')?.value || '';
    if (draftSalespersonChangeEmail(vehicle, change, recipient)) close();
  });
  document.body.appendChild(overlay);
  document.body.classList.add('modal-open');
  overlay.querySelector('[data-sales-email-open]')?.focus();
}

function vehicleOutstandingWorkEmailLines(vehicle = {}) {
  const activeStatuses = new Set(['queued', 'planned', 'started', 'stoppage']);
  const bookings = (Array.isArray(vehicle.salesWorkshopBookings) ? vehicle.salesWorkshopBookings : [])
    .filter(booking => activeStatuses.has(String(booking.status || '').toLowerCase()));
  const dateTime = value => {
    const parsed = parseIsoTimestamp(value);
    return parsed ? parsed.toLocaleString('en-AU', { timeZone: 'Australia/Perth', dateStyle: 'short', timeStyle: 'short' }) : '';
  };
  return pdcRequirementDefinitions(vehicle).filter(job => !pdcJobComplete(vehicle, job)).map(job => {
    const stage = normalizePmbStage(job.key);
    const priority = status => ({ started: 0, stoppage: 1, planned: 2, queued: 3 }[String(status || '').toLowerCase()] ?? 9);
    const matches = bookings.filter(booking => normalizePmbStage(booking.stageCode) === stage)
      .sort((a, b) => priority(a.status) - priority(b.status) || String(a.scheduledStartAt).localeCompare(String(b.scheduledStartAt)));
    const booking = matches[0];
    if (!booking) return `- ${job.label} · Not booked`;
    const status = String(booking.status || 'planned').toUpperCase();
    const start = dateTime(booking.actualStartAt || booking.scheduledStartAt);
    const end = dateTime(booking.actualEndAt || booking.scheduledEndAt);
    const range = [start, end].filter(Boolean).join(' to ');
    return `- ${job.label} · ${status}${range ? ` · ${range}` : ''}${booking.bayName ? ` · ${booking.bayName}` : ''}`;
  });
}

function vehicleStatusUpdateEmailBody(vehicle = {}) {
  const salesperson = salespersonDisplayName(vehicle);
  const location = pdcLocationLabel(vehiclePdcLocation(vehicle)) || statusCategoryLabel(vehicle) || 'Follow Navision';
  const stage = inferredPmbStage(vehicle);
  const stageLabel = stage ? pmbStageLabel(stage) : (vehiclePdcLocation(vehicle) === 'PMB' ? 'Unallocated' : 'Not in PMB');
  const bay = pmbBaySummary(vehicle) || 'No numbered bay';
  const partsStatus = partsDepartmentStatus(vehicle);
  const partsOpen = !['issued', 'notrequired'].includes(partsStatus);
  const partsEta = partsWorstEtaLabel(vehicle) || 'Not recorded';
  const partsCountdown = partsWorstEtaCountdownLabel(vehicle);
  const completed = pdcCompletedJobs(vehicle).map(job => {
    const completedAt = parseIsoTimestamp(vehicle[job.completeAtKey]);
    const when = completedAt ? ` on ${completedAt.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' })}` : '';
    const by = cleanNavisionText(vehicle[job.completeByKey] || '');
    const mechanic = pdcJobMechanic(vehicle, job);
    const completedBay = pdcJobBay(vehicle, job);
    const hours = pdcJobHours(vehicle, job);
    return `- ${job.label}${when}${by ? ` by ${by}` : ''}${mechanic ? ` · Mechanic: ${mechanic}` : ''}${completedBay ? ` · Bay: ${completedBay}` : ''}${hours ? ` · ${hours}h` : ''}`;
  });
  const outstanding = vehicleOutstandingWorkEmailLines(vehicle);
  const workshopHistory = vehicleWorkshopHistoryLines(vehicle);
  const blocker = isPdcBlocked(vehicle) ? pdcBlockReason(vehicle) : '';
  return [
    `Hi ${salesperson},`,
    '',
    ...salespersonChangeBannerLines(vehicle, { title: 'Vehicle status update' }),
    '',
    'Here is the latest PDC update for this vehicle:',
    '',
    ...vehicleEmailLines(vehicle),
    `Job Card: ${vehicleJobcardNumber(vehicle) || 'TBA'}`,
    `Current location: ${location}`,
    `Current PMB area: ${stageLabel}${vehiclePdcLocation(vehicle) === 'PMB' ? ` · ${bay}` : ''}`,
    `Navision sub-location: ${navisionStatusText(vehicle) || 'Not supplied'}`,
    `ETA to Kewdale: ${scotEtaOnly(vehicle.etaAtDealer) || 'Not supplied'}`,
    '',
    `Parts status: ${partsDepartmentStatusLabel(partsStatus)}`,
    ...(partsOpen ? [
      `Parts ETA: ${partsEta}${partsCountdown ? ` (${partsCountdown})` : ''}`,
      ...(isActivePartsStoppage(vehicle) ? [`Parts STOPPAGE: ${partsStoppageReason(vehicle)}`] : []),
    ] : []),
    '',
    'Workshop / bay history:',
    ...(workshopHistory.length ? workshopHistory : ['- No bay visits recorded yet']),
    '',
    'Work completed:',
    ...(completed.length ? completed : ['- No PDC work has been signed off yet']),
    '',
    'Work still outstanding:',
    ...(outstanding.length ? outstanding : ['- None']),
    ...(blocker ? ['', `Current STOPPAGE / blocker: ${blocker}`] : []),
    '',
    'Kind Regards,',
  ].join('\n');
}

function draftSelectedVehicleStatusEmail(key = '') {
  const cleanKey = String(key || '').trim();
  const activeDetail = app.activeVehicleDetail;
  const modalVehicle = cleanKey
    && activeDetail
    && String(vehicleKey(activeDetail) || '').trim() === cleanKey
    ? activeDetail
    : null;
  const resolvedVehicle = modalVehicle || (cleanKey ? selectedVehicle(cleanKey) : null);
  const selected = resolvedVehicle ? [resolvedVehicle] : selectedVehiclesForBulkEmail();
  if (selected.length !== 1) {
    pdcNotify('Select exactly one vehicle before using EMAIL UPDATE.');
    return;
  }
  const vehicle = selected[0];
  if (!displayStockNumber(vehicle) || vehicle.__emailVehicleServerAuthoritative !== true || vehicle.__emailVehicleIdentityConflict === true || !vehicleWorkshopDetailCanonicalId(vehicle)
      || (app.vehicleModalIdentity && !vehicleModalIdentityMatches(vehicle))) {
    pdcNotify('The authoritative vehicle card is still loading. No blank or TBA email draft was opened.');
    return;
  }
  offerSalespersonChangeEmail(vehicle, {
    title: 'Vehicle status update',
    subject: 'Vehicle update',
    details: [
      `Current location: ${pdcLocationLabel(vehiclePdcLocation(vehicle)) || statusCategoryLabel(vehicle) || 'Follow Navision'}.`,
      `Parts: ${partsDepartmentStatusLabel(partsDepartmentStatus(vehicle))}.`,
      'The draft includes parts ETA, bay history, completed work and outstanding work.',
    ],
    body: vehicleStatusUpdateEmailBody(vehicle),
  });
}

function draftRftSalespersonNotificationEmail(vehicles = []) {
  const list = vehicles.map(item => typeof item === 'string' ? selectedVehicle(item) : item).filter(Boolean);
  if (!list.length) return;
  const salesperson = list.length === 1 ? salespersonDisplayName(list[0]) : 'Sales team';
  const body = [
    `Hi ${salesperson},`,
    '',
    ...salespersonChangeBannerLines(list[0], { title: 'Ready for transport (RFT)' }),
    '',
    list.length === 1 ? 'The following vehicle is complete and ready for transport:' : 'The following vehicles are complete and ready for transport:',
    '',
    list.map(vehicle => {
      const completed = pdcCompletedJobs(vehicle).map(job => {
        const by = vehicle[job.completeByKey] ? ` by ${vehicle[job.completeByKey]}` : '';
        const at = parseIsoTimestamp(vehicle[job.completeAtKey]);
        const atText = at ? ` on ${at.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' })}` : '';
        const mechanic = pdcJobMechanic(vehicle, job) ? ` · mechanic ${pdcJobMechanic(vehicle, job)}` : '';
        const bay = pdcJobBay(vehicle, job) ? ` · bay ${pdcJobBay(vehicle, job)}` : '';
        const hours = pdcJobHours(vehicle, job) ? ` · ${pdcJobHours(vehicle, job)}h` : '';
        return `- ${job.label}${by}${atText}${mechanic}${bay}${hours}`;
      });
      const outstanding = vehicleOutstandingWorkEmailLines(vehicle);
      return [
        `Stock number: ${displayStockNumber(vehicle) || 'TBA'}`,
        `Customer Name: ${vehicleCustomerName(vehicle) || 'TBA'}`,
        `Vehicle: ${displayVehicle(vehicle) || 'TBA'}`,
        `Salesperson: ${consultantName(vehicle) || 'Unassigned'}`,
        `PMB bucket: ${pmbStageLabel(inferredPmbStage(vehicle)) || 'Unallocated'}`,
        `Kewdale ETA age: ${pmbAgeDetailText(vehicle)}`,
        '',
        'Jobs completed:',
        completed.length ? completed.join('\n') : '- No PMB jobs have been ticked as complete in the tracker',
        '',
        'Outstanding jobs at RFT transfer:',
        outstanding.length ? outstanding.join('\n') : '- None recorded',
      ].join('\n');
    }).join('\n\n'),
    '',
    'Status: RFT - Ready for Transport',
    '',
    'Kind Regards,'
  ].join('\n');
  const subject = list.length === 1
    ? `RFT complete - ${displayStockNumber(list[0]) || 'TBA'}`
    : `RFT complete - ${list.length} vehicles`;
  const recipient = list.length === 1 ? salespersonEmail(list[0]) : RFT_SALESPERSON_EMAIL;
  window.location.href = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}


function draftSelectedArrivingVehicleEmail() {
  const vehicles = selectedVehiclesForBulkEmail();
  if (!vehicles.length) return;
  const body = [
    'Hi PDC,',
    '',
    'The following vehicles are arriving:',
    '',
    vehicles.map(vehicle => vehicleEmailLines(vehicle).join('\n')).join('\n\n'),
    '',
    'Kind Regards,'
  ].join('\n');
  const subject = `Vehicles arriving - ${vehicles.length} vehicle${vehicles.length === 1 ? '' : 's'}`;
  window.location.href = `mailto:${AMY_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}



const QZ_DEFAULT_PRINTER_NAMES = ['BT-Zebra-EricComp', 'dc-01\\BT-Zebra-EricComp', '192.168.0.164'];
let qzLastPrinterName = localStorage.getItem('vehicleTrackingCoreQzPrinter:v1') || '';
const externalScriptLoads = new Map();

function loadExternalScript(src = '', id = '') {
  const cleanSrc = String(src || '').trim();
  if (!cleanSrc) return Promise.reject(new Error('No script source was supplied.'));
  if (externalScriptLoads.has(cleanSrc)) return externalScriptLoads.get(cleanSrc);
  const existing = id ? document.getElementById(id) : null;
  if (existing?.dataset.loaded === 'true') return Promise.resolve(existing);
  const promise = new Promise((resolve, reject) => {
    const script = existing || document.createElement('script');
    if (id) script.id = id;
    script.src = cleanSrc;
    script.async = true;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve(script);
    }, { once: true });
    script.addEventListener('error', () => {
      externalScriptLoads.delete(cleanSrc);
      reject(new Error(`Could not load ${cleanSrc}.`));
    }, { once: true });
    if (!existing) document.head.appendChild(script);
  });
  externalScriptLoads.set(cleanSrc, promise);
  return promise;
}

function qzAvailable() {
  return typeof window.qz !== 'undefined' && window.qz.websocket && window.qz.printers && window.qz.configs;
}

async function ensureQzConnected() {
  if (!qzAvailable()) {
    await loadExternalScript('vendor/qz/qz-tray.js?v=2.2.6', 'qz-tray-script');
  }
  if (!qzAvailable()) {
    throw new Error('The QZ Tray browser connector did not load. Check QZ Tray is installed and running.');
  }
  if (!qz.websocket.isActive()) {
    await qz.websocket.connect({ retries: 2, delay: 1 });
  }
}

function printerNameMatches(name = '', target = '') {
  const a = String(name || '').toLowerCase();
  const b = String(target || '').toLowerCase();
  if (!a || !b) return false;
  return a === b || a.includes(b) || b.includes(a);
}

async function findZebraPrinterName() {
  await ensureQzConnected();
  const printers = await qz.printers.find();
  const list = Array.isArray(printers) ? printers : [printers].filter(Boolean);
  for (const target of QZ_DEFAULT_PRINTER_NAMES) {
    const match = list.find(name => String(name || '').toLowerCase() === String(target).toLowerCase());
    if (match) {
      qzLastPrinterName = match;
      localStorage.setItem('vehicleTrackingCoreQzPrinter:v1', match);
      return match;
    }
  }
  const savedZebra = list.find(name => name === qzLastPrinterName && /zebra|zdesigner|bt-zebra/i.test(String(name || '')));
  if (savedZebra) return savedZebra;
  for (const target of QZ_DEFAULT_PRINTER_NAMES) {
    const match = list.find(name => printerNameMatches(name, target));
    if (match) {
      qzLastPrinterName = match;
      localStorage.setItem('vehicleTrackingCoreQzPrinter:v1', match);
      return match;
    }
  }
  const zebra = list.find(name => /zebra|zdesigner|bt-zebra/i.test(String(name || '')));
  if (zebra) {
    qzLastPrinterName = zebra;
    localStorage.setItem('vehicleTrackingCoreQzPrinter:v1', zebra);
    return zebra;
  }
  throw new Error(`Zebra printer not found. Expected BT-Zebra-EricComp, dc-01\\BT-Zebra-EricComp or 192.168.0.164. Available printers: ${list.join(', ') || 'none'}`);
}

async function printRawZpl(zpl, sourceLabel = 'labels') {
  const clean = String(zpl || '').trim();
  if (!clean) {
    pdcNotify('No ZPL labels to print. Generate labels first.');
    return;
  }
  const printButtons = $$('[data-print-selected-zpl]').concat([$('#zpl-print')].filter(Boolean));
  printButtons.forEach(button => { button.disabled = true; });
  try {
    const printerName = await findZebraPrinterName();
    const config = qz.configs.create(printerName, {
      copies: 1,
      scaleContent: false,
      encoding: 'UTF-8',
    });
    await qz.print(config, [{ type: 'raw', format: 'plain', data: clean }]);
    const message = `Sent ${sourceLabel} to ${printerName}`;
    const summary = $('#zpl-summary');
    if (summary) summary.insertAdjacentHTML('afterbegin', `<div class="zpl-selected-notice qz-print-ok"><strong>Printed</strong><span>${escapeHtml(message)}</span></div>`);
    else pdcNotify(message, 'info');
  } catch (error) {
    const message = error?.message || String(error || 'QZ Tray print failed.');
    pdcNotify(`Could not print to Zebra via QZ Tray.\n\n${message}\n\nQZ Tray must be running, and you may need to approve this website in QZ Tray.`);
  } finally {
    updateBulkSelectionPanel(sortRows(filteredVehicles()));
    const output = $('#zpl-output');
    const printButton = $('#zpl-print');
    if (printButton) printButton.disabled = !(output && output.value.trim());
  }
}

function confirmZplWarnings(warnings = [], description = 'labels') {
  if (!warnings.length) return true;
  const preview = warnings.slice(0, 8).map(warning => `• ${warning}`).join('\n');
  const more = warnings.length > 8 ? `\n• plus ${warnings.length - 8} more warning${warnings.length - 8 === 1 ? '' : 's'}` : '';
  return window.confirm(`VIN / label warning before printing ${description}:\n\n${preview}${more}\n\nThe label can still be printed. Continue?`);
}

function selectedVehicleLabelData(vehicle = {}) {
  return {
    keyNumber: cleanZplField(vehicleKeyNumber(vehicle) || getSelectedZplBatch(vehicle)),
    stock: cleanZplField(displayStockNumber(vehicle) || ''),
    jobCard: cleanZplField(vehicleJobcardNumber(vehicle) || ''),
    customer: cleanZplField(vehicleCustomerName(vehicle) || vehicle.client || 'Dealer Order'),
    model: cleanZplField(displayVehicle(vehicle) || vehicle.vehicle || ''),
    sales: cleanZplField(consultantName(vehicle) || vehicle.salesperson || vehicle.salesPerson || ''),
    department: cleanZplField(vehicleDepartmentLabel(vehicle) || vehicle.dealershipDepartment || vehicle.dealership || 'PDC'),
  };
}

function vehiclesToZpl(vehicles = []) {
  if (!vehicles.length) return { zpl: '', count: 0, warnings: ['Select one or more vehicles first.'] };
  const zpl = vehicles.map(vehicle => vehicleToZplBlock(selectedVehicleLabelData(vehicle))).join('\n\n');
  return { zpl, count: vehicles.length, warnings: [] };
}

function selectedVehiclesToZpl() {
  return vehiclesToZpl(selectedVehiclesForBulkEmail());
}

async function printZplFromSelectedRows() {
  const result = selectedVehiclesToZpl();
  if (!result.count) return;
  if (!confirmZplWarnings(result.warnings, `${result.count} selected vehicle${result.count === 1 ? '' : 's'}`)) return;
  await printRawZpl(result.zpl, `${result.count} selected vehicle${result.count === 1 ? '' : 's'}`);
}

async function printCurrentZplOutput() {
  const output = $('#zpl-output')?.value || '';
  if (!output.trim()) {
    pdcNotify('No ZPL labels to print. Generate labels first.');
    return;
  }
  const parsed = parseZplInput($('#zpl-input')?.value || '');
  if (!confirmZplWarnings(parsed.warnings, 'the troubleshooting ZPL output')) return;
  await printRawZpl(output, 'current ZPL output');
}

async function printZplForVehicleKey(key = '') {
  const cleanKey = String(key || '').trim();
  const vehicle = app.data.find(item => [vehicleKey(item), item.stock, item.batch, item.id].map(String).includes(cleanKey));
  if (!vehicle) {
    pdcNotify('This vehicle could not be found. Refresh the page and try again.');
    return;
  }
  const result = vehiclesToZpl([vehicle]);
  if (!result.count) return;
  const stock = displayStockNumber(vehicle) || 'this vehicle';
  if (!confirmZplWarnings(result.warnings, stock)) return;
  await printRawZpl(result.zpl, `${stock} label`);
}

function getSelectedZplBatch(vehicle) {
  const toyota = getToyotaMatch(vehicle) || {};
  return cleanZplField(
    vehicle.autocareBatch ||
    vehicle.batch ||
    vehicle.toyotaBatch ||
    toyota.batch ||
    displayStockNumber(vehicle) ||
    ''
  );
}

function getSelectedZplVin(vehicle) {
  const directVin = [vehicle.autocareVin, vehicle.vin, vehicle.frameVin, vehicle.vinNumber, vehicle.fullVin]
    .map(value => cleanZplField(value).toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, ''))
    .find(Boolean);
  if (directVin) return directVin;
  const wmi = cleanZplField(vehicle.wmi || vehicle.WMI || '').replace(/\s+/g, '');
  const vds = cleanZplField(vehicle.vdsNumber || vehicle.vds || vehicle.VDS || '').replace(/\s+/g, '');
  const frame = cleanZplField(vehicle.frame || vehicle.frameNo || vehicle.autocareFrame || vehicle.Frame || '').replace(/\s+/g, '');
  return cleanZplField(`${wmi}${vds}${frame}`).replace(/\s+/g, '');
}

function splitVinPartsForZpl(vehicle) {
  const vin = getSelectedZplVin(vehicle);
  const wmiSource = cleanZplField(vehicle.wmi || vehicle.WMI || '').replace(/\s+/g, '');
  const vdsSource = cleanZplField(vehicle.vdsNumber || vehicle.vds || vehicle.VDS || '').replace(/\s+/g, '');
  const frameSource = cleanZplField(vehicle.frame || vehicle.frameNo || vehicle.autocareFrame || vehicle.Frame || '').replace(/\s+/g, '');
  if (vin.length === 17) {
    return { wmi: vin.slice(0, 3), vds: vin.slice(3, 9), frame: vin.slice(9) };
  }
  return {
    wmi: wmiSource || vin.slice(0, 3),
    vds: vdsSource || vin.slice(3, 9),
    frame: frameSource || vin.slice(9),
  };
}

function selectedVehicleToZplRow(vehicle) {
  const toyota = getToyotaMatch(vehicle) || {};
  const vinParts = splitVinPartsForZpl(vehicle);
  return [
    getSelectedZplBatch(vehicle),
    cleanZplField(vehicle.customerSurname || vehicle.client || ''),
    cleanZplField(vehicle.dealerCustomerName || vehicle.toyotaCustomer || toyota.toyotaCustomer || vehicle.dealerCustomer || ''),
    cleanZplField(vehicle.modelDescription || vehicle.toyotaVehicle || toyota.toyotaVehicle || vehicle.autocareModelDescription || vehicle.autocareModel || displayVehicle(vehicle) || vehicle.vehicle || ''),
    cleanZplField(vehicle.suffixDescription || vehicle.suffix || toyota.suffix || vehicle.autocareVersionDescription || ''),
    cleanZplField(vehicle.trimDescription || vehicle.trim || toyota.trim || ''),
    cleanZplField(vehicle.colourDescription || vehicle.colour || vehicle.color || toyota.colour || vehicle.autocareColour || ''),
    cleanZplField(vinParts.wmi),
    cleanZplField(vinParts.vds),
    cleanZplField(vinParts.frame),
  ].join('\t');
}

function generateZplFromSelectedRows() {
  const vehicles = selectedVehiclesForBulkEmail();
  if (!vehicles.length) return;
  const tsv = [ZPL_REQUIRED_COLUMNS.join('\t'), ...vehicles.map(selectedVehicleToZplRow)].join('\n');
  const input = $('#zpl-input');
  if (input) input.value = tsv;
  showView('zpl');
  generateZplFromInput();
  const summary = $('#zpl-summary');
  if (summary) {
    summary.insertAdjacentHTML('afterbegin', `<div class="zpl-selected-notice"><strong>Prepared from selected CRM rows</strong><span>${vehicles.length} vehicle${vehicles.length === 1 ? '' : 's'} selected from the main tracker. Review any warnings, then copy the ZPL output.</span></div>`);
  }
}


function makeTableResizable(table) {
  if (!table) return;
  const storageKey = `vehicleTrackingCoreColumnWidths:v4:${table.id || 'vehicle-table'}`;
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch { saved = {}; }
  const headers = Array.from(table.querySelectorAll('thead th'));
  headers.forEach((th, index) => {
    const widthKey = th.dataset.colId || String(index);
    if (saved[widthKey] || saved[index]) {
      const savedWidth = `${saved[widthKey] || saved[index]}px`;
      th.style.setProperty('width', savedWidth, 'important');
      th.style.setProperty('min-width', savedWidth, 'important');
      th.style.setProperty('max-width', savedWidth, 'important');
    }
    if (th.querySelector('.col-resizer')) return;
    const grip = document.createElement('span');
    grip.className = 'col-resizer';
    grip.setAttribute('aria-hidden', 'true');
    th.appendChild(grip);
    grip.addEventListener('click', e => e.stopPropagation());
    grip.addEventListener('mousedown', e => {
      e.preventDefault();
      e.stopPropagation();
      const startX = e.clientX;
      const startWidth = th.getBoundingClientRect().width;
      document.body.classList.add('resizing-column');
      const onMove = ev => {
        const next = Math.max(48, Math.round(startWidth + ev.clientX - startX));
        const nextWidth = `${next}px`;
        th.style.setProperty('width', nextWidth, 'important');
        th.style.setProperty('min-width', nextWidth, 'important');
        th.style.setProperty('max-width', nextWidth, 'important');
        saved[widthKey] = next;
      };
      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.body.classList.remove('resizing-column');
        localStorage.setItem(storageKey, JSON.stringify(saved));
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  });
}

function setupFrozenVehicleHeader(table) {
  if (!table || table.id !== 'vehicle-table') return;
  const wrap = table.closest('.table-wrap');
  const thead = table.querySelector('thead');
  if (!wrap || !thead) return;

  if (app.frozenHeaderCleanup) app.frozenHeaderCleanup();

  const frozenWrap = document.createElement('div');
  frozenWrap.id = 'vehicle-table-frozen-head';
  frozenWrap.className = 'frozen-table-head';
  frozenWrap.setAttribute('role', 'presentation');

  const frozenTable = document.createElement('table');
  frozenTable.className = `${table.className} frozen-table-head-table`;
  frozenTable.appendChild(thead.cloneNode(true));
  frozenWrap.appendChild(frozenTable);
  document.body.appendChild(frozenWrap);

  const storageKey = `vehicleTrackingCoreColumnWidths:v4:${table.id || 'vehicle-table'}`;
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch { saved = {}; }

  let frameRequested = false;
  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(() => {
      frameRequested = false;
      updateFrozenVehicleHeader(table, wrap, frozenWrap, frozenTable);
    });
  };

  const frozenSortButtons = $$('[data-sort-key]', frozenWrap);
  frozenSortButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      setSort(button.dataset.sortKey);
    });
  });

  bindColumnFilterControls(frozenWrap);
  makeVehicleColumnsReorderable(frozenTable);

  const frozenSelectAll = $('[data-select-visible]', frozenWrap);
  if (frozenSelectAll) {
    frozenSelectAll.addEventListener('click', event => event.stopPropagation());
    frozenSelectAll.addEventListener('change', () => {
      const visibleKeys = sortRows(filteredVehicles()).map(vehicleKey).filter(Boolean);
      visibleKeys.forEach(key => {
        if (frozenSelectAll.checked) app.selectedRows.add(key);
        else app.selectedRows.delete(key);
      });
      renderVehicleTable();
    });
  }

  const frozenHeaders = Array.from(frozenWrap.querySelectorAll('thead th'));
  frozenHeaders.forEach((frozenTh, index) => {
    const grip = frozenTh.querySelector('.col-resizer');
    const widthKey = frozenTh.dataset.colId || String(index);
    if (!grip) return;
    grip.addEventListener('click', event => event.stopPropagation());
    grip.addEventListener('mousedown', event => {
      event.preventDefault();
      event.stopPropagation();
      const realTh = table.querySelectorAll('thead th')[index];
      if (!realTh) return;
      const startX = event.clientX;
      const startWidth = realTh.getBoundingClientRect().width;
      document.body.classList.add('resizing-column');
      const onMove = moveEvent => {
        const next = Math.max(48, Math.round(startWidth + moveEvent.clientX - startX));
        const nextWidth = `${next}px`;
        realTh.style.setProperty('width', nextWidth, 'important');
        realTh.style.setProperty('min-width', nextWidth, 'important');
        realTh.style.setProperty('max-width', nextWidth, 'important');
        frozenTh.style.setProperty('width', nextWidth, 'important');
        frozenTh.style.setProperty('min-width', nextWidth, 'important');
        frozenTh.style.setProperty('max-width', nextWidth, 'important');
        saved[widthKey] = next;
        requestUpdate();
      };
      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.body.classList.remove('resizing-column');
        localStorage.setItem(storageKey, JSON.stringify(saved));
        requestUpdate();
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  });

  const listeners = [
    [window, 'scroll', requestUpdate, { passive: true }],
    [window, 'resize', requestUpdate, { passive: true }],
    [wrap, 'scroll', requestUpdate, { passive: true }],
  ];
  listeners.forEach(([target, type, handler, options]) => target.addEventListener(type, handler, options));
  app.frozenHeaderCleanup = () => {
    listeners.forEach(([target, type, handler]) => target.removeEventListener(type, handler));
    frozenWrap.remove();
    document.body.classList.remove('vehicle-table-header-pinned');
  };
  requestUpdate();
}

function updateFrozenVehicleHeader(table, wrap, frozenWrap, frozenTable) {
  if (!table?.isConnected || !wrap?.isConnected || !frozenWrap?.isConnected) return;
  const dashboardActive = $('#dashboard')?.classList.contains('active');
  const thead = table.querySelector('thead');
  const firstBodyRow = table.querySelector('tbody tr');
  if (!dashboardActive || !thead || !firstBodyRow) {
    frozenWrap.classList.remove('active');
    document.body.classList.remove('vehicle-table-header-pinned');
    return;
  }

  const topOffset = 0;
  const tableRect = table.getBoundingClientRect();
  const wrapRect = wrap.getBoundingClientRect();
  const headRect = thead.getBoundingClientRect();
  const headHeight = Math.ceil(headRect.height || 34);
  const shouldPin = headRect.top <= topOffset && tableRect.bottom > topOffset + headHeight + 8;

  frozenWrap.classList.toggle('active', shouldPin);
  document.body.classList.toggle('vehicle-table-header-pinned', shouldPin);
  if (!shouldPin) return;

  frozenWrap.style.top = `${topOffset}px`;
  frozenWrap.style.left = `${Math.max(wrapRect.left, 0)}px`;
  frozenWrap.style.width = `${Math.max(wrapRect.width, 0)}px`;
  frozenWrap.style.height = `${headHeight}px`;
  frozenTable.style.width = `${Math.ceil(tableRect.width)}px`;
  frozenTable.style.minWidth = `${Math.ceil(tableRect.width)}px`;
  frozenTable.style.transform = `translateX(${-wrap.scrollLeft}px)`;

  const realHeaders = Array.from(table.querySelectorAll('thead th'));
  const frozenHeaders = Array.from(frozenWrap.querySelectorAll('thead th'));
  realHeaders.forEach((realTh, index) => {
    const frozenTh = frozenHeaders[index];
    if (!frozenTh) return;
    const width = Math.ceil(realTh.getBoundingClientRect().width);
    const widthPx = `${width}px`;
    frozenTh.style.setProperty('width', widthPx, 'important');
    frozenTh.style.setProperty('min-width', widthPx, 'important');
    frozenTh.style.setProperty('max-width', widthPx, 'important');
  });

  const visibleKeys = sortRows(filteredVehicles()).map(vehicleKey).filter(Boolean);
  const selectedVisible = visibleKeys.filter(key => app.selectedRows.has(key)).length;
  const frozenSelectAll = $('[data-select-visible]', frozenWrap);
  if (frozenSelectAll) {
    frozenSelectAll.checked = visibleKeys.length > 0 && selectedVisible === visibleKeys.length;
    frozenSelectAll.indeterminate = selectedVisible > 0 && selectedVisible < visibleKeys.length;
  }
}

function renderQuickFilterBanner(count) {
  const banner = $('#quick-filter-banner');
  if (!banner) return;
  const label = quickFilterLabel();
  if (!label) {
    banner.classList.remove('active');
    banner.innerHTML = '';
    return;
  }
  banner.classList.add('active');
  banner.innerHTML = `<span><strong>${escapeHtml(label)}</strong> · ${count} vehicle${count === 1 ? '' : 's'} shown</span><button class="small-button" type="button" id="clear-quick-filter-inline">Clear filter</button>`;
  $('#clear-quick-filter-inline')?.addEventListener('click', () => {
    clearQuickFilter(true);
    renderVehicleTable();
  });
}

function loadAuditLog() { return loadJson(AUDIT_LOG_KEY, []); }
function saveAuditLog(log) { saveJson(AUDIT_LOG_KEY, Array.isArray(log) ? log.slice(0, 1500) : []); }

function getCurrentOperatorName() {
  const authenticated = String(window.PDC_AUTH_CONTEXT?.displayName || window.PDC_AUTH_CONTEXT?.email || '').trim();
  if (authenticated) return authenticated;
  const saved = String(localStorage.getItem(OPERATOR_NAME_KEY) || '').trim();
  if (saved) return saved;
  const entered = window.prompt('Enter your name or initials for the PDC audit trail:', '') || '';
  const clean = entered.trim() || 'Unknown operator';
  try { localStorage.setItem(OPERATOR_NAME_KEY, clean); } catch {}
  return clean;
}

function getCurrentOperatorRole() {
  const authenticated = String(window.PDC_AUTH_CONTEXT?.role || '').trim();
  if (authenticated) return authenticated;
  const saved = String(localStorage.getItem(OPERATOR_ROLE_KEY) || '').trim();
  if (saved) return saved;
  const entered = window.prompt('Enter your department/role for the PDC audit trail (Tint, Hoist, Fitting, Fabrication, Electrical, Tyre bay, Parts, QC, Manager):', '') || '';
  const clean = entered.trim() || 'Unassigned role';
  try { localStorage.setItem(OPERATOR_ROLE_KEY, clean); } catch {}
  return clean;
}

function setOperatorProfile() {
  if (window.PDC_AUTH_CONTEXT?.email) {
    pdcNotify(`Signed in as ${window.PDC_AUTH_CONTEXT.displayName || window.PDC_AUTH_CONTEXT.email} (${window.PDC_AUTH_CONTEXT.role}).`, 'info');
    return;
  }
  const currentName = String(localStorage.getItem(OPERATOR_NAME_KEY) || '').trim();
  const currentRole = String(localStorage.getItem(OPERATOR_ROLE_KEY) || '').trim();
  const name = window.prompt('Name or initials for the audit trail:', currentName || '') || currentName;
  const role = window.prompt('Department/role for the audit trail:', currentRole || '') || currentRole;
  try {
    localStorage.setItem(OPERATOR_NAME_KEY, (name || 'Unknown operator').trim());
    localStorage.setItem(OPERATOR_ROLE_KEY, (role || 'Unassigned role').trim());
  } catch {}
  renderTvBoard();
  pdcNotify(`PDC operator set to ${(name || 'Unknown operator').trim()} (${(role || 'Unassigned role').trim() || 'Unassigned role'}).`, 'info');
}

function recordVehicleAudit(vehicleOrKey, action, details = {}) {
  const vehicle = typeof vehicleOrKey === 'object' ? vehicleOrKey : selectedVehicle(vehicleOrKey);
  if (!vehicle) return;
  const key = vehicleKey(vehicle);
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    at: nowIsoString(),
    by: details.by || getCurrentOperatorName(),
    role: details.role || getCurrentOperatorRole(),
    action,
    vehicleKey: key,
    stock: displayStockNumber(vehicle) || vehicle.stock || '',

    customer: vehicle.client || vehicle.toyotaCustomer || '',
    vehicle: displayVehicle(vehicle) || '',
    details,
  };
  const log = loadAuditLog();
  log.unshift(entry);
  saveAuditLog(log);
}

function auditTrailForVehicle(vehicle = {}) {
  const keys = new Set([vehicleKey(vehicle), vehicle.stock, vehicle.id].map(v => String(v || '').trim()).filter(Boolean));
  return loadAuditLog().filter(entry => keys.has(String(entry.vehicleKey || '').trim()) || keys.has(String(entry.stock || '').trim())).slice(0, 30);
}

function vehicleWorkshopHistoryLines(vehicle = {}) {
  const workshopActions = new Set([
    'Transferred to PMB',
    'PMB bucket moved',
    'Assigned to PMB bay',
    'Swapped PMB bay',
    'Removed from PMB bay',
    'Bay work completed',
    'Moved to next PMB station',
    'Job signed off',
  ]);
  return auditTrailForVehicle(vehicle)
    .filter(entry => workshopActions.has(cleanNavisionText(entry.action || '')))
    .reverse()
    .map(entry => {
      const details = entry.details || {};
      const when = parseIsoTimestamp(entry.at);
      const whenLabel = when ? when.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : 'Date not recorded';
      const movement = details.from || details.to ? [details.from, details.to].filter(Boolean).join(' → ') : '';
      const place = [details.stage, details.bay].map(cleanNavisionText).filter(Boolean).join(' · ');
      const work = cleanNavisionText(details.job || '');
      const assignee = cleanNavisionText(details.mechanic || details.provider || '');
      const hours = cleanNavisionText(details.hours || '');
      const extra = [movement, place, work, assignee ? `Mechanic/provider: ${assignee}` : '', hours ? `${hours}h` : ''].filter(Boolean).join(' · ');
      return `- ${whenLabel}: ${entry.action}${extra ? ` · ${extra}` : ''}`;
    });
}

function compactAuditValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') {
    const text = JSON.stringify(value);
    return text.length > 140 ? `${text.slice(0, 137)}…` : text;
  }
  return String(value);
}

function authoritativeAuditChangeSummary(entry = {}) {
  const before = entry.before_data && typeof entry.before_data === 'object' ? entry.before_data : {};
  const after = entry.after_data && typeof entry.after_data === 'object' ? entry.after_data : {};
  const keys = [...new Set([...Object.keys(before), ...Object.keys(after)])]
    .filter(key => JSON.stringify(before[key]) !== JSON.stringify(after[key]))
    .filter(key => !['updated_at', 'version'].includes(key));
  return keys.slice(0, 10).map(key => `${key.replace(/_/g, ' ')}: ${compactAuditValue(before[key])} → ${compactAuditValue(after[key])}`).join(' · ')
    || Object.entries(entry.metadata || {}).slice(0, 8).map(([key, value]) => `${key.replace(/_/g, ' ')}: ${compactAuditValue(value)}`).join(' · ');
}

function vehicleImportProvenanceHtml(vehicle = {}, detail = null) {
  const emails = Array.isArray(detail?.email_imports) ? detail.email_imports : [];
  const navision = Array.isArray(detail?.navision_imports) ? detail.navision_imports : [];
  const rows = [];
  emails.forEach(item => rows.push({
    title: 'Authenticated email import',
    at: item.imported_at || item.source_received_at,
    text: [`Sender ${item.sender_address || 'not recorded'}`, `Received ${item.source_received_at || 'time not recorded'}`, `Identity ${String(item.identity_source || 'email').replace(/_/g, ' ')}`, item.source_uid ? `Message UID ${item.source_uid}` : '', item.receipt_id ? `Receipt ${item.receipt_id}` : ''].filter(Boolean).join(' · '),
  }));
  navision.forEach(item => rows.push({
    title: 'Shared Navision import',
    at: item.first_seen_at || item.last_seen_at,
    text: [`First file ${item.first_source_name || 'not recorded'}`, item.first_seen_at ? `first seen ${item.first_seen_at}` : '', `Latest file ${item.last_source_name || 'not recorded'}`, item.last_seen_at ? `last seen ${item.last_seen_at}` : '', item.last_revision ? `revision ${item.last_revision}` : '', item.source_record_id ? `source record ${item.source_record_id}` : ''].filter(Boolean).join(' · '),
  }));
  if (!rows.length) rows.push({
    title: vehicle.source || (vehicle.importedAt ? 'Navision / tracker import' : 'Tracker or manual record'),
    at: vehicle.importedAt || vehicle.updatedAt || '',
    text: [vehicle.sourceRecordId ? `Source record ${vehicle.sourceRecordId}` : '', vehicle.__sharedNavisionActivationSource ? `Board activation ${vehicle.__sharedNavisionActivationSource}` : '', vehicle.__sharedNavisionDealerCode ? `Dealer ${vehicle.__sharedNavisionDealerCode}` : ''].filter(Boolean).join(' · ') || 'The legacy record does not contain a durable import receipt.',
  });
  return `<div class="vehicle-provenance-list">${rows.map(row => `<div class="vehicle-provenance-item"><strong>${escapeHtml(row.title)}</strong><span>${escapeHtml(row.at ? `${row.at} · ${row.text}` : row.text)}</span></div>`).join('')}</div>`;
}

function lifecycleHistoryHtml(vehicle = {}, detail = null) {
  const history = detail?.lifecycle_history || lifecycleHistoryForVehicle(vehicle);
  const timestamp = (businessKey, rawKey) => history[businessKey] || history[rawKey] || 'Unknown';
  const state = history.evidence_state || history.evidenceState || 'partial_or_unknown';
  const missing = Array.isArray(history.missing_evidence) ? history.missing_evidence : (Array.isArray(history.missingEvidence) ? history.missingEvidence : []);
  const status = state === 'complete' ? 'Complete evidence' : `Partial / Unknown${missing.length ? ` · Missing: ${missing.join(', ')}` : ''}`;
  return `<section class="vehicle-lifecycle-history" aria-labelledby="vehicle-lifecycle-history-heading">
    <div class="muted-label" id="vehicle-lifecycle-history-heading">Retained lifecycle history · ${escapeHtml(status)}</div>
    <div class="vehicle-provenance-list lifecycle-history-list">
      <div class="vehicle-provenance-item"><strong>First Yard Hold</strong><span>UTC: ${escapeHtml(timestamp('first_reached_yard_hold_at_utc', 'firstReachedYardHoldAt'))}<br>Australia/Perth: ${escapeHtml(timestamp('first_reached_yard_hold_at_business', 'firstReachedYardHoldAt'))}</span></div>
      <div class="vehicle-provenance-item"><strong>First PMB entry</strong><span>UTC: ${escapeHtml(timestamp('first_entered_pmb_at_utc', 'firstEnteredPmbAt'))}<br>Australia/Perth: ${escapeHtml(timestamp('first_entered_pmb_at_business', 'firstEnteredPmbAt'))}</span></div>
      <div class="vehicle-provenance-item"><strong>First successful QC → RFT</strong><span>UTC: ${escapeHtml(timestamp('first_became_rft_at_utc', 'firstBecameRftAt'))}<br>Australia/Perth: ${escapeHtml(timestamp('first_became_rft_at_business', 'firstBecameRftAt'))}</span></div>
      <div class="vehicle-provenance-item"><strong>Yard Hold → PMB</strong><span>${escapeHtml(lifecycleDurationLabel({ lifecycleHistory: history }, 'elapsedYardHoldToPmb'))}</span></div>
      <div class="vehicle-provenance-item"><strong>PMB → RFT</strong><span>${escapeHtml(lifecycleDurationLabel({ lifecycleHistory: history }, 'elapsedPmbToRft'))}</span></div>
      <div class="vehicle-provenance-item"><strong>Yard Hold → RFT</strong><span>${escapeHtml(lifecycleDurationLabel({ lifecycleHistory: history }, 'elapsedYardHoldToRft'))}</span></div>
    </div>
  </section>`;
}

function vehicleHistoryActorLabel(entry = {}, recordedIdField = 'actor_id') {
  const actor = entry.actor && typeof entry.actor === 'object' ? entry.actor : {};
  const text = value => String(value || '').trim();
  const isId = value => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
  // Actor projections come from the authorised history RPC, never the edited row.
  const label = text(actor.label);
  if (label && !isId(label)) return label;
  const email = text(actor.email || entry.actor_email);
  const name = text(actor.display_name);
  if (email) return name && name !== email ? `${name} (${email})` : email;
  if (name && !isId(name)) return name;
  if (actor.kind === 'automation') return 'Automated action';
  const recordedId = text(entry[recordedIdField] || actor.id);
  if (recordedId && !isId(recordedId)) return recordedId;
  return recordedId ? 'User not identified' : 'User not recorded';
}

function renderAuditTrailSection(vehicle = {}) {
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const state = canonicalId ? app.vehicleHistoryCache.get(canonicalId) : null;
  const detail = state?.status === 'ready' ? state.detail : null;
  const localRows = auditTrailForVehicle(vehicle);
  const serverRows = Array.isArray(detail?.audit_events) ? detail.audit_events : [];
  const movements = Array.isArray(detail?.movements) ? detail.movements : [];
  const historyRows = [
    ...movements.map(item => ({ at: item.moved_at, action: 'Vehicle moved', by: vehicleHistoryActorLabel(item, 'moved_by'), detail: [`${item.from_location || 'Unknown'} → ${item.to_location || 'Unknown'}`, item.from_pmb_stage || item.to_pmb_stage ? `${item.from_pmb_stage || 'Unallocated'} → ${item.to_pmb_stage || 'Unallocated'}` : '', item.reason || ''].filter(Boolean).join(' · ') })),
    ...serverRows.map(item => ({ at: item.created_at, action: `${String(item.action || 'update').replace(/_/g, ' ')} · ${String(item.table_name || 'vehicle').replace(/_/g, ' ')}`, by: vehicleHistoryActorLabel(item), detail: authoritativeAuditChangeSummary(item) })),
    ...localRows.map(item => ({ at: item.at, action: item.action || 'Update', by: `Browser record: ${item.by || item.user || 'Unknown operator'}${item.role ? ` (${item.role})` : ''}`, detail: Object.entries(item.details || {}).filter(([key, value]) => key !== 'by' && value !== undefined && value !== '').map(([key, value]) => `${key.replace(/_/g, ' ')}: ${compactAuditValue(value)}`).join(' · ') })),
  ].sort((a, b) => String(b.at || '').localeCompare(String(a.at || ''))).slice(0, 150);
  const status = !canonicalId ? '<div class="subtle">This legacy vehicle has no canonical shared ID, so only browser-recorded history is available.</div>'
    : state?.status === 'loading' || !state ? '<div class="subtle" role="status">Loading authoritative import receipts, movements and audit events…</div>'
      : state.status === 'error' ? `<div class="subtle">Authoritative history unavailable: ${escapeHtml(state.message || 'request failed')}</div>` : '';
  const list = historyRows.length ? `<div class="audit-log-list">${historyRows.map(entry => {
    const when = parseIsoTimestamp(entry.at);
    const whenLabel = when ? when.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Australia/Perth' }) : 'Unknown time';
    return `<div class="audit-log-item"><strong>${escapeHtml(entry.action)}</strong><span class="vehicle-history-actor">By: ${escapeHtml(entry.by)} · ${escapeHtml(whenLabel)} (Perth)</span>${entry.detail ? `<span>${escapeHtml(entry.detail)}</span>` : ''}</div>`;
  }).join('')}</div>` : '<div class="subtle">No movement or audit events have been recorded for this vehicle yet.</div>';
  return `<div class="vehicle-audit-detail">${lifecycleHistoryHtml(vehicle, detail)}<div class="muted-label">How this vehicle was imported</div>${vehicleImportProvenanceHtml(vehicle, detail)}${status}<div class="muted-label vehicle-history-label">Detailed history</div>${list}</div>`;
}

async function loadVehicleHistoryForDetail(vehicle = {}) {
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (!canonicalId) return;
  const existing = app.vehicleHistoryCache.get(canonicalId);
  if (existing && ['loading', 'ready'].includes(existing.status)) return;
  const service = app.emailVehicleLocationService;
  if (!service?.vehicleHistory) {
    app.vehicleHistoryCache.set(canonicalId, { status: 'error', message: 'History service is not available.' });
    return;
  }
  const generation = ++app.vehicleHistoryRequestGeneration;
  app.vehicleHistoryCache.set(canonicalId, { status: 'loading' });
  try {
    const response = await service.vehicleHistory(canonicalId, vehicle.__sharedNavisionDealerCode || vehicle.dealerCode || vehicle.dealer_code || '');
    if (generation !== app.vehicleHistoryRequestGeneration) return;
    if (!response?.ok) throw new Error(response?.code || 'request failed');
    app.vehicleHistoryCache.set(canonicalId, { status: 'ready', detail: response.data || {} });
  } catch (error) {
    if (generation !== app.vehicleHistoryRequestGeneration) return;
    app.vehicleHistoryCache.set(canonicalId, { status: 'error', message: error?.message || 'request failed' });
  }
  if (vehicleKey(selectedVehicle() || {}) === vehicleKey(vehicle) && !$('#vehicle-modal')?.hidden) {
    const history = $('#vehicle-detail')?.querySelector('.vehicle-audit-detail');
    if (history) history.outerHTML = renderAuditTrailSection(selectedVehicle() || vehicle);
    else renderVehicleDetailAfterBackgroundRefresh();
  }
}

const VEHICLE_WORKSHOP_STATION_PRESENTATION = Object.freeze({
  BUS_4X4: { label: 'Bus 4x4', colour: '#3e6690', tint: '#edf2f8' },
  TINT: { label: 'Tint', colour: '#227889', tint: '#eaf7f9' },
  HOIST: { label: 'Hoist', colour: '#805b43', tint: '#f5eee8' },
  FITTING: { label: 'Fitting', colour: '#79528f', tint: '#f4eef8' },
  FABRICATION: { label: 'Fabrication', colour: '#8c671d', tint: '#fbf5e5' },
  ELECTRICAL: { label: 'Electrical', colour: '#557649', tint: '#eef4eb' },
  TYRE: { label: 'Tyre', colour: '#a05270', tint: '#faedf2' },
  PIT_INSPECTION: { label: 'Pit inspection', colour: '#475569', tint: '#f8fafc' },
  SUBLET: { label: 'Sublet', colour: '#5f6d7c', tint: '#eef1f5' },
  PARTS: { label: 'Parts', colour: '#dc2626', tint: '#fef2f2' },
  REVIEW: { label: 'Review', colour: '#b45309', tint: '#fffbeb' },
  OWNER_SUPPLIED_DOCUMENT: { label: 'Unallocated – mapping review', colour: '#64748b', tint: '#f8fafc' },
});

function vehicleWorkshopStageCode(value = '') {
  const canonical = normalizePmbStage(value);
  if (canonical) return canonical;
  return cleanNavisionText(value || '').toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'OTHER';
}

function vehicleWorkshopStationPresentation(stage = '') {
  if(stage==='JOB_CARD_NOTES')return {label:'Jobcard notes',colour:'#475569',tint:'#f8fafc'};
  const code = vehicleWorkshopStageCode(stage);
  return VEHICLE_WORKSHOP_STATION_PRESENTATION[code] || { label: pmbStageLabel(code) || code.replace(/_/g, ' '), colour: '#475569', tint: '#f8fafc' };
}

function vehicleWorkshopDetailCanonicalId(vehicle = {}) {
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const direct = [vehicle.__emailVehicleId, vehicle.sharedVehicleId, vehicle.__sharedNavisionCanonicalVehicleId, vehicle.permanentVehicleId, vehicle.permanent_vehicle_id, vehicle.id]
    .map(value => cleanNavisionText(value || ''))
    .find(value => uuid.test(value));
  if (direct) return direct;
  const stock = cleanNavisionText(displayStockNumber(vehicle) || '');
  const matches = (Array.isArray(app.workshopEligibilitySnapshot?.candidates) ? app.workshopEligibilitySnapshot.candidates : [])
    .map(candidate => ({ id: candidate?.vehicle_id || candidate?.vehicle?.id || '', stock_number: candidate?.stock_number || candidate?.vehicle?.stock_number || '' }))
    .filter(row => stock && cleanNavisionText(row.stock_number || '') === stock && uuid.test(String(row.id || '')));
  const unique = [...new Set(matches.map(row => String(row.id)))];
  return unique.length === 1 ? unique[0] : '';
}

function vehicleWorkshopLocalRequirements(vehicle = {}) {
  return PDC_JOB_DEFS.filter(def => pdcJobRequired(vehicle, def)).map(def => ({
    work_key: def.key,
    stage_code: pmbStageForPdcJob(def) || def.key.toUpperCase(),
    required: true,
    completed: pdcJobComplete(vehicle, def),
    completed_at: vehicle[def.completeAtKey] || '',
  }));
}

function vehicleWorkshopLineDescription(line = {}, fallback = 'Workshop work required') {
  return cleanNavisionText(line.description || line.name || line.label || line.code || fallback) || fallback;
}

function vehicleWorkshopLineHours(line = {}) {
  const raw = [line.confirmedHours, line.estimatedHours, line.estimated_hours, line.hours]
    .find(value => value !== null && value !== undefined && String(value).trim() !== '');
  const value = Number(raw);
  return Number.isFinite(value) && value >= 0 ? value : null;
}

function vehicleWorkshopLineIdentity(stage = '', line = {}) {
  const retained = cleanNavisionText(line.workshopLineKey || line.line_key || '');
  if (retained) return retained;
  const operationLineId = cleanNavisionText(line.operation_line_id || '');
  if (/^[0-9a-f-]{36}$/i.test(operationLineId)) return `source:${operationLineId}`;
  const operationNo = cleanNavisionText(line.operation_no || '').toUpperCase();
  if (operationNo) return `operation:${operationNo}`;
  const basis = `${vehicleWorkshopStageCode(stage)}\0${vehicleWorkshopLineDescription(line, '').toLowerCase()}`;
  let hash = 2166136261;
  for (let index = 0; index < basis.length; index += 1) {
    hash ^= basis.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return `display:${vehicleWorkshopStageCode(stage)}:${(hash >>> 0).toString(16).padStart(8, '0')}`;
}

function vehicleWorkshopRoleCanEditLines() {
  return ['operator', 'administrator'].includes(String(window.PDC_AUTH_CONTEXT?.role || '').trim().toLowerCase());
}

function vehicleWorkshopCanEditLines() {
  return vehicleWorkshopRoleCanEditLines();
}

function vehicleWorkshopHoursLabel(hours) {
  if (hours === null || hours === undefined || String(hours).trim() === '') return 'Estimate not set';
  const value = Number(hours);
  if (!Number.isFinite(value) || value < 0) return 'Estimate not set';
  const text = Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  return `${text} hr${value === 1 ? '' : 's'}`;
}

function vehicleWorkshopPerthDateKey(value) {
  const date = value instanceof Date ? value : new Date(value || 0);
  if (!Number.isFinite(date.getTime())) return '';
  try {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Perth', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return `${values.year}-${values.month}-${values.day}`;
  } catch (_error) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }
}

function vehicleWorkshopBookingDateKey(booking = {}) {
  const source = booking.status === 'completed' ? (booking.actual_end_at || booking.scheduled_start_at) : booking.scheduled_start_at;
  return source ? vehicleWorkshopPerthDateKey(source) : '';
}

function vehicleWorkshopBookingTimeLabel(booking = {}) {
  const start = booking.scheduled_start_at ? new Date(booking.scheduled_start_at) : null;
  const end = booking.scheduled_end_at ? new Date(booking.scheduled_end_at) : null;
  if (!start || Number.isNaN(start.getTime())) return 'Booking time unavailable';
  const dateOptions = { timeZone: 'Australia/Perth', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
  const timeOptions = { timeZone: 'Australia/Perth', hour: 'numeric', minute: '2-digit' };
  const startDate = start.toLocaleDateString('en-AU', dateOptions);
  const from = start.toLocaleTimeString('en-AU', timeOptions);
  let endLabel = '';
  if (end && !Number.isNaN(end.getTime())) {
    const to = end.toLocaleTimeString('en-AU', timeOptions);
    endLabel = vehicleWorkshopPerthDateKey(end) === vehicleWorkshopPerthDateKey(start)
      ? to
      : `${end.toLocaleDateString('en-AU', dateOptions)} · ${to}`;
  }
  return `${startDate} · ${from}${endLabel ? `–${endLabel}` : ''}`;
}

function vehicleWorkshopBookingStatusLabel(status = '') {
  return ({ queued: 'Queued', planned: 'Booked', started: 'In progress', stoppage: 'STOPPAGE', completed: 'Completed' })[cleanNavisionText(status).toLowerCase()] || 'Booked';
}

function vehicleWorkshopBookingsForStage(bookings = [], stage = '') {
  const code = vehicleWorkshopStageCode(stage);
  const priority = { started: 0, stoppage: 1, planned: 2, queued: 3, completed: 4 };
  return (Array.isArray(bookings) ? bookings : [])
    .filter(booking => vehicleWorkshopStageCode(booking.stage_code || '') === code)
    .sort((a, b) => (priority[a.status] ?? 9) - (priority[b.status] ?? 9)
      || String(a.scheduled_start_at || '').localeCompare(String(b.scheduled_start_at || ''))
      || String(a.booking_id || '').localeCompare(String(b.booking_id || '')));
}

function vehicleWorkshopBookingRowsHtml(bookings = [], fallbackText = 'Not booked', vehicle = {}) {
  if (!bookings.length) return `<span class="vehicle-workshop-not-booked">${escapeHtml(fallbackText)}</span>`;
  return bookings.map(booking => {
    const bookingId = cleanNavisionText(booking.booking_id || '');
    const stage = vehicleWorkshopStageCode(booking.stage_code || '');
    const dateKey = vehicleWorkshopBookingDateKey(booking);
    const bayCode = `${stage}-BAY-${String(booking.bay_number).padStart(2, '0')}`;
    const bayRows = (typeof window === 'object' && window.__workshopReferenceDataService?.getCachedWorkshopBays?.()?.rows) || [];
    const cachedBay = String(bayRows.find(row => row && row.code === bayCode)?.display_name || '').trim();
    const storedBay = cleanNavisionText(booking.bay_display_name || booking.bay_name || booking.bay?.display_name || '');
    const bay = cachedBay || storedBay || (Number(booking.bay_number) > 0 ? pdcBayText(stage, Number(booking.bay_number)) : '') || 'Bay not assigned';
    const label = `${vehicleWorkshopBookingTimeLabel(booking)} · ${bay} · ${vehicleWorkshopBookingStatusLabel(booking.status)}`;
    const vehicleId = vehicleWorkshopDetailCanonicalId(vehicle);
    const stock = displayStockNumber(vehicle);
    const bayNumber = Number(booking.bay_number) > 0 ? String(Number(booking.bay_number)) : '';
    if (!bookingId || !vehicleId || !stock || !WORKSHOP_PLANNER_ROUTE_BY_STAGE[stage] || !dateKey || !bayNumber) return `<span class="vehicle-workshop-booking-static">${escapeHtml(label)}</span>`;
    return `<button type="button" class="vehicle-workshop-booking-link" data-vehicle-workshop-booking-id="${escapeHtml(bookingId)}" data-vehicle-workshop-booking-vehicle-id="${escapeHtml(vehicleId)}" data-vehicle-workshop-booking-stock="${escapeHtml(stock)}" data-vehicle-workshop-booking-stage="${escapeHtml(stage)}" data-vehicle-workshop-booking-date="${escapeHtml(dateKey)}" data-vehicle-workshop-booking-bay="${escapeHtml(bayNumber)}" title="Open this exact booking in the ${escapeHtml(vehicleWorkshopStationPresentation(stage).label)} Planner">${escapeHtml(label)} <b>Open planner →</b></button>`;
  }).join('');
}

function vehicleWorkshopAdjustedSourceDescription(line = {}, adjustment = {}) {
  return String(adjustment?.description ?? line?.description ?? '');
}

function vehicleWorkshopAdjustedSourceHours(value) {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
}

function vehicleWorkshopDepartment138(vehicle = {}, line = {}, detail = null) {
  const identity = item => String(item.line_identity || item.line_key || item.workshopLineKey
    || item.lineIdentity || item.operation_line_id || item.source_operation_line_id || item.source_line_id || item.sourceLineId || '').replace(/^source:/, '');
  const key = identity(line);
  const sources = [detail?.job_card_lines, detail?.operation_lines, detail?.work_lines, detail?.line_adjustments, vehicle.pdcQcOperationLines, vehicle.pdcEmailOperationLines]
    .filter(Array.isArray).flat();
  const source = key ? sources.find(item => identity(item) === key && String(item.department ?? '').trim()) : null;
  const department = String(source?.department ?? line.department ?? '').trim();
  // A mixed-source vehicle can contain jobs from different departments.
  // Use each source line's department before falling back for manual/legacy lines.
  return department ? department === '138' : vehicleDepartmentCode(vehicle) === '138';
}


function vehicleWorkshop138AllowedStation(vehicle, lineKey, detail, fallbackDescription = '') {
  const identity = String(lineKey || '').replace(/^source:/,'');
  const lines = [detail?.job_card_lines,detail?.operation_lines,detail?.work_lines,vehicle.pdcQcOperationLines,vehicle.pdcEmailOperationLines].filter(Array.isArray).flat();
  const line = lines.find(item => String(item.line_identity || item.line_key || item.lineIdentity || item.source_line_id || item.sourceLineId || item.operation_line_id || '').replace(/^source:/,'') === identity);
  const acceptedStage = String(line?.stage_code || line?.stageCode || '').toUpperCase();
  if (['BUS_4X4','TINT','TYRE'].includes(acceptedStage)
    || (line?.category_rule === 'craig_jobcard_categories_20261015' && ['PIT_INSPECTION','SUBLET'].includes(acceptedStage))) return acceptedStage;
  const description = line?.description || fallbackDescription;
  return window.PDC_WORKSHOP_DEPARTMENTS?.sharedStation(description) || 'BUS_4X4';
}

function vehicleWorkshopGroups(vehicle = {}, detail = null) {
  // A scoped category response owns line identity, hours and routing. Do not
  // merge older browser import rows back into those same job cards.
  if (Array.isArray(detail?.job_card_lines) && detail.job_card_lines.some(line => line.category_rule === 'craig_jobcard_categories_20261015')) {
    const requirements = detail.requirements || [];
    const groups = new Map();
    const ensure = stage => {
      if (!groups.has(stage)) groups.set(stage,{stage,requirements:requirements.filter(item => vehicleWorkshopStageCode(item.stage_code || item.work_key) === stage),lines:[],bookings:vehicleWorkshopBookingsForStage(detail.bookings || [],stage),evidenceOnly:false});
      return groups.get(stage);
    };
    for (const line of detail.job_card_lines) {
      if (line.active === false) continue;
      const adjustment = (detail.line_adjustments || []).find(item => item.line_key === line.line_identity || item.adjustment_id === line.source_line_id);
      const stage = vehicleWorkshopStageCode(line.stage_code);
      ensure(stage).lines.push({...line,workshopLineKey:line.line_identity,authoritativeJobCardLine:true,
        work_key:stage === 'BUS_4X4' ? 'bus4x4' : stage.toLowerCase(),
        estimatedHours:line.estimated_hours,sourceEstimatedHours:line.source_estimated_hours,
        operation_line_id:line.source_line_id,sourceDescription:line.description,sourceOperationNo:line.operation_no,
        authenticatedEmailOperation:line.source_kind === 'authenticated',workshopManualLine:line.source_kind === 'manual',
        adjustmentId:adjustment?.adjustment_id || '',adjustmentVersion:Number(adjustment?.version || 0),
        adjustmentProtected:adjustment?.manual_assignment_locked === true,correctionOrigin:adjustment?.correction_origin || ''});
    }
    requirements.filter(item => item.required).forEach(item => ensure(vehicleWorkshopStageCode(item.stage_code || item.work_key)));
    const split = typeof window === 'object' ? window.PDC_WORKSHOP_DEPARTMENTS?.splitGroups([...groups.values()]) : null;
    return (split || [...groups.values()]).map(group => {
      const category = (detail.work_categories || []).find(item => item.work_category === group.category);
      return category?.completed ? {...group,requirements:group.requirements.map(item => ({...item,completed:true}))} : group;
    });
  }
  const requirements = Array.isArray(detail?.requirements) ? detail.requirements : vehicleWorkshopLocalRequirements(vehicle);
  const bookings = Array.isArray(detail?.bookings) ? detail.bookings : [];
  const authoritativeJobCardLines = Array.isArray(detail?.job_card_lines) ? detail.job_card_lines
    : Array.isArray(detail?.operation_lines) ? detail.operation_lines
      : Array.isArray(detail?.work_lines) ? detail.work_lines : [];
  const structuredLines = typeof vehiclePdcJobLines === 'function' ? vehiclePdcJobLines(vehicle) : [];
  const authenticatedLines = (Array.isArray(vehicle.pdcEmailOperationLines) ? vehicle.pdcEmailOperationLines : [])
    .slice(0, 50)
    .filter(line => authenticatedOperationLineValid(line?.operation_no) && line?.description
      && (line?.work_key || line?.stage_code || line?.department_code || line?.operation_no))
    .sort((a, b) => {
      const left = authenticatedOperationLineSortValue(a.operation_no);
      const right = authenticatedOperationLineSortValue(b.operation_no);
      return left[0] - right[0] || left[1] - right[1] || left[2].localeCompare(right[2]);
    });
  const adjustments = Array.isArray(detail?.line_adjustments) ? detail.line_adjustments : [];
  const adjustmentByKey = new Map(adjustments.filter(item => item?.source_kind !== 'manual' && item?.line_key).map(item => [String(item.line_key), item]));
  const authenticatedTargetStage = line => {
    const sourceStage = vehicleWorkshopStageCode(line?.work_key || line?.stage_code || line?.department_code || 'PIT_INSPECTION');
    const adjustment = adjustmentByKey.get(vehicleWorkshopLineIdentity(sourceStage, line));
    return adjustment ? vehicleWorkshopStageCode(adjustment.stage_code) : sourceStage;
  };
  const authenticatedDescriptions = new Set(authenticatedLines.map(line => `${authenticatedTargetStage(line)}\0${cleanNavisionText(line.description).toLowerCase()}`));
  const groups = new Map();
  const canDisplayStage = stage => Boolean(
    stage !== 'PIT_INSPECTION' && (WORKSHOP_PLANNER_ROUTE_BY_STAGE[stage]
      || (typeof VEHICLE_WORKSHOP_STATION_PRESENTATION !== 'undefined' && VEHICLE_WORKSHOP_STATION_PRESENTATION[stage])
      || stage === 'PARTS'),
  );
  const ensureGroup = stage => {
    if (!canDisplayStage(stage)) return null;
    if (!groups.has(stage)) groups.set(stage, { stage, requirements: [], lines: [], bookings: vehicleWorkshopBookingsForStage(bookings, stage), evidenceOnly: false });
    return groups.get(stage);
  };
  requirements.filter(item => item?.required === true).forEach(item => {
    const stage = vehicleWorkshopStageCode(item.stage_code || item.work_key || '');
    const group = ensureGroup(stage);
    if (group) group.requirements.push(item);
  });
  structuredLines.forEach(line => {
    const stage = vehicleWorkshopStageCode(typeof pdcJobLineStage === 'function' ? pdcJobLineStage(line) : (line.category || line.stage || ''));
    if (authenticatedDescriptions.has(`${stage}\0${cleanNavisionText(vehicleWorkshopLineDescription(line, '')).toLowerCase()}`)) return;
    const group = ensureGroup(stage);
    if (group) group.lines.push(line);
  });
  authenticatedLines.forEach(line => {
    const stage = authenticatedTargetStage(line);
    const jobCard = cleanNavisionText(line.job_card_number || line.jobCardNumber || '');
    const group = ensureGroup(stage);
    if (group) group.lines.push({
      ...line,
      sourceDescription: line.description,
      sourceOperationNo: line.operation_no,
      description: `${jobCard ? `JC ${jobCard} · ` : ''}${authenticatedOperationLineLabel(line.operation_no)} · ${line.description}`,
      authenticatedEmailOperation: true,
    });
    if (group) group.evidenceOnly = group.requirements.length === 0;
  });
  authoritativeJobCardLines.slice(0, 250).forEach(line => {
    const stage = vehicleWorkshopStageCode(line.stage_code || line.department_code || line.work_key || '');
    const group = ensureGroup(stage);
    if (!group) return;
    const lineIdentity = vehicleWorkshopLineIdentity(stage, line);
    const existingIndex = group.lines.findIndex(existing => vehicleWorkshopLineIdentity(stage, existing) === lineIdentity);
    if (existingIndex >= 0) {
      const existing = group.lines[existingIndex];
      group.lines[existingIndex] = {
        ...existing,
        ...line,
        description: existing.authenticatedEmailOperation === true ? existing.description : line.description,
        job_card_number: existing.job_card_number || line.job_card_number || line.jobCardNumber || null,
        authoritativeJobCardLine: true,
      };
    } else group.lines.push({ ...line, authoritativeJobCardLine: true });
  });
  adjustments.filter(item => item?.source_kind === 'display' && item?.line_key).forEach(item => {
    const group = ensureGroup(vehicleWorkshopStageCode(item.stage_code || ''));
    if (!group || group.lines.some(line => String(line.workshopLineKey || line.line_key || '') === String(item.line_key))) return;
    group.evidenceOnly = group.requirements.length === 0;
    group.lines.push({ ...item, workshopLineKey: item.line_key, estimatedHours: Number(item.estimated_hours), evidenceOnly: true, sourceDescription: item.description });
  });
  const relocatedLines = [];
  groups.forEach(group => {
    group.lines = group.lines.flatMap(line => {
      const lineKey = vehicleWorkshopLineIdentity(group.stage, line);
      const adjustment = adjustmentByKey.get(lineKey);
      if (adjustment?.active === false && adjustment.source_kind !== 'display') return [];
      const sourceHours = vehicleWorkshopAdjustedSourceHours(line.estimated_hours ?? line.estimatedHours ?? line.confirmed_hours ?? line.confirmedHours);
      const sourceKind = cleanNavisionText(line.estimated_hours_source || line.estimatedHoursSource || line.provenance || '').toLowerCase();
      const adjustedLine = adjustment ? {
        ...line,
        department: adjustment.department ?? line.department,
        workshopLineKey: lineKey,
        sourceWorkshopStage: group.stage,
        description: vehicleWorkshopAdjustedSourceDescription(line, adjustment),
        estimatedHours: vehicleWorkshopAdjustedSourceHours(adjustment.estimated_hours),
        estimatedHoursSource: adjustment.correction_origin === 'job_card_source_correction' ? 'job_card' : (adjustment.correction_origin || sourceKind),
        sourceEstimatedHours: adjustment.correction_origin === 'job_card_source_correction'
          ? vehicleWorkshopAdjustedSourceHours(adjustment.estimated_hours)
          : (/\bai\b|model/.test(sourceKind) ? null : sourceHours),
        aiEstimatedHours: adjustment.correction_origin === 'job_card_source_correction'
          ? null
          : (/\bai\b|model/.test(sourceKind) ? sourceHours : vehicleWorkshopAdjustedSourceHours(line.ai_estimated_hours)),
        protectedHours: adjustment.correction_origin === 'job_card_source_correction'
          ? null
          : (adjustment.manual_assignment_locked && adjustment.correction_origin !== 'manual_operator' ? adjustment.estimated_hours : line.protected_hours),
        manualOverrideHours: adjustment.manual_assignment_locked && adjustment.correction_origin !== 'manual_operator'
          ? line.manual_override_hours
          : vehicleWorkshopAdjustedSourceHours(adjustment.estimated_hours),
        manualHoursUnknown: adjustment.correction_origin === 'manual_operator_unknown',
        adjustmentId: adjustment.adjustment_id,
        adjustmentVersion: Number(adjustment.version || 0),
        adjustmentProtected: adjustment.manual_assignment_locked === true,
        correctionOrigin: adjustment.correction_origin || '',
        workshopManualLine: false,
      } : { ...line, workshopLineKey: lineKey, sourceWorkshopStage: group.stage, estimatedHours: sourceHours, sourceEstimatedHours: /\bai\b|model/.test(sourceKind) ? null : sourceHours, aiEstimatedHours: /\bai\b|model/.test(sourceKind) ? sourceHours : vehicleWorkshopAdjustedSourceHours(line.ai_estimated_hours), protectedHours: line.protected_hours, manualOverrideHours: line.manual_override_hours, manualHoursUnknown: false, adjustmentId: '', adjustmentVersion: 0, adjustmentProtected: false, correctionOrigin: '', workshopManualLine: false };
      const targetStage = adjustment ? vehicleWorkshopStageCode(adjustment.stage_code) : group.stage;
      const targetGroup = targetStage !== group.stage ? ensureGroup(targetStage) : null;
      if (targetGroup) {
        relocatedLines.push({ targetStage, line: adjustedLine });
        return [];
      }
      return [adjustedLine];
    });
  });
  relocatedLines.forEach(({ targetStage, line }) => groups.get(targetStage).lines.push(line));
  adjustments.filter(item => item?.source_kind === 'manual').forEach(item => {
    const stage = vehicleWorkshopStageCode(item.stage_code);
    const group = ensureGroup(stage);
    if (!group) return;
    group.lines.push({
      workshopLineKey: item.line_key,
      description: item.description,
      estimatedHours: Number(item.estimated_hours),
      adjustmentId: item.adjustment_id,
      adjustmentVersion: Number(item.version || 0),
      workshopManualLine: true,
    });
  });
  groups.forEach(group => {
    if (!group.lines.length && group.requirements.length) {
      const station = vehicleWorkshopStationPresentation(group.stage);
      group.lines.push({ description: `${station.label} work required`, confirmedHours: null, estimatedHours: null, fallback: true });
    }
  });
  const result = [...groups.values()];
  return (typeof window === 'object' ? window.PDC_WORKSHOP_DEPARTMENTS?.splitGroups(result) : null) || result;
}

function vehicleWorkshopJobCardValue(line = {}, keys = [], fallback = '—') {
  const value = keys.map(key => line?.[key]).find(item => item !== null && item !== undefined && String(item).trim() !== '');
  if (value === undefined) return fallback;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return cleanNavisionText(value) || fallback;
}

function vehicleWorkshopBookingsForLine(group = {}, line = {}) {
  const lineIds = [line.work_item_id, line.workItemId, line.operation_line_id, line.source_line_id, line.line_id]
    .map(value => String(value || '').trim()).filter(Boolean);
  if (!lineIds.length) return group.lines.length === 1 ? group.bookings : [];
  return group.bookings.filter(booking => [booking.work_item_id, booking.operation_line_id, booking.source_line_id, booking.line_id]
    .map(value => String(value || '').trim()).some(value => value && lineIds.includes(value)));
}

function vehicleWorkshopJobCardBookedActual(line = {}, bookings = []) {
  const booked = vehicleWorkshopJobCardValue(line, ['booked_hours', 'bookedHours'], '');
  const actual = vehicleWorkshopJobCardValue(line, ['actual_hours', 'actualHours'], '');
  if (booked || actual) return [booked ? `Booked ${booked}h` : '', actual ? `Actual ${actual}h` : ''].filter(Boolean).join(' · ');
  const bookingMinutes = bookings.reduce((sum, booking) => sum + Number(booking.default_duration_minutes || 0), 0);
  const actualMinutes = bookings.reduce((sum, booking) => sum + Number(booking.actual_duration_minutes || 0), 0);
  return [bookingMinutes > 0 ? `Booked ${(bookingMinutes / 60).toFixed(2).replace(/\.00$/, '')}h` : '', actualMinutes > 0 ? `Actual ${(actualMinutes / 60).toFixed(2).replace(/\.00$/, '')}h` : ''].filter(Boolean).join(' · ') || 'Not recorded';
}

function vehicleWorkshopOperationAdministratorActive() {
  return vehicleWorkshopRoleCanEditLines();
}

function vehicleWorkshopOperationRemovalService() {
  if (!vehicleWorkshopOperationAdministratorActive() || typeof createWorkshopOperationRemovalService !== 'function' || typeof createWorkshopSupabaseClient !== 'function') return null;
  if (app.vehicleWorkshopOperationRemovalService) return app.vehicleWorkshopOperationRemovalService;
  const config = window.PDC_SUPABASE_CONFIG || {};
  if (!config.url || !config.publishableKey) return null;
  app.vehicleWorkshopOperationRemovalService = createWorkshopOperationRemovalService({
    client: createWorkshopSupabaseClient(config),
    getAccessToken: getPdcSupabaseAccessToken,
    getRole: () => window.PDC_AUTH_CONTEXT?.role,
    refresh: async () => {
      const vehicle = selectedVehicle() || {};
      const detail = await loadVehicleWorkshopDetail(vehicle, { force: true });
      if (!detail) throw new Error('authoritative refresh unavailable');
    },
  });
  return app.vehicleWorkshopOperationRemovalService;
}

function vehicleWorkshopOperationError(result = {}) {
  return ({ invalid_input: 'Enter a reason of at least three characters.', permission_denied: 'Administrator authority is required.', authority_superseded: 'Your authenticated session changed. No result was accepted.', version_conflict: 'This operation changed. The authoritative version has been reloaded.', vehicle_protected: 'Completed, collected or inactive vehicle work is protected.', completed_work_protected: 'Completed work cannot be removed.', manual_or_protected_overlay: 'A later manual or protected change prevents removal.', later_manual_or_protected_change: 'Undo was blocked because a later manual or protected change must be preserved.', authoritative_refresh_failed: 'The operation response could not be reconciled. Refresh before taking another action.' })[result.error || result.code] || 'The server rejected this operation change. Authoritative data was reloaded.';
}

async function removeVehicleWorkshopOperation(button) {
  const service = vehicleWorkshopOperationRemovalService();
  if (!service) { pdcNotify('Administrator authority and an authenticated Workshop service are required.'); return false; }
  const operationNo = String(button.dataset.operationNo || '').trim();
  const description = String(button.dataset.operationDescription || '').trim();
  const department = String(button.dataset.operationDepartment || '').trim();
  const confirmation = `Remove ${operationNo} ${description} from ${department}`;
  if (!window.confirm(`Confirm explicit line removal:\n\nOP: ${operationNo}\nDescription: ${description}\nDepartment: ${department}\n\nOnly this line will leave the active projection. Immutable source evidence is retained.`)) return false;
  const reason = window.prompt('Concise reason for removing this operation (recorded in the immutable receipt)', 'Incorrect workshop operation');
  if (reason === null) return false;
  const operationLineId = String(button.dataset.operationLineId || '');
  const key = `ui772-${operationLineId}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const vehicle = selectedVehicle() || {};
  button.disabled = true;
  const result = await service.removeOperation({
    operationLineId,
    vehicleId: button.dataset.operationVehicleId || vehicleWorkshopDetailCanonicalId(vehicle),
    stockNumber: button.dataset.operationStock || displayStockNumber(vehicle),
    jobCardNumber: button.dataset.operationJobCard || vehicleJobcardNumber(vehicle),
    operationNo,
    description,
    department,
    expectedVehicleVersion: Number(app.vehicleWorkshopDetailCache.get(vehicleWorkshopDetailCanonicalId(vehicle))?.detail?.vehicle_version || vehicle.version || 0),
    expectedAdjustmentVersion: Number(button.dataset.adjustmentVersion || 0),
    confirmation,
    reason,
    sourceEvidence: JSON.parse(button.dataset.sourceEvidence || '{}'),
    idempotencyKey: key,
  });
  if (result?.ok !== true) { pdcNotify(vehicleWorkshopOperationError(result)); return false; }
  const data = result.data || result;
  app.vehicleWorkshopRemovalReceipt = { receiptId: data.receipt_id, operationLineId, vehicleId: button.dataset.operationVehicleId || vehicleWorkshopDetailCanonicalId(vehicle), code: result.code || 'operation_line_deleted_772' };
  renderDetail();
  return true;
}

async function undoVehicleWorkshopOperation() {
  const receipt = app.vehicleWorkshopRemovalReceipt;
  const service = vehicleWorkshopOperationRemovalService();
  if (!receipt?.receiptId || !service) return false;
  const reason = window.prompt('Reason for undoing this removal (required; later protected changes are preserved)', 'Removal made in error');
  if (reason === null) return false;
  const vehicle = selectedVehicle() || {};
  const key = `ui772-undo-${receipt.operationLineId}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const result = await service.undoRemoval({ receiptId: receipt.receiptId, vehicleId: receipt.vehicleId || vehicleWorkshopDetailCanonicalId(vehicle), operationLineId: receipt.operationLineId, expectedVehicleVersion: Number(app.vehicleWorkshopDetailCache.get(vehicleWorkshopDetailCanonicalId(vehicle))?.detail?.vehicle_version || vehicle.version || 0), idempotencyKey: key, reason });
  if (result?.ok !== true) { pdcNotify(vehicleWorkshopOperationError(result)); return false; }
  app.vehicleWorkshopRemovalReceipt = null;
  renderDetail();
  return true;
}

function vehicleWorkshopRemovalReceiptHtml() {
  const receipt = app.vehicleWorkshopRemovalReceipt;
  if (!vehicleWorkshopOperationAdministratorActive() || !receipt?.receiptId) return '';
  return `<div class="vehicle-workshop-removal-receipt" role="status"><span><strong>Operation removed</strong> Receipt ${escapeHtml(receipt.receiptId)}</span><button type="button" data-vehicle-workshop-operation-undo>Undo removal</button></div>`;
}

function vehicleWorkshopHoursProjection(line = {}) {
  if (line.authoritativeJobCardLine === true) {
    const hours = line.estimated_hours;
    return { schedulingHours: typeof hours === 'number' && Number.isFinite(hours) ? hours : null,
      rule: line.adjustmentId ? 'manual_override' : 'source', evidence: { selectedField: 'estimated_hours' } };
  }
  if (!window.WorkshopNavigation?.projectWorkshopHours) {
    const value = vehicleWorkshopLineHours(line);
    return { schedulingHours: value, rule: value === null ? 'unavailable' : 'source', evidence: { selectedField: value === null ? null : 'sourceEstimatedHours' } };
  }
  return window.WorkshopNavigation.projectWorkshopHours({
    sourceEstimatedHours: line.sourceEstimatedHours,
    aiEstimatedHours: line.aiEstimatedHours,
    protectedHours: line.protectedHours,
    manualOverrideHours: line.manualOverrideHours,
    manualHoursUnknown: line.manualHoursUnknown,
  });
}

function vehicleWorkshopHoursEvidenceLabel(projection = {}, line = {}) {
  if (line.correctionOrigin === 'craig_standard_pd_1_5') return 'Craig standard override · scheduling authority';
  if (line.correctionOrigin === 'zero_hour_estimate_683') return 'Estimate · no hours on the job card (same job elsewhere, else station default)';
  return ({ manual_unknown: 'Manual override · hours unknown', manual_override: 'Manual override · scheduling authority', protected: 'Protected estimate · scheduling authority', source: 'Source evidence · scheduling authority', ai_fallback: 'AI fallback · no source estimate', unavailable: 'No hours evidence' })[projection.rule] || 'No hours evidence';
}

function vehicleWorkshopDetailRequestDealerCode(vehicle = {}, config = {}) {
  const dealer = cleanNavisionText(vehicle.__sharedNavisionDealerCode || vehicle.dealerCode || vehicle.dealer_code || config.dealerCode || '');
  if (['14450', '37047'].includes(dealer)) return dealer;
  // Imported PMG vehicles may have a customer-account code instead of a dealer.
  // This selects a read scope only; the server verifies accepted job evidence.
  const navisionCanonical = vehicle.__sharedNavisionReadOnly === true
    && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(vehicle.__sharedNavisionCanonicalVehicleId || ''));
  return (vehicle.__emailVehicleServerAuthoritative === true || navisionCanonical)
    && config.dealerCode === '14450' ? '14450' : '';
}

function vehicleWorkshopDetailResponse(detail, canonicalId = '') {
  if (detail?.ok === false) {
    const code = cleanNavisionText(detail.code || detail.error || 'workshop_detail_rejected');
    const message = ({
      dealer_scope_denied: 'Your signed-in account is not authorised for this dealer’s Workshop data.',
      vehicle_not_in_dealer_scope: 'This vehicle is outside the signed-in dealer Workshop scope.',
    })[code] || `The shared Workshop request was rejected (${code}).`;
    return { ok: false, detail: null, message };
  }
  const vehicleVersion = Number(detail?.vehicle_version);
  const bookingComplete = booking => {
    if (!booking || typeof booking !== 'object' || Array.isArray(booking)) return false;
    const version = Number(booking.version ?? booking.booking_version);
    const start = Date.parse(booking.scheduled_start_at || '');
    const end = Date.parse(booking.scheduled_end_at || '');
    return cleanNavisionText(booking.booking_id || '') !== ''
      && cleanNavisionText(booking.stage_code || '') !== ''
      && cleanNavisionText(booking.status || '') !== ''
      && Number.isInteger(version) && version >= 1
      && Number.isFinite(start) && Number.isFinite(end) && end > start;
  };
  const complete = detail && String(detail.vehicle_id || '') === String(canonicalId || '')
    && Number.isInteger(vehicleVersion) && vehicleVersion >= 1
    && Array.isArray(detail.requirements) && Array.isArray(detail.bookings) && detail.bookings.every(bookingComplete)
    && Array.isArray(detail.line_adjustments);
  return complete
    ? { ok: true, detail, message: '' }
    : { ok: false, detail: null, message: 'The shared Workshop response was incomplete.' };
}

function vehicleWorkshopDisplayLineHours(projection = {}, totalHours = null, lineCount = 0) {
  if (projection.rule === 'manual_unknown') return null;
  return projection.schedulingHours ?? (lineCount === 1 ? totalHours : null);
}

function vehicleWorkshopHoursClass(line = {}, estimate = null) {
  const provenance = cleanNavisionText(line.provenance || line.estimateProvenance || line.estimate_provenance || line.estimatedHoursSource || line.estimated_hours_source || line.hoursProvenance || line.hours_provenance || line.source_kind || line.source_type || line.source || '').toLowerCase();
  if (line.correctionOrigin === 'craig_standard_pd_1_5' && Number.isFinite(Number(estimate))) return { label: 'Craig standard hours', value: Number(estimate) };
  // r683 (F293): a 0-hour line given an estimate (same job elsewhere, else the station default).
  if ((line.correctionOrigin === 'zero_hour_estimate_683' || line.estimatedHoursSource === 'zero_hour_estimate') && Number.isFinite(Number(estimate))) return { label: 'Estimate', value: Number(estimate) };
  const confirmedRaw = [line.confirmedHours, line.confirmed_hours]
    .find(value => value !== null && value !== undefined && String(value).trim() !== '');
  const confirmed = Number(confirmedRaw);
  if (Number.isFinite(confirmed) && confirmed >= 0) return { label: 'Confirmed hours', value: confirmed };
  if (estimate === null || estimate === undefined || String(estimate).trim() === '' || !Number.isFinite(Number(estimate)) || Number(estimate) < 0) return { label: 'Unknown hours', value: null };
  if (/supplier|provider|sublet/.test(provenance)) return { label: 'Supplier estimate', value: Number(estimate) };
  if (/^ai(?:[_ -]|$)|\bmodel\b/.test(provenance)) return { label: 'AI estimate', value: Number(estimate) };
  if (/histor|previous|catalog|default/.test(provenance)) return { label: 'Historical estimate', value: Number(estimate) };
  if (/job[_ -]?card|confirm|staff|authenticated|manual/.test(provenance)) return { label: 'Confirmed hours', value: Number(estimate) };
  return { label: 'Unknown hours', value: Number(estimate) };
}

function vehicleWorkshopHoursBatchDraftValue(vehicleId = '', operationLineId = '', fallback = null) {
  const drafts = app.vehicleWorkshopHoursBatchDrafts.get(String(vehicleId || ''));
  if (!drafts || !drafts.has(String(operationLineId || ''))) return fallback;
  return drafts.get(String(operationLineId || ''));
}

function vehicleWorkshopHoursBatchRowsFromPage(page) {
  return [...(page?.querySelectorAll?.('[data-vehicle-workshop-hours-batch-input]') || [])].map(input => {
    // r687 (F297, Craig 29 Oct): ".2" means 0.2 and "2." means 2, so short typing saves instead of "Enter valid hours".
    const raw = String(input.value ?? '').trim().replace(/^\.(?=[0-9])/, '0.').replace(/^([0-9]+)\.$/, '$1');
    return {
      operationLineId: String(input.dataset.operationLineId || '').trim().toLowerCase(),
      adjustmentId: input.dataset.adjustmentId || null,
      expectedLineVersion: Number(input.dataset.adjustmentVersion || 0),
      lineKey: String(input.dataset.lineKey || '').trim(),
      stageCode: String(input.dataset.stage || '').trim().toUpperCase(),
      workKey: String(input.dataset.workKey || '').trim().toLowerCase(),
      estimatedHours: raw === '' ? null : Number(raw),
      raw,
      changed: raw !== String(input.dataset.originalHours ?? '').trim(),
    };
  });
}

function vehicleWorkshopHoursBatchValueValid(row = {}) {
  if (!row.operationLineId || !/^source:[0-9a-f-]{36}$/i.test(row.lineKey) || !Number.isInteger(row.expectedLineVersion) || row.expectedLineVersion < 0) return false;
  const raw = String(row.raw === undefined ? (row.estimatedHours ?? '') : row.raw).trim();
  if (raw === '') return row.estimatedHours === null;
  if (!/^(?:0|[1-9][0-9]{0,2})(?:\.[0-9]{1,2})?$/.test(raw)) return false;
  return Number.isFinite(row.estimatedHours) && row.estimatedHours >= 0 && row.estimatedHours <= 999.99
    && Math.abs(Math.round(row.estimatedHours * 100) - row.estimatedHours * 100) <= 1e-9;
}

function vehicleWorkshopHoursBatchDirty(page) {
  return vehicleWorkshopHoursBatchRowsFromPage(page).some(row => {
    const input = [...(page?.querySelectorAll?.('[data-vehicle-workshop-hours-batch-input]') || [])]
      .find(candidate => String(candidate.dataset.operationLineId || '').toLowerCase() === row.operationLineId);
    const original = String(input?.dataset.originalHours ?? '').trim();
    return row.raw !== original;
  });
}

function vehicleWorkshopHoursBatchSyncDrafts(page) {
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (!canonicalId) return;
  const drafts = new Map();
  vehicleWorkshopHoursBatchRowsFromPage(page).forEach(row => drafts.set(row.operationLineId, row.raw));
  app.vehicleWorkshopHoursBatchDrafts.set(canonicalId, drafts);
}

function vehicleWorkshopHoursBatchError(result = {}) {
  if (result.code === 'hours_description_rejected') {
    return result.message || 'The hours were not saved. The job wording on a line is empty, has a hidden character, or is longer than 2000 characters. Shorten that wording, then try again. Nothing else was changed.';
  }
  return ({
    invalid_hours_batch: 'The hours batch was invalid. No change was made.',
    vehicle_not_found: 'The canonical vehicle is no longer available. No change was made.',
    vehicle_identity_conflict: 'The Stock or Job Card identity changed. No change was made.',
    vehicle_version_conflict: 'This vehicle changed in another session. Authoritative hours were reloaded; your draft is kept for review.',
    line_version_conflict: 'One or more operation rows changed in another session. Authoritative hours were reloaded; your draft is kept for review.',
    parts_not_hour_bearing: 'Parts is a completion state and cannot receive hours or a station booking.',
    idempotency_conflict: 'This Save all hours request key was already used for different data. No change was made.',
    workshop_hours_batch_unavailable: 'The staging hours service is unavailable. No change was made.',
  })[result.code] || 'The hours batch was rejected. Authoritative values were reloaded; no unrelated row was changed.';
}

// r681 (F291): the save needs a job card that is on this vehicle's lines. 40 vehicles (FMG and others) have no job
// card on the vehicle row, so Save sent '' and every hours save came back "invalid". Use a job card from the lines.
function vehicleWorkshopHoursBatchJobCard(vehicle = {}, detail = {}) {
  const found = new Set();
  const walk = (value, depth) => {
    if (!value || depth > 6) return;
    if (Array.isArray(value)) { value.forEach(item => walk(item, depth + 1)); return; }
    if (typeof value !== 'object') return;
    const jc = String(value.job_card_number || '').trim();
    if (jc) found.add(jc);
    Object.values(value).forEach(item => { if (item && typeof item === 'object') walk(item, depth + 1); });
  };
  walk(detail, 0);
  const direct = String(vehicleJobcardNumber(vehicle) || '').trim();
  const tokens = direct.split(/[^A-Za-z0-9_-]+/).filter(Boolean);
  return tokens.find(token => found.has(token)) || [...found][0] || direct;
}

async function saveVehicleWorkshopLineHoursBatch(button) {
  if (!button || app.vehicleWorkshopHoursBatchSaving) return false;
  const page = button.closest?.('[data-vehicle-workshop-hours-batch-page]');
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const detail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
  const rows = vehicleWorkshopHoursBatchRowsFromPage(page).filter(row => row.changed);
  if (!page || !canonicalId || !detail || !rows.length || rows.some(row => !vehicleWorkshopHoursBatchValueValid(row))) {
    pdcNotify('Enter valid hours from 0 to 999.99 with no more than two decimal places. Blank means unknown.');
    return false;
  }
  vehicleWorkshopHoursBatchSyncDrafts(page);
  const service = app.emailVehicleLocationService;
  if (!service || typeof service.saveVehicleWorkshopLineHoursBatch !== 'function') {
    app.vehicleWorkshopHoursBatchMessage = 'The staging hours service is unavailable. No change was made.';
    renderDetail();
    return false;
  }
  app.vehicleWorkshopHoursBatchSaving = true;
  button.disabled = true;
  page.querySelector('[data-vehicle-workshop-hours-batch-reset]')?.setAttribute('disabled', 'disabled');
  try {
    const result = await service.saveVehicleWorkshopLineHoursBatch({
      vehicleId: canonicalId,
      stockNumber: displayStockNumber(vehicle),
      jobCardNumber: vehicleWorkshopHoursBatchJobCard(vehicle, detail),
      expectedVehicleVersion: Number(detail.vehicle_version || vehicle.__emailVehicleVersion || 0),
      rows,
      idempotencyKey: crypto.randomUUID(),
    });
    if (result?.ok === true) {
      app.vehicleWorkshopHoursBatchDrafts.delete(canonicalId);
      app.vehicleWorkshopHoursBatchMessage = `${result.data.changed_count || 0} hour row${Number(result.data.changed_count || 0) === 1 ? '' : 's'} saved atomically. Receipt recorded.`;
      await loadVehicleWorkshopDetail(vehicle, { force: true });
      return true;
    }
    app.vehicleWorkshopHoursBatchMessage = vehicleWorkshopHoursBatchError(result);
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return false;
  } catch (_error) {
    app.vehicleWorkshopHoursBatchMessage = 'The hours batch could not be completed. Authoritative values were reloaded; your draft is kept for review.';
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return false;
  } finally {
    app.vehicleWorkshopHoursBatchSaving = false;
    if (button.isConnected) button.disabled = !vehicleWorkshopHoursBatchDirty(page);
    if (page?.querySelector?.('[data-vehicle-workshop-hours-batch-reset]')?.isConnected) page.querySelector('[data-vehicle-workshop-hours-batch-reset]').disabled = false;
  }
}

function resetVehicleWorkshopLineHoursBatch(button) {
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (canonicalId) app.vehicleWorkshopHoursBatchDrafts.delete(canonicalId);
  app.vehicleWorkshopHoursBatchMessage = '';
  renderDetail();
  return true;
}

function vehicleWorkshopCompactLinesHtml(group = {}, bookingFallback = 'Not booked', vehicle = {}, validStages = []) {
  const presentation = {...vehicleWorkshopStationPresentation(group.stage), ...(group.label ? {label:group.label} : {})};
  const complete = group.requirements.length > 0 && group.requirements.every(item => item.completed === true);
  const isDeferredPit = group.stage === 'PIT_INSPECTION';
  const canEditCategory = vehicleWorkshopCanEditLines() && !complete && group.stage !== 'PARTS' && group.stage !== 'JOB_CARD_NOTES' && group.evidenceOnly !== true;
  const canEdit = canEditCategory && !isDeferredPit && group.requirements.length > 0;
  const isPartsStage = group.stage === 'PARTS';
  const projections = group.lines.map(line => typeof vehicleWorkshopHoursProjection === 'function'
    ? vehicleWorkshopHoursProjection(line)
    : { schedulingHours: vehicleWorkshopLineHours(line), rule: 'source', evidence: {} });
  const lineHours = projections.map(item => item.schedulingHours).filter(value => value !== null);
  const bookingHours = group.bookings.map(booking => Number(booking.default_duration_minutes || 0) / 60).filter(value => Number.isFinite(value) && value > 0);
  const totalHours = lineHours.length ? lineHours.reduce((sum, value) => sum + value, 0) : (bookingHours[0] || null);
  const activeBooking = group.bookings.find(booking => ['queued', 'planned'].includes(String(booking.status || '').toLowerCase())) || null;
  const canonicalVehicleId = vehicleWorkshopDetailCanonicalId(vehicle);
  const vehicleIdentity = vehicleKey(vehicle);
  const hasSchedulableHours = Number.isFinite(totalHours) && totalHours > 0;
  const rows = group.lines.map((line, index) => {
    const projection = projections[index] || vehicleWorkshopHoursProjection(line);
    const estimate = vehicleWorkshopDisplayLineHours(projection, totalHours, group.lines.length);
    const lineKey = vehicleWorkshopLineIdentity(group.stage, line);
    const description = vehicleWorkshopLineDescription(line, `${presentation.label} work required`);
    const lineBookings = vehicleWorkshopBookingsForLine(group, line);
    const aiHours = window.PdcEstimatedHours?.forVehicleLine(vehicle,line,estimate) || {ai:false};
    const hoursClass = aiHours.ai ? {label:'AI estimate',value:estimate} : vehicleWorkshopHoursClass(line, estimate);
    const hoursEvidenceLabel = aiHours.ai ? 'AI planning estimate · accepted hours' : typeof vehicleWorkshopHoursEvidenceLabel === 'function' ? vehicleWorkshopHoursEvidenceLabel(projection, line) : '';
    const hoursEvidence = hoursEvidenceLabel ? `<small class="vehicle-workshop-hours-evidence rule-${escapeHtml(projection.rule)}">${escapeHtml(hoursEvidenceLabel)}</small>` : '';
    const operationLineId = cleanNavisionText(line.operation_line_id || line.source_operation_line_id || '').trim().toLowerCase();
    const sourceDescription = cleanNavisionText(line.sourceDescription || line.description || '').replace(/^JC\s+[^·]+\s+·\s+OP\d+\s+·\s+/i, '');
    const operationNo = cleanNavisionText(line.sourceOperationNo || line.operation_no || '').trim();
    const batchEditable = canEdit && !isPartsStage && !line.fallback && !line.workshopManualLine && /^[0-9a-f-]{36}$/i.test(operationLineId) && /^source:[0-9a-f-]{36}$/i.test(lineKey);
    const draftValue = batchEditable ? vehicleWorkshopHoursBatchDraftValue(canonicalVehicleId, operationLineId, estimate) : estimate;
    const inputValue = draftValue === null || draftValue === undefined ? '' : String(draftValue);
    const mutationData = `data-work-category="${escapeHtml(group.category || '')}" data-original-category="${escapeHtml(line.work_category || group.stage || '')}" data-category-version="${Number(line.category_version || 0)}" data-stage="${escapeHtml(group.stage)}" data-line-key="${escapeHtml(lineKey)}" data-adjustment-id="${escapeHtml(line.adjustmentId || '')}" data-adjustment-version="${escapeHtml(String(line.adjustmentVersion || 0))}" data-description="${escapeHtml(description)}" data-hours="${escapeHtml(estimate ?? '')}"`;
    const batchInputData = `${mutationData} data-operation-line-id="${escapeHtml(operationLineId)}" data-work-key="${escapeHtml(String(line.work_key || line.category || '').trim().toLowerCase())}" data-original-hours="${escapeHtml(estimate ?? '')}"`;
    const hoursHtml = batchEditable
      ? `<div class="vehicle-workshop-hours-control"><label class="vehicle-workshop-quick-hours" aria-label="Estimated hours for ${escapeHtml(description)}"><input type="number" min="0" max="999.99" step="0.01" value="${escapeHtml(inputValue)}" placeholder="Blank = unknown" data-vehicle-workshop-hours-input data-vehicle-workshop-hours-batch-input ${batchInputData}><span>h</span></label><small class="vehicle-workshop-hours-draft-note">Draft only until Save all hours</small>${hoursEvidence}</div>`
      : isPartsStage || String(line.work_key || '').toLowerCase() === 'parts'
        ? '<span class="vehicle-workshop-hours-readonly parts-hours-not-required"><strong>Parts — no hours required</strong><small>No station booking required</small></span>'
      : `<span class="vehicle-workshop-hours-readonly"><strong>${escapeHtml(hoursClass.value === null ? hoursClass.label : `${hoursClass.label}: ${vehicleWorkshopHoursLabel(hoursClass.value)}`)}</strong>${hoursEvidence}</span>`;
    const scheduleButton = canEdit && hasSchedulableHours && canonicalVehicleId && WORKSHOP_PLANNER_ROUTE_BY_STAGE[group.stage] && !activeBooking
      ? `<button type="button" class="vehicle-workshop-schedule-next" data-vehicle-workshop-schedule-next ${mutationData} data-vehicle-id="${escapeHtml(canonicalVehicleId)}" data-vehicle-key="${escapeHtml(vehicleIdentity)}" title="Choose the earliest available time across all active bays">Best slot</button>` : '';
    const busOnly = vehicleWorkshopDepartment138(vehicle, line);
    const lineStages = busOnly ? [group.stage] : validStages;
    const stationOptions = lineStages.map(stage => {
      const option = vehicleWorkshopStationPresentation(stage);
      return `<option value="${escapeHtml(stage)}"${stage === group.stage ? ' selected' : ''}>${escapeHtml(option.label)}</option>`;
    }).join('');
    const categories = window.PDC_WORKSHOP_DEPARTMENTS;
    const categoryOptions = categories?.categoryChoices(busOnly ? '138' : '139').map(code => `<option value="${code}"${code === (line.work_category || group.stage) ? ' selected' : ''}>${escapeHtml(categories.categoryLabel(code))}</option>`).join('');
    const moveControl = canEditCategory && !line.fallback && line.work_category && categoryOptions
      ? `<label class="vehicle-workshop-line-station"><span>Work category</span><select data-vehicle-workshop-line-category ${mutationData}>${categoryOptions}</select></label>`
      : canEdit && !line.fallback && !busOnly && validStages.length > 1
        ? `<label class="vehicle-workshop-line-station"><span>Station</span><select data-vehicle-workshop-line-stage ${mutationData}>${stationOptions}</select></label>` : '';
    const canRemoveSource = typeof vehicleWorkshopOperationAdministratorActive === 'function' && vehicleWorkshopOperationAdministratorActive() && operationLineId && operationNo && !complete && !line.adjustmentProtected && line.authenticatedEmailOperation === true;
    const controls = canEdit ? `<span class="vehicle-workshop-line-actions">${moveControl}${scheduleButton}<button type="button" data-vehicle-workshop-line-edit ${mutationData}>Edit line</button>${line.workshopManualLine ? `<button type="button" class="is-danger" data-vehicle-workshop-line-delete data-adjustment-id="${escapeHtml(line.adjustmentId || '')}" data-adjustment-version="${escapeHtml(String(line.adjustmentVersion || 0))}">Remove</button>` : ''}${canRemoveSource ? `<button type="button" class="is-danger" data-vehicle-workshop-operation-remove data-operation-line-id="${escapeHtml(operationLineId)}" data-operation-no="${escapeHtml(operationNo)}" data-operation-description="${escapeHtml(sourceDescription)}" data-operation-department="${escapeHtml(group.stage)}" data-operation-vehicle-id="${escapeHtml(canonicalVehicleId)}" data-operation-stock="${escapeHtml(displayStockNumber(vehicle))}" data-operation-job-card="${escapeHtml(vehicleJobcardNumber(vehicle))}" data-adjustment-version="${escapeHtml(String(line.adjustmentVersion || 0))}" data-source-evidence="${escapeHtml(JSON.stringify({ operation_line_id: operationLineId, operation_no: operationNo, description: sourceDescription, stage_code: group.stage, estimated_hours: projection.schedulingHours, selected_hours_field: projection.evidence?.selectedField || null }))}">Remove operation</button>` : ''}</span>` : '';
    const handleData = `data-vehicle-workshop-line-handle data-work-category="${escapeHtml(group.category || '')}" data-stage="${escapeHtml(group.stage)}" data-vehicle-id="${escapeHtml(canonicalVehicleId)}" data-vehicle-key="${escapeHtml(vehicleIdentity)}" data-booking-id="${escapeHtml(activeBooking?.booking_id || activeBooking?.id || '')}" data-hours="${escapeHtml(totalHours ?? estimate ?? '')}"`;
    const number = canEdit && hasSchedulableHours && canonicalVehicleId && WORKSHOP_PLANNER_ROUTE_BY_STAGE[group.stage]
      ? `<button type="button" class="vehicle-workshop-line-number" draggable="true" ${handleData} aria-label="Drag ${escapeHtml(description)} to a workshop bay">${index + 1}</button>`
      : `<span class="vehicle-workshop-line-number">${index + 1}</span>`;
    const bookingCell = group.stage === 'JOB_CARD_NOTES' ? '<span class="vehicle-workshop-not-booked">Information only · no bay required</span>' : isDeferredPit ? '<span class="vehicle-workshop-not-booked">External Department of Transport inspection · no on-site bay</span>' : lineBookings.length ? vehicleWorkshopBookingRowsHtml(lineBookings, bookingFallback, vehicle)
      : (group.bookings.length ? '<span class="vehicle-workshop-booking-static">Station booking shown below</span>' : `<span class="vehicle-workshop-not-booked">${escapeHtml(bookingFallback)}</span>`);
    const progress = vehicleWorkshopJobCardBookedActual(line, lineBookings);
    const progressHtml = progress === 'Not recorded' ? '' : `<small>${escapeHtml(progress)}</small>`;
    return `<div class="vehicle-workshop-line">${number}<span class="vehicle-workshop-line-description"><strong>${escapeHtml(description)}</strong></span><span class="vehicle-workshop-line-hours${aiHours.ai?' pdc-ai-estimate':''}"${aiHours.detail?` title="${escapeHtml(aiHours.detail)}"`:''}>${aiHours.ai?'<small class="pdc-ai-estimate pdc-ai-estimate-badge">AI estimate</small>':''}${hoursHtml}</span><span class="vehicle-workshop-line-booking">${progressHtml}${bookingCell}</span>${controls}${!canEdit && moveControl ? `<span class="vehicle-workshop-line-actions">${moveControl}</span>` : ''}</div>`;
  }).join('');
  return `<div class="vehicle-workshop-lines">${rows}</div>`;
}

function vehicleWorkshopStationHtml(group = {}, bookingFallback = 'Not booked', vehicle = {}, validStages = []) {
  const presentation = {...vehicleWorkshopStationPresentation(group.stage), ...(group.label ? {label:group.label} : {})};
  const isPartsStage = group.stage === 'PARTS';
  const isDeferredPit = group.stage === 'PIT_INSPECTION';
  const complete = group.requirements.length > 0 && group.requirements.every(item => item.completed === true);
  const lineHours = isPartsStage ? [] : group.lines.map(line => typeof vehicleWorkshopHoursProjection === 'function' ? vehicleWorkshopHoursProjection(line).schedulingHours : vehicleWorkshopLineHours(line)).filter(value => value !== null);
  const bookingHours = isPartsStage ? [] : group.bookings.map(booking => Number(booking.default_duration_minutes || 0) / 60).filter(value => Number.isFinite(value) && value > 0);
  const totalHours = lineHours.length ? lineHours.reduce((sum, value) => sum + value, 0) : (bookingHours[0] || null);
  const evidenceOnly = group.evidenceOnly === true || group.requirements.length === 0;
  const addButton = !isPartsStage && !isDeferredPit && !evidenceOnly && vehicleWorkshopCanEditLines() && !complete ? `<button type="button" class="vehicle-workshop-line-add" data-vehicle-workshop-line-add data-stage="${escapeHtml(group.stage)}">+ Add line</button>` : '';
  const stationBookings = !isPartsStage && !isDeferredPit && group.bookings.length ? `<div class="vehicle-workshop-station-bookings"><strong>Station bookings</strong>${vehicleWorkshopBookingRowsHtml(group.bookings, bookingFallback, vehicle)}</div>` : '';
  const wholeJob = group.category && group.bookings.find(item => !item.work_category && ['queued','planned'].includes(item.status) && !item.actual_start_at);
  const splitBooking = wholeJob && vehicleWorkshopCanEditLines()
    ? `<p class="vehicle-workshop-warning">This work is covered by an existing whole-job booking. <button type="button" data-vehicle-workshop-split-category data-booking-id="${escapeHtml(wholeJob.booking_id)}" data-booking-version="${Number(wholeJob.booking_version)}">Split booking into categories</button><small>The existing bay reservation will be released. Book each category separately; the original booking stays in history.</small></p>` : '';
  const offboard = vehicleWorkshopOffboardHtml(group, vehicle, complete, wholeJob);
  const statusLabel = isDeferredPit ? 'External inspection' : isPartsStage ? 'Parts state only' : evidenceOnly ? 'Evidence' : complete ? 'Completed' : 'Required';
  const statusClass = isPartsStage ? 'is-parts-state' : evidenceOnly ? 'is-evidence' : complete ? 'is-complete' : 'is-required';
  const description = isDeferredPit ? 'External Department of Transport inspection · record the confirmed appointment separately' : isPartsStage ? 'Parts requires neither hours nor a station booking' : evidenceOnly ? 'Evidence retained from source or display projection' : complete ? 'Required work completed' : 'Required work outstanding';
  return `<section class="vehicle-workshop-station${isPartsStage ? ' parts-no-hour-gate' : ''}${evidenceOnly ? ' is-evidence-only' : ''}" data-vehicle-workshop-stage="${escapeHtml(group.stage)}" data-work-category="${escapeHtml(group.category || '')}" style="--station-colour:${escapeHtml(presentation.colour)};--station-tint:${escapeHtml(presentation.tint)}"><header><span class="vehicle-workshop-station-code">${escapeHtml(presentation.label.slice(0, 2).toUpperCase())}</span><div><h3>${escapeHtml(presentation.label)}</h3><p>${description}</p></div>${addButton}<span class="vehicle-workshop-station-status ${statusClass}">${statusLabel}</span><span class="vehicle-workshop-station-total">${isPartsStage ? 'No hours required' : escapeHtml(vehicleWorkshopHoursLabel(totalHours))}</span></header>${splitBooking}${offboard}${vehicleWorkshopCompactLinesHtml(group, bookingFallback, vehicle, validStages)}${stationBookings}</section>`;
}

function vehicleImportedAdditionsHtml(detail = {}) {
  const rows = Array.isArray(detail?.imported_additions) ? detail.imported_additions : [];
  if (!rows.length) return '';
  return `<section class="vehicle-workshop-warning" aria-label="Imported jobcard additions"><h3>Imported jobcard additions</h3><p>These lines are already on this card. Automatic routing is pending or an existing work safeguard needs attention.</p>${rows.map(row => {
    const state = /completed|protected|rework/.test(row.status || '') ? 'Existing completed work retained — check rework before scheduling'
      : /schedule|busy/.test(row.status || '') ? 'Automatic scheduling retry pending'
      : 'Automatic classification pending';
    return `<div><strong>${escapeHtml(row.job_card || '')} · Line ${escapeHtml(String(row.line_number || ''))}</strong><p>${escapeHtml(row.description || '')}</p><small>${escapeHtml(state)}</small></div>`;
  }).join('')}</section>`;
}

function renderVehicleWorkshopWorkPage(vehicle = {}) {
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const state = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId) : null;
  const bookingFallback = !canonicalId || state?.status === 'error' ? 'Booking data unavailable' : 'Not booked';
  if (canonicalId && (!state || state.status === 'loading')) return `<div class="vehicle-workshop-page" data-vehicle-workshop-page><div class="vehicle-workshop-intro"><h3>Required work</h3></div><div class="empty-state" role="status"><strong>Loading work and bookings</strong><span>No scheduling information is shown until the shared response is confirmed.</span></div></div>`;
  const groups = vehicleWorkshopGroups(vehicle, state?.status === 'ready' ? state.detail : null);
  const warning = !canonicalId
    ? '<div class="vehicle-workshop-warning" role="status"><strong>Booking data unavailable</strong><span>This vehicle is not uniquely linked to shared Workshop authority. Required work is shown, but no booking time is guessed.</span></div>'
    : state?.status === 'error'
      ? `<div class="vehicle-workshop-warning" role="status"><strong>Booking data unavailable</strong><span>${escapeHtml(state.message || 'The shared Workshop detail could not be loaded. No booking time is guessed.')}</span></div>`
      : '';
  const validStages = groups.filter(group => group.requirements.some(item => item?.required === true && item?.completed !== true)).map(group => group.stage);
  const content = groups.length ? groups.map(group => vehicleWorkshopStationHtml(group, bookingFallback, vehicle, validStages)).join('') : '<div class="empty-state"><strong>No required work</strong><span>This vehicle has no canonical required Workshop work.</span></div>';
  const batchableCount = groups.flatMap(group => ['PARTS','JOB_CARD_NOTES'].includes(group.stage) ? [] : group.lines).filter(line => /^[0-9a-f-]{36}$/i.test(String(line.operation_line_id || line.source_operation_line_id || '')) && !line.fallback && !line.workshopManualLine).length;
  const batchMessage = app.vehicleWorkshopHoursBatchMessage ? `<span class="vehicle-workshop-hours-batch-message" role="status" aria-live="polite">${escapeHtml(app.vehicleWorkshopHoursBatchMessage)}</span>` : '';
  const batchToolbar = vehicleWorkshopCanEditLines() && batchableCount
    ? `<div class="vehicle-workshop-hours-batch"><div><strong>Edit Job Card hours</strong><small>${batchableCount} operation row${batchableCount === 1 ? '' : 's'} · drafts stay local until saved</small></div><div class="vehicle-workshop-hours-batch-actions"><button type="button" class="primary compact" data-vehicle-workshop-hours-batch-save disabled>Save all hours</button><button type="button" class="ghost compact" data-vehicle-workshop-hours-batch-reset>Cancel/reset</button></div>${batchMessage}</div>`
    : '';
  return `<div class="vehicle-workshop-page" data-vehicle-workshop-page data-vehicle-workshop-hours-batch-page>${batchToolbar}<div class="vehicle-workshop-intro"><h3>Required work</h3></div>${warning}${vehicleImportedAdditionsHtml(state?.status === 'ready' ? state.detail : null)}${vehicleWorkshopRemovalReceiptHtml()}<div class="vehicle-workshop-stations">${content}</div></div>`;
}

async function loadVehicleWorkshopDetail(vehicle = {}, { force = false } = {}) {
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (!canonicalId) return null;
  const existing = app.vehicleWorkshopDetailCache.get(canonicalId);
  if (!force && existing && ['loading', 'ready'].includes(existing.status)) return existing.detail || null;
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  const config = window.PDC_SUPABASE_CONFIG || {};
  if (!token || !config.url || !config.publishableKey) {
    app.vehicleWorkshopDetailCache.set(canonicalId, { status: 'error', message: 'Sign in again to load authoritative Workshop booking details.' });
    if (app.vehicleDetailPage === 'work' && vehicleKey(selectedVehicle() || {}) === vehicleKey(vehicle)) renderDetail();
    return null;
  }
  const generation = ++app.vehicleWorkshopDetailRequestGeneration;
  const selectedKey = vehicleKey(vehicle);
  app.vehicleWorkshopDetailCache.set(canonicalId, { status: 'loading', detail: existing?.detail || null });
  if (app.vehicleDetailPage === 'work' && vehicleKey(selectedVehicle() || {}) === selectedKey) renderDetail();
  try {
    const dealerCode = vehicleWorkshopDetailRequestDealerCode(vehicle, config);
    if (!dealerCode) throw new Error('This vehicle has no confirmed dealer scope for Workshop data.');
    const response = await fetch(`${config.url}/rest/v1/rpc/get_vehicle_workshop_detail_scoped`, { method: 'POST', headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ p_vehicle_id: canonicalId, p_dealer_code: dealerCode }) });
    if (generation !== app.vehicleWorkshopDetailRequestGeneration) return null;
    if (!response.ok) throw new Error(response.status === 401 || response.status === 403 ? 'Your account is not authorised to read Workshop booking details.' : `Workshop booking detail request failed (${response.status}).`);
    const contract = vehicleWorkshopDetailResponse(await response.json(), canonicalId);
    if (!contract.ok) throw new Error(contract.message);
    const detail = contract.detail;
    app.vehicleWorkshopDetailCache.set(canonicalId, { status: 'ready', detail });
    if (app.vehicleDetailPage === 'work' && vehicleKey(selectedVehicle() || {}) === selectedKey) renderDetail();
    return detail;
  } catch (error) {
    if (generation !== app.vehicleWorkshopDetailRequestGeneration) return null;
    app.vehicleWorkshopDetailCache.set(canonicalId, { status: 'error', message: error?.message || 'The shared Workshop detail could not be loaded.' });
    if (app.vehicleDetailPage === 'work' && vehicleKey(selectedVehicle() || {}) === selectedKey) renderDetail();
    return null;
  }
}

function selectVehicleDetailPage(page = 'details') {
  app.vehicleDetailPage = page === 'work' ? 'work' : 'details';
  renderDetail();
  if (app.vehicleDetailPage === 'work') loadVehicleWorkshopDetail(selectedVehicle() || {}, { force: true });
}

function openVehicleWorkshopBooking(bookingId = '', stage = '', date = '', vehicleId = '', stockNumber = '', bay = '', options = {}) {
  const normalizedStage = vehicleWorkshopStageCode(stage);
  const target = window.VehicleRequirementsGuard?.exactBookingNavigationTarget?.({ bookingId, vehicleId, stockNumber, department: normalizedStage, date, bay });
  if (!target || !WORKSHOP_PLANNER_ROUTE_BY_STAGE[normalizedStage]) return false;
  app.pendingWorkshopBookingLink = { ...target, stage: normalizedStage, focused: true };
  if (options.showSurrounding === true) {
    app.pendingWorkshopBookingLink.focused = false;
    app.pendingWorkshopBookingLink.search = true;
  }
  closeVehicleModal();
  openWorkshopPlannerForStage(normalizedStage);
  return true;
}

async function saveVehicleWorkshopLine({ stage = '', lineKey = '', adjustmentId = '', adjustmentVersion = 0, description = '', hours = '', hoursOnly = false, refresh = true, showError = true } = {}) {
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const detail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
  if (!vehicleWorkshopCanEditLines() || !canonicalId || !detail) return false;
  if (vehicleWorkshopDepartment138(vehicle, {line_key:lineKey}, detail) && vehicleWorkshopStageCode(stage) !== vehicleWorkshop138AllowedStation(vehicle,lineKey,detail,description)) {
    if (showError) pdcNotify('Dept 138 work uses its assigned Bus 4×4, Tint or Tyres station. Refresh this vehicle to load its current station.');
    return false;
  }
  const nextDescription = hoursOnly ? description : window.prompt(lineKey ? 'Workshop line description' : 'New Workshop line description', description || '');
  if (nextDescription === null) return false;
  const trimmedDescription = cleanNavisionText(nextDescription);
  if (!trimmedDescription || trimmedDescription.length > 2000) {
    pdcNotify('Enter a Workshop line description between 1 and 2000 characters.');
    return false;
  }
  const nextHours = hoursOnly ? hours : window.prompt('Estimated hours (up to two decimal places)', hours || '1');
  if (nextHours === null) return false;
  const numericHours = Number(nextHours);
  if (!Number.isFinite(numericHours) || numericHours < 0 || numericHours > 999.99 || Math.abs(Math.round(numericHours * 100) - numericHours * 100) > 1e-9) {
    pdcNotify('Estimated hours must be between 0 and 999.99 with no more than two decimal places.');
    return false;
  }
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey) return false;
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/upsert_vehicle_workshop_line_adjustment`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        p_vehicle_id: canonicalId,
        p_adjustment_id: adjustmentId || null,
        p_expected_version: adjustmentId ? Number(adjustmentVersion || 0) : (lineKey ? 0 : Number(detail.vehicle_version || 0)),
        p_line_key: lineKey || '',
        p_stage_code: vehicleWorkshopStageCode(stage),
        p_description: trimmedDescription,
        p_estimated_hours: numericHours,
      }),
    });
    const body = await response.json().catch(() => null);
    let lineError = body?.message || body?.code || `Workshop line update failed (${response.status}).`;
    if (body?.code === 'hours_description_rejected') {
      lineError = body.message || 'The hours were not saved. This job wording is empty, has a hidden character, or is longer than 2000 characters. Shorten the wording, then try again.';
    } else if (body?.code === '23514' && /description_check/.test(String(body?.message || ''))) {
      lineError = 'The hours were not saved. This job wording is empty, has a hidden character, or is longer than 2000 characters. Shorten the wording, then try again.';
    }
    if (!response.ok || body?.ok === false) throw new Error(lineError);
    if (refresh) await loadVehicleWorkshopDetail(vehicle, { force: true });
    return true;
  } catch (error) {
    if (refresh) await loadVehicleWorkshopDetail(vehicle, { force: true });
    if (showError) pdcNotify(error?.message || 'Workshop line update failed. Refresh and try again.');
    return false;
  }
}

async function moveVehicleWorkshopSourceLineStage(select, targetStage) {
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const detail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
  const lineKey = String(select?.dataset?.lineKey || '');
  if (!select || !vehicleWorkshopCanEditLines() || !canonicalId || !detail || !/^source:[0-9a-f-]{36}$/i.test(lineKey)) return false;
  if (vehicleWorkshopDepartment138(vehicle, {line_key:lineKey}, detail) && vehicleWorkshopStageCode(targetStage) !== vehicleWorkshop138AllowedStation(vehicle,lineKey,detail)) {
    pdcNotify('Dept 138 uses Bus 4×4 bays, with shared Tint and Tyre bays for those operations.');
    return false;
  }
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey) return false;
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/move_vehicle_workshop_source_line_stage`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        p_vehicle_id: canonicalId,
        p_adjustment_id: select.dataset.adjustmentId || null,
        p_expected_version: select.dataset.adjustmentId ? Number(select.dataset.adjustmentVersion || 0) : 0,
        p_line_key: lineKey,
        p_stage_code: targetStage,
      }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok === false) throw new Error(body?.message || body?.code || `Workshop station move failed (${response.status}).`);
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return true;
  } catch (error) {
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    pdcNotify(error?.message || 'Workshop station move failed. The authoritative station has been reloaded; review it and try again.');
    return false;
  }
}

async function moveVehicleWorkshopLineStage(select) {
  if (!select) return false;
  const previousStage = vehicleWorkshopStageCode(select.dataset.stage || '');
  const targetStage = vehicleWorkshopStageCode(select.value || '');
  if (!targetStage || targetStage === previousStage) return true;
  if (/^source:[0-9a-f-]{36}$/i.test(String(select.dataset.lineKey || ''))) {
    select.disabled = true;
    const moved = await moveVehicleWorkshopSourceLineStage(select, targetStage);
    if (!moved) select.value = previousStage;
    return moved;
  }
  let hours = Number(select.dataset.hours || 0);
  if (!Number.isFinite(hours) || hours < 0.25 || Math.round(hours * 4) !== hours * 4) {
    const entered = window.prompt('Enter estimated hours before moving this job (quarter-hour increments)', hours > 0 ? String(hours) : '1');
    if (entered === null) { select.value = previousStage; return false; }
    hours = Number(entered);
  }
  if (!Number.isFinite(hours) || hours < 0.25 || hours > 999.75 || Math.round(hours * 4) !== hours * 4) {
    pdcNotify('Estimated hours must be between 0.25 and 999.75 in quarter-hour increments.');
    select.value = previousStage;
    return false;
  }
  select.disabled = true;
  const saved = await saveVehicleWorkshopLine({
    stage: targetStage,
    lineKey: select.dataset.lineKey,
    adjustmentId: select.dataset.adjustmentId,
    adjustmentVersion: Number(select.dataset.adjustmentVersion || 0),
    description: select.dataset.description,
    hours,
    hoursOnly: true,
    refresh: true,
    showError: true,
  });
  if (!saved) select.value = previousStage;
  return saved;
}

async function scheduleVehicleWorkshopNextAvailable(button) {
  if (!button || typeof workshopScheduleVehicleNextAvailable !== 'function') return false;
  const station = button.closest('[data-vehicle-workshop-stage]');
  const enteredHours = [...(station?.querySelectorAll('[data-vehicle-workshop-hours-input]') || [])]
    .map(input => Number(input.value))
    .filter(value => Number.isFinite(value) && value > 0)
    .reduce((sum, value) => sum + value, 0);
  const selected = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(selected);
  const detail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
  const authoritativeGroup = station && selected
    ? vehicleWorkshopGroups(selected, detail).find(group => group.stage === vehicleWorkshopStageCode(station.dataset.vehicleWorkshopStage || '') && (group.category || '') === (station.dataset.workCategory || ''))
    : null;
  const projectedHours = authoritativeGroup
    ? authoritativeGroup.lines.map(line => vehicleWorkshopHoursProjection(line).schedulingHours)
      .filter(value => value !== null)
      .reduce((sum, value) => sum + value, 0)
    : null;
  const payload = {
    vehicleId: button.dataset.vehicleId,
    vehicleKeyValue: button.dataset.vehicleKey,
    stage: button.dataset.stage,
    workCategory: button.dataset.workCategory || '',
    hours: projectedHours !== null ? projectedHours : (enteredHours || Number(button.dataset.hours || 0)),
  };
  closeVehicleModal();
  openWorkshopPlannerForStage(payload.stage);
  return workshopScheduleVehicleNextAvailable(payload);
}

function beginVehicleWorkshopLineDrag(event, handle) {
  const stage = vehicleWorkshopStageCode(handle?.dataset?.stage || '');
  if (!event.dataTransfer || !WORKSHOP_PLANNER_ROUTE_BY_STAGE[stage]) {
    event.preventDefault();
    return false;
  }
  const bookingId = cleanNavisionText(handle.dataset.bookingId || '');
  event.dataTransfer.effectAllowed = bookingId ? 'move' : 'copy';
  if (bookingId) event.dataTransfer.setData('application/x-workshop-plan-id', bookingId);
  else {
    event.dataTransfer.setData('application/x-workshop-vehicle-key', handle.dataset.vehicleId || handle.dataset.vehicleKey || '');
    event.dataTransfer.setData('text/plain', handle.dataset.vehicleId || handle.dataset.vehicleKey || '');
    event.dataTransfer.setData('application/x-workshop-duration-hours', handle.dataset.hours || '');
  }
  if (typeof workshopSetDragPreview === 'function') workshopSetDragPreview({ type: bookingId ? 'plan' : 'queue', hours: Number(handle.dataset.hours || 0) || 1 });
  const modal = $('#vehicle-modal');
  modal?.classList.add('vehicle-workshop-drag-handoff');
  document.body.classList.remove('modal-open');
  if (stage === 'BUS_4X4') app.pendingBusBayGroup=window.PDC_WORKSHOP_DEPARTMENTS?.category(handle.dataset.workCategory)?.id || 'mechanical';
  openWorkshopPlannerForStage(stage);
  return true;
}

function finishVehicleWorkshopLineDrag(event) {
  if (typeof workshopSetDragPreview === 'function') workshopSetDragPreview(null);
  const modal = $('#vehicle-modal');
  modal?.classList.remove('vehicle-workshop-drag-handoff');
  if (event.dataTransfer?.dropEffect && event.dataTransfer.dropEffect !== 'none') closeVehicleModal();
  else if (modal && !modal.hidden) document.body.classList.add('modal-open');
}

let vehicleWorkshopCategoryReleaseGrant = null;
function vehicleWorkshopCategoryBatch(select) {
  const root = select.closest('[data-vehicle-workshop-hours-batch-page], [data-vehicle-workshop-page]') || document;
  const rows = [];
  root.querySelectorAll('[data-vehicle-workshop-line-category]').forEach(node => {
    if (!node.dataset.lineKey || !node.dataset.originalCategory || node.value === node.dataset.originalCategory) return;
    rows.push({ line_identity: node.dataset.lineKey, category: node.value });
  });
  if (select?.dataset?.lineKey && !rows.some(row => row.line_identity === select.dataset.lineKey)) {
    rows.push({ line_identity: select.dataset.lineKey, category: select.value });
  }
  return rows;
}
async function saveVehicleWorkCategory(select, options = {}) {
  const vehicle = selectedVehicle() || {};
  const id = vehicleWorkshopDetailCanonicalId(vehicle);
  const detail = app.vehicleWorkshopDetailCache.get(id)?.detail;
  if (!vehicleWorkshopCanEditLines() || !id || !detail) return false;
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = getPdcSupabaseAccessToken();
  if (!token || !config.url || !config.publishableKey) return false;
  const batch = vehicleWorkshopCategoryBatch(select);
  const granted = vehicleWorkshopCategoryReleaseGrant
    && vehicleWorkshopCategoryReleaseGrant.vehicleId === id
    && vehicleWorkshopCategoryReleaseGrant.lines.includes(select.dataset.lineKey);
  const release = options.release === true || granted === true;
  select.disabled = true;
  try {
    const body = {p_vehicle_id:id,p_vehicle_expected_version:detail.vehicle_version,
      p_line_identity:select.dataset.lineKey,p_category:select.value,p_category_expected_version:Number(select.dataset.categoryVersion || 0),
      p_batch:batch};
    if (release) body.p_release_unstarted = true;
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/set_vehicle_work_category`, {
      method:'POST', headers:{apikey:config.publishableKey,Authorization:`Bearer ${token}`,'Content-Type':'application/json'},
      body:JSON.stringify(body),
    });
    const result = await response.json();
    if (result?.error === 'confirm_release' && result?.ok !== true && !release) {
      const accepted = typeof window.confirm === 'function' && window.confirm(result.message || 'This will release the unstarted booking.');
      if (!accepted) throw new Error('Save cancelled. Nothing was changed.');
      vehicleWorkshopCategoryReleaseGrant = { vehicleId: id, lines: batch.map(row => row.line_identity) };
      return await saveVehicleWorkCategory(select, { release: true });
    }
    if (!response.ok || result?.ok !== true) throw new Error(result?.message || result?.error || 'The work category could not be saved. Refresh and try again.');
    await loadVehicleWorkshopDetail(vehicle,{force:true});
    return true;
  } catch(error) {
    pdcNotify(error.message || 'The work category could not be saved.');
    await loadVehicleWorkshopDetail(vehicle,{force:true});
    return false;
  } finally { select.disabled=false; }
}

// r565 (F179): side-panel completion ticks. The panel does not call fetch itself.
// Controllers are operator and administrator; the server refuses anyone else.
async function loadPanelLineCompletions(vehicleId) {
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey || !vehicleId) return [];
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/get_panel_line_completions_565`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_vehicle_id: vehicleId }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok !== true || !Array.isArray(body.lines)) return [];
    return body.lines;
  } catch (_) {
    return [];
  }
}
async function setPanelLineCompletion(vehicleId, lineIdentity, completed) {
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey || !vehicleId || !lineIdentity) return { ok: false, error: 'completion_unavailable' };
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/set_panel_line_completion_565`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_vehicle_id: vehicleId, p_line_identity: lineIdentity, p_completed: completed === true }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok !== true) return body || { ok: false, error: 'completion_unavailable' };
    if (typeof refreshStationIconCompletion === 'function') void refreshStationIconCompletion(vehicleId);
    return body;
  } catch (_) {
    return { ok: false, error: 'completion_unavailable' };
  }
}

async function loadStationIconDetail(vehicleId) {
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey || !vehicleId) return [];
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/list_station_icon_completion_578`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_vehicle_ids: [vehicleId] }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok !== true || !Array.isArray(body.stations)) return [];
    return body.stations;
  } catch (_) {
    return [];
  }
}

// r915 (F497, Craig 3 Nov 14:26): FC / WPC / RFT panels show the operation lines with who ticked, overrode or QC'd
// each one. Read only: get_vehicle_operation_history_915 writes nothing. The panel does not call fetch itself.
async function loadVehicleOperationHistory(vehicleId) {
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey || !vehicleId) return { ok: false, error: 'unavailable' };
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/get_vehicle_operation_history_915`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_vehicle_id: vehicleId }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok !== true || !Array.isArray(body.lines)) return { ok: false, error: body?.error || 'unavailable' };
    return body;
  } catch (_) {
    return { ok: false, error: 'unavailable' };
  }
}

async function refreshStationIconCompletion(vehicleId) {
  const id = String(vehicleId || '');
  if (!id) return;
  const previous = app.stationIconCompletionSignature || '';
  const rows = await loadStationIconDetail(id);
  if (!(app.stationIconCompletionStamp instanceof Map)) app.stationIconCompletionStamp = new Map();
  app.stationIconCompletionStamp.set(id, Date.now());
  storeStationIconCompletion([id], rows, 0);
  redrawStationIconsIfChanged(previous);
}

async function setStationCompletionOverride(vehicleId, workKey, completed) {
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey || !vehicleId || !workKey) return { ok: false, error: 'completion_unavailable' };
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/set_station_completion_override_578`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_vehicle_id: vehicleId, p_work_key: workKey, p_completed: completed === true }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok !== true) return body || { ok: false, error: 'completion_unavailable' };
    void refreshStationIconCompletion(vehicleId);
    return body;
  } catch (_) {
    return { ok: false, error: 'completion_unavailable' };
  }
}

// r399: Mechanical, Electrical or Accessories work finished before the board
// went live has no booking to press Done on, so it would sit in Unallocated
// forever. Operators record it as done with a reason; the server keeps the
// lines, hours, overrides and history and the confirmation can be undone.
const VEHICLE_WORKSHOP_OFFBOARD_CATEGORIES = Object.freeze(['BUS_MECHANICAL','BUS_ELECTRICAL','BUS_ACCESSORIES']);
function vehicleWorkshopOffboardHtml(group = {}, vehicle = {}, complete = false, wholeJob = null) {
  if (!VEHICLE_WORKSHOP_OFFBOARD_CATEGORIES.includes(group.category) || !vehicleWorkshopCanEditLines()) return '';
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  const detail = canonicalId ? app.vehicleWorkshopDetailCache.get(canonicalId)?.detail : null;
  if (!detail || !Number.isFinite(Number(detail.vehicle_version))) return '';
  const category = (detail.work_categories || []).find(item => item.work_category === group.category) || {};
  const label = escapeHtml(group.label || category.label || 'this work');
  const attrs = `data-category="${escapeHtml(group.category)}" data-vehicle-version="${Number(detail.vehicle_version)}"`;
  if (category.offboard_confirmed) {
    return `<p class="vehicle-workshop-offboard">Marked done before the board.<button type="button" class="ghost compact" data-vehicle-workshop-offboard-undo ${attrs}>Undo</button></p>`;
  }
  const started = (group.bookings || []).some(item => item.work_category === group.category && item.actual_start_at && !['cancelled','deleted'].includes(item.status));
  if (complete || wholeJob || started) return '';
  return `<p class="vehicle-workshop-offboard"><button type="button" class="ghost compact" data-vehicle-workshop-offboard-done ${attrs}>Mark ${label} done (finished before the board)</button></p>`;
}

async function vehicleWorkshopOffboardCall(button, undo = false) {
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (!vehicleWorkshopCanEditLines() || !canonicalId || !button?.dataset?.category) return false;
  const reason = window.prompt(undo
    ? 'Why are you reopening this work? (5–500 characters)'
    : 'This marks the work done without a bay booking. Any unstarted booking for it is released and kept in history. Who did the work and when? (5–500 characters)');
  if (reason === null) return false;
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = getPdcSupabaseAccessToken();
  if (!token || !config.url || !config.publishableKey) return false;
  button.disabled = true;
  try {
    const body = { p_vehicle_id: canonicalId, p_vehicle_expected_version: Number(button.dataset.vehicleVersion), p_category: button.dataset.category, p_reason: String(reason).trim() };
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/${undo ? 'undo_bus_category_done' : 'confirm_bus_category_done'}`, {
      method: 'POST', headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const result = await response.json();
    if (!response.ok || result?.ok !== true) {
      throw new Error(result?.error === 'vehicle_version_conflict' ? 'This vehicle changed after you opened it. It has been reloaded; try again.' : result?.message || 'The change was not saved. Refresh and try again.');
    }
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return true;
  } catch (error) {
    pdcNotify(error.message || 'The change was not saved.');
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return false;
  } finally { button.disabled = false; }
}

async function splitVehicleWorkshopBooking(button) {
  const vehicle = selectedVehicle() || {};
  if (!vehicleWorkshopCanEditLines() || !button?.dataset?.bookingId) return false;
  if (!window.confirm('Release this unstarted whole-job bay reservation and split its work into categories? The original booking stays in history. You will need to book the categories into bays again.')) return false;
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = getPdcSupabaseAccessToken();
  if (!token || !config.url || !config.publishableKey) return false;
  button.disabled = true;
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/split_bus_booking_to_categories`, {
      method: 'POST', headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_booking_id: button.dataset.bookingId, p_expected_version: Number(button.dataset.bookingVersion) }),
    });
    const result = await response.json();
    if (!response.ok || result?.ok !== true) throw new Error(result?.message || 'The booking changed or has started. Refresh and review it before splitting.');
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return true;
  } catch (error) {
    pdcNotify(error.message || 'The booking could not be split.');
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return false;
  } finally { button.disabled = false; }
}

async function deleteVehicleWorkshopLine(adjustmentId = '', adjustmentVersion = 0) {
  const vehicle = selectedVehicle() || {};
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (!vehicleWorkshopCanEditLines() || !canonicalId || !adjustmentId || !window.confirm('Remove this manually added Workshop line?')) return false;
  const config = window.PDC_SUPABASE_CONFIG || {};
  const token = typeof getPdcSupabaseAccessToken === 'function' ? getPdcSupabaseAccessToken() : null;
  if (!token || !config.url || !config.publishableKey) return false;
  try {
    const response = await fetch(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/delete_vehicle_workshop_line_adjustment`, {
      method: 'POST',
      headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_vehicle_id: canonicalId, p_adjustment_id: adjustmentId, p_expected_version: Number(adjustmentVersion || 0) }),
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || body?.ok === false) throw new Error(body?.message || body?.code || `Workshop line removal failed (${response.status}).`);
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    return true;
  } catch (error) {
    await loadVehicleWorkshopDetail(vehicle, { force: true });
    pdcNotify(error?.message || 'Workshop line removal failed. Refresh and try again.');
    return false;
  }
}

function activateVehicleWorkshopLineHandle(handle) {
  const line = handle?.closest?.('.vehicle-workshop-line');
  const stationSelect = line?.querySelector?.('[data-vehicle-workshop-line-stage]');
  if (stationSelect) {
    stationSelect.focus();
    if (typeof stationSelect.showPicker === 'function') {
      try { stationSelect.showPicker(); } catch (_) { /* focus remains a safe fallback */ }
    }
    return true;
  }
  const schedule = line?.querySelector?.('[data-vehicle-workshop-schedule-next]');
  if (schedule) {
    schedule.focus();
    return true;
  }
  if (handle?.dataset?.bookingId) {
    const booking = (app.vehicleWorkshopDetailCache.get(handle.dataset.vehicleId)?.detail?.bookings || [])
      .find(row => String(row.booking_id || row.id || '') === handle.dataset.bookingId) || {};
    const vehicle = selectedVehicle() || {};
    return openVehicleWorkshopBooking(
      handle.dataset.bookingId,
      handle.dataset.stage,
      vehicleWorkshopBookingDateKey(booking),
      handle.dataset.vehicleId,
      displayStockNumber(vehicle) || handle.dataset.vehicleKey,
      Number(booking.bay_number) > 0 ? String(Number(booking.bay_number)) : ''
    );
  }
  return false;
}

function bindVehicleDetailTabs(panel) {
  panel.querySelectorAll('[data-vehicle-detail-tab]').forEach(button => button.addEventListener('click', () => selectVehicleDetailPage(button.dataset.vehicleDetailTab)));
  const tabs = [...panel.querySelectorAll('[data-vehicle-detail-tab]')];
  tabs.forEach((button, index) => button.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
    tabs[next].focus();
    selectVehicleDetailPage(tabs[next].dataset.vehicleDetailTab);
  }));
  panel.querySelectorAll('[data-vehicle-workshop-booking-id]').forEach(button => button.addEventListener('click', () => openVehicleWorkshopBooking(button.dataset.vehicleWorkshopBookingId, button.dataset.vehicleWorkshopBookingStage, button.dataset.vehicleWorkshopBookingDate, button.dataset.vehicleWorkshopBookingVehicleId, button.dataset.vehicleWorkshopBookingStock, button.dataset.vehicleWorkshopBookingBay)));
  panel.querySelectorAll('[data-pdc-work-destination-view]').forEach(button => button.addEventListener('click', () => {
    const selected = selectedVehicle() || {};
    closeVehicleModal();
    if (button.dataset.pdcWorkDestinationView === 'parts') {
      app.partsFocusSearch = displayStockNumber(selected) || vehicleKeyNumber(selected) || vehicleKey(selected) || '';
      app.partsOperationalFilter = 'ordered';
    }
    showView(button.dataset.pdcWorkDestinationView);
    if (button.dataset.pdcWorkDestinationView === 'parts') {
      window.requestAnimationFrame(() => {
        const input = $('#parts-search');
        if (!input) return;
        input.value = app.partsFocusSearch || '';
        input.focus();
        input.select?.();
        renderPartsHome();
      });
    }
  }));
  panel.querySelectorAll('[data-vehicle-workshop-line-add]').forEach(button => button.addEventListener('click', () => saveVehicleWorkshopLine({ stage: button.dataset.stage })));
  panel.querySelectorAll('[data-vehicle-workshop-line-edit]').forEach(button => button.addEventListener('click', () => saveVehicleWorkshopLine({
    stage: button.dataset.stage,
    lineKey: button.dataset.lineKey,
    adjustmentId: button.dataset.adjustmentId,
    adjustmentVersion: Number(button.dataset.adjustmentVersion || 0),
    description: button.dataset.description,
    hours: button.dataset.hours,
  })));
  panel.querySelectorAll('[data-vehicle-workshop-line-stage]').forEach(select => select.addEventListener('change', () => moveVehicleWorkshopLineStage(select)));
  const batchPage = panel.querySelector('[data-vehicle-workshop-hours-batch-page]');
  const batchSave = batchPage?.querySelector('[data-vehicle-workshop-hours-batch-save]');
  const batchReset = batchPage?.querySelector('[data-vehicle-workshop-hours-batch-reset]');
  const syncBatchDraftState = () => {
    vehicleWorkshopHoursBatchSyncDrafts(batchPage);
    if (batchSave) batchSave.disabled = app.vehicleWorkshopHoursBatchSaving || !vehicleWorkshopHoursBatchDirty(batchPage);
  };
  batchPage?.querySelectorAll('[data-vehicle-workshop-hours-batch-input]').forEach(input => input.addEventListener('input', syncBatchDraftState));
  batchSave?.addEventListener('click', () => { void saveVehicleWorkshopLineHoursBatch(batchSave); });
  batchReset?.addEventListener('click', () => resetVehicleWorkshopLineHoursBatch(batchReset));
  panel.querySelectorAll('[data-vehicle-workshop-line-delete]').forEach(button => button.addEventListener('click', () => deleteVehicleWorkshopLine(button.dataset.adjustmentId, Number(button.dataset.adjustmentVersion || 0))));
  panel.querySelectorAll('[data-vehicle-workshop-operation-remove]').forEach(button => button.addEventListener('click', () => removeVehicleWorkshopOperation(button)));
  panel.querySelector('[data-vehicle-workshop-operation-undo]')?.addEventListener('click', () => undoVehicleWorkshopOperation());
  panel.querySelectorAll('[data-vehicle-workshop-line-category]').forEach(select => select.addEventListener('change', () => { void saveVehicleWorkCategory(select); }));
  panel.querySelectorAll('[data-vehicle-workshop-split-category]').forEach(button => button.addEventListener('click', () => { void splitVehicleWorkshopBooking(button); }));
  panel.querySelectorAll('[data-vehicle-workshop-offboard-done]').forEach(button => button.addEventListener('click', () => { void vehicleWorkshopOffboardCall(button, false); }));
  panel.querySelectorAll('[data-vehicle-workshop-offboard-undo]').forEach(button => button.addEventListener('click', () => { void vehicleWorkshopOffboardCall(button, true); }));
  panel.querySelectorAll('[data-vehicle-workshop-schedule-next]').forEach(button => button.addEventListener('click', () => { void scheduleVehicleWorkshopNextAvailable(button); }));
  panel.querySelectorAll('[data-vehicle-workshop-line-handle]').forEach(handle => {
    handle.addEventListener('dragstart', event => beginVehicleWorkshopLineDrag(event, handle));
    handle.addEventListener('dragend', finishVehicleWorkshopLineDrag);
    handle.addEventListener('click', () => activateVehicleWorkshopLineHandle(handle));
  });
}

function vehicleModalIdentityStock(vehicle = {}) {
  return cleanNavisionText(
    displayStockNumber(vehicle)
      || vehicle.stock_number
      || vehicle.stockNumber
      || vehicle.batch
      || '',
  );
}

// r437 (F48): Toyota head office account codes on dealer stock (Navision Dealer
// column 001234 / 002345). They are customer accounts, not dealers, so they are
// never a dealer scope of their own.
const PDC_HEAD_OFFICE_ACCOUNT_CODES = Object.freeze(['001234', '002345']);

function vehicleModalBoardDealerScope() {
  const host = typeof window !== 'undefined' ? window : globalThis;
  const dealer = cleanNavisionText(host.PDC_SUPABASE_CONFIG?.dealerCode || '');
  return ['14450', '37047'].includes(dealer) ? dealer : '';
}

function vehicleModalDealerIdentity(vehicle = {}) {
  const dealer = cleanNavisionText(vehicle.__sharedNavisionDealerCode || vehicle.dealerCode || vehicle.dealer_code || '');
  if (['14450', '37047'].includes(dealer)) return dealer;
  // r437 (F48): a head office account vehicle opens under this board's own dealer
  // read scope, the same rule Workshop detail has used since #351. Only for one
  // server-authoritative row with a canonical vehicle UUID and no identity
  // conflict; any other unknown code stays blocked. The server still checks scope.
  if (!PDC_HEAD_OFFICE_ACCOUNT_CODES.includes(dealer)) return '';
  if (vehicle.__emailVehicleServerAuthoritative !== true || vehicle.__emailVehicleIdentityConflict === true) return '';
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(vehicleWorkshopDetailCanonicalId(vehicle) || ''))) return '';
  return vehicleModalBoardDealerScope();
}

function vehicleModalCanOpenWithoutDealer(vehicle, identity) {
  if (vehicle?.__emailVehicleServerAuthoritative !== true || vehicle.__emailVehicleIdentityConflict === true) return false;
  const suppliedDealer = cleanNavisionText(vehicle.__sharedNavisionDealerCode || vehicle.dealerCode || vehicle.dealer_code || '');
  if (suppliedDealer) return false;
  const exact = exactAuthoritativeVehicleSnapshotRow(identity);
  // External Tune intake has a canonical identity before a Navision match exists.
  // Require the authenticated exact row; never infer a dealer from Stock or owner.
  return exact.ok === true && exact.row?.source_system === 'tune_pmg';
}

function vehicleModalApplyDealerIdentity(vehicle, identity = app.vehicleModalIdentity) {
  if (!vehicle || !identity) return null;
  const boundDealer = cleanNavisionText(identity.dealerCode || '');
  const mappedDealer = cleanNavisionText(vehicle.__sharedNavisionDealerCode || vehicle.dealerCode || vehicle.dealer_code || '');
  if (!boundDealer) return vehicle;
  if (!['14450', '37047'].includes(boundDealer)) return null;
  // r437 (F48): a head office account row bound under the board scope keeps its
  // own Navision code; it is never relabelled as the dealer.
  if (PDC_HEAD_OFFICE_ACCOUNT_CODES.includes(mappedDealer) && boundDealer === vehicleModalBoardDealerScope()) return { ...vehicle };
  if (mappedDealer && mappedDealer !== boundDealer) return null;
  return { ...vehicle, __sharedNavisionDealerCode: boundDealer };
}

function exactAuthoritativeVehicleSnapshotRow(identity = app.vehicleModalIdentity, rows = app.emailVehicleLocationRows) {
  const host = typeof window !== 'undefined' ? window : globalThis;
  const resolver = host.PDC_VEHICLE_MODAL_IDENTITY?.resolveExactAuthoritativeVehicleRow;
  if (typeof resolver !== 'function') return { ok: false, code: 'identity_resolver_unavailable', row: null };
  return resolver(rows, identity);
}

function vehicleModalBoundVehicle() {
  const identity = app.vehicleModalIdentity;
  if (!identity) return null;
  const module = typeof window !== 'undefined'
    ? window.PDC_EMAIL_VEHICLE_LOCATION_SERVICE
    : globalThis.PDC_EMAIL_VEHICLE_LOCATION_SERVICE;
  const exact = exactAuthoritativeVehicleSnapshotRow(identity);
  const canonicalId = String(identity.canonicalId || '').trim();
  const stockBaseline = String(identity.stockBaseline || '').trim();
  // The authenticated snapshot intentionally retains raw snake_case rows.
  // Map the one exact UUID+Stock row before handing it to the camelCase card.
  if (exact.ok && typeof module?.mapServerVehicle === 'function') {
    const mapped = vehicleModalApplyDealerIdentity(module.mapServerVehicle(exact.row), identity);
    if (!mapped || mapped.__emailVehicleServerAuthoritative !== true
        || String(vehicleWorkshopDetailCanonicalId(mapped) || '').trim() !== canonicalId
        || vehicleModalIdentityStock(mapped) !== stockBaseline
        || mapped.__emailVehicleIdentityConflict === true) return null;
    return applySharedWorkStateCache([mapped])[0] || mapped;
  }
  // Every snapshot identity failure other than an absent snapshot is a hard
  // stop. Do not choose a row from a conflicting or wrong-Stock projection.
  if (exact.code !== 'not_found') return null;
  // A bounded receipt overlay may temporarily make the mapped Board row newer
  // than the next snapshot. Fallback only to server-authoritative DTOs and pick
  // one exact accepted DTO; never fall back to a legacy/local row.
  const canonicalRows = [];
  (Array.isArray(app.data) ? app.data : [])
    .filter(vehicle => vehicle?.__emailVehicleServerAuthoritative === true)
    .forEach(vehicle => {
      if (String(vehicleWorkshopDetailCanonicalId(vehicle) || '').trim() !== canonicalId) return;
      const stock = vehicleModalIdentityStock(vehicle);
      if (!stock) return;
      canonicalRows.push(vehicle);
    });
  const exactDtos = canonicalRows.filter(vehicle => vehicleModalIdentityStock(vehicle) === stockBaseline);
  if (canonicalRows.length !== 1 || exactDtos.length !== 1) return null;
  const bound = vehicleModalApplyDealerIdentity(exactDtos[0], identity);
  return bound?.__emailVehicleIdentityConflict === true ? null : bound;
}

function vehicleModalIdentityMatches(vehicle = {}) {
  const identity = app.vehicleModalIdentity;
  if (!identity || !vehicle) return false;
  return String(vehicleWorkshopDetailCanonicalId(vehicle) || '').trim() === String(identity.canonicalId || '').trim()
    && vehicleModalIdentityStock(vehicle) === String(identity.stockBaseline || '').trim();
}

function selectedVehicle(key = app.selectedStock) {
  if (arguments.length === 0 && app.vehicleModalIdentity) return vehicleModalBoundVehicle();
  const requested = String(key ?? '').trim();
  if (!requested) return null;

  const canonicalMatches = app.data.filter(vehicle => String(vehicleKey(vehicle) || '').trim() === requested);
  if (canonicalMatches.length > 1) {
    console.warn('Vehicle lookup was ambiguous; no vehicle was selected.', { requested, matchCount: canonicalMatches.length });
    return null;
  }
  const boardMatches = vehicleLocationBoardRows().filter(vehicle => String(vehicleKey(vehicle) || '').trim() === requested);
  if (boardMatches.length > 1) {
    console.warn('Vehicle Locations lookup was ambiguous; no vehicle was selected.', { requested, matchCount: boardMatches.length });
    return null;
  }
  const boardVehicle = boardMatches[0] || null;
  if (boardVehicle?.__emailVehicleIdentityConflict === true || boardVehicle?.__locationIdentityReadOnly === true) {
    console.warn('Vehicle Locations identity conflict; no vehicle was selected.', { requested });
    return null;
  }
  if (boardVehicle) return boardVehicle;
  if (canonicalMatches.length === 1) return canonicalMatches[0];
  const aliasMatches = app.data.filter(vehicle => [vehicle.stock, vehicle.batch, vehicle.id]
    .map(value => String(value || '').trim())
    .includes(requested));
  if (aliasMatches.length === 1) return aliasMatches[0];
  if (aliasMatches.length > 1) console.warn('Vehicle alias lookup was ambiguous; no vehicle was selected.', { requested, matchCount: aliasMatches.length });
  return null;
}

function saveVehicleEdits(key, updates, options = {}) {
  const vehicle = selectedVehicle(key);
  if (!vehicle) return false;
  const editKey = vehicleKey(vehicle);
  if (!vehicleLocationActionAllowed(vehicle, 'edit')) return false;
  const nextUpdates = { ...updates };
  const protectedNavisionAuthorityFields = [
    'jitQty',
    'navisionJitaNumber',
    'navisionJitaNumberAuthority',
    'jitaPartsOrdered',
    '_navisionJitaNumberColumnPresent',
  ];
  const rejectedAuthorityFields = protectedNavisionAuthorityFields.filter(field => Object.prototype.hasOwnProperty.call(nextUpdates, field));
  rejectedAuthorityFields.forEach(field => { delete nextUpdates[field]; });
  if (rejectedAuthorityFields.length) {
    console.warn('Ignored operator edit to imported Navision JITA authority fields.', { fields: rejectedAuthorityFields });
  }
  if (!Object.keys(nextUpdates).length) return false;
  if ('etaAtDealer' in nextUpdates) nextUpdates.etaAtDealer = navisionEtaForVehicle({ ...vehicle, ...nextUpdates });
  const wasNestedTransaction = storageTransactionDepth > 0;
  const previousValues = Object.fromEntries(Object.keys(nextUpdates).map(field => [field, {
    exists: Object.prototype.hasOwnProperty.call(vehicle, field),
    value: vehicle[field],
  }]));
  try {
    runStorageTransaction('Vehicle update', [EDITS_KEY], () => {
      Object.assign(vehicle, nextUpdates);
      const edits = loadVehicleEdits();
      edits[editKey] = { ...(edits[editKey] || {}), ...nextUpdates };
      saveJson(EDITS_KEY, edits);
    });
  } catch (error) {
    Object.entries(previousValues).forEach(([field, previous]) => {
      if (previous.exists) vehicle[field] = previous.value;
      else delete vehicle[field];
    });
    if (wasNestedTransaction) throw error;
    pdcNotify(error.message || String(error));
    return false;
  }
  if (options.render !== false) renderAll();
  return true;
}

async function openVehicleWorkBookingsFromTile(tile) {
  const key = String(tile?.dataset?.openWorkBookings || '').trim();
  if (!key) return false;
  const opened = await openVehicleFromStockClick(key, tile);
  if (!opened) return false;
  if (window.PDC_VEHICLE_SLIDEOUT?.state?.key === key) return true;
  app.pendingVehicleWorkContext = Object.freeze({
    station: String(tile.dataset.workStation || '').trim(),
    bay: String(tile.dataset.workBay || '').trim(),
  });
  app.vehicleDetailPage = 'work';
  renderDetail();
  await loadVehicleWorkshopDetail(selectedVehicle() || {}, { force: true });
  return true;
}

function vehicleLocationsVehicleForSidePanel(stock = '') {
  const cleanKey = String(stock || '').trim();
  if (!cleanKey || typeof vehicleLocationsScreenRows !== 'function') return null;
  const rows = vehicleLocationsScreenRows();
  return (Array.isArray(rows) ? rows : []).find(row => {
    const id = vehicleKey(row);
    if (id && id === cleanKey) return true;
    return [row?.stock, row?.stock_number, row?.id, row?.permanent_vehicle_id]
      .some(value => String(value || '').trim() === cleanKey);
  }) || null;
}

function tryOpenVehicleSidePanel(stock = '') {
  const key = String(stock || '').trim();
  if (!key) return false;
  const vehicle = vehicleLocationsVehicleForSidePanel(key) || selectedVehicle(key);
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'open')) return false;
  const locationKey = vehicleKey(vehicle);
  const bucket = typeof incomingBucketForVehicle === 'function' ? incomingBucketForVehicle(vehicle) : '';
  const open = typeof window !== 'undefined' ? window.PDC_VEHICLE_SLIDEOUT?.open : null;
  if (locationKey && bucket && typeof open === 'function') {
    open(locationKey, bucket);
    return true;
  }
  return false;
}

async function ensureVehicleOpenableFromBoard(stock, trigger = null) {
  const key = String(stock || '').trim();
  if (!key) return null;
  let vehicle = selectedVehicle(key);
  if (vehicle && vehicleLocationActionAllowed(vehicle, 'open')) return vehicle;
  if (!sharedNavisionVisibilityConfigured()) return null;
  trigger?.classList.add('is-loading');
  trigger?.setAttribute('aria-busy', 'true');
  try {
    const deadline = Date.now() + 8000;
    while (Date.now() < deadline && !sharedNavisionLocationAuthorityReady()) {
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    vehicle = selectedVehicle(key);
    if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'open')) {
      pdcNotify('Vehicle details are still syncing. Please click the stock number again in a moment.');
      return null;
    }
    return vehicle;
  } finally {
    trigger?.classList.remove('is-loading');
    trigger?.removeAttribute('aria-busy');
  }
}

// r560 (F174): stock-number entry points open the Vehicle Locations side panel; the centred vehicle card is "More details".
async function openVehicleFromStockClick(stock, trigger = null) {
  const key = String(stock || '').trim();
  if (!key) return false;
  const vehicle = selectedVehicle(key);
  if (vehicle && vehicleLocationActionAllowed(vehicle, 'open') && tryOpenVehicleSidePanel(key)) return true;
  const ready = vehicle && vehicleLocationActionAllowed(vehicle, 'open')
    ? vehicle
    : await ensureVehicleOpenableFromBoard(key, trigger);
  if (!ready) return false;
  if (tryOpenVehicleSidePanel(key)) return true;
  return openVehicleModal(key) !== false;
}

async function openVehicleCardFromVisibleBoard(stock, trigger = null) {
  const key = String(stock || '').trim();
  if (!key) return false;
  const vehicle = selectedVehicle(key);
  if (vehicle && vehicleLocationActionAllowed(vehicle, 'open')) {
    openVehicleModal(key);
    return true;
  }
  const ready = await ensureVehicleOpenableFromBoard(key, trigger);
  if (!ready) return false;
  openVehicleModal(key);
  return true;
}

const modalReturnFocus = new WeakMap();

function rememberModalReturnFocus(modal) {
  const active = document.activeElement;
  modalReturnFocus.set(modal, active instanceof HTMLElement && active !== document.body ? active : null);
}

function modalFocusableElements(modal) {
  return Array.from(modal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
    .filter(element => !element.hidden && element.getClientRects().length > 0);
}

function trapModalFocus(modal, event) {
  const focusable = modalFocusableElements(modal);
  if (!focusable.length) {
    event.preventDefault();
    modal.focus();
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
    event.preventDefault();
    first.focus();
  }
  // Async detail refreshes can replace the focused control after keydown. Re-check
  // after promise/render work so focus cannot briefly fall back to body/outside.
  setTimeout(() => {
    if (modal.hidden || modal.contains(document.activeElement)) return;
    const refreshed = modalFocusableElements(modal);
    (refreshed[0] || modal).focus();
  }, 0);
}

function restoreModalReturnFocus(modal) {
  const target = modalReturnFocus.get(modal);
  modalReturnFocus.delete(modal);
  if (target?.isConnected && typeof target.focus === 'function') target.focus();
}

async function refreshVehicleModalExactIdentity(identity = app.vehicleModalIdentity) {
  if (!identity) return { ok: false, code: 'identity_missing', vehicle: null };
  if (app.vehicleModalIdentityRecoveryInFlight && app.vehicleModalIdentity === identity) return app.vehicleModalIdentityRecoveryInFlight;
  app.vehicleModalIdentityRecoveryAttempted = true;
  const service = app.emailVehicleLocationService || initEmailVehicleLocationsIfAvailable({ skipInitialRefresh: true });
  const refreshGeneration = app.vehicleLocationsRefreshGeneration;
  const module = typeof window !== 'undefined'
    ? window.PDC_EMAIL_VEHICLE_LOCATION_SERVICE
    : globalThis.PDC_EMAIL_VEHICLE_LOCATION_SERVICE;
  if (!service?.snapshot || typeof module?.mapServerVehicle !== 'function') {
    if (app.vehicleModalIdentity === identity) app.vehicleModalIdentityLastError = 'identity_refresh_unavailable';
    return { ok: false, code: 'identity_refresh_unavailable', vehicle: null };
  }
  const owner = identity;
  const request = (async () => {
    let response;
    try { response = await service.snapshot(); } catch (_error) {
      if (app.vehicleModalIdentity === owner) app.vehicleModalIdentityLastError = 'identity_refresh_unavailable';
      return { ok: false, code: 'identity_refresh_unavailable', vehicle: null };
    }
    if (app.vehicleModalIdentity !== owner || refreshGeneration !== app.vehicleLocationsRefreshGeneration) return { ok: false, code: 'identity_superseded', vehicle: null };
    if (response?.ok !== true) {
      const code = String(response?.code || response?.error || 'snapshot_unavailable');
      app.vehicleModalIdentityLastError = code;
      return { ok: false, code, vehicle: null };
    }
    const rows = Array.isArray(response?.data?.vehicles) ? response.data.vehicles : [];
    const authoritativeRows = applyPendingAuthoritativeVehicleReceiptOverlays(rows);
    const exact = exactAuthoritativeVehicleSnapshotRow(owner, authoritativeRows);
    if (!exact.ok) {
      app.vehicleModalIdentityLastError = exact.code;
      return { ok: false, code: exact.code, vehicle: null };
    }
    const mapped = vehicleModalApplyDealerIdentity(module.mapServerVehicle(exact.row), owner);
    if (!mapped || mapped.__emailVehicleServerAuthoritative !== true
        || String(vehicleWorkshopDetailCanonicalId(mapped) || '').trim() !== String(owner.canonicalId || '').trim()
        || vehicleModalIdentityStock(mapped) !== String(owner.stockBaseline || '').trim()
        || mapped.__emailVehicleIdentityConflict === true) {
      app.vehicleModalIdentityLastError = 'identity_mapping_contradictory';
      return { ok: false, code: 'identity_mapping_contradictory', vehicle: null };
    }
    const authoritative = applyPendingSharedWorkStateOverlays([mapped])[0] || mapped;
    const canonicalId = String(owner.canonicalId || '').trim();
    const merge = row => String(vehicleWorkshopDetailCanonicalId(row) || '').trim() === canonicalId ? { ...row, ...authoritative } : row;
    app.emailVehicleLocationRows = applyPendingSharedWorkStateOverlays(authoritativeRows);
    app.data = (Array.isArray(app.data) ? app.data : []).map(merge);
    if (!app.data.some(row => String(vehicleWorkshopDetailCanonicalId(row) || '').trim() === canonicalId)) app.data.push(authoritative);
    app.emailVehicleLocationRevision = response.data?.revision ?? app.emailVehicleLocationRevision;
    app.vehicleModalIdentityReady = true;
    app.vehicleModalLoadingIdentity = false;
    app.vehicleModalIdentityLastError = '';
    return { ok: true, code: 'exact_identity_rebound', vehicle: authoritative };
  })();
  const guarded = request.finally(() => {
    if (app.vehicleModalIdentityRecoveryInFlight === guarded) app.vehicleModalIdentityRecoveryInFlight = null;
  });
  app.vehicleModalIdentityRecoveryInFlight = guarded;
  return guarded;
}

function openVehicleModal(stock) {
  const vehicle = selectedVehicle(stock);
  if (!vehicle) {
    pdcNotify('That vehicle could not be found. Refresh the list and try again. No vehicle was changed.');
    return false;
  }
  if (!vehicleLocationActionAllowed(vehicle, 'open')) return false;
  const modal = $('#vehicle-modal');
  if (!modal) return false;
  rememberModalReturnFocus(modal);
  app.selectedStock = vehicleKey(vehicle);
  app.vehicleModalIdentity = Object.freeze({
    canonicalId: vehicleWorkshopDetailCanonicalId(vehicle),
    stockBaseline: vehicleModalIdentityStock(vehicle),
    dealerCode: vehicleModalDealerIdentity(vehicle),
  });
  app.vehicleModalIdentityReady = false;
  app.vehicleModalIdentityRecoveryAttempted = false;
  app.vehicleModalIdentityLastError = '';
  if (!app.vehicleModalIdentity.canonicalId || !app.vehicleModalIdentity.stockBaseline
      || (!app.vehicleModalIdentity.dealerCode && !vehicleModalCanOpenWithoutDealer(vehicle, app.vehicleModalIdentity))) {
    app.vehicleModalIdentity = null;
    pdcNotify('The exact vehicle identity is unavailable. Refresh the list and try again. No vehicle was changed.');
    return false;
  }
  app.vehicleDetailPage = 'details';
  app.vehicleWorkshopDetailRequestGeneration += 1;
  const canonicalId = vehicleWorkshopDetailCanonicalId(vehicle);
  if (canonicalId) app.vehicleWorkshopDetailCache.delete(canonicalId);
  const cachedAuthoritative = vehicleModalBoundVehicle();
  const cachedReady = Boolean(cachedAuthoritative && vehicleModalIdentityMatches(cachedAuthoritative));
  app.vehicleModalIdentityReady = cachedReady;
  app.vehicleModalLoadingIdentity = !cachedReady;
  const panel = $('#vehicle-detail');
  if (panel && !cachedReady) panel.innerHTML = '<div class="empty-state vehicle-detail-loading" role="status"><strong>Loading authoritative vehicle details…</strong><span>The card will open only after the exact Stock and vehicle UUID are available from staging.</span></div>';
  modal.hidden = false;
  document.body.classList.add('modal-open');
  if (cachedReady) renderDetail();
  $('#modal-close')?.focus();
  const identityAtOpen = app.vehicleModalIdentity;
  if (cachedReady) {
    // The canonical vehicle snapshot is the single authority for required-work
    // states on the modal, vehicle pills and Vehicle Locations icons. Loading
    // booking detail must not replace those states with a second direct-table
    // projection after only the modal has rendered.
    void loadVehicleWorkshopDetail(cachedAuthoritative, { force: true }).then(() => {
      if (app.vehicleModalIdentity === identityAtOpen) renderVehicleDetailAfterBackgroundRefresh();
    });
  }
  void (async () => {
    let ready = cachedReady;
    let refreshed = cachedAuthoritative;
    try {
      initEmailVehicleLocationsIfAvailable({ skipInitialRefresh: true });
      const refreshedOk = await refreshEmailVehicleLocations();
      if (app.vehicleModalIdentity !== identityAtOpen) return;
      if (!refreshedOk) {
        const backgroundError = app.emailVehicleLocationError || 'snapshot_unavailable';
        if (cachedReady && isRetryableVehicleModalIdentityFailure(backgroundError) && app.vehicleModalIdentity === identityAtOpen) {
          // A retryable background snapshot failure must not discard the last
          // authenticated UUID+Stock row that already opened the card.
          app.vehicleModalIdentityLastError = backgroundError;
          app.vehicleModalIdentityReady = true;
          app.vehicleModalLoadingIdentity = false;
          ready = true;
          renderVehicleDetailAfterBackgroundRefresh();
          return;
        }
        const rebound = await refreshVehicleModalExactIdentity(identityAtOpen);
        if (!rebound?.ok || app.vehicleModalIdentity !== identityAtOpen) return;
        refreshed = rebound.vehicle || vehicleModalBoundVehicle();
      } else {
        refreshed = vehicleModalBoundVehicle();
      }
      if (!refreshed || !vehicleModalIdentityMatches(refreshed)) {
        const rebound = await refreshVehicleModalExactIdentity(identityAtOpen);
        if (!rebound?.ok || app.vehicleModalIdentity !== identityAtOpen) return;
        refreshed = rebound.vehicle || vehicleModalBoundVehicle();
      }
      if (!refreshed || !vehicleModalIdentityMatches(refreshed)) return;
      // The canonical snapshot already contains identity, salesperson, required
      // work and booking pills. Open the card immediately after that bounded
      // UUID+Stock readback; secondary detail services must never hold every
      // vehicle card behind an indefinite loading screen.
      ready = true;
      app.vehicleModalIdentityReady = true;
      app.vehicleModalLoadingIdentity = false;
      renderVehicleDetailAfterBackgroundRefresh();
      void loadVehicleWorkshopDetail(refreshed, { force: true }).then(() => {
        if (app.vehicleModalIdentity === identityAtOpen) renderVehicleDetailAfterBackgroundRefresh();
      });
    } catch (error) {
      // Previously a return inside finally swallowed this silently.
      console.error('Vehicle card identity check failed.', error);
    } finally {
      if (app.vehicleModalIdentity === identityAtOpen && !ready) {
        app.vehicleModalIdentityReady = false;
        app.vehicleModalLoadingIdentity = false;
        if (!modal.hidden) renderDetail();
      }
    }
  })();
  return true;
}

function openAuthenticatedOperationWorkshop(stock) {
  const vehicle = selectedVehicle(stock);
  const canonicalId = vehicle ? vehicleWorkshopDetailCanonicalId(vehicle) : '';
  if (!vehicle || !canonicalId || !vehicleWorkshopRoleCanEditLines()) {
    pdcNotify('Workshop jobs are not available for editing. Refresh the list and try again. No work was changed.');
    return false;
  }
  // Leave the read-only Auditor before opening the separately authorised Workshop editor.
  // Every write still passes through vehicleWorkshopCanEditLines and the audited RPC.
  showView('dashboard');
  if (!vehicleWorkshopCanEditLines()) {
    pdcNotify('Workshop jobs are not available for editing. Refresh the list and try again. No work was changed.');
    return false;
  }
  const modal = $('#vehicle-modal');
  if (!modal) return false;
  rememberModalReturnFocus(modal);
  // This is intentionally separate from the location/lifecycle editor.
  // canonical Workshop overlay; every write still goes through the operator-only audited RPC.
  app.selectedStock = vehicleKey(vehicle);
  app.vehicleDetailPage = 'work';
  app.vehicleWorkshopDetailRequestGeneration += 1;
  app.vehicleWorkshopDetailCache.delete(canonicalId);
  renderDetail();
  modal.hidden = false;
  document.body.classList.add('modal-open');
  loadVehicleWorkshopDetail(vehicle, { force: true });
  $('#modal-close')?.focus();
  return true;
}

function closeVehicleModal() {
  const modal = $('#vehicle-modal');
  app.vehicleWorkshopDetailRequestGeneration += 1;
  app.vehicleDetailPage = 'details';
  app.vehicleModalLoadingIdentity = false;
  app.vehicleModalIdentityReady = false;
  app.vehicleModalIdentityRecoveryAttempted = false;
  app.vehicleModalIdentityLastError = '';
  app.vehicleModalIdentityRecoveryInFlight = null;
  app.activeVehicleDetail = null;
  app.vehicleModalIdentity = null;
  if (!modal || modal.hidden) return;
  modal.hidden = true;
  document.body.classList.remove('modal-open');
  refreshOpenAuthenticatedOperationSummaries($('#incoming-main-board') || document);
  restoreModalReturnFocus(modal);
}

function isRetryableVehicleModalIdentityFailure(code = '') {
  const host = typeof window !== 'undefined' ? window : globalThis;
  return host.PDC_VEHICLE_MODAL_IDENTITY?.isRetryableVehicleModalIdentityFailure?.(code) === true;
}

function vehicleModalIdentityErrorMessage(code = '', stock = '') {
  const label = stock || 'this Stock';
  if (isRetryableVehicleModalIdentityFailure(code)) return `The last authenticated ${label} row is retained, but fresh authoritative details are temporarily unavailable. Retry when the staging connection recovers.`;
  if (code === 'not_found') return `Stock ${label} is no longer present in the authenticated staging snapshot. No vehicle was changed.`;
  if (code === 'duplicate_identity') return `Stock ${label} has duplicate canonical rows in the authenticated staging snapshot. No vehicle was changed.`;
  if (code === 'conflicting_stock' || code === 'stock_mismatch') return `Stock ${label} has a conflicting UUID/Stock identity in the authenticated staging snapshot. No vehicle was changed.`;
  if (code === 'permission_denied') return `Your account is not authorised to read Stock ${label}. No vehicle was changed.`;
  return `Stock ${label} remains read-only until its exact authenticated UUID/Stock identity is confirmed. No vehicle was changed.`;
}

function applyPdcWorkStateControl(button, next, panel) {
  button.dataset.state = next;
  button.classList.remove(
    'pdc-work-state-none',
    'pdc-work-state-required',
    'pdc-work-state-booked',
    'pdc-work-state-ordered',
    'pdc-work-state-complete',
  );
  button.classList.add(`pdc-work-state-${next}`);
  const statusText = next === 'complete' ? 'Completed' : next === 'required' ? 'To be completed' : 'Not required';
  const status = button.querySelector('.pdc-work-state-status');
  if (status) status.textContent = statusText;
  const jobKey = button.dataset.pdcWorkState || '';
  const requireInput = panel.querySelector(`input[data-pdc-work-require="${jobKey}"]`);
  const completeInput = panel.querySelector(`input[data-pdc-work-complete="${jobKey}"]`);
  if (requireInput) requireInput.value = next === 'none' ? '0' : '1';
  if (completeInput) completeInput.value = next === 'complete' ? '1' : '0';
  const label = button.querySelector('.pdc-work-state-label')?.textContent || 'Work item';
  button.setAttribute('aria-label', `${label} - ${statusText}`);
  button.title = `${label} - ${statusText}. Click to cycle: grey not required, red to complete, green completed.`;
}

function renderVehicleDetailAfterBackgroundRefresh() {
  const modal = $('#vehicle-modal');
  const panel = $('#vehicle-detail');
  if (!modal || modal.hidden || !panel) return false;
  const form = panel.querySelector('[data-vehicle-edit-form]');
  const mountedServerAuthoritative = form?.dataset.serverAuthoritative === 'true';
  const currentServerAuthoritative = selectedVehicle()?.__emailVehicleServerAuthoritative === true;
  if (form && mountedServerAuthoritative !== currentServerAuthoritative) {
    renderDetail();
    return true;
  }
  // The open details form is a draft boundary. Background snapshot/history/
  // booking completion must not replace its controls or focus while an operator
  // is editing. A deliberate tab change, save, retry or reopen still renders.
  if (app.vehicleDetailPage === 'details' && form) return false;
  renderDetail();
  return true;
}

function retryAuthoritativeVehicleDetails() {
  const identity = app.vehicleModalIdentity;
  if (!identity || app.vehicleModalIdentityRecoveryInFlight) return false;
  const retained = vehicleModalBoundVehicle();
  const retainedReady = Boolean(retained && vehicleModalIdentityMatches(retained));
  app.vehicleModalIdentityRecoveryAttempted = false;
  app.vehicleModalIdentityLastError = '';
  app.vehicleModalIdentityReady = retainedReady;
  app.vehicleModalLoadingIdentity = !retainedReady;
  renderDetail();
  void refreshVehicleModalExactIdentity(identity).then(result => {
    if (app.vehicleModalIdentity !== identity) return;
    app.vehicleModalLoadingIdentity = false;
    if (result?.ok === true) app.vehicleModalIdentityReady = true;
    else if (retainedReady && isRetryableVehicleModalIdentityFailure(result?.code)) app.vehicleModalIdentityReady = true;
    else app.vehicleModalIdentityReady = false;
    renderDetail();
  });
  return true;
}

function vehicleModalIdentityRefreshNoticeHtml() {
  const code = String(app.vehicleModalIdentityLastError || '').trim();
  if (!code || !isRetryableVehicleModalIdentityFailure(code)) return '';
  const stock = escapeHtml(app.vehicleModalIdentity?.stockBaseline || 'this Stock');
  return `<div class="vehicle-identity-refresh-notice" role="status" aria-live="polite"><span>The last authenticated Stock ${stock} row is retained while fresh details reconnect.</span><button class="small-button vehicle-modal-retry-details" type="button" data-modal-retry-authoritative-details>Retry authoritative details</button></div>`;
}

async function removeVehicle(stock, { resetTest = false } = {}) {
  const vehicle = selectedVehicle(stock);
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'delete')) return false;
  if (!vehicleLifecycleAdministratorActive()) {
    pdcNotify('Administrator access is required. No vehicle was changed.');
    return false;
  }
  if (!vehicleLifecycleSharedModeActive() || typeof window.__vehicleLifecycleActions?.adminArchiveVehicle !== 'function') {
    pdcNotify('Shared vehicle lifecycle service is unavailable. No vehicle was changed.');
    return false; // Fail closed: destructive shared-mode actions never use localStorage.
  }
  if (resetTest && !vehicleLifecycleStagingResetAllowed()) {
    pdcNotify('Reset Staging Test Vehicle is available only in the staging environment. No vehicle was changed.');
    return false;
  }

  const ref = await vehicleLifecycleSharedRef(vehicle);
  if (!ref || ref.outcome !== 'resolved') {
    pdcNotify(describeVehicleLifecycleResolutionOutcome(ref));
    return false;
  }
  if (ref.isArchived) {
    pdcNotify('This vehicle is already in Deleted or Completed vehicles.');
    await refreshVehicleLifecycleLocationsAndRender();
    return false;
  }
  const stockNumber = cleanNavisionText(displayStockNumber(vehicle) || '');
  const customer = cleanNavisionText(vehicleCustomerName(vehicle) || 'Unknown customer');
  const vehicleUuid = cleanNavisionText(ref.vehicleId || '');
  if (!stockNumber || !vehicleUuid) {
    pdcNotify('The exact Stock Number or vehicle UUID is unavailable. No vehicle was changed.');
    return false;
  }
  const actionLabel = resetTest ? 'Reset Staging Test Vehicle' : 'Delete Vehicle';
  if (!window.confirm(`${actionLabel}\n\nStock Number: ${stockNumber}\nCustomer: ${customer}\nVehicle UUID: ${vehicleUuid}\n\nThis archives the vehicle from active Board screens while retaining its tombstone and audit evidence.`)) return false;
  const stockConfirmation = window.prompt(`Type the exact Stock Number (${stockNumber}) to confirm:`, '') ?? '';
  if (stockConfirmation !== stockNumber) {
    pdcNotify('Stock Number confirmation did not match exactly. No vehicle was changed.');
    return false;
  }
  const reason = cleanNavisionText(window.prompt(`Reason for ${resetTest ? 'resetting this staging test vehicle' : 'deleting this vehicle'} (required):`, '') || '');
  if (!reason) {
    pdcNotify('A reason is required. No vehicle was changed.');
    return false;
  }
  const result = await window.__vehicleLifecycleActions.adminArchiveVehicle({
    vehicleId: ref.vehicleId,
    expectedVersion: ref.version,
    stockConfirmation,
    reason,
    resetTest,
  });
  if (!result || result.ok !== true) {
    await refreshVehicleLifecycleLocationsAndRender();
    pdcNotify(vehicleLifecycleActionErrorMessage(result));
    return false;
  }
  await refreshVehicleLifecycleLocationsAndRender();
  closeVehicleModal();
  return true;
}

function completeVehicleDeleteIdempotencyKey(vehicleId = '') {
  const suffix = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `complete-delete-${String(vehicleId || '').replace(/[^a-zA-Z0-9-]/g, '').slice(0, 48)}-${suffix}`.slice(0, 160);
}

function completeVehicleDeleteCommissioned() {
  return vehicleLifecycleStagingResetAllowed()
    && window.PDC_SUPABASE_CONFIG?.vehicleLifecycle?.completeVehicleDeleteCommissioned === true;
}

async function completeVehicleDelete(stock) {
  const vehicle = selectedVehicle(stock);
  if (!vehicle || !vehicleLocationActionAllowed(vehicle, 'delete')) return false;
  if (!vehicleLifecycleAdministratorActive() || !vehicleLifecycleStagingResetAllowed()) {
    pdcNotify('Administrator access to the staging site is required. No vehicle was changed.');
    return false;
  }
  if (!vehicleLifecycleSharedModeActive() || typeof window.__vehicleLifecycleActions?.adminCompleteVehicleDelete !== 'function') {
    pdcNotify('The staging complete-delete service is unavailable. No vehicle was changed.');
    return false;
  }
  const ref = await vehicleLifecycleSharedRef(vehicle);
  if (!ref || ref.outcome !== 'resolved') {
    pdcNotify(describeVehicleLifecycleResolutionOutcome(ref));
    return false;
  }
  const stockNumber = cleanNavisionText(displayStockNumber(vehicle) || '');
  const vehicleUuid = cleanNavisionText(ref.vehicleId || '');
  if (!stockNumber || !vehicleUuid) {
    pdcNotify('The exact Stock Number or vehicle UUID is unavailable. No vehicle was changed.');
    return false;
  }
  const confirmation = window.confirm(
    `COMPLETE VEHICLE DELETE — STAGING ONLY\n\nStock Number: ${stockNumber}\nVehicle UUID: ${vehicleUuid}\n\nThis permanently removes the vehicle and its visible/operational/archive staging state.\nHistorical email and source messages will NOT replay. A new source is required to recreate this Stock/VIN.\nThis cannot be undone. Continue?`,
  );
  if (!confirmation) return false;
  const stockConfirmation = window.prompt(`Type the exact Stock Number (${stockNumber}) to confirm:`, '') ?? '';
  if (stockConfirmation !== stockNumber) {
    pdcNotify('Stock Number confirmation did not match exactly. No vehicle was changed.');
    return false;
  }
  const reason = cleanNavisionText(window.prompt('Reason for the staging complete delete (required):', '') || '');
  if (!reason) {
    pdcNotify('A reason is required. No vehicle was changed.');
    return false;
  }
  const button = $('#vehicle-detail')?.querySelector('[data-complete-vehicle-delete]');
  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Deleting…';
  }
  try {
    const result = await window.__vehicleLifecycleActions.adminCompleteVehicleDelete({
      vehicleId: ref.vehicleId,
      expectedVersion: ref.version,
      stockConfirmation,
      reason,
      idempotencyKey: completeVehicleDeleteIdempotencyKey(ref.vehicleId),
    });
    if (!result || result.ok !== true) {
      await refreshVehicleLifecycleLocationsAndRender();
      pdcNotify(vehicleLifecycleActionErrorMessage(result));
      return false;
    }
    await refreshVehicleLifecycleLocationsAndRender();
    const stillPresent = app.emailVehicleLocationRows.some(row => cleanNavisionText(displayStockNumber(row) || '') === stockNumber);
    if (stillPresent) {
      pdcNotify('The server accepted the delete, but authoritative staging readback still shows this Stock Number. The modal remains open so the state can be checked safely.');
      return false;
    }
    closeVehicleModal();
    return true;
  } finally {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
}

const VEHICLE_EMAIL_PARTS_ETA_CSS = [
  '.vehicle-email-parts-eta{grid-column:1/-1}',
  '.vehicle-email-warning{position:relative;margin:4px 0;border:1px solid #7dd3fc;border-left:4px solid #0284c7;border-radius:8px;background:#e0f2fe;color:#0c4a6e}',
  '.vehicle-email-warning-row{display:flex;gap:8px;align-items:center;width:100%;text-align:left;background:transparent;border:0;color:#0c4a6e;font:inherit;padding:6px 8px;cursor:pointer}',
  '.vehicle-email-warning-kind{font-weight:700}',
  '.vehicle-email-warning-when{margin-left:auto;white-space:nowrap}',
  '.vehicle-email-warning-panel{display:none;padding:8px 10px 10px;border-top:1px solid #7dd3fc;background:#f0f9ff;color:#0c4a6e}',
  '.vehicle-email-warning:hover .vehicle-email-warning-panel,.vehicle-email-warning:focus-within .vehicle-email-warning-panel,.vehicle-email-warning.is-open .vehicle-email-warning-panel{display:block}',
  '.vehicle-email-warning-panel dl{display:grid;grid-template-columns:5.5rem 1fr;gap:2px 8px;margin:0}',
  '.vehicle-email-warning-panel dt{font-weight:700}',
  '.vehicle-email-warning-panel dd{margin:0;overflow-wrap:anywhere}',
  '.vehicle-email-warning-text,.vehicle-email-warning-conflict{margin:8px 0 0;white-space:pre-wrap}',
  '.vehicle-email-warning-conflict{font-weight:650}',
].join('');

function vehicleEmailNotesVisible() {
  const role = String(window.PDC_AUTH_CONTEXT?.role || '').trim().toLowerCase();
  return role === 'operator' || role === 'administrator';
}

function ensureVehicleEmailPartsEtaStyle() {
  if (typeof document === 'undefined' || document.getElementById('vehicle-email-parts-eta-style')) return;
  const style = document.createElement('style');
  style.id = 'vehicle-email-parts-eta-style';
  style.textContent = VEHICLE_EMAIL_PARTS_ETA_CSS;
  document.head.appendChild(style);
}

function vehicleEmailNoteWhen(value, withTime = true) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const options = { timeZone: 'Australia/Perth', day: 'numeric', month: 'short', year: 'numeric' };
  if (withTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
    options.hour12 = false;
  }
  return new Intl.DateTimeFormat('en-AU', options).format(date);
}

function vehicleEmailConflictSentence(note) {
  const conflicts = note?.conflicts === true || note?.conflicts === 'true';
  if (!conflicts) return '';
  if (note.category === 'parts_complete') {
    return 'The email disagrees with the board: the email says parts are complete, and the board does not show parts received.';
  }
  return 'The email disagrees with the board: parts are still waiting, and the board shows parts received.';
}

function vehicleEmailWarningHtml(note) {
  const labels = {
    parts_eta: 'Parts ETA',
    waiting_parts: 'Still waiting on parts',
    stoppage: 'Stoppage email',
    parts_complete: 'Parts complete',
    cancellation: 'Cancellation',
    job_card_problem: 'Job card problem',
    po_received: 'PO received',
    other: 'Email',
    job_card: 'Job card problem',
    eta_chase: 'Parts ETA',
  };
  const category = labels[note.category] || 'Email';
  const fromParts = [note.sender_name, note.sender_email].map(part => String(part || '').trim()).filter(Boolean);
  const fromText = fromParts.length === 2 ? `${fromParts[0]} <${fromParts[1]}>` : (fromParts[0] || '');
  const when = vehicleEmailNoteWhen(note.event_at, false);
  const whenFull = vehicleEmailNoteWhen(note.event_at, true);
  const conflict = vehicleEmailConflictSentence(note);
  const text = String(note.snippet || note.quote || note.summary || '').trim();
  return `<div class="vehicle-email-warning">
    <button type="button" class="vehicle-email-warning-row" aria-expanded="false" aria-label="${escapeHtml(['Email', category, when].filter(Boolean).join(', '))}">
      <span class="vehicle-email-warning-kind">Email</span>
      <span class="vehicle-email-warning-label">${escapeHtml(category)}</span>
      <span class="vehicle-email-warning-when">${escapeHtml(when)}</span>
    </button>
    <div class="vehicle-email-warning-panel">
      <dl>
        <dt>From</dt><dd>${escapeHtml(fromText)}</dd>
        <dt>To</dt><dd>${escapeHtml(note.to_address || '')}</dd>
        <dt>Date</dt><dd>${escapeHtml(whenFull)}</dd>
        <dt>Subject</dt><dd>${escapeHtml(note.subject || '')}</dd>
      </dl>
      <p class="vehicle-email-warning-text">${escapeHtml(text)}</p>
      ${conflict ? `<p class="vehicle-email-warning-conflict">${escapeHtml(conflict)}</p>` : ''}
    </div>
  </div>`;
}

function vehicleEmailPartsEtaHost(vehicle, surface = 'card') {
  if (!vehicleEmailNotesVisible()) return '';
  const vehicleId = String(vehicle?.__emailVehicleId || vehicle?.id || '').trim();
  if (!vehicleId) return '';
  if (surface === 'detail') {
    return `<div class="vehicle-email-parts-eta" data-vehicle-email-warnings="${escapeHtml(vehicleId)}" data-vehicle-email-surface="detail"><div class="muted-label">Parts ETA</div><div class="subtle">Loading board emails…</div></div>`;
  }
  return `<div class="wide vehicle-email-parts-eta" data-vehicle-email-warnings="${escapeHtml(vehicleId)}" data-vehicle-email-surface="card" hidden></div>`;
}

function finishVehicleEmailWarningHost(host, notes, failed) {
  const detail = host.dataset.vehicleEmailSurface === 'detail';
  if (failed || !notes.length) {
    if (!detail) {
      host.hidden = true;
      host.replaceChildren();
      return;
    }
    host.hidden = false;
    host.innerHTML = `<div class="muted-label">Parts ETA</div><div class="subtle">${failed ? 'Board emails could not be loaded.' : 'No board emails on this vehicle yet.'}</div>`;
    return;
  }
  host.hidden = false;
  const rows = notes.map(vehicleEmailWarningHtml).join('');
  host.innerHTML = detail ? `<div class="muted-label">Parts ETA</div>${rows}` : rows;
}

function installVehicleEmailWarningInteractions() {
  if (typeof document === 'undefined' || document.documentElement?.dataset?.vehicleEmailWarningsBound === '1') return;
  document.documentElement.dataset.vehicleEmailWarningsBound = '1';
  ensureVehicleEmailPartsEtaStyle();
  document.addEventListener('toggle', event => {
    const row = event.target;
    if (!row?.matches?.('details.incoming-vehicle-card[data-incoming-row]')) return;
    if (!row.open || !vehicleEmailNotesVisible()) return;
    void loadVehicleEmailWarnings(selectedVehicle(row.dataset.incomingRow), row);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target?.closest?.('.vehicle-email-warning-row');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const item = button.closest('.vehicle-email-warning');
    if (!item) return;
    const open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

async function loadVehicleEmailWarnings(vehicle, root) {
  installVehicleEmailWarningInteractions();
  if (!root?.querySelectorAll || !vehicleEmailNotesVisible()) return;
  const vehicleId = String(vehicle?.__emailVehicleId || vehicle?.id || '').trim();
  const hosts = [...root.querySelectorAll('[data-vehicle-email-warnings]')].filter(host => host.dataset.vehicleEmailWarnings === vehicleId);
  if (!hosts.length) return;
  if (!vehicleId || !window.PDC_SUPABASE?.rpc) {
    hosts.forEach(host => finishVehicleEmailWarningHost(host, [], true));
    return;
  }
  const { data, error } = await window.PDC_SUPABASE.rpc('list_vehicle_email_notes_556', { p_vehicle_id: vehicleId });
  if (!root.isConnected) return;
  const notes = Array.isArray(data) ? data : [];
  hosts.forEach(host => finishVehicleEmailWarningHost(host, notes, Boolean(error)));
}

function renderDetail() {
  const v = selectedVehicle();
  const panel = $('#vehicle-detail');
  if (!panel) return;
  if (app.vehicleModalLoadingIdentity === true) {
    app.activeVehicleDetail = null;
    panel.innerHTML = '<div class="empty-state vehicle-detail-loading" role="status"><strong>Loading authoritative vehicle details…</strong><span>The exact Stock and vehicle UUID are being refreshed from staging before this card becomes editable.</span></div>';
    return;
  }
  if (!v && app.vehicleModalIdentity && !app.vehicleModalIdentityRecoveryAttempted) {
    app.vehicleModalLoadingIdentity = true;
    panel.innerHTML = '<div class="empty-state vehicle-detail-loading" role="status"><strong>Refreshing exact vehicle identity…</strong><span>The current canonical UUID and Stock are being rebound from the authenticated staging snapshot.</span></div>';
    void refreshVehicleModalExactIdentity().then(result => {
      if (result?.ok === true && app.vehicleModalIdentity) renderDetail();
      else if (app.vehicleModalIdentity) {
        app.vehicleModalLoadingIdentity = false;
        renderDetail();
      }
    });
    return;
  }
  if (app.vehicleModalIdentity && app.vehicleModalIdentityReady !== true) {
    const stock = escapeHtml(app.vehicleModalIdentity.stockBaseline || 'the selected Stock');
    const errorCode = String(app.vehicleModalIdentityLastError || 'identity_refresh_unavailable');
    const retryButton = isRetryableVehicleModalIdentityFailure(errorCode)
      ? '<button type="button" class="small-button vehicle-modal-retry-details" data-modal-retry-authoritative-details>Retry authoritative details</button>'
      : '';
    app.activeVehicleDetail = null;
    panel.innerHTML = `<div class="empty-state vehicle-identity-fail-closed" role="alert"><strong>Authoritative vehicle details could not be loaded</strong><span>${escapeHtml(vehicleModalIdentityErrorMessage(errorCode, app.vehicleModalIdentity.stockBaseline || 'the selected Stock'))}</span><div class="vehicle-identity-fail-actions">${retryButton}<button type="button" class="primary" data-modal-cancel>Close</button></div></div>`;
    panel.querySelector('[data-modal-cancel]')?.addEventListener('click', closeVehicleModal);
    panel.querySelector('[data-modal-retry-authoritative-details]')?.addEventListener('click', retryAuthoritativeVehicleDetails);
    return;
  }
  if (!v && app.vehicleModalIdentity) {
    const stock = escapeHtml(app.vehicleModalIdentity.stockBaseline || 'the selected Stock');
    const errorCode = String(app.vehicleModalIdentityLastError || 'identity_refresh_unavailable');
    const retryButton = isRetryableVehicleModalIdentityFailure(errorCode)
      ? '<button type="button" class="small-button vehicle-modal-retry-details" data-modal-retry-authoritative-details>Retry authoritative details</button>'
      : '';
    app.activeVehicleDetail = null;
    panel.innerHTML = `<div class="empty-state vehicle-identity-fail-closed" role="alert"><strong>Vehicle identity changed or is unavailable</strong><span>${escapeHtml(vehicleModalIdentityErrorMessage(errorCode, app.vehicleModalIdentity.stockBaseline || 'the selected Stock'))}</span><div class="vehicle-identity-fail-actions">${retryButton}<button type="button" class="primary" data-modal-cancel>Close</button></div></div>`;
    panel.querySelector('[data-modal-cancel]')?.addEventListener('click', closeVehicleModal);
    panel.querySelector('[data-modal-retry-authoritative-details]')?.addEventListener('click', retryAuthoritativeVehicleDetails);
    return;
  }
  if (!v) return;
  app.activeVehicleDetail = v;
  const key = vehicleKey(v);
  const rawPdcBlocked = v.pdcBlocked === true || v.pdcWorkshopBlocked === true;
  const rawWorkStateBaseline = Object.fromEntries(PDC_JOB_DEFS.map(def => [def.key, pdcJobTriState(v, def)]));
  const notes = getNotes(key);
  const customerWarning = !isCustomerMatch(v);
  const isCompletedVehicle = statusCategory(v) === 'completed';
  const completedLockAttr = isCompletedVehicle ? 'disabled' : '';
  const activePage = app.vehicleDetailPage === 'work' ? 'work' : 'details';
  const serverAuthoritative = v.__emailVehicleServerAuthoritative === true;
  panel.innerHTML = `
    <div class="panel-header vehicle-detail-header">
      <div><h2 id="vehicle-modal-title">Vehicle detail</h2><p>${stockLabel(v)} <span class="vehicle-copyable-field" data-vehicle-stock>${escapeHtml(displayStockNumber(v))}</span> <button class="small-button inline-copy-button" type="button" data-copy-vehicle-stock>Copy</button><span class="sr-only" aria-live="polite" data-copy-vehicle-stock-status></span></p></div>
      <div class="vehicle-detail-header-tools">
        <nav class="vehicle-detail-tabs" role="tablist" aria-label="Vehicle detail pages">
          <button type="button" role="tab" id="vehicle-detail-tab-details" aria-controls="vehicle-detail-panel-details" aria-selected="${activePage === 'details'}" tabindex="${activePage === 'details' ? '0' : '-1'}" class="${activePage === 'details' ? 'is-active' : ''}" data-vehicle-detail-tab="details">Vehicle details</button>
          <button type="button" role="tab" id="vehicle-detail-tab-work" aria-controls="vehicle-detail-panel-work" aria-selected="${activePage === 'work'}" tabindex="${activePage === 'work' ? '0' : '-1'}" class="${activePage === 'work' ? 'is-active' : ''}" data-vehicle-detail-tab="work">Work & bookings</button>
        </nav>
        ${formatStatus(v)}
      </div>
    </div>
    ${activePage === 'work'
      ? `<div id="vehicle-detail-panel-work" role="tabpanel" aria-labelledby="vehicle-detail-tab-work">${renderVehicleWorkshopWorkPage(v)}</div>`
      : `<div id="vehicle-detail-panel-details" role="tabpanel" aria-labelledby="vehicle-detail-tab-details" class="detail-body">
      ${vehicleModalIdentityRefreshNoticeHtml()}
      <div class="detail-title">
        <div><h3>${escapeHtml(v.client || 'New customer')}</h3><p>${escapeHtml(displayVehicle(v))}</p></div>
        <div class="detail-actions">
          ${vehiclePdcLocation(v) === 'QC' ? '' : `<button class="small-button vehicle-label-button" type="button" data-label-vehicle="${escapeHtml(key)}">Label</button>`}
          <button class="primary" type="button" data-email-vehicle-update="${escapeHtml(key)}">EMAIL UPDATE</button>
        </div>
      </div>
      <form class="edit-form" data-vehicle-edit-form data-server-authoritative="${serverAuthoritative ? 'true' : 'false'}" data-key-number-baseline="${escapeHtml(vehicleKeyNumber(v))}" data-jobcard-baseline="${escapeHtml(vehicleJobcardNumber(v))}" data-pdc-location-baseline="${escapeHtml(vehiclePdcLocation(v))}" data-pdc-blocked-baseline="${rawPdcBlocked ? 'true' : 'false'}" data-pdc-block-reason-baseline="${escapeHtml(v.pdcBlockReason || '')}" data-pdc-work-state-baseline="${escapeHtml(JSON.stringify(rawWorkStateBaseline))}">
        <div class="form-row three-col">
          <label>
            <span class="muted-label">SP <b class="sp-required-911" aria-hidden="true">*</b></span>
            <select name="consultant" aria-required="true">${salespersonOptionsHtml(consultantName(v))}</select>
            ${String(v.salespersonEmail || '').includes('@') ? '' : '<small class="sp-needed-hint-911">Required — if blank the FC email goes to Ron Haynes to forward</small>'}
          </label>
          <label>
            <span class="muted-label">Client name</span>
            <input name="client" value="${escapeHtml(v.client || '')}" placeholder="Client name" ${serverAuthoritative ? 'readonly' : ''} />
          </label>
          <label>
            <span class="muted-label">Key tag number</span>
            ${statusCategory(v) === 'pmb' ? `<input name="keyNumber" value="${escapeHtml(vehicleKeyNumber(v))}" placeholder="One active PMB key tag number" />` : `<input name="keyNumber" value="" placeholder="Available once allocated into PMB" readonly />`}
            <span class="field-help">Shown and editable only while the vehicle is allocated into PMB.</span>
          </label>
        </div>
        <div class="form-row two-col">
          <label>
            <span class="muted-label">JC Jobcard Number</span>
            <input name="pdcJobcard" value="${escapeHtml(vehicleJobcardNumber(v))}" placeholder="Workshop jobcard #" />
          </label>
          <label>
            <span class="muted-label">Navision ETA</span>
            <input value="${escapeHtml(scotEtaOnly(v.etaAtDealer))}" placeholder="No Navision ETA" readonly />
          </label>
        </div>
        <div class="form-row one-col">
          <label>
            <span class="muted-label">PDC location</span>
            <select name="pdcLocation" ${serverAuthoritative ? 'disabled' : ''}>${pdcLocationSelectOptions(v.pdcLocation, serverAuthoritative, v)}</select>
            <span class="field-help">Manual from Yard Hold onward. Navision will not overwrite PMB or RFT.</span>
          </label>
        </div>
        <div class="form-row two-col">
          <label>
            <span class="muted-label">Workshop activity</span>
            <input value="${escapeHtml(vehicleWorkshopActivityLabel(v))}" readonly />
            <span class="field-help">PDC location: ${escapeHtml(pdcLocationLabel(vehiclePdcLocation(v)) || 'Not recorded')} · PMB stream: ${escapeHtml(pmbStageLabel(inferredPmbStage(v)) || 'Unassigned')}. Future bookings do not change the vehicle’s location.</span>
          </label>
          <label>
            <span class="muted-label">Bucket age</span>
            <input value="${escapeHtml(statusCategory(v) === 'pmb' ? pmbStageAgeLabel(v) : 'Not in PMB')}" readonly />
          </label>
        </div>
        <div class="muted-label section-label">Blocked / exception control</div>
        <div class="form-row two-col">
          <label class="check-option block-check"><input name="pdcBlocked" type="checkbox" ${rawPdcBlocked ? 'checked' : ''} /> <span>Blocked / problem vehicle</span></label>
          <label>
            <span class="muted-label">Blocked reason</span>
            <input name="pdcBlockReason" value="${escapeHtml(v.pdcBlockReason || '')}" placeholder="Parts missing, damage, awaiting supplier, rework..." />
          </label>
        </div>
        <div class="muted-label section-label">Required work before RFT</div>
        <div class="pdc-work-state-grid" data-pdc-work-state-grid>
          ${PDC_JOB_DEFS.map(def => pdcJobTriStateControl(v, def, isCompletedVehicle)).join('')}
        </div>
        <div class="field-help pdc-work-state-help">Click each work item to cycle: grey = not required, red = to be completed, orange = Parts ordered / Workshop booked, green = completed.</div>
        <div class="edit-actions">
          <button class="primary" type="submit">Save changes</button>
          <button class="ghost" type="button" data-modal-cancel>Cancel</button>
          <span class="save-message" data-save-message role="status" aria-live="polite"></span>
        </div>
      </form>
      ${renderPmbBayControlSection(v)}
      ${renderPoTasksSection(v)}
      ${renderPdcJobLinesSection(v)}
      ${renderPurchaseOrderDetailSection(v)}
      ${renderNavisionDetailSection(v)}

      <div>
        <div class="muted-label">Status history</div>
        <div class="timeline">
          <div class="timeline-item"><span class="dot"></span><div><strong>Task</strong><br>${escapeHtml(v.internalStatus || 'No task selected')}</div></div>
          ${vehiclePdcLocation(v) ? `<div class="timeline-item"><span class="dot"></span><div><strong>PDC location</strong><br>${escapeHtml(pdcLocationLabel(v.pdcLocation))}</div></div>` : ''}
          ${inferredPmbStage(v) ? `<div class="timeline-item"><span class="dot"></span><div><strong>PMB work stream</strong><br>${escapeHtml(pmbStageLabel(inferredPmbStage(v)))}${pmbBaySummary(v) ? ` · ${escapeHtml(pmbBaySummary(v))}` : ''}</div></div>` : ''}
          ${v.toyotaStatus ? `<div class="timeline-item"><span class="dot"></span><div><strong>Navision Sub Location Description</strong><br>${escapeHtml(v.toyotaStatus)}${scotEtaOnly(v.etaAtDealer) ? ` · ETA ${escapeHtml(scotEtaOnly(v.etaAtDealer))}` : ''}</div></div>` : ''}
          ${(v.poTasks || []).length ? `<div class="timeline-item"><span class="dot"></span><div><strong>Purchase order tasks loaded</strong><br>${(v.poTasks || []).length} workshop / accessory task${(v.poTasks || []).length === 1 ? '' : 's'} attached.</div></div>` : ''}
          ${isAutocareDespatched(v) ? `<div class="timeline-item autocare-timeline"><span class="dot"></span><div><strong>Autocare despatch notice matched</strong><br>${v.autocareLoadNumber ? `Load ${escapeHtml(v.autocareLoadNumber)} · ` : ''}${v.autocareBatch ? `Batch ${escapeHtml(v.autocareBatch)} · ` : ''}${v.autocareVin ? `VIN ${escapeHtml(v.autocareVin)}` : 'Marked as despatched from Autocare notice'}</div></div>` : ''}
          ${customerWarning ? `<div class="timeline-item"><span class="dot"></span><div><strong>Customer mismatch warning</strong><br>Tracker says ${escapeHtml(v.client)}; Toyota says ${escapeHtml(v.toyotaCustomer)}.</div></div>` : ''}
        </div>
      </div>
      <div>
        <div class="muted-label">Import & detailed audit trail</div>
        ${renderAuditTrailSection(v)}
      </div>
      ${vehicleEmailPartsEtaHost(v, 'detail')}
      <form class="notes-form" data-notes-form>
        <div class="muted-label">Team notes</div>
        <textarea rows="3" placeholder="Add call notes, accessory reminders, or follow-up actions..."></textarea>
        <button class="primary" type="submit">Add note</button>
      </form>
      <div class="notes-list">${notes.map(n => `<div class="note-pill">${escapeHtml(n)}</div>`).join('') || '<div class="subtle">No notes added yet.</div>'}</div>
      ${vehicleLifecycleAdministratorActive() && vehicleLifecycleSharedModeActive() ? `<div class="detail-danger-zone">
        <div><strong>Delete Vehicle</strong><span>Archives this vehicle from active Board screens. Tombstone and audit evidence are retained.</span></div>
        <button class="danger ghost" type="button" data-remove-vehicle="${escapeHtml(key)}">Delete Vehicle</button>
      </div>
      ${vehicleLifecycleStagingResetAllowed() ? `<div class="detail-danger-zone">
        <div><strong>Reset Staging Test Vehicle</strong><span>Staging-only reset for an Administrator-controlled test vehicle.</span></div>
        <button class="danger ghost" type="button" data-reset-test-vehicle="${escapeHtml(key)}">Reset Staging Test Vehicle</button>
      </div>
      ${completeVehicleDeleteCommissioned() ? `<div class="detail-danger-zone complete-vehicle-delete-zone">
        <div><strong>Complete Vehicle Delete</strong><span>Permanently removes this vehicle's visible, operational and archive staging footprint. Historical email will not replay; the old source stays fenced and a genuinely new source is required to recreate the Stock/VIN.</span></div>
        <button class="danger" type="button" data-complete-vehicle-delete="${escapeHtml(key)}">Complete Vehicle Delete</button>
      </div>` : ''}` : ''}` : ''}
    </div>`}
  `;
  const vehicleEditForm = $('[data-vehicle-edit-form]', panel);
  if (vehicleEditForm?.consultant) vehicleEditForm.dataset.consultantBaseline = vehicleEditForm.consultant.value;
  bindVehicleDetailTabs(panel);
  if (activePage === 'work') return;
  on($('[data-copy-vehicle-stock]', panel), 'click', async event => {
    const value = cleanNavisionText(displayStockNumber(v));
    const status = $('[data-copy-vehicle-stock-status]', panel);
    await copyVehicleStockNumber(value, event.currentTarget, status);
  });
  loadVehicleHistoryForDetail(v);
  if (vehicleEmailNotesVisible()) void loadVehicleEmailWarnings(v, panel);
  on($('[data-email-vehicle-update]', panel), 'click', () => draftSelectedVehicleStatusEmail(key));
  bindVehicleLabelButtons(panel);
  on($('[data-remove-vehicle]', panel), 'click', () => removeVehicle(key));
  on($('[data-reset-test-vehicle]', panel), 'click', () => removeVehicle(key, { resetTest: true }));
  on($('[data-complete-vehicle-delete]', panel), 'click', () => completeVehicleDelete(key));
  on($('[data-modal-cancel]', panel), 'click', closeVehicleModal);
  on($('[data-modal-retry-authoritative-details]', panel), 'click', retryAuthoritativeVehicleDetails);

  $$('[data-confirm-pdc-job-line]', panel).forEach(button => {
    button.addEventListener('click', () => {
      const lineId = button.dataset.confirmPdcJobLine || '';
      const input = panel.querySelector(`[data-pdc-job-line-hours="${lineId}"]`);
      const stage = panel.querySelector(`[data-pdc-job-line-stage="${lineId}"]`);
      confirmPdcJobLineHours(key, lineId, input?.value || '', stage?.value || '');
    });
  });
  $$('[data-pdc-work-state]', panel).forEach(button => {
    button.addEventListener('click', () => {
      if (button.disabled) return;
      const current = button.dataset.state || 'none';
      const next = current === 'none' ? 'required' : current === 'required' ? 'complete' : 'none';
      applyPdcWorkStateControl(button, next, panel);
    });
  });
  $('[data-vehicle-edit-form]', panel).addEventListener('submit', async (e) => {
    e.preventDefault();
    if (app.vehicleModalSaveInFlight) return;
    const saveToken = {};
    app.vehicleModalSaveInFlight = saveToken;
    try {
      const form = e.currentTarget;
    let authoritativeSaveVehicle = v;
    let identityRebound = false;
    if (serverAuthoritative && (!vehicleModalIdentityMatches(v) || !vehicleModalIdentityMatches(vehicleModalBoundVehicle()))) {
      const rebound = await refreshVehicleModalExactIdentity();
      if (!rebound?.ok || !vehicleModalIdentityMatches(rebound.vehicle)) {
        const saveMessage = $('[data-save-message]', panel);
        if (saveMessage) saveMessage.textContent = 'Error: exact vehicle identity is no longer available; no change was made';
        pdcNotify('The exact Stock and canonical vehicle identity changed or disappeared. No vehicle was changed.');
        return;
      }
      authoritativeSaveVehicle = rebound.vehicle;
      identityRebound = true;
    } else if (serverAuthoritative) {
      authoritativeSaveVehicle = vehicleModalBoundVehicle() || v;
    }
    if (serverAuthoritative && (!vehicleModalIdentityMatches(authoritativeSaveVehicle) || authoritativeSaveVehicle.__emailVehicleServerAuthoritative !== true)) {
      const saveMessage = $('[data-save-message]', panel);
      if (saveMessage) saveMessage.textContent = 'Error: exact vehicle identity is no longer available; no change was made';
      pdcNotify('The exact Stock and canonical vehicle identity changed or disappeared. No vehicle was changed.');
      return;
    }
    const clientInput = form.client.value.trim();
    const client = serverAuthoritative ? String(v.client || '').trim() : (clientInput || v.client);
    const keyNumber = statusCategory(v) === 'pmb' ? cleanNavisionText(form.keyNumber?.value || '') : vehicleKeyNumber(v);
    const consultant = form.consultant.value.trim();
    const saveButton = form.querySelector('button[type="submit"]');
    const saveMessage = $('[data-save-message]', panel);
    const salespersonChangedByUser = consultant !== String(form.dataset.consultantBaseline || '').trim();
    const salespersonChanged = serverAuthoritative && salespersonChangedByUser
      && authoritativeSalespersonCode(authoritativeSaveVehicle) !== consultant.trim().toUpperCase();
    const internalStatus = v.internalStatus || '';
    const previousPdcLocation = vehiclePdcLocation(v);
    const previousPmbStage = normalizePmbStage(v.pmbStage || '');
    const previouslyPdcBlocked = rawPdcBlocked;
    const pdcLocation = isCompletedVehicle || serverAuthoritative ? previousPdcLocation : normalizePdcLocation(form.pdcLocation.value);
    const pmbStage = previousPmbStage;
    const pdcJobcard = cleanNavisionText(form.pdcJobcard?.value || '');
    const pdcBlocked = Boolean(form.pdcBlocked?.checked);
    const pdcBlockReasonValue = cleanNavisionText(form.pdcBlockReason?.value || '');
    const workStateMap = pdcWorkStateMapFromForm(form, v, isCompletedVehicle);
    const { requirementUpdates, completionUpdates } = pdcWorkStateUpdatesFromMap(workStateMap);
    let rawWorkStateBaseline = null;
    try { rawWorkStateBaseline = JSON.parse(form.dataset.pdcWorkStateBaseline || ''); } catch (_error) { rawWorkStateBaseline = null; }
    const workStateChangedByUser = rawWorkStateBaseline && PDC_JOB_DEFS.some(def => workStateMap[def.key] !== rawWorkStateBaseline[def.key]);
    const detailChanges = {};
    if (serverAuthoritative && client !== String(v.client || '').trim()) detailChanges.client_name = client;
    if (serverAuthoritative && keyNumber !== String(form.dataset.keyNumberBaseline || '').trim()) detailChanges.key_number = keyNumber;
    if (serverAuthoritative && pdcJobcard !== String(form.dataset.jobcardBaseline || '').trim()) detailChanges.job_card_number = pdcJobcard;
    const duplicateKeyVehicle = detailChanges.key_number !== undefined ? boardVehicleWithSameKey(keyNumber, key) : null;
    if (duplicateKeyVehicle) {
      const sentence = keyAlreadyOnStockSentence(keyNumber, duplicateKeyVehicle);
      if (saveMessage) {
        saveMessage.textContent = sentence;
        saveMessage.classList.add('is-key-clash');
      }
      pdcNotify(sentence, 'info');
      return;
    }
    const authoritativeLocationChanged = serverAuthoritative
      && pdcLocation !== normalizePdcLocation(form.dataset.pdcLocationBaseline || previousPdcLocation);
    if (pdcLocation === 'PMB' && previousPdcLocation !== 'PMB') {
      const partsWarning = pmbPartsReleaseWarning([authoritativeSaveVehicle]);
      if (partsWarning && !window.confirm(partsWarning)) return;
    }
    if (authoritativeLocationChanged) {
      const hasOtherAuthoritativeChanges = salespersonChanged
        || Object.keys(detailChanges).length > 0
        || Boolean(workStateChangedByUser)
        || pdcBlocked !== previouslyPdcBlocked
        || pdcBlockReasonValue !== cleanNavisionText(v.pdcBlockReason || '');
      if (hasOtherAuthoritativeChanges) {
        if (saveMessage) saveMessage.textContent = 'Error: save other edits before changing PDC Location';
        pdcNotify('PDC Location is an audited lifecycle action. Save other edits first, then change the location separately. No change was made.');
        return;
      }
      if (!pdcLocationManualTransitionAllowed(previousPdcLocation, pdcLocation, authoritativeSaveVehicle)) {
        if (saveMessage) saveMessage.textContent = 'Error: that PDC location transition is not allowed';
        return;
      }
      const ref = await vehicleLifecycleSharedRef(authoritativeSaveVehicle);
      if (!ref || ref.outcome !== 'resolved' || typeof window.__vehicleLifecycleActions?.setPdcLocation !== 'function') {
        if (saveMessage) saveMessage.textContent = 'Error: authoritative PDC location service unavailable';
        return;
      }
      if (saveButton) { saveButton.disabled = true; saveButton.setAttribute('aria-busy', 'true'); }
      if (saveMessage) saveMessage.textContent = 'Saving PDC location…';
      const locationResult = await window.__vehicleLifecycleActions.setPdcLocation({
        vehicleId: ref.vehicleId,
        expectedVersion: ref.version,
        location: pdcLocation,
        requestKey: pdcLocationRequestKey(ref.vehicleId, ref.version, pdcLocation),
      });
      if (!locationResult || locationResult.ok !== true) {
        await refreshVehicleLifecycleLocationsAndRender();
        if (saveButton) { saveButton.disabled = false; saveButton.removeAttribute('aria-busy'); }
        if (saveMessage) saveMessage.textContent = `Error: ${vehicleLifecycleActionErrorMessage(locationResult)}`;
        return;
      }
      const rebound = await refreshVehicleModalExactIdentity();
      if (!rebound?.ok || !rebound.vehicle) {
        if (saveMessage) saveMessage.textContent = 'Saved location, but authoritative readback failed';
        return;
      }
      authoritativeSaveVehicle = rebound.vehicle;
      if (saveMessage) saveMessage.textContent = 'PDC Location saved';
      renderAll();
      renderDetail();
      return;
    }
    if (serverAuthoritative && (pdcBlocked !== (form.dataset.pdcBlockedBaseline === 'true')
      || pdcBlockReasonValue !== String(form.dataset.pdcBlockReasonBaseline || ''))) {
      if (saveMessage) saveMessage.textContent = 'Error: lifecycle or stoppage fields use their dedicated shared action';
      return;
    }
    let authoritativeResult = null;
    if (serverAuthoritative && (salespersonChanged || Object.keys(detailChanges).length)) {
      if (saveButton) { saveButton.disabled = true; saveButton.setAttribute('aria-busy', 'true'); }
      if (saveMessage) saveMessage.textContent = 'Saving…';
      const identityHelper = window.PDC_VEHICLE_MODAL_IDENTITY;
      authoritativeResult = typeof identityHelper?.saveWithOneExactRebindRetry === 'function'
        ? await identityHelper.saveWithOneExactRebindRetry({
          vehicle: authoritativeSaveVehicle,
          changes: detailChanges,
          save: current => saveAuthoritativeVehicleChanges(current, consultant, detailChanges),
          refreshAndRebind: identityRebound ? null : async () => {
            identityRebound = true;
            return refreshVehicleModalExactIdentity();
          },
        })
        : await saveAuthoritativeVehicleChanges(authoritativeSaveVehicle, consultant, detailChanges);
      if (!authoritativeResult || authoritativeResult.ok !== true) {
        if (saveButton) { saveButton.disabled = false; saveButton.removeAttribute('aria-busy'); }
        const clash = String(authoritativeResult?.message || '');
        if (/^Key \S+ is already on stock /.test(clash)) {
          if (saveMessage) {
            saveMessage.textContent = clash;
            saveMessage.classList.add('is-key-clash');
          }
          pdcNotify(clash, 'info');
        } else if (saveMessage) {
          saveMessage.classList.remove('is-key-clash');
          saveMessage.textContent = `Error: ${authoritativeResult?.code || 'authoritative_vehicle_save_failed'}`;
        }
        return;
      }
      authoritativeSaveVehicle = authoritativeResult.data?.authoritativeVehicle || vehicleModalBoundVehicle() || v;
    }
    const updates = { client, keyNumber, pdcJobcard, consultant, internalStatus, pdcLocation, pmbStage, pdcBlocked, pdcBlockReason: pdcBlockReasonValue, ...requirementUpdates, ...completionUpdates };
    const hasIndependentPdcWork = Boolean(
      (!serverAuthoritative && pdcJobcard) || pdcLocation || pdcBlocked ||
      PDC_JOB_DEFS.some(def => requirementUpdates[def.requireKey] || completionUpdates[def.completeKey])
    );
    if (hasIndependentPdcWork) Object.assign(updates, pdcVisibilityPromotionUpdates(v, 'Operator / PDC work update'));
    const changedCompletions = workStateChangedByUser ? PDC_JOB_DEFS.filter(def => pdcJobComplete(v, def) !== completionUpdates[def.completeKey]) : [];
    const changedRequirements = workStateChangedByUser ? PDC_JOB_DEFS.filter(def => pdcJobRequired(v, def) !== requirementUpdates[def.requireKey]) : [];
    let sharedWorkStatesSaved = false;
    if (!isCompletedVehicle && (changedCompletions.length || changedRequirements.length) && vehicleLifecycleSharedModeActive()) {
      const submit = form.querySelector('button[type="submit"]');
      const saveMessage = $('[data-save-message]', panel);
      if (submit) submit.disabled = true;
      if (saveMessage) saveMessage.textContent = 'Saving required work…';
      const workStates = Object.fromEntries(PDC_JOB_DEFS.map(def => [
        def.key,
        completionUpdates[def.completeKey] ? 'complete' : requirementUpdates[def.requireKey] ? 'required' : 'none',
      ]));
      const sharedResult = await saveSharedVehicleWorkStates(authoritativeSaveVehicle, workStates);
      if (!sharedResult || sharedResult.ok !== true) {
        if (submit) submit.disabled = false;
        if (saveMessage) saveMessage.textContent = 'Not saved';
        pdcNotify(sharedResult?.message || describeSharedVehicleWorkStateError(sharedResult));
        return;
      }
      sharedWorkStatesSaved = true;
    }
    if (changedCompletions.length || changedRequirements.length) {
      Object.assign(updates, { pdcQcComplete: false, pdcQcCompleteAt: '', pdcQcCompleteBy: '' });
    }
    if (changedCompletions.length) {
      const operator = getCurrentOperatorName();
      const now = nowIsoString();
      changedCompletions.forEach(def => {
        if (completionUpdates[def.completeKey]) {
          updates[def.completeAtKey] = now;
          updates[def.completeByKey] = operator;
          if (!sharedWorkStatesSaved) recordVehicleAudit(v, 'Job signed off', { job: def.label, by: operator });
        } else {
          updates[def.completeAtKey] = '';
          updates[def.completeByKey] = '';
          if (!sharedWorkStatesSaved) recordVehicleAudit(v, 'Job sign-off removed', { job: def.label, by: operator });
        }
      });
    }
    if (!serverAuthoritative || workStateChangedByUser) PDC_JOB_DEFS.forEach(def => {
      if (!sharedWorkStatesSaved && pdcJobRequired(v, def) !== requirementUpdates[def.requireKey]) recordVehicleAudit(v, requirementUpdates[def.requireKey] ? 'Requirement added' : 'Requirement removed', { job: def.label });
    });
    if (!serverAuthoritative && (isPdcBlocked(v) !== pdcBlocked || pdcBlockReason(v) !== (pdcBlockReasonValue || 'Blocked'))) {
      recordVehicleAudit(v, pdcBlocked ? 'Vehicle blocked' : 'Vehicle unblocked', { reason: pdcBlockReasonValue });
    }
    if (!serverAuthoritative && pdcLocation !== previousPdcLocation) {
      const now = nowIsoString();
      updates.pdcLocationUpdatedAt = now;
      if (pdcLocation === 'PMB') {
        updates.manualLocation = 'PMB';
        updates.pdcLocationLocked = true;
        updates.pmbTransferredAt = v.pmbTransferredAt || now;
        updates.pmbEnteredAt = pmbEnteredTimestamp(v) || now;
        if (previousPdcLocation !== 'PMB') {
          updates.pmbStage = '';
          updates.pdcWorkStage = '';
          updates.workStage = '';
          updates.pmbStageEnteredAt = '';
          updates.pmbStageUpdatedAt = '';
          updates.pmbBayStage = '';
          updates.pmbBayNumber = '';
          updates.pmbBayEstimatedHours = '';
          updates.pmbBayEnteredAt = '';
          updates.pmbBayScheduledStartAt = '';
          updates.pmbBayCompletedAt = '';
          updates.pmbBayCompletedBy = '';
          updates.pmbBayCompletedStage = '';
          updates.pmbBayMechanic = '';
          updates.pmbSubletProvider = '';
        }
      }
      if (pdcLocation === 'RFT') { updates.manualLocation = 'RFT'; updates.pdcLocationLocked = true; updates.rftTransferredAt = now; updates.pmbEnteredAt = pmbEnteredTimestamp(v) || now; }
      if (pdcLocation === 'YH') { updates.manualLocation = 'YH'; updates.pdcLocationLocked = true; }
      recordVehicleAudit(v, 'PDC location changed', { from: pdcLocationLabel(previousPdcLocation) || 'Follow Navision', to: pdcLocationLabel(pdcLocation) || 'Follow Navision' });
    }
    if (!(pdcLocation === 'PMB' && previousPdcLocation !== 'PMB') && pmbStage !== previousPmbStage) {
      updates.pmbStageUpdatedAt = nowIsoString();
      updates.pmbStageEnteredAt = updates.pmbStageUpdatedAt;
      recordVehicleAudit(v, 'PMB bucket moved', { from: pmbStageLabel(previousPmbStage) || 'Unallocated', to: pmbStageLabel(pmbStage) || 'Unallocated' });
    }
    const savedLocalFields = serverAuthoritative ? true : saveVehicleEdits(key, updates);
    const newlyCompleted = changedCompletions.filter(def => completionUpdates[def.completeKey]);
    const stoppageAdded = !previouslyPdcBlocked && pdcBlocked;
    if (newlyCompleted.length || stoppageAdded) {
      const notificationTitle = stoppageAdded
        ? 'PDC STOPPAGE recorded'
        : newlyCompleted.length === 1
          ? `${newlyCompleted[0].label} completed`
          : `${newlyCompleted.length} PDC jobs completed`;
      offerSalespersonChangeEmail(v, {
        title: notificationTitle,
        subject: stoppageAdded ? 'PDC STOPPAGE update' : 'PDC work completed',
        details: [
          ...newlyCompleted.map(def => `${def.label} was signed off by ${getCurrentOperatorName()}.`),
          stoppageAdded ? `Reason: ${pdcBlockReasonValue || 'Blocked'}` : '',
        ],
      });
    }
    renderDetail();
    const msg = document.querySelector('[data-save-message]');
    if (msg) msg.textContent = authoritativeResult?.readbackPending ? 'Saved online; refreshing…' : 'Saved';
    if (saveButton) { saveButton.disabled = false; saveButton.removeAttribute('aria-busy'); }
    } finally {
      if (app.vehicleModalSaveInFlight === saveToken) app.vehicleModalSaveInFlight = null;
    }
  });
  $('[data-pmb-bay-detail-form]', panel)?.addEventListener('submit', (e) => {
    e.preventDefault();
    const saved = savePmbBayDetailForm(v, e.currentTarget);
    renderDetail();
    if (saved) {
      const msg = $('[data-bay-save-message]', panel) || $('[data-bay-save-message]');
      if (msg) msg.textContent = 'Saved';
    }
  });
  $('[data-modal-complete-pmb-bay-work]', panel)?.addEventListener('click', (e) => {
    e.preventDefault();
    completePmbBayWork(e.currentTarget.dataset.modalCompletePmbBayWork, e.currentTarget.dataset.modalCompletePmbBayStage);
    renderDetail();
  });
  $('[data-notes-form]', panel).addEventListener('submit', (e) => {
    e.preventDefault();
    const text = $('textarea', e.currentTarget).value.trim();
    if (!text) return;
    const stamp = new Date().toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' });
    setNotes(key, [`${stamp} - ${text}`, ...getNotes(key)]);
    renderDetail();
  });
}


function renderNavisionDetailSection(vehicle = {}) {
  const note = navisionDealerNoteText(vehicle);
  const fields = [
    ['Batch', vehicle.batch || vehicle.stock],
    ['Dealer code', vehicleModalDealerIdentity(vehicle)],
    ['Production Month', productionMonthLabel(vehicle.prodMth || vehicle.productionMonth || '')],
    ['Model Description', vehicle.toyotaVehicle],
    ['Suffix Description', vehicle.suffix],
    ['Trim Description', vehicle.trim],
    ['Colour Description', vehicle.colour],
    ['VIN', vehicle.vin],
    ['WMI', vehicle.wmi],
    ['VDS Number', vehicle.vdsNumber],
    ['Frame', vehicle.frame],
    ['Dealer Customer Name', vehicle.dealerCustomer || vehicle.toyotaCustomer],
    ['JITA Number', jitaDisplay(vehicle)],
    ['Tray Fitment Ordered', vehicleFlag(vehicle, 'trayOrdered') ? 'Yes' : 'No'],
    ['Tray Fitment Complete', vehicleFlag(vehicle, 'trayFitmentComplete') ? 'Yes' : 'No'],
    ['Sub Location Description', vehicle.navisionSubLocationDescription || vehicle.toyotaStatus],
    ['Location Status', vehicle.navisionLocationStatus],
    ['Build Status', vehicle.navisionBuildStatus],
    ['Transport Load No.', vehicle.navisionTransportLoadNo],
    ['Control Board ETA', scotEtaOnly(vehicle.etaAtDealer)],
    ['ETA At Kewdale Yard', vehicle.navisionKewdaleEta],
    ['ETA Date (not used for dashboard ETA)', vehicle.navisionEtaDate],
    ['Port/Plant ETA Date (not used for dashboard ETA)', vehicle.navisionPortPlantEta],
    ['ETA At Dealer/BB (not used for dashboard ETA)', vehicle.navisionEtaAtDealerBB],
    ['Vehicle Note', vehicle.navisionVehicleNote],
    ['Cut But Vehicle', isNavisionCutButVehicle(vehicle) ? (vehicle.navisionCutButVehicleSource || 'Yes') : ''],
  ].filter(([, value]) => cleanNavisionText(value));

  const notesHtml = note
    ? `<div class="navision-notes-detail"><div class="muted-label">Navision Notes / Dealer Comments</div><pre>${escapeHtml(note)}</pre></div>`
    : `<div class="navision-notes-detail empty"><div class="muted-label">Navision Notes / Dealer Comments</div><pre>No Dealer Comments imported for this vehicle.</pre></div>`;

  return `<section class="navision-detail-panel">
    ${notesHtml}
    <div class="muted-label">Navision vehicle fields</div>
    <div class="navision-field-grid">
      ${fields.map(([label, value]) => `<div class="navision-field"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></div>`).join('') || '<div class="subtle">No detailed Navision fields are available for this row.</div>'}
    </div>
  </section>`;
}


function pdcJobLineIdentity(line = {}) {
  if (cleanNavisionText(line.id || '')) return cleanNavisionText(line.id);
  const source = [line.code, line.description, Number(line.quantity || 1)].join('|').toUpperCase();
  let hash = 5381;
  for (let index = 0; index < source.length; index += 1) hash = ((hash << 5) + hash) ^ source.charCodeAt(index);
  return `jobline-${(hash >>> 0).toString(16).padStart(8, '0')}`;
}

function pdcJobLineStage(line = {}) {
  const requested = normalizePmbStage(line.category || line.stage || line.suggestedStage || '');
  if (PDC_JOB_LINE_STAGE_OPTIONS.some(option => option.value === requested)) return requested;
  const value = `${line.code || ''} ${line.description || ''}`;
  if (/\btint\b/i.test(value)) return 'TINT';
  if (/\b(?:tyres?|tires?|wheel alignment|alignment)\b/i.test(value)) return 'TYRE';
  if (/\b(?:electrical|driving lights?|light bar|dual battery|battery system|uhf|antenna|reverse alarm|brake controller|wiring|solis)\b/i.test(value)) return 'ELECTRICAL';
  if (/\b(?:bull\s*bar|nudge\s*bar|tow\s*bar|winch|canopy|snorkel|side rails?|side steps?|seat covers?|floor mats?|dash mat|recovery point|roof rack|fold step|fit(?:ting)?)\b/i.test(value)) return 'FITTING';
  if (/\b(?:fabricat|tray|module|service body|rops|tool ?box|jacking points?|water tank|mine bar|weld)\b/i.test(value)) return 'FABRICATION';
  if (/\b(?:suspension|gvm|lift kit|weight upgrade)\b/i.test(value)) return 'HOIST';
  if (/\b(?:pit inspection|pit and weigh|quality check)\b/i.test(value)) return 'PIT_INSPECTION';
  if (/\bbus\s*4\s*x\s*4\b/i.test(value)) return 'BUS_4X4';
  return 'FITTING';
}

function pdcJobLineStageOptionsHtml(current = '') {
  const selected = normalizePmbStage(current);
  return PDC_JOB_LINE_STAGE_OPTIONS.map(option => `<option value="${escapeHtml(option.value)}"${option.value === selected ? ' selected' : ''}>${escapeHtml(option.label)}</option>`).join('');
}

function mergePdcJobLines(...groups) {
  const merged = new Map();
  groups.flat().filter(line => line && typeof line === 'object').forEach(line => {
    const id = pdcJobLineIdentity(line);
    merged.set(id, { ...(merged.get(id) || {}), ...line, id });
  });
  return [...merged.values()];
}

function arbEstimateForJobLine(code = '', description = '', quantity = 1) {
  const entries = ARB_LABOUR_CATALOG.entries || {};
  const ambiguous = ARB_LABOUR_CATALOG.ambiguous || {};
  const tokens = [code, description].join(' ').toUpperCase().match(/\b[A-Z0-9][A-Z0-9-]{2,39}\b/g) || [];
  const matchedCodes = [...new Set(tokens.filter(token => entries[token]))];
  const candidateHours = [...new Set(matchedCodes.map(token => Number(entries[token]?.hours || 0)).filter(hours => hours > 0))];
  const normalizedQuantity = Math.max(0.01, Number(quantity || 1));
  if (matchedCodes.length === 1 && candidateHours.length === 1) {
    const matchedCode = matchedCodes[0];
    const entry = entries[matchedCode];
    const fittingCharge = Number(entry.fittingCharge || 0);
    const rateDetail = fittingCharge
      ? ` · $${fittingCharge} ÷ $${Number(ARB_LABOUR_CATALOG.labourRate || 160)}/h (rate p${ARB_LABOUR_CATALOG.labourRateSourcePage || '?'})`
      : ' · explicit catalogue fit time';
    return {
      estimatedHours: Number((candidateHours[0] * normalizedQuantity).toFixed(4)),
      estimateStatus: 'provisional',
      estimateSource: `${ARB_LABOUR_CATALOG.sourceCode || 'ARB catalogue'} · ${matchedCode} · page ${entry.page || '?'}${rateDetail}`,
      estimateMethod: entry.method || 'catalogue',
      catalogHoursEach: candidateHours[0],
    };
  }
  const ambiguousCode = tokens.find(token => ambiguous[token]);
  return {
    estimatedHours: null,
    estimateStatus: 'review-required',
    estimateSource: ambiguousCode
      ? `${ARB_LABOUR_CATALOG.sourceCode || 'ARB catalogue'} · ${ambiguousCode} has vehicle-dependent fitting times`
      : (matchedCodes.length > 1 ? `${ARB_LABOUR_CATALOG.sourceCode || 'ARB catalogue'} · multiple product codes require line-by-line review` : ''),
    estimateMethod: '',
    catalogHoursEach: null,
  };
}

function pdcJobLineFromPurchaseOrderItem(item = {}) {
  const code = cleanNavisionText(item.item || item.code || '').toUpperCase();
  const description = cleanNavisionText(item.description || 'Purchase order work item');
  const quantity = Math.max(0.01, Number(item.quantity || 1));
  const estimate = arbEstimateForJobLine(code, description, quantity);
  const line = {
    code,
    description,
    quantity,
    source: 'Reviewed PO upload',
    ...estimate,
  };
  line.id = pdcJobLineIdentity(line);
  return line;
}

function vehiclePdcJobLines(vehicle = {}) {
  const reviews = vehicle.pdcJobLineReviews && typeof vehicle.pdcJobLineReviews === 'object' ? vehicle.pdcJobLineReviews : {};
  return mergePdcJobLines(vehicle.pdcJobLines || [], vehicle.pdcManualJobLines || []).map(line => {
    const review = reviews[pdcJobLineIdentity(line)] || {};
    return { ...line, ...review, id: pdcJobLineIdentity(line) };
  });
}

function validPdcJobLineHours(value) {
  const hours = Number(value);
  return Number.isFinite(hours) && hours >= (1 / 12) && hours <= 40 ? Number(hours.toFixed(2)) : null;
}

function renderPdcJobLinesSection(vehicle) {
  const lines = vehiclePdcJobLines(vehicle);
  if (!lines.length) return '';
  const completedLocked = vehicleCollectedFromRft(vehicle);
  const confirmed = lines.filter(line => line.confirmed === true).length;
  const total = lines.reduce((sum, line) => sum + (Number(line.confirmedHours ?? line.estimatedHours) || 0), 0);
  return `<section class="pdc-job-lines-panel">
    <div class="pdc-job-lines-header">
      <div><div class="muted-label">PD Document work and estimated hours</div><div class="subtle">${completedLocked ? 'Completed vehicle — job-line hours are locked.' : 'Orange estimates require confirmation. Adjust the hours beside each job line, then confirm.'}</div></div>
      <strong>${confirmed}/${lines.length} confirmed · ${total.toFixed(2).replace(/\.00$/, '')}h total</strong>
    </div>
    <div class="pdc-job-line-list">${lines.map(line => {
      const isConfirmed = line.confirmed === true;
      const hours = isConfirmed ? line.confirmedHours : line.estimatedHours;
      const source = cleanNavisionText(line.estimateSource || (line.estimatedHours == null ? 'No safe catalogue match — enter hours for review' : 'ARB catalogue estimate'));
      return `<div class="pdc-job-line ${isConfirmed ? 'is-confirmed' : 'is-provisional'}" data-pdc-job-line="${escapeHtml(line.id)}">
        <div class="pdc-job-line-copy">
          <strong>${line.code ? `<span>${escapeHtml(line.code)}</span> · ` : ''}${escapeHtml(line.description || 'Work item')}</strong>
          <small>Qty ${escapeHtml(String(line.quantity || 1))} · ${escapeHtml(source)}</small>
        </div>
        <label><span>Category</span><select data-pdc-job-line-stage="${escapeHtml(line.id)}" ${completedLocked ? 'disabled' : ''}>${pdcJobLineStageOptionsHtml(pdcJobLineStage(line))}</select></label>
        <label><span>Hours</span><input type="number" min="0.08" max="40" step="0.25" value="${hours == null ? '' : escapeHtml(String(hours))}" placeholder="Enter" data-pdc-job-line-hours="${escapeHtml(line.id)}" ${completedLocked ? 'disabled' : ''} /></label>
        <button class="${isConfirmed ? 'ghost' : 'primary'}" type="button" data-confirm-pdc-job-line="${escapeHtml(line.id)}" ${completedLocked ? 'disabled' : ''}>${isConfirmed ? 'Update confirmed' : 'Confirm hours'}</button>
      </div>`;
    }).join('')}</div>
  </section>`;
}

function confirmPdcJobLineHours(vehicleKeyValue, lineId, rawHours, rawStage = '') {
  const vehicle = selectedVehicle(vehicleKeyValue);
  if (!vehicle) return false;
  if (vehicleCollectedFromRft(vehicle)) {
    pdcNotify('This vehicle is completed/collected. Job-line hours are locked and were not changed.');
    return false;
  }
  const line = vehiclePdcJobLines(vehicle).find(item => item.id === lineId);
  if (!line) return false;
  const hours = validPdcJobLineHours(rawHours);
  if (hours == null) {
    pdcNotify('Enter estimated hours from 0.08 to 40 before confirming this job line.');
    return false;
  }
  const stage = normalizePmbStage(rawStage || pdcJobLineStage(line));
  if (!PDC_JOB_LINE_STAGE_OPTIONS.some(option => option.value === stage)) {
    pdcNotify('Choose a workshop category before confirming this job line.');
    return false;
  }
  const operator = getCurrentOperatorName();
  if (!operator || operator === 'Unknown operator') {
    pdcNotify('Set an operator name before confirming job-line hours. No hours were saved.');
    return false;
  }
  const role = getCurrentOperatorRole();
  const key = vehicleKey(vehicle);
  const previousReviews = vehicle.pdcJobLineReviews;
  const nextReviews = {
    ...(previousReviews || {}),
    [lineId]: {
      confirmed: true,
      confirmedHours: hours,
      confirmedAt: nowIsoString(),
      confirmedBy: operator,
      estimateStatus: 'confirmed',
      category: stage,
    },
  };
  try {
    runStorageTransaction('Confirm job-line hours', [EDITS_KEY, AUDIT_LOG_KEY], () => {
      vehicle.pdcJobLineReviews = nextReviews;
      const edits = loadVehicleEdits();
      edits[key] = { ...(edits[key] || {}), pdcJobLineReviews: nextReviews };
      saveJson(EDITS_KEY, edits);
      recordVehicleAudit(vehicle, line.confirmed === true ? 'Confirmed job-line hours updated' : 'Provisional job-line hours confirmed', {
        job: line.description || line.code || 'Work item',
        code: line.code || '',
        hours,
        previousHours: line.confirmedHours ?? line.estimatedHours ?? '',
        category: stage,
        by: operator,
        role,
      });
    });
  } catch (error) {
    if (previousReviews === undefined) delete vehicle.pdcJobLineReviews;
    else vehicle.pdcJobLineReviews = previousReviews;
    pdcNotify(error.message || String(error));
    return false;
  }
  app.data = buildVehicleData();
  app.selectedStock = key;
  renderAll();
  renderDetail();
  return true;
}

function renderPoTasksSection(vehicle) {
  const tasks = vehicle.poTasks || [];
  const files = vehicle.poFiles || [];
  if (!tasks.length && !files.length) return '';
  return `<section class="po-task-panel">
    <div class="muted-label">Purchase order / workshop tasks</div>
    ${files.length ? `<div class="subtle"><strong>Uploaded PDFs:</strong> ${files.map(escapeHtml).join(', ')}</div>` : ''}
    ${tasks.length ? `<ul class="po-task-list">${tasks.map(task => `<li>${escapeHtml(task)}</li>`).join('')}</ul>` : ''}
  </section>`;
}

function renderPurchaseOrderDetailSection(vehicle) {
  if (!vehicle.purchaseOrderNumber) return '';
  const fields = [
    ['PO number', vehicle.purchaseOrderNumber],
    ['Due date', vehicle.purchaseOrderDueDate],
    ['Issued by', vehicle.purchaseOrderIssuedBy],
    ['Department', vehicle.purchaseOrderDepartment],
    ['Reference', vehicle.purchaseOrderReference],
    ['Deliver to', vehicle.purchaseOrderDeliverTo],
    ['Model code', vehicle.purchaseOrderModelCode],
    ['Colour', [vehicle.purchaseOrderColourCode, vehicle.colour].filter(Boolean).join(' ')],
    ['Trim', [vehicle.purchaseOrderTrimCode, vehicle.trim].filter(Boolean).join(' ')],
    ['Factory option', vehicle.purchaseOrderFactoryOption],
    ['Alternate model', vehicle.purchaseOrderAlternateModel],
    ['Engine', vehicle.purchaseOrderEngine],
    ['Build date', vehicle.purchaseOrderBuildDate],
    ['VIN', vehicle.vin],
    ['Total inc. GST', vehicle.purchaseOrderTotalIncGst ? `$${vehicle.purchaseOrderTotalIncGst}` : ''],
  ].filter(([, value]) => cleanNavisionText(value));
  return `<section class="navision-detail-panel purchase-order-detail-panel">
    <div class="muted-label">Purchase order vehicle details</div>
    <div class="navision-field-grid">
      ${fields.map(([label, value]) => `<div class="navision-field"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></div>`).join('')}
    </div>
  </section>`;
}

function poTasksForEmail(vehicle) {
  const tasks = vehicle.poTasks || [];
  return tasks.length ? tasks.map(task => `- ${task}`).join('\n') : (vehicle.internalStatus || 'Please confirm workshop requirements.');
}

function vehicleEmailLines(vehicle) {
  return [
    `Stock number: ${displayStockNumber(vehicle) || 'TBA'}`,
    `Customer Name: ${vehicleCustomerName(vehicle) || 'TBA'}`,
    `Vehicle: ${displayVehicle(vehicle) || 'TBA'}`,
  ];
}

function handleVehicleAction(stock, action) {
  if (action === 'released') return draftReleasedVehicleEmail(stock);
  if (action === 'update') return draftRequestUpdateEmail(stock);
  if (action === 'build') return draftNewVehicleBuildEmail(stock);
  if (action === 'tint') return draftTintPoEmail(stock);
}

function draftPdcEmail(stock) {
  return draftReleasedVehicleEmail(stock);
}

function draftReleasedVehicleEmail(stock) {
  const v = selectedVehicle(stock);
  if (!v) return;
  const body = vehicleEmailLines(v).join('\n');
  const subject = `Vehicle released - ${displayStockNumber(v) || 'TBA'}`;
  window.location.href = `mailto:${AMY_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function draftRequestUpdateEmail(stock) {
  const v = selectedVehicle(stock);
  if (!v) return;
  const body = vehicleEmailLines(v).join('\n');
  const subject = `Request update - ${displayStockNumber(v) || 'TBA'}`;
  window.location.href = `mailto:${PMG_UPDATE_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function poAttachmentLines(vehicle) {
  const files = vehicle.poFiles || [];
  if (!files.length) return ['Parts Order (131)', 'PMG work order PO'];
  return files.map(file => {
    const lower = String(file).toLowerCase();
    if (lower.includes('131') || lower.includes('parts order')) return `Parts Order (131) - ${file}`;
    if (lower.includes('pmg') || lower.includes('sublet')) return `PMG work order PO - ${file}`;
    return file;
  });
}

function pmgDueDate(vehicle) {
  return scotEtaOnly(vehicle.etaAtDealer) || '';
}

function draftNewVehicleBuildEmail(stock) {
  const v = selectedVehicle(stock);
  if (!v) return;
  const attachments = poAttachmentLines(v);
  const due = pmgDueDate(v);
  const body = [
    'Hi Guys,',
    '',
    'New vehicle order as attached for',
    '',
    `${displayStockNumber(v) || 'TBA'} - ${displayVehicle(v) || 'Vehicle TBA'}`,
    '',
    'For',
    '',
    `${vehicleCustomerName(v) || 'Customer TBA'}`,
    '',
    'Please find attached',
    '',
    ...attachments,
    '',
    'Dealer to supply all parts on 131 Parts PO',
    '',
    'PMG to supply parts listed on the PMG work order and fit all listed items to the vehicle',
    '',
    'Vehicle is having a TWA Steel tray fitted with underbody and head board tyre hangers.',
    '',
    due ? `This vehicle is due to arrive to PMG by ${due}` : 'This vehicle is due to arrive to PMG by',
    '',
    'Just let me know if you have any queries, or if there are any extended delay in parts',
    '',
    'Kind Regards,'
  ].join('\n');
  const subject = `New PMB work order for ${displayStockNumber(v) || 'TBA'}`;
  if ((v.poFiles || []).length) {
    // r409 (F25): deliberately still a blocking alert(): it must be read before
    // the mail app takes focus, because the PO PDFs have to be attached by hand.
    window.alert('Your email draft will open now. Browser email links cannot attach PDF files automatically, so please attach the uploaded PO PDFs listed in the email body.');
  }
  window.location.href = `mailto:${PMG_UPDATE_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}


function draftTintPoEmail(stock) {
  const v = selectedVehicle(stock);
  if (!v) return;
  const body = [
    'Hi Jono,',
    '',
    'Please see tint PO request for the vehicle below.',
    '',
    ...vehicleEmailLines(v),
    '',
    'Kind Regards,'
  ].join('\n');
  const subject = `Tint PO - ${displayStockNumber(v) || 'TBA'}`;
  window.location.href = `mailto:${TINT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function renderKanban() {
  const stages = ['Production / In Transit', 'Yard Hold', 'PMB', 'RFT'];
  const pipelineVehicles = pdcSheetVehicles().filter(vehicle => getStage(vehicle) !== 'Needs Matching');
  const grouped = groupBy(pipelineVehicles, getStage);
  $('#pipeline-count').textContent = `${pipelineVehicles.length} vehicles`;
  $('#kanban').innerHTML = stages.map(stage => {
    const vehicles = (grouped[stage] || []).slice().sort((a, b) => toyotaStatusRank(a.toyotaStatus) - toyotaStatusRank(b.toyotaStatus) || String(displayStockNumber(a)).localeCompare(String(displayStockNumber(b)), 'en-AU', { numeric: true }));
    return `<details class="pipeline-section" open>
      <summary class="pipeline-summary"><strong>${escapeHtml(stage)}</strong><span class="badge neutral">${vehicles.length}</span></summary>
      <div class="pdc-production-grid-scroll pipeline-production-grid">
        ${vehicles.length ? productionGridHeaderHtml('pipeline-production-grid-header', { meta1Label: 'Sales / order', meta2Label: 'Location / ETA', actionLabel: 'Open' }) : ''}
        <div class="pdc-production-grid-body pipeline-list">
          ${vehicles.map(v => `<button class="kanban-card pipeline-card pdc-production-grid-row pdc-production-grid-static-row" type="button" data-stock="${escapeHtml(vehicleKey(v))}">
            <span class="pdc-grid-control" aria-hidden="true">›</span><span class="pdc-grid-select-spacer" aria-hidden="true"></span>
            <span class="incoming-card-stock">${vehicleIdentityStackHtml(v)}</span>
            <span class="incoming-card-main"><strong>${escapeHtml(displayVehicle(v) || 'Vehicle not listed')}</strong></span>
            <span class="incoming-card-work-wrap">${incomingWorkChecklistHtml(v)}</span>
            <span class="incoming-card-meta"><b>Sales</b><span>${escapeHtml(salesPersonInitials(consultantName(v)) || '—')}</span></span>
            <span class="incoming-card-meta"><b>Location</b><span>${escapeHtml(pdcLocationLabel(v.pdcLocation) || v.toyotaStatus || 'Not matched')}</span><small>${scotEtaOnly(v.etaAtDealer) ? `ETA ${escapeHtml(scotEtaOnly(v.etaAtDealer))}` : ''}</small></span>
            <span class="incoming-card-action"><span class="small-button">Open</span></span>
          </button>`).join('') || '<div class="subtle pdc-grid-empty-row">No vehicles in this stage.</div>'}
        </div>
      </div>
    </details>`;
  }).join('');
  $$('.kanban-card').forEach(card => card.addEventListener('click', () => { void openVehicleFromStockClick(card.dataset.stock, card); }));
}

function scheduleDateForVehicle(vehicle = {}) {
  return parseDateAU(kewdaleEtaValue(vehicle) || scotEtaOnly(vehicle.etaAtDealer || '') || vehicle.deliveryDate || '');
}

function scheduleBucketForVehicle(vehicle = {}) {
  const date = scheduleDateForVehicle(vehicle);
  if (!date) return { key: 'unknown', label: 'No ETA set', rank: 4 };
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.floor((start - today) / (1000 * 60 * 60 * 24));
  if (days < 0) return { key: 'overdue', label: 'Overdue / already at Kewdale', rank: 0 };
  if (days === 0) return { key: 'today', label: 'Due today', rank: 1 };
  if (days <= 7) return { key: 'week', label: 'Next 7 days', rank: 2 };
  return { key: 'later', label: 'Later', rank: 3 };
}

function productionFlowSource(vehicle = {}) {
  return [pdcJobSourceText(vehicle), vehicle.navisionNotes, vehicle.internalStatus, vehicle.toyotaStatus, displayVehicle(vehicle), (vehicle.poTasks || []).join(' ')].join(' ').toLowerCase();
}

function productionDepartmentRequired(vehicle = {}, def = {}) {
  const job = PDC_JOB_BY_KEY.get(def.jobKey);
  const stage = inferredPmbStage(vehicle);
  const source = productionFlowSource(vehicle);
  if (stage && stage === def.stage) return true;
  if (def.search?.test(source)) return true;
  return Boolean(job && pdcJobRequired(vehicle, job) && def.key === 'FITTING');
}

function productionDepartmentComplete(vehicle = {}, def = {}) {
  const job = PDC_JOB_BY_KEY.get(def.jobKey);
  return Boolean(job && pdcJobComplete(vehicle, job));
}

function productionDepartmentsForVehicle(vehicle = {}) {
  return PRODUCTION_FLOW_DEFS
    .map(def => ({ ...def, required: productionDepartmentRequired(vehicle, def), complete: productionDepartmentComplete(vehicle, def) }))
    .filter(def => def.required);
}

function readinessChecklistForVehicle(vehicle = {}) {
  const parts = partsJobDef();
  const fabrication = PDC_JOB_BY_KEY.get('fabrication');
  const items = [];
  if (parts && pdcJobRequired(vehicle, parts)) {
    const status = partsDepartmentStatus(vehicle);
    items.push({ label: `Parts: ${partsDepartmentStatusLabel(status)}`, state: ['issued', 'notrequired'].includes(status) ? 'ready' : (status === 'stoppage' || status === 'notordered' ? 'blocked' : 'watch') });
  }
  if (fabrication && pdcJobRequired(vehicle, fabrication)) {
    items.push({ label: `Fabrication: ${pdcJobComplete(vehicle, fabrication) ? 'signed off' : 'required'}`, state: pdcJobComplete(vehicle, fabrication) ? 'ready' : 'watch' });
  }
  if (isPdcBlocked(vehicle)) items.push({ label: pdcBlockReason(vehicle), state: 'blocked' });
  const issues = vehicleRftGateIssues(vehicle).filter(issue => !issue.startsWith('No PMB bucket'));
  if (issues.length && !items.some(item => item.state === 'blocked')) items.push({ label: `${issues.length} RFT gate issue${issues.length === 1 ? '' : 's'}`, state: 'watch' });
  return items;
}

function scheduleRows() {
  const q = ($('#schedule-search')?.value || '').trim().toLowerCase();
  const department = $('#schedule-department-filter')?.value || '';
  return pdcSheetVehicles()
    .filter(vehicleHasBatchNumber)
    .map(vehicle => ({ vehicle, departments: productionDepartmentsForVehicle(vehicle), bucket: scheduleBucketForVehicle(vehicle), readiness: readinessChecklistForVehicle(vehicle) }))
    .filter(row => row.departments.length || statusCategory(row.vehicle) === 'pmb')
    .filter(row => !department || row.departments.some(def => def.key === department))
    .filter(row => {
      if (!q) return true;
      const hay = [
        displayStockNumber(row.vehicle), row.vehicle.client, row.vehicle.toyotaCustomer,
        displayVehicle(row.vehicle), pmbStageLabel(inferredPmbStage(row.vehicle)), statusCategoryLabel(row.vehicle),
        row.departments.map(def => def.label).join(' '), row.readiness.map(item => item.label).join(' '),
        kewdaleEtaValue(row.vehicle), pmbAgeLabel(row.vehicle), pdcBlockReason(row.vehicle)
      ].join(' ').toLowerCase();
      return hay.includes(q);
    })
    .sort((a, b) => a.bucket.rank - b.bucket.rank
      || (scheduleDateForVehicle(a.vehicle)?.getTime() ?? Number.MAX_SAFE_INTEGER) - (scheduleDateForVehicle(b.vehicle)?.getTime() ?? Number.MAX_SAFE_INTEGER)
      || String(displayStockNumber(a.vehicle) || '').localeCompare(String(displayStockNumber(b.vehicle) || ''), 'en-AU', { numeric: true }));
}

function scheduleDepartmentPillsHtml(departments = []) {
  if (!departments.length) return '<span class="schedule-dept-pill neutral">Unallocated</span>';
  return departments.map(def => `<span class="schedule-dept-pill ${def.complete ? 'is-complete' : 'is-open'}">${escapeHtml(def.label)}${def.complete ? ' ✓' : ''}</span>`).join('');
}

function scheduleReadinessHtml(items = []) {
  if (!items.length) return '<span class="schedule-ready-pill ready">Ready prompts clear</span>';
  return items.map(item => `<span class="schedule-ready-pill ${escapeHtml(item.state)}">${escapeHtml(item.label)}</span>`).join('');
}

function renderScheduleBoard() {
  const host = $('#schedule-content');
  if (!host) return;
  const rows = scheduleRows();
  const count = $('#schedule-count');
  if (count) count.textContent = `${rows.length} vehicle${rows.length === 1 ? '' : 's'} · earliest Kewdale ETA first`;
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No production / in transit vehicles match this filter</strong><span>Clear search or choose another department.</span></div>';
    return;
  }
  host.innerHTML = `<section class="schedule-list-panel pdc-grid-page-section">
    <div class="schedule-list-header"><strong>Production / In Transit</strong><span>Sorted by earliest ETA At Kewdale Yard first</span></div>
    <div class="pdc-production-grid-scroll">
      ${productionGridHeaderHtml('schedule-production-grid-header', { meta1Label: 'ETA Kewdale', meta2Label: 'Current stage', actionLabel: 'Readiness' })}
      <div class="pdc-production-grid-body" role="list">
        ${rows.map(({ vehicle, departments, readiness }, index) => {
          const stage = `${statusCategoryLabel(vehicle)}${inferredPmbStage(vehicle) ? ` · ${pmbStageLabel(inferredPmbStage(vehicle))}` : ''}`;
          const readinessTitle = readiness.length ? readiness.map(item => item.label).join(' · ') : 'Ready prompts clear';
          return `<button class="pdc-production-grid-row pdc-production-grid-static-row schedule-production-row" type="button" role="listitem" data-stock="${escapeHtml(vehicleKey(vehicle))}" title="${escapeHtml(readinessTitle)}">
            <span class="pdc-grid-control pdc-grid-rank">${escapeHtml(String(index + 1).padStart(2, '0'))}</span>
            <span class="pdc-grid-select-spacer" aria-hidden="true"></span>
            <span class="incoming-card-stock">${vehicleIdentityStackHtml(vehicle)}</span>
            <span class="incoming-card-main"><strong>${escapeHtml(displayVehicle(vehicle) || 'Vehicle not listed')}</strong></span>
            <span class="incoming-card-work-wrap">${incomingWorkChecklistHtml(vehicle)}</span>
            <span class="incoming-card-meta"><b>ETA</b><span>${escapeHtml(kewdaleEtaValue(vehicle) || 'No ETA')}</span><small>${escapeHtml(pmbAgeLabel(vehicle))}</small></span>
            <span class="incoming-card-meta"><b>Stage</b><span>${escapeHtml(stage)}</span></span>
            <span class="incoming-card-action schedule-grid-readiness">${scheduleReadinessHtml(readiness)}</span>
          </button>`;
        }).join('')}
      </div>
    </div>
  </section>`;
  $$('[data-stock]', host).forEach(card => card.addEventListener('click', () => { void openVehicleFromStockClick(card.dataset.stock, card); }));
}

function activeProductionDepartmentDef() {
  const stage = app.activeProductionDepartment || 'TINT';
  return PRODUCTION_FLOW_DEFS.find(def => def.key === stage) || PRODUCTION_FLOW_DEFS[0];
}

function departmentVehicleStatus(vehicle = {}, def = {}) {
  const complete = productionDepartmentComplete(vehicle, def);
  if (isPdcBlocked(vehicle)) return 'blocked';
  return complete ? 'complete' : 'open';
}

function productionDepartmentRows(def = activeProductionDepartmentDef()) {
  const q = ($('#department-search')?.value || '').trim().toLowerCase();
  const filter = $('#department-status-filter')?.value || 'open';
  return app.data
    .filter(vehicleHasBatchNumber)
    .filter(vehicle => productionDepartmentRequired(vehicle, def) || inferredPmbStage(vehicle) === def.stage)
    .filter(vehicle => {
      const status = departmentVehicleStatus(vehicle, def);
      if (filter === 'open' && status !== 'open') return false;
      if (filter === 'blocked' && status !== 'blocked') return false;
      if (filter === 'complete' && status !== 'complete') return false;
      if (!q) return true;
      const hay = [
        displayStockNumber(vehicle), vehicle.client, vehicle.toyotaCustomer, displayVehicle(vehicle),
        statusCategoryLabel(vehicle), pmbStageLabel(inferredPmbStage(vehicle)), kewdaleEtaValue(vehicle),
        pmbAgeLabel(vehicle), pdcBlockReason(vehicle), readinessChecklistForVehicle(vehicle).map(item => item.label).join(' ')
      ].join(' ').toLowerCase();
      return hay.includes(q);
    })
    .sort((a, b) => {
      const rank = { blocked: 0, open: 1, complete: 2 };
      const rankDiff = (rank[departmentVehicleStatus(a, def)] ?? 9) - (rank[departmentVehicleStatus(b, def)] ?? 9);
      if (rankDiff) return rankDiff;
      const etaDiff = (scheduleDateForVehicle(a)?.getTime() ?? Number.MAX_SAFE_INTEGER) - (scheduleDateForVehicle(b)?.getTime() ?? Number.MAX_SAFE_INTEGER);
      if (etaDiff) return etaDiff;
      return String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''), 'en-AU', { numeric: true });
    });
}

function departmentStatusBadgeHtml(vehicle = {}, def = {}) {
  const status = departmentVehicleStatus(vehicle, def);
  if (status === 'blocked') return `<span class="department-status-badge blocked">STOPPAGE · ${escapeHtml(pdcBlockReason(vehicle))}</span>`;
  if (status === 'complete') return '<span class="department-status-badge complete">Complete ✓</span>';
  return '<span class="department-status-badge open">Open work</span>';
}

function renderProductionDepartmentBoard() {
  const host = $('#department-content');
  if (!host) return;
  const def = activeProductionDepartmentDef();
  const rows = productionDepartmentRows(def);
  const heading = $('#department-heading');
  const description = $('#department-description');
  const count = $('#department-count');
  const help = $('#department-help-strip');
  const capacity = pmbStageCapacityLabel(def.stage);
  if (heading) heading.textContent = def.label;
  if (description) description.textContent = `${def.label} focused work list. Use the row actions to sign off work, record STOPPAGES, or open the vehicle details.`;
  if (count) count.textContent = `${rows.length} vehicle${rows.length === 1 ? '' : 's'} · ${capacity}`;
  if (help) help.innerHTML = `<strong>${escapeHtml(def.label)}</strong><span>Capacity: ${escapeHtml(capacity)}</span><span>Sort: STOPPAGES first, then earliest Kewdale ETA.</span>`;
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No vehicles match this department filter</strong><span>Clear search or change the status filter.</span></div>';
    return;
  }
  host.innerHTML = `<div class="pdc-production-grid-scroll department-production-grid">
    ${productionGridHeaderHtml('department-production-grid-header', { meta1Label: 'Station status', meta2Label: 'ETA / age', actionLabel: 'Actions' })}
    <div class="pdc-production-grid-body" role="list">
      ${rows.map(vehicle => {
        const key = vehicleKey(vehicle);
        const complete = productionDepartmentComplete(vehicle, def);
        return `<article class="pdc-production-grid-row pdc-production-grid-static-row department-job-card ${departmentVehicleStatus(vehicle, def)}" role="listitem">
          <span class="pdc-grid-control" aria-hidden="true">›</span>
          <span class="pdc-grid-select-spacer" aria-hidden="true"></span>
          <span class="incoming-card-stock">${vehicleIdentityStackHtml(vehicle)}</span>
          <span class="incoming-card-main"><strong>${escapeHtml(displayVehicle(vehicle) || 'Vehicle not listed')}</strong></span>
          <span class="incoming-card-work-wrap">${incomingWorkChecklistHtml(vehicle)}</span>
          <span class="incoming-card-meta department-grid-status"><b>${escapeHtml(def.label)}</b>${departmentStatusBadgeHtml(vehicle, def)}<small>Current: ${escapeHtml(pmbStageLabel(inferredPmbStage(vehicle)) || statusCategoryLabel(vehicle))}</small></span>
          <span class="incoming-card-meta"><b>ETA</b><span>${escapeHtml(kewdaleEtaValue(vehicle) || 'No ETA')}</span><small>${escapeHtml(pmbAgeLabel(vehicle))}</small></span>
          <span class="incoming-card-action department-actions">
            ${complete ? `<button type="button" class="small-button" data-dept-next="${escapeHtml(key)}" data-dept-stage="${escapeHtml(def.stage)}">Next bay</button>` : `<button type="button" class="primary" data-dept-complete="${escapeHtml(key)}" data-dept-stage="${escapeHtml(def.stage)}">Complete</button>`}
            <button type="button" class="small-button" data-dept-stoppage="${escapeHtml(key)}" data-dept-stage="${escapeHtml(def.stage)}">STOPPAGE</button>
            ${isPdcBlocked(vehicle) ? `<button type="button" class="small-button" data-dept-clear-stoppage="${escapeHtml(key)}">Clear</button>` : ''}
            <button type="button" class="small-button" data-dept-open="${escapeHtml(key)}">Open</button>
          </span>
        </article>`;
      }).join('')}
    </div>
  </div>`;
  $$('[data-dept-complete]', host).forEach(button => button.addEventListener('click', () => completePmbBayWork(button.dataset.deptComplete, button.dataset.deptStage)));
  $$('[data-dept-next]', host).forEach(button => button.addEventListener('click', () => moveVehicleToNextPmbStageFromBay(button.dataset.deptNext, button.dataset.deptStage)));
  $$('[data-dept-stoppage]', host).forEach(button => button.addEventListener('click', () => markProductionDepartmentStoppage(button.dataset.deptStoppage, button.dataset.deptStage)));
  $$('[data-dept-clear-stoppage]', host).forEach(button => button.addEventListener('click', () => clearProductionDepartmentStoppage(button.dataset.deptClearStoppage)));
  $$('[data-dept-open]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.deptOpen, button); }));
}

function markProductionDepartmentStoppage(key = '', stage = '') {
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const normalizedStage = normalizePmbStage(stage || inferredPmbStage(vehicle));
  if (!normalizedStage) return;
  const reason = cleanNavisionText(window.prompt(`Enter ${pmbStageLabel(normalizedStage)} STOPPAGE reason:`, isPdcBlocked(vehicle) ? pdcBlockReason(vehicle) : '') || '');
  if (!reason) return;
  const def = pmbStageJobDef(normalizedStage);
  const operator = getCurrentOperatorName();
  const updates = {
    pdcBlocked: true,
    pdcBlockReason: `${pmbStageLabel(normalizedStage)}: ${reason}`,
    pdcBlockedAt: nowIsoString(),
    pdcBlockedBy: operator,
    pmbStage: normalizedStage,
    pmbStageUpdatedAt: nowIsoString(),
  };
  if (def) {
    updates[def.requireKey] = true;
    updates[def.completeKey] = false;
  }
  recordVehicleAudit(vehicle, 'Production STOPPAGE recorded', { stage: pmbStageLabel(normalizedStage), reason, by: operator });
  saveVehicleEdits(key, updates);
  offerSalespersonChangeEmail(vehicle, {
    title: `${pmbStageLabel(normalizedStage)} STOPPAGE recorded`,
    subject: 'PDC STOPPAGE update',
    details: [`Reason: ${reason}`, `Recorded by ${operator}.`],
  });
}

function clearProductionDepartmentStoppage(key = '') {
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const operator = getCurrentOperatorName();
  recordVehicleAudit(vehicle, 'Production STOPPAGE cleared', { reason: pdcBlockReason(vehicle), by: operator });
  saveVehicleEdits(key, {
    pdcBlocked: false,
    pdcBlockReason: '',
    pdcBlockedClearedAt: nowIsoString(),
    pdcBlockedClearedBy: operator,
  });
}

function partsJobDef() {
  return PDC_JOB_BY_KEY.get('parts');
}

function partsStateComplete(vehicle = {}) {
  const def = partsJobDef();
  return Boolean(
    pdcJobComplete(vehicle, def)
      || vehicle.pdcPartsReceived === true
      || vehicle.parts_received === true
      || vehicle.parts_completed === true
      || vehicle.pdcCompleteParts === true
  );
}

function partsStoppageReason(vehicle = {}) {
  return cleanNavisionText(vehicle.pdcPartsStoppageReason || '') || 'Parts STOPPAGE recorded';
}

function partsWorstEtaValue(vehicle = {}) {
  if (typeof partsStateComplete === 'function' && partsStateComplete(vehicle)) return '';
  return cleanNavisionText(vehicle.pdcPartsWorstEta || vehicle.partsWorstEta || '');
}

function partsWorstEtaDate(vehicle = {}) {
  const value = partsWorstEtaValue(vehicle);
  if (!value) return null;
  const isoDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoDate) return new Date(Number(isoDate[1]), Number(isoDate[2]) - 1, Number(isoDate[3]));
  return parseDateAU(value) || parseIsoTimestamp(value);
}

function partsHasValidAuthoritativeEta(vehicle = {}) {
  if (vehicle.__emailVehicleServerAuthoritative !== true) return false;
  const value = partsWorstEtaValue(vehicle);
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return false;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.getFullYear() === Number(match[1]) && date.getMonth() === Number(match[2]) - 1 && date.getDate() === Number(match[3]);
}

function partsWorstEtaInputValue(vehicle = {}) {
  const value = partsWorstEtaValue(vehicle);
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = partsWorstEtaDate(vehicle);
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function partsWorstEtaLabel(vehicle = {}) {
  const value = partsWorstEtaValue(vehicle);
  if (!value) return '';
  const date = partsWorstEtaDate(vehicle);
  if (date) return date.toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  return value;
}

function partsWorstEtaDaysUntil(vehicle = {}) {
  const date = partsWorstEtaDate(vehicle);
  if (!date) return null;
  const target = new Date(date);
  target.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
}

function partsWorstEtaCountdownLabel(vehicle = {}) {
  const days = partsWorstEtaDaysUntil(vehicle);
  if (days === null) return '';
  if (days < 0) return `-${Math.abs(days)} Day${Math.abs(days) === 1 ? '' : 's'} Overdue`;
  if (days === 0) return '0 Days';
  return `+${days} Day${days === 1 ? '' : 's'}`;
}

function partsWorstEtaCountdownClass(vehicle = {}) {
  const days = partsWorstEtaDaysUntil(vehicle);
  if (days === null) return 'unset';
  if (days < 0) return 'negative';
  if (days > 0) return 'positive';
  return 'today';
}

function refreshPartsEtaCounters(sourceRows = null) {
  const rows = Array.isArray(sourceRows) ? sourceRows : partsDepartmentSourceRows();
  const rowsByKey = new Map();
  rows.forEach(vehicle => {
    const key = String(vehicleKey(vehicle) || '').trim();
    if (!key) return;
    rowsByKey.set(key, rowsByKey.has(key) ? null : vehicle);
  });
  $$('[data-parts-eta-counter]').forEach(node => {
    const vehicle = rowsByKey.get(String(node.dataset.partsEtaCounter || '').trim()) || null;
    if (!vehicle) return;
    node.className = `parts-eta-countdown ${partsWorstEtaCountdownClass(vehicle)}`;
    node.textContent = partsWorstEtaCountdownLabel(vehicle) || '—';
  });
}

function setupPartsEtaCounterClock(sourceRows = null) {
  refreshPartsEtaCounters(sourceRows);
  if (app.partsEtaCounterTimer || typeof window.setInterval !== 'function') return;
  app.partsEtaCounterTimer = window.setInterval(refreshPartsEtaCounters, 60000);
}

function partsWorstEtaSortValue(vehicle = {}) {
  const date = partsWorstEtaDate(vehicle);
  return date ? date.getTime() : -8640000000000000;
}

function partsScheduledWorkshopBookings(vehicle = {}) {
  const canonicalId = typeof vehicleWorkshopDetailCanonicalId === 'function' ? vehicleWorkshopDetailCanonicalId(vehicle) : '';
  const cached = canonicalId ? app.vehicleWorkshopDetailCache?.get(canonicalId)?.detail : null;
  return [
    ...(Array.isArray(vehicle.workshopBookings) ? vehicle.workshopBookings : []),
    ...(Array.isArray(vehicle.pdcWorkshopBookings) ? vehicle.pdcWorkshopBookings : []),
    ...(Array.isArray(cached?.bookings) ? cached.bookings : []),
  ];
}

function partsEtaRisk(vehicle = {}) {
  if (partsStateComplete(vehicle)) return false;
  const guard = window.VehicleRequirementsGuard;
  if (!guard?.partsRiskState) return false;
  return guard.partsRiskState({
    partsEta: partsWorstEtaValue(vehicle),
    partsComplete: partsStateComplete(vehicle),
    partsStoppage: isActivePartsStoppage(vehicle),
    vehicle,
    bookings: partsScheduledWorkshopBookings(vehicle),
  }).risk;
}

function partsRiskBadge(vehicle = {}) {
  return partsEtaRisk(vehicle) ? `<span class="badge parts-risk-badge" title="Parts ETA is later than the scheduled workshop booking date">PARTS RISK</span>` : '';
}

function isActivePartsStoppage(vehicle = {}) {
  if (partsStateComplete(vehicle)) return false;
  const parts = PDC_JOB_BY_KEY.get('parts');
  const hasStoppage = vehicle.pdcPartsStoppage === true || Boolean(cleanNavisionText(vehicle.pdcPartsStoppageReason || ''));
  return Boolean(hasStoppage && parts && pdcJobRequired(vehicle, parts));
}

function partsOrdered(vehicle = {}) {
  const projection = vehicle.parts_update || vehicle.partsUpdate || vehicle.__emailPartsUpdate || null;
  return projection?.parts_ordered === true
    || vehicle.pdcPartsOrdered === true
    || Boolean(cleanNavisionText(vehicle.pdcPartsOrderedAt || vehicle.partsOrderedAt || ''));
}

function partsMiscAcc(vehicle = {}) {
  const value = String(vehicle.pdcPartsMiscAcc || vehicle.partsMiscAcc || vehicle.navisionPartsStatus || vehicle.partsStatus || '').trim().toLowerCase();
  return vehicle.pdcPartsMiscAcc === true || value === 'misc acc' || value === 'miscacc' || value.includes('misc acc');
}

function importedPartsStatus(vehicle = {}) {
  const p = vehicle.pdcPartsFlags || vehicle.parts_flags;
  return p && ['orange', 'red', 'green', 'grey', 'review'].includes(p.colour) ? p : null;
}

function importedPartsTitle(vehicle = {}) {
  const p = importedPartsStatus(vehicle);
  if (!p) return '';
  const when = p.last_successful_import_at ? new Date(p.last_successful_import_at).toLocaleString('en-AU', {timeZone: 'Australia/Perth'}) : 'Not recorded';
  return `${p.label}. Last successful import: ${when} (Perth). ${p.meaning || ''}`;
}

function partsDepartmentStatus(vehicle = {}) {
  const imported = typeof importedPartsStatus === 'function' ? importedPartsStatus(vehicle) : null;
  if (typeof isActivePartsStoppage === 'function' && isActivePartsStoppage(vehicle)) return 'stoppage';
  if (imported) return 'import:' + imported.label;
  const def = partsJobDef();
  const projected = canonicalVehicleWorkState(vehicle, def);
  if (projected.state === 'none') return 'notrequired';
  if (projected.state === 'stoppage') return 'stoppage';
  if (partsMiscAcc(vehicle)) return 'miscacc';
  if (projected.state === 'completed' || vehicle.pdcPartsReceived === true) return 'issued';
  if (projected.state === 'booked') return 'onorder';
  return 'notordered';
}

function partsDepartmentStatusLabel(status = '') {
  if (status.startsWith('import:')) return status.slice(7);
  return {
    notrequired: 'Not Required',
    notordered: 'Not Ordered',
    onorder: 'On Order',
    stoppage: 'Parts STOPPAGE',
    issued: 'Issued',
    miscacc: 'Misc Acc',
  }[status] || 'Not Ordered';
}

function partsDepartmentStatusClass(status = '') {
  if (status.startsWith('import:')) {
    const label = status.slice(7);
    if (label === 'Parts attached — no recorded backorders') return 'parts-status-complete';
    if (label === 'Parts on order — outstanding' || label === 'Parts attached; outstanding parts — check PO') return 'parts-status-ordered';
    if (label === 'Outstanding parts — PO not confirmed') return 'parts-status-toorder';
    return 'parts-status-unknown';
  }
  return {
    notrequired: 'parts-status-complete',
    notordered: 'parts-status-toorder',
    onorder: 'parts-status-ordered',
    stoppage: 'parts-status-stoppage',
    issued: 'parts-status-complete',
    miscacc: 'parts-status-stoppage',
  }[status] || 'parts-status-toorder';
}

function partsLastUpdateLabel(vehicle = {}) {
  const imported = typeof importedPartsStatus === 'function' ? importedPartsStatus(vehicle) : null;
  if (imported?.last_successful_import_at) return 'Imported ' + new Date(imported.last_successful_import_at).toLocaleString('en-AU', { timeZone: 'Australia/Perth' });
  const candidates = [
    vehicle.pdcCompletePartsAt,
    vehicle.pdcPartsStoppageAt,
    vehicle.pdcPartsOrderedAt,
    vehicle.pdcLocationUpdatedAt,
  ].map(parseIsoTimestamp).filter(Boolean).sort((a, b) => b - a);
  if (!candidates.length) return '';
  return candidates[0].toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' });
}

function partsCurrentLocationLabel(vehicle = {}) {
  if (vehicleCollectedFromRft(vehicle)) return 'Completed';
  const category = statusCategory(vehicle);
  const location = vehiclePdcLocation(vehicle);
  if (location === 'PMB' || category === 'pmb') {
    const stage = normalizePmbStage(vehicle.pmbBayStage || inferredPmbStage(vehicle));
    if (!stage) return 'PMB · Unallocated';
    if (stage === 'SUBLET') {
      const provider = pmbBaySubletProvider(vehicle);
      return provider ? `Sublet · ${provider}` : 'Sublet';
    }
    const bay = pmbBayNumber(vehicle, stage);
    return `${pmbStageLabel(stage)} · ${bay ? pdcBayText(stage, bay, true) : 'No bay'}`;
  }
  if (location === 'YH') return 'Yard Hold';
  if (location === 'RFT') return 'RFT';
  if (location) return pdcLocationLabel(location);
  return {
    yardhold: 'Yard Hold',
    rft: 'RFT',
    transit: 'In Transit',
    overseas: 'Overseas / Other',
    completed: 'Completed',
  }[category] || statusCategoryLabel(vehicle) || 'Current location unknown';
}

function partsCurrentLocationUpdateLabel(vehicle = {}) {
  const category = statusCategory(vehicle);
  const location = vehiclePdcLocation(vehicle);
  let values = [];
  if (vehicleCollectedFromRft(vehicle)) {
    values = [vehicle.rftCollectedAt, vehicle.rftTransferredAt, vehicle.pdcLocationUpdatedAt];
  } else if (location === 'PMB' || category === 'pmb') {
    values = [
      vehicle.pmbBayEnteredAt,
      vehicle.pmbStageUpdatedAt,
      vehicle.pmbStageEnteredAt,
      vehicle.pmbEnteredAt,
      vehicle.pmbTransferredAt,
      vehicle.pdcLocationUpdatedAt,
    ];
  } else if (location === 'RFT' || category === 'rft') {
    values = [vehicle.rftTransferredAt, vehicle.pdcLocationUpdatedAt];
  } else {
    values = [vehicle.pdcLocationUpdatedAt];
  }
  const latest = values.map(parseIsoTimestamp).filter(Boolean).sort((a, b) => b - a)[0];
  return latest ? latest.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : '';
}

function partsOutstandingStationWork(vehicle = {}) {
  return pdcRequiredJobs(vehicle)
    .filter(def => def.key !== 'parts' && !pdcJobComplete(vehicle, def))
    .map(def => pdcGridJobLabel(def));
}

function partsMatchesOperationalFilter(vehicle = {}, filter = 'notordered') {
  const status = partsDepartmentStatus(vehicle);
  if (filter === 'ordered') return status === 'onorder';
  if (filter === 'overdue') return !['issued', 'notrequired'].includes(status) && partsWorstEtaDaysUntil(vehicle) < 0;
  if (filter === 'stoppage') return status === 'stoppage';
  return ['notordered', 'miscacc'].includes(status);
}

function partsQueueVisibleVehicle(vehicle = {}) {
  if (vehicle.tuneCheckout?.confirmed === true) return false;
  // An active STOPPAGE remains actionable even when the prior Parts delivery
  // was marked complete; the canonical completion mutation clears this state.
  return !partsStateComplete(vehicle) || partsDepartmentStatus(vehicle) === 'stoppage';
}

function partsDepartmentSourceRows() {
  // Shared authenticated vehicle/work-item authority must feed Parts. The
  // browser-backed local layer is intentionally empty on zero-data staging.
  return vehicleLocationsScreenRows().filter(partsQueueVisibleVehicle);
}

function partsDepartmentRows(sourceRows = partsDepartmentSourceRows()) {
  const q = ($('#parts-search')?.value || '').trim().toLowerCase();
  const operationalFilter = app.partsOperationalFilter || 'notordered';
  const departmentFilter = $('#parts-department-filter')?.value || '';
  return sourceRows
    .filter(vehicleHasBatchNumber)
    .filter(partsQueueVisibleVehicle)
    .filter(vehicle => partsMatchesOperationalFilter(vehicle, operationalFilter))
    .filter(vehicle => !departmentFilter || (window.PDC_DEPARTMENT_FILTER?.departmentCodes
      ? window.PDC_DEPARTMENT_FILTER.departmentCodes(vehicle).includes(departmentFilter)
      : vehicleDepartmentCode(vehicle) === departmentFilter))
    .filter(vehicle => {
      if (!q) return true;
      const hay = [displayStockNumber(vehicle), vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle),
        vehicleCustomerName(vehicle), displayVehicle(vehicle), partsDepartmentStatusLabel(partsDepartmentStatus(vehicle)),
        partsStoppageReason(vehicle), ...partsOutstandingStationWork(vehicle)].join(' ').toLowerCase();
      return hay.includes(q);
    })
    .sort((a, b) => {
      const rank = { stoppage: 0, notordered: 1, onorder: 2, issued: 3, notrequired: 4 };
      return (rank[partsDepartmentStatus(a)] ?? 9) - (rank[partsDepartmentStatus(b)] ?? 9)
        || String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''), undefined, { numeric: true });
    });
}
function renderPartsSummary(sourceRows = partsDepartmentSourceRows()) {
  const all = sourceRows.filter(vehicleHasBatchNumber).filter(partsQueueVisibleVehicle);
  const filters = [
    ['notordered', 'Parts Not Ordered'],
    ['ordered', 'Parts Ordered'],
    ['overdue', 'Parts Overdue'],
    ['stoppage', 'Parts STOPPAGE'],
  ];
  const active = app.partsOperationalFilter || 'notordered';
  const host = $('#parts-summary-grid');
  if (!host) return;
  host.innerHTML = filters.map(([key, label]) => {
    const count = all.filter(vehicle => partsMatchesOperationalFilter(vehicle, key)).length;
    return `<button class="parts-filter-chip ${key === active ? 'is-active' : ''}" type="button" data-parts-operational-filter="${key}" aria-pressed="${key === active}"><span>${escapeHtml(label)}</span><strong>${count}</strong></button>`;
  }).join('');
  $$('[data-parts-operational-filter]', host).forEach(button => button.addEventListener('click', () => {
    app.partsOperationalFilter = button.dataset.partsOperationalFilter || 'notordered';
    renderPartsHome();
  }));
}
function partsQueueActionsHtml(vehicle = {}, status = partsDepartmentStatus(vehicle)) {
  const key = vehicleKey(vehicle);
  const received = ['issued', 'notrequired'].includes(status);
  const stopped = status === 'stoppage';
  const canMarkOrdered = partsHasValidAuthoritativeEta(vehicle);
  const markOrderedHint = canMarkOrdered ? 'Mark Parts ordered' : 'Set Parts ETA before marking ordered';
  return `<div class="parts-action-group parts-visible-actions">
    ${status === 'notordered' ? `<button class="small-button parts-ordered-button" type="button" data-parts-ordered="${escapeHtml(key)}" title="${escapeHtml(markOrderedHint)}" aria-label="${escapeHtml(markOrderedHint)}"${canMarkOrdered ? '' : ' disabled aria-disabled="true"'}>Mark ordered</button>` : ''}
    ${received ? '' : `<button class="small-button parts-received-button" type="button" data-parts-complete="${escapeHtml(key)}">Mark received</button>`}
    ${stopped
      ? `<button class="small-button" type="button" data-parts-clear-stoppage="${escapeHtml(key)}">Remove Parts STOPPAGE</button>`
      : `<button class="small-button danger-button" type="button" data-parts-stoppage="${escapeHtml(key)}">Parts STOPPAGE</button>`}
    <button class="small-button" type="button" data-open-stock="${escapeHtml(key)}">Open vehicle</button>
  </div>`;
}

function bindPartsQueueActionButtons(host) {
  if (!host) return;
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
  $$('[data-parts-ordered]', host).forEach(button => button.addEventListener('click', () => markVehiclePartsOrdered(button.dataset.partsOrdered)));
  $$('[data-parts-complete]', host).forEach(button => button.addEventListener('click', () => markVehiclePartsComplete(button.dataset.partsComplete)));
  $$('[data-parts-stoppage]', host).forEach(button => button.addEventListener('click', () => markVehiclePartsStoppage(button.dataset.partsStoppage)));
  $$('[data-parts-clear-stoppage]', host).forEach(button => button.addEventListener('click', () => clearVehiclePartsStoppage(button.dataset.partsClearStoppage)));
  $$('[data-parts-eta-email]', host).forEach(button => button.addEventListener('click', () => draftPartsEtaSalesEmail(button.dataset.partsEtaEmail)));
}

function partsQueueRowHtml(vehicle = {}) {
  const key = vehicleKey(vehicle);
  const status = partsDepartmentStatus(vehicle);
  const customer = vehicleCustomerName(vehicle) || 'Dealer Order';
  const unit = displayVehicle(vehicle) || 'Vehicle not listed';
  const blocker = status === 'stoppage' ? partsStoppageReason(vehicle) : '';
  const importedEvidence = status === 'stoppage' ? importedPartsStatus(vehicle) : null;

  const jitaNumber = vehicleNavisionJitaNumber(vehicle);
  const etaValue = partsWorstEtaInputValue(vehicle);
  const etaCountdown = partsWorstEtaCountdownLabel(vehicle);
  const etaCountdownClass = partsWorstEtaCountdownClass(vehicle);
  return `<tr class="parts-row parts-queue-row ${escapeHtml(partsDepartmentStatusClass(status))}">
    <td><strong>${escapeHtml(vehicleKeyNumber(vehicle) || '—')}</strong></td>
    <td><button class="parts-compact-identity" type="button" data-open-stock="${escapeHtml(key)}"><strong>${escapeHtml(displayStockNumber(vehicle) || '—')}</strong></button></td>
    <td><strong>${escapeHtml(vehicleJobcardNumber(vehicle) || '—')}</strong></td>
    <td><div class="parts-queue-customer"><strong title="${escapeHtml(unit)}">${escapeHtml(unit)}</strong><span title="${escapeHtml(customer)}">${escapeHtml(customer)}</span></div></td>
    <td><span class="parts-status-pill ${escapeHtml(partsDepartmentStatusClass(status))}">${escapeHtml(partsDepartmentStatusLabel(status))}</span>${importedEvidence ? `<div class="subtle" title="${escapeHtml(importedPartsTitle(vehicle))}">${escapeHtml(importedEvidence.label)}</div>` : ''}</td>
    <td class="parts-eta-cell"><input class="parts-eta-input" type="date" data-parts-worst-eta="${escapeHtml(key)}" value="${escapeHtml(etaValue)}" aria-label="Parts ETA for ${escapeHtml(displayStockNumber(vehicle) || 'vehicle')}" /><button class="parts-place-stoppage" type="button" data-parts-place-stoppage="${escapeHtml(key)}">Place as STOPPAGE</button></td>
    <td class="parts-eta-counter-cell"><span class="parts-eta-countdown ${escapeHtml(etaCountdownClass)}" data-parts-eta-counter="${escapeHtml(vehicleKey(vehicle))}">${escapeHtml(etaCountdown || '—')}</span></td>
    <td class="parts-queue-jita-cell">${jitaNumber ? `<span class="jita-icon yes" role="img" aria-label="Navision JITA number ${escapeHtml(jitaNumber)}" title="Navision JITA number ${escapeHtml(jitaNumber)}">✓</span>` : '<span class="parts-jita-empty" aria-label="No Navision JITA number">—</span>'}</td>
    <td class="parts-queue-blocker">${blocker ? `<strong title="${escapeHtml(blocker)}">${escapeHtml(blocker)}</strong>` : '<span class="subtle">None</span>'}</td>
    <td>${partsQueueActionsHtml(vehicle, status)}</td>
  </tr>`;
}
function partsIssuedStoppagePickerHtml(sourceRows = partsDepartmentSourceRows()) {
  // Completed rows are excluded from the queue, but an issued row can still
  // be selected for a new explicit STOPPAGE. Read that picker-only candidate
  // from Vehicle Locations without widening the Parts queue itself.
  const pickerRows = [...new Map(
    [...sourceRows, ...vehicleLocationsScreenRows()].map(vehicle => [vehicleKey(vehicle), vehicle])
  ).values()];
  const issued = pickerRows
    .filter(vehicleHasBatchNumber)
    .filter(vehicle => partsDepartmentStatus(vehicle) === 'issued')
    .sort((a, b) => String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''), undefined, { numeric: true }));
  if (!issued.length) return '<div class="parts-stoppage-picker"><strong>Add issued vehicle to Parts STOPPAGE</strong><span>No issued vehicles are currently available.</span></div>';
  const options = issued.map(vehicle => `<option value="${escapeHtml(vehicleKey(vehicle))}">${escapeHtml(displayStockNumber(vehicle) || vehicleKeyNumber(vehicle) || 'Vehicle')} · ${escapeHtml(vehicleCustomerName(vehicle) || 'Unknown customer')}</option>`).join('');
  return `<div class="parts-stoppage-picker"><label><strong>Add issued vehicle to Parts STOPPAGE</strong><select data-parts-issued-stoppage-vehicle><option value="">Select issued vehicle</option>${options}</select></label><button class="small-button danger-button" type="button" data-parts-add-issued-stoppage>Add Parts STOPPAGE</button></div>`;
}

function bindPartsIssuedStoppagePicker(host) {
  const button = host?.querySelector('[data-parts-add-issued-stoppage]');
  const select = host?.querySelector('[data-parts-issued-stoppage-vehicle]');
  button?.addEventListener('click', () => {
    const key = select?.value || '';
    if (!key) {
      pdcNotify('Select an issued vehicle before adding a Parts STOPPAGE.');
      return;
    }
    markVehiclePartsStoppage(key);
  });
}

function renderPartsHome() {
  const host = $('#parts-home-content');
  const summaryHost = $('#parts-summary-grid');
  if (!host && !summaryHost) return;
  const sourceRows = partsDepartmentSourceRows();
  const rows = partsDepartmentRows(sourceRows);
  renderPartsSummary(sourceRows);
  if (!host) return;
  const stoppagePicker = (app.partsOperationalFilter || 'notordered') === 'stoppage' ? partsIssuedStoppagePickerHtml(sourceRows) : '';
  if (!rows.length) {
    host.innerHTML = `${stoppagePicker}<div class="empty-state"><strong>No vehicles match the current parts filter</strong><span>Clear search or change the Parts status filter.</span></div>`;
    bindPartsIssuedStoppagePicker(host);
    return;
  }
  host.innerHTML = `${stoppagePicker}<div class="table-scroll-cue" aria-hidden="true">Swipe horizontally to view all columns →</div><div class="parts-table-wrap parts-queue-wrap"><table class="data-table compact-table parts-queue-table">
    <thead><tr>
      <th>Key</th><th>Stock</th><th>JC</th><th>Vehicle / customer</th><th>Parts status</th><th>Parts ETA</th><th>ETA counter</th><th>JITA</th><th>Parts STOPPAGE reason</th><th>Actions</th>
    </tr></thead>
    <tbody>${rows.map(partsQueueRowHtml).join('')}</tbody></table></div>`;
  bindPartsIssuedStoppagePicker(host);
  bindPartsQueueActionButtons(host);
  setupPartsEtaCounterClock(sourceRows);
  $$('[data-parts-worst-eta]', host).forEach(input => input.addEventListener('change', () => updateVehiclePartsWorstEta(input.dataset.partsWorstEta, input.value)));
  $$('[data-parts-place-stoppage]', host).forEach(button => button.addEventListener('click', () => placePartsEtaAsStoppage(button.dataset.partsPlaceStoppage, true)));
}

function authenticatedEmailPartsTarget(key = '', selected = null) {
  const service = app.emailVehicleLocationService || initEmailVehicleLocationsIfAvailable();
  if (!service) return null;
  const requested = String(key || '').trim();
  const selectedKeys = selected ? [vehicleKey(selected), selected.stock, selected.batch, selected.id, selected.__emailVehicleId] : [];
  const keys = new Set([requested, ...selectedKeys].map(value => String(value || '').trim()).filter(Boolean));
  const candidates = [selected, ...(Array.isArray(app.emailVehicleLocationRows) ? app.emailVehicleLocationRows : [])].filter(Boolean);
  const row = candidates.find(candidate => {
    if (candidate.__emailVehicleServerAuthoritative !== true) return false;
    return [vehicleKey(candidate), candidate.stock, candidate.batch, candidate.id, candidate.__emailVehicleId]
      .map(value => String(value || '').trim()).some(value => keys.has(value));
  });
  if (!row || !row.__emailVehicleId) return null;
  return { service, vehicle: row, vehicleId: row.__emailVehicleId, expectedVersion: row.__emailVehicleVersion };
}

async function authenticatedPartsTarget(key = '', selected = null) {
  const emailTarget = authenticatedEmailPartsTarget(key, selected);
  if (emailTarget) return emailTarget;
  const service = app.emailVehicleLocationService || initEmailVehicleLocationsIfAvailable();
  if (!service || !selected || !vehicleLifecycleSharedModeActive()) return null;
  const ref = await vehicleLifecycleSharedRef(selected);
  if (!ref || ref.outcome !== 'resolved') return null;
  return { service, vehicle: selected, vehicleId: ref.vehicleId, expectedVersion: ref.version };
}

async function markVehiclePartsOrdered(key = '') {
  const authority = vehicleLifecycleSharedModeActive() ? capturePdcWriteAuthority() : null;
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  let vehicle = selectedVehicle(key);
  if (!vehicle) return;
  if (vehicle.__emailVehicleServerAuthoritative === true) {
    await refreshEmailVehicleLocations();
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    vehicle = selectedVehicle(key);
  }
  if (!vehicle || !partsHasValidAuthoritativeEta(vehicle)) {
    pdcNotify('Set a valid authoritative Parts ETA before marking Parts ordered. The latest shared row has been loaded; no change was made.');
    renderPartsHome();
    return;
  }
  const sharedTarget = await authenticatedPartsTarget(key, vehicle);
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  if (sharedTarget) {
    const { service, vehicle: sharedVehicle, vehicleId, expectedVersion } = sharedTarget;
    if (!partsHasValidAuthoritativeEta(sharedVehicle)) {
      pdcNotify('The authoritative shared vehicle has no valid Parts ETA. Set the ETA and wait for confirmed readback before marking Parts ordered. No change was made.');
      await refreshEmailVehicleLocations();
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshSharedVehicleWorkState(sharedVehicle);
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      renderPartsHome();
      return;
    }
    if (typeof service.markPartsOrdered !== 'function') {
      pdcNotify('The shared Parts service is unavailable. No change was made.');
      renderPartsHome();
      return;
    }
    const result = await service.markPartsOrdered(vehicleId, expectedVersion, crypto.randomUUID());
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    if (!result?.ok) {
      const message = result?.code === 'vehicle_version_conflict'
        ? 'This vehicle changed since the Parts row loaded. The latest information will be reloaded; check it and try again.'
        : result?.code === 'parts_eta_required'
          ? 'Set a valid authoritative Parts ETA before marking Parts ordered. No change was made.'
        : result?.code === 'parts_already_ordered'
          ? 'Parts are already marked ordered. The current shared row will be reloaded.'
        : result?.code === 'parts_not_required' || result?.code === 'parts_required_false'
          ? 'Set Parts as required and save that authoritative work state before marking Parts ordered. No change was made.'
        : result?.code === 'parts_already_received'
          ? 'Parts are already marked received and cannot be marked ordered again.'
        : result?.code === '42501' || /unauthor|operator.required/i.test(String(result?.code || ''))
          ? 'Operator access is required to mark Parts ordered. No change was made.'
        : result?.code === 'parts_ordered_receipt_invalid'
          ? 'The Parts order request did not return a valid authoritative receipt. No change is shown; reload before retrying.'
          : `Parts could not be marked ordered (${escapeHtml(String(result?.code || 'unknown error'))}). No change was made.`;
      pdcNotify(message);
      await refreshEmailVehicleLocations();
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshSharedVehicleWorkState(sharedVehicle);
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      renderPartsHome();
      return;
    }
    const snapshotRefreshed = await refreshEmailVehicleLocations();
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    const refreshedVehicle = selectedVehicle(key) || sharedVehicle;
    const workRefreshed = await refreshSharedVehicleWorkState(refreshedVehicle);
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    if (!snapshotRefreshed || !workRefreshed || !partsOrdered(refreshedVehicle)) {
      pdcNotify('Parts ordered was accepted, but authoritative readback did not converge. No ordered state is shown; refresh before continuing.');
      renderPartsHome();
      return;
    }
    renderPartsHome();
    return;
  }
  pdcNotify('Parts ordering requires one authoritative shared vehicle record and a confirmed Parts ETA. No local change was made.');
}

async function markVehiclePartsComplete(key = '') {
  const authority = vehicleLifecycleSharedModeActive() ? capturePdcWriteAuthority() : null;
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const sharedTarget = await authenticatedPartsTarget(key, vehicle);
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  if (!sharedTarget) {
    pdcNotify('Parts completion requires the authenticated shared vehicle record. No change was made.');
    renderPartsHome();
    return;
  }
  const { service, vehicle: sharedVehicle, vehicleId, expectedVersion } = sharedTarget;
  if (typeof service.markPartsComplete !== 'function') {
    pdcNotify('The shared Parts completion service is unavailable. No change was made.');
    renderPartsHome();
    return;
  }
  app.partsCompletionInFlight = app.partsCompletionInFlight || new Set();
  if (app.partsCompletionInFlight.has(vehicleId)) return;
  app.partsCompletionInFlight.add(vehicleId);
  try {
    const result = await service.markPartsComplete(vehicleId, sharedVehicle.stock, expectedVersion, crypto.randomUUID());
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    if (!result?.ok) {
      const message = result?.code === 'vehicle_version_conflict'
        ? 'This vehicle changed since the Parts row loaded. The latest information will be reloaded; check it and try again.'
        : result?.code === 'parts_already_complete' || result?.code === 'parts_already_received' || result?.code === 'replayed'
          ? 'Parts are already marked received. The current shared row will be reloaded.'
        : result?.code === 'dealer_scope_denied' || result?.code === 'permission_denied'
          ? 'Your account is not authorised for this vehicle’s Parts record. No change was made.'
        : result?.code === 'vehicle_identity_mismatch' || result?.code === 'canonical_identity_mismatch'
          ? 'The shared vehicle identity could not be confirmed. Reload the Parts board before retrying; no change was made.'
        : result?.code === 'parts_not_ordered'
          ? 'Parts must be marked ordered before they can be marked received. No change was made.'
        : result?.code === 'vehicle_not_visible'
          ? 'This vehicle is no longer visible on the shared board. Reload before retrying; no change was made.'
        : result?.code === 'parts_receipt_idempotency_conflict'
          ? 'This Parts request conflicts with an earlier request. Reload the shared row before retrying; no change was made.'
        : result?.code === 'parts_completion_receipt_invalid'
            ? 'The shared completion did not return a valid receipt. No change was made.'
            : 'Parts could not be marked received on the shared vehicle record. No change was made.';
      pdcNotify(message);
      await refreshEmailVehicleLocations();
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshSharedVehicleWorkState(sharedVehicle);
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      renderPartsHome();
      return;
    }
    // Reconcile from the canonical vehicle UUID readback. The completion
    // response is receipt-backed; the row is never ticked by a local guess.
    await refreshEmailVehicleLocations();
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    await refreshSharedVehicleWorkState(sharedVehicle);
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    renderPartsHome();
    if (result.code === 'parts_completed' && result.data?.changed === true) {
      offerSalespersonChangeEmail(vehicle, {
        title: 'Parts completed',
        subject: 'PDC work completed',
        details: ['Parts were signed off through the authenticated canonical completion receipt.'],
      });
    }
  } finally {
    if (!authority || pdcWriteAuthorityCurrent(authority)) app.partsCompletionInFlight.delete(vehicleId);
  }
}

async function markVehiclePartsStoppage(key = '') {
  const authority = vehicleLifecycleSharedModeActive() ? capturePdcWriteAuthority() : null;
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const reason = cleanNavisionText(window.prompt('Enter Parts STOPPAGE reason:', partsStoppageReason(vehicle) === 'Parts STOPPAGE recorded' ? '' : partsStoppageReason(vehicle)) || '');
  if (!reason) return;
  const sharedTarget = await authenticatedPartsTarget(key, vehicle);
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  if (sharedTarget) {
    const { service, vehicle: sharedVehicle, vehicleId, expectedVersion } = sharedTarget;
    if (typeof service.setPartsStoppage !== 'function') {
      pdcNotify('The shared Parts STOPPAGE service is unavailable. No change was made.');
      return;
    }
    app.partsStoppageInFlight = app.partsStoppageInFlight || new Set();
    if (app.partsStoppageInFlight.has(vehicleId)) return;
    app.partsStoppageInFlight.add(vehicleId);
    try {
      const result = await service.setPartsStoppage(vehicleId, expectedVersion, 'set', reason, crypto.randomUUID());
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshEmailVehicleLocations();
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshSharedVehicleWorkState(sharedVehicle);
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      if (!result?.ok) {
        const message = result?.code === 'vehicle_version_conflict'
          ? 'This vehicle changed since the Parts row loaded. The latest shared row has been loaded; check it and try again.'
          : result?.code === 'parts_already_received' || result?.code === 'vehicle_inactive_or_issued'
            ? 'Received, issued or inactive vehicle Parts cannot be placed in STOPPAGE.'
            : 'Parts STOPPAGE was rejected by the shared record. No change was made.';
        pdcNotify(message);
        renderPartsHome();
        return;
      }
      app.partsOperationalFilter = 'stoppage';
      renderPartsHome();
      return;
    } finally {
      if (!authority || pdcWriteAuthorityCurrent(authority)) app.partsStoppageInFlight.delete(vehicleId);
    }
  }
  if (vehicle.__emailVehicleServerAuthoritative === true) {
    pdcNotify('This shared vehicle could not be resolved to one authoritative Parts record. No local STOPPAGE was recorded.');
    return;
  }
  const operator = getCurrentOperatorName();
  const updates = {
    pdcRequiresParts: true,
    pdcPartsStoppage: true,
    pdcPartsStoppageReason: reason,
    pdcPartsStoppageAt: nowIsoString(),
    pdcPartsStoppageBy: operator,
  };
  recordVehicleAudit(vehicle, 'Parts STOPPAGE recorded', { reason, by: operator });
  saveVehicleEdits(key, updates);
}

async function placePartsEtaAsStoppage(key = '', place = true) {
  const vehicle = selectedVehicle(key);
  if (!vehicle) return { ok: false, code: 'vehicle_not_found' };
  const target = await authenticatedPartsTarget(key, vehicle);
  const vehicleId = String(target?.vehicleId || vehicle.__emailVehicleId || vehicle.id || '');
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(vehicleId)) {
    if (place) pdcNotify('This vehicle has no shared record yet, so it was not placed as STOPPAGE.');
    return { ok: false, code: 'vehicle_not_found' };
  }
  const input = [...document.querySelectorAll('[data-parts-worst-eta]')].find(el => el.dataset.partsWorstEta === key);
  const eta = String(input?.value || '').slice(0, 10);
  if (place && !/^\d{4}-\d{2}-\d{2}$/.test(eta)) {
    pdcNotify('Set a Parts ETA before placing a STOPPAGE.');
    return { ok: false, code: 'eta_required' };
  }
  const client = window.PDC_SUPABASE;
  if (!client || typeof client.rpc !== 'function') {
    if (place) pdcNotify('Place as STOPPAGE is not available. The date was kept.');
    return { ok: false, code: 'unavailable' };
  }
  const { data, error } = await client.rpc('place_parts_eta_stoppage_573', {
    p_vehicle_id: vehicleId,
    p_eta: place ? eta : null,
    p_note: '',
    p_place: place === true,
  });
  if (error) {
    const missing = /404|schema cache|could not find/i.test(String(error.message || error));
    if (place || !missing) pdcNotify(missing ? 'Place as STOPPAGE is not on this database yet. The date was kept.' : 'The stoppage was not changed.');
    return { ok: false, code: missing ? 'missing' : 'error' };
  }
  if (data?.ok === true) {
    if (place) pdcNotify('Placed as STOPPAGE until the parts ETA.');
    else if (data.changed !== false) pdcNotify('STOPPAGE lifted.');
    return data;
  }
  const code = data?.error || data?.code;
  const text = code === 'eta_reached' ? 'That ETA is already here, so no stoppage was placed.'
    : code === 'vehicle_running' ? 'A job already running on this vehicle covers that date.'
    : code === 'bay_running' ? 'A running job is in the way. Nothing was moved.'
    : code === 'push_failed' ? 'The later jobs could not be moved. Nothing was placed.'
    : 'The stoppage was not changed.';
  if (place || code) pdcNotify(text);
  return data || { ok: false, code };
}

async function updateVehiclePartsWorstEta(key = '', value = '') {
  const authority = vehicleLifecycleSharedModeActive() ? capturePdcWriteAuthority() : null;
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const eta = cleanNavisionText(value || '');
  const previousEta = partsWorstEtaValue(vehicle);
  const operator = getCurrentOperatorName();
  const sharedTarget = await authenticatedPartsTarget(key, vehicle);
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  if (sharedTarget) {
    const { service, vehicle: sharedVehicle, vehicleId, expectedVersion } = sharedTarget;
    if (typeof service.updatePartsEta !== 'function') {
      pdcNotify('The shared Parts ETA service is unavailable. No change was made.');
      renderPartsHome();
      return;
    }
    const result = await service.updatePartsEta(vehicleId, expectedVersion, eta);
    if (authority && !pdcWriteAuthorityCurrent(authority)) return;
    if (!result?.ok) {
      const message = result?.code === 'vehicle_version_conflict'
        ? 'This vehicle changed since the Parts row loaded. The latest information will be reloaded; check it and try again.'
        : 'The Parts ETA could not be saved to the shared vehicle record. No change was made.';
      pdcNotify(message);
      await refreshEmailVehicleLocations();
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshSharedVehicleWorkState(sharedVehicle);
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      renderPartsHome();
      return;
    }
    // The RPC response is authoritative for the accepted ETA. Render that
    // accepted value immediately; reconcile the broader projections in
    // parallel so the Parts row is not blocked for two sequential refreshes.
    sharedVehicle.pdcPartsWorstEta = eta;
    renderPartsHome();
    if (!eta) void placePartsEtaAsStoppage(key, false);
    void Promise.allSettled([
      refreshEmailVehicleLocations(),
      refreshSharedVehicleWorkState(sharedVehicle),
    ]).then(() => { if (!authority || pdcWriteAuthorityCurrent(authority)) renderPartsHome(); });
    return;
  }
  recordVehicleAudit(vehicle, eta ? 'Parts worst ETA updated' : 'Parts worst ETA cleared', { eta, previousEta, by: operator });
  saveVehicleEdits(key, {
    pdcPartsPreviousWorstEta: previousEta,
    pdcPartsWorstEta: eta,
    pdcPartsWorstEtaUpdatedAt: nowIsoString(),
    pdcPartsWorstEtaUpdatedBy: operator,
  });
  if (!eta) void placePartsEtaAsStoppage(key, false);
  if (eta !== previousEta) {
    const previousLabel = previousEta ? partsWorstEtaLabel({ pdcPartsWorstEta: previousEta }) : 'Not previously recorded';
    const newLabel = eta ? partsWorstEtaLabel({ pdcPartsWorstEta: eta }) : 'Cleared';
    offerSalespersonChangeEmail(vehicle, {
      title: eta ? 'Parts ETA updated' : 'Parts ETA cleared',
      subject: 'Parts ETA update',
      details: [`Previous Parts ETA: ${previousLabel}`, `New Parts ETA: ${newLabel}`, eta ? `Revised countdown: ${partsWorstEtaCountdownLabel(vehicle) || 'Not available'}` : ''],
    });
  }
}

function draftPartsEtaSalesEmail(key = '') {
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const eta = partsWorstEtaLabel(vehicle);
  if (!eta) {
    pdcNotify('Set a Parts ETA before emailing sales.');
    return;
  }
  const salesperson = salespersonDisplayName(vehicle);
  const countdown = partsWorstEtaCountdownLabel(vehicle);
  const previousEta = cleanNavisionText(vehicle.pdcPartsPreviousWorstEta || vehicle.previousPartsWorstEta || '');
  const previousEtaLabel = previousEta ? partsWorstEtaLabel({ pdcPartsWorstEta: previousEta }) : '';
  const blocker = partsStoppageReason(vehicle);
  const body = [
    `Hi ${salesperson},`,
    '',
    ...salespersonChangeBannerLines(vehicle, { title: 'Parts ETA / delay update' }),
    '',
    'Parts have updated the expected ETA for the vehicle below.',
    '',
    ...vehicleEmailLines(vehicle),
    `Job Card: ${vehicleJobcardNumber(vehicle) || 'TBA'}`,
    `Current stage: ${statusCategoryLabel(vehicle)}${inferredPmbStage(vehicle) ? ` / ${pmbStageLabel(inferredPmbStage(vehicle))}` : ''}`,
    `Previous Parts ETA: ${previousEtaLabel || 'Not recorded'}`,
    `New Parts ETA: ${eta}`,
    `Revised countdown: ${countdown || 'No countdown available'}`,
    blocker ? `Parts note: ${blocker}` : '',

    'Please update the customer/delivery expectation as required.',
    '',
    'Kind Regards,',
  ].filter(line => line !== '').join('\n');
  const subject = `Parts ETA update - ${displayStockNumber(vehicle) || 'TBA'}`;
  recordVehicleAudit(vehicle, 'Parts ETA sales email drafted', { eta, countdown, salesperson });
  window.location.href = `mailto:${salespersonEmail(vehicle)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

async function clearVehiclePartsStoppage(key = '') {
  const authority = vehicleLifecycleSharedModeActive() ? capturePdcWriteAuthority() : null;
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  const vehicle = selectedVehicle(key);
  if (!vehicle) return;
  const reason = cleanNavisionText(window.prompt('Reason for clearing Parts STOPPAGE (recorded in audit history):', '') || '');
  if (!reason) return;
  const sharedTarget = await authenticatedPartsTarget(key, vehicle);
  if (authority && !pdcWriteAuthorityCurrent(authority)) return;
  if (sharedTarget) {
    const { service, vehicle: sharedVehicle, vehicleId, expectedVersion } = sharedTarget;
    if (typeof service.setPartsStoppage !== 'function') {
      pdcNotify('The shared Parts recovery service is unavailable. No change was made.');
      return;
    }
    app.partsStoppageInFlight = app.partsStoppageInFlight || new Set();
    if (app.partsStoppageInFlight.has(vehicleId)) return;
    app.partsStoppageInFlight.add(vehicleId);
    try {
      const result = await service.setPartsStoppage(vehicleId, expectedVersion, 'clear', reason, crypto.randomUUID());
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshEmailVehicleLocations();
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      await refreshSharedVehicleWorkState(sharedVehicle);
      if (authority && !pdcWriteAuthorityCurrent(authority)) return;
      if (!result?.ok) {
        pdcNotify(result?.code === 'vehicle_version_conflict'
          ? 'This vehicle changed since the Parts row loaded. The latest shared row has been loaded; check it and try again.'
          : 'Parts STOPPAGE recovery was rejected by the shared record. No change was made.');
        renderPartsHome();
        return;
      }
      renderPartsHome();
      return;
    } finally {
      if (!authority || pdcWriteAuthorityCurrent(authority)) app.partsStoppageInFlight.delete(vehicleId);
    }
  }
  if (vehicle.__emailVehicleServerAuthoritative === true) {
    pdcNotify('This shared vehicle could not be resolved to one authoritative Parts record. No local recovery was recorded.');
    return;
  }
  const operator = getCurrentOperatorName();
  recordVehicleAudit(vehicle, 'Parts STOPPAGE cleared', { previousReason: partsStoppageReason(vehicle), reason, by: operator });
  saveVehicleEdits(key, {
    pdcPartsStoppage: false,
    pdcPartsStoppageReason: '',
    pdcPartsStoppageClearedAt: nowIsoString(),
    pdcPartsStoppageClearedBy: operator,
  });
}

function exportPartsCsv() {
  const rows = partsDepartmentRows();
  const headers = ['Parts Status','Stock','Client','Vehicle','Kewdale ETA','Kewdale ETA Age','Parts Worst ETA','Parts Worst ETA Countdown','Current Stage','PMB Stage','Parts Ordered','Parts Ordered By','Parts Issued','Parts Issued By','Parts STOPPAGE','Parts STOPPAGE Reason','Last Parts Update'];
  const def = partsJobDef();
  const lines = [headers.join(',')].concat(rows.map(vehicle => [
    partsDepartmentStatusLabel(partsDepartmentStatus(vehicle)),
    displayStockNumber(vehicle), vehicle.client || vehicle.toyotaCustomer || '', displayVehicle(vehicle),
    kewdaleEtaValue(vehicle), pmbAgeLabel(vehicle), partsWorstEtaLabel(vehicle), partsWorstEtaCountdownLabel(vehicle), statusCategoryLabel(vehicle), pmbStageLabel(inferredPmbStage(vehicle)),
    partsOrdered(vehicle) ? 'Yes' : 'No', vehicle.pdcPartsOrderedBy || '', def && pdcJobComplete(vehicle, def) ? 'Yes' : 'No', def ? (vehicle[def.completeByKey] || '') : '',
    vehicle.pdcPartsStoppage === true ? 'Yes' : 'No', partsStoppageReason(vehicle), partsLastUpdateLabel(vehicle)
  ].map(csvEscape).join(',')));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pdc-parts-home-export.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function rftHomeStatus(vehicle = {}) {
  if (statusCategory(vehicle) !== 'rft') return '';
  if (vehicle.tuneCheckout?.confirmed === true) return 'checked_out';
  const issues = vehicleRftGateIssues(vehicle);
  if (issues.length) return 'blocked';
  const required = pdcRequiredJobs(vehicle);
  if (required.length && required.every(def => pdcJobComplete(vehicle, def))) return 'complete';
  return 'ready';
}

function rftHomeStatusLabel(status = '') {
  return { blocked: 'Blocked', ready: 'Ready', complete: 'Complete', checked_out: 'Checked out (Tune)' }[status] || 'Ready';
}

function rftHomeStatusClass(status = '') {
  return {
    checked_out: 'parts-status-ordered rft-status-checked-out',
    blocked: 'parts-status-stoppage rft-status-blocked',
    ready: 'parts-status-ordered rft-status-ready',
    complete: 'parts-status-complete rft-status-complete',
  }[status] || 'parts-status-ordered rft-status-ready';
}

function rftHomeRows() {
  const q = ($('#rft-search')?.value || '').trim().toLowerCase();
  const filter = $('#rft-status-filter')?.value || 'open';
  return app.data
    .filter(vehicle => statusCategory(vehicle) === 'rft' && !vehicleCollectedFromRft(vehicle))
    .filter(vehicle => {
      const status = rftHomeStatus(vehicle);
      const matchesStatus = filter === 'all'
        || filter === 'open'
        || status === filter;
      if (!matchesStatus) return false;
      if (!q) return true;
      const hay = [
        displayStockNumber(vehicle), vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle), vehicle.client, vehicle.toyotaCustomer,
        displayVehicle(vehicle), pdcCompletedJobsText(vehicle), pdcOutstandingJobsText(vehicle),
        vehicleRftGateIssues(vehicle).join(' '), rftHomeStatusLabel(status), vehicle.rftTransferredBy || '',
      ].join(' ').toLowerCase();
      return hay.includes(q);
    })
    .sort((a, b) => {
      const rank = { blocked: 0, checked_out: 1, ready: 2, complete: 3 };
      const rankDiff = (rank[rftHomeStatus(a)] ?? 9) - (rank[rftHomeStatus(b)] ?? 9);
      if (rankDiff) return rankDiff;
      const timeA = parseIsoTimestamp(a.rftTransferredAt || a.pdcLocationUpdatedAt || '')?.getTime() || 0;
      const timeB = parseIsoTimestamp(b.rftTransferredAt || b.pdcLocationUpdatedAt || '')?.getTime() || 0;
      if (timeA !== timeB) return timeB - timeA;
      return String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''), undefined, { numeric: true });
    });
}

function renderRftSummary() {
  const all = app.data.filter(vehicle => statusCategory(vehicle) === 'rft' && !vehicleCollectedFromRft(vehicle));
  const counts = all.reduce((acc, vehicle) => {
    const status = rftHomeStatus(vehicle);
    acc[status] = (acc[status] || 0) + 1;
    acc.open += 1;
    return acc;
  }, { open: 0, blocked: 0, ready: 0, complete: 0, checked_out: 0 });
  const cards = [
    ['blocked', 'Blocked', counts.blocked, 'Missing required sign-offs'],
    ['open', 'Open RFT', counts.open, 'All uncollected transport handovers'],
    ['checked_out', 'Checked out (Tune)', counts.checked_out, 'Service report confirms checkout'],
    ['ready', 'Ready', counts.ready, 'Can be handed over'],
    ['complete', 'Complete', counts.complete, 'All required jobs ticked'],
  ];
  const host = $('#rft-summary-grid');
  if (!host) return;
  host.innerHTML = cards.map(([key, label, count, hint]) => `<button class="parts-summary-card rft-summary-card ${escapeHtml(rftHomeStatusClass(key === 'open' ? 'ready' : key))}" type="button" data-rft-summary-filter="${escapeHtml(key)}"><span>${escapeHtml(label)}</span><strong>${count}</strong><small>${escapeHtml(hint)}</small></button>`).join('');
  $$('[data-rft-summary-filter]', host).forEach(button => button.addEventListener('click', () => {
    const select = $('#rft-status-filter');
    if (select) select.value = button.dataset.rftSummaryFilter || 'open';
    renderRftHome();
  }));
}

function rftCompletionTicksHtml(vehicle = {}) {
  const required = pdcRequiredJobs(vehicle);
  if (!required.length) return '<span class="subtle">No required jobs set</span>';
  const key = vehicleKey(vehicle);
  return `<div class="rft-completion-ticks">${required.map(def => {
    const complete = pdcJobComplete(vehicle, def);
    const title = pdcJobCompletionTitle(vehicle, def);
    return `<label class="rft-completion-tick ${complete ? 'is-complete' : 'is-pending'}" title="${escapeHtml(title)}"><input type="checkbox" data-rft-completion-key="${escapeHtml(key)}" data-rft-completion-job="${escapeHtml(def.key)}" ${complete ? 'checked' : ''} /> <span><b>${complete ? '✓' : escapeHtml(def.short)}</b>${escapeHtml(def.label)}</span></label>`;
  }).join('')}</div>`;
}

function rftCompletionSummaryHtml(vehicle = {}) {
  const required = pdcRequiredJobs(vehicle);
  if (!required.length) return '<span class="subtle">No jobs</span>';
  const done = required.filter(def => pdcJobComplete(vehicle, def)).length;
  const pending = required.length - done;
  return `<span class="rft-completion-summary-pill ${pending ? 'is-pending' : 'is-complete'}">${done}/${required.length} jobs${pending ? ` · ${pending} open` : ' · done'}</span>`;
}

function renderRftHome() {
  const host = $('#rft-home-content');
  const summaryHost = $('#rft-summary-grid');
  if (!host && !summaryHost) return;
  const rows = rftHomeRows();
  renderRftSummary();
  if (!host) return;
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No RFT vehicles match the current filter</strong><span>Clear search or change the RFT status filter.</span></div>';
    return;
  }
  host.innerHTML = `<div class="incoming-vertical-list rft-compact-list">${productionGridHeaderHtml('rft-production-grid-header', { meta1Label: 'RFT date', meta2Label: 'RFT status', actionLabel: 'Actions' })}${rows.map(vehicle => rftVehicleDetailRow(vehicle)).join('')}</div>`;
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    void openVehicleFromStockClick(button.dataset.openStock, button);
  }));
  $$('[data-rft-completion-key]', host).forEach(input => input.addEventListener('change', () => {
    togglePdcJobCompletionFromCard(input.dataset.rftCompletionKey, input.dataset.rftCompletionJob);
  }));
  $$('[data-rft-email]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    draftRftSalespersonNotificationEmail([button.dataset.rftEmail]);
  }));
  $$('[data-rft-delete]', host).forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    deleteIncomingVehicleFromMain(button.dataset.rftDelete);
  }));
  bindRftCollectedInputs(host);
  updateCollapseToggleButtons();
}

function rftVehicleDetailRow(vehicle = {}) {
  const key = vehicleKey(vehicle);
  const status = rftHomeStatus(vehicle);
  const statusClass = rftHomeStatusClass(status);
  const issues = vehicleRftGateIssues(vehicle);
  const transferredAt = parseIsoTimestamp(vehicle.rftTransferredAt || vehicle.pdcLocationUpdatedAt || '');
  const transferredLabel = transferredAt ? transferredAt.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : '—';
  const blocker = issues.length ? issues.join(' · ') : pdcOutstandingJobsText(vehicle);
  const stock = displayStockNumber(vehicle) || key || 'No stock';
  const unit = displayVehicle(vehicle) || 'Vehicle not listed';
  const customer = vehicleCustomerName(vehicle) || 'Dealer Order';
  const keyNo = vehicleKeyNumber(vehicle) || '—';
  return `
    <details class="incoming-vehicle-card pdc-production-grid-card incoming-rft-row rft-compact-row ${escapeHtml(statusClass)}" data-rft-row="${escapeHtml(key)}">
      <summary class="incoming-vehicle-summary pdc-production-grid-row rft-vehicle-summary">
        <span class="pdc-grid-select-spacer" aria-hidden="true"></span>
        <span class="incoming-card-stock">${vehicleIdentityStackHtml(vehicle, { className: 'incoming-identity' })}</span>
        <span class="incoming-card-main"><strong title="${escapeHtml(unit)}">${escapeHtml(unit)}</strong></span>
        <span class="incoming-card-work-wrap rft-card-work-wrap">${incomingWorkChecklistHtml(vehicle)}</span>
        <span class="incoming-card-meta incoming-card-age"><b>RFT</b><span>${escapeHtml(transferredLabel)}</span></span>
        <span class="incoming-card-meta"><b>Status</b><span class="parts-status-pill ${escapeHtml(statusClass)}">${escapeHtml(rftHomeStatusLabel(status))}</span></span>
        <span class="incoming-card-action rft-card-actions">
          ${rftCompletionSummaryHtml(vehicle)}
        </span>
      </summary>
      <div class="incoming-vehicle-detail-grid">
        <div><b>RFT status</b><span>${escapeHtml(rftHomeStatusLabel(status))}</span></div>
        ${vehicle.tuneCheckout?.confirmed === true ? `<div class="wide"><b>Checkout source</b><span>Tune Sub Status 99 · ${escapeHtml((vehicle.tuneCheckout.jobCards || []).map(job => job.ro).join(', '))}. Work completed by Tune checkout; removed from active workshop, parts and Sublet queues. QC sign-off remains separately recorded.</span></div>` : ''}
        <div><b>Stock</b><span>${escapeHtml(stock)}</span></div>
        <div><b>Key</b><span>${escapeHtml(keyNo)}</span></div>
        <div><b>Customer</b><span>${escapeHtml(customer)}</span></div>
        <div class="wide"><b>Blocker / outstanding</b><span>${escapeHtml(blocker || 'No outstanding RFT blockers')}</span></div>
        <div class="wide"><b>Completion ticks</b><span>${rftCompletionTicksHtml(vehicle)}</span></div>
        <div class="wide rft-detail-actions"><b>Transport handover</b><span class="rft-transport-checks"><button class="primary rft-booked-button" type="button" data-rft-transport-booked-key="${escapeHtml(key)}" ${vehicleRftTransportBooked(vehicle) ? 'disabled' : ''} title="Booked on trucking website; captures the intercepted salesperson status email">${vehicleRftTransportBooked(vehicle) ? 'RFT Booked ✓' : 'RFT Booked'}</button><button class="primary rft-collected-button" type="button" data-rft-collected-key="${escapeHtml(key)}" ${vehicleRftCollectionEnabled(vehicle) ? '' : 'disabled'}>Collected</button><button class="small-button incoming-open-button" type="button" data-open-stock="${escapeHtml(key)}">Open vehicle</button>${rftTransportEmailStatusLabel(vehicle) ? `<small class="rft-email-status">${escapeHtml(rftTransportEmailStatusLabel(vehicle))}</small>` : '<small class="rft-email-status">Book transport to enable collection</small>'}</span></div>
      </div>
    </details>`;
}

function beginRftTransportAction(key = '') {
  const actionKey = `rft:${String(key || '')}`;
  if (!String(key || '').trim()) return null;
  const authority = capturePdcWriteAuthority();
  if (!pdcWriteAuthorityCurrent(authority)) return null;
  if (!(app.rftTransportActionInFlight instanceof Set)) app.rftTransportActionInFlight = new Set();
  if (!(app.rftTransportActionOwners instanceof Map)) app.rftTransportActionOwners = new Map();
  if (app.rftTransportActionInFlight.has(actionKey)) return null;
  const generation = Number(app.rftTransportActionGeneration || 0) + 1;
  app.rftTransportActionGeneration = generation;
  app.rftTransportActionInFlight.add(actionKey);
  const action = { actionKey, generation, authority };
  app.rftTransportActionOwners.set(actionKey, action);
  return action;
}

function rftTransportActionIsCurrent(action = null) {
  return Boolean(action
    && pdcWriteAuthorityCurrent(action.authority)
    && app.rftTransportActionOwners?.get(action.actionKey) === action
    && app.rftTransportActionInFlight instanceof Set
    && app.rftTransportActionInFlight.has(action.actionKey));
}

function finishRftTransportAction(action = null) {
  if (action && app.rftTransportActionOwners?.get(action.actionKey) === action) {
    app.rftTransportActionOwners.delete(action.actionKey);
    app.rftTransportActionInFlight?.delete(action.actionKey);
  }
}

async function markRftConfirmation(key = '', confirmed = false) {
  const vehicle = selectedVehicle(key);
  const service = app.emailVehicleLocationService;
  const desired = confirmed === true;
  if (!vehicle || !vehicleRftLifecycleRoleAllowed()) { renderAll(); return false; }
  if (!rftTransportActionAuthorityReady(vehicle) || typeof service?.setRftConfirmation736 !== 'function') {
    pdcNotify('This RFT vehicle is not bound to current staging authority. Nothing was changed.'); renderAll(); return false;
  }
  if (!desired && rftConfirmationIrreversibleReason(vehicle)) {
    pdcNotify(rftConfirmationIrreversibleReason(vehicle)); renderAll(); return false;
  }
  if (vehicleRftConfirmationActive(vehicle) === desired) { renderAll(); return false; }
  const action = beginRftTransportAction(key);
  if (!action) return false;
  try {
    const label = vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'this vehicle';
    const prompt = desired
      ? `Confirm ${label} is manually RFT’d?\n\nThis records the authoritative RFT confirmation and starts the dealer-transit timer. It does not send the salesperson email.`
      : `Untick RFT’d for ${label}?\n\nThis reverses the accidental manual confirmation and clears the open dealer-transit timer. It is only allowed before Email Sales Person evidence exists.`;
    if (!window.confirm(prompt)) { renderAll(); return false; }
    const result = await service.setRftConfirmation736(vehicle.__emailVehicleId, Number(vehicle.__emailVehicleVersion), desired, salespersonAssignmentIdempotencyKey());
    if (!rftTransportActionIsCurrent(action)) return false;
    if (!result?.ok) {
      const messages = {
        rft_confirmation_irreversible: 'Email Sales Person evidence or Collected/Completed history exists; RFT’d cannot be unticked.',
        rft_confirmation_stale_version: 'This vehicle changed in another session. The latest state has been reloaded.',
        rft_confirmation_invalid_state: 'The vehicle is no longer in the RFT location.',
        rft_confirmation_required: 'Tick RFT’d before Email Sales Person.',
      };
      await refreshEmailVehicleLocations();
      if (!rftTransportActionIsCurrent(action)) return false;
      pdcNotify(messages[result?.code] || 'RFT’d was not changed. No history was removed.'); renderAll(); return false;
    }
    const data = result.data && typeof result.data === 'object' ? result.data : {};
    if (String(data.vehicle_id || '') !== String(vehicle.__emailVehicleId) || !data.receipt_id || !Number.isInteger(Number(data.vehicle_version_after)) || Number(data.vehicle_version_after) < 1 || data.rft_confirmed !== desired) {
      await refreshEmailVehicleLocations();
      if (!rftTransportActionIsCurrent(action)) return false;
      pdcNotify('The RFT confirmation response was incomplete. Refresh before retrying.'); renderAll(); return false;
    }
    const refreshed = await refreshEmailVehicleLocations();
    if (!rftTransportActionIsCurrent(action)) return false;
    if (!refreshed) { pdcNotify('RFT’d was accepted, but the shared row could not be read back. Refresh before retrying.'); renderAll(); return false; }
    renderAll();
    pdcNotify(desired ? 'RFT’d recorded. The dealer-transit timer has started.' : 'RFT’d unticked. The accidental confirmation and open timer were cleared.', 'info');
    return true;
  } finally {
    finishRftTransportAction(action);
  }
}

async function markRftTransportBooked(key = '', booked = true) {
  // Legacy bookRftTransport700(vehicle.__emailVehicleId, ...) is retired;
  // the durable staging path below is the only booking dispatch.
  const vehicle = selectedVehicle(key);
  const service = app.emailVehicleLocationService;
  if (!vehicle || !booked || !vehicleRftLifecycleRoleAllowed()) { renderAll(); return false; }
  if (vehicleRftTransportBooked(vehicle)) { renderAll(); return false; }
  if (!durableRftLifecycleEnabled() || vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId || Number(vehicle.__emailVehicleVersion || 0) < 1 || typeof service?.bookRftTransport739 !== 'function') {
    pdcNotify('This RFT vehicle is not bound to current server authority. Nothing was changed.'); renderAll(); return false;
  }
  const action = beginRftTransportAction(key);
  if (!action) return false;
  try {
    const label = vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'this vehicle';
    if (!window.confirm(`Confirm ${label} has been booked on the trucking company website?\n\nThis permanently records the booking and creates the mandatory salesperson email with completed work, dates, build times, stoppages and the QC photo.`)) return false;
    const result = await service.bookRftTransport739(vehicle.__emailVehicleId, Number(vehicle.__emailVehicleVersion), salespersonAssignmentIdempotencyKey());
    if (!rftTransportActionIsCurrent(action)) return false;
    if (!result?.ok) {
      const messages = { rft_confirmation_required: 'Tick RFT’d and wait for the authoritative checked state before emailing.', salesperson_email_required: 'Assign an active salesperson with an email address first.', qc_evidence_required: 'The QC completion list and photo must be stored before transport can be booked.', qc_items_required: 'Every required QC item must be complete before transport can be booked.', qc_photo_receipt_required: 'A durable QC vehicle photo is required before transport can be booked.', qc_photo_storage_missing: 'The durable QC photo storage object could not be read back.', qc_photo_evidence_changed: 'The QC photo changed. Refresh the vehicle and retry.', qc_photo_bytes_mismatch: 'The QC photo bytes did not match the immutable evidence. Nothing was booked.', qc_photo_bytes_invalid: 'The QC photo could not be bound to the immutable evidence. Nothing was booked.', vehicle_version_conflict: 'This vehicle changed in another session. The latest state has been reloaded.', vehicle_not_in_rft: 'This vehicle is no longer in RFT.', transport_already_booked: 'Transport has already been booked.', transport_draft_already_exists: 'The intercepted salesperson draft already exists. Refresh to download it.', rft_transport_draft_receipt_invalid: 'The intercepted salesperson draft readback was incomplete. Nothing was claimed as sent.' };
      await refreshEmailVehicleLocations();
      if (!rftTransportActionIsCurrent(action)) return false;
      pdcNotify(messages[result?.code] || 'Transport booking was not saved. No email was created.'); renderAll(); return false;
    }
    const refreshed = await refreshEmailVehicleLocations();
    if (!rftTransportActionIsCurrent(action)) return false;
    if (!refreshed) { pdcNotify('Transport booking was accepted, but the shared row could not be read back. Refresh before retrying.'); renderAll(); return false; }
    renderAll();
    pdcNotify('Transport booking saved. The mandatory salesperson update has been created with the full build history and QC photo.', 'info');
    return true;
  } finally {
    finishRftTransportAction(action);
  }
}

async function markRftVehicleCollected(key = '', collected = true) {
  // Legacy collectRftTransport700(vehicle.__emailVehicleId, ...) is retired;
  // Collected is dispatched only through the durable 734 successor.
  const vehicle = selectedVehicle(key);
  const service = app.emailVehicleLocationService;
  if (!vehicle || !collected || !vehicleRftLifecycleRoleAllowed()) { renderAll(); return false; }
  if (!vehicleRftTransportBooked(vehicle)) { pdcNotify('Book the vehicle on the trucking company website first.'); renderAll(); return false; }
  if (!vehicleRftEmailEvidenceReady(vehicle)) { pdcNotify('The intercepted salesperson email and QC photo evidence must be read back before collection.'); renderAll(); return false; }
  if (!vehicleRftCollectionEnabled(vehicle) || vehicle.__emailVehicleServerAuthoritative !== true || !vehicle.__emailVehicleId || Number(vehicle.__emailVehicleVersion || 0) < 1 || typeof service?.collectRftTransport734 !== 'function') {
    pdcNotify('This RFT vehicle is not bound to current server authority. Nothing was changed.'); renderAll(); return false;
  }
  const action = beginRftTransportAction(key);
  if (!action) return false;
  try {
    const label = vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'this vehicle';
    if (!window.confirm(`Confirm ${label} has physically been collected?\n\nThis moves it to Collected Vehicles, clears active bay/workshop pointers and leaves the dealer-transit timer open. Delivery closes it later.`)) return false;
    const result = await service.collectRftTransport734(vehicle.__emailVehicleId, Number(vehicle.__emailVehicleVersion), salespersonAssignmentIdempotencyKey());
    if (!rftTransportActionIsCurrent(action)) return false;
    if (!result?.ok) {
      const messages = { transport_booking_and_mandatory_email_required: 'The trucking booking and mandatory salesperson update must exist first.', started_booking_must_be_completed_before_collection: 'A Workshop job is still STARTED. Complete that real work before collection.', vehicle_version_conflict: 'This vehicle changed in another session. The latest state has been reloaded; please try again.', vehicle_not_in_rft: 'This vehicle is no longer in RFT.' };
      await Promise.allSettled([refreshEmailVehicleLocations(), window.__workshopDataService?.loadSnapshot?.('rft_collection_rejected')]);
      if (!rftTransportActionIsCurrent(action)) return false;
      pdcNotify(messages[result?.code] || 'The vehicle was not marked collected. No history was removed.'); renderAll(); return false;
    }
    const [refreshed] = await Promise.all([refreshEmailVehicleLocations(), window.__workshopDataService?.loadSnapshot?.('rft_collected_412')]);
    if (!rftTransportActionIsCurrent(action)) return false;
    if (!refreshed) { pdcNotify('Collection was accepted, but the shared row could not be read back. Refresh before retrying.'); renderAll(); return false; }
    renderAll();
    return true;
  } finally {
    finishRftTransportAction(action);
  }
}

async function downloadRftTransportDraft(key = '') {
  const vehicle = selectedVehicle(key);
  const service = app.emailVehicleLocationService;
  if (!vehicle || typeof service?.readRftTransportDraft739 !== 'function') return false;
  const result = await service.readRftTransportDraft739(vehicle.__emailVehicleId);
  if (!result?.ok) { pdcNotify(result?.code === 'transport_draft_not_found' ? 'The intercepted salesperson draft is not available yet.' : 'The intercepted salesperson draft could not be read.'); return false; }
  const data = result.data || {};
  try {
    const binary = atob(data.mime_base64);
    const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));
    if (bytes.byteLength !== Number(data.mime_byte_length || 0)) throw new Error('length');
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    const sha256 = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
    if (sha256 !== String(data.mime_sha256 || '').toLowerCase()) throw new Error('hash');
    const blob = new Blob([bytes], { type: 'message/rfc822' });
    const objectUrl = URL.createObjectURL(blob); const anchor = document.createElement('a');
    anchor.href = objectUrl; anchor.download = String(data.draft_filename || 'rft-transport.eml').replace(/[^A-Za-z0-9._-]/g, '-');
    document.body.appendChild(anchor); anchor.click(); anchor.remove(); setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
    return true;
  } catch (_error) { pdcNotify('The intercepted salesperson draft failed its byte/hash readback. Nothing was downloaded.'); return false; }
}

function bindRftCollectedInputs(root = document) {
  $$('[data-rft-confirmation-key]', root).forEach(input => input.addEventListener('change', event => { event.stopPropagation(); void markRftConfirmation(input.dataset.rftConfirmationKey, input.checked); }));
  $$('[data-rft-transport-booked-key]', root).forEach(button => button.addEventListener('click', event => { event.stopPropagation(); void markRftTransportBooked(button.dataset.rftTransportBookedKey, true); }));
  $$('[data-rft-collected-key]', root).forEach(button => button.addEventListener('click', event => { event.stopPropagation(); void markRftVehicleCollected(button.dataset.rftCollectedKey, true); }));
  $$('[data-rft-draft-key]', root).forEach(link => link.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); void downloadRftTransportDraft(link.dataset.rftDraftKey); }));
}

function collectedVehicleRows() {
  const q = ($('#collected-search')?.value || '').trim().toLowerCase();
  return app.data
    .filter(vehicleInCollectedState)
    .filter(vehicle => !isHermesSyntheticVehicle(vehicle))
    .filter(vehicle => {
      if (!q) return true;
      return [displayStockNumber(vehicle), vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle), vehicle.client, vehicle.toyotaCustomer, displayVehicle(vehicle), vehicle.rftCollectedBy || '', vehicle.rftCollectedAt || '', vehicle.dealerTransitStartedAt || ''].join(' ').toLowerCase().includes(q);
    })
    .sort((a, b) => (parseIsoTimestamp(b.rftCollectedAt || '')?.getTime() || 0) - (parseIsoTimestamp(a.rftCollectedAt || '')?.getTime() || 0));
}

function collectedTransitTiming(vehicle = {}, now = Date.now()) {
  const started = parseIsoTimestamp(vehicle.dealerTransitStartedAt || '');
  const closed = parseIsoTimestamp(vehicle.dealerTransitClosedAt || '');
  if (!started) return { label: 'Start not recorded', note: 'Transit timing unavailable' };
  const end = closed ? closed.getTime() : Number(now);
  if (!Number.isFinite(end) || end < started.getTime()) return { label: 'Awaiting transit start', note: 'Check the recorded start time' };
  const recorded = vehicle.dealerTransitDurationSeconds;
  const seconds = closed && recorded !== null && recorded !== undefined && recorded !== '' && Number.isFinite(Number(recorded)) && Number(recorded) >= 0
    ? Number(recorded) : Math.floor((end - started.getTime()) / 1000);
  return { label: `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`, note: closed ? 'Delivered · transit complete' : 'In transit · awaiting delivery' };
}

function refreshCollectedTransitTimers() {
  if (app.currentView !== 'collected' || !window.PDC_AUTH_CONTEXT) {
    if (app.collectedTransitTimer) window.clearInterval(app.collectedTransitTimer);
    app.collectedTransitTimer = null;
    return;
  }
  $$('[data-collected-transit-start]', $('#collected-vehicles-content')).forEach(cell => {
    const timing = collectedTransitTiming({ dealerTransitStartedAt: cell.dataset.collectedTransitStart, dealerTransitClosedAt: cell.dataset.collectedTransitEnd, dealerTransitDurationSeconds: cell.dataset.collectedTransitSeconds });
    cell.querySelector('strong').textContent = timing.label;
    cell.querySelector('small').textContent = timing.note;
  });
}

function renderCollectedVehicles() {
  const host = $('#collected-vehicles-content');
  if (!host) return;
  const rows = collectedVehicleRows();
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No collected vehicles yet</strong><span>Vehicles appear here after the RFT transport handover is physically collected.</span></div>';
    return;
  }
  host.innerHTML = `<div class="parts-table-wrap collected-table-wrap pdc-grid-table-wrap"><table class="data-table compact-table collected-table pdc-grid-table"><thead><tr><th>Collected</th><th>Stock</th><th>Job Card</th><th>Customer</th><th>Vehicle</th><th>Transit started</th><th>Timer</th><th>Collected by</th><th>Actions</th></tr></thead><tbody>${rows.map(vehicle => {
    const key = vehicleKey(vehicle);
    const collectedAt = parseIsoTimestamp(vehicle.rftCollectedAt || '');
    const transitStarted = parseIsoTimestamp(vehicle.dealerTransitStartedAt || '');
    const timing = collectedTransitTiming(vehicle);
    const dateOptions = { timeZone: 'Australia/Perth', dateStyle: 'short', timeStyle: 'short' };
    return `<tr class="collected-vehicle-row"><td>${escapeHtml(collectedAt ? collectedAt.toLocaleString('en-AU', dateOptions) : '—')}</td><td class="pdc-id-cell"><button class="stock-link stock-button" type="button" data-open-stock="${escapeHtml(key)}">${escapeHtml(displayStockNumber(vehicle) || '—')}</button></td><td>${escapeHtml(vehicleJobcardNumber(vehicle) || '—')}</td><td>${escapeHtml(vehicleCustomerName(vehicle) || 'Dealer Order')}</td><td>${escapeHtml(displayVehicle(vehicle) || 'Vehicle not listed')}</td><td>${escapeHtml(transitStarted ? transitStarted.toLocaleString('en-AU', dateOptions) : '—')}</td><td data-collected-transit-start="${escapeHtml(vehicle.dealerTransitStartedAt || '')}" data-collected-transit-end="${escapeHtml(vehicle.dealerTransitClosedAt || '')}" data-collected-transit-seconds="${escapeHtml(vehicle.dealerTransitDurationSeconds ?? '')}"><strong>${escapeHtml(timing.label)}</strong><small>${escapeHtml(timing.note)}</small></td><td>${escapeHtml(vehicle.rftCollectedBy || '')}</td><td><button class="small-button" type="button" data-open-stock="${escapeHtml(key)}">Open</button></td></tr>`;
  }).join('')}</tbody></table></div>`;
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
  if (!app.collectedTransitTimer) app.collectedTransitTimer = window.setInterval(refreshCollectedTransitTimers, 60000);
}

function completedHistoryMilestone(value = '') {
  const text = String(value || '').trim();
  if (!text) return null;
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(text);
  const date = parseIsoTimestamp(dateOnly ? `${text}T00:00:00+08:00` : text);
  if (!date) return null;
  completedHistoryMilestone.formatter ||= new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Perth', year: 'numeric', month: '2-digit', day: '2-digit' });
  const parts = Object.fromEntries(completedHistoryMilestone.formatter.formatToParts(date).map(part => [part.type, part.value]));
  const calendarDate = `${parts.year}-${parts.month}-${parts.day}`;
  if (dateOnly && calendarDate !== text) return null;
  return { value: text, date, dateOnly, calendarDate };
}

function completedHistoryMilestones(vehicle = {}) {
  const history = lifecycleHistoryForVehicle(vehicle);
  const firstValid = values => values.map(completedHistoryMilestone).find(Boolean) || null;
  // r895 (F466, Craig 2 Nov 15:47): the old-system RFT spreadsheet (Date In, RFT date) is the truth while the board
  // builds its own history, so a car listed there takes its PMB and RFT dates from the spreadsheet.
  const sheet = completedHistorySheetDates(vehicle);
  const fromSheet = value => { const m = completedHistoryMilestone(value); return m ? { ...m, source: 'sheet' } : null; };
  return {
    pmb: (sheet && fromSheet(sheet[0])) || firstValid([history.firstEnteredPmbAt, vehicle.dateToPmb, vehicle.date_to_pmb]),
    rft: (sheet && fromSheet(sheet[1])) || firstValid([history.firstBecameRftAt, vehicle.rftTransferredAt, vehicle.dateToRft, vehicle.date_to_rft]),
    delivered: firstValid([vehicle.dealerTransitClosedAt, vehicle.deliveredToDealerDate, vehicle.delivered_to_dealer_date]),
  };
}

// r895: Date In / RFT date from the RFT spreadsheet for a board car, keyed like normalize_vehicle_stock_number.
function completedHistorySheetDates(vehicle = {}) {
  const map = app.pmbTurnaround895 && app.pmbTurnaround895.sheet_dates;
  if (!map || typeof map !== 'object') return null;
  const shown = typeof displayStockNumber === 'function' ? displayStockNumber(vehicle) : '';
  const stock = String(vehicle.stockNumberNormalized || vehicle.stock_number_normalized || shown || vehicle.stock || vehicle.stockNumber || vehicle.stock_number || '')
    .trim().toUpperCase().replace(/[\s-]+/g, '');
  const dates = stock ? map[stock] : null;
  return Array.isArray(dates) && dates.length === 2 && dates[0] && dates[1] ? dates : null;
}

async function completedHistoryLoadTurnaround(force = false) {
  if (app.pmbTurnaround895 && !force) return app.pmbTurnaround895;
  if (app.pmbTurnaroundLoading895) return null;
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function') return null;
  app.pmbTurnaroundLoading895 = true;
  try {
    const { data, error } = await client.rpc('get_pmb_turnaround_895');
    if (!error && data && data.ok === true) app.pmbTurnaround895 = data;
    else app.pmbTurnaroundError895 = 'PMB turnaround history could not be loaded.';
  } catch (_) {
    app.pmbTurnaroundError895 = 'PMB turnaround history could not be loaded.';
  } finally {
    app.pmbTurnaroundLoading895 = false;
  }
  return app.pmbTurnaround895 || null;
}

function completedHistoryTurnaroundPeriodLabel(grain, period) {
  const text = String(period || '');
  if (grain === 'month') {
    const [year, month] = text.split('-').map(Number);
    const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return year && names[month - 1] ? `${names[month - 1]} ${year}` : text;
  }
  if (grain === 'quarter') return text.replace(/^(\d{4})-Q(\d)$/, 'Q$2 $1');
  return text;
}

function completedHistoryTurnaroundDays(value) {
  const number = Number(value);
  if (value === null || value === undefined || value === '' || !Number.isFinite(number)) return '—';
  const rounded = Math.round(number * 10) / 10;
  return `${rounded} day${rounded === 1 ? '' : 's'}`;
}

function completedHistoryTurnaroundHtml() {
  const data = app.pmbTurnaround895;
  if (!data) {
    return `<div class="completed-turnaround-panel"><div class="completed-turnaround-head"><div><span>Days at PMB by PMB start</span><strong>${app.pmbTurnaroundError895 ? escapeHtml(app.pmbTurnaroundError895) : 'Loading RFT spreadsheet history…'}</strong></div></div></div>`;
  }
  const grain = ['month', 'quarter', 'year'].includes(app.pmbTurnaroundGrain895) ? app.pmbTurnaroundGrain895 : 'month';
  const periods = (Array.isArray(data.periods) ? data.periods : []).filter(row => row && row.grain === grain);
  const years = Array.from(new Set((Array.isArray(data.periods) ? data.periods : []).filter(row => row && row.grain === 'year').map(row => String(row.period)))).sort().reverse();
  const year = grain === 'year' ? 'all' : (app.pmbTurnaroundYear895 && (app.pmbTurnaroundYear895 === 'all' || years.includes(app.pmbTurnaroundYear895)) ? app.pmbTurnaroundYear895 : (years[0] || 'all'));
  const rows = periods.filter(row => year === 'all' || String(row.period).startsWith(year));
  const grainButton = (value, label) => `<button type="button" class="small-button${grain === value ? ' is-selected' : ''}" data-turnaround-grain="${value}" aria-pressed="${grain === value}">${label}</button>`;
  const source = data.source || {};
  const notCounted = Number(data.board_not_counted) || 0;
  return `<div class="completed-turnaround-panel">
      <div class="completed-turnaround-head">
        <div><span>Days at PMB by PMB start</span><strong>${rows.reduce((total, row) => total + (Number(row.vehicles) || 0), 0).toLocaleString('en-AU')} vehicles${year === 'all' ? '' : ` in ${escapeHtml(year)}`} · grouped by the ${grain === 'quarter' ? 'quarter' : grain === 'year' ? 'year' : 'month'} they got to PMB</strong></div>
        <div class="completed-turnaround-controls">
          <div class="completed-scope" role="group" aria-label="Group by">${grainButton('month', 'Month')}${grainButton('quarter', 'Quarter')}${grainButton('year', 'Year')}</div>
          ${grain === 'year' ? '' : `<label class="completed-turnaround-year">Year <select data-turnaround-year>${['all', ...years].map(value => `<option value="${escapeHtml(value)}"${value === year ? ' selected' : ''}>${value === 'all' ? 'All years' : escapeHtml(value)}</option>`).join('')}</select></label>`}
        </div>
      </div>
      <div class="parts-table-wrap completed-turnaround-wrap"><table class="data-table compact-table completed-turnaround-table">
        <thead><tr><th>Got to PMB</th><th>Vehicles</th><th>Average at PMB</th><th>Median</th><th>Fastest</th><th>Longest</th><th>Source</th></tr></thead>
        <tbody>${rows.length ? rows.map(row => `<tr><td><strong>${escapeHtml(completedHistoryTurnaroundPeriodLabel(grain, row.period))}</strong></td><td>${escapeHtml(row.vehicles)}</td><td class="is-average">${escapeHtml(completedHistoryTurnaroundDays(row.average))}</td><td>${escapeHtml(completedHistoryTurnaroundDays(row.median))}</td><td>${escapeHtml(completedHistoryTurnaroundDays(row.fastest))}</td><td>${escapeHtml(completedHistoryTurnaroundDays(row.longest))}</td><td><small>${[Number(row.from_sheet) ? `${row.from_sheet} spreadsheet` : '', Number(row.from_board) ? `${row.from_board} board` : ''].filter(Boolean).join(' · ') || '—'}</small></td></tr>`).join('') : '<tr><td colspan="7">No vehicles in this period.</td></tr>'}</tbody>
      </table></div>
      <small class="completed-turnaround-note">Days at PMB = RFT date minus the date it got to PMB. The old-system RFT spreadsheet (${escapeHtml(source.sheets || '2024 to 2026 tabs')}) is the truth for Date In and RFT. Board cars count only when the board recorded both the PMB date and a real RFT${notCounted ? `; ${notCounted} board car${notCounted === 1 ? '' : 's'} from the changeover without a real RFT date ${notCounted === 1 ? 'is' : 'are'} not counted` : ''}. The latest months only include cars already RFT'd, so they look faster until the rest are done.</small>
    </div>`;
}

function completedHistoryBindTurnaround(host) {
  if (!host || typeof $$ !== 'function') return;
  $$('[data-turnaround-grain]', host).forEach(button => button.addEventListener('click', () => {
    app.pmbTurnaroundGrain895 = button.dataset.turnaroundGrain;
    renderCompletedPmbStatistics(completedVehicleRows());
  }));
  $$('[data-turnaround-year]', host).forEach(select => select.addEventListener('change', () => {
    app.pmbTurnaroundYear895 = select.value;
    renderCompletedPmbStatistics(completedVehicleRows());
  }));
}

function completedHistoryInterval(vehicle = {}, key = '', milestones = completedHistoryMilestones(vehicle)) {
  const pairs = { pmbToRft: ['pmb', 'rft'], rftToOd: ['rft', 'delivered'], pmbToOd: ['pmb', 'delivered'] };
  const [from, to] = pairs[key] || [];
  const start = milestones[from], end = milestones[to];
  if (!start || !end) return null;
  if (start.dateOnly || end.dateOnly) {
    const days = (Date.parse(end.calendarDate) - Date.parse(start.calendarDate)) / 86400000;
    return days >= 0 ? { days, seconds: null, dateOnly: true } : null;
  }
  const seconds = (end.date - start.date) / 1000;
  return seconds >= 0 ? { days: seconds / 86400, seconds, dateOnly: false } : null;
}

function completedHistoryDurationLabel(interval) {
  if (!interval || !Number.isFinite(interval.days) || interval.days < 0) return 'Unknown';
  if (interval.dateOnly) return `${interval.days} day${interval.days === 1 ? '' : 's'} (date only)`;
  const seconds = interval.seconds;
  if (!Number.isFinite(seconds) || seconds < 0) return 'Unknown';
  if (seconds > 0 && seconds < 60) return '<1m';
  const minutes = Math.floor(seconds / 60);
  return [Math.floor(minutes / 1440) ? `${Math.floor(minutes / 1440)}d` : '', Math.floor(minutes % 1440 / 60) ? `${Math.floor(minutes % 1440 / 60)}h` : '', minutes % 60 || minutes === 0 ? `${minutes % 60}m` : ''].filter(Boolean).join(' ');
}

function completedHistoryDateLabel(milestone) {
  if (!milestone) return 'Not recorded';
  completedHistoryDateLabel.formatter ||= new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Perth', day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' });
  if (milestone.source === 'sheet') return `${shortDateAu(milestone.date)} (RFT sheet)`;
  return milestone.dateOnly ? `${shortDateAu(milestone.date)} (date only)` : completedHistoryDateLabel.formatter.format(milestone.date);
}

function completedHistoryRows() {
  // History is retained independently of the current import file and collection UI.
  const sharedCompleted = (Array.isArray(app.sharedNavisionVisibleRows) ? app.sharedNavisionVisibleRows : [])
    .filter(item => String(item.lifecycle_state || '').toLowerCase() === 'completed')
    .map(sharedNavisionLocationVehicle);
  const candidates = app.data.concat(sharedCompleted).filter(vehicle => !isHermesSyntheticVehicle(vehicle) && (vehicle.vehicleDeliveredState === true || vehicleCollectedFromRft(vehicle)));
  const canonicalId = vehicle => String(vehicle.__emailVehicleId || vehicle.__sharedNavisionCanonicalVehicleId || vehicle.canonicalVehicleId || '').trim();
  const deduplicated = new Map();
  candidates.forEach((vehicle, index) => {
    const linkedId = canonicalId(vehicle);
    // Stock numbers can repeat across dealers. Merge only explicit record links.
    const identity = linkedId ? `vehicle:${linkedId}` : vehicle.__sharedNavisionRecordId ? `navision:${vehicle.__sharedNavisionRecordId}` : vehicle.id ? `legacy:${vehicle.id}` : `unlinked:${index}`;
    const retained = deduplicated.get(identity);
    if (!retained) { deduplicated.set(identity, vehicle); return; }
    const primary = vehicle.__emailVehicleServerAuthoritative === true && retained.__emailVehicleServerAuthoritative !== true ? vehicle : retained;
    const fallback = primary === retained ? vehicle : retained;
    const merged = { ...fallback, ...primary };
    for (const field of ['stock', 'client', 'vehicle', 'jobCardNumber', 'jobcard', 'keyNumber', 'dateToPmb', 'dateToRft', 'deliveredToDealerDate', 'dealerTransitClosedAt', 'rftTransferredAt']) {
      if (!merged[field] && fallback[field]) merged[field] = fallback[field];
    }
    // A thinner Navision mirror cannot replace the canonical identity or evidence.
    merged.lifecycleHistory = { ...(fallback.lifecycleHistory || {}), ...(primary.lifecycleHistory || {}) };
    deduplicated.set(identity, merged);
  });
  return Array.from(deduplicated.values());
}

function completedVehicleRows() {
  const q = ($('#completed-search')?.value || '').trim().toLowerCase();
  return completedHistoryRows()
    .filter(vehicle => {
      if (!q) return true;
      const hay = [
        displayStockNumber(vehicle), vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle), vehicle.client, vehicle.toyotaCustomer,
        displayVehicle(vehicle), vehicle.rftCollectedBy || '', vehicle.rftCollectedAt || '', vehicle.rftTransferredAt || '',
        ...Object.values(completedHistoryMilestones(vehicle)).map(completedHistoryDateLabel), pdcCompletedJobsText(vehicle),
      ].join(' ').toLowerCase();
      return hay.includes(q);
    })
    .sort((a, b) => {
      const timeA = completedHistoryMilestones(a).delivered?.date.getTime() || 0;
      const timeB = completedHistoryMilestones(b).delivered?.date.getTime() || 0;
      if (timeA !== timeB) return timeB - timeA;
      return String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''), undefined, { numeric: true });
    });
}

function completedHistoryCanOpen(vehicle = {}) {
  const key = vehicleKey(vehicle);
  if (!key) return false;
  const matches = app.data.filter(row => vehicleKey(row) === key);
  if (matches.length !== 1) return false;
  const canonicalId = String(vehicle.__emailVehicleId || vehicle.__sharedNavisionCanonicalVehicleId || vehicle.canonicalVehicleId || '');
  const retainedId = String(matches[0].__emailVehicleId || matches[0].canonicalVehicleId || '');
  return canonicalId ? canonicalId === retainedId : matches[0].id === vehicle.id && !vehicle.__sharedNavisionReadOnly;
}

// r756a (F361, Craig 30 Oct 11:55): the Completed page also lists Archived cars (off the board by an upload or an
// administrator, not deleted, not completed; they were on no page) and an All view of every car that has left the board.
async function loadArchivedVehicles756(force = false) {
  if (app.archivedVehicles756 && !force) return app.archivedVehicles756;
  const client = typeof window === 'object' ? window.PDC_SUPABASE : null;
  if (!client || typeof client.rpc !== 'function') return [];
  try {
    const { data, error } = await client.rpc('list_archived_vehicles_756');
    if (error || !data || data.ok !== true) return app.archivedVehicles756 || [];
    app.archivedVehicles756 = Array.isArray(data.rows) ? data.rows : [];
  } catch (_) { return app.archivedVehicles756 || []; }
  return app.archivedVehicles756;
}
function completedScope756() { return ['completed', 'archived', 'all'].includes(app.completedScope756) ? app.completedScope756 : 'completed'; }
function leftBoardRows756(scope, archived) {
  const q = ($('#completed-search')?.value || '').trim().toLowerCase();
  const when = v => { const d = v ? new Date(v) : null; return d && !Number.isNaN(d.getTime()) ? d.toLocaleString('en-AU', { timeZone: 'Australia/Perth', dateStyle: 'medium', timeStyle: 'short' }) : '—'; };
  const rows = [];
  archived.forEach(r => rows.push({ state: 'Archived', stock: r.stock_number || '', key: r.key_number || '', customer: r.customer_name || '', vehicle: r.vehicle_description || '', at: r.archived_at || '',
    detail: `${r.prior_location ? `was ${r.prior_location} · ` : ''}${r.reason || ''}${r.navision_current ? ` · still on Navision${r.navision_status ? ` (${r.navision_status})` : ''}` : ''}` }));
  if (scope === 'all') {
    completedHistoryRows().forEach(v => { const m = completedHistoryMilestones(v); rows.push({ state: 'Completed', stock: displayStockNumber(v) || '', key: vehicleKeyNumber(v) || '', customer: vehicleCustomerName(v) || '', vehicle: displayVehicle(v) || '', at: m.delivered?.date?.toISOString?.() || v.rftCollectedAt || '', detail: 'Delivered / collected' }); });
    deletedVehicleRecords().forEach(r => rows.push({ state: 'Deleted', stock: displayStockNumber(r.vehicle || {}) || r.key || '', key: vehicleKeyNumber(r.vehicle || {}) || '', customer: vehicleCustomerName(r.vehicle || {}) || '', vehicle: displayVehicle(r.vehicle || {}) || '', at: r.deletedAt || '', detail: r.deletedBy ? `by ${r.deletedBy}` : '' }));
  }
  return rows.filter(r => !q || [r.state, r.stock, r.key, r.customer, r.vehicle, r.detail].join(' ').toLowerCase().includes(q))
    .sort((a, b) => (Date.parse(b.at) || 0) - (Date.parse(a.at) || 0)).map(r => ({ ...r, whenLabel: when(r.at) }));
}
function renderLeftBoard756(host, scope, archived) {
  const rows = leftBoardRows756(scope, archived);
  const stats = $('#completed-pmb-statistics'); if (stats) stats.innerHTML = '';
  if (!rows.length) { host.innerHTML = `<div class="empty-state"><strong>${scope === 'archived' ? 'No archived vehicles' : 'No vehicles have left the board'}</strong><span>${($('#completed-search')?.value || '').trim() ? 'Clear the search to see them all.' : 'Nothing to show.'}</span></div>`; return; }
  host.innerHTML = `<div class="parts-table-wrap completed-table-wrap pdc-grid-table-wrap"><table class="data-table compact-table completed-table pdc-grid-table">
    <thead><tr>${scope === 'all' ? '<th>State</th>' : ''}<th>Stock / job card</th><th>Key</th><th>Customer / vehicle</th><th>Left the board</th><th>Detail</th></tr></thead>
    <tbody>${rows.map(r => `<tr class="completed-vehicle-row completed-left-row is-${escapeHtml(r.state.toLowerCase())}">${scope === 'all' ? `<td><span class="badge neutral">${escapeHtml(r.state)}</span></td>` : ''}<td><strong>${escapeHtml(r.stock || '—')}</strong></td><td>${escapeHtml(r.key || '—')}</td><td><strong>${escapeHtml(r.customer || 'Dealer Order')}</strong><small>${escapeHtml(r.vehicle || 'Vehicle not listed')}</small></td><td>${escapeHtml(r.whenLabel)}</td><td>${escapeHtml(r.detail || '')}</td></tr>`).join('')}</tbody></table></div>`;
}
function renderCompletedVehicles() {
  const host = $('#completed-vehicles-content');
  if (!host) return;
  const scope = typeof completedScope756 === 'function' ? completedScope756() : 'completed';
  if (typeof $$ === 'function') $$('[data-completed-scope-pick]').forEach(b => { const on = b.dataset.completedScopePick === scope; b.classList.toggle('is-selected', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
  if (scope !== 'completed') {
    const cached = app.archivedVehicles756;
    if (!cached) { host.innerHTML = '<div class="empty-state"><strong>Loading archived vehicles…</strong></div>'; void loadArchivedVehicles756().then(() => { if (completedScope756() !== 'completed') renderCompletedVehicles(); }); return; }
    renderLeftBoard756(host, scope, cached);
    return;
  }
  // r895: load the RFT spreadsheet turnaround once, then redraw so its dates and the period table show.
  if (!app.pmbTurnaround895 && !app.pmbTurnaroundLoading895 && !app.pmbTurnaroundError895 && typeof completedHistoryLoadTurnaround === 'function') {
    const pending = completedHistoryLoadTurnaround();
    if (pending && typeof pending.then === 'function') void pending.then(() => { if ((app.pmbTurnaround895 || app.pmbTurnaroundError895) && app.currentView === 'completed' && completedScope756() === 'completed') renderCompletedVehicles(); });
  }
  const rows = completedVehicleRows();
  renderCompletedPmbStatistics(rows);
  if (!rows.length) {
    const searching = ($('#completed-search')?.value || '').trim();
    host.innerHTML = searching ? '<div class="empty-state"><strong>No matching completed vehicles</strong><span>Clear the search to see the retained delivery history.</span></div>' : '<div class="empty-state"><strong>No completed vehicles yet</strong><span>Delivered vehicles appear here when Navision confirms OD – Delivered to dealer.</span></div>';
    return;
  }
  host.innerHTML = `<div class="parts-table-wrap completed-table-wrap pdc-grid-table-wrap"><table class="data-table compact-table completed-table completed-history-table pdc-grid-table">
    <thead><tr>
      <th>Stock / job card</th><th>Customer / vehicle</th><th>PMB recorded</th><th>RFT</th><th>OD recorded</th><th>PMB → RFT</th><th>RFT → OD</th><th>Total PMB → OD</th><th>History</th>
    </tr></thead>
    <tbody>${rows.map(vehicle => {
      const key = vehicleKey(vehicle);
      const canOpen = completedHistoryCanOpen(vehicle);
      const milestones = completedHistoryMilestones(vehicle);
      return `<tr class="completed-vehicle-row">
        <td>${canOpen ? `<button class="stock-link stock-button" type="button" data-open-stock="${escapeHtml(key)}">${escapeHtml(displayStockNumber(vehicle) || '—')}</button>` : `<strong>${escapeHtml(displayStockNumber(vehicle) || '—')}</strong>`}<small>${escapeHtml(vehicleJobcardNumber(vehicle) || 'Job card not recorded')}</small></td>
        <td><strong>${escapeHtml(vehicleCustomerName(vehicle) || 'Dealer Order')}</strong><small>${escapeHtml(displayVehicle(vehicle) || 'Vehicle not listed')}</small></td>
        ${['pmb', 'rft', 'delivered'].map(name => `<td>${escapeHtml(completedHistoryDateLabel(milestones[name]))}</td>`).join('')}
        ${['pmbToRft', 'rftToOd', 'pmbToOd'].map(name => `<td class="completed-history-duration">${escapeHtml(completedHistoryDurationLabel(completedHistoryInterval(vehicle, name, milestones)))}</td>`).join('')}
        <td><details><summary>Details</summary><dl><dt>Key</dt><dd>${escapeHtml(vehicleKeyNumber(vehicle) || 'Not recorded')}</dd><dt>Collected</dt><dd>${escapeHtml(completedHistoryDateLabel(completedHistoryMilestone(vehicle.rftCollectedAt)))}</dd><dt>Collected by</dt><dd>${escapeHtml(vehicle.rftCollectedBy || 'Not recorded')}</dd><dt>Completed stations</dt><dd>${escapeHtml(pdcGridCompletedJobsText(vehicle) || 'Not recorded')}</dd></dl>${canOpen ? `<button class="small-button" type="button" data-open-stock="${escapeHtml(key)}">Open vehicle</button>` : ''}</details></td>
      </tr>`;
    }).join('')}</tbody></table></div>`;
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
}

function deletedVehiclesSearchText(record = {}) {
  const vehicle = record.vehicle || {};
  return [
    record.key, record.deletedAt, record.deletedBy, record.deletedRole,
    displayStockNumber(vehicle), vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle),
    vehicle.client, vehicle.toyotaCustomer, displayVehicle(vehicle), auditTrailForVehicle(vehicle).map(entry => `${entry.action} ${entry.by} ${entry.at}`).join(' '),
  ].join(' ').toLowerCase();
}

function deletedVehicleRows() {
  const q = ($('#deleted-search')?.value || '').trim().toLowerCase();
  return deletedVehicleRecords()
    .filter(record => !q || deletedVehiclesSearchText(record).includes(q))
    .sort((a, b) => {
      const timeA = parseIsoTimestamp(a.deletedAt || '')?.getTime() || 0;
      const timeB = parseIsoTimestamp(b.deletedAt || '')?.getTime() || 0;
      return timeB - timeA;
    });
}

function deletedVehicleSnapshotRecord(row = {}) {
  const tombstone = row.tombstone && typeof row.tombstone === 'object' ? row.tombstone : row;
  const vehicleSnapshot = row.vehicle_snapshot && typeof row.vehicle_snapshot === 'object' ? row.vehicle_snapshot : {};
  const events = Array.isArray(row.lifecycle_events) ? row.lifecycle_events : [];
  return {
    ...row,
    tombstoneId: row.tombstone_id || tombstone.tombstone_id || '',
    id: row.vehicle_id || row.id || tombstone.vehicle_id || tombstone.id || '',
    version: Number(row.version ?? tombstone.version ?? vehicleSnapshot.version ?? 0),
    stockNumber: row.stock_number || tombstone.stock_number || '',
    customerName: row.customer_name || tombstone.customer_name || vehicleSnapshot.customer_name || '',
    vehicleDescription: row.vehicle_description || vehicleSnapshot.vehicle_description || [row.make || tombstone.make || vehicleSnapshot.make, row.model || tombstone.model || vehicleSnapshot.model].filter(Boolean).join(' '),
    deletedAt: row.deleted_at || row.archived_at || tombstone.deleted_at || tombstone.archived_at || '',
    deletedBy: row.deleted_by_email || row.deleted_by || row.archived_by || tombstone.deleted_by_email || tombstone.deleted_by || tombstone.archived_by || '',
    deleteReason: row.delete_reason || row.archive_reason || row.reason || tombstone.delete_reason || tombstone.reason || '',
    resetEligible: (row.tombstone_kind || tombstone.tombstone_kind) === 'staging_reset',
    restored: events.some(event => event?.event_kind === 'restored'),
    recreationAllowed: events.some(event => event?.event_kind === 'recreation_authorized')
      && !events.some(event => event?.event_kind === 'recreation_consumed'),
    recreationConsumed: events.some(event => event?.event_kind === 'recreation_consumed'),
    lifecycleHistory: row.lifecycle_history && typeof row.lifecycle_history === 'object' ? row.lifecycle_history : {},
  };
}

async function loadDeletedVehicleSnapshot({ force = false } = {}) {
  if (!vehicleLifecycleAdministratorActive() || !vehicleLifecycleSharedModeActive()
      || typeof window.__vehicleLifecycleActions?.adminDeletedVehicleSnapshot !== 'function') return false;
  if (!force && ['loading', 'ready'].includes(app.deletedVehicleSnapshotState)) return true;
  const generation = ++app.deletedVehicleSnapshotGeneration;
  app.deletedVehicleSnapshotState = 'loading';
  app.deletedVehicleSnapshotError = '';
  const result = await window.__vehicleLifecycleActions.adminDeletedVehicleSnapshot();
  if (generation !== app.deletedVehicleSnapshotGeneration) return false;
  if (!result || result.ok === false || result.error) {
    app.deletedVehicleSnapshotState = 'error';
    app.deletedVehicleSnapshotError = vehicleLifecycleActionErrorMessage(result);
  } else {
    const payload = result?.data && typeof result.data === 'object' ? result.data : result;
    const rows = Array.isArray(payload) ? payload : (payload?.items || payload?.vehicles || payload?.deleted_vehicles || payload?.rows || []);
    app.deletedVehicleSnapshotRows = rows.map(deletedVehicleSnapshotRecord);
    app.deletedVehicleSnapshotState = 'ready';
  }
  if (app.currentView === 'deleted') renderDeletedVehicles();
  return app.deletedVehicleSnapshotState === 'ready';
}

async function runDeletedVehicleAdminAction(tombstoneId, action) {
  if (!vehicleLifecycleAdministratorActive()) return false;
  const row = app.deletedVehicleSnapshotRows.find(item => String(item.tombstoneId) === String(tombstoneId));
  if (!row || row.restored) return false;
  const label = action === 'restore' ? 'Restore Vehicle' : 'Allow one controlled recreation';
  if (action !== 'restore' && (!row.resetEligible || row.recreationAllowed || row.recreationConsumed)) return false;
  if (!window.confirm(`${label}\n\nStock Number: ${row.stockNumber}\nCustomer: ${row.customerName || 'Unknown customer'}\nVehicle UUID: ${row.id}\nTombstone type: ${row.resetEligible ? 'Staging reset' : 'Manual delete'}\n\nContinue to exact Stock Number confirmation?`)) return false;
  const stockConfirmation = window.prompt(`Type the exact Stock Number (${row.stockNumber}) to confirm:`, '') ?? '';
  if (stockConfirmation !== row.stockNumber) {
    pdcNotify('Stock Number confirmation did not match exactly. No vehicle was changed.');
    return false;
  }
  const reason = cleanNavisionText(window.prompt(`Reason for ${label.toLowerCase()} (required):`, '') || '');
  if (!reason) {
    pdcNotify('A reason is required. No vehicle was changed.');
    return false;
  }
  let evidenceBinding = {};
  if (action !== 'restore') {
    const sourceHash = window.prompt('Authenticated email source SHA-256 (64 lowercase hex characters):', '') ?? '';
    const evidenceHash = window.prompt('Authenticated email evidence SHA-256 (64 lowercase hex characters):', '') ?? '';
    const sourceUid = window.prompt('Exact authenticated email source UID:', '') ?? '';
    if (!/^[a-f0-9]{64}$/.test(sourceHash) || !/^[a-f0-9]{64}$/.test(evidenceHash) || sourceUid.length < 1 || sourceUid.length > 100) {
      pdcNotify('Exact authenticated email evidence is required. No recreation was authorized.');
      return false;
    }
    evidenceBinding = { sourceHash, evidenceHash, sourceUid };
  }
  const method = action === 'restore' ? 'adminRestoreVehicle' : 'adminAllowOneVehicleRecreation';
  const result = await window.__vehicleLifecycleActions[method]({ tombstoneId, stockConfirmation, reason, ...evidenceBinding });
  if (!result || result.ok !== true) {
    pdcNotify(vehicleLifecycleActionErrorMessage(result));
    await loadDeletedVehicleSnapshot({ force: true });
    await refreshVehicleLifecycleLocationsAndRender();
    return false;
  }
  await loadDeletedVehicleSnapshot({ force: true });
  await refreshVehicleLifecycleLocationsAndRender();
  return true;
}

function renderDeletedVehicles() {
  const host = $('#deleted-vehicles-content');
  if (!host) return;
  if (!vehicleLifecycleAdministratorActive()) {
    host.innerHTML = '<div class="empty-state"><strong>Administrator access required</strong><span>Deleted vehicle tombstones and lifecycle actions are restricted to Administrators.</span></div>';
    return;
  }
  if (!vehicleLifecycleSharedModeActive()) {
    host.innerHTML = '<div class="empty-state"><strong>Shared lifecycle unavailable</strong><span>Deleted vehicles cannot be managed from local browser storage.</span></div>';
    return;
  }
  if (app.deletedVehicleSnapshotState === 'idle') {
    host.innerHTML = '<div class="empty-state"><strong>Loading Deleted Vehicles…</strong></div>';
    loadDeletedVehicleSnapshot();
    return;
  }
  if (app.deletedVehicleSnapshotState === 'loading') {
    host.innerHTML = '<div class="empty-state"><strong>Loading Deleted Vehicles…</strong></div>';
    return;
  }
  if (app.deletedVehicleSnapshotState === 'error') {
    host.innerHTML = `<div class="empty-state"><strong>Could not load Deleted Vehicles</strong><span>${escapeHtml(app.deletedVehicleSnapshotError)}</span></div>`;
    return;
  }
  const q = ($('#deleted-search')?.value || '').trim().toLowerCase();
  const rows = app.deletedVehicleSnapshotRows.filter(row => !q || [row.stockNumber, row.customerName, row.vehicleDescription, row.id, row.deletedBy, row.deleteReason].join(' ').toLowerCase().includes(q));
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No deleted vehicles</strong><span>No matching server tombstones were returned.</span></div>';
    return;
  }
  host.innerHTML = `<div class="incoming-vertical-list deleted-compact-list">${rows.map(row => `
    <details class="incoming-vehicle-card deleted-vehicle-row">
      <summary class="incoming-vehicle-summary"><strong>${escapeHtml(row.stockNumber || 'No stock number')}</strong><span>${escapeHtml(row.customerName || 'Unknown customer')}</span><span class="parts-status-pill blocked">Deleted</span></summary>
      <div class="incoming-vehicle-detail-grid deleted-vehicle-detail-grid">
        <div><b>Stock Number</b><span>${escapeHtml(row.stockNumber || '—')}</span></div>
        <div><b>Customer</b><span>${escapeHtml(row.customerName || '—')}</span></div>
        <div><b>Vehicle</b><span>${escapeHtml(row.vehicleDescription || '—')}</span></div>
        <div><b>Vehicle UUID</b><span>${escapeHtml(row.id || '—')}</span></div>
        <div><b>Deleted at</b><span>${escapeHtml(row.deletedAt || '—')}</span></div>
        <div><b>Deleted by</b><span>${escapeHtml(row.deletedBy || '—')}</span></div>
        <div class="wide"><b>Reason</b><span>${escapeHtml(row.deleteReason || '—')}</span></div>
        <div class="wide">${lifecycleHistoryHtml(row, { lifecycle_history: row.lifecycleHistory })}</div>
        <div class="wide deleted-card-actions">
          <button class="small-button primary" type="button" data-restore-deleted-vehicle="${escapeHtml(row.tombstoneId)}" ${row.restored ? 'disabled title="Vehicle has already been restored"' : ''}>Restore Vehicle</button>
          ${row.resetEligible ? `<button class="small-button" type="button" data-allow-vehicle-recreation="${escapeHtml(row.tombstoneId)}" ${(row.recreationAllowed || row.recreationConsumed || row.restored) ? `disabled title="${row.recreationConsumed ? 'One-time recreation permission was consumed' : row.restored ? 'Vehicle has been restored' : 'One controlled recreation is already allowed'}"` : ''}>Allow one controlled recreation</button>` : ''}
        </div>
      </div>
    </details>`).join('')}</div>`;
  $$('[data-restore-deleted-vehicle]', host).forEach(button => button.addEventListener('click', () => runDeletedVehicleAdminAction(button.dataset.restoreDeletedVehicle, 'restore')));
  $$('[data-allow-vehicle-recreation]', host).forEach(button => button.addEventListener('click', () => runDeletedVehicleAdminAction(button.dataset.allowVehicleRecreation, 'recreate')));
}

function sharedNavisionVisibleData(result = null) {
  return result?.data?.data || result?.data || null;
}

function sharedNavisionVisibilityConfigured() {
  const service = navisionSharedBackendService();
  return Boolean(service && typeof service.visibleSnapshot === 'function');
}

function sharedNavisionLocationAuthorityReady() {
  if (!sharedNavisionVisibilityConfigured()) return true;
  return app.sharedNavisionVisibleState === 'ready' &&
    app.sharedNavisionVisibleRealtimeState === 'subscribed' &&
    app.sharedNavisionVisibleRealtimeReconciled === true;
}

function vehicleLocationActionAllowed(vehicleOrKey, operation = 'change') {
  if (!sharedNavisionLocationAuthorityReady()) {
    console.warn('Vehicle action blocked while shared Navision identity authority is not reconciled.', { operation });
    return false;
  }
  vehicleLocationBoardRows();
  const vehicle = vehicleOrKey && typeof vehicleOrKey === 'object' ? vehicleOrKey : selectedVehicle(vehicleOrKey);
  if (!vehicle) return false;
  const key = vehicleKey(vehicle);
  if (app.sharedNavisionLocationReadOnlyKeys?.has(key)) {
    if (operation === 'open') return true;
    if (operation === 'transfer to PMB'
      && vehicle.__emailVehicleServerAuthoritative === true
      && vehicle.__locationIdentityReadOnly !== true
      && vehicleLifecycleSharedModeActive()
      && typeof window.__vehicleLifecycleActions?.pmbTransferVehicle === 'function') return true;
    if (operation === 'delete'
      && vehicle.__emailVehicleServerAuthoritative === true
      && vehicleLifecycleAdministratorActive()
      && vehicleLifecycleSharedModeActive()
      && typeof window.__vehicleLifecycleActions?.adminArchiveVehicle === 'function') return true;
    console.warn('Vehicle action blocked because the Locations identity is read-only.', { operation, key });
    return false;
  }
  return true;
}

function renderSharedNavisionVisibilityState() {
  renderBackEndData();
  if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
  if (app.currentView === 'bus-pit') renderBusPitInspections();
}

function clearSharedNavisionVisibilityReconnectTimer() {
  if (app.sharedNavisionVisibleReconnectTimer) clearTimeout(app.sharedNavisionVisibleReconnectTimer);
  app.sharedNavisionVisibleReconnectTimer = null;
  if (app.sharedNavisionVisibleStableTimer) clearTimeout(app.sharedNavisionVisibleStableTimer);
  app.sharedNavisionVisibleStableTimer = null;
}

function releaseSharedNavisionVisibilityChannel() {
  if (app.sharedNavisionVisibleStableTimer) clearTimeout(app.sharedNavisionVisibleStableTimer);
  app.sharedNavisionVisibleStableTimer = null;
  app.sharedNavisionVisibleRealtimeReconciled = false;
  const channel = app.sharedNavisionVisibleRealtime;
  app.sharedNavisionVisibleRealtime = null;
  app.sharedNavisionVisibleRealtimeGeneration += 1;
  if (!channel) return;
  try {
    if (window.PDC_SUPABASE && typeof window.PDC_SUPABASE.removeChannel === 'function') {
      window.PDC_SUPABASE.removeChannel(channel);
    } else if (typeof channel.unsubscribe === 'function') {
      channel.unsubscribe();
    }
  } catch (_err) { /* best-effort teardown */ }
}

function scheduleSharedNavisionVisibilityReconnect() {
  if (app.sharedNavisionVisibleReconnectTimer || !window.PDC_AUTH_CONTEXT || !sharedNavisionVisibilityConfigured()) return;
  const delay = Math.min(30000, 1000 * (2 ** Math.min(app.sharedNavisionVisibleReconnectAttempt, 5)));
  app.sharedNavisionVisibleReconnectAttempt += 1;
  app.sharedNavisionVisibleReconnectTimer = setTimeout(() => {
    app.sharedNavisionVisibleReconnectTimer = null;
    subscribeSharedNavisionVisibility();
  }, delay);
}

function subscribeSharedNavisionVisibility() {
  if (app.sharedNavisionVisibleRealtime || !window.PDC_AUTH_CONTEXT || !sharedNavisionVisibilityConfigured()) return;
  const client = window.PDC_SUPABASE;
  if (!client || typeof client.channel !== 'function') return;
  clearSharedNavisionVisibilityReconnectTimer();
  const generation = ++app.sharedNavisionVisibleRealtimeGeneration;
  app.sharedNavisionVisibleRealtimeState = 'connecting';
  const channel = client
    .channel('pdc_navision_visible_revision')
    .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'navision_backend_revision' }, (typeof pdcBurstGate === 'function' ? pdcBurstGate : f => f)(payload => { // r619 (F234)
      if (generation !== app.sharedNavisionVisibleRealtimeGeneration || app.sharedNavisionVisibleRealtime !== channel) return;
      const revision = Number(payload?.new?.revision);
      if (!Number.isFinite(revision) || revision !== Number(app.sharedNavisionVisibleRevision)) {
        if (app.vehicleLocationsRefreshCoordinator) void refreshVehicleLocations({ supersede: true, deferSupersede: true });
        else loadSharedNavisionVisibleRows({ force: true });
      }
    }));
  app.sharedNavisionVisibleRealtime = channel;
  channel.subscribe(status => {
    if (generation !== app.sharedNavisionVisibleRealtimeGeneration || app.sharedNavisionVisibleRealtime !== channel) return;
    if (status === 'SUBSCRIBED') {
      const firstHealthySubscription = app.sharedNavisionVisibleRealtimeState !== 'subscribed';
      app.sharedNavisionVisibleRealtimeState = 'subscribed';
      if (firstHealthySubscription) app.sharedNavisionVisibleRealtimeReconciled = false;
      if (app.sharedNavisionVisibleStableTimer) clearTimeout(app.sharedNavisionVisibleStableTimer);
      app.sharedNavisionVisibleStableTimer = setTimeout(() => {
        if (generation === app.sharedNavisionVisibleRealtimeGeneration && app.sharedNavisionVisibleRealtime === channel && app.sharedNavisionVisibleRealtimeState === 'subscribed') {
          app.sharedNavisionVisibleReconnectAttempt = 0;
        }
        app.sharedNavisionVisibleStableTimer = null;
      }, 10000);
      renderSharedNavisionVisibilityState();
      // Check the revision after subscription to close the load/subscribe race
      // without discarding and repeating an unchanged multi-page download.
      if (firstHealthySubscription) void reconcileSharedNavisionVisibility(generation, channel);
      return;
    }
    if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT' || status === 'CLOSED') {
      app.sharedNavisionVisibleRealtimeState = 'reconnecting';
      releaseSharedNavisionVisibilityChannel();
      renderSharedNavisionVisibilityState();
      scheduleSharedNavisionVisibilityReconnect();
    }
  });
}

async function reconcileSharedNavisionVisibility(generation, channel) {
  const service = navisionSharedBackendService();
  const current = () => generation === app.sharedNavisionVisibleRealtimeGeneration
    && channel === app.sharedNavisionVisibleRealtime && app.sharedNavisionVisibleRealtimeState === 'subscribed';
  const result = await service?.visibleRevision?.();
  if (!current()) return;
  // The first download may still be running. Its revision can prove that it
  // already contains everything observed by the post-subscription check.
  if (app.sharedNavisionVisibleLoadPromise) await app.sharedNavisionVisibleLoadPromise;
  if (!current()) return;
  if (result?.ok && app.sharedNavisionVisibleState === 'ready'
      && app.sharedNavisionVisibleRevision != null
      && Number(app.sharedNavisionVisibleRevision) >= result.revision) {
    app.sharedNavisionVisibleRealtimeReconciled = true;
    renderSharedNavisionVisibilityState();
    return;
  }
  return loadSharedNavisionVisibleRows({ force: true });
}

function loadSharedNavisionVisibleRows(options = {}) {
  if (app.sharedNavisionVisibleState === 'loading' && options.force !== true) return app.sharedNavisionVisibleLoadPromise;
  const pending = readSharedNavisionVisibleRows(options).finally(() => {
    if (app.sharedNavisionVisibleLoadPromise === pending) app.sharedNavisionVisibleLoadPromise = null;
  });
  app.sharedNavisionVisibleLoadPromise = pending;
  return pending;
}

async function readSharedNavisionVisibleRows(options = {}) {
  const force = options.force === true;
  const refreshGeneration = options.refreshGeneration;
  if (app.sharedNavisionVisibleState === 'loading' && !force) return;
  const service = navisionSharedBackendService();
  if (!service || typeof service.visibleSnapshot !== 'function') {
    app.sharedNavisionVisibleState = 'idle';
    app.sharedNavisionVisibleError = '';
    return { ok: false, error: 'shared_navision_service_unavailable' };
  }
  subscribeSharedNavisionVisibility();

  // Only a read begun under this established subscription can independently
  // prove freshness. An initial/reconnecting read may miss a revision before
  // subscription, so its result must await the post-subscription revision check.
  const subscribedChannel = app.sharedNavisionVisibleRealtimeState === 'subscribed' ? app.sharedNavisionVisibleRealtime : null;
  const subscriptionGeneration = app.sharedNavisionVisibleRealtimeGeneration;
  const generation = ++app.sharedNavisionVisibleGeneration;
  if (app.sharedNavisionVisibleRealtimeState === 'subscribed') app.sharedNavisionVisibleRealtimeReconciled = false;
  app.sharedNavisionVisibleState = 'loading';
  app.sharedNavisionVisibleError = '';
  let refreshResult = { ok: true };
  renderBackEndData();
  if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
  try {
    let expectedRevision = null;
    const dealerRows = await Promise.all(['14450', '37047', '002345', '001234'].map(async dealerCode => {
      const rows = [];
      let cursor = {};
      let pageCount = 0;
      let exhausted = false;
      while (pageCount < 25) {
        if (generation !== app.sharedNavisionVisibleGeneration) return [];
        const result = await service.visibleSnapshot(
          { sourceSystem: 'microsoft_navision', dealerCode },
          cursor,
          500,
          expectedRevision,
        );
        if (generation !== app.sharedNavisionVisibleGeneration) return [];
        if (refreshGeneration != null && refreshGeneration !== app.vehicleLocationsRefreshGeneration) return [];
        if (!result?.ok) throw new Error(result?.error || 'shared_navision_visibility_failed');
        const data = sharedNavisionVisibleData(result) || {};
        const revision = Number(data.revision);
        if (!Number.isFinite(revision)) throw new Error('shared_navision_revision_missing');
        if (expectedRevision === null) expectedRevision = revision;
        if (revision !== expectedRevision) throw new Error('shared_navision_revision_changed');
        (Array.isArray(data.items) ? data.items : []).forEach(item => rows.push({ ...item, dealer_code: item.dealer_code || dealerCode }));
        pageCount += 1;
        if (!data.has_more) {
          exhausted = true;
          break;
        }
        if (!data.next_record_id) throw new Error('shared_navision_cursor_missing');
        cursor = { recordId: data.next_record_id };
      }
      if (!exhausted) throw new Error('shared_navision_page_limit_exceeded');
      return rows;
    }));
    if (generation !== app.sharedNavisionVisibleGeneration) return { ok: false, stale: true };
    if (refreshGeneration != null && refreshGeneration !== app.vehicleLocationsRefreshGeneration) return { ok: false, stale: true };
    app.sharedNavisionVisibleRows = dealerRows.flat();
    app.sharedNavisionVisibleRevision = expectedRevision;
    app.sharedNavisionVisibleState = 'ready';
    app.sharedNavisionVisibleRealtimeReconciled = Boolean(subscribedChannel)
      && subscribedChannel === app.sharedNavisionVisibleRealtime
      && subscriptionGeneration === app.sharedNavisionVisibleRealtimeGeneration
      && app.sharedNavisionVisibleRealtimeState === 'subscribed';
  } catch (error) {
    if (generation !== app.sharedNavisionVisibleGeneration) return { ok: false, stale: true };
    if (refreshGeneration != null && refreshGeneration !== app.vehicleLocationsRefreshGeneration) return { ok: false, stale: true };
    console.error('Shared Navision visibility load failed', error);
    app.sharedNavisionVisibleState = 'error';
    app.sharedNavisionVisibleRealtimeReconciled = false;
    app.sharedNavisionVisibleError = error?.message || 'Shared Navision imports could not be loaded.';
    refreshResult = { ok: false, error: app.sharedNavisionVisibleError };
  }
  if (refreshGeneration == null || refreshGeneration === app.vehicleLocationsRefreshGeneration) {
    renderBackEndData();
    if (app.currentView === 'dashboard') renderIncomingDashboardBoard();
    if (app.currentView === 'bus-pit') renderBusPitInspections();
  }
  return { ...refreshResult, revision: app.sharedNavisionVisibleRevision, count: app.sharedNavisionVisibleRows.length };
}

function sharedNavisionIdentityToken(value = '') {
  return cleanNavisionText(value).toUpperCase();
}

function sharedNavisionItemIdentityKeys(item = {}) {
  return [
    item.stock_number ? `stock:${sharedNavisionIdentityToken(item.stock_number)}` : '',
  ].filter(key => !key.endsWith(':'));
}

function vehicleSharedNavisionIdentityKeys(vehicle = {}) {
  const stock = vehicle.stock || vehicle.stockNumber || vehicle.batch || '';
  const dealer = vehicle.dealer_code || vehicle.dealerCode || vehicle.navisionDealerCode || vehicle.toyotaDealerCode || vehicle.__sharedNavisionDealerCode || '';
  return [
    stock ? `stock:${sharedNavisionIdentityToken(stock)}` : '',
    dealer ? `dealer:${sharedNavisionIdentityToken(dealer)}` : '',
  ].filter(key => !key.endsWith(':'));
}

function sharedNavisionLocationVehicle(item = {}) {
  const completed = String(item.lifecycle_state || '').toLowerCase() === 'completed';
  const canonicalLocation = cleanNavisionText(item.current_location || '');
  const lifecycleHistory = item.lifecycle_history && typeof item.lifecycle_history === 'object' ? item.lifecycle_history : {};
  return {
    id: `shared-navision-${item.id || sharedNavisionIdentityToken(item.stock_number)}`,
    canonicalVehicleId: item.canonical_vehicle_id || '',
    sharedVehicleId: item.canonical_vehicle_id || '',
    stock: item.stock_number || '',
    batch: item.stock_number || '',
    client: item.customer_name || '',
    toyotaCustomer: item.customer_name || '',
    consultant: item.salesperson || '',
    vehicle: [item.model, item.colour].filter(Boolean).join(' · '),
    toyotaVehicle: item.model || '',
    colour: item.colour || '',
    toyotaStatus: item.vehicle_status || '',
    navisionLocationStatus: item.vehicle_status || '',
    etaAtDealer: item.eta_to_kewdale || '',
    navisionKewdaleEta: item.eta_to_kewdale || '',
    dateToPmb: item.date_to_pmb || '',
    dateToRft: item.date_to_rft || '',
    deliveredToDealerDate: item.delivered_to_dealer_date || '',
    firstReachedYardHoldAt: lifecycleHistory.first_reached_yard_hold_at || item.first_reached_yard_hold_at || '',
    firstEnteredPmbAt: lifecycleHistory.first_entered_pmb_at || item.first_entered_pmb_at || '',
    firstBecameRftAt: lifecycleHistory.first_became_rft_at || item.first_became_rft_at || '',
    lifecycleHistory,
    pdcLocation: completed ? 'Completed' : (canonicalLocation || currentPdcLocationFromNavision({
      navisionLocationStatus: item.vehicle_status || '',
      toyotaStatus: item.vehicle_status || '',
    })),
    lifecycleState: item.lifecycle_state || (completed ? 'completed' : 'active'),
    pdcLifecycleState: item.lifecycle_state || (completed ? 'completed' : 'active'),
    vehicleDeliveredState: completed,
    dealerTransitClosedAt: item.dealer_transit_closed_at || (completed ? item.completed_at || '' : ''),
    dealerTransitStartedAt: item.dealer_transit_started_at || '', // r956 (F529): RFT -> OD list reads the RFT'd tick
    dealerTransitDurationSeconds: item.dealer_transit_duration_seconds ?? null,
    completedVehicle: completed,
    rftCollected: Boolean(item.rft_collected_at),
    rftCollectedAt: item.rft_collected_at || '',
    rftCollectedBy: item.rft_collected_by || '',
    completionReason: item.completion_reason || '',
    importedAt: item.updated_at || '',
    source: 'Shared Navision',
    pdcSheetVisible: true,
    __sharedNavisionReadOnly: true,
    __sharedNavisionRecordId: item.id || '',
    __sharedNavisionDealerCode: item.dealer_code || '',
    __sharedNavisionBoardActivated: item.board_activated === true,
    __sharedNavisionActivationSource: item.activation_source || '',
    __sharedNavisionCanonicalVehicleId: item.canonical_vehicle_id || '',
    __sharedNavisionCanonicalLocation: canonicalLocation,
  };
}

function sharedNavisionIdentityPartsFromItem(item = {}) {
  return {
    stock: sharedNavisionIdentityToken(item.stock_number || ''),
    dealer: sharedNavisionIdentityToken(item.dealer_code || ''),
  };
}

function sharedNavisionIdentityPartsFromVehicle(vehicle = {}) {
  return {
    stock: sharedNavisionIdentityToken(vehicle.stock || vehicle.stockNumber || vehicle.batch || ''),
    dealer: sharedNavisionIdentityToken(vehicle.dealer_code || vehicle.dealerCode || vehicle.navisionDealerCode || vehicle.toyotaDealerCode || vehicle.__sharedNavisionDealerCode || ''),
  };
}

function sharedNavisionIdentityRelation(vehicle = {}, item = {}) {
  const local = sharedNavisionIdentityPartsFromVehicle(vehicle);
  const shared = sharedNavisionIdentityPartsFromItem(item);
  const stockMatch = Boolean(local.stock && shared.stock && local.stock === shared.stock);
  const dealerConflict = Boolean(local.dealer && shared.dealer && local.dealer !== shared.dealer);
  if (stockMatch && dealerConflict) return 'conflict';
  if (stockMatch && !dealerConflict) return 'match';
  return 'unrelated';
}

function localLocationIdentitySignature(vehicle = {}) {
  const keys = vehicleSharedNavisionIdentityKeys(vehicle).sort();
  return keys.length ? keys.join('|') : `record:${String(vehicle.id || vehicleKey(vehicle) || '')}`;
}

function deduplicateLocalLocationRows(rows = []) {
  const bySignature = new Map();
  (Array.isArray(rows) ? rows : []).forEach(vehicle => {
    const signature = localLocationIdentitySignature(vehicle);
    if (!bySignature.has(signature)) {
      bySignature.set(signature, vehicle);
      return;
    }
    const retained = bySignature.get(signature);
    bySignature.set(signature, {
      ...retained,
      __locationIdentityReadOnly: true,
      __locationIdentityConflictCount: Number(retained.__locationIdentityConflictCount || 1) + 1,
    });
  });
  return Array.from(bySignature.values());
}

function activeSharedNavisionRows(rows = app.sharedNavisionVisibleRows) {
  const seenSignatures = new Set();
  return (Array.isArray(rows) ? rows : []).filter(item => {
    if (item?.is_current !== true) return false;
    const identity = sharedNavisionItemIdentityKeys(item).sort().join('|') || `record:${String(item.id || '')}`;
    const signature = [
      `dealer:${sharedNavisionIdentityToken(item.dealer_code || '')}`,
      identity,
      `status:${cleanNavisionText(item.vehicle_status || '')}`,
      `eta:${cleanNavisionText(item.eta_to_kewdale || '')}`,
      `model:${cleanNavisionText(item.model || '')}`,
      `colour:${cleanNavisionText(item.colour || '')}`,
    ].join('|');
    if (seenSignatures.has(signature)) return false;
    seenSignatures.add(signature);
    return true;
  });
}

function vehicleLocationBoardRows(localRows = pdcSheetVehicles(), sharedRows = app.sharedNavisionVisibleRows) {
  const emailModule = window.PDC_EMAIL_VEHICLE_LOCATION_SERVICE;
  if (typeof emailModule?.reconcileVehicleRows === 'function') {
    const reconciled = emailModule.reconcileVehicleRows(localRows, app.emailVehicleLocationRows).rows;
    localRows = applyPendingSharedWorkStateOverlays(reconciled);
  }
  localRows = applySharedWorkStateCache(localRows);
  const currentShared = activeSharedNavisionRows(sharedRows);
  const localVehicles = deduplicateLocalLocationRows(localRows);
  const sharedByStock = new Map();
  const sharedByCanonicalVehicleId = new Map();
  currentShared.forEach(item => {
    const canonicalId = String(item.canonical_vehicle_id || '').trim();
    if (canonicalId) {
      const canonicalBucket = sharedByCanonicalVehicleId.get(canonicalId) || [];
      canonicalBucket.push(item);
      sharedByCanonicalVehicleId.set(canonicalId, canonicalBucket);
    }
    const stock = sharedNavisionIdentityPartsFromItem(item).stock;
    if (!stock) return;
    const bucket = sharedByStock.get(stock) || [];
    bucket.push(item);
    sharedByStock.set(stock, bucket);
  });
  const candidatesByLocal = new Map();
  const conflictsByLocal = new Map();
  const sharedCandidateCounts = new Map();

  localVehicles.forEach(vehicle => {
    const localIdentity = sharedNavisionIdentityPartsFromVehicle(vehicle);
    // Authenticated email rows carry the canonical vehicles.id used by Parts
    // RPCs. Prefer the shared Navision projection's canonical_vehicle_id when
    // present; stock is only the legacy fallback. This prevents a projection
    // with a changed/display-only stock from becoming a second ambiguous row.
    const canonicalId = String(vehicle.__emailVehicleId || '').trim();
    const canonicalCandidates = canonicalId ? (sharedByCanonicalVehicleId.get(canonicalId) || []) : [];
    const stockCandidates = localIdentity.stock ? (sharedByStock.get(localIdentity.stock) || []) : [];
    const candidates = canonicalCandidates.length ? canonicalCandidates : stockCandidates;
    const matches = candidates.filter(item => {
      const sharedIdentity = sharedNavisionIdentityPartsFromItem(item);
      return !(localIdentity.dealer && sharedIdentity.dealer && localIdentity.dealer !== sharedIdentity.dealer);
    });
    const hasConflict = candidates.some(item => {
      const sharedIdentity = sharedNavisionIdentityPartsFromItem(item);
      return Boolean(localIdentity.dealer && sharedIdentity.dealer && localIdentity.dealer !== sharedIdentity.dealer);
    });
    candidatesByLocal.set(vehicle, matches);
    conflictsByLocal.set(vehicle, hasConflict);
    matches.forEach(item => sharedCandidateCounts.set(item, Number(sharedCandidateCounts.get(item) || 0) + 1));
  });

  const consumedShared = new Set();
  const mergedLocal = localVehicles.map(vehicle => {
    const matches = candidatesByLocal.get(vehicle) || [];
    const hasConflictingIdentity = conflictsByLocal.get(vehicle) === true;
    const mayMergeAuthoritativeNavision = !vehicle.__locationIdentityReadOnly || vehicle.__emailVehicleServerAuthoritative === true;
    const item = mayMergeAuthoritativeNavision && matches.length === 1 && sharedCandidateCounts.get(matches[0]) === 1 ? matches[0] : null;
    const identityAmbiguous = Boolean(vehicle.__locationIdentityReadOnly || hasConflictingIdentity || matches.length > 1 || (matches.length === 1 && !item));
    if (!item) return identityAmbiguous ? { ...vehicle, __locationIdentityReadOnly: true } : vehicle;
    consumedShared.add(item);
    const shared = sharedNavisionLocationVehicle(item);
    // Canonical operating state can be newer than the separate Navision reader.
    // Its source status/ETA may refresh without undoing QC, rework or collection.
    const authoritativeLocation = vehicle.__emailVehicleLocationAuthoritative === true
      && vehicle.__emailVehicleServerAuthoritative === true ? cleanNavisionText(vehicle.pdcLocation) : '';
    return {
      ...shared,
      ...vehicle,
      toyotaStatus: shared.toyotaStatus,
      navisionLocationStatus: shared.navisionLocationStatus,
      pdcLocation: authoritativeLocation || shared.pdcLocation || vehicle.pdcLocation || '',
      __sharedNavisionCanonicalLocation: authoritativeLocation || shared.__sharedNavisionCanonicalLocation || '',
      etaAtDealer: shared.etaAtDealer,
      navisionKewdaleEta: shared.navisionKewdaleEta,
      importedAt: shared.importedAt || vehicle.importedAt || '',
      __sharedNavisionReadOnly: false,
      __locationIdentityReadOnly: identityAmbiguous,
      __sharedNavisionRecordId: item.id || '',
    };
  });
  const sharedOnly = currentShared
    .filter(item => !consumedShared.has(item))
    .filter(item => item.board_activated === true)
    .map(sharedNavisionLocationVehicle);
  const result = mergedLocal.concat(sharedOnly);
  app.sharedNavisionLocationReadOnlyKeys = new Set(result
    .filter(vehicle => vehicle.__sharedNavisionReadOnly === true || vehicle.__locationIdentityReadOnly === true || vehicle.__emailVehicleServerAuthoritative === true)
    .map(vehicleKey));
  return result;
}

function captureIncomingBoardDisclosureState(host = $('#incoming-main-board')) {
  const state = {};
  $$('details', host).forEach(row => {
    const key = row.dataset.incomingRow
      ? `row:${row.dataset.incomingRow}`
      : row.classList.contains('incoming-bucket')
        ? `bucket:${[...row.classList].find(name => name.startsWith('incoming-') && name !== 'incoming-bucket') || ''}`
        : row.classList.contains('incoming-priority-list') ? 'priority' : '';
    if (key) state[key] = row.open === true;
  });
  return state;
}

function restoreIncomingBoardDisclosureState(host = $('#incoming-main-board'), state = {}) {
  if (!state || typeof state !== 'object') return;
  $$('details', host).forEach(row => {
    const key = row.dataset.incomingRow
      ? `row:${row.dataset.incomingRow}`
      : row.classList.contains('incoming-bucket')
        ? `bucket:${[...row.classList].find(name => name.startsWith('incoming-') && name !== 'incoming-bucket') || ''}`
        : row.classList.contains('incoming-priority-list') ? 'priority' : '';
    if (key && Object.prototype.hasOwnProperty.call(state, key)) row.open = state[key] === true;
  });
}

function vehicleLocationsRefreshRoleCanRead(role = window.PDC_AUTH_CONTEXT?.role) {
  return ['viewer', 'operator', 'importer', 'administrator'].includes(String(role || '').trim().toLowerCase());
}

const OPERATIONAL_REFRESH_ROUTES = Object.freeze([
  'dashboard', 'qc', 'workflow', 'workshop', 'visibility', 'tv', 'schedule',
  'department', 'parts', 'sublet', 'bus-pit', 'rft', 'completed', 'collected', 'deleted',
  'backend', 'emailreview', 'ai-auditor',
]);

function operationalRefreshRouteLabel(route = '') {
  return ({
    dashboard: 'Vehicle Locations', qc: 'Final check', workflow: 'Control Board', workshop: 'Workshop Planner',
    visibility: 'Operations', tv: 'PDC TV', schedule: 'Production', department: 'Department',
    parts: 'Parts', sublet: 'Sublet', 'bus-pit': 'Bus Pit inspections', rft: 'RFT', completed: 'Completed Vehicles',
    collected: 'Collected Vehicles', deleted: 'Deleted Vehicles', backend: 'Back End Data',
    emailreview: 'AI / Email Intake', 'ai-auditor': 'AI Auditor',
  })[route] || 'Operational page';
}

function operationalRefreshControlMarkup(route = '') {
  const currentRoute = String(route || '').trim();
  const busy = app.operationalRefreshState === 'refreshing' && app.operationalRefreshRoute === currentRoute;
  const failed = app.operationalRefreshState === 'error' && app.operationalRefreshRoute === currentRoute;
  const result = app.operationalRefreshResult;
  const revision = result?.revision || app.emailVehicleLocationRevision || app.sharedNavisionVisibleRevision || window.__workshopDataService?.getLastRevision?.() || '—';
  const updated = result?.finishedAt ? new Date(result.finishedAt).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' }) : '';
  const draftConflict = Array.isArray(app.operationalRefreshDraftConflicts) && app.operationalRefreshDraftConflicts.length
    ? ` · ${app.operationalRefreshDraftConflicts[0]}` : '';
  const message = busy
    ? 'Refreshing authoritative data…'
    : failed
      ? `Refresh incomplete · failed: ${app.operationalRefreshError || 'unknown source'} · retry available`
      : updated ? `Updated ${updated} · revision ${revision}${draftConflict}` : `Refresh ${operationalRefreshRouteLabel(currentRoute)} data`;
  return `<span class="pdc-operational-refresh-control${busy ? ' is-refreshing' : ''}${failed ? ' is-error' : ''}" data-pdc-refresh-control data-pdc-refresh-route="${escapeHtml(currentRoute)}" role="group" aria-label="Refresh ${escapeHtml(operationalRefreshRouteLabel(currentRoute))}"${busy ? ' aria-busy="true"' : ''}>
    <button class="small-button pdc-operational-refresh-button" type="button" data-pdc-operational-refresh data-pdc-refresh-route="${escapeHtml(currentRoute)}"${busy ? ' disabled aria-busy="true"' : ''}>${busy ? 'Refreshing…' : failed ? 'Retry' : 'Refresh'}</button>
    <span class="pdc-operational-refresh-status" role="status" aria-live="polite">${escapeHtml(message)}</span>
  </span>`;
}

function operationalRefreshControlKey(element) {
  if (!element) return '';
  if (element.id) return `id:${element.id}`;
  const data = element.dataset || {};
  const stable = ['subletKey', 'subletField', 'operationLineId', 'workKey', 'qcOperationCheck', 'qcLineIdentity', 'rftCompletionKey', 'rftCompletionJob']
    .map(key => data[key] ? `${key}=${data[key]}` : '').filter(Boolean);
  return `${element.tagName || 'control'}:${stable.join('|')}`;
}

function operationalRefreshScrollableKey(element, index) {
  const classes = [...(element?.classList || [])].filter(value => /wrap|scroll|content|board/i.test(value));
  return `${classes.join('.') || element?.tagName || 'scroll'}:${index}`;
}

function captureOperationalRefreshViewState(route = app.currentView) {
  const view = document.getElementById(route) || document.querySelector('.view.active');
  const controls = [];
  const elements = [...(view?.querySelectorAll?.('input, textarea, select') || [])];
  elements.forEach(element => {
    const value = element.type === 'checkbox' || element.type === 'radio' ? element.checked : element.value;
    const initial = element.type === 'checkbox' || element.type === 'radio' ? element.defaultChecked : element.defaultValue;
    if (value === initial && document.activeElement !== element) return;
    controls.push({ key: operationalRefreshControlKey(element), value, type: element.type, draft: true });
  });
  const details = [...(view?.querySelectorAll?.('details') || [])].map((element, index) => ({
    key: element.dataset.incomingRow ? `row:${element.dataset.incomingRow}` : operationalRefreshScrollableKey(element, index),
    open: element.open === true,
  }));
  const scrollables = [...(view?.querySelectorAll?.('.table-wrap, .sublet-table-wrap, .workshop-timeline-scroll, .pdc-production-grid-scroll, .parts-home-content') || [])]
    .map((element, index) => ({ key: operationalRefreshScrollableKey(element, index), top: element.scrollTop, left: element.scrollLeft }));
  const active = document.activeElement;
  return {
    route: String(route || ''),
    scrollY: Number(window.scrollY || document.scrollingElement?.scrollTop || 0),
    scrollX: Number(window.scrollX || document.scrollingElement?.scrollLeft || 0),
    activeKey: operationalRefreshControlKey(active),
    refreshFocused: Boolean(active?.matches?.('[data-pdc-operational-refresh]')),
    controls,
    details,
    scrollables,
    selectedStock: app.selectedStock,
    modalIdentity: app.vehicleModalIdentity ? { ...app.vehicleModalIdentity } : null,
  };
}

function restoreOperationalRefreshViewState() {
  const saved = app.operationalRefreshRestoreState;
  if (!saved || saved.route !== String(app.currentView || '')) return;
  const view = document.getElementById(saved.route) || document.querySelector('.view.active');
  const controls = [...(view?.querySelectorAll?.('input, textarea, select') || [])];
  const byKey = new Map(controls.map(element => [operationalRefreshControlKey(element), element]));
  const conflicts = [];
  saved.controls.forEach(item => {
    const element = byKey.get(item.key);
    if (!element) return;
    const current = element.type === 'checkbox' || element.type === 'radio' ? element.checked : element.value;
    if (current !== item.value) conflicts.push(`${item.key} changed on the server; your draft was preserved for review`);
    if (element.type === 'checkbox' || element.type === 'radio') element.checked = item.value === true;
    else element.value = String(item.value ?? '');
  });
  [...(view?.querySelectorAll?.('details') || [])].forEach((element, index) => {
    const key = element.dataset.incomingRow ? `row:${element.dataset.incomingRow}` : operationalRefreshScrollableKey(element, index);
    const savedDetail = saved.details.find(item => item.key === key);
    if (savedDetail) element.open = savedDetail.open === true;
  });
  [...(view?.querySelectorAll?.('.table-wrap, .sublet-table-wrap, .workshop-timeline-scroll, .pdc-production-grid-scroll, .parts-home-content') || [])]
    .forEach((element, index) => {
      const scroll = saved.scrollables.find(item => item.key === operationalRefreshScrollableKey(element, index));
      if (scroll) { element.scrollTop = scroll.top; element.scrollLeft = scroll.left; }
    });
  if (typeof window.scrollTo === 'function') window.scrollTo(saved.scrollX, saved.scrollY);
  if (conflicts.length) app.operationalRefreshDraftConflicts = [...new Set(conflicts)];
  if (saved.refreshFocused) {
    const button = view?.querySelector?.('[data-pdc-operational-refresh]');
    if (button && typeof button.focus === 'function') button.focus();
  } else if (saved.activeKey) {
    const active = byKey.get(saved.activeKey);
    if (active && typeof active.focus === 'function') active.focus();
  }
}

function ensureOperationalRefreshControls() {
  OPERATIONAL_REFRESH_ROUTES.forEach(route => {
    const view = document.getElementById(route);
    if (!view || view.hidden || !view.classList.contains('view')) return;
    if (route === 'dashboard' && view.querySelector('.vehicle-locations-refresh [data-pdc-operational-refresh]')) {
      view.querySelectorAll('.incoming-search-panel [data-pdc-operational-refresh]').forEach(button => button.closest('[data-pdc-refresh-control]')?.remove());
      return;
    }
    let target = route === 'workshop'
      ? view.querySelector('.workshop-date-controls')
      : route === 'workflow' && view.querySelector('[data-workflow-refresh-slot]')
        ? view.querySelector('[data-workflow-refresh-slot]')
      : route === 'dashboard'
        ? view.querySelector('.incoming-search-panel')
        : view.querySelector('.panel-header .panel-actions') || view.querySelector('.panel-header');
    if (!target) target = view.querySelector('.panel') || view;
    const existing = view.querySelector(`[data-pdc-operational-refresh][data-pdc-refresh-route="${route}"]`);
    if (existing) {
      const control = existing.closest('[data-pdc-refresh-control]') || existing;
      const button = control.querySelector?.('button[data-pdc-operational-refresh]');
      const status = control.querySelector?.('.pdc-operational-refresh-status');
      const busy = app.operationalRefreshState === 'refreshing' && app.operationalRefreshRoute === route;
      const failed = app.operationalRefreshState === 'error' && app.operationalRefreshRoute === route;
      const result = app.operationalRefreshResult;
      const revision = result?.revision || app.emailVehicleLocationRevision || app.sharedNavisionVisibleRevision || window.__workshopDataService?.getLastRevision?.() || '—';
      const updated = result?.finishedAt ? new Date(result.finishedAt).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' }) : '';
      const conflict = Array.isArray(app.operationalRefreshDraftConflicts) && app.operationalRefreshDraftConflicts.length
        ? ` · ${app.operationalRefreshDraftConflicts[0]}` : '';
      if (button) {
        button.disabled = busy;
        button.textContent = busy ? 'Refreshing…' : failed ? 'Retry' : 'Refresh';
        if (busy) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
      }
      if (busy) control.setAttribute('aria-busy', 'true'); else control.removeAttribute('aria-busy');
      control.classList.toggle('is-refreshing', busy);
      control.classList.toggle('is-error', failed);
      if (status) status.textContent = busy
        ? 'Refreshing authoritative data…'
        : failed
          ? `Refresh incomplete · failed: ${app.operationalRefreshError || 'unknown source'} · retry available`
          : updated ? `Updated ${updated} · revision ${revision}${conflict}` : `Refresh ${operationalRefreshRouteLabel(route)} data`;
      if (route === 'workshop' && target && !target.contains(existing)) target.appendChild(existing.closest('[data-pdc-refresh-control]') || existing);
      return;
    }
    if (target && typeof target.insertAdjacentHTML === 'function') target.insertAdjacentHTML('beforeend', operationalRefreshControlMarkup(route));
  });
}

window.__pdcEnsureOperationalRefreshControls = ensureOperationalRefreshControls;

function operationalRefreshCommonLoaders(route) {
  return {
    sharedNavision: ({ generation, sources }) => sources?.every(source => source === 'email_revision')
      ? { ok: true, skipped: true }
      : loadSharedNavisionVisibleRows({ force: true, refreshGeneration: generation }),
    operationalVehicleSnapshot: async ({ generation }) => {
      initEmailVehicleLocationsIfAvailable({ skipInitialRefresh: true });
      if (!app.emailVehicleLocationService) return { ok: false, error: 'operational_snapshot_unavailable' };
      const ok = await refreshEmailVehicleLocations({ refreshGeneration: generation });
      return { ok, error: ok ? '' : app.emailVehicleLocationError || 'refresh_failed' };
    },
    workOperationStates: async () => {
      // The authenticated dashboard uses the email/Navision snapshot and
      // eligibility readers. The old unscoped get_workshop_snapshot RPC is
      // intentionally revoked; only a selected Workshop station has a
      // scoped planner snapshot to refresh.
      if (route !== 'workshop') return { ok: true, skipped: true };
      if (typeof initWorkshopSharedServicesIfEnabled === 'function') initWorkshopSharedServicesIfEnabled();
      const service = window.__workshopDataService;
      if (!service || typeof service.loadSnapshot !== 'function') return { ok: true, skipped: true };
      if (typeof service.setScope !== 'function' || typeof workshopState !== 'function') return { ok: true, skipped: true };
      const workshop = workshopState();
      const stage = normalizePmbStage(app.activeWorkshopPlannerStage || workshop.stage || '');
      const date = cleanNavisionText(workshop.date || '').match(/^\d{4}-\d{2}-\d{2}$/)?.[0] || new Date().toISOString().slice(0, 10);
      if (!stage) return { ok: true, skipped: true };
      const nextScope = { stageCode: stage, dateFrom: date, dateTo: date };
      const scopeChanged = typeof service.getScope === 'function'
        && JSON.stringify(service.getScope()) !== JSON.stringify(nextScope);
      const scopedSnapshot = await service.setScope(nextScope);
      // A scope change already issues and awaits its authoritative read.
      // Keep explicit same-scope refreshes fresh without downloading the new
      // date/station twice when navigation and Refresh overlap.
      const snapshot = scopeChanged ? scopedSnapshot : await service.loadSnapshot(`operational_refresh:${route}`);
      const state = typeof service.getState === 'function' ? service.getState() : '';
      const trusted = typeof service.getTrustedSnapshot === 'function' ? service.getTrustedSnapshot() : snapshot;
      return { ok: Boolean(trusted) && ['connected_editable', 'connected_read_only'].includes(state), snapshot, revision: service.getLastRevision?.() };
    },
    routeAuthority: async ({ sources } = {}) => {
      const refreshes = [];
      if (['dashboard', 'workflow'].includes(route) && workshopEligibilitySharedAuthorityEnabled()) {
        if (!app.workshopEligibilityRealtime) workshopEligibilityOverviewSubscribe();
        if (app.workshopEligibilityRealtime) refreshes.push(route === 'dashboard'
          ? loadWorkshopEligibilitySnapshot('vehicle_locations_refresh')
          : loadWorkshopEligibilitySnapshot(`operational_refresh:${route}`));
      }
      // Reference tables have their own realtime subscriptions and a periodic
      // reconciliation. Vehicle-only events do not invalidate those tables.
      if (!sources?.every(source => source === 'email_revision') && typeof refreshWorkshopReferenceData === 'function') refreshes.push(refreshWorkshopReferenceData());
      if (route === 'ai-auditor' && typeof loadPdcAuditorSnapshot === 'function') refreshes.push(loadPdcAuditorSnapshot({ force: true }));
      if (route === 'emailreview' && typeof refreshServerAiIntake === 'function') refreshes.push(refreshServerAiIntake({ silent: true }));
      const results = await Promise.all(refreshes);
      return { ok: results.every(result => result == null || result.ok !== false), results };
    },
    vehicleDetail: async () => {
      const vehicle = app.vehicleModalIdentity ? selectedVehicle() : null;
      if (!vehicle || app.vehicleDetailPage !== 'work' || typeof loadVehicleWorkshopDetail !== 'function') return { ok: true, skipped: true };
      const detail = await loadVehicleWorkshopDetail(vehicle, { force: true });
      return { ok: Boolean(detail), error: detail ? '' : 'vehicle_detail_unavailable' };
    },
  };
}

function getOperationalRefreshCoordinator() {
  if (app.vehicleLocationsRefreshCoordinator) return app.vehicleLocationsRefreshCoordinator;
  const factory = window.PDC_VEHICLE_LOCATIONS_REFRESH?.createPdcOperationalRefreshCoordinator
    || window.PDC_VEHICLE_LOCATIONS_REFRESH?.createVehicleLocationsRefreshCoordinator;
  if (typeof factory !== 'function') return null;
  const routeAdapters = Object.fromEntries(OPERATIONAL_REFRESH_ROUTES.map(route => [route, operationalRefreshCommonLoaders(route)]));
  app.vehicleLocationsRefreshCoordinator = factory({
    routeAdapters,
    getRoute: () => app.currentView || 'dashboard',
    onStart: (generation, route) => {
      app.vehicleLocationsRefreshGeneration = generation;
      app.vehicleLocationsRefreshState = 'refreshing';
      app.vehicleLocationsRefreshError = '';
      app.vehicleLocationsRefreshResult = null;
      app.operationalRefreshState = 'refreshing';
      app.operationalRefreshRoute = route;
      app.operationalRefreshError = '';
      app.operationalRefreshResult = null;
      app.operationalRefreshDraftConflicts = [];
      app.operationalRefreshRestoreState = captureOperationalRefreshViewState(route);
      app.vehicleLocationsRefreshDisclosure = captureIncomingBoardDisclosureState();
      renderAll();
    },
    onFinish: result => {
      if (result.stale || result.generation !== app.vehicleLocationsRefreshGeneration) return;
      subscribeSharedNavisionVisibility();
      window.__workshopRealtimeManager?.start?.();
      app.vehicleLocationsRefreshResult = result;
      app.vehicleLocationsRefreshState = result.ok ? 'success' : 'error';
      app.vehicleLocationsRefreshError = result.ok ? '' : result.errors.map(item => `${item.key}: ${String(item.error)}`).join(' · ');
      app.operationalRefreshResult = { ...result, finishedAt: Date.now() };
      app.operationalRefreshState = result.ok ? 'success' : 'error';
      app.operationalRefreshError = app.vehicleLocationsRefreshError;
      if (app.currentView === result.route) renderAll();
      app.operationalRefreshRestoreState = null;
    },
  });
  return app.vehicleLocationsRefreshCoordinator;
}

function handleOperationalRefreshClickStart(button) {
  const route = button?.dataset?.pdcRefreshRoute || app.currentView || 'dashboard';
  app.operationalRefreshState = 'refreshing';
  app.operationalRefreshRoute = route;
  const status = button?.closest?.('[data-pdc-refresh-control], .vehicle-locations-refresh');
  status?.setAttribute?.('aria-busy', 'true');
  const copy = status?.querySelector?.('.pdc-operational-refresh-status, span');
  if (copy && !copy.classList?.contains?.('vehicle-locations-refresh-button')) copy.textContent = 'Refreshing authoritative data…';
}

function handleOperationalRefreshClickResult(result) {
  if (result?.stale || result?.ok !== false) return;
  app.operationalRefreshState = 'error';
  app.operationalRefreshError = result.errors?.map(item => `${item.key}: ${String(item.error)}`).join(' · ') || result.error || 'refresh_failed';
}

function refreshOperationalPage(route = app.currentView || 'dashboard', options = {}) {
  const selectedRoute = OPERATIONAL_REFRESH_ROUTES.includes(route) ? route : app.currentView || 'dashboard';
  if (!window.PDC_AUTH_CONTEXT || !vehicleLocationsRefreshRoleCanRead()) return Promise.resolve({ ok: false, error: 'not_authenticated', route: selectedRoute });
  const coordinator = getOperationalRefreshCoordinator();
  if (!coordinator) return Promise.resolve({ ok: false, error: 'refresh_unavailable', route: selectedRoute });
  return coordinator.refresh({ ...options, route: selectedRoute });
}

function getVehicleLocationsRefreshCoordinator() {
  return getOperationalRefreshCoordinator();
}

function refreshVehicleLocations(options = {}) {
  return refreshOperationalPage('dashboard', options);
}

function invalidateVehicleLocationsRefresh() {
  app.vehicleLocationsRefreshGeneration += 1;
  app.vehicleLocationsRefreshCoordinator?.invalidate?.();
  app.vehicleLocationsRefreshState = 'idle';
  app.vehicleLocationsRefreshError = '';
  app.vehicleLocationsRefreshResult = null;
  app.vehicleLocationsRefreshDisclosure = null;
  app.operationalRefreshState = 'idle';
  app.operationalRefreshRoute = '';
  app.operationalRefreshError = '';
  app.operationalRefreshResult = null;
  app.operationalRefreshDraftConflicts = [];
  app.operationalRefreshRestoreState = null;
}

function sharedNavisionLocationsStatusHtml() {
  if (!sharedNavisionVisibilityConfigured()) return '';
  if (app.sharedNavisionVisibleState === 'idle' && !window.PDC_AUTH_CONTEXT) return '';
  const refreshing = app.vehicleLocationsRefreshState === 'refreshing';
  const count = activeSharedNavisionRows().length;
  const realtimeHealthy = app.sharedNavisionVisibleRealtimeState === 'subscribed' && app.sharedNavisionVisibleRealtimeReconciled === true;
  const failedRefresh = app.vehicleLocationsRefreshState === 'error';
  const stale = failedRefresh || (!realtimeHealthy && app.sharedNavisionVisibleState === 'ready');
  const statusClass = failedRefresh ? 'is-error is-stale' : realtimeHealthy ? 'is-ready' : stale ? 'is-stale' : '';
  const draftConflict = Array.isArray(app.operationalRefreshDraftConflicts) && app.operationalRefreshDraftConflicts.length
    ? ` · ${app.operationalRefreshDraftConflicts[0]}` : '';
  const heading = refreshing
    ? 'Refreshing Vehicle Locations…'
    : failedRefresh
      ? 'Vehicle Locations refresh incomplete'
      : app.sharedNavisionVisibleState === 'loading' || app.sharedNavisionVisibleState === 'idle'
        ? 'Loading shared Navision vehicles'
        : realtimeHealthy ? 'Shared Navision locations online' : 'Shared Navision locations loaded';
  const detail = refreshing
    ? 'Reloading the authoritative Navision, operational, work, booking and receipt snapshots.'
    : failedRefresh
      ? `Refresh failed (${app.vehicleLocationsRefreshError || 'refresh_failed'}). Previous authoritative Vehicle Locations data is stale. Retry without leaving this Board.`
      : app.sharedNavisionVisibleState === 'error'
        ? (app.sharedNavisionVisibleError || 'Shared Navision imports could not be loaded. Previous rows remain visible.')
        : `${count} Navision source record${count === 1 ? '' : 's'} · approved job imports also appear on this board · revision ${app.sharedNavisionVisibleRevision ?? '—'} · ${realtimeHealthy ? 'synchronized across signed-in computers' : 'live synchronization reconnecting'}${draftConflict}`;
  const busy = refreshing ? ' aria-busy="true"' : '';
  return `<div class="backend-shared-status vehicle-locations-refresh ${statusClass}" role="status" aria-live="polite" aria-atomic="true"${busy}>
    <strong>${heading}</strong><span>${escapeHtml(detail)}</span>
    <button class="small-button vehicle-locations-refresh-button" type="button" data-vehicle-locations-refresh data-pdc-operational-refresh data-pdc-refresh-route="dashboard" ${refreshing ? 'disabled' : ''} aria-label="Refresh Vehicle Locations">${refreshing ? 'Refreshing…' : failedRefresh ? 'Retry' : 'Refresh'}</button>
  </div>`;
}

function sharedNavisionBackEndRows() {
  return (app.sharedNavisionVisibleRows || []).map(item => ({
    vehicle: {
      id: `shared-navision-${item.id || ''}`,
      stock: item.stock_number || '',
      batch: item.stock_number || '',
      client: item.customer_name || '',
      toyotaCustomer: item.customer_name || '',
      consultant: item.salesperson || '',
      vehicle: [item.model, item.colour].filter(Boolean).join(' · '),
      toyotaVehicle: item.model || '',
      colour: item.colour || '',
      toyotaStatus: item.vehicle_status || '',
      etaAtDealer: item.eta_to_kewdale || '',
      importedAt: item.updated_at || '',
      source: 'Shared Navision',
    },
    state: 'Shared Navision',
    detail: `Online · dealer ${item.dealer_code || '—'} · ${item.is_current === false ? 'missing from latest upload' : item.board_activated === true ? 'shown on Vehicle Locations' : 'Back End Data only'}`,
    deletedAt: '',
    sharedReadOnly: true,
    backendRecordId: item.id || '',
    canonicalVehicleId: item.canonical_vehicle_id || '',
    isCurrent: item.is_current === true,
    boardActivated: item.board_activated === true,
    activationSource: item.activation_source || '',
  }));
}

function backEndDataRows() {
  const deletedRecords = deletedVehicleRecords().map(record => ({
    vehicle: record.vehicle || {},
    state: 'Deleted',
    detail: record.reason || 'Removed from current Navision / dashboard data',
    deletedAt: record.deletedAt || '',
  }));
  const activeRows = app.data.map(vehicle => ({
    vehicle,
    state: isVehicleVisibleOnPdcSheet(vehicle) ? 'PDC Sheet' : 'Back end only',
    detail: [vehicle.source || (vehicle.importedAt ? 'Navision' : 'Tracker'), vehicle.pdcVisibilitySource].filter(Boolean).join(' · '),
    deletedAt: '',
  }));
  const activeCanonicalIds = new Set(app.data.map(vehicle => String(vehicle.__emailVehicleId || '').trim()).filter(Boolean));
  const unlinkedSharedRows = sharedNavisionBackEndRows().filter(row => {
    const canonicalId = String(row.canonicalVehicleId || '').trim();
    // Tune approval and Navision activation are separate intake routes. A verified
    // canonical link already identifies this vehicle, regardless of activation route.
    return !(canonicalId && activeCanonicalIds.has(canonicalId));
  });
  return activeRows.concat(unlinkedSharedRows, deletedRecords).sort((a, b) => String(displayStockNumber(a.vehicle) || vehicleKey(a.vehicle) || '').localeCompare(String(displayStockNumber(b.vehicle) || vehicleKey(b.vehicle) || ''), 'en-AU', { numeric: true }));
}

function filteredBackEndDataRows(rows = backEndDataRows()) {
  const query = cleanNavisionText($('#backend-data-search')?.value || '').toLowerCase();
  const stateFilter = $('#backend-data-state-filter')?.value || 'all';
  const terms = query.split(/\s+/).filter(Boolean);
  return rows.filter(row => {
    if (stateFilter === 'backend' && row.state !== 'Back end only') return false;
    if (stateFilter === 'active' && row.state !== 'PDC Sheet') return false;
    if (stateFilter === 'deleted' && row.state !== 'Deleted') return false;
    if (stateFilter === 'shared' && row.state !== 'Shared Navision') return false;
    if (!terms.length) return true;
    const vehicle = row.vehicle || {};
    const haystack = [
      displayStockNumber(vehicle), vehicle.batch,
      vehicle.vin, vehicle.fullVin, vehicle.frame, vehicle.autocareVin,
      vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle), vehicleCustomerName(vehicle),
      displayVehicle(vehicle), vehicle.toyotaStatus, consultantName(vehicle),
      vehicle.purchaseOrderNumber, vehicle.purchaseOrderReference, vehicle.purchaseOrderDeliverTo,
      vehicle.source, row.state, row.detail,
    ].map(value => cleanNavisionText(value || '').toLowerCase()).join(' ');
    return terms.every(term => haystack.includes(term));
  });
}

function clearBackEndDataSearch() {
  const search = $('#backend-data-search');
  const state = $('#backend-data-state-filter');
  if (search) search.value = '';
  if (state) state.value = 'all';
  renderBackEndData();
}

function navisionLocationSourceText(vehicle = {}) {
  return [
    vehicle.navisionLocationStatus,
    vehicle.locationStatus,
    vehicle.navisionSubLocationDescription,
    vehicle.toyotaStatus,
    vehicle.navisionBuildStatus,
    vehicle.internalStatus,
  ].map(value => normalizeToyotaStatus(value || '')).filter(Boolean).join(' ');
}

function navisionTextIsBodyBuilder(text = '') {
  const normalized = normalizeToyotaStatus(text);
  return /\bbody\s*-?\s*builder\b|\bbodybuilder\b|\bpmb\b/.test(normalized) || normalized.includes('perth motor bodies');
}

function currentPdcLocationFromNavision(vehicle = {}, existing = {}) {
  const lifecycle = window.PDC_VEHICLE_LOCATION_LIFECYCLE;
  if (lifecycle?.resolveVehicleLifecycleLocation) {
    return lifecycle.resolveVehicleLifecycleLocation({ ...existing, ...vehicle }, { now: new Date() }).location;
  }
  const automatic = navisionAutoPdcLocation(vehicle);
  if (automatic) return automatic;
  const locationStatus = normalizeToyotaStatus(vehicle.navisionLocationStatus || vehicle.locationStatus || '');
  const subLocation = normalizeToyotaStatus(vehicle.navisionSubLocationDescription || vehicle.toyotaStatus || '');
  const text = navisionLocationSourceText(vehicle);
  if (locationStatus === 'yh' || subLocation.includes('yard hold') || /\byh\b/.test(text)) return 'YH';
  if (
    locationStatus === 'rft' || /\brft\b/.test(text) ||
    text.includes('ready for transport') || text.includes('ready for transfer') ||
    text.includes('at dealer') || text.includes('delivered to dealer') ||
    text.includes('delivered - at dealer') || text.includes('dealer received')
  ) return 'RFT';
  return '';
}

function navisionDerivedLocationUpdates(incoming = {}, existing = {}) {
  const lifecycle = window.PDC_VEHICLE_LOCATION_LIFECYCLE;
  const decision = lifecycle?.resolveVehicleLifecycleLocation
    ? lifecycle.resolveVehicleLifecycleLocation({ ...existing, ...incoming }, { now: new Date() })
    : null;
  const nextLocation = decision?.location || currentPdcLocationFromNavision(incoming, existing);
  const previousLocation = vehiclePdcLocation(existing);
  const now = nowIsoString();
  const businessDate = decision?.businessDate || now.slice(0, 10);
  const updates = {
    pdcLocation: nextLocation,
    manualLocation: '',
    pdcLocationLocked: false,
    pdcLocationDerivedFromNavision: true,
    pdcLocationSource: 'Navision current location',
  };
  if (nextLocation !== previousLocation) updates.pdcLocationUpdatedAt = now;
  if (nextLocation === 'PMB' && previousLocation !== 'PMB') {
    Object.assign(updates, {
      dateToPmb: existing.dateToPmb || existing.date_to_pmb || businessDate,
      pmbEnteredAt: pmbEnteredTimestamp(existing) || now,
      pmbTransferredAt: existing.pmbTransferredAt || now,
      pmbStage: '',
      pdcWorkStage: '',
      workStage: '',
      pmbStageEnteredAt: '',
      pmbStageUpdatedAt: '',
      pmbBayStage: '',
      pmbBayNumber: '',
      pmbBayEstimatedHours: '',
      pmbBayEnteredAt: '',
      pmbBayScheduledStartAt: '',
      pmbBayCompletedAt: '',
      pmbBayCompletedBy: '',
      pmbBayCompletedStage: '',
      pmbBayMechanic: '',
      pmbSubletProvider: '',
    });
  }
  if (nextLocation === 'RFT' && previousLocation !== 'RFT') {
    updates.rftTransferredAt = existing.rftTransferredAt || now;
    updates.dateToRft = existing.dateToRft || existing.date_to_rft || businessDate;
  }
  if (nextLocation === 'Completed') {
    updates.completedVehicle = true;
    updates.rftCollected = true;
    updates.rftCollectedAt = existing.rftCollectedAt || now;
    updates.deliveredToDealerDate = existing.deliveredToDealerDate || existing.delivered_to_dealer_date || businessDate;
  }
  if (previousLocation === 'PMB' && !['PMB', 'Completed'].includes(nextLocation)) {
    Object.assign(updates, {
      pmbStage: '',
      pdcWorkStage: '',
      workStage: '',
      pmbBayStage: '',
      pmbBayNumber: '',
      pmbBayEstimatedHours: '',
      pmbBayEnteredAt: '',
      pmbBayScheduledStartAt: '',
      pmbBayMechanic: '',
      pmbSubletProvider: '',
    });
  }
  return updates;
}

function backEndActivationLocationLabel(vehicle = {}) {
  const location = currentPdcLocationFromNavision(vehicle);
  if (location === 'PMB') return 'PMB - Unallocated';
  if (location) return pdcLocationLabel(location);
  return statusCategoryLabel(vehicle) || navisionStatusText(vehicle) || 'current Navision location';
}

function transferBackEndVehicleToActive(key = '') {
  const vehicle = app.data.find(row => vehicleKey(row) === key || row.stock === key || row.id === key);
  if (!vehicle || isVehicleVisibleOnPdcSheet(vehicle)) return;
  const identity = displayStockNumber(vehicle) || 'this vehicle';
  const customer = vehicleCustomerName(vehicle) || 'Unknown customer';
  const locationLabel = backEndActivationLocationLabel(vehicle);
  const navisionLocation = navisionStatusText(vehicle) || cleanNavisionText(vehicle.navisionLocationStatus || '') || 'No Navision location supplied';
  if (!window.confirm(`Move ${identity} - ${customer} from Back End Data to the active PDC Sheet?\n\nCurrent location: ${locationLabel}\nNavision: ${navisionLocation}\n\nThe active vehicle will follow this current Navision location. Body Builder / PMB vehicles land in PMB Unallocated.`)) return;
  saveVehicleEdits(vehicleKey(vehicle), {
    ...pdcVisibilityPromotionUpdates(vehicle, 'Operator transfer from Back End Data'),
    ...navisionDerivedLocationUpdates(vehicle, vehicle),
  });
  recordVehicleAudit(vehicle, 'Moved from Back End Data to active PDC Sheet', { by: getCurrentOperatorName(), location: locationLabel, navisionLocation });
  app.data = buildVehicleData();
  renderAll();
}

function navisionBoardActivationRoleAllowed(role = window.PDC_AUTH_CONTEXT?.role) {
  // r421 (F36): importer = viewer + Navision import; showing a record on Vehicle Locations is a controller action.
  return ['operator', 'administrator'].includes(String(role || '').trim().toLowerCase());
}

function navisionBoardActivationIdempotencyKey(recordId = '', source = 'manual') {
  const nonce = typeof crypto?.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `navision-board-${source}-${String(recordId || '').slice(0, 36)}-${nonce}`;
}

async function activateSharedNavisionBackendRecord(recordId = '', source = 'manual', options = {}) {
  const item = (app.sharedNavisionVisibleRows || []).find(row => String(row?.id || '') === String(recordId || ''));
  if (!item || item.is_current !== true) return { ok: false, code: 'record_not_current' };
  if (item.board_activated === true) return { ok: true, code: 'already_activated', data: { result_revision: app.sharedNavisionVisibleRevision } };
  if (!navisionBoardActivationRoleAllowed()) return { ok: false, code: 'unauthorized' };
  if (!app.navisionSharedBackendService?.activate || app.sharedNavisionVisibleState !== 'ready' || app.sharedNavisionVisibleRealtimeState !== 'subscribed' || app.sharedNavisionVisibleRealtimeReconciled !== true) {
    return { ok: false, code: 'shared_authority_unavailable' };
  }
  if (source === 'manual' && options.confirm !== false) {
    const identity = item.stock_number || 'this vehicle';
    const customer = item.customer_name || 'Unknown customer';
    if (!window.confirm(`Show ${identity} - ${customer} on Vehicle Locations?\n\nThe shared Navision record will remain read only and this activation will be synchronized across approved computers.`)) {
      return { ok: false, code: 'cancelled' };
    }
  }
  const response = await app.navisionSharedBackendService.activate(
    item.id,
    app.sharedNavisionVisibleRevision,
    navisionBoardActivationIdempotencyKey(item.id, source),
    source,
  );
  if (!response?.ok) return response || { ok: false, code: 'activation_failed' };
  await loadSharedNavisionVisibleRows({ force: true });
  renderAll();
  return response;
}

function activateSharedNavisionForApprovedDocumentReview(vehicle = {}, source = 'approved_pd_document') {
  const normalizedSource = String(source || '').trim().toLowerCase();
  if (normalizedSource.includes('email') || normalizedSource.includes('ai_intake')) {
    return { ok: false, code: 'server_ai_intake_rpc_required', activated: false };
  }
  if (sharedNavisionVisibilityConfigured() && !sharedNavisionLocationAuthorityReady()) {
    return { ok: false, code: 'shared_authority_unavailable' };
  }
  const matches = activeSharedNavisionRows().filter(item => sharedNavisionIdentityRelation(vehicle, item) === 'match');
  if (!matches.length) return { ok: true, code: 'no_shared_match' };
  if (matches.length !== 1 || activeSharedNavisionRows().some(item => sharedNavisionIdentityRelation(vehicle, item) === 'conflict')) {
    return { ok: false, code: 'identity_conflict' };
  }
  return activateSharedNavisionBackendRecord(matches[0].id, source, { confirm: false });
}

function activateSharedNavisionForApprovedEmailReview(_vehicle = {}) {
  // Local/uploaded email drafts are never an authority path. The only AI
  // Intake activation contract is the exact Administrator RPC in migration 065.
  return { ok: false, code: 'server_ai_intake_rpc_required' };
}

function renderBackEndData() {
  const host = $('#backend-data-content');
  if (!host) return;
  const sharedRole = String(window.PDC_AUTH_CONTEXT?.role || '').trim().toLowerCase();
  const sharedRoleApproved = ['viewer', 'operator', 'importer', 'administrator'].includes(sharedRole);
  if (app.sharedNavisionVisibleState === 'idle' && sharedRoleApproved) loadSharedNavisionVisibleRows();
  const allRows = backEndDataRows();
  const rows = filteredBackEndDataRows(allRows);
  const pdcSheet = allRows.filter(row => row.state === 'PDC Sheet').length;
  const backEndOnly = allRows.filter(row => row.state === 'Back end only').length;
  const shared = allRows.filter(row => row.state === 'Shared Navision').length;
  const sharedSourceTotal = (app.sharedNavisionVisibleRows || []).length;
  const linkedSharedMerged = Math.max(0, sharedSourceTotal - shared);
  const deleted = allRows.filter(row => row.state === 'Deleted').length;
  const count = $('#backend-data-count');
  if (count) count.textContent = `${rows.length} shown · ${pdcSheet} active · ${backEndOnly} local back end · ${sharedSourceTotal} shared Navision · ${linkedSharedMerged} linked into active rows · ${deleted} deleted`;
  const sharedStatus = app.sharedNavisionVisibleState === 'loading'
    ? '<div class="backend-shared-status is-loading"><strong>Loading shared Navision imports…</strong><span>Reading the approved online display view.</span></div>'
    : app.sharedNavisionVisibleState === 'error'
      ? `<div class="backend-shared-status is-error"><strong>Shared Navision imports could not be loaded</strong><span>${escapeHtml(app.sharedNavisionVisibleError || 'Use Refresh shared imports to try again.')}</span></div>`
      : app.sharedNavisionVisibleState === 'ready'
        ? `<div class="backend-shared-status is-ready"><strong>Online Navision imports visible</strong><span>${sharedSourceTotal} shared row${sharedSourceTotal === 1 ? '' : 's'} · ${linkedSharedMerged} linked into active vehicles · revision ${escapeHtml(app.sharedNavisionVisibleRevision ?? '—')} · updates refresh automatically.</span></div>`
        : '';
  if (!rows.length) {
    host.innerHTML = `${sharedStatus}<div class="empty-state"><strong>No matching back-end vehicles</strong><span>${allRows.length ? 'Change the search or state filter, then try again.' : 'Upload the latest Navision dump to populate this page.'}</span></div>`;
    return;
  }
  host.innerHTML = `${sharedStatus}<div class="table-scroll-cue" aria-hidden="true">Swipe horizontally to view all columns →</div><div class="responsive-table pdc-grid-table-wrap"><table class="data-table backend-data-table pdc-grid-table">
    <thead><tr><th>Key</th><th>Stock (Batch)</th><th>Job Card</th><th>Customer</th><th>Salesperson</th><th>Model</th><th>Colour</th><th>Status</th><th>Source / note</th><th>Updated</th><th>Actions</th></tr></thead>
    <tbody>${rows.map(row => {
      const v = row.vehicle || {};
      const key = vehicleKey(v);
      const isDeleted = row.state === 'Deleted';
      const isBackEndOnly = row.state === 'Back end only';
      const isShared = row.state === 'Shared Navision' || row.sharedReadOnly === true;
      const stockCell = isDeleted || isShared
        ? escapeHtml(displayStockNumber(v) || '—')
        : `<button class="stock-link stock-button" type="button" data-open-stock="${escapeHtml(key)}">${escapeHtml(displayStockNumber(v) || '—')}</button>`;
      const sharedCanActivate = isShared && !row.boardActivated && row.isCurrent && navisionBoardActivationRoleAllowed(sharedRole);
      const sharedAction = row.boardActivated
        ? '<span class="badge success">Shown on board</span>'
        : sharedCanActivate
          ? `<button class="small-button primary" type="button" data-shared-backend-activate="${escapeHtml(row.backendRecordId || '')}">Show on board</button>`
          : '<span class="badge neutral">Back End only</span>';
      const actionCell = isShared
        ? sharedAction
        : isBackEndOnly
          ? `<button class="small-button primary" type="button" data-backend-activate="${escapeHtml(key)}">Move to active</button>`
          : isDeleted ? '<span class="subtle">Locked</span>' : '<span class="badge neutral">Active</span>';
      return `<tr class="${isDeleted ? 'deleted-row' : isShared ? 'shared-navision-row' : ''}">
        <td class="pdc-id-cell pdc-key-cell">${escapeHtml(vehicleKeyNumber(v) || '—')}</td>
        <td class="pdc-id-cell pdc-stock-cell">${stockCell}</td>
        <td class="pdc-id-cell pdc-jc-cell">${escapeHtml(vehicleJobcardNumber(v) || '—')}</td>
        <td class="pdc-name-cell">${escapeHtml(vehicleCustomerName(v) || 'Customer TBA')}</td>
        <td class="pdc-name-cell">${escapeHtml(consultantName(v) || '—')}</td>
        <td class="pdc-vehicle-cell">${escapeHtml(v.toyotaVehicle || v.vehicle || '—')}</td>
        <td class="pdc-vehicle-cell">${escapeHtml(v.colour || '—')}</td>
        <td class="pdc-status-cell"><span class="badge ${isDeleted ? 'danger' : isBackEndOnly ? 'warning' : 'neutral'}">${escapeHtml(row.state)}</span>${v.toyotaStatus ? ` <span class="subtle">${escapeHtml(v.toyotaStatus)}</span>` : ''}</td>
        <td class="pdc-note-cell">${escapeHtml(row.detail || '')}</td>
        <td>${escapeHtml(isDeleted ? (parseIsoTimestamp(row.deletedAt)?.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) || '') : (parseIsoTimestamp(v.importedAt || v.updatedAt || '')?.toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) || ''))}</td>
        <td class="backend-action-cell">${actionCell}</td>
      </tr>`;
    }).join('')}</tbody>
  </table></div>`;
  $$('[data-open-stock]', host).forEach(btn => btn.addEventListener('click', () => { void openVehicleFromStockClick(btn.dataset.openStock, btn); }));
  $$('[data-backend-activate]', host).forEach(btn => btn.addEventListener('click', () => transferBackEndVehicleToActive(btn.dataset.backendActivate)));
  $$('[data-shared-backend-activate]', host).forEach(btn => btn.addEventListener('click', async () => {
    btn.disabled = true;
    const result = await activateSharedNavisionBackendRecord(btn.dataset.sharedBackendActivate, 'manual');
    if (!result?.ok && result?.code !== 'cancelled') pdcNotify(`Vehicle was not activated: ${result?.code || 'unknown error'}. Refresh shared imports and try again.`);
    btn.disabled = false;
  }));
}

function exportDeletedVehiclesCsv() {
  const rows = deletedVehicleRows();
  const headers = ['Stock','Key','Client','Vehicle','Deleted At','Deleted By','Deleted Role','Audit Events'];
  const lines = [headers.join(',')].concat(rows.map(record => {
    const vehicle = record.vehicle || { stock: record.key };
    const audit = auditTrailForVehicle(vehicle).map(entry => `${entry.at || ''} ${entry.action || ''} ${entry.by || ''}`).join(' | ');
    return [
      displayStockNumber(vehicle) || record.key || '', vehicleKeyNumber(vehicle), vehicle.client || vehicle.toyotaCustomer || '',
      displayVehicle(vehicle), record.deletedAt || '', record.deletedBy || '', record.deletedRole || '', audit,
    ].map(csvEscape).join(',');
  }));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pdc-deleted-vehicles-export.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function completedHistoryCsv(rows = completedVehicleRows()) {
  const headers = ['Stock','Key','Job Card','Customer','Vehicle','PMB Recorded','PMB Precision','RFT','RFT Precision','OD Recorded','OD Precision','PMB to RFT Days','RFT to OD Days','Total PMB to OD Days','PMB to RFT Seconds','RFT to OD Seconds','Total PMB to OD Seconds','Collected At','Collected By','Completed Jobs'];
  const lines = [headers.join(',')].concat(rows.map(vehicle => [
    displayStockNumber(vehicle), vehicleKeyNumber(vehicle), vehicleJobcardNumber(vehicle), vehicleCustomerName(vehicle) || '', displayVehicle(vehicle),
    ...Object.values(completedHistoryMilestones(vehicle)).flatMap(value => [value?.value || '', value ? (value.dateOnly ? 'date only' : 'timestamp') : 'unknown']),
    ...['pmbToRft', 'rftToOd', 'pmbToOd'].map(key => completedHistoryInterval(vehicle, key)?.days ?? ''),
    ...['pmbToRft', 'rftToOd', 'pmbToOd'].map(key => completedHistoryInterval(vehicle, key)?.seconds ?? ''),
    vehicle.rftCollectedAt || '', vehicle.rftCollectedBy || '', pdcCompletedJobsText(vehicle),
  ].map(csvEscape).join(',')));
  return lines.join('\n');
}

function exportCompletedVehiclesCsv() {
  const blob = new Blob([completedHistoryCsv()], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pdc-completed-vehicles-export.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function exportRftCsv() {
  const rows = rftHomeRows();
  const headers = ['RFT Status','Stock','Key','Client','Vehicle','Completed Jobs','Outstanding Jobs','Blockers','Transferred At','Transferred By'];
  const lines = [headers.join(',')].concat(rows.map(vehicle => [
    rftHomeStatusLabel(rftHomeStatus(vehicle)), displayStockNumber(vehicle), vehicleKeyNumber(vehicle),
    vehicle.client || vehicle.toyotaCustomer || '', displayVehicle(vehicle), pdcCompletedJobsText(vehicle),
    pdcOutstandingJobsText(vehicle), vehicleRftGateIssues(vehicle).join(' | '), vehicle.rftTransferredAt || vehicle.pdcLocationUpdatedAt || '', vehicle.rftTransferredBy || ''
  ].map(csvEscape).join(',')));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pdc-rft-home-export.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function groupBy(items, fn) {
  return items.reduce((acc, item) => {
    const key = fn(item);
    acc[key] = acc[key] || [];
    acc[key].push(item);
    return acc;
  }, {});
}

function renderTvBoard() {
  const host = $('#tv-board');
  if (!host) return;
  const rows = pdcSheetVehicles();
  const pmbRows = rows.filter(vehicle => statusCategory(vehicle) === 'pmb');
  const blocked = pmbRows.filter(isPdcBlocked);
  const gateIssues = pmbRows.filter(vehicle => vehicleRftGateIssues(vehicle).length);
  const stageCards = STATUS_TAB_DEFS.filter(def => def.key !== 'all').map(def => {
    const count = rows.filter(matchesQuickFilter(def.key)).length;
    return `<button class="tv-stage-card ${escapeHtml(def.className)}" type="button" data-tv-filter="${escapeHtml(def.key)}"><span>${escapeHtml(def.label)}</span><strong>${count}</strong><small>${escapeHtml(def.sub)}</small></button>`;
  }).join('');

  const lanes = [
    { value: '', label: 'Unassigned' },
    ...PMB_STAGE_DEFS.map(def => ({ value: def.value, label: def.label }))
  ];
  const laneCards = lanes.map(lane => {
    const vehicles = lane.value ? pmbRows.filter(v => inferredPmbStage(v) === lane.value) : pmbRows.filter(v => !inferredPmbStage(v));
    const metrics = pmbLaneMetrics(lane.value, vehicles);
    const oldest = metrics.oldestStageDays ? `${metrics.oldestStageDays}d oldest` : 'No ageing';
    const className = metrics.overLimit ? 'over-limit' : metrics.blockedCount ? 'has-blocked' : metrics.atLimit ? 'at-limit' : 'normal';
    return `<article class="tv-lane-card ${escapeHtml(className)}">
      <div><span>${escapeHtml(lane.label)}</span><strong>${vehicles.length}/${escapeHtml(metrics.limitLabel)}</strong></div>
      <small>${escapeHtml(oldest)} · ${metrics.blockedCount} blocked · ${vehiclesWithRftGateIssues(vehicles).length} gate issue${vehiclesWithRftGateIssues(vehicles).length === 1 ? '' : 's'}</small>
    </article>`;
  }).join('');

  const overdue = pmbRows
    .map(vehicle => ({ vehicle, days: pmbStageAgeDays(vehicle), limit: pmbLaneAgeLimit(inferredPmbStage(vehicle)) }))
    .filter(row => row.days !== null && row.days > row.limit)
    .sort((a, b) => b.days - a.days)
    .slice(0, 12);

  const issueList = gateIssues.slice(0, 12).map(vehicle => `<button class="tv-issue-row" type="button" data-open-stock="${escapeHtml(vehicleKey(vehicle))}">
    ${vehicleIdentityStackHtml(vehicle)}
    <small>${escapeHtml(vehicleRftGateIssues(vehicle).join(' · '))}</small>
  </button>`).join('') || '<div class="subtle">No active RFT gate issues.</div>';

  const overdueList = overdue.map(row => `<button class="tv-issue-row" type="button" data-open-stock="${escapeHtml(vehicleKey(row.vehicle))}">
    ${vehicleIdentityStackHtml(row.vehicle)}
    <span>${escapeHtml(pmbStageLabel(inferredPmbStage(row.vehicle)) || 'Unallocated')}</span>
    <small>${escapeHtml(row.days)} days in bucket · limit ${escapeHtml(row.limit)} day${row.limit === 1 ? '' : 's'}</small>
  </button>`).join('') || '<div class="subtle">No overdue PMB bucket ageing.</div>';

  const operator = String(localStorage.getItem(OPERATOR_NAME_KEY) || '').trim() || 'Not set';
  const role = String(localStorage.getItem(OPERATOR_ROLE_KEY) || '').trim() || 'Not set';
  host.innerHTML = `
    <div class="tv-operator-strip"><span>Current operator: <strong>${escapeHtml(operator)}</strong> · Role: <strong>${escapeHtml(role)}</strong></span><button class="small-button" id="tv-set-operator" type="button">Set operator</button></div>
    <div class="tv-stage-grid">${stageCards}</div>
    <div class="tv-section-grid">
      <section class="tv-panel"><h3>PMB WIP limits</h3><div class="tv-lane-grid">${laneCards}</div></section>
      <section class="tv-panel"><h3>RFT gate / blocked work</h3><div class="tv-issue-list">${issueList}</div></section>
      <section class="tv-panel"><h3>Overdue bucket ageing</h3><div class="tv-issue-list">${overdueList}</div></section>
    </div>`;
  on($('#tv-set-operator'), 'click', setOperatorProfile);
  $$('[data-tv-filter]', host).forEach(button => button.addEventListener('click', () => applyQuickFilter(button.dataset.tvFilter)));
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
}

function renderCustomers() {
  const grid = $('#customer-grid');
  if (!grid) return;
  const q = ($('#customer-search')?.value || '').toLowerCase();
  const byCustomer = groupBy(pdcSheetVehicles(), v => v.client || v.toyotaCustomer || 'Unknown');
  const cards = Object.entries(byCustomer)
    .filter(([name]) => !q || name.toLowerCase().includes(q))
    .sort(([a], [b]) => a.localeCompare(b))
    .slice(0, 72)
    .map(([name, vehicles]) => {
      const first = vehicles.find(v => v.contact) || vehicles[0];
      const statuses = [...new Set(vehicles.map(v => v.toyotaStatus).filter(Boolean))];
      const next = vehicles.map(v => scotEtaOnly(v.etaAtDealer)).filter(Boolean).sort((a, b) => (parseDateAU(a)?.getTime() || 0) - (parseDateAU(b)?.getTime() || 0))[0] || '';
      const salesPeople = [...new Set(vehicles.map(v => salesPersonInitials(consultantName(v))))].join(', ');
      return `<article class="customer-card">
        <h3>${escapeHtml(name)}</h3>
        <div class="customer-meta">
          <span class="badge neutral">${vehicles.length} vehicle${vehicles.length > 1 ? 's' : ''}</span>

        </div>
        <div class="subtle">SP: ${escapeHtml(salesPeople || '--')}</div>
        <div class="subtle">Contact: ${escapeHtml(first.contact || 'Add contact')}</div>
        <div class="subtle">Next ETA: ${escapeHtml(next)}</div>
        <div class="customer-meta">${vehicles.map(v => `<button class="vehicle-chip" data-stock="${escapeHtml(vehicleKey(v))}">${escapeHtml(displayStockNumber(v) || 'TBA')} · ${escapeHtml(displayVehicle(v) || 'Vehicle')}</button>`).join('')}</div>
        <div>${statuses.slice(0, 3).map(s => `<span class="badge ${statusClass(s)}">${escapeHtml(s)}</span>`).join(' ')}</div>
      </article>`;
    });
  grid.innerHTML = cards.join('') || $('#empty-state').innerHTML;
  $$('.vehicle-chip').forEach(chip => chip.addEventListener('click', () => { void openVehicleFromStockClick(chip.dataset.stock, chip); }));
}

function openCustomerModal() {
  const modal = $('#customer-modal');
  if (!modal) return;
  if (vehicleLifecycleSharedModeActive() && window.PDC_AUTH_CONTEXT?.role !== 'administrator') {
    pdcNotify('Manual browser-only vehicle creation is unavailable in shared mode. No vehicle was created.');
    return false;
  }
  rememberModalReturnFocus(modal);
  const form = $('#new-customer-form');
  form?.reset();
  if (form) delete form.dataset.acceptanceIdempotency;
  const salespersonSelect = $('[data-new-customer-salesperson]');
  if (salespersonSelect) salespersonSelect.innerHTML = salespersonOptionsHtml('');
  $('#new-customer-message').textContent = '';
  modal.hidden = false;
  document.body.classList.add('modal-open');
  $('#new-customer-form input[name="client"]')?.focus();
}

function closeCustomerModal() {
  const modal = $('#customer-modal');
  if (!modal || modal.hidden) return;
  modal.hidden = true;
  if ($('#vehicle-modal')?.hidden !== false) document.body.classList.remove('modal-open');
  restoreModalReturnFocus(modal);
}

async function addCustomerFromForm(e) {
  e.preventDefault();
  const form = e.currentTarget;
  const data = Object.fromEntries(new FormData(form).entries());
  const stock = (data.stock || '').trim() || `NEW-${Date.now().toString().slice(-6)}`;
  const isProtectedAcceptanceVehicle = /^HERMES-TEST-AC-[ABC]$/.test(stock);
  if (vehicleLifecycleSharedModeActive() && !isProtectedAcceptanceVehicle) {
    const message = $('#new-customer-message');
    if (message) message.textContent = 'Manual browser-only vehicle creation is unavailable in shared mode. No vehicle was created.';
    return false;
  }
  if (isProtectedAcceptanceVehicle) {
    const service = app.emailVehicleLocationService;
    const message = $('#new-customer-message');
    const submit = form.querySelector('button[type="submit"]');
    if (!service || typeof service.createAcceptanceVehicle !== 'function' || window.PDC_AUTH_CONTEXT?.role !== 'administrator') {
      if (message) message.textContent = 'Protected staging creation is unavailable';
      return;
    }
    const idempotencyKey = form.dataset.acceptanceIdempotency || crypto.randomUUID();
    form.dataset.acceptanceIdempotency = idempotencyKey;
    if (submit) submit.disabled = true;
    if (message) message.textContent = 'Creating protected staging vehicle…';
    const result = await service.createAcceptanceVehicle(stock, data.client, data.vehicle, data.pdcJobcard, idempotencyKey);
    if (!result?.ok) {
      if (submit) submit.disabled = false;
      if (message) message.textContent = `Not created (${result?.code || 'request failed'})`;
      return;
    }
    delete form.dataset.acceptanceIdempotency;
    const refreshed = await refreshEmailVehicleLocations();
    const created = selectedVehicle(stock);
    if (!refreshed || !created || created.__emailVehicleServerAuthoritative !== true
        || String(created.__emailVehicleId || '') !== String(result.data?.vehicle_id || '')) {
      if (submit) submit.disabled = false;
      if (message) message.textContent = 'Created receipt returned, but authoritative readback did not converge';
      return;
    }
    populateFilters();
    renderAll();
    closeCustomerModal();
    showView('dashboard');
    openVehicleModal(stock);
    return;
  }
  const vehicle = {
    id: `manual-${Date.now()}`,
    sourceRow: '',
    stock,
    client: (data.client || '').trim(),
    internalStatus: (data.internalStatus || '').trim(),
    deliveryDate: '',
    vehicle: (data.vehicle || '').trim(),
    financeNote: '',
    group: 'Manual entry',
    source: 'Manual',
    recordLifecycle: 'manual',
    pdcSheetVisible: true,
    pdcVisibilitySource: 'Manual vehicle entry',
    pdcPromotedAt: nowIsoString(),
    toyotaCustomer: '',
    contact: (data.contact || '').trim(),
    toyotaVehicle: '',
    suffix: '',
    colour: '',
    trim: '',
    origMth: '',
    prodMth: '',
    compPlate: '',
    arrivalPort: '',
    toyotaStatus: '',
    etaAtDealer: (data.etaAtDealer || '').trim(),
    epodReceipt: '',
    jitQty: '',
    pdcJobcard: (data.pdcJobcard || '').trim(),
    consultant: (data.consultant || '').trim(),
  };
  const added = loadAddedVehicles();
  added.unshift(vehicle);
  saveAddedVehicles(added);
  app.data.unshift(vehicle);
  populateFilters();
  renderAll();
  closeCustomerModal();
  showView('dashboard');
  openVehicleModal(stock);
}

function normalizePurchaseOrderText(value = '') {
  return String(value || '')
    .replace(/\r/g, '\n')
    .replace(/\f/g, '\n')
    .replace(/[−–—]/g, '-')
    .replace(/\u00a0/g, ' ');
}

function cleanPurchaseOrderLine(value = '') {
  return normalizePurchaseOrderText(value).replace(/\s+/g, ' ').trim();
}

function purchaseOrderNumberFromFilename(filename = '') {
  return ((String(filename).match(/\bPO\d{6,}\b/i) || [])[0] || '').toUpperCase();
}

function extractStockFromPoFilename(filename = '') {
  const value = String(filename || '');
  const labelled = value.match(/(?:stock|batch)[ _#:-]*(\d{6,12})/i);
  if (labelled) return labelled[1];
  if (/\bPO\d{6,}\b/i.test(value)) return '';
  const unlabelled = value.match(/\b\d{7,12}\b/);
  return unlabelled ? unlabelled[0] : '';
}

function purchaseOrderCodeAndDescription(value = '') {
  const cleaned = cleanPurchaseOrderLine(value);
  const match = cleaned.match(/^(TOY[A-Z0-9]+)\s+(.+)$/i);
  return match ? { code: match[1].toUpperCase(), description: match[2].trim() } : { code: '', description: cleaned };
}

function purchaseOrderClientFromDeliverTo(deliverTo = '') {
  if (/FLEET/i.test(deliverTo)) return 'Broome Toyota Fleet Sales';
  if (/RETAIL/i.test(deliverTo)) return 'Broome Toyota Retail Sales';
  return 'Broome Toyota';
}

function purchaseOrderSalespersonCode(issuedBy = '') {
  const code = cleanPurchaseOrderLine(issuedBy).toUpperCase();
  if (/^[A-Z]{5,}$/.test(code)) return `${code[0]}${code[code.length - 1]}`;
  return /^[A-Z]{1,4}$/.test(code) ? code : '';
}

function purchaseOrderLabelValue(lines, labelPattern) {
  const line = lines.find(value => labelPattern.test(value));
  return line ? cleanPurchaseOrderLine(line.replace(labelPattern, '')) : '';
}

function legacyDisabledParsePurchaseOrderText(text, sourceFilename = '') {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
  const raw = normalizePurchaseOrderText(text);
  const lines = raw.split('\n').map(cleanPurchaseOrderLine).filter(Boolean);
  const compact = lines.join(' ');
  const headerMatch = compact.match(/\b(PO\d{6,})\s+(\d{1,2}\/\d{1,2}\/\d{2,4})\s+([A-Z][A-Z0-9]{1,15})\s+Vehicle\s*\/\s*Sublet\s+(\d{2,4})\s+(\d{6,12})\s+\d+\b/i);
  const purchaseOrderNumber = ((headerMatch && headerMatch[1]) || (raw.match(/\bPO\d{6,}\b/i) || [])[0] || purchaseOrderNumberFromFilename(sourceFilename)).toUpperCase();
  const stock = ((raw.match(/Stock\s*#\s*:?\s*(\d{6,12})/i) || [])[1] || (headerMatch && headerMatch[5]) || extractStockFromPoFilename(sourceFilename) || '').trim();
  const dueDate = (headerMatch && headerMatch[2]) || '';
  const issuedBy = ((headerMatch && headerMatch[3]) || ((sourceFilename.match(/^([A-Z]{3,})_PO/i) || [])[1]) || '').toUpperCase();
  const department = (headerMatch && headerMatch[4]) || '';
  const reference = (headerMatch && headerMatch[5]) || stock;
  const printedMatch = compact.match(/Printed\s+(\d{1,2}\/\d{1,2}\/\d{2,4})\s+(\d{1,2}:\d{2})/i);
  const deliverTo = ((compact.match(/\bNEW TOYOTA (?:FLEET|RETAIL) SALES\b/i) || [])[0] || '').toUpperCase();
  const colourValue = purchaseOrderLabelValue(lines, /^Colour\s*:\s*/i);
  const trimValue = purchaseOrderLabelValue(lines, /^Trim\s*:\s*/i);
  const colour = purchaseOrderCodeAndDescription(colourValue);
  const trim = purchaseOrderCodeAndDescription(trimValue);
  const factoryOption = purchaseOrderLabelValue(lines, /^Factory Option\s*:\s*/i);
  const alternateModel = purchaseOrderLabelValue(lines, /^Alternate Model\s*:\s*/i);
  const engine = purchaseOrderLabelValue(lines, /^Engine\s*:\s*/i);
  const buildDate = purchaseOrderLabelValue(lines, /^Build Date\s*:\s*/i);
  const vin = normalizeVin(purchaseOrderLabelValue(lines, /^VIN\s*:\s*/i));

  const metadataIndexes = new Set();
  lines.forEach((line, index) => {
    if (/^(Colour|Trim|Factory Option|Alternate Model|Engine|Build Date|Stock\s*#|VIN)\s*:/i.test(line)) metadataIndexes.add(index);
  });
  const colourIndex = lines.findIndex(line => /^Colour\s*:/i.test(line));
  let vehicle = '';
  let modelCode = '';
  if (colourIndex > 0) {
    const immediatelyBefore = lines[colourIndex - 1];
    const separateModelCode = immediatelyBefore.match(/^([A-Z0-9-]{5,})\s+(\d{3})$/i);
    if (separateModelCode && colourIndex > 1) {
      modelCode = `${separateModelCode[1]} ${separateModelCode[2]}`;
      vehicle = lines[colourIndex - 2];
      metadataIndexes.add(colourIndex - 2);
      metadataIndexes.add(colourIndex - 1);
    } else {
      const combinedModelCode = immediatelyBefore.match(/\s+([A-Z0-9-]{5,})\s+(\d{3})$/i);
      modelCode = combinedModelCode ? `${combinedModelCode[1]} ${combinedModelCode[2]}` : '';
      vehicle = combinedModelCode ? immediatelyBefore.slice(0, combinedModelCode.index).trim() : immediatelyBefore;
      metadataIndexes.add(colourIndex - 1);
    }
  }

  const lineItems = [];
  let currentLineItem = null;
  const wrappedDescriptionIndexes = new Set();
  lines.forEach((line, index) => {
    if (wrappedDescriptionIndexes.has(index)) return;
    let itemLine = line;
    const nextLine = lines[index + 1] || '';
    if (/^[!A-Z][A-Z0-9_*!-]{1,40}$/.test(line) && /\s+\d+(?:\.\d+)?\s+\$?[\d,.]+\s+\$?[\d,.]+$/.test(nextLine)) {
      itemLine = `${line} ${nextLine}`;
      wrappedDescriptionIndexes.add(index + 1);
    }
    const itemMatch = itemLine.match(/^([!A-Z][A-Z0-9_*!-]{1,40})\s+(.+?)\s+(\d+(?:\.\d+)?)\s+\$?([\d,.]+)\s+\$?([\d,.]+)$/);
    if (itemMatch) {
      if (/^PO\d{6,}$/i.test(itemMatch[1])) return;
      currentLineItem = {
        item: itemMatch[1],
        description: itemMatch[2].trim(),
        quantity: itemMatch[3],
        unitPrice: itemMatch[4],
        extendedPrice: itemMatch[5],
      };
      lineItems.push(currentLineItem);
      return;
    }
    if (/^Stock\s*#/i.test(line)) {
      currentLineItem = null;
      return;
    }
    if (!currentLineItem || metadataIndexes.has(index)) return;
    if (/^(PURCHASE ORDER|Printed|\d{1,2}\/\d{1,2}\/\d{2,4}\s+\d{1,2}:\d{2}|To Deliver To|PILBARA MOTOR GROUP|PO BOX|CNR\b|BROOME\b|MALAGA\b|PH:|P\.O\. No\.|PO\d{6,}\b|Item Description|Text$|\*+\s*CONTINUED|TOTAL$|Total Exc\.|GST\b|Purchase order number|No backorders|Authorised Signature|\(Includes GST\))/i.test(line)) return;
    if (line.length <= 160 && !/^[\d$,. ]+$/.test(line)) currentLineItem.description = `${currentLineItem.description} ${line}`.replace(/\s+/g, ' ').trim();
  });

  const totalMatches = [...raw.matchAll(/\$\s*([\d,]+\.\d{2})/g)];
  const tasks = [...new Set(lineItems.map(item => item.description).filter(Boolean))];
  return {
    sourceFilename,
    purchaseOrderNumber,
    stock,
    dueDate,
    issuedBy,
    salesperson: purchaseOrderSalespersonCode(issuedBy),
    department,
    reference,
    printedDate: (printedMatch && printedMatch[1]) || '',
    printedTime: (printedMatch && printedMatch[2]) || '',
    deliverTo,
    client: purchaseOrderClientFromDeliverTo(deliverTo),
    vehicle,
    modelCode,
    colourCode: colour.code,
    colour: colour.description,
    trimCode: trim.code,
    trim: trim.description,
    factoryOption,
    alternateModel,
    engine,
    buildDate,
    vin,
    totalIncGst: totalMatches.length ? totalMatches[totalMatches.length - 1][1] : '',
    lineItems,
    tasks,
  };
}

function legacyDisabledFindVehicleForPurchaseOrder(parsed = {}) {
  const stock = normalizeBatch(parsed.stock);
  const reference = normalizeBatch(parsed.reference);
  const vin = normalizeVin(parsed.vin);
  return app.data.find(vehicle => {
    const identities = [vehicle.stock, vehicle.batch, vehicle.toyotaBatch].map(normalizeBatch).filter(Boolean);
    const vehicleVin = normalizeVin(vehicle.vin || vehicle.autocareVin || vehicle.frameVin);
    return (stock && identities.includes(stock)) || (reference && identities.includes(reference)) || (vin && vehicleVin === vin);
  }) || null;
}

function legacyDisabledEnsureVehicleForPo(stockOrParsed) {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
  const parsed = typeof stockOrParsed === 'object' ? stockOrParsed : { stock: String(stockOrParsed || '') };
  const stock = String(parsed.stock || parsed.reference || '').trim();
  let vehicle = findVehicleForPurchaseOrder(parsed);
  if (vehicle) return promoteVehicleToPdcSheet(vehicle, 'Disabled legacy document intake');
  vehicle = {
    id: `po-${stock}`,
    sourceRow: '',
    stock,
    batch: stock,
    client: parsed.client || 'Broome Toyota',
    internalStatus: '',
    deliveryDate: '',
    vehicle: parsed.vehicle || '',
    financeNote: '',
    group: 'Disabled legacy document intake',
    source: 'Disabled legacy document intake',
    recordLifecycle: 'purchase-order',
    pdcSheetVisible: true,
    pdcVisibilitySource: 'Disabled legacy document intake',
    pdcPromotedAt: nowIsoString(),
    toyotaCustomer: '',
    contact: '',
    toyotaVehicle: parsed.vehicle || '',
    suffix: '',
    colour: parsed.colour || '',
    trim: parsed.trim || '',
    origMth: '',
    prodMth: '',
    compPlate: '',
    arrivalPort: '',
    toyotaStatus: '',
    etaAtDealer: '',
    epodReceipt: '',
    jitQty: '',
    consultant: parsed.salesperson || '',
    vin: parsed.vin || '',
    poTasks: [],
    poFiles: [],
  };
  const added = loadAddedVehicles();
  added.unshift(vehicle);
  saveAddedVehicles(added);
  app.data.unshift(vehicle);
  return vehicle;
}

function legacyDisabledPurchaseOrderVehicleUpdates(vehicle, parsed, combinedTasks, combinedFiles) {
  const flags = workImportRequirementUpdates(parsed, vehicle, combinedTasks);
  const wasReviewed = Boolean(parsed.reviewRequirementUpdates && typeof parsed.reviewRequirementUpdates === 'object');
  const importedJobLines = (parsed.lineItems || []).map(pdcJobLineFromPurchaseOrderItem);
  const updates = {
    purchaseOrderNumber: parsed.purchaseOrderNumber,
    purchaseOrderDueDate: parsed.dueDate,
    purchaseOrderIssuedBy: parsed.issuedBy,
    purchaseOrderDepartment: parsed.department,
    purchaseOrderReference: parsed.reference,
    purchaseOrderPrintedDate: parsed.printedDate,
    purchaseOrderPrintedTime: parsed.printedTime,
    purchaseOrderDeliverTo: parsed.deliverTo,
    purchaseOrderTotalIncGst: parsed.totalIncGst,
    purchaseOrderModelCode: parsed.modelCode,
    purchaseOrderColourCode: parsed.colourCode,
    purchaseOrderTrimCode: parsed.trimCode,
    purchaseOrderFactoryOption: parsed.factoryOption,
    purchaseOrderAlternateModel: parsed.alternateModel,
    purchaseOrderEngine: parsed.engine,
    purchaseOrderBuildDate: parsed.buildDate,
    purchaseOrderLineItems: parsed.lineItems,
    pdcManualJobLines: mergePdcJobLines(vehicle.pdcManualJobLines || [], importedJobLines),
    poTasks: combinedTasks,
    poFiles: combinedFiles,
    buildPoRaised: true,
    pdcSheetVisible: true,
    pdcVisibilitySource: 'Disabled legacy document intake',
    pdcPromotedAt: vehicle.pdcPromotedAt || nowIsoString(),
    pdcLocation: vehiclePdcLocation(vehicle) || 'PMB',
  };
  Object.entries(flags).forEach(([key, value]) => {
    updates[key] = wasReviewed ? value === true : value === true || vehicle[key] === true;
  });
  if ((!vehicle.client || /customer (?:from|not on) po/i.test(vehicle.client)) && parsed.client) updates.client = parsed.client;
  if (!cleanNavisionText(vehicle.vehicle) && parsed.vehicle) updates.vehicle = parsed.vehicle;
  if (!cleanNavisionText(vehicle.toyotaVehicle) && parsed.vehicle) updates.toyotaVehicle = parsed.vehicle;
  if (!cleanNavisionText(vehicle.colour) && parsed.colour) updates.colour = parsed.colour;
  if (!cleanNavisionText(vehicle.trim) && parsed.trim) updates.trim = parsed.trim;
  if (!normalizeVin(vehicle.vin) && parsed.vin) updates.vin = parsed.vin;
  if ((!vehicle.consultant || consultantName(vehicle) === 'Unassigned') && parsed.salesperson) updates.consultant = parsed.salesperson;
  Object.assign(updates, workImportVehicleUpdates(parsed));
  return updates;
}

function legacyDisabledPersistPurchaseOrderVehicleUpdates(vehicle, updates) {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
  const key = vehicleKey(vehicle);
  Object.assign(vehicle, updates);
  const edits = loadVehicleEdits();
  edits[key] = { ...(edits[key] || {}), ...updates };
  saveJson(EDITS_KEY, edits);
}

function legacyDisabledApplyPurchaseOrderImport(parsed, filename) {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
}

function legacyDisabledApplyPurchaseOrderImportUnsafe(parsed, filename) {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
  const existing = findVehicleForPurchaseOrder(parsed);
  const vehicle = ensureVehicleForPo(parsed);
  const key = vehicleKey(vehicle);
  const tasksStore = loadPoTasks();
  const filesStore = loadPoFiles();
  const currentTasks = tasksStore[key] || vehicle.poTasks || [];
  const combinedTasks = [...new Set(currentTasks.concat(parsed.tasks || []))];
  const currentFiles = filesStore[key] || vehicle.poFiles || [];
  const combinedFiles = [...new Set(currentFiles.concat(filename || parsed.sourceFilename || []).filter(Boolean))];
  tasksStore[key] = combinedTasks;
  filesStore[key] = combinedFiles;
  savePoTasks(tasksStore);
  savePoFiles(filesStore);
  persistPurchaseOrderVehicleUpdates(vehicle, purchaseOrderVehicleUpdates(vehicle, parsed, combinedTasks, combinedFiles));
  recordVehicleAudit(vehicle, existing ? 'Purchase order matched' : 'Vehicle created from purchase order', {
    purchaseOrder: parsed.purchaseOrderNumber,
    file: filename,
    tasks: (parsed.tasks || []).length,
  });
  return { vehicle, created: !existing, taskCount: (parsed.tasks || []).length, totalTasks: combinedTasks.length };
}

async function legacyDisabledHandleVehiclePoSelect(key, event) {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
  const files = [...(event.target.files || [])];
  if (!files.length) return;
  const selected = selectedVehicle(key);
  if (!selected) return;
  const selectedStock = normalizeBatch(selected.stock || selected.batch);
  const messages = [];
  let importedCount = 0;
  for (const file of files) {
    try {
      const parsed = parsePurchaseOrderText(await extractTextFromPdfFile(file), file.name);
      if (!parsed.stock && selectedStock) parsed.stock = selectedStock;
      if (selectedStock && normalizeBatch(parsed.stock) !== selectedStock) {
        throw new Error(`This PO is for stock ${parsed.stock}, not ${displayStockNumber(selected) || selectedStock}.`);
      }
      const reviewed = await showWorkImportReviewModal({ kind: 'po', parsed, filename: file.name, existing: selected });
      if (!reviewed) {
        messages.push(`${file.name}: import cancelled; no changes saved.`);
        continue;
      }
      const result = applyPurchaseOrderImport(reviewed, file.name);
      importedCount += 1;
      messages.push(`${reviewed.purchaseOrderNumber || file.name}: ${result.taskCount} work items imported after review.`);
    } catch (error) {
      messages.push(`${file.name}: ${error.message || error}`);
    }
  }
  app.data = buildVehicleData();
  if (importedCount) {
    updateOperationalHealth({
      lastWorkImportAt: nowIsoString(),
      lastWorkImportType: 'Purchase order',
      lastWorkImportRows: importedCount,
    });
  }
  renderAll();
  app.selectedStock = vehicleKey(selected);
  renderDetail();
  if (messages.some(message => /not |No Stock|could not|error/i.test(message))) pdcNotify(messages.join('\n'));
  event.target.value = '';
}

async function legacyDisabledHandlePoSelect(e) {
  throw new Error('Purchase-order vehicle-work intake is disabled. Upload the approved PD Document instead.');
  const files = [...(e.target.files || [])];
  const statusList = $('#po-status-list');
  const card = $('#po-scan-card');
  if (!files.length) return;
  if (statusList) statusList.innerHTML = '<div class="po-status-row"><strong>Reading PDFs</strong><span>Extracting stock, vehicle details and PMB work items...</span></div>';
  if (card) {
    card.querySelector('.po-files strong').textContent = `${files.length} file${files.length === 1 ? '' : 's'}`;
    card.querySelector('.po-matched strong').textContent = 'Reading...';
    card.querySelector('.po-created strong').textContent = 'Reading...';
  }
  const results = [];
  for (const file of files) {
    try {
      const text = await extractTextFromPdfFile(file);
      const parsed = parsePurchaseOrderText(text, file.name);
      const reviewed = await showWorkImportReviewModal({
        kind: 'po',
        parsed,
        filename: file.name,
        existing: findVehicleForPurchaseOrder(parsed),
      });
      if (!reviewed) {
        results.push({ ok: false, cancelled: true, file: file.name, stock: parsed.stock || '', created: false, message: 'Import cancelled. No vehicle data was changed.' });
        continue;
      }
      const applied = applyPurchaseOrderImport(reviewed, file.name);
      const selectedWork = PDC_JOB_DEFS.filter(def => reviewed.reviewRequirementUpdates?.[def.requireKey]).map(def => def.label);
      results.push({
        ok: true,
        file: file.name,
        stock: reviewed.stock,
        created: applied.created,
        po: reviewed.purchaseOrderNumber,
        vehicle: reviewed.vehicle,
        count: applied.taskCount,
        vehicleKey: vehicleKey(applied.vehicle),
        message: `${applied.created ? 'Created new active vehicle from PO' : 'Matched existing vehicle'} · Required work: ${selectedWork.join(', ') || 'none selected'} · ${reviewed.client}`,
      });
    } catch (error) {
      results.push({ ok: false, file: file.name, stock: '', created: false, message: error.message || String(error) });
    }
  }
  app.data = buildVehicleData();
  const successfulImports = results.filter(result => result.ok);
  if (successfulImports.length) {
    updateOperationalHealth({
      lastWorkImportAt: nowIsoString(),
      lastWorkImportType: 'Purchase order',
      lastWorkImportRows: successfulImports.length,
    });
  }
  if (card) {
    card.querySelector('.po-matched strong').textContent = `${results.filter(result => result.ok).length} active`;
    card.querySelector('.po-created strong').textContent = `${results.filter(result => result.ok && result.created).length} new`;
  }
  if (statusList) {
    statusList.innerHTML = results.map(result => `<div class="po-status-row ${result.ok ? 'ok' : 'warn'}"><strong>${escapeHtml(result.stock || 'Not imported')}</strong><span>${result.po ? `<b>${escapeHtml(result.po)}</b> · ` : ''}${result.vehicle ? `${escapeHtml(result.vehicle)} · ` : ''}${escapeHtml(result.message)}<small>${escapeHtml(result.file)}</small></span></div>`).join('');
  }
  app.quickFilter = 'incoming';
  populateFilters();
  renderAll();
  focusVehiclesAfterWorkImport(results.filter(result => result.ok).map(result => result.vehicleKey));
  e.target.value = '';
}


function updateAutocareScanButton() {
  const button = $('#scan-autocare');
  if (!button) return;
  const hasFiles = Boolean(app.autocareFiles && app.autocareFiles.length);
  const hasPaste = Boolean(($('#autocare-paste')?.value || '').trim());
  button.disabled = !(hasFiles || hasPaste);
}

function handleAutocareSelect(e) {
  const files = [...(e.target.files || [])];
  app.autocareFiles = files;
  const card = $('#autocare-scan-card');
  if (card) {
    card.querySelector('.autocare-files strong').textContent = `${files.length} file${files.length === 1 ? '' : 's'}`;
    card.querySelector('.autocare-detected strong').textContent = 'Ready to scan';
    card.querySelector('.autocare-matched strong').textContent = '0 matched';
  }
  app.autocareScan = null;
  renderAutocareResults(null);
  updateAutocareScanButton();
}

function clearAutocareResults() {
  app.autocareFiles = [];
  app.autocareScan = null;
  saveJson(AUTOCARE_RESULTS_KEY, null);
  const upload = $('#autocare-upload');
  const paste = $('#autocare-paste');
  if (upload) upload.value = '';
  if (paste) paste.value = '';
  const card = $('#autocare-scan-card');
  if (card) {
    card.querySelector('.autocare-files strong').textContent = '0 files';
    card.querySelector('.autocare-detected strong').textContent = '0 detected';
    card.querySelector('.autocare-matched strong').textContent = '0 matched';
  }
  renderAutocareResults(null);
  updateAutocareScanButton();
}

async function scanAutocareNotice() {
  const button = $('#scan-autocare');
  if (button) {
    button.disabled = true;
    button.textContent = 'Scanning...';
  }
  const files = app.autocareFiles || [];
  const pastedText = ($('#autocare-paste')?.value || '').trim();
  const texts = [];
  const warnings = [];

  for (const file of files) {
    try {
      const text = await extractTextFromPdfFile(file);
      texts.push(text);
    } catch (error) {
      warnings.push(`${file.name}: ${error.message || error}`);
    }
  }
  if (pastedText) texts.push(pastedText);

  const combinedText = texts.join('\n\n');
  const parsed = parseAutocareNoticeText(combinedText, files.map(file => file.name));
  parsed.warnings = [...(parsed.warnings || []), ...warnings];
  if (!combinedText.trim() && warnings.length) {
    parsed.warnings.unshift('No notice text could be read. Paste the Autocare notice text into the optional paste area, then scan again.');
  }

  const result = applyAutocareDespatch(parsed);
  app.autocareScan = result;
  saveJson(AUTOCARE_RESULTS_KEY, result);
  renderAutocareResults(result);
  updateAutocareControlStats(result);

  if (button) {
    button.textContent = 'Scan Autocare notice';
    updateAutocareScanButton();
  }
  if (result.vehicles?.length && window.confirm(`Autocare notice loaded ${result.vehicles.length} vehicle${result.vehicles.length === 1 ? '' : 's'}.\n\nPrint one Zebra label for each vehicle now?`)) {
    await printZplFromAutocareResults('all');
  }
}

async function extractTextFromPdfFile(file) {
  if (!window.pdfjsLib) {
    try {
      await loadExternalScript('vendor/pdfjs/pdf.min.js?v=3.11.174', 'pdfjs-script');
      if (window.pdfjsLib) window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'vendor/pdfjs/pdf.worker.min.js?v=3.11.174';
    } catch (_) {
      // The built-in lightweight reader below remains available when PDF.js cannot load.
    }
  }
  if (window.pdfjsLib) {
    try {
      const data = new Uint8Array(await file.arrayBuffer());
      const pdf = await window.pdfjsLib.getDocument({ data }).promise;
      const pages = [];
      for (let pageNo = 1; pageNo <= pdf.numPages; pageNo += 1) {
        const page = await pdf.getPage(pageNo);
        const textContent = await page.getTextContent();
        pages.push(pdfTextContentToLines(textContent));
      }
      return pages.join('\n\n');
    } catch (_) {
      // Fall through to the built-in lightweight PDF reader.
    }
  }
  return extractTextFromPdfStreams(file);
}

async function extractTextFromPdfStreams(file) {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const decoder = new TextDecoder('latin1');
  const raw = decoder.decode(bytes);
  const chunks = [];
  const warnings = [];
  let searchFrom = 0;

  while (searchFrom < raw.length) {
    const streamIndex = raw.indexOf('stream', searchFrom);
    if (streamIndex === -1) break;
    let dataStart = streamIndex + 'stream'.length;
    if (bytes[dataStart] === 13) dataStart += 1;
    if (bytes[dataStart] === 10) dataStart += 1;
    const endIndex = raw.indexOf('endstream', dataStart);
    if (endIndex === -1) break;
    let dataEnd = endIndex;
    while (dataEnd > dataStart && (bytes[dataEnd - 1] === 10 || bytes[dataEnd - 1] === 13 || bytes[dataEnd - 1] === 32 || bytes[dataEnd - 1] === 9)) dataEnd -= 1;
    const dictStart = Math.max(0, raw.lastIndexOf('<<', streamIndex));
    const dictText = raw.slice(dictStart, streamIndex);
    const streamBytes = bytes.slice(dataStart, dataEnd);
    if (/\/FlateDecode/i.test(dictText)) {
      const inflated = await inflatePdfStreamBytes(streamBytes);
      if (inflated) chunks.push(inflated);
      else warnings.push('A compressed PDF stream could not be read in this browser.');
    } else if (!/\/DCTDecode|\/Image/i.test(dictText)) {
      chunks.push(decoder.decode(streamBytes));
    }
    searchFrom = endIndex + 'endstream'.length;
  }

  const text = chunks.map(pdfContentStreamText).join('\n');
  if (!text.trim() && /VIN|Batch|DESPATCH|Autocare/i.test(raw)) return raw;
  if (!text.trim() && warnings.length) throw new Error(warnings[0]);
  return text;
}

async function inflatePdfStreamBytes(bytes) {
  if (typeof DecompressionStream === 'undefined') return '';
  for (const format of ['deflate', 'deflate-raw']) {
    try {
      const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream(format));
      const inflated = await new Response(stream).arrayBuffer();
      return new TextDecoder('latin1').decode(inflated);
    } catch (_) {
      // Try the next format.
    }
  }
  return '';
}

function pdfContentStreamText(text = '') {
  const parts = [];
  const re = /\((?:\\.|[^\\)])*\)/g;
  let match;
  while ((match = re.exec(text))) parts.push(decodePdfTextLiteral(match[0].slice(1, -1)));
  return parts.length ? parts.join('\n') : text;
}

function decodePdfTextLiteral(value = '') {
  return String(value)
    .replace(/\\([nrtbf()\\])/g, (_, ch) => ({ n: '\n', r: '\r', t: '\t', b: '\b', f: '\f', '(': '(', ')': ')', '\\': '\\' }[ch] || ch))
    .replace(/\\\r?\n/g, '')
    .replace(/[ \t]+/g, ' ')
    .trim();
}

function pdfTextContentToLines(textContent) {
  const rows = [];
  (textContent.items || []).forEach(item => {
    const str = String(item.str || '').trim();
    if (!str) return;
    const transform = item.transform || [];
    const x = Number(transform[4] || 0);
    const y = Number(transform[5] || 0);
    let row = rows.find(entry => Math.abs(entry.y - y) <= 2);
    if (!row) {
      row = { y, items: [] };
      rows.push(row);
    }
    row.items.push({ x, str });
  });
  return rows
    .sort((a, b) => b.y - a.y)
    .map(row => row.items.sort((a, b) => a.x - b.x).map(item => item.str).join(' '))
    .join('\n');
}

function parseAutocareNoticeText(text, sourceFiles = []) {
  const raw = String(text || '').replace(/\r/g, '\n').replace(/\f/g, '\n');
  const loadNumber = (raw.match(/Load\s*Number\s*:?\s*([A-Z0-9-]+)/i) || [])[1] || '';
  const haulierRegistration = (raw.match(/Haulier\s*Registration\s*:?\s*([A-Z0-9-]+)/i) || [])[1] || '';
  const byVin = new Map();
  const warnings = [];
  const lines = raw.split('\n').map(cleanAutocareLine).filter(Boolean);
  const compactRaw = raw.replace(/\s+/g, ' ');
  const compactDetailRe = /VIN:\s*([A-HJ-NPR-Z0-9]{17})[\s\S]{0,700}?Model:\s*(.*?)\s+Version:\s*(.*?)\s+Frame\s+No#?\s*:?\s*([A-Z0-9]+)\s+Batch\s+No#?\s*:?\s*(\d{6,12})/gi;
  let compactMatch;
  while ((compactMatch = compactDetailRe.exec(compactRaw))) {
    mergeAutocareVehicle(byVin, {
      vin: compactMatch[1],
      model: [compactMatch[2], compactMatch[3]].filter(Boolean).join(' '),
      modelDescription: compactMatch[2],
      versionDescription: compactMatch[3],
      frame: compactMatch[4],
      batch: compactMatch[5],
    });
  }

  lines.forEach(line => {
    const match = line.match(/^([A-HJ-NPR-Z0-9]{17})\s+(.+)$/i);
    if (!match) return;
    const description = match[2]
      .replace(/\s+Colour\s*$/i, '')
      .replace(/\s+Page\s+\d+\s*$/i, '')
      .trim();
    if (/^(manufacturer|model|version|frame|batch|area description)\b/i.test(description)) return;
    mergeAutocareVehicle(byVin, { vin: match[1], model: description });
  });

  raw.split(/VEHICLE DETAILS/i).slice(1).forEach(block => {
    const vin = normalizeVin(extractAutocareLineValue(block, /^VIN\s*:?\s*/i) || ((block.match(/\b[A-HJ-NPR-Z0-9]{17}\b/i) || [])[0]));
    if (!vin) return;
    const model = extractAutocareLineValue(block, /^Model\s*:?\s*/i);
    const version = extractAutocareLineValue(block, /^Version\s*:?\s*/i);
    const frame = extractAutocareLineValue(block, /^Frame\s+No#?\s*:?\s*/i);
    const batch = extractAutocareLineValue(block, /^Batch\s+No#?\s*:?\s*/i);
    mergeAutocareVehicle(byVin, {
      vin,
      model: [model, version].filter(Boolean).join(' '),
      modelDescription: model,
      versionDescription: version,
      frame,
      batch,
    });
  });

  if (!byVin.size) {
    [...raw.matchAll(/\b[A-HJ-NPR-Z0-9]{17}\b/gi)].forEach(match => mergeAutocareVehicle(byVin, { vin: match[0] }));
  }

  const vehicles = [...byVin.values()].sort((a, b) => String(a.vin).localeCompare(String(b.vin), 'en-AU', { numeric: true }));
  if (!vehicles.length && raw.trim()) warnings.push('No 17-character VINs were detected in the Autocare notice text.');
  return { sourceFiles, loadNumber, haulierRegistration, vehicles, warnings };
}

function cleanAutocareLine(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function extractAutocareLineValue(block, labelRegex) {
  const lines = String(block || '').split('\n').map(cleanAutocareLine).filter(Boolean);
  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];
    if (!labelRegex.test(line)) continue;
    const value = line.replace(labelRegex, '').replace(/^[:#\s]+/, '').trim();
    return value || cleanAutocareLine(lines[index + 1] || '');
  }
  return '';
}

function normalizeVin(value) {
  const match = String(value || '').toUpperCase().match(/\b(?:[A-HJ-NPR-Z0-9]{17}|REBHV1[0-9]{8})\b/);
  return match ? match[0] : '';
}

function normalizeBatch(value) {
  return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').trim();
}

function mergeAutocareVehicle(map, entry) {
  const vin = normalizeVin(entry.vin);
  if (!vin) return;
  const current = map.get(vin) || { vin, model: '', modelDescription: '', versionDescription: '', colour: '', batch: '', frame: '' };
  const nextModel = cleanAutocareLine(entry.model || '');
  const nextModelDescription = cleanAutocareLine(entry.modelDescription || '');
  const nextVersionDescription = cleanAutocareLine(entry.versionDescription || '');
  if (nextModel && nextModel.length >= current.model.length) current.model = nextModel;
  if (nextModelDescription) current.modelDescription = nextModelDescription;
  if (nextVersionDescription) current.versionDescription = nextVersionDescription;
  if (entry.colour || entry.color) current.colour = cleanAutocareLine(entry.colour || entry.color);
  if (entry.batch) current.batch = normalizeBatch(entry.batch);
  if (entry.frame) current.frame = normalizeBatch(entry.frame);
  map.set(vin, current);
}

function findAutocareVehicleMatch(item) {
  const vin = normalizeVin(item.vin);
  const batch = normalizeBatch(item.batch);
  const frame = normalizeBatch(item.frame);

  for (const vehicle of app.data) {
    const vehicleVin = normalizeVin(vehicle.vin || vehicle.autocareVin || vehicle.frameVin);
    if (vin && vehicleVin && vin === vehicleVin) return { vehicle, matchedBy: 'VIN' };
  }

  if (batch) {
    for (const vehicle of app.data) {
      const toyota = getToyotaMatch(vehicle) || {};
      const candidates = [vehicle.stock, vehicle.batch, vehicle.toyotaBatch, vehicle.autocareBatch, toyota.batch, toyota.stock]
        .map(normalizeBatch)
        .filter(Boolean);
      if (candidates.includes(batch)) return { vehicle, matchedBy: 'Batch / Stock' };
    }
  }

  if (frame) {
    for (const vehicle of app.data) {
      const candidates = [vehicle.frame, vehicle.frameNo, vehicle.autocareFrame]
        .map(normalizeBatch)
        .filter(Boolean);
      if (candidates.includes(frame)) return { vehicle, matchedBy: 'Frame' };
    }
  }
  return null;
}

function autocarePmbArrivalUpdates(vehicle = {}, arrivedAt = nowIsoString()) {
  const explicitLocation = vehiclePdcLocation(vehicle);
  const category = vehicleCollectedFromRft(vehicle)
    ? 'completed'
    : explicitLocation === 'RFT'
      ? 'rft'
      : explicitLocation === 'PMB'
        ? 'pmb'
        : statusCategory(vehicle);
  const alreadyFurtherAlong = category === 'rft' || category === 'completed';
  const alreadyAtPmb = category === 'pmb';
  const updates = {
    pdcSheetVisible: true,
    pdcVisibilitySource: 'Autocare despatch notice - PMB arrival',
    pdcPromotedAt: vehicle.pdcPromotedAt || arrivedAt,
  };
  if (alreadyFurtherAlong) {
    return {
      updates,
      arrivalNote: category === 'completed'
        ? 'Autocare arrival recorded; Completed location retained'
        : 'Autocare arrival recorded; RFT location retained',
      movedToPmb: false,
    };
  }
  Object.assign(updates, {
    pdcLocation: 'PMB',
    manualLocation: 'PMB',
    pdcLocationLocked: true,
    pdcLocationDerivedFromNavision: false,
    pdcLocationUpdatedAt: arrivedAt,
    pmbEnteredAt: pmbEnteredTimestamp(vehicle) || arrivedAt,
  });
  if (!alreadyAtPmb) {
    Object.assign(updates, {
      pmbStage: '',
      pdcWorkStage: '',
      workStage: '',
      pmbStageEnteredAt: '',
      pmbStageUpdatedAt: '',
      pmbBayStage: '',
      pmbBayNumber: '',
      pmbBayEstimatedHours: '',
      pmbBayEnteredAt: '',
      pmbBayScheduledStartAt: '',
      pmbBayCompletedAt: '',
      pmbBayCompletedBy: '',
      pmbBayCompletedStage: '',
      pmbBayMechanic: '',
      pmbSubletProvider: '',
    });
  }
  return {
    updates,
    arrivalNote: alreadyAtPmb
      ? `PMB arrival confirmed; ${pmbStageLabel(inferredPmbStage(vehicle)) || 'Unallocated'} retained`
      : 'Arrived at PMB; placed in Unallocated',
    movedToPmb: !alreadyAtPmb,
  };
}

function migrateLegacyAutocareArrivalsToPmb() {
  const edits = loadVehicleEdits();
  let migrated = 0;
  app.data.forEach(vehicle => {
    if (!isAutocareDespatched(vehicle)) return;
    const explicitLocation = vehiclePdcLocation(vehicle);
    if (vehicleCollectedFromRft(vehicle) || explicitLocation === 'RFT' || explicitLocation === 'PMB') return;
    const arrivedAt = parseIsoTimestamp(vehicle.autocareUpdatedAt)?.toISOString() || nowIsoString();
    const arrival = autocarePmbArrivalUpdates(vehicle, arrivedAt);
    const key = vehicleKey(vehicle);
    if (!key) return;
    edits[key] = { ...(edits[key] || {}), ...arrival.updates };
    migrated += 1;
  });
  if (migrated) {
    saveJson(EDITS_KEY, edits);
    app.data = buildVehicleData();
  }
  return migrated;
}

function applyAutocareDespatch(parsed) {
  const edits = loadVehicleEdits();
  const matched = [];
  const unmatched = [];
  const updatedAt = new Date().toISOString();

  (parsed.vehicles || []).forEach(item => {
    const match = findAutocareVehicleMatch(item);
    if (!match) {
      unmatched.push(item);
      return;
    }
    const key = vehicleKey(match.vehicle);
    const arrival = autocarePmbArrivalUpdates(match.vehicle, updatedAt);
    const updates = {
      ...arrival.updates,
      autocareDespatched: true,
      autocareVin: item.vin || match.vehicle.autocareVin || '',
      autocareBatch: item.batch || match.vehicle.autocareBatch || '',
      autocareFrame: item.frame || match.vehicle.autocareFrame || '',
      autocareModel: item.model || match.vehicle.autocareModel || '',
      autocareModelDescription: item.modelDescription || match.vehicle.autocareModelDescription || '',
      autocareVersionDescription: item.versionDescription || match.vehicle.autocareVersionDescription || '',
      autocareColour: item.colour || match.vehicle.autocareColour || '',
      autocareLoadNumber: parsed.loadNumber || match.vehicle.autocareLoadNumber || '',
      autocareNoticeFiles: parsed.sourceFiles || [],
      autocareUpdatedAt: updatedAt,
    };
    matched.push({ vehicle: { ...match.vehicle }, item, matchedBy: match.matchedBy, previousStatus: match.vehicle.toyotaStatus || '', arrivalNote: arrival.arrivalNote, movedToPmb: arrival.movedToPmb });
    recordVehicleAudit(match.vehicle, 'Autocare PMB arrival recorded', {
      matchedBy: match.matchedBy,
      loadNumber: parsed.loadNumber || '',
      outcome: arrival.arrivalNote,
    });
    edits[key] = { ...(edits[key] || {}), ...updates };
    Object.assign(match.vehicle, updates);
  });

  saveJson(EDITS_KEY, edits);
  app.data = buildVehicleData();
  populateFilters();
  renderKpis();
  renderVehicleTable();
  renderKanban();
  renderTvBoard();
  renderAdminLists();
  renderCustomers();

  return { ...parsed, matched, unmatched, updatedAt };
}

function updateAutocareControlStats(result) {
  const card = $('#autocare-scan-card');
  if (!card || !result) return;
  const fileCount = app.autocareFiles?.length || 0;
  card.querySelector('.autocare-files strong').textContent = `${fileCount} file${fileCount === 1 ? '' : 's'}`;
  card.querySelector('.autocare-detected strong').textContent = `${result.vehicles.length} detected`;
  card.querySelector('.autocare-matched strong').textContent = `${result.matched.length} matched`;
}

function renderAutocareResults(result) {
  const host = $('#autocare-status-list');
  const clearButton = $('#autocare-clear');
  const zplAllButton = $('#autocare-zpl-all');
  const zplUnmatchedButton = $('#autocare-zpl-unmatched');
  const hasResult = Boolean(result);
  if (clearButton) clearButton.disabled = !hasResult;
  if (zplAllButton) zplAllButton.disabled = !(hasResult && result.vehicles && result.vehicles.length);
  if (zplUnmatchedButton) zplUnmatchedButton.disabled = !(hasResult && result.unmatched && result.unmatched.length);
  if (!host) return;
  if (!result) {
    host.innerHTML = `<div class="empty-state compact-empty"><strong>No Autocare notice scanned</strong><span>Upload a despatch notice to update matched vehicles and see any VINs/batches not in the system.</span></div>`;
    return;
  }

  const sourceLabel = result.sourceFiles?.length ? result.sourceFiles.join(', ') : 'Pasted text';
  const warningList = (result.warnings || []).map(warning => `<div class="summary-row warn"><strong>Warning</strong><span>${escapeHtml(warning)}</span></div>`).join('');
  const matchedList = result.matched.length ? result.matched.map((row, index) => {
    const current = app.data.find(vehicle => vehicleKey(vehicle) === vehicleKey(row.vehicle)) || row.vehicle;
    const key = autocareResultItemKey(row.item, index);
    return `<div class="summary-row ok autocare-result-row"><div>${vehicleIdentityStackHtml(current)}<span>${escapeHtml(displayVehicle(current) || row.item.model || 'Vehicle')} · matched by ${escapeHtml(row.matchedBy)}${row.previousStatus ? ` · was ${escapeHtml(row.previousStatus)}` : ''} · ${escapeHtml(row.arrivalNote || 'Arrived at PMB')}</span></div><button class="small-button" type="button" data-autocare-zpl-single="matched:${escapeHtml(key)}">Print label</button></div>`;
  }).join('') : `<div class="summary-row"><strong>None matched</strong><span>No vehicles in the CRM matched the VINs or batches on this notice.</span></div>`;

  const unmatchedList = result.unmatched.length ? result.unmatched.map((item, index) => {
    const key = autocareResultItemKey(item, index);
    return `
    <div class="summary-row warn autocare-result-row autocare-unmatched-row" data-autocare-unmatched-key="${escapeHtml(key)}">
      <div class="autocare-result-copy">
        <strong>${escapeHtml(item.batch || item.vin || 'Unknown')}</strong>
        <span>${item.vin ? `VIN ${escapeHtml(item.vin)} · ` : ''}${escapeHtml(item.model || 'Model not shown')}${item.frame ? ` · Frame ${escapeHtml(item.frame)}` : ''}</span>
      </div>
      <label class="autocare-name-field"><span>Customer name for label</span><input type="text" data-autocare-name-key="${escapeHtml(key)}" placeholder="Leave blank for (Dealer Order)" /></label>
      <button class="small-button" type="button" data-autocare-zpl-single="unmatched:${escapeHtml(key)}">Print label</button>
    </div>`;
  }).join('') : `<div class="summary-row ok"><strong>All matched</strong><span>Every vehicle on the despatch notice was found in the CRM.</span></div>`;

  host.innerHTML = `
    <div class="scot-summary-grid autocare-summary-grid">
      <div class="summary-stat"><span>Notice</span><strong>${escapeHtml(result.loadNumber || 'No load #')}</strong></div>
      <div class="summary-stat"><span>Vehicles detected</span><strong>${result.vehicles.length}</strong></div>
      <div class="summary-stat"><span>Marked</span><strong>${result.matched.length}</strong></div>
      <div class="summary-stat"><span>Not in system</span><strong>${result.unmatched.length}</strong></div>
    </div>
    <div class="autocare-zpl-actions">
      <button class="primary" type="button" data-autocare-zpl-mode="all">Print labels from this notice</button>
      <button class="small-button" type="button" data-autocare-zpl-mode="unmatched" ${result.unmatched.length ? '' : 'disabled'}>Print not-in-system only</button>
      <span class="subtle">For vehicles not in the CRM, enter a customer name or leave it blank to print (Dealer Order).</span>
    </div>
    <div class="summary-section">
      <h3>Matched vehicles — PMB arrival recorded</h3>
      ${matchedList}
    </div>
    <div class="summary-section">
      <h3>Vehicles on the despatch notice not in our system</h3>
      ${unmatchedList}
    </div>
    ${warningList ? `<div class="summary-section"><h3>Extraction notes</h3>${warningList}</div>` : ''}
    <div class="subtle autocare-source">Source: ${escapeHtml(sourceLabel)}${result.haulierRegistration ? ` · Haulier ${escapeHtml(result.haulierRegistration)}` : ''}</div>
  `;

  $$('[data-autocare-zpl-mode]', host).forEach(button => {
    button.addEventListener('click', () => printZplFromAutocareResults(button.dataset.autocareZplMode));
  });
  $$('[data-autocare-zpl-single]', host).forEach(button => {
    button.addEventListener('click', () => printZplFromAutocareSingle(button.dataset.autocareZplSingle));
  });
}

function autocareResultItemKey(item, index = 0) {
  return normalizeBatch(item?.vin || item?.batch || item?.frame || `autocare-${index}`) || `autocare-${index}`;
}

function findAutocareResultItem(kindAndKey) {
  const result = app.autocareScan;
  if (!result) return null;
  const [kind, key] = String(kindAndKey || '').split(':');
  const normalizedKey = normalizeBatch(key);
  if (kind === 'matched') {
    return (result.matched || []).find((row, index) => autocareResultItemKey(row.item, index) === normalizedKey) || null;
  }
  if (kind === 'unmatched') {
    return (result.unmatched || []).find((item, index) => autocareResultItemKey(item, index) === normalizedKey) || null;
  }
  return null;
}

function getAutocareEnteredName(item, index = 0) {
  const key = autocareResultItemKey(item, index);
  const input = $$('[data-autocare-name-key]').find(field => field.dataset.autocareNameKey === key);
  return cleanZplField(input?.value || '');
}

function splitAutocareModelForZpl(item = {}) {
  const explicitModel = cleanZplField(item.modelDescription || '');
  const explicitVersion = cleanZplField(item.versionDescription || '');
  if (explicitModel || explicitVersion) {
    return {
      model: explicitModel || cleanZplField(item.model || ''),
      spec: explicitVersion,
    };
  }
  const combined = cleanZplField(item.model || '');
  if (!combined) return { model: '', spec: '' };
  const upper = combined.toUpperCase();
  const knownPrefixes = [
    'LANDCRUISER 300 SERIES', 'LANDCRUISER', 'COROLLA CROSS', 'YARIS CROSS',
    'PRADO', 'HILUX', 'RAV4', 'CAMRY', 'FORTUNER', 'COROLLA', 'HIACE', 'LC300', 'LC70', 'BZ4X'
  ];
  const found = knownPrefixes.find(prefix => upper === prefix || upper.startsWith(`${prefix} `));
  if (!found) return { model: combined, spec: '' };
  return {
    model: combined.slice(0, found.length).trim(),
    spec: combined.slice(found.length).trim(),
  };
}

function autocareItemToZplRow(item = {}, customerName = '') {
  const vin = normalizeVin(item.vin);
  const modelParts = splitAutocareModelForZpl(item);
  const wmi = vin ? vin.slice(0, 3) : '';
  const vds = vin ? vin.slice(3, 9) : '';
  const frame = vin ? vin.slice(9) : cleanZplField(item.frame || '').replace(/\s+/g, '');
  return [
    cleanZplField(item.batch || item.vin || item.frame || ''),
    cleanZplField(customerName),
    '',
    cleanZplField(modelParts.model),
    cleanZplField(modelParts.spec),
    '',
    '',
    cleanZplField(wmi),
    cleanZplField(vds),
    cleanZplField(frame),
  ].join('\t');
}

function matchedAutocareRowToZplRow(row, index = 0) {
  const current = app.data.find(vehicle => vehicleKey(vehicle) === vehicleKey(row.vehicle)) || row.vehicle;
  if (current) {
    const enriched = {
      ...current,
      autocareVin: row.item?.vin || current.autocareVin,
      autocareBatch: row.item?.batch || current.autocareBatch,
      autocareFrame: row.item?.frame || current.autocareFrame,
      autocareModel: row.item?.model || current.autocareModel,
      autocareModelDescription: row.item?.modelDescription || current.autocareModelDescription,
      autocareVersionDescription: row.item?.versionDescription || current.autocareVersionDescription,
      autocareColour: row.item?.colour || current.autocareColour,
    };
    const tsv = selectedVehicleToZplRow(enriched).split('\t');
    if (!tsv[0]) tsv[0] = cleanZplField(row.item?.batch || row.item?.vin || '');
    if (!tsv[3]) {
      const modelParts = splitAutocareModelForZpl(row.item || {});
      tsv[3] = cleanZplField(modelParts.model);
      if (!tsv[4]) tsv[4] = cleanZplField(modelParts.spec);
    }
    return tsv.join('\t');
  }
  return autocareItemToZplRow(row.item, getAutocareEnteredName(row.item, index));
}


function zplFromAutocareRows(rows = []) {
  if (!rows.length) return { zpl: '', count: 0, warnings: ['No Autocare vehicles selected for printing.'] };
  const tsv = [ZPL_REQUIRED_COLUMNS.join('\t'), ...rows].join('\n');
  const parsed = parseZplInput(tsv);
  const zpl = parsed.vehicles.map(vehicleToZplBlock).join('\n\n');
  return { zpl, count: parsed.vehicles.length, warnings: parsed.warnings };
}

async function printZplFromAutocareResults(mode = 'all') {
  const result = app.autocareScan;
  if (!result) return;
  const rows = [];
  if (mode === 'all') {
    (result.matched || []).forEach((row, index) => rows.push(matchedAutocareRowToZplRow(row, index)));
  }
  if (mode === 'all' || mode === 'unmatched') {
    (result.unmatched || []).forEach((item, index) => rows.push(autocareItemToZplRow(item, getAutocareEnteredName(item, index))));
  }
  const print = zplFromAutocareRows(rows);
  if (!print.count) return;
  if (!confirmZplWarnings(print.warnings, `${print.count} Autocare vehicle${print.count === 1 ? '' : 's'}`)) return;
  await printRawZpl(print.zpl, `${print.count} Autocare vehicle${print.count === 1 ? '' : 's'}`);
}

async function printZplFromAutocareSingle(kindAndKey) {
  const result = app.autocareScan;
  if (!result) return;
  const [kind] = String(kindAndKey || '').split(':');
  let row = '';
  if (kind === 'matched') {
    const matched = findAutocareResultItem(kindAndKey);
    if (!matched) return;
    row = matchedAutocareRowToZplRow(matched, (result.matched || []).indexOf(matched));
  } else {
    const item = findAutocareResultItem(kindAndKey);
    if (!item) return;
    row = autocareItemToZplRow(item, getAutocareEnteredName(item, (result.unmatched || []).indexOf(item)));
  }
  const print = zplFromAutocareRows([row]);
  if (!print.count) return;
  if (!confirmZplWarnings(print.warnings, 'one Autocare vehicle')) return;
  await printRawZpl(print.zpl, 'one Autocare vehicle');
}

function generateZplFromAutocareResults(mode = 'all') {
  const result = app.autocareScan;
  if (!result) return;
  const rows = [];
  if (mode === 'all') {
    (result.matched || []).forEach((row, index) => rows.push(matchedAutocareRowToZplRow(row, index)));
  }
  if (mode === 'all' || mode === 'unmatched') {
    (result.unmatched || []).forEach((item, index) => rows.push(autocareItemToZplRow(item, getAutocareEnteredName(item, index))));
  }
  if (!rows.length) return;
  writeZplRowsToGenerator(rows, mode === 'unmatched' ? 'Prepared from Autocare not-in-system vehicles' : 'Prepared from Autocare despatch notice');
}

function generateZplFromAutocareSingle(kindAndKey) {
  const result = app.autocareScan;
  if (!result) return;
  const [kind] = String(kindAndKey || '').split(':');
  let row = '';
  if (kind === 'matched') {
    const matched = findAutocareResultItem(kindAndKey);
    if (!matched) return;
    row = matchedAutocareRowToZplRow(matched, (result.matched || []).indexOf(matched));
  } else {
    const item = findAutocareResultItem(kindAndKey);
    if (!item) return;
    row = autocareItemToZplRow(item, getAutocareEnteredName(item, (result.unmatched || []).indexOf(item)));
  }
  writeZplRowsToGenerator([row], 'Prepared from one Autocare despatch vehicle');
}

function writeZplRowsToGenerator(rows, title) {
  const input = $('#zpl-input');
  if (input) input.value = [ZPL_REQUIRED_COLUMNS.join('\t'), ...rows].join('\n');
  showView('zpl');
  generateZplFromInput();
  const summary = $('#zpl-summary');
  if (summary) {
    summary.insertAdjacentHTML('afterbegin', `<div class="zpl-selected-notice"><strong>${escapeHtml(title)}</strong><span>${rows.length} label block${rows.length === 1 ? '' : 's'} created from the last Autocare scan. Review any VIN warnings, then copy the ZPL output.</span></div>`);
  }
}


function isRealStockNumber(value) {
  return /^\d{8}$/.test(String(value || '').trim()) && String(value || '').trim() !== '00000000';
}

function detectNewStockNumberRows() {
  return [];
}

function buildScotSummary() {
  const reviewRows = buildReviewRows();
  const changedRows = reviewRows.filter(r => r.changed.length);
  const newStockNumbers = detectNewStockNumberRows();
  const scotOnly = app.data.filter(v => v.source === 'Navision only');
  const pendingNoStock = [];
  return {
    rowsDetected: app.data.length,
    matchedVehicles: Object.keys(app.matches || {}).length,
    proposedChanges: changedRows.length,
    statusChanges: changedRows.filter(r => r.changed.some(([field]) => field === 'Toyota Status')).length,
    etaChanges: changedRows.filter(r => r.changed.some(([field]) => field === 'ETA At Dealer')).length,
    newStockNumbers,
    scotOnly,
    pendingNoStock,
  };
}

function renderScotSummary(scanned = false) {
  const host = $('#scot-summary');
  if (!host) return;
  if (!scanned) {
    host.innerHTML = `<div class="empty-state compact-empty"><strong>Ready to scan</strong><span>After scanning, this will show changed fields, new stock numbers, and new Navision-only vehicles.</span></div>`;
    return;
  }
  const summary = buildScotSummary();
  const newStockList = summary.newStockNumbers.slice(0, 8).map(item => `
    <div class="summary-row important"><strong>${escapeHtml(item.stock)}</strong><span>${escapeHtml(item.client)} · ${escapeHtml(item.vehicle)}</span></div>
  `).join('') || `<div class="summary-row"><strong>None detected</strong><span>No Stock-number updates were detected in this sample scan.</span></div>`;
  const scotOnlyList = summary.scotOnly.slice(0, 10).map(v => `
    <div class="summary-row warn">${vehicleIdentityStackHtml(v)}<span>${escapeHtml(displayVehicle(v))}${v.toyotaStatus ? ` · ${escapeHtml(v.toyotaStatus)}` : ''}</span></div>
  `).join('') || `<div class="summary-row"><strong>None detected</strong><span>No new Navision-only vehicles found.</span></div>`;

  host.innerHTML = `
    <div class="scot-summary-grid">
      <div class="summary-stat"><span>Rows detected</span><strong>${summary.rowsDetected}</strong></div>
      <div class="summary-stat"><span>Matched</span><strong>${summary.matchedVehicles}</strong></div>
      <div class="summary-stat"><span>Proposed changes</span><strong>${summary.proposedChanges}</strong></div>
      <div class="summary-stat"><span>Status changes</span><strong>${summary.statusChanges}</strong></div>
      <div class="summary-stat"><span>ETA changes</span><strong>${summary.etaChanges}</strong></div>
      <div class="summary-stat"><span>New vehicles</span><strong>${summary.scotOnly.length}</strong></div>
    </div>
    <div class="summary-section">
      <h3>New stock numbers issued</h3>
      ${newStockList}
    </div>
    <div class="summary-section">
      <h3>New vehicles from Navision not already in the tracker</h3>
      ${scotOnlyList}
      ${summary.scotOnly.length > 10 ? `<div class="subtle">Showing first 10 of ${summary.scotOnly.length}. Use the Navision-only dashboard filter to see all.</div>` : ''}
    </div>
  `;
}


function setNavisionUploadProfile(profile) {
  const control = $('#navision-dealer-code');
  if (!control || !['broome', 'pilbara'].includes(profile)) return false;
  if (control.value !== profile) {
    app.navisionImport = null;
    app.pendingNavisionImport = null;
    app.pendingSharedNavisionImport = null;
    app.broomeNavisionLastResult = null;
    const summary = $('#navision-status-list');
    if (summary) summary.innerHTML = '<div class="empty-state compact-empty"><strong>Upload selection changed</strong><span>Your source data is still here. Click Preview Data to check it for the selected upload.</span></div>';
  }
  control.value = profile;
  document.querySelectorAll('[data-navision-profile]').forEach(tab => {
    const selected = tab.dataset.navisionProfile === profile;
    tab.setAttribute('aria-selected', String(selected));
    tab.classList.toggle('active', selected);
  });
  const help = $('#navision-profile-help');
  if (help) help.textContent = profile === 'broome'
    ? 'Broome Toyota 037047, plus Toyota head office 001234 and 002345.'
    : 'Pilbara Toyota 014450, plus Toyota head office 001234 and 002345.';
  return true;
}

function assessNavisionUploadProfile(rows = [], selectedProfile = '') {
  const counts = { broome: 0, pilbara: 0, headOffice: 0, other: 0 };
  let invalidDealerRow = 0;
  const canonical = value => String(value ?? '').trim().replace(/^0+/, '') || '';
  rows.forEach((row, index) => {
    // Only the original Dealer column can select the upload; names, filenames,
    // comments and Swap From Dealer must never determine a row's dealer scope.
    const columns = row?.navisionRawEvidence?.columns;
    const dealers = Array.isArray(columns) ? columns.filter(column =>
      ['dealer', 'dealercode', 'dealerno', 'dealernumber'].includes(
        String(column.header || '').toLowerCase().replace(/[^a-z0-9]/g, ''))
    ).map(column => canonical(column.value || column.rawValue)) : [];
    const codes = [...new Set(dealers)];
    const code = codes[0];
    if (codes.length !== 1 || !/^[0-9]{1,6}$/.test(code || '')
        || (row.dealer_code && canonical(row.dealer_code) !== code)) {
      invalidDealerRow ||= index + 1;
      return;
    }
    if (code === '37047') counts.broome++;
    else if (code === '14450') counts.pilbara++;
    else if (['1234', '2345'].includes(code)) counts.headOffice++;
    else counts.other++;
  });
  const detectedProfile = invalidDealerRow ? '' : counts.broome && !counts.pilbara ? 'broome'
    : counts.pilbara && !counts.broome ? 'pilbara' : '';
  const profile = detectedProfile || selectedProfile;
  const eligible = Number(counts[profile] || 0) + counts.headOffice;
  const label = profile === 'broome' ? 'Broome Upload' : 'Pilbara Upload';
  let message = `${label}: ${Number(counts[profile] || 0)} dealer rows and ${counts.headOffice} Toyota head office rows detected.`;
  const excluded = rows.length - eligible;
  if (excluded) message += ` ${excluded} rows are outside this upload or need a Dealer check; they will be listed for review.`;
  if (detectedProfile && detectedProfile !== selectedProfile) message = `${label} detected from the Dealer column. Preview Data will select it automatically. ${message}`;
  const blockedMessage = invalidDealerRow
    ? `Row ${invalidDealerRow} needs one unambiguous original Dealer column. Check the Dealer values and paste the corrected export. Nothing was imported.`
    : !eligible ? 'This file has no vehicles for Broome (037047), Pilbara (014450), or Toyota head office (001234 / 002345). Check the Dealer column and upload the correct export. Nothing was imported.' : '';
  return { profile, detectedProfile, eligible, excluded, counts, message, blockedMessage, invalidDealerRow };
}

function renderNavisionUploadProfileDetection(assessment = null) {
  const host = $('#navision-profile-detection');
  if (!host) return;
  host.hidden = !assessment;
  host.textContent = assessment ? assessment.blockedMessage || assessment.message : '';
}

function updateNavisionControlStats(result = null) {
  const card = $('#navision-scan-card');
  if (!card) return;
  const raw = ($('#navision-paste')?.value || '').trim();
  const fileName = app.navisionFileName || (raw ? 'Pasted text' : 'Waiting for text');
  const broome = ($('#navision-dealer-code')?.value || '').trim() === '37047';
  if (broome) {
    let count = 0; try { count = raw ? window.BROOME_NAVISION_IMPORT?.parse(prepareNavisionText(raw))?.length || 0 : 0; } catch { /* Preview reports the actual format error. */ }
    const pending = app.pendingSharedNavisionImport;
    const current = pending?.route === 'broome_sales_orders' && pending.sourceTextSha256 === sha256Hex(raw);
    const summary = current ? pending.previewData : app.broomeNavisionLastResult?.sourceTextSha256 === sha256Hex(raw) ? app.broomeNavisionLastResult.data : null;
    const values = [['.navision-file strong', fileName], ['.navision-detected strong', count + ' rows'], ['.navision-updated strong', summary ? summary.applied ? summary.changed + ' sales orders updated' : summary.without_stock + ' sold orders without stock accepted' : raw ? 'Broome sales order upload' : '0 changed']];
    values.forEach(([selector,value])=>{const el=card.querySelector(selector);if(el)el.textContent=value;});return;
  }
  const selectedProfile = ($('#navision-dealer-code')?.value || '').trim();
  const preview = raw && !result ? parseNavisionInput(raw, {...navisionImportOptionsFromDom(),uploadProfile:['broome','pilbara'].includes(selectedProfile)?selectedProfile:null}) : null;
  renderNavisionUploadProfileDetection(raw && preview?.vehicles?.length && ['broome', 'pilbara'].includes(selectedProfile)
    ? assessNavisionUploadProfile(preview.vehicles, selectedProfile) : null);
  const rowCount = result?.parsed?.vehicles?.length ?? preview?.vehicles?.length ?? 0;
  const changed = result ? ((result.added?.length || 0) + (result.updated?.length || 0)) : 0;
  const fileEl = card.querySelector('.navision-file strong');
  const detectedEl = card.querySelector('.navision-detected strong');
  const updatedEl = card.querySelector('.navision-updated strong');
  if (fileEl) fileEl.textContent = fileName;
  if (detectedEl) detectedEl.textContent = raw || result ? `${rowCount} row${rowCount === 1 ? '' : 's'}` : '0 rows';
  if (updatedEl) {
    if (result) updatedEl.textContent = `${changed} changed`;
    else if (preview?.warnings?.length) updatedEl.textContent = `${preview.warnings.length} warning${preview.warnings.length === 1 ? '' : 's'}`;
    else updatedEl.textContent = raw ? 'Ready to import' : '0 changed';
  }
}

function navisionSharedImportRoleAllowed(role = null) {
  const resolvedRole = String(role ?? (typeof window !== 'undefined' ? window.PDC_AUTH_CONTEXT?.role : '') ?? '').trim().toLowerCase();
  return ['importer', 'administrator'].includes(resolvedRole);
}

function updateNavisionImportAccessStatus(sharedMode = Boolean($('#navision-dealer-code'))) {
  const host = $('#navision-import-access-status');
  if (!host) return !sharedMode || navisionSharedImportRoleAllowed();
  if (!sharedMode) {
    host.hidden = true;
    return true;
  }
  host.hidden = false;
  const broome = ($('#navision-dealer-code')?.value || '').trim() === '37047';
  const allowed = broome ? window.BROOME_NAVISION_IMPORT?.allowed() === true : navisionSharedImportRoleAllowed();
  if (broome) {
    host.className = `navision-import-access-status ${allowed ? 'is-ready' : 'is-blocked'}`;
    host.innerHTML = allowed ? '<strong>Broome sales import ready</strong><span>COSI sold orders can have a blank Batch / Stock. Toyota Order is required. This updates the sales tracker only.</span>' : '<strong>Broome administrator access required</strong><span>An approved administrator must preview and apply Broome sales order uploads.</span>';return allowed;
  }
  host.className = `navision-import-access-status ${allowed ? 'is-ready' : 'is-blocked'}`;
  host.innerHTML = allowed
    ? '<strong>Import access ready</strong><span>Your account can preview and apply shared Navision imports.</span>'
    : '<strong>Importer access required</strong><span>An administrator must assign your account the importer role before Navision preview or apply is enabled.</span>';
  return allowed;
}

function updateNavisionImportButton() {
  const raw = ($('#navision-paste')?.value || '').trim();
  const dealerCode = ($('#navision-dealer-code')?.value || '').trim();
  const sharedMode = Boolean($('#navision-dealer-code')) && Boolean(navisionSharedBackendService());
  const roleAllowed = updateNavisionImportAccessStatus(sharedMode);
  if (sharedMode && app.pendingSharedNavisionImport && (app.pendingSharedNavisionImport.dealerCode !== dealerCode || app.pendingSharedNavisionImport.sourceTextSha256 !== sha256Hex(raw))) {
    app.pendingSharedNavisionImport = null;
  }
  const button = $('#import-navision');
  const applyButton = $('#apply-navision-shared');
  const clear = $('#navision-clear');
  const applying = app.navisionSharedApplyInFlight === true;
  const previewing = app.navisionPreviewInFlight === true;
  const busy = applying || previewing;
  if (button) {
    button.disabled = busy || !raw || (sharedMode && (!roleAllowed || !['broome', 'pilbara', 'combined', '14450', '37047', '002345', '001234'].includes(dealerCode)));
    button.title = sharedMode && !roleAllowed ? 'Importer or administrator access is required.' : '';
    button.classList.toggle('is-loading', previewing);
    button.setAttribute('aria-busy', previewing ? 'true' : 'false');
    button.innerHTML = previewing
      ? '<span class="navision-button-spinner" aria-hidden="true"></span><span>Previewing…</span>'
      : 'Preview Data';
  }
  if (applyButton) {
    applyButton.disabled = busy || !app.pendingSharedNavisionImport || (sharedMode && !roleAllowed);
    applyButton.title = sharedMode && !roleAllowed ? 'Importer or administrator access is required.' : '';
    applyButton.classList.toggle('is-loading', applying);
    applyButton.setAttribute('aria-busy', applying ? 'true' : 'false');
    applyButton.innerHTML = applying
      ? '<span class="navision-button-spinner" aria-hidden="true"></span><span>Applying Navision import…</span>'
      : 'Confirm and Apply';
  }
  if (clear) clear.disabled = busy || (!raw && !app.navisionImport && !app.pendingSharedNavisionImport);
  document.querySelectorAll('[data-navision-profile]').forEach(tab=>{tab.disabled=busy;});
  ['navision-upload', 'navision-paste', 'navision-dealer-code'].forEach(id => {
    const control = $('#' + id);
    if (control) control.disabled = busy;
  });
  updateNavisionControlStats(app.pendingNavisionImport || app.navisionImport);
}

function setNavisionSharedApplyBusy(busy = false) {
  app.navisionSharedApplyInFlight = busy === true;
  updateNavisionImportButton();
}

function setNavisionPreviewBusy(busy = false) {
  app.navisionPreviewInFlight = busy === true;
  const status = $('#navision-preview-status');
  if (status) status.textContent = app.navisionPreviewInFlight ? 'Previewing Navision data. No data has been applied.' : '';
  updateNavisionImportButton();
}

function navisionWaitForBusyPaint() {
  return new Promise(resolve => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    const fallback = setTimeout(finish, 250);
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(() => {
        clearTimeout(fallback);
        finish();
      });
    }
  });
}

function navisionSharedApplyAuthorityIdentity() {
  const context = window.PDC_AUTH_CONTEXT || {};
  return [context.userId || context.user_id || '', context.email || '', context.role || '']
    .map(value => String(value || '').trim().toLowerCase())
    .join('|');
}

function navisionSharedPendingStillCurrent(pending, authorityIdentity = '') {
  const raw = ($('#navision-paste')?.value || '').trim();
  const dealerCode = ($('#navision-dealer-code')?.value || '').trim();
  return Boolean(
    pending
    && app.pendingSharedNavisionImport === pending
    && navisionSharedImportRoleAllowed()
    && (!authorityIdentity || navisionSharedApplyAuthorityIdentity() === authorityIdentity)
    && pending.dealerCode === dealerCode
    && pending.sourceTextSha256 === sha256Hex(raw)
  );
}

function navisionSharedPreviewRequestStillCurrent(request = {}) {
  return navisionSharedImportRoleAllowed()
    && request.authorityIdentity === navisionSharedApplyAuthorityIdentity()
    && request.dealerCode === ($('#navision-dealer-code')?.value || '').trim()
    && request.sourceTextSha256 === sha256Hex(($('#navision-paste')?.value || '').trim());
}

function sharedNavisionPreviewErrorMessage(result = {}) {
  const code = String(result.code || result.error || '').toLowerCase();
  if (code === 'upload_dealer_column_invalid') {
    const row = Number.isSafeInteger(result.rowIndex) && result.rowIndex > 0 ? `Row ${result.rowIndex}` : 'Each row';
    return `${row} needs one unambiguous original Dealer column. Check the Dealer values and paste the corrected export. Your pasted data is still here; nothing was imported.`;
  }
  if (code === 'upload_no_supported_dealers') return 'This file has no vehicles for Broome (037047), Pilbara (014450), or Toyota head office (001234 / 002345). Check the Dealer column and upload the correct export. Your pasted data is still here; nothing was imported.';
  if (code === '22023') {
    const detail = String(result.data?.message || result.message || '').trim();
    if (detail === 'No eligible rows for the selected upload') return 'No vehicles match the selected upload. Use Broome Upload for Dealer 037047 or Pilbara Upload for Dealer 014450. Both accept Toyota head office 001234 and 002345. Your pasted data is still here; nothing was imported.';
    if (/^Row [0-9]+ (?:needs one unambiguous original Dealer column|has conflicting Dealer values|without Batch needs a Toyota Order number)$/.test(detail)) return `${detail}. Check that row in the source export and preview again. Your pasted data is still here; nothing was imported.`;
    return 'The Navision file has a format or Dealer issue. Include the original headings, a Dealer value on every row, and a Toyota Order number when Batch is blank. Your pasted data is still here; nothing was imported.';
  }
  if (code === '57014') return 'Checking the Navision file took too long and stopped. Nothing was imported. Your pasted data is still here. Please try Preview Data again.';
  if (code === 'preview_connection_failed') return 'The connection ended before the Navision file check could finish. Nothing was imported. Your pasted data is still here. Check your connection and try Preview Data again.';
  if (code === 'service_unavailable') return 'The Navision service is unavailable. Nothing was imported. Your pasted data is still here. Please try Preview Data again.';
  if (code === '401' || code === '42501' || code === 'unauthorized' || code === 'not_authenticated') return 'Your import access could not be confirmed. Nothing was imported. Your pasted data is still here. Sign in with importer or administrator access, then preview it again.';
  const reference = /^[a-z0-9_]{1,80}$/.test(code) ? ` Reference: ${code}.` : '';
  return `The Navision file could not be checked. Nothing was imported. Your pasted data is still here. Please try Preview Data again.${reference}`;
}

function reportSharedNavisionPreviewError(result, request) {
  if (!navisionSharedPreviewRequestStillCurrent(request)) return;
  app.pendingSharedNavisionImport = null;
  const message = sharedNavisionPreviewErrorMessage(result);
  const host = $('#navision-status-list');
  if (host) host.innerHTML = `<div class="summary-row error" role="alert"><strong>Navision preview could not finish</strong><span>${escapeHtml(message)}</span></div>`;
  updateNavisionImportButton();
  pdcNotify(message);
}

async function handleNavisionFileSelect(event) {
  const file = event.target.files?.[0];
  if (!file) return;
  const input = $('#navision-paste');
  const summary = $('#navision-status-list');
  try {
    app.navisionFileName = file.name;
    app.navisionImport = null;
    app.pendingNavisionImport = null;
    app.pendingSharedNavisionImport = null;
    if (summary) summary.innerHTML = `<div class="empty-state compact-empty"><strong>${escapeHtml(file.name)}</strong><span>Reading file...</span></div>`;
    let text = '';
    let sourceLabel = 'Text loaded';
    if (isXlsxFile(file)) {
      const parsed = await readXlsxVehicleSpreadsheet(file);
      text = parsed.text;
      app.navisionFileName = `${file.name} · ${parsed.sheetName || 'first sheet'}`;
      const headerNote = parsed.headerRowIndex > 0 ? `; headings found on workbook row ${parsed.headerRowIndex + 1}` : '';
      sourceLabel = `Excel sheet converted: ${parsed.sheetName || 'first sheet'} (${parsed.rows.length} row${parsed.rows.length === 1 ? '' : 's'}${headerNote})`;
    } else if (/\.xls$/i.test(file.name)) {
      throw new Error('Legacy .xls files are not supported in this browser-only version. Save the spreadsheet as .xlsx, .csv or .tsv and upload it again.');
    } else {
      text = await readTextFile(file);
    }
    if (input) input.value = text;
    updateNavisionImportButton();
    const broome = ($('#navision-dealer-code')?.value || '').trim() === '37047';
    if (broome) {
      const rows = window.BROOME_NAVISION_IMPORT.parse(prepareNavisionText(text));
      if (summary) summary.innerHTML = '<div class="empty-state compact-empty"><strong>'+escapeHtml(file.name)+'</strong><span>'+escapeHtml(sourceLabel)+'. '+rows.length+' Broome source rows detected, including orders without Batch / Stock. Click Preview Data to check the sold orders.</span></div>';
      return;
    }
    let selectedProfile=($('#navision-dealer-code')?.value||'').trim();
    const preview = parseNavisionInput(text, {...navisionImportOptionsFromDom(),uploadProfile:['broome','pilbara'].includes(selectedProfile)?selectedProfile:null});
    if (['broome', 'pilbara'].includes(selectedProfile) && preview.vehicles.length) {
      const assessment = assessNavisionUploadProfile(preview.vehicles, selectedProfile);
      if (assessment.detectedProfile && assessment.profile !== selectedProfile) {
        setNavisionUploadProfile(assessment.profile);
        selectedProfile = assessment.profile;
        updateNavisionImportButton();
      }
      renderNavisionUploadProfileDetection(assessNavisionUploadProfile(preview.vehicles, selectedProfile));
    }
    if (summary) {
      const warning = preview.vehicles.length ? '' : ` ${preview.warnings?.[0] || 'No usable vehicle rows were found.'}`;
      summary.innerHTML = `<div class="empty-state compact-empty"><strong>${escapeHtml(file.name)}</strong><span>${escapeHtml(sourceLabel)}. ${preview.vehicles.length} vehicle row${preview.vehicles.length === 1 ? '' : 's'} detected.${escapeHtml(warning)}${preview.vehicles.length ? ' Click Preview Data to continue.' : ''}</span></div>`;
    }
  } catch (error) {
    console.error('File import failed', error);
    if (input) input.value = '';
    app.navisionFileName = file.name;
    updateNavisionImportButton();
    if (summary) {
      summary.innerHTML = `<div class="summary-row error"><strong>${escapeHtml(file.name)}</strong><span>${escapeHtml(error.message || 'Could not read this file.')}</span></div>`;
    }
    pdcNotify(error.message || 'Could not read this file.');
  }
}

function isXlsxFile(file = {}) {
  return /\.xlsx$/i.test(file.name || '') || /spreadsheetml\.sheet/i.test(file.type || '');
}

function readTextFile(file) {
  if (file.text) return file.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('Could not read text file.'));
    reader.readAsText(file);
  });
}

function readArrayBufferFile(file) {
  if (file.arrayBuffer) return file.arrayBuffer();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('Could not read spreadsheet.'));
    reader.readAsArrayBuffer(file);
  });
}

async function readXlsxVehicleSpreadsheet(file) {
  if (typeof DecompressionStream === 'undefined') {
    throw new Error('This browser cannot read .xlsx files directly. Save the spreadsheet as CSV/TSV, or use a current Chrome/Edge browser.');
  }
  const buffer = await readArrayBufferFile(file);
  const files = await unzipXlsxEntries(buffer);
  const sharedStrings = parseXlsxSharedStrings(files['xl/sharedStrings.xml'] || '');
  const dateStyles = parseXlsxDateStyles(files['xl/styles.xml'] || '');
  const sheets = workbookSheetEntries(files);
  const candidates = sheets.length ? sheets : Object.keys(files).filter(name => /^xl\/worksheets\/sheet\d+\.xml$/i.test(name)).map(name => ({ name, path: name }));
  let fallback = null;
  for (const sheet of candidates) {
    const xml = files[sheet.path];
    if (!xml) continue;
    const rows = parseXlsxSheetRows(xml, sharedStrings, dateStyles);
    if (!rows.length) continue;
    if (!fallback) fallback = { sheetName: sheet.name || sheet.path, rows };
    const headerRowIndex = findNavisionHeaderRowIndex(rows);
    if (headerRowIndex >= 0) {
      const importRows = rows.slice(headerRowIndex);
      return {
        sheetName: sheet.name || sheet.path,
        rows: importRows,
        text: xlsxRowsToDelimitedText(importRows),
        headerRowIndex,
      };
    }
  }
  if (!fallback) throw new Error('No usable rows were found in the Excel workbook.');
  return { ...fallback, text: xlsxRowsToDelimitedText(fallback.rows) };
}

async function unzipXlsxEntries(buffer) {
  const bytes = new Uint8Array(buffer);
  const entries = {};
  const decoder = new TextDecoder('utf-8');
  const eocdOffset = findZipEndOfCentralDirectory(bytes);
  if (eocdOffset < 0) throw new Error('This does not look like a valid .xlsx file.');
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const totalEntries = view.getUint16(eocdOffset + 10, true);
  let centralOffset = view.getUint32(eocdOffset + 16, true);
  for (let i = 0; i < totalEntries; i += 1) {
    if (view.getUint32(centralOffset, true) !== 0x02014b50) break;
    const method = view.getUint16(centralOffset + 10, true);
    const compressedSize = view.getUint32(centralOffset + 20, true);
    const nameLength = view.getUint16(centralOffset + 28, true);
    const extraLength = view.getUint16(centralOffset + 30, true);
    const commentLength = view.getUint16(centralOffset + 32, true);
    const localOffset = view.getUint32(centralOffset + 42, true);
    const name = decoder.decode(bytes.slice(centralOffset + 46, centralOffset + 46 + nameLength));
    const localNameLength = view.getUint16(localOffset + 26, true);
    const localExtraLength = view.getUint16(localOffset + 28, true);
    const dataStart = localOffset + 30 + localNameLength + localExtraLength;
    const compressed = bytes.slice(dataStart, dataStart + compressedSize);
    let contents;
    if (method === 0) contents = compressed;
    else if (method === 8) contents = new Uint8Array(await inflateRawDeflate(compressed));
    else contents = null;
    if (contents) entries[normalizeZipPath(name)] = decoder.decode(contents);
    centralOffset += 46 + nameLength + extraLength + commentLength;
  }
  return entries;
}

function findZipEndOfCentralDirectory(bytes) {
  for (let i = bytes.length - 22; i >= Math.max(0, bytes.length - 66000); i -= 1) {
    if (bytes[i] === 0x50 && bytes[i + 1] === 0x4b && bytes[i + 2] === 0x05 && bytes[i + 3] === 0x06) return i;
  }
  return -1;
}

async function inflateRawDeflate(bytes) {
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
  return streamToArrayBuffer(stream);
}

function streamToArrayBuffer(stream) {
  if (new Response(stream).arrayBuffer) return new Response(stream).arrayBuffer();
  return new Promise((resolve, reject) => {
    const reader = stream.getReader();
    const chunks = [];
    reader.read().then(function pump(result) {
      if (result.done) return resolve(new Blob(chunks).arrayBuffer());
      chunks.push(result.value);
      return reader.read().then(pump);
    }).catch(reject);
  });
}

function normalizeZipPath(path = '') {
  const parts = String(path || '').replace(/^\/+/, '').split('/');
  const clean = [];
  parts.forEach(part => {
    if (!part || part === '.') return;
    if (part === '..') clean.pop();
    else clean.push(part);
  });
  return clean.join('/');
}

function joinZipPath(base = '', target = '') {
  if (/^\//.test(target)) return normalizeZipPath(target);
  return normalizeZipPath(`${base.replace(/\/[^/]*$/, '')}/${target}`);
}

function xmlAttr(tag = '', name = '') {
  const match = String(tag || '').match(new RegExp(`\\b${name}="([^"]*)"`, 'i'));
  return match ? decodeXml(match[1]) : '';
}

function decodeXml(value = '') {
  return String(value || '')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCodePoint(parseInt(hex, 16)))
    .replace(/&#(\d+);/g, (_, num) => String.fromCodePoint(parseInt(num, 10)));
}

function parseXlsxSharedStrings(xml = '') {
  const strings = [];
  String(xml || '').replace(/<si\b[\s\S]*?<\/si>/g, si => {
    const parts = [...si.matchAll(/<t\b[^>]*>([\s\S]*?)<\/t>/g)].map(match => decodeXml(match[1]));
    strings.push(parts.join(''));
    return si;
  });
  return strings;
}

function parseXlsxDateStyles(stylesXml = '') {
  const builtinDateIds = new Set([14,15,16,17,18,19,20,21,22,27,28,29,30,31,32,33,34,35,36,45,46,47,50,51,52,53,54,55,56,57,58]);
  const customDateIds = new Set();
  String(stylesXml || '').replace(/<numFmt\b[^>]*\/>/g, tag => {
    const id = Number(xmlAttr(tag, 'numFmtId'));
    const code = xmlAttr(tag, 'formatCode').toLowerCase();
    if (id && /[dmy]/.test(code) && !/\[[^\]]+\]/.test(code)) customDateIds.add(id);
    return tag;
  });
  const xfsMatch = String(stylesXml || '').match(/<cellXfs\b[^>]*>([\s\S]*?)<\/cellXfs>/);
  const xfs = xfsMatch ? xfsMatch[1].match(/<xf\b[^>]*(?:\/>|>[\s\S]*?<\/xf>)/g) || [] : [];
  return xfs.map(tag => {
    const id = Number(xmlAttr(tag, 'numFmtId'));
    return builtinDateIds.has(id) || customDateIds.has(id);
  });
}

function workbookSheetEntries(files = {}) {
  const workbook = files['xl/workbook.xml'] || '';
  const rels = files['xl/_rels/workbook.xml.rels'] || '';
  const relMap = {};
  rels.replace(/<Relationship\b[^>]*\/>/g, tag => {
    const id = xmlAttr(tag, 'Id');
    const target = xmlAttr(tag, 'Target');
    if (id && target) relMap[id] = target;
    return tag;
  });
  const sheets = [];
  workbook.replace(/<sheet\b[^>]*\/>/g, tag => {
    const name = xmlAttr(tag, 'name') || `Sheet ${sheets.length + 1}`;
    const relId = xmlAttr(tag, 'r:id');
    const target = relMap[relId];
    if (target) sheets.push({ name, path: joinZipPath('xl/workbook.xml', target) });
    return tag;
  });
  return sheets;
}

function parseXlsxSheetRows(sheetXml = '', sharedStrings = [], dateStyles = []) {
  const rows = [];
  String(sheetXml || '').replace(/<row\b[^>]*>[\s\S]*?<\/row>/g, rowXml => {
    const row = [];
    rowXml.replace(/<c\b[^>]*(?:\/>|>[\s\S]*?<\/c>)/g, cellXml => {
      const openTag = cellXml.match(/^<c\b[^>]*>/)?.[0] || cellXml;
      const ref = xmlAttr(openTag, 'r');
      const colIndex = columnIndexFromCellRef(ref);
      if (colIndex < 0) return cellXml;
      row[colIndex] = parseXlsxCellValue(cellXml, sharedStrings, dateStyles);
      return cellXml;
    });
    while (row.length && cleanNavisionText(row[row.length - 1]) === '') row.pop();
    if (row.some(cell => cleanNavisionText(cell))) rows.push(row);
    return rowXml;
  });
  return rows;
}

function columnIndexFromCellRef(ref = '') {
  const match = String(ref || '').match(/^([A-Z]+)/i);
  if (!match) return -1;
  return match[1].toUpperCase().split('').reduce((value, ch) => value * 26 + (ch.charCodeAt(0) - 64), 0) - 1;
}

function parseXlsxCellValue(cellXml = '', sharedStrings = [], dateStyles = []) {
  const openTag = String(cellXml || '').match(/^<c\b[^>]*>/)?.[0] || cellXml;
  const type = xmlAttr(openTag, 't');
  const styleIndex = Number(xmlAttr(openTag, 's') || -1);
  if (type === 'inlineStr') {
    return [...String(cellXml).matchAll(/<t\b[^>]*>([\s\S]*?)<\/t>/g)].map(match => decodeXml(match[1])).join('');
  }
  const raw = decodeXml(String(cellXml || '').match(/<v\b[^>]*>([\s\S]*?)<\/v>/)?.[1] || '');
  if (!raw) return '';
  if (type === 's') return sharedStrings[Number(raw)] ?? '';
  if (type === 'b') return raw === '1' ? 'Yes' : 'No';
  if (type === 'd') return isoDateToAu(raw) || raw;
  if (dateStyles[styleIndex] && /^-?\d+(\.\d+)?$/.test(raw)) return excelSerialDateToAu(raw);
  if (/^-?\d+\.0+$/.test(raw)) return raw.replace(/\.0+$/, '');
  return raw;
}

function isoDateToAu(value = '') {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${String(date.getUTCDate()).padStart(2, '0')}/${String(date.getUTCMonth() + 1).padStart(2, '0')}/${date.getUTCFullYear()}`;
}

function excelSerialDateToAu(serial) {
  const value = Number(serial);
  if (!Number.isFinite(value)) return String(serial || '');
  const ms = Date.UTC(1899, 11, 30) + Math.round(value * 86400000);
  const date = new Date(ms);
  return `${String(date.getUTCDate()).padStart(2, '0')}/${String(date.getUTCMonth() + 1).padStart(2, '0')}/${date.getUTCFullYear()}`;
}

function tsvCell(value = '') {
  const text = String(value ?? '').replace(/[\r\n]+/g, ' ').trim();
  return /[\t"]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

function xlsxRowsToDelimitedText(rows = []) {
  return rows.map(row => row.map(tsvCell).join('\t')).join('\n');
}


function clearNavisionImport() {
  const input = $('#navision-paste');
  const upload = $('#navision-upload');
  if (input) input.value = '';
  if (upload) upload.value = '';
  app.navisionFileName = '';
  app.navisionImport = null;
  app.pendingNavisionImport = null;
  app.pendingSharedNavisionImport = null;
  app.broomeNavisionLastResult = null;
  updateNavisionImportButton();
  const summary = $('#navision-status-list');
  if (summary) {
    summary.innerHTML = '<div class="empty-state compact-empty"><strong>No Navision text imported</strong><span>Paste copied Navision rows, or upload a text/CSV/XLSX file, then click Preview Data.</span></div>';
  }
  updateNavisionControlStats(null);
}

function normalizeNavisionHeader(header = '') {
  return String(header || '')
    .replace(/^\uFEFF/, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function cleanNavisionText(value = '') {
  return String(value ?? '')
    .replace(/[\r\n]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function navisionCutButVehiclePattern(value = '') {
  const text = cleanNavisionText(value).toLowerCase();
  return /\bcut\s+(but|by)\s+vehicle\b/.test(text) || /\bcut\s+vehicle\b/.test(text);
}

function navisionCutButVehicleText(row = [], headerMap = null) {
  const values = [];
  if (headerMap) {
    ['Status', 'Dealer Comments', 'Vehicle Note', 'Instructions', 'Build Status', 'Location Status', 'Sub Location Description'].forEach(column => {
      const value = getNavisionValue(row, headerMap, column);
      if (value) values.push(value);
    });
  }
  if (Array.isArray(row)) values.push(row.map(cleanNavisionText).join(' '));
  return values.find(navisionCutButVehiclePattern) || '';
}

function isNavisionCutButVehicle(vehicle = {}) {
  if (vehicle.navisionCutButVehicle === true) return true;
  return navisionCutButVehiclePattern([
    vehicle.navisionCutButVehicleSource,
    vehicle.navisionDealerComments,
    vehicle.navisionVehicleNote,
    vehicle.navisionBuildStatus,
    vehicle.navisionLocationStatus,
    vehicle.navisionSubLocationDescription,
    vehicle.financeNote,
  ].filter(Boolean).join(' '));
}

function buildNavisionHeaderMap(headers = []) {
  const map = new Map();
  headers.forEach((header, index) => {
    const clean = cleanNavisionText(header).replace(/^\uFEFF/, '');
    const normalized = normalizeNavisionHeader(clean);
    if (clean && !map.has(clean)) map.set(clean, index);
    if (normalized && !map.has(normalized)) map.set(normalized, index);
  });
  return map;
}

function buildHeaderMap(headers = []) {
  return buildNavisionHeaderMap(headers);
}

function navisionHeaderRowScore(row = []) {
  const headers = (Array.isArray(row) ? row : []).map(normalizeNavisionHeader).filter(Boolean);
  if (!headers.length) return 0;
  const has = aliases => aliases.some(alias => headers.includes(normalizeNavisionHeader(alias)));
  const identity = has(['Batch', 'Batch Number', 'Batch No', 'Batch No.', 'Stock', 'Stock Number', 'Vehicle Stock Number', 'SN', 'Stock No', 'Stock No.']);
  const vehicle = has(['Model Description', 'Model Desc', 'Model Desc.', 'Vehicle Description', 'Vehicle', 'Model']);
  const workFile = has(['PDC Job Card', 'Job Card', 'Job Card Number', 'Work File', 'Body Builder', 'PDC Location', 'PMB Bucket', 'TINT', 'HOIST', 'FITTING', 'FABRICATION', 'ELECTRICAL', 'TYRE', 'PIT INSPECTION', 'PARTS']);
  if (!identity || (!vehicle && !workFile)) return 0;
  let score = 10;

  if (has(['Customer Surname', 'Dealer Customer Name', 'Customer', 'Client'])) score += 1;
  if (has(['Sub Location Description', 'Location Status'])) score += 1;
  if (has(['ETA At Kewdale Yard', 'ETA to Kewdale', 'ETA To Kewdale'])) score += 1;
  if (has(['JITA PreOrder', 'JITA'])) score += 1;
  return score;
}

function findNavisionHeaderRowIndex(rows = []) {
  let bestIndex = -1;
  let bestScore = 0;
  (Array.isArray(rows) ? rows : []).slice(0, 80).forEach((row, index) => {
    const score = navisionHeaderRowScore(row);
    if (score > bestScore) {
      bestScore = score;
      bestIndex = index;
    }
  });
  return bestIndex;
}

function hasNavisionColumn(headerMap, column) {
  return headerMap.has(column) || headerMap.has(normalizeNavisionHeader(column));
}

function getNavisionValue(row, headerMap, columns) {
  const names = Array.isArray(columns) ? columns : [columns];
  for (const name of names) {
    const exact = headerMap.get(name);
    const normalized = headerMap.get(normalizeNavisionHeader(name));
    const index = exact !== undefined ? exact : normalized;
    if (index === undefined) continue;
    const value = cleanNavisionText(row[index] || '');
    if (value) return value;
  }
  return '';
}

function formatNavisionProductionMonth(value = '') {
  const text = cleanNavisionText(value);
  const match = text.match(/^(\d{4})(\d{2})$/);
  if (!match) return text;
  return `${match[2]}/${match[1].slice(-2)}`;
}

function productionMonthLabel(value = '') {
  const text = cleanNavisionText(value);
  if (!text) return '';
  const navision = text.match(/^(\d{4})(\d{2})$/);
  if (navision) return `${navision[2]}/${navision[1].slice(-2)}`;
  const slash = text.match(/^(\d{1,2})\/(\d{2}|\d{4})$/);
  if (slash) return `${slash[1].padStart(2, '0')}/${slash[2].slice(-2)}`;
  return text;
}

function productionMonthRank(value = '') {
  const label = productionMonthLabel(value);
  const slash = label.match(/^(\d{1,2})\/(\d{2}|\d{4})$/);
  if (slash) {
    const month = Number(slash[1]);
    const year = Number(slash[2].length === 2 ? `20${slash[2]}` : slash[2]);
    return year * 100 + month;
  }
  const navision = cleanNavisionText(value).match(/^(\d{4})(\d{2})$/);
  if (navision) return Number(navision[1]) * 100 + Number(navision[2]);
  return Number.MAX_SAFE_INTEGER;
}

function sortProductionMonths(months = []) {
  const collator = new Intl.Collator('en-AU', { numeric: true, sensitivity: 'base' });
  return months.slice().sort((a, b) => {
    const ar = productionMonthRank(a);
    const br = productionMonthRank(b);
    const aUnknown = ar === Number.MAX_SAFE_INTEGER;
    const bUnknown = br === Number.MAX_SAFE_INTEGER;
    if (aUnknown && !bUnknown) return 1;
    if (bUnknown && !aUnknown) return -1;
    const rankDiff = br - ar;
    return rankDiff || collator.compare(String(a), String(b));
  });
}

function navisionExpectedDelivery(row, headerMap) {
  const month = getNavisionValue(row, headerMap, 'Expected Customer Delivery Mth');
  const year = getNavisionValue(row, headerMap, 'Expected Customer Delivery Yr');
  return [month, year].filter(Boolean).join(' ');
}

function navisionConsultant(value = '') {
  const text = cleanNavisionText(value);
  const code = text.match(/^([A-Z]{1,4})\b/i);
  if (code && (code[1].length <= 3 || /\d/.test(text))) return code[1].toUpperCase();
  return text;
}

function navisionToyotaStatus(row, headerMap) {
  // Navision-only version: Toyota Status on the dashboard must come only from this column.
  return getNavisionValue(row, headerMap, 'Sub Location Description');
}

function navisionHasColumn(headerMap, columns) {
  const names = Array.isArray(columns) ? columns : [columns];
  return names.some(name => headerMap.has(name) || headerMap.has(normalizeNavisionHeader(name)));
}

function navisionJitaNumber(row, headerMap) {
  const value = cleanNavisionText(getNavisionValue(row, headerMap, ['JITA Number', 'JITA No.', 'JITA No', 'JITA PreOrder']));
  return /\d/.test(value) && !/^0+(?:\.0+)?$/.test(value) ? value : '';
}

function navisionJita(row, headerMap) {
  return navisionJitaNumber(row, headerMap) ? 'Yes' : 'Unknown';
}


function explicitImportValue(row, headerMap, columns) {
  const names = Array.isArray(columns) ? columns : [columns];
  const hasAny = names.some(name => hasNavisionColumn(headerMap, name));
  if (!hasAny) return { present: false, value: '' };
  return { present: true, value: getNavisionValue(row, headerMap, names) };
}

function explicitImportBoolean(row, headerMap, columns) {
  const found = explicitImportValue(row, headerMap, columns);
  if (!found.present) return undefined;
  return pdcBooleanFromText(found.value);
}

function buildExplicitPdcUpdatesFromImport(row, headerMap) {
  const updates = {};
  const pairs = [
    ['pdcRequiresBus4x4', ['BUS 4X4', 'Bus 4x4', 'BUS_4X4', 'Requires Bus 4x4', 'Bus 4x4 Required', 'Department 138']],
    ['pdcRequiresTint', ['TINT', 'Tint', 'Requires Tint', 'Tint Required']],
    ['pdcRequiresHoist', ['HOIST', 'Hoist', 'Requires Hoist', 'Hoist Required']],
    ['pdcRequiresFitting', ['FITTING', 'Fitting', 'Fitment', 'Requires Fitting', 'Fitting Required', 'BUILD', 'Build', 'Requires Build', 'Build Required']],
    ['pdcRequiresFabrication', ['FABRICATION', 'Fabrication', 'FAB', 'Fab', 'Requires Fabrication', 'Fabrication Required']],
    ['pdcRequiresElectrical', ['ELECTRICAL', 'Electrical', 'Auto Electrical', 'Auto-Electrical', 'Requires Electrical', 'Electrical Required']],
    ['pdcRequiresTyre', ['TYRE', 'Tyre', 'Tire', 'Wheel', 'Requires Tyre', 'Tyre Required']],
    ['pdcRequiresPitInspection', ['PIT INSPECTION', 'Pit Inspection', 'PIT', 'Requires Pit Inspection', 'Pit Inspection Required']],
    ['pdcRequiresParts', ['PARTS', 'Parts', 'Requires Parts', 'Parts Required', 'Parts Needed', 'Parts To Order']],
    ['pdcCompleteTint', ['Tint Complete', 'Tint Completed', 'Tint Done', 'TINT DONE']],
    ['pdcCompleteHoist', ['Hoist Complete', 'Hoist Completed', 'Hoist Done', 'HOIST DONE']],
    ['pdcCompleteFitting', ['Fitting Complete', 'Fitting Completed', 'Fitting Done', 'Fitment Complete', 'BUILD DONE', 'Build Complete', 'Build Completed', 'Build Done']],
    ['pdcCompleteFabrication', ['Fabrication Complete', 'Fabrication Completed', 'Fabrication Done', 'Fab Complete', 'FAB DONE']],
    ['pdcCompleteElectrical', ['Electrical Complete', 'Electrical Completed', 'Electrical Done', 'ELECTRICAL DONE']],
    ['pdcCompleteTyre', ['Tyre Complete', 'Tyre Completed', 'Tyre Done', 'Tire Complete', 'TYRE DONE']],
    ['pdcCompletePitInspection', ['Pit Inspection Complete', 'Pit Inspection Completed', 'Pit Inspection Done', 'PIT DONE']],
    ['pdcCompleteParts', ['Parts Complete', 'Parts Completed', 'Parts Done', 'PARTS DONE', 'Parts Issued', 'Parts Received']],
    ['pdcBlocked', ['Blocked', 'PDC Blocked', 'Problem Vehicle']],
  ];
  pairs.forEach(([key, columns]) => {
    const value = explicitImportBoolean(row, headerMap, columns);
    if (value !== undefined) updates[key] = value;
  });
  const location = explicitImportValue(row, headerMap, ['PDC Location', 'PDC Status', 'Manual Location']);
  if (location.present) updates.pdcLocation = normalizePdcLocation(location.value);
  const stage = explicitImportValue(row, headerMap, ['PMB Work Stream', 'PMB Bucket', 'Work Stream', 'Bucket', 'PMB Stage']);
  if (stage.present) updates.pmbStage = normalizePmbStage(stage.value);
  const blockReason = explicitImportValue(row, headerMap, ['Blocked Reason', 'Block Reason', 'Issue', 'Problem', 'Exception']);
  if (blockReason.present) updates.pdcBlockReason = blockReason.value;
  const jobCard = explicitImportValue(row, headerMap, ['PDC Job Card', 'Job Card', 'Job Card Number', 'Jobcard', 'Work File', 'Work Number']);
  if (jobCard.present) updates.pdcJobcard = jobCard.value;
  return updates;
}

function navisionTruthyWorkValue(value = '') {
  const text = cleanNavisionText(value);
  if (!text) return false;
  const bool = pdcBooleanFromText(text);
  if (bool !== undefined) return bool;
  return !/^(0|none|no|n|false|na|n\/a|not required)$/i.test(text);
}

function navisionHasExplicitPmbWorkSignal(row, headerMap) {
  const updates = buildExplicitPdcUpdatesFromImport(row, headerMap);
  if (cleanNavisionText(updates.pdcJobcard || '')) return true;
  if (normalizePdcLocation(updates.pdcLocation || '') === 'PMB' || normalizePdcLocation(updates.pdcLocation || '') === 'RFT') return true;
  if (normalizePmbStage(updates.pmbStage || '')) return true;
  const requireKeys = PDC_JOB_DEFS.map(def => def.requireKey);
  return requireKeys.some(key => updates[key] === true);
}

function navisionHasPmbWorkSignal(row, headerMap, vehicle = {}) {
  if (navisionHasExplicitPmbWorkSignal(row, headerMap)) return true;
  if (navisionTruthyWorkValue(getNavisionValue(row, headerMap, ['Body Builder', 'Bodybuilder', 'Body Builder Code']))) return true;
  if (vehicle.trayOrdered === true) return true;

  const locationText = [
    vehicle.navisionLocationStatus,
    vehicle.navisionSubLocationDescription,
    vehicle.toyotaStatus,
  ].map(normalizeToyotaStatus).join(' ');
  if (/\bpmb\b/.test(locationText) || /\brft\b/.test(locationText) || locationText.includes('perth motor bodies') || locationText.includes('body builder')) return true;

  const workText = [
    vehicle.navisionDealerComments,
    vehicle.navisionVehicleNote,
    getNavisionValue(row, headerMap, 'Instructions'),
  ].map(cleanNavisionText).join(' ').toLowerCase();
  return /\b(pmb|perth motor bodies|body builder|purchase order|\bpo\b|tint|tray|electrical|fabrication|sublet|accessory|fitment)\b/i.test(workText);
}

function navisionImportOptionsFromDom() {
  return { pmbOnly: false };
}

function navisionImportIsFullRefresh() {
  return true;
}

function pmbWorkSkipMessage(vehicle = {}, excelRow) {
  const identity = displayStockNumber(vehicle) || `row ${excelRow}`;
  return `Row ${excelRow}${identity ? ` / ${identity}` : ''}: skipped because PDC work / job file mode is on and no work signal was found.`;
}

function protectPmbFirstLandingFromImport(payload = {}, existing = {}) {
  const incomingLocation = normalizePdcLocation(payload.pdcLocation || '');
  const existingLocation = vehiclePdcLocation(existing);
  if (incomingLocation !== 'PMB' || existingLocation === 'PMB') return payload;

  // Import sheets may identify a vehicle as PMB, but the control-board rule is
  // that the first PMB entry lands in Unallocated. Required jobs and PMB Bucket
  // columns must not silently allocate Tint/Hoist/Fitting/Fabrication/Electrical/Tyre.
  payload.pmbStage = '';
  payload.pdcWorkStage = '';
  payload.workStage = '';
  payload.pmbStageEnteredAt = '';
  payload.pmbStageUpdatedAt = '';
  payload.pmbBayStage = '';
  payload.pmbBayNumber = '';
  payload.pmbBayEstimatedHours = '';
  payload.pmbBayEnteredAt = '';
  payload.pmbBayScheduledStartAt = '';
  payload.pmbBayCompletedAt = '';
  payload.pmbBayCompletedBy = '';
  payload.pmbBayCompletedStage = '';
  payload.pmbBayMechanic = '';
  payload.pmbSubletProvider = '';
  return payload;
}

function applyExplicitPdcImportFields(payload, incoming = {}, existing = {}) {
  const keys = [
    ...PDC_JOB_DEFS.flatMap(def => [def.requireKey, def.completeKey]),
    'pdcBlocked','pdcBlockReason','pdcLocation','pmbStage','pdcJobcard'
  ];
  let hasAny = false;
  keys.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(incoming, key)) {
      payload[key] = incoming[key];
      hasAny = true;
    }
  });
  if (!hasAny) return payload;
  protectPmbFirstLandingFromImport(payload, existing);
  const now = nowIsoString();
  if (payload.pdcLocation && normalizePdcLocation(payload.pdcLocation) !== vehiclePdcLocation(existing)) {
    payload.pdcLocationUpdatedAt = now;
    if (normalizePdcLocation(payload.pdcLocation) === 'PMB') {
      payload.pmbEnteredAt = pmbEnteredTimestamp(existing) || now;
      payload.pmbTransferredAt = existing.pmbTransferredAt || now;
    }
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'pmbStage') && normalizePmbStage(payload.pmbStage) !== normalizePmbStage(existing.pmbStage || '')) {
    payload.pmbStageUpdatedAt = now;
    payload.pmbStageEnteredAt = now;
  }
  PDC_JOB_DEFS.forEach(def => {
    if (payload[def.completeKey] === true && !existing[def.completeKey]) {
      payload[def.completeAtKey] = now;
      payload[def.completeByKey] = existing[def.completeByKey] || 'Spreadsheet import';
    }
  });
  return payload;
}

function navisionPrimaryEta(row, headerMap) {
  // Dashboard ETA must come only from the Kewdale ETA field.
  // If Kewdale ETA is blank, leave ETA blank.
  return scotEtaOnly(getNavisionValue(row, headerMap, ['ETA At Kewdale Yard', 'ETA to Kewdale', 'ETA To Kewdale']) || '');
}

function navisionAutoPdcLocation(vehicle = {}) {
  const locationStatus = normalizeToyotaStatus(vehicle.navisionLocationStatus || '');
  const subLocation = normalizeToyotaStatus(vehicle.navisionSubLocationDescription || vehicle.toyotaStatus || '');
  const text = navisionLocationSourceText(vehicle);
  if (!text) return '';
  if (locationStatus === 'yh' || subLocation.includes('yard hold') || /\byh\b/.test(text)) return '';
  if (locationStatus === 'pmb' || navisionTextIsBodyBuilder(text) || text.includes('on consignment') || text.includes('out on consignment')) return 'PMB';
  if (locationStatus === 'rft' || /\brft\b/.test(text) || text.includes('ready for transport') || text.includes('ready for transfer')) return 'RFT';
  return '';
}

function applyNavisionAutoPdcLocation(payload = {}, incoming = {}, existing = {}) {
  const autoLocation = navisionAutoPdcLocation(incoming);
  if (!autoLocation) return payload;
  if (existing && (existing.pdcLocationLocked || existing.manualLocation || vehiclePdcLocation(existing))) return payload;
  if (normalizePdcLocation(payload.pdcLocation || '')) return payload;
  const now = nowIsoString();
  payload.pdcLocation = autoLocation;
  payload.pdcLocationUpdatedAt = now;
  if (autoLocation === 'PMB') {
    payload.pmbEnteredAt = pmbEnteredTimestamp(existing) || now;
    payload.pmbTransferredAt = existing.pmbTransferredAt || now;
    protectPmbFirstLandingFromImport(payload, existing);
  }
  if (autoLocation === 'RFT') {
    payload.rftTransferredAt = existing.rftTransferredAt || now;
  }
  return payload;
}

function vehicleLooksNonToyota(vehicle = {}) {
  const text = [vehicle.make, vehicle.manufacturer, vehicle.brand, vehicle.vehicleMake, vehicle.vehicleManufacturer, vehicle.vehicle, vehicle.toyotaVehicle, vehicle.model, vehicle.modelDescription, vehicle.navisionDealerComments, vehicle.financeNote]
    .map(value => cleanNavisionText(value || '').toLowerCase())
    .filter(Boolean)
    .join(' ');
  return /\b(nissan|isuzu|ford|mazda|mitsubishi|subaru|hyundai|kia|volkswagen|vw|ldv|gwm|haval|ram|chevrolet|holden|hino|fuso|mercedes|benz|iveco)\b/.test(text);
}

function vehicleLooksToyota(vehicle = {}) {
  if (vehicleLooksNonToyota(vehicle)) return false;
  const text = [vehicle.make, vehicle.manufacturer, vehicle.brand, vehicle.vehicleMake, vehicle.vehicleManufacturer, vehicle.vehicle, vehicle.toyotaVehicle, vehicle.model, vehicle.modelDescription, vehicle.source, vehicle.group, vehicle.toyotaStatus]
    .map(value => cleanNavisionText(value || '').toLowerCase())
    .filter(Boolean)
    .join(' ');
  if (/\btoyota\b/.test(text)) return true;
  if (vehicle.toyotaStatus || vehicle.toyotaVehicle || vehicle.toyotaCustomer || vehicle.navisionSubLocationDescription || /navision/.test(text)) return true;
  return false;
}

function buildNavisionVehicle(row, headerMap, excelRow, options = {}) {
  const batch = getNavisionValue(row, headerMap, ['Batch', 'Batch Number', 'Batch No', 'Batch No.', 'Stock', 'Stock Number', 'Vehicle Stock Number', 'SN', 'Stock No', 'Stock No.']);
  const stock = isBlankStock(batch) ? '' : batch;
  const modelDescription = getNavisionValue(row, headerMap, ['Model Description', 'Model Desc', 'Model Desc.', 'Vehicle Description', 'Vehicle', 'Model']);
  const suffixDescription = getNavisionValue(row, headerMap, ['Suffix Description', 'Suffix', 'Variant']);
  const trimDescription = getNavisionValue(row, headerMap, ['Trim Description', 'Trim']);
  const colourDescription = getNavisionValue(row, headerMap, ['Colour Description', 'Color Description', 'Colour', 'Color']);
  const customerSurname = getNavisionValue(row, headerMap, ['Customer Surname', 'Customer', 'Client']);
  const dealerCustomerName = getNavisionValue(row, headerMap, ['Dealer Customer Name', 'Customer Name', 'Client Name']);
  const customer = customerSurname || dealerCustomerName || '(Dealer Order)';
  const dealerComments = getNavisionValue(row, headerMap, 'Dealer Comments');
  const vehicleNote = getNavisionValue(row, headerMap, 'Vehicle Note');
  const instructions = getNavisionValue(row, headerMap, 'Instructions');
  const comments = [dealerComments, vehicleNote, instructions].filter(Boolean).join(' ');
  const { wmi, vdsNumber, frame, vin } = window.PDC_NAVISION_VIN.buildNavisionVinParts(
    getNavisionValue(row, headerMap, 'WMI'),
    getNavisionValue(row, headerMap, 'VDS Number'),
    getNavisionValue(row, headerMap, 'Frame'),
  );
  const trayOrdered = /^yes$/i.test(getNavisionValue(row, headerMap, 'Tray Fitment Ordered')) || /tray/i.test(comments);
  const trayComplete = /^yes$/i.test(getNavisionValue(row, headerMap, 'Tray Fitment Complete'));
  const cutButVehicleSource = navisionCutButVehicleText(row, headerMap);
  const rawStatus = navisionToyotaStatus(row, headerMap);
  const navisionEtaAtDealerBB = getNavisionValue(row, headerMap, 'ETA At Dealer/BB');
  const navisionPortPlantEta = getNavisionValue(row, headerMap, 'Port/Plant ETA Date');
  const navisionKewdaleEta = getNavisionValue(row, headerMap, ['ETA At Kewdale Yard', 'ETA to Kewdale', 'ETA To Kewdale']);
  const navisionEtaDate = getNavisionValue(row, headerMap, 'ETA Date');
  const keyNumber = getNavisionValue(row, headerMap, ['Key Number', 'Key No', 'Key No.', 'Key #', 'Key', 'Key Tag']);
  const navisionEta = scotEtaOnly(navisionKewdaleEta);
  const navisionJitaNumberColumnPresent = navisionHasColumn(headerMap, ['JITA Number', 'JITA No.', 'JITA No', 'JITA PreOrder']);
  const importedNavisionJitaNumber = navisionJitaNumber(row, headerMap);
  const workFileMode = options.pmbOnly === true || options.workFile === true;
  const explicitPdcUpdates = workFileMode ? protectPmbFirstLandingFromImport(buildExplicitPdcUpdatesFromImport(row, headerMap), {}) : {};
  const payload = {
    id: window.PDC_NAVISION_VIN.navisionSourceIdentity(stock, vin, excelRow),
    sourceRow: excelRow,
    stock,
    batch: batch || stock,
    keyNumber,
    client: customer,
    customerSurname,
    dealerCustomerName,
    toyotaCustomer: dealerCustomerName || customer,
    contact: '',
    internalStatus: 'Allocate vehicle, generate orders',
    deliveryDate: navisionExpectedDelivery(row, headerMap),
    vehicle: [modelDescription, suffixDescription].filter(Boolean).join(' '),
    modelDescription,
    suffixDescription,
    trimDescription,
    colourDescription,
    toyotaVehicle: modelDescription,
    suffix: suffixDescription,
    trim: trimDescription,
    colour: colourDescription,
    financeNote: dealerComments,
    group: 'Navision import',
    owner: navisionConsultant(getNavisionValue(row, headerMap, ['Salesperson', 'Sales Person', 'SP', 'Consultant'])),
    consultant: navisionConsultant(getNavisionValue(row, headerMap, ['Salesperson', 'Sales Person', 'SP', 'Consultant'])),
    source: 'Navision',
    origMth: '',
    prodMth: formatNavisionProductionMonth(getNavisionValue(row, headerMap, ['Production Month', 'Prod Mth', 'P/Month'])),
    compPlate: getNavisionValue(row, headerMap, 'Compliance Date'),
    arrivalPort: getNavisionValue(row, headerMap, 'Arrival Port Name'),
    toyotaStatus: rawStatus,
    etaAtDealer: navisionEta,
    navisionEtaAtDealerBB,
    navisionPortPlantEta,
    navisionKewdaleEta,
    navisionEtaDate,
    navisionTransportLoadNo: getNavisionValue(row, headerMap, 'Transport Load No.'),
    navisionTransportPriority: getNavisionValue(row, headerMap, 'Transport Priority'),
    navisionLocationStatus: getNavisionValue(row, headerMap, 'Location Status'),
    navisionSubLocationDescription: getNavisionValue(row, headerMap, 'Sub Location Description'),
    navisionBuildStatus: getNavisionValue(row, headerMap, 'Build Status'),
    navisionRavStatus: getNavisionValue(row, headerMap, 'RAV Status'),
    navisionDealerComments: dealerComments,
    navisionVehicleNote: vehicleNote,
    epodReceipt: getNavisionValue(row, headerMap, 'EPOD Date'),
    jitQty: importedNavisionJitaNumber,
    jitaPartsOrdered: navisionJita(row, headerMap),
    navisionJitaNumberAuthority: navisionJitaNumberColumnPresent ? NAVISION_JITA_NUMBER_AUTHORITY : '',
    _navisionJitaNumberColumnPresent: navisionJitaNumberColumnPresent,
    wmi,
    vdsNumber,
    frame,
    vin,
    engine: getNavisionValue(row, headerMap, 'Engine'),
    dealerCustomer: getNavisionValue(row, headerMap, 'Dealer Customer'),
    dealerCustomerCategory: getNavisionValue(row, headerMap, 'Dealer Customer Category'),
    salesType: getNavisionValue(row, headerMap, 'Sales Type'),
    listPrice: getNavisionValue(row, headerMap, 'List Price'),
    suburb: getNavisionValue(row, headerMap, 'Suburb'),
    pma: getNavisionValue(row, headerMap, 'PMA'),
    trayOrdered,
    trayFitmentComplete: trayComplete,
    navisionCutButVehicle: Boolean(cutButVehicleSource),
    navisionCutButVehicleSource: cutButVehicleSource,
    ...explicitPdcUpdates,
    recordLifecycle: 'navision',
    pdcImportMode: workFileMode ? 'work-file' : 'navision',
    importedAt: new Date().toISOString(),
  };
  const pdcVisibilitySignal = workFileMode && navisionHasPmbWorkSignal(row, headerMap, payload);
  payload.pdcSheetVisible = Boolean(pdcVisibilitySignal);
  payload.pdcVisibilitySource = pdcVisibilitySignal ? 'PDC work / job file upload' : 'Navision back end only';
  return workFileMode ? applyNavisionAutoPdcLocation(payload, payload, {}) : payload;
}

function prepareNavisionText(text = '') {
  let value = restoreNavisionExpandedTabs(String(text || '')).trim();
  const looksLikeQuotedCsvOrTsv = /^"[^"\r\n]*"[\t,;]/.test(value);
  const wrappedInStraightQuotes = value.startsWith('"') && value.endsWith('"') && !looksLikeQuotedCsvOrTsv;
  const wrappedInSmartQuotes = value.startsWith('“') && value.endsWith('”');
  if (wrappedInStraightQuotes || wrappedInSmartQuotes) {
    value = value.slice(1, -1);
  }
  return value;
}

function restoreNavisionExpandedTabs(text = '', tabWidth = 6) {
  // Some Navision copy operations expand each tab to enough U+2002 EN SPACE
  // characters to reach the next six-character tab stop. Reconstruct the
  // original tabs, including consecutive tabs that represent blank cells.
  return String(text || '').split(/\r?\n/).map(line => {
    const characters = Array.from(line);
    let output = '';
    let column = 0;
    for (let index = 0; index < characters.length; index += 1) {
      const character = characters[index];
      if (character !== '\u2002') {
        output += character;
        column += 1;
        continue;
      }
      let runLength = 1;
      while (characters[index + runLength] === '\u2002') runLength += 1;
      const firstTabWidth = tabWidth - (column % tabWidth || 0);
      const remainder = runLength - firstTabWidth;
      if (remainder >= 0 && remainder % tabWidth === 0) {
        output += '\t'.repeat(1 + (remainder / tabWidth));
      } else {
        // A non-tab-aligned EN SPACE run is still a delimiter in Navision text.
        output += '\t';
      }
      column += runLength;
      index += runLength - 1;
    }
    return output;
  }).join('\n');
}

function isPostYardHoldNavisionVehicle(vehicle = {}) {
  // Only the actual Navision location fields decide whether a row is past Yard Hold.
  // Notes/comments/build status can mention PMB, body builder or transport work before the
  // vehicle has physically reached Yard Hold, so they must not block the upload.
  const locationStatus = normalizeToyotaStatus(vehicle.navisionLocationStatus || '');
  const subLocation = normalizeToyotaStatus(vehicle.navisionSubLocationDescription || vehicle.toyotaStatus || '');
  const text = `${locationStatus} ${subLocation}`.trim();

  if (!text) return false;
  if (locationStatus === 'yh' || subLocation.includes('yard hold') || /\byh\b/.test(text)) return false;

  return (
    locationStatus === 'pmb' ||
    locationStatus === 'rft' ||
    /\bpmb\b/.test(text) ||
    /\brft\b/.test(text) ||
    text.includes('perth motor bodies') ||
    text.includes('body builder') ||
    text.includes('ready for transport') ||
    text.includes('ready for transfer') ||
    text.includes('out on consignment') ||
    text.includes('at dealer') ||
    text.includes('delivered to dealer') ||
    text.includes('delivered - at dealer') ||
    text.includes('dealer received')
  );
}

function postYardHoldReason(vehicle = {}) {
  return cleanNavisionText(vehicle.navisionLocationStatus || vehicle.navisionSubLocationDescription || vehicle.toyotaStatus || 'past Yard Hold');
}

function parseNavisionInput(text, options = {}) {
  if (options.pmbOnly === true || options.workFile === true) {
    return {
      vehicles: [],
      warnings: ['PDC work/job imports are disabled. Upload the approved PD Document for vehicle work.'],
      missing: ['PD Document required'],
      delimiter: '',
      options: { pmbOnly: false, workFile: false },
    };
  }
  const prepared = prepareNavisionText(text);
  const detected = detectDelimitedRows(prepared);
  const rows = detected.rows;
  if (!rows.length) return { vehicles: [], warnings: ['Paste the Navision export with the header row first.'], missing: [], delimiter: detected.delimiter, options };
  const headerRowIndex = findNavisionHeaderRowIndex(rows);
  const resolvedHeaderRowIndex = headerRowIndex >= 0 ? headerRowIndex : 0;
  const rawHeaders = rows[resolvedHeaderRowIndex].map(header => String(header ?? '').replace(/^\uFEFF/, ''));
  const headers = rawHeaders.map(header => cleanNavisionText(header));
  const headerMap = buildNavisionHeaderMap(headers);
  const hasIdentityColumn = ['Batch', 'Batch Number', 'Batch No', 'Batch No.', 'Stock', 'Stock Number', 'Vehicle Stock Number', 'SN', 'Stock No', 'Stock No.'].some(column => hasNavisionColumn(headerMap, column));
  const hasVehicleColumn = ['Model Description', 'Model Desc', 'Model Desc.', 'Vehicle Description', 'Vehicle', 'Model'].some(column => hasNavisionColumn(headerMap, column));
  const missing = [];
  if (!hasIdentityColumn) missing.push('Batch / Stock');
  if (!hasVehicleColumn && !options.pmbOnly && !options.workFile) missing.push('Model Description / Vehicle');
  if (missing.length) {
    return {
      vehicles: [],
      warnings: [`Missing required columns: ${missing.join(', ')}.`],
      missing,
      delimiter: detected.delimiter,
      options,
    };
  }

  const importOptions = { pmbOnly: false, ...options };
  const warnings = [];
  if (resolvedHeaderRowIndex > 0) warnings.push(`Navision headings were detected on row ${resolvedHeaderRowIndex + 1}; the report title rows above them were ignored.`);
  if (!hasNavisionColumn(headerMap, 'Sub Location Description')) {
    warnings.push('Sub Location Description column was not found, so Toyota Status will be blank for this import.');
  }
  if (importOptions.pmbOnly) {
    warnings.push('PDC work / job file mode is on: matching rows are promoted to the PDC Sheet; rows without a work signal are skipped.');
  }
  const vehicles = [];
  const rejectedRows = [];
  rows.slice(resolvedHeaderRowIndex + 1).forEach((row, index) => {
    const excelRow = resolvedHeaderRowIndex + index + 2;
    const vehicle = buildNavisionVehicle(row, headerMap, excelRow, importOptions);
    const rawEvidence = {
      sourceRow: excelRow,
      columns: rawHeaders.map((header, columnIndex) => ({ header, value: String(row[columnIndex] ?? '') })),
    };
    vehicle.navisionRawEvidence = rawEvidence;
    if (['broome','pilbara'].includes(options.uploadProfile)) {
      const order=getNavisionValue(row,headerMap,'Order');
      const cosi=getNavisionValue(row,headerMap,'COSI');
      const dealer=getNavisionValue(row,headerMap,'Dealer');
      vehicle.order=order;vehicle.cosi=cosi;vehicle.dealer_code=dealer;
      vehicle.id=vehicle.stock|| (order ? 'TOYOTA-ORDER-'+order : '');
      vehicle.batch=vehicle.stock;
      vehicles.push(vehicle);
      return;
    }
    if (!vehicle.stock) {
      warnings.push(`Row ${excelRow}: skipped because Batch / Stock is blank.`);
      rejectedRows.push(rawEvidence);
      return;
    }
    if (importOptions.pmbOnly && !navisionHasPmbWorkSignal(row, headerMap, vehicle)) {
      warnings.push(pmbWorkSkipMessage(vehicle, excelRow));
      return;
    }
    if (!vehicle.vehicle && !vehicle.toyotaVehicle) {
      warnings.push(`Row ${excelRow}${vehicle.stock ? ` / Stock ${vehicle.stock}` : ''}: vehicle description is blank.`);
    }
    vehicles.push(vehicle);
  });
  return { vehicles, rejectedRows, warnings, missing: [], delimiter: detected.delimiter, options: importOptions };
}

function navisionMatchKeys(vehicle = {}) {
  vehicle = vehicle || {};
  return [
    vehicle.stock,
    vehicle.batch,
    vehicle.vin,
    vehicle.frame,
    vehicle.id,
  ].map(value => String(value || '').trim()).filter(Boolean);
}

function navisionComparableKeys(vehicle = {}) {
  const v = vehicle || {};
  const keys = new Set();
  const addKey = (value, { stockLike = false } = {}) => {
    const raw = String(value || '').trim();
    if (!raw) return;
    if (stockLike && isBlankStock(raw)) return;
    const clean = normalizeBatch(raw);
    if (!clean || clean === '0' || /^TBA$/i.test(clean)) return;
    keys.add(clean);
  };
  addKey(v.stock, { stockLike: true });
  addKey(v.batch, { stockLike: true });
  addKey(v.toyotaBatch, { stockLike: true });
  addKey(v.autocareBatch, { stockLike: true });
  addKey(v.frame);
  addKey(v.frameNo);
  addKey(v.autocareFrame);
  [v.vin, v.fullVin, v.frameVin, v.autocareVin, [v.wmi, v.vdsNumber, v.frame].filter(Boolean).join('')]
    .map(normalizeVin)
    .filter(Boolean)
    .forEach(vin => keys.add(vin));
  return [...keys];
}

function navisionVehiclesOverlap(a = {}, b = {}) {
  const keys = new Set(navisionComparableKeys(a));
  if (!keys.size) return false;
  return navisionComparableKeys(b).some(key => keys.has(key));
}

function isProtectedPdcVehicle(vehicle = {}) {
  return !isNavisionOnlyBackEndVehicle(vehicle);
}

function vehiclesMissingFromNavisionImport(existingRows = [], incomingRows = [], options = {}) {
  const fullRefresh = options.fullRefresh !== false;
  if (!fullRefresh) return [];
  const candidates = existingRows.filter(isNavisionOnlyBackEndVehicle).filter(vehicleLooksToyota);
  if (!candidates.length) return [];
  if (!incomingRows.length) return candidates.slice();
  return candidates.filter(vehicle => !incomingRows.some(incoming => navisionVehiclesOverlap(incoming, vehicle)));
}

function deletedVehicleRecordMatchesNavision(record = {}, incoming = {}) {
  if (record.vehicle && navisionVehiclesOverlap(record.vehicle, incoming)) return true;
  const incomingKeys = new Set(navisionComparableKeys(incoming));
  return [record.key].concat(record.keys || [])
    .map(value => normalizeBatch(value))
    .filter(Boolean)
    .some(key => incomingKeys.has(key));
}

function deletedRecordForNavision(records = [], incoming = {}) {
  return (Array.isArray(records) ? records : []).find(record => deletedVehicleRecordMatchesNavision(record, incoming)) || null;
}

function navisionCanRestoreDeletedRecord(record = {}) {
  return cleanNavisionText(record.deletionType || '').toLowerCase() === 'navision-missing';
}

function findAddedVehicleIndex(added, incoming, existing) {
  const keys = new Set(navisionMatchKeys(incoming).concat(navisionMatchKeys(existing)));
  return added.findIndex(vehicle => navisionMatchKeys(vehicle).some(key => keys.has(key)));
}

function findVehicleForNavision(incoming) {
  const stock = normalizeBatch(incoming.stock || incoming.batch);
  const vin = normalizeVin(incoming.vin);
  const frame = normalizeBatch(incoming.frame);
  return app.data.find(vehicle => {
    const toyota = getToyotaMatch(vehicle) || {};
    const candidates = [vehicle.stock, vehicle.batch, vehicle.toyotaBatch, toyota.batch, vehicle.autocareBatch, vehicle.id]
      .map(normalizeBatch)
      .filter(Boolean);
    const vins = [vehicle.vin, vehicle.frameVin, vehicle.fullVin, vehicle.autocareVin]
      .map(normalizeVin)
      .filter(Boolean);
    const frames = [vehicle.frame, vehicle.frameNo, vehicle.autocareFrame]
      .map(normalizeBatch)
      .filter(Boolean);
    return (stock && candidates.includes(stock)) ||
      (vin && vins.includes(vin)) ||
      (frame && frames.includes(frame));
  }) || null;
}

function mergeNavisionSource(existingSource = '') {
  const source = String(existingSource || '').trim();
  if (!source) return 'Navision';
  if (/navision/i.test(source)) return source;
  return `${source} + Navision`;
}

function navisionEditPayload(incoming, existing = {}) {
  // For existing CRM rows, protect manual edits and preparation fields.
  // Navision refreshes only identifiers needed for matching plus Tray, Dealer Comments, JITA and location/status fields.
  const workFileMode = incoming.pdcImportMode === 'work-file';
  const navisionJitaNumberColumnPresent = incoming._navisionJitaNumberColumnPresent === true;
  const independentlyPromoted = vehicleWasIndependentlyPromoted(existing) || Boolean(existing.pdcLocationLocked || existing.navisionLocationLocked || existing.manualLocation);
  const workFilePromotes = workFileMode && incoming.pdcSheetVisible === true;
  const keepVisible = independentlyPromoted || workFilePromotes;
  const payload = {
    source: mergeNavisionSource(existing.source || incoming.source),
    recordLifecycle: existing.recordLifecycle || incoming.recordLifecycle || 'navision',
    pdcSheetVisible: keepVisible,
    pdcVisibilitySource: workFilePromotes
      ? (incoming.pdcVisibilitySource || 'PDC work / job file upload')
      : independentlyPromoted
        ? (existing.pdcVisibilitySource || 'Independent PDC work')
        : 'Navision back end only',
    pdcPromotedAt: keepVisible ? (existing.pdcPromotedAt || incoming.importedAt || nowIsoString()) : '',
    pdcImportMode: workFileMode ? 'work-file' : 'navision',
    importedAt: incoming.importedAt,
    sourceRow: incoming.sourceRow,

    // Navision source fields that should keep refreshing on existing rows.
    prodMth: incoming.prodMth || existing.prodMth || '',
    compPlate: incoming.compPlate || existing.compPlate || '',
    etaAtDealer: workFileMode ? (existing.etaAtDealer || '') : (incoming.etaAtDealer || ''),
    navisionEtaAtDealerBB: workFileMode ? (existing.navisionEtaAtDealerBB || '') : (incoming.navisionEtaAtDealerBB || ''),
    navisionKewdaleEta: workFileMode ? (existing.navisionKewdaleEta || '') : (incoming.navisionKewdaleEta || ''),
    navisionEtaDate: workFileMode ? (existing.navisionEtaDate || '') : (incoming.navisionEtaDate || ''),
    navisionPortPlantEta: workFileMode ? (existing.navisionPortPlantEta || '') : (incoming.navisionPortPlantEta || ''),

    // Batch/Stock is the Navision identity authority.
    id: existing.id || incoming.id,
    stock: incoming.stock || existing.stock || '',
    batch: incoming.batch || incoming.stock || existing.batch || existing.stock || '',

    wmi: incoming.wmi || existing.wmi || '',
    vdsNumber: incoming.vdsNumber || existing.vdsNumber || '',
    frame: incoming.frame || existing.frame || '',
    vin: incoming.vin || existing.vin || '',
    customerSurname: incoming.customerSurname || existing.customerSurname || '',
    dealerCustomerName: incoming.dealerCustomerName || existing.dealerCustomerName || '',
    modelDescription: incoming.modelDescription || existing.modelDescription || '',
    suffixDescription: incoming.suffixDescription || existing.suffixDescription || '',
    trimDescription: incoming.trimDescription || existing.trimDescription || '',
    colourDescription: incoming.colourDescription || existing.colourDescription || '',

    // Allowed Navision refresh fields.
    trayOrdered: workFileMode ? (incoming.trayOrdered === true || existing.trayOrdered === true) : incoming.trayOrdered,
    trayFitmentComplete: workFileMode ? (incoming.trayFitmentComplete === true || existing.trayFitmentComplete === true) : incoming.trayFitmentComplete,
    jitaPartsOrdered: navisionJitaNumberColumnPresent ? incoming.jitaPartsOrdered : (existing.jitaPartsOrdered || 'Unknown'),
    jitQty: navisionJitaNumberColumnPresent ? (incoming.jitQty || '') : (existing.jitQty || ''),
    navisionJitaNumberAuthority: navisionJitaNumberColumnPresent
      ? NAVISION_JITA_NUMBER_AUTHORITY
      : (/navision/i.test(String(existing.source || '')) ? (existing.navisionJitaNumberAuthority || '') : ''),
    toyotaStatus: workFileMode ? (existing.toyotaStatus || '') : (incoming.toyotaStatus || ''),
    navisionSubLocationDescription: workFileMode ? (existing.navisionSubLocationDescription || '') : (incoming.navisionSubLocationDescription || ''),
    navisionLocationStatus: workFileMode ? (existing.navisionLocationStatus || '') : (incoming.navisionLocationStatus || ''),
    navisionTransportLoadNo: workFileMode ? (existing.navisionTransportLoadNo || '') : (incoming.navisionTransportLoadNo || ''),
    navisionTransportPriority: workFileMode ? (existing.navisionTransportPriority || '') : (incoming.navisionTransportPriority || ''),
    navisionBuildStatus: workFileMode ? (existing.navisionBuildStatus || '') : (incoming.navisionBuildStatus || ''),
    navisionRavStatus: workFileMode ? (existing.navisionRavStatus || '') : (incoming.navisionRavStatus || ''),
    arrivalPort: incoming.arrivalPort || existing.arrivalPort || '',
    navisionDealerComments: workFileMode ? (existing.navisionDealerComments || '') : (incoming.navisionDealerComments || ''),
    financeNote: workFileMode ? (existing.financeNote || '') : (incoming.financeNote || ''),
    navisionVehicleNote: workFileMode ? (existing.navisionVehicleNote || '') : (incoming.navisionVehicleNote || ''),
    navisionCutButVehicle: workFileMode ? Boolean(existing.navisionCutButVehicle) : Boolean(incoming.navisionCutButVehicle),
    navisionCutButVehicleSource: workFileMode ? (existing.navisionCutButVehicleSource || '') : (incoming.navisionCutButVehicleSource || ''),
  };
  delete payload._navisionJitaNumberColumnPresent;
  if (!workFileMode) {
    const wasOldAutomaticPromotion = /navision pdc work|navision.*location signal/i.test(existing.pdcVisibilitySource || '');
    if (!independentlyPromoted && wasOldAutomaticPromotion) {
      payload.pdcLocation = '';
      payload.pmbStage = '';
      payload.pdcWorkStage = '';
      payload.workStage = '';
      payload.pdcBlocked = false;
      payload.pdcPartsStoppage = false;
      PDC_JOB_DEFS.forEach(def => {
        payload[def.requireKey] = false;
        payload[def.completeKey] = false;
      });
    }
    // Vehicles promoted from Back End Data initially follow their latest Navision
    // location. Once an operator manually transfers/places one, the location lock
    // takes precedence and later daily files cannot move it behind their back.
    const operatorBackendPromotion = existing.pdcVisibilitySource === 'Operator transfer from Back End Data';
    if ((existing.pdcLocationDerivedFromNavision === true || operatorBackendPromotion) && !existing.pdcLocationLocked && !existing.manualLocation) {
      Object.assign(payload, navisionDerivedLocationUpdates(incoming, existing));
    }
    return payload;
  }
  const explicitPayload = applyExplicitPdcImportFields(payload, incoming, existing);
  return applyNavisionAutoPdcLocation(explicitPayload, incoming, existing);
}

function navisionComparableValue(value) {
  if (value === true || value === false) return value ? 'Yes' : 'No';
  return cleanNavisionText(value || '');
}

function navisionFieldChanges(existing = {}, payload = {}) {
  const fields = [
    ['stock', 'Stock / Batch'],
    ['batch', 'Batch'],

    ['prodMth', 'P/Month'],
    ['etaAtDealer', 'ETA'],
    ['toyotaStatus', 'Toyota Status'],
    ['jitQty', 'JITA Number'],
    ['trayOrdered', 'Tray Fitment Ordered'],
    ['trayFitmentComplete', 'Tray Fitment Complete'],
    ['navisionDealerComments', 'Navision Notes'],
    ['navisionVehicleNote', 'Vehicle Note'],
    ['navisionSubLocationDescription', 'Sub Location Description'],
    ['navisionLocationStatus', 'Location Status'],
    ['navisionTransportLoadNo', 'Transport Load No.'],
    ['navisionBuildStatus', 'Build Status'],
    ['navisionRavStatus', 'RAV Status'],
    ['pdcLocation', 'PDC Location'],
    ['pdcSheetVisible', 'PDC Sheet visibility'],
    ['pdcJobcard', 'PDC Job Card'],
    ['pmbStage', 'PMB Work Stream'],
    ['pdcBlocked', 'Blocked'],
    ['pdcBlockReason', 'Blocked Reason'],
    ...PDC_JOB_DEFS.flatMap(def => [
      [def.requireKey, `Requires ${def.label}`],
      [def.completeKey, `${def.label} Complete`],
    ]),
    ['vin', 'VIN'],
    ['frame', 'Frame'],
  ];
  return fields.flatMap(([key, label]) => {
    const before = navisionComparableValue(key === 'etaAtDealer' ? scotEtaOnly(existing[key]) : existing[key]);
    const after = navisionComparableValue(key === 'etaAtDealer' ? scotEtaOnly(payload[key]) : payload[key]);
    if (before === after) return [];
    if (!before && !after) return [];
    return [{ key, label, before, after }];
  });
}

function buildNavisionImportPlan(parsed) {
  const deletedRecords = deletedVehicleRecords();
  const activeBeforeImport = app.data.slice();
  const fullRefresh = navisionImportIsFullRefresh();
  const removeMissingChecked = Boolean($('#navision-remove-missing')?.checked) && fullRefresh;
  const result = {
    parsed,
    added: [],
    updated: [],
    unchanged: [],
    stockNumberUpdates: [],
    restored: [],
    skipped: parsed.warnings.slice(),
    missingFromUpload: [],
    removedMissing: [],
    removeMissingChecked,
    importedAt: new Date().toISOString(),
    fileName: app.navisionFileName || 'Pasted text',
    fullRefresh,
    requiresConfirmation: false,
    confirmed: false,
  };

  parsed.vehicles.forEach(incoming => {
    const deletedRecord = deletedRecordForNavision(deletedRecords, incoming);
    if (deletedRecord && !navisionCanRestoreDeletedRecord(deletedRecord)) {
      result.skipped.push(`${displayStockNumber(incoming) || 'Vehicle'} remains Deleted because it was removed by an operator.`);
      return;
    }
    const existing = findVehicleForNavision(incoming);
    if (deletedRecord) result.restored.push(incoming);

    if (existing) {
      const incomingHasStock = incoming.stock && !isBlankStock(incoming.stock);
      const existingHadNoStock = isBlankStock(existing.stock);
      const stockChanged = incomingHasStock && existingHadNoStock;
      const payload = navisionEditPayload(incoming, existing);
      const changes = navisionFieldChanges(existing, payload);
      const row = { incoming, existing: { ...existing }, stockChanged, payload, changes, key: vehicleKey(existing) || vehicleKey(incoming) };
      if (stockChanged) result.stockNumberUpdates.push(row);
      if (changes.length || stockChanged) result.updated.push(row);
      else result.unchanged.push(row);
    } else {
      result.added.push(incoming);
    }
  });

  result.missingFromUpload = vehiclesMissingFromNavisionImport(activeBeforeImport, parsed.vehicles, { fullRefresh });
  result.requiresConfirmation = Boolean(result.updated.length || result.stockNumberUpdates.length);
  return result;
}

function navisionSharedBackendService() {
  if (app.navisionSharedBackendService) return app.navisionSharedBackendService;
  const serviceModule = window.PDC_NAVISION_BACKEND_SERVICE;
  const factory = serviceModule?.createNavisionBackendService;
  const config = window.PDC_SUPABASE_CONFIG || {};
  if (typeof factory !== 'function') return null;
  try {
    app.navisionSharedBackendService = factory({
      config,
      projectRef: serviceModule.NAVISION_STAGING_PROJECT_REF,
      getAccessToken: () => window.__pdcCachedAccessToken || null,
    });
    return app.navisionSharedBackendService;
  } catch (error) {
    console.error('Shared Navision service unavailable', error);
    return null;
  }
}

function navisionBrowserAuthoritySha256() {
  const keys = [ADDED_KEY, EDITS_KEY, DELETED_KEY, PO_TASKS_KEY, PO_FILES_KEY, AUDIT_LOG_KEY, NAVISION_IMPORT_RESULTS_KEY, OPERATIONAL_HEALTH_KEY]
    .filter(Boolean).sort();
  return sha256Hex(JSON.stringify(keys.map(key => [key, localStorage.getItem(key)])));
}

function navisionSharedPreviewData(result = null) {
  return result?.data?.data || result?.data || null;
}

function navisionSharedPreviewBlockingState(data = {}) {
  const helper = window.PDC_NAVISION_BACKEND_SERVICE?.navisionPreviewBlockingState;
  if (typeof helper === 'function') return helper(data);
  const counts = data?.counts && typeof data.counts === 'object' ? data.counts : null;
  const invalid = Math.max(0, Number(counts?.invalid || 0));
  const conflict = Math.max(0, Number(counts?.conflict || 0));
  const affected = invalid + conflict;
  const safety = data?.safety && typeof data.safety === 'object' ? data.safety : null;
  const safetyBlocking = safety?.blocking === true;
  return {
    invalid,
    conflict,
    affected,
    safetyBlocking,
    safetyReason: safetyBlocking ? String(safety?.reason || 'safety_review_required') : '',
    inconsistentFlag: data?.blocking === true && affected === 0 && Boolean(counts) && !safetyBlocking,
    blocking: affected > 0 || safetyBlocking || (data?.blocking === true && !counts),
  };
}

function navisionSafetyIssueMessage(reason = '') {
  const messages = {
    suspicious_partial_snapshot: 'This file omits an unusually large number of current dealer vehicles and may be a partial export.',
    suspicious_complete_replacement: 'This file would replace the complete current dealer scope.',
    suspicious_cross_dealer_overlap: 'This file appears to contain records belonging to another dealer.',
    suspicious_dealer_filename_mismatch: 'The selected dealer does not match the uploaded filename.',
    source_name_dealer_scope_mismatch: 'The selected dealer does not match the uploaded filename.',
    cross_dealer_identity_overlap: 'This file contains Navision identities already assigned to the other dealer.',
    unproven_empty_dealer_scope: 'This dealer has no established Navision baseline. An administrator must review and approve this exact first full snapshot.',
    suspicious_empty_scope: 'The dealer scope or source file could not be proven safely.',
    suspicious_tiny_snapshot: 'This file is too small to treat as a complete daily Navision snapshot.',
    safety_review_required: 'The server safety assessment requires this file to be reviewed before import.',
  };
  return messages[reason] || messages.safety_review_required;
}

function navisionDealerName(dealerCode = '') {
  if(dealerCode==='broome')return 'Broome Upload · 037047 + 001234 + 002345';
  if(dealerCode==='pilbara')return 'Pilbara Upload · 014450 + 001234 + 002345';
  if (dealerCode === 'combined') return '014450, 001234 and 002345';
  return String(dealerCode) === '14450' ? 'Pilbara Toyota' : String(dealerCode) === '37047' ? 'Broome Toyota' : `dealer ${dealerCode || 'not selected'}`;
}

function navisionPreviewIssueMessage(reason = '') {
  const messages = {
    row_not_object: 'This row is not a valid spreadsheet record.',
    missing_source_record_id: 'No unique Navision record ID was found in this row.',
    forbidden_operational_field: 'This row contains workshop fields that Navision is not allowed to change.',
    duplicate_source_record_id: 'The same Navision record appears more than once in this file.',
    duplicate_stock_number: 'This Stock number appears in more than one source row. Keep one authoritative row.',
    duplicate_existing_stock_number: 'This Stock number already belongs to another current Navision record.',
    duplicate_vin: 'This VIN appears in more than one source row.',
    delivery_vehicle_not_found: 'Delivered - At Dealer was not applied because the linked vehicle is missing or soft-deleted.',
    duplicate_toyota_order: 'This Toyota Order appears in more than one source row.',
    wrong_dealer_scope: 'This row declares a different dealer from the selected dealer.',
    missing_dealer_column: 'Combined uploads need a Dealer column for every row.',
    invalid_status_code: 'The explicit workflow status code is not supported by the shared import contract.',
    invalid_date: 'The explicit date is not a valid ISO or Australian date.',
    invalid_location_code: 'The explicit location code must be YH, PMB or RFT.',
    canonical_identity_mismatch: 'The Stock/VIN identity points to a different canonical vehicle than this Navision record.',
    ambiguous_canonical_identity: 'This record matches more than one car, so it cannot be safely updated.',
    legacy_claim_requires_administrator: 'An Administrator must review this older unassigned record.',
  };
  return messages[reason] || 'This row could not be matched safely.';
}

function navisionPreviewItemLabel(item = {}) {
  const stock = cleanNavisionText(item.stock_number || item.stock || '');
  const identity = cleanNavisionText(item.source_record_id || '');
  if (stock) return `Stock ${stock}${identity ? ` · Navision record ${identity}` : ''}`;
  return identity ? `Navision record ${identity}` : `Row ${Number(item.row_index || 0) || '?'}`;
}

function navisionClientPreflight(rows = [], dealerCode = '') {
  const sourceRows = Array.isArray(rows) ? rows : [];
  const canonicalDealer = value => {
    const code = String(value || '').trim().replace(/^0+/, '');
    return code === '2345' ? '002345' : code === '1234' ? '001234' : code;
  };
  const normalizedDealer = canonicalDealer(dealerCode);
  const combined = ['combined','broome','pilbara'].includes(dealerCode);
  const combinedDealers = [dealerCode==='broome'?'37047':'14450', '001234', '002345'];
  const sourceIds = new Map();
  const stocks = new Map();
  const vins = new Map();
  const orders = new Map();
  const issues = [];
  const add = (map, value, index) => {
    if (!value) return;
    if (!map.has(value)) map.set(value, []);
    map.get(value).push(index);
  };
  const sourceIdFor = row => String(row?.id || row?.source_record_id || row?.sourceRecordId || '').trim();
  const stockFor = row => normalizeBatch(row?.stock || row?.stock_number || row?.batch || '') || '';
  const vinFor = row => normalizeVin(row?.vin || row?.fullVin || row?.frameVin || '') || '';
  const orderFor = row => normalizeBatch(row?.order || row?.toyota_order_number || '') || '';
  const declaredDealerFor = row => {
    const direct = row?.dealerCode || row?.dealer_code || row?.navisionDealerCode || row?.navision_dealer_code;
    if (direct) return canonicalDealer(direct);
    const columns = row?.navisionRawEvidence?.columns;
    if (!Array.isArray(columns)) return '';
    const match = columns.find(column => ['dealer', 'dealercode', 'dealerno', 'dealernumber'].includes(cleanNavisionText(column?.header || '').toLowerCase().replace(/[^a-z0-9]/g, '')));
    return match ? canonicalDealer(match.value || match.rawValue) : '';
  };
  const explicitValue = (row, keys) => keys.map(key => row?.[key]).find(value => String(value || '').trim()) || '';
  const validDate = value => {
    const text = String(value || '').trim();
    if (!text) return true;
    if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
      const date = new Date(`${text}T00:00:00Z`);
      return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === text;
    }
    const match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return false;
    const date = new Date(Date.UTC(Number(match[3]), Number(match[2]) - 1, Number(match[1])));
    return date.getUTCFullYear() === Number(match[3]) && date.getUTCMonth() === Number(match[2]) - 1 && date.getUTCDate() === Number(match[1]);
  };
  sourceRows.forEach((row, index) => {
    if (combined && !combinedDealers.includes(declaredDealerFor(row))) return;
    add(sourceIds, sourceIdFor(row), index);
    add(stocks, stockFor(row), index);
    add(vins, vinFor(row), index);
    add(orders, orderFor(row), index);
  });
  sourceRows.forEach((row, index) => {
    const sourceRecordId = sourceIdFor(row);
    const stock = stockFor(row);
    const vin = vinFor(row);
    const order = orderFor(row);
    const declaredDealer = declaredDealerFor(row);
    if (combined && declaredDealer && !combinedDealers.includes(declaredDealer)) return;
    const status = explicitValue(row, ['pdcStatus', 'pdc_status', 'workflowStatus', 'workflow_status', 'statusCode', 'status_code']);
    const location = explicitValue(row, ['pdcLocation', 'pdc_location', 'locationCode', 'location_code']);
    const date = explicitValue(row, ['pdcEtaDate', 'pdc_eta_date', 'locationDate', 'location_date']);
    let reason = '';
    let field = '';
    let classification = 'conflict';
    if (!row || typeof row !== 'object' || Array.isArray(row)) { reason = 'row_not_object'; field = 'source_record_id'; classification = 'invalid'; }
    else if (!sourceRecordId) { reason = 'missing_source_record_id'; field = 'source_record_id'; classification = 'invalid'; }
    else if (combined && !declaredDealer) { reason = 'missing_dealer_column'; field = 'dealer_code'; classification = 'invalid'; }
    else if (!combined && declaredDealer && declaredDealer !== normalizedDealer) { reason = 'wrong_dealer_scope'; field = 'dealer_code'; }
    else if ((sourceIds.get(sourceRecordId) || []).length > 1) { reason = 'duplicate_source_record_id'; field = 'source_record_id'; }
    else if (stock && (stocks.get(stock) || []).length > 1) { reason = 'duplicate_stock_number'; field = 'stock'; }
    else if (vin && (vins.get(vin) || []).length > 1) { reason = 'duplicate_vin'; field = 'vin'; }
    else if (order && (orders.get(order) || []).length > 1) { reason = 'duplicate_toyota_order'; field = 'toyota_order_number'; }
    else if (status && !['new', 'current', 'active', 'inactive', 'planned', 'pending', 'review', 'reviewonly', 'yardhold', 'yh', 'pmb', 'rft', 'completed', 'other'].includes(status.toLowerCase().replace(/[^a-z0-9]+/g, ''))) { reason = 'invalid_status_code'; field = 'status_code'; classification = 'invalid'; }
    else if (location && !['YH', 'PMB', 'RFT'].includes(location.toUpperCase().replace(/[^A-Z0-9]+/g, ''))) { reason = 'invalid_location_code'; field = 'location_code'; classification = 'invalid'; }
    else if (date && !validDate(date)) { reason = 'invalid_date'; field = 'date'; classification = 'invalid'; }
    if (reason) issues.push({ row_index: index + 1, classification, reason, field, stock_number: stock || null, source_record_id: sourceRecordId || null, candidate_vehicle_ids: [] });
  });
  return { contract_version: 1, blocking: issues.length > 0, issue_count: issues.length, issues, authority: 'shared_navision_backend_only', atomic_apply: true };
}

function mergeNavisionPreflightData(data = {}, preflight = {}) {
  const issues = Array.isArray(preflight?.issues) ? preflight.issues : [];
  if (!issues.length) return data;
  const items = Array.isArray(data.items) ? data.items.map(item => ({ ...item })) : [];
  issues.forEach(issue => {
    const index = items.findIndex(item => Number(item.row_index) === Number(issue.row_index));
    if (index < 0 || index >= items.length) return;
    items[index] = { ...items[index], ...issue };
  });
  const counts = {
    total: items.length,
    new: items.filter(item => item.classification === 'new').length,
    changed: items.filter(item => item.classification === 'changed').length,
    unchanged: items.filter(item => item.classification === 'unchanged').length,
    invalid: items.filter(item => item.classification === 'invalid').length,
    conflict: items.filter(item => item.classification === 'conflict').length,
    missing: Number(data?.counts?.missing || 0),
    proposed_links: Number(data?.counts?.proposed_links || 0),
    operational_mutations: 0,
  };
  return { ...data, items, counts, preflight, blocking: data.blocking === true || preflight.blocking === true };
}

function sharedNavisionApplyErrorMessage(result = {}) {
  const code = String(result?.code || result?.error || '').toLowerCase();
  const data = result?.data?.data || result?.data || {};
  const issues = data?.preflight?.issues || data?.issues || [];
  if (code === 'navision_preflight_blocked' || code === 'blocking_reconciliation' || code === 'preview_has_blocking_issues') {
    const detail = issues.slice(0, 4).map(item => `${navisionPreviewItemLabel(item)} — ${navisionPreviewIssueMessage(item.reason)}${item.field ? ` (field ${item.field})` : ''}`).join('; ');
    return `Navision apply was blocked before any change. ${detail || 'Review the flagged rows in the preview and correct the source file.'} Nothing was imported.`;
  }
  if (code === '23514' || code.includes('navision_vehicle_link_or_refresh_incomplete')) {
    return 'Navision apply was blocked by a duplicate or stale canonical vehicle identity. Preview the file again; nothing was imported and no browser-local fallback was attempted.';
  }
  if (code === 'stale_revision' || code === 'source_changed' || code === 'preview_changed') return 'The shared Navision data changed while this file was open. Preview the file again; nothing was imported.';
  if (['55p03', '40p01', '40001'].includes(code)) return 'The workshop was updating at the same time and the Navision import could not obtain access. Nothing was imported. Your preview is still here; try Apply again shortly.';
  if (code === '57014') return 'The Navision import took too long and was cancelled. Nothing was imported. Your preview is still here; try Apply again shortly.';
  if (code === 'transport_unconfirmed') return 'The connection ended before the import result could be confirmed. Keep this preview and retry Apply to check the same import safely.';
  if (code === 'suspicious_import_blocked') return `${navisionSafetyIssueMessage(data?.safety?.reason)} Nothing was imported.`;
  if (code === 'sublet_provider_review_required') return 'A sublet provider in this file needs review. Check the provider names in the preview before applying. Nothing was imported.';
  if (code === 'unauthorized') return 'Importer or administrator access is required for shared Navision imports. Nothing was imported.';
  const serverMessage = String(result?.data?.message || result?.message || '');
  if (serverMessage.includes('navision_dealer_delivery_failed')) {
    return `The shared Navision import was rejected before completion. ${serverMessage} Nothing was imported.`;
  }
  const reference = /^[a-z0-9_]{1,80}$/.test(code) ? ` Reference: ${code}.` : '';
  return `The shared Navision import was rejected before completion. Preview the file again or correct the flagged source row; nothing was imported and no browser-local fallback was attempted.${reference}`;
}

async function loadSharedNavisionCurrentRows(service, dealerCode, expectedRevision) {
  const items = [];
  let cursor = {};
  for (let page = 0; page < 12; page += 1) {
    const response = await service.snapshot({ sourceSystem: 'microsoft_navision', dealerCode }, cursor, 500, expectedRevision);
    if (!response?.ok) return null;
    const data = navisionSharedPreviewData(response) || {};
    items.push(...(Array.isArray(data.items) ? data.items : []));
    if (!data.has_more) return items;
    if (!data.next_source_record_id || !data.next_record_id) return null;
    cursor = { sourceRecordId: data.next_source_record_id, recordId: data.next_record_id };
  }
  return null;
}

async function enrichSharedNavisionPreviewChanges(state = {}, service = null) {
  const data = state.previewData || {};
  if (!service || !Number.isInteger(data.base_revision)) return false;
  const scopes = ['combined','broome','pilbara'].includes(state.dealerCode) ? (data.dealer_groups || []).map(group => group.dealer_code) : [state.dealerCode];
  const snapshots = await Promise.all(scopes.map(dealer => loadSharedNavisionCurrentRows(service, dealer, data.base_revision)));
  const existingRows = snapshots.every(rows => Array.isArray(rows)) ? snapshots.flat() : null;
  if (!existingRows) return false;
  const byId = new Map(existingRows.map(row => [String(row.id || ''), row]));
  const items = Array.isArray(data.items) ? data.items : [];
  items.forEach(item => {
    if (item.classification !== 'changed') return;
    const incoming = state.rows?.[Math.max(0, Number(item.row_index || 1) - 1)] || {};
    const existing = byId.get(String(item.backend_record_id || ''));
    item.field_changes = existing ? navisionFieldChanges(existing.normalized_data || {}, incoming) : [];
    item.change_details_available = Boolean(existing);
  });
  state.previewChangeDetailsReady = true;
  return true;
}

function renderSharedNavisionChangeDetails(state = {}, data = {}) {
  const items = Array.isArray(data.items) ? data.items : (Array.isArray(state.previewData?.items) ? state.previewData.items : []);
  const changed = items.filter(item => item.classification === 'changed');
  const issues = items.filter(item => ['invalid', 'conflict'].includes(item.classification));
  const changedHtml = changed.length ? `<section class="navision-human-detail"><h4>Cars that would be modified</h4>${changed.map(item => {
    const changes = Array.isArray(item.field_changes) ? item.field_changes : [];
    const detail = changes.length
      ? `<ul>${changes.map(change => `<li><strong>${escapeHtml(change.label)}:</strong> ${escapeHtml(change.before || 'Blank')} → ${escapeHtml(change.after || 'Blank')}</li>`).join('')}</ul>`
      : `<p>${item.change_details_available === false ? 'The existing record could not be loaded. Preview again to see the exact changes.' : 'Navision data changed, but no staff-facing vehicle fields changed.'}</p>`;
    return `<div class="navision-human-row"><strong>${escapeHtml(navisionPreviewItemLabel(item))}</strong>${detail}</div>`;
  }).join('')}</section>` : '';
  const issueHtml = issues.length ? `<section class="navision-human-detail navision-human-errors"><h4>Rows that need attention</h4><ul>${issues.map(item => `<li><strong>${escapeHtml(navisionPreviewItemLabel(item))}:</strong> ${escapeHtml(navisionPreviewIssueMessage(item.reason))}</li>`).join('')}</ul><p>Fix these rows in the source file, then preview it again. Nothing has been imported.</p></section>` : '';
  return `${changedHtml}${issueHtml}`;
}

function renderNavisionCombinedSummary(data = {}) {
  if (!Array.isArray(data.dealer_groups)) return '';
  const excluded = Array.isArray(data.excluded_rows) ? data.excluded_rows : [];
  return `<section class="navision-human-detail"><h4>Combined dealer upload</h4><ul>${data.dealer_groups.map(group => `<li>Dealer ${escapeHtml(String(group.dealer_code).padStart(6, '0'))}: ${Number(group.counts?.total || 0)} vehicles</li>`).join('')}</ul>${excluded.length ? `<p>${excluded.length} row${excluded.length === 1 ? '' : 's'} excluded from this upload:</p><ul>${excluded.map(row => `<li>${escapeHtml(navisionPreviewItemLabel(row))} · dealer ${escapeHtml(row.dealer_code)} (${row.reason === 'unsold_without_stock' ? 'not COSI sold and no stock number' : 'outside the selected dealers'})</li>`).join('')}</ul>` : ''}</section>`;
}

function renderSharedNavisionPreview(state = {}, applied = false) {
  const host = $('#navision-status-list');
  if (!host) return;
  let data = navisionSharedPreviewData(applied ? state.applyResult : state.previewResult) || state.previewData || {};
  if (applied && Array.isArray(data.items) && Array.isArray(state.previewData?.items)) {
    const previewItems = new Map(state.previewData.items.map(item => [`${item.row_index || ''}|${item.source_record_id || ''}`, item]));
    data = {
      ...data,
      items: data.items.map(item => {
        const previewItem = previewItems.get(`${item.row_index || ''}|${item.source_record_id || ''}`);
        return previewItem ? { ...item, field_changes: previewItem.field_changes || [], change_details_available: previewItem.change_details_available === true } : item;
      }),
    };
  }
  const counts = data.counts || state.previewData?.counts || {};
  const total = Number(counts.total || 0);
  const added = Number(counts.new || 0);
  const changed = Number(counts.changed || 0);
  const unchanged = Number(counts.unchanged || 0);
  const missing = Number(counts.missing || 0);
  const blockingState = navisionSharedPreviewBlockingState(data);
  const invalid = blockingState.invalid;
  const conflict = blockingState.conflict;
  const blocking = blockingState.blocking;
  const deliveryReviews = Array.isArray(data.delivery_reviews) ? data.delivery_reviews : [];
  const deliveryReviewHtml = deliveryReviews.length
    ? `<section class="navision-human-detail navision-human-errors"><h4>Delivered - At Dealer rows held for review</h4><ul>${deliveryReviews.map(item => `<li><strong>Stock ${escapeHtml(String(item.stock_number || 'unknown'))}:</strong> ${escapeHtml(String(item.detail || navisionPreviewIssueMessage(item.reason)))}</li>`).join('')}</ul><p>These rows were saved. Delivery was not applied, and soft-deleted vehicles were not restored.</p></section>`
    : '';
  const resultBanner = applied
    ? `<div class="navision-import-success" role="status" aria-live="polite"><span class="navision-import-success-tick" aria-hidden="true">✓</span><div><strong>Navision import complete</strong><span>Received ${total} car record${total === 1 ? '' : 's'} for ${escapeHtml(navisionDealerName(state.dealerCode))}.</span></div></div>`
    : `<div class="summary-row ${blocking ? 'error' : 'success'}"><strong>${blocking ? 'This file needs attention before it can be imported' : 'Navision file checked and ready'}</strong><span>Received ${total} car record${total === 1 ? '' : 's'} for ${escapeHtml(navisionDealerName(state.dealerCode))}. ${blocking ? 'Nothing was changed.' : 'This is a preview. Nothing has changed yet.'}</span></div>`;
  host.innerHTML = `${resultBanner}
    ${renderNavisionCombinedSummary(data)}
    <div class="scot-summary-grid navision-human-summary">
      <div class="summary-stat"><span>${applied ? 'Added to Back End Data' : 'Would be added'}</span><strong>${added}</strong></div>
      <div class="summary-stat"><span>${applied ? 'Cars modified' : 'Would be modified'}</span><strong>${changed}</strong></div>
      <div class="summary-stat"><span>Already up to date</span><strong>${unchanged}</strong></div>
      <div class="summary-stat"><span>Not in this file</span><strong>${missing}</strong></div>
      <div class="summary-stat"><span>Rows needing attention</span><strong>${invalid + conflict}</strong></div>
      <div class="summary-stat"><span>Delivered - At Dealer</span><strong>To Completed</strong></div>
    </div>
    <div class="parts-help-strip"><strong>${applied ? 'What happened:' : 'Import rule:'}</strong><span>${applied ? `The shared Navision records were updated. ${added} added, ${changed} modified and ${unchanged} already current. Confirmed Delivered - At Dealer vehicles are in Completed Vehicles with their active PMB bookings cancelled. Their history is retained.` : 'A Navision upload updates the shared vehicle details. Delivered - At Dealer moves linked PMB vehicles to Completed Vehicles and cancels their active bookings. History is retained; work items, Parts and QC results are preserved.'}</span></div>
    ${!applied && blockingState.inconsistentFlag ? '<div class="summary-row warning"><strong>Preview rechecked</strong><span>No invalid or conflicting rows were found. The database will validate the exact preview again before applying any change.</span></div>' : ''}
    ${!applied && blockingState.safetyBlocking ? `<div class="summary-row error"><strong>Server safety check blocked this import</strong><span>${escapeHtml(navisionSafetyIssueMessage(blockingState.safetyReason))} Nothing was changed.</span></div>` : ''}
    ${renderSharedNavisionChangeDetails(state, data)}
    ${deliveryReviewHtml}
    <details class="navision-technical-details"><summary>Technical details</summary><div class="subtle navision-note">Dealer ${escapeHtml(state.dealerCode || '')} · ${applied ? `receipt ${escapeHtml(data.receipt_id || data.receiptId || 'returned by server')} · revision ${escapeHtml(data.revision ?? data.result_revision ?? '')}` : `preview ${escapeHtml(data.preview_hash || '')}`} · browser check ${escapeHtml(state.browserLocalSha256 || '')}</div></details>`;
}


function renderBroomeNavisionOrders(pending, applied = false) {
  const host = $('#navision-status-list'); if (!host) return;
  const data = pending.previewData || {}, early = Number(data.without_stock || 0), accepted = Number(data.accepted || 0);
  const sold = pending.rows.filter(row=>/^(yes|true|1)$/i.test(String(row.cosi||'').trim())).length;
  host.innerHTML = '<div class="summary-row success" role="status"><strong>'+ (applied ? 'Broome sales order import complete' : 'Broome sales orders checked and ready') + '</strong><span>'+ (applied ? Number(data.changed||0)+' sales records updated.' : 'Preview only. Nothing has changed yet.') + '</span></div><div class="scot-summary-grid navision-human-summary"><div class="summary-stat"><span>Source rows</span><strong>'+pending.rows.length+'</strong></div><div class="summary-stat"><span>COSI sold orders</span><strong>'+sold+'</strong></div><div class="summary-stat"><span>Sold orders without Batch / Stock</span><strong>'+early+'</strong></div><div class="summary-stat"><span>Eligible source orders</span><strong>'+accepted+'</strong></div><div class="summary-stat"><span>Unsold rows not added</span><strong>'+Number(data.skipped_unsold||0)+'</strong></div><div class="summary-stat"><span>Existing COSI visibility updates</span><strong>'+Number(data.visibility_updates||0)+'</strong></div></div><div class="parts-help-strip"><strong>Broome sales tracker only:</strong><span>Blank Batch / Stock is accepted for COSI Yes orders with a Toyota Order number and recognised salesperson. Orders keep the same tracking identity when a stock number arrives. PDC vehicles, Parts, locations and workshop bookings are unchanged. Unsold vehicles are hidden from the sales dashboard.</span></div><p><a href="sales/">Open Broome Toyota sales tracker</a></p>';
}
async function previewBroomeNavisionOrders(text) {
  const identity = navisionSharedApplyAuthorityIdentity(), sourceHash = sha256Hex(text.trim());
  app.pendingSharedNavisionImport = null; app.broomeNavisionLastResult = null;
  try {
    const pending = await window.BROOME_NAVISION_IMPORT?.preview(prepareNavisionText(text));
    if (!pending) return;
    if (identity !== navisionSharedApplyAuthorityIdentity() || ($('#navision-dealer-code')?.value || '').trim() !== '37047' || sha256Hex(($('#navision-paste')?.value || '').trim()) !== sourceHash) return;
    app.pendingSharedNavisionImport = {...pending,sourceTextSha256:sourceHash};
    renderBroomeNavisionOrders(app.pendingSharedNavisionImport);
  } catch (error) {
    if (identity !== navisionSharedApplyAuthorityIdentity()) return;
    const host = $('#navision-status-list');
    if (host) host.innerHTML = '<div class="summary-row error" role="alert"><strong>Broome order preview needs attention</strong><span>'+escapeHtml(error.message||'The file could not be checked.')+'</span><span>No orders were imported. A blank Batch / Stock is allowed when COSI is Yes; every included order still needs its Toyota Order number and recognised salesperson.</span></div>';
  } finally {updateNavisionImportButton();}
}
async function applyBroomeNavisionOrders(pending, authorityIdentity) {
  if (!navisionSharedPendingStillCurrent(pending, authorityIdentity) || !window.BROOME_NAVISION_IMPORT?.allowed()) return;
  try {
    const data = await window.BROOME_NAVISION_IMPORT.apply(pending);
    if (!data || !navisionSharedPendingStillCurrent(pending, authorityIdentity)) return;
    app.pendingSharedNavisionImport = null;
    app.broomeNavisionLastResult = {sourceTextSha256:pending.sourceTextSha256,data};
    renderBroomeNavisionOrders({...pending,previewData:data},true);
  } catch(error) {
    if (navisionSharedPendingStillCurrent(pending, authorityIdentity)) {
      const host = $('#navision-status-list');if(host)host.innerHTML='<div class="summary-row error" role="alert"><strong>Broome import could not be confirmed</strong><span>'+escapeHtml(error.message||'Keep this preview and retry.')+'</span></div>';
    }
  } finally {updateNavisionImportButton();}
}


function navisionCompleteSnapshotReviewable(pending = {}) {
  const data = pending.previewData || {}, block = navisionSharedPreviewBlockingState(data);
  const groups = Array.isArray(data.dealer_groups) ? data.dealer_groups : [];
  return ['broome','pilbara'].includes(pending.dealerCode)
    && String(window.PDC_AUTH_CONTEXT?.role || '').toLowerCase() === 'administrator'
    && block.safetyBlocking && block.affected === 0 && groups.length > 0
    && groups.some(group => group.blocking === true)
    && groups.every(group => group.blocking !== true ||
      ['suspicious_partial_snapshot','unproven_empty_dealer_scope'].includes(group.safety?.reason));
}

async function reviewNavisionCompleteSnapshot(pending, service, authorityIdentity = navisionSharedApplyAuthorityIdentity()) {
  if (!navisionCompleteSnapshotReviewable(pending) || !service?.reviewCompleteSnapshot
      || !navisionSharedPendingStillCurrent(pending, authorityIdentity)) return false;
  const data = pending.previewData;
  renderSharedNavisionPreview(pending);
  const summary = data.dealer_groups.map(group =>
    `Dealer ${String(group.dealer_code).padStart(6,'0')}: ${Number(group.counts?.total || 0)} in this file; ${Number(group.counts?.missing || 0)} not in this file.`).join('\n');
  if (!window.confirm(`Confirm this is the complete current Navision export for the included dealers?\n\n${summary}\n\nContinue only if this is the full export, not a filtered or partial list. Missing vehicles will leave the active sales planner under the existing Navision rules; their history is retained. Dealers absent from this file are unchanged.\n\nThis reviews only this exact file for your account for two hours. You will still confirm the import separately. When applied, Delivered - At Dealer completes linked PMB vehicles and cancels their active bookings. Work items, Parts and QC results are preserved.`)) return false;
  if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) return false;
  const approval = await service.reviewCompleteSnapshot(pending.rows, pending.previewResult, pending.metadata);
  if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) return false;
  if (!approval?.ok) {
    pdcNotify(sharedNavisionApplyErrorMessage(approval));
    return false;
  }
  const result = await service.preview(pending.rows, pending.metadata);
  if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) return false;
  if (!result?.ok) {
    pdcNotify('The reviewed file could not be rechecked. Preview it again; nothing was imported.');
    return false;
  }
  pending.previewResult = result;
  pending.previewData = mergeNavisionPreflightData(navisionSharedPreviewData(result) || {}, pending.clientPreflight);
  renderSharedNavisionPreview(pending);
  updateNavisionImportButton();
  return true;
}

async function importNavisionVehicles() {
  if (app.navisionPreviewInFlight === true) return;
  setNavisionPreviewBusy(true);
  await navisionWaitForBusyPaint();
  let previewRequest = null;
  let previewDispatched = false;
  try {
  const input = $('#navision-paste');
  const text = input?.value || '';
  if (!$('#navision-dealer-code')) return importNavisionVehiclesLocal(text);
  if (!navisionSharedImportRoleAllowed()) {
    updateNavisionImportAccessStatus(true);
    pdcNotify('Importer or administrator access is required for shared Navision imports. Ask an administrator to assign the importer role. Nothing changed.');
    return;
  }
  let dealerCode = ($('#navision-dealer-code')?.value || '').trim();
  if (!['broome','pilbara','combined', '14450', '37047', '002345', '001234'].includes(dealerCode)) {
    pdcNotify('Choose Broome Upload or Pilbara Upload before previewing.');
    return;
  }
  if (dealerCode === '37047') return await previewBroomeNavisionOrders(text);
  previewRequest = {
    authorityIdentity: navisionSharedApplyAuthorityIdentity(),
    dealerCode,
    sourceTextSha256: sha256Hex(text.trim()),
  };
  app.pendingSharedNavisionImport = null;
  const options = {...navisionImportOptionsFromDom(),uploadProfile:['broome','pilbara'].includes(dealerCode)?dealerCode:null};
  const parsed = parseNavisionInput(text, options);
  if (['broome', 'pilbara'].includes(dealerCode) && parsed.vehicles.length) {
    const assessment = assessNavisionUploadProfile(parsed.vehicles, dealerCode);
    if (assessment.detectedProfile && assessment.profile !== dealerCode) {
      setNavisionUploadProfile(assessment.profile);
      dealerCode = assessment.profile;
      parsed.options.uploadProfile = dealerCode;
      previewRequest.dealerCode = dealerCode;
    }
    renderNavisionUploadProfileDetection(assessNavisionUploadProfile(parsed.vehicles, dealerCode));
    if (assessment.blockedMessage) {
      reportSharedNavisionPreviewError({ code: assessment.invalidDealerRow ? 'upload_dealer_column_invalid' : 'upload_no_supported_dealers', rowIndex: assessment.invalidDealerRow }, previewRequest);
      return;
    }
  }
  if (parsed.rejectedRows?.length) {
    app.pendingSharedNavisionImport = null;
    renderNavisionSummary({ parsed, added: [], updated: [], unchanged: [], stockNumberUpdates: [], restored: [], skipped: parsed.warnings });
    pdcNotify('One or more source rows have no Navision identity. Shared preview was blocked so no raw source evidence is silently discarded.');
    updateNavisionImportButton();
    return;
  }
  if (!parsed.vehicles.length) {
    app.pendingSharedNavisionImport = null;
    renderNavisionSummary({ parsed, added: [], updated: [], unchanged: [], stockNumberUpdates: [], restored: [], skipped: parsed.warnings });
    updateNavisionImportButton();
    return;
  }
  const service = navisionSharedBackendService();
  if (!service) {
    reportSharedNavisionPreviewError({ code: 'service_unavailable' }, previewRequest);
    return;
  }
  const browserLocalSha256 = navisionBrowserAuthoritySha256();
  const rows = parsed.vehicles;
  const clientPreflight = navisionClientPreflight(rows, dealerCode);
  const metadata = { sourceSystem: 'microsoft_navision', dealerCode, sourceName: app.navisionFileName || 'Pasted text', sourceTimestamp: null };
  const previewAuthorityIdentity = previewRequest.authorityIdentity;
  previewDispatched = true;
  let previewResult = await service.preview(rows, metadata);
  if (!navisionSharedPreviewRequestStillCurrent(previewRequest)) return;
  if (!previewResult?.ok) {
    reportSharedNavisionPreviewError(previewResult || {}, previewRequest);
    return;
  }
  let previewData = mergeNavisionPreflightData(navisionSharedPreviewData(previewResult) || {}, clientPreflight);
  let blockingState = navisionSharedPreviewBlockingState(previewData);
  const role = String(window.PDC_AUTH_CONTEXT?.role || '').trim().toLowerCase();
  if (!['broome','pilbara'].includes(dealerCode) && blockingState.safetyBlocking && blockingState.safetyReason === 'unproven_empty_dealer_scope' && role === 'administrator') {
    const approved = window.confirm(`Establish the first Navision baseline for ${navisionDealerName(dealerCode)}?\n\nDealer: ${dealerCode}\nRows: ${rows.length}\n\nThe server will approve only this exact snapshot for your account for two hours. It will still reject invalid rows, duplicate identities, cross-dealer matches and stale previews. No vehicle location, Parts or workshop data will change.`);
    if (approved) {
      const approvalResult = await service.approveInitialScope(rows, metadata);
      if (!approvalResult?.ok) {
        pdcNotify(`Initial dealer-scope review failed: ${approvalResult?.error || 'server unavailable'}. Nothing was imported or changed.`);
      } else {
        previewResult = await service.preview(rows, metadata);
        if (!navisionSharedPreviewRequestStillCurrent(previewRequest)) return;
        if (!previewResult?.ok) {
          reportSharedNavisionPreviewError(previewResult || {}, previewRequest);
          return;
        } else {
          previewData = mergeNavisionPreflightData(navisionSharedPreviewData(previewResult) || {}, clientPreflight);
          blockingState = navisionSharedPreviewBlockingState(previewData);
        }
      }
    }
  }
  if (previewAuthorityIdentity !== navisionSharedApplyAuthorityIdentity() || !navisionSharedImportRoleAllowed()
      || dealerCode !== ($('#navision-dealer-code')?.value || '').trim()
      || sha256Hex(text.trim()) !== sha256Hex(($('#navision-paste')?.value || '').trim())) return;
  app.pendingSharedNavisionImport = { rows, parsed, dealerCode, metadata, previewResult, previewData, clientPreflight, browserLocalSha256, sourceTextSha256: sha256Hex(text.trim()) };
  await reviewNavisionCompleteSnapshot(app.pendingSharedNavisionImport, service);
  try {
    await enrichSharedNavisionPreviewChanges(app.pendingSharedNavisionImport, service);
  } catch (error) {
    console.warn('Exact Navision field changes could not be loaded', error);
  }
  renderSharedNavisionPreview(app.pendingSharedNavisionImport);
  updateNavisionImportButton();
  } catch (error) {
    if (!previewRequest) throw error;
    reportSharedNavisionPreviewError({ code: previewDispatched ? 'preview_connection_failed' : 'preview_check_failed' }, previewRequest);
  } finally {
    setNavisionPreviewBusy(false);
  }
}

function importNavisionVehiclesLocal(text = '') {
  const options = navisionImportOptionsFromDom();
  const parsed = parseNavisionInput(text, options);
  if (!parsed.vehicles.length) {
    app.pendingNavisionImport = null;
    renderNavisionSummary({ parsed, added: [], updated: [], unchanged: [], stockNumberUpdates: [], restored: [], skipped: parsed.warnings });
    return;
  }
  const result = buildNavisionImportPlan(parsed);
  result.sourceFingerprint = navisionPayloadFingerprint(text, options);
  if (result.requiresConfirmation) {
    app.pendingNavisionImport = result;
    renderNavisionPendingReview(result);
    updateNavisionControlStats(result);
    updateNavisionImportButton();
    return;
  }
  applyNavisionImportPlan(result);
}

async function applySharedNavisionImport() {
  if (app.navisionSharedApplyInFlight === true) return;
  if (!navisionSharedImportRoleAllowed()) {
    updateNavisionImportAccessStatus(true);
    pdcNotify('Importer or administrator access is required for shared Navision imports. Nothing changed.');
    return;
  }
  const pending = app.pendingSharedNavisionImport;
  if (!pending) return;
  const authorityIdentity = navisionSharedApplyAuthorityIdentity();
  setNavisionSharedApplyBusy(true);
  try {
    await navisionWaitForBusyPaint();
    if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) {
      pdcNotify('Import authority or preview input changed before apply. Preview again; nothing was changed.');
      return;
    }
    return await applySharedNavisionImportPending(pending, authorityIdentity);
  } finally {
    setNavisionSharedApplyBusy(false);
  }
}

async function applySharedNavisionImportPending(pending, authorityIdentity = '') {
  if (pending?.route === 'broome_sales_orders') return await applyBroomeNavisionOrders(pending, authorityIdentity);
  let data = pending.previewData || {};
  let counts = data.counts || {};
  let blockingState = navisionSharedPreviewBlockingState(data);
  let service = navisionSharedBackendService();
  if (blockingState.blocking) {
    if (!service) {
      pdcNotify('The shared Navision backend is unavailable, so the blocked preview could not be rechecked. Nothing was imported or changed.');
      return;
    }
    const refreshedPreview = await service.preview(pending.rows, pending.metadata);
    if (!refreshedPreview?.ok) {
      pdcNotify(`Shared Navision safety recheck failed: ${refreshedPreview?.error || 'service unavailable'}. Nothing was imported or changed.`);
      return;
    }
    pending.previewResult = refreshedPreview;
    pending.previewData = mergeNavisionPreflightData(navisionSharedPreviewData(refreshedPreview) || {}, pending.clientPreflight || navisionClientPreflight(pending.rows, pending.dealerCode));
    data = pending.previewData;
    counts = data.counts || {};
    blockingState = navisionSharedPreviewBlockingState(data);
    renderSharedNavisionPreview(pending);
  }
  if (blockingState.blocking && navisionCompleteSnapshotReviewable(pending)) {
    await reviewNavisionCompleteSnapshot(pending, service, authorityIdentity);
    if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) return;
    data = pending.previewData; counts = data.counts || {};
    blockingState = navisionSharedPreviewBlockingState(data);
  }
  if (blockingState.blocking) {
    const { invalid, conflict, affected } = blockingState;
    const safety = data.safety || {};
    const serverDetail = blockingState.safetyBlocking
      ? `\n\nServer check: ${Number(safety.incoming_valid_count || counts.total || 0)} valid row(s), ${Number(safety.cross_dealer_matches || 0)} cross-dealer identity match(es), authority ${String(safety.authority || 'not established')}.`
      : '';
    pdcNotify(blockingState.safetyBlocking
      ? `${navisionSafetyIssueMessage(blockingState.safetyReason)}${serverDetail}\n\nNothing was imported or changed.`
      : `${affected} row${affected === 1 ? '' : 's'} need attention (${invalid} invalid, ${conflict} conflicting).\n\nClose this message to see each affected row and how to fix it. Nothing was imported or changed.`);
    return;
  }
  if (navisionBrowserAuthoritySha256() !== pending.browserLocalSha256) {
    pdcNotify('Browser-local operational data changed after preview. Preview again before applying. Nothing was applied.');
    app.pendingSharedNavisionImport = null;
    updateNavisionImportButton();
    return;
  }
  const totals = ['new', 'changed', 'unchanged', 'missing', 'invalid', 'conflict'].map(key => `${key} ${Number(counts[key] || 0)}`).join(', ');
  if (!window.confirm(`Apply this exact shared Navision preview?\n\nDealer: ${navisionDealerName(pending.dealerCode)}\n${totals}\n\nThis updates the shared Navision records. Delivered - At Dealer moves linked PMB vehicles to Completed Vehicles and cancels their active bookings. Booking history, work items, Parts and QC results are preserved.`)) return;
  service = navisionSharedBackendService();
  if (!service || !navisionSharedPendingStillCurrent(pending, authorityIdentity)) {
    pdcNotify('Import authority, service, or preview input changed before dispatch. Preview again; nothing was changed.');
    return;
  }
  const idempotencyKey = `normal-upload:${pending.dealerCode}:${data.source_hash || sha256Hex(JSON.stringify(pending.rows))}`.slice(0, 200);
  const applyOptions = { ...pending.metadata, confirmed: true, idempotencyKey };
  let applyResult;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) return;
    try {
      applyResult = await service.apply(pending.rows, pending.previewResult, applyOptions);
    } catch {
      // A lost response can follow a commit. Keep the same preview/key for a safe replay.
      applyResult = { ok: false, code: 'transport_unconfirmed' };
    }
    const code = String(applyResult?.code || applyResult?.error || '').toLowerCase();
    if (applyResult?.ok || !['55p03', '40p01', '40001'].includes(code) || attempt === 2) break;
    // These database errors roll back the transaction; only retry the exact request.
    await new Promise(resolve => setTimeout(resolve, (attempt + 1) * 1000));
  }
  if (!navisionSharedPendingStillCurrent(pending, authorityIdentity)) return;
  if (!applyResult?.ok) {
    pdcNotify(sharedNavisionApplyErrorMessage(applyResult));
    return;
  }
  const afterSha256 = navisionBrowserAuthoritySha256();
  if (afterSha256 !== pending.browserLocalSha256) throw new Error('Shared Navision apply unexpectedly changed browser-local authority.');
  app.pendingSharedNavisionImport = null;
  renderSharedNavisionPreview({ ...pending, applyResult, browserLocalSha256: afterSha256 }, true);
  updateNavisionControlStats({ parsed: pending.parsed, added: [], updated: [], unchanged: pending.parsed.vehicles, stockNumberUpdates: [] });
  updateNavisionImportButton();
  loadSharedNavisionVisibleRows({ force: true });
}

function selectedPendingNavisionUpdateKeys(result) {
  const checked = $$('[data-navision-apply-update]')
    .filter(input => input.checked)
    .map(input => input.dataset.navisionApplyUpdate)
    .filter(Boolean);
  if (!checked.length) return new Set();
  return new Set(checked);
}

function applyPendingNavisionImport(mode = 'all') {
  const pending = app.pendingNavisionImport;
  if (!pending) return;
  const selectedKeys = mode === 'selected' ? selectedPendingNavisionUpdateKeys(pending) : null;
  if (mode === 'selected' && (!selectedKeys || !selectedKeys.size)) {
    pdcNotify('Select at least one existing vehicle update, or use Apply all Navision updates.');
    return;
  }
  applyNavisionImportPlan(pending, selectedKeys);
}

function cancelPendingNavisionImport() {
  app.pendingNavisionImport = null;
  renderNavisionSummary({ parsed: { vehicles: [], warnings: [] }, added: [], updated: [], unchanged: [], stockNumberUpdates: [], restored: [], skipped: ['Navision import cancelled. No tracker data was changed.'] });
  updateNavisionImportButton();
}

function navisionRemovalAuditEntry(vehicle, action, details, at, index) {
  return {
    id: `${Date.parse(at) || Date.now()}-nav-${String(index).padStart(4, '0')}-${sha256Hex(vehicleKey(vehicle) || JSON.stringify(vehicle)).slice(0, 8)}`,
    at,
    by: details.by || getCurrentOperatorName(),
    role: details.role || getCurrentOperatorRole(),
    action,
    vehicleKey: vehicleKey(vehicle),
    stock: displayStockNumber(vehicle) || vehicle.stock || '',

    customer: vehicle.client || vehicle.toyotaCustomer || '',
    vehicle: displayVehicle(vehicle) || '',
    details,
  };
}

function buildNavisionImportCommit(plan, selectedUpdateKeys = null, appliedAt = nowIsoString()) {
  const parsed = plan.parsed;
  let added = loadAddedVehicles().map(vehicle => ({ ...vehicle }));
  const edits = JSON.parse(JSON.stringify(loadVehicleEdits()));
  let deletedRecords = deletedVehicleRecords().map(record => JSON.parse(JSON.stringify(record)));
  const poTasks = JSON.parse(JSON.stringify(loadPoTasks()));
  const poFiles = JSON.parse(JSON.stringify(loadPoFiles()));
  const auditLog = JSON.parse(JSON.stringify(loadAuditLog()));
  const activeBeforeImport = app.data.slice();
  const removeMissingChecked = Boolean(plan.removeMissingChecked);
  const result = { ...plan, added: [], updated: [], unchanged: [], stockNumberUpdates: [], restored: [], missingFromUpload: [], removedMissing: [], confirmed: true, appliedAt };

  parsed.vehicles.forEach(incoming => {
    const deletedRecord = deletedRecordForNavision(deletedRecords, incoming);
    if (deletedRecord && !navisionCanRestoreDeletedRecord(deletedRecord)) return;
    if (deletedRecord) {
      deletedRecords = deletedRecords.filter(record => record !== deletedRecord);
      result.restored.push(incoming);
    }
    const existing = findVehicleForNavision(incoming);
    const keys = navisionMatchKeys(incoming).concat(navisionMatchKeys(existing));
    if (existing) {
      const existingKey = vehicleKey(existing) || vehicleKey(incoming);
      const incomingHasStock = incoming.stock && !isBlankStock(incoming.stock);
      const existingHadNoStock = isBlankStock(existing.stock);
      const stockChanged = incomingHasStock && existingHadNoStock;
      const payload = navisionEditPayload(incoming, existing);
      const changes = navisionFieldChanges(existing, payload);
      const row = { incoming, existing: { ...existing }, stockChanged, payload, changes, key: existingKey };
      if (selectedUpdateKeys && !selectedUpdateKeys.has(existingKey)) {
        result.unchanged.push({ ...row, skippedByUser: true });
        return;
      }
      if (stockChanged) result.stockNumberUpdates.push(row);
      const addedIndex = findAddedVehicleIndex(added, incoming, existing);
      if (addedIndex >= 0) added[addedIndex] = { ...added[addedIndex], ...payload, id: added[addedIndex].id || payload.id };
      const editKeys = new Set(keys.concat([vehicleKey(existing), vehicleKey(incoming)]).filter(Boolean));
      editKeys.forEach(key => { edits[key] = { ...(edits[key] || {}), ...payload }; });
      if (changes.length || stockChanged) result.updated.push(row);
      else result.unchanged.push(row);
    } else {
      added.unshift(incoming);
      result.added.push(incoming);
    }
  });

  const missingFromUpload = vehiclesMissingFromNavisionImport(activeBeforeImport, parsed.vehicles, { fullRefresh: plan.fullRefresh !== false });
  result.missingFromUpload = missingFromUpload;
  let removalKeysChanged = false;
  if (removeMissingChecked && missingFromUpload.length) {
    removalKeysChanged = true;
    const existingRecordsByKey = new Map();
    deletedRecords.forEach(record => {
      [record.key].concat(record.keys || []).filter(Boolean).forEach(key => existingRecordsByKey.set(String(key), record));
    });
    const exactRemovalKeys = new Set();
    const operator = getCurrentOperatorName();
    const role = getCurrentOperatorRole();
    const reason = 'No longer present in the latest full Navision upload';
    missingFromUpload.forEach((vehicle, index) => {
      const exactKeys = [vehicleDeleteKey(vehicle), vehicleKey(vehicle), vehicle.stock, vehicle.batch, vehicle.id]
        .map(value => String(value || '').trim()).filter(Boolean);
      const vin = normalizeVin(vehicle.vin || vehicle.fullVin || vehicle.frameVin || vehicle.autocareVin || '');
      const allDeleteKeys = [...new Set(exactKeys.concat(vin ? [vin] : []))];
      const key = exactKeys[0] || vin;
      exactKeys.forEach(value => exactRemovalKeys.add(value));
      allDeleteKeys.forEach(value => {
        delete edits[value];
        delete poTasks[value];
        delete poFiles[value];
      });
      if (key && !allDeleteKeys.some(value => existingRecordsByKey.has(value))) {
        const record = {
          key,
          keys: allDeleteKeys,
          deletedAt: appliedAt,
          deletedBy: operator || 'Unknown operator',
          deletedRole: role || 'Unassigned role',
          reason,
          deletionType: 'navision-missing',
          vehicle: JSON.parse(JSON.stringify(vehicle)),
        };
        deletedRecords.unshift(record);
        allDeleteKeys.forEach(value => existingRecordsByKey.set(value, record));
        auditLog.unshift(navisionRemovalAuditEntry(vehicle, 'Retired from Navision back end', {
          by: operator || 'Unknown operator', role: role || 'Unassigned role', reason,
        }, appliedAt, index));
      }
    });
    added = added.filter(vehicle => {
      const keys = [vehicleDeleteKey(vehicle), vehicleKey(vehicle), vehicle.stock, vehicle.batch, vehicle.id]
        .map(value => String(value || '').trim()).filter(Boolean);
      return !keys.some(key => exactRemovalKeys.has(key));
    });
    result.removedMissing = missingFromUpload.slice();
    result.missingFromUpload = [];
  }

  const workFileRows = parsed.vehicles.filter(vehicle => vehicle.pdcImportMode === 'work-file');
  const healthUpdates = workFileRows.length ? {
    lastWorkImportAt: appliedAt,
    lastWorkImportType: 'Job card / work file',
    lastWorkImportRows: workFileRows.length,
  } : {
    lastNavisionImportAt: appliedAt,
    lastNavisionRows: parsed.vehicles.length,
    lastNavisionAdded: result.added.length,
    lastNavisionUpdated: result.updated.length,
    lastNavisionWarnings: (result.skipped || parsed.warnings || []).length,
  };
  const finalValues = new Map([
    [ADDED_KEY, JSON.stringify(added)],
    [EDITS_KEY, JSON.stringify(edits)],
    [DELETED_KEY, JSON.stringify(deletedRecords)],
    [NAVISION_IMPORT_RESULTS_KEY, JSON.stringify(boundedNavisionImportSummary(result))],
    [OPERATIONAL_HEALTH_KEY, JSON.stringify({ ...loadOperationalHealth(), ...healthUpdates })],
  ]);
  if (removalKeysChanged) {
    finalValues.set(PO_TASKS_KEY, JSON.stringify(poTasks));
    finalValues.set(PO_FILES_KEY, JSON.stringify(poFiles));
    finalValues.set(AUDIT_LOG_KEY, JSON.stringify(auditLog.slice(0, 1500)));
  }
  return { result, finalValues, workFileRows };
}

function projectNavisionImportPeakStorage(plan, selectedUpdateKeys = null) {
  const commit = buildNavisionImportCommit(plan, selectedUpdateKeys);
  const transaction = prepareStorageTransaction('Navision import', [...commit.finalValues.keys()], commit.result.appliedAt);
  const current = currentLocalStorageValues();
  const currentBytes = [...current.entries()].reduce((total, [key, value]) => total + localStorageQuotaBytes(key, value), 0);
  const existingJournal = current.get(STORAGE_TRANSACTION_JOURNAL_KEY);
  const existingJournalBytes = existingJournal === undefined ? 0 : localStorageQuotaBytes(STORAGE_TRANSACTION_JOURNAL_KEY, existingJournal);
  const journalBytes = localStorageQuotaBytes(STORAGE_TRANSACTION_JOURNAL_KEY, transaction.serializedJournal);
  let runningBytes = currentBytes - existingJournalBytes + journalBytes;
  let projectedPeakBytes = Math.max(currentBytes, runningBytes);
  const writeOrder = [...commit.finalValues.entries()].map(([key, value], index) => {
    const previous = current.get(key);
    const oldBytes = previous === undefined ? 0 : localStorageQuotaBytes(key, previous);
    const newBytes = localStorageQuotaBytes(key, value);
    return { key, value, index, deltaBytes: newBytes - oldBytes, oldBytes, newBytes };
  }).sort((a, b) => a.deltaBytes - b.deltaBytes || a.index - b.index);
  writeOrder.forEach(write => {
    runningBytes += write.deltaBytes;
    projectedPeakBytes = Math.max(projectedPeakBytes, runningBytes);
  });
  const summaryValue = commit.finalValues.get(NAVISION_IMPORT_RESULTS_KEY) || '';
  return {
    allowed: projectedPeakBytes <= NAVISION_LOCAL_STORAGE_SAFE_BUDGET_BYTES,
    budgetBytes: NAVISION_LOCAL_STORAGE_SAFE_BUDGET_BYTES,
    projectedPeakBytes,
    currentBytes,
    journalBytes,
    finalBytes: runningBytes - journalBytes,
    summaryBytes: localStorageQuotaBytes(NAVISION_IMPORT_RESULTS_KEY, summaryValue),
    writeOrder,
    commit,
    transaction,
  };
}

function renderNavisionQuotaRejection(projection) {
  const host = $('#navision-status-list');
  if (host) {
    host.innerHTML = `<div class="summary-row error"><strong>${NAVISION_IMPORT_TOO_LARGE_MESSAGE}</strong><span>The projected peak is ${projection.projectedPeakBytes.toLocaleString('en-AU')} bytes, above the ${projection.budgetBytes.toLocaleString('en-AU')}-byte safety limit. The existing local Navision dataset was not changed. Select a different file or export the current dataset.</span></div>`;
  }
  const button = $('#import-navision');
  if (button) button.disabled = true;
}

function finalizeNavisionImportCommit(commit) {
  const { result, workFileRows } = commit;
  app.quickFilter = 'incoming';
  app.pmbSubFilter = '';
  app.columnFilters = { sales: '', production: '', status: '', jita: '' };
  const searchInput = $('#search');
  if (searchInput) searchInput.value = '';
  app.data = buildVehicleData();
  app.selectedRows.clear();
  app.pendingNavisionImport = null;
  app.rejectedNavisionFingerprint = '';
  app.rejectedNavisionProjection = null;
  populateFilters();
  app.navisionImport = result;
  renderOperationalHealthSummary();
  renderAll();
  updateNavisionSidebarMeta();
  renderNavisionSummary(result);
  updateNavisionControlStats(result);
  updateNavisionImportButton();
  const workFileKeys = workFileRows.map(vehicle => vehicleKey(findVehicleForNavision(vehicle) || vehicle));
  if (workFileKeys.length) focusVehiclesAfterWorkImport(workFileKeys);
}

function applyNavisionImportPlan(plan, selectedUpdateKeys = null) {
  const fingerprint = plan?.sourceFingerprint || sha256Hex(JSON.stringify(plan?.parsed?.vehicles || []));
  if (app.rejectedNavisionFingerprint && app.rejectedNavisionFingerprint === fingerprint) {
    renderNavisionQuotaRejection(app.rejectedNavisionProjection || { projectedPeakBytes: 0, budgetBytes: NAVISION_LOCAL_STORAGE_SAFE_BUDGET_BYTES });
    pdcNotify(NAVISION_IMPORT_TOO_LARGE_MESSAGE);
    return null;
  }
  const projection = projectNavisionImportPeakStorage(plan, selectedUpdateKeys);
  if (!projection.allowed) {
    app.rejectedNavisionFingerprint = fingerprint;
    app.rejectedNavisionProjection = projection;
    app.pendingNavisionImport = plan;
    renderNavisionQuotaRejection(projection);
    pdcNotify(NAVISION_IMPORT_TOO_LARGE_MESSAGE);
    return null;
  }
  try {
    runStorageTransaction('Navision import', projection.transaction.touchedKeys, () => {
      projection.writeOrder.forEach(write => localStorage.setItem(write.key, write.value));
    }, projection.transaction);
  } catch (error) {
    app.data = buildVehicleData();
    app.pendingNavisionImport = plan;
    renderAll();
    pdcNotify(error.message || String(error));
    return null;
  }
  finalizeNavisionImportCommit(projection.commit);
  return projection.commit.result;
}


function renderNavisionChangeRows(rows = []) {
  if (!rows.length) return `<div class="summary-row"><strong>None</strong><span>No existing vehicles need Navision changes applied.</span></div>`;
  return rows.slice(0, 80).map((row, index) => {
    const key = row.key || vehicleKey(row.existing) || vehicleKey(row.incoming) || `update-${index}`;
    const changes = (row.changes || []).slice(0, 8).map(change => `
      <tr>
        <td>${escapeHtml(change.label)}</td>
        <td>${escapeHtml(change.before || 'Blank')}</td>
        <td>${escapeHtml(change.after || 'Blank')}</td>
      </tr>`).join('');
    return `<div class="summary-row navision-review-row">
      <label class="navision-review-select">
        <input type="checkbox" data-navision-apply-update="${escapeHtml(key)}" checked />
        <span>${vehicleIdentityStackHtml(row.incoming || row.existing)}${navisionVehicleSummary(row.incoming)}</span>
      </label>
      <table class="navision-change-table">
        <thead><tr><th>Field</th><th>Current CRM</th><th>New Navision</th></tr></thead>
        <tbody>${changes || '<tr><td>Stock / Batch</td><td>Order-only vehicle</td><td>New stock number received</td></tr>'}</tbody>
      </table>
    </div>`;
  }).join('') + (rows.length > 80 ? `<div class="subtle">Showing first 80 of ${rows.length} existing vehicle update${rows.length === 1 ? '' : 's'}.</div>` : '');
}

function renderNavisionPendingReview(result) {
  const host = $('#navision-status-list');
  if (!host) return;
  const warnings = (result?.skipped || result?.parsed?.warnings || []).filter(Boolean);
  const warningList = warnings.length
    ? `<div class="summary-section"><h3>Warnings / skipped rows</h3>${warnings.slice(0, 8).map(warning => `<div class="summary-row error"><strong>Review</strong><span>${escapeHtml(warning)}</span></div>`).join('')}</div>`
    : '';

  host.innerHTML = `
    <div class="navision-confirm-banner">
      <div>
        <strong>Review Navision changes before applying</strong>
        <span>Nothing has been written to the tracker yet. Manual team notes and PO uploads are protected. Spreadsheet columns named ${PDC_IMPORT_CONTROL_COLUMNS_TEXT}, PMB Bucket, PDC Location or Blocked can deliberately update those PDC controls.</span>
      </div>
      <div class="navision-confirm-actions">
        <button class="primary" id="navision-apply-all" type="button">Apply all Navision updates</button>
        <button class="small-button" id="navision-apply-selected" type="button">Apply selected updates only</button>
        <button class="small-button danger-button" id="navision-cancel-import" type="button">Cancel import</button>
      </div>
    </div>
    <div class="scot-summary-grid">
      <div class="summary-stat"><span>Rows detected</span><strong>${result.parsed.vehicles.length}</strong></div>
      <div class="summary-stat"><span>New vehicles pending</span><strong>${result.added.length}</strong></div>
      <div class="summary-stat"><span>Existing changes</span><strong>${result.updated.length}</strong></div>
      <div class="summary-stat"><span>Unchanged existing</span><strong>${result.unchanged.length}</strong></div>
      <div class="summary-stat"><span>Back end to retire</span><strong>${result.missingFromUpload.length}</strong></div>
      <div class="summary-stat"><span>Warnings</span><strong>${warnings.length}</strong></div>
    </div>
    <div class="summary-section">
      <div class="summary-section-heading"><h3>Existing vehicle changes needing confirmation</h3><label class="small-toggle"><input id="navision-toggle-all-updates" type="checkbox" checked /> Select all</label></div>
      ${renderNavisionChangeRows(result.updated || [])}
    </div>
    <div class="summary-section">
      <h3>New vehicles that will be added after confirmation</h3>
      ${renderNavisionRows(result.added || [], 'navision-new', 'No new vehicles will be added.')}
    </div>
    <div class="summary-section">
      <h3>Navision-only back-end vehicles not found</h3>
      ${renderNavisionRows(result.missingFromUpload || [], 'navision-missing', 'No eligible back-end vehicle needs retiring.')}
      <div class="subtle">Only unpromoted Navision-only back-end rows are eligible. Manual, PO, PD check-form and PDC Sheet vehicles stay protected when absent from Navision.</div>
    </div>
    ${warningList}
    <div class="subtle">Navision can update stock/order/VIN, P/Month, Toyota Status, ETA, JITA, Tray, Dealer Comments/Navision Notes and related location fields. Excel update sheets can also update explicit PDC control columns such as TINT, HOIST, FITTING, FABRICATION, ELECTRICAL, TYRE, PIT INSPECTION, PARTS, PMB Bucket, PDC Location and Blocked.</div>
  `;
  on($('#navision-apply-all'), 'click', () => applyPendingNavisionImport('all'));
  on($('#navision-apply-selected'), 'click', () => applyPendingNavisionImport('selected'));
  on($('#navision-cancel-import'), 'click', cancelPendingNavisionImport);
  $('#navision-toggle-all-updates')?.addEventListener('change', event => {
    $$('[data-navision-apply-update]', host).forEach(input => { input.checked = event.currentTarget.checked; });
  });
}

function navisionVehicleSummary(vehicle = {}) {
  return `${vehicleIdentityTitle(vehicle) || displayStockNumber(vehicle) || 'Vehicle'} · ${escapeHtml(displayVehicle(vehicle) || vehicle.vehicle || vehicle.toyotaVehicle || 'Vehicle')}`;
}

function renderNavisionRows(rows, cssClass, emptyText) {
  if (!rows.length) return `<div class="summary-row"><strong>None</strong><span>${escapeHtml(emptyText)}</span></div>`;
  return rows.slice(0, 12).map(row => {
    const vehicle = row.incoming || row;
    return `<div class="summary-row ${cssClass}">${vehicleIdentityStackHtml(vehicle)}<span>${navisionVehicleSummary(vehicle)}${vehicle.toyotaStatus ? ` · ${escapeHtml(vehicle.toyotaStatus)}` : ''}</span></div>`;
  }).join('') + (rows.length > 12 ? `<div class="subtle">Showing first 12 of ${rows.length}.</div>` : '');
}

function renderNavisionSummary(result) {
  const host = $('#navision-status-list');
  if (!host) return;
  const parsed = result?.parsed || { vehicles: [], warnings: [] };
  const counts = result?.counts || {};
  const parsedVehicleCount = parsed.vehicleCount ?? parsed.vehicles?.length ?? counts.rows ?? 0;
  const warnings = (result?.skipped || parsed.warnings || []).filter(Boolean);
  const stockUpdates = result?.stockNumberUpdates || [];
  const missingFromUpload = result?.missingFromUpload || [];
  const removedMissing = result?.removedMissing || [];
  const warningList = warnings.length
    ? `<div class="summary-section"><h3>Warnings / skipped rows</h3>${warnings.slice(0, 12).map(warning => `<div class="summary-row error"><strong>Review</strong><span>${escapeHtml(warning)}</span></div>`).join('')}${warnings.length > 12 ? `<div class="subtle">Showing first 12 of ${warnings.length} warnings.</div>` : ''}</div>`
    : '';
  const stockUpdateList = stockUpdates.length
    ? `<div class="summary-section"><h3>Vehicles receiving a new stock number</h3>${stockUpdates.slice(0, 12).map(row => `<div class="summary-row important"><strong>${escapeHtml(row.incoming.stock)}</strong><span>${escapeHtml(row.incoming.client || row.existing.client || '')}</span></div>`).join('')}${stockUpdates.length > 12 ? `<div class="subtle">Showing first 12 of ${stockUpdates.length}.</div>` : ''}</div>`
    : '';
  const missingList = missingFromUpload.length
    ? `<div class="summary-section"><div class="summary-section-heading"><h3>Navision-only back-end vehicles not found</h3><button class="small-button danger-button" id="navision-remove-missing-now" type="button">Retire from back end</button></div>${renderNavisionRows(missingFromUpload, 'navision-missing', 'Every Navision-only back-end vehicle was found in this upload.')}<div class="subtle">Manual, PO, PD check-form and PDC Sheet vehicles are protected even when they are absent from Navision.</div></div>`
    : `<div class="summary-section"><h3>Navision-only back-end vehicles not found</h3><div class="summary-row"><strong>None</strong><span>No eligible back-end vehicle needs retiring.</span></div></div>`;
  const removedList = removedMissing.length
    ? `<div class="summary-section"><h3>Retired from the Navision back end</h3>${renderNavisionRows(removedMissing, 'navision-removed', 'No Navision-only back-end vehicles were retired during this import.')}</div>`
    : '';

  host.innerHTML = `
    <div class="scot-summary-grid">
      <div class="summary-stat"><span>Rows detected</span><strong>${parsedVehicleCount}</strong></div>
      <div class="summary-stat"><span>Back end added</span><strong>${result?.added?.length ?? counts.added ?? 0}</strong></div>
      <div class="summary-stat"><span>Updated</span><strong>${result?.updated?.length ?? counts.updated ?? 0}</strong></div>
      <div class="summary-stat"><span>New stock #</span><strong>${stockUpdates.length || counts.stockNumberUpdates || 0}</strong></div>
      <div class="summary-stat"><span>Not in upload</span><strong>${missingFromUpload.length || counts.missingFromUpload || 0}</strong></div>
      <div class="summary-stat"><span>Removed</span><strong>${removedMissing.length || counts.removedMissing || 0}</strong></div>
      <div class="summary-stat"><span>Restored</span><strong>${result?.restored?.length ?? counts.restored ?? 0}</strong></div>
      <div class="summary-stat"><span>Warnings</span><strong>${warnings.length}</strong></div>
    </div>
    <div class="summary-section-heading"><h3>Import complete</h3><button class="small-button" id="navision-view-backend" type="button">View Back End Data</button></div>
    <div class="subtle">${app.data.length} active back-end records · ${pdcSheetVehicles().length} vehicles currently visible on the PDC Sheet.</div>
    <div class="summary-section">
      <h3>New vehicles stored in Back End Data</h3>
      ${renderNavisionRows(result?.added || [], 'navision-new', 'No new vehicles were added.')}
    </div>
    <div class="summary-section">
      <h3>Existing vehicles updated</h3>
      ${renderNavisionRows(result?.updated || [], 'navision-updated', 'No existing vehicles were updated.')}
    </div>
    ${stockUpdateList}
    ${missingList}
    ${removedList}
    ${warningList}
    <div class="subtle">Toyota Status is taken only from Navision Sub Location Description. Normal Navision uploads refresh source data but do not promote new vehicles to the PDC Sheet. Rows marked as Cut But Vehicle are highlighted light blue.</div>
  `;
  on($('#navision-remove-missing-now'), 'click', removeMissingFromLastNavisionImport);
  on($('#navision-view-backend'), 'click', () => showView('backend'));
}

function removeMissingFromLastNavisionImport() {
  const result = app.navisionImport || loadJson(NAVISION_IMPORT_RESULTS_KEY, null);
  const missingCount = Number(result?.missingCount ?? result?.missingFromUpload?.length ?? 0);
  if (!missingCount) return;
  pdcNotify(`For storage safety, no records were changed. Re-select the same Navision source file, choose the reviewed “Retire missing” option in the import confirmation, and apply it through the exact quota preflight (${missingCount} currently missing).`);
}

function handlePdfSelect(e) {
  const file = e.target.files[0];
  if (!file) return;
  $('#scan-report').disabled = false;
  $('#scan-card .scan-line:nth-child(1) strong').textContent = file.name.includes('SCOT') ? 'Toyota Navision report detected' : 'PDF selected';
  $('#scan-card .scan-line:nth-child(2) strong').textContent = `${app.data.length} rows in sample parser`;
  $('#scan-card .scan-line:nth-child(3) strong').textContent = `${Object.keys(app.matches).length} matched to current tracker`;
  $('#progress-bar').style.width = '14%';
  renderScotSummary(false);
}


function scanReport() {
  let width = 14;
  $('#scan-report').disabled = true;
  const timer = setInterval(() => {
    width += 18;
    $('#progress-bar').style.width = `${Math.min(width, 100)}%`;
    if (width >= 100) {
      clearInterval(timer);
      app.reviewed = true;
      renderReviewTable(true);
      renderScotSummary(true);
      $('#approve-all').disabled = false;
    }
  }, 220);
}

function buildReviewRows() {
  return app.data
    .map(v => ({ vehicle: v, match: getToyotaMatch(v) }))
    .filter(row => row.match)
    .map(({ vehicle: v, match: m }) => {
      const changed = [];
      if ((canonicalToyotaStatus(v.toyotaStatus) || '') !== (canonicalToyotaStatus(m.toyotaStatus) || '')) changed.push(['Toyota Status', canonicalToyotaStatus(v.toyotaStatus) || 'Blank', canonicalToyotaStatus(m.toyotaStatus) || 'Blank']);
      if (scotEtaOnly(v.etaAtDealer) !== scotEtaOnly(m.etaAtDealer)) changed.push(['ETA At Dealer', scotEtaOnly(v.etaAtDealer) || 'Blank', scotEtaOnly(m.etaAtDealer) || 'Blank']);
      if ((v.contact || '') !== (m.contact || '')) changed.push(['Contact', v.contact || 'Blank', m.contact || 'Blank']);

      const temp = { ...v, ...m, toyotaStatus: m.toyotaStatus };
      const ok = isCustomerMatch(temp);
      return { vehicle: v, match: m, changed, ok };
    });
}

function renderReviewTable(scanned = false) {
  const table = $('#review-table');
  if (!table) return;
  if (!scanned) {
    table.innerHTML = `<tbody><tr><td><div class="empty-state"><strong>Upload and scan the Toyota PDF</strong><span>The proposed update list will appear here.</span></div></td></tr></tbody>`;
    return;
  }
  const rows = buildReviewRows();
  table.innerHTML = `
    <thead><tr><th>Stock #</th><th>Current tracker</th><th>Toyota PDF</th><th>Proposed changes</th><th>Review</th></tr></thead>
    <tbody>${rows.map(r => `
      <tr>
        <td>${vehicleIdentityStackHtml(r.vehicle, { button: true })}${stockOrderSubline(r.vehicle)}</td>
        <td><div class="review-block"><strong>${escapeHtml(vehicleCustomerName(r.vehicle) || 'Customer TBA')}</strong><span class="subtle">${escapeHtml(displayVehicle(r.vehicle))}</span>${scotEtaOnly(r.vehicle.etaAtDealer) ? `<span class="subtle">ETA ${escapeHtml(scotEtaOnly(r.vehicle.etaAtDealer))}</span>` : ''}</div></td>
        <td><div class="review-block"><strong>${escapeHtml(r.match.toyotaCustomer || '')}</strong><span class="subtle">${escapeHtml(displayVehicle(r.match))}</span><span>${formatStatus(r.match)}</span></div></td>
        <td>${r.changed.map(([field, oldVal, newVal]) => `<div><strong>${escapeHtml(field)}</strong><div class="subtle">${escapeHtml(oldVal)} -> ${escapeHtml(newVal)}</div></div>`).join('') || '<span class="subtle">No changes</span>'}</td>
        <td>${r.ok ? '<span class="review-ok">Clean match</span>' : '<span class="review-warning">Needs manual review</span>'}</td>
      </tr>`).join('')}</tbody>
  `;
  $$('[data-open-stock]', table).forEach(btn => btn.addEventListener('click', () => { void openVehicleFromStockClick(btn.dataset.openStock, btn); }));
}

function approveCleanMatches() {
  const rows = buildReviewRows().filter(r => r.ok);
  const edits = loadVehicleEdits();
  rows.forEach(({ vehicle, match }) => {
    Object.assign(vehicle, match);
    const key = vehicleKey(vehicle);
    edits[key] = {
      ...(edits[key] || {}),
      toyotaStatus: isAutocareDespatched(vehicle) ? AUTOCARE_DESPATCH_STATUS : (match.toyotaStatus || ''),
      contact: match.contact || vehicle.contact || '',
    };
  });
  saveJson(EDITS_KEY, edits);
  app.data = buildVehicleData();
  app.reviewed = false;
  $('#approve-all').disabled = true;
  renderAll();
  showView('dashboard');
}


function clearDashboard() {
  const count = app.data.length;
  const message = count
    ? `Clear the dashboard and remove ${count} vehicle${count === 1 ? '' : 's'} from this browser?\n\nThis gives you a clean Navision-only starting point before the next upload.`
    : 'Dashboard is already clear. Reset saved import state anyway?';
  if (!window.confirm(message)) return;
  try {
    runStorageTransaction('Dashboard clear', crmManagedStorageKeys(), () => {
      [EDITS_KEY, ADDED_KEY, PO_TASKS_KEY, PO_FILES_KEY, DELETED_KEY, AUTOCARE_RESULTS_KEY, NAVISION_IMPORT_RESULTS_KEY].forEach(key => localStorage.removeItem(key));
      for (let index = localStorage.length - 1; index >= 0; index -= 1) {
        const key = localStorage.key(index);
        if (key && key.startsWith('vehicleTrackingCoreNotes:')) localStorage.removeItem(key);
      }
    });
  } catch (error) {
    app.data = buildVehicleData();
    pdcNotify(error.message || String(error));
    return;
  }
  app.selectedRows.clear();
  app.autocareFiles = [];
  app.autocareScan = null;
  app.navisionImport = null;
  app.navisionFileName = '';
  const navisionPaste = $('#navision-paste');
  const navisionUpload = $('#navision-upload');
  const autocarePaste = $('#autocare-paste');
  const autocareUpload = $('#autocare-upload');
  if (navisionPaste) navisionPaste.value = '';
  if (navisionUpload) navisionUpload.value = '';
  if (autocarePaste) autocarePaste.value = '';
  if (autocareUpload) autocareUpload.value = '';
  app.data = buildVehicleData();
  app.quickFilter = 'incoming';
  app.pmbSubFilter = '';
  app.sort = { key: '', dir: 'asc' };
  populateFilters();
  renderAll();
}


function crmManagedStorageKeys() {
  const keys = new Set(CRM_BACKUP_STORAGE_KEYS);
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!key) continue;
    if (key.startsWith('vehicleTrackingCoreNotes:') || key.startsWith('vehicleTrackingCoreColumnWidths:') || key === VEHICLE_TABLE_COLUMN_ORDER_KEY) keys.add(key);
    if (key.startsWith('vehicleTrackingCoreNavisionOnly')) keys.add(key);
  }
  return [...keys];
}

function crmDefaultStorageValues() {
  return {
    [EDITS_KEY]: '{}',
    [ADDED_KEY]: '[]',
    [PO_TASKS_KEY]: '{}',
    [PO_FILES_KEY]: '{}',
    [DELETED_KEY]: '[]',
    [AUTOCARE_RESULTS_KEY]: 'null',
    [NAVISION_IMPORT_RESULTS_KEY]: 'null',
  };
}

function crmStorageSnapshot() {
  const storage = { ...crmDefaultStorageValues() };
  crmManagedStorageKeys().forEach(key => {
    const value = localStorage.getItem(key);
    if (value !== null) storage[key] = value;
  });
  return storage;
}

function crmBackupStats(backup) {
  const storage = backup?.storage || {};
  let noteCount = 0;
  Object.entries(storage).forEach(([key, value]) => {
    if (!key.startsWith('vehicleTrackingCoreNotes:')) return;
    try {
      const notes = JSON.parse(value || '[]');
      if (Array.isArray(notes)) noteCount += notes.length;
    } catch {}
  });
  return {
    vehicles: Array.isArray(backup?.vehicles) ? backup.vehicles.length : app.data.length,
    addedVehicles: loadJsonFromString(storage[ADDED_KEY], []).length,
    editRows: Object.keys(loadJsonFromString(storage[EDITS_KEY], {})).length,
    deletedVehicles: loadJsonFromString(storage[DELETED_KEY], []).length,
    poRows: Object.keys(loadJsonFromString(storage[PO_TASKS_KEY], {})).length + Object.keys(loadJsonFromString(storage[PO_FILES_KEY], {})).length,
    notes: noteCount,
    storageKeys: Object.keys(storage).length,
  };
}

function loadJsonFromString(value, fallback) {
  if (typeof value !== 'string') return fallback;
  try { return JSON.parse(value); }
  catch { return fallback; }
}

function buildCrmBackup() {
  const storage = crmStorageSnapshot();
  const backup = {
    type: CRM_BACKUP_TYPE,
    version: CRM_BACKUP_VERSION,
    appTitle: 'Vehicle Tracking Core',
    exportedAt: new Date().toISOString(),
    storage,
    vehicles: app.data,
    instructions: vehicleLifecycleSharedModeActive()
      ? 'Browser snapshot for reference only. This file cannot restore the shared database, accounts, bookings or photo storage. Shared recovery requires the database and storage backups.'
      : 'Restore this JSON from Backup / Restore in browser-local mode. CSV exports are for reporting only and are not a complete backup.'
  };
  backup.summary = crmBackupStats(backup);
  return backup;
}

function safeBackupFileDate() {
  const d = new Date();
  const pad = value => String(value).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

function exportLocalNavisionDataset() {
  const storedValue = localStorage.getItem(ADDED_KEY);
  const sourceValue = storedValue === null ? '[]' : storedValue;
  let records = null;
  try {
    const parsed = JSON.parse(sourceValue);
    if (Array.isArray(parsed)) records = parsed.length;
  } catch {}
  const exportedAt = new Date().toISOString();
  const evidence = {
    sourceKey: ADDED_KEY,
    exportedAt,
    records,
    datasetSha256: sha256Hex(sourceValue),
    exactStoredBytes: storedValue !== null,
  };
  const blob = new Blob([sourceValue], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `pdc-browser-local-navision-${exportedAt.slice(0, 10)}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return evidence;
}

function exportCrmBackup() {
  const backup = buildCrmBackup();
  const blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `vehicle-tracking-core-backup-${safeBackupFileDate()}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  updateOperationalHealth({ lastBackupAt: backup.exportedAt });
  renderBackupStatus({ type: 'exported', backup });
}

function configureCrmBackupAuthorityUi() {
  if (!vehicleLifecycleSharedModeActive()) return;
  const upload = $('#backup-upload');
  if (upload) upload.disabled = true;
  const dropZone = $('.backup-drop-zone');
  if (dropZone) {
    dropZone.classList.add('is-disabled');
    const heading = dropZone.querySelector('strong');
    const detail = dropZone.querySelector('span:last-child');
    if (heading) heading.textContent = 'Restore unavailable in shared mode';
    if (detail) detail.textContent = 'Operational vehicles are authoritative in Supabase. Browser backup files cannot replace shared tracker state.';
  }
}

function handleCrmBackupFileSelect(event) {
  if (vehicleLifecycleSharedModeActive()) {
    if (event?.target) event.target.value = '';
    renderBackupStatus({
      type: 'error',
      message: 'Browser backup restore is unavailable in shared mode. Operational vehicles remain authoritative in Supabase.',
    });
    return false;
  }
  const file = event.target.files?.[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = () => restoreCrmBackup(String(reader.result || ''), file.name);
  reader.onerror = () => renderBackupStatus({ type: 'error', message: `Could not read ${file.name}.` });
  reader.readAsText(file);
}

function normalizeIncomingBackupKey(key) {
  if (key.startsWith('broomeToyotaVehicleCrmNavisionOnly')) {
    return key.replace('broomeToyotaVehicleCrmNavisionOnly', 'vehicleTrackingCoreNavisionOnly');
  }
  if (key.startsWith('notes:')) {
    return key.replace('notes:', 'vehicleTrackingCoreNotes:');
  }
  if (key.startsWith('columnWidths:v10:')) {
    return key.replace('columnWidths:v10:', 'vehicleTrackingCoreColumnWidths:v4:');
  }
  return key;
}

function backupStorageKeyAllowed(key) {
  const normalizedKey = normalizeIncomingBackupKey(key);
  return CRM_BACKUP_STORAGE_KEYS.includes(normalizedKey) ||
    normalizedKey.startsWith('vehicleTrackingCoreNotes:') ||
    normalizedKey.startsWith('vehicleTrackingCoreColumnWidths:') ||
    normalizedKey === VEHICLE_TABLE_COLUMN_ORDER_KEY ||
    normalizedKey.startsWith('vehicleTrackingCoreNavisionOnly');
}

function stripRestoredNavisionJitaAuthority(value, key = '') {
  if (![ADDED_KEY, EDITS_KEY].includes(key)) return value;
  try {
    const parsed = JSON.parse(value);
    const stripRow = row => {
      if (!row || typeof row !== 'object') return row;
      const cleaned = { ...row };
      ['jitQty', 'navisionJitaNumber', 'navisionJitaNumberAuthority', 'jitaPartsOrdered', '_navisionJitaNumberColumnPresent']
        .forEach(field => { delete cleaned[field]; });
      return cleaned;
    };
    if (Array.isArray(parsed)) return JSON.stringify(parsed.map(stripRow));
    if (parsed && typeof parsed === 'object') {
      return JSON.stringify(Object.fromEntries(Object.entries(parsed).map(([rowKey, row]) => [rowKey, stripRow(row)])));
    }
  } catch (_error) { /* malformed restored values fail through normal JSON validation */ }
  return value;
}

function normalizedBackupStorage(backup) {
  const storage = backup?.storage && typeof backup.storage === 'object' ? { ...backup.storage } : {};
  if (!storage[ADDED_KEY] && Array.isArray(backup?.vehicles)) {
    storage[ADDED_KEY] = JSON.stringify(backup.vehicles);
  }
  return Object.fromEntries(Object.entries(storage)
    .filter(([key, value]) => backupStorageKeyAllowed(key) && typeof value === 'string')
    .map(([key, value]) => {
      const normalizedKey = normalizeIncomingBackupKey(key);
      return [normalizedKey, stripRestoredNavisionJitaAuthority(value, normalizedKey)];
    }));
}

function restoreCrmBackup(text, fileName = 'backup file') {
  // A backup file is untrusted browser input. Once shared lifecycle authority
  // is enabled it must never replace the operational projection, even through
  // a stale DOM event or direct function call.
  if (vehicleLifecycleSharedModeActive()) {
    renderBackupStatus({
      type: 'error',
      message: 'Browser backup restore is unavailable in shared mode. Operational vehicles remain authoritative in Supabase.',
    });
    return false;
  }
  let backup;
  try { backup = JSON.parse(text); }
  catch {
    renderBackupStatus({ type: 'error', message: 'That file is not valid JSON. Use a CRM backup JSON, not a CSV export.' });
    return;
  }

  const storage = normalizedBackupStorage(backup);
  const entries = Object.entries(storage);
  if (!entries.length) {
    renderBackupStatus({ type: 'error', message: 'No restorable CRM data was found in that file. CSV exports cannot restore the full tracker state.' });
    return;
  }

  const stats = crmBackupStats({ ...backup, storage });
  const confirmed = window.confirm(
    `Restore ${stats.vehicles} vehicle${stats.vehicles === 1 ? '' : 's'} from ${fileName}?\n\n` +
    'This replaces the saved tracker data in this browser with the backup contents.'
  );
  if (!confirmed) {
    renderBackupStatus({ type: 'cancelled', message: 'Backup restore cancelled.' });
    return;
  }

  try {
    runStorageTransaction('CRM backup restore', [...new Set(crmManagedStorageKeys().concat(entries.map(([key]) => key)))], () => {
      const incomingKeys = new Set(entries.map(([key]) => key));
      entries.forEach(([key, value]) => localStorage.setItem(key, value));
      crmManagedStorageKeys().filter(key => !incomingKeys.has(key)).forEach(key => localStorage.removeItem(key));
    });
  } catch (error) {
    renderBackupStatus({ type: 'error', message: error.message || String(error) });
    return;
  }

  app.data = buildVehicleData();
  app.autocareFiles = [];
  app.autocareScan = loadJson(AUTOCARE_RESULTS_KEY, null);
  app.navisionImport = loadJson(NAVISION_IMPORT_RESULTS_KEY, null);
  app.navisionFileName = '';
  app.pendingNavisionImport = null;
  app.quickFilter = 'incoming';
  app.pmbSubFilter = '';
  app.sort = { key: '', dir: 'asc' };
  app.selectedRows.clear();
  app.columnFilters = { sales: '', production: '', status: '', jita: '' };
  updateOperationalHealth({ lastRestoreAt: nowIsoString() });
  ['search', 'source-filter'].forEach(id => { const el = $('#' + id); if (el) el.value = ''; });
  populateFilters();
  renderAll();
  if (app.navisionImport) renderNavisionSummary(app.navisionImport);
  updateNavisionSidebarMeta();
  renderBackupStatus({ type: 'restored', backup: { ...backup, storage }, fileName });

  const upload = $('#backup-upload');
  if (upload) upload.value = '';
}

function renderBackupStatus({ type, backup = null, fileName = '', message = '' } = {}) {
  const host = $('#backup-status-list');
  if (!host) return;
  if (type === 'error') {
    host.innerHTML = `<div class="summary-row error"><strong>Backup error</strong><span>${escapeHtml(message || 'The backup could not be processed.')}</span></div>`;
    return;
  }
  if (type === 'cancelled') {
    host.innerHTML = `<div class="summary-row warn"><strong>Restore cancelled</strong><span>${escapeHtml(message || 'No tracker data was changed.')}</span></div>`;
    return;
  }
  const stats = crmBackupStats(backup || buildCrmBackup());
  const exportedAt = backup?.exportedAt ? new Date(backup.exportedAt) : new Date();
  const when = exportedAt && !Number.isNaN(exportedAt.getTime()) ? exportedAt.toLocaleString('en-AU') : 'Unknown time';
  const heading = type === 'restored' ? 'Backup restored' : 'Backup exported';
  const detail = type === 'restored'
    ? `${fileName ? escapeHtml(fileName) + ' · ' : ''}The dashboard has been reloaded from the backup.`
    : 'A JSON backup file has been downloaded. Keep it with your Navision export history.';
  host.innerHTML = `
    <div class="scot-summary-grid backup-summary-grid">
      <div class="summary-stat"><span>Vehicles</span><strong>${stats.vehicles}</strong></div>
      <div class="summary-stat"><span>Edited rows</span><strong>${stats.editRows}</strong></div>
      <div class="summary-stat"><span>Notes</span><strong>${stats.notes}</strong></div>
      <div class="summary-stat"><span>Saved keys</span><strong>${stats.storageKeys}</strong></div>
    </div>
    <div class="summary-section">
      <h3>${heading}</h3>
      <div class="summary-row ok"><strong>${type === 'restored' ? 'Ready' : 'Downloaded'}</strong><span>${detail}</span></div>
      <div class="summary-row"><strong>Backup time</strong><span>${escapeHtml(when)}</span></div>
    </div>
    <div class="subtle">Use <strong>Export CRM backup JSON</strong> when you need to restore the tracker after a website update.</div>
  `;
}

function teamNotesText(vehicle) {
  return getNotes(vehicleKey(vehicle)).join(' | ');
}

function exportCsv() {
  const jobHeaders = PDC_JOB_DEFS.flatMap(def => [`Requires ${def.label}`, `${def.label} Complete`]);
  const headers = ['SP','Stock','Key Number','P/Month','Client','Vehicle','PDC Location','PMB Work Stream','SUBLET Provider','PMB Bay','PMB Bay Hours','PMB Bay Scheduled Start','PMB Bay Started','PMB Bay Completed','PMB Requirements','PMB Completed','PMB Outstanding','Blocked','Blocked Reason','Bucket Days','Days Since Kewdale ETA','Parts Status','Parts ETA','Parts Worst ETA','RFT Gate Issues','RFT Date','Navision Notes','Team Notes','Task', ...jobHeaders, 'PD Document Tasks','PD Document Files','Toyota Status (Sub Location)','Navision ETA','Delivery Date','JITA Number','Contact','Source','Autocare VIN','Autocare Batch','Autocare Load','Match Warning'];
  const lines = [headers.join(',')].concat(pdcSheetVehicles().map(v => [
    salesPersonInitials(consultantName(v)), displayStockNumber(v), vehicleKeyNumber(v), productionMonthLabel(v.prodMth || v.productionMonth || ''), v.client, displayVehicle(v), pdcLocationLabel(v.pdcLocation), pmbStageLabel(inferredPmbStage(v)), pmbBaySubletProvider(v), pmbBayNumber(v, inferredPmbStage(v)) || '', pmbBayHours(v) === '' ? '' : pmbBayHours(v), v.pmbBayScheduledStartAt ? new Date(v.pmbBayScheduledStartAt).toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : '', v.pmbBayEnteredAt ? new Date(v.pmbBayEnteredAt).toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : '', v.pmbBayCompletedAt ? new Date(v.pmbBayCompletedAt).toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : '', pmbRequirementText(v), pdcCompletedJobsText(v), pdcOutstandingJobsText(v), isPdcBlocked(v) ? 'Yes' : 'No', pdcBlockReason(v), pmbStageAgeDays(v) === null ? '' : pmbStageAgeDays(v), pmbAgeDays(v) === null ? '' : pmbAgeDays(v), partsDepartmentStatusLabel(partsDepartmentStatus(v)), kewdaleEtaValue(v), partsWorstEtaLabel(v), vehicleRftGateIssues(v).join('; '), v.rftTransferredAt ? new Date(v.rftTransferredAt).toLocaleString('en-AU', { dateStyle: 'short', timeStyle: 'short' }) : '', navisionDealerNoteText(v), teamNotesText(v), v.internalStatus || '', ...PDC_JOB_DEFS.flatMap(def => [pdcJobRequired(v, def) ? 'Yes' : 'No', pdcJobComplete(v, def) ? 'Yes' : 'No']), (v.poTasks || []).join('; '), (v.poFiles || []).join('; '), v.toyotaStatus || '', scotEtaOnly(v.etaAtDealer), v.deliveryDate || '', jitaDisplay(v), v.contact || '', v.source || '', v.autocareVin || '', v.autocareBatch || '', v.autocareLoadNumber || '', isCustomerMatch(v) ? '' : 'Customer mismatch'
  ].map(csvEscape).join(',')));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'vehicle-tracking-core-export.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function csvEscape(value) {
  value = String(value ?? '');
  return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}


const ZPL_REQUIRED_COLUMNS = [
  'Batch',
  'Customer Surname',
  'Dealer Customer Name',
  'Model Description',
  'Suffix Description',
  'Trim Description',
  'Colour Description',
  'WMI',
  'VDS Number',
  'Frame'
];

function cleanZplField(value) {
  return String(value ?? '')
    .replace(/[\^~]/g, '')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function parseDelimitedLine(line, delimiter = '\t') {
  const cells = [];
  let cell = '';
  let quoted = false;
  for (let i = 0; i < String(line || '').length; i += 1) {
    const ch = line[i];
    const next = line[i + 1];
    if (ch === '"') {
      if (quoted && next === '"') {
        cell += '"';
        i += 1;
      } else {
        quoted = !quoted;
      }
      continue;
    }
    if (ch === delimiter && !quoted) {
      cells.push(cell);
      cell = '';
      continue;
    }
    cell += ch;
  }
  cells.push(cell);
  return cells;
}

function detectDelimitedRows(text) {
  const value = String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const lines = value.split('\n').filter(line => line.trim().length > 0);
  if (!lines.length) return { rows: [], delimiter: '\t' };
  const sampleLines = lines.slice(0, 40);
  // Navision's browser copy/export can use U+2002 EN SPACE between cells instead
  // of a real tab. Preserve repeated separators because they represent blank columns.
  const counts = ['\t', '\u2002', ',', ';'].map(delimiter => {
    const perLine = sampleLines.map(line => Array.from(line).filter(character => character === delimiter).length);
    const strongest = perLine.slice().sort((a, b) => b - a).slice(0, 5);
    return [delimiter, strongest.reduce((sum, value) => sum + value, 0)];
  });
  const [delimiter, count] = counts.sort((a, b) => b[1] - a[1])[0];
  const chosen = count > 0 ? delimiter : '\t';
  return { rows: lines.map(line => parseDelimitedLine(line, chosen)), delimiter: chosen };
}

function splitTsvRows(text) {
  return detectDelimitedRows(text).rows;
}

function getTsvValue(row, headerMap, column) {
  const index = headerMap.get(column);
  return index === undefined ? '' : row[index] || '';
}

function vehicleToZplBlock(vehicle) {
  const keyNumber = cleanZplField(vehicle.keyNumber || vehicle.batch || 'NO KEY');
  const stock = cleanZplField(vehicle.stock || '—');
  const jobCard = cleanZplField(vehicle.jobCard || '—');
  const customer = cleanZplField(vehicle.customer || '(Dealer Order)');
  const model = cleanZplField(vehicle.model || 'Vehicle not listed');
  const sales = cleanZplField(vehicle.sales || '—');
  const department = cleanZplField(vehicle.department || 'PDC');
  return [
    '^XA', '^PW540', '^LL360', '^LH0,0', '^CI28',
    `^FO18,12^A0N,62,62^FB504,1,0,L,0^FD${keyNumber}^FS`,
    `^FO18,82^A0N,28,28^FB504,1,0,L,0^FDSTOCK ${stock}^FS`,
    `^FO18,116^A0N,25,25^FB504,1,0,L,0^FDJOB CARD ${jobCard}^FS`,
    `^FO18,150^A0N,27,27^FB504,2,2,L,0^FD${customer}^FS`,
    `^FO18,210^A0N,25,25^FB504,2,2,L,0^FD${model}^FS`,
    `^FO18,276^A0N,23,23^FB504,1,0,L,0^FDSALES ${sales}^FS`,
    `^FO18,308^A0N,22,22^FB504,1,0,L,0^FD${department}^FS`,
    '^PQ1', '^XZ'
  ].join('\n');
}

function parseZplInput(text) {
  const rows = splitTsvRows(text);
  if (!rows.length) return { vehicles: [], warnings: ['Paste a tab-separated export with a header row first.'], missing: ZPL_REQUIRED_COLUMNS.slice() };
  const headers = rows[0].map(header => String(header || '').trim());
  const headerMap = new Map(headers.map((header, index) => [header, index]));
  const missing = ZPL_REQUIRED_COLUMNS.filter(column => !headerMap.has(column));
  if (missing.length) return { vehicles: [], warnings: [`Missing required columns: ${missing.join(', ')}`], missing };

  const warnings = [];
  const vehicles = rows.slice(1).map((row, rowIndex) => {
    const excelRow = rowIndex + 2;
    const batch = cleanZplField(getTsvValue(row, headerMap, 'Batch'));
    const customerSurname = cleanZplField(getTsvValue(row, headerMap, 'Customer Surname'));
    const dealerCustomer = cleanZplField(getTsvValue(row, headerMap, 'Dealer Customer Name'));
    const model = cleanZplField(getTsvValue(row, headerMap, 'Model Description'));
    const suffix = cleanZplField(getTsvValue(row, headerMap, 'Suffix Description'));
    const trim = cleanZplField(getTsvValue(row, headerMap, 'Trim Description'));
    const colour = cleanZplField(getTsvValue(row, headerMap, 'Colour Description'));
    const wmi = cleanZplField(getTsvValue(row, headerMap, 'WMI')).replace(/\s+/g, '');
    const vds = cleanZplField(getTsvValue(row, headerMap, 'VDS Number')).replace(/\s+/g, '');
    const frame = cleanZplField(getTsvValue(row, headerMap, 'Frame')).replace(/\s+/g, '');
    const vin = `${wmi}${vds}${frame}`;
    const customer = customerSurname || dealerCustomer || '(Dealer Order)';
    const specLine = [suffix, trim, colour].filter(Boolean).join(' ');
    if (!batch) {
      warnings.push(`Row ${excelRow}: Batch is blank.`);
    }
    const missingVinParts = [];
    if (!wmi) missingVinParts.push('WMI');
    if (!vds) missingVinParts.push('VDS Number');
    if (!frame) missingVinParts.push('Frame');
    if (missingVinParts.length || vin.length !== 17) {
      warnings.push(`Row ${excelRow}${batch ? ` / Batch ${batch}` : ''}: VIN is ${vin.length || 0} characters${missingVinParts.length ? `, missing ${missingVinParts.join(' and ')}` : ''}.`);
    }
    return { batch, customer, model, specLine, vin, row: excelRow };
  });
  return { vehicles, warnings, missing: [] };
}

function generateZplFromInput() {
  const input = $('#zpl-input')?.value || '';
  const output = $('#zpl-output');
  const copyButton = $('#zpl-copy');
  const printButton = $('#zpl-print');
  const parsed = parseZplInput(input);
  const zpl = parsed.vehicles.map(vehicleToZplBlock).join('\n\n');
  if (output) output.value = zpl;
  if (copyButton) copyButton.disabled = !zpl;
  if (printButton) printButton.disabled = !zpl;
  renderZplSummary(parsed, zpl);
}

function renderZplSummary(parsed, zpl) {
  const summary = $('#zpl-summary');
  if (!summary) return;
  const count = parsed.vehicles.length;
  const warningList = parsed.warnings.map(warning => `<li>${escapeHtml(warning)}</li>`).join('');
  summary.innerHTML = `
    <div class="zpl-summary-grid">
      <div class="summary-stat"><span>Vehicles processed</span><strong>${count}</strong></div>
      <div class="summary-stat"><span>Label copies</span><strong>${count}</strong></div>
      <div class="summary-stat"><span>ZPL blocks</span><strong>${zpl ? count : 0}</strong></div>
    </div>
    ${parsed.warnings.length ? `<div class="zpl-warning"><strong>Review before printing</strong><ul>${warningList}</ul></div>` : '<div class="zpl-ok">Ready to print. No incomplete VINs detected.</div>'}
  `;
}

function copyZplOutput() {
  const output = $('#zpl-output');
  if (!output || !output.value) return;
  const setCopied = () => {
    const btn = $('#zpl-copy');
    if (!btn) return;
    const original = btn.textContent;
    btn.textContent = 'Copied';
    window.setTimeout(() => { btn.textContent = original; }, 1400);
  };
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(output.value).then(setCopied).catch(() => {
      output.focus();
      output.select();
      document.execCommand('copy');
      setCopied();
    });
  } else {
    output.focus();
    output.select();
    document.execCommand('copy');
    setCopied();
  }
}

function clearZplGenerator() {
  const input = $('#zpl-input');
  const output = $('#zpl-output');
  if (input) input.value = '';
  if (output) output.value = '';
  const copyButton = $('#zpl-copy');
  if (copyButton) copyButton.disabled = true;
  const printButton = $('#zpl-print');
  if (printButton) printButton.disabled = true;
  const summary = $('#zpl-summary');
  if (summary) summary.innerHTML = '<div class="empty-state compact-empty"><strong>Ready</strong><span>Paste rows and generate. Incomplete VINs will be flagged before printing.</span></div>';
}

function aiBoardNormalizeStockIdentity(value = '') {
  const raw = String(value || '').trim().toUpperCase();
  const normalized = raw.replace(/[\s-]+/g, '');
  if (!normalized || ['0', 'TBA', 'TBD', 'UNKNOWN', 'NA', 'N/A', 'NONE', 'UNASSIGNED'].includes(normalized)) return '';
  if (/^(NEW|PD|PENDING|TEMP)-/.test(raw)) return '';
  return normalized;
}

function aiBoardSharedModeEnabled() {
  return window.PDC_SUPABASE_CONFIG?.workshop?.sharedData === true;
}

function aiBoardSharedSnapshot() {
  if (!aiBoardSharedModeEnabled()) return null;
  const service = window.__workshopDataService;
  if (!service || typeof service.getTrustedSnapshot !== 'function') return null;
  const snapshot = service.getTrustedSnapshot();
  return snapshot && typeof snapshot === 'object' ? snapshot : null;
}

function aiBoardSharedVehicleIdentity(vehicle = {}, snapshot = null) {
  const rows = snapshot && Array.isArray(snapshot.vehicles) ? snapshot.vehicles : [];
  const legacyKey = vehicleKey(vehicle);
  const stockIdentity = aiBoardNormalizeStockIdentity(legacyKey);
  const sourceIdentity = String(legacyKey || '').trim().toUpperCase();
  const matches = rows.filter(row => (
    (stockIdentity && aiBoardNormalizeStockIdentity(row?.stock_number) === stockIdentity)
    || (sourceIdentity && String(row?.permanent_vehicle_id || '').trim().toUpperCase() === sourceIdentity)
  ));
  const ids = [...new Set(matches.map(row => String(row?.id || '').trim()).filter(Boolean))];
  return ids.length === 1 ? `shared:${ids[0]}` : '';
}

function aiBoardVehicleIdentity(vehicle = {}, snapshot = null) {
  if (aiBoardSharedModeEnabled() && snapshot) return aiBoardSharedVehicleIdentity(vehicle, snapshot);
  const key = String(vehicleKey(vehicle) || '').trim();
  return key ? `legacy:${key}` : '';
}

function aiBoardDateIso(value = '') {
  const direct = parseIsoTimestamp(value);
  if (direct) return direct.toISOString();
  const local = parseDateAU(value);
  return local && !Number.isNaN(local.getTime()) ? local.toISOString() : '';
}

function aiBoardVehicleDtos(snapshot = null) {
  return pdcSheetVehicles().map(vehicle => {
    const required = pdcRequiredJobs(vehicle);
    const completed = pdcCompletedJobs(vehicle);
    const parts = partsJobDef();
    return {
      identity: aiBoardVehicleIdentity(vehicle, snapshot),
      stock: displayStockNumber(vehicle) || vehicleKey(vehicle),
      currentStage: inferredPmbStage(vehicle),
      stageAgeDays: pmbStageAgeDays(vehicle),
      stageAgeLimitDays: pmbLaneAgeLimit(inferredPmbStage(vehicle)),
      deliveryAt: aiBoardDateIso(vehicle.deliveryDate || ''),
      blocked: isPdcBlocked(vehicle),
      blockReason: pdcBlockReason(vehicle),
      requiredStages: required.filter(def => def.key !== 'parts').map(def => pmbStageForPdcJob(def) || def.label),
      completedStages: completed.filter(def => def.key !== 'parts').map(def => pmbStageForPdcJob(def) || def.label),
      parts: {
        required: Boolean(parts && pdcJobRequired(vehicle, parts)),
        complete: Boolean(parts && pdcJobComplete(vehicle, parts)),
        stoppage: Boolean(vehicle.pdcPartsStoppage),
        reason: cleanNavisionText(vehicle.pdcPartsStoppageReason || ''),
        eta: aiBoardDateIso(vehicle.pdcPartsWorstEta || ''),
      },
      jobLines: (Array.isArray(vehicle.pdcManualJobLines) ? vehicle.pdcManualJobLines : []).map(line => ({
        description: cleanNavisionText(line?.description || ''),
        hours: line?.confirmedHours ?? line?.estimatedHours ?? null,
        confirmed: line?.confirmed === true || line?.estimateStatus === 'confirmed',
      })),
    };
  });
}

function aiBoardBookingDtos(snapshot = null) {
  if (aiBoardSharedModeEnabled()) {
    if (!snapshot || snapshot.revision == null || !Array.isArray(snapshot.bookings)) return { bookingCoverage: false, bookingSource: 'shared', bookingRevision: '', bookings: [] };
    return {
      bookingCoverage: true,
      bookingSource: 'shared',
      bookingRevision: String(snapshot.revision),
      bookings: snapshot.bookings.map(booking => {
        const duration = Number(booking?.default_duration_minutes || 0);
        const start = parseIsoTimestamp(booking?.scheduled_start_at || '');
        const calculatedEnd = start && duration > 0 ? new Date(start.getTime() + duration * 60000).toISOString() : '';
        return {
          id: booking?.booking_id || booking?.id || '',
          vehicleIdentity: (booking?.vehicle_id || booking?.vehicle?.id)
            ? `shared:${booking.vehicle_id || booking.vehicle.id}` : '',
          stage: booking?.stage?.code || booking?.stage_code || '',
          bay: booking?.bay?.bay_number ?? booking?.bay_number ?? '',
          status: booking?.status === 'queued' ? 'planned' : booking?.status || '',
          startAt: booking?.scheduled_start_at || '',
          endAt: booking?.scheduled_end_at || calculatedEnd,
          stoppageReason: booking?.stoppage_reason || '',
        };
      }),
    };
  }
  const rows = loadJson('vehicleTrackingCoreWorkshopPlan:v1', []);
  return {
    bookingCoverage: true,
    bookingSource: 'local',
    bookingRevision: '',
    bookings: (Array.isArray(rows) ? rows : []).map(booking => {
      const start = parseIsoTimestamp(booking?.startAt || '');
      const hours = Number(booking?.hours || 0);
      return {
        id: booking?.id || '',
        vehicleIdentity: booking?.sharedVehicleId ? `shared:${String(booking.sharedVehicleId).trim()}` : (booking?.vehicleKey ? `legacy:${String(booking.vehicleKey).trim()}` : ''),
        stage: booking?.stage || '',
        bay: booking?.bay || booking?.assignee || '',
        status: booking?.status || '',
        startAt: booking?.startAt || '',
        endAt: start && hours > 0 ? new Date(start.getTime() + hours * 3600000).toISOString() : '',
        stoppageReason: booking?.stoppageReason || '',
      };
    }),
  };
}

function aiBoardAdvisorInput(nowIso = nowIsoString()) {
  const snapshot = aiBoardSharedSnapshot();
  const bookingData = aiBoardBookingDtos(snapshot);
  return {
    nowIso,
    bookingCoverage: bookingData.bookingCoverage,
    bookingSource: bookingData.bookingSource,
    bookingRevision: bookingData.bookingRevision,
    vehicles: aiBoardVehicleDtos(snapshot),
    bookings: bookingData.bookings,
  };
}

function aiBoardSeverityLabel(severity = '') {
  return ({ critical: 'Critical', high: 'High', medium: 'Review', low: 'Low' })[severity] || 'Review';
}

function renderAiBoardAdvisor(nowIso = nowIsoString()) {
  const host = $('#ai-board-advisor-content');
  if (!host) return null;
  const api = window.PdcAiBoardAdvisor;
  if (!api || typeof api.analyze !== 'function') {
    host.innerHTML = '<div class="empty-state"><strong>Advisor unavailable</strong><span>The read-only advisory engine did not load. No operational data was changed.</span></div>';
    return null;
  }
  const result = api.analyze(aiBoardAdvisorInput(nowIso));
  const counts = result.counts || { critical: 0, high: 0, medium: 0, low: 0, total: 0 };
  const coverage = result.bookingCoverage
    ? `<span class="badge ready">Vehicle + ${result.bookingSource === 'shared' ? `booking coverage · revision ${escapeHtml(result.bookingRevision || '')}` : 'local booking coverage'}</span>`
    : '<span class="badge warning">Vehicle coverage only</span>';
  const findings = Array.isArray(result.findings) ? result.findings : [];
  const priorityFindings = findings.filter(item => item.severity === 'critical' || item.severity === 'high');
  const visibleFindings = findings.slice(0, Math.max(50, priorityFindings.length));
  host.innerHTML = `
    <div class="ai-board-summary" role="status" aria-live="polite">
      <div class="summary-stat ai-board-critical"><span>Critical</span><strong>${counts.critical || 0}</strong></div>
      <div class="summary-stat ai-board-high"><span>High</span><strong>${counts.high || 0}</strong></div>
      <div class="summary-stat"><span>Review</span><strong>${counts.medium || 0}</strong></div>
      <div class="summary-stat"><span>Total</span><strong>${counts.total || 0}</strong></div>
    </div>
    <div class="ai-board-coverage">${coverage}<span>Calculated ${escapeHtml(operationalHealthDateLabel(result.generatedAt) || result.generatedAt || 'now')} · deterministic rules ${escapeHtml(result.version || '')}</span></div>
    ${result.bookingCoverage ? '' : '<div class="parts-help-strip"><strong>Coverage limit:</strong><span>No authoritative Workshop booking snapshot is available in this session, so booking conflicts and unscheduled-work checks are omitted rather than guessed.</span></div>'}
    ${findings.length ? `${findings.length > visibleFindings.length ? `<div class="parts-help-strip"><strong>Priority view:</strong><span>Showing the first ${visibleFindings.length} of ${findings.length} deterministically ranked findings. Critical and high risks sort first.</span></div>` : ''}<ol class="ai-board-findings" aria-label="Advisory findings">${visibleFindings.map(item => `
      <li class="ai-board-finding ai-board-${escapeHtml(item.severity)}">
        <div class="ai-board-finding-heading"><span class="badge ${item.severity === 'critical' ? 'danger' : item.severity === 'high' ? 'warning' : 'neutral'}">${escapeHtml(aiBoardSeverityLabel(item.severity))}</span><strong>${escapeHtml(item.title)}</strong><code>${escapeHtml(item.rule)}</code></div>
        <p>${escapeHtml(item.explanation)}</p>
        ${item.stock ? `<div class="ai-board-identity"><b>Stock:</b> ${escapeHtml(item.stock)}</div>` : ''}
        <ul>${(Array.isArray(item.evidence) ? item.evidence : []).map(value => `<li>${escapeHtml(value)}</li>`).join('')}</ul>
        <div class="ai-board-recommendation"><strong>Human review:</strong> ${escapeHtml(item.recommendation)}</div>
      </li>`).join('')}</ol>` : '<div class="empty-state compact-empty"><strong>No deterministic risks detected</strong><span>This is not an approval or guarantee. Continue normal staff checks and refresh when data changes.</span></div>'}
  `;
  return result;
}

const PDC_AUDITOR_CATEGORY_DEFS = Object.freeze([
  { key: 'critical_issues', label: 'Critical issues', colour: '#dc2626', matches: item => item.severity === 'critical' },
  { key: 'high_priority', label: 'High-priority issues', colour: '#ea580c', matches: item => item.severity === 'high' },
  { key: 'invalid_job_booking', label: 'Bookings without valid jobs', colour: '#b91c1c', matches: item => /BOOKING_(WITHOUT|WORK_AUTHORITY|INACTIVE|CANCELLED)/.test(item.ruleId) },
  { key: 'missing_hours', label: 'Missing estimated hours', colour: '#d97706', matches: item => /(ESTIMATE|LABOUR_HOURS).*(MISSING|ZERO|INVALID)|LABOUR_PROVENANCE_MISSING/.test(item.ruleId) },
  { key: 'parts_risk', label: 'Parts risks', colour: '#2563eb', aliases: ['parts', 'parts_dependency'], matches: item => item.category === 'parts_risk' || item.ruleId.startsWith('PARTS_') },
  { key: 'double_bookings', label: 'Double bookings', colour: '#7c3aed', matches: item => /(CONFLICT|OVERLAP|MULTIPLE_ACTIVE_BOOKINGS|DUPLICATE_ACTIVE_BOOKING)/.test(item.ruleId) },
  { key: 'active_stoppages', label: 'Active stoppages', colour: '#be123c', matches: item => item.ruleId.includes('STOPPAGE') },
  { key: 'forgotten_vehicles', label: 'Forgotten vehicles', colour: '#0f766e', matches: item => /(FORGOTTEN|NO_FUTURE_BOOKING|NO_PROGRESS|NO_REPLACEMENT|NOT_REVIEWED|NOT_COLLECTED)/.test(item.ruleId) },
  { key: 'workflow_problems', label: 'Workflow problems', colour: '#475569', matches: item => item.category === 'workflow' || /(QC_|RFT_|COMPLETED_|WORKFLOW_|SUBLET_|LOCATION_)/.test(item.ruleId) },
  { key: 'awaiting_approval', label: 'Recommendations awaiting approval', colour: '#64748b', matches: item => item.review && !item.review.decision },
]);

function auditorAuthorityIdentity() {
  return String(window.PDC_AUTH_CONTEXT?.userId || window.PDC_AUTH_CONTEXT?.email || '');
}

function createPdcAuditorSnapshotService({ config = {}, getAccessToken = () => null, fetchImpl = window.fetch?.bind(window) } = {}) {
  let lifecycleGeneration = 0;
  let destroyed = false;
  let retainedSnapshot = null;

  function invalidate() {
    lifecycleGeneration += 1;
    retainedSnapshot = null;
  }

  async function getAuditorSnapshot() {
    if (destroyed) return { ok: false, code: 'destroyed' };
    const token = getAccessToken();
    const authority = auditorAuthorityIdentity();
    if (!token || !authority || !config.url || !config.publishableKey || typeof fetchImpl !== 'function') {
      invalidate();
      return { ok: false, code: 'unavailable' };
    }
    const generation = lifecycleGeneration;
    try {
      let firstPage = null;
      let afterVehicleId = null;
      const items = [];
      for (let pageIndex = 0; pageIndex < 5; pageIndex += 1) {
        const response = await fetchImpl(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/get_pdc_auditor_snapshot`, {
          method: 'POST',
          headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ p_after_vehicle_id: afterVehicleId, p_page_size: 100 }),
        });
        if (destroyed || generation !== lifecycleGeneration || authority !== auditorAuthorityIdentity() || token !== getAccessToken()) return { ok: false, code: 'superseded' };
        if (!response.ok) {
          invalidate();
          return { ok: false, code: response.status === 401 || response.status === 403 ? 'permission_denied' : 'unavailable', status: response.status };
        }
        const page = await response.json();
        if (destroyed || generation !== lifecycleGeneration || authority !== auditorAuthorityIdentity() || token !== getAccessToken()) return { ok: false, code: 'superseded' };
        const pageItems = Array.isArray(page?.items) ? page.items : Array.isArray(page?.vehicles) ? page.vehicles : null;
        if (!page || typeof page !== 'object' || !page.response_revision || !page.generated_at || !page.dealer_code || !pageItems || pageItems.length > 100) {
          invalidate();
          return { ok: false, code: 'invalid_snapshot' };
        }
        if (!firstPage) firstPage = page;
        else if (page.response_revision !== firstPage.response_revision || page.dealer_code !== firstPage.dealer_code || page.environment !== firstPage.environment) {
          invalidate();
          return { ok: false, code: 'snapshot_changed_during_pagination' };
        }
        items.push(...pageItems);
        if (!page.has_more) {
          const snapshot = {
            ...firstPage,
            revision: firstPage.response_revision,
            as_of: firstPage.generated_at,
            page_size: firstPage.page_size,
            has_more: false,
            next_vehicle_id: null,
            page_manifest: {
              ...(firstPage.page_manifest || {}),
              after_vehicle_id: null,
              returned_count: items.length,
              total_scoped_vehicle_count: items.length,
              has_more: false,
              next_vehicle_id: null,
            },
            items,
            vehicles: items,
          };
          const queueResponse = await fetchImpl(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/get_pdc_auditor_review_queue`, {
            method: 'POST',
            headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ p_limit: 200 }),
          });
          if (destroyed || generation !== lifecycleGeneration || authority !== auditorAuthorityIdentity() || token !== getAccessToken()) return { ok: false, code: 'superseded' };
          if (!queueResponse.ok) {
            invalidate();
            return { ok: false, code: queueResponse.status === 401 || queueResponse.status === 403 ? 'permission_denied' : 'review_queue_unavailable', status: queueResponse.status };
          }
          const queue = await queueResponse.json();
          if (destroyed || generation !== lifecycleGeneration || authority !== auditorAuthorityIdentity() || token !== getAccessToken()) return { ok: false, code: 'superseded' };
          if (!queue || queue.ok !== true || queue.environment !== 'staging' || queue.dealer_code !== snapshot.dealer_code || !Array.isArray(queue.items) || queue.items.length > 200) {
            invalidate();
            return { ok: false, code: 'invalid_review_queue' };
          }
          snapshot.reviewQueue = queue.items;
          snapshot.reviewCanDecide = queue.can_decide === true;
          retainedSnapshot = snapshot;
          return { ok: true, snapshot };
        }
        if (!page.next_vehicle_id || page.next_vehicle_id === afterVehicleId) {
          invalidate();
          return { ok: false, code: 'invalid_snapshot' };
        }
        afterVehicleId = page.next_vehicle_id;
      }
      invalidate();
      return { ok: false, code: 'snapshot_too_large' };
    } catch (_error) {
      if (destroyed || generation !== lifecycleGeneration) return { ok: false, code: 'superseded' };
      invalidate();
      return { ok: false, code: 'unavailable' };
    }
  }

  async function reconcileDecision({ findingId, evidenceFingerprint, lastSeenRunId, decision, reason }) {
    const refreshed = await getAuditorSnapshot();
    if (!refreshed.ok) return { ok: false, code: 'decision_outcome_unknown' };
    const item = (refreshed.snapshot.reviewQueue || []).find(row => String(row?.finding_id || '') === findingId
      && String(row?.evidence_fingerprint || '') === evidenceFingerprint
      && String(row?.last_seen_run_id || '') === lastSeenRunId);
    const recorded = item?.decision;
    if (!recorded) return { ok: false, code: 'decision_outcome_unknown' };
    const recordedReason = String(recorded.reason || '').trim();
    if (recorded.status !== decision || recordedReason !== String(reason || '').trim()) return { ok: false, code: 'already_decided' };
    if (recorded.operational_change === true) return { ok: false, code: 'invalid_decision_receipt' };
    return { ok: true, reconciled: true, data: {
      decision_id: String(recorded.decision_id || ''), status: recorded.status,
      reason: recorded.reason || null, operational_change: false, execution_reference: null,
    } };
  }

  async function decideFinding({ findingId = '', evidenceFingerprint = '', lastSeenRunId = '', decision = '', reason = null } = {}) {
    if (destroyed) return { ok: false, code: 'destroyed' };
    const token = getAccessToken();
    const authority = auditorAuthorityIdentity();
    if (!token || !authority || !config.url || !config.publishableKey || typeof fetchImpl !== 'function') return { ok: false, code: 'unavailable' };
    if (!/^[0-9a-f-]{36}$/i.test(findingId) || !/^[a-f0-9]{64}$/.test(evidenceFingerprint)
        || !/^[0-9a-f-]{36}$/i.test(lastSeenRunId) || !['approved', 'denied'].includes(decision)) return { ok: false, code: 'invalid_decision' };
    const cleanReason = String(reason || '').trim();
    if ((decision === 'denied' && (cleanReason.length < 3 || cleanReason.length > 500)) || cleanReason.length > 500) return { ok: false, code: 'invalid_reason' };
    const generation = lifecycleGeneration;
    try {
      const response = await fetchImpl(`${String(config.url).replace(/\/$/, '')}/rest/v1/rpc/record_pdc_auditor_decision`, {
        method: 'POST',
        headers: { apikey: config.publishableKey, Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          p_finding_id: findingId,
          p_evidence_fingerprint: evidenceFingerprint,
          p_last_seen_run_id: lastSeenRunId,
          p_decision: decision,
          p_reason: cleanReason || null,
        }),
      });
      if (destroyed || generation !== lifecycleGeneration || authority !== auditorAuthorityIdentity() || token !== getAccessToken()) return { ok: false, code: 'superseded' };
      if (!response.ok) {
        const error = await response.json().catch(() => null);
        const message = String(error?.message || error?.code || '').toLowerCase();
        if (message.includes('stale')) return { ok: false, code: 'stale' };
        if (message.includes('already_decided')) return { ok: false, code: 'already_decided' };
        if (response.status === 401 || response.status === 403) return { ok: false, code: 'permission_denied' };
        return reconcileDecision({ findingId, evidenceFingerprint, lastSeenRunId, decision, reason: cleanReason });
      }
      const data = await response.json().catch(() => null);
      if (data?.operational_change === true || data?.execution_reference != null) return { ok: false, code: 'invalid_decision_receipt' };
      if (!data || data.ok !== true || data.operational_change !== false || !['approved', 'denied'].includes(data.status)) {
        return reconcileDecision({ findingId, evidenceFingerprint, lastSeenRunId, decision, reason: cleanReason });
      }
      invalidate();
      return { ok: true, data };
    } catch (_error) {
      if (destroyed || generation !== lifecycleGeneration || authority !== auditorAuthorityIdentity() || token !== getAccessToken()) return { ok: false, code: 'superseded' };
      return reconcileDecision({ findingId, evidenceFingerprint, lastSeenRunId, decision, reason: cleanReason });
    }
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    invalidate();
  }

  return {
    getAuditorSnapshot,
    decideFinding,
    getTrustedSnapshot: () => (destroyed ? null : retainedSnapshot),
    invalidate,
    destroy,
  };
}

function pdcAuditorCategory(value = '') {
  const normalized = cleanNavisionText(value).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  return PDC_AUDITOR_CATEGORY_DEFS.find(def => def.key === normalized || (Array.isArray(def.aliases) && def.aliases.includes(normalized)))?.key || 'data_quality';
}

function pdcAuditorSafeText(value = '', max = 420) {
  return cleanNavisionText(value).slice(0, max);
}

function pdcAuditorNormalizeFinding(item = {}, index = 0) {
  const evidence = (Array.isArray(item.evidence) ? item.evidence : [])
    .map(value => typeof value === 'string' ? value : (value?.label || value?.value || value?.fact || ''))
    .map(value => pdcAuditorSafeText(value, 300)).filter(Boolean).slice(0, 12);
  const vehicleId = pdcAuditorSafeText(item.vehicle_id || item.vehicleId || item.entity_id || '', 80);
  const sourceRef = pdcAuditorSafeText(item.source_ref || item.sourceRef || item.rule_id || item.rule || '', 120);
  return {
    id: pdcAuditorSafeText(item.finding_id || item.id || `${pdcAuditorCategory(item.category)}:${sourceRef || index}`, 160),
    engineFingerprint: pdcAuditorSafeText(item.fingerprint || '', 100),
    category: pdcAuditorCategory(item.category || item.kind || item.rule_category),
    ruleId: pdcAuditorSafeText(item.ruleId || item.rule_id || item.rule || '', 100).toUpperCase(),
    severity: ['critical', 'high', 'medium', 'low'].includes(String(item.severity || '').toLowerCase()) ? String(item.severity).toLowerCase() : 'medium',
    title: pdcAuditorSafeText(item.title || item.summary || item.issue || 'Finding requires review', 180),
    explanation: pdcAuditorSafeText(item.explanation || item.issue || item.description || item.reason || 'Review the recorded evidence before taking any action.'),
    recommendedAction: pdcAuditorSafeText(item.recommendedAction || item.recommended_action || item.recommendation || ''),
    evidence,
    limitation: pdcAuditorSafeText(item.limitation || item.limitations || ''),
    vehicleId,
    vehicleLabel: pdcAuditorSafeText(item.stock_number || item.stock || item.vehicle_label || vehicleId, 100),
    sourceRef,
    reportViews: (Array.isArray(item.report_views) ? item.report_views : []).map(value => String(value || '').toLowerCase()),
    scope: (Array.isArray(item.scope) ? item.scope : []).map(value => pdcAuditorSafeText(value, 100)).filter(Boolean).slice(0, 12),
  };
}

function pdcAuditorReviewCandidates(finding, queue = [], source = {}) {
    const scope = new Set([finding.vehicleId, ...(finding.scope || [])].filter(Boolean));
    const ruleId = String(finding.ruleId || '').toUpperCase();
    return Array.isArray(queue) ? queue.filter(item => {
      if (!item || item.lifecycle_status !== 'current') return false;
      if (String(item.rule_key || '').toUpperCase() !== ruleId) return false;
      if (!scope.has(String(item.entity_id || ''))) return false;
      if (String(item.run_operational_revision || '') !== String(source.operational_revision || '')) return false;
      if (String(item.run_rule_set_hash || '') !== String(source.rule_set_hash || '')) return false;
      if (String(item.run_model_key || '') !== 'deterministic-stage-a-rules') return false;
      return /^[0-9a-f-]{36}$/i.test(String(item.finding_id || ''))
        && /^[0-9a-f-]{36}$/i.test(String(item.last_seen_run_id || ''))
        && /^[a-f0-9]{64}$/.test(String(item.stable_fingerprint || ''))
        && /^[a-f0-9]{64}$/.test(String(item.evidence_fingerprint || ''));
    }) : [];
  }

  function pdcAuditorBindReviewFindings(findings = [], queue = [], source = {}) {
    const candidates = findings.map(finding => pdcAuditorReviewCandidates(finding, queue, source));
    const usage = new Map();
    candidates.forEach(rows => rows.forEach(item => {
      const id = String(item.finding_id || '');
      if (id) usage.set(id, (usage.get(id) || 0) + 1);
    }));
    return findings.map((finding, index) => {
      const rows = candidates[index];
      if (rows.length !== 1 || usage.get(String(rows[0].finding_id || '')) !== 1) return { ...finding, review: null };
      const item = rows[0];
      const decision = item.decision && ['approved', 'denied'].includes(item.decision.status) ? {
        status: item.decision.status,
        reason: pdcAuditorSafeText(item.decision.reason || '', 500),
        decidedAt: pdcAuditorSafeText(item.decision.decided_at || '', 80),
        decidedByRole: pdcAuditorSafeText(item.decision.decided_by_role || '', 40),
        operationalChange: item.decision.operational_change === true,
      } : null;
      if (decision?.operationalChange) return { ...finding, review: null };
      return {
        ...finding,
        review: {
          findingId: String(item.finding_id),
          evidenceFingerprint: String(item.evidence_fingerprint),
          lastSeenRunId: String(item.last_seen_run_id),
          decision,
        },
      };
    });
  }

function pdcAuditorProjectedReports(evaluated = {}) {
  const reports = evaluated?.projections?.reports;
  return reports && typeof reports === 'object' ? reports : null;
}

function pdcAuditorEvaluateSnapshot(snapshot = {}) {
  const engine = window.PdcAiAuditorStageA;
  let evaluated = null;
  if (engine && typeof engine.analyze === 'function') {
    try { evaluated = engine.analyze(snapshot); } catch (_error) { return null; }
  } else {
    evaluated = snapshot.auditor || snapshot.result || snapshot;
  }
  if (!evaluated || typeof evaluated !== 'object') return null;
  const sourceFindings = Array.isArray(evaluated.findings) ? evaluated.findings
    : Array.isArray(snapshot.findings) ? snapshot.findings
      : Array.isArray(snapshot.auditor_findings) ? snapshot.auditor_findings : null;
  if (!sourceFindings) return null;
  const projectedReports = pdcAuditorProjectedReports(evaluated);
  const reportMembership = new Map();
  if (projectedReports) {
    Object.entries(projectedReports).forEach(([reportName, report]) => {
      const reportFindings = Array.isArray(report) ? report : Array.isArray(report?.findings) ? report.findings : [];
      reportFindings.forEach(finding => {
        const id = String(finding?.id || finding?.finding_id || finding?.recommendationId || '');
        if (!id) return;
        if (!reportMembership.has(id)) reportMembership.set(id, []);
        reportMembership.get(id).push(String(reportName).toLowerCase());
      });
    });
  }
  const normalizedFindings = sourceFindings.slice(0, 500).map((finding, index) => pdcAuditorNormalizeFinding({
    ...finding,
    report_views: reportMembership.get(String(finding?.id || finding?.finding_id || '')) || finding?.report_views,
  }, index));
  const findings = pdcAuditorBindReviewFindings(normalizedFindings, snapshot.reviewQueue, snapshot);
  return {
    revision: snapshot.revision,
    asOf: snapshot.as_of || snapshot.asOf || snapshot.generated_at,
    version: pdcAuditorSafeText(evaluated.version || snapshot.schema_version || 'Stage A', 60),
    hasReportProjections: Boolean(projectedReports),
    findings,
  };
}

function resetPdcAuditorAuthorityState() {
  app.pdcAuditorGeneration += 1;
  try { app.pdcAuditorService?.destroy?.(); } catch (_error) { /* synchronous fail-closed teardown */ }
  try { if (app.pdcAuditorRealtime) window.PDC_SUPABASE?.removeChannel?.(app.pdcAuditorRealtime); } catch (_error) { /* teardown remains fail closed */ }
  app.pdcAuditorRealtime = null;
  app.pdcAuditorService = null;
  app.pdcAuditorSnapshot = null;
  app.pdcAuditorResult = null;
  app.pdcAuditorState = 'idle';
  app.pdcAuditorError = '';
  app.pdcAuditorDecisionInFlight = false;
  app.pdcAuditorDecisionMessage = '';
  app.pdcAuditorDocumentProposals = [];
  app.aiIntakeFiles = [];
  clearAiFileAssistantUploads();
  const state = document.getElementById('ai-auditor-state');
  const summary = document.getElementById('ai-auditor-summary');
  const report = document.getElementById('ai-auditor-report');
  if (state) {
    state.dataset.state = 'unavailable';
    state.setAttribute('aria-busy', 'false');
    state.replaceChildren();
  }
  if (summary) summary.replaceChildren();
  if (report) report.replaceChildren();
}

function pdcAuditorService() {
  if (app.pdcAuditorService) return app.pdcAuditorService;
  if (!auditorAuthorityIdentity() || !getPdcSupabaseAccessToken()) return null;
  app.pdcAuditorService = createPdcAuditorSnapshotService({
    config: window.PDC_SUPABASE_CONFIG || {},
    getAccessToken: () => getPdcSupabaseAccessToken(),
  });
  return app.pdcAuditorService;
}

function subscribePdcAuditorRealtime(dealerCode = '') {
  const client = window.PDC_SUPABASE;
  const dealer = String(dealerCode || '').trim();
  if (app.pdcAuditorRealtime || !client || typeof client.channel !== 'function' || !auditorAuthorityIdentity() || !/^\d{5}$/.test(dealer)) return app.pdcAuditorRealtime;
  app.pdcAuditorRealtime = client.channel('pdc_auditor_revision_read_only')
    .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'pdc_auditor_revision', filter: `dealer_code=eq.${dealer}` }, () => {
      // Realtime is invalidation only. Authority always comes from a fresh RPC snapshot.
      if (document.getElementById('ai-auditor')?.classList.contains('active')) loadPdcAuditorSnapshot({ force: true });
      else app.pdcAuditorService?.invalidate?.();
    })
    .subscribe();
  return app.pdcAuditorRealtime;
}

async function loadPdcAuditorSnapshot({ force = false } = {}) {
  if (app.pdcAuditorState === 'loading' && !force) return false;
  const service = pdcAuditorService();
  const authority = auditorAuthorityIdentity();
  const generation = ++app.pdcAuditorGeneration;
  app.pdcAuditorSnapshot = null;
  app.pdcAuditorResult = null;
  app.pdcAuditorState = 'loading';
  app.pdcAuditorError = '';
  renderPdcAuditor();
  if (!service || !authority) {
    app.pdcAuditorState = 'unavailable';
    app.pdcAuditorError = 'Sign in with an approved account to request the dedicated auditor snapshot.';
    renderPdcAuditor();
    return false;
  }
  const response = await service.getAuditorSnapshot();
  if (generation !== app.pdcAuditorGeneration || service !== app.pdcAuditorService || authority !== auditorAuthorityIdentity()) return false;
  const result = response.ok ? pdcAuditorEvaluateSnapshot(response.snapshot) : null;
  if (!response.ok || !result) {
    app.pdcAuditorSnapshot = null;
    app.pdcAuditorResult = null;
    app.pdcAuditorState = 'unavailable';
    app.pdcAuditorError = response.code === 'permission_denied'
      ? 'Your current account is not authorised to read the auditor snapshot.'
      : 'Auditor snapshot unavailable. No browser or retained operational data was used.';
    renderPdcAuditor();
    return false;
  }
  app.pdcAuditorSnapshot = response.snapshot;
  app.pdcAuditorResult = result;
  app.pdcAuditorState = 'ready';
  subscribePdcAuditorRealtime(response.snapshot.dealer_code);
  renderPdcAuditor();
  return true;
}

function pdcAuditorFindingsForReport(result = app.pdcAuditorResult, report = app.pdcAuditorReport) {
  const findings = Array.isArray(result?.findings) ? result.findings : [];
  if (report === 'critical') return findings.filter(item => item.severity === 'critical');
  const explicitlyScoped = findings.filter(item => item.reportViews.includes(report));
  return result?.hasReportProjections ? explicitlyScoped : findings;
}

function pdcAuditorFilteredFindings(findings = []) {
  const severity = app.pdcAuditorSeverityFilter || 'all';
  const category = app.pdcAuditorCategoryFilter || 'all';
  const query = cleanNavisionText(app.pdcAuditorSearch || '').toLowerCase();
  return findings.filter(item => {
    if (severity !== 'all' && item.severity !== severity) return false;
    if (category !== 'all') {
      const def = PDC_AUDITOR_CATEGORY_DEFS.find(entry => entry.key === category);
      if (!def || typeof def.matches !== 'function' || !def.matches(item)) return false;
    }
    if (!query) return true;
    return [item.ruleId, item.title, item.explanation, item.vehicleLabel, item.sourceRef, ...(item.evidence || [])]
      .some(value => String(value || '').toLowerCase().includes(query));
  });
}

function openPdcAuditorSnapshotVehicleDetail(row = {}) {
  const modal = $('#vehicle-modal');
  const host = $('#vehicle-detail');
  if (!modal || !host || !row || typeof row !== 'object') return false;
  const workItems = Array.isArray(row.work_items) ? row.work_items : [];
  const bookings = Array.isArray(row.bookings) ? row.bookings : [];
  const workRows = workItems.map(item => `<tr><td>${escapeHtml(item.work_key || '—')}</td><td>${escapeHtml(item.status || '—')}</td><td>${escapeHtml(item.completed_at || '—')}</td></tr>`).join('');
  const bookingRows = bookings.map(item => `<tr><td>${escapeHtml(item.stage_code || '—')}</td><td>${escapeHtml(item.status || '—')}</td><td>${escapeHtml(item.scheduled_start_at || '—')}</td><td>${escapeHtml(item.scheduled_end_at || '—')}</td></tr>`).join('');
  host.innerHTML = `<div class="vehicle-detail-page"><div class="ai-auditor-read-only-banner" role="status"><strong>BETA – HUMAN REVIEW / NO AUTOMATIC CHANGES</strong><span>This exact vehicle detail is rendered only from the authenticated auditor snapshot.</span></div><div class="panel-header"><div><span class="eyebrow">Vehicle Detail · read only</span><h2 id="vehicle-modal-title">${escapeHtml(row.stock_number || row.key_number || 'Authenticated vehicle')}</h2><p>${escapeHtml(row.model || 'Model unavailable')}</p></div></div><div class="summary-grid"><article><span>Location</span><strong>${escapeHtml(row.location?.code || '—')}</strong></article><article><span>Workshop status</span><strong>${escapeHtml(row.workshop?.status || '—')}</strong></article><article><span>Lifecycle</span><strong>${escapeHtml(row.lifecycle?.state || '—')}</strong></article></div><section><h3>Work</h3><div class="table-wrap"><table class="data-table compact-table"><thead><tr><th>Work</th><th>Status</th><th>Completed</th></tr></thead><tbody>${workRows || '<tr><td colspan="3">No authoritative work rows</td></tr>'}</tbody></table></div></section><section><h3>Bookings</h3><div class="table-wrap"><table class="data-table compact-table"><thead><tr><th>Stage</th><th>Status</th><th>Start</th><th>End</th></tr></thead><tbody>${bookingRows || '<tr><td colspan="4">No explicit authoritative bookings</td></tr>'}</tbody></table></div></section></div>`;
  modal.hidden = false;
  document.body.classList.add('modal-open');
  $('#modal-close')?.focus();
  return true;
}

function openPdcAuditorVehicle(vehicleId = '') {
  const id = String(vehicleId || '').trim();
  if (!id) return false;
  const auditorRows = Array.isArray(app.pdcAuditorSnapshot?.items) ? app.pdcAuditorSnapshot.items : [];
  const exact = auditorRows.filter(row => String(row?.vehicle_id || '').trim() === id);
  return exact.length === 1 ? openPdcAuditorSnapshotVehicleDetail(exact[0]) : false;
}

function selectPdcAuditorReport(report = 'morning') {
  const allowed = ['morning', 'midday', 'eod', 'critical'];
  app.pdcAuditorReport = allowed.includes(report) ? report : 'morning';
  renderPdcAuditor();
  document.querySelector(`[data-ai-auditor-report="${app.pdcAuditorReport}"]`)?.focus();
}

async function pdcAuditorRecordDecision(finding, decision) {
  if (app.pdcAuditorDecisionInFlight || !finding?.review || finding.review.decision) return false;
  const service = pdcAuditorService();
  if (!service || app.pdcAuditorSnapshot?.reviewCanDecide !== true) return false;
  let reason = null;
  if (decision === 'approved') {
    if (!window.confirm('Approve this recommendation?\n\nThis records your review decision only. It will not change any vehicle, booking, Parts, location, workflow or provider.')) return false;
  } else {
    reason = window.prompt('Why are you denying this recommendation? (3–500 characters)');
    if (reason == null) return false;
    reason = String(reason).trim();
    if (reason.length < 3 || reason.length > 500) {
      app.pdcAuditorDecisionMessage = 'Enter a denial reason between 3 and 500 characters.';
      renderPdcAuditor();
      return false;
    }
  }
  app.pdcAuditorDecisionInFlight = true;
  app.pdcAuditorDecisionMessage = `${decision === 'approved' ? 'Approving' : 'Denying'} recommendation…`;
  renderPdcAuditor();
  const receipt = await service.decideFinding({
    findingId: finding.review.findingId,
    evidenceFingerprint: finding.review.evidenceFingerprint,
    lastSeenRunId: finding.review.lastSeenRunId,
    decision,
    reason,
  });
  app.pdcAuditorDecisionInFlight = false;
  if (!receipt?.ok) {
    app.pdcAuditorDecisionMessage = receipt?.code === 'stale'
      ? 'This recommendation is stale. Refresh the Auditor before deciding.'
      : receipt?.code === 'already_decided'
        ? 'This recommendation already has a different decision.'
        : receipt?.code === 'permission_denied'
          ? 'Your role cannot record Auditor decisions.'
          : receipt?.code === 'decision_outcome_unknown'
            ? 'The decision result could not be confirmed. Refresh before retrying; do not submit a different decision.'
            : 'The decision could not be accepted. No operational action was requested.';
    renderPdcAuditor();
    return false;
  }
  app.pdcAuditorDecisionMessage = `${decision === 'approved' ? 'Approved' : 'Denied'} — review recorded. No operational changes were made.`;
  await loadPdcAuditorSnapshot({ force: true });
  return true;
}

function pdcAuditorDecisionDate(value = '') {
  const parsed = new Date(String(value || ''));
  return Number.isNaN(parsed.getTime())
    ? 'Decision time unavailable'
    : parsed.toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' });
}

function renderPdcAuditor() {
  const state = $('#ai-auditor-state');
  const summary = $('#ai-auditor-summary');
  const reportHost = $('#ai-auditor-report');
  if (!state || !summary || !reportHost) return;
  const canUploadEvidence = app.pdcAuditorSnapshot?.reviewCanDecide === true;
  const uploadInput = $('#ai-intake-upload');
  const uploadAnalyze = $('#ai-intake-analyze');
  if (uploadInput) uploadInput.disabled = !canUploadEvidence;
  if (uploadAnalyze) uploadAnalyze.disabled = !canUploadEvidence || !(Array.isArray(app.aiIntakeFiles) && app.aiIntakeFiles.length);
  const result = app.pdcAuditorResult;
  const ready = app.pdcAuditorState === 'ready' && result;
  state.dataset.state = ready ? 'ready' : (app.pdcAuditorState === 'loading' ? 'loading' : 'unavailable');
  state.setAttribute('aria-busy', String(app.pdcAuditorState === 'loading'));
  state.innerHTML = app.pdcAuditorState === 'loading'
    ? '<strong>Requesting auditor snapshot</strong><span>Findings stay hidden until current authenticated authority is confirmed.</span>'
    : ready
      ? `<strong>Read-only snapshot ready</strong><span>Revision ${escapeHtml(String(result.revision))} · as of ${escapeHtml(String(result.asOf))} · engine ${escapeHtml(result.version)}</span>`
      : `<strong>Auditor not assessed</strong><span>${escapeHtml(app.pdcAuditorError || 'The dedicated auditor snapshot is not available. No fallback data was used.')}</span>`;
  const findings = ready ? result.findings : [];
  const filterSummary = $('#ai-auditor-filter-summary');
  summary.innerHTML = PDC_AUDITOR_CATEGORY_DEFS.map(def => `<article style="--auditor-category-colour:${def.colour}"><span>${escapeHtml(def.label)}</span><strong>${ready ? findings.filter(item => typeof def.matches === 'function' ? def.matches(item) : item.category === def.key).length : '—'}</strong></article>`).join('');
  $$('[data-ai-auditor-report]').forEach(button => {
    const selected = button.dataset.aiAuditorReport === app.pdcAuditorReport;
    button.setAttribute('aria-selected', String(selected));
    button.tabIndex = selected ? 0 : -1;
  });
  const activeTab = $(`[data-ai-auditor-report="${app.pdcAuditorReport}"]`);
  if (activeTab) reportHost.setAttribute('aria-labelledby', activeTab.id);
  if (!ready) {
    if (filterSummary) filterSummary.textContent = 'Authoritative totals are not changed by filters.';
    reportHost.innerHTML = '<div class="empty-state"><strong>No trusted auditor snapshot</strong><span>Findings remain hidden until the dedicated service succeeds.</span></div>';
    return;
  }
  const authoritativeReportFindings = pdcAuditorFindingsForReport(result, app.pdcAuditorReport);
  const reportFindings = pdcAuditorFilteredFindings(authoritativeReportFindings);
  if (filterSummary) filterSummary.textContent = `Showing ${reportFindings.length} of ${authoritativeReportFindings.length} recommendations in this report. Summary cards remain authoritative totals.`;
  const reportLabel = ({ morning: 'Morning', midday: 'Midday', eod: 'EOD', critical: 'Critical' })[app.pdcAuditorReport];
  const decisionMessage = app.pdcAuditorDecisionMessage
    ? `<div class="ai-auditor-decision-message" role="status">${escapeHtml(app.pdcAuditorDecisionMessage)}</div>` : '';
  reportHost.innerHTML = `<div class="ai-auditor-report-heading"><h3>${escapeHtml(reportLabel)} report</h3><span>Human review · ${reportFindings.length} finding${reportFindings.length === 1 ? '' : 's'}</span></div>${decisionMessage}${reportFindings.length ? `<ol class="ai-auditor-findings">${reportFindings.map(item => {
    const def = PDC_AUDITOR_CATEGORY_DEFS.find(category => category.key === item.category) || PDC_AUDITOR_CATEGORY_DEFS.at(-1);
    const recorded = item.review?.decision;
    const decisionHtml = recorded
      ? `<div class="ai-auditor-review-status is-${escapeHtml(recorded.status)}"><strong>${recorded.status === 'approved' ? 'Approved' : 'Denied'}</strong><span>${recorded.decidedAt ? `Recorded ${escapeHtml(pdcAuditorDecisionDate(recorded.decidedAt))}` : 'Decision recorded'} · no operational change</span>${recorded.reason ? `<p>${escapeHtml(recorded.reason)}</p>` : ''}</div>`
      : item.review && app.pdcAuditorSnapshot?.reviewCanDecide === true
        ? `<div class="ai-auditor-decision-actions" aria-label="Review recommendation"><button type="button" data-ai-auditor-decision="approved" data-finding-id="${escapeHtml(item.id)}" ${app.pdcAuditorDecisionInFlight ? 'disabled' : ''}>Approve</button><button type="button" data-ai-auditor-decision="denied" data-finding-id="${escapeHtml(item.id)}" ${app.pdcAuditorDecisionInFlight ? 'disabled' : ''}>Deny</button><small>Records review only — it does not execute the recommendation.</small></div>`
        : `<div class="ai-auditor-review-status is-pending"><strong>${item.review ? 'View only' : 'Awaiting Auditor publication'}</strong><span>${item.review ? 'Operator or Administrator access is required to decide.' : 'Approve/Deny becomes available after this exact finding is published by the authenticated Auditor.'}</span></div>`;
    return `<li class="ai-auditor-finding" style="--auditor-category-colour:${def.colour}"><div class="ai-auditor-finding-header"><div class="ai-auditor-finding-title"><span>${escapeHtml(def.label)} · ${escapeHtml(item.severity)}</span><strong>${escapeHtml(item.title)}</strong>${item.vehicleLabel ? `<small>Vehicle ${escapeHtml(item.vehicleLabel)}</small>` : ''}</div>${item.vehicleId ? `<button class="small-button ai-auditor-open-vehicle" type="button" data-ai-auditor-open-vehicle="${escapeHtml(item.vehicleId)}">Open Vehicle</button>` : ''}</div><p>${escapeHtml(item.explanation)}</p>${item.recommendedAction ? `<div class="ai-auditor-limitations"><strong>Recommended staff action:</strong> ${escapeHtml(item.recommendedAction)}</div>` : ''}<details class="ai-auditor-evidence"><summary>View Evidence (${item.evidence.length})</summary>${item.evidence.length ? `<ul>${item.evidence.map(value => `<li>${escapeHtml(value)}</li>`).join('')}</ul>` : '<p>No displayable evidence was supplied by the snapshot.</p>'}</details>${item.sourceRef ? `<small>Source ref: ${escapeHtml(item.sourceRef)}</small>` : ''}${item.limitation ? `<div class="ai-auditor-limitations">Evidence limitation: ${escapeHtml(item.limitation)}</div>` : ''}${decisionHtml}</li>`;
  }).join('')}</ol>` : '<div class="empty-state"><strong>No findings in this report view</strong><span>This is not an approval or guarantee. Continue normal staff checks.</span></div>'}`;
  $$('[data-ai-auditor-open-vehicle]', reportHost).forEach(button => button.addEventListener('click', () => {
    if (!openPdcAuditorVehicle(button.dataset.aiAuditorOpenVehicle)) {
      button.setAttribute('aria-describedby', 'ai-auditor-state');
      state.dataset.state = 'unavailable';
      state.innerHTML = '<strong>Vehicle detail unavailable</strong><span>The snapshot identity did not uniquely match the authenticated vehicle projection. No first match was selected.</span>';
    }
  }));
  $$('[data-ai-auditor-decision]', reportHost).forEach(button => button.addEventListener('click', () => {
    const finding = reportFindings.find(item => item.id === button.dataset.findingId);
    if (finding) pdcAuditorRecordDecision(finding, button.dataset.aiAuditorDecision);
  }));
}

function pdcAuditorSuggestedStage(description = '') {
  const value = cleanNavisionText(description).toLowerCase();
  if (!value) return '';
  if (/\b(?:electrical|electric|wire|wiring|battery|light|camera|sensor|radio|uhf|solar)\b/.test(value)) return 'ELECTRICAL';
  if (/\btint(?:ing|ed)?\b/.test(value)) return 'TINT';
  if (/\b(?:pit inspection|final pit inspection)\b/.test(value)) return 'PIT_INSPECTION';
  if (/\b(?:hoist|underbody inspection|pre[- ]?delivery inspection)\b/.test(value)) return 'HOIST';
  if (/\b(?:fabricat(?:e|ion)|weld|cutting|bracket)\b/.test(value)) return 'FABRICATION';
  if (/\b(?:tyre|tire|wheel|alignment)\b/.test(value)) return 'TYRE';
  if (/\b(?:bus\s*4x4|4x4 conversion)\b/.test(value)) return 'BUS_4X4';
  if (/\b(?:fit|fitting|install|installation|mount|bullbar|towbar|rack|step|snorkel|accessor(?:y|ies))\b/.test(value)) return 'FITTING';
  return '';
}

function pdcAuditorUploadedOperationLines(text = '') {
  const rows = [];
  String(text || '').replace(/\r\n?/g, '\n').split('\n').forEach((raw, index) => {
    const line = cleanNavisionText(raw);
    if (!line || line.length > 500) return;
    const labelled = line.match(/(?:estimated\s*)?(?:labou?r\s*)?(?:hours?|hrs?)\s*[:=-]?\s*(\d+(?:\.\d{1,2})?)/i);
    const trailing = line.match(/(?:^|\s)(\d+(?:\.\d{1,2})?)\s*(?:h|hr|hrs|hours)\s*$/i);
    const match = labelled || trailing;
    if (!match) return;
    const estimatedHours = Number(match[1]);
    if (!Number.isFinite(estimatedHours) || estimatedHours < 0 || estimatedHours > 999.75) return;
    const description = cleanNavisionText(line
      .replace(match[0], ' ')
      .replace(/^\s*(?:op(?:eration)?\s*)[#:-]?\s*[a-z0-9-]{1,16}\s*[:.)-]?\s*/i, '')
      .replace(/^\s*[a-z0-9-]{1,16}\s*[:.)-]\s+/i, ''))
      .slice(0, 180);
    if (!description || /^total\b/i.test(description)) return;
    const stage = pdcAuditorSuggestedStage(description);
    rows.push({
      id: `upload-line:${index + 1}:${description.toLowerCase()}`,
      description,
      estimatedHours,
      stage,
      sourceLine: index + 1,
    });
  });
  return rows;
}

function pdcAuditorUploadedDocumentProposal(text = '', file = {}, sourceEvidence = {}) {
  const sourceText = String(text || '');
  const flattened = cleanNavisionText(sourceText);
  const filename = cleanNavisionText(file?.name || 'uploaded document');
  const stock = (flattened.match(/\bstock\s*(?:no\.?|number|#)?\s*[:#-]?\s*([a-z0-9-]{5,20})\b/i) || [])[1] || '';
  const jobCard = (flattened.match(/\b(?:job\s*card|j\/?c)\s*(?:no\.?|number|#)?\s*[:#-]?\s*([a-z0-9-]{3,24})\b/i) || [])[1] || '';
  const documentType = /\bsublet\b|\bprovider\b|\bexpected\s+return\b/i.test(`${filename} ${flattened}`)
    ? 'Sublet information'
    : /\bjob\s*card\b|\bj\/?c\b/i.test(`${filename} ${flattened}`)
      ? 'Job card'
      : 'Workshop document';
  const lines = pdcAuditorUploadedOperationLines(sourceText);
  const warnings = [];
  if (!stock) warnings.push('Stock number was not found; exact vehicle binding is required before any staff adjustment.');
  if (!lines.length) warnings.push('No operation line with an explicit estimated-hour value was detected.');
  if (lines.some(line => !line.stage)) warnings.push('One or more operation lines have no safe station match and require staff classification.');
  const sha256 = String(sourceEvidence?.sha256 || '').toLowerCase();
  return {
    id: sha256 ? `auditor-upload:${sha256}` : aiFileAssistantReviewId('auditor-upload-unbound'),
    filename,
    documentType,
    stock: cleanNavisionText(stock).toUpperCase(),
    jobCard: cleanNavisionText(jobCard).toUpperCase(),
    lines,
    warnings,
    sourceEvidence: {
      sha256,
      byteLength: Number(sourceEvidence?.byteLength || 0),
      mediaType: cleanNavisionText(sourceEvidence?.mediaType || file?.type || ''),
      lastModified: Number(sourceEvidence?.lastModified || file?.lastModified || 0),
    },
    receivedAt: nowIsoString(),
  };
}

function renderPdcAuditorDocumentProposals() {
  const host = $('#ai-auditor-upload-proposals');
  if (!host) return;
  const proposals = Array.isArray(app.pdcAuditorDocumentProposals) ? app.pdcAuditorDocumentProposals : [];
  if (!proposals.length) {
    host.innerHTML = '<div class="empty-state compact-empty"><strong>No uploaded document proposals</strong><span>Uploaded files stay review-only and are cleared when this page session resets.</span></div>';
    return;
  }
  host.innerHTML = `<div class="ai-auditor-upload-proposal-list">${proposals.map(proposal => {
    const lines = proposal.lines || [];
    const evidence = proposal.sourceEvidence || {};
    const lineRows = lines.map(line => `<tr><td>${escapeHtml(line.sourceLine)}</td><td>${escapeHtml(line.description)}</td><td>${escapeHtml(line.stage ? pmbStageLabel(line.stage) : 'Review required')}</td><td>${escapeHtml(Number(line.estimatedHours).toFixed(2))}h</td></tr>`).join('');
    const warningHtml = (proposal.warnings || []).length
      ? `<ul class="ai-auditor-upload-warnings">${proposal.warnings.map(warning => `<li>${escapeHtml(warning)}</li>`).join('')}</ul>` : '';
    const evidenceHtml = evidence.sha256 ? `<p class="ai-auditor-upload-evidence"><strong>Evidence SHA-256:</strong> <code>${escapeHtml(evidence.sha256)}</code> · ${escapeHtml(evidence.byteLength)} bytes</p>` : '<p class="ai-auditor-upload-evidence is-unbound"><strong>Evidence hash unavailable — proposal is not reviewable.</strong></p>';
    return `<article class="ai-auditor-upload-proposal"><div class="ai-auditor-upload-proposal-heading"><div><span class="eyebrow">Review-only ${escapeHtml(proposal.documentType)}</span><h3>${escapeHtml(proposal.filename)}</h3><p>Stock ${escapeHtml(proposal.stock || 'not detected')} · JC ${escapeHtml(proposal.jobCard || 'not detected')} · ${lines.length} estimated line${lines.length === 1 ? '' : 's'}</p></div>${proposal.stock && evidence.sha256 ? `<button type="button" class="small-button" data-ai-auditor-review-stock="${escapeHtml(proposal.stock)}">Open Workshop to review</button>` : ''}</div>${evidenceHtml}${warningHtml}${lines.length ? `<div class="table-wrap"><table class="data-table compact-table"><thead><tr><th>Source line</th><th>Operation</th><th>Suggested station</th><th>Document hours</th></tr></thead><tbody>${lineRows}</tbody></table></div>` : ''}<div class="ai-auditor-limitations"><strong>No automatic changes:</strong> this extraction is evidence for staff review only. Any accepted station/hour edit must be made through the separate audited Workshop control.</div></article>`;
  }).join('')}</div>`;
  $$('[data-ai-auditor-review-stock]', host).forEach(button => button.addEventListener('click', () => {
    if (!openAuthenticatedOperationWorkshop(button.dataset.aiAuditorReviewStock)) {
      setAiFileAssistantStatus([{ ok: false, title: 'Exact vehicle not found', message: `Stock ${button.dataset.aiAuditorReviewStock} did not resolve uniquely in the authenticated Workshop data.` }]);
    }
  }));
}

function loadAiFileAssistantReviews() {
  const reviews = loadJson(AI_FILE_ASSISTANT_REVIEWS_KEY, []);
  return Array.isArray(reviews) ? reviews.filter(item => item && typeof item === 'object' && cleanNavisionText(item.id || '')) : [];
}

function saveAiFileAssistantReviews(reviews = []) {
  const safeReviews = (Array.isArray(reviews) ? reviews : [])
    .filter(item => item && typeof item === 'object' && cleanNavisionText(item.id || ''))
    .slice(-200);
  saveJson(AI_FILE_ASSISTANT_REVIEWS_KEY, safeReviews);
}

function aiFileAssistantReviewId(prefix = 'ai-review') {
  const random = Math.random().toString(36).slice(2, 8);
  return `${prefix}:${Date.now().toString(36)}:${random}`;
}

function aiAssistantReviewWarnings(review = {}) {
  return Array.isArray(review.analysisWarnings) ? review.analysisWarnings.map(item => cleanNavisionText(item)).filter(Boolean) : [];
}

function aiAssistantReviewSourceFiles(review = {}) {
  return Array.isArray(review.sourceFiles) ? review.sourceFiles.map(item => cleanNavisionText(item)).filter(Boolean) : [];
}

function aiAssistantReviewMetaHtml(review = {}) {
  const warnings = aiAssistantReviewWarnings(review);
  const files = aiAssistantReviewSourceFiles(review);
  const confidence = cleanNavisionText(review.analysisConfidence || '');
  const summary = cleanNavisionText(review.analysisSummary || '');
  const sourceType = cleanNavisionText(review.sourceType || '');
  if (!warnings.length && !files.length && !confidence && !summary && !sourceType) return '';
  return `<div class="email-review-analysis-meta">${[
    summary ? `<span><b>Analysis:</b> ${escapeHtml(summary)}</span>` : '',
    sourceType ? `<span><b>Source:</b> ${escapeHtml(sourceType)}</span>` : '',
    confidence ? `<span><b>Confidence:</b> ${escapeHtml(confidence)}</span>` : '',
    files.length ? `<span><b>Files:</b> ${escapeHtml(files.join(', '))}</span>` : '',
    warnings.length ? `<span><b>Warnings:</b> ${escapeHtml(warnings.join(' · '))}</span>` : ''
  ].filter(Boolean).join('')}</div>`;
}

function aiAssistantTaskJobLines(tasks = []) {
  return [...new Set((Array.isArray(tasks) ? tasks : []).map(task => cleanNavisionText(task)).filter(Boolean))].map(description => {
    const stage = pdcJobLineStage({ description });
    const line = {
      description,
      quantity: 1,
      estimatedHours: null,
      estimateStatus: 'review-required',
      estimateSource: 'Phase 1 file analysis · enter labour hours before pushing to the PDC board',
      suggestedStage: stage,
      category: stage,
      source: 'AI file assistant',
    };
    line.id = pdcJobLineIdentity(line);
    return line;
  });
}

function aiAssistantVehicleImportReview(kind = 'pd', parsed = {}, files = [], detectedWarnings = []) {
  const preview = workImportReviewPreviewVehicle('pd', parsed, findVehicleForPd(parsed));
  const sourceFiles = (Array.isArray(files) ? files : []).map(item => cleanNavisionText(item)).filter(Boolean);
  const warnings = [...new Set((Array.isArray(detectedWarnings) ? detectedWarnings : []).map(item => cleanNavisionText(item)).filter(Boolean))];
  const id = aiFileAssistantReviewId('ai-pd');
  const receivedAt = nowIsoString();
  const stock = cleanNavisionText(parsed.stock || parsed.reference || preview.stock || preview.batch || '');
  const jobLines = aiAssistantTaskJobLines(parsed.tasks || []);
  const confidence = ((parsed.stock || parsed.vin) && jobLines.length ? 'medium' : 'low');
  return {
    id,
    intakeId: id,
    type: 'vehicle-import',
    source: 'AI file assistant',
    sender: 'Local file upload',
    receivedAt,
    stock,
    vehicle: {
      stock,
      batch: stock,
      vin: normalizeVin(parsed.vin || preview.vin || ''),
      client: cleanNavisionText(parsed.customer || parsed.client || preview.client || ''),
      vehicle: cleanNavisionText(parsed.vehicle || preview.vehicle || ''),
      consultant: cleanNavisionText(parsed.salesperson || preview.consultant || ''),
      colour: cleanNavisionText(parsed.colour || preview.colour || ''),
      trim: cleanNavisionText(parsed.trim || preview.trim || ''),
      pmbSubletProvider: cleanNavisionText(parsed.subletProvider || preview.pmbSubletProvider || ''),
    },
    jobLines,
    sourceFiles,
    sourceType: 'PD Document',
    analysisSummary: `Detected ${jobLines.length || 0} work item${jobLines.length === 1 ? '' : 's'} from the uploaded PD Document`,
    analysisConfidence: confidence,
    analysisWarnings: warnings,
  };
}

function parseAiAssistantPartsUpdate(text = '', sourceFilename = '') {
  const source = String(text || '').replace(/\r/g, '\n');
  const squashed = source.replace(/\s+/g, ' ').trim();
  if (!/\bparts?\b|back\s*order|eta|stoppage|received|issued/i.test(squashed)) return null;
  const stock = (squashed.match(/\bstock\s*(?:no\.?|number|#)?\s*[:#-]?\s*(\d{6,12})\b/i) || squashed.match(/\b(\d{6,12})\b/) || [])[1] || '';
  if (!stock) return null;
  const rawEta = (source.match(/\bETA\s*[:#-]?\s*([^\n]+)/i) || source.match(/\b(\d{1,2}[\/.-]\d{1,2}[\/.-]\d{2,4})\b/) || [])[1] || '';
  const notes = cleanNavisionText(source.split('\n').map(line => cleanNavisionText(line)).filter(Boolean).slice(0, 3).join(' · ')).slice(0, 280);
  const action = /\breceived\b|\bissued\b|\bcomplete\b/.test(squashed)
    ? 'complete'
    : (/\bstoppage\b|back\s*order|awaiting|\beta\b/.test(squashed) ? 'stoppage' : 'note');
  const warning = action === 'note' ? 'No clear complete/STOPPAGE action was detected; review before applying.' : '';
  return {
    id: aiFileAssistantReviewId('ai-parts'),
    intakeId: aiFileAssistantReviewId('ai-parts-intake'),
    type: 'parts-update',
    source: 'AI file assistant',
    sender: 'Local file upload',
    receivedAt: nowIsoString(),
    stock,
    action,
    eta: cleanNavisionText(rawEta),
    notes,
    reason: action === 'stoppage' ? cleanNavisionText(notes || 'Parts STOPPAGE from uploaded file') : '',
    sourceFiles: [cleanNavisionText(sourceFilename)].filter(Boolean),
    sourceType: 'Parts update text file',
    analysisSummary: `Detected Parts ${action === 'complete' ? 'completion' : action === 'stoppage' ? 'STOPPAGE' : 'note'} for stock ${stock}`,
    analysisConfidence: action === 'note' ? 'low' : 'medium',
    analysisWarnings: warning ? [warning] : [],
  };
}

function analyzeAiAssistantText(text = '', file = {}) {
  const filename = cleanNavisionText(file?.name || 'uploaded file');
  const documentText = `${filename}\n${String(text || '')}`;
  const isPdDocument = /\bpre\s*delivery\s*check\s*form\b|\bpd\s*document\b|pdcheckform/i.test(documentText);
  if (!isPdDocument && /\bpurchase\s+order\b|\bjob\s*card\b/i.test(documentText)) {
    return { ok: false, message: `${filename}: vehicle work must be uploaded as a PD Document. Purchase orders and job cards are not imported.` };
  }
  if (isPdDocument) {
    const pd = parsePdCheckFormText(text, [filename]);
    if (cleanNavisionText(pd.stock || pd.vin || '') || (Array.isArray(pd.tasks) && pd.tasks.length)) {
      const warnings = [];
      if (!pd.tasks?.length) warnings.push('No safe work lines were detected automatically. Add or amend the review lines before applying.');
      return { ok: true, review: aiAssistantVehicleImportReview('pd', pd, [filename], warnings), message: `${filename}: PD Document draft created with ${(pd.tasks || []).length} detected work item${(pd.tasks || []).length === 1 ? '' : 's'}.` };
    }
    return { ok: false, message: `${filename}: no safe PD Document review draft could be created from this file.` };
  }
  const parts = parseAiAssistantPartsUpdate(text, filename);
  if (parts) {
    return { ok: true, review: parts, message: `${filename}: Parts review draft created for stock ${parts.stock}.` };
  }
  return { ok: false, message: `${filename}: vehicle work must be uploaded as a PD Document. Purchase orders and job cards are not imported.` };
}

function setAiFileAssistantStatus(rows = []) {
  const host = $('#ai-intake-status');
  app.aiIntakeStatus = Array.isArray(rows) ? rows : [];
  if (!host) return;
  if (!app.aiIntakeStatus.length) {
    host.innerHTML = '<div class="empty-state compact-empty"><strong>No files queued</strong><span>Add one or more files above to create review drafts.</span></div>';
    return;
  }
  host.innerHTML = `<div class="email-intake-status-list">${app.aiIntakeStatus.map(row => `<div class="summary-row ${row.ok ? 'navision-updated' : 'navision-skipped'}"><strong>${escapeHtml(row.title || 'AI file analysis')}</strong><span>${escapeHtml(row.message || '')}</span></div>`).join('')}</div>`;
}

function updateAiFileAssistantButtons() {
  const files = Array.isArray(app.aiIntakeFiles) ? app.aiIntakeFiles : [];
  const analyze = $('#ai-intake-analyze');
  const clear = $('#ai-intake-clear');
  const auditorAllowed = !$('#ai-auditor-upload-proposals') || app.pdcAuditorSnapshot?.reviewCanDecide === true;
  if (analyze) {
    analyze.disabled = !files.length || !auditorAllowed;
    analyze.textContent = files.length ? `Analyse files (${files.length})` : 'Analyse files';
  }
  if (clear) {
    const proposals = Array.isArray(app.pdcAuditorDocumentProposals) ? app.pdcAuditorDocumentProposals : [];
    clear.disabled = !files.length && !proposals.length;
  }
}

async function aiFileAssistantSourceEvidence(file) {
  if (!globalThis.crypto?.subtle || typeof file?.arrayBuffer !== 'function') throw new Error('Secure file hashing is unavailable.');
  const bytes = await file.arrayBuffer();
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
  const sha256 = [...new Uint8Array(digest)].map(value => value.toString(16).padStart(2, '0')).join('');
  return Object.freeze({
    sha256,
    byteLength: bytes.byteLength,
    mediaType: cleanNavisionText(file?.type || ''),
    lastModified: Number(file?.lastModified || 0),
  });
}

function aiFileAssistantAcceptedFiles(files = []) {
  return [...(files || [])].slice(0, 10).filter(file => {
    const name = String(file?.name || '');
    const type = String(file?.type || '').toLowerCase();
    const size = Number(file?.size || 0);
    const supported = /\.(?:pdf|txt|csv|tsv)$/i.test(name) || ['application/pdf', 'text/plain', 'text/csv', 'text/tab-separated-values'].includes(type);
    return supported && Number.isFinite(size) && size <= 10 * 1024 * 1024;
  });
}

function handleAiFileAssistantSelect(event) {
  app.aiIntakeAnalysisGeneration += 1;
  if ($('#ai-auditor-upload-proposals') && app.pdcAuditorSnapshot?.reviewCanDecide !== true) {
    app.aiIntakeFiles = [];
    if (event?.target) event.target.value = '';
    updateAiFileAssistantButtons();
    setAiFileAssistantStatus([{ ok: false, title: 'Upload not authorised', message: 'Operator or Administrator access is required to analyse Workshop evidence.' }]);
    return false;
  }
  const selected = [...(event?.target?.files || [])];
  app.aiIntakeFiles = aiFileAssistantAcceptedFiles(selected);
  updateAiFileAssistantButtons();
  setAiFileAssistantStatus(app.aiIntakeFiles.length
    ? [{ ok: true, title: `${app.aiIntakeFiles.length} file${app.aiIntakeFiles.length === 1 ? '' : 's'} ready`, message: app.aiIntakeFiles.map(file => cleanNavisionText(file.name || 'uploaded file')).join(', ') }]
    : [{ ok: false, title: 'No supported files', message: 'Use up to 10 PDF, TXT, CSV or TSV files, each no larger than 10 MB.' }]);
  return app.aiIntakeFiles.length > 0;
}

function handleAiFileAssistantDragOver(event) {
  event?.preventDefault?.();
  if (app.pdcAuditorSnapshot?.reviewCanDecide !== true) return;
  if (event?.dataTransfer) event.dataTransfer.dropEffect = 'copy';
  event?.currentTarget?.classList?.add('is-dragover');
}

function handleAiFileAssistantDragLeave(event) {
  event?.preventDefault?.();
  event?.currentTarget?.classList?.remove('is-dragover');
}

function handleAiFileAssistantDropZoneKeydown(event) {
  if (!['Enter', ' '].includes(event?.key)) return;
  event.preventDefault();
  if (app.pdcAuditorSnapshot?.reviewCanDecide !== true) {
    setAiFileAssistantStatus([{ ok: false, title: 'Upload not authorised', message: 'Operator or Administrator access is required to analyse Workshop evidence.' }]);
    return;
  }
  $('#ai-intake-upload')?.click?.();
}

function handleAiFileAssistantDrop(event) {
  event?.preventDefault?.();
  event?.currentTarget?.classList?.remove('is-dragover');
  app.aiIntakeAnalysisGeneration += 1;
  if (app.pdcAuditorSnapshot?.reviewCanDecide !== true) {
    setAiFileAssistantStatus([{ ok: false, title: 'Upload not authorised', message: 'Operator or Administrator access is required to analyse Workshop evidence.' }]);
    return false;
  }
  const dropped = [...(event?.dataTransfer?.files || [])];
  app.aiIntakeFiles = aiFileAssistantAcceptedFiles(dropped);
  updateAiFileAssistantButtons();
  setAiFileAssistantStatus(app.aiIntakeFiles.length
    ? [{ ok: true, title: `${app.aiIntakeFiles.length} dropped file${app.aiIntakeFiles.length === 1 ? '' : 's'} ready`, message: app.aiIntakeFiles.map(file => cleanNavisionText(file.name || 'uploaded file')).join(', ') }]
    : [{ ok: false, title: 'No supported files', message: 'Use up to 10 PDF, TXT, CSV or TSV files, each no larger than 10 MB.' }]);
  return app.aiIntakeFiles.length > 0;
}

function clearAiFileAssistantUploads(preserveStatus = false, preserveProposals = false) {
  app.aiIntakeAnalysisGeneration += 1;
  app.aiIntakeFiles = [];
  if (!preserveProposals) app.pdcAuditorDocumentProposals = [];
  const input = $('#ai-intake-upload');
  if (input) input.value = '';
  updateAiFileAssistantButtons();
  renderPdcAuditorDocumentProposals();
  if (!preserveStatus) setAiFileAssistantStatus([]);
}

async function analyzeAiFileAssistantUploads() {
  const files = Array.isArray(app.aiIntakeFiles) ? app.aiIntakeFiles : [];
  if (!files.length) {
    setAiFileAssistantStatus([{ ok: false, title: 'No files selected', message: 'Choose one or more PDFs or text files first.' }]);
    return false;
  }
  const analyzeButton = $('#ai-intake-analyze');
  if (analyzeButton) analyzeButton.disabled = true;
  const auditorUpload = Boolean($('#ai-auditor-upload-proposals'));
  if (auditorUpload && app.pdcAuditorSnapshot?.reviewCanDecide !== true) {
    setAiFileAssistantStatus([{ ok: false, title: 'Upload not authorised', message: 'Operator or Administrator access is required to analyse Workshop evidence.' }]);
    clearAiFileAssistantUploads(true);
    return false;
  }
  const analysisGeneration = ++app.aiIntakeAnalysisGeneration;
  const analysisIsCurrent = () => analysisGeneration === app.aiIntakeAnalysisGeneration
    && (!auditorUpload || app.pdcAuditorSnapshot?.reviewCanDecide === true);
  const results = [];
  const proposals = [];
  const createdReviews = [];
  for (const file of files) {
    try {
      const isPdf = /\.pdf$/i.test(file.name || '') || file.type === 'application/pdf';
      const text = isPdf ? await extractTextFromPdfFile(file) : await file.text();
      if (!analysisIsCurrent()) return false;
      if (auditorUpload) {
        const sourceEvidence = await aiFileAssistantSourceEvidence(file);
        if (!analysisIsCurrent()) return false;
        const proposal = pdcAuditorUploadedDocumentProposal(text, file, sourceEvidence);
        proposals.push(proposal);
        results.push({
          ok: proposal.lines.length > 0,
          title: file.name,
          message: `${proposal.documentType}: checked ${proposal.lines.length} operation line${proposal.lines.length === 1 ? '' : 's'} with explicit estimated hours. Review proposal created; no operational change was made.`,
        });
      } else {
        const result = analyzeAiAssistantText(text, file);
        results.push({ ok: result.ok, title: file.name, message: result.message });
        if (result.ok && result.review) createdReviews.push(result.review);
      }
    } catch (error) {
      if (!analysisIsCurrent()) return false;
      results.push({ ok: false, title: file.name || 'uploaded file', message: error.message || String(error) });
    }
  }
  if (!analysisIsCurrent()) return false;
  if (auditorUpload) {
    app.pdcAuditorDocumentProposals = proposals;
    renderPdcAuditorDocumentProposals();
  } else if (createdReviews.length) {
    runStorageTransaction('Save AI file assistant review drafts', [AI_FILE_ASSISTANT_REVIEWS_KEY], () => {
      const existing = loadAiFileAssistantReviews();
      const merged = new Map(existing.map(item => [String(item.id || ''), item]));
      createdReviews.forEach(review => merged.set(String(review.id || ''), review));
      saveAiFileAssistantReviews([...merged.values()]);
    });
    renderEmailIntakeReview();
  }
  setAiFileAssistantStatus(results.length ? results : [{ ok: false, title: auditorUpload ? 'AI Auditor document review' : 'AI file assistant', message: 'No files were analysed.' }]);
  clearAiFileAssistantUploads(true, auditorUpload);
  return auditorUpload ? proposals.length > 0 : createdReviews.length > 0;
}

function serverAiIntakeAuthMarker() {
  const context = window.PDC_AUTH_CONTEXT || {};
  const role = String(context.role || '').trim().toLowerCase();
  const userId = String(context.userId || context.user?.id || '').trim();
  const email = String(context.email || context.user?.email || '').trim().toLowerCase();
  const token = String(getPdcSupabaseAccessToken() || '');
  return role === 'administrator' && userId && email && token
    ? `${userId}|${email}|${token}`
    : '';
}

function resetServerAiIntakeAuthorityState({ clearData = true } = {}) {
  app.serverAiIntakeLifecycleGeneration += 1;
  app.serverAiIntakeGeneration += 1;
  try { app.serverAiIntakeRealtime?.unsubscribe?.(); } catch (_error) { /* best-effort teardown */ }
  app.serverAiIntakeRealtime = null;
  app.serverAiIntakeService = null;
  app.serverAiIntakeDecisionInFlight = false;
  app.serverAiIntakeRevision = null;
  app.serverAiIntakeNavisionRevision = null;
  app.serverAiIntakeError = '';
  app.serverAiIntakeState = 'idle';
  if (clearData) {
    app.serverAiIntakeItems = [];
    app.serverAiIntakeHistory = [];
  }
  renderServerAiIntake();
}

function serverAiIntakeService() {
  if (app.serverAiIntakeService) return app.serverAiIntakeService;
  const module = window.PDC_AI_INTAKE_SERVICE;
  if (!$('#ai-intake-server-panel') || typeof module?.createPdcAiIntakeService !== 'function') return null;
  try {
    app.serverAiIntakeService = module.createPdcAiIntakeService({
      config: window.PDC_SUPABASE_CONFIG || {},
      getAccessToken: () => getPdcSupabaseAccessToken(),
      subscribeRealtime: (tableName, onChange) => createPdcSupabaseTableRealtimeSubscription(tableName, { onChange }),
    });
    return app.serverAiIntakeService;
  } catch (error) {
    app.serverAiIntakeState = 'error';
    app.serverAiIntakeError = error.message || String(error);
    return null;
  }
}

function initServerAiIntakeIfAvailable() {
  if (!serverAiIntakeAuthMarker()) {
    resetServerAiIntakeAuthorityState({ clearData: true });
    return null;
  }
  const service = serverAiIntakeService();
  if (!service || app.serverAiIntakeRealtime) return service;
  app.serverAiIntakeRealtime = service.subscribe(() => {
    if (app.currentView === 'emailreview') refreshServerAiIntake({ silent: true });
  });
  refreshServerAiIntake({ silent: true });
  return service;
}

async function refreshPdcEmailMonitorStatus(service, authority, lifecycle, generation) {
  const host = $('#pdc-email-monitor-status');
  const details = $('#pdc-email-monitor-error');
  if (!host || typeof service?.monitorStatus !== 'function') return false;
  const response = await service.monitorStatus();
  if (generation !== app.serverAiIntakeGeneration
      || lifecycle !== app.serverAiIntakeLifecycleGeneration
      || authority !== serverAiIntakeAuthMarker()
      || service !== app.serverAiIntakeService) return false;
  if (!response.ok) {
    host.innerHTML = '<article><span>Pilot</span><strong>Unavailable</strong></article>';
    if (details) details.textContent = String(response.code || 'Monitor status unavailable');
    return false;
  }
  const status = response.data || {};
  const label = value => value === null || value === undefined || value === '' ? '—' : String(value);
  const when = value => value ? new Date(value).toLocaleString() : '—';
  host.innerHTML = [
    ['Pilot', status.pilot_enabled ? 'Enabled' : 'Disabled'],
    ['Service', label(status.running_status)], ['Queue', label(status.queue_count)],
    ['Failed', label(status.failed_count)], ['Review', label(status.review_count)],
    ['Mailbox start', `UID ${label(status.minimum_uid)}`],
    ['Last success', when(status.last_successful_run)],
    ['Last error', label(status.last_error_code)],
  ].map(([name, value]) => `<article><span>${escapeHtml(name)}</span><strong>${escapeHtml(value)}</strong></article>`).join('');
  if (details) details.textContent = JSON.stringify(status, null, 2);
  return true;
}

async function refreshServerAiIntake(options = {}) {
  const authority = serverAiIntakeAuthMarker();
  const lifecycle = app.serverAiIntakeLifecycleGeneration;
  if (!authority) {
    resetServerAiIntakeAuthorityState({ clearData: true });
    return false;
  }
  const service = serverAiIntakeService();
  if (!service) {
    renderServerAiIntake();
    return false;
  }
  const generation = ++app.serverAiIntakeGeneration;
  const filter = $('#ai-intake-server-filter')?.value || 'pending';
  if (!options.silent) app.serverAiIntakeState = 'loading';
  renderServerAiIntake();
  const response = await service.snapshot(filter, 150);
  const monitorStatusPromise = refreshPdcEmailMonitorStatus(service, authority, lifecycle, generation);
  if (generation !== app.serverAiIntakeGeneration
      || lifecycle !== app.serverAiIntakeLifecycleGeneration
      || authority !== serverAiIntakeAuthMarker()
      || service !== app.serverAiIntakeService) return false;
  await monitorStatusPromise;
  if (generation !== app.serverAiIntakeGeneration
      || lifecycle !== app.serverAiIntakeLifecycleGeneration
      || authority !== serverAiIntakeAuthMarker()
      || service !== app.serverAiIntakeService) return false;
  if (!response.ok) {
    app.serverAiIntakeState = 'error';
    app.serverAiIntakeError = response.code || 'AI Intake snapshot failed';
    renderServerAiIntake();
    return false;
  }
  app.serverAiIntakeState = 'synchronized';
  app.serverAiIntakeError = '';
  app.serverAiIntakeRevision = response.data?.revision ?? null;
  app.serverAiIntakeNavisionRevision = response.data?.navision_revision ?? null;
  app.serverAiIntakeItems = Array.isArray(response.data?.items) ? response.data.items : [];
  app.serverAiIntakeHistory = Array.isArray(response.data?.history) ? response.data.history : [];
  renderServerAiIntake();
  return true;
}

function serverAuthoritativeAiIntakeEnabled() {
  return Boolean($('#ai-intake-server-panel'));
}

function serverAiIntakeRoleCanApply() {
  return String(window.PDC_AUTH_CONTEXT?.role || '').toLowerCase() === 'administrator'
    && !app.serverAiIntakeDecisionInFlight;
}

function serverAiIntakeStatusClass(status = '') {
  return status === 'applied' ? 'ready' : status === 'pending' ? 'warning' : 'neutral';
}

function aiIntakeAuditChangeSummary(item = {}) {
  const events = Array.isArray(item.change_events) ? item.change_events : [];
  const changes = [];
  const fieldLabels = {
    stock_number: 'Stock number', vin: 'VIN', toyota_order_number: 'Order number', job_card_number: 'Job card',
    customer_name: 'Customer', make: 'Make', vehicle_description: 'Vehicle', model: 'Model', registration: 'Registration',
    key_number: 'Key number', salesperson_reference: 'Salesperson', arrival_reference_date: 'Arrival date',
    eta_to_kewdale: 'ETA to Kewdale', visible_on_board: 'Active on control board', current_location: 'Location',
  };
  const valueLabel = value => {
    if (value === true) return 'Yes';
    if (value === false) return 'No';
    if (value === null || value === undefined || value === '') return 'Blank';
    return String(value);
  };
  let vehicleCreated = false;
  events.forEach(event => {
    const before = event.before_data || {};
    const after = event.after_data || {};
    if (event.table_name === 'vehicles' && event.action === 'insert') {
      vehicleCreated = true;
      changes.push({ label: 'Control Board', before: 'Not active', after: 'Car activated' });
      return;
    }
    if (event.table_name === 'vehicles') {
      Object.entries(fieldLabels).forEach(([key, label]) => {
        if (valueLabel(before[key]) !== valueLabel(after[key])) changes.push({ label, before: valueLabel(before[key]), after: valueLabel(after[key]) });
      });
      return;
    }
    if (event.table_name === 'vehicle_work_items') {
      const workKey = after.work_key || before.work_key;
      const work = PDC_JOB_DEFS.find(def => def.key === workKey)?.label || workKey || 'Workshop work';
      if (Boolean(before.required) !== Boolean(after.required) || event.action === 'insert') {
        changes.push({ label: `${work} required`, before: event.action === 'insert' ? 'No' : valueLabel(Boolean(before.required)), after: valueLabel(Boolean(after.required)) });
      }
      return;
    }
    if (event.table_name === 'vehicle_parts_updates' && (Boolean(before.parts_required) !== Boolean(after.parts_required) || event.action === 'insert')) {
      changes.push({ label: 'Parts required', before: event.action === 'insert' ? 'No' : valueLabel(Boolean(before.parts_required)), after: valueLabel(Boolean(after.parts_required)) });
    }
  });
  if (item.board_activation_created && !vehicleCreated) changes.unshift({ label: 'Control Board', before: 'Not active', after: 'Car activated' });
  const unique = [...new Map(changes.map(change => [`${change.label}|${change.before}|${change.after}`, change])).values()];
  return {
    changes: unique,
    activated: vehicleCreated || Boolean(item.board_activation_created) || (item.status === 'applied' && item.action_type === 'board_activate_only'),
    modified: !vehicleCreated && unique.some(change => change.label !== 'Control Board'),
    auditAvailable: events.length > 0 || Boolean(item.board_activation_created),
  };
}

function aiIntakeHumanOutcome(item = {}) {
  const audit = aiIntakeAuditChangeSummary(item);
  if (item.status === 'pending') return { ...audit, badge: 'NEEDS REVIEW', title: 'Email received — waiting for review', message: item.action_type === 'board_activate_only' ? 'This may activate the matching Navision car after an Administrator checks it.' : 'No car has been changed.' };
  if (item.status === 'rejected') return { ...audit, badge: 'NO CHANGE', title: 'Reviewed — no car changed', message: item.decision_reason || 'This email was dismissed.' };
  if (audit.activated) return { ...audit, badge: 'CAR ACTIVATED', title: 'Car activated', message: 'The matching car is now active on the control board.' };
  if (audit.modified) return { ...audit, badge: 'CAR MODIFIED', title: 'Existing car modified', message: 'The changes made from this email are listed below.' };
  if (item.status === 'applied') return { ...audit, badge: 'RECEIVED', title: 'Email processed', message: audit.auditAvailable ? 'The car was already up to date.' : 'No recorded car changes were found for this older receipt.' };
  return { ...audit, badge: 'RECEIVED', title: 'Email received', message: 'No car has been changed.' };
}

function aiIntakeHumanChangesHtml(outcome = {}) {
  if (!outcome.changes?.length) return '<p class="ai-intake-no-changes">No vehicle details were changed.</p>';
  return `<ul class="ai-intake-change-list">${outcome.changes.map(change => `<li><strong>${escapeHtml(change.label)}:</strong> ${escapeHtml(change.before)} → ${escapeHtml(change.after)}</li>`).join('')}</ul>`;
}

function aiIntakeVehicleForStock(stock = '') {
  const identity = cleanNavisionText(stock).toUpperCase();
  if (!identity) return null;
  const exactRows = vehicleLocationBoardRows().filter(vehicle => [vehicle.stockNumber, vehicle.stock, vehicle.stock_number, vehicle.batch]
    .some(value => cleanNavisionText(value).toUpperCase() === identity));
  const matches = [...new Map(exactRows.map(vehicle => {
    const canonicalKey = cleanNavisionText(vehicle.permanentVehicleId || vehicle.permanent_vehicle_id || vehicle.__sharedNavisionRecordId || vehicle.id || vehicleKey(vehicle));
    return [canonicalKey, vehicle];
  })).values()];
  return matches.length === 1 ? matches[0] : null;
}

function aiIntakeStockNavigationHtml(stock = '', matchedVehicle = null, options = {}) {
  const identity = cleanNavisionText(stock);
  const label = `${options.includeStockLabel === false ? '' : 'Stock '}${identity || 'Not found'}`;
  const vehicle = matchedVehicle || aiIntakeVehicleForStock(identity);
  const key = vehicle ? vehicleKey(vehicle) : '';
  if (!identity || !key) return `<strong>${escapeHtml(label)}</strong>`;
  return `<button class="stock-link stock-button ai-intake-stock-link" type="button" data-open-stock="${escapeHtml(key)}" title="Open ${escapeHtml(label)} vehicle card" aria-label="Open ${escapeHtml(label)} vehicle card">${escapeHtml(label)}</button>`;
}

function bindAiIntakeStockNavigation(root) {
  $$('[data-open-stock]', root).forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    void openVehicleFromStockClick(button.dataset.openStock, button);
  }));
}

function aiIntakeHistoryLabel(eventType = '') {
  const labels = { noticed: 'Email received', applied: 'Car change recorded', rejected: 'Reviewed — no change made' };
  return labels[String(eventType || '').toLowerCase()] || 'Email activity recorded';
}

function renderServerAiIntake() {
  const host = $('#ai-intake-server-content');
  const historyHost = $('#ai-intake-history-content');
  const stateHost = $('#ai-intake-server-state');
  if (!host || !historyHost || !stateHost) return;
  const state = app.serverAiIntakeState;
  stateHost.className = `badge ${state === 'synchronized' ? 'ready' : state === 'error' ? 'danger' : 'warning'}`;
  stateHost.textContent = state === 'synchronized'
    ? `Online · revision ${app.serverAiIntakeRevision ?? '—'}`
    : state === 'error' ? 'Unavailable' : state === 'loading' ? 'Refreshing' : 'Connecting';
  if (state === 'error') {
    host.innerHTML = `<div class="empty-state"><strong>Email intake could not be loaded</strong><span>Try Refresh inbox. Nothing can be approved while the online record is unavailable.</span><details class="ai-intake-technical-details"><summary>Technical details</summary><span>${escapeHtml(app.serverAiIntakeError || 'No online snapshot is available.')}</span></details></div>`;
    historyHost.innerHTML = '<div class="empty-state compact-empty"><strong>History could not be loaded</strong><span>Try Refresh inbox.</span></div>';
    return;
  }
  const rows = Array.isArray(app.serverAiIntakeItems) ? app.serverAiIntakeItems : [];
  if (!rows.length) {
    host.innerHTML = state === 'synchronized'
      ? '<div class="empty-state compact-empty"><strong>No emails match this filter</strong><span>Choose another filter, or refresh the inbox.</span></div>'
      : '<div class="empty-state compact-empty"><strong>Loading email intake</strong><span>Checking the latest online records.</span></div>';
  } else {
    const canDecide = serverAiIntakeRoleCanApply();
    host.innerHTML = `<div class="ai-intake-server-list">${rows.map(item => {
      const pending = item.status === 'pending';
      const actionable = item.action_type === 'board_activate_only';
      const outcome = aiIntakeHumanOutcome(item);
      const statusClass = serverAiIntakeStatusClass(item.status);
      return `<article class="ai-intake-server-row ai-intake-review-card" data-status="${escapeHtml(item.status || '')}" data-ai-intake-proposal="${escapeHtml(item.proposal_id || '')}">
        <header class="ai-intake-review-heading">
          <div class="ai-intake-review-title"><span class="ai-intake-mail-icon" aria-hidden="true">✉</span><strong>${escapeHtml(item.subject || 'Email received')}</strong><span class="badge ${statusClass}">${escapeHtml(outcome.badge)}</span></div>
          <time>${escapeHtml(item.source_received_at ? operationalHealthDateLabel(item.source_received_at) : 'Date unavailable')}</time>
        </header>
        <div class="ai-intake-review-body">
          <div class="ai-intake-review-content">
            <div class="ai-intake-review-meta">
              <div><span>Sender</span><strong>${escapeHtml(item.sender_address || 'Unknown sender')}</strong></div>
              <div><span>Matched stock</span>${item.stock_number ? aiIntakeStockNavigationHtml(item.stock_number, null, { includeStockLabel: false }) : '<strong>Not matched</strong>'}</div>
              <div><span>Matched car</span><strong>${escapeHtml(item.authoritative_vehicle || 'Not matched yet')}</strong><small>${item.authoritative_location ? `Location: ${escapeHtml(item.authoritative_location)}` : ''}</small></div>
            </div>
            <section class="ai-intake-email-summary"><span>What the email says</span><p>${escapeHtml(item.summary || 'No reliable email summary was generated. Deny this item or open the technical details before deciding.')}</p></section>
            <section class="ai-intake-detected-changes"><span>Detected changes</span>${aiIntakeHumanChangesHtml(outcome)}</section>
            <div class="ai-intake-proposed-action"><span>Proposed action</span><strong>${actionable ? 'Activate matching car on Control Board' : escapeHtml(outcome.title)}</strong><small>${escapeHtml(outcome.message)}</small></div>
          </div>
          ${pending ? `<aside class="ai-intake-decision-panel">${actionable ? `<button class="primary ai-intake-approve" type="button" data-ai-intake-apply="${escapeHtml(item.proposal_id)}" ${canDecide ? '' : 'disabled title="Active Administrator access required"'}>✓ Approve</button>` : ''}<button class="small-button ai-intake-deny" type="button" data-ai-intake-reject="${escapeHtml(item.proposal_id)}" ${canDecide ? '' : 'disabled title="Active Administrator access required"'}>× Deny</button></aside>` : `<aside class="ai-intake-decision-panel ai-intake-decision-complete"><strong>${escapeHtml(outcome.title)}</strong><span>Processed by ${escapeHtml(item.decided_by_email || 'System')}</span><small>${escapeHtml(item.decided_at ? operationalHealthDateLabel(item.decided_at) : '')}</small></aside>`}
        </div>
        <details class="ai-intake-technical-details"><summary>Email and technical details</summary><div class="ai-intake-server-meta"><span>UID ${escapeHtml(item.source_uid || '—')}</span><span>Receipt ${escapeHtml(item.fingerprint || '—')}</span><span>Action ${escapeHtml(item.action_type || 'review_only')}</span></div></details>
      </article>`;
    }).join('')}</div>`;
  }
  const history = Array.isArray(app.serverAiIntakeHistory) ? app.serverAiIntakeHistory : [];
  historyHost.innerHTML = history.length
    ? `<div class="ai-intake-history-list">${history.map(event => `<div class="ai-intake-history-row"><strong>${escapeHtml(aiIntakeHistoryLabel(event.event_type))}${event.stock_number ? ` · Stock ${escapeHtml(event.stock_number)}` : ''}</strong><span>${escapeHtml(event.actor_email || 'System')} · ${escapeHtml(event.event_at ? operationalHealthDateLabel(event.event_at) : '')}</span><details class="ai-intake-technical-details"><summary>Technical details</summary><span>Event ${escapeHtml(event.event_type || 'unknown')} · Receipt ${escapeHtml(event.fingerprint || '—')}</span></details></div>`).join('')}</div>`
    : '<div class="empty-state compact-empty"><strong>No history yet</strong><span>Received, processed and dismissed emails will appear here.</span></div>';
  bindAiIntakeStockNavigation(host);
  $$('[data-ai-intake-apply]', host).forEach(button => button.addEventListener('click', () => decideServerAiIntake(button.dataset.aiIntakeApply, 'apply')));
  $$('[data-ai-intake-reject]', host).forEach(button => button.addEventListener('click', () => decideServerAiIntake(button.dataset.aiIntakeReject, 'reject')));
}

function persistServerAiIntakeDecisionAttempts() {
  try {
    const entries = [...app.serverAiIntakeDecisionAttempts.entries()].slice(-50);
    sessionStorage.setItem('pdc.ai-intake.decision-attempts.v1', JSON.stringify(entries));
  } catch (_error) { /* memory-only retry remains available */ }
}

function restoreServerAiIntakeDecisionAttempts() {
  if (app.serverAiIntakeDecisionAttempts.size) return;
  try {
    const entries = JSON.parse(sessionStorage.getItem('pdc.ai-intake.decision-attempts.v1') || '[]');
    for (const [signature, attempt] of Array.isArray(entries) ? entries : []) {
      if (typeof signature === 'string'
          && /^pdc-ai-intake-[a-zA-Z0-9_-]{16,160}$/.test(String(attempt?.idempotencyKey || ''))
          && attempt?.proposal?.proposal_id) {
        app.serverAiIntakeDecisionAttempts.set(signature, attempt);
      }
    }
  } catch (_error) { /* corrupt UI retry cache is ignored */ }
}

function deleteServerAiIntakeDecisionAttempt(signature = '') {
  app.serverAiIntakeDecisionAttempts.delete(signature);
  persistServerAiIntakeDecisionAttempts();
}

function serverAiIntakeDecisionAttempt(proposal = {}, decision = '', reason = '') {
  restoreServerAiIntakeDecisionAttempts();
  const context = window.PDC_AUTH_CONTEXT || {};
  const actor = `${String(context.userId || context.user?.id || '')}|${String(context.email || context.user?.email || '').toLowerCase()}`;
  const signature = JSON.stringify([actor, proposal.proposal_id, proposal.version, decision, reason]);
  let attempt = app.serverAiIntakeDecisionAttempts.get(signature);
  if (!attempt) {
    const nonce = typeof window.crypto?.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    attempt = {
      idempotencyKey: `pdc-ai-intake-${nonce}`,
      proposal: {
        ...proposal,
        inbox_revision: Number(app.serverAiIntakeRevision),
        navision_revision: Number(app.serverAiIntakeNavisionRevision),
      },
    };
    app.serverAiIntakeDecisionAttempts.set(signature, attempt);
    persistServerAiIntakeDecisionAttempts();
  }
  return { signature, ...attempt };
}

async function decideServerAiIntake(proposalId = '', decision = '') {
  if (!serverAiIntakeRoleCanApply()) return false;
  const proposal = app.serverAiIntakeItems.find(item => String(item.proposal_id || '') === String(proposalId || ''));
  const service = serverAiIntakeService();
  const authority = serverAiIntakeAuthMarker();
  const lifecycle = app.serverAiIntakeLifecycleGeneration;
  if (!proposal || !service || !authority) return false;
  // Staff no longer have to type a reason for routine triage.
  // truthful audit reason so the protected RPC and durable history still record
  // what happened without inventing user-authored detail.
  const reason = decision === 'apply' ? 'Approved through AI Intake' : 'Denied through AI Intake';
  if (decision === 'apply' && !window.confirm(`Approve this intake item for Stock ${proposal.stock_number || 'unknown'}? Email evidence is informational only. The server will revalidate the exact Navision record and revision, preserve its location, and make no other operational change.`)) return false;
  if (decision === 'reject' && !window.confirm('Deny this intake item? No car will be changed.')) return false;
  const attempt = serverAiIntakeDecisionAttempt(proposal, decision, reason);
  app.serverAiIntakeDecisionInFlight = true;
  renderServerAiIntake();
  let response;
  try {
    response = await service.decide(attempt.proposal, decision, reason, attempt.idempotencyKey);
  } finally {
    if (lifecycle === app.serverAiIntakeLifecycleGeneration && authority === serverAiIntakeAuthMarker()) {
      app.serverAiIntakeDecisionInFlight = false;
    }
  }
  if (lifecycle !== app.serverAiIntakeLifecycleGeneration
      || authority !== serverAiIntakeAuthMarker()
      || service !== app.serverAiIntakeService) return false;
  if (response?.outcomeUnknown) {
    await refreshServerAiIntake();
    if (lifecycle !== app.serverAiIntakeLifecycleGeneration || authority !== serverAiIntakeAuthMarker()) return false;
    const current = app.serverAiIntakeItems.find(item => String(item.proposal_id || '') === String(proposalId));
    const terminalHistory = app.serverAiIntakeHistory.some(event => String(event.proposal_id || '') === String(proposalId)
      && ['applied', 'rejected'].includes(String(event.event_type || '').toLowerCase()));
    if ((current && current.status !== 'pending') || terminalHistory) {
      deleteServerAiIntakeDecisionAttempt(attempt.signature);
      pdcNotify('The original response was lost, but authoritative history confirms that the decision was recorded.', 'info');
      return true;
    }
    pdcNotify('The server outcome is not yet known. No result is being claimed. Retry the same decision to reconcile the durable receipt with the same idempotency key.');
    return false;
  }
  if (!response?.ok) {
    deleteServerAiIntakeDecisionAttempt(attempt.signature);
    pdcNotify(`AI Intake decision rejected: ${response?.code || 'unknown error'}. The server returned a definitive rejection and committed no change.`);
    await refreshServerAiIntake();
    return false;
  }
  deleteServerAiIntakeDecisionAttempt(attempt.signature);
  if (decision === 'apply' && typeof loadSharedNavisionVisibleRows === 'function') await loadSharedNavisionVisibleRows();
  if (lifecycle === app.serverAiIntakeLifecycleGeneration && authority === serverAiIntakeAuthMarker()) await refreshServerAiIntake();
  return true;
}

function emailReviewItems() {
  const seeded = Array.isArray(window.PDC_EMAIL_BOARD_DATA?.reviews) ? window.PDC_EMAIL_BOARD_DATA.reviews : [];
  const local = loadAiFileAssistantReviews();
  const merged = new Map();
  seeded.concat(local).forEach(review => {
    if (!review || typeof review !== 'object') return;
    const id = cleanNavisionText(review.id || '');
    if (!id) return;
    merged.set(id, review);
  });
  return [...merged.values()].sort((a, b) => String(b.receivedAt || '').localeCompare(String(a.receivedAt || '')) || String(a.id || '').localeCompare(String(b.id || '')));
}

function emailReviewDecisions() {
  return loadJson(EMAIL_REVIEW_DECISIONS_KEY, {});
}

function saveEmailReviewDecision(id = '', status = '', details = {}) {
  if (serverAuthoritativeAiIntakeEnabled()) throw new Error('browser_ai_intake_mutation_disabled');
  const decisions = emailReviewDecisions();
  decisions[id] = { status, ...details, decidedAt: nowIsoString(), decidedBy: getCurrentOperatorName() };
  saveJson(EMAIL_REVIEW_DECISIONS_KEY, decisions);
}

function vehicleForEmailReview(review = {}) {
  const stock = cleanNavisionText(review.stock || '').toUpperCase();
  if (!stock) return null;
  const matches = app.data.filter(vehicle => [vehicleKey(vehicle), displayStockNumber(vehicle), vehicle.batch]
    .map(value => cleanNavisionText(value).toUpperCase()).includes(stock));
  if (matches.length === 1) return matches[0];
  if (matches.length > 1) console.warn('Email review vehicle lookup was ambiguous; no vehicle was selected.', { stock, matchCount: matches.length });
  return null;
}

function emailReviewActionLabel(review = {}) {
  if (review.type === 'vehicle-import') return 'Review vehicle, labour and workshop categories';
  return review.action === 'complete' ? 'Mark Parts complete' : review.action === 'stoppage' ? 'Record Parts STOPPAGE' : 'Add Parts note';
}

function emailReviewApplyUpdates(vehicle = {}, review = {}) {
  const operator = getCurrentOperatorName();
  const now = nowIsoString();
  const notes = cleanNavisionText(review.notes || '');
  const reason = cleanNavisionText(review.reason || notes || 'Parts STOPPAGE received by email');
  const existingNotes = Array.isArray(vehicle.pdcPartsEmailNotes) ? vehicle.pdcPartsEmailNotes : [];
  const updates = {
    pdcRequiresParts: true,
    pdcPartsEmailNotes: notes ? [...existingNotes, { note: notes, at: now, by: operator, intakeId: review.intakeId || '' }].slice(-20) : existingNotes,
    pdcLastEmailReviewId: review.id || '',
    pdcLastEmailReviewAt: now,
    pdcLastEmailReviewBy: operator,
  };
  const def = partsJobDef();
  if (review.action === 'complete') {
    Object.assign(updates, {
      pdcPartsOrdered: true,
      pdcPartsOrderedAt: vehicle.pdcPartsOrderedAt || now,
      pdcPartsStoppage: false,
      pdcPartsStoppageReason: '',
      pdcPartsWorstEta: '',
    });
    if (def) {
      updates[def.completeKey] = true;
      updates[def.completeAtKey] = now;
      updates[def.completeByKey] = operator;
    }
  } else if (review.action === 'stoppage') {
    Object.assign(updates, {
      pdcPartsStoppage: true,
      pdcPartsStoppageReason: reason,
      pdcPartsStoppageAt: now,
      pdcPartsStoppageBy: operator,
      pdcPartsWorstEta: cleanNavisionText(review.eta || vehicle.pdcPartsWorstEta || ''),
    });
  }
  return updates;
}

function emailVehicleReviewDetailValues(reviewId = '') {
  const row = $$('[data-email-vehicle-review]').find(item => item.dataset.emailVehicleReview === reviewId);
  if (!row) return {};
  return {
    client: cleanNavisionText($('[data-email-vehicle-customer]', row)?.value || ''),
    vehicle: cleanNavisionText($('[data-email-vehicle-description]', row)?.value || ''),
    jobCardNumber: cleanNavisionText($('[data-email-vehicle-job-card]', row)?.value || ''),
  };
}

function emailVehicleReviewLineValues(reviewId = '') {
  const row = $$('[data-email-vehicle-review]').find(item => item.dataset.emailVehicleReview === reviewId);
  if (!row) return [];
  return $$('[data-email-review-line]', row).map(lineRow => ({
    id: lineRow.dataset.emailReviewLine || '',
    included: Boolean($('[data-email-line-include]', lineRow)?.checked),
    description: $('[data-email-line-description]', lineRow)?.value || '',
    hours: $('[data-email-line-hours]', lineRow)?.value || '',
    category: $('[data-email-line-stage]', lineRow)?.value || '',
  }));
}

function reviewedEmailJobLines(review = {}, values = [], operator = getCurrentOperatorName()) {
  const valueMap = new Map((Array.isArray(values) ? values : []).map(value => [String(value.id || ''), value]));
  const now = nowIsoString();
  return (Array.isArray(review.jobLines) ? review.jobLines : []).map(sourceLine => {
    const id = pdcJobLineIdentity(sourceLine);
    const value = valueMap.get(id) || { id, included: true, description: sourceLine.description, hours: sourceLine.estimatedHours, category: pdcJobLineStage(sourceLine) };
    if (!value.included) return null;
    const description = cleanNavisionText(value.description || sourceLine.description || '');
    const hours = validPdcJobLineHours(value.hours);
    const category = normalizePmbStage(value.category || pdcJobLineStage(sourceLine));
    if (!description) throw new Error('Every included job line needs a description.');
    if (hours == null) throw new Error(`Enter valid labour hours for “${description}” before pushing to the PDC board.`);
    if (!PDC_JOB_LINE_STAGE_OPTIONS.some(option => option.value === category)) throw new Error(`Choose a workshop category for “${description}”.`);
    return {
      ...sourceLine,
      id,
      description,
      category,
      confirmed: true,
      confirmedHours: hours,
      estimatedHours: Number(sourceLine.estimatedHours ?? hours),
      estimateStatus: 'confirmed',
      confirmedAt: now,
      confirmedBy: operator,
      source: 'AI Intake Review',
    };
  }).filter(Boolean);
}

function reviewedEmailVehicleUpdates(vehicle = {}, review = {}, lines = [], operator = getCurrentOperatorName(), details = {}) {
  const mergedLines = mergePdcJobLines(vehicle.pdcManualJobLines || [], lines);
  const updates = {
    ...Object.fromEntries(Object.entries(details || {}).filter(([, value]) => cleanNavisionText(value || ''))),
    pdcManualJobLines: mergedLines,
    pdcLastEmailReviewId: review.id || '',
    pdcLastEmailReviewAt: nowIsoString(),
    pdcLastEmailReviewBy: operator,
  };
  lines.forEach(line => {
    const def = pmbStageJobDef(line.category);
    if (def?.requireKey) updates[def.requireKey] = true;
  });
  return updates;
}

async function applyVehicleImportReview(review = {}) {
  if (serverAuthoritativeAiIntakeEnabled()) {
    pdcNotify('Uploaded-file proposals are local drafts only. Server AI Intake is observation and history only; nothing changed.');
    return false;
  }
  const operator = getCurrentOperatorName();
  if (!operator || operator === 'Unknown operator') {
    pdcNotify('Set an operator name before approving an email import. Nothing was changed.');
    return false;
  }
  let lines;
  try {
    lines = reviewedEmailJobLines(review, emailVehicleReviewLineValues(review.id), operator);
  } catch (error) {
    pdcNotify(error.message || String(error));
    return false;
  }
  if (!lines.length) {
    pdcNotify('Select at least one valid work line before pushing this vehicle to the PDC board.');
    return false;
  }
  const existing = vehicleForEmailReview(review);
  const details = emailVehicleReviewDetailValues(review.id);
  const baseVehicle = existing || { ...(review.vehicle || {}), ...details, stock: review.stock || review.vehicle?.stock || '' };
  const updates = reviewedEmailVehicleUpdates(baseVehicle, review, lines, operator, details);
  const key = vehicleKey(baseVehicle) || cleanNavisionText(review.stock || '');
  if (!key) {
    pdcNotify('This proposal has no safe stock/job-card identity and cannot be pushed.');
    return false;
  }
  const sharedActivation = await activateSharedNavisionForApprovedEmailReview(baseVehicle);
  if (!sharedActivation?.ok) {
    pdcNotify(`This approved build email could not activate the matching shared Navision vehicle: ${sharedActivation?.code || 'unknown error'}. Nothing was pushed locally.`);
    return false;
  }
  try {
    runStorageTransaction('Approve email vehicle import', [ADDED_KEY, EDITS_KEY, AUDIT_LOG_KEY, EMAIL_REVIEW_DECISIONS_KEY], () => {
      if (existing) {
        const edits = loadVehicleEdits();
        edits[key] = { ...(edits[key] || {}), ...updates };
        saveJson(EDITS_KEY, edits);
      } else {
        const added = loadAddedVehicles();
        const nextVehicle = { ...baseVehicle, ...updates, id: baseVehicle.id || `reviewed-email-${key}`, stock: baseVehicle.stock || key };
        const nextAdded = [...added.filter(item => vehicleKey(item) !== key), nextVehicle];
        saveAddedVehicles(nextAdded);
      }
      recordVehicleAudit(baseVehicle, 'Email vehicle import approved and pushed to PDC board', {
        intakeId: review.intakeId || '',
        jobLineCount: lines.length,
        categories: [...new Set(lines.map(line => line.category))],
        by: operator,
      });
      saveEmailReviewDecision(review.id, 'applied', { stock: review.stock, action: 'vehicle-import', jobLineCount: lines.length });
    });
  } catch (error) {
    pdcNotify(error.message || String(error));
    return false;
  }
  app.data = buildVehicleData();
  populateFilters();
  renderAll();
  renderEmailIntakeReview();
  return true;
}

function applyEmailReview(id = '') {
  if ($('#ai-intake-server-panel')) {
    pdcNotify('Uploaded-file proposals are local drafts only. Server AI Intake is observation and history only; nothing changed.');
    return false;
  }
  const review = emailReviewItems().find(item => String(item.id || '') === String(id || ''));
  if (!review) return;
  if (review.type === 'vehicle-import') return applyVehicleImportReview(review);
  const vehicle = vehicleForEmailReview(review);
  if (!vehicle) {
    pdcNotify(`No vehicle matching stock ${review.stock || 'unknown'} was found. Keep this proposal pending until the vehicle exists.`);
    return;
  }
  const updates = emailReviewApplyUpdates(vehicle, review);
  const operator = getCurrentOperatorName();
  const vehicleSnapshot = { ...vehicle };
  try {
    runStorageTransaction('Apply reviewed Parts email', [EDITS_KEY, AUDIT_LOG_KEY, EMAIL_REVIEW_DECISIONS_KEY], () => {
      if (!saveVehicleEdits(vehicleKey(vehicle), updates, { render: false })) throw new Error('The vehicle update failed.');
      recordVehicleAudit(vehicle, 'Reviewed Parts email applied', { action: review.action, reason: review.reason || '', notes: review.notes || '', eta: review.eta || '', intakeId: review.intakeId || '', by: operator });
      saveEmailReviewDecision(review.id, 'applied', { stock: review.stock, action: review.action });
    });
  } catch (error) {
    Object.keys(vehicle).forEach(key => { if (!Object.prototype.hasOwnProperty.call(vehicleSnapshot, key)) delete vehicle[key]; });
    Object.assign(vehicle, vehicleSnapshot);
    pdcNotify(error.message || String(error));
    return false;
  }
  renderAll();
  const freshVehicle = selectedVehicle(vehicleKey(vehicle)) || vehicle;
  offerSalespersonChangeEmail(freshVehicle, {
    title: review.action === 'complete' ? 'Parts completed from reviewed email' : review.action === 'stoppage' ? 'Parts STOPPAGE from reviewed email' : 'Parts note received',
    subject: 'PDC Parts email update',
    details: [review.reason && `Reason: ${review.reason}`, review.notes && `Notes: ${review.notes}`, review.eta && `Parts ETA: ${review.eta}`].filter(Boolean),
  });
  renderEmailIntakeReview();
  return true;
}

function rejectEmailReview(id = '') {
  if (serverAuthoritativeAiIntakeEnabled()) {
    pdcNotify('Browser-local AI Intake decisions are disabled on staging. Nothing changed.');
    return false;
  }
  const review = emailReviewItems().find(item => String(item.id || '') === String(id || ''));
  if (!review || !window.confirm(`Reject this proposed update for ${review.stock}?`)) return false;
  const vehicle = vehicleForEmailReview(review);
  try {
    runStorageTransaction('Reject reviewed email update', [AUDIT_LOG_KEY, EMAIL_REVIEW_DECISIONS_KEY], () => {
      saveEmailReviewDecision(review.id, 'rejected', { stock: review.stock, action: review.action });
      if (vehicle) recordVehicleAudit(vehicle, 'Reviewed Parts email rejected', { action: review.action, intakeId: review.intakeId || '', by: getCurrentOperatorName() });
    });
  } catch (error) {
    pdcNotify(error.message || String(error));
    return false;
  }
  renderEmailIntakeReview();
  return true;
}

function emailVehicleReviewLinesHtml(review = {}, disabled = false) {
  const lines = Array.isArray(review.jobLines) ? review.jobLines : [];
  if (!lines.length) return '<div class="empty-state compact-empty"><strong>No safe job lines were extracted</strong><span>Reject this proposal or add the vehicle manually.</span></div>';
  return `<div class="email-vehicle-review-lines">${lines.map(line => {
    const id = pdcJobLineIdentity(line);
    const stage = pdcJobLineStage(line);
    const hours = line.estimatedHours == null ? '' : line.estimatedHours;
    const source = cleanNavisionText(line.estimateSource || 'Starting estimate requires staff confirmation');
    return `<div class="email-vehicle-review-line" data-email-review-line="${escapeHtml(id)}">
      <label class="email-line-include"><input type="checkbox" data-email-line-include checked ${disabled ? 'disabled' : ''}> Include</label>
      <label class="email-line-description"><span>Job line</span><input type="text" data-email-line-description value="${escapeHtml(line.description || '')}" ${disabled ? 'disabled' : ''}><small>${line.code ? `${escapeHtml(line.code)} · ` : ''}${escapeHtml(source)}</small></label>
      <label><span>Category</span><select data-email-line-stage ${disabled ? 'disabled' : ''}>${pdcJobLineStageOptionsHtml(stage)}</select></label>
      <label><span>Labour hours</span><input type="number" min="0.08" max="40" step="0.25" data-email-line-hours value="${escapeHtml(String(hours))}" placeholder="Enter" ${disabled ? 'disabled' : ''}></label>
    </div>`;
  }).join('')}</div>`;
}

function renderEmailIntakeReview() {
  const host = $('#email-intake-review-content');
  if (!host) return;
  renderServerAiIntake();
  renderAiBoardAdvisor();
  updateAiFileAssistantButtons();
  const decisions = emailReviewDecisions();
  const filter = $('#email-review-status-filter')?.value || 'pending';
  const localApplyDisabled = Boolean($('#ai-intake-server-panel'));
  const all = emailReviewItems();
  const rows = all.filter(review => {
    const state = decisions[review.id]?.status || 'pending';
    return filter === 'all' || state === filter;
  });
  const pending = all.filter(review => !decisions[review.id]?.status).length;
  const countHost = $('#email-review-count');
  if (countHost) countHost.textContent = `${pending} pending · ${all.length} total`;
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No review proposals match this filter</strong><span>Email and uploaded-file proposals appear here for approval before any PDC-board changes are made.</span></div>';
    return;
  }
  host.innerHTML = `<div class="email-review-list">${rows.map(review => {
    const decision = decisions[review.id] || {};
    const vehicle = vehicleForEmailReview(review);
    const state = decision.status || 'pending';
    if (review.type === 'vehicle-import') {
      const proposalVehicle = vehicle || review.vehicle || {};
      const lineCount = Array.isArray(review.jobLines) ? review.jobLines.length : 0;
      const customer = vehicleCustomerName(proposalVehicle) || 'Customer not supplied';
      const vehicleDescription = displayVehicle(proposalVehicle) || proposalVehicle.vehicle || 'Vehicle details not supplied';
      const jobCard = vehicleJobcardNumber(proposalVehicle) || proposalVehicle.jobCardNumber || 'Not supplied';
      const confidence = cleanNavisionText(review.analysisConfidence || '').toUpperCase() || 'REVIEW';
      const metaHtml = aiAssistantReviewMetaHtml(review);
      return `<details class="email-review-row email-vehicle-review email-review-${escapeHtml(state)}" data-email-vehicle-review="${escapeHtml(review.id)}">
        <summary class="email-review-summary">
          <span class="email-review-summary-identity"><span class="badge ${state === 'pending' ? 'warning' : state === 'applied' ? 'ready' : 'neutral'}">${escapeHtml(state.toUpperCase())}</span>${aiIntakeStockNavigationHtml(review.stock, vehicle)}</span>
          <span class="email-review-summary-cell"><small>Customer</small><b title="${escapeHtml(customer)}">${escapeHtml(customer)}</b></span>
          <span class="email-review-summary-cell"><small>Vehicle</small><b title="${escapeHtml(vehicleDescription)}">${escapeHtml(vehicleDescription)}</b></span>
          <span class="email-review-summary-cell"><small>Job card</small><b>${escapeHtml(jobCard)}</b></span>
          <span class="email-review-summary-meta"><b>${lineCount} job ${lineCount === 1 ? 'line' : 'lines'}</b><small>${escapeHtml(review.receivedAt ? operationalHealthDateLabel(review.receivedAt) : 'Date unavailable')}</small></span>
          <span class="email-review-summary-meta"><b>${escapeHtml(confidence)}</b><small>Confidence</small></span>
          <span class="email-review-open-label" aria-hidden="true"></span>
        </summary>
        <div class="email-review-expanded">
          <div class="email-review-expanded-heading"><b>${escapeHtml(emailReviewActionLabel(review))}</b><small>Review and approve this vehicle only when you are ready.</small></div>
          ${metaHtml}
          <div class="email-review-vehicle-fields"><label><span>Customer</span><input type="text" data-email-vehicle-customer value="${escapeHtml(vehicleCustomerName(proposalVehicle) || '')}" ${state !== 'pending' ? 'disabled' : ''}></label><label><span>Vehicle details</span><input type="text" data-email-vehicle-description value="${escapeHtml(displayVehicle(proposalVehicle) || proposalVehicle.vehicle || '')}" ${state !== 'pending' ? 'disabled' : ''}></label><label><span>Job card</span><input type="text" data-email-vehicle-job-card value="${escapeHtml(vehicleJobcardNumber(proposalVehicle) || proposalVehicle.jobCardNumber || '')}" ${state !== 'pending' ? 'disabled' : ''}></label></div>
          <div class="email-review-guidance"><strong>Check every included row.</strong> Correct the description, move it to the workshop category that will perform it, and confirm labour hours. Only approved rows are pushed to the PDC board and Workshop Planner.</div>
          ${emailVehicleReviewLinesHtml(review, state !== 'pending')}
          <div class="email-review-actions">${state === 'pending' ? `<button class="primary" type="button" data-email-review-apply="${escapeHtml(review.id)}" ${lineCount && !localApplyDisabled ? '' : 'disabled'}>${localApplyDisabled ? 'Server proposal required' : 'Approve &amp; push to PDC board'}</button><button class="small-button" type="button" data-email-review-reject="${escapeHtml(review.id)}">Reject draft</button>` : `<span class="subtle">${escapeHtml(decision.decidedBy || '')} · ${escapeHtml(decision.decidedAt ? operationalHealthDateLabel(decision.decidedAt) : '')}</span>`}</div>
        </div>
      </details>`;
    }
    return `<article class="email-review-row email-review-${escapeHtml(state)}">
      <div class="email-review-main"><span class="badge ${state === 'pending' ? 'warning' : state === 'applied' ? 'ready' : 'neutral'}">${escapeHtml(state.toUpperCase())}</span>${aiIntakeStockNavigationHtml(review.stock, vehicle, { includeStockLabel: false })}<b>${escapeHtml(emailReviewActionLabel(review))}</b><small>${escapeHtml(review.receivedAt ? operationalHealthDateLabel(review.receivedAt) : 'Date unavailable')}</small></div>
      <div class="email-review-details"><span><b>Vehicle:</b> ${escapeHtml(vehicle ? `${vehicleCustomerName(vehicle)} · ${displayVehicle(vehicle)}` : 'No matching vehicle')}</span>${review.reason ? `<span><b>Reason:</b> ${escapeHtml(review.reason)}</span>` : ''}${review.notes ? `<span><b>Notes:</b> ${escapeHtml(review.notes)}</span>` : ''}${review.eta ? `<span><b>ETA:</b> ${escapeHtml(review.eta)}</span>` : ''}<span><b>Sender:</b> ${escapeHtml(review.sender || 'Unknown')}</span></div>
      ${aiAssistantReviewMetaHtml(review)}
      <div class="email-review-actions">${state === 'pending' ? `<button class="primary" type="button" data-email-review-apply="${escapeHtml(review.id)}" ${vehicle && !localApplyDisabled ? '' : 'disabled'}>${localApplyDisabled ? 'Server proposal required' : 'Apply reviewed update'}</button><button class="small-button" type="button" data-email-review-reject="${escapeHtml(review.id)}">Reject draft</button>` : `<span class="subtle">${escapeHtml(decision.decidedBy || '')} · ${escapeHtml(decision.decidedAt ? operationalHealthDateLabel(decision.decidedAt) : '')}</span>`}</div>
    </article>`;
  }).join('')}</div>`;
  $$('[data-email-vehicle-review]', host).forEach(row => row.addEventListener('toggle', () => {
    if (!row.open) return;
    $$('[data-email-vehicle-review]', host).forEach(other => {
      if (other !== row) other.removeAttribute('open');
    });
  }));
  bindAiIntakeStockNavigation(host);
  $$('[data-email-review-apply]', host).forEach(button => button.addEventListener('click', () => applyEmailReview(button.dataset.emailReviewApply)));
  $$('[data-email-review-reject]', host).forEach(button => button.addEventListener('click', () => rejectEmailReview(button.dataset.emailReviewReject)));
}

function plainDateValue(value = '') {
  const match = String(value || '').match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : '';
}

function renderBusPitInspections() {
  const host = $('#bus-pit-content');
  if (!host) return;
  const unavailable = app.emailVehicleLocationError || app.sharedNavisionVisibleState === 'error'
    || typeof window.PDC_WORKSHOP_DEPARTMENTS?.externalPitLines !== 'function';
  const loading = app.emailVehicleLocationRevision == null || app.sharedNavisionVisibleState !== 'ready'
    || (app.operationalRefreshState === 'refreshing' && app.operationalRefreshRoute === 'bus-pit');
  if (unavailable || loading) {
    host.innerHTML = `<div class="empty-state" role="status"><strong>${unavailable ? 'Pit inspections unavailable' : 'Loading Pit inspections…'}</strong><span>${unavailable ? 'The latest job-card information could not be loaded. Use Refresh to try again.' : 'Checking current vehicle and job-card information.'}</span></div>`;
    return;
  }
  const vehicles = vehicleLocationBoardRows();
  if (vehicles.some(vehicle => vehicle.__emailVehicleServerAuthoritative === true && vehicle.pdcQcOperationLinesProjectionPresent !== true)) {
    host.innerHTML = '<div class="empty-state" role="status"><strong>Pit inspections unavailable</strong><span>Job-card details are incomplete. Use Refresh to try again.</span></div>';
    return;
  }
  const rows = vehicles.flatMap(vehicle => (window.PDC_WORKSHOP_DEPARTMENTS?.externalPitLines(vehicle) || []).map(line => ({ vehicle, line })));
  host.innerHTML = rows.length ? `<div class="table-wrap"><table class="data-table"><thead><tr><th>Stock</th><th>Customer</th><th>Vehicle</th><th>Job card</th><th>Dept</th><th>Inspection required</th><th>Location</th><th>Done (optional)</th><th></th></tr></thead><tbody>${rows.map(({ vehicle, line }) => `<tr><td>${escapeHtml(displayStockNumber(vehicle) || '—')}</td><td>${escapeHtml(vehicleCustomerName(vehicle) || '—')}</td><td>${escapeHtml(displayVehicle(vehicle) || '—')}</td><td>${escapeHtml(line.jobCardNumber || vehicleJobcardNumber(vehicle) || '—')}</td><td>${escapeHtml(line.department || '—')}</td><td>${escapeHtml(line.description)}</td><td>${escapeHtml(vehiclePdcLocation(vehicle) || '—')}</td><td><label class="pdc-pit-tick-cell">${pdcPitTickCheckboxHtml(vehicle, line)}<small>${escapeHtml(pdcPitTickFor(vehicle, line)?.ticked === true ? `Ticked by ${pdcPitTickFor(vehicle, line).ticked_by_email || 'staff'}` : 'Never blocks')}</small></label></td><td><button class="small-button" type="button" data-open-stock="${escapeHtml(vehicleKey(vehicle))}">Open vehicle</button></td></tr>`).join('')}</tbody></table></div>`
    : '<div class="empty-state"><strong>No open Bus Pit inspections</strong><span>No active job-card lines (any department) currently require Pit inspection.</span></div>';
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
}

function subletRows() {
  // r952 (F524), Craig 4 Nov 13:57: "where it's got sublet to book, don't have anything in there, so don't link it to a vehicle.
  // So we just need to create one." The Sublet page lists bookings only. It no longer builds a 'to book' row for every vehicle
  // with a Sublet job (that per-vehicle work was what made the page slow to open). New bookings come from Create new booking.
  return vehicleLocationBoardRows().flatMap(vehicle => {
    if (vehicle.tuneCheckout?.confirmed === true) return [];
    const bookings = Array.isArray(vehicle.pdcSubletBookings) ? vehicle.pdcSubletBookings : [];
    if (bookings.length) return bookings.map(booking => ({
      ...vehicle,
      __subletVehicleKey: vehicleKey(vehicle),
      __subletBookingId: booking.bookingId,
      __subletBookingVersion: booking.version,
      __subletOperationIdentity: booking.operationLineIdentity,
      __subletOperationDescription: booking.operationDescription,
      __subletProviderId: booking.providerId,
      __subletBookingStatus: booking.status,
      pmbSubletProvider: booking.provider,
      pmbSubletProviderEmail: booking.providerEmail,
      pmbSubletBookingDate: booking.outDate,
      pmbSubletExpectedReturnDate: booking.expectedReturnDate,
      pmbSubletActualReturnDate: booking.status === 'returned' ? booking.returnedAt : '',
      pmbSubletNotes: booking.notes,
    }));
    return plainDateValue(vehicle.pmbSubletBookingDate) ? [vehicle] : [];
  });
}

function subletDateOrdinal(value = '') {
  const dateKey = plainDateValue(value);
  if (!dateKey) return null;
  const parts = dateKey.split('-').map(Number);
  if (parts.length !== 3 || parts.some(part => !Number.isInteger(part))) return null;
  const ordinal = Date.UTC(parts[0], parts[1] - 1, parts[2]);
  return Number.isFinite(ordinal) ? ordinal : null;
}

function compareSubletBookingProximity(a = {}, b = {}, referenceDate = new Date()) {
  const referenceKey = referenceDate instanceof Date
    ? `${referenceDate.getFullYear()}-${String(referenceDate.getMonth() + 1).padStart(2, '0')}-${String(referenceDate.getDate()).padStart(2, '0')}`
    : plainDateValue(referenceDate);
  const referenceOrdinal = subletDateOrdinal(referenceKey) ?? 0;
  const aOrdinal = subletDateOrdinal(a.pmbSubletBookingDate);
  const bOrdinal = subletDateOrdinal(b.pmbSubletBookingDate);
  if (aOrdinal === null && bOrdinal !== null) return 1;
  if (aOrdinal !== null && bOrdinal === null) return -1;
  if (aOrdinal !== null && bOrdinal !== null) {
    const distance = Math.abs(aOrdinal - referenceOrdinal) - Math.abs(bOrdinal - referenceOrdinal);
    if (distance) return distance;
    if (aOrdinal !== bOrdinal) return aOrdinal - bOrdinal;
  }
  return String(displayStockNumber(a) || vehicleKey(a) || '').localeCompare(String(displayStockNumber(b) || vehicleKey(b) || ''));
}

function subletBookingState(vehicle = {}) {
  if (vehicle.__subletBookingStatus === 'cancelled') return 'cancelled';
  if (vehicle.__subletBookingStatus === 'returned') return 'returned';
  if (plainDateValue(vehicle.pmbSubletActualReturnDate)) return 'returned';
  return plainDateValue(vehicle.pmbSubletBookingDate) ? 'booked' : 'to-book';
}

function subletMatchesOperationalFilter(vehicle = {}, filter = 'to-book') {
  // r491 (F104): 'away' = booked, out date on or before today (Perth) and not yet back.
  if (filter === 'away') return subletBookingState(vehicle) === 'booked' && subletAwayOnDate(vehicle, subletTodayDateKey());
  const requested = ['booked', 'returned'].includes(filter) ? filter : 'to-book';
  return subletBookingState(vehicle) === requested;
}

// r491 (F104): whole days a vehicle has been (or was) away at its sublet provider, from the out /
// booking date to its return (or today, Perth). null when it has not gone out yet.
function subletDaysAway(vehicle = {}, todayKey = subletTodayDateKey()) {
  const out = subletDateOrdinal(vehicle.pmbSubletBookingDate);
  if (out === null) return null;
  const back = subletDateOrdinal(vehicle.pmbSubletActualReturnDate);
  const end = back !== null ? back : subletDateOrdinal(todayKey);
  if (end === null || end < out) return null;
  return Math.round((end - out) / 86400000);
}

function subletDaysOverdue(vehicle = {}, todayKey = subletTodayDateKey()) {
  if (!subletIsOverdue(vehicle)) return 0;
  const expected = subletDateOrdinal(vehicle.pmbSubletExpectedReturnDate);
  const today = subletDateOrdinal(todayKey);
  return expected === null || today === null ? 0 : Math.max(0, Math.round((today - expected) / 86400000));
}

function subletDaysLabel(days) {
  return `${days} day${days === 1 ? '' : 's'}`;
}

function subletStatusText(vehicle = {}, todayKey = subletTodayDateKey()) {
  const state = subletBookingState(vehicle);
  const days = subletDaysAway(vehicle, todayKey);
  if (state === 'returned') return days === null ? 'Returned' : `Back · ${subletDaysLabel(days)}`;
  if (subletIsOverdue(vehicle)) return `OVERDUE ${subletDaysLabel(subletDaysOverdue(vehicle, todayKey))}`;
  if (state === 'booked' && subletAwayOnDate(vehicle, todayKey)) return `Away ${subletDaysLabel(days || 0)}`;
  return state === 'booked' ? 'Sublet Booked' : 'Sublet To Book';
}

function compareSubletBookingDate(a = {}, b = {}) {
  const aOrdinal = subletDateOrdinal(a.pmbSubletBookingDate);
  const bOrdinal = subletDateOrdinal(b.pmbSubletBookingDate);
  if (aOrdinal === null && bOrdinal !== null) return 1;
  if (aOrdinal !== null && bOrdinal === null) return -1;
  if (aOrdinal !== null && bOrdinal !== null && aOrdinal !== bOrdinal) return aOrdinal - bOrdinal;
  return String(displayStockNumber(a) || vehicleKey(a) || '').localeCompare(String(displayStockNumber(b) || vehicleKey(b) || ''), undefined, { numeric: true });
}

function subletDateKeyFromOrdinal(ordinal) {
  if (!Number.isFinite(Number(ordinal))) return '';
  const date = new Date(Number(ordinal));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}

function subletShiftDate(dateKey = '', days = 0) {
  const ordinal = subletDateOrdinal(dateKey);
  return ordinal === null ? '' : subletDateKeyFromOrdinal(ordinal + Number(days || 0) * 86400000);
}

function subletTodayDateKey(referenceDate = new Date()) {
  if (!(referenceDate instanceof Date) || Number.isNaN(referenceDate.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'Australia/Perth',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(referenceDate).reduce((values, part) => {
    if (part.type !== 'literal') values[part.type] = part.value;
    return values;
  }, {});
  return parts.year && parts.month && parts.day ? `${parts.year}-${parts.month}-${parts.day}` : '';
}

function subletCalendarRange(mode = 'week', anchorDate = '') {
  const anchor = plainDateValue(anchorDate) || subletTodayDateKey();
  const anchorOrdinal = subletDateOrdinal(anchor);
  const safeAnchor = anchorOrdinal === null ? subletTodayDateKey() : anchor;
  const parts = safeAnchor.split('-').map(Number);
  const calendarMode = mode === 'month' ? 'month' : 'week';
  let periodStart = safeAnchor;
  let periodEnd = safeAnchor;
  if (calendarMode === 'month') {
    periodStart = `${parts[0]}-${String(parts[1]).padStart(2, '0')}-01`;
    periodEnd = subletDateKeyFromOrdinal(Date.UTC(parts[0], parts[1], 0));
  }
  const startOrdinal = subletDateOrdinal(periodStart);
  const endOrdinal = subletDateOrdinal(periodEnd);
  const startDay = new Date(startOrdinal).getUTCDay();
  const endDay = new Date(endOrdinal).getUTCDay();
  const start = subletShiftDate(periodStart, -((startDay + 6) % 7));
  const end = subletShiftDate(periodEnd, (7 - endDay) % 7);
  const days = [];
  for (let key = start; key && key <= end; key = subletShiftDate(key, 1)) days.push(key);
  return { mode: calendarMode, anchor: safeAnchor, month: safeAnchor.slice(0, 7), start, end, days };
}

function subletCalendarEvents(rows = []) {
  const events = [];
  (Array.isArray(rows) ? rows : []).forEach(vehicle => {
    const key = vehicleKey(vehicle);
    const stock = displayStockNumber(vehicle) || 'Vehicle';
    const provider = pmbBaySubletProvider(vehicle) || 'Provider not assigned';
    const customer = vehicleCustomerName(vehicle) || 'Dealer Order';
    const description = displayVehicle(vehicle) || '';
    const bookingDate = plainDateValue(vehicle.pmbSubletBookingDate);
    const expectedReturnDate = plainDateValue(vehicle.pmbSubletExpectedReturnDate);
    const actualReturnDate = plainDateValue(vehicle.pmbSubletActualReturnDate);
    const common = { key, mutationKey: vehicle.__subletBookingId || key, bookingId: vehicle.__subletBookingId || '', stock, keyNumber: vehicleKeyNumber(vehicle), provider, customer, operation: vehicle.__subletOperationDescription || '', vehicle: description, bookingDate };
    if (bookingDate) events.push({ ...common, date: bookingDate, type: 'outgoing', label: 'Going out', missingReturn: !expectedReturnDate && !actualReturnDate });
    if (actualReturnDate) events.push({ ...common, date: actualReturnDate, type: 'returned', label: 'Returned', missingReturn: false });
    else if (expectedReturnDate) events.push({ ...common, date: expectedReturnDate, type: 'due-back', label: 'Due back', missingReturn: false, overdue: expectedReturnDate < subletTodayDateKey() });
  });
  const typeOrder = { outgoing: 0, 'due-back': 1, returned: 2 };
  return events.sort((a, b) => a.date.localeCompare(b.date)
    || Number(typeOrder[a.type] ?? 9) - Number(typeOrder[b.type] ?? 9)
    || String(a.stock).localeCompare(String(b.stock), undefined, { numeric: true }));
}

function subletCalendarEventField(type = '') {
  return ({
    outgoing: 'pmbSubletBookingDate',
    'due-back': 'pmbSubletExpectedReturnDate',
    returned: 'pmbSubletActualReturnDate',
  })[String(type || '')] || '';
}

function subletAwayOnDate(vehicle = {}, dateKey = '') {
  const date = plainDateValue(dateKey);
  const booking = plainDateValue(vehicle.pmbSubletBookingDate);
  const actual = plainDateValue(vehicle.pmbSubletActualReturnDate);
  if (!date || !booking || date < booking) return false;
  return !actual || date < actual;
}

// r952 (F524), Craig 4 Nov 13:57: "when it's out during those days, I need the key number somewhere to highlight or flash ... so we
// don't book in during that period, or we don't look for a key to work on if it's going to be off-site for those days."
// 'away' = an active Sublet booking whose ETA out is on or before today (Perth) and ETA back is today or later (the same days the
// database pdc_sublet_away_on_date blocks bay bookings). 'overdue' = past ETA back and Back not ticked yet.
const pdcOffsiteToday952 = { at: 0, key: '' };
function pdcSubletOffsite952(vehicle = {}, todayKey = '') {
  const bookings = Array.isArray(vehicle?.pdcSubletBookings) ? vehicle.pdcSubletBookings : [];
  if (!bookings.length) return null;
  let today = plainDateValue(todayKey);
  if (!today) {
    if (Date.now() - pdcOffsiteToday952.at > 60000 || !pdcOffsiteToday952.key) { pdcOffsiteToday952.key = subletTodayDateKey(); pdcOffsiteToday952.at = Date.now(); }
    today = pdcOffsiteToday952.key;
  }
  let overdue = null;
  for (const booking of bookings) {
    if (booking?.status !== 'active') continue;
    const out = plainDateValue(booking.outDate);
    const back = plainDateValue(booking.expectedReturnDate);
    if (!out || !today || today < out) continue;
    const found = { provider: cleanNavisionText(booking.provider || ''), out, back };
    if (!back || today <= back) return { state: 'away', ...found };
    if (!overdue) overdue = { state: 'overdue', ...found };
  }
  return overdue;
}

function pdcSubletOffsiteTitle952(offsite = null) {
  if (!offsite) return '';
  const at = offsite.provider ? ` at ${offsite.provider}` : '';
  const back = offsite.back ? subletCalendarDateLabel(offsite.back, { weekday: 'short', day: 'numeric', month: 'short' }) : '';
  return offsite.state === 'away'
    ? `OFF SITE${at}${back ? ` until ${back}` : ''}. Do not book in or look for this key.`
    : `Was due back${back ? ` ${back}` : ''}${at}. Tick Back on the Sublet page when it returns.`;
}

function pdcSubletOffsiteTagHtml952(offsite = null) {
  if (!offsite) return '';
  return `<b class="pdc-offsite-tag is-${offsite.state === 'away' ? 'away' : 'overdue'}" title="${escapeHtml(pdcSubletOffsiteTitle952(offsite))}">${offsite.state === 'away' ? 'OFF SITE' : 'DUE BACK'}</b>`;
}

function subletDateChangeError(vehicle = {}, field = '', value = '') {
  const next = plainDateValue(value);
  const booking = field === 'pmbSubletBookingDate' ? next : plainDateValue(vehicle.pmbSubletBookingDate);
  const expected = field === 'pmbSubletExpectedReturnDate' ? next : plainDateValue(vehicle.pmbSubletExpectedReturnDate);
  const actual = field === 'pmbSubletActualReturnDate' ? next : plainDateValue(vehicle.pmbSubletActualReturnDate);
  if (!booking && (expected || actual)) return 'Set the Sublet booking date before setting a return date.';
  if (booking && expected && expected < booking) return field === 'pmbSubletBookingDate'
    ? 'Booking date cannot be after the expected return date.'
    : 'Expected return date cannot be before the booking date.';
  if (booking && actual && actual < booking) return field === 'pmbSubletBookingDate'
    ? 'Booking date cannot be after the actual return date.'
    : 'Actual return date cannot be before the booking date.';
  return '';
}

function selectSubletView(mode = 'list') {
  app.subletViewMode = mode === 'calendar' ? 'calendar' : 'list';
  if (app.subletViewMode === 'calendar') app.subletOperationalFilter = 'booked';
  renderSubletHome();
}

function selectSubletCalendarMode(mode = 'week') {
  app.subletCalendarMode = mode === 'month' ? 'month' : 'week';
  renderSubletHome();
}

function moveSubletCalendar(direction = 0) {
  const mode = app.subletCalendarMode === 'month' ? 'month' : 'week';
  const anchor = plainDateValue(app.subletCalendarAnchor) || subletTodayDateKey();
  if (!Number(direction)) app.subletCalendarAnchor = subletTodayDateKey();
  else if (mode === 'week') app.subletCalendarAnchor = subletShiftDate(anchor, Number(direction) * 7);
  else {
    const [year, month] = anchor.split('-').map(Number);
    app.subletCalendarAnchor = subletDateKeyFromOrdinal(Date.UTC(year, month - 1 + Number(direction), 1));
  }
  renderSubletHome();
}

function subletCalendarDateLabel(dateKey = '', options = {}) {
  const ordinal = subletDateOrdinal(dateKey);
  if (ordinal === null) return '';
  return new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', ...options }).format(new Date(ordinal));
}

function subletCalendarRangeLabel(range = {}) {
  if (range.mode === 'month') return subletCalendarDateLabel(`${range.month}-01`, { month: 'long', year: 'numeric' });
  const start = subletCalendarDateLabel(range.start, { day: 'numeric', month: 'short' });
  const end = subletCalendarDateLabel(range.end, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${start} – ${end}`;
}

function syncSubletViewControls(range = null) {
  const calendar = app.subletViewMode === 'calendar';
  const mode = app.subletCalendarMode === 'month' ? 'month' : 'week';
  const listButton = $('#sublet-list-view');
  const calendarButton = $('#sublet-calendar-view');
  const controls = $('#sublet-calendar-controls');
  const sortLabel = $('#sublet-sort-filter')?.closest?.('label');
  [[listButton, !calendar], [calendarButton, calendar]].forEach(([button, active]) => {
    if (!button) return;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  if (controls) controls.hidden = !calendar;
  if (sortLabel) sortLabel.hidden = calendar;
  [['week', $('#sublet-calendar-week')], ['month', $('#sublet-calendar-month')]].forEach(([key, button]) => {
    if (!button) return;
    const active = key === mode;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  const label = $('#sublet-calendar-range-label');
  if (label) label.textContent = range ? subletCalendarRangeLabel(range) : '';
}

function renderSubletCalendar(rows = []) {
  const range = subletCalendarRange(app.subletCalendarMode, app.subletCalendarAnchor);
  app.subletCalendarAnchor = range.anchor;
  syncSubletViewControls(range);
  const today = subletTodayDateKey();
  const eventsByDate = new Map();
  subletCalendarEvents(rows).forEach(event => {
    if (!eventsByDate.has(event.date)) eventsByDate.set(event.date, []);
    eventsByDate.get(event.date).push(event);
  });
  const weekdayHeadings = range.days.slice(0, 7).map(date => `<span role="columnheader">${escapeHtml(subletCalendarDateLabel(date, { weekday: 'short' }))}</span>`).join('');
  const days = range.days.map(date => {
    const outside = range.mode === 'month' && !date.startsWith(range.month);
    const events = eventsByDate.get(date) || [];
    const fullDate = subletCalendarDateLabel(date, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    const eventHtml = events.map(event => {
      const returnCheck = event.type === 'due-back' && event.bookingId
        ? `<label class="sublet-calendar-returned-check" title="Mark this Sublet booking returned"><input type="checkbox" data-sublet-calendar-returned="${escapeHtml(event.mutationKey)}" data-sublet-calendar-out-date="${escapeHtml(event.bookingDate)}" aria-label="Mark stock ${escapeHtml(event.stock)}, ${escapeHtml(event.provider)}, returned from Sublet"><span>Back</span></label>`
        : '';
      // r959 (F532): slim tiles. Key and stock on one line, provider on the next; type is the colour, details are in the hover.
      const identity = [event.keyNumber ? `Key ${event.keyNumber}` : '', event.stock].filter(Boolean).join(' · ');
      return `<article class="sublet-calendar-event is-${escapeHtml(event.type)} ${event.overdue ? 'is-overdue' : ''} ${event.missingReturn ? 'is-missing-return' : ''}" title="${escapeHtml([identity, event.provider, event.operation, event.customer, event.vehicle].filter(Boolean).join(' · '))}" draggable="true" data-sublet-calendar-event="${escapeHtml(`${event.type}:${event.mutationKey}:${date}`)}" data-sublet-calendar-drag-key="${escapeHtml(event.mutationKey)}" data-sublet-calendar-drag-type="${escapeHtml(event.type)}" data-sublet-calendar-drag-date="${escapeHtml(date)}"><button class="sublet-calendar-event-open" type="button" data-open-stock="${escapeHtml(event.key)}" aria-label="${escapeHtml(`${event.label}: stock ${event.stock}${event.keyNumber ? `, key ${event.keyNumber}` : ''}, ${event.provider}, ${fullDate}. Drag the card to move this date, or use the date field in List View.`)}"><span>${escapeHtml(identity)}</span><strong>${escapeHtml(event.provider)}</strong>${event.overdue ? '<em>OVERDUE</em>' : (event.missingReturn ? '<em>Back TBC</em>' : '')}</button>${returnCheck}</article>`;
    }).join('');
    return `<section class="sublet-calendar-day ${outside ? 'is-outside-month' : ''} ${date === today ? 'is-today' : ''}" data-sublet-calendar-date="${escapeHtml(date)}" data-sublet-calendar-drop-date="${escapeHtml(date)}" role="gridcell" aria-label="${escapeHtml(fullDate)}"><header><span>${escapeHtml(subletCalendarDateLabel(date, range.mode === 'month' ? { day: 'numeric' } : { day: 'numeric', month: 'short' }))}</span>${date === today ? '<b>Today</b>' : ''}</header><div class="sublet-calendar-day-events">${eventHtml}</div></section>`;
  }).join('');
  const missingReturns = rows.filter(vehicle => plainDateValue(vehicle.pmbSubletBookingDate) && !plainDateValue(vehicle.pmbSubletExpectedReturnDate) && !plainDateValue(vehicle.pmbSubletActualReturnDate)).length;
  return `<div class="sublet-calendar-shell">
    <div class="sublet-calendar-legend" aria-label="Calendar legend"><span class="is-outgoing"><i></i>Going out</span><span class="is-due-back"><i></i>Due back</span><span class="is-returned"><i></i>Returned</span>${missingReturns ? `<strong>${missingReturns} with back date TBC</strong>` : ''}</div>
    <div class="sublet-calendar-weekdays" role="row">${weekdayHeadings}</div>
    <div class="sublet-calendar-grid is-${escapeHtml(range.mode)}" role="grid" aria-label="${escapeHtml(`Sublet ${range.mode} calendar, ${subletCalendarRangeLabel(range)}`)}">${days}</div>
  </div>`;
}

function clearSubletCalendarDragTargets(host = null) {
  $$('[data-sublet-calendar-drop-date]', host || $('#sublet-home-content')).forEach(day => day.classList.remove('is-drag-target'));
}

function beginSubletCalendarDrag(event, card) {
  const payload = {
    key: cleanNavisionText(card?.dataset?.subletCalendarDragKey || ''),
    type: cleanNavisionText(card?.dataset?.subletCalendarDragType || ''),
    date: plainDateValue(card?.dataset?.subletCalendarDragDate || ''),
  };
  if (!payload.key || !subletCalendarEventField(payload.type) || !payload.date || !event?.dataTransfer) {
    event?.preventDefault?.();
    return false;
  }
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('application/x-pdc-sublet-calendar', JSON.stringify(payload));
  event.dataTransfer.setData('text/plain', JSON.stringify(payload));
  app.subletCalendarDragData = payload;
  card.classList.add('is-dragging');
  return true;
}

function subletCalendarDragPayload(event) {
  const retained = app.subletCalendarDragData;
  let raw = '';
  if (event?.dataTransfer) {
    raw = event.dataTransfer.getData('application/x-pdc-sublet-calendar') || event.dataTransfer.getData('text/plain');
  }
  try {
    const payload = raw ? JSON.parse(raw) : retained;
    const field = subletCalendarEventField(payload.type);
    return payload.key && field && plainDateValue(payload.date) ? { ...payload, field } : null;
  } catch (_error) {
    return null;
  }
}

async function dropSubletCalendarEvent(event, targetDate = '') {
  event?.preventDefault?.();
  const payload = subletCalendarDragPayload(event);
  const date = plainDateValue(targetDate);
  app.subletCalendarDragData = null;
  clearSubletCalendarDragTargets();
  if (!payload || !date || date === payload.date) return false;
  return updateSubletField(payload.key, payload.field, date);
}

function bindSubletCalendarInteractions(host) {
  $$('[data-sublet-calendar-event]', host).forEach(card => {
    card.addEventListener('dragstart', event => {
      if (event.target?.closest?.('[data-sublet-calendar-returned]')) {
        event.preventDefault();
        return;
      }
      beginSubletCalendarDrag(event, card);
    });
    card.addEventListener('dragend', () => {
      app.subletCalendarDragData = null;
      card.classList.remove('is-dragging');
      clearSubletCalendarDragTargets(host);
    });
  });
  $$('[data-sublet-calendar-returned]', host).forEach(input => input.addEventListener('change', async () => {
    if (!input.checked || input.disabled) return;
    input.disabled = true;
    const saved = await setSubletReturned(input.dataset.subletCalendarReturned, true);
    if (!saved) {
      input.checked = false;
      input.disabled = false;
    }
  }));
  $$('[data-sublet-calendar-drop-date]', host).forEach(day => {
    day.addEventListener('dragover', event => {
      if (!subletCalendarDragPayload(event)) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
      clearSubletCalendarDragTargets(host);
      day.classList.add('is-drag-target');
    });
    day.addEventListener('dragleave', event => {
      if (!day.contains(event.relatedTarget)) day.classList.remove('is-drag-target');
    });
    day.addEventListener('drop', event => { void dropSubletCalendarEvent(event, day.dataset.subletCalendarDropDate); });
  });
}

function renderSubletSummary(rows = []) {
  const host = $('#sublet-summary-grid');
  if (!host) return;
  // r952 (F524): no Sublet To Book list; the page shows bookings only.
  const active = ['booked', 'away', 'returned'].includes(app.subletOperationalFilter) ? app.subletOperationalFilter : 'booked';
  const filters = [
    ['booked', 'Sublet Booked'],
    ['away', 'Away now'],
    ['returned', 'Returned'],
  ];
  host.innerHTML = filters.map(([key, label]) => {
    const count = rows.filter(vehicle => subletMatchesOperationalFilter(vehicle, key)).length;
    return `<button class="parts-filter-chip sublet-filter-chip ${key === active ? 'is-active' : ''}" type="button" data-sublet-operational-filter="${key}" aria-pressed="${key === active}"><span>${escapeHtml(label)}</span><strong>${count}</strong></button>`;
  }).join('');
  $$('[data-sublet-operational-filter]', host).forEach(button => button.addEventListener('click', () => {
    app.subletOperationalFilter = ['booked', 'away', 'returned'].includes(button.dataset.subletOperationalFilter) ? button.dataset.subletOperationalFilter : 'booked';
    if (app.subletOperationalFilter === 'away') app.subletViewMode = 'list';
    renderSubletHome();
  }));
}

function syncSubletProviderFilter(rows = []) {
  const select = $('#sublet-provider-filter');
  if (!select) return 'all';
  const previous = cleanNavisionText(select.value || 'all');
  const providers = normalizedSubletProviderList([
    ...loadSubletProviders(),
    ...(Array.isArray(rows) ? rows.map(pmbBaySubletProvider) : []),
  ]);
  select.innerHTML = `<option value="all">All providers</option><option value="unassigned">Unassigned</option>${providers.map(provider => `<option value="${escapeHtml(provider)}">${escapeHtml(provider)}</option>`).join('')}`;
  const available = [...select.options].some(option => option.value === previous);
  select.value = available ? previous : 'all';
  return select.value;
}

function subletIsOverdue(vehicle = {}) {
  const expected = plainDateValue(vehicle.pmbSubletExpectedReturnDate || '');
  if (!expected || plainDateValue(vehicle.pmbSubletActualReturnDate || '')) return false;
  return expected < subletTodayDateKey();
}

function subletVehicleByKey(key = '') {
  const requested = String(key || '');
  return subletRows().find(vehicle => vehicle.__subletBookingId === requested || vehicle.__subletOperationKey === requested)
    || subletRows().find(vehicle => vehicleKey(vehicle) === requested) || selectedVehicle(key);
}

const SUBLET_SERVER_FIELD_MAP = Object.freeze({
  pmbSubletProvider: 'provider',
  pmbSubletProviderEmail: 'provider_email',
  pmbSubletPoSentDate: 'po_sent_date',
  pmbSubletBookingDate: 'booking_date',
  pmbSubletExpectedReturnDate: 'expected_return_date',
  pmbSubletActualReturnDate: 'actual_return_date',
  pmbSubletNotes: 'notes',
  pmbSubletEmailSent: 'email_sent',
});

function queueSubletVehicleMutation(vehicleId = '', mutation) {
  const id = cleanNavisionText(vehicleId || '');
  if (!id || typeof mutation !== 'function') return Promise.resolve(false);
  const actor = window.PDC_AUTH_CONTEXT?.userId;
  const token = getPdcSupabaseAccessToken();
  const service = app.emailVehicleLocationService;
  const currentSession = () => !!actor && !!token && actor === window.PDC_AUTH_CONTEXT?.userId
    && token === getPdcSupabaseAccessToken() && service === app.emailVehicleLocationService
    && ['operator', 'administrator'].includes(window.PDC_AUTH_CONTEXT?.role);
  if (!currentSession()) return Promise.resolve(false);
  const previous = app.subletMutationQueues.get(id) || Promise.resolve();
  const current = previous.catch(() => false).then(() => currentSession() ? mutation(currentSession) : false).catch(() => {
    if (currentSession()) {
      pdcNotify('The Sublet change could not be confirmed. Refresh Sublet and check the booking before retrying.');
      renderSubletHome();
    }
    return false;
  });
  app.subletMutationQueues.set(id, current);
  return current.finally(() => {
    if (app.subletMutationQueues.get(id) === current) app.subletMutationQueues.delete(id);
  });
}

function subletMutationFieldMatches(vehicle = {}, field = '', cleanValue = '') {
  if (field === 'pmbSubletEmailSent') return vehicle[field] === (cleanValue === 'true');
  return cleanNavisionText(vehicle[field] || '') === cleanValue;
}

async function refreshSubletMutationAuthority(key = '', vehicleId = '', minimumVersion = 0, field = '', cleanValue = '') {
  for (let attempt = 0; attempt < 4; attempt += 1) {
    await refreshEmailVehicleLocations();
    const current = subletVehicleByKey(key);
    const versionReady = current && current.__emailVehicleId === vehicleId
      && Number(current.__subletBookingVersion) >= Number(minimumVersion || 0);
    if (versionReady && (!field || subletMutationFieldMatches(current, field, cleanValue))) return current;
    await new Promise(resolve => window.setTimeout(resolve, 75));
  }
  return null;
}

function subletProviderRecordByName(name = '') {
  const service = typeof initWorkshopReferenceDataServiceIfAvailable === 'function' ? initWorkshopReferenceDataServiceIfAvailable() : null;
  const rows = service?.getCachedSubletProviders?.()?.rows || [];
  const requested = cleanNavisionText(name).toLowerCase();
  const matches = rows.filter(row => row?.active && cleanNavisionText(row.name).toLowerCase() === requested);
  return matches.length === 1 ? matches[0] : null;
}

async function updateSubletField(key = '', field = '', value = '') {
  const allowed = new Set(['pmbSubletProvider', 'pmbSubletProviderEmail', 'pmbSubletPoSentDate', 'pmbSubletBookingDate', 'pmbSubletExpectedReturnDate', 'pmbSubletActualReturnDate', 'pmbSubletNotes', 'pmbSubletEmailSent']);
  if (!allowed.has(field)) return false;
  const vehicle = subletVehicleByKey(key);
  if (!vehicle) return false;
  const cleanValue = cleanNavisionText(value || '');
  const dateError = subletDateChangeError(vehicle, field, cleanValue);
  if (dateError) {
    pdcNotify(dateError);
    renderSubletHome();
    return false;
  }
  if (vehicle.__subletBookingId && vehicle.__emailVehicleServerAuthoritative === true) {
    const service = app.emailVehicleLocationService;
    const providerFields = ['pmbSubletProvider', 'pmbSubletProviderEmail'];
    if (!service?.updateSubletBooking || (providerFields.includes(field) && !service.updateSubletBookingProvider) || (!providerFields.includes(field) && !['pmbSubletBookingDate', 'pmbSubletExpectedReturnDate', 'pmbSubletNotes'].includes(field))) {
      pdcNotify('This canonical booking field is read-only or the shared booking service is unavailable. No change was made.');
      renderSubletHome();
      return false;
    }
    const bookingId = vehicle.__subletBookingId;
    return queueSubletVehicleMutation(bookingId, async currentSession => {
      const current = subletVehicleByKey(bookingId);
      if (!current || current.__subletBookingStatus !== 'active') return false;
      let response;
      if (providerFields.includes(field)) {
        const provider = field === 'pmbSubletProvider' ? subletProviderRecordByName(cleanValue) : { id: current.__subletProviderId, name: current.pmbSubletProvider };
        if (!provider?.id) {
          pdcNotify('Choose an active canonical provider. No change was made.');
          return false;
        }
        const providerEmail = field === 'pmbSubletProviderEmail' ? cleanValue : cleanNavisionText(provider.email || '');
        response = await service.updateSubletBookingProvider(bookingId, current.__subletBookingVersion, provider.id, providerEmail, crypto.randomUUID());
      } else {
        const outDate = field === 'pmbSubletBookingDate' ? cleanValue : plainDateValue(current.pmbSubletBookingDate);
        const expectedReturnDate = field === 'pmbSubletExpectedReturnDate' ? cleanValue : plainDateValue(current.pmbSubletExpectedReturnDate);
        const notes = field === 'pmbSubletNotes' ? cleanValue : null;
        response = await service.updateSubletBooking(bookingId, current.__subletBookingVersion, outDate, expectedReturnDate, notes);
      }
      if (!currentSession()) return false;
      if (!response?.ok) {
        await refreshEmailVehicleLocations();
        if (!currentSession()) return false;
        const message = response?.code === 'version_conflict'
          ? 'This booking changed concurrently. Refresh Sublet, review the current values and reapply your change.'
          : response?.code === 'sublet_booking_overlap'
            ? 'Those dates overlap another Sublet booking for this vehicle. No change was made.'
            : 'The Sublet change could not be confirmed. Refresh Sublet and check the booking before retrying.';
        pdcNotify(message);
        renderSubletHome();
        return false;
      }
      let refreshed;
      try { refreshed = await refreshEmailVehicleLocations(); } catch (_error) { refreshed = false; }
      if (!currentSession()) return false;
      if (refreshed === false) pdcNotify('The booking was saved, but its current details could not be refreshed. Refresh Sublet before making another change.');
      renderSubletHome();
      return true;
    });
  }
  if (vehicle.__emailVehicleServerAuthoritative === true && !vehicle.__subletBookingId) {
    pdcNotify('No active canonical Sublet booking exists for this vehicle. Use Create booking first; no legacy placeholder update was sent.');
    renderSubletHome();
    return false;
  }
  recordVehicleAudit(vehicle, 'Sublet booking updated', { field, value: cleanValue, by: getCurrentOperatorName() });
  saveVehicleEdits(key, { [field]: cleanValue, pmbSubletUpdatedAt: nowIsoString(), pmbSubletUpdatedBy: getCurrentOperatorName() });
  return true;
}

async function setSubletReturned(key = '', returned = false, referenceDate = new Date()) {
  const vehicle = subletVehicleByKey(key);
  if (vehicle?.__subletBookingId && vehicle.__emailVehicleServerAuthoritative === true) {
    if (!returned) {
      pdcNotify('Returned bookings are immutable history and cannot be reopened. Create a new booking instead.');
      renderSubletHome();
      return false;
    }
    const service = app.emailVehicleLocationService;
    if (!service?.returnSubletBooking) return false;
    const bookingId = vehicle.__subletBookingId;
    return queueSubletVehicleMutation(bookingId, async currentSession => {
      const current = subletVehicleByKey(bookingId);
      if (!current) return false;
      const businessDate = subletTodayDateKey(referenceDate instanceof Date ? referenceDate : new Date());
      const outDate = plainDateValue(current.pmbSubletBookingDate);
      if (outDate && businessDate < outDate) {
        pdcNotify(`This booking cannot be marked Back before its Going Out date (${outDate}). Correct the Going Out date first.`);
        renderSubletHome();
        return false;
      }
      const response = await service.returnSubletBooking(bookingId, current.__subletBookingVersion, `${businessDate}T12:00:00+08:00`);
      if (!currentSession()) return false;
      if (!response?.ok) {
        await refreshEmailVehicleLocations();
        if (!currentSession()) return false;
        const message = response?.code === 'version_conflict'
          ? 'This booking changed concurrently. Refresh Sublet and check its current status before marking it Back again.'
          : response?.code === 'invalid_return'
            ? 'This booking cannot be marked Back before its Going Out date. Correct the Going Out date first.'
            : 'The return could not be confirmed. Refresh Sublet and check whether this booking is marked Back before retrying.';
        pdcNotify(message);
        renderSubletHome();
        return false;
      }
      let refreshed;
      try { refreshed = await refreshEmailVehicleLocations(); } catch (_error) { refreshed = false; }
      if (!currentSession()) return false;
      if (refreshed === false) pdcNotify('The return was saved, but the booking could not be refreshed. Refresh Sublet before making another change.');
      renderSubletHome();
      return true;
    });
  }
  const value = returned ? subletTodayDateKey(referenceDate) : '';
  return updateSubletField(key, 'pmbSubletActualReturnDate', value);
}

async function setSubletEmailSent(key = '', sent = false) {
  const vehicle = subletVehicleByKey(key);
  if (!vehicle) return;
  if (vehicle.__emailVehicleServerAuthoritative === true) {
    return updateSubletField(key, 'pmbSubletEmailSent', sent ? 'true' : 'false');
  }
  recordVehicleAudit(vehicle, sent ? 'Sublet email marked sent' : 'Sublet email marked not sent', { by: getCurrentOperatorName() });
  saveVehicleEdits(key, { pmbSubletEmailSent: Boolean(sent), pmbSubletEmailSentAt: sent ? nowIsoString() : '', pmbSubletEmailSentBy: sent ? getCurrentOperatorName() : '' });
}

// r492 (F105): what a sublet agent needs to find the car in the yard and know the job (Bhavesh, 21 Oct:
// the PO goes out with the key number and stock / serial number). Key number = parking bay in the yard.
function subletProviderEmailVehicleLines(vehicle = {}) {
  const key = vehicleKeyNumber(vehicle);
  const vin = cleanNavisionText(vehicle.vin || vehicle.fullVin || vehicle.frameVin || vehicle.autocareVin || '').toUpperCase();
  const work = cleanNavisionText(vehicle.__subletOperationDescription || '');
  return [
    `Key number (yard bay): ${key || 'TBA - not yet in our yard'}`,
    ...(vin ? [`VIN / serial: ${vin}`] : []),
    ...(work ? [`Sublet work: ${work}`] : []),
    ...(key ? [`The vehicle is in our yard at key ${key}.`] : []),
  ];
}

function draftSubletProviderEmail(key = '') {
  const vehicle = subletVehicleByKey(key);
  if (!vehicle) return;
  const contact = subletProviderContact(vehicle);
  const recipient = contact.email;
  if (!contact.name) { pdcNotify('Choose a sublet provider before drafting an email.'); return false; }
  if (!recipient || !subletProviderEmailValid(recipient)) { pdcNotify('Add a valid email for this provider in Setup or in the booking before drafting.'); return false; }
  const stock = displayStockNumber(vehicle) || 'TBA';
  const subject = `Sublet booking - ${stock}`;
  const body = [`Hello ${contact.name},`, '', 'Please confirm the following booking:', '', ...vehicleEmailLines(vehicle), ...subletProviderEmailVehicleLines(vehicle), `Job Card: ${vehicleJobcardNumber(vehicle) || 'TBA'}`, `Booking date: ${plainDateValue(vehicle.pmbSubletBookingDate) || 'TBA'}`, ...(plainDateValue(vehicle.pmbSubletExpectedReturnDate) ? [`Due back: ${plainDateValue(vehicle.pmbSubletExpectedReturnDate)}`] : []), `Notes: ${cleanNavisionText(vehicle.pmbSubletNotes || 'None')}`, '', 'Kind Regards,'].join('\n');
  if (vehicle.__emailVehicleServerAuthoritative !== true) {
    recordVehicleAudit(vehicle, 'Sublet provider email drafted', { provider: pmbBaySubletProvider(vehicle), recipient, by: getCurrentOperatorName() });
    saveVehicleEdits(key, { pmbSubletEmailDraftedAt: nowIsoString(), pmbSubletEmailDraftedBy: getCurrentOperatorName() });
  }
  window.location.href = `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function draftSubletSalesUpdate(key = '') {
  const vehicle = subletVehicleByKey(key);
  if (!vehicle) return;
  draftSalespersonChangeEmail(vehicle, {
    title: 'Sublet booking update',
    subject: 'PDC Sublet update',
    details: [`Provider: ${pmbBaySubletProvider(vehicle) || 'Unassigned'}`, `Booking: ${plainDateValue(vehicle.pmbSubletBookingDate) || 'TBA'}`, vehicle.pmbSubletNotes && `Notes: ${vehicle.pmbSubletNotes}`].filter(Boolean),
  });
}

const subletCreateSession = { generation: 0, request: null };

function resetSubletCreateSession() {
  subletCreateSession.generation += 1;
  const request = subletCreateSession.request;
  subletCreateSession.request = null;
  request?.controls.forEach((disabled, control) => { if (control.isConnected) control.disabled = disabled; });
  $('#sublet-create-form')?.removeAttribute('aria-busy');
  const submit = $('#sublet-create-form button[type="submit"]');
  if (submit && request) submit.textContent = request.submitLabel;
}

window.addEventListener('pdc-auth-locked', () => closeSubletCreateDialog());

function subletCreateCanonicalVehicles() {
  return vehicleLocationBoardRows().filter(vehicle => vehicle.__emailVehicleServerAuthoritative === true && vehicle.__emailVehicleId);
}

function subletCreateVehicleMatches(query = '') {
  // r952 (F524): type the key number or the stock number. An exact key or stock match is listed first.
  const needle = cleanNavisionText(query).toLowerCase();
  if (!needle) return [];
  const exact = [];
  const partial = [];
  subletCreateCanonicalVehicles().forEach(vehicle => {
    const keyNo = cleanNavisionText(typeof vehicleKeyNumber === 'function' ? vehicleKeyNumber(vehicle) : '').toLowerCase();
    const stock = cleanNavisionText(displayStockNumber(vehicle)).toLowerCase();
    if (needle === keyNo || needle === stock) exact.push(vehicle);
    else if ([keyNo, stock, vehicleCustomerName(vehicle), displayVehicle(vehicle)].some(value => cleanNavisionText(value).toLowerCase().includes(needle))) partial.push(vehicle);
  });
  return [...exact, ...partial].slice(0, 12);
}

function subletCreateVehicleLabel(vehicle = {}) {
  const keyNo = cleanNavisionText(typeof vehicleKeyNumber === 'function' ? vehicleKeyNumber(vehicle) : '');
  return [keyNo ? `Key ${keyNo}` : 'No key', displayStockNumber(vehicle) || 'No stock', vehicleCustomerName(vehicle) || 'Dealer Order', displayVehicle(vehicle) || 'Vehicle'].join(' · ');
}

function renderSubletCreateVehicleMatches() {
  const input = $('#sublet-create-vehicle-search');
  const selected = $('#sublet-create-vehicle-id');
  const host = $('#sublet-create-vehicle-results');
  if (!input || !selected || !host) return;
  selected.value = '';
  const matches = subletCreateVehicleMatches(input.value);
  host.innerHTML = matches.map(vehicle => `<button type="button" role="option" data-sublet-create-vehicle="${escapeHtml(vehicle.__emailVehicleId)}" data-sublet-create-vehicle-version="${escapeHtml(String(vehicle.__emailVehicleVersion || 0))}" data-sublet-create-vehicle-label="${escapeHtml(subletCreateVehicleLabel(vehicle))}"><strong>${escapeHtml(subletCreateVehicleLabel(vehicle).split(' · ').slice(0, 2).join(' · '))}</strong><span>${escapeHtml(vehicleCustomerName(vehicle) || 'Dealer Order')} · ${escapeHtml(displayVehicle(vehicle) || 'Vehicle')}</span>${typeof pdcSubletOffsite952 === 'function' ? pdcSubletOffsiteTagHtml952(pdcSubletOffsite952(vehicle)) : ''}</button>`).join('') || '<small>No car found. Check the key or stock number.</small>';
}

function chooseSubletCreateVehicle(button) {
  const id = cleanNavisionText(button?.dataset?.subletCreateVehicle || '');
  const version = cleanNavisionText(button?.dataset?.subletCreateVehicleVersion || '');
  const label = cleanNavisionText(button?.dataset?.subletCreateVehicleLabel || '');
  const vehicle = subletCreateCanonicalVehicles().filter(row => row.__emailVehicleId === id);
  if (!id || vehicle.length !== 1) return false;
  $('#sublet-create-vehicle-id').value = `${id}:${version}`;
  $('#sublet-create-vehicle-search').value = label;
  $('#sublet-create-vehicle-results').innerHTML = `<p class="is-selected" role="status">Selected: ${escapeHtml(label)}</p>`;
  return true;
}

function openSubletCreateDialog() {
  const dialog = $('#sublet-create-dialog');
  const form = $('#sublet-create-form');
  if (!dialog || !form) return;
  resetSubletCreateSession();
  form.reset();
  $('#sublet-create-vehicle-id').value = '';
  $('#sublet-create-error').textContent = '';
  $('#sublet-create-vehicle-results').innerHTML = '';
  const providers = typeof loadSubletProviderRecords === 'function' ? loadSubletProviderRecords().filter(row => row.active !== false && row.id) : [];
  $('#sublet-create-provider').innerHTML = `<option value="">Select provider</option>${providers.map(row => `<option value="${escapeHtml(row.id)}">${escapeHtml(row.name)}</option>`).join('')}`;
  const today = subletTodayDateKey();
  $('#sublet-create-out-date').value = today;
  // r959 (F532): ETA back starts blank; it is optional ("we don't know when they're going to be in").
  $('#sublet-create-return-date').value = '';
  if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  const search = cleanNavisionText($('#sublet-search')?.value || '');
  if (search) {
    $('#sublet-create-vehicle-search').value = search;
    renderSubletCreateVehicleMatches();
  }
  window.setTimeout(() => $('#sublet-create-vehicle-search')?.focus(), 0);
}

function closeSubletCreateDialog() {
  resetSubletCreateSession();
  const dialog = $('#sublet-create-dialog');
  if (!dialog) return;
  if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
}

async function submitSubletCreate(event) {
  event?.preventDefault?.();
  if (subletCreateSession.request) return false;
  const actor = window.PDC_AUTH_CONTEXT?.userId;
  const token = getPdcSupabaseAccessToken();
  const dialog = $('#sublet-create-dialog');
  const error = $('#sublet-create-error');
  if (!dialog?.open) return false;
  if (!actor || !token || !['operator', 'administrator'].includes(window.PDC_AUTH_CONTEXT?.role)) {
    error.textContent = 'Sign in as an Operator or Administrator to create a booking.';
    return false;
  }
  const binding = cleanNavisionText($('#sublet-create-vehicle-id')?.value || '');
  const split = binding.lastIndexOf(':');
  const vehicleId = split > 0 ? binding.slice(0, split) : '';
  const vehicleVersion = Number(split > 0 ? binding.slice(split + 1) : 0);
  const exact = subletCreateCanonicalVehicles().filter(vehicle => vehicle.__emailVehicleId === vehicleId && Number(vehicle.__emailVehicleVersion || 0) === vehicleVersion);
  const providerId = cleanNavisionText($('#sublet-create-provider')?.value || '');
  const outDate = plainDateValue($('#sublet-create-out-date')?.value || '');
  const returnDate = plainDateValue($('#sublet-create-return-date')?.value || '');
  if (exact.length !== 1) { error.textContent = 'Choose the car from the list. No booking was made.'; return false; }
  // r952 (F524): a new booking is not linked to a job line. A requirement is only sent when one was chosen.
  const operationIdentity = $('#sublet-create-operation')?.value || '';
  const intake = window.PDC_SUBLET_INTAKE;
  if (operationIdentity && intake && !intake.pending(exact[0]).some(line => line.lineIdentity === operationIdentity)) {
    error.textContent = 'Choose one unbooked Sublet requirement.'; return false;
  }
  if (!providerId) { error.textContent = 'Choose the provider.'; return false; }
  if (!outDate) { error.textContent = 'Enter the ETA out.'; return false; }
  // r959 (F532): no ETA back is allowed; the car stays OFF SITE until Back is ticked.
  if (returnDate && returnDate < outDate) { error.textContent = 'ETA back must be on or after ETA out.'; return false; }
  const service = app.emailVehicleLocationService;
  if (!service?.createSubletBooking) { error.textContent = 'Shared Sublet booking service is unavailable. No booking was created.'; return false; }
  const form = $('#sublet-create-form');
  const submit = form.querySelector('button[type="submit"]');
  const request = { generation: subletCreateSession.generation, submitLabel: submit?.textContent || 'Create booking',
    controls: new Map(Array.from(form.querySelectorAll('input, select, textarea, button[type="submit"]')).map(control => [control, control.disabled])) };
  const sameSession = () => actor === window.PDC_AUTH_CONTEXT?.userId && token === getPdcSupabaseAccessToken()
    && service === app.emailVehicleLocationService && ['operator', 'administrator'].includes(window.PDC_AUTH_CONTEXT?.role);
  const current = () => sameSession() && subletCreateSession.request === request
    && subletCreateSession.generation === request.generation && dialog.open;
  subletCreateSession.request = request;
  request.controls.forEach((_disabled, control) => { control.disabled = true; });
  form.setAttribute('aria-busy', 'true');
  if (submit) submit.textContent = 'Creating booking…';
  error.textContent = '';
  try {
    const response = await service.createSubletBooking(vehicleId, vehicleVersion, providerId, outDate, returnDate, cleanNavisionText($('#sublet-create-provider-email')?.value || ''), cleanNavisionText($('#sublet-create-notes')?.value || ''), operationIdentity);
    if (!current()) return false;
    if (!response?.ok) {
      error.textContent = response?.code === 'sublet_booking_overlap' ? 'These dates overlap another booking for this vehicle.'
        : response?.code === 'workshop_booking_conflict' ? 'This car is booked in a workshop bay on those days. Move that booking first, or change the dates.'
          : response?.code === 'vehicle_version_conflict' ? 'This car changed while you were booking. Choose it from the list again, then Confirm.'
            : 'The booking could not be confirmed. Refresh Sublet and check this car before retrying.';
      await refreshEmailVehicleLocations();
      return false;
    }
    closeSubletCreateDialog();
    const completedGeneration = subletCreateSession.generation;
    let refreshed;
    try { refreshed = await refreshEmailVehicleLocations(); } catch (_error) { refreshed = false; }
    if (sameSession() && subletCreateSession.generation === completedGeneration && !dialog.open) {
      if (refreshed === false) pdcNotify('The booking was created, but the list could not be refreshed. Refresh Sublet before creating another booking for this requirement.');
      app.subletOperationalFilter = 'booked';
      renderSubletHome();
    }
    return true;
  } catch (_error) {
    if (current()) error.textContent = 'The booking could not be confirmed. Check your connection, then refresh Sublet before retrying.';
    return false;
  } finally {
    if (subletCreateSession.request === request) resetSubletCreateSession();
  }
}

function bindSubletCreateDialog() {
  on($('#sublet-create-provider'), 'change', fillSubletCreateProviderEmail);
  on($('#sublet-create-open'), 'click', openSubletCreateDialog);
  on($('#sublet-create-close'), 'click', closeSubletCreateDialog);
  on($('#sublet-create-cancel'), 'click', closeSubletCreateDialog);
  on($('#sublet-create-vehicle-search'), 'input', renderSubletCreateVehicleMatches);
  // r952 (F524): Enter on a key or stock number picks the one car that matches it exactly.
  on($('#sublet-create-vehicle-search'), 'keydown', event => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    const needle = cleanNavisionText(event.target?.value || '').toLowerCase();
    const exact = subletCreateCanonicalVehicles().filter(vehicle => [vehicleKeyNumber(vehicle), displayStockNumber(vehicle)].some(value => cleanNavisionText(value).toLowerCase() === needle));
    const button = exact.length === 1 ? $(`#sublet-create-vehicle-results [data-sublet-create-vehicle="${CSS.escape(exact[0].__emailVehicleId)}"]`) : null;
    if (button) chooseSubletCreateVehicle(button);
  });
  on($('#sublet-create-form'), 'submit', submitSubletCreate);
  const results = $('#sublet-create-vehicle-results');
  on(results, 'click', event => {
    const button = event.target.closest?.('[data-sublet-create-vehicle]');
    if (button && results.contains(button)) chooseSubletCreateVehicle(button);
  });
  const dialog = $('#sublet-create-dialog');
  on(dialog, 'click', event => { if (event.target === dialog) closeSubletCreateDialog(); });
  on(dialog, 'cancel', event => { event.preventDefault(); closeSubletCreateDialog(); });
}

function renderSubletHome() {
  const host = $('#sublet-home-content');
  if (!host) return;
  const search = cleanNavisionText($('#sublet-search')?.value || '').toLowerCase();
  const allRows = subletRows();
  app.subletViewMode = app.subletViewMode === 'calendar' ? 'calendar' : 'list';
  app.subletCalendarMode = app.subletCalendarMode === 'month' ? 'month' : 'week';
  if (app.subletViewMode === 'calendar') app.subletOperationalFilter = 'booked';
  app.subletOperationalFilter = ['booked', 'away', 'returned'].includes(app.subletOperationalFilter) ? app.subletOperationalFilter : 'booked';
  app.subletExpandedRows = app.subletExpandedRows instanceof Set ? app.subletExpandedRows : new Set();
  renderSubletSummary(allRows);
  const providerFilter = syncSubletProviderFilter(allRows);
  const sortMode = cleanNavisionText($('#sublet-sort-filter')?.value || 'nearest');
  const sortReference = new Date();
  const rows = allRows.filter(vehicle => {
    if (app.subletViewMode === 'calendar') {
      if (subletBookingState(vehicle) !== 'booked') return false;
    } else if (!subletMatchesOperationalFilter(vehicle, app.subletOperationalFilter)) return false;
    const provider = normalizeSubletProviderName(pmbBaySubletProvider(vehicle));
    if (providerFilter === 'unassigned' && provider) return false;
    if (!['all', 'unassigned'].includes(providerFilter) && provider.toLowerCase() !== normalizeSubletProviderName(providerFilter).toLowerCase()) return false;
    if (!search) return true;
    return [vehicleKeyNumber(vehicle), displayStockNumber(vehicle), vehicleJobcardNumber(vehicle), vehicleCustomerName(vehicle), displayVehicle(vehicle), pmbBaySubletProvider(vehicle), vehicle.pmbSubletNotes].join(' ').toLowerCase().includes(search);
  }).sort((a, b) => {
    if (app.subletOperationalFilter === 'away' && app.subletViewMode !== 'calendar') {
      const longest = (subletDaysAway(b) ?? -1) - (subletDaysAway(a) ?? -1);
      if (longest) return longest;
    }
    if (sortMode === 'stock') return String(displayStockNumber(a) || '').localeCompare(String(displayStockNumber(b) || ''), undefined, { numeric: true });
    if (sortMode === 'date') return compareSubletBookingDate(a, b);
    return compareSubletBookingProximity(a, b, sortReference);
  });
  const booked = allRows.filter(vehicle => subletBookingState(vehicle) === 'booked').length;
  const away = allRows.filter(vehicle => subletMatchesOperationalFilter(vehicle, 'away')).length;
  const count = $('#sublet-summary');
  if (count) count.textContent = `${rows.length} shown · ${booked} booked · ${away} off site now`;
  if (app.subletViewMode === 'calendar') {
    host.innerHTML = renderSubletCalendar(rows);
    bindSubletCalendarInteractions(host);
    $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
    return;
  }
  syncSubletViewControls(null);
  if (!rows.length) {
    host.innerHTML = '<div class="empty-state"><strong>No Sublet bookings match this filter</strong><span>Use Create new booking to book a car off site.</span></div>';
    return;
  }
  host.innerHTML = `<div class="sublet-table-wrap"><table class="data-table compact-table sublet-table"><colgroup><col style="width:28px"><col style="width:45px"><col style="width:90px"><col style="width:100px"><col style="width:76px"><col style="width:175px"><col style="width:98px"><col style="width:290px"><col style="width:140px"><col style="width:120px"><col style="width:120px"><col style="width:120px"><col style="width:110px"></colgroup><thead><tr><th aria-label="Expand"></th><th>Key</th><th>Stock</th><th>Job card</th><th>Returned</th><th>Customer</th><th>Vehicle</th><th>Work required</th><th>Provider</th><th>Booking date</th><th>Due back</th><th>Status</th><th>Actions</th></tr></thead><tbody>${rows.map(vehicle => {
    const vehicleOpenKey = vehicle.__subletVehicleKey || vehicleKey(vehicle);
    const key = vehicle.__subletBookingId || vehicle.__subletOperationKey || vehicleOpenKey;
    const stock = displayStockNumber(vehicle) || 'vehicle';
    const accessibleStock = escapeHtml(stock);
    const expanded = app.subletExpandedRows.has(key);
    const state = subletBookingState(vehicle);
    const returned = state === 'returned';
    const canonical = vehicle.__emailVehicleServerAuthoritative === true;
    const overdue = subletIsOverdue(vehicle);
    const statusLabel = subletStatusText(vehicle);
    const statusTitle = [plainDateValue(vehicle.pmbSubletBookingDate) && `Out ${plainDateValue(vehicle.pmbSubletBookingDate)}`, plainDateValue(vehicle.pmbSubletExpectedReturnDate) && `due back ${plainDateValue(vehicle.pmbSubletExpectedReturnDate)}`, plainDateValue(vehicle.pmbSubletActualReturnDate) && `back ${plainDateValue(vehicle.pmbSubletActualReturnDate)}`, pmbBaySubletProvider(vehicle) && `at ${pmbBaySubletProvider(vehicle)}`].filter(Boolean).join(' · ');
    return `<tr class="sublet-row sublet-summary-row ${overdue ? 'is-overdue' : ''} ${expanded ? 'is-expanded' : ''}">
      <td><button class="sublet-row-toggle" type="button" data-sublet-toggle="${escapeHtml(key)}" aria-expanded="${expanded}" aria-label="${expanded ? 'Collapse' : 'Expand'} Sublet details for ${accessibleStock}">${expanded ? '▾' : '›'}</button></td>
      <td class="${typeof pdcSubletOffsite952 === 'function' && vehicle.__subletBookingStatus === 'active' && pdcSubletOffsite952(vehicle) ? `pdc-offsite-key is-${pdcSubletOffsite952(vehicle).state}` : ''}"><strong>${escapeHtml(vehicleKeyNumber(vehicle) || '—')}</strong></td>
      <td><button class="sublet-stock-link" type="button" data-open-stock="${escapeHtml(vehicleOpenKey)}"><strong>${escapeHtml(stock === 'vehicle' ? '—' : stock)}</strong></button></td>
      <td><strong>${escapeHtml(vehicleJobcardNumber(vehicle) || '—')}</strong></td>
      <td class="sublet-returned-cell"><label class="sublet-returned-check"><input type="checkbox" aria-label="Mark stock ${accessibleStock}, ${escapeHtml(pmbBaySubletProvider(vehicle) || 'provider unassigned')}, returned from Sublet" data-sublet-returned="${escapeHtml(key)}" ${returned ? 'checked disabled' : ''}><span>Back</span></label></td>
      <td><strong title="${escapeHtml(vehicleCustomerName(vehicle) || 'Dealer Order')}">${escapeHtml(vehicleCustomerName(vehicle) || 'Dealer Order')}</strong></td>
      <td><span title="${escapeHtml(displayVehicle(vehicle) || '')}">${escapeHtml(displayVehicle(vehicle) || '—')}</span></td>
      <td class="sublet-work-required"></td>
      <td><select aria-label="Sublet provider for ${accessibleStock}" data-sublet-field="pmbSubletProvider" data-sublet-key="${escapeHtml(key)}" ${vehicle.__subletBookingId ? 'disabled title="Provider identity is immutable; create another booking"' : ''}>${subletProviderOptionsHtml(pmbBaySubletProvider(vehicle))}</select></td>
      <td><input type="date" aria-label="Sublet booking date for ${accessibleStock}" value="${escapeHtml(plainDateValue(vehicle.pmbSubletBookingDate))}" data-sublet-field="pmbSubletBookingDate" data-sublet-key="${escapeHtml(key)}" ${returned ? 'disabled' : ''}></td>
      <td><input type="date" aria-label="Expected Sublet return date for ${accessibleStock}" value="${escapeHtml(plainDateValue(vehicle.pmbSubletExpectedReturnDate))}" data-sublet-field="pmbSubletExpectedReturnDate" data-sublet-key="${escapeHtml(key)}" ${returned ? 'disabled' : ''}></td>
      <td><span class="sublet-status-pill is-${escapeHtml(state)} ${overdue ? 'is-overdue' : ''}"${statusTitle ? ` title="${escapeHtml(statusTitle)}"` : ''}>${escapeHtml(statusLabel)}</span></td>
      <td class="sublet-row-actions"><button class="small-button" type="button" data-open-stock="${escapeHtml(vehicleOpenKey)}">Open vehicle</button></td>
    </tr>${expanded ? `<tr class="sublet-detail-row"><td colspan="13"><div class="sublet-detail-grid">
      <label><span>Provider email</span><input type="email" aria-label="Sublet provider email for ${accessibleStock}" placeholder="Provider email" value="${escapeHtml(subletProviderContact(vehicle).email)}" data-sublet-field="pmbSubletProviderEmail" data-sublet-key="${escapeHtml(key)}" ${canonical&&returned?'disabled title="Returned booking history is read-only"':''}></label>
      <label><span>Actual return</span><input type="date" aria-label="Actual Sublet return date for ${accessibleStock}" value="${escapeHtml(plainDateValue(vehicle.pmbSubletActualReturnDate))}" data-sublet-field="pmbSubletActualReturnDate" data-sublet-key="${escapeHtml(key)}" ${canonical?'disabled title="Use Back to record the vehicle’s return"':''}></label>
      <label class="sublet-notes-field"><span>Notes</span><textarea rows="2" aria-label="Sublet notes for ${accessibleStock}" data-sublet-field="pmbSubletNotes" data-sublet-key="${escapeHtml(key)}" ${canonical&&returned?'disabled title="Returned booking history is read-only"':''}>${escapeHtml(vehicle.pmbSubletNotes || '')}</textarea></label>
      <label class="sublet-email-check"><input type="checkbox" data-sublet-email-sent="${escapeHtml(key)}" ${vehicle.pmbSubletEmailSent ? 'checked' : ''} ${canonical?'disabled title="Email sending is recorded by the shared booking service"':''}> Provider email sent</label>
      <div class="sublet-detail-actions"><button class="small-button" type="button" data-sublet-provider-email="${escapeHtml(key)}">Draft provider email</button><button class="small-button" type="button" data-sublet-sales-email="${escapeHtml(key)}">Draft sales update</button></div>
    </div></td></tr>` : ''}`;
  }).join('')}</tbody></table></div>`;
  $$('[data-sublet-field]', host).forEach(input => input.addEventListener('change', () => updateSubletField(input.dataset.subletKey, input.dataset.subletField, input.value)));
  $$('[data-sublet-returned]', host).forEach(input => input.addEventListener('change', () => setSubletReturned(input.dataset.subletReturned, input.checked)));
  $$('[data-sublet-email-sent]', host).forEach(input => input.addEventListener('change', () => setSubletEmailSent(input.dataset.subletEmailSent, input.checked)));
  $$('[data-sublet-provider-email]', host).forEach(button => button.addEventListener('click', () => draftSubletProviderEmail(button.dataset.subletProviderEmail)));
  $$('[data-sublet-sales-email]', host).forEach(button => button.addEventListener('click', () => draftSubletSalesUpdate(button.dataset.subletSalesEmail)));
  $$('[data-open-stock]', host).forEach(button => button.addEventListener('click', () => { void openVehicleFromStockClick(button.dataset.openStock, button); }));
  $$('[data-sublet-toggle]', host).forEach(button => button.addEventListener('click', () => {
    const key = button.dataset.subletToggle || '';
    if (app.subletExpandedRows.has(key)) app.subletExpandedRows.delete(key);
    else app.subletExpandedRows.add(key);
    renderSubletHome();
  }));
}

function getNotes(stock) { return loadJson(`vehicleTrackingCoreNotes:${stock}`, []); }
function setNotes(stock, notes) { saveJson(`vehicleTrackingCoreNotes:${stock}`, notes); }

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { try { init(); } catch (error) { showStartupError(error); } finally { pdcStartupComplete = true; } });
} else {
  try { init(); } catch (error) { showStartupError(error); } finally { pdcStartupComplete = true; }
}


on(window, 'error', event => {
  if (event?.error) reportPdcRuntimeError(event.error);
});
on(window, 'unhandledrejection', event => {
  reportPdcRuntimeError(event?.reason || new Error('Unhandled promise rejection'));
});
